import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A date string, such as 2007-12-03, compliant with the `full-date` format
   * outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for
   * representation of dates and times using the Gregorian calendar.
   */
  Date: { input: string; output: string; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
   */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type AcceptInviteInput = {
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountType?: InputMaybe<BankAccountType>;
  bankBranchCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  disputedFirstName?: InputMaybe<Scalars['String']['input']>;
  disputedLastName?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  municipality?: InputMaybe<Scalars['String']['input']>;
  parentDisputeReason?: InputMaybe<Scalars['String']['input']>;
  parentDisputed?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  paymentPhone?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileDisputed?: InputMaybe<Scalars['Boolean']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  stockingPoint?: InputMaybe<AcceptInviteStockingPointInput>;
  /** @deprecated Ignored. The stocking point is named by convention. */
  stockingPointName?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  /** @deprecated Ignored. The stocking point is named by convention. */
  useAsStockingPoint?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AcceptInviteStockingPointInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type AddAccessoryStockInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  stockingPointId: Scalars['String']['input'];
};

export type AddPurchaseOrderItemsInput = {
  items: Array<PurchaseOrderItemInput>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productSku?: InputMaybe<Scalars['String']['input']>;
};

export type AddStockItemInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  deviceTypeId: Scalars['String']['input'];
  hotpSecret?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  secretKey?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startingCode?: InputMaybe<Scalars['String']['input']>;
  stockTypeId?: InputMaybe<Scalars['String']['input']>;
  stockingPointId: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  addressLevel1?: Maybe<Scalars['String']['output']>;
  addressLevel2?: Maybe<Scalars['String']['output']>;
  addressLevel3?: Maybe<Scalars['String']['output']>;
  addressLevel4?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  id?: Maybe<Scalars['ID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AddressInput = {
  addressLevel1?: InputMaybe<Scalars['String']['input']>;
  addressLevel2?: InputMaybe<Scalars['String']['input']>;
  addressLevel3?: InputMaybe<Scalars['String']['input']>;
  addressLevel4?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

/** An age band. UNKNOWN is no birth date, or one giving an age under 18 or over 100. */
export type AgeBand =
  | 'AGE_18_24'
  | 'AGE_25_34'
  | 'AGE_35_44'
  | 'AGE_45_54'
  | 'AGE_55_64'
  | 'AGE_65_PLUS'
  | 'UNKNOWN';

export type Agent = {
  __typename?: 'Agent';
  agentCategory?: Maybe<AgentCategory>;
  agentType?: Maybe<AgentType>;
  agreementStatus?: Maybe<AgentAgreementStatus>;
  bankAccountHolder?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankAccountType?: Maybe<AgentBankAccountType>;
  bankBranchCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankVerificationStatus?: Maybe<BankVerificationStatus>;
  canDoReplacements?: Maybe<Scalars['Boolean']['output']>;
  canHoldStock?: Maybe<Scalars['Boolean']['output']>;
  canSell?: Maybe<Scalars['Boolean']['output']>;
  changeHistory?: Maybe<Array<AgentChangeHistory>>;
  childAgents?: Maybe<Array<Agent>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dccFirstNameSnapshot?: Maybe<Scalars['String']['output']>;
  dccLastNameSnapshot?: Maybe<Scalars['String']['output']>;
  dccRamIdSnapshot?: Maybe<Scalars['String']['output']>;
  dccRamNameSnapshot?: Maybe<Scalars['String']['output']>;
  disputeResolutions?: Maybe<Array<DisputeResolution>>;
  disputedFirstName?: Maybe<Scalars['String']['output']>;
  disputedLastName?: Maybe<Scalars['String']['output']>;
  earnsMonthlyFee?: Maybe<Scalars['Boolean']['output']>;
  expectedParentExternalId?: Maybe<Scalars['String']['output']>;
  externalAgentId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  needsParentReconciliation?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  parentAgent?: Maybe<Agent>;
  parentDisputeReason?: Maybe<Scalars['String']['output']>;
  parentDisputed?: Maybe<Scalars['Boolean']['output']>;
  parentMismatch?: Maybe<Scalars['Boolean']['output']>;
  parentUser?: Maybe<User>;
  parentUserId?: Maybe<Scalars['String']['output']>;
  paymentPhone?: Maybe<Scalars['String']['output']>;
  pendingParentExternalId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profileDisputed?: Maybe<Scalars['Boolean']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  salesId?: Maybe<Scalars['String']['output']>;
  sourceAgentKey?: Maybe<Scalars['String']['output']>;
  sourcePhone?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AgentStatus>;
  stockingPointUsers?: Maybe<Array<StockingPointUser>>;
  taxId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type AgentAgreement = {
  __typename?: 'AgentAgreement';
  agent?: Maybe<Agent>;
  consentAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  countersignedAt?: Maybe<Scalars['DateTime']['output']>;
  countersignedByName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  decisionReason?: Maybe<Scalars['String']['output']>;
  documentHash?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  events?: Maybe<Array<AgentAgreementEvent>>;
  id?: Maybe<Scalars['ID']['output']>;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  partyAddressSnapshot?: Maybe<Scalars['String']['output']>;
  partyIdNumberSnapshot?: Maybe<Scalars['String']['output']>;
  partyNameSnapshot?: Maybe<Scalars['String']['output']>;
  partyRegistrationNumberSnapshot?: Maybe<Scalars['String']['output']>;
  partyType?: Maybe<AgreementPartyType>;
  reminderCount?: Maybe<Scalars['Int']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<User>;
  signatoryCapacitySnapshot?: Maybe<Scalars['String']['output']>;
  signatoryNameSnapshot?: Maybe<Scalars['String']['output']>;
  signatureMethod?: Maybe<AgreementSignatureMethod>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedBy?: Maybe<User>;
  signingDate?: Maybe<Scalars['DateTime']['output']>;
  slaBreached?: Maybe<Scalars['Boolean']['output']>;
  slaDueAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<AgentAgreementStatus>;
  template?: Maybe<AgreementTemplate>;
  templateVersion?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AgentAgreementEvent = {
  __typename?: 'AgentAgreementEvent';
  actor?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fromStatus?: Maybe<AgentAgreementStatus>;
  id?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<AgentAgreementStatus>;
};

export type AgentAgreementFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slaBreachedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AgentAgreementStatus>;
};

export type AgentAgreementListResult = {
  __typename?: 'AgentAgreementListResult';
  items: Array<AgentAgreement>;
  totalCount: Scalars['Int']['output'];
};

export type AgentAgreementStatus =
  | 'COUNTERSIGNED'
  | 'DECLINED'
  | 'INFO_REQUESTED'
  | 'NOT_ISSUED'
  | 'PENDING'
  | 'REJECTED'
  | 'SIGNED'
  | 'UNDER_REVIEW';

export type AgentBankAccountType =
  | 'BUSINESS'
  | 'CHEQUE'
  | 'SAVINGS';

export type AgentCategory = {
  __typename?: 'AgentCategory';
  canBeParent?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AgentChangeHistory = {
  __typename?: 'AgentChangeHistory';
  changeType?: Maybe<Scalars['String']['output']>;
  changedBy?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type AgentCommissionSummary = {
  __typename?: 'AgentCommissionSummary';
  approvedAmountCents?: Maybe<Scalars['Int']['output']>;
  approvedAmountRands?: Maybe<Scalars['Float']['output']>;
  approvedCount?: Maybe<Scalars['Int']['output']>;
  cancelledAmountCents?: Maybe<Scalars['Int']['output']>;
  cancelledCount?: Maybe<Scalars['Int']['output']>;
  onHoldAmountCents: Scalars['Int']['output'];
  onHoldAmountRands: Scalars['Float']['output'];
  onHoldCount: Scalars['Int']['output'];
  paidAmountCents?: Maybe<Scalars['Int']['output']>;
  paidAmountRands?: Maybe<Scalars['Float']['output']>;
  paidCount?: Maybe<Scalars['Int']['output']>;
  pendingAmountCents?: Maybe<Scalars['Int']['output']>;
  pendingAmountRands?: Maybe<Scalars['Float']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
};

export type AgentHierarchyWorkbook = {
  __typename?: 'AgentHierarchyWorkbook';
  contentBase64?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

/** An agent invite held for Marketing to approve before it is sent (ADR-0081). */
export type AgentInviteApproval = {
  __typename?: 'AgentInviteApproval';
  agentCategoryName?: Maybe<Scalars['String']['output']>;
  agentType?: Maybe<Scalars['String']['output']>;
  claimsDormantAgent: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  parentAgent?: Maybe<Agent>;
  requestedBy?: Maybe<User>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<User>;
  status: ApprovalStatus;
};

export type AgentInviteApprovalCount = {
  __typename?: 'AgentInviteApprovalCount';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type AgentInviteApprovalListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApprovalStatus>;
};

export type AgentInviteApprovalListResult = {
  __typename?: 'AgentInviteApprovalListResult';
  items: Array<AgentInviteApproval>;
  totalCount: Scalars['Int']['output'];
};

export type AgentListInput = {
  agentTypes?: InputMaybe<Array<AgentType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentAgentId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<AgentStatus>>;
};

export type AgentListResult = {
  __typename?: 'AgentListResult';
  items: Array<Agent>;
  totalCount: Scalars['Int']['output'];
};

export type AgentNameMatch = {
  __typename?: 'AgentNameMatch';
  agent?: Maybe<SellerCorrectionAgent>;
  candidates?: Maybe<Array<SellerCorrectionAgent>>;
  status?: Maybe<AgentNameMatchStatus>;
};

export type AgentNameMatchStatus =
  | 'AMBIGUOUS'
  | 'MATCHED'
  | 'NOT_FOUND';

export type AgentOnboarding = {
  __typename?: 'AgentOnboarding';
  byDistributor: Array<AgentOnboardingDistributor>;
  /** YYYY-MM, on South African time. */
  month: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

/** One distributor's agents onboarded this month. A null distributor is the agents with none. */
export type AgentOnboardingDistributor = {
  __typename?: 'AgentOnboardingDistributor';
  count: Scalars['Int']['output'];
  distributorId?: Maybe<Scalars['ID']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  distributorSalesId?: Maybe<Scalars['String']['output']>;
};

export type AgentStatus =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'PROVISIONAL'
  | 'SUSPENDED';

export type AgentStatusCount = {
  __typename?: 'AgentStatusCount';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AgentTransferDestination = {
  __typename?: 'AgentTransferDestination';
  label: Scalars['String']['output'];
  stockingPointId: Scalars['String']['output'];
  stockingPointName: Scalars['String']['output'];
};

export type AgentType =
  | 'DISTRIBUTOR'
  | 'FIELD'
  | 'INDEPENDENT';

export type AgreementPartyDetails = {
  __typename?: 'AgreementPartyDetails';
  address?: Maybe<Scalars['String']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<IdentificationType>;
  partyName?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  signatoryCapacity?: Maybe<Scalars['String']['output']>;
  signatoryName?: Maybe<Scalars['String']['output']>;
};

export type AgreementPartyDetailsInput = {
  address: Scalars['String']['input'];
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<IdentificationType>;
  partyName: Scalars['String']['input'];
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  signatoryCapacity?: InputMaybe<Scalars['String']['input']>;
  signatoryName?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementPartyType =
  | 'COMPANY'
  | 'INDIVIDUAL';

export type AgreementSignatureMethod =
  | 'DRAWN'
  | 'TYPED'
  | 'UPLOADED';

export type AgreementTemplate = {
  __typename?: 'AgreementTemplate';
  consentStatement?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mergeFields?: Maybe<Array<Scalars['String']['output']>>;
  partyType?: Maybe<AgreementPartyType>;
  retiredAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ApiConsumer = {
  __typename?: 'ApiConsumer';
  clientId?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hasInboundSecret?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inboundSignatureMode?: Maybe<WebhookSignatureMode>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type Application = {
  __typename?: 'Application';
  changeHistory?: Maybe<Array<ApplicationChangeHistory>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  customer?: Maybe<Customer>;
  documents?: Maybe<Array<Document>>;
  employer?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  income?: Maybe<Scalars['Float']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicationChangeHistory = {
  __typename?: 'ApplicationChangeHistory';
  changeType?: Maybe<Scalars['String']['output']>;
  changedBy?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type ApplicationListInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ApplicationStatus>;
};

export type ApplicationListResult = {
  __typename?: 'ApplicationListResult';
  items: Array<Application>;
  totalCount: Scalars['Int']['output'];
};

export type ApplicationStatus =
  | 'DRAFT'
  | 'SUBMITTED';

export type ApplySellerCorrectionsInput = {
  corrections: Array<SellerCorrectionInput>;
  reason: Scalars['String']['input'];
  source: SellerCorrectionSource;
};

export type ApplySellerCorrectionsResult = {
  __typename?: 'ApplySellerCorrectionsResult';
  appliedCount?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<SellerCorrectionRowResult>>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
};

export type ApprovalListInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ApprovalRequestKind>;
  kinds?: InputMaybe<Array<ApprovalRequestKind>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ApprovalStatus>;
};

export type ApprovalListResult = {
  __typename?: 'ApprovalListResult';
  items: Array<ApprovalRequest>;
  totalCount: Scalars['Int']['output'];
};

export type ApprovalRequest = {
  __typename?: 'ApprovalRequest';
  agent?: Maybe<Agent>;
  contract?: Maybe<Contract>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<ApprovalRequestKind>;
  ratePlan?: Maybe<RatePlan>;
  requestReason?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<User>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<User>;
  status?: Maybe<ApprovalStatus>;
  stockItem?: Maybe<StockItem>;
  stockTransfer?: Maybe<StockTransfer>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApprovalRequestKind =
  | 'CONTRACT_CREATION'
  | 'RETURN_TO_HEAD_OFFICE'
  | 'UPGRADE_ONBOARDING';

export type ApprovalStatus =
  | 'APPROVED'
  | 'CANCELLED'
  | 'PENDING'
  | 'REJECTED';

export type ApprovalStatusCount = {
  __typename?: 'ApprovalStatusCount';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ApproveCommissionsInput = {
  ids: Array<Scalars['String']['input']>;
};

export type ArchiveStockItemsInput = {
  ids: Array<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reason: StockItemArchiveReason;
};

export type AssignDeviceToContractInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  agentId: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  /** Serial number or account number of the device being assigned. */
  identifier: Scalars['String']['input'];
  meterTypeId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Explicit intent to assign a device located at another stocking point,
   * auto-transferring it to the agent. Requires stock:assign_override —
   * the server re-checks the permission and never trusts this flag alone.
   */
  override?: InputMaybe<Scalars['Boolean']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  startingCode?: InputMaybe<Scalars['String']['input']>;
};

export type AtlasHistoryToken = {
  __typename?: 'AtlasHistoryToken';
  /** Units of credit the token carries, counted in whatever the token type counts in - days for DAILY, weeks for WEEKLY. Zero for BUYOUT and REKEY, which carry none. Deliberately not converted to days: nothing from Atlas says what a WEEKLY unit is worth. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Atlas's own row id for the token. */
  id?: Maybe<Scalars['String']['output']>;
  /** The index key this token carries. This is what the lookup exists for: a REKEY has to name the index the device is sitting on, and the payment service we normally vend through never passes one back. */
  index?: Maybe<Scalars['Int']['output']>;
  /** What Atlas calls createdAt, and only sometimes the moment the token was issued: everything minted before d.light's own August 2026 migration carries the migration's timestamp instead. Right for anything recent, and the only date Atlas offers. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The code, printed as Atlas prints it: XXX-XXX-XXX-XXX. */
  token?: Maybe<Scalars['String']['output']>;
  /** DAILY, WEEKLY, MONTHLY, BUYOUT or REKEY. */
  tokenType?: Maybe<Scalars['String']['output']>;
};

/** An Atlas device the customer holds. Present only for Atlas: it is the one vendor whose re-gating needs the index the device is sitting on, so it is the one vendor whose token history is worth reading directly. */
export type AtlasRekeyDevice = {
  __typename?: 'AtlasRekeyDevice';
  /** The meter number Atlas knows the device by, and what its history is keyed on. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  stockSaleId?: Maybe<Scalars['String']['output']>;
  /** The Platform API as recorded, e.g. 'Atlas Independent'. */
  vendor?: Maybe<Scalars['String']['output']>;
};

export type AtlasTokenHistory = {
  __typename?: 'AtlasTokenHistory';
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** When Atlas answered, so the reader can see how fresh this is. */
  fetchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether Atlas holds a page after this one. The most recent token is not always the one being looked for, so there is always a way to ask for more. */
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<AtlasHistoryToken>>;
  /** Zero-based page number, as asked for. */
  page?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  /** Every token Atlas holds for the account, across all pages. Null if Atlas does not say. */
  totalTokens?: Maybe<Scalars['Int']['output']>;
};

export type AttendanceDepartment = {
  __typename?: 'AttendanceDepartment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AttendanceEmployee = {
  __typename?: 'AttendanceEmployee';
  department?: Maybe<AttendanceDepartment>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type AttendanceFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<AttendanceStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AttendanceMetrics = {
  __typename?: 'AttendanceMetrics';
  absentDays: HrMetric;
  absenteeismRate: HrMetric;
  from: Scalars['DateTime']['output'];
  hoursWorked: HrMetric;
  lateArrivals: HrMetric;
  leaveDaysTaken: HrMetric;
  leaveLiabilityDays: HrMetric;
  leaveTakenByType: Array<LeaveDaysByType>;
  overtimeHours: HrMetric;
  pendingLeaveRequests: HrMetric;
  scheduledDays: HrMetric;
  sickDays: HrMetric;
  sickDaysPerEmployee: HrMetric;
  to: Scalars['DateTime']['output'];
};

export type AttendanceMetricsFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AttendanceRecord = {
  __typename?: 'AttendanceRecord';
  date: Scalars['DateTime']['output'];
  employee: AttendanceEmployee;
  hoursWorked?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  overtimeHours?: Maybe<Scalars['Float']['output']>;
  source: HrDataSource;
  status: AttendanceStatus;
};

export type AttendanceRecordList = {
  __typename?: 'AttendanceRecordList';
  items: Array<AttendanceRecord>;
  totalCount: Scalars['Int']['output'];
};

export type AttendanceStatus =
  | 'ABSENT'
  | 'LATE'
  | 'OFF'
  | 'ON_LEAVE'
  | 'PRESENT'
  | 'PUBLIC_HOLIDAY';

export type AuditAction =
  | 'EMAIL_VERIFICATION_SENT'
  | 'EMAIL_VERIFIED'
  | 'LOGIN'
  | 'LOGIN_FAILED'
  | 'LOGOUT'
  | 'ORGANIZATION_UPDATED'
  | 'PASSWORD_CHANGED'
  | 'PASSWORD_RESET_COMPLETED'
  | 'PASSWORD_RESET_REQUESTED'
  | 'PROFILE_UPDATED';

export type AuditCategory =
  | 'AUTHENTICATION'
  | 'SETTINGS';

export type AuditLog = {
  __typename?: 'AuditLog';
  action?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  organization?: Maybe<Organization>;
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type AuditLogListResult = {
  __typename?: 'AuditLogListResult';
  items: Array<AuditLog>;
  totalCount: Scalars['Int']['output'];
};

export type AuditStatus =
  | 'FAILED'
  | 'PARTIAL'
  | 'SUCCESS';

export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  requiresEmailVerification?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type BadDebtorsReport = {
  __typename?: 'BadDebtorsReport';
  basis: ReceivablesBasis;
  cutoff: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  groups: Array<ReceivablesStatusRow>;
  partialMonth: Scalars['Boolean']['output'];
  totals: BadDebtorsTotals;
};

export type BadDebtorsTotals = {
  __typename?: 'BadDebtorsTotals';
  averagePaid: Scalars['Float']['output'];
  averageUnlockPrice: Scalars['Float']['output'];
  contracts: Scalars['Int']['output'];
  customers: Scalars['Int']['output'];
  outstanding: Scalars['Float']['output'];
  paid: Scalars['Float']['output'];
  recoveredShare: Scalars['Float']['output'];
  unlockPrice: Scalars['Float']['output'];
};

export type BankAccountType =
  | 'BUSINESS'
  | 'CHEQUE'
  | 'SAVINGS';

export type BankStatementBatch = {
  __typename?: 'BankStatementBatch';
  bank: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Processable lines in the weeks tokens may still be generated for. */
  eligibleProcessableRows: Scalars['Int']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchedRows: Scalars['Int']['output'];
  originalFileName: Scalars['String']['output'];
  /** The weeks this statement's lines fall in, newest first. */
  periods: Array<BankStatementPeriod>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  processedRows: Scalars['Int']['output'];
  rows: Array<BankStatementRow>;
  status: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  uploadedById: Scalars['String']['output'];
  uploadedByName?: Maybe<Scalars['String']['output']>;
};


export type BankStatementBatchRowsArgs = {
  disposition?: InputMaybe<Scalars['String']['input']>;
};

export type BankStatementBatchListResult = {
  __typename?: 'BankStatementBatchListResult';
  items: Array<BankStatementBatch>;
  totalCount: Scalars['Int']['output'];
};

/** A contract a bank line can be matched to, found by searching. */
export type BankStatementContractMatch = {
  __typename?: 'BankStatementContractMatch';
  accountNumber?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
  contractNumber: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type BankStatementNoLoadReason =
  | 'ALREADY_PROCESSED'
  | 'ES_DEPOSIT'
  | 'FFS'
  | 'LARGE_AMOUNT'
  | 'LSP_ANGAZA'
  | 'LSP_PAYGOPS'
  | 'MANUAL'
  | 'NEW_REGISTRATION'
  | 'RECENT_TRANSACTION'
  | 'UNKNOWN_CUSTOMER';

/** A calendar week (Monday to Sunday, organisation time) that a statement's lines fall in. */
export type BankStatementPeriod = {
  __typename?: 'BankStatementPeriod';
  /** True for this week and last week: tokens may be generated. */
  eligible: Scalars['Boolean']['output'];
  processableRows: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  /** 'YYYY-MM-DD', the Sunday. */
  weekEnd: Scalars['String']['output'];
  /** 'YYYY-MM-DD', the Monday. */
  weekStart: Scalars['String']['output'];
};

export type BankStatementProcessFailure = {
  __typename?: 'BankStatementProcessFailure';
  error: Scalars['String']['output'];
  rowId: Scalars['String']['output'];
};

export type BankStatementRow = {
  __typename?: 'BankStatementRow';
  amount: Scalars['Float']['output'];
  bankDate?: Maybe<Scalars['DateTime']['output']>;
  bankUniqueId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  derivedAccountNumber?: Maybe<Scalars['String']['output']>;
  disposition: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastTransactionAmount?: Maybe<Scalars['Float']['output']>;
  lastTransactionAt?: Maybe<Scalars['DateTime']['output']>;
  matchedContractId?: Maybe<Scalars['String']['output']>;
  matchedCustomerId?: Maybe<Scalars['String']['output']>;
  noLoadReason?: Maybe<Scalars['String']['output']>;
  paymentTransactionId?: Maybe<Scalars['String']['output']>;
  rawDescription?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  scrubbedDescription?: Maybe<Scalars['String']['output']>;
};

export type BankStatementTokenCandidate = {
  __typename?: 'BankStatementTokenCandidate';
  batch: BankStatementBatch;
  processableRows: Scalars['Int']['output'];
};

export type BankStatementTokenWeek = {
  __typename?: 'BankStatementTokenWeek';
  processableRows: Scalars['Int']['output'];
  statements: Array<BankStatementTokenCandidate>;
  weekEnd: Scalars['String']['output'];
  weekStart: Scalars['String']['output'];
};

export type BankVerification = {
  __typename?: 'BankVerification';
  agent?: Maybe<Agent>;
  bankAccountHolderSnapshot?: Maybe<Scalars['String']['output']>;
  bankAccountNumberSnapshot?: Maybe<Scalars['String']['output']>;
  bankBranchCodeSnapshot?: Maybe<Scalars['String']['output']>;
  bankNameSnapshot?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  decisionReason?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  events?: Maybe<Array<BankVerificationEvent>>;
  hasStaleProof?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  reminderCount?: Maybe<Scalars['Int']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<User>;
  slaBreached?: Maybe<Scalars['Boolean']['output']>;
  slaDueAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<BankVerificationStatus>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankVerificationEvent = {
  __typename?: 'BankVerificationEvent';
  actor?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fromStatus?: Maybe<BankVerificationStatus>;
  id?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<BankVerificationStatus>;
};

export type BankVerificationFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slaBreachedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<BankVerificationStatus>;
};

export type BankVerificationListResult = {
  __typename?: 'BankVerificationListResult';
  items: Array<BankVerification>;
  totalCount: Scalars['Int']['output'];
};

export type BankVerificationStatus =
  | 'DOCUMENTS_SUBMITTED'
  | 'INFO_REQUESTED'
  | 'PENDING'
  | 'REJECTED'
  | 'UNDER_REVIEW'
  | 'VERIFIED';

export type BatchAddDevicesInput = {
  deviceTypeId: Scalars['String']['input'];
  incoming?: InputMaybe<IncomingShipmentInput>;
  productId: Scalars['String']['input'];
  rows: Array<BatchDeviceRowInput>;
  stockTypeId?: InputMaybe<Scalars['String']['input']>;
  stockingPointId: Scalars['String']['input'];
};

export type BatchAddDevicesResult = {
  __typename?: 'BatchAddDevicesResult';
  errors?: Maybe<Array<BatchDeviceError>>;
  imported?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  skippedRows?: Maybe<Array<BatchDeviceError>>;
};

export type BatchDeviceError = {
  __typename?: 'BatchDeviceError';
  reason?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['Int']['output']>;
};

export type BatchDeviceRowInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  hotpSecret?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startingCode?: InputMaybe<Scalars['String']['input']>;
};

/** An element of the amended B-BBEE Codes of Good Practice scorecard. */
export type BbbeeElement =
  | 'ENTERPRISE_SUPPLIER_DEVELOPMENT'
  | 'MANAGEMENT_CONTROL'
  | 'OWNERSHIP'
  | 'SKILLS_DEVELOPMENT'
  | 'SOCIO_ECONOMIC_DEVELOPMENT';

export type BbbeeLevel =
  | 'LEVEL_1'
  | 'LEVEL_2'
  | 'LEVEL_3'
  | 'LEVEL_4'
  | 'LEVEL_5'
  | 'LEVEL_6'
  | 'LEVEL_7'
  | 'LEVEL_8'
  | 'NON_COMPLIANT';

/** Active subcontractors by B-BBEE level. A null level is "Not recorded". */
export type BbbeeLevelCount = {
  __typename?: 'BbbeeLevelCount';
  count: Scalars['Int']['output'];
  level?: Maybe<BbbeeLevel>;
};

export type BulkActionResult = {
  __typename?: 'BulkActionResult';
  count?: Maybe<Scalars['Int']['output']>;
};

export type BulkChangeContractRatePlanInput = {
  newRatePlanId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  rows: Array<RatePlanChangeRowInput>;
};

export type BulkFlagContractsForRepossessionInput = {
  contractIds: Array<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type BulkFlagRepossessionResult = {
  __typename?: 'BulkFlagRepossessionResult';
  failed?: Maybe<Scalars['Int']['output']>;
  flagged?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<BulkFlagRepossessionRow>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BulkFlagRepossessionRow = {
  __typename?: 'BulkFlagRepossessionRow';
  contractId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BulkFlagRepossessionRowStatus>;
};

export type BulkFlagRepossessionRowStatus =
  | 'FAILED'
  | 'FLAGGED'
  | 'SKIPPED';

export type BulkInviteFailure = {
  __typename?: 'BulkInviteFailure';
  email: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type BulkInviteInput = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  emails: Array<Scalars['String']['input']>;
  isAgent?: InputMaybe<Scalars['Boolean']['input']>;
  roleId: Scalars['String']['input'];
};

export type BulkInviteResult = {
  __typename?: 'BulkInviteResult';
  failed: Array<BulkInviteFailure>;
  pendingApproval?: Maybe<Scalars['Int']['output']>;
  sent: Scalars['Int']['output'];
};

export type BulkInviteRowInput = {
  email: Scalars['String']['input'];
  expectedParentExternalId?: InputMaybe<Scalars['String']['input']>;
  externalAgentId?: InputMaybe<Scalars['String']['input']>;
};

export type BulkInviteRowOutcome = {
  __typename?: 'BulkInviteRowOutcome';
  identifier?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<BulkInviteRowStatus>;
};

export type BulkInviteRowStatus =
  | 'FAILED'
  | 'PENDING_APPROVAL'
  | 'SKIPPED'
  | 'SUCCEEDED';

/** Per-row outcome of a bulk plan change. A row that fails is reported and skipped; the rest of the batch still lands. */
export type BulkRatePlanChangeResult = {
  __typename?: 'BulkRatePlanChangeResult';
  failed?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<BulkRatePlanChangeRowOutcome>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  succeeded?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BulkRatePlanChangeRowOutcome = {
  __typename?: 'BulkRatePlanChangeRowOutcome';
  catchUpTokenAmount?: Maybe<Scalars['Float']['output']>;
  catchUpTokenDays?: Maybe<Scalars['Int']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  newBalance?: Maybe<Scalars['Float']['output']>;
  newSerialNumber?: Maybe<Scalars['String']['output']>;
  previousSerialNumber?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<RatePlanChangeRowStatus>;
};

export type BulkSendInvitesInput = {
  agentCategoryId: Scalars['String']['input'];
  canDoReplacements?: InputMaybe<Scalars['Boolean']['input']>;
  canHoldStock?: InputMaybe<Scalars['Boolean']['input']>;
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  rows: Array<BulkInviteRowInput>;
};

export type BulkSendInvitesResult = {
  __typename?: 'BulkSendInvitesResult';
  failed?: Maybe<Scalars['Int']['output']>;
  pendingApproval?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<BulkInviteRowOutcome>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  succeeded?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BusinessLine = {
  __typename?: 'BusinessLine';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CalculationMethod =
  | 'FIXED'
  | 'PERCENTAGE';

export type Call = {
  __typename?: 'Call';
  callType?: Maybe<Scalars['String']['output']>;
  callerNumber?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  customer?: Maybe<Customer>;
  dispositionOne?: Maybe<Scalars['String']['output']>;
  dispositionThree?: Maybe<Scalars['String']['output']>;
  dispositionTwo?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  loggedBy?: Maybe<User>;
  notes?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  solutionToIssue?: Maybe<Scalars['String']['output']>;
  source?: Maybe<CallSource>;
  statedIssue?: Maybe<Scalars['String']['output']>;
};

export type CallListInput = {
  callType?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  occurredFrom?: InputMaybe<Scalars['DateTime']['input']>;
  occurredTo?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CallSource>;
};

export type CallListResult = {
  __typename?: 'CallListResult';
  items: Array<Call>;
  totalCount: Scalars['Int']['output'];
};

export type CallSource =
  | 'ATLAS'
  | 'DCC';

export type CancelCommissionInput = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type CancelledDeviceLocation =
  | 'RETURNED'
  | 'WITH_CUSTOMER';

export type Candidate = {
  __typename?: 'Candidate';
  applications: Array<CandidateApplication>;
  documents: Array<CandidateCv>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<CandidateSource>;
  sourceDetail?: Maybe<Scalars['String']['output']>;
};

export type CandidateApplication = {
  __typename?: 'CandidateApplication';
  appliedDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  stage: JobApplicationStage;
  vacancyId: Scalars['ID']['output'];
  vacancyStatus: VacancyStatus;
  vacancyTitle: Scalars['String']['output'];
};

export type CandidateCv = {
  __typename?: 'CandidateCv';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type CandidateFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<CandidateSource>>;
};

export type CandidateList = {
  __typename?: 'CandidateList';
  items: Array<Candidate>;
  totalCount: Scalars['Int']['output'];
};

export type CandidateSource =
  | 'AGENCY'
  | 'INTERNAL'
  | 'JOB_BOARD'
  | 'OTHER'
  | 'REFERRAL'
  | 'SOCIAL'
  | 'WALK_IN';

export type ChangeContractRatePlanInput = {
  contractId: Scalars['String']['input'];
  newDeviceIdentifiers: Array<Scalars['String']['input']>;
  newRatePlanId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ChangeRatePlanResult = {
  __typename?: 'ChangeRatePlanResult';
  catchUpTokenAmount?: Maybe<Scalars['Float']['output']>;
  catchUpTokenDays?: Maybe<Scalars['Int']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  newBalance?: Maybe<Scalars['Float']['output']>;
  newRateName?: Maybe<Scalars['String']['output']>;
  newTotalPrice?: Maybe<Scalars['Float']['output']>;
  reassignment?: Maybe<DeviceReassignment>;
};

export type CheckDuplicateCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  excludeCustomerId?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CheckDuplicateCustomerResult = {
  __typename?: 'CheckDuplicateCustomerResult';
  hardConflicts?: Maybe<Array<DuplicateMatch>>;
  hasDuplicates?: Maybe<Scalars['Boolean']['output']>;
  softConflicts?: Maybe<Array<DuplicateMatch>>;
};

export type CheckDuplicateLeadInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  excludeLeadId?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CheckDuplicateLeadResult = {
  __typename?: 'CheckDuplicateLeadResult';
  customerMatches?: Maybe<Array<LeadCustomerMatch>>;
  hasConflict?: Maybe<Scalars['Boolean']['output']>;
  hasHardConflict?: Maybe<Scalars['Boolean']['output']>;
  leadMatches?: Maybe<Array<LeadDuplicateMatch>>;
};

export type ClearRepossessionFlagInput = {
  contractId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type CoidaClaimStatus =
  | 'ACCEPTED'
  | 'CLOSED'
  | 'LODGED'
  | 'PAID'
  | 'REJECTED';

/** Combo sales of one mix of devices: contracts on a combo plan whose first payment cleared the deposit. */
export type ComboMix = {
  __typename?: 'ComboMix';
  devices: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

/** Combos sold over a span — one contract selling two or more devices is one sale — beside every sale over the same days, as reported to EDF. */
export type ComboSales = {
  __typename?: 'ComboSales';
  combos: Scalars['Int']['output'];
  countedFrom: Scalars['DateTime']['output'];
  mixes: Array<ComboMix>;
  sales: Scalars['Int']['output'];
};

export type CommissionApproach =
  | 'AS_COLLECTED'
  | 'FINANCE_WORKBOOK';

export type CommissionApproachChange = {
  __typename?: 'CommissionApproachChange';
  approach: CommissionApproach;
  changedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fromPeriod: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** False once the month it starts on, or a later one, has a run. */
  removable: Scalars['Boolean']['output'];
};

export type CommissionApproachSettings = {
  __typename?: 'CommissionApproachSettings';
  /** Every change, oldest first. */
  changes: Array<CommissionApproachChange>;
  /** First month of the As Collected stretch the month in progress is in; null under Finance's Workbook. */
  collectedFrom?: Maybe<Scalars['DateTime']['output']>;
  /** The approach the month in progress is worked out by. */
  currentApproach: CommissionApproach;
  /** The month in progress, on the organization's calendar. */
  currentPeriod: Scalars['DateTime']['output'];
  /** The earliest month a change may start on: the month after the last month that has a run. Null when no month has a run. */
  earliestFromPeriod?: Maybe<Scalars['DateTime']['output']>;
};

export type CommissionDistributorPaid =
  | 'AT_TIME_OF_SALE'
  | 'CURRENT';

export type CommissionEntry = {
  __typename?: 'CommissionEntry';
  agent?: Maybe<Agent>;
  amountCents?: Maybe<Scalars['Int']['output']>;
  amountRands?: Maybe<Scalars['Float']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  commissionRule?: Maybe<CommissionRule>;
  commissionRun?: Maybe<CommissionRun>;
  commissionType?: Maybe<Scalars['String']['output']>;
  commissionTypeRef?: Maybe<CommissionTypeConfig>;
  contract?: Maybe<Contract>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The part of the amount a distributor earns as the distributor of a sale they made themselves; the rest is theirs as its seller (ADR-0084). */
  distributorAmountCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  periodDate?: Maybe<Scalars['DateTime']['output']>;
  periodMonth?: Maybe<Scalars['Int']['output']>;
  ratePlan?: Maybe<RatePlan>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockSale?: Maybe<StockSale>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommissionEntryListInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  commissionType?: InputMaybe<CommissionType>;
  commissionTypeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CommissionEntryStatus>;
};

export type CommissionEntryListResult = {
  __typename?: 'CommissionEntryListResult';
  items: Array<CommissionEntry>;
  totalCount: Scalars['Int']['output'];
};

export type CommissionEntrySource =
  | 'MANUAL'
  | 'SYSTEM';

export type CommissionEntryStatus =
  | 'APPROVED'
  | 'CANCELLED'
  | 'NOT_PAYABLE'
  | 'ON_HOLD'
  | 'PAID'
  | 'PENDING';

export type CommissionMissedTranche =
  | 'LOST'
  | 'PAID_LATER';

export type CommissionMonthOneStart =
  | 'ACTIVATION_DATE'
  | 'REGISTRATION_DATE'
  | 'SALE_DATE';

/** Which active units earn the monthly amount: every one; only those whose token was running at the payment cutoff; or only those whose customer had paid the deposit plus one instalment per month so far by it. */
export type CommissionMonthlyUnitEligibility =
  | 'EVERY_ACTIVE_CONTRACT'
  | 'ON_TIME_ONLY'
  | 'UP_TO_DATE_ONLY';

/** When the paid-off bonus is paid: in the run for the month the contract was paid off, or once a year in the December run for every contract paid off that year. */
export type CommissionPaidOffBonusTiming =
  | 'ANNUAL'
  | 'WHEN_PAID_OFF';

/** Per-org commission settings: the rules the business may change, each starting on what the engine did before the setting existed. */
export type CommissionPolicy = {
  __typename?: 'CommissionPolicy';
  distributorPaid?: Maybe<CommissionDistributorPaid>;
  minimumPayoutCents?: Maybe<Scalars['Int']['output']>;
  missedTranche?: Maybe<CommissionMissedTranche>;
  monthOneStartsAt?: Maybe<CommissionMonthOneStart>;
  monthlyUnitEligibility?: Maybe<CommissionMonthlyUnitEligibility>;
  paidOffBonusTiming?: Maybe<CommissionPaidOffBonusTiming>;
  requireUpToDate?: Maybe<Scalars['Boolean']['output']>;
  runDayOfNextMonth?: Maybe<Scalars['Int']['output']>;
  trancheMonthBasis?: Maybe<CommissionTrancheMonthBasis>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visitMode?: Maybe<CommissionVisitMode>;
};

export type CommissionRule = {
  __typename?: 'CommissionRule';
  active?: Maybe<Scalars['Boolean']['output']>;
  calculationMethod?: Maybe<Scalars['String']['output']>;
  commissionType?: Maybe<CommissionTypeConfig>;
  commissionTypeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endMonth?: Maybe<Scalars['Int']['output']>;
  forfeitAfterMonths?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isNegative?: Maybe<Scalars['Boolean']['output']>;
  ratePlan?: Maybe<RatePlan>;
  ratePlanId?: Maybe<Scalars['String']['output']>;
  rates?: Maybe<Array<CommissionRuleRate>>;
  startMonth?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommissionRuleListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionRuleListResult = {
  __typename?: 'CommissionRuleListResult';
  items: Array<CommissionRule>;
  totalCount: Scalars['Int']['output'];
};

export type CommissionRuleRate = {
  __typename?: 'CommissionRuleRate';
  agentCategory?: Maybe<AgentCategory>;
  agentCategoryId?: Maybe<Scalars['String']['output']>;
  amountCents?: Maybe<Scalars['Int']['output']>;
  commissionRuleId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type CommissionRuleRateInput = {
  agentCategoryId: Scalars['String']['input'];
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CommissionRun = {
  __typename?: 'CommissionRun';
  /** The approach this run's month is worked out by. */
  approach: CommissionApproach;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  paidAmountCents?: Maybe<Scalars['Int']['output']>;
  paidAmountRands?: Maybe<Scalars['Float']['output']>;
  periodDate?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  totalAmountRands?: Maybe<Scalars['Float']['output']>;
  totalEntries?: Maybe<Scalars['Int']['output']>;
  triggeredBy?: Maybe<User>;
  unpaidEntryCount?: Maybe<Scalars['Int']['output']>;
};

export type CommissionRunListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommissionRunListResult = {
  __typename?: 'CommissionRunListResult';
  items: Array<CommissionRun>;
  totalCount: Scalars['Int']['output'];
};

export type CommissionRunStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'PROCESSING';

export type CommissionRunWorkbook = {
  __typename?: 'CommissionRunWorkbook';
  contentBase64?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

export type CommissionSummary = {
  __typename?: 'CommissionSummary';
  approvedAmountRands?: Maybe<Scalars['Float']['output']>;
  approvedCount?: Maybe<Scalars['Int']['output']>;
  onHoldAmountRands: Scalars['Float']['output'];
  onHoldCount: Scalars['Int']['output'];
  paidAmountRands?: Maybe<Scalars['Float']['output']>;
  paidCount?: Maybe<Scalars['Int']['output']>;
  pendingAmountRands?: Maybe<Scalars['Float']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
};

export type CommissionTrancheMonthBasis =
  | 'CALENDAR_MONTH'
  | 'PAYMENT_COUNT';

export type CommissionType =
  | 'AFTERCARE_AGENT'
  | 'AFTERCARE_RAM'
  | 'SALE_CLOSEOUT'
  | 'SALE_MONTH_1'
  | 'SALE_MONTH_2'
  | 'SALE_MONTH_3'
  | 'SALE_MONTH_4';

export type CommissionTypeConfig = {
  __typename?: 'CommissionTypeConfig';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  triggerEvent?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommissionVisitMode =
  | 'AGENT_CONFIRMS'
  | 'AUTOMATIC';

export type CompleteRepairInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  faultSubTypeId?: InputMaybe<Scalars['String']['input']>;
  faultTypeId?: InputMaybe<Scalars['String']['input']>;
  physicalState: WorkshopPhysicalState;
  physicalStateNote?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigureWorkshopDeviceInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  deviceTypeId: Scalars['String']['input'];
  hotpSecret?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  secretKey?: InputMaybe<Scalars['String']['input']>;
  startingCode?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorRequestEntry = {
  __typename?: 'ConnectorRequestEntry';
  arguments?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  succeeded?: Maybe<Scalars['Boolean']['output']>;
  tool?: Maybe<Scalars['String']['output']>;
};

export type ConnectorUsage = {
  __typename?: 'ConnectorUsage';
  averageDurationMs?: Maybe<Scalars['Int']['output']>;
  byDay?: Maybe<Array<ConnectorUsageDay>>;
  byTool?: Maybe<Array<ConnectorUsageTool>>;
  calls?: Maybe<Scalars['Int']['output']>;
  days?: Maybe<Scalars['Int']['output']>;
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  lastCallAt?: Maybe<Scalars['DateTime']['output']>;
  recent?: Maybe<Array<ConnectorRequestEntry>>;
  refused?: Maybe<Scalars['Int']['output']>;
};

export type ConnectorUsageDay = {
  __typename?: 'ConnectorUsageDay';
  calls?: Maybe<Scalars['Int']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
};

export type ConnectorUsageTool = {
  __typename?: 'ConnectorUsageTool';
  calls?: Maybe<Scalars['Int']['output']>;
  estimatedTokens?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  tool?: Maybe<Scalars['String']['output']>;
};

export type Contract = {
  __typename?: 'Contract';
  accessories?: Maybe<Array<ContractAccessory>>;
  /** @deprecated Renamed to paymentNumber. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  aftercareAgent?: Maybe<Scalars['Int']['output']>;
  aftercareRam?: Maybe<Scalars['Int']['output']>;
  applicationType?: Maybe<ContractApplicationType>;
  balance?: Maybe<Scalars['Float']['output']>;
  carriedBalance?: Maybe<Scalars['Float']['output']>;
  changeHistory?: Maybe<Array<ContractChangeHistory>>;
  commissionCloseout?: Maybe<Scalars['Int']['output']>;
  commissionMonth1?: Maybe<Scalars['Int']['output']>;
  commissionMonth2?: Maybe<Scalars['Int']['output']>;
  commissionMonth3?: Maybe<Scalars['Int']['output']>;
  commissionMonth4?: Maybe<Scalars['Int']['output']>;
  commissionRam?: Maybe<Scalars['Int']['output']>;
  contractEndDate?: Maybe<Scalars['DateTime']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractReference?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  customer?: Maybe<Customer>;
  daysPastDue?: Maybe<Scalars['Int']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositOutstanding?: Maybe<Scalars['Float']['output']>;
  deviceCapacity?: Maybe<Scalars['Int']['output']>;
  deviceControlActions?: Maybe<Array<DeviceControlAction>>;
  /** The distributor above this contract's sales, by name; more than one is joined with '; '. Reversed sales are left out. */
  distributorName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  flaggedForRepossessionAt?: Maybe<Scalars['DateTime']['output']>;
  flaggedForRepossessionBy?: Maybe<User>;
  flaggedForRepossessionReason?: Maybe<Scalars['String']['output']>;
  heldBalance: Scalars['Float']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isFlaggedForRepossession: Scalars['Boolean']['output'];
  isMigrated?: Maybe<Scalars['Boolean']['output']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  manSystem?: Maybe<Scalars['String']['output']>;
  /** The National Sales Manager above this contract's sales, by name. */
  nationalSalesManagerName?: Maybe<Scalars['String']['output']>;
  nonTokenAmount?: Maybe<Scalars['Int']['output']>;
  paymentNumber?: Maybe<Scalars['String']['output']>;
  /** When the payment number was last texted to the customer. Null means it never reached them: no number on file, the gateway refused it, or the contract predates this being sent. */
  paymentNumberNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The number it was sent to. A resend may go to a different handset, so the customer record does not answer this. */
  paymentNumberNotifiedTo?: Maybe<Scalars['String']['output']>;
  priceAdjustment?: Maybe<Scalars['Float']['output']>;
  rateAmount?: Maybe<Scalars['Float']['output']>;
  rateName?: Maybe<Scalars['String']['output']>;
  ratePlan?: Maybe<RatePlan>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  reopenPreview?: Maybe<ReopenPreview>;
  repossessedAt?: Maybe<Scalars['DateTime']['output']>;
  repossessedBy?: Maybe<User>;
  status?: Maybe<Scalars['String']['output']>;
  statusGroup: ContractStatusGroup;
  stockSale?: Maybe<StockSale>;
  stockSales?: Maybe<Array<StockSale>>;
  subStatus?: Maybe<ContractSubStatus>;
  termLength?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upgrade?: Maybe<ContractUpgrade>;
  upgradedInto?: Maybe<ContractUpgradeSource>;
  writeOffEligible: Scalars['Boolean']['output'];
  writeOffReason?: Maybe<Scalars['String']['output']>;
  xeroInvoiceId?: Maybe<Scalars['String']['output']>;
  xeroRepeatingInvoiceId?: Maybe<Scalars['String']['output']>;
};

export type ContractAccessory = {
  __typename?: 'ContractAccessory';
  id?: Maybe<Scalars['ID']['output']>;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  issuedBy?: Maybe<User>;
  product: Product;
  quantity: Scalars['Int']['output'];
  returnReason?: Maybe<ContractAccessoryReturnReason>;
  returnedAt?: Maybe<Scalars['DateTime']['output']>;
  returnedBy?: Maybe<User>;
  stockItem?: Maybe<StockItem>;
  stockingPoint?: Maybe<StockingPoint>;
};

export type ContractAccessoryReturnReason =
  | 'ADDED_IN_ERROR'
  | 'RETURNED';

export type ContractApplicationType =
  | 'NORMAL'
  | 'UPGRADE';

export type ContractChangeHistory = {
  __typename?: 'ContractChangeHistory';
  changeType?: Maybe<Scalars['String']['output']>;
  changedBy?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type ContractCreditSummary = {
  __typename?: 'ContractCreditSummary';
  contractId: Scalars['ID']['output'];
  contractNumber: Scalars['String']['output'];
  daysWithoutCredit: Scalars['Int']['output'];
  fromDate: Scalars['String']['output'];
  longestGapDays: Scalars['Int']['output'];
  percentWithoutCredit: Scalars['Float']['output'];
  status: ContractStatus;
  toDate: Scalars['String']['output'];
  totalDaysAnalysed: Scalars['Int']['output'];
};

export type ContractDelinquencyFilter =
  | 'DELINQUENT'
  | 'IN_CREDIT'
  | 'REPOSSESSION_DUE'
  | 'WRITE_OFF_DUE';

export type ContractLifecycleSummary = {
  __typename?: 'ContractLifecycleSummary';
  active?: Maybe<Scalars['Int']['output']>;
  activeDelinquent?: Maybe<Scalars['Int']['output']>;
  activeInCredit?: Maybe<Scalars['Int']['output']>;
  activeRepossessionDue?: Maybe<Scalars['Int']['output']>;
  activeWriteOffDue?: Maybe<Scalars['Int']['output']>;
  cancelled?: Maybe<Scalars['Int']['output']>;
  draft?: Maybe<Scalars['Int']['output']>;
  paidOff?: Maybe<Scalars['Int']['output']>;
  pendingInstallation?: Maybe<Scalars['Int']['output']>;
  repossessed?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  upgraded?: Maybe<Scalars['Int']['output']>;
  writtenOff?: Maybe<Scalars['Int']['output']>;
  writtenOffNotRepossessed?: Maybe<Scalars['Int']['output']>;
  writtenOffRepossessed?: Maybe<Scalars['Int']['output']>;
  writtenOffTheft?: Maybe<Scalars['Int']['output']>;
};

export type ContractListInput = {
  awaitingLockConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  delinquency?: InputMaybe<ContractDelinquencyFilter>;
  flaggedForRepossession?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  owing?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ContractSort>;
  statusGroups?: InputMaybe<Array<ContractStatusGroup>>;
  statuses?: InputMaybe<Array<ContractStatus>>;
};

export type ContractListResult = {
  __typename?: 'ContractListResult';
  items: Array<Contract>;
  totalCount: Scalars['Int']['output'];
};

export type ContractSort =
  | 'BALANCE_ASC'
  | 'BALANCE_DESC'
  | 'CREATED_DESC';

export type ContractStatus =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'DRAFT'
  | 'PAID_OFF'
  | 'PENDING_INSTALLATION'
  | 'REPOSSESSED'
  | 'UPGRADED'
  | 'WRITTEN_OFF';

export type ContractStatusCount = {
  __typename?: 'ContractStatusCount';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ContractStatusGroup =
  | 'ACTIVE'
  | 'COMPLETE'
  | 'PRE_CONTRACT';

export type ContractSubStatus =
  | 'DELINQUENT_TIER_1'
  | 'DELINQUENT_TIER_2'
  | 'DELINQUENT_TIER_3'
  | 'DELINQUENT_TIER_4'
  | 'IN_CREDIT';

/** One upgrade onboarding: the contracts an Upgrade contract closed and what moved onto it (ADR-0083). */
export type ContractUpgrade = {
  __typename?: 'ContractUpgrade';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditAmount?: Maybe<Scalars['Float']['output']>;
  creditReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  movedTotal?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  onboardedBy?: Maybe<User>;
  openingBalance?: Maybe<Scalars['Float']['output']>;
  sources?: Maybe<Array<ContractUpgradeSource>>;
  upgradeContract?: Maybe<Contract>;
  writtenOffTotal?: Maybe<Scalars['Float']['output']>;
};

export type ContractUpgradeSource = {
  __typename?: 'ContractUpgradeSource';
  amountMoved?: Maybe<Scalars['Float']['output']>;
  amountWrittenOff?: Maybe<Scalars['Float']['output']>;
  balanceAtClosure?: Maybe<Scalars['Float']['output']>;
  balanceTreatment?: Maybe<UpgradeBalanceTreatment>;
  contractUpgrade?: Maybe<ContractUpgrade>;
  deviceOutcome?: Maybe<UpgradeDeviceOutcome>;
  id?: Maybe<Scalars['ID']['output']>;
  sourceContract?: Maybe<Contract>;
  statusBefore?: Maybe<ContractStatus>;
};

export type ConvertLeadResult = {
  __typename?: 'ConvertLeadResult';
  customerId?: Maybe<Scalars['String']['output']>;
  linked?: Maybe<Scalars['Boolean']['output']>;
};

export type Courier =
  | 'COURIER_GUY'
  | 'PARCEL_PERFECT'
  | 'TRITON';

export type CourierImport = {
  __typename?: 'CourierImport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  importedBy?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<CourierImportKind>;
  notFoundWaybills?: Maybe<Array<Scalars['String']['output']>>;
  rowsImported?: Maybe<Scalars['Int']['output']>;
  rowsRead?: Maybe<Scalars['Int']['output']>;
};

export type CourierImportKind =
  | 'TRITON_INVOICE'
  | 'TRITON_WAYBILL_LIST';

export type CreateAgentCategoryInput = {
  canBeParent?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAgentInput = {
  agentCategoryId?: InputMaybe<Scalars['String']['input']>;
  agentType: AgentType;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountType?: InputMaybe<AgentBankAccountType>;
  bankBranchCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  canDoReplacements?: InputMaybe<Scalars['Boolean']['input']>;
  canHoldStock?: InputMaybe<Scalars['Boolean']['input']>;
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  municipality?: InputMaybe<Scalars['String']['input']>;
  parentAgentId?: InputMaybe<Scalars['String']['input']>;
  paymentPhone?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  province?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAgentTransferInput = {
  destinationStockingPointId: Scalars['String']['input'];
  stockItemIds: Array<Scalars['String']['input']>;
};

export type CreateApiConsumerInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};

export type CreateApiConsumerResult = {
  __typename?: 'CreateApiConsumerResult';
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  consumer?: Maybe<ApiConsumer>;
};

export type CreateApiKeyInput = {
  name: Scalars['String']['input'];
};

export type CreateApiKeyResult = {
  __typename?: 'CreateApiKeyResult';
  apiKey?: Maybe<ApiKey>;
  rawKey?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicationInput = {
  customerId: Scalars['String']['input'];
  employer?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  income?: InputMaybe<Scalars['Float']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateApprovalRequestInput = {
  customerId: Scalars['String']['input'];
  ratePlanId: Scalars['String']['input'];
  requestReason: Scalars['String']['input'];
};

export type CreateAttendanceRecordInput = {
  date: Scalars['DateTime']['input'];
  hoursWorked?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overtimeHours?: InputMaybe<Scalars['Float']['input']>;
  status: AttendanceStatus;
};

export type CreateBusinessLineInput = {
  externalCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCandidateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CandidateSource>;
  sourceDetail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommissionRuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  calculationMethod: CalculationMethod;
  commissionTypeId: Scalars['String']['input'];
  endMonth?: InputMaybe<Scalars['Int']['input']>;
  forfeitAfterMonths?: InputMaybe<Scalars['Int']['input']>;
  isNegative?: InputMaybe<Scalars['Boolean']['input']>;
  ratePlanId?: InputMaybe<Scalars['String']['input']>;
  startMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCommissionTypeInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  triggerEvent: TriggerEvent;
};

export type CreateContractInput = {
  customerId: Scalars['String']['input'];
  ratePlanId: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  address?: InputMaybe<AddressInput>;
  currentSourceOfLight?: InputMaybe<SourceOfLight>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  gpsLatitude?: InputMaybe<Scalars['Float']['input']>;
  gpsLongitude?: InputMaybe<Scalars['Float']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<IdentificationType>;
  income?: InputMaybe<Scalars['Float']['input']>;
  lastName: Scalars['String']['input'];
  occupation?: InputMaybe<Occupation>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primarySource?: InputMaybe<ManSystem>;
  registrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  secondaryContactFirstName?: InputMaybe<Scalars['String']['input']>;
  secondaryContactLastName?: InputMaybe<Scalars['String']['input']>;
  secondaryContactPhone?: InputMaybe<Scalars['String']['input']>;
  secondaryPhone?: InputMaybe<Scalars['String']['input']>;
  sourceSystemIds?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateDepartmentInput = {
  name: Scalars['String']['input'];
};

export type CreateDeviceTypeInput = {
  defaultMeterTypeId?: InputMaybe<Scalars['Int']['input']>;
  fields?: InputMaybe<Array<DeviceTypeFieldInput>>;
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDigitalChannelInput = {
  gaPropertyId: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kind: DigitalChannelKind;
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateEmployeeBenefitInput = {
  employeeContribution?: InputMaybe<Scalars['Float']['input']>;
  employerContribution?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type: EmployeeBenefitType;
};

export type CreateEmployeeFromHireInput = {
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateEmployeeInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  employment?: InputMaybe<EmploymentInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateEsgBeneficiaryInput = {
  /** The staff member, on an employee-wellness programme only. */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  gender?: InputMaybe<EsgBeneficiaryGender>;
  /** Only for an INDIVIDUAL. */
  hasDisability?: InputMaybe<Scalars['Boolean']['input']>;
  /** Aged 15–35. Only for an INDIVIDUAL. */
  isYouth?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** People in a community. Only for a COMMUNITY. */
  peopleCount?: InputMaybe<Scalars['Int']['input']>;
  reachedDate: Scalars['DateTime']['input'];
  type: EsgBeneficiaryType;
};

export type CreateEsgOutcomeInput = {
  measuredDate: Scalars['DateTime']['input'];
  metricName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type CreateEsgProgrammeInput = {
  bbbeeElement?: InputMaybe<BbbeeElement>;
  /** In rand. */
  budget?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<EsgProgrammeCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** A CRM user. */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<EsgProgrammeStatus>;
};

export type CreateEsgSpendInput = {
  /** In rand. */
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  spendDate: Scalars['DateTime']['input'];
};

export type CreateEsgVolunteeringInput = {
  activityDate: Scalars['DateTime']['input'];
  employeeId: Scalars['ID']['input'];
  hours: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Never type the caller's name, number or email address into any field. */
export type CreateGrievanceInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  desiredOutcome?: InputMaybe<Scalars['String']['input']>;
  incidentDate?: InputMaybe<Scalars['Date']['input']>;
  incidentLocation?: InputMaybe<Scalars['String']['input']>;
  involvement?: InputMaybe<GrievanceInvolvement>;
  managementAware?: InputMaybe<GrievanceManagementAware>;
  retaliationConcern?: InputMaybe<Scalars['Boolean']['input']>;
  source: GrievanceManualSource;
  subject: Scalars['String']['input'];
};

/** The Access Code is shown once, here, to read back to the caller. It is never stored. */
export type CreateGrievancePayload = {
  __typename?: 'CreateGrievancePayload';
  accessCode?: Maybe<Scalars['String']['output']>;
  grievance?: Maybe<Grievance>;
};

/** Disciplinary fields (offence, sanction, warning expiry) only on a DISCIPLINARY case; case number, referral date, stage and outcome only on CCMA and LABOUR_DISPUTE. */
export type CreateHrCaseInput = {
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  closedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** In rand. */
  cost?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  employeeId: Scalars['ID']['input'];
  offenceCategory?: InputMaybe<Scalars['String']['input']>;
  openedDate: Scalars['DateTime']['input'];
  outcome?: InputMaybe<HrCaseOutcome>;
  referralDate?: InputMaybe<Scalars['DateTime']['input']>;
  sanction?: InputMaybe<HrCaseSanction>;
  stage?: InputMaybe<HrCaseStage>;
  status?: InputMaybe<HrCaseStatus>;
  type: HrCaseType;
  warningExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateImprovementPlanInput = {
  employeeId: Scalars['ID']['input'];
  endDate: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  objectives: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateItemCategoryInput = {
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJobApplicationInput = {
  appliedDate?: InputMaybe<Scalars['DateTime']['input']>;
  candidateId: Scalars['ID']['input'];
  vacancyId: Scalars['ID']['input'];
};

export type CreateLeadInput = {
  assignedToId: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<IdentificationType>;
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<LeadCommunicationChannel>;
  products?: InputMaybe<Array<LeadProductInput>>;
  sourceId: Scalars['String']['input'];
  statusId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeadSourceInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeadStatusInput = {
  category?: InputMaybe<LeadStatusCategory>;
  color?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLearningProgrammeInput = {
  employeeId: Scalars['ID']['input'];
  /** The fixed-term Employment it sits on. Defaults to the open one. */
  employmentId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  nqfLevel?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<LearningProgrammeOutcome>;
  seta?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  type: LearningProgrammeType;
};

export type CreateLeaveBalanceInput = {
  cycleEnd?: InputMaybe<Scalars['DateTime']['input']>;
  cycleStart: Scalars['DateTime']['input'];
  entitlementDays?: InputMaybe<Scalars['Float']['input']>;
  takenDays?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateLeaveRequestInput = {
  days?: InputMaybe<Scalars['Float']['input']>;
  employeeId: Scalars['ID']['input'];
  endDate: Scalars['DateTime']['input'];
  leaveTypeId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateManualCommissionInput = {
  agentId: Scalars['String']['input'];
  amountCents: Scalars['Int']['input'];
  commissionTypeId: Scalars['String']['input'];
  note: Scalars['String']['input'];
  periodDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateModuleInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateNoteInput = {
  body: Scalars['String']['input'];
  categoryId?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<NoteVisibility>;
};

export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
};

export type CreatePayRunInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  periodMonth: Scalars['DateTime']['input'];
};

export type CreatePerformanceReviewInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  cycleId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PerformanceReviewStatus>;
};

export type CreateProductBrandInput = {
  externalCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProductCategoryInput = {
  externalCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProductInput = {
  batteryKwh?: InputMaybe<Scalars['Float']['input']>;
  businessLineId?: InputMaybe<Scalars['String']['input']>;
  canAcceptToken?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  itemCategoryId?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ProductKind>;
  lastCostCents?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  panelEfficiency?: InputMaybe<Scalars['Float']['input']>;
  panelWatts?: InputMaybe<Scalars['Int']['input']>;
  productBrandId?: InputMaybe<Scalars['String']['input']>;
  productCategoryId: Scalars['String']['input'];
  requiresSerialTracking?: InputMaybe<Scalars['Boolean']['input']>;
  sku: Scalars['String']['input'];
  systemEfficiency?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePurchaseOrderInput = {
  contentType?: InputMaybe<PurchaseOrderContentType>;
  destinationId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  shippingCompanyId?: InputMaybe<Scalars['String']['input']>;
  stockType?: InputMaybe<PurchaseOrderStockType>;
  supplierId: Scalars['String']['input'];
  waybillReference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRatePlanInput = {
  aftercareAgent?: InputMaybe<Scalars['Int']['input']>;
  aftercareRam?: InputMaybe<Scalars['Int']['input']>;
  commissionCloseout?: InputMaybe<Scalars['Int']['input']>;
  commissionMonth1?: InputMaybe<Scalars['Int']['input']>;
  commissionMonth2?: InputMaybe<Scalars['Int']['input']>;
  commissionMonth3?: InputMaybe<Scalars['Int']['input']>;
  commissionMonth4?: InputMaybe<Scalars['Int']['input']>;
  commissionRam?: InputMaybe<Scalars['Int']['input']>;
  depositAmount: Scalars['Float']['input'];
  depositCollectedUpfront?: InputMaybe<Scalars['Boolean']['input']>;
  downpayment: Scalars['Float']['input'];
  downpaymentFormula?: InputMaybe<Scalars['String']['input']>;
  manSystem: ManSystem;
  product: Scalars['String']['input'];
  productAllocations?: InputMaybe<Array<RatePlanProductAllocationInput>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rateAmount: Scalars['Float']['input'];
  rateName: Scalars['String']['input'];
  termLength: Scalars['Int']['input'];
  tokenCase?: InputMaybe<TokenCase>;
  type?: InputMaybe<RatePlanType>;
};

export type CreateRoleInput = {
  accessLevel?: InputMaybe<Scalars['String']['input']>;
  assignableForAgents?: InputMaybe<Scalars['Boolean']['input']>;
  canManageAgents?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  homeModule?: InputMaybe<HomeModule>;
  name: Scalars['String']['input'];
  requiresWorkshop?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSafetyCorrectiveActionInput = {
  description: Scalars['String']['input'];
  /** Set when done. */
  doneDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** A CRM user. */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSafetyIncidentInput = {
  /** With status CLOSED; defaults to today. */
  closedDate?: InputMaybe<Scalars['DateTime']['input']>;
  coidaClaimNumber?: InputMaybe<Scalars['String']['input']>;
  coidaClaimStatus?: InputMaybe<CoidaClaimStatus>;
  /** Defaults to the employee's home department on a new incident. */
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** An employee or a subcontractor (optionally one of its workers), never both. Picking a worker sets the subcontractor. */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Health information (POPIA special). */
  injuryDetails?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lostDays?: InputMaybe<Scalars['Int']['input']>;
  /** Date and time. */
  occurredAt: Scalars['DateTime']['input'];
  reportable?: InputMaybe<Scalars['Boolean']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<SafetyIncidentSeverity>;
  status?: InputMaybe<SafetyIncidentStatus>;
  /** An employee or a subcontractor (optionally one of its workers), never both. Picking a worker sets the subcontractor. */
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
  /** An employee or a subcontractor (optionally one of its workers), never both. Picking a worker sets the subcontractor. */
  subcontractorWorkerId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<SafetyIncidentType>;
};

export type CreateSafetyInspectionInput = {
  area: Scalars['String']['input'];
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  findingsCount?: InputMaybe<Scalars['Int']['input']>;
  inspectionDate: Scalars['DateTime']['input'];
  inspectorName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scorePercent?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<SafetyInspectionType>;
};

export type CreateShippingCompanyInput = {
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  courier?: InputMaybe<Courier>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  trackingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStockTransferFromSerialsInput = {
  destinationStockingPointId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  serialNumbers: Array<Scalars['String']['input']>;
  shippingCompanyId?: InputMaybe<Scalars['String']['input']>;
  sourceStockingPointId: Scalars['String']['input'];
  waybillReference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStockTransferInput = {
  destinationStockingPointId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  shippingCompanyId?: InputMaybe<Scalars['String']['input']>;
  sourceStockingPointId: Scalars['String']['input'];
  stockItemIds: Array<Scalars['String']['input']>;
  waybillReference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStockTypeInput = {
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateStockingPointInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  minimumStockLevel?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentStockingPointId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  stockQuantityLimit?: InputMaybe<Scalars['Int']['input']>;
  type: StockingPointType;
};

export type CreateSubcontractorComplianceInput = {
  /** The last day it is valid. Null = it does not expire. */
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuedDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type: SubcontractorDocumentType;
};

export type CreateSubcontractorHoursInput = {
  hours: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};

export type CreateSubcontractorInput = {
  bbbeeLevel?: InputMaybe<BbbeeLevel>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contractEnd?: InputMaybe<Scalars['DateTime']['input']>;
  contractStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** In rand. */
  contractValue?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubcontractorStatus>;
};

export type CreateSubcontractorInvoiceInput = {
  /** In rand. */
  amount: Scalars['Float']['input'];
  invoiceDate: Scalars['DateTime']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubcontractorWorkerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Link to a CRM sales agent. Optional. */
  agentId?: InputMaybe<Scalars['ID']['input']>;
  firstName: Scalars['String']['input'];
  /** SA ID or passport number. */
  idNumber?: InputMaybe<Scalars['String']['input']>;
  inductionDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  beeLevel?: InputMaybe<Scalars['Int']['input']>;
  beeStatus?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type CreateThirdPartyCredentialInput = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateTrainingCertificationInput = {
  certificateNumber?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  employeeId: Scalars['ID']['input'];
  /** Omit to work it out from the course's validity; send null for a certificate that does not expire. */
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuedDate: Scalars['DateTime']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTrainingSessionInput = {
  /** In rand. */
  cost?: InputMaybe<Scalars['Float']['input']>;
  courseId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  /** Also record the certificate: a completed session, dated its end, expiring by the course's validity. */
  issueCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<TrainingSessionStatus>;
};

export type CreateUnitOfMeasureInput = {
  externalCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateVacancyInput = {
  closedDate?: InputMaybe<Scalars['DateTime']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  headcount?: InputMaybe<Scalars['Int']['input']>;
  hiringManagerId?: InputMaybe<Scalars['ID']['input']>;
  jobPositionId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openedDate?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<VacancyReason>;
  status?: InputMaybe<VacancyStatus>;
  targetFillDate?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};

export type CreateWebhookSubscriptionInput = {
  apiConsumerId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  events: Array<Scalars['String']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateWebhookSubscriptionResult = {
  __typename?: 'CreateWebhookSubscriptionResult';
  secret: Scalars['String']['output'];
  subscription: WebhookSubscription;
};

export type CreditDay = {
  __typename?: 'CreditDay';
  /** Whole days of credit left at the end of the day. */
  creditDays: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  inCredit: Scalars['Boolean']['output'];
  paymentAmount: Scalars['Float']['output'];
};

export type CreditGap = {
  __typename?: 'CreditGap';
  days: Scalars['Int']['output'];
  fromDate: Scalars['String']['output'];
  toDate: Scalars['String']['output'];
};

export type CreditInsight = {
  __typename?: 'CreditInsight';
  code: CreditInsightCode;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<ContractStatus>;
  days?: Maybe<Scalars['Int']['output']>;
  fromDate?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<PaymentRating>;
  toDate?: Maybe<Scalars['String']['output']>;
};

export type CreditInsightCode =
  | 'CURRENTLY_WITHOUT_CREDIT'
  | 'DECLINING'
  | 'IMPROVING'
  | 'LONGEST_GAP'
  | 'NO_CREDIT_HISTORY'
  | 'PRIOR_DEFAULT'
  | 'RATING_SUMMARY';

/** What recovering delivered days costs the customer who keeps them. */
export type CreditRecoveryPlan = {
  __typename?: 'CreditRecoveryPlan';
  extendedByFloor: Scalars['Boolean']['output'];
  instalments: Scalars['Int']['output'];
  perPayment: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Address>;
  applications?: Maybe<Array<Application>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedReason?: Maybe<Scalars['String']['output']>;
  changeHistory?: Maybe<Array<CustomerChangeHistory>>;
  contracts?: Maybe<Array<Contract>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currentSourceOfLight?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<User>;
  /** The distributor above this customer's sales, by name; more than one is joined with '; '. Reversed sales are left out. */
  distributorName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  gpsLatitude?: Maybe<Scalars['Float']['output']>;
  gpsLongitude?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  identificationType?: Maybe<Scalars['String']['output']>;
  income?: Maybe<Scalars['Float']['output']>;
  isMigrated?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** The National Sales Manager above this customer's sales, by name. */
  nationalSalesManagerName?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  primarySource?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  secondaryContactFirstName?: Maybe<Scalars['String']['output']>;
  secondaryContactLastName?: Maybe<Scalars['String']['output']>;
  secondaryContactPhone?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
  sourceSystemIds?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  xeroContactId?: Maybe<Scalars['String']['output']>;
};

/** Active customers on the book over one month, for the organization and per owning agent. */
export type CustomerBookActivity = {
  __typename?: 'CustomerBookActivity';
  agents: Array<CustomerBookAgentActivity>;
  closingDate: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  month: Scalars['String']['output'];
  openingDate: Scalars['DateTime']['output'];
  partialMonth: Scalars['Boolean']['output'];
  total: CustomerBookActivityFigures;
};

/** Active customers and contracts at the start and end of a month, and what moved the contracts between the two. Active means ACTIVE status with the token still running at the end of the day. Opening + newContracts + paidAgain + returned − tokenRanOut − paidOff − repossessed − writtenOff − cancelled = closing. */
export type CustomerBookActivityFigures = {
  __typename?: 'CustomerBookActivityFigures';
  cancelled: Scalars['Int']['output'];
  closingContracts: Scalars['Int']['output'];
  closingCustomers: Scalars['Int']['output'];
  closingNoPayment90: Scalars['Int']['output'];
  closingPaidOffContracts: Scalars['Int']['output'];
  /** Customers holding at least one PAID_OFF contract at the end. */
  closingPaidOffCustomers: Scalars['Int']['output'];
  closingRepossessedContracts: Scalars['Int']['output'];
  /** Customers holding at least one REPOSSESSED contract at the end. */
  closingRepossessedCustomers: Scalars['Int']['output'];
  closingTokenOut: Scalars['Int']['output'];
  /** Customers holding at least one ACTIVE contract whose token had run out at the end. */
  closingTokenOutCustomers: Scalars['Int']['output'];
  closingWrittenOffContracts: Scalars['Int']['output'];
  /** Customers holding at least one WRITTEN_OFF contract at the end. */
  closingWrittenOffCustomers: Scalars['Int']['output'];
  newContracts: Scalars['Int']['output'];
  openingContracts: Scalars['Int']['output'];
  openingCustomers: Scalars['Int']['output'];
  openingNoPayment90: Scalars['Int']['output'];
  openingTokenOut: Scalars['Int']['output'];
  paidAgain: Scalars['Int']['output'];
  paidOff: Scalars['Int']['output'];
  repossessed: Scalars['Int']['output'];
  returned: Scalars['Int']['output'];
  tokenRanOut: Scalars['Int']['output'];
  writtenOff: Scalars['Int']['output'];
};

/** One owning agent's active figures, by the same ownership rule as the book. */
export type CustomerBookAgentActivity = {
  __typename?: 'CustomerBookAgentActivity';
  agentId?: Maybe<Scalars['String']['output']>;
  figures: CustomerBookActivityFigures;
};

/** One owning agent's trend, by the same ownership rule as the book. */
export type CustomerBookAgentTrend = {
  __typename?: 'CustomerBookAgentTrend';
  agentId?: Maybe<Scalars['String']['output']>;
  series: CustomerBookTrendSeries;
};

export type CustomerBookNsm = {
  __typename?: 'CustomerBookNsm';
  contracts: Scalars['Int']['output'];
  customers: Scalars['Int']['output'];
  distributors: Scalars['Int']['output'];
  nsmAvatarUrl?: Maybe<Scalars['String']['output']>;
  nsmEmail?: Maybe<Scalars['String']['output']>;
  nsmId?: Maybe<Scalars['String']['output']>;
  nsmName?: Maybe<Scalars['String']['output']>;
  owners: Array<CustomerBookOwner>;
  salesAgents: Scalars['Int']['output'];
};

export type CustomerBookOwner = {
  __typename?: 'CustomerBookOwner';
  agentAvatarUrl?: Maybe<Scalars['String']['output']>;
  agentId: Scalars['String']['output'];
  agentName: Scalars['String']['output'];
  agentSalesId: Scalars['String']['output'];
  agentStatus: AgentStatus;
  agentType: AgentType;
  contracts: Scalars['Int']['output'];
  customers: Scalars['Int']['output'];
  distributorName?: Maybe<Scalars['String']['output']>;
};

export type CustomerBookReport = {
  __typename?: 'CustomerBookReport';
  attributedContracts: Scalars['Int']['output'];
  attributedCustomers: Scalars['Int']['output'];
  items: Array<CustomerBookNsm>;
  totalContracts: Scalars['Int']['output'];
  totalCustomers: Scalars['Int']['output'];
};

/** Active contracts, token out and no payment in 90+ days at every day of a period — every month for one longer than a quarter — for the organization and per owning agent. The first and last points are the activity card's opening and closing figures. */
export type CustomerBookTrend = {
  __typename?: 'CustomerBookTrend';
  agents: Array<CustomerBookAgentTrend>;
  dates: Array<Scalars['String']['output']>;
  generatedAt: Scalars['DateTime']['output'];
  month: Scalars['String']['output'];
  partialMonth: Scalars['Boolean']['output'];
  step: CustomerBookTrendStep;
  total: CustomerBookTrendSeries;
};

/** The card's three end-of-day figures at every point of the trend, one entry per date in order. */
export type CustomerBookTrendSeries = {
  __typename?: 'CustomerBookTrendSeries';
  activeContracts: Array<Scalars['Int']['output']>;
  noPayment90: Array<Scalars['Int']['output']>;
  tokenOut: Array<Scalars['Int']['output']>;
};

export type CustomerBookTrendStep =
  | 'DAY'
  | 'MONTH';

export type CustomerChangeHistory = {
  __typename?: 'CustomerChangeHistory';
  changeType?: Maybe<Scalars['String']['output']>;
  changedBy?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type CustomerDemographicsFilter = {
  contractStatus?: InputMaybe<ContractStatus>;
  province?: InputMaybe<Scalars['String']['input']>;
  registeredFrom?: InputMaybe<Scalars['DateTime']['input']>;
  registeredTo?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<CustomerSource>;
};

/** Who the live customers are — age and gender — and where they live. Every dimension keeps its unknowns: coverage says how many customers each one is known for. */
export type CustomerDemographicsReport = {
  __typename?: 'CustomerDemographicsReport';
  ageBands: Array<DemographicAgeBand>;
  averageAge?: Maybe<Scalars['Float']['output']>;
  cities: Array<DemographicPlace>;
  coverage: DemographicsCoverage;
  gender: Array<DemographicGenderCount>;
  medianAge?: Maybe<Scalars['Float']['output']>;
  municipalities: Array<DemographicPlace>;
  provinces: Array<DemographicPlace>;
  sources: Array<DemographicSourceCoverage>;
  totalCustomers: Scalars['Int']['output'];
  towns: Array<DemographicPlace>;
};

/** A customer's credit rebuilt day by day across all their contracts. A day counts once however many contracts ran on it, and is without credit if any of them had none for the whole day. */
export type CustomerFinancialAnalysis = {
  __typename?: 'CustomerFinancialAnalysis';
  contracts: Array<ContractCreditSummary>;
  currentGapDays: Scalars['Int']['output'];
  days: Array<CreditDay>;
  daysWithoutCredit: Scalars['Int']['output'];
  fromDate?: Maybe<Scalars['String']['output']>;
  insights: Array<CreditInsight>;
  longestGap?: Maybe<CreditGap>;
  percentWithoutCredit?: Maybe<Scalars['Float']['output']>;
  priorDefault?: Maybe<PriorDefault>;
  rating?: Maybe<PaymentRating>;
  thresholds: PaymentRatingPolicy;
  toDate?: Maybe<Scalars['String']['output']>;
  totalDaysAnalysed: Scalars['Int']['output'];
};

export type CustomerListResult = {
  __typename?: 'CustomerListResult';
  items: Array<Customer>;
  totalCount: Scalars['Int']['output'];
};

export type CustomerSearchInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<CustomerStatus>>;
};

/** Where a customer record came from: a platform it was migrated or synced from, or CRM for one created here. */
export type CustomerSource =
  | 'ANGAZA'
  | 'ATLAS'
  | 'CRM'
  | 'LEGACYSMSUTILS'
  | 'PAYGOPS';

/**
 * A Statement issued to a customer: the record of it, never the document. An
 * issued statement is never downloaded again; staff issue a new one.
 */
export type CustomerStatement = {
  __typename?: 'CustomerStatement';
  contractCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuedByName: Scalars['String']['output'];
  number: Scalars['String']['output'];
  /** Null for a statement of the customer's full history. */
  periodFrom?: Maybe<Scalars['DateTime']['output']>;
  /** The exclusive end: midnight (SAST) after the statement's last day. */
  periodTo: Scalars['DateTime']['output'];
  /** Null when no contract on the statement has a price. */
  totalBalance?: Maybe<Scalars['Float']['output']>;
};

export type CustomerStatus =
  | 'ACTIVE'
  | 'DEACTIVATED'
  | 'DELINQUENT'
  | 'DRAFT'
  | 'PAID_OFF'
  | 'REPOSSESSED'
  | 'SUSPENDED'
  | 'WRITTEN_OFF';

export type CustomerStatusCount = {
  __typename?: 'CustomerStatusCount';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DccProfile = {
  __typename?: 'DccProfile';
  externalAgentId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ramId?: Maybe<Scalars['String']['output']>;
  ramName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type DeleteDocumentResult = {
  __typename?: 'DeleteDocumentResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DelinquencyPolicy = {
  __typename?: 'DelinquencyPolicy';
  repossessionThresholdDays?: Maybe<Scalars['Int']['output']>;
  tier1Days?: Maybe<Scalars['Int']['output']>;
  tier2Days?: Maybe<Scalars['Int']['output']>;
  tier3Days?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  writeOffThresholdDays?: Maybe<Scalars['Int']['output']>;
};

/** One age band, split by gender. */
export type DemographicAgeBand = {
  __typename?: 'DemographicAgeBand';
  band: AgeBand;
  female: Scalars['Int']['output'];
  male: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unknown: Scalars['Int']['output'];
};

/** A customer's gender as the demographics report counts it. UNKNOWN covers no record, a record the ID number cannot fill, and "prefer not to say". */
export type DemographicGender =
  | 'FEMALE'
  | 'MALE'
  | 'OTHER'
  | 'UNKNOWN';

export type DemographicGenderCount = {
  __typename?: 'DemographicGenderCount';
  customers: Scalars['Int']['output'];
  gender: DemographicGender;
};

export type DemographicPlace = {
  __typename?: 'DemographicPlace';
  customers: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  province?: Maybe<Scalars['String']['output']>;
};

/** How complete one source platform's customer records are. */
export type DemographicSourceCoverage = {
  __typename?: 'DemographicSourceCoverage';
  customers: Scalars['Int']['output'];
  source: CustomerSource;
  withAge: Scalars['Int']['output'];
  withGender: Scalars['Int']['output'];
  withProvince: Scalars['Int']['output'];
};

/** How many customers each dimension is known for. */
export type DemographicsCoverage = {
  __typename?: 'DemographicsCoverage';
  age: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  gender: Scalars['Int']['output'];
  municipality: Scalars['Int']['output'];
  province: Scalars['Int']['output'];
  town: Scalars['Int']['output'];
};

export type DemographicsJobPosition = {
  __typename?: 'DemographicsJobPosition';
  id: Scalars['ID']['output'];
  level?: Maybe<JobLevel>;
  title: Scalars['String']['output'];
};

export type DemographicsTeam = {
  __typename?: 'DemographicsTeam';
  departmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Department = {
  __typename?: 'Department';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultRoles?: Maybe<Array<DepartmentRole>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userDepartments?: Maybe<Array<UserDepartment>>;
};

export type DepartmentRole = {
  __typename?: 'DepartmentRole';
  department?: Maybe<Department>;
  id?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<Role>;
};

export type DeviceCondition =
  | 'FAIR'
  | 'GOOD'
  | 'NOT_WORKING'
  | 'PHYSICAL_DAMAGE'
  | 'POOR';

export type DeviceConfirmationMethod =
  | 'PHONE_CALL'
  | 'PHOTO'
  | 'VISIT';

export type DeviceControlAction = {
  __typename?: 'DeviceControlAction';
  accountNumber?: Maybe<Scalars['String']['output']>;
  action?: Maybe<DeviceControlCommand>;
  /** When an operator confirmed the customer keyed this code in. LOCK only, and it is what moves the contract clock rather than the action being recorded: no vendor can tell us whether a code was entered. Null means we do not know yet, not that it failed. */
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the code was texted to the customer. Null means nobody received it (the gateway refused it, no number was on file, or the unlock predates this being recorded), and is what puts the resend within reach. */
  customerNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The number the code was sent to. Kept separately because a resend may be directed elsewhere, so the customer record does not answer this. */
  customerNotifiedTo?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  requestedBy?: Maybe<User>;
  status?: Maybe<DeviceControlStatus>;
  stockSale?: Maybe<StockSale>;
  /** The code exactly as the vendor gave it. Display verbatim: a full Sun King keypad needs its * and # and Atlas codes carry their grouping. */
  token?: Maybe<Scalars['String']['output']>;
  tokenSequence?: Maybe<Scalars['Int']['output']>;
  /** Which vendor answered, carrying a "(mock)" suffix where nothing was really sent. Show it beside the code so a mocked result is never read as proof a device was unlocked. */
  vendor?: Maybe<Scalars['String']['output']>;
};

export type DeviceControlCommand =
  | 'LOCK'
  | 'UNLOCK';

export type DeviceControlEligibility = {
  __typename?: 'DeviceControlEligibility';
  /** When this device was unlocked, if it already has been. A second unlock is refused because no vendor has told us what that does. */
  alreadyUnlockedAt?: Maybe<Scalars['DateTime']['output']>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  /** Sentence for the operator: what unlocking would do when it can happen, what stands in the way when it cannot. */
  explanation?: Maybe<Scalars['String']['output']>;
  /** The device's Platform API, which is the vendor that would be asked. Null when no adapter claims it. */
  vendor?: Maybe<Scalars['String']['output']>;
};

export type DeviceControlStatus =
  | 'ALREADY_UNLOCKED'
  | 'FAILED'
  | 'ISSUED';

export type DeviceField =
  | 'ACCOUNT_NUMBER'
  | 'HOTP_SECRET'
  | 'SECRET_KEY'
  | 'STARTING_CODE';

export type DeviceHistoryEntry = {
  __typename?: 'DeviceHistoryEntry';
  at?: Maybe<Scalars['DateTime']['output']>;
  kind?: Maybe<DeviceHistoryKind>;
  reference?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type DeviceHistoryKind =
  | 'ARCHIVE'
  | 'REASSIGNMENT'
  | 'RESTORE'
  | 'RETURN_TURNED_DOWN'
  | 'SALE'
  | 'TRANSFER'
  | 'WORKSHOP_JOB';

export type DeviceLockEligibility = {
  __typename?: 'DeviceLockEligibility';
  /** UNLOCKED or GATED: what the CRM believes the device state is without having asked any vendor, from our own recorded actions and otherwise ADR-0022 rule. A belief, not a fact - devices unlocked by hand in a vendor portal read as GATED - so it steers the warning rather than refusing the action. */
  belief?: Maybe<Scalars['String']['output']>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  /** Sentence for the operator: what locking would do and what it would cost when it can happen, what stands in the way when it cannot. */
  explanation?: Maybe<Scalars['String']['output']>;
  /** When a lock code was issued for this device that nobody has confirmed the customer keyed in. A lock only takes effect once the code is entered, so one still waiting is unfinished work: the code is already with the customer, and a second would leave them holding two. Null when nothing is outstanding. */
  pendingSince?: Maybe<Scalars['DateTime']['output']>;
  /** Whether this vendor needs the index currently on the device, which only the customer can read off the keypad with 03#. Atlas does; nothing else does today. Ours is not a substitute, because it runs ahead whenever a token was generated and never keyed in. */
  requiresIndex?: Maybe<Scalars['Boolean']['output']>;
  /** Whole days of running time this contract still shows, which a lock clears. Null where it shows none. Tell the operator before they confirm: this is what locking costs the customer, and it reads the same for every vendor. */
  runtimeAtRisk?: Maybe<Scalars['Int']['output']>;
  /** The device's Platform API, which is the vendor that would be asked. Null when no adapter claims it. */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** The transfer, purchase order or stock upload carrying a device that is at no stocking point (ADR-0074). */
export type DeviceOnTheWay = {
  __typename?: 'DeviceOnTheWay';
  from?: Maybe<StockingPoint>;
  kind: DeviceOnTheWayKind;
  recordId: Scalars['ID']['output'];
  /** The transfer or purchase order number; an upload has only its waybill. */
  reference?: Maybe<Scalars['String']['output']>;
  shipment?: Maybe<Shipment>;
  to: StockingPoint;
};

export type DeviceOnTheWayKind =
  | 'PURCHASE_ORDER'
  | 'TRANSFER'
  | 'UPLOAD';

export type DeviceReassignment = {
  __typename?: 'DeviceReassignment';
  cause?: Maybe<DeviceReassignmentCause>;
  contract?: Maybe<Contract>;
  contractPaidThroughAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditRecoveryPerPayment?: Maybe<Scalars['Int']['output']>;
  creditRecoveryRemaining?: Maybe<Scalars['Int']['output']>;
  creditRecoveryTotal?: Maybe<Scalars['Int']['output']>;
  customerNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  deviceLoadedThroughAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  newAccountNumber?: Maybe<Scalars['String']['output']>;
  newRateName?: Maybe<Scalars['String']['output']>;
  newSerialNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  performedBy?: Maybe<User>;
  previousAccountNumber?: Maybe<Scalars['String']['output']>;
  previousRateName?: Maybe<Scalars['String']['output']>;
  previousSerialNumber?: Maybe<Scalars['String']['output']>;
  swapGroupId?: Maybe<Scalars['String']['output']>;
  tokenDaysShortfall?: Maybe<Scalars['Int']['output']>;
};

export type DeviceReassignmentCause =
  | 'OTHER'
  | 'RATE_PLAN_CHANGE'
  | 'WARRANTY_REPLACEMENT'
  | 'WRONG_DEVICE_DISPATCHED'
  | 'WRONG_DEVICE_INSTALLED';

export type DeviceReassignmentWarning = {
  __typename?: 'DeviceReassignmentWarning';
  code?: Maybe<DeviceReassignmentWarningCode>;
  detail?: Maybe<Scalars['String']['output']>;
};

export type DeviceReassignmentWarningCode =
  | 'ACCOUNT_NUMBER_CHANGING'
  | 'CANNOT_ACCEPT_TOKEN'
  | 'CATCH_UP_TOKEN'
  | 'CORRECTION_REVERSED'
  | 'CREDIT_RECOVERY'
  | 'NO_ACCOUNT_NUMBER'
  | 'NO_METER'
  | 'PRODUCT_MISMATCH'
  | 'TOKEN_DAYS_SHORTFALL'
  | 'WOULD_PAY_OFF'
  | 'XERO_REPEATING_INVOICE';

export type DeviceRelease = {
  __typename?: 'DeviceRelease';
  /** The credit application this release rejected, when the device was freed from a reservation rather than from a contract. Set on exactly the releases where `contractNumber` is null. */
  applicationId?: Maybe<Scalars['String']['output']>;
  /** True for a release recorded by the one-time correction of contracts that ended before the release flow existed. `releasedAt` is then when the correction ran, not when the contract ended. */
  backfilled?: Maybe<Scalars['Boolean']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** The stocking point the device sat at once released. */
  location?: Maybe<Scalars['String']['output']>;
  /** True when the device came back because the customer moved onto another rate plan rather than because their contract ended. `reason` describes a live contract in that case and does not explain the release. */
  ratePlanChange?: Maybe<Scalars['Boolean']['output']>;
  /** The terminal contract status that released the device: CANCELLED, WRITTEN_OFF or REPOSSESSED. */
  reason?: Maybe<ContractStatus>;
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who released it: whoever ended the contract, cleared the reservation or changed the plan. Null on a backfilled release, whose original actor was never recorded. */
  releasedBy?: Maybe<User>;
  /** True when the release moved the device and wrote a transfer. False when it was already where it needed to be, or was released in place by the backfill. */
  relocated?: Maybe<Scalars['Boolean']['output']>;
  /** The device given to the customer in this one's place, when a rate plan change sent it back. */
  replacedBySerialNumber?: Maybe<Scalars['String']['output']>;
  transferNumber?: Maybe<Scalars['String']['output']>;
};

/** Why a device cannot be released back to stock by hand. */
export type DeviceReleaseBlocker =
  | 'ALREADY_RELEASED'
  | 'ARCHIVED'
  | 'CONTRACT_LIVE'
  | 'NOT_CONTRACT_HELD'
  | 'RESOLD'
  | 'TRANSFER_PENDING';

export type DeviceReleaseEligibility = {
  __typename?: 'DeviceReleaseEligibility';
  /** The credit application the release would reject, on the reservation path. */
  applicationId?: Maybe<Scalars['String']['output']>;
  /** Devices on the same credit application — a combo is a pair sold only together. Not released unless `releaseApplicationSiblings` asks for it. */
  applicationSiblings?: Maybe<Array<Scalars['String']['output']>>;
  blocker?: Maybe<DeviceReleaseBlocker>;
  /** True when a live sale is still open on the device, which is what currently bars it from being sold again. */
  closesLiveSale?: Maybe<Scalars['Boolean']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  /** The ended contract the release would be attributed to. */
  contractStatus?: Maybe<ContractStatus>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  /** Sentence for the operator: what releasing would do when eligible, why it cannot when not. */
  explanation?: Maybe<Scalars['String']['output']>;
  /** Which release this would be. Null when nothing releasable holds the device. */
  hold?: Maybe<DeviceReleaseHold>;
  /** Where the device would sit afterwards — exactly where it sits now, since a manual release never relocates it. */
  location?: Maybe<Scalars['String']['output']>;
  /** True when the release must carry a reason: taking a device off a contract that is still running. */
  reasonRequired: Scalars['Boolean']['output'];
  /** The stock permission a person must hold to perform this release. */
  requiredPermission?: Maybe<Scalars['String']['output']>;
  /** The grade the device would come back at: NEW from a cancellation, USED from a write-off or repossession. */
  resultingCondition?: Maybe<StockItemCondition>;
  /** Whether the signed-in user holds the permission this particular release needs. */
  viewerMayRelease?: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceReleaseHold =
  | 'CONTRACT'
  | 'LIVE_CONTRACT'
  | 'RESERVATION';

export type DeviceResolutionKind =
  | 'FROM_STOCK'
  | 'SWAP';

/** One device's share of a token generation. A combo mints one token per device at its allocation percentage; `accepted` is false when the provider refused this share (nothing was charged for it). */
export type DeviceTokenResult = {
  __typename?: 'DeviceTokenResult';
  accepted: Scalars['Boolean']['output'];
  accountNumber: Scalars['String']['output'];
  /** This device's share of the requested amount, in major units. */
  amount: Scalars['Float']['output'];
  message?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenSequence?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type DeviceType = {
  __typename?: 'DeviceType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultMeterType?: Maybe<MeterType>;
  defaultMeterTypeId?: Maybe<Scalars['Int']['output']>;
  fields?: Maybe<Array<DeviceTypeField>>;
  id?: Maybe<Scalars['ID']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeviceTypeField = {
  __typename?: 'DeviceTypeField';
  field?: Maybe<DeviceField>;
  id?: Maybe<Scalars['ID']['output']>;
  requirement?: Maybe<FieldRequirement>;
};

export type DeviceTypeFieldInput = {
  field: DeviceField;
  requirement: FieldRequirement;
};

/** An app or website whose visitor numbers Google Analytics measures. */
export type DigitalChannel = {
  __typename?: 'DigitalChannel';
  createdAt: Scalars['DateTime']['output'];
  /** Google Analytics' numeric ID for the channel. */
  gaPropertyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  kind: DigitalChannelKind;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DigitalChannelBreakdownRow = {
  __typename?: 'DigitalChannelBreakdownRow';
  activeUsers: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** A page (website) or screen (app). */
export type DigitalChannelContentRow = {
  __typename?: 'DigitalChannelContentRow';
  activeUsers: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};

export type DigitalChannelDay = {
  __typename?: 'DigitalChannelDay';
  activeUsers: Scalars['Int']['output'];
  /** YYYY-MM-DD */
  date: Scalars['String']['output'];
  sessions: Scalars['Int']['output'];
};

/** One channel in depth for a period. Platforms and app versions are empty for a website. */
export type DigitalChannelDetail = {
  __typename?: 'DigitalChannelDetail';
  appVersions: Array<DigitalChannelBreakdownRow>;
  channel: DigitalChannel;
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  platforms: Array<DigitalChannelBreakdownRow>;
  status: DigitalChannelStatus;
  topContent: Array<DigitalChannelContentRow>;
  trafficSources: Array<DigitalChannelTrafficSourceRow>;
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

/** APP shows screens, platforms and app versions; WEBSITE shows pages. */
export type DigitalChannelKind =
  | 'APP'
  | 'WEBSITE';

/** Every active channel for a period, compared with the same number of days before it. */
export type DigitalChannelOverview = {
  __typename?: 'DigitalChannelOverview';
  channels: Array<DigitalChannelSummary>;
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  previousFrom: Scalars['String']['output'];
  previousTo: Scalars['String']['output'];
};

/** YYYY-MM-DD, both days included, at most 366 days. */
export type DigitalChannelPeriodInput = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
};

/** UNAVAILABLE: Google could not be read for this channel; the others still show. */
export type DigitalChannelStatus =
  | 'OK'
  | 'UNAVAILABLE';

/** One channel's totals for the period and the one before. Null figures when UNAVAILABLE. */
export type DigitalChannelSummary = {
  __typename?: 'DigitalChannelSummary';
  channel: DigitalChannel;
  current?: Maybe<DigitalChannelTotals>;
  previous?: Maybe<DigitalChannelTotals>;
  series: Array<DigitalChannelDay>;
  status: DigitalChannelStatus;
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export type DigitalChannelTotals = {
  __typename?: 'DigitalChannelTotals';
  activeUsers: Scalars['Int']['output'];
  /** Engagement time per active user, in seconds. */
  averageEngagementSeconds: Scalars['Float']['output'];
  newUsers: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
};

export type DigitalChannelTrafficSourceRow = {
  __typename?: 'DigitalChannelTrafficSourceRow';
  activeUsers: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  sessions: Scalars['Int']['output'];
};

export type DisputeFlag =
  | 'PARENT_DISPUTED'
  | 'PARENT_MISMATCH'
  | 'PARENT_MISSING'
  | 'PROFILE_DISPUTED';

export type DisputeOutcome =
  | 'ACCEPTED_DCC'
  | 'ACCEPTED_INVITEE'
  | 'DEFERRED'
  | 'MANUAL_EDIT';

export type DisputeResolution = {
  __typename?: 'DisputeResolution';
  afterValue?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Agent>;
  beforeValue?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disputeType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  resolvedBy?: Maybe<User>;
};

export type DistributorReconciliation = {
  __typename?: 'DistributorReconciliation';
  accessoriesHeld?: Maybe<Scalars['Int']['output']>;
  accessoriesIssued?: Maybe<Scalars['Int']['output']>;
  availableStock?: Maybe<Scalars['Int']['output']>;
  childAgentCount?: Maybe<Scalars['Int']['output']>;
  closedSales?: Maybe<Scalars['Int']['output']>;
  damagedStock?: Maybe<Scalars['Int']['output']>;
  distributorId?: Maybe<Scalars['String']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  inTransitStock?: Maybe<Scalars['Int']['output']>;
  otherStock?: Maybe<Scalars['Int']['output']>;
  reservedStock?: Maybe<Scalars['Int']['output']>;
  salesFromOtherStock?: Maybe<Scalars['Int']['output']>;
  salesFromOwnStock?: Maybe<Scalars['Int']['output']>;
  salesRecorded?: Maybe<Scalars['Int']['output']>;
  soldStock?: Maybe<Scalars['Int']['output']>;
  stockingPointCount?: Maybe<Scalars['Int']['output']>;
  totalHeld?: Maybe<Scalars['Int']['output']>;
};

export type DistrictMunicipality = {
  __typename?: 'DistrictMunicipality';
  id?: Maybe<Scalars['ID']['output']>;
  localMunicipalities?: Maybe<Array<LocalMunicipality>>;
  name?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Province>;
};

export type DiversityFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiversityMetrics = {
  __typename?: 'DiversityMetrics';
  asOf: Scalars['DateTime']['output'];
  byGender: Array<GenderCount>;
  byGenderRace: Array<GenderRaceCount>;
  byJobLevel: Array<JobLevelCount>;
  byRace: Array<RaceCount>;
  disabilityPercent: HrMetric;
  headcount: HrMetric;
  /** Women among the people flagged as management. */
  womenInManagementPercent: HrMetric;
  /** Aged 18 to 35 on the day. */
  youthPercent: HrMetric;
};

export type Document = {
  __typename?: 'Document';
  application?: Maybe<Application>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  documentType?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBy?: Maybe<User>;
};

export type DuplicateMatch = {
  __typename?: 'DuplicateMatch';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  matchedOn?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EdfReportCollectionRate = {
  __typename?: 'EdfReportCollectionRate';
  cashSaleContracts: Scalars['Int']['output'];
  cashSales: Scalars['Float']['output'];
  collectionRate?: Maybe<Scalars['Float']['output']>;
  cutoff: Scalars['DateTime']['output'];
  deposit: Scalars['Float']['output'];
  expected: Scalars['Float']['output'];
  expectedContracts: Scalars['Int']['output'];
  generatedAt: Scalars['DateTime']['output'];
  month: Scalars['String']['output'];
  newPaygoContracts: Scalars['Int']['output'];
  paidForPaygo: Scalars['Float']['output'];
  partialMonth: Scalars['Boolean']['output'];
};

export type EdfReportDebtorAgeing = {
  __typename?: 'EdfReportDebtorAgeing';
  cutoff: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  month: Scalars['String']['output'];
  months: Array<EdfReportDebtorAgeingMonth>;
  partialMonth: Scalars['Boolean']['output'];
};

export type EdfReportDebtorAgeingMonth = {
  __typename?: 'EdfReportDebtorAgeingMonth';
  closingDebtor: Scalars['Float']['output'];
  days0To30: Scalars['Float']['output'];
  days31To60: Scalars['Float']['output'];
  days61To90: Scalars['Float']['output'];
  days90Plus: Scalars['Float']['output'];
  month: Scalars['String']['output'];
  newContractRevenue: Scalars['Float']['output'];
  newContracts: Scalars['Int']['output'];
  openingDebtor: Scalars['Float']['output'];
  overpayment: Scalars['Float']['output'];
  paymentsReceived: Scalars['Float']['output'];
  writtenOff: Scalars['Float']['output'];
};

export type EdfReportDefaultRate = {
  __typename?: 'EdfReportDefaultRate';
  /** @deprecated Always 0: on EDF's method a contract only enters the portfolio once it has paid past its deposit. */
  activeNoToken: Scalars['Int']['output'];
  cutoff: Scalars['DateTime']['output'];
  defaultRate?: Maybe<Scalars['Float']['output']>;
  generatedAt: Scalars['DateTime']['output'];
  inDefault: Scalars['Int']['output'];
  leftPortfolio: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  noLongerInDefaultRate?: Maybe<Scalars['Float']['output']>;
  partialMonth: Scalars['Boolean']['output'];
  portfolioContracts: Scalars['Int']['output'];
  reactivated: Scalars['Int']['output'];
};

export type EdfReportRarBand =
  | 'DAYS_1_7'
  | 'DAYS_8_15'
  | 'DAYS_16_29'
  | 'DAYS_30_59'
  | 'DAYS_60_89'
  | 'DAYS_90_120'
  | 'DAYS_121_PLUS'
  | 'NORMAL';

export type EdfReportRarBandRow = {
  __typename?: 'EdfReportRarBandRow';
  band: EdfReportRarBand;
  contracts: Scalars['Int']['output'];
  receivables: Scalars['Float']['output'];
  share?: Maybe<Scalars['Float']['output']>;
};

export type EdfReportReceivablesAtRisk = {
  __typename?: 'EdfReportReceivablesAtRisk';
  bands: Array<EdfReportRarBandRow>;
  contracts: Scalars['Int']['output'];
  cutoff: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  month: Scalars['String']['output'];
  partialMonth: Scalars['Boolean']['output'];
  receivables: Scalars['Float']['output'];
};

export type EdfReportRecoveries = {
  __typename?: 'EdfReportRecoveries';
  cutoff: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  inPortfolio: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  par60Contracts: Scalars['Int']['output'];
  partialMonth: Scalars['Boolean']['output'];
  reactivated: Scalars['Int']['output'];
  reactivatedRate?: Maybe<Scalars['Float']['output']>;
  recovered: Scalars['Int']['output'];
  repossessed: Scalars['Int']['output'];
  repossessedYearToDate: Scalars['Int']['output'];
  repossessionRate?: Maybe<Scalars['Float']['output']>;
  toRecover: Scalars['Int']['output'];
  totalContracts: Scalars['Int']['output'];
  writeOffRate?: Maybe<Scalars['Float']['output']>;
  writtenOff: Scalars['Int']['output'];
};

export type EdfReportRepaymentRate = {
  __typename?: 'EdfReportRepaymentRate';
  cutoff: Scalars['DateTime']['output'];
  due: Scalars['Float']['output'];
  generatedAt: Scalars['DateTime']['output'];
  month: Scalars['String']['output'];
  paid: Scalars['Float']['output'];
  partialMonth: Scalars['Boolean']['output'];
  portfolioContracts: Scalars['Int']['output'];
  repaymentRate?: Maybe<Scalars['Float']['output']>;
};

export type EffectivePermission = {
  __typename?: 'EffectivePermission';
  action?: Maybe<Scalars['String']['output']>;
  granted?: Maybe<Scalars['Boolean']['output']>;
  manualOverride?: Maybe<Scalars['Boolean']['output']>;
  moduleCode?: Maybe<Scalars['String']['output']>;
  moduleName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceRoleId?: Maybe<Scalars['String']['output']>;
};

export type Employee = {
  __typename?: 'Employee';
  createdAt: Scalars['DateTime']['output'];
  currentEmployment?: Maybe<Employment>;
  department?: Maybe<EmployeeDepartment>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  employments: Array<Employment>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  user?: Maybe<EmployeeUser>;
};

export type EmployeeBenefit = {
  __typename?: 'EmployeeBenefit';
  employee: PayrollEmployee;
  employeeContribution?: Maybe<Scalars['Float']['output']>;
  employerContribution?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  source: HrDataSource;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  type: EmployeeBenefitType;
};

export type EmployeeBenefitType =
  | 'FUNERAL'
  | 'MEDICAL_AID'
  | 'OTHER'
  | 'PENSION'
  | 'PROVIDENT';

export type EmployeeDemographics = {
  __typename?: 'EmployeeDemographics';
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  employeeId: Scalars['ID']['output'];
  gender?: Maybe<EmployeeGender>;
  hasDisability?: Maybe<Scalars['Boolean']['output']>;
  isManagement?: Maybe<Scalars['Boolean']['output']>;
  /** The person's own level. When null the dashboard uses the job position's level. */
  jobLevel?: Maybe<JobLevel>;
  jobPosition?: Maybe<DemographicsJobPosition>;
  race?: Maybe<EmployeeRace>;
  team?: Maybe<DemographicsTeam>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeDemographicsInput = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<EmployeeGender>;
  hasDisability?: InputMaybe<Scalars['Boolean']['input']>;
  isManagement?: InputMaybe<Scalars['Boolean']['input']>;
  jobLevel?: InputMaybe<JobLevel>;
  jobPositionId?: InputMaybe<Scalars['ID']['input']>;
  race?: InputMaybe<EmployeeRace>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type EmployeeDepartment = {
  __typename?: 'EmployeeDepartment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EmployeeFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentTypes?: InputMaybe<Array<EmploymentType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmployeeStatusFilter>;
  workingPatterns?: InputMaybe<Array<WorkingPattern>>;
};

export type EmployeeGender =
  | 'FEMALE'
  | 'MALE';

export type EmployeeList = {
  __typename?: 'EmployeeList';
  items: Array<Employee>;
  totalCount: Scalars['Int']['output'];
};

export type EmployeeMovement = {
  __typename?: 'EmployeeMovement';
  changes: Array<EmployeeMovementChange>;
  diversityHidden: Scalars['Boolean']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  movementType: EmployeeMovementType;
  reason?: Maybe<Scalars['String']['output']>;
  recordedAt: Scalars['DateTime']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
};

export type EmployeeMovementChange = {
  __typename?: 'EmployeeMovementChange';
  field: EmployeeMovementField;
  from?: Maybe<Scalars['String']['output']>;
  fromLabel?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  toLabel?: Maybe<Scalars['String']['output']>;
};

export type EmployeeMovementField =
  | 'DEPARTMENT'
  | 'EMPLOYMENT_TYPE'
  | 'JOB_LEVEL'
  | 'JOB_POSITION'
  | 'TEAM'
  | 'WORKING_PATTERN';

export type EmployeeMovementType =
  | 'DEMOTION'
  | 'OTHER'
  | 'PATTERN_CHANGE'
  | 'PROMOTION'
  | 'ROLE_CHANGE'
  | 'TRANSFER'
  | 'TYPE_CHANGE';

export type EmployeePerformance = {
  __typename?: 'EmployeePerformance';
  employeeId: Scalars['ID']['output'];
  improvementPlans: Array<ImprovementPlan>;
  probations: Array<EmploymentProbation>;
  reviews: Array<PerformanceReview>;
};

export type EmployeeRace =
  | 'AFRICAN'
  | 'COLOURED'
  | 'FOREIGN_NATIONAL'
  | 'INDIAN'
  | 'WHITE';

export type EmployeeStatusFilter =
  | 'ALL'
  | 'CURRENT'
  | 'LEFT';

export type EmployeeTraining = {
  __typename?: 'EmployeeTraining';
  certifications: Array<TrainingCertification>;
  employeeId: Scalars['ID']['output'];
  programmes: Array<LearningProgramme>;
  sessions: Array<TrainingSession>;
};

export type EmployeeUser = {
  __typename?: 'EmployeeUser';
  archived: Scalars['Boolean']['output'];
  blocked: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Employment = {
  __typename?: 'Employment';
  employmentType?: Maybe<EmploymentType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  exitReason?: Maybe<Scalars['String']['output']>;
  exitType?: Maybe<ExitType>;
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  workingPattern?: Maybe<WorkingPattern>;
};

export type EmploymentInput = {
  employmentType?: InputMaybe<EmploymentType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  workingPattern?: InputMaybe<WorkingPattern>;
};

export type EmploymentProbation = {
  __typename?: 'EmploymentProbation';
  employmentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  probation?: Maybe<Probation>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type EmploymentStatus =
  | 'EMPLOYED'
  | 'OTHER'
  | 'RETIRED'
  | 'SELF_EMPLOYED'
  | 'STUDENT'
  | 'UNEMPLOYED';

export type EmploymentType =
  | 'CONTRACTOR'
  | 'FIXED_TERM'
  | 'PERMANENT';

export type EndEmploymentInput = {
  endDate: Scalars['DateTime']['input'];
  exitReason?: InputMaybe<Scalars['String']['input']>;
  exitType: ExitType;
};

/** Someone a programme reached. Personal data, read only with hr_esg. */
export type EsgBeneficiary = {
  __typename?: 'EsgBeneficiary';
  employee?: Maybe<EsgEmployee>;
  gender?: Maybe<EsgBeneficiaryGender>;
  hasDisability?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isYouth?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** People in a community. Null = not recorded. */
  peopleCount?: Maybe<Scalars['Int']['output']>;
  reachedDate: Scalars['DateTime']['output'];
  type: EsgBeneficiaryType;
};

export type EsgBeneficiaryGender =
  | 'FEMALE'
  | 'MALE'
  | 'OTHER';

export type EsgBeneficiaryType =
  | 'COMMUNITY'
  | 'INDIVIDUAL'
  | 'ORGANISATION';

/** Rand spent in the range by programme category. A null category is "Not recorded". */
export type EsgCategorySpend = {
  __typename?: 'EsgCategorySpend';
  amount: Scalars['Float']['output'];
  category?: Maybe<EsgProgrammeCategory>;
};

/** Rand spent in the range by B-BBEE element. A null element is "Not recorded". */
export type EsgElementSpend = {
  __typename?: 'EsgElementSpend';
  amount: Scalars['Float']['output'];
  element?: Maybe<BbbeeElement>;
};

export type EsgEmployee = {
  __typename?: 'EsgEmployee';
  employeeNumber?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

/** Download from GET /api/hr/esg-evidence/:id (hr_esg:view). */
export type EsgEvidenceFile = {
  __typename?: 'EsgEvidenceFile';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

/** Individuals reached in the range, yes / no. A null value is "Not recorded". */
export type EsgFlagCount = {
  __typename?: 'EsgFlagCount';
  count: Scalars['Int']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

/** Individuals reached in the range. A null gender is "Not recorded". */
export type EsgGenderCount = {
  __typename?: 'EsgGenderCount';
  count: Scalars['Int']['output'];
  gender?: Maybe<EsgBeneficiaryGender>;
};

/** The ESG figures (ADR-0069). Spend, beneficiaries and volunteering count on the day they are dated; active programmes are as of today. An area with no records is MISSING. */
export type EsgMetrics = {
  __typename?: 'EsgMetrics';
  /** Programmes with status ACTIVE today. */
  activeProgrammes: HrMetric;
  beneficiariesByDisability: Array<EsgFlagCount>;
  beneficiariesByGender: Array<EsgGenderCount>;
  beneficiariesByYouth: Array<EsgFlagCount>;
  /** Spend to the end of the range ÷ budget × 100, over programmes active today or with spend in the range. Programmes without a budget are notRecorded. */
  budgetUsedPercent: HrMetric;
  /** Communities reached in the range. */
  communitiesReached: HrMetric;
  /** People in the communities reached in the range; communities with no head count are notRecorded. Never added to individuals. */
  communityPeopleReached: HrMetric;
  from: Scalars['DateTime']['output'];
  /** Individual beneficiaries reached in the range. */
  individualsReached: HrMetric;
  /** Organisations reached in the range. */
  organisationsReached: HrMetric;
  spendByBbbeeElement: Array<EsgElementSpend>;
  spendByCategory: Array<EsgCategorySpend>;
  /** Needs net profit after tax from finance, which the CRM does not hold: always NOT_APPLICABLE. */
  spendPercentOfNetProfit: HrMetric;
  to: Scalars['DateTime']['output'];
  /** Rand spent in the range. MISSING while no spend is recorded. */
  totalSpend: HrMetric;
  /** Hours staff volunteered in the range. MISSING while none is recorded. */
  volunteeringHours: HrMetric;
  /** Employees who volunteered in the range. */
  volunteers: HrMetric;
};

/** A free-form measure of what a programme achieved. */
export type EsgOutcome = {
  __typename?: 'EsgOutcome';
  id: Scalars['ID']['output'];
  measuredDate: Scalars['DateTime']['output'];
  metricName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

/** An ESG / CSI programme. */
export type EsgProgramme = {
  __typename?: 'EsgProgramme';
  /** The B-BBEE scorecard element it counts towards. Null = not recorded. */
  bbbeeElement?: Maybe<BbbeeElement>;
  beneficiaryCount: Scalars['Int']['output'];
  /** In rand, for the whole programme. Null = not recorded, never R0. */
  budget?: Maybe<Scalars['Float']['output']>;
  /** Spent to date ÷ budget × 100. Null without a budget or any spend. */
  budgetUsedPercent?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<EsgProgrammeCategory>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<EsgUser>;
  /** Every spend line, in rand. Null while none is recorded. */
  spentToDate?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: EsgProgrammeStatus;
};

export type EsgProgrammeCategory =
  | 'COMMUNITY'
  | 'EMPLOYEE_WELLNESS'
  | 'ENTERPRISE_DEVELOPMENT'
  | 'ENVIRONMENT'
  | 'OTHER'
  | 'SKILLS_DEVELOPMENT'
  | 'SOCIO_ECONOMIC_DEVELOPMENT'
  | 'SUPPLIER_DEVELOPMENT';

export type EsgProgrammeDetail = {
  __typename?: 'EsgProgrammeDetail';
  beneficiaries: Array<EsgBeneficiary>;
  outcomes: Array<EsgOutcome>;
  programme: EsgProgramme;
  spend: Array<EsgSpend>;
  volunteering: Array<EsgVolunteering>;
};

export type EsgProgrammeFilterInput = {
  categories?: InputMaybe<Array<EsgProgrammeCategory>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<EsgProgrammeStatus>>;
};

export type EsgProgrammeList = {
  __typename?: 'EsgProgrammeList';
  items: Array<EsgProgramme>;
  totalCount: Scalars['Int']['output'];
};

export type EsgProgrammeStatus =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'PLANNED';

export type EsgSpend = {
  __typename?: 'EsgSpend';
  /** In rand. */
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  files: Array<EsgEvidenceFile>;
  id: Scalars['ID']['output'];
  spendDate: Scalars['DateTime']['output'];
};

export type EsgUser = {
  __typename?: 'EsgUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type EsgVolunteering = {
  __typename?: 'EsgVolunteering';
  activityDate: Scalars['DateTime']['output'];
  employee: EsgEmployee;
  hours: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};

export type ExitType =
  | 'CONTRACT_ENDED'
  | 'INVOLUNTARY'
  | 'VOLUNTARY';

export type FaultAlertRecipient = {
  __typename?: 'FaultAlertRecipient';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FaultCategory = {
  __typename?: 'FaultCategory';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type FaultSubType = {
  __typename?: 'FaultSubType';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type FaultType = {
  __typename?: 'FaultType';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  subTypes: Array<FaultSubType>;
};

/** What became of a new distributor's Solar Management Fee for a month (ADR-0084). */
export type FeeReviewStatus =
  | 'APPROVED'
  | 'HELD'
  | 'NOT_RUN'
  | 'NO_FEE'
  | 'PAID'
  | 'PENDING'
  | 'REJECTED';

export type FieldRequirement =
  | 'DISABLED'
  | 'OPTIONAL'
  | 'REQUIRED';

export type FinanceWorkbook = {
  __typename?: 'FinanceWorkbook';
  builtAt?: Maybe<Scalars['DateTime']['output']>;
  contentBase64?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  status: FinanceWorkbookStatus;
};

export type FinanceWorkbookKind =
  | 'EDF_COLLECTION_RATE'
  | 'EDF_DEBTOR_AGEING'
  | 'EDF_DEFAULT_RATE'
  | 'EDF_RECEIVABLES_AT_RISK'
  | 'EDF_RECOVERIES'
  | 'EDF_REPAYMENT'
  | 'EDF_SALES'
  | 'IFC_TRACKS'
  | 'PORTFOLIO'
  | 'PROJECTION'
  | 'SALES';

export type FinanceWorkbookStatus =
  | 'BUILDING'
  | 'READY';

export type FlagForRepossessionInput = {
  contractId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type FlagStockSaleAsBadInput = {
  reason: Scalars['String']['input'];
  saleId: Scalars['String']['input'];
};

export type Gender =
  | 'FEMALE'
  | 'MALE'
  | 'OTHER'
  | 'PREFER_NOT_TO_SAY';

export type GenderCount = {
  __typename?: 'GenderCount';
  count: Scalars['Int']['output'];
  gender?: Maybe<EmployeeGender>;
};

export type GenderRaceCount = {
  __typename?: 'GenderRaceCount';
  count: Scalars['Int']['output'];
  gender?: Maybe<EmployeeGender>;
  race?: Maybe<EmployeeRace>;
};

export type GenerateTokenInput = {
  amount: Scalars['Float']['input'];
  contractId: Scalars['String']['input'];
  isCompensation?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
  type?: InputMaybe<PaymentType>;
};

/** Token generation result. `token` + `tokenSequence` are populated only when the provider returns them synchronously (or in mock mode). When null, the actual token will arrive asynchronously via callback — see paymentTransactions(contractId). */
export type GenerateTokenResult = {
  __typename?: 'GenerateTokenResult';
  accountNumber: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  contractId: Scalars['String']['output'];
  /** One entry per device. A single-device contract has one; a combo has one per token-capable product, each charged its allocation share. The top-level fields mirror the first entry. */
  devices: Array<DeviceTokenResult>;
  initiatedAt: Scalars['DateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenSequence?: Maybe<Scalars['Int']['output']>;
  transactionId: Scalars['String']['output'];
};

/** A grievance in the register. Always anonymous: there is no reporter field. */
export type Grievance = {
  __typename?: 'Grievance';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<GrievanceCategory>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  desiredOutcome?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<GrievanceEvent>>;
  id?: Maybe<Scalars['ID']['output']>;
  incidentDate?: Maybe<Scalars['Date']['output']>;
  incidentLocation?: Maybe<Scalars['String']['output']>;
  involvement?: Maybe<GrievanceInvolvement>;
  managementAware?: Maybe<GrievanceManagementAware>;
  messages?: Maybe<Array<GrievanceMessage>>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  outcome?: Maybe<GrievanceOutcome>;
  owner?: Maybe<GrievanceOfficer>;
  reference?: Maybe<Scalars['String']['output']>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  retaliationConcern?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<GrievanceSource>;
  status?: Maybe<GrievanceStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GrievanceCategory = {
  __typename?: 'GrievanceCategory';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  examples?: Maybe<Scalars['JSON']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Scalars['JSON']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type GrievanceCategoryReport = {
  __typename?: 'GrievanceCategoryReport';
  acknowledgement?: Maybe<GrievanceDurations>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  openAgeing?: Maybe<GrievanceDurations>;
  resolution?: Maybe<GrievanceDurations>;
};

export type GrievanceCount = {
  __typename?: 'GrievanceCount';
  count?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type GrievanceDurations = {
  __typename?: 'GrievanceDurations';
  count?: Maybe<Scalars['Int']['output']>;
  medianHours?: Maybe<Scalars['Float']['output']>;
  p90Hours?: Maybe<Scalars['Float']['output']>;
};

export type GrievanceEvent = {
  __typename?: 'GrievanceEvent';
  actor?: Maybe<GrievanceOfficer>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fromStatus?: Maybe<GrievanceStatus>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<GrievanceStatus>;
  type?: Maybe<GrievanceEventType>;
};

export type GrievanceEventType =
  | 'ACKNOWLEDGED'
  | 'ASSIGNED'
  | 'CREATED'
  | 'MESSAGE_RECEIVED'
  | 'MESSAGE_SENT'
  | 'NOTE_ADDED'
  | 'REOPENED'
  | 'RESOLVED'
  | 'STATUS_CHANGED'
  | 'WITHDRAWN';

export type GrievanceFilterInput = {
  categoryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  openedTo?: InputMaybe<Scalars['DateTime']['input']>;
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  sources?: InputMaybe<Array<GrievanceSource>>;
  statuses?: InputMaybe<Array<GrievanceStatus>>;
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrievanceInvolvement =
  | 'AFFECTED'
  | 'TOLD_BY_WITNESS'
  | 'WITNESS';

export type GrievanceList = {
  __typename?: 'GrievanceList';
  items?: Maybe<Array<Grievance>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GrievanceManagementAware =
  | 'DONT_KNOW'
  | 'NO'
  | 'YES';

export type GrievanceManualSource =
  | 'EMAIL'
  | 'IN_PERSON'
  | 'PHONE';

export type GrievanceMessage = {
  __typename?: 'GrievanceMessage';
  author?: Maybe<GrievanceOfficer>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<GrievanceMessageFrom>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GrievanceMessageFrom =
  | 'OFFICER'
  | 'REPORTER';

export type GrievanceOfficer = {
  __typename?: 'GrievanceOfficer';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GrievanceOutcome = {
  __typename?: 'GrievanceOutcome';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Scalars['JSON']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** Grievances opened in [from, to), from exact times. */
export type GrievanceReport = {
  __typename?: 'GrievanceReport';
  acknowledgement?: Maybe<GrievanceDurations>;
  byCategory?: Maybe<Array<GrievanceCategoryReport>>;
  byOutcome?: Maybe<Array<GrievanceCount>>;
  bySource?: Maybe<Array<GrievanceCount>>;
  byStatus?: Maybe<Array<GrievanceCount>>;
  from?: Maybe<Scalars['DateTime']['output']>;
  openAgeing?: Maybe<GrievanceDurations>;
  resolution?: Maybe<GrievanceDurations>;
  to?: Maybe<Scalars['DateTime']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GrievanceSettings = {
  __typename?: 'GrievanceSettings';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactHours?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  extraQuestionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  messagesEnabled?: Maybe<Scalars['Boolean']['output']>;
  replyPromiseWorkingDays?: Maybe<Scalars['Int']['output']>;
};

export type GrievanceSource =
  | 'APP'
  | 'EMAIL'
  | 'IN_PERSON'
  | 'PHONE';

export type GrievanceStatus =
  | 'ACKNOWLEDGED'
  | 'CLOSED'
  | 'IN_PROGRESS'
  | 'OPEN'
  | 'RESOLVED'
  | 'WITHDRAWN';

export type GrievanceStatusChange =
  | 'CLOSED'
  | 'IN_PROGRESS'
  | 'WITHDRAWN';

export type GrievanceStatusCount = {
  __typename?: 'GrievanceStatusCount';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type HeadcountPoint = {
  __typename?: 'HeadcountPoint';
  headcount: Scalars['Int']['output'];
  monthEnd: Scalars['DateTime']['output'];
  notRecorded: Scalars['Int']['output'];
};

export type HomeModule =
  | 'CRM'
  | 'HR'
  | 'REPORTS'
  | 'STOCK';

/** A disciplinary case, CCMA referral or labour dispute about one Employee. */
export type HrCase = {
  __typename?: 'HrCase';
  caseNumber?: Maybe<Scalars['String']['output']>;
  closedDate?: Maybe<Scalars['DateTime']['output']>;
  /** In rand. Null is not recorded, never R0. */
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documents: Array<HrCaseDocument>;
  employee: HrCasePerson;
  /** The timeline, latest first. */
  events: Array<HrCaseEvent>;
  id: Scalars['ID']['output'];
  offenceCategory?: Maybe<Scalars['String']['output']>;
  openedBy?: Maybe<HrCaseUser>;
  openedDate: Scalars['DateTime']['output'];
  outcome?: Maybe<HrCaseOutcome>;
  referralDate?: Maybe<Scalars['DateTime']['output']>;
  sanction?: Maybe<HrCaseSanction>;
  stage?: Maybe<HrCaseStage>;
  status: HrCaseStatus;
  type: HrCaseType;
  updatedAt: Scalars['DateTime']['output'];
  warningExpiryDate?: Maybe<Scalars['DateTime']['output']>;
};

/** A file on a case. Download it from /api/hr/case-documents/{id}. */
export type HrCaseDocument = {
  __typename?: 'HrCaseDocument';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploadedBy: HrCaseUser;
};

/** One line on a case timeline: a note, or something that happened to the case. */
export type HrCaseEvent = {
  __typename?: 'HrCaseEvent';
  actor?: Maybe<HrCaseUser>;
  createdAt: Scalars['DateTime']['output'];
  eventDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: HrCaseEventKind;
  /** The note, or the file name for a document event. */
  note?: Maybe<Scalars['String']['output']>;
};

export type HrCaseEventKind =
  | 'CLOSED'
  | 'DOCUMENT_ADDED'
  | 'DOCUMENT_REMOVED'
  | 'NOTE'
  | 'OPENED'
  | 'REOPENED';

export type HrCaseFilterInput = {
  /** The Employee department today. */
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  openedTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Employee name or number, or case number. */
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<HrCaseStatus>>;
  types?: InputMaybe<Array<HrCaseType>>;
};

export type HrCaseList = {
  __typename?: 'HrCaseList';
  items: Array<HrCase>;
  totalCount: Scalars['Int']['output'];
};

/** The HR case figures (ADR-0065). A case counts in its Employee department on the day it was opened. No cases at all is MISSING. */
export type HrCaseMetrics = {
  __typename?: 'HrCaseMetrics';
  /** Warnings still running on the last day of the range. No expiry date is notRecorded. */
  activeWarnings: HrMetric;
  /** Mean days from opened to closed, for cases closed in the range. */
  averageDaysToClose: HrMetric;
  /** Disciplinary cases opened in the range, by sanction. */
  bySanction: Array<HrCaseSanctionCount>;
  /** CCMA cases referred in the range. No referral date is notRecorded. */
  ccmaReferrals: HrMetric;
  /** Disciplinary cases opened in the range. */
  disciplinaryCases: HrMetric;
  /** Disciplinary cases opened in the range per 100 of the average month-end Headcount. */
  disciplinaryPer100: HrMetric;
  /** CCMA and dispute cases closed in the range: won ÷ (won + lost) × 100. */
  disputeWinRate: HrMetric;
  /** CCMA and dispute cases closed in the range, by outcome. */
  disputesByOutcome: Array<HrCaseOutcomeCount>;
  from: Scalars['DateTime']['output'];
  /** Cases opened in the range. */
  newCases: HrMetric;
  openByType: Array<HrCaseTypeCount>;
  /** Cases open on the last day of the range. */
  openCases: HrMetric;
  to: Scalars['DateTime']['output'];
  /** Rand cost of the cases opened in the range. Cases with no cost are notRecorded. */
  totalCost: HrMetric;
};

export type HrCaseMetricsFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HrCaseNoteInput = {
  /** When it happened; today if omitted. */
  eventDate?: InputMaybe<Scalars['DateTime']['input']>;
  note: Scalars['String']['input'];
};

/** How a CCMA referral or dispute ended, from KES's side. */
export type HrCaseOutcome =
  | 'LOST'
  | 'SETTLED'
  | 'WITHDRAWN'
  | 'WON';

/** Closed disputes with one outcome. A null outcome is "Not recorded". */
export type HrCaseOutcomeCount = {
  __typename?: 'HrCaseOutcomeCount';
  count: Scalars['Int']['output'];
  outcome?: Maybe<HrCaseOutcome>;
};

/** The Employee a case is about. */
export type HrCasePerson = {
  __typename?: 'HrCasePerson';
  departmentName?: Maybe<Scalars['String']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

/** NONE is a real answer (no sanction); null is not recorded. */
export type HrCaseSanction =
  | 'DISMISSAL'
  | 'FINAL_WRITTEN_WARNING'
  | 'NONE'
  | 'VERBAL_WARNING'
  | 'WRITTEN_WARNING';

/** Disciplinary cases with one sanction. A null sanction is "Not recorded". */
export type HrCaseSanctionCount = {
  __typename?: 'HrCaseSanctionCount';
  count: Scalars['Int']['output'];
  sanction?: Maybe<HrCaseSanction>;
};

export type HrCaseStage =
  | 'ARBITRATION'
  | 'CONCILIATION'
  | 'LABOUR_COURT';

export type HrCaseStatus =
  | 'CLOSED'
  | 'OPEN';

export type HrCaseType =
  | 'CCMA'
  | 'DISCIPLINARY'
  | 'LABOUR_DISPUTE'
  | 'OTHER';

/** Open cases of one type. A null type is "Not recorded". */
export type HrCaseTypeCount = {
  __typename?: 'HrCaseTypeCount';
  count: Scalars['Int']['output'];
  type?: Maybe<HrCaseType>;
};

/** A CRM user who opened a case, wrote a note or added a document. */
export type HrCaseUser = {
  __typename?: 'HrCaseUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type HrDataSource =
  | 'CSV_IMPORT'
  | 'EXTERNAL'
  | 'MANUAL';

export type HrImportError = {
  __typename?: 'HrImportError';
  line: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type HrImportResult = {
  __typename?: 'HrImportResult';
  errors: Array<HrImportError>;
  imported: Scalars['Int']['output'];
  unmatched: Array<HrUnmatchedLine>;
};

export type HrMetric = {
  __typename?: 'HrMetric';
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  notRecorded: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
  state: HrMetricState;
  value?: Maybe<Scalars['Float']['output']>;
};

export type HrMetricState =
  | 'ACTUAL'
  | 'MISSING'
  | 'NOT_APPLICABLE'
  | 'PENDING_SYNC';

export type HrUnmatchedLine = {
  __typename?: 'HrUnmatchedLine';
  employeeNumber?: Maybe<Scalars['String']['output']>;
  line: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export type IdentificationType =
  | 'NATIONAL_ID'
  | 'PASSPORT';

export type ImprovementPlan = {
  __typename?: 'ImprovementPlan';
  employee: PerformancePerson;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectives: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: ImprovementPlanStatus;
};

export type ImprovementPlanStatus =
  | 'CANCELLED'
  | 'COMPLETED_FAILED'
  | 'COMPLETED_SUCCESS'
  | 'OPEN';

export type IncomingShipmentInput = {
  shippingCompanyId: Scalars['String']['input'];
  waybillReference: Scalars['String']['input'];
};

export type IssueContractAccessoriesInput = {
  contractId: Scalars['String']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type ItemCategory = {
  __typename?: 'ItemCategory';
  children: Array<ItemCategory>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ItemCategory>;
  parentId?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  /** Null while the category's group is in A to Z order. */
  position?: Maybe<Scalars['Int']['output']>;
  productCount: Scalars['Int']['output'];
};

export type JobApplication = {
  __typename?: 'JobApplication';
  appliedDate: Scalars['DateTime']['output'];
  candidate: JobApplicationCandidate;
  employee?: Maybe<JobApplicationEmployee>;
  history: Array<JobApplicationMove>;
  id: Scalars['ID']['output'];
  offer?: Maybe<JobOffer>;
  stage: JobApplicationStage;
  stageDate: Scalars['DateTime']['output'];
  vacancyId: Scalars['ID']['output'];
  vacancyTitle: Scalars['String']['output'];
};

export type JobApplicationCandidate = {
  __typename?: 'JobApplicationCandidate';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<CandidateSource>;
};

export type JobApplicationEmployee = {
  __typename?: 'JobApplicationEmployee';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type JobApplicationMove = {
  __typename?: 'JobApplicationMove';
  date: Scalars['DateTime']['output'];
  fromStage?: Maybe<JobApplicationStage>;
  id: Scalars['ID']['output'];
  movedBy?: Maybe<RecruitmentUser>;
  notes?: Maybe<Scalars['String']['output']>;
  toStage: JobApplicationStage;
};

export type JobApplicationStage =
  | 'APPLIED'
  | 'HIRED'
  | 'INTERVIEW'
  | 'OFFER'
  | 'REJECTED'
  | 'SCREENING'
  | 'WITHDRAWN';

export type JobLevel =
  | 'PROFESSIONALLY_QUALIFIED'
  | 'SEMI_SKILLED'
  | 'SENIOR_MANAGEMENT'
  | 'SKILLED_TECHNICAL'
  | 'TOP_MANAGEMENT'
  | 'UNSKILLED';

export type JobLevelCount = {
  __typename?: 'JobLevelCount';
  count: Scalars['Int']['output'];
  level?: Maybe<JobLevel>;
};

export type JobOffer = {
  __typename?: 'JobOffer';
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  declinedDate?: Maybe<Scalars['DateTime']['output']>;
  employmentType?: Maybe<EmploymentType>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offeredDate: Scalars['DateTime']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  workingPattern?: Maybe<WorkingPattern>;
};

export type JobOfferInput = {
  acceptedDate?: InputMaybe<Scalars['DateTime']['input']>;
  declinedDate?: InputMaybe<Scalars['DateTime']['input']>;
  employmentType?: InputMaybe<EmploymentType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offeredDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  workingPattern?: InputMaybe<WorkingPattern>;
};

export type JobPosition = {
  __typename?: 'JobPosition';
  holderCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  level?: Maybe<JobLevel>;
  title: Scalars['String']['output'];
};

export type JobPositionInput = {
  level?: InputMaybe<JobLevel>;
  title: Scalars['String']['input'];
};

export type Lead = {
  __typename?: 'Lead';
  assignedTo?: Maybe<User>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  convertedCustomer?: Maybe<Customer>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  email?: Maybe<Scalars['String']['output']>;
  estimatedValue?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  identificationType?: Maybe<IdentificationType>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredChannel?: Maybe<LeadCommunicationChannel>;
  products?: Maybe<Array<LeadProduct>>;
  source?: Maybe<LeadSource>;
  status?: Maybe<LeadStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LeadCategoryCounts = {
  __typename?: 'LeadCategoryCounts';
  converted?: Maybe<Scalars['Int']['output']>;
  lost?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Int']['output']>;
};

export type LeadCommunicationChannel =
  | 'EMAIL'
  | 'PHONE'
  | 'SMS';

export type LeadCustomerMatch = {
  __typename?: 'LeadCustomerMatch';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  isHard?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  matchedOn?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LeadDuplicateMatch = {
  __typename?: 'LeadDuplicateMatch';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  isHard?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  matchedOn?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  statusName?: Maybe<Scalars['String']['output']>;
};

export type LeadListResult = {
  __typename?: 'LeadListResult';
  items: Array<Lead>;
  totalCount: Scalars['Int']['output'];
};

export type LeadProduct = {
  __typename?: 'LeadProduct';
  id?: Maybe<Scalars['ID']['output']>;
  lineValue?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Int']['output']>;
  ratePlan?: Maybe<RatePlan>;
  unitValue?: Maybe<Scalars['Float']['output']>;
};

export type LeadProductInput = {
  productId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  ratePlanId?: InputMaybe<Scalars['String']['input']>;
};

export type LeadSearchInput = {
  assignedToId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<LeadStatusCategory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
};

export type LeadSource = {
  __typename?: 'LeadSource';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LeadStatus = {
  __typename?: 'LeadStatus';
  category?: Maybe<LeadStatusCategory>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LeadStatusCategory =
  | 'CONVERTED'
  | 'LOST'
  | 'OPEN';

export type LearningProgramme = {
  __typename?: 'LearningProgramme';
  employee: TrainingPerson;
  employmentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nqfLevel?: Maybe<Scalars['Int']['output']>;
  outcome?: Maybe<LearningProgrammeOutcome>;
  seta?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  type: LearningProgrammeType;
};

export type LearningProgrammeFilterInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};

export type LearningProgrammeOutcome =
  | 'COMPLETED'
  | 'NOT_COMPLETED'
  | 'WITHDRAWN';

export type LearningProgrammeType =
  | 'APPRENTICESHIP'
  | 'INTERNSHIP'
  | 'LEARNERSHIP'
  | 'SKILLS_PROGRAMME';

export type LeaveApprover = {
  __typename?: 'LeaveApprover';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type LeaveBalance = {
  __typename?: 'LeaveBalance';
  cycleEnd: Scalars['DateTime']['output'];
  cycleStart: Scalars['DateTime']['output'];
  employee: AttendanceEmployee;
  entitlementDays: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  leaveType: LeaveTypeSummary;
  remainingDays: Scalars['Float']['output'];
  source: HrDataSource;
  takenDays: Scalars['Float']['output'];
  takenFromRequests: Scalars['Boolean']['output'];
};

export type LeaveBalanceFilterInput = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type LeaveCategory =
  | 'ANNUAL'
  | 'FAMILY_RESPONSIBILITY'
  | 'MATERNITY'
  | 'OTHER'
  | 'PARENTAL'
  | 'SICK'
  | 'STUDY'
  | 'UNPAID';

export type LeaveDaysByType = {
  __typename?: 'LeaveDaysByType';
  category?: Maybe<LeaveCategory>;
  days: Scalars['Float']['output'];
};

export type LeaveRequest = {
  __typename?: 'LeaveRequest';
  approver?: Maybe<LeaveApprover>;
  createdAt: Scalars['DateTime']['output'];
  days: Scalars['Float']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decisionNote?: Maybe<Scalars['String']['output']>;
  employee: AttendanceEmployee;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  leaveType?: Maybe<LeaveTypeSummary>;
  reason?: Maybe<Scalars['String']['output']>;
  source: HrDataSource;
  startDate: Scalars['DateTime']['output'];
  status: LeaveRequestStatus;
};

export type LeaveRequestFilterInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<LeaveRequestStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LeaveRequestList = {
  __typename?: 'LeaveRequestList';
  items: Array<LeaveRequest>;
  totalCount: Scalars['Int']['output'];
};

export type LeaveRequestStatus =
  | 'APPROVED'
  | 'CANCELLED'
  | 'DECLINED'
  | 'REQUESTED';

export type LeaveType = {
  __typename?: 'LeaveType';
  active: Scalars['Boolean']['output'];
  category: LeaveCategory;
  cycleMonths?: Maybe<Scalars['Int']['output']>;
  entitlementDays?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paid?: Maybe<Scalars['Boolean']['output']>;
};

export type LeaveTypeSummary = {
  __typename?: 'LeaveTypeSummary';
  category: LeaveCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LeftWithLogin = {
  __typename?: 'LeftWithLogin';
  email: Scalars['String']['output'];
  employeeId: Scalars['ID']['output'];
  endDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type LegacyEntityType =
  | 'CONTRACT'
  | 'CUSTOMER'
  | 'STOCK_ITEM';

export type LegacySourceRecord = {
  __typename?: 'LegacySourceRecord';
  data?: Maybe<Scalars['JSON']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceTable?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
};

export type LegacySourceRecordResult = {
  __typename?: 'LegacySourceRecordResult';
  available?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  records?: Maybe<Array<LegacySourceRecord>>;
  system?: Maybe<Scalars['String']['output']>;
};

export type ListDisputesInput = {
  flags?: InputMaybe<Array<DisputeFlag>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Money the payment service has reported over a span, ahead of the till files.
 * The unreconciled half of the Finance overview's week.
 */
export type LiveMoneyIn = {
  __typename?: 'LiveMoneyIn';
  from: Scalars['DateTime']['output'];
  payments: Scalars['Int']['output'];
  to: Scalars['DateTime']['output'];
  totalCents: Scalars['Int']['output'];
};

export type LocalMunicipality = {
  __typename?: 'LocalMunicipality';
  districtMunicipality?: Maybe<DistrictMunicipality>;
  id?: Maybe<Scalars['ID']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MailingListEntry = {
  __typename?: 'MailingListEntry';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  list: MailingListName;
};

export type MailingListFrequency =
  | 'DAILY'
  | 'FORTNIGHTLY'
  | 'MONTHLY'
  | 'WEEKLY';

export type MailingListName =
  | 'AGENT_AGREEMENT'
  | 'AGENT_INVITE_APPROVAL'
  | 'AUTO_RESTORE_REPORT'
  | 'BANK_VERIFICATION'
  | 'COMMISSION_RUN'
  | 'CONTRACT_APPROVAL'
  | 'FAULT_ALERT'
  | 'GRIEVANCE'
  | 'JOB_REPORT'
  | 'PART_REQUEST'
  | 'RETURN_TO_HEAD_OFFICE'
  | 'SMS_CAMPAIGN_REPORT'
  | 'UPGRADE_ONBOARDING'
  | 'WRITE_OFF_REPORT';

export type MailingListSchedule = {
  __typename?: 'MailingListSchedule';
  frequency: MailingListFrequency;
  list: MailingListName;
  /** When the next email is due. */
  nextSendAt: Scalars['DateTime']['output'];
  /** HH:MM, South African time. */
  sendAt: Scalars['String']['output'];
  /** YYYY-MM-DD, the South African calendar date of the first send. */
  startsOn: Scalars['String']['output'];
  /** Null while it is the unsaved default. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ManSystem =
  | 'ANGAZA'
  | 'ATLAS'
  | 'PAYGOPS';

export type MarkAllReadResult = {
  __typename?: 'MarkAllReadResult';
  count?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkCommissionRunPaidInput = {
  override?: InputMaybe<Scalars['Boolean']['input']>;
  runId: Scalars['String']['input'];
};

export type MarkCommissionsPaidInput = {
  ids: Array<Scalars['String']['input']>;
};

export type MarkCommissionsPaidResult = {
  __typename?: 'MarkCommissionsPaidResult';
  paidCount?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Array<SkippedPayout>>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
};

export type MemberListResult = {
  __typename?: 'MemberListResult';
  items: Array<User>;
  totalCount: Scalars['Int']['output'];
};

export type MemberSearchInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Where a device's tokens are minted. */
export type MeterHost =
  | 'ANGAZA'
  | 'KES';

export type MeterType = {
  __typename?: 'MeterType';
  angazaSupported?: Maybe<Scalars['Int']['output']>;
  atlasSupported?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payAtSalesSupported?: Maybe<Scalars['Int']['output']>;
  paygOpsSalesSupported?: Maybe<Scalars['Int']['output']>;
  paygoSupported?: Maybe<Scalars['Int']['output']>;
  smsTemplate?: Maybe<Scalars['String']['output']>;
};

/** A card payment taken on an MTN MoMo POS terminal, copied from the legacy database. */
export type MoMoPosPayment = {
  __typename?: 'MoMoPosPayment';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  authCode?: Maybe<Scalars['String']['output']>;
  cardScheme?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<MoMoPosPaymentContract>;
  id?: Maybe<Scalars['Int']['output']>;
  maskedCard?: Maybe<Scalars['String']['output']>;
  mtnTransactionNo?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<MoMoPosPaymentStatus>;
  terminalSerial?: Maybe<Scalars['String']['output']>;
  typedAccount?: Maybe<Scalars['String']['output']>;
};

export type MoMoPosPaymentContract = {
  __typename?: 'MoMoPosPaymentContract';
  contractNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MoMoPosPaymentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MoMoPosPaymentStatus>;
};

export type MoMoPosPaymentList = {
  __typename?: 'MoMoPosPaymentList';
  items?: Maybe<Array<MoMoPosPayment>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MoMoPosPaymentStatus =
  /** An agent confirmed the payment and the token was sent. */
  | 'TOKEN_SENT'
  /** A status the MoMo flow does not use. */
  | 'UNKNOWN'
  /** MTN reported the payment; no agent has confirmed it, so no token was sent. */
  | 'WAITING';

export type Module = {
  __typename?: 'Module';
  actions?: Maybe<Array<Scalars['String']['output']>>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentCode?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<RolePermission>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MoveJobApplicationInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  stage: JobApplicationStage;
};

export type MovementDetailsInput = {
  correction?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  movementType?: InputMaybe<EmployeeMovementType>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _noop?: Maybe<Scalars['Boolean']['output']>;
  acceptInvite?: Maybe<AuthPayload>;
  acknowledgeGrievance?: Maybe<Grievance>;
  activateCustomer?: Maybe<SuccessPayload>;
  addAccessoryStock?: Maybe<Scalars['Int']['output']>;
  addFaultAlertRecipient?: Maybe<FaultAlertRecipient>;
  addGrievanceNote?: Maybe<GrievanceEvent>;
  addHrCaseNote: HrCaseEvent;
  addPartFromRequest?: Maybe<PartRequest>;
  addPurchaseOrderItems?: Maybe<PurchaseOrder>;
  addRecruitmentCost: RecruitmentCost;
  addSmsOptOut: SmsOptOut;
  addStockItemToStockingPoint?: Maybe<StockItem>;
  addStockTakeLine?: Maybe<StockTakeLine>;
  addToMailingList: MailingListEntry;
  addWriteOffReportRecipient?: Maybe<WriteOffReportRecipient>;
  adjustPartStock?: Maybe<StockMovement>;
  applyPaymentReallocation: ReallocationResult;
  applySellerCorrections?: Maybe<ApplySellerCorrectionsResult>;
  approveBankVerification?: Maybe<BankVerification>;
  approveCommissions?: Maybe<BulkActionResult>;
  /** Approves a new distributor's Solar Management Fee held for review: ON_HOLD to APPROVED (ADR-0084). */
  approveHeldCommissions: BulkActionResult;
  /** Send the next batch of a campaign waiting for approval: as many people as 90% of the credit balance covers now. */
  approveNextSmsCampaignBatch: SmsCampaign;
  approveStockTake?: Maybe<StockTake>;
  archiveCustomer?: Maybe<SuccessPayload>;
  archiveMember?: Maybe<SuccessPayload>;
  archiveNote?: Maybe<SuccessPayload>;
  archiveStockItems?: Maybe<StockItemBulkActionResult>;
  assignAgentToStockingPoint?: Maybe<StockingPointUser>;
  assignDeviceToContract?: Maybe<StockSale>;
  assignGrievance?: Maybe<Grievance>;
  assignSalesRegion: SalesRegionManager;
  assignUserToDepartment?: Maybe<SuccessPayload>;
  assignUserToRole?: Maybe<SuccessPayload>;
  assignWorkshopMember?: Maybe<StockingPointMember>;
  autoMatchBankStatement: BankStatementBatch;
  batchAddDevicesToStockingPoint?: Maybe<BatchAddDevicesResult>;
  bulkChangeContractRatePlan?: Maybe<BulkRatePlanChangeResult>;
  bulkFlagContractsForRepossession?: Maybe<BulkFlagRepossessionResult>;
  bulkInvite?: Maybe<BulkInviteResult>;
  bulkSendInvites?: Maybe<BulkSendInvitesResult>;
  cancelAgentInviteApproval?: Maybe<AgentInviteApproval>;
  cancelApprovalRequest?: Maybe<ApprovalRequest>;
  cancelCommission?: Maybe<Scalars['Boolean']['output']>;
  cancelLeaveRequest: LeaveRequest;
  cancelPartRequest: PartRequest;
  cancelPermissionChangeRequest?: Maybe<PermissionChangeRequest>;
  cancelPurchaseOrder?: Maybe<PurchaseOrder>;
  cancelReturnToHeadOffice?: Maybe<ReturnToHeadOffice>;
  cancelSmsCampaign: SmsCampaign;
  cancelStockTake?: Maybe<StockTake>;
  cancelStockTransfer?: Maybe<StockTransfer>;
  changeContractRatePlan?: Maybe<ChangeRatePlanResult>;
  changeLeadStatus?: Maybe<Lead>;
  changePassword?: Maybe<SuccessPayload>;
  clearContractRepossessionFlag?: Maybe<Contract>;
  clearWebhookSubscriptionFailures?: Maybe<WebhookSubscription>;
  cloneRole?: Maybe<Role>;
  closePurchaseOrder?: Maybe<PurchaseOrder>;
  completeRepair: WorkshopJob;
  completeStockTransfer?: Maybe<StockTransfer>;
  configureDeviceAtWorkshop: WorkshopJob;
  confirmDeviceLock?: Maybe<DeviceControlAction>;
  convertLead?: Maybe<ConvertLeadResult>;
  copySmsCampaign: SmsCampaign;
  countStockTakeLine?: Maybe<StockTakeLine>;
  countersignAgentAgreement?: Maybe<AgentAgreement>;
  createAgent?: Maybe<Agent>;
  createAgentCategory?: Maybe<AgentCategory>;
  createAgentTransfer?: Maybe<StockTransfer>;
  createApiConsumer?: Maybe<CreateApiConsumerResult>;
  createApiKey?: Maybe<CreateApiKeyResult>;
  createApplication?: Maybe<Application>;
  createApprovalRequest?: Maybe<ApprovalRequest>;
  createAttendanceRecord: AttendanceRecord;
  createBusinessLine?: Maybe<BusinessLine>;
  createCandidate: Candidate;
  createCommissionRule?: Maybe<CommissionRule>;
  createCommissionTypeConfig?: Maybe<CommissionTypeConfig>;
  createContract?: Maybe<Contract>;
  createCustomer?: Maybe<Customer>;
  createDepartment?: Maybe<Department>;
  createDeviceType?: Maybe<DeviceType>;
  createDigitalChannel: DigitalChannel;
  createEmployee: Employee;
  createEmployeeBenefit: EmployeeBenefit;
  createEmployeeFromHire: Employee;
  createEsgBeneficiary: EsgBeneficiary;
  createEsgOutcome: EsgOutcome;
  createEsgProgramme: EsgProgramme;
  createEsgSpend: EsgSpend;
  createEsgVolunteering: EsgVolunteering;
  createFaultCategory: FaultCategory;
  createFaultSubType: FaultSubType;
  createFaultType: FaultType;
  createGrievance?: Maybe<CreateGrievancePayload>;
  createHrCase: HrCase;
  createImprovementPlan: ImprovementPlan;
  createItemCategory?: Maybe<ItemCategory>;
  createJobApplication: JobApplication;
  createJobPosition: JobPosition;
  createLead?: Maybe<Lead>;
  createLeadSource?: Maybe<LeadSource>;
  createLeadStatus?: Maybe<LeadStatus>;
  createLearningProgramme: LearningProgramme;
  createLeaveBalance: LeaveBalance;
  createLeaveRequest: LeaveRequest;
  createManualCommission?: Maybe<CommissionEntry>;
  createModule?: Maybe<Module>;
  createNote?: Maybe<Note>;
  createOrganization?: Maybe<Organization>;
  createPart: Part;
  createPayRun: PayRun;
  createPayslip: Payslip;
  createPerformanceReview: PerformanceReview;
  createProduct?: Maybe<Product>;
  createProductBrand?: Maybe<ProductBrand>;
  createProductCategory?: Maybe<ProductCategory>;
  createPurchaseOrder?: Maybe<PurchaseOrder>;
  createRatePlan?: Maybe<RatePlan>;
  createReviewCycle: ReviewCycle;
  createRole?: Maybe<Role>;
  createSafetyCorrectiveAction: SafetyCorrectiveAction;
  createSafetyIncident: SafetyIncident;
  createSafetyInspection: SafetyInspection;
  createSalesRegion: SalesRegion;
  createShippingCompany?: Maybe<ShippingCompany>;
  createSmsCampaign: SmsCampaign;
  createStockTransfer?: Maybe<StockTransfer>;
  createStockTransferFromSerials?: Maybe<StockTransfer>;
  createStockType?: Maybe<StockType>;
  createStockingPoint?: Maybe<StockingPoint>;
  createSubcontractor: Subcontractor;
  createSubcontractorComplianceDocument: SubcontractorComplianceDocument;
  createSubcontractorHours: SubcontractorHours;
  createSubcontractorInvoice: SubcontractorInvoice;
  createSubcontractorWorker: SubcontractorWorker;
  createSupplier?: Maybe<Supplier>;
  createTeam: Team;
  createThirdPartyCredential?: Maybe<ThirdPartyCredential>;
  createTrainingCertification: TrainingCertification;
  createTrainingCourse: TrainingCourse;
  createTrainingSession: TrainingSession;
  createUnitOfMeasure?: Maybe<UnitOfMeasure>;
  createVacancy: Vacancy;
  createWebhookSubscription?: Maybe<CreateWebhookSubscriptionResult>;
  deactivateAgent?: Maybe<Scalars['Boolean']['output']>;
  deactivateCustomer?: Maybe<SuccessPayload>;
  decideLeaveRequest: LeaveRequest;
  declineAgentAgreement?: Maybe<AgentAgreement>;
  deleteAgentCategory?: Maybe<AgentCategory>;
  deleteApiKey?: Maybe<SuccessPayload>;
  deleteAttendanceRecord: Scalars['Boolean']['output'];
  deleteBusinessLine?: Maybe<BusinessLine>;
  deleteCandidate: Scalars['Boolean']['output'];
  deleteCommissionRule?: Maybe<Scalars['Boolean']['output']>;
  deleteCommissionTypeConfig?: Maybe<Scalars['Boolean']['output']>;
  deleteDepartment?: Maybe<SuccessPayload>;
  deleteDeviceType?: Maybe<DeviceType>;
  deleteDigitalChannel: Scalars['Boolean']['output'];
  deleteDocument?: Maybe<DeleteDocumentResult>;
  deleteEmployeeBenefit: Scalars['Boolean']['output'];
  deleteEsgBeneficiary: Scalars['Boolean']['output'];
  deleteEsgOutcome: Scalars['Boolean']['output'];
  deleteEsgProgramme: Scalars['Boolean']['output'];
  deleteEsgSpend: Scalars['Boolean']['output'];
  deleteEsgVolunteering: Scalars['Boolean']['output'];
  deleteFaultCategory: Scalars['Boolean']['output'];
  deleteFaultSubType: Scalars['Boolean']['output'];
  deleteFaultType: Scalars['Boolean']['output'];
  deleteItemCategory?: Maybe<ItemCategory>;
  deleteJobApplication: Scalars['Boolean']['output'];
  deleteJobPosition: Scalars['Boolean']['output'];
  deleteLeadSource?: Maybe<LeadSource>;
  deleteLeadStatus?: Maybe<LeadStatus>;
  deleteLeaveBalance: Scalars['Boolean']['output'];
  deleteModule?: Maybe<SuccessPayload>;
  deletePayRun: Scalars['Boolean']['output'];
  deletePayslip: Scalars['Boolean']['output'];
  deleteProductBrand?: Maybe<ProductBrand>;
  deleteProductCategory?: Maybe<ProductCategory>;
  deleteRatePlan?: Maybe<SuccessPayload>;
  deleteRecruitmentCost: Scalars['Boolean']['output'];
  deleteReviewCycle: Scalars['Boolean']['output'];
  deleteRole?: Maybe<SuccessPayload>;
  deleteSafetyCorrectiveAction: Scalars['Boolean']['output'];
  deleteSafetyIncident: Scalars['Boolean']['output'];
  deleteSafetyInspection: Scalars['Boolean']['output'];
  deleteSalesRegion: Scalars['Boolean']['output'];
  deleteSmsCampaign: Scalars['Boolean']['output'];
  deleteStockType?: Maybe<StockType>;
  deleteSubcontractor: Scalars['Boolean']['output'];
  deleteSubcontractorComplianceDocument: Scalars['Boolean']['output'];
  deleteSubcontractorHours: Scalars['Boolean']['output'];
  deleteSubcontractorInvoice: Scalars['Boolean']['output'];
  deleteSubcontractorWorker: Scalars['Boolean']['output'];
  deleteTeam: Scalars['Boolean']['output'];
  deleteThirdPartyCredential?: Maybe<SuccessPayload>;
  deleteTrainingCertification: Scalars['Boolean']['output'];
  deleteTrainingCourse: Scalars['Boolean']['output'];
  deleteTrainingSession: Scalars['Boolean']['output'];
  deleteUnitOfMeasure?: Maybe<UnitOfMeasure>;
  deleteVacancy: Scalars['Boolean']['output'];
  deleteWebhookSubscription?: Maybe<SuccessPayload>;
  dispatchStockTransfer?: Maybe<StockTransfer>;
  endEmployment: Employment;
  finalisePayRun: PayRun;
  flagContractForRepossession?: Maybe<Contract>;
  flagStockSaleAsBad?: Maybe<StockSale>;
  generateTestToken: WorkshopTokenTest;
  generateToken: GenerateTokenResult;
  ignorePayAtRows?: Maybe<Scalars['Int']['output']>;
  importAttendance: HrImportResult;
  importPayslips: HrImportResult;
  importSubcontractorHours: SubcontractorHoursImportResult;
  issueAgentAgreement?: Maybe<AgentAgreement>;
  issueContractAccessories?: Maybe<Array<ContractAccessory>>;
  linkPartRequest?: Maybe<PartRequest>;
  lockContractDevices?: Maybe<Array<DeviceControlAction>>;
  logRedactedFieldAccess?: Maybe<SuccessPayload>;
  login?: Maybe<AuthPayload>;
  logout?: Maybe<Scalars['Boolean']['output']>;
  markAllNotificationsAsRead?: Maybe<MarkAllReadResult>;
  markCommissionRunPaid?: Maybe<MarkCommissionsPaidResult>;
  markCommissionsPaid?: Maybe<MarkCommissionsPaidResult>;
  markCustomerDelinquent?: Maybe<SuccessPayload>;
  markNotificationAsRead?: Maybe<Notification>;
  markPurchaseOrderInTransit?: Maybe<PurchaseOrder>;
  matchPayAtRow?: Maybe<PayAtDumpRow>;
  materializeAllPermissions?: Maybe<SuccessPayload>;
  moveJobApplication: JobApplication;
  onboardUpgrade?: Maybe<ContractUpgrade>;
  openStockTake?: Maybe<StockTake>;
  processBankStatement: ProcessBankStatementResult;
  processBankStatements: Array<ProcessBankStatementResult>;
  processWarrantyReplacement?: Maybe<StockSale>;
  raisePartRequest: PartRequest;
  reactivateAgent?: Maybe<Scalars['Boolean']['output']>;
  reactivateCustomer?: Maybe<SuccessPayload>;
  reallocatePayment: ReallocationResult;
  reassignContractDevice?: Maybe<DeviceReassignment>;
  reassignLead?: Maybe<Lead>;
  receiveAtWorkshop?: Maybe<StockTransfer>;
  receivePartRequest: PartRequest;
  receiveParts: StockMovement;
  receivePurchaseOrderLines?: Maybe<PurchaseOrder>;
  /** Receive an upload recorded while still on its way. Returns the number of devices received. */
  receiveStockImport?: Maybe<Scalars['Int']['output']>;
  recheckPayAtRow?: Maybe<PayAtDumpRow>;
  reconcileBankStatementRow: BankStatementRow;
  recordContractRepossession?: Maybe<Contract>;
  recordEmployeeMovement: EmployeeMovement;
  recordPayAtRowPayment?: Maybe<PayAtRecordPaymentResult>;
  recordStockSale?: Maybe<StockSale>;
  recordTokenTestVerdict: WorkshopTokenTest;
  redactNote?: Maybe<SuccessPayload>;
  /** commissions:configure. Works Running Commission out now; returns how many agents' figures were written. */
  refreshRunningCommission: Scalars['Int']['output'];
  refreshShipment?: Maybe<Shipment>;
  refreshToken?: Maybe<RefreshPayload>;
  registerDeviceAtWorkshop: WorkshopJob;
  rejectAgentAgreement?: Maybe<AgentAgreement>;
  rejectBankVerification?: Maybe<BankVerification>;
  rejectPartRequest: PartRequest;
  releaseDevice?: Maybe<StockItem>;
  releaseFromWorkshop: StockTransfer;
  releaseFromWorkshopMany?: Maybe<StockTransfer>;
  removeAgentFromStockingPoint?: Maybe<Scalars['Boolean']['output']>;
  removeCandidateCv: Scalars['Boolean']['output'];
  /** commissions:configure */
  removeCommissionApproachChange: CommissionApproachSettings;
  removeEsgSpendEvidence: Scalars['Boolean']['output'];
  removeFaultAlertRecipient?: Maybe<SuccessPayload>;
  removeFromMailingList?: Maybe<SuccessPayload>;
  removeHrCaseDocument: Scalars['Boolean']['output'];
  removeSafetyIncidentEvidence: Scalars['Boolean']['output'];
  removeSmsOptOut: SmsOptOut;
  removeStockTakeScan?: Maybe<Scalars['Boolean']['output']>;
  removeSubcontractorComplianceFile: Scalars['Boolean']['output'];
  removeTrainingCertificateDocument: Scalars['Boolean']['output'];
  removeUserFromDepartment?: Maybe<SuccessPayload>;
  removeUserFromRole?: Maybe<SuccessPayload>;
  removeUserPermissionOverride?: Maybe<SuccessPayload>;
  removeWorkshopMember?: Maybe<Scalars['Boolean']['output']>;
  removeWriteOffReportRecipient?: Maybe<SuccessPayload>;
  renameSalesRegion: SalesRegion;
  renameStockingPoint?: Maybe<StockingPoint>;
  reopenContract?: Maybe<Contract>;
  reopenGrievance?: Maybe<Grievance>;
  reopenPayRun: PayRun;
  /** Puts one group of siblings in the order given: the top level, or the sub-categories of parentId. */
  reorderItemCategories: Array<ItemCategory>;
  reorderStockingPoints?: Maybe<Array<StockingPoint>>;
  replaceAgent?: Maybe<Scalars['Boolean']['output']>;
  requestAgentAgreementInfo?: Maybe<AgentAgreement>;
  requestBankVerificationInfo?: Maybe<BankVerification>;
  requestPasswordReset?: Maybe<SuccessPayload>;
  requestPhoneNumberUpdate: PhoneNumberUpdateRequest;
  requestUpgradeOnboarding?: Maybe<ApprovalRequest>;
  resendContractPaymentNumberSms?: Maybe<Contract>;
  resendDeviceUnlockSms?: Maybe<DeviceControlAction>;
  resendFailedSmsCampaign: SmsCampaign;
  resendInvite?: Maybe<SuccessPayload>;
  resendPhoneNumberUpdateOtp: PhoneNumberUpdateRequest;
  resendTokenSms: ResendTokenSmsResult;
  resendVerificationEmail?: Maybe<SuccessPayload>;
  resendWebhookDelivery?: Maybe<SuccessPayload>;
  /** Puts one group of siblings back in A to Z order. */
  resetItemCategoryOrder: Array<ItemCategory>;
  resetPassword?: Maybe<SuccessPayload>;
  resolveDispute?: Maybe<ResolveDisputePayload>;
  resolveGrievance?: Maybe<Grievance>;
  restoreCustomer?: Maybe<SuccessPayload>;
  restoreMember?: Maybe<SuccessPayload>;
  restoreNote?: Maybe<Note>;
  restoreStockItems?: Maybe<StockItemBulkActionResult>;
  resumeSmsCampaign: SmsCampaign;
  retrySalesAppMessage: SalesAppMessage;
  retryXeroOperation?: Maybe<XeroSyncResult>;
  returnContractAccessory?: Maybe<ContractAccessory>;
  returnParts: StockMovement;
  reverseStockImport?: Maybe<StockImportReversalResult>;
  reviewAgentInviteApproval?: Maybe<AgentInviteApproval>;
  reviewApprovalRequest?: Maybe<ApprovalRequest>;
  reviewPermissionChangeRequest?: Maybe<PermissionChangeRequest>;
  reviewReturnToHeadOffice?: Maybe<ReturnToHeadOffice>;
  revokeApiConsumer?: Maybe<ApiConsumer>;
  revokeApiKey?: Maybe<SuccessPayload>;
  revokeInvite?: Maybe<SuccessPayload>;
  revokeThirdPartyCredential?: Maybe<SuccessPayload>;
  rotateApiConsumerSecret?: Maybe<RotateApiConsumerSecretResult>;
  rotateWebhookSubscriptionSecret?: Maybe<RotateWebhookSecretResult>;
  runCommissions?: Maybe<CommissionRun>;
  runPayAtReconciliation?: Maybe<PayAtReconciliationRunResult>;
  saveJobOffer: JobApplication;
  scanStockTakeUnit?: Maybe<StockTakeUnit>;
  /** commissions:configure */
  scheduleCommissionApproach: CommissionApproachSettings;
  scrapDevice?: Maybe<WorkshopJob>;
  seedLeaveTypes: Array<LeaveType>;
  sendBackStockTake?: Maybe<StockTake>;
  sendGrievanceMessage?: Maybe<GrievanceMessage>;
  sendInvite?: Maybe<SuccessPayload>;
  sendPartRequest: PartRequest;
  sendSalesAppMessage: SalesAppMessage;
  sendSmsCampaign: SmsCampaign;
  sendSmsCampaignTest: Scalars['Boolean']['output'];
  setApiKeyInboundSignature?: Maybe<ApiKey>;
  setDepartmentAdmin: SuccessPayload;
  setDepartmentDefaultRoles?: Maybe<SuccessPayload>;
  setMailingListSchedule: MailingListSchedule;
  setNotePinned?: Maybe<Note>;
  setNoteVisibility?: Maybe<Note>;
  setPayAtRowAccount?: Maybe<PayAtDumpRow>;
  setProbation: Probation;
  setRoleGrants: SuccessPayload;
  setStockingPointActive?: Maybe<StockingPoint>;
  setStockingPointProductMinimum?: Maybe<StockingPointProductMinimum>;
  setUserPermission?: Maybe<SuccessPayload>;
  setUserPermissionOverride?: Maybe<SuccessPayload>;
  setWorkshopJobIntakeReason: WorkshopJob;
  setupDeviceMeter?: Maybe<StockItem>;
  signMyAgentAgreement?: Maybe<AgentAgreement>;
  startAgentAgreementReview?: Maybe<AgentAgreement>;
  startBankVerificationReview?: Maybe<BankVerification>;
  startEmployment: Employment;
  stopSmsCampaign: SmsCampaign;
  submitReturnToHeadOffice?: Maybe<ReturnToHeadOffice>;
  submitStockTake?: Maybe<StockTake>;
  suspendCustomer?: Maybe<SuccessPayload>;
  swapContractDevices?: Maybe<Array<DeviceReassignment>>;
  syncCustomerToXero?: Maybe<XeroSyncResult>;
  toggleCommissionRuleActive?: Maybe<CommissionRule>;
  toggleModule?: Maybe<Module>;
  unflagStockSale?: Maybe<StockSale>;
  unignorePayAtRow?: Maybe<PayAtDumpRow>;
  unlockContractDevices?: Maybe<Array<DeviceControlAction>>;
  unmatchPayAtRow?: Maybe<PayAtDumpRow>;
  unreconcileBankStatementRow: BankStatementRow;
  updateAgent?: Maybe<Agent>;
  updateAgentCategory?: Maybe<AgentCategory>;
  updateApplication?: Maybe<Application>;
  updateAttendanceRecord: AttendanceRecord;
  updateBankStatementRow: BankStatementRow;
  updateBusinessLine?: Maybe<BusinessLine>;
  updateCandidate: Candidate;
  updateCommissionPolicy?: Maybe<CommissionPolicy>;
  updateCommissionRule?: Maybe<CommissionRule>;
  updateCommissionTypeConfig?: Maybe<CommissionTypeConfig>;
  updateContract?: Maybe<Contract>;
  updateCustomer?: Maybe<Customer>;
  updateDelinquencyPolicy?: Maybe<DelinquencyPolicy>;
  updateDepartment?: Maybe<Department>;
  updateDevice?: Maybe<StockItem>;
  updateDeviceMeter?: Maybe<StockItem>;
  updateDeviceType?: Maybe<DeviceType>;
  updateDigitalChannel: DigitalChannel;
  updateEmployee: Employee;
  updateEmployeeBenefit: EmployeeBenefit;
  updateEmployeeDemographics: EmployeeDemographics;
  updateEmployment: Employment;
  updateEsgBeneficiary: EsgBeneficiary;
  updateEsgOutcome: EsgOutcome;
  updateEsgProgramme: EsgProgramme;
  updateEsgSpend: EsgSpend;
  updateEsgVolunteering: EsgVolunteering;
  updateFaultCategory: FaultCategory;
  updateFaultSubType: FaultSubType;
  updateFaultType: FaultType;
  updateGrievanceSettings?: Maybe<GrievanceSettings>;
  updateGrievanceStatus?: Maybe<Grievance>;
  updateHrCase: HrCase;
  updateImprovementPlan: ImprovementPlan;
  updateItemCategory?: Maybe<ItemCategory>;
  updateJobPosition: JobPosition;
  updateLead?: Maybe<Lead>;
  updateLeadSource?: Maybe<LeadSource>;
  updateLeadStatus?: Maybe<LeadStatus>;
  updateLearningProgramme: LearningProgramme;
  updateLeaveBalance: LeaveBalance;
  updateLeaveType: LeaveType;
  updateMinimumStockLevel?: Maybe<StockingPoint>;
  updateModule?: Maybe<Module>;
  updateMyBankingDetails?: Maybe<Agent>;
  updateNote?: Maybe<Note>;
  updateOrganization?: Maybe<Organization>;
  updatePart: Part;
  updatePayRun: PayRun;
  updatePaymentRatingPolicy: PaymentRatingPolicy;
  updatePayslip: Payslip;
  updatePerformanceReview: PerformanceReview;
  updateProduct?: Maybe<Product>;
  updateProductBrand?: Maybe<ProductBrand>;
  updateProductCategory?: Maybe<ProductCategory>;
  updateProfile?: Maybe<User>;
  updatePurchaseOrderPlan?: Maybe<PurchaseOrder>;
  updatePurchaseOrderShipping?: Maybe<PurchaseOrder>;
  updateRatePlan?: Maybe<RatePlan>;
  updateReallocationPolicy: ReallocationPolicy;
  updateRecruitmentCost: RecruitmentCost;
  updateReviewCycle: ReviewCycle;
  updateRole?: Maybe<Role>;
  updateRolePermissions?: Maybe<SuccessPayload>;
  updateSafetyCorrectiveAction: SafetyCorrectiveAction;
  updateSafetyIncident: SafetyIncident;
  updateSafetyInspection: SafetyInspection;
  updateShippingCompany?: Maybe<ShippingCompany>;
  updateSmsCampaign: SmsCampaign;
  updateStockTransferShipping?: Maybe<StockTransfer>;
  updateStockType?: Maybe<StockType>;
  updateStockingPoint?: Maybe<StockingPoint>;
  updateSubcontractor: Subcontractor;
  updateSubcontractorComplianceDocument: SubcontractorComplianceDocument;
  updateSubcontractorHours: SubcontractorHours;
  updateSubcontractorInvoice: SubcontractorInvoice;
  updateSubcontractorWorker: SubcontractorWorker;
  updateSupplier?: Maybe<Supplier>;
  updateTeam: Team;
  updateThirdPartyCredential?: Maybe<ThirdPartyCredential>;
  updateTrainingCertification: TrainingCertification;
  updateTrainingCourse: TrainingCourse;
  updateTrainingSession: TrainingSession;
  updateUnitOfMeasure?: Maybe<UnitOfMeasure>;
  updateVacancy: Vacancy;
  updateWebhookSubscription?: Maybe<WebhookSubscription>;
  updateWorkshopPolicy?: Maybe<WorkshopPolicy>;
  useParts: StockMovement;
  validateInvite?: Maybe<ValidateInvitePayload>;
  verifyEmail?: Maybe<SuccessPayload>;
  verifyPhoneNumberUpdateOtp: PhoneNumberUpdateRequest;
  withdrawReturnToHeadOffice?: Maybe<ReturnToHeadOffice>;
  writeOffContract?: Maybe<Contract>;
};


export type MutationAcceptInviteArgs = {
  input: AcceptInviteInput;
};


export type MutationAcknowledgeGrievanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddAccessoryStockArgs = {
  input: AddAccessoryStockInput;
};


export type MutationAddFaultAlertRecipientArgs = {
  email: Scalars['String']['input'];
};


export type MutationAddGrievanceNoteArgs = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationAddHrCaseNoteArgs = {
  caseId: Scalars['ID']['input'];
  input: HrCaseNoteInput;
};


export type MutationAddPartFromRequestArgs = {
  id: Scalars['ID']['input'];
  input: PartInput;
};


export type MutationAddPurchaseOrderItemsArgs = {
  id: Scalars['String']['input'];
  input: AddPurchaseOrderItemsInput;
};


export type MutationAddRecruitmentCostArgs = {
  input: RecruitmentCostInput;
  vacancyId: Scalars['ID']['input'];
};


export type MutationAddSmsOptOutArgs = {
  phone: Scalars['String']['input'];
};


export type MutationAddStockItemToStockingPointArgs = {
  input: AddStockItemInput;
};


export type MutationAddStockTakeLineArgs = {
  condition?: InputMaybe<StockCondition>;
  productId: Scalars['String']['input'];
  stockTakeId: Scalars['String']['input'];
};


export type MutationAddToMailingListArgs = {
  email: Scalars['String']['input'];
  list: MailingListName;
};


export type MutationAddWriteOffReportRecipientArgs = {
  email: Scalars['String']['input'];
};


export type MutationAdjustPartStockArgs = {
  delta: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  stockingPointId: Scalars['String']['input'];
};


export type MutationApplyPaymentReallocationArgs = {
  reallocationId: Scalars['String']['input'];
};


export type MutationApplySellerCorrectionsArgs = {
  input: ApplySellerCorrectionsInput;
};


export type MutationApproveBankVerificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationApproveCommissionsArgs = {
  input: ApproveCommissionsInput;
};


export type MutationApproveHeldCommissionsArgs = {
  input: ApproveCommissionsInput;
};


export type MutationApproveNextSmsCampaignBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveStockTakeArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveCustomerArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationArchiveMemberArgs = {
  userId: Scalars['String']['input'];
};


export type MutationArchiveNoteArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationArchiveStockItemsArgs = {
  input: ArchiveStockItemsInput;
};


export type MutationAssignAgentToStockingPointArgs = {
  agentId: Scalars['String']['input'];
  stockingPointId: Scalars['String']['input'];
};


export type MutationAssignDeviceToContractArgs = {
  input: AssignDeviceToContractInput;
};


export type MutationAssignGrievanceArgs = {
  id: Scalars['ID']['input'];
  ownerUserId: Scalars['ID']['input'];
};


export type MutationAssignSalesRegionArgs = {
  salesRegionId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationAssignUserToDepartmentArgs = {
  departmentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAssignUserToRoleArgs = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAssignWorkshopMemberArgs = {
  stockingPointId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAutoMatchBankStatementArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationBatchAddDevicesToStockingPointArgs = {
  input: BatchAddDevicesInput;
};


export type MutationBulkChangeContractRatePlanArgs = {
  input: BulkChangeContractRatePlanInput;
};


export type MutationBulkFlagContractsForRepossessionArgs = {
  input: BulkFlagContractsForRepossessionInput;
};


export type MutationBulkInviteArgs = {
  input: BulkInviteInput;
};


export type MutationBulkSendInvitesArgs = {
  input: BulkSendInvitesInput;
};


export type MutationCancelAgentInviteApprovalArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelApprovalRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelCommissionArgs = {
  input: CancelCommissionInput;
};


export type MutationCancelLeaveRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelPartRequestArgs = {
  id: Scalars['ID']['input'];
  resolutionNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelPermissionChangeRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelPurchaseOrderArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelReturnToHeadOfficeArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelSmsCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelStockTakeArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelStockTransferArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationChangeContractRatePlanArgs = {
  input: ChangeContractRatePlanInput;
};


export type MutationChangeLeadStatusArgs = {
  id: Scalars['String']['input'];
  statusId: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationClearContractRepossessionFlagArgs = {
  input: ClearRepossessionFlagInput;
};


export type MutationClearWebhookSubscriptionFailuresArgs = {
  id: Scalars['String']['input'];
};


export type MutationCloneRoleArgs = {
  newName: Scalars['String']['input'];
  sourceRoleId: Scalars['String']['input'];
};


export type MutationClosePurchaseOrderArgs = {
  courierOverrideReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationCompleteRepairArgs = {
  id: Scalars['ID']['input'];
  input: CompleteRepairInput;
};


export type MutationCompleteStockTransferArgs = {
  courierOverrideReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationConfigureDeviceAtWorkshopArgs = {
  input: ConfigureWorkshopDeviceInput;
};


export type MutationConfirmDeviceLockArgs = {
  deviceControlActionId: Scalars['ID']['input'];
};


export type MutationConvertLeadArgs = {
  id: Scalars['String']['input'];
};


export type MutationCopySmsCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCountStockTakeLineArgs = {
  countedQuantity: Scalars['Int']['input'];
  lineId: Scalars['String']['input'];
};


export type MutationCountersignAgentAgreementArgs = {
  id: Scalars['String']['input'];
  signingDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateAgentArgs = {
  input: CreateAgentInput;
};


export type MutationCreateAgentCategoryArgs = {
  input: CreateAgentCategoryInput;
};


export type MutationCreateAgentTransferArgs = {
  input: CreateAgentTransferInput;
};


export type MutationCreateApiConsumerArgs = {
  input: CreateApiConsumerInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateApprovalRequestArgs = {
  input: CreateApprovalRequestInput;
};


export type MutationCreateAttendanceRecordArgs = {
  employeeId: Scalars['ID']['input'];
  input: CreateAttendanceRecordInput;
};


export type MutationCreateBusinessLineArgs = {
  input: CreateBusinessLineInput;
};


export type MutationCreateCandidateArgs = {
  input: CreateCandidateInput;
};


export type MutationCreateCommissionRuleArgs = {
  input: CreateCommissionRuleInput;
  rates: Array<CommissionRuleRateInput>;
};


export type MutationCreateCommissionTypeConfigArgs = {
  input: CreateCommissionTypeInput;
};


export type MutationCreateContractArgs = {
  input: CreateContractInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationCreateDeviceTypeArgs = {
  input: CreateDeviceTypeInput;
};


export type MutationCreateDigitalChannelArgs = {
  input: CreateDigitalChannelInput;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateEmployeeBenefitArgs = {
  employeeId: Scalars['ID']['input'];
  input: CreateEmployeeBenefitInput;
};


export type MutationCreateEmployeeFromHireArgs = {
  applicationId: Scalars['ID']['input'];
  input?: InputMaybe<CreateEmployeeFromHireInput>;
};


export type MutationCreateEsgBeneficiaryArgs = {
  input: CreateEsgBeneficiaryInput;
  programmeId: Scalars['ID']['input'];
};


export type MutationCreateEsgOutcomeArgs = {
  input: CreateEsgOutcomeInput;
  programmeId: Scalars['ID']['input'];
};


export type MutationCreateEsgProgrammeArgs = {
  input: CreateEsgProgrammeInput;
};


export type MutationCreateEsgSpendArgs = {
  input: CreateEsgSpendInput;
  programmeId: Scalars['ID']['input'];
};


export type MutationCreateEsgVolunteeringArgs = {
  input: CreateEsgVolunteeringInput;
  programmeId: Scalars['ID']['input'];
};


export type MutationCreateFaultCategoryArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateFaultSubTypeArgs = {
  faultTypeId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateFaultTypeArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateGrievanceArgs = {
  input: CreateGrievanceInput;
};


export type MutationCreateHrCaseArgs = {
  input: CreateHrCaseInput;
};


export type MutationCreateImprovementPlanArgs = {
  input: CreateImprovementPlanInput;
};


export type MutationCreateItemCategoryArgs = {
  input: CreateItemCategoryInput;
};


export type MutationCreateJobApplicationArgs = {
  input: CreateJobApplicationInput;
};


export type MutationCreateJobPositionArgs = {
  input: JobPositionInput;
};


export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


export type MutationCreateLeadSourceArgs = {
  input: CreateLeadSourceInput;
};


export type MutationCreateLeadStatusArgs = {
  input: CreateLeadStatusInput;
};


export type MutationCreateLearningProgrammeArgs = {
  input: CreateLearningProgrammeInput;
};


export type MutationCreateLeaveBalanceArgs = {
  employeeId: Scalars['ID']['input'];
  input: CreateLeaveBalanceInput;
  leaveTypeId: Scalars['ID']['input'];
};


export type MutationCreateLeaveRequestArgs = {
  input: CreateLeaveRequestInput;
};


export type MutationCreateManualCommissionArgs = {
  input: CreateManualCommissionInput;
};


export type MutationCreateModuleArgs = {
  input: CreateModuleInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePartArgs = {
  input: PartInput;
};


export type MutationCreatePayRunArgs = {
  input: CreatePayRunInput;
};


export type MutationCreatePayslipArgs = {
  employeeId: Scalars['ID']['input'];
  input: PayslipInput;
  payRunId: Scalars['ID']['input'];
};


export type MutationCreatePerformanceReviewArgs = {
  input: CreatePerformanceReviewInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductBrandArgs = {
  input: CreateProductBrandInput;
};


export type MutationCreateProductCategoryArgs = {
  input: CreateProductCategoryInput;
};


export type MutationCreatePurchaseOrderArgs = {
  input: CreatePurchaseOrderInput;
};


export type MutationCreateRatePlanArgs = {
  input: CreateRatePlanInput;
};


export type MutationCreateReviewCycleArgs = {
  input: ReviewCycleInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSafetyCorrectiveActionArgs = {
  incidentId: Scalars['ID']['input'];
  input: CreateSafetyCorrectiveActionInput;
};


export type MutationCreateSafetyIncidentArgs = {
  input: CreateSafetyIncidentInput;
};


export type MutationCreateSafetyInspectionArgs = {
  input: CreateSafetyInspectionInput;
};


export type MutationCreateSalesRegionArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateShippingCompanyArgs = {
  input: CreateShippingCompanyInput;
};


export type MutationCreateSmsCampaignArgs = {
  input: SmsCampaignDraftInput;
};


export type MutationCreateStockTransferArgs = {
  input: CreateStockTransferInput;
};


export type MutationCreateStockTransferFromSerialsArgs = {
  input: CreateStockTransferFromSerialsInput;
};


export type MutationCreateStockTypeArgs = {
  input: CreateStockTypeInput;
};


export type MutationCreateStockingPointArgs = {
  input: CreateStockingPointInput;
};


export type MutationCreateSubcontractorArgs = {
  input: CreateSubcontractorInput;
};


export type MutationCreateSubcontractorComplianceDocumentArgs = {
  input: CreateSubcontractorComplianceInput;
  subcontractorId: Scalars['ID']['input'];
};


export type MutationCreateSubcontractorHoursArgs = {
  input: CreateSubcontractorHoursInput;
  workerId: Scalars['ID']['input'];
};


export type MutationCreateSubcontractorInvoiceArgs = {
  input: CreateSubcontractorInvoiceInput;
  subcontractorId: Scalars['ID']['input'];
};


export type MutationCreateSubcontractorWorkerArgs = {
  input: CreateSubcontractorWorkerInput;
  subcontractorId: Scalars['ID']['input'];
};


export type MutationCreateSupplierArgs = {
  input: CreateSupplierInput;
};


export type MutationCreateTeamArgs = {
  input: TeamInput;
};


export type MutationCreateThirdPartyCredentialArgs = {
  input: CreateThirdPartyCredentialInput;
};


export type MutationCreateTrainingCertificationArgs = {
  input: CreateTrainingCertificationInput;
};


export type MutationCreateTrainingCourseArgs = {
  input: TrainingCourseInput;
};


export type MutationCreateTrainingSessionArgs = {
  input: CreateTrainingSessionInput;
};


export type MutationCreateUnitOfMeasureArgs = {
  input: CreateUnitOfMeasureInput;
};


export type MutationCreateVacancyArgs = {
  input: CreateVacancyInput;
};


export type MutationCreateWebhookSubscriptionArgs = {
  input: CreateWebhookSubscriptionInput;
};


export type MutationDeactivateAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeactivateCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDecideLeaveRequestArgs = {
  approve: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeclineAgentAgreementArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDeleteAgentCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAttendanceRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBusinessLineArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommissionRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommissionTypeConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDeviceTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDigitalChannelArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmployeeBenefitArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEsgBeneficiaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEsgOutcomeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEsgProgrammeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEsgSpendArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEsgVolunteeringArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFaultCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFaultSubTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFaultTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteItemCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteJobApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobPositionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLeadSourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLeadStatusArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLeaveBalanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteModuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePayRunArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePayslipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductBrandArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProductCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRatePlanArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRecruitmentCostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReviewCycleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSafetyCorrectiveActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSafetyIncidentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSafetyInspectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSalesRegionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSmsCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStockTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSubcontractorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubcontractorComplianceDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubcontractorHoursArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubcontractorInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubcontractorWorkerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteThirdPartyCredentialArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTrainingCertificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTrainingCourseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTrainingSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUnitOfMeasureArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVacancyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWebhookSubscriptionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDispatchStockTransferArgs = {
  id: Scalars['String']['input'];
};


export type MutationEndEmploymentArgs = {
  id: Scalars['ID']['input'];
  input: EndEmploymentInput;
};


export type MutationFinalisePayRunArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFlagContractForRepossessionArgs = {
  input: FlagForRepossessionInput;
};


export type MutationFlagStockSaleAsBadArgs = {
  input: FlagStockSaleAsBadInput;
};


export type MutationGenerateTestTokenArgs = {
  days: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type MutationGenerateTokenArgs = {
  input: GenerateTokenInput;
};


export type MutationIgnorePayAtRowsArgs = {
  rowIds: Array<Scalars['String']['input']>;
};


export type MutationImportAttendanceArgs = {
  csv: Scalars['String']['input'];
};


export type MutationImportPayslipsArgs = {
  csv: Scalars['String']['input'];
  periodMonth: Scalars['DateTime']['input'];
};


export type MutationImportSubcontractorHoursArgs = {
  csv: Scalars['String']['input'];
  subcontractorId: Scalars['ID']['input'];
};


export type MutationIssueAgentAgreementArgs = {
  agentId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIssueContractAccessoriesArgs = {
  input: IssueContractAccessoriesInput;
};


export type MutationLinkPartRequestArgs = {
  id: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};


export type MutationLockContractDevicesArgs = {
  contractId: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  stockSaleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLogRedactedFieldAccessArgs = {
  customerId: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMarkCommissionRunPaidArgs = {
  input: MarkCommissionRunPaidInput;
};


export type MutationMarkCommissionsPaidArgs = {
  input: MarkCommissionsPaidInput;
};


export type MutationMarkCustomerDelinquentArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkPurchaseOrderInTransitArgs = {
  id: Scalars['String']['input'];
};


export type MutationMatchPayAtRowArgs = {
  paymentIds: Array<Scalars['String']['input']>;
  rowId: Scalars['String']['input'];
};


export type MutationMoveJobApplicationArgs = {
  id: Scalars['ID']['input'];
  input: MoveJobApplicationInput;
};


export type MutationOnboardUpgradeArgs = {
  input: OnboardUpgradeInput;
};


export type MutationOpenStockTakeArgs = {
  input: OpenStockTakeInput;
};


export type MutationProcessBankStatementArgs = {
  batchId: Scalars['String']['input'];
  weekStarts?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationProcessBankStatementsArgs = {
  batchIds: Array<Scalars['String']['input']>;
  weekStarts: Array<Scalars['String']['input']>;
};


export type MutationProcessWarrantyReplacementArgs = {
  input: WarrantyReplacementInput;
};


export type MutationRaisePartRequestArgs = {
  input: RaisePartRequestInput;
};


export type MutationReactivateAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationReactivateCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationReallocatePaymentArgs = {
  input: ReallocatePaymentInput;
};


export type MutationReassignContractDeviceArgs = {
  input: ReassignContractDeviceInput;
};


export type MutationReassignLeadArgs = {
  assignedToId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationReceiveAtWorkshopArgs = {
  input: ReceiveAtWorkshopInput;
};


export type MutationReceivePartRequestArgs = {
  id: Scalars['ID']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReceivePartsArgs = {
  input: PartMovementInput;
};


export type MutationReceivePurchaseOrderLinesArgs = {
  id: Scalars['String']['input'];
  lines: Array<ReceivePurchaseOrderLineInput>;
};


export type MutationReceiveStockImportArgs = {
  batchId: Scalars['String']['input'];
  courierOverrideReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecheckPayAtRowArgs = {
  rowId: Scalars['String']['input'];
};


export type MutationReconcileBankStatementRowArgs = {
  input: ReconcileBankStatementRowInput;
};


export type MutationRecordContractRepossessionArgs = {
  input: RecordRepossessionInput;
};


export type MutationRecordEmployeeMovementArgs = {
  input: RecordEmployeeMovementInput;
};


export type MutationRecordPayAtRowPaymentArgs = {
  rowId: Scalars['String']['input'];
};


export type MutationRecordStockSaleArgs = {
  input: RecordStockSaleInput;
};


export type MutationRecordTokenTestVerdictArgs = {
  accepted: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRedactNoteArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRefreshShipmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRegisterDeviceAtWorkshopArgs = {
  input: RegisterDeviceAtWorkshopInput;
};


export type MutationRejectAgentAgreementArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectBankVerificationArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectPartRequestArgs = {
  id: Scalars['ID']['input'];
  resolutionNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReleaseDeviceArgs = {
  input: ReleaseDeviceInput;
};


export type MutationReleaseFromWorkshopArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReleaseFromWorkshopManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRemoveAgentFromStockingPointArgs = {
  agentId: Scalars['String']['input'];
  stockingPointId: Scalars['String']['input'];
};


export type MutationRemoveCandidateCvArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationRemoveCommissionApproachChangeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveEsgSpendEvidenceArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationRemoveFaultAlertRecipientArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveFromMailingListArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveHrCaseDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSafetyIncidentEvidenceArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationRemoveSmsOptOutArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRemoveStockTakeScanArgs = {
  stockTakeUnitId: Scalars['String']['input'];
};


export type MutationRemoveSubcontractorComplianceFileArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationRemoveTrainingCertificateDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromDepartmentArgs = {
  departmentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveUserFromRoleArgs = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveUserPermissionOverrideArgs = {
  action: Scalars['String']['input'];
  moduleCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveWorkshopMemberArgs = {
  stockingPointId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveWriteOffReportRecipientArgs = {
  id: Scalars['String']['input'];
};


export type MutationRenameSalesRegionArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameStockingPointArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationReopenContractArgs = {
  input: ReopenContractInput;
};


export type MutationReopenGrievanceArgs = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationReopenPayRunArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReorderItemCategoriesArgs = {
  orderedIds: Array<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReorderStockingPointsArgs = {
  orderedIds: Array<Scalars['ID']['input']>;
};


export type MutationReplaceAgentArgs = {
  id: Scalars['String']['input'];
  replacementAgentId: Scalars['String']['input'];
};


export type MutationRequestAgentAgreementInfoArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRequestBankVerificationInfoArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestPhoneNumberUpdateArgs = {
  customerId: Scalars['String']['input'];
  newPhone: Scalars['String']['input'];
};


export type MutationRequestUpgradeOnboardingArgs = {
  input: RequestUpgradeOnboardingInput;
};


export type MutationResendContractPaymentNumberSmsArgs = {
  contractId: Scalars['ID']['input'];
  phoneOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendDeviceUnlockSmsArgs = {
  deviceControlActionId: Scalars['ID']['input'];
  phoneOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendFailedSmsCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationResendPhoneNumberUpdateOtpArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationResendTokenSmsArgs = {
  paymentTransactionId: Scalars['String']['input'];
  phoneOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendWebhookDeliveryArgs = {
  deliveryId: Scalars['String']['input'];
};


export type MutationResetItemCategoryOrderArgs = {
  parentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResolveDisputeArgs = {
  input: ResolveDisputeInput;
};


export type MutationResolveGrievanceArgs = {
  id: Scalars['ID']['input'];
  outcome: Scalars['String']['input'];
  resolutionNotes: Scalars['String']['input'];
};


export type MutationRestoreCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreMemberArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRestoreNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreStockItemsArgs = {
  input: RestoreStockItemsInput;
};


export type MutationResumeSmsCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrySalesAppMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryXeroOperationArgs = {
  logId: Scalars['String']['input'];
};


export type MutationReturnContractAccessoryArgs = {
  input: ReturnContractAccessoryInput;
};


export type MutationReturnPartsArgs = {
  input: PartMovementInput;
};


export type MutationReverseStockImportArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationReviewAgentInviteApprovalArgs = {
  id: Scalars['String']['input'];
  input: ReviewAgentInviteInput;
};


export type MutationReviewApprovalRequestArgs = {
  id: Scalars['String']['input'];
  input: ReviewApprovalInput;
};


export type MutationReviewPermissionChangeRequestArgs = {
  decision: PermissionRequestDecision;
  id: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReviewReturnToHeadOfficeArgs = {
  id: Scalars['String']['input'];
  input: ReviewReturnToHeadOfficeInput;
};


export type MutationRevokeApiConsumerArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeThirdPartyCredentialArgs = {
  id: Scalars['String']['input'];
};


export type MutationRotateApiConsumerSecretArgs = {
  id: Scalars['String']['input'];
};


export type MutationRotateWebhookSubscriptionSecretArgs = {
  id: Scalars['String']['input'];
};


export type MutationRunCommissionsArgs = {
  input: RunCommissionInput;
};


export type MutationSaveJobOfferArgs = {
  applicationId: Scalars['ID']['input'];
  input: JobOfferInput;
};


export type MutationScanStockTakeUnitArgs = {
  serial: Scalars['String']['input'];
  stockTakeId: Scalars['String']['input'];
};


export type MutationScheduleCommissionApproachArgs = {
  input: ScheduleCommissionApproachInput;
};


export type MutationScrapDeviceArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSendBackStockTakeArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSendGrievanceMessageArgs = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSendInviteArgs = {
  input: SendInviteInput;
};


export type MutationSendPartRequestArgs = {
  id: Scalars['ID']['input'];
  input: SourcePartRequestInput;
};


export type MutationSendSalesAppMessageArgs = {
  input: SendSalesAppMessageInput;
};


export type MutationSendSmsCampaignArgs = {
  id: Scalars['ID']['input'];
  input: SendSmsCampaignInput;
};


export type MutationSendSmsCampaignTestArgs = {
  body: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationSetApiKeyInboundSignatureArgs = {
  id: Scalars['String']['input'];
  input: SetInboundSignatureInput;
};


export type MutationSetDepartmentAdminArgs = {
  departmentId: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSetDepartmentDefaultRolesArgs = {
  departmentId: Scalars['String']['input'];
  roleIds: Array<Scalars['String']['input']>;
};


export type MutationSetMailingListScheduleArgs = {
  input: SetMailingListScheduleInput;
};


export type MutationSetNotePinnedArgs = {
  id: Scalars['String']['input'];
  pinned: Scalars['Boolean']['input'];
};


export type MutationSetNoteVisibilityArgs = {
  id: Scalars['String']['input'];
  visibility: NoteVisibility;
};


export type MutationSetPayAtRowAccountArgs = {
  accountNumber: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
};


export type MutationSetProbationArgs = {
  employmentId: Scalars['ID']['input'];
  input: ProbationInput;
};


export type MutationSetRoleGrantsArgs = {
  grantableRoleIds: Array<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};


export type MutationSetStockingPointActiveArgs = {
  id: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSetStockingPointProductMinimumArgs = {
  minimumStockLevel: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  stockingPointId: Scalars['String']['input'];
};


export type MutationSetUserPermissionArgs = {
  action: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  granted: Scalars['Boolean']['input'];
  moduleCode: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationSetUserPermissionOverrideArgs = {
  action: Scalars['String']['input'];
  granted: Scalars['Boolean']['input'];
  moduleCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSetWorkshopJobIntakeReasonArgs = {
  id: Scalars['ID']['input'];
  intakeReason: WorkshopJobIntakeReason;
};


export type MutationSetupDeviceMeterArgs = {
  input: SetupDeviceMeterInput;
};


export type MutationSignMyAgentAgreementArgs = {
  input: SignAgreementInput;
};


export type MutationStartAgentAgreementReviewArgs = {
  id: Scalars['String']['input'];
};


export type MutationStartBankVerificationReviewArgs = {
  id: Scalars['String']['input'];
};


export type MutationStartEmploymentArgs = {
  employeeId: Scalars['ID']['input'];
  input: EmploymentInput;
};


export type MutationStopSmsCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitReturnToHeadOfficeArgs = {
  input: SubmitReturnToHeadOfficeInput;
};


export type MutationSubmitStockTakeArgs = {
  id: Scalars['String']['input'];
};


export type MutationSuspendCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationSwapContractDevicesArgs = {
  input: SwapContractDevicesInput;
};


export type MutationSyncCustomerToXeroArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationToggleCommissionRuleActiveArgs = {
  id: Scalars['String']['input'];
};


export type MutationToggleModuleArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationUnflagStockSaleArgs = {
  input: UnflagStockSaleInput;
};


export type MutationUnignorePayAtRowArgs = {
  rowId: Scalars['String']['input'];
};


export type MutationUnlockContractDevicesArgs = {
  contractId: Scalars['ID']['input'];
  stockSaleId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUnmatchPayAtRowArgs = {
  rowId: Scalars['String']['input'];
};


export type MutationUnreconcileBankStatementRowArgs = {
  rowId: Scalars['String']['input'];
};


export type MutationUpdateAgentArgs = {
  id: Scalars['String']['input'];
  input: UpdateAgentInput;
};


export type MutationUpdateAgentCategoryArgs = {
  id: Scalars['String']['input'];
  input: UpdateAgentCategoryInput;
};


export type MutationUpdateApplicationArgs = {
  id: Scalars['String']['input'];
  input: UpdateApplicationInput;
};


export type MutationUpdateAttendanceRecordArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAttendanceRecordInput;
};


export type MutationUpdateBankStatementRowArgs = {
  input: UpdateBankStatementRowInput;
};


export type MutationUpdateBusinessLineArgs = {
  id: Scalars['String']['input'];
  input: UpdateBusinessLineInput;
};


export type MutationUpdateCandidateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCandidateInput;
};


export type MutationUpdateCommissionPolicyArgs = {
  input: UpdateCommissionPolicyInput;
};


export type MutationUpdateCommissionRuleArgs = {
  input: UpdateCommissionRuleInput;
  rates?: InputMaybe<Array<CommissionRuleRateInput>>;
};


export type MutationUpdateCommissionTypeConfigArgs = {
  input: UpdateCommissionTypeInput;
};


export type MutationUpdateContractArgs = {
  id: Scalars['String']['input'];
  input: UpdateContractInput;
};


export type MutationUpdateCustomerArgs = {
  id: Scalars['String']['input'];
  input: UpdateCustomerInput;
};


export type MutationUpdateDelinquencyPolicyArgs = {
  input: UpdateDelinquencyPolicyInput;
};


export type MutationUpdateDepartmentArgs = {
  id: Scalars['String']['input'];
  input: UpdateDepartmentInput;
};


export type MutationUpdateDeviceArgs = {
  input: UpdateDeviceInput;
};


export type MutationUpdateDeviceMeterArgs = {
  input: UpdateDeviceMeterInput;
};


export type MutationUpdateDeviceTypeArgs = {
  id: Scalars['String']['input'];
  input: UpdateDeviceTypeInput;
};


export type MutationUpdateDigitalChannelArgs = {
  id: Scalars['String']['input'];
  input: UpdateDigitalChannelInput;
};


export type MutationUpdateEmployeeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeInput;
  movement?: InputMaybe<MovementDetailsInput>;
};


export type MutationUpdateEmployeeBenefitArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeBenefitInput;
};


export type MutationUpdateEmployeeDemographicsArgs = {
  employeeId: Scalars['ID']['input'];
  input: EmployeeDemographicsInput;
  movement?: InputMaybe<MovementDetailsInput>;
};


export type MutationUpdateEmploymentArgs = {
  id: Scalars['ID']['input'];
  input: EmploymentInput;
  movement?: InputMaybe<MovementDetailsInput>;
};


export type MutationUpdateEsgBeneficiaryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEsgBeneficiaryInput;
};


export type MutationUpdateEsgOutcomeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEsgOutcomeInput;
};


export type MutationUpdateEsgProgrammeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEsgProgrammeInput;
};


export type MutationUpdateEsgSpendArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEsgSpendInput;
};


export type MutationUpdateEsgVolunteeringArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEsgVolunteeringInput;
};


export type MutationUpdateFaultCategoryArgs = {
  id: Scalars['ID']['input'];
  input: TaxonomyEntryUpdateInput;
};


export type MutationUpdateFaultSubTypeArgs = {
  id: Scalars['ID']['input'];
  input: TaxonomyEntryUpdateInput;
};


export type MutationUpdateFaultTypeArgs = {
  id: Scalars['ID']['input'];
  input: TaxonomyEntryUpdateInput;
};


export type MutationUpdateGrievanceSettingsArgs = {
  input: UpdateGrievanceSettingsInput;
};


export type MutationUpdateGrievanceStatusArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  toStatus: GrievanceStatusChange;
};


export type MutationUpdateHrCaseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHrCaseInput;
};


export type MutationUpdateImprovementPlanArgs = {
  id: Scalars['ID']['input'];
  input: UpdateImprovementPlanInput;
};


export type MutationUpdateItemCategoryArgs = {
  id: Scalars['String']['input'];
  input: UpdateItemCategoryInput;
};


export type MutationUpdateJobPositionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobPositionInput;
};


export type MutationUpdateLeadArgs = {
  id: Scalars['String']['input'];
  input: UpdateLeadInput;
};


export type MutationUpdateLeadSourceArgs = {
  id: Scalars['String']['input'];
  input: UpdateLeadSourceInput;
};


export type MutationUpdateLeadStatusArgs = {
  id: Scalars['String']['input'];
  input: UpdateLeadStatusInput;
};


export type MutationUpdateLearningProgrammeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLearningProgrammeInput;
};


export type MutationUpdateLeaveBalanceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeaveBalanceInput;
};


export type MutationUpdateLeaveTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeaveTypeInput;
};


export type MutationUpdateMinimumStockLevelArgs = {
  id: Scalars['String']['input'];
  minimumStockLevel: Scalars['Int']['input'];
};


export type MutationUpdateModuleArgs = {
  id: Scalars['String']['input'];
  input: UpdateModuleInput;
};


export type MutationUpdateMyBankingDetailsArgs = {
  input: UpdateMyBankingInput;
};


export type MutationUpdateNoteArgs = {
  id: Scalars['String']['input'];
  input: UpdateNoteInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdatePartArgs = {
  id: Scalars['ID']['input'];
  input: PartInput;
};


export type MutationUpdatePayRunArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePayRunInput;
};


export type MutationUpdatePaymentRatingPolicyArgs = {
  input: UpdatePaymentRatingPolicyInput;
};


export type MutationUpdatePayslipArgs = {
  id: Scalars['ID']['input'];
  input: PayslipInput;
};


export type MutationUpdatePerformanceReviewArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePerformanceReviewInput;
};


export type MutationUpdateProductArgs = {
  id: Scalars['String']['input'];
  input: UpdateProductInput;
};


export type MutationUpdateProductBrandArgs = {
  id: Scalars['String']['input'];
  input: UpdateProductBrandInput;
};


export type MutationUpdateProductCategoryArgs = {
  id: Scalars['String']['input'];
  input: UpdateProductCategoryInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdatePurchaseOrderPlanArgs = {
  id: Scalars['String']['input'];
  input: UpdatePurchaseOrderPlanInput;
};


export type MutationUpdatePurchaseOrderShippingArgs = {
  id: Scalars['String']['input'];
  input: ShippingDetailsInput;
};


export type MutationUpdateRatePlanArgs = {
  id: Scalars['String']['input'];
  input: UpdateRatePlanInput;
};


export type MutationUpdateReallocationPolicyArgs = {
  input: UpdateReallocationPolicyInput;
};


export type MutationUpdateRecruitmentCostArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRecruitmentCostInput;
};


export type MutationUpdateReviewCycleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateReviewCycleInput;
};


export type MutationUpdateRoleArgs = {
  id: Scalars['String']['input'];
  input: UpdateRoleInput;
};


export type MutationUpdateRolePermissionsArgs = {
  permissions: Array<RolePermissionInput>;
  roleId: Scalars['String']['input'];
};


export type MutationUpdateSafetyCorrectiveActionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSafetyCorrectiveActionInput;
};


export type MutationUpdateSafetyIncidentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSafetyIncidentInput;
};


export type MutationUpdateSafetyInspectionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSafetyInspectionInput;
};


export type MutationUpdateShippingCompanyArgs = {
  id: Scalars['String']['input'];
  input: UpdateShippingCompanyInput;
};


export type MutationUpdateSmsCampaignArgs = {
  id: Scalars['ID']['input'];
  input: SmsCampaignDraftInput;
};


export type MutationUpdateStockTransferShippingArgs = {
  id: Scalars['String']['input'];
  input: ShippingDetailsInput;
};


export type MutationUpdateStockTypeArgs = {
  id: Scalars['String']['input'];
  input: UpdateStockTypeInput;
};


export type MutationUpdateStockingPointArgs = {
  id: Scalars['String']['input'];
  input: UpdateStockingPointInput;
};


export type MutationUpdateSubcontractorArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorInput;
};


export type MutationUpdateSubcontractorComplianceDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorComplianceInput;
};


export type MutationUpdateSubcontractorHoursArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorHoursInput;
};


export type MutationUpdateSubcontractorInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorInvoiceInput;
};


export type MutationUpdateSubcontractorWorkerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorWorkerInput;
};


export type MutationUpdateSupplierArgs = {
  id: Scalars['String']['input'];
  input: UpdateSupplierInput;
};


export type MutationUpdateTeamArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTeamInput;
};


export type MutationUpdateThirdPartyCredentialArgs = {
  id: Scalars['String']['input'];
  input: UpdateThirdPartyCredentialInput;
};


export type MutationUpdateTrainingCertificationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTrainingCertificationInput;
};


export type MutationUpdateTrainingCourseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTrainingCourseInput;
};


export type MutationUpdateTrainingSessionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTrainingSessionInput;
};


export type MutationUpdateUnitOfMeasureArgs = {
  id: Scalars['String']['input'];
  input: UpdateUnitOfMeasureInput;
};


export type MutationUpdateVacancyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVacancyInput;
};


export type MutationUpdateWebhookSubscriptionArgs = {
  id: Scalars['String']['input'];
  input: UpdateWebhookSubscriptionInput;
};


export type MutationUpdateWorkshopPolicyArgs = {
  input: UpdateWorkshopPolicyInput;
};


export type MutationUsePartsArgs = {
  input: PartMovementInput;
};


export type MutationValidateInviteArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyPhoneNumberUpdateOtpArgs = {
  otp: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationWithdrawReturnToHeadOfficeArgs = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWriteOffContractArgs = {
  input: WriteOffContractInput;
};

export type MyRunningCommission = {
  __typename?: 'MyRunningCommission';
  /** Whether the month in progress is worked out As Collected. False after a switch back, while only last month's figure is shown. */
  collected: Scalars['Boolean']['output'];
  /** The caller's own figure for the month in progress; null until it has been worked out. */
  current?: Maybe<RunningCommissionFigure>;
  /** The month in progress. */
  periodDate: Scalars['DateTime']['output'];
  /** Last month's figure while its run has not happened yet; null otherwise. */
  previous?: Maybe<RunningCommissionFigure>;
  /** For a distributor, each agent directly under them this month, highest first; empty for anybody else. */
  team: Array<RunningCommissionFigure>;
};

/** A new distributor of the month and what became of their Solar Management Fee (ADR-0084): the pack's Fee Review sheet, row for row. */
export type NewDistributorFee = {
  __typename?: 'NewDistributorFee';
  agentId: Scalars['String']['output'];
  agentName: Scalars['String']['output'];
  amountCents: Scalars['Int']['output'];
  amountRands: Scalars['Float']['output'];
  daysCounted: Scalars['Int']['output'];
  daysInMonth: Scalars['Int']['output'];
  /** The fee's entry, to approve or reject; null when there was nothing to pay. */
  entryId?: Maybe<Scalars['String']['output']>;
  firstSaleAt?: Maybe<Scalars['DateTime']['output']>;
  firstStockAt?: Maybe<Scalars['DateTime']['output']>;
  onboardedAt: Scalars['DateTime']['output'];
  reason: Scalars['String']['output'];
  status: FeeReviewStatus;
};

export type NewWorkshopDeviceInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  deviceTypeId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  stockTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type Note = {
  __typename?: 'Note';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  archivedReason?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canModerate?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<NoteCategory>;
  contract?: Maybe<Contract>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  customer?: Maybe<Customer>;
  format?: Maybe<NoteFormat>;
  id?: Maybe<Scalars['ID']['output']>;
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  isRedacted?: Maybe<Scalars['Boolean']['output']>;
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  pinnedBy?: Maybe<User>;
  redactedAt?: Maybe<Scalars['DateTime']['output']>;
  redactedBy?: Maybe<User>;
  redactedReason?: Maybe<Scalars['String']['output']>;
  revisionCount?: Maybe<Scalars['Int']['output']>;
  revisions?: Maybe<Array<NoteRevision>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visibility?: Maybe<NoteVisibility>;
};

export type NoteCategory = {
  __typename?: 'NoteCategory';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type NoteFormat =
  | 'PLAIN';

export type NoteListInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  includeContractNotes?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pinnedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<NoteVisibility>;
};

export type NoteListResult = {
  __typename?: 'NoteListResult';
  items: Array<Note>;
  restrictedHiddenCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type NoteRevision = {
  __typename?: 'NoteRevision';
  body?: Maybe<Scalars['String']['output']>;
  changeReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  format?: Maybe<NoteFormat>;
  id?: Maybe<Scalars['ID']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<NoteVisibility>;
};

export type NoteVisibility =
  | 'INTERNAL'
  | 'RESTRICTED';

export type Notification = {
  __typename?: 'Notification';
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type NotificationCount = {
  __typename?: 'NotificationCount';
  count?: Maybe<Scalars['Int']['output']>;
};

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Occupation =
  | 'BUSINESS'
  | 'DRIVER_MOTORBIKE_RIDER'
  | 'FARMER'
  | 'LABOURER'
  | 'OTHER'
  | 'TEACHER';

export type OnboardUpgradeInput = {
  contractId: Scalars['ID']['input'];
  credit?: InputMaybe<UpgradeCreditInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  sources: Array<UpgradeSourceInput>;
};

export type OpenOrderLine = {
  __typename?: 'OpenOrderLine';
  destinationId: Scalars['ID']['output'];
  destinationName: Scalars['String']['output'];
  expectedAt?: Maybe<Scalars['DateTime']['output']>;
  purchaseOrderId: Scalars['ID']['output'];
  purchaseOrderLineId: Scalars['ID']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  remaining: Scalars['Int']['output'];
  supplierName: Scalars['String']['output'];
};

export type OpenStockTakeInput = {
  countsUnits?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  stockingPointId: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Array<Department>>;
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legalAddress?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  logoBackground?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<User>>;
  modules?: Maybe<Array<Module>>;
  name?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  requireAgentInviteApproval: Scalars['Boolean']['output'];
  requireConfirmPassword?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Role>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Part = {
  __typename?: 'Part';
  businessLine?: Maybe<BusinessLine>;
  elsewhereQuantity: Scalars['Int']['output'];
  headOfficeQuantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  itemCategory?: Maybe<ItemCategory>;
  itemCategoryId?: Maybe<Scalars['String']['output']>;
  lastCostCents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  reorderLevelAt?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  totalQuantity: Scalars['Int']['output'];
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};


export type PartElsewhereQuantityArgs = {
  excludingStockingPointId?: InputMaybe<Scalars['String']['input']>;
};


export type PartReorderLevelAtArgs = {
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type PartInput = {
  businessLineId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryId?: InputMaybe<Scalars['String']['input']>;
  lastCostCents?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['String']['input']>;
};

export type PartMovementInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  stockingPointId: Scalars['String']['input'];
  workshopJobId?: InputMaybe<Scalars['String']['input']>;
};

export type PartRequest = {
  __typename?: 'PartRequest';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationStockingPoint: StockingPoint;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  part?: Maybe<Part>;
  purchaseOrderLine?: Maybe<PurchaseOrderLine>;
  quantity: Scalars['Int']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedBy?: Maybe<User>;
  reference?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<User>;
  resolutionNote?: Maybe<Scalars['String']['output']>;
  route?: Maybe<PartRequestRoute>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<User>;
  sourceStockingPoint?: Maybe<StockingPoint>;
  status: PartRequestStatus;
  stockTransfer?: Maybe<StockTransfer>;
  supplier?: Maybe<Supplier>;
  workshopJob?: Maybe<WorkshopJob>;
};

export type PartRequestListInput = {
  destinationStockingPointId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<PartRequestStatus>>;
  workshopJobId?: InputMaybe<Scalars['String']['input']>;
};

export type PartRequestListResult = {
  __typename?: 'PartRequestListResult';
  items: Array<PartRequest>;
  totalCount: Scalars['Int']['output'];
};

export type PartRequestRoute =
  | 'FROM_STOCK'
  | 'PURCHASE';

export type PartRequestStatus =
  | 'CANCELLED'
  | 'RECEIVED'
  | 'REJECTED'
  | 'REQUESTED'
  | 'SENT';

export type PayAtCandidateGroup = {
  __typename?: 'PayAtCandidateGroup';
  accountNumbers: Array<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
  contractNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  daysApart: Scalars['Float']['output'];
  grossCents: Scalars['Int']['output'];
  paidAt: Scalars['DateTime']['output'];
  paymentIds: Array<Scalars['String']['output']>;
  referenceCode: Scalars['String']['output'];
};

export type PayAtDump = {
  __typename?: 'PayAtDump';
  badLineCount: Scalars['Int']['output'];
  businessDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ingestedAt?: Maybe<Scalars['DateTime']['output']>;
  lineCount: Scalars['Int']['output'];
  matchedAt?: Maybe<Scalars['DateTime']['output']>;
  s3Key: Scalars['String']['output'];
  status: PayAtDumpStatus;
};

export type PayAtDumpListResult = {
  __typename?: 'PayAtDumpListResult';
  items: Array<PayAtDump>;
  totalCount: Scalars['Int']['output'];
};

export type PayAtDumpRow = {
  __typename?: 'PayAtDumpRow';
  accountNumber?: Maybe<Scalars['String']['output']>;
  claimedCents: Scalars['Int']['output'];
  contract?: Maybe<Contract>;
  dump: PayAtDump;
  feeCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  matchedAt?: Maybe<Scalars['DateTime']['output']>;
  matchedBy?: Maybe<Scalars['String']['output']>;
  payments: Array<PaymentTransaction>;
  rawReference: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  status: PayAtDumpRowStatus;
  store: Scalars['String']['output'];
  tenderType?: Maybe<Scalars['String']['output']>;
  tillDate: Scalars['DateTime']['output'];
  totalCents: Scalars['Int']['output'];
  varianceCents: Scalars['Int']['output'];
};

export type PayAtDumpRowFilterInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  dumpId?: InputMaybe<Scalars['String']['input']>;
  exceptionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<PayAtDumpRowStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayAtDumpRowListResult = {
  __typename?: 'PayAtDumpRowListResult';
  items: Array<PayAtDumpRow>;
  totalCount: Scalars['Int']['output'];
};

export type PayAtDumpRowStatus =
  | 'AMOUNT_DIFFERS'
  | 'IGNORED'
  | 'MATCHED'
  | 'MATCHED_SPLIT'
  | 'NO_PAYMENT'
  | 'NO_PAYMENT_IN_WINDOW'
  | 'PENDING'
  | 'PLACEHOLDER'
  | 'REMOVED'
  | 'SUPERSEDED'
  | 'UNKNOWN_ACCOUNT';

export type PayAtDumpStatus =
  | 'DISCOVERED'
  | 'FAILED'
  | 'INGESTED'
  | 'INGESTING';

/** What the Pay@ tills took over one period of a trend series. */
export type PayAtMoneyInPoint = {
  __typename?: 'PayAtMoneyInPoint';
  /** The next period's first till date — the window is half-open. */
  end: Scalars['Date']['output'];
  lines: Scalars['Int']['output'];
  /** The period's first till date. */
  start: Scalars['Date']['output'];
  totalCents: Scalars['Int']['output'];
};

export type PayAtReconciliationRunResult = {
  __typename?: 'PayAtReconciliationRunResult';
  failures: Array<Scalars['String']['output']>;
  stats: Array<PayAtReconciliationRunStat>;
};

export type PayAtReconciliationRunStat = {
  __typename?: 'PayAtReconciliationRunStat';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PayAtReconciliationStatusCount = {
  __typename?: 'PayAtReconciliationStatusCount';
  lines: Scalars['Int']['output'];
  status: PayAtDumpRowStatus;
  totalCents: Scalars['Int']['output'];
};

export type PayAtReconciliationSummary = {
  __typename?: 'PayAtReconciliationSummary';
  byStatus: Array<PayAtReconciliationStatusCount>;
  from: Scalars['DateTime']['output'];
  lines: Scalars['Int']['output'];
  to: Scalars['DateTime']['output'];
  totalCents: Scalars['Int']['output'];
};

export type PayAtRecordPaymentResult = {
  __typename?: 'PayAtRecordPaymentResult';
  paymentId: Scalars['String']['output'];
  rowId: Scalars['String']['output'];
};

export type PayRun = {
  __typename?: 'PayRun';
  finalisedAt?: Maybe<Scalars['DateTime']['output']>;
  finalisedBy?: Maybe<PayrollUser>;
  id: Scalars['ID']['output'];
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  lineCount: Scalars['Int']['output'];
  linesWithoutGross: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  periodMonth: Scalars['DateTime']['output'];
  source: HrDataSource;
  status: PayRunStatus;
  totalGross?: Maybe<Scalars['Float']['output']>;
};

export type PayRunDetail = {
  __typename?: 'PayRunDetail';
  payslips: Array<Payslip>;
  run: PayRun;
};

export type PayRunFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<PayRunStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayRunStatus =
  | 'DRAFT'
  | 'FINAL';

export type PaymentCallback = {
  __typename?: 'PaymentCallback';
  accountNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  paymentTransactionId?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** How a payment's `bankConfirmed` flag was proven. */
export type PaymentConfirmationSource =
  | 'BANK_STATEMENT'
  | 'PAYAT';

export type PaymentRating =
  | 'EXCELLENT'
  | 'FAIR'
  | 'GOOD'
  | 'HIGH_RISK'
  | 'POOR';

/** Per-org bands rating a customer's payment behaviour by the percentage of analysed days spent without credit. Each is an inclusive upper bound; above poorMaxPercent is High Risk. */
export type PaymentRatingPolicy = {
  __typename?: 'PaymentRatingPolicy';
  excellentMaxPercent: Scalars['Float']['output'];
  fairMaxPercent: Scalars['Float']['output'];
  goodMaxPercent: Scalars['Float']['output'];
  poorMaxPercent: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** One misrouted payment moved onto the contract it was meant for. */
export type PaymentReallocation = {
  __typename?: 'PaymentReallocation';
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creditRecoveryCancelledAt?: Maybe<Scalars['DateTime']['output']>;
  creditRecoveryPerPayment?: Maybe<Scalars['Int']['output']>;
  creditRecoveryRemaining?: Maybe<Scalars['Int']['output']>;
  creditRecoveryTotal?: Maybe<Scalars['Int']['output']>;
  destinationContract: Contract;
  destinationPayment?: Maybe<PaymentTransaction>;
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  performedBy: User;
  reason: PaymentReallocationReason;
  reversalPayment: PaymentTransaction;
  sourceContract: Contract;
  sourcePayment: PaymentTransaction;
  writeOffAmount?: Maybe<Scalars['Int']['output']>;
  writeOffReason?: Maybe<PaymentReallocationWriteOffReason>;
};

export type PaymentReallocationReason =
  | 'AMBIGUOUS_ACCOUNT_NUMBER'
  | 'BANK_STATEMENT_MISMATCH'
  | 'OPERATOR_KEYING_ERROR'
  | 'OTHER'
  | 'WRONG_ACCOUNT_NUMBER_QUOTED';

export type PaymentReallocationWarning = {
  __typename?: 'PaymentReallocationWarning';
  code: PaymentReallocationWarningCode;
  detail: Scalars['String']['output'];
};

export type PaymentReallocationWarningCode =
  | 'COST_RECOVERY_EXCEEDS_PAYMENT'
  | 'DESTINATION_CANNOT_ACCEPT_TOKEN'
  | 'DESTINATION_CONTRACT_NOT_ACTIVE'
  | 'NO_RECOVERABLE_DAYS'
  | 'RECOVERY_LEAVES_NO_DAYS'
  | 'SOURCE_CONTRACT_NOT_ACTIVE';

export type PaymentReallocationWriteOffReason =
  | 'CONTRACT_CLOSED'
  | 'CONTRACT_PAID_OFF'
  | 'CONTRACT_WRITTEN_OFF'
  | 'NO_RATE_TO_PRICE_FROM';

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  accountNumber: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  bankConfirmed: Scalars['Boolean']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  callbacks: Array<PaymentCallback>;
  confirmationRef?: Maybe<Scalars['String']['output']>;
  confirmationSource?: Maybe<PaymentConfirmationSource>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  contract?: Maybe<Contract>;
  contractId?: Maybe<Scalars['String']['output']>;
  countsTowardBalance: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  depositDeducted?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  reallocation?: Maybe<PaymentReallocation>;
  reason?: Maybe<Scalars['String']['output']>;
  referenceCode: Scalars['String']['output'];
  routingNote?: Maybe<Scalars['String']['output']>;
  systemType?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenDays?: Maybe<Scalars['Int']['output']>;
  tokenForPreviousDevice: Scalars['Boolean']['output'];
  tokenSequence?: Maybe<Scalars['Int']['output']>;
  type: PaymentType;
};

export type PaymentTransactionListInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  systemType?: InputMaybe<Scalars['String']['input']>;
  tokenStatus?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentTransactionListResult = {
  __typename?: 'PaymentTransactionListResult';
  items: Array<PaymentTransaction>;
  totalCount: Scalars['Int']['output'];
};

/** What kind of row a payment is. Only PAYMENT and REALLOCATION are money; a REISSUE, COMPENSATION or TEST carries days and counts for nothing. */
export type PaymentType =
  | 'COMPENSATION'
  | 'HELD_PAYMENT'
  | 'PAYMENT'
  | 'REALLOCATION'
  | 'REISSUE'
  | 'TEST';

export type PayrollDepartment = {
  __typename?: 'PayrollDepartment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PayrollEmployee = {
  __typename?: 'PayrollEmployee';
  department?: Maybe<PayrollDepartment>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type PayrollMetrics = {
  __typename?: 'PayrollMetrics';
  averageGross: HrMetric;
  benefitsCost: HrMetric;
  employeesPaid: HrMetric;
  from: Scalars['DateTime']['output'];
  genderPayGapMeanPercent: HrMetric;
  genderPayGapMedianPercent: HrMetric;
  medianGross: HrMetric;
  overtimeCostPercent: HrMetric;
  payrollCostPerEmployee: HrMetric;
  payrollGrowthPercent: HrMetric;
  to: Scalars['DateTime']['output'];
  totalGross: HrMetric;
  totalPayrollCost: HrMetric;
};

export type PayrollMetricsFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PayrollUser = {
  __typename?: 'PayrollUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type Payslip = {
  __typename?: 'Payslip';
  allowances?: Maybe<Scalars['Float']['output']>;
  basic?: Maybe<Scalars['Float']['output']>;
  deductions?: Maybe<Scalars['Float']['output']>;
  employee: PayrollEmployee;
  employerMedical?: Maybe<Scalars['Float']['output']>;
  employerPension?: Maybe<Scalars['Float']['output']>;
  gross?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  net?: Maybe<Scalars['Float']['output']>;
  overtimePay?: Maybe<Scalars['Float']['output']>;
  paye?: Maybe<Scalars['Float']['output']>;
  sdl?: Maybe<Scalars['Float']['output']>;
  source: HrDataSource;
  uifEmployee?: Maybe<Scalars['Float']['output']>;
  uifEmployer?: Maybe<Scalars['Float']['output']>;
};

export type PayslipInput = {
  allowances?: InputMaybe<Scalars['Float']['input']>;
  basic?: InputMaybe<Scalars['Float']['input']>;
  deductions?: InputMaybe<Scalars['Float']['input']>;
  employerMedical?: InputMaybe<Scalars['Float']['input']>;
  employerPension?: InputMaybe<Scalars['Float']['input']>;
  gross?: InputMaybe<Scalars['Float']['input']>;
  net?: InputMaybe<Scalars['Float']['input']>;
  overtimePay?: InputMaybe<Scalars['Float']['input']>;
  paye?: InputMaybe<Scalars['Float']['input']>;
  sdl?: InputMaybe<Scalars['Float']['input']>;
  uifEmployee?: InputMaybe<Scalars['Float']['input']>;
  uifEmployer?: InputMaybe<Scalars['Float']['input']>;
};

export type PendingInvite = {
  __typename?: 'PendingInvite';
  agentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invitedBy?: Maybe<Scalars['String']['output']>;
  isAgent?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
};

export type PerformanceFilterInput = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PerformanceMetrics = {
  __typename?: 'PerformanceMetrics';
  averageRating: HrMetric;
  byRating: Array<RatingCount>;
  cycleCount: Scalars['Int']['output'];
  from: Scalars['DateTime']['output'];
  highPerformerLeaverPercent: HrMetric;
  highPerformerLeavers: HrMetric;
  highPerformerPercent: HrMetric;
  improvementPlanSuccessRate: HrMetric;
  openImprovementPlans: HrMetric;
  probationPassRate: HrMetric;
  probationsEndingSoon: HrMetric;
  reviewCompletionRate: HrMetric;
  reviewsCompleted: HrMetric;
  reviewsExpected: HrMetric;
  to: Scalars['DateTime']['output'];
};

export type PerformancePerson = {
  __typename?: 'PerformancePerson';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type PerformanceReview = {
  __typename?: 'PerformanceReview';
  comments?: Maybe<Scalars['String']['output']>;
  cycle: ReviewCycleSummary;
  employee: PerformancePerson;
  id: Scalars['ID']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  reviewer?: Maybe<PerformanceReviewer>;
  status: PerformanceReviewStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PerformanceReviewStatus =
  | 'COMPLETED'
  | 'DRAFT'
  | 'SUBMITTED';

export type PerformanceReviewer = {
  __typename?: 'PerformanceReviewer';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PermissionChangeRequest = {
  __typename?: 'PermissionChangeRequest';
  affectedUserCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  kind?: Maybe<PermissionRequestKind>;
  requestedById?: Maybe<Scalars['String']['output']>;
  requestedByName?: Maybe<Scalars['String']['output']>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  sensitive?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<PermissionRequestStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  targetUserName?: Maybe<Scalars['String']['output']>;
};

export type PermissionRequestDecision =
  | 'APPROVED'
  | 'REJECTED';

export type PermissionRequestKind =
  | 'DEPARTMENT_MEMBERSHIP'
  | 'INVITE'
  | 'PERMISSION_EXCEPTION'
  | 'REMOVE_EXCEPTION'
  | 'RESTORE_MEMBER'
  | 'ROLE_ASSIGNMENT'
  | 'ROLE_PERMISSIONS';

export type PermissionRequestStatus =
  | 'APPROVED'
  | 'CANCELLED'
  | 'EXPIRED'
  | 'PENDING'
  | 'REJECTED';

export type PhoneNumberUpdateRequest = {
  __typename?: 'PhoneNumberUpdateRequest';
  attemptsRemaining: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiatedBy: User;
  maskedNewPhone: Scalars['String']['output'];
  maskedOldPhone?: Maybe<Scalars['String']['output']>;
  newPhone: Scalars['String']['output'];
  oldPhone?: Maybe<Scalars['String']['output']>;
  otpAttempts: Scalars['Int']['output'];
  resendCount: Scalars['Int']['output'];
  resendsRemaining: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PreviewReallocationInput = {
  destinationContractId: Scalars['String']['input'];
  paymentTransactionId: Scalars['String']['input'];
  recoveryInstalments?: InputMaybe<Scalars['Int']['input']>;
};

export type PreviewSellerCorrectionUploadInput = {
  contentBase64: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type PriorDefault = {
  __typename?: 'PriorDefault';
  at?: Maybe<Scalars['DateTime']['output']>;
  contractNumber: Scalars['String']['output'];
  status: ContractStatus;
};

export type Probation = {
  __typename?: 'Probation';
  effectiveEndDate: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  extendedTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<ProbationOutcome>;
};

export type ProbationInput = {
  endDate: Scalars['DateTime']['input'];
  extendedTo?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<ProbationOutcome>;
};

export type ProbationOutcome =
  | 'EXTENDED'
  | 'FAILED'
  | 'PASSED';

export type ProcessBankStatementResult = {
  __typename?: 'ProcessBankStatementResult';
  batchId: Scalars['String']['output'];
  failed: Array<BankStatementProcessFailure>;
  processed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type Product = {
  __typename?: 'Product';
  batteryKwh?: Maybe<Scalars['Float']['output']>;
  businessLine?: Maybe<BusinessLine>;
  businessLineId?: Maybe<Scalars['String']['output']>;
  canAcceptToken?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  itemCategory?: Maybe<ItemCategory>;
  itemCategoryId?: Maybe<Scalars['String']['output']>;
  kind: ProductKind;
  lastCostCents?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  panelEfficiency?: Maybe<Scalars['Float']['output']>;
  panelWatts?: Maybe<Scalars['Int']['output']>;
  productBrand?: Maybe<ProductBrand>;
  productBrandId?: Maybe<Scalars['String']['output']>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryId?: Maybe<Scalars['String']['output']>;
  requiresSerialTracking?: Maybe<Scalars['Boolean']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  stockItems?: Maybe<Array<StockItem>>;
  systemEfficiency?: Maybe<Scalars['Float']['output']>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
  unitOfMeasureId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductBrand = {
  __typename?: 'ProductBrand';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductKind =
  | 'ACCESSORY'
  | 'DEVICE'
  | 'PART';

export type ProductListInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kinds?: InputMaybe<Array<ProductKind>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productCategoryId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  unclassified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductListResult = {
  __typename?: 'ProductListResult';
  items: Array<Product>;
  totalCount: Scalars['Int']['output'];
};

/** Units sold of one product: completed sales, warranty swaps excluded. */
export type ProductSales = {
  __typename?: 'ProductSales';
  name: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  units: Scalars['Int']['output'];
};

export type Province = {
  __typename?: 'Province';
  districtMunicipalities?: Maybe<Array<DistrictMunicipality>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  contentType?: Maybe<PurchaseOrderContentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  destination?: Maybe<StockingPoint>;
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<StockItem>>;
  lines: Array<PurchaseOrderLine>;
  notes?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  poNumber?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  shipment?: Maybe<Shipment>;
  shippingCompany?: Maybe<ShippingCompany>;
  status?: Maybe<PurchaseOrderStatus>;
  stockType?: Maybe<PurchaseOrderStockType>;
  supplier?: Maybe<Supplier>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  waybillReference?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderContentType =
  | 'PRODUCTS_AND_PARTS'
  | 'PRODUCTS_ONLY';

export type PurchaseOrderItemInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber: Scalars['String']['input'];
};

export type PurchaseOrderLine = {
  __typename?: 'PurchaseOrderLine';
  id: Scalars['ID']['output'];
  product: Product;
  purchaseOrder: PurchaseOrder;
  quantity: Scalars['Int']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedBy?: Maybe<User>;
  receivedQuantity?: Maybe<Scalars['Int']['output']>;
  unitCostCents?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseOrderLineInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  unitCostCents?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseOrderListInput = {
  awaitingReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  destinationId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PurchaseOrderStatus>>;
};

export type PurchaseOrderListResult = {
  __typename?: 'PurchaseOrderListResult';
  items: Array<PurchaseOrder>;
  totalCount: Scalars['Int']['output'];
};

export type PurchaseOrderStatus =
  | 'CANCELLED'
  | 'CLOSED'
  | 'GENERATED'
  | 'IN_TRANSIT';

export type PurchaseOrderStockType =
  | 'NEW_STOCK'
  | 'REPLACEMENT_STOCK';

export type Query = {
  __typename?: 'Query';
  _health?: Maybe<Scalars['String']['output']>;
  activePhoneNumberUpdateRequest?: Maybe<PhoneNumberUpdateRequest>;
  agent?: Maybe<Agent>;
  agentAgreement?: Maybe<AgentAgreement>;
  agentAgreements?: Maybe<AgentAgreementListResult>;
  agentCategories?: Maybe<Array<AgentCategory>>;
  agentCategory?: Maybe<AgentCategory>;
  agentCommissionSummary?: Maybe<AgentCommissionSummary>;
  agentDisputeCount: Scalars['Int']['output'];
  agentDisputeResolutions?: Maybe<Array<DisputeResolution>>;
  agentDisputes?: Maybe<Array<Agent>>;
  agentInviteApprovalCounts: Array<AgentInviteApprovalCount>;
  agentInviteApprovals?: Maybe<AgentInviteApprovalListResult>;
  agentManagers?: Maybe<Array<User>>;
  agentStatusCounts?: Maybe<Array<AgentStatusCount>>;
  agentStock?: Maybe<Array<StockItem>>;
  agentTransferDestinations?: Maybe<Array<AgentTransferDestination>>;
  agents?: Maybe<AgentListResult>;
  /** Agents onboarded this South African month, counted under their distributor. */
  agentsOnboardedThisMonth?: Maybe<AgentOnboarding>;
  /** A consumer's Claude connector calls over the last `days` days (1-90). */
  apiConsumerUsage?: Maybe<ConnectorUsage>;
  apiConsumers?: Maybe<Array<ApiConsumer>>;
  apiKey?: Maybe<ApiKey>;
  apiKeys?: Maybe<Array<ApiKey>>;
  application?: Maybe<Application>;
  applicationDocuments?: Maybe<Array<Document>>;
  applications?: Maybe<ApplicationListResult>;
  approvalRequest?: Maybe<ApprovalRequest>;
  approvalRequests?: Maybe<ApprovalListResult>;
  approvalStatusCounts?: Maybe<Array<ApprovalStatusCount>>;
  atlasRekeyDevices?: Maybe<Array<AtlasRekeyDevice>>;
  atlasTokenHistory?: Maybe<AtlasTokenHistory>;
  attendanceMetrics: AttendanceMetrics;
  attendanceRecords: AttendanceRecordList;
  attendanceRecordsExport: Array<AttendanceRecord>;
  auditLogs?: Maybe<AuditLogListResult>;
  badDebtorsReport: BadDebtorsReport;
  bankReconciledMoneyIn?: Maybe<LiveMoneyIn>;
  bankStatementBatch: BankStatementBatch;
  bankStatementBatches: BankStatementBatchListResult;
  /** Contracts to match a bank line to by customer name, ID number, contract number or account number. */
  bankStatementContractSearch: Array<BankStatementContractMatch>;
  bankStatementRowCandidates: Array<PaymentTransaction>;
  /** The weeks tokens may be generated for (this week, then last week), each with the statements that have processable lines in it. */
  bankStatementTokenWeeks: Array<BankStatementTokenWeek>;
  bankVerification?: Maybe<BankVerification>;
  bankVerifications?: Maybe<BankVerificationListResult>;
  businessLine?: Maybe<BusinessLine>;
  businessLines?: Maybe<Array<BusinessLine>>;
  call?: Maybe<Call>;
  callTypes?: Maybe<Array<Scalars['String']['output']>>;
  calls?: Maybe<CallListResult>;
  canApproveAccessRequests?: Maybe<Scalars['Boolean']['output']>;
  candidate: Candidate;
  candidates: CandidateList;
  checkDuplicateCustomer?: Maybe<CheckDuplicateCustomerResult>;
  checkDuplicateLead?: Maybe<CheckDuplicateLeadResult>;
  comboSales: ComboSales;
  /** commissions:configure */
  commissionApproach: CommissionApproachSettings;
  commissionEntries?: Maybe<CommissionEntryListResult>;
  commissionEntry?: Maybe<CommissionEntry>;
  commissionPolicy?: Maybe<CommissionPolicy>;
  commissionRule?: Maybe<CommissionRule>;
  commissionRules?: Maybe<Array<CommissionRule>>;
  commissionRulesPage?: Maybe<CommissionRuleListResult>;
  commissionRuns?: Maybe<CommissionRunListResult>;
  commissionSummary?: Maybe<CommissionSummary>;
  commissionTypeConfig?: Maybe<CommissionTypeConfig>;
  commissionTypeConfigs?: Maybe<Array<CommissionTypeConfig>>;
  contract?: Maybe<Contract>;
  contractDeviceHistory?: Maybe<Array<DeviceReassignment>>;
  contractLifecycleSummary?: Maybe<ContractLifecycleSummary>;
  contractStatusCounts?: Maybe<Array<ContractStatusCount>>;
  contracts?: Maybe<ContractListResult>;
  countedStock: Array<StockLevel>;
  courierImports?: Maybe<Array<CourierImport>>;
  customer?: Maybe<Customer>;
  customerBookActivity: CustomerBookActivity;
  customerBookReport: CustomerBookReport;
  customerBookTrend: CustomerBookTrend;
  customerDemographicsReport: CustomerDemographicsReport;
  customerDocuments?: Maybe<Array<Document>>;
  customerFinancialAnalysis: CustomerFinancialAnalysis;
  /** Every Statement issued to a customer, newest first. Needs customers:view. */
  customerStatements: Array<CustomerStatement>;
  customerStatusCounts?: Maybe<Array<CustomerStatusCount>>;
  customers?: Maybe<CustomerListResult>;
  delinquencyPolicy?: Maybe<DelinquencyPolicy>;
  department?: Maybe<Department>;
  departments?: Maybe<Array<Department>>;
  deviceType?: Maybe<DeviceType>;
  deviceTypes?: Maybe<Array<DeviceType>>;
  digitalChannelDetail: DigitalChannelDetail;
  digitalChannelOverview: DigitalChannelOverview;
  digitalChannels: Array<DigitalChannel>;
  distributorReconciliation?: Maybe<DistributorReconciliation>;
  districtMunicipalities?: Maybe<Array<DistrictMunicipality>>;
  diversityMetrics: DiversityMetrics;
  edfReportCollectionRate: EdfReportCollectionRate;
  edfReportDebtorAgeing: EdfReportDebtorAgeing;
  edfReportDefaultRate: EdfReportDefaultRate;
  edfReportReceivablesAtRisk: EdfReportReceivablesAtRisk;
  edfReportRecoveries: EdfReportRecoveries;
  edfReportRepaymentRate: EdfReportRepaymentRate;
  effectivePermissions?: Maybe<Array<EffectivePermission>>;
  employee: Employee;
  employeeBenefits: Array<EmployeeBenefit>;
  employeeDemographics: EmployeeDemographics;
  employeeMovements: Array<EmployeeMovement>;
  employeePerformance: EmployeePerformance;
  employeeTraining: EmployeeTraining;
  employees: EmployeeList;
  employeesLeftWithLogin: Array<LeftWithLogin>;
  esgMetrics: EsgMetrics;
  esgProgramme: EsgProgrammeDetail;
  esgProgrammes: EsgProgrammeList;
  esgProgrammesExport: Array<EsgProgramme>;
  exportAgentHierarchyWorkbook?: Maybe<AgentHierarchyWorkbook>;
  exportCalls?: Maybe<CallListResult>;
  exportCommissionEntries?: Maybe<CommissionEntryListResult>;
  exportCommissionRun?: Maybe<CommissionRunWorkbook>;
  exportContracts?: Maybe<ContractListResult>;
  exportCustomers?: Maybe<CustomerListResult>;
  exportFinanceWorkbook: FinanceWorkbook;
  exportLeads?: Maybe<LeadListResult>;
  exportNotes?: Maybe<NoteListResult>;
  exportPaymentTransactions: PaymentTransactionListResult;
  exportSalesWorkbook?: Maybe<SalesWorkbook>;
  exportStockOnHand?: Maybe<StockItemListResult>;
  exportStockSales?: Maybe<StockSaleListResult>;
  exportWriteOffWorkbook: WriteOffWorkbook;
  faultAlertFallbackRecipient?: Maybe<Scalars['String']['output']>;
  faultAlertRecipients?: Maybe<Array<FaultAlertRecipient>>;
  faultCategories: Array<FaultCategory>;
  faultTypes: Array<FaultType>;
  grievance?: Maybe<Grievance>;
  grievanceCategories?: Maybe<Array<GrievanceCategory>>;
  grievanceOfficers?: Maybe<Array<GrievanceOfficer>>;
  grievanceOutcomes?: Maybe<Array<GrievanceOutcome>>;
  grievanceReport?: Maybe<GrievanceReport>;
  grievanceSettings?: Maybe<GrievanceSettings>;
  grievances?: Maybe<GrievanceList>;
  hrCase: HrCase;
  hrCaseMetrics: HrCaseMetrics;
  hrCases: HrCaseList;
  hrCasesExport: Array<HrCase>;
  /** Top-level item categories in order, each with its sub-categories. */
  itemCategories: Array<ItemCategory>;
  jobApplications: Array<JobApplication>;
  jobPositions: Array<JobPosition>;
  lead?: Maybe<Lead>;
  leadAssignableUsers?: Maybe<Array<User>>;
  leadCategoryCounts?: Maybe<LeadCategoryCounts>;
  leadSource?: Maybe<LeadSource>;
  leadSources?: Maybe<Array<LeadSource>>;
  leadStatus?: Maybe<LeadStatus>;
  leadStatuses?: Maybe<Array<LeadStatus>>;
  leads?: Maybe<LeadListResult>;
  learningProgrammes: Array<LearningProgramme>;
  leaveBalances: Array<LeaveBalance>;
  leaveRequests: LeaveRequestList;
  leaveTypes: Array<LeaveType>;
  legacySourceRecords?: Maybe<LegacySourceRecordResult>;
  liveMoneyIn?: Maybe<LiveMoneyIn>;
  localMunicipalities?: Maybe<Array<LocalMunicipality>>;
  mailingList: Array<MailingListEntry>;
  mailingListFallbackRecipient?: Maybe<Scalars['String']['output']>;
  /** Null for a list that sends as things happen rather than on a schedule. */
  mailingListSchedule?: Maybe<MailingListSchedule>;
  me?: Maybe<User>;
  members?: Maybe<MemberListResult>;
  meterTypes?: Maybe<Array<MeterType>>;
  module?: Maybe<Module>;
  modules?: Maybe<Array<Module>>;
  momoPosPayments?: Maybe<MoMoPosPaymentList>;
  myAgentAgreement?: Maybe<AgentAgreement>;
  myAgreementPartyPrefill?: Maybe<AgreementPartyDetails>;
  myBankVerification?: Maybe<BankVerification>;
  myCommissionSummary?: Maybe<AgentCommissionSummary>;
  /** commissions:view; the caller's own agent only. Null when the caller is not an agent, or when neither the month in progress nor last month, while it waits for its run, is As Collected. */
  myRunningCommission?: Maybe<MyRunningCommission>;
  /** The month's new distributors and their Solar Management Fee (ADR-0084). */
  newDistributorFeeReview: Array<NewDistributorFee>;
  note?: Maybe<Note>;
  noteCategories?: Maybe<Array<NoteCategory>>;
  notes?: Maybe<NoteListResult>;
  notifications?: Maybe<Array<Notification>>;
  organization?: Maybe<Organization>;
  paidToPreviousSeller?: Maybe<SellerCorrectionListResult>;
  partMovements: Array<StockMovement>;
  partRequests: PartRequestListResult;
  partStock: Array<StockLevel>;
  parts: Array<Part>;
  payAtDumpRow?: Maybe<PayAtDumpRow>;
  payAtDumpRows?: Maybe<PayAtDumpRowListResult>;
  payAtDumps?: Maybe<PayAtDumpListResult>;
  /**
   * Money through the Pay@ tills per day, week or month. One aggregate whatever
   * the span, where `payAtReconciliationSummary` is one aggregate per window.
   */
  payAtReconciliationSeries: Array<PayAtMoneyInPoint>;
  payAtReconciliationSummary?: Maybe<PayAtReconciliationSummary>;
  payAtRowCandidates?: Maybe<Array<PayAtCandidateGroup>>;
  payRun: PayRunDetail;
  payRunExport: Array<Payslip>;
  payRuns: Array<PayRun>;
  paymentRatingPolicy: PaymentRatingPolicy;
  paymentTransaction: PaymentTransaction;
  paymentTransactions: PaymentTransactionListResult;
  payrollMetrics: PayrollMetrics;
  pendingInvites?: Maybe<Array<PendingInvite>>;
  pendingPermissionChangeRequestCount?: Maybe<Scalars['Int']['output']>;
  performanceMetrics: PerformanceMetrics;
  performanceReviews: Array<PerformanceReview>;
  permissionChangeRequests?: Maybe<Array<PermissionChangeRequest>>;
  previewReallocation: ReallocationPreview;
  previewSellerCorrectionUpload?: Maybe<SellerCorrectionPreview>;
  product?: Maybe<Product>;
  productBrand?: Maybe<ProductBrand>;
  productBrands?: Maybe<Array<ProductBrand>>;
  productCategories?: Maybe<Array<ProductCategory>>;
  productCategory?: Maybe<ProductCategory>;
  productSales: Array<ProductSales>;
  products?: Maybe<ProductListResult>;
  provinces?: Maybe<Array<Province>>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrders?: Maybe<PurchaseOrderListResult>;
  ratePlan?: Maybe<RatePlan>;
  ratePlans?: Maybe<RatePlanListResult>;
  reallocationPolicy: ReallocationPolicy;
  receivablesContracts: Array<ReceivablesContract>;
  receivablesReport: ReceivablesReport;
  recruitmentMetrics: RecruitmentMetrics;
  replacementStockOptions?: Maybe<Array<StockItem>>;
  replenishmentAlerts?: Maybe<Array<ReplenishmentAlert>>;
  resolveCorrectDevice?: Maybe<ResolvedDevice>;
  resolveRatePlanChange?: Maybe<RatePlanChangePreview>;
  returnToHeadOffice?: Maybe<ReturnToHeadOffice>;
  returnToHeadOfficeCounts?: Maybe<Array<ReturnToHeadOfficeStatusCount>>;
  returnableDevices?: Maybe<ReturnableDeviceListResult>;
  returnsToHeadOffice?: Maybe<ReturnToHeadOfficeListResult>;
  revealThirdPartyCredential?: Maybe<RevealedThirdPartyCredential>;
  reviewCycle: ReviewCycle;
  reviewCycles: Array<ReviewCycle>;
  role?: Maybe<Role>;
  roles?: Maybe<Array<Role>>;
  safetyIncident: SafetyIncident;
  safetyIncidents: SafetyIncidentList;
  safetyIncidentsExport: Array<SafetyIncident>;
  safetyInspections: SafetyInspectionList;
  safetyMetrics: SafetyMetrics;
  safetySubcontractorOptions: Array<SafetySubcontractorOption>;
  salesAppMessage: SalesAppMessage;
  salesAppMessageDistributorTeam: Array<Scalars['ID']['output']>;
  salesAppMessages: SalesAppMessageListResult;
  salesContributionReport: SalesContributionReport;
  /** The sales behind the Sales Contribution counts, one row per contract with the day it sold. */
  salesContributionSales: Array<SalesContributionSale>;
  salesRegionManagers: Array<SalesRegionManager>;
  salesRegions: Array<SalesRegion>;
  sellerCorrectionAgents?: Maybe<Array<SellerCorrectionAgent>>;
  sellerCorrectionSales?: Maybe<Array<SellerCorrectionSale>>;
  sellerCorrections?: Maybe<SellerCorrectionListResult>;
  sensitivePermissions?: Maybe<Array<SensitivePermission>>;
  serialNumberHistory?: Maybe<StockItem>;
  shippingCompanies?: Maybe<ShippingCompanyListResult>;
  shippingCompany?: Maybe<ShippingCompany>;
  smsCallbacks: SmsCallbackListResult;
  smsCampaign: SmsCampaign;
  smsCampaignMessageSize: SmsMessageSize;
  smsCampaignPreview: SmsCampaignPreview;
  smsCampaignRecipients: SmsCampaignRecipientListResult;
  smsCampaignRecipientsCsv: Scalars['String']['output'];
  smsCampaigns: SmsCampaignListResult;
  smsLogs: SmsLogListResult;
  smsOptOuts: SmsOptOutListResult;
  stockActivity: StockActivity;
  stockBalances: StockBalances;
  stockByTierReport: StockByTierFullReport;
  stockByTierUnits: Array<StockByTierUnit>;
  stockCard: StockCard;
  stockImportBatches?: Maybe<Array<StockImportBatch>>;
  stockItems?: Maybe<StockItemListResult>;
  stockOnHand?: Maybe<StockItemListResult>;
  stockReport?: Maybe<StockReportResult>;
  stockSale?: Maybe<StockSale>;
  stockSaleProductNames?: Maybe<Array<Scalars['String']['output']>>;
  stockSales?: Maybe<StockSaleListResult>;
  stockSalesActivations?: Maybe<StockSalesActivations>;
  stockSalesReport?: Maybe<StockSalesReport>;
  stockTake?: Maybe<StockTake>;
  stockTakes: Array<StockTake>;
  stockTransfer?: Maybe<StockTransfer>;
  stockTransfers?: Maybe<StockTransferListResult>;
  stockType?: Maybe<StockType>;
  stockTypes?: Maybe<Array<StockType>>;
  stockValuationReport: StockValuationReport;
  stockingPoint?: Maybe<StockingPoint>;
  stockingPointInventory?: Maybe<StockingPointInventoryResult>;
  stockingPointProductMinimums?: Maybe<Array<StockingPointProductMinimum>>;
  stockingPoints?: Maybe<StockingPointListResult>;
  subcontractor: SubcontractorDetail;
  subcontractorAgentOptions: Array<SubcontractorWorkerAgent>;
  subcontractorComplianceDocuments: Array<SubcontractorComplianceDocument>;
  subcontractorHours: SubcontractorHoursList;
  subcontractorMetrics: SubcontractorMetrics;
  subcontractorWorkers: Array<SubcontractorWorker>;
  subcontractors: SubcontractorList;
  subcontractorsExport: Array<Subcontractor>;
  supplier?: Maybe<Supplier>;
  suppliers?: Maybe<SupplierListResult>;
  teams: Array<Team>;
  thirdPartyCredential?: Maybe<ThirdPartyCredential>;
  thirdPartyCredentials?: Maybe<Array<ThirdPartyCredential>>;
  topSellers: Array<SellerRank>;
  trainingCertifications: Array<TrainingCertification>;
  trainingCourses: Array<TrainingCourse>;
  trainingMetrics: TrainingMetrics;
  trainingSessions: TrainingSessionList;
  trainingSessionsExport: Array<TrainingSession>;
  transferDestinations?: Maybe<Array<TransferDestination>>;
  transferSources?: Maybe<Array<TransferSource>>;
  unappliedPaymentReallocations: Array<PaymentReallocation>;
  unclaimedTillPayments?: Maybe<UnclaimedTillPaymentListResult>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
  unitsOfMeasure?: Maybe<Array<UnitOfMeasure>>;
  /**
   * Units sold per day, week or month: completed sales, warranty swaps left out.
   * Counted in the database, so the span costs nothing — unlike
   * `stockSalesReport`, which materialises a row per sale.
   */
  unitsSoldSeries: Array<UnitsSoldPoint>;
  unreadNotificationCount?: Maybe<NotificationCount>;
  upgradeOnboarding?: Maybe<UpgradeOnboarding>;
  userPermissions?: Maybe<Array<UserPermission>>;
  vacancies: VacancyList;
  vacanciesExport: Array<Vacancy>;
  vacancy: Vacancy;
  validateSerialForSale?: Maybe<SerialValidationResult>;
  validateSerialForTransfer?: Maybe<StockItem>;
  validateTransferItems?: Maybe<Array<TransferItemValidation>>;
  warrantyReport: WarrantyReport;
  webhookDeliveries: Array<WebhookDelivery>;
  webhookEventCatalogue: Array<Scalars['String']['output']>;
  webhookEvents: WebhookEventListResult;
  webhookSubscriptions: Array<WebhookSubscription>;
  workforceMetrics: WorkforceMetrics;
  workshopDeviceSecret: RevealedDeviceSecret;
  workshopIntakeQueue?: Maybe<WorkshopIntakeQueue>;
  workshopJob: WorkshopJob;
  workshopJobs: WorkshopJobListResult;
  workshopPolicy?: Maybe<WorkshopPolicy>;
  workshopStats: WorkshopStats;
  writeOffReportFallbackRecipient?: Maybe<Scalars['String']['output']>;
  writeOffReportRecipients?: Maybe<Array<WriteOffReportRecipient>>;
  xeroConnectionStatus?: Maybe<XeroConnectionStatus>;
  xeroIntegrationLogs?: Maybe<Array<XeroIntegrationLog>>;
};


export type QueryActivePhoneNumberUpdateRequestArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryAgentArgs = {
  id: Scalars['String']['input'];
};


export type QueryAgentAgreementArgs = {
  id: Scalars['String']['input'];
};


export type QueryAgentAgreementsArgs = {
  filter?: InputMaybe<AgentAgreementFilterInput>;
};


export type QueryAgentCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryAgentCommissionSummaryArgs = {
  agentId: Scalars['String']['input'];
};


export type QueryAgentDisputeCountArgs = {
  input?: InputMaybe<ListDisputesInput>;
};


export type QueryAgentDisputeResolutionsArgs = {
  agentId: Scalars['String']['input'];
};


export type QueryAgentDisputesArgs = {
  input?: InputMaybe<ListDisputesInput>;
};


export type QueryAgentInviteApprovalsArgs = {
  input?: InputMaybe<AgentInviteApprovalListInput>;
};


export type QueryAgentStockArgs = {
  agentId: Scalars['String']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgentsArgs = {
  input?: InputMaybe<AgentListInput>;
};


export type QueryApiConsumerUsageArgs = {
  apiConsumerId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type QueryApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryApplicationDocumentsArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryApplicationsArgs = {
  input?: InputMaybe<ApplicationListInput>;
};


export type QueryApprovalRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryApprovalRequestsArgs = {
  input?: InputMaybe<ApprovalListInput>;
};


export type QueryApprovalStatusCountsArgs = {
  kinds?: InputMaybe<Array<ApprovalRequestKind>>;
};


export type QueryAtlasRekeyDevicesArgs = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAtlasTokenHistoryArgs = {
  accountNumber: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAttendanceMetricsArgs = {
  filter?: InputMaybe<AttendanceMetricsFilterInput>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryAttendanceRecordsArgs = {
  filter?: InputMaybe<AttendanceFilterInput>;
};


export type QueryAttendanceRecordsExportArgs = {
  filter?: InputMaybe<AttendanceFilterInput>;
};


export type QueryAuditLogsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBadDebtorsReportArgs = {
  basis?: InputMaybe<ReceivablesBasis>;
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBankReconciledMoneyInArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryBankStatementBatchArgs = {
  id: Scalars['String']['input'];
};


export type QueryBankStatementBatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBankStatementContractSearchArgs = {
  search: Scalars['String']['input'];
};


export type QueryBankStatementRowCandidatesArgs = {
  rowId: Scalars['String']['input'];
};


export type QueryBankVerificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryBankVerificationsArgs = {
  filter?: InputMaybe<BankVerificationFilterInput>;
};


export type QueryBusinessLineArgs = {
  id: Scalars['String']['input'];
};


export type QueryCallArgs = {
  id: Scalars['String']['input'];
};


export type QueryCallTypesArgs = {
  input: CallListInput;
};


export type QueryCallsArgs = {
  input: CallListInput;
};


export type QueryCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCandidatesArgs = {
  filter?: InputMaybe<CandidateFilterInput>;
};


export type QueryCheckDuplicateCustomerArgs = {
  input: CheckDuplicateCustomerInput;
};


export type QueryCheckDuplicateLeadArgs = {
  input: CheckDuplicateLeadInput;
};


export type QueryComboSalesArgs = {
  from: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryCommissionEntriesArgs = {
  input?: InputMaybe<CommissionEntryListInput>;
};


export type QueryCommissionEntryArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommissionRuleArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommissionRulesPageArgs = {
  input?: InputMaybe<CommissionRuleListInput>;
};


export type QueryCommissionRunsArgs = {
  input?: InputMaybe<CommissionRunListInput>;
};


export type QueryCommissionTypeConfigArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractDeviceHistoryArgs = {
  contractId: Scalars['String']['input'];
};


export type QueryContractStatusCountsArgs = {
  mine?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContractsArgs = {
  input?: InputMaybe<ContractListInput>;
};


export type QueryCountedStockArgs = {
  kind: ProductKind;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCourierImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerBookActivityArgs = {
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerBookTrendArgs = {
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerDemographicsReportArgs = {
  filter?: InputMaybe<CustomerDemographicsFilter>;
};


export type QueryCustomerDocumentsArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryCustomerFinancialAnalysisArgs = {
  customerId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCustomerStatementsArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryCustomerStatusCountsArgs = {
  mine?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomersArgs = {
  input?: InputMaybe<CustomerSearchInput>;
};


export type QueryDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type QueryDeviceTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryDigitalChannelDetailArgs = {
  channelId: Scalars['String']['input'];
  input: DigitalChannelPeriodInput;
};


export type QueryDigitalChannelOverviewArgs = {
  input: DigitalChannelPeriodInput;
};


export type QueryDigitalChannelsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDistributorReconciliationArgs = {
  distributorId: Scalars['String']['input'];
};


export type QueryDistrictMunicipalitiesArgs = {
  provinceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDiversityMetricsArgs = {
  asOf: Scalars['DateTime']['input'];
  filter?: InputMaybe<DiversityFilterInput>;
};


export type QueryEdfReportCollectionRateArgs = {
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEdfReportDebtorAgeingArgs = {
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEdfReportDefaultRateArgs = {
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEdfReportReceivablesAtRiskArgs = {
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEdfReportRecoveriesArgs = {
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEdfReportRepaymentRateArgs = {
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEffectivePermissionsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeBenefitsArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmployeeDemographicsArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeeMovementsArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeePerformanceArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeeTrainingArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeesArgs = {
  filter?: InputMaybe<EmployeeFilterInput>;
};


export type QueryEsgMetricsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryEsgProgrammeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEsgProgrammesArgs = {
  filter?: InputMaybe<EsgProgrammeFilterInput>;
};


export type QueryEsgProgrammesExportArgs = {
  filter?: InputMaybe<EsgProgrammeFilterInput>;
};


export type QueryExportCallsArgs = {
  input: CallListInput;
};


export type QueryExportCommissionEntriesArgs = {
  input?: InputMaybe<CommissionEntryListInput>;
};


export type QueryExportCommissionRunArgs = {
  runId: Scalars['String']['input'];
};


export type QueryExportContractsArgs = {
  input?: InputMaybe<ContractListInput>;
};


export type QueryExportCustomersArgs = {
  input?: InputMaybe<CustomerSearchInput>;
};


export type QueryExportFinanceWorkbookArgs = {
  basis?: InputMaybe<ReceivablesBasis>;
  kind: FinanceWorkbookKind;
  month?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExportLeadsArgs = {
  input?: InputMaybe<LeadSearchInput>;
};


export type QueryExportNotesArgs = {
  input: NoteListInput;
};


export type QueryExportPaymentTransactionsArgs = {
  input?: InputMaybe<PaymentTransactionListInput>;
};


export type QueryExportSalesWorkbookArgs = {
  to: Scalars['DateTime']['input'];
};


export type QueryExportStockOnHandArgs = {
  input?: InputMaybe<StockOnHandInput>;
};


export type QueryExportStockSalesArgs = {
  input?: InputMaybe<StockSaleListInput>;
};


export type QueryExportWriteOffWorkbookArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryFaultCategoriesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFaultTypesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrievanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGrievanceReportArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryGrievancesArgs = {
  filter?: InputMaybe<GrievanceFilterInput>;
};


export type QueryHrCaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHrCaseMetricsArgs = {
  filter?: InputMaybe<HrCaseMetricsFilterInput>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryHrCasesArgs = {
  filter?: InputMaybe<HrCaseFilterInput>;
};


export type QueryHrCasesExportArgs = {
  filter?: InputMaybe<HrCaseFilterInput>;
};


export type QueryJobApplicationsArgs = {
  vacancyId: Scalars['ID']['input'];
};


export type QueryLeadArgs = {
  id: Scalars['String']['input'];
};


export type QueryLeadSourceArgs = {
  id: Scalars['String']['input'];
};


export type QueryLeadStatusArgs = {
  id: Scalars['String']['input'];
};


export type QueryLeadsArgs = {
  input?: InputMaybe<LeadSearchInput>;
};


export type QueryLearningProgrammesArgs = {
  filter?: InputMaybe<LearningProgrammeFilterInput>;
};


export type QueryLeaveBalancesArgs = {
  filter?: InputMaybe<LeaveBalanceFilterInput>;
};


export type QueryLeaveRequestsArgs = {
  filter?: InputMaybe<LeaveRequestFilterInput>;
};


export type QueryLegacySourceRecordsArgs = {
  entityId: Scalars['String']['input'];
  entityType: LegacyEntityType;
};


export type QueryLiveMoneyInArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryLocalMunicipalitiesArgs = {
  districtMunicipalityId?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMailingListArgs = {
  list: MailingListName;
};


export type QueryMailingListScheduleArgs = {
  list: MailingListName;
};


export type QueryMembersArgs = {
  input?: InputMaybe<MemberSearchInput>;
};


export type QueryModuleArgs = {
  id: Scalars['String']['input'];
};


export type QueryMomoPosPaymentsArgs = {
  filter?: InputMaybe<MoMoPosPaymentFilterInput>;
};


export type QueryNewDistributorFeeReviewArgs = {
  periodDate: Scalars['DateTime']['input'];
};


export type QueryNoteArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotesArgs = {
  input: NoteListInput;
};


export type QueryNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaidToPreviousSellerArgs = {
  input?: InputMaybe<SellerCorrectionListInput>;
};


export type QueryPartMovementsArgs = {
  productId: Scalars['String']['input'];
};


export type QueryPartRequestsArgs = {
  input?: InputMaybe<PartRequestListInput>;
};


export type QueryPartStockArgs = {
  stockingPointId: Scalars['String']['input'];
};


export type QueryPartsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPayAtDumpRowArgs = {
  id: Scalars['String']['input'];
};


export type QueryPayAtDumpRowsArgs = {
  filter?: InputMaybe<PayAtDumpRowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPayAtDumpsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPayAtReconciliationSeriesArgs = {
  bucket: SeriesBucket;
  from: Scalars['DateTime']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryPayAtReconciliationSummaryArgs = {
  from: Scalars['DateTime']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryPayAtRowCandidatesArgs = {
  rowId: Scalars['String']['input'];
};


export type QueryPayRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayRunExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayRunsArgs = {
  filter?: InputMaybe<PayRunFilterInput>;
};


export type QueryPaymentTransactionArgs = {
  id: Scalars['String']['input'];
};


export type QueryPaymentTransactionsArgs = {
  input?: InputMaybe<PaymentTransactionListInput>;
};


export type QueryPayrollMetricsArgs = {
  filter?: InputMaybe<PayrollMetricsFilterInput>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryPerformanceMetricsArgs = {
  filter?: InputMaybe<PerformanceFilterInput>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryPerformanceReviewsArgs = {
  cycleId: Scalars['ID']['input'];
};


export type QueryPermissionChangeRequestsArgs = {
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PermissionRequestStatus>;
};


export type QueryPreviewReallocationArgs = {
  input: PreviewReallocationInput;
};


export type QueryPreviewSellerCorrectionUploadArgs = {
  input: PreviewSellerCorrectionUploadInput;
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductBrandArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductSalesArgs = {
  from: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryProductsArgs = {
  input?: InputMaybe<ProductListInput>;
};


export type QueryPurchaseOrderArgs = {
  id: Scalars['String']['input'];
};


export type QueryPurchaseOrdersArgs = {
  input?: InputMaybe<PurchaseOrderListInput>;
};


export type QueryRatePlanArgs = {
  id: Scalars['String']['input'];
};


export type QueryRatePlansArgs = {
  input?: InputMaybe<RatePlanListInput>;
};


export type QueryReceivablesContractsArgs = {
  basis?: InputMaybe<ReceivablesBasis>;
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  section?: InputMaybe<ReceivablesSectionInput>;
};


export type QueryReceivablesReportArgs = {
  basis?: InputMaybe<ReceivablesBasis>;
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRecruitmentMetricsArgs = {
  filter?: InputMaybe<RecruitmentMetricsFilterInput>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryReplacementStockOptionsArgs = {
  agentId: Scalars['String']['input'];
  onBehalfOfAgentId?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResolveCorrectDeviceArgs = {
  contractId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  stockSaleId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResolveRatePlanChangeArgs = {
  input: ResolveRatePlanChangeInput;
};


export type QueryReturnToHeadOfficeArgs = {
  id: Scalars['String']['input'];
};


export type QueryReturnableDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReturnsToHeadOfficeArgs = {
  input?: InputMaybe<ReturnToHeadOfficeListInput>;
};


export type QueryRevealThirdPartyCredentialArgs = {
  id: Scalars['String']['input'];
};


export type QueryReviewCycleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoleArgs = {
  id: Scalars['String']['input'];
};


export type QueryRolesArgs = {
  assignableForAgents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySafetyIncidentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySafetyIncidentsArgs = {
  filter?: InputMaybe<SafetyIncidentFilterInput>;
};


export type QuerySafetyIncidentsExportArgs = {
  filter?: InputMaybe<SafetyIncidentFilterInput>;
};


export type QuerySafetyInspectionsArgs = {
  filter?: InputMaybe<SafetyInspectionFilterInput>;
};


export type QuerySafetyMetricsArgs = {
  filter?: InputMaybe<SafetyMetricsFilterInput>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QuerySafetySubcontractorOptionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalesAppMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalesAppMessageDistributorTeamArgs = {
  distributorId: Scalars['ID']['input'];
};


export type QuerySalesAppMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySalesContributionReportArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalesContributionSalesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  span: SalesContributionSpan;
};


export type QuerySellerCorrectionAgentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySellerCorrectionSalesArgs = {
  identifier: Scalars['String']['input'];
};


export type QuerySellerCorrectionsArgs = {
  input?: InputMaybe<SellerCorrectionListInput>;
};


export type QuerySerialNumberHistoryArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryShippingCompaniesArgs = {
  input?: InputMaybe<ShippingCompanyListInput>;
};


export type QueryShippingCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QuerySmsCallbacksArgs = {
  input?: InputMaybe<SmsCallbackListInput>;
};


export type QuerySmsCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmsCampaignMessageSizeArgs = {
  body: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySmsCampaignPreviewArgs = {
  audience: SmsCampaignAudienceInput;
  body: Scalars['String']['input'];
};


export type QuerySmsCampaignRecipientsArgs = {
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SmsCampaignRecipientStatus>;
};


export type QuerySmsCampaignRecipientsCsvArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QuerySmsCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySmsLogsArgs = {
  input?: InputMaybe<SmsLogListInput>;
};


export type QuerySmsOptOutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStockActivityArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStockCardArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['String']['input'];
};


export type QueryStockImportBatchesArgs = {
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStockItemsArgs = {
  input?: InputMaybe<StockItemListInput>;
};


export type QueryStockOnHandArgs = {
  input?: InputMaybe<StockOnHandInput>;
};


export type QueryStockReportArgs = {
  input?: InputMaybe<StockReportInput>;
};


export type QueryStockSaleArgs = {
  id: Scalars['String']['input'];
};


export type QueryStockSalesArgs = {
  input?: InputMaybe<StockSaleListInput>;
};


export type QueryStockSalesActivationsArgs = {
  input?: InputMaybe<ReportDateRangeInput>;
};


export type QueryStockSalesReportArgs = {
  input?: InputMaybe<ReportDateRangeInput>;
};


export type QueryStockTakeArgs = {
  id: Scalars['String']['input'];
};


export type QueryStockTakesArgs = {
  status?: InputMaybe<StockTakeStatus>;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStockTransferArgs = {
  id: Scalars['String']['input'];
};


export type QueryStockTransfersArgs = {
  input?: InputMaybe<StockTransferListInput>;
};


export type QueryStockTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryStockingPointArgs = {
  id: Scalars['String']['input'];
};


export type QueryStockingPointInventoryArgs = {
  kind?: InputMaybe<StockKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StockItemStatus>;
  stockingPointId: Scalars['String']['input'];
};


export type QueryStockingPointProductMinimumsArgs = {
  stockingPointId: Scalars['String']['input'];
};


export type QueryStockingPointsArgs = {
  input?: InputMaybe<StockingPointListInput>;
};


export type QuerySubcontractorArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubcontractorAgentOptionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubcontractorComplianceDocumentsArgs = {
  filter?: InputMaybe<SubcontractorComplianceFilterInput>;
};


export type QuerySubcontractorHoursArgs = {
  filter?: InputMaybe<SubcontractorHoursFilterInput>;
};


export type QuerySubcontractorMetricsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QuerySubcontractorWorkersArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubcontractorsArgs = {
  filter?: InputMaybe<SubcontractorFilterInput>;
};


export type QuerySubcontractorsExportArgs = {
  filter?: InputMaybe<SubcontractorFilterInput>;
};


export type QuerySupplierArgs = {
  id: Scalars['String']['input'];
};


export type QuerySuppliersArgs = {
  input?: InputMaybe<SupplierListInput>;
};


export type QueryTeamsArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryThirdPartyCredentialArgs = {
  id: Scalars['String']['input'];
};


export type QueryThirdPartyCredentialsArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopSellersArgs = {
  from: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryTrainingCertificationsArgs = {
  filter?: InputMaybe<TrainingCertificationFilterInput>;
};


export type QueryTrainingMetricsArgs = {
  filter?: InputMaybe<TrainingMetricsFilterInput>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryTrainingSessionsArgs = {
  filter?: InputMaybe<TrainingSessionFilterInput>;
};


export type QueryTrainingSessionsExportArgs = {
  filter?: InputMaybe<TrainingSessionFilterInput>;
};


export type QueryUnclaimedTillPaymentsArgs = {
  from: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryUnitOfMeasureArgs = {
  id: Scalars['String']['input'];
};


export type QueryUnitsSoldSeriesArgs = {
  bucket: SeriesBucket;
  from: Scalars['DateTime']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryUpgradeOnboardingArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryUserPermissionsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryVacanciesArgs = {
  filter?: InputMaybe<VacancyFilterInput>;
};


export type QueryVacanciesExportArgs = {
  filter?: InputMaybe<VacancyFilterInput>;
};


export type QueryVacancyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryValidateSerialForSaleArgs = {
  agentId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  override?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryValidateSerialForTransferArgs = {
  serialNumber: Scalars['String']['input'];
  sourceStockingPointId: Scalars['String']['input'];
};


export type QueryValidateTransferItemsArgs = {
  identifiers: Array<Scalars['String']['input']>;
  sourceStockingPointId: Scalars['String']['input'];
};


export type QueryWarrantyReportArgs = {
  input?: InputMaybe<ReportDateRangeInput>;
};


export type QueryWebhookDeliveriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WebhookDeliveryStatus>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  webhookEventId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWebhookEventsArgs = {
  input?: InputMaybe<WebhookEventListInput>;
};


export type QueryWorkforceMetricsArgs = {
  filter?: InputMaybe<WorkforceFilterInput>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryWorkshopDeviceSecretArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryWorkshopIntakeQueueArgs = {
  stockingPointId: Scalars['String']['input'];
};


export type QueryWorkshopJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkshopJobsArgs = {
  input?: InputMaybe<WorkshopJobListInput>;
};


export type QueryWorkshopStatsArgs = {
  input: WorkshopStatsInput;
};


export type QueryXeroIntegrationLogsArgs = {
  filter?: InputMaybe<XeroLogFilterInput>;
};

export type RaceCount = {
  __typename?: 'RaceCount';
  count: Scalars['Int']['output'];
  race?: Maybe<EmployeeRace>;
};

export type RaisePartRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  destinationStockingPointId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  workshopJobId?: InputMaybe<Scalars['String']['input']>;
};

export type RatePlan = {
  __typename?: 'RatePlan';
  aftercareAgent?: Maybe<Scalars['Int']['output']>;
  aftercareRam?: Maybe<Scalars['Int']['output']>;
  commissionCloseout?: Maybe<Scalars['Int']['output']>;
  commissionMonth1?: Maybe<Scalars['Int']['output']>;
  commissionMonth2?: Maybe<Scalars['Int']['output']>;
  commissionMonth3?: Maybe<Scalars['Int']['output']>;
  commissionMonth4?: Maybe<Scalars['Int']['output']>;
  commissionRam?: Maybe<Scalars['Int']['output']>;
  contractCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositCollectedUpfront?: Maybe<Scalars['Boolean']['output']>;
  downpayment?: Maybe<Scalars['Float']['output']>;
  downpaymentFormula?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isCombo?: Maybe<Scalars['Boolean']['output']>;
  manSystem?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<RatePlanProduct>>;
  rateAmount?: Maybe<Scalars['Float']['output']>;
  rateName?: Maybe<Scalars['String']['output']>;
  termLength?: Maybe<Scalars['Int']['output']>;
  tokenCase?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** One of the contract's devices under the new plan: kept when the plan still sells that product, otherwise replaced. */
export type RatePlanChangeDevicePreview = {
  __typename?: 'RatePlanChangeDevicePreview';
  currentAccountNumber?: Maybe<Scalars['String']['output']>;
  currentSerialNumber?: Maybe<Scalars['String']['output']>;
  newAccountNumber?: Maybe<Scalars['String']['output']>;
  newSerialNumber?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  replacing?: Maybe<Scalars['Boolean']['output']>;
};

export type RatePlanChangePreview = {
  __typename?: 'RatePlanChangePreview';
  planError?: Maybe<Scalars['String']['output']>;
  planRateName?: Maybe<Scalars['String']['output']>;
  planValid?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<RatePlanChangeRowPreview>>;
};

export type RatePlanChangeRowInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  newDeviceIdentifiers: Array<Scalars['String']['input']>;
};

/** What one row of a plan change would do, checked without changing anything. */
export type RatePlanChangeRowPreview = {
  __typename?: 'RatePlanChangeRowPreview';
  alreadyApplied?: Maybe<Scalars['Boolean']['output']>;
  catchUpTokenAmount?: Maybe<Scalars['Float']['output']>;
  catchUpTokenDays?: Maybe<Scalars['Int']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  currentDeviceAccountNumber?: Maybe<Scalars['String']['output']>;
  currentDeviceSerialNumber?: Maybe<Scalars['String']['output']>;
  currentRateName?: Maybe<Scalars['String']['output']>;
  currentTotalPrice?: Maybe<Scalars['Float']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  /** Every device the contract will run under the new plan, kept or replaced. */
  devices?: Maybe<Array<RatePlanChangeDevicePreview>>;
  error?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  newDeviceAccountNumber?: Maybe<Scalars['String']['output']>;
  newDeviceProductName?: Maybe<Scalars['String']['output']>;
  newDeviceSerialNumber?: Maybe<Scalars['String']['output']>;
  newTotalPrice?: Maybe<Scalars['Float']['output']>;
  projectedBalance?: Maybe<Scalars['Float']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<DeviceReassignmentWarning>>;
  wouldPayOff?: Maybe<Scalars['Boolean']['output']>;
};

export type RatePlanChangeRowStatus =
  | 'FAILED'
  | 'SKIPPED'
  | 'SUCCEEDED';

export type RatePlanListInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  manSystem?: InputMaybe<ManSystem>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RatePlanListResult = {
  __typename?: 'RatePlanListResult';
  items: Array<RatePlan>;
  totalCount: Scalars['Int']['output'];
};

export type RatePlanProduct = {
  __typename?: 'RatePlanProduct';
  allocationPercentage?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  product?: Maybe<Product>;
};

export type RatePlanProductAllocationInput = {
  allocationPercentage: Scalars['Float']['input'];
  productId: Scalars['String']['input'];
};

export type RatePlanType =
  | 'CASH'
  | 'LOAN';

export type RatingCount = {
  __typename?: 'RatingCount';
  count: Scalars['Int']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
};

export type ReallocatePaymentInput = {
  destinationContractId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  paymentTransactionId: Scalars['String']['input'];
  reason: PaymentReallocationReason;
  recoveryInstalments?: InputMaybe<Scalars['Int']['input']>;
  writeOffUnrecovered?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Per-organization settings for correcting a misrouted payment. */
export type ReallocationPolicy = {
  __typename?: 'ReallocationPolicy';
  costRecoveryAmount: Scalars['Int']['output'];
  minimumTokenDaysPerPayment: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** What the operator is shown before committing to a reallocation. */
export type ReallocationPreview = {
  __typename?: 'ReallocationPreview';
  amount: Scalars['Float']['output'];
  amountReachingDestination: Scalars['Float']['output'];
  costRecoveryAmount: Scalars['Int']['output'];
  deliveredTokenDays?: Maybe<Scalars['Int']['output']>;
  destinationContractId: Scalars['String']['output'];
  destinationContractNumber: Scalars['String']['output'];
  destinationCustomerName: Scalars['String']['output'];
  paymentTransactionId: Scalars['String']['output'];
  recovery?: Maybe<CreditRecoveryPlan>;
  sourceContractId: Scalars['String']['output'];
  sourceContractNumber: Scalars['String']['output'];
  sourceCustomerName: Scalars['String']['output'];
  unrecoverable?: Maybe<PaymentReallocationWriteOffReason>;
  warnings: Array<PaymentReallocationWarning>;
};

/** `applied` false means the money is off the wrong contract but not yet on the right one. */
export type ReallocationResult = {
  __typename?: 'ReallocationResult';
  applied: Scalars['Boolean']['output'];
  applyError?: Maybe<Scalars['String']['output']>;
  reallocationId: Scalars['String']['output'];
  writtenOffAmount?: Maybe<Scalars['Int']['output']>;
  writtenOffReason?: Maybe<PaymentReallocationWriteOffReason>;
};

export type ReassignContractDeviceInput = {
  cause: DeviceReassignmentCause;
  contractId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  stockSaleId?: InputMaybe<Scalars['String']['input']>;
};

export type ReceivablesBasis =
  | 'POINT_IN_TIME'
  | 'RESTATED';

export type ReceivablesBucket =
  | 'CURRENT'
  | 'DAYS_1_30'
  | 'DAYS_31_60'
  | 'DAYS_61_90'
  | 'DAYS_90_PLUS'
  | 'NO_TOKEN';

export type ReceivablesBucketRow = {
  __typename?: 'ReceivablesBucketRow';
  bucket: ReceivablesBucket;
  buyout: Scalars['Float']['output'];
  contracts: Scalars['Int']['output'];
  customers: Scalars['Int']['output'];
};

export type ReceivablesContract = {
  __typename?: 'ReceivablesContract';
  accountNumber?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
  contractNumber: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  customerPhone?: Maybe<Scalars['String']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  nationalSalesManagerName?: Maybe<Scalars['String']['output']>;
  outstanding: Scalars['Float']['output'];
  paid: Scalars['Float']['output'];
  product?: Maybe<Scalars['String']['output']>;
  ratePlan?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  registrationYear: Scalars['Int']['output'];
  status: ReceivablesStatus;
  unlockPrice: Scalars['Float']['output'];
};

export type ReceivablesReport = {
  __typename?: 'ReceivablesReport';
  basis: ReceivablesBasis;
  buckets: Array<ReceivablesBucketRow>;
  cutoff: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  partialMonth: Scalars['Boolean']['output'];
  statusBrands: Array<ReceivablesStatusBrandRow>;
  statusYears: Array<ReceivablesStatusYearRow>;
  statuses: Array<ReceivablesStatusRow>;
  totals: ReceivablesTotals;
  years: Array<ReceivablesYearRow>;
};

export type ReceivablesSectionInput = {
  badDebt?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<ReceivablesBucket>;
  registrationYear?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReceivablesStatus>;
};

export type ReceivablesStatus =
  | 'ACTIVE'
  | 'PAID_OFF'
  | 'REPOSSESSED'
  | 'WRITTEN_OFF';

export type ReceivablesStatusBrandRow = {
  __typename?: 'ReceivablesStatusBrandRow';
  brand?: Maybe<Scalars['String']['output']>;
  carried: Scalars['Float']['output'];
  contracts: Scalars['Int']['output'];
  credit: Scalars['Float']['output'];
  customers: Scalars['Int']['output'];
  outstanding: Scalars['Float']['output'];
  owingContracts: Scalars['Int']['output'];
  paid: Scalars['Float']['output'];
  status: ReceivablesStatus;
  unlockPrice: Scalars['Float']['output'];
};

export type ReceivablesStatusRow = {
  __typename?: 'ReceivablesStatusRow';
  carried: Scalars['Float']['output'];
  contracts: Scalars['Int']['output'];
  credit: Scalars['Float']['output'];
  customers: Scalars['Int']['output'];
  outstanding: Scalars['Float']['output'];
  owingContracts: Scalars['Int']['output'];
  paid: Scalars['Float']['output'];
  status: ReceivablesStatus;
  unlockPrice: Scalars['Float']['output'];
};

export type ReceivablesStatusYearRow = {
  __typename?: 'ReceivablesStatusYearRow';
  carried: Scalars['Float']['output'];
  contracts: Scalars['Int']['output'];
  credit: Scalars['Float']['output'];
  customers: Scalars['Int']['output'];
  outstanding: Scalars['Float']['output'];
  owingContracts: Scalars['Int']['output'];
  paid: Scalars['Float']['output'];
  registrationYear: Scalars['Int']['output'];
  status: ReceivablesStatus;
  unlockPrice: Scalars['Float']['output'];
};

export type ReceivablesTotals = {
  __typename?: 'ReceivablesTotals';
  buyout: Scalars['Float']['output'];
  contracts: Scalars['Int']['output'];
  customers: Scalars['Int']['output'];
  overdueBuyout: Scalars['Float']['output'];
  overdueContracts: Scalars['Int']['output'];
};

export type ReceivablesYearRow = {
  __typename?: 'ReceivablesYearRow';
  buckets: Array<ReceivablesBucketRow>;
  buyout: Scalars['Float']['output'];
  contracts: Scalars['Int']['output'];
  customers: Scalars['Int']['output'];
  overdueBuyout: Scalars['Float']['output'];
  registrationYear: Scalars['Int']['output'];
};

export type ReceiveAtWorkshopInput = {
  stockItemIds: Array<Scalars['String']['input']>;
  stockingPointId: Scalars['String']['input'];
};

export type ReceivePurchaseOrderLineInput = {
  lineId: Scalars['String']['input'];
  receivedQuantity: Scalars['Int']['input'];
  unitCostCents?: InputMaybe<Scalars['Int']['input']>;
};

export type ReconcileBankStatementRowInput = {
  paymentId?: InputMaybe<Scalars['String']['input']>;
  rowId: Scalars['String']['input'];
};

export type RecordEmployeeMovementInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  effectiveDate: Scalars['DateTime']['input'];
  employeeId: Scalars['ID']['input'];
  employmentType?: InputMaybe<EmploymentType>;
  jobLevel?: InputMaybe<JobLevel>;
  jobPositionId?: InputMaybe<Scalars['ID']['input']>;
  movementType?: InputMaybe<EmployeeMovementType>;
  reason?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  workingPattern?: InputMaybe<WorkingPattern>;
};

export type RecordRepossessionInput = {
  contractId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type RecordStockSaleInput = {
  agentId: Scalars['String']['input'];
  contractId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  saleDate?: InputMaybe<Scalars['DateTime']['input']>;
  stockItemId: Scalars['String']['input'];
};

export type RecruitmentCost = {
  __typename?: 'RecruitmentCost';
  amount: Scalars['Float']['output'];
  category: RecruitmentCostCategory;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incurredDate: Scalars['DateTime']['output'];
};

export type RecruitmentCostCategory =
  | 'ADVERTISING'
  | 'AGENCY'
  | 'ASSESSMENT'
  | 'OTHER';

export type RecruitmentCostInput = {
  amount: Scalars['Float']['input'];
  category: RecruitmentCostCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  incurredDate: Scalars['DateTime']['input'];
};

export type RecruitmentMetrics = {
  __typename?: 'RecruitmentMetrics';
  applications: HrMetric;
  applicationsPerVacancy: HrMetric;
  averageDaysToFill: HrMetric;
  averageDaysToHire: HrMetric;
  costPerHire: HrMetric;
  from: Scalars['DateTime']['output'];
  hires: HrMetric;
  internalHirePercent: HrMetric;
  offerAcceptanceRate: HrMetric;
  openPositions: HrMetric;
  openVacancies: HrMetric;
  pipeline: Array<RecruitmentStageCount>;
  sourceOfHire: Array<RecruitmentSourceCount>;
  to: Scalars['DateTime']['output'];
  totalCost: HrMetric;
  vacanciesFilled: HrMetric;
};

export type RecruitmentMetricsFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RecruitmentSourceCount = {
  __typename?: 'RecruitmentSourceCount';
  count: Scalars['Int']['output'];
  source?: Maybe<CandidateSource>;
};

export type RecruitmentStageCount = {
  __typename?: 'RecruitmentStageCount';
  current: Scalars['Int']['output'];
  reached: Scalars['Int']['output'];
  stage: JobApplicationStage;
};

export type RecruitmentUser = {
  __typename?: 'RecruitmentUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type RefreshPayload = {
  __typename?: 'RefreshPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type RegisterDeviceAtWorkshopInput = {
  faultCategoryId?: InputMaybe<Scalars['String']['input']>;
  faultDescription?: InputMaybe<Scalars['String']['input']>;
  intakeReason?: InputMaybe<WorkshopJobIntakeReason>;
  newDevice?: InputMaybe<NewWorkshopDeviceInput>;
  openedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stockItemId?: InputMaybe<Scalars['String']['input']>;
  stockingPointId: Scalars['String']['input'];
};

export type ReleaseDeviceInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Release the rest of the combo this device was reserved with, as well. Only meaningful when `releaseEligibility.applicationSiblings` is non-empty. */
  releaseApplicationSiblings?: InputMaybe<Scalars['Boolean']['input']>;
  stockItemId: Scalars['String']['input'];
};

export type ReopenContractInput = {
  confirm?: InputMaybe<ReopenDeviceConfirmationInput>;
  contractId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: ReopenReason;
  replace?: InputMaybe<ReopenDeviceReplacementInput>;
};

export type ReopenDeviceConfirmationInput = {
  devices: Array<Scalars['String']['input']>;
  method: DeviceConfirmationMethod;
};

export type ReopenDeviceReplacementInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  agentId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  meterTypeId?: InputMaybe<Scalars['Int']['input']>;
  override?: InputMaybe<Scalars['Boolean']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  startingCode?: InputMaybe<Scalars['String']['input']>;
};

export type ReopenDeviceStep =
  | 'CONFIRM'
  | 'NONE'
  | 'REPLACE';

export type ReopenDeviceToConfirm = {
  __typename?: 'ReopenDeviceToConfirm';
  productName?: Maybe<Scalars['String']['output']>;
};

export type ReopenPreview = {
  __typename?: 'ReopenPreview';
  blocker?: Maybe<Scalars['String']['output']>;
  deviceStep?: Maybe<ReopenDeviceStep>;
  devicesPutBack: Array<Scalars['String']['output']>;
  devicesToConfirm: Array<ReopenDeviceToConfirm>;
  reasons: Array<ReopenReason>;
  replaceBecause?: Maybe<Scalars['String']['output']>;
  targetStatus?: Maybe<ContractStatus>;
};

export type ReopenReason =
  | 'ARREARS_SETTLED'
  | 'CANCELLED_IN_ERROR'
  | 'CUSTOMER_RESUMING'
  | 'WRITTEN_OFF_IN_ERROR';

export type ReplenishmentAlert = {
  __typename?: 'ReplenishmentAlert';
  products?: Maybe<Array<ReplenishmentProduct>>;
  shortProductCount?: Maybe<Scalars['Int']['output']>;
  stockingPoint?: Maybe<StockingPoint>;
  totalDeficit?: Maybe<Scalars['Int']['output']>;
};

export type ReplenishmentProduct = {
  __typename?: 'ReplenishmentProduct';
  arrivingCount?: Maybe<Scalars['Int']['output']>;
  availableCount?: Maybe<Scalars['Int']['output']>;
  deficit?: Maybe<Scalars['Int']['output']>;
  minimumStockLevel?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type ReportDateRangeInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
};

export type RequestUpgradeOnboardingInput = {
  contractId: Scalars['String']['input'];
  requestReason?: InputMaybe<Scalars['String']['input']>;
};

/** Result of resending a token SMS for an existing PaymentTransaction. `success` reflects whether the SMS provider accepted the message. */
export type ResendTokenSmsResult = {
  __typename?: 'ResendTokenSmsResult';
  accountNumber: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  to: Scalars['String']['output'];
};

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResolveDisputeInput = {
  agentId: Scalars['String']['input'];
  disputeType: DisputeFlag;
  manualValue?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome: DisputeOutcome;
};

export type ResolveDisputePayload = {
  __typename?: 'ResolveDisputePayload';
  agentId?: Maybe<Scalars['String']['output']>;
  resolutionId?: Maybe<Scalars['String']['output']>;
};

export type ResolveRatePlanChangeInput = {
  newRatePlanId: Scalars['String']['input'];
  rows: Array<RatePlanChangeRowInput>;
};

export type ResolvedDevice = {
  __typename?: 'ResolvedDevice';
  accountNumber?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<DeviceResolutionKind>;
  otherContractId?: Maybe<Scalars['String']['output']>;
  otherContractNumber?: Maybe<Scalars['String']['output']>;
  otherCustomerName?: Maybe<Scalars['String']['output']>;
  otherStockSaleId?: Maybe<Scalars['String']['output']>;
  otherTokenDaysShortfall?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  stockItemId?: Maybe<Scalars['String']['output']>;
  tokenDaysShortfall?: Maybe<Scalars['Int']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  warnings?: Maybe<Array<DeviceReassignmentWarning>>;
};

export type RestoreStockItemsInput = {
  ids: Array<Scalars['String']['input']>;
  status: StockItemRestoreStatus;
  stockingPointId: Scalars['String']['input'];
};

export type ReturnContractAccessoryInput = {
  damaged?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reason: ContractAccessoryReturnReason;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type ReturnToHeadOffice = {
  __typename?: 'ReturnToHeadOffice';
  agentName?: Maybe<Scalars['String']['output']>;
  approvalRequestId?: Maybe<Scalars['String']['output']>;
  approvalStatus?: Maybe<ApprovalStatus>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  declinedCount?: Maybe<Scalars['Int']['output']>;
  /** The devices turned down, which stayed with the agent. */
  declinedDevices?: Maybe<Array<ReturnToHeadOfficeDevice>>;
  destinationStockingPointId?: Maybe<Scalars['String']['output']>;
  destinationStockingPointName?: Maybe<Scalars['String']['output']>;
  /** Devices on it: submitted while it awaits approval, accepted after. */
  deviceCount?: Maybe<Scalars['Int']['output']>;
  /** Before review the devices submitted; after, the ones Head Office accepted. */
  devices?: Maybe<Array<ReturnToHeadOfficeDevice>>;
  dispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of its Staged Transfer. */
  id?: Maybe<Scalars['ID']['output']>;
  manifestAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Where the Return Manifest PDF downloads from, once it is approved. */
  manifestUrl?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  returnNumber?: Maybe<Scalars['String']['output']>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  shippingCompanyName?: Maybe<Scalars['String']['output']>;
  sourceStockingPointId?: Maybe<Scalars['String']['output']>;
  sourceStockingPointName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ReturnToHeadOfficeStatus>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedById?: Maybe<Scalars['String']['output']>;
  submittedByName?: Maybe<Scalars['String']['output']>;
  transfer?: Maybe<StockTransfer>;
  transferStatus?: Maybe<TransferStatus>;
  waybillReference?: Maybe<Scalars['String']['output']>;
};

export type ReturnToHeadOfficeDevice = {
  __typename?: 'ReturnToHeadOfficeDevice';
  accountNumber?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<StockItemCondition>;
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  recentHistory?: Maybe<Array<DeviceHistoryEntry>>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StockItemStatus>;
  stockItemId?: Maybe<Scalars['String']['output']>;
};

export type ReturnToHeadOfficeListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ReturnToHeadOfficeStatus>>;
};

export type ReturnToHeadOfficeListResult = {
  __typename?: 'ReturnToHeadOfficeListResult';
  items?: Maybe<Array<ReturnToHeadOffice>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReturnToHeadOfficeStatus =
  | 'AWAITING_APPROVAL'
  | 'AWAITING_PICKUP'
  | 'CANCELLED'
  | 'IN_TRANSIT'
  | 'RECEIVED'
  | 'REJECTED';

export type ReturnToHeadOfficeStatusCount = {
  __typename?: 'ReturnToHeadOfficeStatusCount';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ReturnToHeadOfficeStatus>;
};

export type ReturnableDevice = {
  __typename?: 'ReturnableDevice';
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Why it cannot go on a return now. Null when it can. */
  blockedReason?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<StockItemCondition>;
  productName?: Maybe<Scalars['String']['output']>;
  recentHistory?: Maybe<Array<DeviceHistoryEntry>>;
  /** The hold submitting takes it off: another transfer not yet dispatched, or a credit reservation. Not restored if Head Office turns it down. */
  releases?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StockItemStatus>;
  stockItemId?: Maybe<Scalars['String']['output']>;
};

export type ReturnableDeviceListResult = {
  __typename?: 'ReturnableDeviceListResult';
  items?: Maybe<Array<ReturnableDevice>>;
  stockingPointName?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A device's stored token credentials, read back for one device on request. The only place the schema returns a stored device key — everything else reports meterHasSecretKey, its presence and nothing more. */
export type RevealedDeviceSecret = {
  __typename?: 'RevealedDeviceSecret';
  /** Serial, or the account number when the unit has no serial yet. */
  identifier: Scalars['String']['output'];
  jobId: Scalars['ID']['output'];
  /** Null when nothing is stored, which is a device nobody has keyed yet. */
  secretKey?: Maybe<Scalars['String']['output']>;
  /** Returned alongside so the form does not need a second round trip. */
  tokenCount?: Maybe<Scalars['Int']['output']>;
};

export type RevealedThirdPartyCredential = {
  __typename?: 'RevealedThirdPartyCredential';
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ReversalBlockedItem = {
  __typename?: 'ReversalBlockedItem';
  identifier?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ReviewAgentInviteInput = {
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  status: ReviewDecision;
};

export type ReviewApprovalInput = {
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  status: ReviewDecision;
};

export type ReviewCycle = {
  __typename?: 'ReviewCycle';
  completedCount: Scalars['Int']['output'];
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  reviewCount: Scalars['Int']['output'];
};

export type ReviewCycleInput = {
  dueDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};

export type ReviewCycleSummary = {
  __typename?: 'ReviewCycleSummary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
};

export type ReviewDecision =
  | 'APPROVED'
  | 'REJECTED';

export type ReviewReturnToHeadOfficeInput = {
  acceptedStockItemIds: Array<Scalars['String']['input']>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
};

export type Role = {
  __typename?: 'Role';
  accessLevel?: Maybe<Scalars['String']['output']>;
  assignableForAgents?: Maybe<Scalars['Boolean']['output']>;
  canManageAgents?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  grantableRoles?: Maybe<Array<Role>>;
  homeModule?: Maybe<HomeModule>;
  id?: Maybe<Scalars['ID']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<RolePermission>>;
  requiresWorkshop?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userRoles?: Maybe<Array<UserRole>>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  action?: Maybe<Scalars['String']['output']>;
  granted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  module?: Maybe<Module>;
  role?: Maybe<Role>;
};

export type RolePermissionInput = {
  action: Scalars['String']['input'];
  granted: Scalars['Boolean']['input'];
  moduleCode: Scalars['String']['input'];
};

export type RotateApiConsumerSecretResult = {
  __typename?: 'RotateApiConsumerSecretResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  consumer?: Maybe<ApiConsumer>;
};

export type RotateWebhookSecretResult = {
  __typename?: 'RotateWebhookSecretResult';
  secret: Scalars['String']['output'];
  subscription: WebhookSubscription;
};

export type RunCommissionInput = {
  periodDate: Scalars['DateTime']['input'];
};

export type RunningCommissionFigure = {
  __typename?: 'RunningCommissionFigure';
  agentId: Scalars['String']['output'];
  agentName: Scalars['String']['output'];
  computedAt: Scalars['DateTime']['output'];
  feeCents: Scalars['Int']['output'];
  monthlyAmountCents: Scalars['Int']['output'];
  paidUnits: Scalars['Int']['output'];
  periodDate: Scalars['DateTime']['output'];
  saleCommissionCents: Scalars['Int']['output'];
  saleMonths: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

export type SafetyCorrectiveAction = {
  __typename?: 'SafetyCorrectiveAction';
  description: Scalars['String']['output'];
  /** Null = still open. */
  doneDate?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<SafetyUser>;
};

export type SafetyDepartment = {
  __typename?: 'SafetyDepartment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SafetyEmployee = {
  __typename?: 'SafetyEmployee';
  departmentName?: Maybe<Scalars['String']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type SafetyIncident = {
  __typename?: 'SafetyIncident';
  actions: Array<SafetyCorrectiveAction>;
  closedDate?: Maybe<Scalars['DateTime']['output']>;
  coidaClaimNumber?: Maybe<Scalars['String']['output']>;
  coidaClaimStatus?: Maybe<CoidaClaimStatus>;
  createdAt: Scalars['DateTime']['output'];
  department?: Maybe<SafetyDepartment>;
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<SafetyEmployee>;
  evidence: Array<SafetyIncidentEvidence>;
  id: Scalars['ID']['output'];
  /** Health information (POPIA special). */
  injuryDetails?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lostDays?: Maybe<Scalars['Int']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  /** Reportable to the Department of Employment and Labour. Null = not assessed. */
  reportable?: Maybe<Scalars['Boolean']['output']>;
  reportedBy?: Maybe<SafetyUser>;
  rootCause?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<SafetyIncidentSeverity>;
  status: SafetyIncidentStatus;
  subcontractor?: Maybe<SafetySubcontractor>;
  subcontractorWorker?: Maybe<SafetyWorker>;
  type?: Maybe<SafetyIncidentType>;
};

/** Download from GET /api/hr/safety-evidence/:id (hr_safety:view). */
export type SafetyIncidentEvidence = {
  __typename?: 'SafetyIncidentEvidence';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type SafetyIncidentFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<SafetyIncidentSeverity>>;
  statuses?: InputMaybe<Array<SafetyIncidentStatus>>;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<SafetyIncidentType>>;
};

export type SafetyIncidentList = {
  __typename?: 'SafetyIncidentList';
  items: Array<SafetyIncident>;
  totalCount: Scalars['Int']['output'];
};

export type SafetyIncidentSeverity =
  | 'FATALITY'
  | 'FIRST_AID'
  | 'LOST_TIME'
  | 'MEDICAL_TREATMENT';

/** Incidents in the range by severity. A null severity is "Not recorded". */
export type SafetyIncidentSeverityCount = {
  __typename?: 'SafetyIncidentSeverityCount';
  count: Scalars['Int']['output'];
  severity?: Maybe<SafetyIncidentSeverity>;
};

export type SafetyIncidentStatus =
  | 'CLOSED'
  | 'INVESTIGATING'
  | 'OPEN';

export type SafetyIncidentType =
  | 'ENVIRONMENTAL'
  | 'INJURY'
  | 'NEAR_MISS'
  | 'OCCUPATIONAL_DISEASE'
  | 'PROPERTY_DAMAGE'
  | 'VEHICLE';

/** Incidents in the range by type. A null type is "Not recorded". */
export type SafetyIncidentTypeCount = {
  __typename?: 'SafetyIncidentTypeCount';
  count: Scalars['Int']['output'];
  type?: Maybe<SafetyIncidentType>;
};

export type SafetyInspection = {
  __typename?: 'SafetyInspection';
  area: Scalars['String']['output'];
  department?: Maybe<SafetyDepartment>;
  findingsCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  inspectionDate: Scalars['DateTime']['output'];
  inspectorName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  scorePercent?: Maybe<Scalars['Float']['output']>;
  type: SafetyInspectionType;
};

export type SafetyInspectionFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<SafetyInspectionType>>;
};

export type SafetyInspectionList = {
  __typename?: 'SafetyInspectionList';
  items: Array<SafetyInspection>;
  totalCount: Scalars['Int']['output'];
};

export type SafetyInspectionType =
  | 'AUDIT'
  | 'INSPECTION';

/** The Health & Safety figures (ADR-0068). An area with nothing recorded is MISSING; hours worked are never guessed. */
export type SafetyMetrics = {
  __typename?: 'SafetyMetrics';
  /** Average score of the inspections in the range. No score: notRecorded. */
  averageInspectionScore: HrMetric;
  /** Days from the last lost-time injury to the end of the range (or today). NOT_APPLICABLE when there has been none. */
  daysSinceLastLostTimeInjury: HrMetric;
  /** Hours employees worked. NOT_APPLICABLE until attendance is in the CRM (ADR-0061 step 10). */
  employeeHoursWorked: HrMetric;
  /** Incidents with severity FATALITY. */
  fatalities: HrMetric;
  from: Scalars['DateTime']['output'];
  /** Incidents that happened in the range. */
  incidents: HrMetric;
  incidentsBySeverity: Array<SafetyIncidentSeverityCount>;
  incidentsByType: Array<SafetyIncidentTypeCount>;
  /** Findings raised by the inspections in the range. */
  inspectionFindings: HrMetric;
  /** Inspections and audits in the range. */
  inspections: HrMetric;
  /** Working days lost to those lost-time injuries. LTIs with no lost days: notRecorded. */
  lostDays: HrMetric;
  /** Incidents with severity LOST_TIME or FATALITY. Severity not recorded where someone may have been hurt: notRecorded. */
  lostTimeInjuries: HrMetric;
  /** Lost-time injuries × 1,000,000 ÷ hours worked, everyone. NOT_APPLICABLE until employee hours are in the CRM. */
  ltifr: HrMetric;
  /** Incidents of type NEAR_MISS. Type not recorded: notRecorded. */
  nearMisses: HrMetric;
  /** Corrective actions not done yet, today. */
  openCorrectiveActions: HrMetric;
  /** Open corrective actions past their due date. No due date: notRecorded. */
  overdueCorrectiveActions: HrMetric;
  /** Incidents reportable to the Department of Employment and Labour. Not assessed: notRecorded. */
  reportableIncidents: HrMetric;
  /** Subcontractor workers' hours whose period ends in the range. NOT_APPLICABLE under a department filter. */
  subcontractorHoursWorked: HrMetric;
  /** Subcontractor lost-time injuries × 1,000,000 ÷ subcontractor hours. MISSING when no hours are recorded. */
  subcontractorLtifr: HrMetric;
  to: Scalars['DateTime']['output'];
};

export type SafetyMetricsFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SafetySubcontractor = {
  __typename?: 'SafetySubcontractor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A subcontractor and its active workers, to name on an incident. */
export type SafetySubcontractorOption = {
  __typename?: 'SafetySubcontractorOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  workers: Array<SafetyWorker>;
};

export type SafetyUser = {
  __typename?: 'SafetyUser';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/** A subcontractor's worker named on an incident. */
export type SafetyWorker = {
  __typename?: 'SafetyWorker';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type SaleStatus =
  | 'CLOSED'
  | 'COMPLETED'
  | 'REVERSED';

export type SalesAppMessage = {
  __typename?: 'SalesAppMessage';
  agentIds: Array<Scalars['String']['output']>;
  alreadySent?: Maybe<Scalars['Int']['output']>;
  attempts: Scalars['Int']['output'];
  audience: SalesAppMessageAudience;
  category: SalesAppMessageCategory;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  resentFromId?: Maybe<Scalars['ID']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentByName?: Maybe<Scalars['String']['output']>;
  sentTo?: Maybe<Scalars['Int']['output']>;
  status: SalesAppMessageStatus;
  title: Scalars['String']['output'];
  unknownAgentIds: Array<Scalars['String']['output']>;
};

export type SalesAppMessageAudience =
  | 'EVERYONE'
  | 'PICKED';

export type SalesAppMessageCategory =
  | 'ANNOUNCEMENT'
  | 'PROMOTION';

export type SalesAppMessageListResult = {
  __typename?: 'SalesAppMessageListResult';
  items: Array<SalesAppMessage>;
  totalCount: Scalars['Int']['output'];
};

export type SalesAppMessageStatus =
  | 'FAILED'
  | 'PENDING'
  | 'REJECTED'
  | 'SENT';

export type SalesByAgent = {
  __typename?: 'SalesByAgent';
  agentId?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  agentSalesId?: Maybe<Scalars['String']['output']>;
  salesCount?: Maybe<Scalars['Int']['output']>;
};

/** A National Sales Manager the book files agents under. */
export type SalesContributionNsm = {
  __typename?: 'SalesContributionNsm';
  nsmAvatarUrl?: Maybe<Scalars['String']['output']>;
  nsmEmail: Scalars['String']['output'];
  nsmId: Scalars['String']['output'];
  nsmName: Scalars['String']['output'];
  regionId?: Maybe<Scalars['String']['output']>;
};

/** One agent's sales of one product over each span the report compares. A sale is a contract in the period its deposit cleared, as the EDF count and the Marketing overview have it. */
export type SalesContributionProductLine = {
  __typename?: 'SalesContributionProductLine';
  mtd: Scalars['Int']['output'];
  mtdDelinquent: Scalars['Int']['output'];
  previousThreeMonths: Scalars['Int']['output'];
  product: Scalars['String']['output'];
  sameDaysLastYear: Scalars['Int']['output'];
  ytd: Scalars['Int']['output'];
  ytdDelinquent: Scalars['Int']['output'];
};

/** A Sales Region: the National Sales Managers assigned to it in Settings. */
export type SalesContributionRegion = {
  __typename?: 'SalesContributionRegion';
  emblemUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  regionId: Scalars['String']['output'];
};

/** Units sold by the field force over a month and the year to it, per selling agent and product, with the sales that have since gone bad. */
export type SalesContributionReport = {
  __typename?: 'SalesContributionReport';
  closingDate: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  lastYearClosingDate: Scalars['DateTime']['output'];
  lastYearStart: Scalars['DateTime']['output'];
  month: Scalars['String']['output'];
  monthStart: Scalars['DateTime']['output'];
  nsms: Array<SalesContributionNsm>;
  partialMonth: Scalars['Boolean']['output'];
  previousThreeMonthsStart: Scalars['DateTime']['output'];
  products: Array<Scalars['String']['output']>;
  regions: Array<SalesContributionRegion>;
  sellers: Array<SalesContributionSeller>;
  yearStart: Scalars['DateTime']['output'];
};

/** One sale behind the Sales Contribution counts: a contract, on the day its deposit cleared. File it with the report's sellers by agentId. */
export type SalesContributionSale = {
  __typename?: 'SalesContributionSale';
  accountNumber?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
  contractNumber: Scalars['String']['output'];
  contractStatus: ContractStatus;
  customerName?: Maybe<Scalars['String']['output']>;
  delinquent: Scalars['Boolean']['output'];
  product: Scalars['String']['output'];
  saleDate: Scalars['DateTime']['output'];
};

/** One selling agent, filed under the distributor and National Sales Manager the Total Customer Book files them under. */
export type SalesContributionSeller = {
  __typename?: 'SalesContributionSeller';
  agentAvatarUrl?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  agentSalesId?: Maybe<Scalars['String']['output']>;
  agentStatus?: Maybe<AgentStatus>;
  agentType?: Maybe<AgentType>;
  distributorId?: Maybe<Scalars['String']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  nsmId?: Maybe<Scalars['String']['output']>;
  products: Array<SalesContributionProductLine>;
};

/** The span a sales list covers: the month to date, or the year to date. */
export type SalesContributionSpan =
  | 'MTD'
  | 'YTD';

/** A territory National Sales Managers are assigned to — Inland, Coastal, North — for reporting sales by region. */
export type SalesRegion = {
  __typename?: 'SalesRegion';
  emblemUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managers: Array<SalesRegionManager>;
  name: Scalars['String']['output'];
};

/** A member agents report to as their National Sales Manager, with the Sales Region they cover. */
export type SalesRegionManager = {
  __typename?: 'SalesRegionManager';
  agents: Scalars['Int']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  salesRegionId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type SalesWorkbook = {
  __typename?: 'SalesWorkbook';
  contentBase64?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  payAtLinesWithoutFees?: Maybe<Scalars['Int']['output']>;
};

export type ScheduleCommissionApproachInput = {
  approach: CommissionApproach;
  /** Any instant in the first month the approach applies to; snapped to that month. */
  fromPeriod: Scalars['DateTime']['input'];
};

export type SellerCorrection = {
  __typename?: 'SellerCorrection';
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Unpaid distributor commission given up because the new seller has no distributor. */
  cancelledAmountCents?: Maybe<Scalars['Int']['output']>;
  cancelledEntryCount?: Maybe<Scalars['Int']['output']>;
  correctedByName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  fromAgentId?: Maybe<Scalars['String']['output']>;
  fromAgentName?: Maybe<Scalars['String']['output']>;
  fromDistributorName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  movedEntryCount?: Maybe<Scalars['Int']['output']>;
  /** Commission already PAID on the sale that stayed with the previous seller or distributor. */
  paidAmountCents?: Maybe<Scalars['Int']['output']>;
  paidEntryCount?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  saleReference?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<SellerCorrectionSource>;
  stockSaleId?: Maybe<Scalars['String']['output']>;
  toAgentId?: Maybe<Scalars['String']['output']>;
  toAgentName?: Maybe<Scalars['String']['output']>;
  toDistributorName?: Maybe<Scalars['String']['output']>;
};

export type SellerCorrectionAgent = {
  __typename?: 'SellerCorrectionAgent';
  agentType?: Maybe<AgentType>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  salesId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AgentStatus>;
};

export type SellerCorrectionInput = {
  fromAgentId: Scalars['String']['input'];
  stockSaleId: Scalars['String']['input'];
  toAgentId: Scalars['String']['input'];
};

export type SellerCorrectionListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SellerCorrectionListResult = {
  __typename?: 'SellerCorrectionListResult';
  items: Array<SellerCorrection>;
  totalCount: Scalars['Int']['output'];
};

export type SellerCorrectionOutcome =
  | 'APPLIED'
  | 'SKIPPED';

export type SellerCorrectionPreview = {
  __typename?: 'SellerCorrectionPreview';
  okCount?: Maybe<Scalars['Int']['output']>;
  problemCount?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<SellerCorrectionPreviewRow>>;
};

export type SellerCorrectionPreviewRow = {
  __typename?: 'SellerCorrectionPreviewRow';
  accountNumber?: Maybe<Scalars['String']['output']>;
  from?: Maybe<AgentNameMatch>;
  message?: Maybe<Scalars['String']['output']>;
  moveFrom?: Maybe<Scalars['String']['output']>;
  moveTo?: Maybe<Scalars['String']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  sale?: Maybe<SellerCorrectionSale>;
  to?: Maybe<AgentNameMatch>;
  verdict?: Maybe<SellerCorrectionVerdict>;
};

export type SellerCorrectionRowResult = {
  __typename?: 'SellerCorrectionRowResult';
  cancelledAmountCents?: Maybe<Scalars['Int']['output']>;
  /** Unpaid distributor entries given up, wholly or in part, because the new seller has no distributor. */
  cancelledEntryCount?: Maybe<Scalars['Int']['output']>;
  correctionId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  movedEntryCount?: Maybe<Scalars['Int']['output']>;
  outcome?: Maybe<SellerCorrectionOutcome>;
  paidAmountCents?: Maybe<Scalars['Int']['output']>;
  paidEntryCount?: Maybe<Scalars['Int']['output']>;
  saleReference?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<SellerCorrectionSkipReason>;
  stockSaleId?: Maybe<Scalars['String']['output']>;
};

export type SellerCorrectionSale = {
  __typename?: 'SellerCorrectionSale';
  accountNumber?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  distributor?: Maybe<SellerCorrectionAgent>;
  distributorPinned?: Maybe<Scalars['Boolean']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
  saleReference?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<SellerCorrectionAgent>;
  sellerPaidAmountCents?: Maybe<Scalars['Int']['output']>;
  sellerPaidEntryCount?: Maybe<Scalars['Int']['output']>;
  sellerUnpaidAmountCents?: Maybe<Scalars['Int']['output']>;
  sellerUnpaidEntryCount?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SaleStatus>;
  stockSaleId?: Maybe<Scalars['ID']['output']>;
};

export type SellerCorrectionSkipReason =
  | 'AGENT_NOT_FOUND'
  | 'ALREADY_ON_AGENT'
  | 'COMMISSION_CONFLICT'
  | 'SALE_NOT_FOUND'
  | 'SELLER_CHANGED';

export type SellerCorrectionSource =
  | 'SEARCH'
  | 'UPLOAD';

/** What one row of an uploaded correction sheet would do. Only OK rows can be applied as they stand. */
export type SellerCorrectionVerdict =
  | 'AGENT_AMBIGUOUS'
  | 'AGENT_NOT_FOUND'
  | 'ALREADY_ON_AGENT'
  | 'DUPLICATE_ROW'
  | 'OK'
  | 'SALE_NOT_FOUND'
  | 'SELLER_NOT_FROM'
  | 'SEVERAL_LIVE_SALES';

/** One agent on the top sellers board: completed sales, warranty swaps excluded. */
export type SellerRank = {
  __typename?: 'SellerRank';
  agentId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  salesId: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

export type SendInviteInput = {
  agentCategoryId?: InputMaybe<Scalars['String']['input']>;
  agentType?: InputMaybe<AgentType>;
  canDoReplacements?: InputMaybe<Scalars['Boolean']['input']>;
  canHoldStock?: InputMaybe<Scalars['Boolean']['input']>;
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  dormantAgentId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expectedParentExternalId?: InputMaybe<Scalars['String']['input']>;
  externalAgentId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAgent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  parentAgentId?: InputMaybe<Scalars['String']['input']>;
  parentUserId?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  stockingPointIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendSalesAppMessageInput = {
  agentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  category: SalesAppMessageCategory;
  clientRequestId?: InputMaybe<Scalars['String']['input']>;
  everyone?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  resentFromId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type SendSmsCampaignInput = {
  confirmCount: Scalars['Int']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A permission that needs a reason and an end date to give by hand (ADR-0078). */
export type SensitivePermission = {
  __typename?: 'SensitivePermission';
  action?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  moduleCode?: Maybe<Scalars['String']['output']>;
};

export type SerialValidationResult = {
  __typename?: 'SerialValidationResult';
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Populated only for callers with stock:assign_override; null otherwise. */
  currentLocationName?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  hasMeter: Scalars['Boolean']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  /** Populated only for callers with stock:assign_override; null otherwise. */
  requiresOverride?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Canonical serial of the matched device — null for non-serial-tracked items,
   * which are only ever addressable by account number.
   */
  serialNumber?: Maybe<Scalars['String']['output']>;
  stockItemId?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** The period one point on a trend series covers. */
export type SeriesBucket =
  | 'DAY'
  | 'MONTH'
  | 'WEEK';

export type SetInboundSignatureInput = {
  mode: WebhookSignatureMode;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type SetMailingListScheduleInput = {
  frequency: MailingListFrequency;
  list: MailingListName;
  sendAt: Scalars['String']['input'];
  startsOn: Scalars['String']['input'];
};

export type SetupDeviceMeterInput = {
  meterTypeId: Scalars['Int']['input'];
  secretKey?: InputMaybe<Scalars['String']['input']>;
  startingCode?: InputMaybe<Scalars['String']['input']>;
  stockItemId: Scalars['String']['input'];
};

export type Shipment = {
  __typename?: 'Shipment';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  courier?: Maybe<Courier>;
  courierDeliveredAt?: Maybe<Scalars['String']['output']>;
  deliveredSeenAt?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  events?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  state?: Maybe<ShipmentState>;
  statusLabel?: Maybe<Scalars['String']['output']>;
  stockTransfer?: Maybe<StockTransfer>;
  waybillNumber?: Maybe<Scalars['String']['output']>;
};

export type ShipmentState =
  | 'DELIVERED'
  | 'EXCEPTION'
  | 'IN_TRANSIT'
  | 'NOT_FOUND'
  | 'PENDING'
  | 'RETURNED';

export type ShippingCompany = {
  __typename?: 'ShippingCompany';
  contactPerson?: Maybe<Scalars['String']['output']>;
  courier?: Maybe<Courier>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']['output']>;
  trackingUrlTemplate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShippingCompanyListInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingCompanyListResult = {
  __typename?: 'ShippingCompanyListResult';
  items: Array<ShippingCompany>;
  totalCount: Scalars['Int']['output'];
};

export type ShippingDetailsInput = {
  shippingCompanyId?: InputMaybe<Scalars['String']['input']>;
  waybillReference?: InputMaybe<Scalars['String']['input']>;
};

export type SignAgreementInput = {
  consentAccepted: Scalars['Boolean']['input'];
  party: AgreementPartyDetailsInput;
  signatureImage?: InputMaybe<Scalars['String']['input']>;
  signatureMethod: AgreementSignatureMethod;
};

export type SkippedPayout = {
  __typename?: 'SkippedPayout';
  agentId?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type SmsCallback = {
  __typename?: 'SmsCallback';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  kind: SmsCallbackKind;
  messageAt?: Maybe<Scalars['DateTime']['output']>;
  payload: Scalars['JSON']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  providerMessageId?: Maybe<Scalars['String']['output']>;
  sentMessageText?: Maybe<Scalars['String']['output']>;
  smsLog?: Maybe<SmsLog>;
  state?: Maybe<Scalars['String']['output']>;
  statusAt?: Maybe<Scalars['DateTime']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SmsCallbackKind =
  | 'DELIVERY_REPORT'
  | 'REPLY'
  | 'UNKNOWN';

export type SmsCallbackListInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<SmsCallbackKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SmsCallbackListResult = {
  __typename?: 'SmsCallbackListResult';
  items: Array<SmsCallback>;
  states: Array<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type SmsCampaign = {
  __typename?: 'SmsCampaign';
  audience: Scalars['JSON']['output'];
  batches: Array<SmsCampaignBatch>;
  body: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  copiedFromId?: Maybe<Scalars['String']['output']>;
  counts: SmsCampaignCounts;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  sentByName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SmsCampaignStatus;
};

export type SmsCampaignAudienceInput = {
  contractIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  csvRows?: InputMaybe<Array<SmsCampaignCsvRowInput>>;
  statuses?: InputMaybe<Array<SmsCampaignStatusOption>>;
  typedNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** One batch of a campaign: as many people as 90% of the credit balance covered when it was approved. */
export type SmsCampaignBatch = {
  __typename?: 'SmsCampaignBatch';
  approvedByName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creditBalance: Scalars['Int']['output'];
  credits: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  recipients: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type SmsCampaignCounts = {
  __typename?: 'SmsCampaignCounts';
  delivered: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SmsCampaignCsvRowInput = {
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SmsCampaignDraftInput = {
  audience: SmsCampaignAudienceInput;
  body: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SmsCampaignListResult = {
  __typename?: 'SmsCampaignListResult';
  items: Array<SmsCampaign>;
  totalCount: Scalars['Int']['output'];
};

export type SmsCampaignPreview = {
  __typename?: 'SmsCampaignPreview';
  creditBalance?: Maybe<Scalars['Int']['output']>;
  creditsNeeded: Scalars['Int']['output'];
  duplicates: Scalars['Int']['output'];
  maxParts: Scalars['Int']['output'];
  recipients: Scalars['Int']['output'];
  samples: Array<Scalars['String']['output']>;
  skipped: Array<SmsCampaignSkipCount>;
};

export type SmsCampaignRecipient = {
  __typename?: 'SmsCampaignRecipient';
  attempts: Scalars['Int']['output'];
  contractNumber?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  deliveryState?: Maybe<Scalars['String']['output']>;
  deliveryStateAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parts: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  source: SmsCampaignRecipientSource;
  status: SmsCampaignRecipientStatus;
};

export type SmsCampaignRecipientListResult = {
  __typename?: 'SmsCampaignRecipientListResult';
  items: Array<SmsCampaignRecipient>;
  totalCount: Scalars['Int']['output'];
};

export type SmsCampaignRecipientSource =
  /** A row of the uploaded list */
  | 'CSV'
  /** A contract picked by hand */
  | 'PICKED'
  /** A contract with one of the chosen statuses */
  | 'STATUS'
  /** A number typed in */
  | 'TYPED';

export type SmsCampaignRecipientStatus =
  | 'FAILED'
  | 'PENDING'
  | 'SENT'
  | 'SKIPPED';

export type SmsCampaignSkipCount = {
  __typename?: 'SmsCampaignSkipCount';
  count: Scalars['Int']['output'];
  reason: SmsCampaignSkipReason;
};

export type SmsCampaignSkipReason =
  | 'CONTRACT_NOT_FOUND'
  | 'INVALID_PHONE'
  | 'NO_PHONE'
  | 'OPTED_OUT'
  | 'REPOSSESSED';

export type SmsCampaignStatus =
  | 'AWAITING_APPROVAL'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'DRAFT'
  | 'PAUSED'
  | 'SCHEDULED'
  | 'SENDING';

export type SmsCampaignStatusOption =
  | 'CANCELLED'
  | 'DELINQUENT_TIER_1'
  | 'DELINQUENT_TIER_2'
  | 'DELINQUENT_TIER_3'
  | 'DELINQUENT_TIER_4'
  | 'IN_CREDIT'
  | 'PAID_OFF'
  | 'PENDING_INSTALLATION'
  | 'WRITTEN_OFF';

export type SmsDeliveryFilter =
  | 'AWAITING'
  | 'DELIVERED'
  | 'FAILED'
  | 'REJECTED';

export type SmsEncoding =
  | 'GSM'
  | 'UNICODE';

export type SmsLog = {
  __typename?: 'SmsLog';
  accepted: Scalars['Boolean']['output'];
  cellNumber?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerNumber?: Maybe<Scalars['String']['output']>;
  deliveryState?: Maybe<Scalars['String']['output']>;
  deliveryStateAt?: Maybe<Scalars['DateTime']['output']>;
  gatewayResult?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loadedAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  providerMessageId?: Maybe<Scalars['String']['output']>;
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SmsType>;
};

export type SmsLogListInput = {
  delivery?: InputMaybe<SmsDeliveryFilter>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<SmsType>;
};

export type SmsLogListResult = {
  __typename?: 'SmsLogListResult';
  items: Array<SmsLog>;
  platforms: Array<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type SmsMessageSize = {
  __typename?: 'SmsMessageSize';
  characters: Scalars['Int']['output'];
  encoding: SmsEncoding;
  parts: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type SmsOptOut = {
  __typename?: 'SmsOptOut';
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phone: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type SmsOptOutListResult = {
  __typename?: 'SmsOptOutListResult';
  items: Array<SmsOptOut>;
  totalCount: Scalars['Int']['output'];
};

export type SmsType =
  | 'CAMPAIGN'
  | 'NOTIFICATION'
  | 'OTP'
  | 'PAYMENT'
  | 'TOKEN';

export type SourceOfLight =
  | 'BIOGAS_LAMPS'
  | 'CANDLES'
  | 'ELECTRICITY'
  | 'FIXED_SOLAR_PANEL'
  | 'GENERATOR'
  | 'HURRICANE_LANTERN'
  | 'KEROSENE_LAMP'
  | 'OTHER'
  | 'PRESSURE_LAMP'
  | 'SOLAR_LANTERN';

export type SourcePartRequestInput = {
  purchaseOrderId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  route: PartRequestRoute;
  sourceStockingPointId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  unitCostCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Counted items received and issued by month, and the latest movements. */
export type StockActivity = {
  __typename?: 'StockActivity';
  months: Array<StockActivityMonth>;
  recent: Array<StockCardMovement>;
};

export type StockActivityMonth = {
  __typename?: 'StockActivityMonth';
  issued: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  received: Scalars['Int']['output'];
};

export type StockArriving = {
  __typename?: 'StockArriving';
  devices?: Maybe<Scalars['Int']['output']>;
  purchaseOrders?: Maybe<Scalars['Int']['output']>;
  transfers?: Maybe<Scalars['Int']['output']>;
  uploads?: Maybe<Scalars['Int']['output']>;
};

/** One product held at one place in one condition. A null stocking point is in transit. */
export type StockBalancePlace = {
  __typename?: 'StockBalancePlace';
  belowMinimum: Scalars['Boolean']['output'];
  minimum?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  stockingPointId: Scalars['String']['output'];
};

export type StockBalancePoint = {
  __typename?: 'StockBalancePoint';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: StockingPointType;
};

export type StockBalanceProduct = {
  __typename?: 'StockBalanceProduct';
  businessLineName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  itemCategoryName?: Maybe<Scalars['String']['output']>;
  kind: ProductKind;
  name: Scalars['String']['output'];
  requiresSerialTracking: Scalars['Boolean']['output'];
  sku: Scalars['String']['output'];
  unitOfMeasureName?: Maybe<Scalars['String']['output']>;
};

export type StockBalanceRow = {
  __typename?: 'StockBalanceRow';
  belowMinimumCount: Scalars['Int']['output'];
  damagedQuantity: Scalars['Int']['output'];
  inTransit: Scalars['Int']['output'];
  lastIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  onOrder: Scalars['Int']['output'];
  places: Array<StockBalancePlace>;
  product: StockBalanceProduct;
  total: Scalars['Int']['output'];
  unitCostCents?: Maybe<Scalars['Int']['output']>;
  valueCents?: Maybe<Scalars['Float']['output']>;
};

/** What is held, product by product, at every stocking point the reader may see. */
export type StockBalances = {
  __typename?: 'StockBalances';
  asAt: Scalars['DateTime']['output'];
  rows: Array<StockBalanceRow>;
  showsValue: Scalars['Boolean']['output'];
  stockingPoints: Array<StockBalancePoint>;
  unpricedProductCount: Scalars['Int']['output'];
  valueCents: Scalars['Float']['output'];
};

/** Stock by Tier for devices, with Accessories reported beside it by the same rules and never inside the device figures. */
export type StockByTierFullReport = {
  __typename?: 'StockByTierFullReport';
  accessories: StockByTierReport;
  generatedAt: Scalars['DateTime']['output'];
  points: Array<StockByTierPoint>;
  skus: Array<StockByTierSku>;
  totals: StockByTierTotals;
};

/** One place holding stock, and what it holds by SKU. Points holding nothing are left out. */
export type StockByTierPoint = {
  __typename?: 'StockByTierPoint';
  bySku: Array<StockByTierPointSku>;
  distributorKey?: Maybe<Scalars['String']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  province?: Maybe<Scalars['String']['output']>;
  stock: StockOnHand;
  stockingPointId: Scalars['String']['output'];
  tier: StockingPointType;
};

/** One SKU held at one stocking point. */
export type StockByTierPointSku = {
  __typename?: 'StockByTierPointSku';
  description: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  stock: StockOnHand;
};

/** Where every unit still held is standing, per SKU, across warehouse, distributors and agents. */
export type StockByTierReport = {
  __typename?: 'StockByTierReport';
  generatedAt: Scalars['DateTime']['output'];
  points: Array<StockByTierPoint>;
  skus: Array<StockByTierSku>;
  totals: StockByTierTotals;
};

/** One SKU across the tiers stock moves through: what the warehouse holds, what distributors hold, and what agents hold. */
export type StockByTierSku = {
  __typename?: 'StockByTierSku';
  atWarehouse: Scalars['Int']['output'];
  atWorkshop: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  incoming: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  sku: Scalars['String']['output'];
  stock: StockOnHand;
  withAgents: Scalars['Int']['output'];
  withDistributors: Scalars['Int']['output'];
};

/** The whole position, for reconciling the sheets against each other. */
export type StockByTierTotals = {
  __typename?: 'StockByTierTotals';
  agentCount: Scalars['Int']['output'];
  atWarehouse: Scalars['Int']['output'];
  atWorkshop: Scalars['Int']['output'];
  distributorCount: Scalars['Int']['output'];
  incoming: Scalars['Int']['output'];
  skuCount: Scalars['Int']['output'];
  stock: StockOnHand;
  totalUnits: Scalars['Int']['output'];
  withAgents: Scalars['Int']['output'];
  withDistributors: Scalars['Int']['output'];
};

/** One device Stock by Tier counts as on hand. The list is as long as the device on-hand figure. */
export type StockByTierUnit = {
  __typename?: 'StockByTierUnit';
  accountNumber?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  province?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  status: StockItemStatus;
  stockType?: Maybe<Scalars['String']['output']>;
  stockingPoint?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<StockingPointType>;
};

/** One item: where it is, what is on order, and its movements since a date. */
export type StockCard = {
  __typename?: 'StockCard';
  closingBalance: Scalars['Int']['output'];
  from: Scalars['DateTime']['output'];
  lastReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  movements: Array<StockCardMovement>;
  openOrders: Array<OpenOrderLine>;
  openingBalance: Scalars['Int']['output'];
  row?: Maybe<StockBalanceRow>;
  showsValue: Scalars['Boolean']['output'];
  stockingPoints: Array<StockBalancePoint>;
  tracksMovements: Scalars['Boolean']['output'];
};

export type StockCardMovement = {
  __typename?: 'StockCardMovement';
  at: Scalars['DateTime']['output'];
  balance?: Maybe<Scalars['Int']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productSku: Scalars['String']['output'];
  quantityIn: Scalars['Int']['output'];
  quantityOut: Scalars['Int']['output'];
  reason: StockMovementReason;
  recordedByName?: Maybe<Scalars['String']['output']>;
  storeName: Scalars['String']['output'];
};

export type StockCondition =
  | 'DAMAGED'
  | 'NEW'
  | 'REFURBISHED'
  | 'USED';

export type StockImportBatch = {
  __typename?: 'StockImportBatch';
  awaitingReceipt?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deviceTypeName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  importedByName?: Maybe<Scalars['String']['output']>;
  importedCount?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedByName?: Maybe<Scalars['String']['output']>;
  reversedAt?: Maybe<Scalars['DateTime']['output']>;
  reversedByName?: Maybe<Scalars['String']['output']>;
  reversible?: Maybe<Scalars['Boolean']['output']>;
  shipment?: Maybe<Shipment>;
  shippingCompany?: Maybe<ShippingCompany>;
  stockTypeName?: Maybe<Scalars['String']['output']>;
  stockingPoint?: Maybe<StockingPoint>;
  waybillReference?: Maybe<Scalars['String']['output']>;
};

export type StockImportReversalResult = {
  __typename?: 'StockImportReversalResult';
  blocked?: Maybe<Array<ReversalBlockedItem>>;
  reversed?: Maybe<Scalars['Int']['output']>;
};

export type StockItem = {
  __typename?: 'StockItem';
  accountNumber?: Maybe<Scalars['String']['output']>;
  archiveEvents?: Maybe<Array<StockItemArchiveEvent>>;
  condition?: Maybe<StockItemCondition>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deviceType?: Maybe<DeviceType>;
  hasMeter: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isMigrated?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<StockKind>;
  meterHasSecretKey: Scalars['Boolean']['output'];
  /** Which platform mints this device's tokens. ANGAZA marks the devices that stay on Angaza permanently — Angaza issues their token, we do not. KES is everything we mint for, and is what an unmarked device answers. */
  meterHostedOn: MeterHost;
  meterStartingCode?: Maybe<Scalars['String']['output']>;
  /** How many tokens this device's meter has accepted, so the next token in the sequence is this plus one. Null means no meter at all; 0 means a meter that has never vended, which is a different fact. */
  meterTokenCount?: Maybe<Scalars['Int']['output']>;
  meterTypeId?: Maybe<Scalars['Int']['output']>;
  meterTypeName?: Maybe<Scalars['String']['output']>;
  /** What is carrying this device while it is at no stocking point, with its courier tracking when there is a waybill. */
  onTheWay?: Maybe<DeviceOnTheWay>;
  organization?: Maybe<Organization>;
  product?: Maybe<Product>;
  productName?: Maybe<Scalars['String']['output']>;
  productSku?: Maybe<Scalars['String']['output']>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  reassignedFrom?: Maybe<Array<DeviceReassignment>>;
  reassignedTo?: Maybe<Array<DeviceReassignment>>;
  /** Whether this device can be released back to stock by hand, for a contract that ended without releasing it. */
  releaseEligibility?: Maybe<DeviceReleaseEligibility>;
  /** Every time this device was released back into stock by a contract ending, oldest first. */
  releases?: Maybe<Array<DeviceRelease>>;
  /** The device's live sale (status COMPLETED), if any. */
  sale?: Maybe<StockSale>;
  sales?: Maybe<Array<StockSale>>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StockItemStatus>;
  stockType?: Maybe<StockType>;
  stockingPoint?: Maybe<StockingPoint>;
  transferItems?: Maybe<Array<StockTransferItem>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workshopJobs?: Maybe<Array<WorkshopJob>>;
};

export type StockItemActionResult = {
  __typename?: 'StockItemActionResult';
  accountNumber?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  stockItemId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StockItemArchiveAction =
  | 'ARCHIVE'
  | 'RESTORE';

export type StockItemArchiveEvent = {
  __typename?: 'StockItemArchiveEvent';
  action?: Maybe<StockItemArchiveAction>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fromStatus?: Maybe<StockItemStatus>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  performedBy?: Maybe<User>;
  performedByName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<StockItemArchiveReason>;
  stockingPoint?: Maybe<StockingPoint>;
  toStatus?: Maybe<StockItemStatus>;
};

export type StockItemArchiveReason =
  | 'DUPLICATE_RECORD'
  | 'LOST'
  | 'NEVER_RECEIVED'
  | 'OTHER'
  | 'SCRAPPED'
  | 'STOLEN';

export type StockItemBulkActionResult = {
  __typename?: 'StockItemBulkActionResult';
  failureCount?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<StockItemActionResult>>;
  successCount?: Maybe<Scalars['Int']['output']>;
};

export type StockItemCondition =
  | 'NEW'
  | 'REFURBISHED'
  | 'USED';

export type StockItemListInput = {
  condition?: InputMaybe<StockItemCondition>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<StockKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<StockItemSort>;
  statuses?: InputMaybe<Array<StockItemStatus>>;
  stockTypeId?: InputMaybe<Scalars['String']['input']>;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type StockItemListResult = {
  __typename?: 'StockItemListResult';
  items: Array<StockItem>;
  totalCount: Scalars['Int']['output'];
};

export type StockItemRestoreStatus =
  | 'AVAILABLE'
  | 'DAMAGED';

export type StockItemSort =
  | 'CREATED_ASC'
  | 'CREATED_DESC'
  | 'SERIAL_ASC'
  | 'SERIAL_DESC'
  | 'UPDATED_ASC'
  | 'UPDATED_DESC';

export type StockItemStatus =
  | 'ARCHIVED'
  | 'AVAILABLE'
  | 'CANCELLED'
  | 'DAMAGED'
  | 'IN_PURCHASE_ORDER'
  | 'IN_TRANSIT'
  | 'IN_WORKSHOP'
  | 'ISSUED'
  | 'RESERVED'
  | 'SOLD'
  | 'WARRANTY_REPLACEMENT';

export type StockItemStatusCount = {
  __typename?: 'StockItemStatusCount';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type StockKind =
  | 'ACCESSORY'
  | 'DEVICE';

export type StockLeaving = {
  __typename?: 'StockLeaving';
  devices?: Maybe<Scalars['Int']['output']>;
  transfers?: Maybe<Scalars['Int']['output']>;
};

export type StockLevel = {
  __typename?: 'StockLevel';
  condition: StockCondition;
  id: Scalars['ID']['output'];
  isBelowMinimum: Scalars['Boolean']['output'];
  minimum?: Maybe<Scalars['Int']['output']>;
  product: Product;
  quantity: Scalars['Int']['output'];
  reservedQuantity: Scalars['Int']['output'];
  stockingPoint: StockingPoint;
};

export type StockMovement = {
  __typename?: 'StockMovement';
  condition: StockCondition;
  createdAt: Scalars['DateTime']['output'];
  delta: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  partRequest?: Maybe<PartRequest>;
  product: Product;
  purchaseOrderLine?: Maybe<PurchaseOrderLine>;
  reason: StockMovementReason;
  recordedBy?: Maybe<User>;
  stockTake?: Maybe<StockTake>;
  stockTransfer?: Maybe<StockTransfer>;
  stockingPoint: StockingPoint;
  workshopJob?: Maybe<WorkshopJob>;
};

export type StockMovementReason =
  | 'CORRECTION'
  | 'ISSUED_ON_CONTRACT'
  | 'OPENING_BALANCE'
  | 'RECEIVED'
  | 'RECEIVED_ON_PURCHASE_ORDER'
  | 'RETURNED'
  | 'RETURNED_FROM_CONTRACT'
  | 'SENT_ON_REQUEST'
  | 'STOCK_TAKE'
  | 'TRANSFERRED_IN'
  | 'TRANSFERRED_OUT'
  | 'TRANSFER_CANCELLED'
  | 'USED_ON_REPAIR';

/** Units held, split by what can be done with them. The five held statuses add up to `onHand`; `sold` sits outside it. */
export type StockOnHand = {
  __typename?: 'StockOnHand';
  available: Scalars['Int']['output'];
  damaged: Scalars['Int']['output'];
  inTransit: Scalars['Int']['output'];
  inWorkshop: Scalars['Int']['output'];
  issued: Scalars['Int']['output'];
  onHand: Scalars['Int']['output'];
  reserved: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
};

export type StockOnHandInput = {
  kind?: InputMaybe<StockKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  stockType?: InputMaybe<Scalars['String']['input']>;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type StockOnTheWay = {
  __typename?: 'StockOnTheWay';
  arriving?: Maybe<StockArriving>;
  leaving?: Maybe<StockLeaving>;
};

export type StockReportInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  stockType?: InputMaybe<Scalars['String']['input']>;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type StockReportResult = {
  __typename?: 'StockReportResult';
  salesByAgent?: Maybe<Array<SalesByAgent>>;
  totalSales?: Maybe<Scalars['Int']['output']>;
};

export type StockSale = {
  __typename?: 'StockSale';
  agent?: Maybe<Agent>;
  contract?: Maybe<Contract>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  defectiveCondition?: Maybe<DeviceCondition>;
  /** Whether this device can be unlocked from token gating, and why not when it cannot. */
  deviceControl?: Maybe<DeviceControlEligibility>;
  /** Whether this device can be put back under token gating, what that would clear, and why not when it cannot. */
  deviceLockControl?: Maybe<DeviceLockEligibility>;
  deviceReassignments?: Maybe<Array<DeviceReassignment>>;
  /** The distributor this sale's commission goes up to, by name. The seller on a distributor's own sale; their manager's head office on an independent agent's. */
  distributorName?: Maybe<Scalars['String']['output']>;
  flaggedBadAt?: Maybe<Scalars['DateTime']['output']>;
  flaggedBadBy?: Maybe<User>;
  flaggedBadReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** The National Sales Manager above the distributor (or the seller, when nobody sits between). */
  nationalSalesManagerName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** The agent a back-office user recorded this warranty replacement for. Null when the agent recorded it. */
  onBehalfOfAgent?: Maybe<Agent>;
  organization?: Maybe<Organization>;
  /** The user who recorded this sale. Null for sales predating the field. */
  recordedBy?: Maybe<User>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
  saleReference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SaleStatus>;
  stockItem?: Maybe<StockItem>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StockSaleListInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  ratePlanId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type StockSaleListResult = {
  __typename?: 'StockSaleListResult';
  items: Array<StockSale>;
  totalCount: Scalars['Int']['output'];
};

/** A contract counted the EDF way: in the month it first went active, once the deposit was cleared. */
export type StockSalesActivationRow = {
  __typename?: 'StockSalesActivationRow';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  /** On a combo plan, its devices joined with ' + ', the TV last; null when the sale is not a combo. */
  comboDevices?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  /** CANCELLED, MAINTENANCE or REFURBISHED_REISSUE, or null when it counts. */
  notCountedReason?: Maybe<Scalars['String']['output']>;
  /** The device on the contract's oldest sale, as the external API reports it. */
  product?: Maybe<Scalars['String']['output']>;
  productCategory?: Maybe<Scalars['String']['output']>;
  productCategoryRank?: Maybe<Scalars['Int']['output']>;
  rateAmount?: Maybe<Scalars['Float']['output']>;
  ratePlan?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type StockSalesActivations = {
  __typename?: 'StockSalesActivations';
  items?: Maybe<Array<StockSalesActivationRow>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StockSalesReport = {
  __typename?: 'StockSalesReport';
  items?: Maybe<Array<StockSalesReportRow>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StockSalesReportRow = {
  __typename?: 'StockSalesReportRow';
  accountNumber?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  agentSalesId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  /** The contract's own status (ACTIVE, PAID_OFF, …), as distinct from the sale's. */
  contractStatus?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  flaggedBad?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True where the row is a warranty swap rather than a sale. Finance's download
   * keeps them; anything counting sales must not.
   */
  isWarrantyReplacement?: Maybe<Scalars['Boolean']['output']>;
  nationalSalesManagerName?: Maybe<Scalars['String']['output']>;
  /**
   * Why the row is not counted as a sale — WARRANTY_REPLACEMENT, MAINTENANCE or
   * REFURBISHED_REISSUE — or null when it is one.
   */
  notCountedReason?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** On a warranty replacement, the unit that came back; blank on every other sale. */
  previousAccountNumber?: Maybe<Scalars['String']['output']>;
  previousSerialNumber?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  /** The product's category (Small SHS, Medium SHS, Backup); null where unclassified. */
  productCategory?: Maybe<Scalars['String']['output']>;
  /** The category's sort position, smallest first. */
  productCategoryRank?: Maybe<Scalars['Int']['output']>;
  productSku?: Maybe<Scalars['String']['output']>;
  rateAmount?: Maybe<Scalars['Float']['output']>;
  ratePlan?: Maybe<Scalars['String']['output']>;
  saleDate?: Maybe<Scalars['DateTime']['output']>;
  saleReference?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  termLengthMonths?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type StockTake = {
  __typename?: 'StockTake';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<User>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<User>;
  countsUnits: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lines: Array<StockTakeLine>;
  note?: Maybe<Scalars['String']['output']>;
  openedBy: User;
  status: StockTakeStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  stockingPoint: StockingPoint;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<User>;
  summary: StockTakeSummary;
  takeNumber: Scalars['String']['output'];
  units: Array<StockTakeUnit>;
  wholePoint: Scalars['Boolean']['output'];
};

export type StockTakeLine = {
  __typename?: 'StockTakeLine';
  condition: StockCondition;
  countedAt?: Maybe<Scalars['DateTime']['output']>;
  countedBy?: Maybe<User>;
  countedQuantity?: Maybe<Scalars['Int']['output']>;
  expectedQuantity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  product: Product;
  unitCostCents?: Maybe<Scalars['Int']['output']>;
  variance?: Maybe<Scalars['Int']['output']>;
};

export type StockTakeStatus =
  | 'APPROVED'
  | 'CANCELLED'
  | 'OPEN'
  | 'SUBMITTED';

export type StockTakeSummary = {
  __typename?: 'StockTakeSummary';
  countedLineCount: Scalars['Int']['output'];
  foundUnits: Scalars['Int']['output'];
  lineCount: Scalars['Int']['output'];
  missingUnits: Scalars['Int']['output'];
  missingValueCents: Scalars['Float']['output'];
  overQuantity: Scalars['Int']['output'];
  shortQuantity: Scalars['Int']['output'];
  unexpectedUnits: Scalars['Int']['output'];
  unpricedLineCount: Scalars['Int']['output'];
  varianceValueCents: Scalars['Float']['output'];
};

export type StockTakeUnit = {
  __typename?: 'StockTakeUnit';
  id: Scalars['ID']['output'];
  outcome: StockTakeUnitOutcome;
  scannedAt?: Maybe<Scalars['DateTime']['output']>;
  scannedBy?: Maybe<User>;
  serial: Scalars['String']['output'];
  stockItem?: Maybe<StockItem>;
};

export type StockTakeUnitOutcome =
  | 'FOUND'
  | 'MISSING'
  | 'UNEXPECTED';

export type StockTransfer = {
  __typename?: 'StockTransfer';
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who cancelled it. Null unless cancelled, or where it was never recorded. */
  cancelledBy?: Maybe<User>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who received it. Null until completed, or where it was never recorded. */
  completedBy?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  destinationStockingPoint?: Maybe<StockingPoint>;
  dispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who dispatched it. Null before dispatch, or on a transfer dispatched before this was recorded and not recoverable from the audit log. */
  dispatchedBy?: Maybe<User>;
  dispatchedByCourier?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether this transfer is a Return to Head Office (ADR-0089), read at the same id. */
  isReturnToHeadOffice?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<StockTransferItem>>;
  lines: Array<StockTransferLine>;
  notes?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  partRequests: Array<PartRequest>;
  shipment?: Maybe<Shipment>;
  shippingCompany?: Maybe<ShippingCompany>;
  sourceStockingPoint?: Maybe<StockingPoint>;
  status?: Maybe<TransferStatus>;
  transferNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  waybillReference?: Maybe<Scalars['String']['output']>;
};

export type StockTransferItem = {
  __typename?: 'StockTransferItem';
  id?: Maybe<Scalars['ID']['output']>;
  stockItem?: Maybe<StockItem>;
  transfer?: Maybe<StockTransfer>;
};

export type StockTransferLine = {
  __typename?: 'StockTransferLine';
  condition: StockCondition;
  id: Scalars['ID']['output'];
  product: Product;
  quantity: Scalars['Int']['output'];
};

export type StockTransferListInput = {
  awaitingReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  destinationStockingPointId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceStockingPointId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<TransferStatus>>;
};

export type StockTransferListResult = {
  __typename?: 'StockTransferListResult';
  items: Array<StockTransfer>;
  totalCount: Scalars['Int']['output'];
};

export type StockType = {
  __typename?: 'StockType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isReplacement?: Maybe<Scalars['Boolean']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StockValuationBusinessLine = {
  __typename?: 'StockValuationBusinessLine';
  externalCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** One business line, which is one inventory account in the ledger. */
export type StockValuationLine = {
  __typename?: 'StockValuationLine';
  businessLine?: Maybe<StockValuationBusinessLine>;
  products: Array<StockValuationProductRow>;
  quantity: Scalars['Int']['output'];
  unpricedQuantity: Scalars['Int']['output'];
  valueCents: Scalars['Float']['output'];
};

export type StockValuationPlace = {
  __typename?: 'StockValuationPlace';
  condition: StockCondition;
  quantity: Scalars['Int']['output'];
  stockingPointId?: Maybe<Scalars['String']['output']>;
  stockingPointName?: Maybe<Scalars['String']['output']>;
  valueCents?: Maybe<Scalars['Float']['output']>;
};

export type StockValuationProduct = {
  __typename?: 'StockValuationProduct';
  id: Scalars['ID']['output'];
  kind: ProductKind;
  lastCostCents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  unitOfMeasureName?: Maybe<Scalars['String']['output']>;
};

export type StockValuationProductRow = {
  __typename?: 'StockValuationProductRow';
  damagedQuantity: Scalars['Int']['output'];
  places: Array<StockValuationPlace>;
  product: StockValuationProduct;
  quantity: Scalars['Int']['output'];
  unpricedQuantity: Scalars['Int']['output'];
  valueCents: Scalars['Float']['output'];
};

/** Stock on hand at each product's last cost, subtotalled by business line. Damaged stock is valued at nil. */
export type StockValuationReport = {
  __typename?: 'StockValuationReport';
  asAt: Scalars['DateTime']['output'];
  lines: Array<StockValuationLine>;
  quantity: Scalars['Int']['output'];
  unitsWithoutProduct: Scalars['Int']['output'];
  unpricedQuantity: Scalars['Int']['output'];
  valueCents: Scalars['Float']['output'];
};

export type StockingPoint = {
  __typename?: 'StockingPoint';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  canRename?: Maybe<Scalars['Boolean']['output']>;
  canToggleActive?: Maybe<Scalars['Boolean']['output']>;
  childStockingPoints?: Maybe<Array<StockingPoint>>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<User>;
  deactivationReason?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  members?: Maybe<Array<StockingPointMember>>;
  minimumStockLevel?: Maybe<Scalars['Int']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  parentStockingPoint?: Maybe<StockingPoint>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  stockItems?: Maybe<Array<StockItem>>;
  stockOnTheWay?: Maybe<StockOnTheWay>;
  stockQuantityLimit?: Maybe<Scalars['Int']['output']>;
  stockingPointId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StockingPointType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<Array<StockingPointUser>>;
};

export type StockingPointInventoryResult = {
  __typename?: 'StockingPointInventoryResult';
  items: Array<StockItem>;
  statusCounts: Array<StockItemStatusCount>;
  totalCount: Scalars['Int']['output'];
};

export type StockingPointListInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<StockingPointType>>;
};

export type StockingPointListResult = {
  __typename?: 'StockingPointListResult';
  items: Array<StockingPoint>;
  totalCount: Scalars['Int']['output'];
};

export type StockingPointMember = {
  __typename?: 'StockingPointMember';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  stockingPoint?: Maybe<StockingPoint>;
  user?: Maybe<User>;
};

export type StockingPointProductMinimum = {
  __typename?: 'StockingPointProductMinimum';
  availableCount?: Maybe<Scalars['Int']['output']>;
  minimumStockLevel?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type StockingPointType =
  | 'AGENT'
  | 'DISTRIBUTOR'
  | 'HEAD_OFFICE'
  | 'WORKSHOP';

export type StockingPointUser = {
  __typename?: 'StockingPointUser';
  agent?: Maybe<Agent>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  stockingPoint?: Maybe<StockingPoint>;
};

/** A company KES contracts for work. Its people are never Employees. */
export type Subcontractor = {
  __typename?: 'Subcontractor';
  activeWorkerCount: Scalars['Int']['output'];
  bbbeeLevel?: Maybe<BbbeeLevel>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  contractEnd?: Maybe<Scalars['DateTime']['output']>;
  contractStart?: Maybe<Scalars['DateTime']['output']>;
  /** In rand. Null = not recorded, never R0. */
  contractValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Scalars['String']['output']>;
  status: SubcontractorStatus;
};

export type SubcontractorComplianceDocument = {
  __typename?: 'SubcontractorComplianceDocument';
  /** The last day it is valid. Null = it does not expire. */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  files: Array<SubcontractorComplianceFile>;
  id: Scalars['ID']['output'];
  issuedDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  subcontractor: SubcontractorRef;
  type: SubcontractorDocumentType;
};

/** Download from GET /api/hr/subcontractor-documents/:id (hr_subcontractors:view). */
export type SubcontractorComplianceFile = {
  __typename?: 'SubcontractorComplianceFile';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type SubcontractorComplianceFilterInput = {
  /** Active subcontractors' latest documents expiring within this many days, or already expired. */
  expiringWithinDays?: InputMaybe<Scalars['Int']['input']>;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubcontractorDetail = {
  __typename?: 'SubcontractorDetail';
  complianceDocuments: Array<SubcontractorComplianceDocument>;
  invoices: Array<SubcontractorInvoice>;
  subcontractor: Subcontractor;
  workers: Array<SubcontractorWorker>;
};

export type SubcontractorDocumentType =
  | 'BBBEE_CERTIFICATE'
  | 'COIDA_GOOD_STANDING'
  | 'OTHER'
  | 'PUBLIC_LIABILITY'
  | 'TAX_CLEARANCE';

export type SubcontractorFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SubcontractorStatus>>;
};

/** Hours one worker worked in one period. Counts in the range its period ends in. */
export type SubcontractorHours = {
  __typename?: 'SubcontractorHours';
  hours: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  worker: SubcontractorHoursWorker;
};

export type SubcontractorHoursFilterInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubcontractorHoursImportError = {
  __typename?: 'SubcontractorHoursImportError';
  line: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/** All or nothing: with any error, nothing was imported. */
export type SubcontractorHoursImportResult = {
  __typename?: 'SubcontractorHoursImportResult';
  errors: Array<SubcontractorHoursImportError>;
  imported: Scalars['Int']['output'];
};

export type SubcontractorHoursList = {
  __typename?: 'SubcontractorHoursList';
  items: Array<SubcontractorHours>;
  totalCount: Scalars['Int']['output'];
  /** Every matching line, not only this page. */
  totalHours: Scalars['Float']['output'];
};

export type SubcontractorHoursWorker = {
  __typename?: 'SubcontractorHoursWorker';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  subcontractor: SubcontractorRef;
};

export type SubcontractorInvoice = {
  __typename?: 'SubcontractorInvoice';
  /** In rand. */
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type SubcontractorList = {
  __typename?: 'SubcontractorList';
  items: Array<Subcontractor>;
  totalCount: Scalars['Int']['output'];
};

/** The Subcontractor figures (ADR-0068). Who is active is as of today; hours, spend and incidents count in the range. An area with no records is MISSING. */
export type SubcontractorMetrics = {
  __typename?: 'SubcontractorMetrics';
  /** Subcontractors with status ACTIVE today. */
  activeSubcontractors: HrMetric;
  /** Active workers at active subcontractors, today. */
  activeWorkers: HrMetric;
  bbbeeLevels: Array<BbbeeLevelCount>;
  /** Active subcontractors' latest documents already expired. */
  complianceExpired: HrMetric;
  /** Active subcontractors' latest documents expiring in the next 30 days. */
  complianceExpiring: HrMetric;
  from: Scalars['DateTime']['output'];
  /** Hours of timesheet lines whose period ends in the range. */
  hoursWorked: HrMetric;
  /** Safety incidents involving a subcontractor in the range. Null unless the user also holds hr_safety:view. */
  incidents?: Maybe<HrMetric>;
  /** Active workers with a safety induction ÷ active workers × 100. */
  inductedPercent: HrMetric;
  /** Of those, lost-time injuries and fatalities. Null unless the user also holds hr_safety:view. */
  lostTimeIncidents?: Maybe<HrMetric>;
  /** Rand invoiced in the range. MISSING when no invoice is recorded; subcontractors with none are notRecorded. */
  spend: HrMetric;
  spendBySubcontractor: Array<SubcontractorSpend>;
  to: Scalars['DateTime']['output'];
  /** Active subcontractors with no valid COIDA letter of good standing today. */
  withoutValidCoida: HrMetric;
};

export type SubcontractorRef = {
  __typename?: 'SubcontractorRef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Invoiced in the range. MISSING for a subcontractor with no invoice ever. */
export type SubcontractorSpend = {
  __typename?: 'SubcontractorSpend';
  name: Scalars['String']['output'];
  spend: HrMetric;
  subcontractorId: Scalars['ID']['output'];
};

export type SubcontractorStatus =
  | 'ACTIVE'
  | 'ENDED'
  | 'SUSPENDED';

export type SubcontractorWorker = {
  __typename?: 'SubcontractorWorker';
  active: Scalars['Boolean']['output'];
  agent?: Maybe<SubcontractorWorkerAgent>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** SA ID or passport number. */
  idNumber?: Maybe<Scalars['String']['output']>;
  /** Safety induction done. Null = not inducted yet. */
  inductionDate?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  subcontractor: SubcontractorRef;
};

/** The CRM sales agent a worker is linked to. */
export type SubcontractorWorkerAgent = {
  __typename?: 'SubcontractorWorkerAgent';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  salesId: Scalars['String']['output'];
};

export type SubmitReturnToHeadOfficeInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  stockItemIds: Array<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  notificationReceived?: Maybe<NotificationEvent>;
};

export type SuccessPayload = {
  __typename?: 'SuccessPayload';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  beeLevel?: Maybe<Scalars['Int']['output']>;
  beeStatus?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactPerson?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SupplierListInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierListResult = {
  __typename?: 'SupplierListResult';
  items: Array<Supplier>;
  totalCount: Scalars['Int']['output'];
};

export type SwapContractDevicesInput = {
  cause: DeviceReassignmentCause;
  contractId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  otherContractId: Scalars['String']['input'];
  otherStockSaleId?: InputMaybe<Scalars['String']['input']>;
  stockSaleId?: InputMaybe<Scalars['String']['input']>;
};

export type TaxonomyEntryUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Team = {
  __typename?: 'Team';
  department: TeamDepartment;
  id: Scalars['ID']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TeamDepartment = {
  __typename?: 'TeamDepartment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TeamInput = {
  departmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ThirdPartyCredential = {
  __typename?: 'ThirdPartyCredential';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TokenCase =
  | 'CASE_0'
  | 'CASE_1'
  | 'CASE_2';

export type TrainingCategory =
  | 'COMPLIANCE'
  | 'LEADERSHIP'
  | 'OTHER'
  | 'SAFETY'
  | 'SOFT_SKILLS'
  | 'TECHNICAL';

export type TrainingCertificateDocument = {
  __typename?: 'TrainingCertificateDocument';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type TrainingCertification = {
  __typename?: 'TrainingCertification';
  certificateNumber?: Maybe<Scalars['String']['output']>;
  course?: Maybe<TrainingCourseSummary>;
  documents: Array<TrainingCertificateDocument>;
  employee: TrainingPerson;
  /** The last day it is valid. Null = it does not expire. */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  issuedDate: Scalars['DateTime']['output'];
  /** Set when the certificate is not for a catalogue course. */
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type TrainingCertificationFilterInput = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Current staff's latest certificates expiring within this many days, or already expired. */
  expiringWithinDays?: InputMaybe<Scalars['Int']['input']>;
};

export type TrainingCourse = {
  __typename?: 'TrainingCourse';
  accredited: Scalars['Boolean']['output'];
  category: TrainingCategory;
  certificationCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Everyone in the Headcount must hold a valid certificate for it. */
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  sessionCount: Scalars['Int']['output'];
  /** How long its certificate is valid. Null = it does not expire. */
  validityMonths?: Maybe<Scalars['Int']['output']>;
};

export type TrainingCourseInput = {
  accredited?: InputMaybe<Scalars['Boolean']['input']>;
  category: TrainingCategory;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  validityMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type TrainingCourseSummary = {
  __typename?: 'TrainingCourseSummary';
  category: TrainingCategory;
  id: Scalars['ID']['output'];
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  validityMonths?: Maybe<Scalars['Int']['output']>;
};

export type TrainingMandatoryCompliance = {
  __typename?: 'TrainingMandatoryCompliance';
  compliance: HrMetric;
  courseId: Scalars['ID']['output'];
  courseName: Scalars['String']['output'];
  holders: Scalars['Int']['output'];
};

export type TrainingMetrics = {
  __typename?: 'TrainingMetrics';
  /** People on a learnership or other programme on the last day of the range. */
  activeLearners: HrMetric;
  /** Completed ÷ (completed + failed + no-show), sessions starting in the range. */
  completionRate: HrMetric;
  /** Current staff's latest certificates already expired. */
  expired: HrMetric;
  /** Current staff's latest certificates expiring in the next 30 days. */
  expiringIn30: HrMetric;
  /** Current staff's latest certificates expiring in the next 60 days. */
  expiringIn60: HrMetric;
  /** Current staff's latest certificates expiring in the next 90 days. */
  expiringIn90: HrMetric;
  from: Scalars['DateTime']['output'];
  /** Training hours ÷ the average month-end Headcount. */
  hoursPerEmployee: HrMetric;
  /** Valid certificates held for mandatory courses ÷ (Headcount × mandatory courses) × 100. */
  mandatoryCompliance: HrMetric;
  mandatoryCourses: Array<TrainingMandatoryCompliance>;
  /** People in the Headcount on the last day who completed a session in the range. */
  peopleTrained: HrMetric;
  /** Skills-development spend as a % of payroll. NOT_APPLICABLE until payroll is in the CRM. */
  skillsSpendPercentOfPayroll: HrMetric;
  /** Rand cost of the sessions starting in the range. Sessions with no cost are notRecorded. */
  spend: HrMetric;
  /** Spend ÷ the average month-end Headcount. */
  spendPerEmployee: HrMetric;
  to: Scalars['DateTime']['output'];
  /** People trained as a % of the Headcount on the last day. */
  trainedPercent: HrMetric;
  /** Hours of completed and failed sessions starting in the range. */
  trainingHours: HrMetric;
};

export type TrainingMetricsFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TrainingPerson = {
  __typename?: 'TrainingPerson';
  departmentName?: Maybe<Scalars['String']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type TrainingSession = {
  __typename?: 'TrainingSession';
  /** In rand. Null = not recorded, never R0. */
  cost?: Maybe<Scalars['Float']['output']>;
  course: TrainingCourseSummary;
  employee: TrainingPerson;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: TrainingSessionStatus;
};

export type TrainingSessionFilterInput = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<TrainingSessionStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TrainingSessionList = {
  __typename?: 'TrainingSessionList';
  items: Array<TrainingSession>;
  totalCount: Scalars['Int']['output'];
};

export type TrainingSessionStatus =
  | 'BOOKED'
  | 'COMPLETED'
  | 'FAILED'
  | 'NO_SHOW';

export type TransferDestination = {
  __typename?: 'TransferDestination';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stockingPointId: Scalars['String']['output'];
  type: StockingPointType;
};

export type TransferItemStatus =
  | 'DUPLICATE'
  | 'NOT_FOUND'
  | 'READY'
  | 'UNAVAILABLE'
  | 'WRONG_LOCATION';

export type TransferItemValidation = {
  __typename?: 'TransferItemValidation';
  currentLocationName?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  status: TransferItemStatus;
  stockItemId?: Maybe<Scalars['String']['output']>;
};

/** A stocking point the caller may raise a staged transfer FROM. The mirror of TransferDestination: narrowed to the caller's membership unless they hold stock:transfer_from_any, which lifts it. */
export type TransferSource = {
  __typename?: 'TransferSource';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stockingPointId: Scalars['String']['output'];
  type: StockingPointType;
};

export type TransferStatus =
  | 'AWAITING_APPROVAL'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'IN_TRANSIT'
  | 'PENDING';

export type TriggerEvent =
  | 'CONTRACT_PAID_OFF'
  | 'MAINTENANCE_PERFORMED'
  | 'PAYMENT_DEFAULTED'
  | 'PAYMENT_RECEIVED'
  | 'PROSPECT_CONVERTED'
  | 'SALE_COMPLETED'
  | 'SALE_FLAGGED_BAD'
  | 'SALE_REVERSED';

export type UnclaimedTillPaymentListResult = {
  __typename?: 'UnclaimedTillPaymentListResult';
  items: Array<PaymentTransaction>;
  totalCount: Scalars['Int']['output'];
};

export type UnflagStockSaleInput = {
  saleId: Scalars['String']['input'];
};

export type UnitOfMeasure = {
  __typename?: 'UnitOfMeasure';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Units sold in one period: completed sales, warranty swaps excluded. */
export type UnitsSoldPoint = {
  __typename?: 'UnitsSoldPoint';
  /** The next period's first day — the window is half-open. */
  end: Scalars['Date']['output'];
  /** The period's first day, in the timezone the series was cut in. */
  start: Scalars['Date']['output'];
  units: Scalars['Int']['output'];
};

export type UpdateAgentCategoryInput = {
  canBeParent?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAgentInput = {
  agentCategoryId?: InputMaybe<Scalars['String']['input']>;
  agentType?: InputMaybe<AgentType>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountType?: InputMaybe<AgentBankAccountType>;
  bankBranchCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  canDoReplacements?: InputMaybe<Scalars['Boolean']['input']>;
  canHoldStock?: InputMaybe<Scalars['Boolean']['input']>;
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  earnsMonthlyFee?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  parentAgentId?: InputMaybe<Scalars['String']['input']>;
  paymentPhone?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApplicationInput = {
  employer?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  income?: InputMaybe<Scalars['Float']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ApplicationStatus>;
};

export type UpdateAttendanceRecordInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  hoursWorked?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overtimeHours?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<AttendanceStatus>;
};

export type UpdateBankStatementRowInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  clear?: InputMaybe<Scalars['Boolean']['input']>;
  /** A contract found by customer name, ID number or contract number. */
  contractId?: InputMaybe<Scalars['String']['input']>;
  noLoadReason?: InputMaybe<BankStatementNoLoadReason>;
  rowId: Scalars['String']['input'];
};

export type UpdateBusinessLineInput = {
  externalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCandidateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CandidateSource>;
  sourceDetail?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommissionPolicyInput = {
  distributorPaid?: InputMaybe<CommissionDistributorPaid>;
  minimumPayoutCents?: InputMaybe<Scalars['Int']['input']>;
  missedTranche?: InputMaybe<CommissionMissedTranche>;
  monthOneStartsAt?: InputMaybe<CommissionMonthOneStart>;
  monthlyUnitEligibility?: InputMaybe<CommissionMonthlyUnitEligibility>;
  paidOffBonusTiming?: InputMaybe<CommissionPaidOffBonusTiming>;
  requireUpToDate?: InputMaybe<Scalars['Boolean']['input']>;
  runDayOfNextMonth?: InputMaybe<Scalars['Int']['input']>;
  trancheMonthBasis?: InputMaybe<CommissionTrancheMonthBasis>;
  visitMode?: InputMaybe<CommissionVisitMode>;
};

export type UpdateCommissionRuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  calculationMethod?: InputMaybe<CalculationMethod>;
  commissionTypeId?: InputMaybe<Scalars['String']['input']>;
  endMonth?: InputMaybe<Scalars['Int']['input']>;
  forfeitAfterMonths?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  isNegative?: InputMaybe<Scalars['Boolean']['input']>;
  ratePlanId?: InputMaybe<Scalars['String']['input']>;
  startMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCommissionTypeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  triggerEvent?: InputMaybe<TriggerEvent>;
};

export type UpdateContractInput = {
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  deviceLocation?: InputMaybe<CancelledDeviceLocation>;
  nonTokenAmount?: InputMaybe<Scalars['Int']['input']>;
  rateAmount?: InputMaybe<Scalars['Float']['input']>;
  rateName?: InputMaybe<Scalars['String']['input']>;
  ratePlanId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContractStatus>;
  termLength?: InputMaybe<Scalars['Int']['input']>;
  writeOffReason?: InputMaybe<WriteOffReason>;
};

export type UpdateCustomerInput = {
  address?: InputMaybe<AddressInput>;
  currentSourceOfLight?: InputMaybe<SourceOfLight>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  gpsLatitude?: InputMaybe<Scalars['Float']['input']>;
  gpsLongitude?: InputMaybe<Scalars['Float']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<IdentificationType>;
  income?: InputMaybe<Scalars['Float']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Occupation>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primarySource?: InputMaybe<ManSystem>;
  registrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  secondaryContactFirstName?: InputMaybe<Scalars['String']['input']>;
  secondaryContactLastName?: InputMaybe<Scalars['String']['input']>;
  secondaryContactPhone?: InputMaybe<Scalars['String']['input']>;
  secondaryPhone?: InputMaybe<Scalars['String']['input']>;
  sourceSystemIds?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateDelinquencyPolicyInput = {
  repossessionThresholdDays?: InputMaybe<Scalars['Int']['input']>;
  tier1Days: Scalars['Int']['input'];
  tier2Days: Scalars['Int']['input'];
  tier3Days: Scalars['Int']['input'];
  writeOffThresholdDays: Scalars['Int']['input'];
};

export type UpdateDepartmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeviceInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['String']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  stockItemId: Scalars['String']['input'];
};

export type UpdateDeviceMeterInput = {
  clearSecretKey?: InputMaybe<Scalars['Boolean']['input']>;
  meterTypeId: Scalars['Int']['input'];
  secretKey?: InputMaybe<Scalars['String']['input']>;
  startingCode?: InputMaybe<Scalars['String']['input']>;
  stockItemId: Scalars['String']['input'];
};

export type UpdateDeviceTypeInput = {
  defaultMeterTypeId?: InputMaybe<Scalars['Int']['input']>;
  fields?: InputMaybe<Array<DeviceTypeFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDigitalChannelInput = {
  gaPropertyId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<DigitalChannelKind>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEmployeeBenefitInput = {
  employeeContribution?: InputMaybe<Scalars['Float']['input']>;
  employerContribution?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<EmployeeBenefitType>;
};

export type UpdateEmployeeInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEsgBeneficiaryInput = {
  /** The staff member, on an employee-wellness programme only. */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  gender?: InputMaybe<EsgBeneficiaryGender>;
  /** Only for an INDIVIDUAL. */
  hasDisability?: InputMaybe<Scalars['Boolean']['input']>;
  /** Aged 15–35. Only for an INDIVIDUAL. */
  isYouth?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** People in a community. Only for a COMMUNITY. */
  peopleCount?: InputMaybe<Scalars['Int']['input']>;
  reachedDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<EsgBeneficiaryType>;
};

export type UpdateEsgOutcomeInput = {
  measuredDate?: InputMaybe<Scalars['DateTime']['input']>;
  metricName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEsgProgrammeInput = {
  bbbeeElement?: InputMaybe<BbbeeElement>;
  /** In rand. */
  budget?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<EsgProgrammeCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** A CRM user. */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<EsgProgrammeStatus>;
};

export type UpdateEsgSpendInput = {
  /** In rand. */
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  spendDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateEsgVolunteeringInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGrievanceSettingsInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactHours?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  extraQuestionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messagesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  replyPromiseWorkingDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Omit a field to leave it; send null to clear it. Closing sets the closed date (today if none is sent); reopening clears it. Changing the type drops the fields that do not apply. */
export type UpdateHrCaseInput = {
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  closedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** In rand. */
  cost?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  offenceCategory?: InputMaybe<Scalars['String']['input']>;
  openedDate?: InputMaybe<Scalars['DateTime']['input']>;
  outcome?: InputMaybe<HrCaseOutcome>;
  referralDate?: InputMaybe<Scalars['DateTime']['input']>;
  sanction?: InputMaybe<HrCaseSanction>;
  stage?: InputMaybe<HrCaseStage>;
  status?: InputMaybe<HrCaseStatus>;
  type?: InputMaybe<HrCaseType>;
  warningExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateImprovementPlanInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ImprovementPlanStatus>;
};

export type UpdateItemCategoryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateJobPositionInput = {
  level?: InputMaybe<JobLevel>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeadInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<IdentificationType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<LeadCommunicationChannel>;
  products?: InputMaybe<Array<LeadProductInput>>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeadSourceInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeadStatusInput = {
  category?: InputMaybe<LeadStatusCategory>;
  color?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLearningProgrammeInput = {
  /** The fixed-term Employment it sits on. Defaults to the open one. */
  employmentId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nqfLevel?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<LearningProgrammeOutcome>;
  seta?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<LearningProgrammeType>;
};

export type UpdateLeaveBalanceInput = {
  cycleEnd?: InputMaybe<Scalars['DateTime']['input']>;
  cycleStart?: InputMaybe<Scalars['DateTime']['input']>;
  entitlementDays?: InputMaybe<Scalars['Float']['input']>;
  takenDays?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLeaveTypeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cycleMonths?: InputMaybe<Scalars['Int']['input']>;
  entitlementDays?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateModuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyBankingInput = {
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountType?: InputMaybe<AgentBankAccountType>;
  bankBranchCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNoteInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  changeReason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  /** Printed in a Statement's footer. An empty string clears it. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Printed in a Statement's footer. An empty string clears it. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logoBackground?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  requireAgentInviteApproval?: InputMaybe<Scalars['Boolean']['input']>;
  requireConfirmPassword?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePayRunInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdatePaymentRatingPolicyInput = {
  excellentMaxPercent: Scalars['Float']['input'];
  fairMaxPercent: Scalars['Float']['input'];
  goodMaxPercent: Scalars['Float']['input'];
  poorMaxPercent: Scalars['Float']['input'];
};

export type UpdatePerformanceReviewInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PerformanceReviewStatus>;
};

export type UpdateProductBrandInput = {
  externalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductCategoryInput = {
  externalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProductInput = {
  batteryKwh?: InputMaybe<Scalars['Float']['input']>;
  businessLineId?: InputMaybe<Scalars['String']['input']>;
  canAcceptToken?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryId?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ProductKind>;
  lastCostCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  panelEfficiency?: InputMaybe<Scalars['Float']['input']>;
  panelWatts?: InputMaybe<Scalars['Int']['input']>;
  productBrandId?: InputMaybe<Scalars['String']['input']>;
  productCategoryId?: InputMaybe<Scalars['String']['input']>;
  requiresSerialTracking?: InputMaybe<Scalars['Boolean']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  systemEfficiency?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfileInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePurchaseOrderPlanInput = {
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lines?: InputMaybe<Array<PurchaseOrderLineInput>>;
};

export type UpdateRatePlanInput = {
  aftercareAgent?: InputMaybe<Scalars['Int']['input']>;
  aftercareRam?: InputMaybe<Scalars['Int']['input']>;
  commissionCloseout?: InputMaybe<Scalars['Int']['input']>;
  commissionMonth1?: InputMaybe<Scalars['Int']['input']>;
  commissionMonth2?: InputMaybe<Scalars['Int']['input']>;
  commissionMonth3?: InputMaybe<Scalars['Int']['input']>;
  commissionMonth4?: InputMaybe<Scalars['Int']['input']>;
  commissionRam?: InputMaybe<Scalars['Int']['input']>;
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  depositCollectedUpfront?: InputMaybe<Scalars['Boolean']['input']>;
  downpayment?: InputMaybe<Scalars['Float']['input']>;
  downpaymentFormula?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  manSystem?: InputMaybe<ManSystem>;
  product?: InputMaybe<Scalars['String']['input']>;
  productAllocations?: InputMaybe<Array<RatePlanProductAllocationInput>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rateAmount?: InputMaybe<Scalars['Float']['input']>;
  rateName?: InputMaybe<Scalars['String']['input']>;
  termLength?: InputMaybe<Scalars['Int']['input']>;
  tokenCase?: InputMaybe<TokenCase>;
  type?: InputMaybe<RatePlanType>;
};

export type UpdateReallocationPolicyInput = {
  costRecoveryAmount: Scalars['Int']['input'];
  minimumTokenDaysPerPayment: Scalars['Int']['input'];
};

export type UpdateRecruitmentCostInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<RecruitmentCostCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  incurredDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateReviewCycleInput = {
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateRoleInput = {
  accessLevel?: InputMaybe<Scalars['String']['input']>;
  assignableForAgents?: InputMaybe<Scalars['Boolean']['input']>;
  canManageAgents?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  homeModule?: InputMaybe<HomeModule>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresWorkshop?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSafetyCorrectiveActionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Set when done. */
  doneDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** A CRM user. */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSafetyIncidentInput = {
  /** With status CLOSED; defaults to today. */
  closedDate?: InputMaybe<Scalars['DateTime']['input']>;
  coidaClaimNumber?: InputMaybe<Scalars['String']['input']>;
  coidaClaimStatus?: InputMaybe<CoidaClaimStatus>;
  /** Defaults to the employee's home department on a new incident. */
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** An employee or a subcontractor (optionally one of its workers), never both. Picking a worker sets the subcontractor. */
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Health information (POPIA special). */
  injuryDetails?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lostDays?: InputMaybe<Scalars['Int']['input']>;
  /** Date and time. */
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  reportable?: InputMaybe<Scalars['Boolean']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<SafetyIncidentSeverity>;
  status?: InputMaybe<SafetyIncidentStatus>;
  /** An employee or a subcontractor (optionally one of its workers), never both. Picking a worker sets the subcontractor. */
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
  /** An employee or a subcontractor (optionally one of its workers), never both. Picking a worker sets the subcontractor. */
  subcontractorWorkerId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<SafetyIncidentType>;
};

export type UpdateSafetyInspectionInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  findingsCount?: InputMaybe<Scalars['Int']['input']>;
  inspectionDate?: InputMaybe<Scalars['DateTime']['input']>;
  inspectorName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scorePercent?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<SafetyInspectionType>;
};

export type UpdateShippingCompanyInput = {
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  courier?: InputMaybe<Courier>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  trackingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStockTypeInput = {
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStockingPointInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  minimumStockLevel?: InputMaybe<Scalars['Int']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  parentStockingPointId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  stockQuantityLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSubcontractorComplianceInput = {
  /** The last day it is valid. Null = it does not expire. */
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuedDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SubcontractorDocumentType>;
};

export type UpdateSubcontractorHoursInput = {
  hours?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateSubcontractorInput = {
  bbbeeLevel?: InputMaybe<BbbeeLevel>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contractEnd?: InputMaybe<Scalars['DateTime']['input']>;
  contractStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** In rand. */
  contractValue?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubcontractorStatus>;
};

export type UpdateSubcontractorInvoiceInput = {
  /** In rand. */
  amount?: InputMaybe<Scalars['Float']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubcontractorWorkerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Link to a CRM sales agent. Optional. */
  agentId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** SA ID or passport number. */
  idNumber?: InputMaybe<Scalars['String']['input']>;
  inductionDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  beeLevel?: InputMaybe<Scalars['Int']['input']>;
  beeStatus?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateThirdPartyCredentialInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainingCertificationInput = {
  certificateNumber?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  /** Omit to work it out from the course's validity; send null for a certificate that does not expire. */
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainingCourseInput = {
  accredited?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<TrainingCategory>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  validityMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTrainingSessionInput = {
  /** In rand. */
  cost?: InputMaybe<Scalars['Float']['input']>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  /** Also record the certificate: a completed session, dated its end, expiring by the course's validity. */
  issueCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TrainingSessionStatus>;
};

export type UpdateUnitOfMeasureInput = {
  externalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVacancyInput = {
  closedDate?: InputMaybe<Scalars['DateTime']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  headcount?: InputMaybe<Scalars['Int']['input']>;
  hiringManagerId?: InputMaybe<Scalars['ID']['input']>;
  jobPositionId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openedDate?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<VacancyReason>;
  status?: InputMaybe<VacancyStatus>;
  targetFillDate?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebhookSubscriptionInput = {
  apiConsumerId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkshopPolicyInput = {
  maxTestTokenDays: Scalars['Int']['input'];
};

/** What happens to a closed contract's remaining balance. */
export type UpgradeBalanceTreatment =
  | 'CARRIED'
  | 'LEFT'
  | 'WRITTEN_OFF';

/** One of the customer's other contracts, as the upgrade onboarding shows it. */
export type UpgradeCandidate = {
  __typename?: 'UpgradeCandidate';
  balance?: Maybe<Scalars['Float']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  liveDevices?: Maybe<Scalars['Int']['output']>;
  notSelectableReason?: Maybe<Scalars['String']['output']>;
  paymentNumber?: Maybe<Scalars['String']['output']>;
  selectable?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ContractStatus>;
  statusGroup?: Maybe<ContractStatusGroup>;
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
};

export type UpgradeCreditInput = {
  amount: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
};

/** What happens to a closed contract's system: kept, or traded in and put back into stock. */
export type UpgradeDeviceOutcome =
  | 'KEPT'
  | 'TRADED_IN';

export type UpgradeOnboarding = {
  __typename?: 'UpgradeOnboarding';
  approvalRequestId?: Maybe<Scalars['ID']['output']>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  /** Why onboarding cannot start now. Null when it can. */
  blockedReason?: Maybe<Scalars['String']['output']>;
  candidates?: Maybe<Array<UpgradeCandidate>>;
  closableBalanceTotal?: Maybe<Scalars['Float']['output']>;
  contractId?: Maybe<Scalars['ID']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractTotalPrice?: Maybe<Scalars['Float']['output']>;
  contractUpgradeId?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  /** The deposit still to pay on the Upgrade contract, and the most a credit can be. */
  depositOutstanding?: Maybe<Scalars['Int']['output']>;
};

export type UpgradeSourceInput = {
  balance: UpgradeBalanceTreatment;
  contractId: Scalars['ID']['input'];
  device: UpgradeDeviceOutcome;
};

export type User = {
  __typename?: 'User';
  agent?: Maybe<Agent>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homeModule?: Maybe<HomeModule>;
  id?: Maybe<Scalars['ID']['output']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  sessionTimeoutEnabled?: Maybe<Scalars['Boolean']['output']>;
  stockingPointMemberships?: Maybe<Array<StockingPointMember>>;
  userDepartments?: Maybe<Array<UserDepartment>>;
  userRoles?: Maybe<Array<UserRole>>;
};

export type UserDepartment = {
  __typename?: 'UserDepartment';
  department?: Maybe<Department>;
  id?: Maybe<Scalars['ID']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  granted?: Maybe<Scalars['Boolean']['output']>;
  grantedById?: Maybe<Scalars['String']['output']>;
  grantedByName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  manualOverride?: Maybe<Scalars['Boolean']['output']>;
  module?: Maybe<Module>;
  reason?: Maybe<Scalars['String']['output']>;
  sourceRole?: Maybe<Role>;
  sourceRoleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type UserPermissionOverride = {
  __typename?: 'UserPermissionOverride';
  action?: Maybe<Scalars['String']['output']>;
  granted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  module?: Maybe<Module>;
  user?: Maybe<User>;
};

export type UserRole = {
  __typename?: 'UserRole';
  id?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<Role>;
  user?: Maybe<User>;
};

export type Vacancy = {
  __typename?: 'Vacancy';
  applicationCount: Scalars['Int']['output'];
  closedDate?: Maybe<Scalars['DateTime']['output']>;
  costs: Array<RecruitmentCost>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  headcount: Scalars['Int']['output'];
  hiredCount: Scalars['Int']['output'];
  hiringManager?: Maybe<RecruitmentUser>;
  id: Scalars['ID']['output'];
  jobPositionId?: Maybe<Scalars['ID']['output']>;
  jobPositionTitle?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  openedDate?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<VacancyReason>;
  status: VacancyStatus;
  targetFillDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
};

export type VacancyFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VacancyStatus>>;
};

export type VacancyList = {
  __typename?: 'VacancyList';
  items: Array<Vacancy>;
  totalCount: Scalars['Int']['output'];
};

export type VacancyReason =
  | 'NEW_ROLE'
  | 'REPLACEMENT';

export type VacancyStatus =
  | 'CANCELLED'
  | 'DRAFT'
  | 'FILLED'
  | 'ON_HOLD'
  | 'OPEN';

export type ValidateInvitePayload = {
  __typename?: 'ValidateInvitePayload';
  agentCategoryId?: Maybe<Scalars['String']['output']>;
  agentType?: Maybe<Scalars['String']['output']>;
  dccProfile?: Maybe<DccProfile>;
  email?: Maybe<Scalars['String']['output']>;
  externalAgentId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  getsStockingPoint?: Maybe<Scalars['Boolean']['output']>;
  isAgent?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  requireConfirmPassword?: Maybe<Scalars['Boolean']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyEmailInput = {
  code: Scalars['String']['input'];
};

export type WarrantyReplacementInput = {
  conditionNotes?: InputMaybe<Scalars['String']['input']>;
  defectiveSerialNumber: Scalars['String']['input'];
  deviceCondition: DeviceCondition;
  faultCategoryId?: InputMaybe<Scalars['String']['input']>;
  onBehalfOfAgentId?: InputMaybe<Scalars['String']['input']>;
  originalSaleId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  replacementStockItemId: Scalars['String']['input'];
  returnDestinationId?: InputMaybe<Scalars['String']['input']>;
};

export type WarrantyReport = {
  __typename?: 'WarrantyReport';
  items: Array<WarrantyReportRow>;
  totalCount: Scalars['Int']['output'];
  unidentifiedDevices: Scalars['Int']['output'];
  warrantyPeriodDays: Scalars['Int']['output'];
};

/** One warranty replacement: the device that failed, how old it was when it did, and the device issued in its place. */
export type WarrantyReportRow = {
  __typename?: 'WarrantyReportRow';
  accountNumber?: Maybe<Scalars['String']['output']>;
  ageDays?: Maybe<Scalars['Int']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  failureMode?: Maybe<Scalars['String']['output']>;
  faultDescription?: Maybe<Scalars['String']['output']>;
  inWarranty?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  productSku?: Maybe<Scalars['String']['output']>;
  repairOrReplacementDate: Scalars['DateTime']['output'];
  replacementAccountNumber?: Maybe<Scalars['String']['output']>;
  replacementSerialNumber?: Maybe<Scalars['String']['output']>;
  returnDate: Scalars['DateTime']['output'];
  saleReference: Scalars['String']['output'];
  salesDate?: Maybe<Scalars['DateTime']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  sparePartUsed?: Maybe<Scalars['String']['output']>;
};

export type WebhookDelivery = {
  __typename?: 'WebhookDelivery';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  responseBody?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<Scalars['Int']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: WebhookDeliveryStatus;
  subscription: WebhookSubscription;
  webhookEvent: WebhookEvent;
};

export type WebhookDeliveryStatus =
  | 'DELIVERED'
  | 'DELIVERING'
  | 'FAILED'
  | 'PENDING';

export type WebhookDirection =
  | 'INBOUND'
  | 'OUTBOUND';

export type WebhookEvent = {
  __typename?: 'WebhookEvent';
  correlationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveries: Array<WebhookDelivery>;
  direction: WebhookDirection;
  error?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  payload: Scalars['JSON']['output'];
  responseStatus?: Maybe<Scalars['Int']['output']>;
  signatureStatus?: Maybe<WebhookSignatureStatus>;
  source: Scalars['String']['output'];
  status: WebhookEventStatus;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type WebhookEventListInput = {
  direction?: InputMaybe<WebhookDirection>;
  event?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signatureStatus?: InputMaybe<WebhookSignatureStatus>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WebhookEventStatus>;
};

export type WebhookEventListResult = {
  __typename?: 'WebhookEventListResult';
  eventNames: Array<Scalars['String']['output']>;
  events: Array<WebhookEvent>;
  totalCount: Scalars['Int']['output'];
};

export type WebhookEventStatus =
  | 'FAILED'
  | 'IGNORED'
  | 'PROCESSED'
  | 'RECEIVED';

export type WebhookSignatureMode =
  | 'ENFORCE'
  | 'LOG_ONLY'
  | 'OFF';

export type WebhookSignatureStatus =
  | 'INVALID'
  | 'MISSING'
  | 'NOT_CHECKED'
  | 'VALID';

export type WebhookSubscription = {
  __typename?: 'WebhookSubscription';
  apiConsumer?: Maybe<ApiConsumer>;
  createdAt: Scalars['DateTime']['output'];
  events: Array<Scalars['String']['output']>;
  failedDeliveryCount: Scalars['Int']['output'];
  failuresClearedAt?: Maybe<Scalars['DateTime']['output']>;
  hasApiKey: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastFailureAt?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  maxAttempts: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pendingDeliveryCount: Scalars['Int']['output'];
  secretHint: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type WorkforceDepartmentCount = {
  __typename?: 'WorkforceDepartmentCount';
  count: Scalars['Int']['output'];
  departmentId?: Maybe<Scalars['ID']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
};

export type WorkforceFilterInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentTypes?: InputMaybe<Array<EmploymentType>>;
  workingPatterns?: InputMaybe<Array<WorkingPattern>>;
};

export type WorkforceMetrics = {
  __typename?: 'WorkforceMetrics';
  byDepartment: Array<WorkforceDepartmentCount>;
  contractEnded: HrMetric;
  contractors: HrMetric;
  fixedTerm: HrMetric;
  from: Scalars['DateTime']['output'];
  fullTime: HrMetric;
  grievances?: Maybe<Array<GrievanceStatusCount>>;
  headcount: HrMetric;
  involuntaryLeavers: HrMetric;
  netGrowth: HrMetric;
  netGrowthPercent: HrMetric;
  newHires: HrMetric;
  partTime: HrMetric;
  permanent: HrMetric;
  promotionRate: HrMetric;
  promotions: HrMetric;
  terminations: HrMetric;
  to: Scalars['DateTime']['output'];
  transfers: HrMetric;
  trend: Array<HeadcountPoint>;
  turnoverRate: HrMetric;
  voluntaryLeavers: HrMetric;
};

export type WorkingPattern =
  | 'FULL_TIME'
  | 'PART_TIME';

export type WorkshopIntakeCandidate = {
  __typename?: 'WorkshopIntakeCandidate';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  pendingTransfer?: Maybe<StockTransfer>;
  reportedCondition?: Maybe<DeviceCondition>;
  reportedFault?: Maybe<Scalars['String']['output']>;
  reportedFaultCategory?: Maybe<FaultCategory>;
  stockItem?: Maybe<StockItem>;
};

/** Damaged stock waiting at the facility a bench draws on. */
export type WorkshopIntakeQueue = {
  __typename?: 'WorkshopIntakeQueue';
  items?: Maybe<Array<WorkshopIntakeCandidate>>;
  source?: Maybe<StockingPoint>;
};

export type WorkshopJob = {
  __typename?: 'WorkshopJob';
  assignedTo?: Maybe<User>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  faultCategory?: Maybe<FaultCategory>;
  faultDescription?: Maybe<Scalars['String']['output']>;
  faultSubType?: Maybe<FaultSubType>;
  faultType?: Maybe<FaultType>;
  id: Scalars['ID']['output'];
  intakeReason: WorkshopJobIntakeReason;
  openedAt: Scalars['DateTime']['output'];
  openedBy?: Maybe<User>;
  partsUsed: Array<StockMovement>;
  physicalState?: Maybe<WorkshopJobPhysicalState>;
  physicalStateNote?: Maybe<Scalars['String']['output']>;
  scrapReason?: Maybe<Scalars['String']['output']>;
  stage: WorkshopJobStage;
  stockItem: StockItem;
  stockingPoint: StockingPoint;
  tokenTests: Array<WorkshopTokenTest>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WorkshopJobIntakeReason =
  | 'FIELD_FAULT'
  | 'NEW_CONFIGURATION'
  | 'WARRANTY_RETURN';

export type WorkshopJobListInput = {
  closedSince?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Array<WorkshopJobStage>>;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkshopJobListResult = {
  __typename?: 'WorkshopJobListResult';
  items: Array<WorkshopJob>;
  totalCount: Scalars['Int']['output'];
};

export type WorkshopJobPhysicalState =
  | 'AS_NEW'
  | 'DAMAGED'
  | 'USED';

export type WorkshopJobStage =
  | 'IN_WORKSHOP'
  | 'PENDING_PARTS'
  | 'READY_FOR_DISPATCH'
  | 'RELEASED'
  | 'SCRAPPED';

export type WorkshopPhysicalState =
  | 'AS_NEW'
  | 'DAMAGED'
  | 'USED';

/** Per-organization workshop settings. The most days a bench test token may carry is an anti-abuse ceiling: a test proves the unit takes a token, and a day does that as well as a month. */
export type WorkshopPolicy = {
  __typename?: 'WorkshopPolicy';
  maxTestTokenDays?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkshopStats = {
  __typename?: 'WorkshopStats';
  byDeviceType: Array<WorkshopStatsRow>;
  byFaultSubType: Array<WorkshopStatsRow>;
  byFaultType: Array<WorkshopStatsRow>;
  byProduct: Array<WorkshopStatsRow>;
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
  totals: WorkshopStatsCounts;
};

export type WorkshopStatsCounts = {
  __typename?: 'WorkshopStatsCounts';
  pendingParts: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  repaired: Scalars['Int']['output'];
  scrapped: Scalars['Int']['output'];
};

export type WorkshopStatsInput = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  /** One workshop; every workshop in reach when omitted. */
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkshopStatsRow = {
  __typename?: 'WorkshopStatsRow';
  /** On a fault sub-type row, the fault type it narrows. */
  faultTypeName?: Maybe<Scalars['String']['output']>;
  /** Null on the row for jobs where it was never recorded. */
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pendingParts: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  repaired: Scalars['Int']['output'];
  scrapped: Scalars['Int']['output'];
};

export type WorkshopTokenTest = {
  __typename?: 'WorkshopTokenTest';
  accountNumber: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deviceAccepted?: Maybe<Scalars['Boolean']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  requestedBy?: Maybe<User>;
  status: WorkshopTokenTestStatus;
  token?: Maybe<Scalars['String']['output']>;
  tokenSequence?: Maybe<Scalars['Int']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  verdictAt?: Maybe<Scalars['DateTime']['output']>;
  verdictBy?: Maybe<User>;
};

export type WorkshopTokenTestStatus =
  | 'DELIVERED'
  | 'FAILED'
  | 'PENDING';

export type WriteOffContractInput = {
  collectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  collectedByAgentId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: WriteOffReason;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
};

export type WriteOffReason =
  | 'NOT_REPOSSESSED'
  | 'REPOSSESSED'
  | 'THEFT';

export type WriteOffReportRecipient = {
  __typename?: 'WriteOffReportRecipient';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WriteOffWorkbook = {
  __typename?: 'WriteOffWorkbook';
  contentBase64: Scalars['String']['output'];
  /** Contracts on it; 0 is a workbook of headings only. */
  contracts: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
};

export type XeroConnectionStatus = {
  __typename?: 'XeroConnectionStatus';
  connected?: Maybe<Scalars['Boolean']['output']>;
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type XeroIntegrationLog = {
  __typename?: 'XeroIntegrationLog';
  contractId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  errorBody?: Maybe<Scalars['String']['output']>;
  httpStatus?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  requestPayload?: Maybe<Scalars['JSON']['output']>;
  retryCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export type XeroLogFilterInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
};

export type XeroLogStatus =
  | 'FAILED'
  | 'RETRYING'
  | 'SUCCESS';

export type XeroStep =
  | 'CONTACT_CREATE'
  | 'INVOICE_CREATE'
  | 'PAYMENT_APPLY'
  | 'REPEATING_INVOICE';

export type XeroSyncResult = {
  __typename?: 'XeroSyncResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  xeroContactId?: Maybe<Scalars['String']['output']>;
};

export type AgentAgreementDetailFragment = { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, partyType?: AgreementPartyType | null, templateVersion?: number | null, decisionReason?: string | null, issuedAt?: string | null, signedAt?: string | null, signingDate?: string | null, consentAcceptedAt?: string | null, documentHash?: string | null, signatureMethod?: AgreementSignatureMethod | null, slaDueAt?: string | null, slaBreached?: boolean | null, reviewedAt?: string | null, countersignedAt?: string | null, countersignedByName?: string | null, reminderCount?: number | null, createdAt?: string | null, partyNameSnapshot?: string | null, partyIdNumberSnapshot?: string | null, partyRegistrationNumberSnapshot?: string | null, partyAddressSnapshot?: string | null, signatoryNameSnapshot?: string | null, signatoryCapacitySnapshot?: string | null, template?: { __typename?: 'AgreementTemplate', id?: string | null, title?: string | null, version?: number | null, partyType?: AgreementPartyType | null, consentStatement?: string | null } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, agentType?: AgentType | null, agreementStatus?: AgentAgreementStatus | null } | null, signedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, documents?: Array<{ __typename?: 'Document', id?: string | null, documentType?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, createdAt?: string | null }> | null, events?: Array<{ __typename?: 'AgentAgreementEvent', id?: string | null, createdAt?: string | null, fromStatus?: AgentAgreementStatus | null, toStatus?: AgentAgreementStatus | null, reason?: string | null, actor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null };

export type MyAgentAgreementQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAgentAgreementQuery = { __typename?: 'Query', myAgentAgreement?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, partyType?: AgreementPartyType | null, templateVersion?: number | null, decisionReason?: string | null, issuedAt?: string | null, signedAt?: string | null, signingDate?: string | null, consentAcceptedAt?: string | null, documentHash?: string | null, signatureMethod?: AgreementSignatureMethod | null, slaDueAt?: string | null, slaBreached?: boolean | null, reviewedAt?: string | null, countersignedAt?: string | null, countersignedByName?: string | null, reminderCount?: number | null, createdAt?: string | null, partyNameSnapshot?: string | null, partyIdNumberSnapshot?: string | null, partyRegistrationNumberSnapshot?: string | null, partyAddressSnapshot?: string | null, signatoryNameSnapshot?: string | null, signatoryCapacitySnapshot?: string | null, template?: { __typename?: 'AgreementTemplate', id?: string | null, title?: string | null, version?: number | null, partyType?: AgreementPartyType | null, consentStatement?: string | null } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, agentType?: AgentType | null, agreementStatus?: AgentAgreementStatus | null } | null, signedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, documents?: Array<{ __typename?: 'Document', id?: string | null, documentType?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, createdAt?: string | null }> | null, events?: Array<{ __typename?: 'AgentAgreementEvent', id?: string | null, createdAt?: string | null, fromStatus?: AgentAgreementStatus | null, toStatus?: AgentAgreementStatus | null, reason?: string | null, actor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type MyAgreementPartyPrefillQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAgreementPartyPrefillQuery = { __typename?: 'Query', myAgreementPartyPrefill?: { __typename?: 'AgreementPartyDetails', partyName?: string | null, idNumber?: string | null, idType?: IdentificationType | null, registrationNumber?: string | null, address?: string | null, signatoryName?: string | null, signatoryCapacity?: string | null } | null };

export type AgentAgreementsQueryVariables = Exact<{
  filter?: InputMaybe<AgentAgreementFilterInput>;
}>;


export type AgentAgreementsQuery = { __typename?: 'Query', agentAgreements?: { __typename?: 'AgentAgreementListResult', totalCount: number, items: Array<{ __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, partyType?: AgreementPartyType | null, templateVersion?: number | null, signedAt?: string | null, signingDate?: string | null, slaDueAt?: string | null, slaBreached?: boolean | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, agentType?: AgentType | null } | null, template?: { __typename?: 'AgreementTemplate', id?: string | null, title?: string | null } | null }> } | null };

export type AgentAgreementQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AgentAgreementQuery = { __typename?: 'Query', agentAgreement?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, partyType?: AgreementPartyType | null, templateVersion?: number | null, decisionReason?: string | null, issuedAt?: string | null, signedAt?: string | null, signingDate?: string | null, consentAcceptedAt?: string | null, documentHash?: string | null, signatureMethod?: AgreementSignatureMethod | null, slaDueAt?: string | null, slaBreached?: boolean | null, reviewedAt?: string | null, countersignedAt?: string | null, countersignedByName?: string | null, reminderCount?: number | null, createdAt?: string | null, partyNameSnapshot?: string | null, partyIdNumberSnapshot?: string | null, partyRegistrationNumberSnapshot?: string | null, partyAddressSnapshot?: string | null, signatoryNameSnapshot?: string | null, signatoryCapacitySnapshot?: string | null, template?: { __typename?: 'AgreementTemplate', id?: string | null, title?: string | null, version?: number | null, partyType?: AgreementPartyType | null, consentStatement?: string | null } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, agentType?: AgentType | null, agreementStatus?: AgentAgreementStatus | null } | null, signedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, documents?: Array<{ __typename?: 'Document', id?: string | null, documentType?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, createdAt?: string | null }> | null, events?: Array<{ __typename?: 'AgentAgreementEvent', id?: string | null, createdAt?: string | null, fromStatus?: AgentAgreementStatus | null, toStatus?: AgentAgreementStatus | null, reason?: string | null, actor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type SignMyAgentAgreementMutationVariables = Exact<{
  input: SignAgreementInput;
}>;


export type SignMyAgentAgreementMutation = { __typename?: 'Mutation', signMyAgentAgreement?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, signedAt?: string | null, documentHash?: string | null } | null };

export type StartAgentAgreementReviewMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type StartAgentAgreementReviewMutation = { __typename?: 'Mutation', startAgentAgreementReview?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null } | null };

export type CountersignAgentAgreementMutationVariables = Exact<{
  id: Scalars['String']['input'];
  signingDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CountersignAgentAgreementMutation = { __typename?: 'Mutation', countersignAgentAgreement?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, countersignedByName?: string | null, countersignedAt?: string | null, signingDate?: string | null } | null };

export type RejectAgentAgreementMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RejectAgentAgreementMutation = { __typename?: 'Mutation', rejectAgentAgreement?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, decisionReason?: string | null } | null };

export type RequestAgentAgreementInfoMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RequestAgentAgreementInfoMutation = { __typename?: 'Mutation', requestAgentAgreementInfo?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, decisionReason?: string | null } | null };

export type DeclineAgentAgreementMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type DeclineAgentAgreementMutation = { __typename?: 'Mutation', declineAgentAgreement?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, decisionReason?: string | null } | null };

export type IssueAgentAgreementMutationVariables = Exact<{
  agentId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type IssueAgentAgreementMutation = { __typename?: 'Mutation', issueAgentAgreement?: { __typename?: 'AgentAgreement', id?: string | null, status?: AgentAgreementStatus | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null } | null };

export type GetAgentCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentCategoriesQuery = { __typename?: 'Query', agentCategories?: Array<{ __typename?: 'AgentCategory', id?: string | null, name?: string | null, rank?: number | null, canBeParent?: boolean | null, createdAt?: string | null, updatedAt?: string | null }> | null };

export type GetAgentCategoryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAgentCategoryQuery = { __typename?: 'Query', agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null, rank?: number | null, canBeParent?: boolean | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type CreateAgentCategoryMutationVariables = Exact<{
  input: CreateAgentCategoryInput;
}>;


export type CreateAgentCategoryMutation = { __typename?: 'Mutation', createAgentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null, rank?: number | null, canBeParent?: boolean | null } | null };

export type UpdateAgentCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateAgentCategoryInput;
}>;


export type UpdateAgentCategoryMutation = { __typename?: 'Mutation', updateAgentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null, rank?: number | null, canBeParent?: boolean | null } | null };

export type DeleteAgentCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAgentCategoryMutation = { __typename?: 'Mutation', deleteAgentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null } | null };

export type AgentDisputeFieldsFragment = { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, externalAgentId?: string | null, needsParentReconciliation?: boolean | null, pendingParentExternalId?: string | null, parentDisputed?: boolean | null, parentDisputeReason?: string | null, profileDisputed?: boolean | null, disputedFirstName?: string | null, disputedLastName?: string | null, dccFirstNameSnapshot?: string | null, dccLastNameSnapshot?: string | null, dccRamIdSnapshot?: string | null, dccRamNameSnapshot?: string | null, expectedParentExternalId?: string | null, parentMismatch?: boolean | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null } | null, parentAgent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, externalAgentId?: string | null } | null };

export type GetAgentDisputesQueryVariables = Exact<{
  input?: InputMaybe<ListDisputesInput>;
}>;


export type GetAgentDisputesQuery = { __typename?: 'Query', agentDisputes?: Array<{ __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, externalAgentId?: string | null, needsParentReconciliation?: boolean | null, pendingParentExternalId?: string | null, parentDisputed?: boolean | null, parentDisputeReason?: string | null, profileDisputed?: boolean | null, disputedFirstName?: string | null, disputedLastName?: string | null, dccFirstNameSnapshot?: string | null, dccLastNameSnapshot?: string | null, dccRamIdSnapshot?: string | null, dccRamNameSnapshot?: string | null, expectedParentExternalId?: string | null, parentMismatch?: boolean | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null } | null, parentAgent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, externalAgentId?: string | null } | null }> | null };

export type GetAgentDisputeCountQueryVariables = Exact<{
  input?: InputMaybe<ListDisputesInput>;
}>;


export type GetAgentDisputeCountQuery = { __typename?: 'Query', agentDisputeCount: number };

export type GetAgentDisputeResolutionsQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type GetAgentDisputeResolutionsQuery = { __typename?: 'Query', agentDisputeResolutions?: Array<{ __typename?: 'DisputeResolution', id?: string | null, createdAt?: string | null, disputeType?: string | null, outcome?: string | null, notes?: string | null, beforeValue?: string | null, afterValue?: string | null, resolvedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null };

export type ResolveDisputeMutationVariables = Exact<{
  input: ResolveDisputeInput;
}>;


export type ResolveDisputeMutation = { __typename?: 'Mutation', resolveDispute?: { __typename?: 'ResolveDisputePayload', agentId?: string | null, resolutionId?: string | null } | null };

export type AgentInviteApprovalFieldsFragment = { __typename?: 'AgentInviteApproval', id?: string | null, status: ApprovalStatus, email: string, firstName?: string | null, lastName?: string | null, agentType?: string | null, agentCategoryName?: string | null, claimsDormantAgent: boolean, createdAt?: string | null, reviewedAt?: string | null, reviewNotes?: string | null, parentAgent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null };

export type GetAgentInviteApprovalsQueryVariables = Exact<{
  input?: InputMaybe<AgentInviteApprovalListInput>;
}>;


export type GetAgentInviteApprovalsQuery = { __typename?: 'Query', agentInviteApprovals?: { __typename?: 'AgentInviteApprovalListResult', totalCount: number, items: Array<{ __typename?: 'AgentInviteApproval', id?: string | null, status: ApprovalStatus, email: string, firstName?: string | null, lastName?: string | null, agentType?: string | null, agentCategoryName?: string | null, claimsDormantAgent: boolean, createdAt?: string | null, reviewedAt?: string | null, reviewNotes?: string | null, parentAgent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null }> } | null };

export type GetAgentInviteApprovalCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentInviteApprovalCountsQuery = { __typename?: 'Query', agentInviteApprovalCounts: Array<{ __typename?: 'AgentInviteApprovalCount', status: string, count: number }> };

export type ReviewAgentInviteApprovalMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ReviewAgentInviteInput;
}>;


export type ReviewAgentInviteApprovalMutation = { __typename?: 'Mutation', reviewAgentInviteApproval?: { __typename?: 'AgentInviteApproval', id?: string | null, status: ApprovalStatus, email: string, firstName?: string | null, lastName?: string | null, agentType?: string | null, agentCategoryName?: string | null, claimsDormantAgent: boolean, createdAt?: string | null, reviewedAt?: string | null, reviewNotes?: string | null, parentAgent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null };

export type CancelAgentInviteApprovalMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelAgentInviteApprovalMutation = { __typename?: 'Mutation', cancelAgentInviteApproval?: { __typename?: 'AgentInviteApproval', id?: string | null, status: ApprovalStatus, email: string, firstName?: string | null, lastName?: string | null, agentType?: string | null, agentCategoryName?: string | null, claimsDormantAgent: boolean, createdAt?: string | null, reviewedAt?: string | null, reviewNotes?: string | null, parentAgent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null };

export type GetAgentsQueryVariables = Exact<{
  input?: InputMaybe<AgentListInput>;
}>;


export type GetAgentsQuery = { __typename?: 'Query', agents?: { __typename?: 'AgentListResult', totalCount: number, items: Array<{ __typename?: 'Agent', id?: string | null, salesId?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, paymentPhone?: string | null, taxId?: string | null, agentType?: AgentType | null, agreementStatus?: AgentAgreementStatus | null, status?: AgentStatus | null, province?: string | null, municipality?: string | null, canSell?: boolean | null, canHoldStock?: boolean | null, canDoReplacements?: boolean | null, createdAt?: string | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null } | null }> } | null };

export type GetAgentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAgentQuery = { __typename?: 'Query', agent?: { __typename?: 'Agent', id?: string | null, salesId?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, paymentPhone?: string | null, taxId?: string | null, province?: string | null, municipality?: string | null, bankName?: string | null, bankAccountNumber?: string | null, bankBranchCode?: string | null, bankAccountType?: AgentBankAccountType | null, agentType?: AgentType | null, status?: AgentStatus | null, sourceSystem?: string | null, sourceAgentKey?: string | null, sourcePhone?: string | null, canSell?: boolean | null, canHoldStock?: boolean | null, canDoReplacements?: boolean | null, earnsMonthlyFee?: boolean | null, createdAt?: string | null, updatedAt?: string | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null, rank?: number | null, canBeParent?: boolean | null } | null, parentAgent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, childAgents?: Array<{ __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, status?: AgentStatus | null }> | null, user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, stockingPointUsers?: Array<{ __typename?: 'StockingPointUser', id?: string | null, isPrimary?: boolean | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null, type?: StockingPointType | null, stockOnTheWay?: { __typename?: 'StockOnTheWay', arriving?: { __typename?: 'StockArriving', devices?: number | null } | null } | null } | null }> | null, changeHistory?: Array<{ __typename?: 'AgentChangeHistory', id?: string | null, createdAt?: string | null, effectiveFrom?: string | null, fieldName?: string | null, oldValue?: string | null, newValue?: string | null, changeType?: string | null, changedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type GetAgentStockingPointsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAgentStockingPointsQuery = { __typename?: 'Query', agent?: { __typename?: 'Agent', id?: string | null, stockingPointUsers?: Array<{ __typename?: 'StockingPointUser', id?: string | null, isPrimary?: boolean | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, isActive?: boolean | null } | null }> | null } | null };

export type GetAgentStatusCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentStatusCountsQuery = { __typename?: 'Query', agentStatusCounts?: Array<{ __typename?: 'AgentStatusCount', status?: string | null, count?: number | null }> | null };

export type GetAgentsOnboardedThisMonthQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentsOnboardedThisMonthQuery = { __typename?: 'Query', agentsOnboardedThisMonth?: { __typename?: 'AgentOnboarding', month: string, total: number, byDistributor: Array<{ __typename?: 'AgentOnboardingDistributor', distributorId?: string | null, distributorName?: string | null, distributorSalesId?: string | null, count: number }> } | null };

export type CreateAgentMutationVariables = Exact<{
  input: CreateAgentInput;
}>;


export type CreateAgentMutation = { __typename?: 'Mutation', createAgent?: { __typename?: 'Agent', id?: string | null, salesId?: string | null, firstName?: string | null, lastName?: string | null, status?: AgentStatus | null } | null };

export type UpdateAgentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateAgentInput;
}>;


export type UpdateAgentMutation = { __typename?: 'Mutation', updateAgent?: { __typename?: 'Agent', id?: string | null, salesId?: string | null, firstName?: string | null, lastName?: string | null, status?: AgentStatus | null } | null };

export type DeactivateAgentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeactivateAgentMutation = { __typename?: 'Mutation', deactivateAgent?: boolean | null };

export type ReactivateAgentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReactivateAgentMutation = { __typename?: 'Mutation', reactivateAgent?: boolean | null };

export type ReplaceAgentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  replacementAgentId: Scalars['String']['input'];
}>;


export type ReplaceAgentMutation = { __typename?: 'Mutation', replaceAgent?: boolean | null };

export type ApiConsumerFieldsFragment = { __typename?: 'ApiConsumer', id?: string | null, name?: string | null, clientId?: string | null, scopes?: Array<string> | null, isActive?: boolean | null, expiresAt?: string | null, lastUsedAt?: string | null, contactEmail?: string | null, createdAt?: string | null, updatedAt?: string | null };

export type GetApiConsumersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiConsumersQuery = { __typename?: 'Query', apiConsumers?: Array<{ __typename?: 'ApiConsumer', id?: string | null, name?: string | null, clientId?: string | null, scopes?: Array<string> | null, isActive?: boolean | null, expiresAt?: string | null, lastUsedAt?: string | null, contactEmail?: string | null, createdAt?: string | null, updatedAt?: string | null }> | null };

export type CreateApiConsumerMutationVariables = Exact<{
  input: CreateApiConsumerInput;
}>;


export type CreateApiConsumerMutation = { __typename?: 'Mutation', createApiConsumer?: { __typename?: 'CreateApiConsumerResult', clientId?: string | null, clientSecret?: string | null, consumer?: { __typename?: 'ApiConsumer', id?: string | null, name?: string | null, clientId?: string | null, scopes?: Array<string> | null, isActive?: boolean | null, expiresAt?: string | null, lastUsedAt?: string | null, contactEmail?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type RevokeApiConsumerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevokeApiConsumerMutation = { __typename?: 'Mutation', revokeApiConsumer?: { __typename?: 'ApiConsumer', id?: string | null, name?: string | null, clientId?: string | null, scopes?: Array<string> | null, isActive?: boolean | null, expiresAt?: string | null, lastUsedAt?: string | null, contactEmail?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type RotateApiConsumerSecretMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RotateApiConsumerSecretMutation = { __typename?: 'Mutation', rotateApiConsumerSecret?: { __typename?: 'RotateApiConsumerSecretResult', clientSecret?: string | null, consumer?: { __typename?: 'ApiConsumer', id?: string | null, name?: string | null, clientId?: string | null, scopes?: Array<string> | null, isActive?: boolean | null, expiresAt?: string | null, lastUsedAt?: string | null, contactEmail?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type GetApiConsumerUsageQueryVariables = Exact<{
  apiConsumerId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetApiConsumerUsageQuery = { __typename?: 'Query', apiConsumerUsage?: { __typename?: 'ConnectorUsage', days?: number | null, calls?: number | null, failed?: number | null, refused?: number | null, estimatedTokens?: number | null, averageDurationMs?: number | null, lastCallAt?: string | null, byDay?: Array<{ __typename?: 'ConnectorUsageDay', day?: string | null, calls?: number | null, failed?: number | null, estimatedTokens?: number | null }> | null, byTool?: Array<{ __typename?: 'ConnectorUsageTool', tool?: string | null, calls?: number | null, failed?: number | null, estimatedTokens?: number | null }> | null, recent?: Array<{ __typename?: 'ConnectorRequestEntry', id?: string | null, createdAt?: string | null, tool?: string | null, arguments?: Record<string, unknown> | null, ipAddress?: string | null, succeeded?: boolean | null, error?: string | null, durationMs?: number | null, estimatedTokens?: number | null }> | null } | null };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { __typename?: 'Query', apiKeys?: Array<{ __typename?: 'ApiKey', id?: string | null, name?: string | null, prefix?: string | null, isActive?: boolean | null, lastUsedAt?: string | null, createdAt?: string | null, inboundSignatureMode?: WebhookSignatureMode | null, hasInboundSecret?: boolean | null, user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey?: { __typename?: 'CreateApiKeyResult', rawKey?: string | null, apiKey?: { __typename?: 'ApiKey', id?: string | null, name?: string | null, prefix?: string | null, isActive?: boolean | null, createdAt?: string | null } | null } | null };

export type RevokeApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevokeApiKeyMutation = { __typename?: 'Mutation', revokeApiKey?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteApiKey?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type SetApiKeyInboundSignatureMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: SetInboundSignatureInput;
}>;


export type SetApiKeyInboundSignatureMutation = { __typename?: 'Mutation', setApiKeyInboundSignature?: { __typename?: 'ApiKey', id?: string | null, inboundSignatureMode?: WebhookSignatureMode | null, hasInboundSecret?: boolean | null } | null };

export type ApplicationFieldsFragment = { __typename?: 'Application', id?: string | null, referenceNumber?: string | null, employer?: string | null, income?: number | null, employmentStatus?: string | null, status?: string | null, metadata?: Record<string, unknown> | null, createdAt?: string | null, updatedAt?: string | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type DocumentFieldsFragment = { __typename?: 'Document', id?: string | null, fileName?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, documentType?: string | null, createdAt?: string | null, uploadedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type ChangeHistoryFieldsFragment = { __typename?: 'ApplicationChangeHistory', id?: string | null, fieldName?: string | null, oldValue?: string | null, newValue?: string | null, changeType?: string | null, createdAt?: string | null, changedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type GetApplicationsQueryVariables = Exact<{
  input?: InputMaybe<ApplicationListInput>;
}>;


export type GetApplicationsQuery = { __typename?: 'Query', applications?: { __typename?: 'ApplicationListResult', totalCount: number, items: Array<{ __typename?: 'Application', id?: string | null, referenceNumber?: string | null, status?: string | null, createdAt?: string | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null }> } | null };

export type GetApplicationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetApplicationQuery = { __typename?: 'Query', application?: { __typename?: 'Application', id?: string | null, referenceNumber?: string | null, employer?: string | null, income?: number | null, employmentStatus?: string | null, status?: string | null, metadata?: Record<string, unknown> | null, createdAt?: string | null, updatedAt?: string | null, documents?: Array<{ __typename?: 'Document', id?: string | null, fileName?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, documentType?: string | null, createdAt?: string | null, uploadedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null, changeHistory?: Array<{ __typename?: 'ApplicationChangeHistory', id?: string | null, fieldName?: string | null, oldValue?: string | null, newValue?: string | null, changeType?: string | null, createdAt?: string | null, changedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type CreateApplicationMutationVariables = Exact<{
  input: CreateApplicationInput;
}>;


export type CreateApplicationMutation = { __typename?: 'Mutation', createApplication?: { __typename?: 'Application', id?: string | null, referenceNumber?: string | null, status?: string | null } | null };

export type UpdateApplicationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateApplicationInput;
}>;


export type UpdateApplicationMutation = { __typename?: 'Mutation', updateApplication?: { __typename?: 'Application', id?: string | null, referenceNumber?: string | null, employer?: string | null, income?: number | null, employmentStatus?: string | null, status?: string | null, metadata?: Record<string, unknown> | null, createdAt?: string | null, updatedAt?: string | null, documents?: Array<{ __typename?: 'Document', id?: string | null, fileName?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, documentType?: string | null, createdAt?: string | null, uploadedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null, changeHistory?: Array<{ __typename?: 'ApplicationChangeHistory', id?: string | null, fieldName?: string | null, oldValue?: string | null, newValue?: string | null, changeType?: string | null, createdAt?: string | null, changedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetApprovalRequestsQueryVariables = Exact<{
  input?: InputMaybe<ApprovalListInput>;
}>;


export type GetApprovalRequestsQuery = { __typename?: 'Query', approvalRequests?: { __typename?: 'ApprovalListResult', totalCount: number, items: Array<{ __typename?: 'ApprovalRequest', id?: string | null, kind?: ApprovalRequestKind | null, createdAt?: string | null, status?: ApprovalStatus | null, requestReason?: string | null, reviewNotes?: string | null, reviewedAt?: string | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null, status?: string | null, contracts?: Array<{ __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null, rateName?: string | null, totalPrice?: number | null, depositAmount?: number | null, rateAmount?: number | null, termLength?: number | null }> | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null, depositAmount?: number | null, rateAmount?: number | null, termLength?: number | null } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } | null }> } | null };

export type GetApprovalRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetApprovalRequestQuery = { __typename?: 'Query', approvalRequest?: { __typename?: 'ApprovalRequest', id?: string | null, kind?: ApprovalRequestKind | null, createdAt?: string | null, status?: ApprovalStatus | null, requestReason?: string | null, reviewNotes?: string | null, reviewedAt?: string | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null, status?: string | null, contracts?: Array<{ __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null, rateName?: string | null, totalPrice?: number | null, depositAmount?: number | null, rateAmount?: number | null, termLength?: number | null, applicationType?: ContractApplicationType | null }> | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null, depositAmount?: number | null, rateAmount?: number | null, termLength?: number | null, products?: Array<{ __typename?: 'RatePlanProduct', id?: string | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null } | null }> | null } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null, stockSale?: { __typename?: 'StockSale', id?: string | null } | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null } | null } | null };

export type GetApprovalStatusCountsQueryVariables = Exact<{
  kinds?: InputMaybe<Array<ApprovalRequestKind> | ApprovalRequestKind>;
}>;


export type GetApprovalStatusCountsQuery = { __typename?: 'Query', approvalStatusCounts?: Array<{ __typename?: 'ApprovalStatusCount', status?: string | null, count?: number | null }> | null };

export type CreateApprovalRequestMutationVariables = Exact<{
  input: CreateApprovalRequestInput;
}>;


export type CreateApprovalRequestMutation = { __typename?: 'Mutation', createApprovalRequest?: { __typename?: 'ApprovalRequest', id?: string | null, status?: ApprovalStatus | null, requestReason?: string | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null } | null } | null };

export type ReviewApprovalRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ReviewApprovalInput;
}>;


export type ReviewApprovalRequestMutation = { __typename?: 'Mutation', reviewApprovalRequest?: { __typename?: 'ApprovalRequest', id?: string | null, status?: ApprovalStatus | null, reviewNotes?: string | null, reviewedAt?: string | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null } | null };

export type CancelApprovalRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelApprovalRequestMutation = { __typename?: 'Mutation', cancelApprovalRequest?: { __typename?: 'ApprovalRequest', id?: string | null, status?: ApprovalStatus | null } | null };

export type GetAtlasRekeyDevicesQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAtlasRekeyDevicesQuery = { __typename?: 'Query', atlasRekeyDevices?: Array<{ __typename?: 'AtlasRekeyDevice', stockSaleId?: string | null, contractId?: string | null, contractNumber?: string | null, accountNumber?: string | null, serialNumber?: string | null, productName?: string | null, vendor?: string | null }> | null };

export type GetAtlasTokenHistoryQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAtlasTokenHistoryQuery = { __typename?: 'Query', atlasTokenHistory?: { __typename?: 'AtlasTokenHistory', accountNumber?: string | null, page?: number | null, size?: number | null, totalTokens?: number | null, hasMore?: boolean | null, fetchedAt?: string | null, items?: Array<{ __typename?: 'AtlasHistoryToken', id?: string | null, token?: string | null, index?: number | null, tokenType?: string | null, issuedAt?: string | null }> | null } | null };

export type AttendanceEmployeeFieldsFragment = { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null };

export type AttendanceRecordFieldsFragment = { __typename?: 'AttendanceRecord', id: string, date: string, status: AttendanceStatus, hoursWorked?: number | null, overtimeHours?: number | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null } };

export type LeaveTypeFieldsFragment = { __typename?: 'LeaveType', id: string, category: LeaveCategory, name: string, entitlementDays?: number | null, cycleMonths?: number | null, paid?: boolean | null, active: boolean };

export type LeaveRequestFieldsFragment = { __typename?: 'LeaveRequest', id: string, startDate: string, endDate: string, days: number, reason?: string | null, status: LeaveRequestStatus, decidedAt?: string | null, decisionNote?: string | null, source: HrDataSource, createdAt: string, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType?: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } | null, approver?: { __typename?: 'LeaveApprover', id: string, email: string, firstName?: string | null, lastName?: string | null } | null };

export type LeaveBalanceFieldsFragment = { __typename?: 'LeaveBalance', id: string, cycleStart: string, cycleEnd: string, entitlementDays: number, takenDays: number, takenFromRequests: boolean, remainingDays: number, source: HrDataSource, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } };

export type HrImportResultFieldsFragment = { __typename?: 'HrImportResult', imported: number, errors: Array<{ __typename?: 'HrImportError', line: number, message: string }>, unmatched: Array<{ __typename?: 'HrUnmatchedLine', line: number, employeeNumber?: string | null, name?: string | null, reason: string }> };

export type AttendanceRecordsQueryVariables = Exact<{
  filter?: InputMaybe<AttendanceFilterInput>;
}>;


export type AttendanceRecordsQuery = { __typename?: 'Query', attendanceRecords: { __typename?: 'AttendanceRecordList', totalCount: number, items: Array<{ __typename?: 'AttendanceRecord', id: string, date: string, status: AttendanceStatus, hoursWorked?: number | null, overtimeHours?: number | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null } }> } };

export type AttendanceRecordsExportQueryVariables = Exact<{
  filter?: InputMaybe<AttendanceFilterInput>;
}>;


export type AttendanceRecordsExportQuery = { __typename?: 'Query', attendanceRecordsExport: Array<{ __typename?: 'AttendanceRecord', id: string, date: string, status: AttendanceStatus, hoursWorked?: number | null, overtimeHours?: number | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null } }> };

export type LeaveTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type LeaveTypesQuery = { __typename?: 'Query', leaveTypes: Array<{ __typename?: 'LeaveType', id: string, category: LeaveCategory, name: string, entitlementDays?: number | null, cycleMonths?: number | null, paid?: boolean | null, active: boolean }> };

export type LeaveRequestsQueryVariables = Exact<{
  filter?: InputMaybe<LeaveRequestFilterInput>;
}>;


export type LeaveRequestsQuery = { __typename?: 'Query', leaveRequests: { __typename?: 'LeaveRequestList', totalCount: number, items: Array<{ __typename?: 'LeaveRequest', id: string, startDate: string, endDate: string, days: number, reason?: string | null, status: LeaveRequestStatus, decidedAt?: string | null, decisionNote?: string | null, source: HrDataSource, createdAt: string, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType?: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } | null, approver?: { __typename?: 'LeaveApprover', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type LeaveBalancesQueryVariables = Exact<{
  filter?: InputMaybe<LeaveBalanceFilterInput>;
}>;


export type LeaveBalancesQuery = { __typename?: 'Query', leaveBalances: Array<{ __typename?: 'LeaveBalance', id: string, cycleStart: string, cycleEnd: string, entitlementDays: number, takenDays: number, takenFromRequests: boolean, remainingDays: number, source: HrDataSource, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } }> };

export type AttendanceMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filter?: InputMaybe<AttendanceMetricsFilterInput>;
}>;


export type AttendanceMetricsQuery = { __typename?: 'Query', attendanceMetrics: { __typename?: 'AttendanceMetrics', from: string, to: string, absenteeismRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, absentDays: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, scheduledDays: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, lateArrivals: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, hoursWorked: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, overtimeHours: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, sickDays: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, sickDaysPerEmployee: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, leaveDaysTaken: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, pendingLeaveRequests: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, leaveLiabilityDays: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, leaveTakenByType: Array<{ __typename?: 'LeaveDaysByType', category?: LeaveCategory | null, days: number }> } };

export type CreateAttendanceRecordMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  input: CreateAttendanceRecordInput;
}>;


export type CreateAttendanceRecordMutation = { __typename?: 'Mutation', createAttendanceRecord: { __typename?: 'AttendanceRecord', id: string, date: string, status: AttendanceStatus, hoursWorked?: number | null, overtimeHours?: number | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null } } };

export type UpdateAttendanceRecordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAttendanceRecordInput;
}>;


export type UpdateAttendanceRecordMutation = { __typename?: 'Mutation', updateAttendanceRecord: { __typename?: 'AttendanceRecord', id: string, date: string, status: AttendanceStatus, hoursWorked?: number | null, overtimeHours?: number | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null } } };

export type DeleteAttendanceRecordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAttendanceRecordMutation = { __typename?: 'Mutation', deleteAttendanceRecord: boolean };

export type ImportAttendanceMutationVariables = Exact<{
  csv: Scalars['String']['input'];
}>;


export type ImportAttendanceMutation = { __typename?: 'Mutation', importAttendance: { __typename?: 'HrImportResult', imported: number, errors: Array<{ __typename?: 'HrImportError', line: number, message: string }>, unmatched: Array<{ __typename?: 'HrUnmatchedLine', line: number, employeeNumber?: string | null, name?: string | null, reason: string }> } };

export type SeedLeaveTypesMutationVariables = Exact<{ [key: string]: never; }>;


export type SeedLeaveTypesMutation = { __typename?: 'Mutation', seedLeaveTypes: Array<{ __typename?: 'LeaveType', id: string, category: LeaveCategory, name: string, entitlementDays?: number | null, cycleMonths?: number | null, paid?: boolean | null, active: boolean }> };

export type UpdateLeaveTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLeaveTypeInput;
}>;


export type UpdateLeaveTypeMutation = { __typename?: 'Mutation', updateLeaveType: { __typename?: 'LeaveType', id: string, category: LeaveCategory, name: string, entitlementDays?: number | null, cycleMonths?: number | null, paid?: boolean | null, active: boolean } };

export type CreateLeaveRequestMutationVariables = Exact<{
  input: CreateLeaveRequestInput;
}>;


export type CreateLeaveRequestMutation = { __typename?: 'Mutation', createLeaveRequest: { __typename?: 'LeaveRequest', id: string, startDate: string, endDate: string, days: number, reason?: string | null, status: LeaveRequestStatus, decidedAt?: string | null, decisionNote?: string | null, source: HrDataSource, createdAt: string, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType?: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } | null, approver?: { __typename?: 'LeaveApprover', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type DecideLeaveRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  approve: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type DecideLeaveRequestMutation = { __typename?: 'Mutation', decideLeaveRequest: { __typename?: 'LeaveRequest', id: string, startDate: string, endDate: string, days: number, reason?: string | null, status: LeaveRequestStatus, decidedAt?: string | null, decisionNote?: string | null, source: HrDataSource, createdAt: string, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType?: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } | null, approver?: { __typename?: 'LeaveApprover', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type CancelLeaveRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelLeaveRequestMutation = { __typename?: 'Mutation', cancelLeaveRequest: { __typename?: 'LeaveRequest', id: string, startDate: string, endDate: string, days: number, reason?: string | null, status: LeaveRequestStatus, decidedAt?: string | null, decisionNote?: string | null, source: HrDataSource, createdAt: string, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType?: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } | null, approver?: { __typename?: 'LeaveApprover', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type CreateLeaveBalanceMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  leaveTypeId: Scalars['ID']['input'];
  input: CreateLeaveBalanceInput;
}>;


export type CreateLeaveBalanceMutation = { __typename?: 'Mutation', createLeaveBalance: { __typename?: 'LeaveBalance', id: string, cycleStart: string, cycleEnd: string, entitlementDays: number, takenDays: number, takenFromRequests: boolean, remainingDays: number, source: HrDataSource, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } } };

export type UpdateLeaveBalanceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLeaveBalanceInput;
}>;


export type UpdateLeaveBalanceMutation = { __typename?: 'Mutation', updateLeaveBalance: { __typename?: 'LeaveBalance', id: string, cycleStart: string, cycleEnd: string, entitlementDays: number, takenDays: number, takenFromRequests: boolean, remainingDays: number, source: HrDataSource, employee: { __typename?: 'AttendanceEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'AttendanceDepartment', id: string, name: string } | null }, leaveType: { __typename?: 'LeaveTypeSummary', id: string, category: LeaveCategory, name: string } } };

export type DeleteLeaveBalanceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLeaveBalanceMutation = { __typename?: 'Mutation', deleteLeaveBalance: boolean };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'AuthPayload', accessToken?: string | null, refreshToken?: string | null, expiresIn?: number | null, requiresEmailVerification?: boolean | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, confirmed?: boolean | null, isSuperAdmin?: boolean | null, homeModule?: HomeModule | null, organization?: { __typename?: 'Organization', id?: string | null, name?: string | null } | null } | null } | null };

export type AcceptInviteMutationVariables = Exact<{
  input: AcceptInviteInput;
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite?: { __typename?: 'AuthPayload', accessToken?: string | null, refreshToken?: string | null, expiresIn?: number | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, confirmed?: boolean | null, isSuperAdmin?: boolean | null, homeModule?: HomeModule | null, organization?: { __typename?: 'Organization', id?: string | null, name?: string | null } | null } | null } | null };

export type ValidateInviteMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ValidateInviteMutation = { __typename?: 'Mutation', validateInvite?: { __typename?: 'ValidateInvitePayload', valid?: boolean | null, email?: string | null, organizationName?: string | null, requireConfirmPassword?: boolean | null, isAgent?: boolean | null, agentType?: string | null, agentCategoryId?: string | null, getsStockingPoint?: boolean | null, firstName?: string | null, lastName?: string | null, externalAgentId?: string | null, dccProfile?: { __typename?: 'DccProfile', externalAgentId: string, name?: string | null, surname?: string | null, ramId?: string | null, ramName?: string | null, role?: string | null } | null } | null };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'RefreshPayload', accessToken?: string | null, expiresIn?: number | null } | null };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type GetBankStatementBatchesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBankStatementBatchesQuery = { __typename?: 'Query', bankStatementBatches: { __typename?: 'BankStatementBatchListResult', totalCount: number, items: Array<{ __typename?: 'BankStatementBatch', id: string, createdAt: string, processedAt?: string | null, uploadedByName?: string | null, bank: string, format: string, originalFileName: string, status: string, totalRows: number, matchedRows: number, processedRows: number }> } };

export type GetBankStatementBatchQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBankStatementBatchQuery = { __typename?: 'Query', bankStatementBatch: { __typename?: 'BankStatementBatch', id: string, createdAt: string, processedAt?: string | null, uploadedByName?: string | null, bank: string, format: string, originalFileName: string, status: string, totalRows: number, matchedRows: number, processedRows: number, eligibleProcessableRows: number, periods: Array<{ __typename?: 'BankStatementPeriod', weekStart: string, weekEnd: string, eligible: boolean, totalRows: number, processableRows: number }>, rows: Array<{ __typename?: 'BankStatementRow', id: string, rowIndex: number, bankUniqueId?: string | null, bankDate?: string | null, amount: number, rawDescription?: string | null, scrubbedDescription?: string | null, derivedAccountNumber?: string | null, matchedContractId?: string | null, matchedCustomerId?: string | null, customerName?: string | null, disposition: string, noLoadReason?: string | null, lastTransactionAt?: string | null, lastTransactionAmount?: number | null, paymentTransactionId?: string | null, error?: string | null }> } };

export type AutoMatchBankStatementMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
}>;


export type AutoMatchBankStatementMutation = { __typename?: 'Mutation', autoMatchBankStatement: { __typename?: 'BankStatementBatch', id: string, status: string, totalRows: number, matchedRows: number, processedRows: number } };

export type UpdateBankStatementRowMutationVariables = Exact<{
  input: UpdateBankStatementRowInput;
}>;


export type UpdateBankStatementRowMutation = { __typename?: 'Mutation', updateBankStatementRow: { __typename?: 'BankStatementRow', id: string, disposition: string, noLoadReason?: string | null, derivedAccountNumber?: string | null, matchedContractId?: string | null, matchedCustomerId?: string | null, customerName?: string | null, amount: number, error?: string | null, lastTransactionAt?: string | null, lastTransactionAmount?: number | null } };

export type ProcessBankStatementMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
  weekStarts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProcessBankStatementMutation = { __typename?: 'Mutation', processBankStatement: { __typename?: 'ProcessBankStatementResult', batchId: string, processed: number, skipped: number, failed: Array<{ __typename?: 'BankStatementProcessFailure', rowId: string, error: string }> } };

export type ProcessBankStatementsMutationVariables = Exact<{
  batchIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  weekStarts: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProcessBankStatementsMutation = { __typename?: 'Mutation', processBankStatements: Array<{ __typename?: 'ProcessBankStatementResult', batchId: string, processed: number, skipped: number, failed: Array<{ __typename?: 'BankStatementProcessFailure', rowId: string, error: string }> }> };

export type GetBankStatementTokenWeeksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankStatementTokenWeeksQuery = { __typename?: 'Query', bankStatementTokenWeeks: Array<{ __typename?: 'BankStatementTokenWeek', weekStart: string, weekEnd: string, processableRows: number, statements: Array<{ __typename?: 'BankStatementTokenCandidate', processableRows: number, batch: { __typename?: 'BankStatementBatch', id: string, createdAt: string, bank: string, originalFileName: string } }> }> };

export type SearchBankStatementContractsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchBankStatementContractsQuery = { __typename?: 'Query', bankStatementContractSearch: Array<{ __typename?: 'BankStatementContractMatch', contractId: string, contractNumber: string, status: string, customerName: string, accountNumber?: string | null }> };

export type GetBankStatementRowCandidatesQueryVariables = Exact<{
  rowId: Scalars['String']['input'];
}>;


export type GetBankStatementRowCandidatesQuery = { __typename?: 'Query', bankStatementRowCandidates: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, amount: number, reason?: string | null, createdBy: string, tokenDays?: number | null, bankConfirmed: boolean }> };

export type ReconcileBankStatementRowMutationVariables = Exact<{
  input: ReconcileBankStatementRowInput;
}>;


export type ReconcileBankStatementRowMutation = { __typename?: 'Mutation', reconcileBankStatementRow: { __typename?: 'BankStatementRow', id: string, disposition: string, noLoadReason?: string | null, paymentTransactionId?: string | null, error?: string | null } };

export type UnreconcileBankStatementRowMutationVariables = Exact<{
  rowId: Scalars['String']['input'];
}>;


export type UnreconcileBankStatementRowMutation = { __typename?: 'Mutation', unreconcileBankStatementRow: { __typename?: 'BankStatementRow', id: string, disposition: string, noLoadReason?: string | null, paymentTransactionId?: string | null, lastTransactionAt?: string | null, lastTransactionAmount?: number | null, error?: string | null } };

export type BankVerificationDetailFragment = { __typename?: 'BankVerification', id?: string | null, status?: BankVerificationStatus | null, decisionReason?: string | null, submittedAt?: string | null, slaDueAt?: string | null, slaBreached?: boolean | null, hasStaleProof?: boolean | null, reviewedAt?: string | null, reminderCount?: number | null, bankNameSnapshot?: string | null, bankAccountNumberSnapshot?: string | null, bankBranchCodeSnapshot?: string | null, bankAccountHolderSnapshot?: string | null, createdAt?: string | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, bankVerificationStatus?: BankVerificationStatus | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, documents?: Array<{ __typename?: 'Document', id?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, createdAt?: string | null }> | null, events?: Array<{ __typename?: 'BankVerificationEvent', id?: string | null, createdAt?: string | null, fromStatus?: BankVerificationStatus | null, toStatus?: BankVerificationStatus | null, reason?: string | null, actor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null };

export type MyBankVerificationQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBankVerificationQuery = { __typename?: 'Query', myBankVerification?: { __typename?: 'BankVerification', id?: string | null, status?: BankVerificationStatus | null, decisionReason?: string | null, submittedAt?: string | null, slaDueAt?: string | null, slaBreached?: boolean | null, hasStaleProof?: boolean | null, reviewedAt?: string | null, reminderCount?: number | null, bankNameSnapshot?: string | null, bankAccountNumberSnapshot?: string | null, bankBranchCodeSnapshot?: string | null, bankAccountHolderSnapshot?: string | null, createdAt?: string | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, bankVerificationStatus?: BankVerificationStatus | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, documents?: Array<{ __typename?: 'Document', id?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, createdAt?: string | null }> | null, events?: Array<{ __typename?: 'BankVerificationEvent', id?: string | null, createdAt?: string | null, fromStatus?: BankVerificationStatus | null, toStatus?: BankVerificationStatus | null, reason?: string | null, actor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type BankVerificationsQueryVariables = Exact<{
  filter?: InputMaybe<BankVerificationFilterInput>;
}>;


export type BankVerificationsQuery = { __typename?: 'Query', bankVerifications?: { __typename?: 'BankVerificationListResult', totalCount: number, items: Array<{ __typename?: 'BankVerification', id?: string | null, status?: BankVerificationStatus | null, submittedAt?: string | null, slaDueAt?: string | null, slaBreached?: boolean | null, hasStaleProof?: boolean | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null }> } | null };

export type BankVerificationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BankVerificationQuery = { __typename?: 'Query', bankVerification?: { __typename?: 'BankVerification', id?: string | null, status?: BankVerificationStatus | null, decisionReason?: string | null, submittedAt?: string | null, slaDueAt?: string | null, slaBreached?: boolean | null, hasStaleProof?: boolean | null, reviewedAt?: string | null, reminderCount?: number | null, bankNameSnapshot?: string | null, bankAccountNumberSnapshot?: string | null, bankBranchCodeSnapshot?: string | null, bankAccountHolderSnapshot?: string | null, createdAt?: string | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, bankVerificationStatus?: BankVerificationStatus | null } | null, reviewedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, documents?: Array<{ __typename?: 'Document', id?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, createdAt?: string | null }> | null, events?: Array<{ __typename?: 'BankVerificationEvent', id?: string | null, createdAt?: string | null, fromStatus?: BankVerificationStatus | null, toStatus?: BankVerificationStatus | null, reason?: string | null, actor?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type StartBankVerificationReviewMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type StartBankVerificationReviewMutation = { __typename?: 'Mutation', startBankVerificationReview?: { __typename?: 'BankVerification', id?: string | null, status?: BankVerificationStatus | null } | null };

export type ApproveBankVerificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApproveBankVerificationMutation = { __typename?: 'Mutation', approveBankVerification?: { __typename?: 'BankVerification', id?: string | null, status?: BankVerificationStatus | null } | null };

export type RejectBankVerificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RejectBankVerificationMutation = { __typename?: 'Mutation', rejectBankVerification?: { __typename?: 'BankVerification', id?: string | null, status?: BankVerificationStatus | null, decisionReason?: string | null } | null };

export type RequestBankVerificationInfoMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RequestBankVerificationInfoMutation = { __typename?: 'Mutation', requestBankVerificationInfo?: { __typename?: 'BankVerification', id?: string | null, status?: BankVerificationStatus | null, decisionReason?: string | null } | null };

export type GetBusinessLinesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessLinesQuery = { __typename?: 'Query', businessLines?: Array<{ __typename?: 'BusinessLine', id?: string | null, name?: string | null, externalCode?: string | null, productCount?: number | null, createdAt?: string | null, updatedAt?: string | null }> | null };

export type CreateBusinessLineMutationVariables = Exact<{
  input: CreateBusinessLineInput;
}>;


export type CreateBusinessLineMutation = { __typename?: 'Mutation', createBusinessLine?: { __typename?: 'BusinessLine', id?: string | null, name?: string | null, externalCode?: string | null } | null };

export type UpdateBusinessLineMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateBusinessLineInput;
}>;


export type UpdateBusinessLineMutation = { __typename?: 'Mutation', updateBusinessLine?: { __typename?: 'BusinessLine', id?: string | null, name?: string | null, externalCode?: string | null } | null };

export type DeleteBusinessLineMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteBusinessLineMutation = { __typename?: 'Mutation', deleteBusinessLine?: { __typename?: 'BusinessLine', id?: string | null, name?: string | null } | null };

export type GetCallsQueryVariables = Exact<{
  input: CallListInput;
}>;


export type GetCallsQuery = { __typename?: 'Query', calls?: { __typename?: 'CallListResult', totalCount: number, items: Array<{ __typename?: 'Call', id?: string | null, occurredAt?: string | null, source?: CallSource | null, callType?: string | null, durationSeconds?: number | null, dispositionOne?: string | null, dispositionTwo?: string | null, dispositionThree?: string | null, notes?: string | null, statedIssue?: string | null, solutionToIssue?: string | null, callerNumber?: string | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, loggedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type ExportCallsQueryVariables = Exact<{
  input: CallListInput;
}>;


export type ExportCallsQuery = { __typename?: 'Query', exportCalls?: { __typename?: 'CallListResult', totalCount: number, items: Array<{ __typename?: 'Call', id?: string | null, occurredAt?: string | null, source?: CallSource | null, callType?: string | null, durationSeconds?: number | null, dispositionOne?: string | null, dispositionTwo?: string | null, dispositionThree?: string | null, notes?: string | null, statedIssue?: string | null, solutionToIssue?: string | null, callerNumber?: string | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, loggedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type GetCallTypesQueryVariables = Exact<{
  input: CallListInput;
}>;


export type GetCallTypesQuery = { __typename?: 'Query', callTypes?: Array<string> | null };

export type CallCardFieldsFragment = { __typename?: 'Call', id?: string | null, occurredAt?: string | null, source?: CallSource | null, callType?: string | null, durationSeconds?: number | null, dispositionOne?: string | null, dispositionTwo?: string | null, dispositionThree?: string | null, notes?: string | null, statedIssue?: string | null, solutionToIssue?: string | null, callerNumber?: string | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, loggedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type CommissionApproachSettingsFieldsFragment = { __typename?: 'CommissionApproachSettings', currentPeriod: string, currentApproach: CommissionApproach, collectedFrom?: string | null, earliestFromPeriod?: string | null, changes: Array<{ __typename?: 'CommissionApproachChange', id: string, fromPeriod: string, approach: CommissionApproach, createdAt: string, changedByName?: string | null, removable: boolean }> };

export type RunningCommissionFigureFieldsFragment = { __typename?: 'RunningCommissionFigure', agentId: string, agentName: string, periodDate: string, computedAt: string, saleCommissionCents: number, monthlyAmountCents: number, feeCents: number, totalCents: number, saleMonths: number, paidUnits: number };

export type GetCommissionApproachQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommissionApproachQuery = { __typename?: 'Query', commissionApproach: { __typename?: 'CommissionApproachSettings', currentPeriod: string, currentApproach: CommissionApproach, collectedFrom?: string | null, earliestFromPeriod?: string | null, changes: Array<{ __typename?: 'CommissionApproachChange', id: string, fromPeriod: string, approach: CommissionApproach, createdAt: string, changedByName?: string | null, removable: boolean }> } };

export type GetMyRunningCommissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyRunningCommissionQuery = { __typename?: 'Query', myRunningCommission?: { __typename?: 'MyRunningCommission', periodDate: string, collected: boolean, current?: { __typename?: 'RunningCommissionFigure', agentId: string, agentName: string, periodDate: string, computedAt: string, saleCommissionCents: number, monthlyAmountCents: number, feeCents: number, totalCents: number, saleMonths: number, paidUnits: number } | null, previous?: { __typename?: 'RunningCommissionFigure', agentId: string, agentName: string, periodDate: string, computedAt: string, saleCommissionCents: number, monthlyAmountCents: number, feeCents: number, totalCents: number, saleMonths: number, paidUnits: number } | null, team: Array<{ __typename?: 'RunningCommissionFigure', agentId: string, agentName: string, periodDate: string, computedAt: string, saleCommissionCents: number, monthlyAmountCents: number, feeCents: number, totalCents: number, saleMonths: number, paidUnits: number }> } | null };

export type ScheduleCommissionApproachMutationVariables = Exact<{
  input: ScheduleCommissionApproachInput;
}>;


export type ScheduleCommissionApproachMutation = { __typename?: 'Mutation', scheduleCommissionApproach: { __typename?: 'CommissionApproachSettings', currentPeriod: string, currentApproach: CommissionApproach, collectedFrom?: string | null, earliestFromPeriod?: string | null, changes: Array<{ __typename?: 'CommissionApproachChange', id: string, fromPeriod: string, approach: CommissionApproach, createdAt: string, changedByName?: string | null, removable: boolean }> } };

export type RemoveCommissionApproachChangeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveCommissionApproachChangeMutation = { __typename?: 'Mutation', removeCommissionApproachChange: { __typename?: 'CommissionApproachSettings', currentPeriod: string, currentApproach: CommissionApproach, collectedFrom?: string | null, earliestFromPeriod?: string | null, changes: Array<{ __typename?: 'CommissionApproachChange', id: string, fromPeriod: string, approach: CommissionApproach, createdAt: string, changedByName?: string | null, removable: boolean }> } };

export type RefreshRunningCommissionMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshRunningCommissionMutation = { __typename?: 'Mutation', refreshRunningCommission: number };

export type GetCommissionPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommissionPolicyQuery = { __typename?: 'Query', commissionPolicy?: { __typename?: 'CommissionPolicy', trancheMonthBasis?: CommissionTrancheMonthBasis | null, monthOneStartsAt?: CommissionMonthOneStart | null, runDayOfNextMonth?: number | null, requireUpToDate?: boolean | null, missedTranche?: CommissionMissedTranche | null, visitMode?: CommissionVisitMode | null, monthlyUnitEligibility?: CommissionMonthlyUnitEligibility | null, distributorPaid?: CommissionDistributorPaid | null, paidOffBonusTiming?: CommissionPaidOffBonusTiming | null, minimumPayoutCents?: number | null, updatedAt?: string | null } | null };

export type UpdateCommissionPolicyMutationVariables = Exact<{
  input: UpdateCommissionPolicyInput;
}>;


export type UpdateCommissionPolicyMutation = { __typename?: 'Mutation', updateCommissionPolicy?: { __typename?: 'CommissionPolicy', trancheMonthBasis?: CommissionTrancheMonthBasis | null, monthOneStartsAt?: CommissionMonthOneStart | null, runDayOfNextMonth?: number | null, requireUpToDate?: boolean | null, missedTranche?: CommissionMissedTranche | null, visitMode?: CommissionVisitMode | null, monthlyUnitEligibility?: CommissionMonthlyUnitEligibility | null, distributorPaid?: CommissionDistributorPaid | null, paidOffBonusTiming?: CommissionPaidOffBonusTiming | null, minimumPayoutCents?: number | null, updatedAt?: string | null } | null };

export type GetCommissionRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommissionRulesQuery = { __typename?: 'Query', commissionRules?: Array<{ __typename?: 'CommissionRule', id?: string | null, commissionTypeId?: string | null, calculationMethod?: string | null, startMonth?: number | null, endMonth?: number | null, isNegative?: boolean | null, active?: boolean | null, ratePlanId?: string | null, createdAt?: string | null, updatedAt?: string | null, commissionType?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null, triggerEvent?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null } | null, rates?: Array<{ __typename?: 'CommissionRuleRate', id?: string | null, agentCategoryId?: string | null, amountCents?: number | null, percentage?: number | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null, rank?: number | null } | null }> | null }> | null };

export type GetCommissionRulesPageQueryVariables = Exact<{
  input?: InputMaybe<CommissionRuleListInput>;
}>;


export type GetCommissionRulesPageQuery = { __typename?: 'Query', commissionRulesPage?: { __typename?: 'CommissionRuleListResult', totalCount: number, items: Array<{ __typename?: 'CommissionRule', id?: string | null, commissionTypeId?: string | null, calculationMethod?: string | null, startMonth?: number | null, endMonth?: number | null, isNegative?: boolean | null, active?: boolean | null, ratePlanId?: string | null, commissionType?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null } | null, rates?: Array<{ __typename?: 'CommissionRuleRate', id?: string | null, agentCategoryId?: string | null, amountCents?: number | null, percentage?: number | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null, rank?: number | null } | null }> | null }> } | null };

export type GetCommissionRuleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCommissionRuleQuery = { __typename?: 'Query', commissionRule?: { __typename?: 'CommissionRule', id?: string | null, commissionTypeId?: string | null, calculationMethod?: string | null, startMonth?: number | null, endMonth?: number | null, isNegative?: boolean | null, active?: boolean | null, ratePlanId?: string | null, createdAt?: string | null, updatedAt?: string | null, commissionType?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null, triggerEvent?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null } | null, rates?: Array<{ __typename?: 'CommissionRuleRate', id?: string | null, agentCategoryId?: string | null, amountCents?: number | null, percentage?: number | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null, rank?: number | null } | null }> | null } | null };

export type CreateCommissionRuleMutationVariables = Exact<{
  input: CreateCommissionRuleInput;
  rates: Array<CommissionRuleRateInput> | CommissionRuleRateInput;
}>;


export type CreateCommissionRuleMutation = { __typename?: 'Mutation', createCommissionRule?: { __typename?: 'CommissionRule', id?: string | null, calculationMethod?: string | null, startMonth?: number | null, endMonth?: number | null, isNegative?: boolean | null, active?: boolean | null, ratePlanId?: string | null, commissionType?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null } | null, rates?: Array<{ __typename?: 'CommissionRuleRate', id?: string | null, agentCategoryId?: string | null, amountCents?: number | null, percentage?: number | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null } | null }> | null } | null };

export type UpdateCommissionRuleMutationVariables = Exact<{
  input: UpdateCommissionRuleInput;
  rates?: InputMaybe<Array<CommissionRuleRateInput> | CommissionRuleRateInput>;
}>;


export type UpdateCommissionRuleMutation = { __typename?: 'Mutation', updateCommissionRule?: { __typename?: 'CommissionRule', id?: string | null, calculationMethod?: string | null, startMonth?: number | null, endMonth?: number | null, isNegative?: boolean | null, active?: boolean | null, ratePlanId?: string | null, commissionType?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null } | null, rates?: Array<{ __typename?: 'CommissionRuleRate', id?: string | null, agentCategoryId?: string | null, amountCents?: number | null, percentage?: number | null, agentCategory?: { __typename?: 'AgentCategory', id?: string | null, name?: string | null } | null }> | null } | null };

export type DeleteCommissionRuleMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCommissionRuleMutation = { __typename?: 'Mutation', deleteCommissionRule?: boolean | null };

export type ToggleCommissionRuleActiveMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ToggleCommissionRuleActiveMutation = { __typename?: 'Mutation', toggleCommissionRuleActive?: { __typename?: 'CommissionRule', id?: string | null, active?: boolean | null } | null };

export type GetCommissionTypeConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommissionTypeConfigsQuery = { __typename?: 'Query', commissionTypeConfigs?: Array<{ __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null, triggerEvent?: string | null, createdAt?: string | null, updatedAt?: string | null }> | null };

export type GetCommissionTypeConfigQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCommissionTypeConfigQuery = { __typename?: 'Query', commissionTypeConfig?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null, triggerEvent?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type CreateCommissionTypeConfigMutationVariables = Exact<{
  input: CreateCommissionTypeInput;
}>;


export type CreateCommissionTypeConfigMutation = { __typename?: 'Mutation', createCommissionTypeConfig?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null, triggerEvent?: string | null } | null };

export type UpdateCommissionTypeConfigMutationVariables = Exact<{
  input: UpdateCommissionTypeInput;
}>;


export type UpdateCommissionTypeConfigMutation = { __typename?: 'Mutation', updateCommissionTypeConfig?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null, triggerEvent?: string | null } | null };

export type DeleteCommissionTypeConfigMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCommissionTypeConfigMutation = { __typename?: 'Mutation', deleteCommissionTypeConfig?: boolean | null };

export type GetCommissionEntriesQueryVariables = Exact<{
  input?: InputMaybe<CommissionEntryListInput>;
}>;


export type GetCommissionEntriesQuery = { __typename?: 'Query', commissionEntries?: { __typename?: 'CommissionEntryListResult', totalCount: number, items: Array<{ __typename?: 'CommissionEntry', id?: string | null, commissionType?: string | null, source?: string | null, note?: string | null, periodMonth?: number | null, periodDate?: string | null, amountCents?: number | null, amountRands?: number | null, status?: string | null, approvedAt?: string | null, paidAt?: string | null, cancelledAt?: string | null, cancelReason?: string | null, createdAt?: string | null, commissionTypeRef?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, stockSale?: { __typename?: 'StockSale', id?: string | null, saleReference?: string | null, saleDate?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null } | null }> } | null };

export type GetAgentCommissionSummaryQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
}>;


export type GetAgentCommissionSummaryQuery = { __typename?: 'Query', agentCommissionSummary?: { __typename?: 'AgentCommissionSummary', pendingAmountCents?: number | null, pendingAmountRands?: number | null, pendingCount?: number | null, approvedAmountCents?: number | null, approvedAmountRands?: number | null, approvedCount?: number | null, paidAmountCents?: number | null, paidAmountRands?: number | null, paidCount?: number | null, cancelledAmountCents?: number | null, cancelledCount?: number | null } | null };

export type GetCommissionSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommissionSummaryQuery = { __typename?: 'Query', commissionSummary?: { __typename?: 'CommissionSummary', pendingAmountRands?: number | null, pendingCount?: number | null, approvedAmountRands?: number | null, approvedCount?: number | null, paidAmountRands?: number | null, paidCount?: number | null, onHoldAmountRands: number, onHoldCount: number } | null };

export type GetMyCommissionSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCommissionSummaryQuery = { __typename?: 'Query', myCommissionSummary?: { __typename?: 'AgentCommissionSummary', pendingAmountCents?: number | null, pendingCount?: number | null, approvedAmountCents?: number | null, approvedCount?: number | null, paidAmountCents?: number | null, paidCount?: number | null } | null };

export type GetCommissionRunsQueryVariables = Exact<{
  input?: InputMaybe<CommissionRunListInput>;
}>;


export type GetCommissionRunsQuery = { __typename?: 'Query', commissionRuns?: { __typename?: 'CommissionRunListResult', totalCount: number, items: Array<{ __typename?: 'CommissionRun', id?: string | null, periodDate?: string | null, approach: CommissionApproach, status?: string | null, totalEntries?: number | null, totalAmountCents?: number | null, totalAmountRands?: number | null, paidAmountRands?: number | null, unpaidEntryCount?: number | null, errorMessage?: string | null, startedAt?: string | null, completedAt?: string | null, createdAt?: string | null, triggeredBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type GetNewDistributorFeeReviewQueryVariables = Exact<{
  periodDate: Scalars['DateTime']['input'];
}>;


export type GetNewDistributorFeeReviewQuery = { __typename?: 'Query', newDistributorFeeReview: Array<{ __typename?: 'NewDistributorFee', agentId: string, agentName: string, entryId?: string | null, onboardedAt: string, firstStockAt?: string | null, firstSaleAt?: string | null, daysCounted: number, daysInMonth: number, amountCents: number, amountRands: number, status: FeeReviewStatus, reason: string }> };

export type RunCommissionsMutationVariables = Exact<{
  input: RunCommissionInput;
}>;


export type RunCommissionsMutation = { __typename?: 'Mutation', runCommissions?: { __typename?: 'CommissionRun', id?: string | null, periodDate?: string | null, status?: string | null, totalEntries?: number | null, totalAmountCents?: number | null, totalAmountRands?: number | null, completedAt?: string | null } | null };

export type ApproveCommissionsMutationVariables = Exact<{
  input: ApproveCommissionsInput;
}>;


export type ApproveCommissionsMutation = { __typename?: 'Mutation', approveCommissions?: { __typename?: 'BulkActionResult', count?: number | null } | null };

export type ApproveHeldCommissionsMutationVariables = Exact<{
  input: ApproveCommissionsInput;
}>;


export type ApproveHeldCommissionsMutation = { __typename?: 'Mutation', approveHeldCommissions: { __typename?: 'BulkActionResult', count?: number | null } };

export type MarkCommissionsPaidMutationVariables = Exact<{
  input: MarkCommissionsPaidInput;
}>;


export type MarkCommissionsPaidMutation = { __typename?: 'Mutation', markCommissionsPaid?: { __typename?: 'MarkCommissionsPaidResult', paidCount?: number | null, skippedCount?: number | null, skipped?: Array<{ __typename?: 'SkippedPayout', agentId?: string | null, agentName?: string | null, reason?: string | null }> | null } | null };

export type MarkCommissionRunPaidMutationVariables = Exact<{
  input: MarkCommissionRunPaidInput;
}>;


export type MarkCommissionRunPaidMutation = { __typename?: 'Mutation', markCommissionRunPaid?: { __typename?: 'MarkCommissionsPaidResult', paidCount?: number | null, skippedCount?: number | null, skipped?: Array<{ __typename?: 'SkippedPayout', agentId?: string | null, agentName?: string | null, reason?: string | null }> | null } | null };

export type CancelCommissionMutationVariables = Exact<{
  input: CancelCommissionInput;
}>;


export type CancelCommissionMutation = { __typename?: 'Mutation', cancelCommission?: boolean | null };

export type CreateManualCommissionMutationVariables = Exact<{
  input: CreateManualCommissionInput;
}>;


export type CreateManualCommissionMutation = { __typename?: 'Mutation', createManualCommission?: { __typename?: 'CommissionEntry', id?: string | null, amountCents?: number | null, amountRands?: number | null, status?: string | null, source?: string | null, note?: string | null, periodDate?: string | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, commissionTypeRef?: { __typename?: 'CommissionTypeConfig', id?: string | null, name?: string | null, code?: string | null } | null } | null };

export type ExportCommissionEntriesQueryVariables = Exact<{
  input?: InputMaybe<CommissionEntryListInput>;
}>;


export type ExportCommissionEntriesQuery = { __typename?: 'Query', exportCommissionEntries?: { __typename?: 'CommissionEntryListResult', totalCount: number, items: Array<{ __typename?: 'CommissionEntry', commissionType?: string | null, source?: string | null, note?: string | null, periodMonth?: number | null, periodDate?: string | null, amountRands?: number | null, status?: string | null, approvedAt?: string | null, paidAt?: string | null, createdAt?: string | null, commissionTypeRef?: { __typename?: 'CommissionTypeConfig', name?: string | null, code?: string | null } | null, agent?: { __typename?: 'Agent', firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, stockSale?: { __typename?: 'StockSale', saleReference?: string | null, saleDate?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', rateName?: string | null } | null }> } | null };

export type ExportCommissionRunQueryVariables = Exact<{
  runId: Scalars['String']['input'];
}>;


export type ExportCommissionRunQuery = { __typename?: 'Query', exportCommissionRun?: { __typename?: 'CommissionRunWorkbook', fileName?: string | null, contentBase64?: string | null } | null };

export type IssueContractAccessoriesMutationVariables = Exact<{
  input: IssueContractAccessoriesInput;
}>;


export type IssueContractAccessoriesMutation = { __typename?: 'Mutation', issueContractAccessories?: Array<{ __typename?: 'ContractAccessory', id?: string | null, quantity: number }> | null };

export type ReturnContractAccessoryMutationVariables = Exact<{
  input: ReturnContractAccessoryInput;
}>;


export type ReturnContractAccessoryMutation = { __typename?: 'Mutation', returnContractAccessory?: { __typename?: 'ContractAccessory', id?: string | null, returnedAt?: string | null, returnReason?: ContractAccessoryReturnReason | null } | null };

export type AddAccessoryStockMutationVariables = Exact<{
  input: AddAccessoryStockInput;
}>;


export type AddAccessoryStockMutation = { __typename?: 'Mutation', addAccessoryStock?: number | null };

export type GetUpgradeOnboardingQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type GetUpgradeOnboardingQuery = { __typename?: 'Query', upgradeOnboarding?: { __typename?: 'UpgradeOnboarding', contractId?: string | null, contractNumber?: string | null, contractTotalPrice?: number | null, depositOutstanding?: number | null, customerId?: string | null, customerName?: string | null, approvalRequestId?: string | null, approvalStatus?: string | null, blockedReason?: string | null, contractUpgradeId?: string | null, closableBalanceTotal?: number | null, candidates?: Array<{ __typename?: 'UpgradeCandidate', id?: string | null, contractNumber?: string | null, paymentNumber?: string | null, status?: ContractStatus | null, statusGroup?: ContractStatusGroup | null, balance?: number | null, totalPaid?: number | null, tokenExpiresAt?: string | null, liveDevices?: number | null, selectable?: boolean | null, notSelectableReason?: string | null }> | null } | null };

export type GetContractUpgradeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetContractUpgradeQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id?: string | null, upgrade?: { __typename?: 'ContractUpgrade', id?: string | null, createdAt?: string | null, movedTotal?: number | null, writtenOffTotal?: number | null, creditAmount?: number | null, creditReason?: string | null, openingBalance?: number | null, note?: string | null, onboardedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, sources?: Array<{ __typename?: 'ContractUpgradeSource', id?: string | null, statusBefore?: ContractStatus | null, balanceAtClosure?: number | null, balanceTreatment?: UpgradeBalanceTreatment | null, deviceOutcome?: UpgradeDeviceOutcome | null, amountMoved?: number | null, amountWrittenOff?: number | null, sourceContract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null }> | null } | null } | null };

export type RequestUpgradeOnboardingMutationVariables = Exact<{
  input: RequestUpgradeOnboardingInput;
}>;


export type RequestUpgradeOnboardingMutation = { __typename?: 'Mutation', requestUpgradeOnboarding?: { __typename?: 'ApprovalRequest', id?: string | null, status?: ApprovalStatus | null } | null };

export type OnboardUpgradeMutationVariables = Exact<{
  input: OnboardUpgradeInput;
}>;


export type OnboardUpgradeMutation = { __typename?: 'Mutation', onboardUpgrade?: { __typename?: 'ContractUpgrade', id?: string | null, movedTotal?: number | null, writtenOffTotal?: number | null, creditAmount?: number | null, openingBalance?: number | null, sources?: Array<{ __typename?: 'ContractUpgradeSource', id?: string | null }> | null } | null };

export type GetContractsQueryVariables = Exact<{
  input?: InputMaybe<ContractListInput>;
}>;


export type GetContractsQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractListResult', totalCount: number, items: Array<{ __typename?: 'Contract', id?: string | null, contractNumber?: string | null, contractReference?: string | null, status?: string | null, statusGroup: ContractStatusGroup, subStatus?: ContractSubStatus | null, daysPastDue?: number | null, writeOffReason?: string | null, writeOffEligible: boolean, totalPrice?: number | null, priceAdjustment?: number | null, carriedBalance?: number | null, balance?: number | null, depositAmount?: number | null, depositOutstanding?: number | null, rateAmount?: number | null, nonTokenAmount?: number | null, rateName?: string | null, termLength?: number | null, registrationDate?: string | null, contractEndDate?: string | null, manSystem?: string | null, isMigrated?: boolean | null, applicationType?: ContractApplicationType | null, xeroInvoiceId?: string | null, xeroRepeatingInvoiceId?: string | null, createdAt?: string | null, distributorName?: string | null, nationalSalesManagerName?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null, depositAmount?: number | null, rateAmount?: number | null, downpayment?: number | null, termLength?: number | null } | null, stockSale?: { __typename?: 'StockSale', id?: string | null, stockItem?: { __typename?: 'StockItem', id?: string | null, accountNumber?: string | null } | null } | null }> } | null };

export type GetContractHeldBalanceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetContractHeldBalanceQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id?: string | null, heldBalance: number } | null };

export type GetContractStatusCountsQueryVariables = Exact<{
  mine?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContractStatusCountsQuery = { __typename?: 'Query', contractStatusCounts?: Array<{ __typename?: 'ContractStatusCount', status?: string | null, count?: number | null }> | null };

export type GetContractLifecycleSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractLifecycleSummaryQuery = { __typename?: 'Query', contractLifecycleSummary?: { __typename?: 'ContractLifecycleSummary', total?: number | null, draft?: number | null, pendingInstallation?: number | null, active?: number | null, paidOff?: number | null, cancelled?: number | null, upgraded?: number | null, writtenOff?: number | null, repossessed?: number | null, activeInCredit?: number | null, activeDelinquent?: number | null, activeWriteOffDue?: number | null, activeRepossessionDue?: number | null, writtenOffRepossessed?: number | null, writtenOffTheft?: number | null, writtenOffNotRepossessed?: number | null } | null };

export type GetContractQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetContractQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, paymentNumber?: string | null, paymentNumberNotifiedAt?: string | null, paymentNumberNotifiedTo?: string | null, contractReference?: string | null, status?: string | null, statusGroup: ContractStatusGroup, subStatus?: ContractSubStatus | null, daysPastDue?: number | null, writeOffReason?: string | null, writeOffEligible: boolean, totalPrice?: number | null, balance?: number | null, carriedBalance?: number | null, depositAmount?: number | null, depositOutstanding?: number | null, heldBalance: number, rateAmount?: number | null, nonTokenAmount?: number | null, commissionMonth1?: number | null, commissionMonth2?: number | null, commissionMonth3?: number | null, commissionMonth4?: number | null, commissionCloseout?: number | null, commissionRam?: number | null, aftercareAgent?: number | null, aftercareRam?: number | null, rateName?: string | null, termLength?: number | null, registrationDate?: string | null, contractEndDate?: string | null, flaggedForRepossessionAt?: string | null, flaggedForRepossessionReason?: string | null, isFlaggedForRepossession: boolean, repossessedAt?: string | null, manSystem?: string | null, externalId?: string | null, isMigrated?: boolean | null, applicationType?: ContractApplicationType | null, xeroInvoiceId?: string | null, xeroRepeatingInvoiceId?: string | null, createdAt?: string | null, updatedAt?: string | null, deviceCapacity?: number | null, flaggedForRepossessionBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, reopenPreview?: { __typename?: 'ReopenPreview', targetStatus?: ContractStatus | null, devicesPutBack: Array<string>, reasons: Array<ReopenReason>, blocker?: string | null, deviceStep?: ReopenDeviceStep | null, replaceBecause?: string | null, devicesToConfirm: Array<{ __typename?: 'ReopenDeviceToConfirm', productName?: string | null }> } | null, repossessedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, upgrade?: { __typename?: 'ContractUpgrade', id?: string | null, creditAmount?: number | null } | null, upgradedInto?: { __typename?: 'ContractUpgradeSource', id?: string | null, balanceTreatment?: UpgradeBalanceTreatment | null, deviceOutcome?: UpgradeDeviceOutcome | null, amountMoved?: number | null, amountWrittenOff?: number | null, contractUpgrade?: { __typename?: 'ContractUpgrade', id?: string | null, createdAt?: string | null, upgradeContract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null } | null } | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, manSystem?: string | null, depositAmount?: number | null, rateAmount?: number | null, downpayment?: number | null, termLength?: number | null, products?: Array<{ __typename?: 'RatePlanProduct', id?: string | null, allocationPercentage?: number | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null, canAcceptToken?: boolean | null } | null }> | null } | null, deviceControlActions?: Array<{ __typename?: 'DeviceControlAction', id?: string | null, createdAt?: string | null, action?: DeviceControlCommand | null, status?: DeviceControlStatus | null, accountNumber?: string | null, vendor?: string | null, token?: string | null, tokenSequence?: number | null, failureReason?: string | null, customerNotifiedAt?: string | null, customerNotifiedTo?: string | null, confirmedAt?: string | null, confirmedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, stockSale?: { __typename?: 'StockSale', id?: string | null } | null }> | null, accessories?: Array<{ __typename?: 'ContractAccessory', id?: string | null, issuedAt?: string | null, returnedAt?: string | null, returnReason?: ContractAccessoryReturnReason | null, quantity: number, issuedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, returnedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, product: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null }, stockItem?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } | null }> | null, stockSales?: Array<{ __typename?: 'StockSale', id?: string | null, status?: SaleStatus | null, saleReference?: string | null, saleDate?: string | null, deviceControl?: { __typename?: 'DeviceControlEligibility', eligible?: boolean | null, explanation?: string | null, vendor?: string | null, alreadyUnlockedAt?: string | null } | null, deviceLockControl?: { __typename?: 'DeviceLockEligibility', eligible?: boolean | null, explanation?: string | null, vendor?: string | null, requiresIndex?: boolean | null, runtimeAtRisk?: number | null, belief?: string | null, pendingSince?: string | null } | null, stockItem?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, hasMeter: boolean, meterHostedOn: MeterHost, meterTypeName?: string | null, meterTypeId?: number | null, meterStartingCode?: string | null, meterHasSecretKey: boolean } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, parentAgent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null } | null }> | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, changeHistory?: Array<{ __typename?: 'ContractChangeHistory', id?: string | null, fieldName?: string | null, oldValue?: string | null, newValue?: string | null, changeType?: string | null, createdAt?: string | null, changedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null, depositAmount?: number | null, rateAmount?: number | null, rateName?: string | null, termLength?: number | null, manSystem?: string | null } | null };

export type UpdateContractMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null, subStatus?: ContractSubStatus | null, daysPastDue?: number | null, writeOffReason?: string | null, writeOffEligible: boolean, depositAmount?: number | null, rateAmount?: number | null, nonTokenAmount?: number | null, rateName?: string | null, termLength?: number | null } | null };

export type ExportContractsQueryVariables = Exact<{
  input?: InputMaybe<ContractListInput>;
}>;


export type ExportContractsQuery = { __typename?: 'Query', exportContracts?: { __typename?: 'ContractListResult', totalCount: number, items: Array<{ __typename?: 'Contract', contractNumber?: string | null, contractReference?: string | null, status?: string | null, subStatus?: ContractSubStatus | null, daysPastDue?: number | null, totalPrice?: number | null, balance?: number | null, depositAmount?: number | null, depositOutstanding?: number | null, rateAmount?: number | null, rateName?: string | null, termLength?: number | null, registrationDate?: string | null, contractEndDate?: string | null, lastPaymentDate?: string | null, createdAt?: string | null, distributorName?: string | null, nationalSalesManagerName?: string | null, customer?: { __typename?: 'Customer', fullName?: string | null, phone?: string | null, idNumber?: string | null, identificationType?: string | null, address?: { __typename?: 'Address', streetAddress?: string | null, addressLevel1?: string | null, addressLevel2?: string | null, postalCode?: string | null, country?: string | null, countryName?: string | null } | null } | null, ratePlan?: { __typename?: 'RatePlan', rateName?: string | null, product?: string | null } | null, stockSales?: Array<{ __typename?: 'StockSale', stockItem?: { __typename?: 'StockItem', serialNumber?: string | null, accountNumber?: string | null } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null }> | null }> } | null };

export type FlagContractForRepossessionMutationVariables = Exact<{
  input: FlagForRepossessionInput;
}>;


export type FlagContractForRepossessionMutation = { __typename?: 'Mutation', flagContractForRepossession?: { __typename?: 'Contract', id?: string | null, status?: string | null, flaggedForRepossessionAt?: string | null, flaggedForRepossessionReason?: string | null, isFlaggedForRepossession: boolean, flaggedForRepossessionBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type ClearContractRepossessionFlagMutationVariables = Exact<{
  input: ClearRepossessionFlagInput;
}>;


export type ClearContractRepossessionFlagMutation = { __typename?: 'Mutation', clearContractRepossessionFlag?: { __typename?: 'Contract', id?: string | null, status?: string | null, flaggedForRepossessionAt?: string | null, flaggedForRepossessionReason?: string | null, isFlaggedForRepossession: boolean } | null };

export type RecordContractRepossessionMutationVariables = Exact<{
  input: RecordRepossessionInput;
}>;


export type RecordContractRepossessionMutation = { __typename?: 'Mutation', recordContractRepossession?: { __typename?: 'Contract', id?: string | null, status?: string | null, repossessedAt?: string | null, repossessedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type ReopenContractMutationVariables = Exact<{
  input: ReopenContractInput;
}>;


export type ReopenContractMutation = { __typename?: 'Mutation', reopenContract?: { __typename?: 'Contract', id?: string | null, status?: string | null, statusGroup: ContractStatusGroup, subStatus?: ContractSubStatus | null, daysPastDue?: number | null, writeOffReason?: string | null, writeOffEligible: boolean, balance?: number | null } | null };

export type WriteOffContractMutationVariables = Exact<{
  input: WriteOffContractInput;
}>;


export type WriteOffContractMutation = { __typename?: 'Mutation', writeOffContract?: { __typename?: 'Contract', id?: string | null, status?: string | null, writeOffReason?: string | null, writeOffEligible: boolean, repossessedAt?: string | null, repossessedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type UnlockContractDevicesMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  stockSaleId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UnlockContractDevicesMutation = { __typename?: 'Mutation', unlockContractDevices?: Array<{ __typename?: 'DeviceControlAction', id?: string | null, createdAt?: string | null, status?: DeviceControlStatus | null, accountNumber?: string | null, vendor?: string | null, token?: string | null, tokenSequence?: number | null, failureReason?: string | null, customerNotifiedAt?: string | null, customerNotifiedTo?: string | null, stockSale?: { __typename?: 'StockSale', id?: string | null } | null }> | null };

export type ResendContractPaymentNumberSmsMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  phoneOverride?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendContractPaymentNumberSmsMutation = { __typename?: 'Mutation', resendContractPaymentNumberSms?: { __typename?: 'Contract', id?: string | null, paymentNumberNotifiedAt?: string | null, paymentNumberNotifiedTo?: string | null } | null };

export type ResendDeviceUnlockSmsMutationVariables = Exact<{
  deviceControlActionId: Scalars['ID']['input'];
  phoneOverride?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendDeviceUnlockSmsMutation = { __typename?: 'Mutation', resendDeviceUnlockSms?: { __typename?: 'DeviceControlAction', id?: string | null, customerNotifiedAt?: string | null, customerNotifiedTo?: string | null } | null };

export type GetCustomerDeviceUnlocksQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerDeviceUnlocksQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractListResult', items: Array<{ __typename?: 'Contract', id?: string | null, deviceControlActions?: Array<{ __typename?: 'DeviceControlAction', id?: string | null, createdAt?: string | null, status?: DeviceControlStatus | null, accountNumber?: string | null, vendor?: string | null, token?: string | null, failureReason?: string | null, customerNotifiedAt?: string | null, customerNotifiedTo?: string | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null }> } | null };

export type LockContractDevicesMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  stockSaleId?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LockContractDevicesMutation = { __typename?: 'Mutation', lockContractDevices?: Array<{ __typename?: 'DeviceControlAction', id?: string | null, createdAt?: string | null, action?: DeviceControlCommand | null, status?: DeviceControlStatus | null, accountNumber?: string | null, vendor?: string | null, token?: string | null, tokenSequence?: number | null, failureReason?: string | null, confirmedAt?: string | null, stockSale?: { __typename?: 'StockSale', id?: string | null } | null }> | null };

export type ConfirmDeviceLockMutationVariables = Exact<{
  deviceControlActionId: Scalars['ID']['input'];
}>;


export type ConfirmDeviceLockMutation = { __typename?: 'Mutation', confirmDeviceLock?: { __typename?: 'DeviceControlAction', id?: string | null, confirmedAt?: string | null, confirmedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetContractIdsForBulkFlagQueryVariables = Exact<{
  input?: InputMaybe<ContractListInput>;
}>;


export type GetContractIdsForBulkFlagQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractListResult', totalCount: number, items: Array<{ __typename?: 'Contract', id?: string | null }> } | null };

export type BulkFlagContractsForRepossessionMutationVariables = Exact<{
  input: BulkFlagContractsForRepossessionInput;
}>;


export type BulkFlagContractsForRepossessionMutation = { __typename?: 'Mutation', bulkFlagContractsForRepossession?: { __typename?: 'BulkFlagRepossessionResult', total?: number | null, flagged?: number | null, skipped?: number | null, failed?: number | null, rows?: Array<{ __typename?: 'BulkFlagRepossessionRow', contractNumber?: string | null, status?: BulkFlagRepossessionRowStatus | null, reason?: string | null }> | null } | null };

export type GetCustomersQueryVariables = Exact<{
  input?: InputMaybe<CustomerSearchInput>;
}>;


export type GetCustomersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomerListResult', totalCount: number, items: Array<{ __typename?: 'Customer', id?: string | null, customerNumber?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, idNumber?: string | null, phone?: string | null, email?: string | null, status?: string | null, createdAt?: string | null, isMigrated?: boolean | null, primarySource?: string | null, distributorName?: string | null, nationalSalesManagerName?: string | null }> } | null };

export type ExportCustomersQueryVariables = Exact<{
  input?: InputMaybe<CustomerSearchInput>;
}>;


export type ExportCustomersQuery = { __typename?: 'Query', exportCustomers?: { __typename?: 'CustomerListResult', totalCount: number, items: Array<{ __typename?: 'Customer', firstName?: string | null, lastName?: string | null, idNumber?: string | null, dateOfBirth?: string | null, gender?: string | null, phone?: string | null, email?: string | null, employer?: string | null, income?: number | null, employmentStatus?: string | null, identificationType?: string | null, secondaryPhone?: string | null, occupation?: string | null, currentSourceOfLight?: string | null, secondaryContactFirstName?: string | null, secondaryContactLastName?: string | null, secondaryContactPhone?: string | null, status?: string | null, createdAt?: string | null, distributorName?: string | null, nationalSalesManagerName?: string | null, address?: { __typename?: 'Address', streetAddress?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressLevel1?: string | null, addressLevel2?: string | null, addressLevel3?: string | null, addressLevel4?: string | null, postalCode?: string | null, country?: string | null, countryName?: string | null } | null }> } | null };

export type GetCustomerStatusCountsQueryVariables = Exact<{
  mine?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomerStatusCountsQuery = { __typename?: 'Query', customerStatusCounts?: Array<{ __typename?: 'CustomerStatusCount', status?: string | null, count?: number | null }> | null };

export type GetCustomerQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id?: string | null, customerNumber?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, idNumber?: string | null, dateOfBirth?: string | null, gender?: string | null, phone?: string | null, email?: string | null, employer?: string | null, income?: number | null, employmentStatus?: string | null, identificationType?: string | null, secondaryPhone?: string | null, occupation?: string | null, currentSourceOfLight?: string | null, secondaryContactFirstName?: string | null, secondaryContactLastName?: string | null, secondaryContactPhone?: string | null, xeroContactId?: string | null, primarySource?: string | null, sourceSystemIds?: Record<string, unknown> | null, externalId?: string | null, isMigrated?: boolean | null, registrationDate?: string | null, gpsLatitude?: number | null, gpsLongitude?: number | null, status?: string | null, deactivatedAt?: string | null, archivedAt?: string | null, archivedReason?: string | null, createdAt?: string | null, updatedAt?: string | null, address?: { __typename?: 'Address', id?: string | null, streetAddress?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressLevel1?: string | null, addressLevel2?: string | null, addressLevel3?: string | null, addressLevel4?: string | null, postalCode?: string | null, country?: string | null, countryName?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, deactivatedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, changeHistory?: Array<{ __typename?: 'CustomerChangeHistory', id?: string | null, fieldName?: string | null, oldValue?: string | null, newValue?: string | null, changeType?: string | null, createdAt?: string | null, changedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type CheckDuplicateCustomerQueryVariables = Exact<{
  input: CheckDuplicateCustomerInput;
}>;


export type CheckDuplicateCustomerQuery = { __typename?: 'Query', checkDuplicateCustomer?: { __typename?: 'CheckDuplicateCustomerResult', hasDuplicates?: boolean | null, hardConflicts?: Array<{ __typename?: 'DuplicateMatch', id?: string | null, firstName?: string | null, lastName?: string | null, idNumber?: string | null, phone?: string | null, email?: string | null, status?: string | null, matchedOn?: string | null }> | null, softConflicts?: Array<{ __typename?: 'DuplicateMatch', id?: string | null, firstName?: string | null, lastName?: string | null, idNumber?: string | null, phone?: string | null, email?: string | null, status?: string | null, matchedOn?: string | null }> | null } | null };

export type CustomerStatementsQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type CustomerStatementsQuery = { __typename?: 'Query', customerStatements: Array<{ __typename?: 'CustomerStatement', id: string, number: string, issuedAt: string, periodFrom?: string | null, periodTo: string, totalBalance?: number | null, contractCount: number, issuedByName: string }> };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null };

export type UpdateCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, idNumber?: string | null, dateOfBirth?: string | null, gender?: string | null, phone?: string | null, email?: string | null, employer?: string | null, income?: number | null, employmentStatus?: string | null, identificationType?: string | null, secondaryPhone?: string | null, occupation?: string | null, currentSourceOfLight?: string | null, secondaryContactFirstName?: string | null, secondaryContactLastName?: string | null, secondaryContactPhone?: string | null, primarySource?: string | null, sourceSystemIds?: Record<string, unknown> | null, externalId?: string | null, isMigrated?: boolean | null, registrationDate?: string | null, gpsLatitude?: number | null, gpsLongitude?: number | null, status?: string | null, deactivatedAt?: string | null, archivedAt?: string | null, archivedReason?: string | null, createdAt?: string | null, updatedAt?: string | null, address?: { __typename?: 'Address', id?: string | null, streetAddress?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressLevel1?: string | null, addressLevel2?: string | null, addressLevel3?: string | null, addressLevel4?: string | null, postalCode?: string | null, country?: string | null, countryName?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, deactivatedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, changeHistory?: Array<{ __typename?: 'CustomerChangeHistory', id?: string | null, fieldName?: string | null, oldValue?: string | null, newValue?: string | null, changeType?: string | null, createdAt?: string | null, changedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type DeactivateCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeactivateCustomerMutation = { __typename?: 'Mutation', deactivateCustomer?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type ReactivateCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReactivateCustomerMutation = { __typename?: 'Mutation', reactivateCustomer?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type ArchiveCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type ArchiveCustomerMutation = { __typename?: 'Mutation', archiveCustomer?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RestoreCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreCustomerMutation = { __typename?: 'Mutation', restoreCustomer?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type ActivateCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ActivateCustomerMutation = { __typename?: 'Mutation', activateCustomer?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type SuspendCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SuspendCustomerMutation = { __typename?: 'Mutation', suspendCustomer?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type MarkCustomerDelinquentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkCustomerDelinquentMutation = { __typename?: 'Mutation', markCustomerDelinquent?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type LogRedactedFieldAccessMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
}>;


export type LogRedactedFieldAccessMutation = { __typename?: 'Mutation', logRedactedFieldAccess?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type GetDelinquencyPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDelinquencyPolicyQuery = { __typename?: 'Query', delinquencyPolicy?: { __typename?: 'DelinquencyPolicy', tier1Days?: number | null, tier2Days?: number | null, tier3Days?: number | null, writeOffThresholdDays?: number | null, repossessionThresholdDays?: number | null, updatedAt?: string | null } | null };

export type UpdateDelinquencyPolicyMutationVariables = Exact<{
  input: UpdateDelinquencyPolicyInput;
}>;


export type UpdateDelinquencyPolicyMutation = { __typename?: 'Mutation', updateDelinquencyPolicy?: { __typename?: 'DelinquencyPolicy', tier1Days?: number | null, tier2Days?: number | null, tier3Days?: number | null, writeOffThresholdDays?: number | null, repossessionThresholdDays?: number | null, updatedAt?: string | null } | null };

export type GetDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepartmentsQuery = { __typename?: 'Query', departments?: Array<{ __typename?: 'Department', id?: string | null, name?: string | null, createdAt?: string | null, userDepartments?: Array<{ __typename?: 'UserDepartment', id?: string | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null }> | null };

export type GetDepartmentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDepartmentQuery = { __typename?: 'Query', department?: { __typename?: 'Department', id?: string | null, name?: string | null, createdAt?: string | null, updatedAt?: string | null, userDepartments?: Array<{ __typename?: 'UserDepartment', id?: string | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type CreateDepartmentMutationVariables = Exact<{
  input: CreateDepartmentInput;
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment?: { __typename?: 'Department', id?: string | null, name?: string | null } | null };

export type UpdateDepartmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateDepartmentInput;
}>;


export type UpdateDepartmentMutation = { __typename?: 'Mutation', updateDepartment?: { __typename?: 'Department', id?: string | null, name?: string | null } | null };

export type DeleteDepartmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDepartmentMutation = { __typename?: 'Mutation', deleteDepartment?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type AssignUserToDepartmentMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  departmentId: Scalars['String']['input'];
}>;


export type AssignUserToDepartmentMutation = { __typename?: 'Mutation', assignUserToDepartment?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RemoveUserFromDepartmentMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  departmentId: Scalars['String']['input'];
}>;


export type RemoveUserFromDepartmentMutation = { __typename?: 'Mutation', removeUserFromDepartment?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type SetDepartmentAdminMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  departmentId: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
}>;


export type SetDepartmentAdminMutation = { __typename?: 'Mutation', setDepartmentAdmin: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } };

export type DeviceReassignmentFieldsFragment = { __typename?: 'DeviceReassignment', id?: string | null, createdAt?: string | null, previousSerialNumber?: string | null, previousAccountNumber?: string | null, newSerialNumber?: string | null, newAccountNumber?: string | null, cause?: DeviceReassignmentCause | null, notes?: string | null, contractPaidThroughAt?: string | null, deviceLoadedThroughAt?: string | null, tokenDaysShortfall?: number | null, swapGroupId?: string | null, customerNotifiedAt?: string | null, creditRecoveryTotal?: number | null, creditRecoveryPerPayment?: number | null, creditRecoveryRemaining?: number | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null };

export type ResolveCorrectDeviceQueryVariables = Exact<{
  contractId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  stockSaleId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResolveCorrectDeviceQuery = { __typename?: 'Query', resolveCorrectDevice?: { __typename?: 'ResolvedDevice', valid?: boolean | null, kind?: DeviceResolutionKind | null, error?: string | null, stockItemId?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, otherContractId?: string | null, otherContractNumber?: string | null, otherCustomerName?: string | null, otherStockSaleId?: string | null, tokenDaysShortfall?: number | null, otherTokenDaysShortfall?: number | null, warnings?: Array<{ __typename?: 'DeviceReassignmentWarning', code?: DeviceReassignmentWarningCode | null, detail?: string | null }> | null } | null };

export type ContractDeviceHistoryQueryVariables = Exact<{
  contractId: Scalars['String']['input'];
}>;


export type ContractDeviceHistoryQuery = { __typename?: 'Query', contractDeviceHistory?: Array<{ __typename?: 'DeviceReassignment', id?: string | null, createdAt?: string | null, previousSerialNumber?: string | null, previousAccountNumber?: string | null, newSerialNumber?: string | null, newAccountNumber?: string | null, cause?: DeviceReassignmentCause | null, notes?: string | null, contractPaidThroughAt?: string | null, deviceLoadedThroughAt?: string | null, tokenDaysShortfall?: number | null, swapGroupId?: string | null, customerNotifiedAt?: string | null, creditRecoveryTotal?: number | null, creditRecoveryPerPayment?: number | null, creditRecoveryRemaining?: number | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null }> | null };

export type ReassignContractDeviceMutationVariables = Exact<{
  input: ReassignContractDeviceInput;
}>;


export type ReassignContractDeviceMutation = { __typename?: 'Mutation', reassignContractDevice?: { __typename?: 'DeviceReassignment', id?: string | null, createdAt?: string | null, previousSerialNumber?: string | null, previousAccountNumber?: string | null, newSerialNumber?: string | null, newAccountNumber?: string | null, cause?: DeviceReassignmentCause | null, notes?: string | null, contractPaidThroughAt?: string | null, deviceLoadedThroughAt?: string | null, tokenDaysShortfall?: number | null, swapGroupId?: string | null, customerNotifiedAt?: string | null, creditRecoveryTotal?: number | null, creditRecoveryPerPayment?: number | null, creditRecoveryRemaining?: number | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null };

export type SwapContractDevicesMutationVariables = Exact<{
  input: SwapContractDevicesInput;
}>;


export type SwapContractDevicesMutation = { __typename?: 'Mutation', swapContractDevices?: Array<{ __typename?: 'DeviceReassignment', id?: string | null, createdAt?: string | null, previousSerialNumber?: string | null, previousAccountNumber?: string | null, newSerialNumber?: string | null, newAccountNumber?: string | null, cause?: DeviceReassignmentCause | null, notes?: string | null, contractPaidThroughAt?: string | null, deviceLoadedThroughAt?: string | null, tokenDaysShortfall?: number | null, swapGroupId?: string | null, customerNotifiedAt?: string | null, creditRecoveryTotal?: number | null, creditRecoveryPerPayment?: number | null, creditRecoveryRemaining?: number | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null }> | null };

export type GetDeviceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeviceTypesQuery = { __typename?: 'Query', deviceTypes?: Array<{ __typename?: 'DeviceType', id?: string | null, name?: string | null, isSystem?: boolean | null, sortOrder?: number | null, defaultMeterTypeId?: number | null, defaultMeterType?: { __typename?: 'MeterType', id?: string | null, name?: string | null } | null, fields?: Array<{ __typename?: 'DeviceTypeField', id?: string | null, field?: DeviceField | null, requirement?: FieldRequirement | null }> | null }> | null };

export type CreateDeviceTypeMutationVariables = Exact<{
  input: CreateDeviceTypeInput;
}>;


export type CreateDeviceTypeMutation = { __typename?: 'Mutation', createDeviceType?: { __typename?: 'DeviceType', id?: string | null, name?: string | null, isSystem?: boolean | null, sortOrder?: number | null, defaultMeterTypeId?: number | null, defaultMeterType?: { __typename?: 'MeterType', id?: string | null, name?: string | null } | null, fields?: Array<{ __typename?: 'DeviceTypeField', id?: string | null, field?: DeviceField | null, requirement?: FieldRequirement | null }> | null } | null };

export type UpdateDeviceTypeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateDeviceTypeInput;
}>;


export type UpdateDeviceTypeMutation = { __typename?: 'Mutation', updateDeviceType?: { __typename?: 'DeviceType', id?: string | null, name?: string | null, isSystem?: boolean | null, sortOrder?: number | null, defaultMeterTypeId?: number | null, defaultMeterType?: { __typename?: 'MeterType', id?: string | null, name?: string | null } | null, fields?: Array<{ __typename?: 'DeviceTypeField', id?: string | null, field?: DeviceField | null, requirement?: FieldRequirement | null }> | null } | null };

export type DeleteDeviceTypeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDeviceTypeMutation = { __typename?: 'Mutation', deleteDeviceType?: { __typename?: 'DeviceType', id?: string | null, name?: string | null } | null };

export type DigitalChannelFieldsFragment = { __typename?: 'DigitalChannel', id: string, name: string, kind: DigitalChannelKind, gaPropertyId: string, sortOrder: number, isActive: boolean };

export type DigitalChannelTotalsFieldsFragment = { __typename?: 'DigitalChannelTotals', activeUsers: number, newUsers: number, sessions: number, averageEngagementSeconds: number };

export type GetDigitalChannelsQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDigitalChannelsQuery = { __typename?: 'Query', digitalChannels: Array<{ __typename?: 'DigitalChannel', id: string, name: string, kind: DigitalChannelKind, gaPropertyId: string, sortOrder: number, isActive: boolean }> };

export type GetDigitalChannelOverviewQueryVariables = Exact<{
  input: DigitalChannelPeriodInput;
}>;


export type GetDigitalChannelOverviewQuery = { __typename?: 'Query', digitalChannelOverview: { __typename?: 'DigitalChannelOverview', dateFrom: string, dateTo: string, previousFrom: string, previousTo: string, channels: Array<{ __typename?: 'DigitalChannelSummary', status: DigitalChannelStatus, unavailableReason?: string | null, channel: { __typename?: 'DigitalChannel', id: string, name: string, kind: DigitalChannelKind, gaPropertyId: string, sortOrder: number, isActive: boolean }, current?: { __typename?: 'DigitalChannelTotals', activeUsers: number, newUsers: number, sessions: number, averageEngagementSeconds: number } | null, previous?: { __typename?: 'DigitalChannelTotals', activeUsers: number, newUsers: number, sessions: number, averageEngagementSeconds: number } | null, series: Array<{ __typename?: 'DigitalChannelDay', date: string, activeUsers: number, sessions: number }> }> } };

export type GetDigitalChannelDetailQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  input: DigitalChannelPeriodInput;
}>;


export type GetDigitalChannelDetailQuery = { __typename?: 'Query', digitalChannelDetail: { __typename?: 'DigitalChannelDetail', dateFrom: string, dateTo: string, status: DigitalChannelStatus, unavailableReason?: string | null, channel: { __typename?: 'DigitalChannel', id: string, name: string, kind: DigitalChannelKind, gaPropertyId: string, sortOrder: number, isActive: boolean }, topContent: Array<{ __typename?: 'DigitalChannelContentRow', label: string, views: number, activeUsers: number }>, trafficSources: Array<{ __typename?: 'DigitalChannelTrafficSourceRow', label: string, sessions: number, activeUsers: number }>, platforms: Array<{ __typename?: 'DigitalChannelBreakdownRow', label: string, activeUsers: number }>, appVersions: Array<{ __typename?: 'DigitalChannelBreakdownRow', label: string, activeUsers: number }> } };

export type CreateDigitalChannelMutationVariables = Exact<{
  input: CreateDigitalChannelInput;
}>;


export type CreateDigitalChannelMutation = { __typename?: 'Mutation', createDigitalChannel: { __typename?: 'DigitalChannel', id: string, name: string, kind: DigitalChannelKind, gaPropertyId: string, sortOrder: number, isActive: boolean } };

export type UpdateDigitalChannelMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateDigitalChannelInput;
}>;


export type UpdateDigitalChannelMutation = { __typename?: 'Mutation', updateDigitalChannel: { __typename?: 'DigitalChannel', id: string, name: string, kind: DigitalChannelKind, gaPropertyId: string, sortOrder: number, isActive: boolean } };

export type DeleteDigitalChannelMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDigitalChannelMutation = { __typename?: 'Mutation', deleteDigitalChannel: boolean };

export type DiversityMetricsQueryVariables = Exact<{
  asOf: Scalars['DateTime']['input'];
  filter?: InputMaybe<DiversityFilterInput>;
}>;


export type DiversityMetricsQuery = { __typename?: 'Query', diversityMetrics: { __typename?: 'DiversityMetrics', asOf: string, headcount: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, byGender: Array<{ __typename?: 'GenderCount', gender?: EmployeeGender | null, count: number }>, byRace: Array<{ __typename?: 'RaceCount', race?: EmployeeRace | null, count: number }>, byGenderRace: Array<{ __typename?: 'GenderRaceCount', gender?: EmployeeGender | null, race?: EmployeeRace | null, count: number }>, byJobLevel: Array<{ __typename?: 'JobLevelCount', level?: JobLevel | null, count: number }>, disabilityPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, youthPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, womenInManagementPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } } };

export type EmployeeDemographicsFieldsFragment = { __typename?: 'EmployeeDemographics', employeeId: string, gender?: EmployeeGender | null, race?: EmployeeRace | null, hasDisability?: boolean | null, dateOfBirth?: string | null, jobLevel?: JobLevel | null, isManagement?: boolean | null, updatedAt?: string | null, team?: { __typename?: 'DemographicsTeam', id: string, name: string, departmentId: string } | null, jobPosition?: { __typename?: 'DemographicsJobPosition', id: string, title: string, level?: JobLevel | null } | null };

export type EmployeeDemographicsQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type EmployeeDemographicsQuery = { __typename?: 'Query', employeeDemographics: { __typename?: 'EmployeeDemographics', employeeId: string, gender?: EmployeeGender | null, race?: EmployeeRace | null, hasDisability?: boolean | null, dateOfBirth?: string | null, jobLevel?: JobLevel | null, isManagement?: boolean | null, updatedAt?: string | null, team?: { __typename?: 'DemographicsTeam', id: string, name: string, departmentId: string } | null, jobPosition?: { __typename?: 'DemographicsJobPosition', id: string, title: string, level?: JobLevel | null } | null } };

export type UpdateEmployeeDemographicsMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  input: EmployeeDemographicsInput;
  movement?: InputMaybe<MovementDetailsInput>;
}>;


export type UpdateEmployeeDemographicsMutation = { __typename?: 'Mutation', updateEmployeeDemographics: { __typename?: 'EmployeeDemographics', employeeId: string, gender?: EmployeeGender | null, race?: EmployeeRace | null, hasDisability?: boolean | null, dateOfBirth?: string | null, jobLevel?: JobLevel | null, isManagement?: boolean | null, updatedAt?: string | null, team?: { __typename?: 'DemographicsTeam', id: string, name: string, departmentId: string } | null, jobPosition?: { __typename?: 'DemographicsJobPosition', id: string, title: string, level?: JobLevel | null } | null } };

export type TeamFieldsFragment = { __typename?: 'Team', id: string, name: string, memberCount: number, department: { __typename?: 'TeamDepartment', id: string, name: string } };

export type JobPositionFieldsFragment = { __typename?: 'JobPosition', id: string, title: string, level?: JobLevel | null, holderCount: number };

export type HrTeamsQueryVariables = Exact<{
  departmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type HrTeamsQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: string, name: string, memberCount: number, department: { __typename?: 'TeamDepartment', id: string, name: string } }> };

export type JobPositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobPositionsQuery = { __typename?: 'Query', jobPositions: Array<{ __typename?: 'JobPosition', id: string, title: string, level?: JobLevel | null, holderCount: number }> };

export type CreateTeamMutationVariables = Exact<{
  input: TeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, memberCount: number, department: { __typename?: 'TeamDepartment', id: string, name: string } } };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, name: string, memberCount: number, department: { __typename?: 'TeamDepartment', id: string, name: string } } };

export type DeleteTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: boolean };

export type CreateJobPositionMutationVariables = Exact<{
  input: JobPositionInput;
}>;


export type CreateJobPositionMutation = { __typename?: 'Mutation', createJobPosition: { __typename?: 'JobPosition', id: string, title: string, level?: JobLevel | null, holderCount: number } };

export type UpdateJobPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateJobPositionInput;
}>;


export type UpdateJobPositionMutation = { __typename?: 'Mutation', updateJobPosition: { __typename?: 'JobPosition', id: string, title: string, level?: JobLevel | null, holderCount: number } };

export type DeleteJobPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobPositionMutation = { __typename?: 'Mutation', deleteJobPosition: boolean };

export type GetCustomerDocumentsQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerDocumentsQuery = { __typename?: 'Query', customerDocuments?: Array<{ __typename?: 'Document', id?: string | null, fileName?: string | null, originalName?: string | null, mimeType?: string | null, size?: number | null, documentType?: string | null, createdAt?: string | null, application?: { __typename?: 'Application', id?: string | null, referenceNumber?: string | null } | null, uploadedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument?: { __typename?: 'DeleteDocumentResult', success?: boolean | null, message?: string | null } | null };

export type EsgProgrammeFieldsFragment = { __typename?: 'EsgProgramme', id: string, name: string, category?: EsgProgrammeCategory | null, bbbeeElement?: BbbeeElement | null, description?: string | null, startDate?: string | null, endDate?: string | null, budget?: number | null, status: EsgProgrammeStatus, location?: string | null, municipality?: string | null, spentToDate?: number | null, budgetUsedPercent?: number | null, beneficiaryCount: number, owner?: { __typename?: 'EsgUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null };

export type EsgSpendFieldsFragment = { __typename?: 'EsgSpend', id: string, spendDate: string, amount: number, description?: string | null, files: Array<{ __typename?: 'EsgEvidenceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> };

export type EsgBeneficiaryFieldsFragment = { __typename?: 'EsgBeneficiary', id: string, name: string, type: EsgBeneficiaryType, reachedDate: string, peopleCount?: number | null, gender?: EsgBeneficiaryGender | null, isYouth?: boolean | null, hasDisability?: boolean | null, location?: string | null, notes?: string | null, employee?: { __typename?: 'EsgEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null } | null };

export type EsgOutcomeFieldsFragment = { __typename?: 'EsgOutcome', id: string, metricName: string, value: number, unit?: string | null, measuredDate: string, notes?: string | null };

export type EsgVolunteeringFieldsFragment = { __typename?: 'EsgVolunteering', id: string, activityDate: string, hours: number, notes?: string | null, employee: { __typename?: 'EsgEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null } };

export type EsgProgrammesQueryVariables = Exact<{
  filter?: InputMaybe<EsgProgrammeFilterInput>;
}>;


export type EsgProgrammesQuery = { __typename?: 'Query', esgProgrammes: { __typename?: 'EsgProgrammeList', totalCount: number, items: Array<{ __typename?: 'EsgProgramme', id: string, name: string, category?: EsgProgrammeCategory | null, bbbeeElement?: BbbeeElement | null, description?: string | null, startDate?: string | null, endDate?: string | null, budget?: number | null, status: EsgProgrammeStatus, location?: string | null, municipality?: string | null, spentToDate?: number | null, budgetUsedPercent?: number | null, beneficiaryCount: number, owner?: { __typename?: 'EsgUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type EsgProgrammesExportQueryVariables = Exact<{
  filter?: InputMaybe<EsgProgrammeFilterInput>;
}>;


export type EsgProgrammesExportQuery = { __typename?: 'Query', esgProgrammesExport: Array<{ __typename?: 'EsgProgramme', id: string, name: string, category?: EsgProgrammeCategory | null, bbbeeElement?: BbbeeElement | null, description?: string | null, startDate?: string | null, endDate?: string | null, budget?: number | null, status: EsgProgrammeStatus, location?: string | null, municipality?: string | null, spentToDate?: number | null, budgetUsedPercent?: number | null, beneficiaryCount: number, owner?: { __typename?: 'EsgUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> };

export type EsgProgrammeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EsgProgrammeQuery = { __typename?: 'Query', esgProgramme: { __typename?: 'EsgProgrammeDetail', programme: { __typename?: 'EsgProgramme', id: string, name: string, category?: EsgProgrammeCategory | null, bbbeeElement?: BbbeeElement | null, description?: string | null, startDate?: string | null, endDate?: string | null, budget?: number | null, status: EsgProgrammeStatus, location?: string | null, municipality?: string | null, spentToDate?: number | null, budgetUsedPercent?: number | null, beneficiaryCount: number, owner?: { __typename?: 'EsgUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }, spend: Array<{ __typename?: 'EsgSpend', id: string, spendDate: string, amount: number, description?: string | null, files: Array<{ __typename?: 'EsgEvidenceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> }>, beneficiaries: Array<{ __typename?: 'EsgBeneficiary', id: string, name: string, type: EsgBeneficiaryType, reachedDate: string, peopleCount?: number | null, gender?: EsgBeneficiaryGender | null, isYouth?: boolean | null, hasDisability?: boolean | null, location?: string | null, notes?: string | null, employee?: { __typename?: 'EsgEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null } | null }>, outcomes: Array<{ __typename?: 'EsgOutcome', id: string, metricName: string, value: number, unit?: string | null, measuredDate: string, notes?: string | null }>, volunteering: Array<{ __typename?: 'EsgVolunteering', id: string, activityDate: string, hours: number, notes?: string | null, employee: { __typename?: 'EsgEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null } }> } };

export type EsgMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type EsgMetricsQuery = { __typename?: 'Query', esgMetrics: { __typename?: 'EsgMetrics', from: string, to: string, totalSpend: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, spendByCategory: Array<{ __typename?: 'EsgCategorySpend', category?: EsgProgrammeCategory | null, amount: number }>, spendByBbbeeElement: Array<{ __typename?: 'EsgElementSpend', element?: BbbeeElement | null, amount: number }>, budgetUsedPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, activeProgrammes: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, individualsReached: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, organisationsReached: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, communitiesReached: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, communityPeopleReached: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, beneficiariesByGender: Array<{ __typename?: 'EsgGenderCount', gender?: EsgBeneficiaryGender | null, count: number }>, beneficiariesByYouth: Array<{ __typename?: 'EsgFlagCount', value?: boolean | null, count: number }>, beneficiariesByDisability: Array<{ __typename?: 'EsgFlagCount', value?: boolean | null, count: number }>, volunteeringHours: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, volunteers: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, spendPercentOfNetProfit: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } } };

export type CreateEsgProgrammeMutationVariables = Exact<{
  input: CreateEsgProgrammeInput;
}>;


export type CreateEsgProgrammeMutation = { __typename?: 'Mutation', createEsgProgramme: { __typename?: 'EsgProgramme', id: string, name: string, category?: EsgProgrammeCategory | null, bbbeeElement?: BbbeeElement | null, description?: string | null, startDate?: string | null, endDate?: string | null, budget?: number | null, status: EsgProgrammeStatus, location?: string | null, municipality?: string | null, spentToDate?: number | null, budgetUsedPercent?: number | null, beneficiaryCount: number, owner?: { __typename?: 'EsgUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type UpdateEsgProgrammeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEsgProgrammeInput;
}>;


export type UpdateEsgProgrammeMutation = { __typename?: 'Mutation', updateEsgProgramme: { __typename?: 'EsgProgramme', id: string, name: string, category?: EsgProgrammeCategory | null, bbbeeElement?: BbbeeElement | null, description?: string | null, startDate?: string | null, endDate?: string | null, budget?: number | null, status: EsgProgrammeStatus, location?: string | null, municipality?: string | null, spentToDate?: number | null, budgetUsedPercent?: number | null, beneficiaryCount: number, owner?: { __typename?: 'EsgUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type DeleteEsgProgrammeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEsgProgrammeMutation = { __typename?: 'Mutation', deleteEsgProgramme: boolean };

export type CreateEsgSpendMutationVariables = Exact<{
  programmeId: Scalars['ID']['input'];
  input: CreateEsgSpendInput;
}>;


export type CreateEsgSpendMutation = { __typename?: 'Mutation', createEsgSpend: { __typename?: 'EsgSpend', id: string, spendDate: string, amount: number, description?: string | null, files: Array<{ __typename?: 'EsgEvidenceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type UpdateEsgSpendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEsgSpendInput;
}>;


export type UpdateEsgSpendMutation = { __typename?: 'Mutation', updateEsgSpend: { __typename?: 'EsgSpend', id: string, spendDate: string, amount: number, description?: string | null, files: Array<{ __typename?: 'EsgEvidenceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type DeleteEsgSpendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEsgSpendMutation = { __typename?: 'Mutation', deleteEsgSpend: boolean };

export type RemoveEsgSpendEvidenceMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type RemoveEsgSpendEvidenceMutation = { __typename?: 'Mutation', removeEsgSpendEvidence: boolean };

export type CreateEsgBeneficiaryMutationVariables = Exact<{
  programmeId: Scalars['ID']['input'];
  input: CreateEsgBeneficiaryInput;
}>;


export type CreateEsgBeneficiaryMutation = { __typename?: 'Mutation', createEsgBeneficiary: { __typename?: 'EsgBeneficiary', id: string, name: string, type: EsgBeneficiaryType, reachedDate: string, peopleCount?: number | null, gender?: EsgBeneficiaryGender | null, isYouth?: boolean | null, hasDisability?: boolean | null, location?: string | null, notes?: string | null, employee?: { __typename?: 'EsgEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null } | null } };

export type UpdateEsgBeneficiaryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEsgBeneficiaryInput;
}>;


export type UpdateEsgBeneficiaryMutation = { __typename?: 'Mutation', updateEsgBeneficiary: { __typename?: 'EsgBeneficiary', id: string, name: string, type: EsgBeneficiaryType, reachedDate: string, peopleCount?: number | null, gender?: EsgBeneficiaryGender | null, isYouth?: boolean | null, hasDisability?: boolean | null, location?: string | null, notes?: string | null, employee?: { __typename?: 'EsgEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null } | null } };

export type DeleteEsgBeneficiaryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEsgBeneficiaryMutation = { __typename?: 'Mutation', deleteEsgBeneficiary: boolean };

export type CreateEsgOutcomeMutationVariables = Exact<{
  programmeId: Scalars['ID']['input'];
  input: CreateEsgOutcomeInput;
}>;


export type CreateEsgOutcomeMutation = { __typename?: 'Mutation', createEsgOutcome: { __typename?: 'EsgOutcome', id: string, metricName: string, value: number, unit?: string | null, measuredDate: string, notes?: string | null } };

export type UpdateEsgOutcomeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEsgOutcomeInput;
}>;


export type UpdateEsgOutcomeMutation = { __typename?: 'Mutation', updateEsgOutcome: { __typename?: 'EsgOutcome', id: string, metricName: string, value: number, unit?: string | null, measuredDate: string, notes?: string | null } };

export type DeleteEsgOutcomeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEsgOutcomeMutation = { __typename?: 'Mutation', deleteEsgOutcome: boolean };

export type CreateEsgVolunteeringMutationVariables = Exact<{
  programmeId: Scalars['ID']['input'];
  input: CreateEsgVolunteeringInput;
}>;


export type CreateEsgVolunteeringMutation = { __typename?: 'Mutation', createEsgVolunteering: { __typename?: 'EsgVolunteering', id: string, activityDate: string, hours: number, notes?: string | null, employee: { __typename?: 'EsgEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null } } };

export type UpdateEsgVolunteeringMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEsgVolunteeringInput;
}>;


export type UpdateEsgVolunteeringMutation = { __typename?: 'Mutation', updateEsgVolunteering: { __typename?: 'EsgVolunteering', id: string, activityDate: string, hours: number, notes?: string | null, employee: { __typename?: 'EsgEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null } } };

export type DeleteEsgVolunteeringMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEsgVolunteeringMutation = { __typename?: 'Mutation', deleteEsgVolunteering: boolean };

export type GrievanceOfficerFieldsFragment = { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null };

export type GrievanceSummaryFieldsFragment = { __typename?: 'Grievance', id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null };

export type GrievanceDetailFieldsFragment = { __typename?: 'Grievance', description?: string | null, closedAt?: string | null, withdrawnAt?: string | null, resolutionNotes?: string | null, incidentDate?: string | null, incidentLocation?: string | null, involvement?: GrievanceInvolvement | null, managementAware?: GrievanceManagementAware | null, desiredOutcome?: string | null, id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, outcome?: { __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null } | null, events?: Array<{ __typename?: 'GrievanceEvent', id?: string | null, type?: GrievanceEventType | null, fromStatus?: GrievanceStatus | null, toStatus?: GrievanceStatus | null, note?: string | null, createdAt?: string | null, actor?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, messages?: Array<{ __typename?: 'GrievanceMessage', id?: string | null, from?: GrievanceMessageFrom | null, body?: string | null, createdAt?: string | null, author?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null };

export type GrievanceSettingsFieldsFragment = { __typename?: 'GrievanceSettings', messagesEnabled?: boolean | null, extraQuestionsEnabled?: boolean | null, contactPhone?: string | null, contactEmail?: string | null, contactHours?: string | null, replyPromiseWorkingDays?: number | null };

export type GrievanceDurationsFieldsFragment = { __typename?: 'GrievanceDurations', count?: number | null, medianHours?: number | null, p90Hours?: number | null };

export type GrievancesQueryVariables = Exact<{
  filter?: InputMaybe<GrievanceFilterInput>;
}>;


export type GrievancesQuery = { __typename?: 'Query', grievances?: { __typename?: 'GrievanceList', totalCount?: number | null, items?: Array<{ __typename?: 'Grievance', id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null } | null };

export type GrievanceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GrievanceQuery = { __typename?: 'Query', grievance?: { __typename?: 'Grievance', description?: string | null, closedAt?: string | null, withdrawnAt?: string | null, resolutionNotes?: string | null, incidentDate?: string | null, incidentLocation?: string | null, involvement?: GrievanceInvolvement | null, managementAware?: GrievanceManagementAware | null, desiredOutcome?: string | null, id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, outcome?: { __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null } | null, events?: Array<{ __typename?: 'GrievanceEvent', id?: string | null, type?: GrievanceEventType | null, fromStatus?: GrievanceStatus | null, toStatus?: GrievanceStatus | null, note?: string | null, createdAt?: string | null, actor?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, messages?: Array<{ __typename?: 'GrievanceMessage', id?: string | null, from?: GrievanceMessageFrom | null, body?: string | null, createdAt?: string | null, author?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null } | null };

export type GrievanceLookupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GrievanceLookupsQuery = { __typename?: 'Query', grievanceOfficers?: Array<{ __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null }> | null, grievanceCategories?: Array<{ __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null, active?: boolean | null, sortOrder?: number | null }> | null, grievanceOutcomes?: Array<{ __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null, active?: boolean | null, sortOrder?: number | null }> | null, grievanceSettings?: { __typename?: 'GrievanceSettings', messagesEnabled?: boolean | null, extraQuestionsEnabled?: boolean | null, contactPhone?: string | null, contactEmail?: string | null, contactHours?: string | null, replyPromiseWorkingDays?: number | null } | null };

export type GrievanceReportQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type GrievanceReportQuery = { __typename?: 'Query', grievanceReport?: { __typename?: 'GrievanceReport', from?: string | null, to?: string | null, total?: number | null, bySource?: Array<{ __typename?: 'GrievanceCount', key?: string | null, count?: number | null }> | null, byStatus?: Array<{ __typename?: 'GrievanceCount', key?: string | null, count?: number | null }> | null, byOutcome?: Array<{ __typename?: 'GrievanceCount', key?: string | null, count?: number | null }> | null, acknowledgement?: { __typename?: 'GrievanceDurations', count?: number | null, medianHours?: number | null, p90Hours?: number | null } | null, resolution?: { __typename?: 'GrievanceDurations', count?: number | null, medianHours?: number | null, p90Hours?: number | null } | null, openAgeing?: { __typename?: 'GrievanceDurations', count?: number | null, medianHours?: number | null, p90Hours?: number | null } | null, byCategory?: Array<{ __typename?: 'GrievanceCategoryReport', categoryCode?: string | null, count?: number | null, acknowledgement?: { __typename?: 'GrievanceDurations', count?: number | null, medianHours?: number | null, p90Hours?: number | null } | null, resolution?: { __typename?: 'GrievanceDurations', count?: number | null, medianHours?: number | null, p90Hours?: number | null } | null, openAgeing?: { __typename?: 'GrievanceDurations', count?: number | null, medianHours?: number | null, p90Hours?: number | null } | null }> | null } | null };

export type CreateGrievanceMutationVariables = Exact<{
  input: CreateGrievanceInput;
}>;


export type CreateGrievanceMutation = { __typename?: 'Mutation', createGrievance?: { __typename?: 'CreateGrievancePayload', accessCode?: string | null, grievance?: { __typename?: 'Grievance', description?: string | null, closedAt?: string | null, withdrawnAt?: string | null, resolutionNotes?: string | null, incidentDate?: string | null, incidentLocation?: string | null, involvement?: GrievanceInvolvement | null, managementAware?: GrievanceManagementAware | null, desiredOutcome?: string | null, id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, outcome?: { __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null } | null, events?: Array<{ __typename?: 'GrievanceEvent', id?: string | null, type?: GrievanceEventType | null, fromStatus?: GrievanceStatus | null, toStatus?: GrievanceStatus | null, note?: string | null, createdAt?: string | null, actor?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, messages?: Array<{ __typename?: 'GrievanceMessage', id?: string | null, from?: GrievanceMessageFrom | null, body?: string | null, createdAt?: string | null, author?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null } | null } | null };

export type AcknowledgeGrievanceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcknowledgeGrievanceMutation = { __typename?: 'Mutation', acknowledgeGrievance?: { __typename?: 'Grievance', description?: string | null, closedAt?: string | null, withdrawnAt?: string | null, resolutionNotes?: string | null, incidentDate?: string | null, incidentLocation?: string | null, involvement?: GrievanceInvolvement | null, managementAware?: GrievanceManagementAware | null, desiredOutcome?: string | null, id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, outcome?: { __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null } | null, events?: Array<{ __typename?: 'GrievanceEvent', id?: string | null, type?: GrievanceEventType | null, fromStatus?: GrievanceStatus | null, toStatus?: GrievanceStatus | null, note?: string | null, createdAt?: string | null, actor?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, messages?: Array<{ __typename?: 'GrievanceMessage', id?: string | null, from?: GrievanceMessageFrom | null, body?: string | null, createdAt?: string | null, author?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null } | null };

export type AssignGrievanceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  ownerUserId: Scalars['ID']['input'];
}>;


export type AssignGrievanceMutation = { __typename?: 'Mutation', assignGrievance?: { __typename?: 'Grievance', description?: string | null, closedAt?: string | null, withdrawnAt?: string | null, resolutionNotes?: string | null, incidentDate?: string | null, incidentLocation?: string | null, involvement?: GrievanceInvolvement | null, managementAware?: GrievanceManagementAware | null, desiredOutcome?: string | null, id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, outcome?: { __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null } | null, events?: Array<{ __typename?: 'GrievanceEvent', id?: string | null, type?: GrievanceEventType | null, fromStatus?: GrievanceStatus | null, toStatus?: GrievanceStatus | null, note?: string | null, createdAt?: string | null, actor?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, messages?: Array<{ __typename?: 'GrievanceMessage', id?: string | null, from?: GrievanceMessageFrom | null, body?: string | null, createdAt?: string | null, author?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null } | null };

export type UpdateGrievanceStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  toStatus: GrievanceStatusChange;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGrievanceStatusMutation = { __typename?: 'Mutation', updateGrievanceStatus?: { __typename?: 'Grievance', description?: string | null, closedAt?: string | null, withdrawnAt?: string | null, resolutionNotes?: string | null, incidentDate?: string | null, incidentLocation?: string | null, involvement?: GrievanceInvolvement | null, managementAware?: GrievanceManagementAware | null, desiredOutcome?: string | null, id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, outcome?: { __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null } | null, events?: Array<{ __typename?: 'GrievanceEvent', id?: string | null, type?: GrievanceEventType | null, fromStatus?: GrievanceStatus | null, toStatus?: GrievanceStatus | null, note?: string | null, createdAt?: string | null, actor?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, messages?: Array<{ __typename?: 'GrievanceMessage', id?: string | null, from?: GrievanceMessageFrom | null, body?: string | null, createdAt?: string | null, author?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null } | null };

export type AddGrievanceNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}>;


export type AddGrievanceNoteMutation = { __typename?: 'Mutation', addGrievanceNote?: { __typename?: 'GrievanceEvent', id?: string | null } | null };

export type ResolveGrievanceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  outcome: Scalars['String']['input'];
  resolutionNotes: Scalars['String']['input'];
}>;


export type ResolveGrievanceMutation = { __typename?: 'Mutation', resolveGrievance?: { __typename?: 'Grievance', description?: string | null, closedAt?: string | null, withdrawnAt?: string | null, resolutionNotes?: string | null, incidentDate?: string | null, incidentLocation?: string | null, involvement?: GrievanceInvolvement | null, managementAware?: GrievanceManagementAware | null, desiredOutcome?: string | null, id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, outcome?: { __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null } | null, events?: Array<{ __typename?: 'GrievanceEvent', id?: string | null, type?: GrievanceEventType | null, fromStatus?: GrievanceStatus | null, toStatus?: GrievanceStatus | null, note?: string | null, createdAt?: string | null, actor?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, messages?: Array<{ __typename?: 'GrievanceMessage', id?: string | null, from?: GrievanceMessageFrom | null, body?: string | null, createdAt?: string | null, author?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null } | null };

export type ReopenGrievanceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}>;


export type ReopenGrievanceMutation = { __typename?: 'Mutation', reopenGrievance?: { __typename?: 'Grievance', description?: string | null, closedAt?: string | null, withdrawnAt?: string | null, resolutionNotes?: string | null, incidentDate?: string | null, incidentLocation?: string | null, involvement?: GrievanceInvolvement | null, managementAware?: GrievanceManagementAware | null, desiredOutcome?: string | null, id?: string | null, reference?: string | null, source?: GrievanceSource | null, status?: GrievanceStatus | null, subject?: string | null, openedAt?: string | null, acknowledgedAt?: string | null, resolvedAt?: string | null, retaliationConcern?: boolean | null, outcome?: { __typename?: 'GrievanceOutcome', id?: string | null, code?: string | null, label?: string | null } | null, events?: Array<{ __typename?: 'GrievanceEvent', id?: string | null, type?: GrievanceEventType | null, fromStatus?: GrievanceStatus | null, toStatus?: GrievanceStatus | null, note?: string | null, createdAt?: string | null, actor?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, messages?: Array<{ __typename?: 'GrievanceMessage', id?: string | null, from?: GrievanceMessageFrom | null, body?: string | null, createdAt?: string | null, author?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null }> | null, category?: { __typename?: 'GrievanceCategory', id?: string | null, code?: string | null, label?: string | null } | null, owner?: { __typename?: 'GrievanceOfficer', id?: string | null, name?: string | null, email?: string | null } | null } | null };

export type SendGrievanceMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;


export type SendGrievanceMessageMutation = { __typename?: 'Mutation', sendGrievanceMessage?: { __typename?: 'GrievanceMessage', id?: string | null } | null };

export type UpdateGrievanceSettingsMutationVariables = Exact<{
  input: UpdateGrievanceSettingsInput;
}>;


export type UpdateGrievanceSettingsMutation = { __typename?: 'Mutation', updateGrievanceSettings?: { __typename?: 'GrievanceSettings', messagesEnabled?: boolean | null, extraQuestionsEnabled?: boolean | null, contactPhone?: string | null, contactEmail?: string | null, contactHours?: string | null, replyPromiseWorkingDays?: number | null } | null };

export type HrCaseFieldsFragment = { __typename?: 'HrCase', id: string, type: HrCaseType, status: HrCaseStatus, openedDate: string, closedDate?: string | null, description: string, cost?: number | null, offenceCategory?: string | null, sanction?: HrCaseSanction | null, warningExpiryDate?: string | null, caseNumber?: string | null, referralDate?: string | null, stage?: HrCaseStage | null, outcome?: HrCaseOutcome | null, updatedAt: string, employee: { __typename?: 'HrCasePerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, openedBy?: { __typename?: 'HrCaseUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null };

export type HrCasesQueryVariables = Exact<{
  filter?: InputMaybe<HrCaseFilterInput>;
}>;


export type HrCasesQuery = { __typename?: 'Query', hrCases: { __typename?: 'HrCaseList', totalCount: number, items: Array<{ __typename?: 'HrCase', id: string, type: HrCaseType, status: HrCaseStatus, openedDate: string, closedDate?: string | null, description: string, cost?: number | null, offenceCategory?: string | null, sanction?: HrCaseSanction | null, warningExpiryDate?: string | null, caseNumber?: string | null, referralDate?: string | null, stage?: HrCaseStage | null, outcome?: HrCaseOutcome | null, updatedAt: string, employee: { __typename?: 'HrCasePerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, openedBy?: { __typename?: 'HrCaseUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type HrCaseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HrCaseQuery = { __typename?: 'Query', hrCase: { __typename?: 'HrCase', id: string, type: HrCaseType, status: HrCaseStatus, openedDate: string, closedDate?: string | null, description: string, cost?: number | null, offenceCategory?: string | null, sanction?: HrCaseSanction | null, warningExpiryDate?: string | null, caseNumber?: string | null, referralDate?: string | null, stage?: HrCaseStage | null, outcome?: HrCaseOutcome | null, updatedAt: string, events: Array<{ __typename?: 'HrCaseEvent', id: string, kind: HrCaseEventKind, eventDate: string, note?: string | null, createdAt: string, actor?: { __typename?: 'HrCaseUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }>, documents: Array<{ __typename?: 'HrCaseDocument', id: string, originalName: string, mimeType: string, size: number, createdAt: string, uploadedBy: { __typename?: 'HrCaseUser', id: string, email: string, firstName?: string | null, lastName?: string | null } }>, employee: { __typename?: 'HrCasePerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, openedBy?: { __typename?: 'HrCaseUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type HrCasesExportQueryVariables = Exact<{
  filter?: InputMaybe<HrCaseFilterInput>;
}>;


export type HrCasesExportQuery = { __typename?: 'Query', hrCasesExport: Array<{ __typename?: 'HrCase', id: string, type: HrCaseType, status: HrCaseStatus, openedDate: string, closedDate?: string | null, description: string, cost?: number | null, offenceCategory?: string | null, sanction?: HrCaseSanction | null, warningExpiryDate?: string | null, caseNumber?: string | null, referralDate?: string | null, stage?: HrCaseStage | null, outcome?: HrCaseOutcome | null, updatedAt: string, employee: { __typename?: 'HrCasePerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, openedBy?: { __typename?: 'HrCaseUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> };

export type HrCaseMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filter?: InputMaybe<HrCaseMetricsFilterInput>;
}>;


export type HrCaseMetricsQuery = { __typename?: 'Query', hrCaseMetrics: { __typename?: 'HrCaseMetrics', from: string, to: string, openCases: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, openByType: Array<{ __typename?: 'HrCaseTypeCount', type?: HrCaseType | null, count: number }>, newCases: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, disciplinaryCases: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, disciplinaryPer100: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, bySanction: Array<{ __typename?: 'HrCaseSanctionCount', sanction?: HrCaseSanction | null, count: number }>, activeWarnings: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, ccmaReferrals: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, disputeWinRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, disputesByOutcome: Array<{ __typename?: 'HrCaseOutcomeCount', outcome?: HrCaseOutcome | null, count: number }>, averageDaysToClose: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, totalCost: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } } };

export type CreateHrCaseMutationVariables = Exact<{
  input: CreateHrCaseInput;
}>;


export type CreateHrCaseMutation = { __typename?: 'Mutation', createHrCase: { __typename?: 'HrCase', id: string, type: HrCaseType, status: HrCaseStatus, openedDate: string, closedDate?: string | null, description: string, cost?: number | null, offenceCategory?: string | null, sanction?: HrCaseSanction | null, warningExpiryDate?: string | null, caseNumber?: string | null, referralDate?: string | null, stage?: HrCaseStage | null, outcome?: HrCaseOutcome | null, updatedAt: string, employee: { __typename?: 'HrCasePerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, openedBy?: { __typename?: 'HrCaseUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type UpdateHrCaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateHrCaseInput;
}>;


export type UpdateHrCaseMutation = { __typename?: 'Mutation', updateHrCase: { __typename?: 'HrCase', id: string, type: HrCaseType, status: HrCaseStatus, openedDate: string, closedDate?: string | null, description: string, cost?: number | null, offenceCategory?: string | null, sanction?: HrCaseSanction | null, warningExpiryDate?: string | null, caseNumber?: string | null, referralDate?: string | null, stage?: HrCaseStage | null, outcome?: HrCaseOutcome | null, updatedAt: string, employee: { __typename?: 'HrCasePerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, openedBy?: { __typename?: 'HrCaseUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type AddHrCaseNoteMutationVariables = Exact<{
  caseId: Scalars['ID']['input'];
  input: HrCaseNoteInput;
}>;


export type AddHrCaseNoteMutation = { __typename?: 'Mutation', addHrCaseNote: { __typename?: 'HrCaseEvent', id: string } };

export type RemoveHrCaseDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveHrCaseDocumentMutation = { __typename?: 'Mutation', removeHrCaseDocument: boolean };

export type SendInviteMutationVariables = Exact<{
  input: SendInviteInput;
}>;


export type SendInviteMutation = { __typename?: 'Mutation', sendInvite?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RevokeInviteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevokeInviteMutation = { __typename?: 'Mutation', revokeInvite?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type ResendInviteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendInvite?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type BulkInviteMutationVariables = Exact<{
  input: BulkInviteInput;
}>;


export type BulkInviteMutation = { __typename?: 'Mutation', bulkInvite?: { __typename?: 'BulkInviteResult', sent: number, pendingApproval?: number | null, failed: Array<{ __typename?: 'BulkInviteFailure', email: string, reason: string }> } | null };

export type BulkSendInvitesMutationVariables = Exact<{
  input: BulkSendInvitesInput;
}>;


export type BulkSendInvitesMutation = { __typename?: 'Mutation', bulkSendInvites?: { __typename?: 'BulkSendInvitesResult', total?: number | null, succeeded?: number | null, failed?: number | null, skipped?: number | null, pendingApproval?: number | null, rows?: Array<{ __typename?: 'BulkInviteRowOutcome', rowNumber?: number | null, identifier?: string | null, status?: BulkInviteRowStatus | null, reason?: string | null }> | null } | null };

export type GetPendingInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingInvitesQuery = { __typename?: 'Query', pendingInvites?: Array<{ __typename?: 'PendingInvite', id?: string | null, email?: string | null, roleId?: string | null, invitedBy?: string | null, isAgent?: boolean | null, agentType?: string | null, firstName?: string | null, lastName?: string | null, createdAt?: string | null, expiresAt?: string | null }> | null };

export type ItemCategoryFieldsFragment = { __typename?: 'ItemCategory', id: string, name: string, position?: number | null, parentId?: string | null, path: string, productCount: number };

export type GetItemCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetItemCategoriesQuery = { __typename?: 'Query', itemCategories: Array<{ __typename?: 'ItemCategory', id: string, name: string, position?: number | null, parentId?: string | null, path: string, productCount: number, children: Array<{ __typename?: 'ItemCategory', id: string, name: string, position?: number | null, parentId?: string | null, path: string, productCount: number }> }> };

export type CreateItemCategoryMutationVariables = Exact<{
  input: CreateItemCategoryInput;
}>;


export type CreateItemCategoryMutation = { __typename?: 'Mutation', createItemCategory?: { __typename?: 'ItemCategory', id: string } | null };

export type UpdateItemCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateItemCategoryInput;
}>;


export type UpdateItemCategoryMutation = { __typename?: 'Mutation', updateItemCategory?: { __typename?: 'ItemCategory', id: string } | null };

export type DeleteItemCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteItemCategoryMutation = { __typename?: 'Mutation', deleteItemCategory?: { __typename?: 'ItemCategory', id: string } | null };

export type ReorderItemCategoriesMutationVariables = Exact<{
  parentId?: InputMaybe<Scalars['String']['input']>;
  orderedIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReorderItemCategoriesMutation = { __typename?: 'Mutation', reorderItemCategories: Array<{ __typename?: 'ItemCategory', id: string, position?: number | null }> };

export type ResetItemCategoryOrderMutationVariables = Exact<{
  parentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResetItemCategoryOrderMutation = { __typename?: 'Mutation', resetItemCategoryOrder: Array<{ __typename?: 'ItemCategory', id: string, position?: number | null }> };

export type GetLeadsQueryVariables = Exact<{
  input?: InputMaybe<LeadSearchInput>;
}>;


export type GetLeadsQuery = { __typename?: 'Query', leads?: { __typename?: 'LeadListResult', totalCount: number, items: Array<{ __typename?: 'Lead', id?: string | null, leadNumber?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, phone?: string | null, email?: string | null, idNumber?: string | null, createdAt?: string | null, estimatedValue?: number | null, status?: { __typename?: 'LeadStatus', id?: string | null, name?: string | null, color?: string | null, category?: LeadStatusCategory | null } | null, source?: { __typename?: 'LeadSource', id?: string | null, name?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type GetLeadQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLeadQuery = { __typename?: 'Query', lead?: { __typename?: 'Lead', id?: string | null, leadNumber?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, country?: string | null, phone?: string | null, email?: string | null, identificationType?: IdentificationType | null, idNumber?: string | null, notes?: string | null, preferredChannel?: LeadCommunicationChannel | null, estimatedValue?: number | null, createdAt?: string | null, convertedAt?: string | null, products?: Array<{ __typename?: 'LeadProduct', id?: string | null, quantity?: number | null, unitValue?: number | null, lineValue?: number | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null, sku?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null } | null }> | null, status?: { __typename?: 'LeadStatus', id?: string | null, name?: string | null, color?: string | null, category?: LeadStatusCategory | null } | null, source?: { __typename?: 'LeadSource', id?: string | null, name?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, convertedCustomer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null };

export type GetLeadCategoryCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadCategoryCountsQuery = { __typename?: 'Query', leadCategoryCounts?: { __typename?: 'LeadCategoryCounts', open?: number | null, converted?: number | null, lost?: number | null } | null };

export type GetLeadAssignableUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadAssignableUsersQuery = { __typename?: 'Query', leadAssignableUsers?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null }> | null };

export type CheckDuplicateLeadQueryVariables = Exact<{
  input: CheckDuplicateLeadInput;
}>;


export type CheckDuplicateLeadQuery = { __typename?: 'Query', checkDuplicateLead?: { __typename?: 'CheckDuplicateLeadResult', hasConflict?: boolean | null, hasHardConflict?: boolean | null, customerMatches?: Array<{ __typename?: 'LeadCustomerMatch', id?: string | null, firstName?: string | null, lastName?: string | null, idNumber?: string | null, phone?: string | null, email?: string | null, status?: string | null, matchedOn?: string | null, isHard?: boolean | null }> | null, leadMatches?: Array<{ __typename?: 'LeadDuplicateMatch', id?: string | null, firstName?: string | null, lastName?: string | null, idNumber?: string | null, phone?: string | null, email?: string | null, statusName?: string | null, matchedOn?: string | null, isHard?: boolean | null }> | null } | null };

export type GetLeadStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadStatusesQuery = { __typename?: 'Query', leadStatuses?: Array<{ __typename?: 'LeadStatus', id?: string | null, name?: string | null, color?: string | null, sortOrder?: number | null, category?: LeadStatusCategory | null, isSystem?: boolean | null, isDefault?: boolean | null }> | null };

export type GetLeadSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadSourcesQuery = { __typename?: 'Query', leadSources?: Array<{ __typename?: 'LeadSource', id?: string | null, name?: string | null, sortOrder?: number | null, isDefault?: boolean | null }> | null };

export type CreateLeadMutationVariables = Exact<{
  input: CreateLeadInput;
}>;


export type CreateLeadMutation = { __typename?: 'Mutation', createLead?: { __typename?: 'Lead', id?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null };

export type UpdateLeadMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateLeadInput;
}>;


export type UpdateLeadMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'Lead', id?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, idNumber?: string | null, notes?: string | null, preferredChannel?: LeadCommunicationChannel | null, estimatedValue?: number | null, products?: Array<{ __typename?: 'LeadProduct', id?: string | null, quantity?: number | null, unitValue?: number | null, lineValue?: number | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null, sku?: string | null } | null, ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null } | null }> | null, source?: { __typename?: 'LeadSource', id?: string | null, name?: string | null } | null } | null };

export type ChangeLeadStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  statusId: Scalars['String']['input'];
}>;


export type ChangeLeadStatusMutation = { __typename?: 'Mutation', changeLeadStatus?: { __typename?: 'Lead', id?: string | null, status?: { __typename?: 'LeadStatus', id?: string | null, name?: string | null, category?: LeadStatusCategory | null } | null } | null };

export type ReassignLeadMutationVariables = Exact<{
  id: Scalars['String']['input'];
  assignedToId: Scalars['String']['input'];
}>;


export type ReassignLeadMutation = { __typename?: 'Mutation', reassignLead?: { __typename?: 'Lead', id?: string | null, assignedTo?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type ConvertLeadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConvertLeadMutation = { __typename?: 'Mutation', convertLead?: { __typename?: 'ConvertLeadResult', customerId?: string | null, linked?: boolean | null } | null };

export type CreateLeadStatusMutationVariables = Exact<{
  input: CreateLeadStatusInput;
}>;


export type CreateLeadStatusMutation = { __typename?: 'Mutation', createLeadStatus?: { __typename?: 'LeadStatus', id?: string | null, name?: string | null, category?: LeadStatusCategory | null } | null };

export type UpdateLeadStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateLeadStatusInput;
}>;


export type UpdateLeadStatusMutation = { __typename?: 'Mutation', updateLeadStatus?: { __typename?: 'LeadStatus', id?: string | null, name?: string | null, color?: string | null, sortOrder?: number | null, category?: LeadStatusCategory | null, isDefault?: boolean | null } | null };

export type DeleteLeadStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteLeadStatusMutation = { __typename?: 'Mutation', deleteLeadStatus?: { __typename?: 'LeadStatus', id?: string | null } | null };

export type CreateLeadSourceMutationVariables = Exact<{
  input: CreateLeadSourceInput;
}>;


export type CreateLeadSourceMutation = { __typename?: 'Mutation', createLeadSource?: { __typename?: 'LeadSource', id?: string | null, name?: string | null } | null };

export type UpdateLeadSourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateLeadSourceInput;
}>;


export type UpdateLeadSourceMutation = { __typename?: 'Mutation', updateLeadSource?: { __typename?: 'LeadSource', id?: string | null, name?: string | null, sortOrder?: number | null, isDefault?: boolean | null } | null };

export type DeleteLeadSourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteLeadSourceMutation = { __typename?: 'Mutation', deleteLeadSource?: { __typename?: 'LeadSource', id?: string | null } | null };

export type ExportLeadsQueryVariables = Exact<{
  input?: InputMaybe<LeadSearchInput>;
}>;


export type ExportLeadsQuery = { __typename?: 'Query', exportLeads?: { __typename?: 'LeadListResult', totalCount: number, items: Array<{ __typename?: 'Lead', leadNumber?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, idNumber?: string | null, estimatedValue?: number | null, createdAt?: string | null, status?: { __typename?: 'LeadStatus', name?: string | null, category?: LeadStatusCategory | null } | null, source?: { __typename?: 'LeadSource', name?: string | null } | null, assignedTo?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null }> } | null };

export type LegacySourceRecordsQueryVariables = Exact<{
  entityType: LegacyEntityType;
  entityId: Scalars['String']['input'];
}>;


export type LegacySourceRecordsQuery = { __typename?: 'Query', legacySourceRecords?: { __typename?: 'LegacySourceRecordResult', entityType?: string | null, entityId?: string | null, externalId?: string | null, system?: string | null, available?: boolean | null, message?: string | null, records?: Array<{ __typename?: 'LegacySourceRecord', system?: string | null, recordType?: string | null, sourceTable?: string | null, sourceId?: string | null, syncedAt?: string | null, data?: Record<string, unknown> | null }> | null } | null };

export type GetMailingListQueryVariables = Exact<{
  list: MailingListName;
}>;


export type GetMailingListQuery = { __typename?: 'Query', mailingList: Array<{ __typename?: 'MailingListEntry', id: string, list: MailingListName, email: string, createdAt: string }> };

export type GetMailingListFallbackRecipientQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMailingListFallbackRecipientQuery = { __typename?: 'Query', mailingListFallbackRecipient?: string | null };

export type AddToMailingListMutationVariables = Exact<{
  list: MailingListName;
  email: Scalars['String']['input'];
}>;


export type AddToMailingListMutation = { __typename?: 'Mutation', addToMailingList: { __typename?: 'MailingListEntry', id: string, list: MailingListName, email: string, createdAt: string } };

export type RemoveFromMailingListMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveFromMailingListMutation = { __typename?: 'Mutation', removeFromMailingList?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type GetMailingListScheduleQueryVariables = Exact<{
  list: MailingListName;
}>;


export type GetMailingListScheduleQuery = { __typename?: 'Query', mailingListSchedule?: { __typename?: 'MailingListSchedule', list: MailingListName, frequency: MailingListFrequency, startsOn: string, sendAt: string, nextSendAt: string, updatedAt?: string | null } | null };

export type ExportWriteOffWorkbookQueryVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type ExportWriteOffWorkbookQuery = { __typename?: 'Query', exportWriteOffWorkbook: { __typename?: 'WriteOffWorkbook', fileName: string, contentBase64: string, contracts: number } };

export type SetMailingListScheduleMutationVariables = Exact<{
  input: SetMailingListScheduleInput;
}>;


export type SetMailingListScheduleMutation = { __typename?: 'Mutation', setMailingListSchedule: { __typename?: 'MailingListSchedule', list: MailingListName, frequency: MailingListFrequency, startsOn: string, sendAt: string, nextSendAt: string, updatedAt?: string | null } };

export type GetMeterTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeterTypesQuery = { __typename?: 'Query', meterTypes?: Array<{ __typename?: 'MeterType', id?: string | null, name?: string | null }> | null };

export type GetModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModulesQuery = { __typename?: 'Query', modules?: Array<{ __typename?: 'Module', id?: string | null, code?: string | null, name?: string | null, description?: string | null, enabled?: boolean | null, createdAt?: string | null, actions?: Array<string> | null, parentCode?: string | null }> | null };

export type CreateModuleMutationVariables = Exact<{
  input: CreateModuleInput;
}>;


export type CreateModuleMutation = { __typename?: 'Mutation', createModule?: { __typename?: 'Module', id?: string | null, code?: string | null, name?: string | null, description?: string | null, enabled?: boolean | null } | null };

export type UpdateModuleMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateModuleInput;
}>;


export type UpdateModuleMutation = { __typename?: 'Mutation', updateModule?: { __typename?: 'Module', id?: string | null, code?: string | null, name?: string | null, description?: string | null, enabled?: boolean | null } | null };

export type ToggleModuleMutationVariables = Exact<{
  id: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleModuleMutation = { __typename?: 'Mutation', toggleModule?: { __typename?: 'Module', id?: string | null, code?: string | null, name?: string | null, enabled?: boolean | null } | null };

export type DeleteModuleMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteModuleMutation = { __typename?: 'Mutation', deleteModule?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type GetMoMoPosPaymentsQueryVariables = Exact<{
  filter?: InputMaybe<MoMoPosPaymentFilterInput>;
}>;


export type GetMoMoPosPaymentsQuery = { __typename?: 'Query', momoPosPayments?: { __typename?: 'MoMoPosPaymentList', totalCount?: number | null, items?: Array<{ __typename?: 'MoMoPosPayment', id?: number | null, paidAt?: string | null, amount?: number | null, accountNumber?: string | null, typedAccount?: string | null, status?: MoMoPosPaymentStatus | null, terminalSerial?: string | null, cardScheme?: string | null, maskedCard?: string | null, authCode?: string | null, mtnTransactionNo?: string | null, contract?: { __typename?: 'MoMoPosPaymentContract', id?: string | null, contractNumber?: string | null, customerName?: string | null } | null }> | null } | null };

export type EmployeeMovementFieldsFragment = { __typename?: 'EmployeeMovement', id: string, effectiveDate: string, movementType: EmployeeMovementType, reason?: string | null, recordedAt: string, recordedByName?: string | null, diversityHidden: boolean, changes: Array<{ __typename?: 'EmployeeMovementChange', field: EmployeeMovementField, from?: string | null, to?: string | null, fromLabel?: string | null, toLabel?: string | null }> };

export type EmployeeMovementsQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type EmployeeMovementsQuery = { __typename?: 'Query', employeeMovements: Array<{ __typename?: 'EmployeeMovement', id: string, effectiveDate: string, movementType: EmployeeMovementType, reason?: string | null, recordedAt: string, recordedByName?: string | null, diversityHidden: boolean, changes: Array<{ __typename?: 'EmployeeMovementChange', field: EmployeeMovementField, from?: string | null, to?: string | null, fromLabel?: string | null, toLabel?: string | null }> }> };

export type RecordEmployeeMovementMutationVariables = Exact<{
  input: RecordEmployeeMovementInput;
}>;


export type RecordEmployeeMovementMutation = { __typename?: 'Mutation', recordEmployeeMovement: { __typename?: 'EmployeeMovement', id: string, effectiveDate: string, movementType: EmployeeMovementType, reason?: string | null, recordedAt: string, recordedByName?: string | null, diversityHidden: boolean, changes: Array<{ __typename?: 'EmployeeMovementChange', field: EmployeeMovementField, from?: string | null, to?: string | null, fromLabel?: string | null, toLabel?: string | null }> } };

export type GetSaLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSaLocationsQuery = { __typename?: 'Query', provinces?: Array<{ __typename?: 'Province', id?: string | null, name?: string | null, districtMunicipalities?: Array<{ __typename?: 'DistrictMunicipality', id?: string | null, name?: string | null, localMunicipalities?: Array<{ __typename?: 'LocalMunicipality', id?: string | null, municipality?: string | null }> | null }> | null }> | null };

export type GetNotesQueryVariables = Exact<{
  input: NoteListInput;
}>;


export type GetNotesQuery = { __typename?: 'Query', notes?: { __typename?: 'NoteListResult', totalCount: number, restrictedHiddenCount: number, items: Array<{ __typename?: 'Note', id?: string | null, body?: string | null, format?: NoteFormat | null, visibility?: NoteVisibility | null, revisionCount?: number | null, isEdited?: boolean | null, isRedacted?: boolean | null, canEdit?: boolean | null, canModerate?: boolean | null, lastEditedAt?: string | null, pinnedAt?: string | null, createdAt?: string | null, archivedAt?: string | null, archivedReason?: string | null, redactedAt?: string | null, redactedReason?: string | null, category?: { __typename?: 'NoteCategory', id?: string | null, name?: string | null, color?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, pinnedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, redactedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type GetNoteQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetNoteQuery = { __typename?: 'Query', note?: { __typename?: 'Note', id?: string | null, body?: string | null, format?: NoteFormat | null, visibility?: NoteVisibility | null, revisionCount?: number | null, isEdited?: boolean | null, isRedacted?: boolean | null, canEdit?: boolean | null, canModerate?: boolean | null, lastEditedAt?: string | null, pinnedAt?: string | null, createdAt?: string | null, archivedAt?: string | null, archivedReason?: string | null, redactedAt?: string | null, redactedReason?: string | null, revisions?: Array<{ __typename?: 'NoteRevision', id?: string | null, revision?: number | null, body?: string | null, visibility?: NoteVisibility | null, changeReason?: string | null, createdAt?: string | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null, category?: { __typename?: 'NoteCategory', id?: string | null, name?: string | null, color?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, pinnedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, redactedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetNoteCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNoteCategoriesQuery = { __typename?: 'Query', noteCategories?: Array<{ __typename?: 'NoteCategory', id?: string | null, name?: string | null, color?: string | null, sortOrder?: number | null, isDefault?: boolean | null, isSystem?: boolean | null }> | null };

export type ExportNotesQueryVariables = Exact<{
  input: NoteListInput;
}>;


export type ExportNotesQuery = { __typename?: 'Query', exportNotes?: { __typename?: 'NoteListResult', totalCount: number, items: Array<{ __typename?: 'Note', id?: string | null, body?: string | null, format?: NoteFormat | null, visibility?: NoteVisibility | null, revisionCount?: number | null, isEdited?: boolean | null, isRedacted?: boolean | null, canEdit?: boolean | null, canModerate?: boolean | null, lastEditedAt?: string | null, pinnedAt?: string | null, createdAt?: string | null, archivedAt?: string | null, archivedReason?: string | null, redactedAt?: string | null, redactedReason?: string | null, category?: { __typename?: 'NoteCategory', id?: string | null, name?: string | null, color?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, pinnedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, redactedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type NoteCardFieldsFragment = { __typename?: 'Note', id?: string | null, body?: string | null, format?: NoteFormat | null, visibility?: NoteVisibility | null, revisionCount?: number | null, isEdited?: boolean | null, isRedacted?: boolean | null, canEdit?: boolean | null, canModerate?: boolean | null, lastEditedAt?: string | null, pinnedAt?: string | null, createdAt?: string | null, archivedAt?: string | null, archivedReason?: string | null, redactedAt?: string | null, redactedReason?: string | null, category?: { __typename?: 'NoteCategory', id?: string | null, name?: string | null, color?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, pinnedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, redactedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote?: { __typename?: 'Note', id?: string | null } | null };

export type UpdateNoteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote?: { __typename?: 'Note', id?: string | null } | null };

export type SetNoteVisibilityMutationVariables = Exact<{
  id: Scalars['String']['input'];
  visibility: NoteVisibility;
}>;


export type SetNoteVisibilityMutation = { __typename?: 'Mutation', setNoteVisibility?: { __typename?: 'Note', id?: string | null, visibility?: NoteVisibility | null } | null };

export type SetNotePinnedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  pinned: Scalars['Boolean']['input'];
}>;


export type SetNotePinnedMutation = { __typename?: 'Mutation', setNotePinned?: { __typename?: 'Note', id?: string | null, pinnedAt?: string | null } | null };

export type ArchiveNoteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type ArchiveNoteMutation = { __typename?: 'Mutation', archiveNote?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RestoreNoteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreNoteMutation = { __typename?: 'Mutation', restoreNote?: { __typename?: 'Note', id?: string | null } | null };

export type RedactNoteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RedactNoteMutation = { __typename?: 'Mutation', redactNote?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type GetNotificationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'Notification', id?: string | null, title?: string | null, message?: string | null, channel?: string | null, status?: string | null, entityType?: string | null, entityId?: string | null, readAt?: string | null, createdAt?: string | null }> | null };

export type GetUnreadNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationCountQuery = { __typename?: 'Query', unreadNotificationCount?: { __typename?: 'NotificationCount', count?: number | null } | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead?: { __typename?: 'Notification', id?: string | null, readAt?: string | null, status?: string | null } | null };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead?: { __typename?: 'MarkAllReadResult', success?: boolean | null, count?: number | null } | null };

export type OnNotificationReceivedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNotificationReceivedSubscription = { __typename?: 'Subscription', notificationReceived?: { __typename?: 'NotificationEvent', id?: string | null, title?: string | null, message?: string | null, channel?: string | null, status?: string | null, entityType?: string | null, entityId?: string | null, createdAt?: string | null } | null };

export type PaymentRatingThresholdsFragment = { __typename?: 'PaymentRatingPolicy', excellentMaxPercent: number, goodMaxPercent: number, fairMaxPercent: number, poorMaxPercent: number };

export type GetCustomerFinancialAnalysisQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetCustomerFinancialAnalysisQuery = { __typename?: 'Query', customerFinancialAnalysis: { __typename?: 'CustomerFinancialAnalysis', fromDate?: string | null, toDate?: string | null, totalDaysAnalysed: number, daysWithoutCredit: number, percentWithoutCredit?: number | null, rating?: PaymentRating | null, currentGapDays: number, priorDefault?: { __typename?: 'PriorDefault', contractNumber: string, status: ContractStatus, at?: string | null } | null, longestGap?: { __typename?: 'CreditGap', days: number, fromDate: string, toDate: string } | null, days: Array<{ __typename?: 'CreditDay', date: string, creditDays: number, inCredit: boolean, paymentAmount: number }>, contracts: Array<{ __typename?: 'ContractCreditSummary', contractId: string, contractNumber: string, status: ContractStatus, fromDate: string, toDate: string, totalDaysAnalysed: number, daysWithoutCredit: number, percentWithoutCredit: number, longestGapDays: number }>, insights: Array<{ __typename?: 'CreditInsight', code: CreditInsightCode, rating?: PaymentRating | null, percent?: number | null, days?: number | null, fromDate?: string | null, toDate?: string | null, contractNumber?: string | null, contractStatus?: ContractStatus | null }>, thresholds: { __typename?: 'PaymentRatingPolicy', excellentMaxPercent: number, goodMaxPercent: number, fairMaxPercent: number, poorMaxPercent: number } } };

export type GetCustomerPaymentVerdictQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetCustomerPaymentVerdictQuery = { __typename?: 'Query', customerFinancialAnalysis: { __typename?: 'CustomerFinancialAnalysis', totalDaysAnalysed: number, daysWithoutCredit: number, percentWithoutCredit?: number | null, rating?: PaymentRating | null, currentGapDays: number, priorDefault?: { __typename?: 'PriorDefault', contractNumber: string, status: ContractStatus, at?: string | null } | null, longestGap?: { __typename?: 'CreditGap', days: number, fromDate: string, toDate: string } | null } };

export type GetPaymentRatingPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentRatingPolicyQuery = { __typename?: 'Query', paymentRatingPolicy: { __typename?: 'PaymentRatingPolicy', updatedAt?: string | null, excellentMaxPercent: number, goodMaxPercent: number, fairMaxPercent: number, poorMaxPercent: number } };

export type UpdatePaymentRatingPolicyMutationVariables = Exact<{
  input: UpdatePaymentRatingPolicyInput;
}>;


export type UpdatePaymentRatingPolicyMutation = { __typename?: 'Mutation', updatePaymentRatingPolicy: { __typename?: 'PaymentRatingPolicy', updatedAt?: string | null, excellentMaxPercent: number, goodMaxPercent: number, fairMaxPercent: number, poorMaxPercent: number } };

export type PaymentReallocationFieldsFragment = { __typename?: 'PaymentReallocation', id: string, createdAt: string, appliedAt?: string | null, reason: PaymentReallocationReason, notes: string, creditRecoveryTotal?: number | null, creditRecoveryPerPayment?: number | null, creditRecoveryRemaining?: number | null, sourcePayment: { __typename?: 'PaymentTransaction', id: string, referenceCode: string, amount: number }, sourceContract: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null }, destinationContract: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null }, destinationPayment?: { __typename?: 'PaymentTransaction', id: string, referenceCode: string } | null, performedBy: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } };

export type PreviewReallocationQueryVariables = Exact<{
  input: PreviewReallocationInput;
}>;


export type PreviewReallocationQuery = { __typename?: 'Query', previewReallocation: { __typename?: 'ReallocationPreview', paymentTransactionId: string, amount: number, sourceContractId: string, sourceContractNumber: string, sourceCustomerName: string, destinationContractId: string, destinationContractNumber: string, destinationCustomerName: string, deliveredTokenDays?: number | null, unrecoverable?: PaymentReallocationWriteOffReason | null, costRecoveryAmount: number, amountReachingDestination: number, recovery?: { __typename?: 'CreditRecoveryPlan', total: number, perPayment: number, instalments: number, extendedByFloor: boolean } | null, warnings: Array<{ __typename?: 'PaymentReallocationWarning', code: PaymentReallocationWarningCode, detail: string }> } };

export type UnappliedPaymentReallocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnappliedPaymentReallocationsQuery = { __typename?: 'Query', unappliedPaymentReallocations: Array<{ __typename?: 'PaymentReallocation', id: string, createdAt: string, appliedAt?: string | null, reason: PaymentReallocationReason, notes: string, creditRecoveryTotal?: number | null, creditRecoveryPerPayment?: number | null, creditRecoveryRemaining?: number | null, sourcePayment: { __typename?: 'PaymentTransaction', id: string, referenceCode: string, amount: number }, sourceContract: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null }, destinationContract: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null }, destinationPayment?: { __typename?: 'PaymentTransaction', id: string, referenceCode: string } | null, performedBy: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } }> };

export type ReallocatePaymentMutationVariables = Exact<{
  input: ReallocatePaymentInput;
}>;


export type ReallocatePaymentMutation = { __typename?: 'Mutation', reallocatePayment: { __typename?: 'ReallocationResult', reallocationId: string, applied: boolean, applyError?: string | null, writtenOffAmount?: number | null, writtenOffReason?: PaymentReallocationWriteOffReason | null } };

export type ApplyPaymentReallocationMutationVariables = Exact<{
  reallocationId: Scalars['String']['input'];
}>;


export type ApplyPaymentReallocationMutation = { __typename?: 'Mutation', applyPaymentReallocation: { __typename?: 'ReallocationResult', reallocationId: string, applied: boolean, applyError?: string | null } };

export type SearchContractsForReallocationQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchContractsForReallocationQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractListResult', items: Array<{ __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null }> } | null };

export type GetReallocationPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReallocationPolicyQuery = { __typename?: 'Query', reallocationPolicy: { __typename?: 'ReallocationPolicy', costRecoveryAmount: number, minimumTokenDaysPerPayment: number, updatedAt?: string | null } };

export type UpdateReallocationPolicyMutationVariables = Exact<{
  input: UpdateReallocationPolicyInput;
}>;


export type UpdateReallocationPolicyMutation = { __typename?: 'Mutation', updateReallocationPolicy: { __typename?: 'ReallocationPolicy', costRecoveryAmount: number, minimumTokenDaysPerPayment: number, updatedAt?: string | null } };

export type GenerateTokenMutationVariables = Exact<{
  input: GenerateTokenInput;
}>;


export type GenerateTokenMutation = { __typename?: 'Mutation', generateToken: { __typename?: 'GenerateTokenResult', transactionId: string, accountNumber: string, contractId: string, amount: number, message?: string | null, initiatedAt: string, token?: string | null, tokenSequence?: number | null, devices: Array<{ __typename?: 'DeviceTokenResult', transactionId?: string | null, accountNumber: string, productName?: string | null, amount: number, message?: string | null, token?: string | null, tokenSequence?: number | null, accepted: boolean }> } };

export type ResendTokenSmsMutationVariables = Exact<{
  paymentTransactionId: Scalars['String']['input'];
  phoneOverride?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendTokenSmsMutation = { __typename?: 'Mutation', resendTokenSms: { __typename?: 'ResendTokenSmsResult', success: boolean, message: string, to: string, accountNumber: string } };

export type GetPaymentTransactionsQueryVariables = Exact<{
  input?: InputMaybe<PaymentTransactionListInput>;
}>;


export type GetPaymentTransactionsQuery = { __typename?: 'Query', paymentTransactions: { __typename?: 'PaymentTransactionListResult', totalCount: number, items: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, phone?: string | null, description?: string | null, systemType?: string | null, createdBy: string, reason?: string | null, token?: string | null, tokenSequence?: number | null, tokenDays?: number | null, depositDeducted?: number | null, countsTowardBalance: boolean, routingNote?: string | null, tokenForPreviousDevice: boolean, bankConfirmed: boolean, confirmationSource?: PaymentConfirmationSource | null, bankName?: string | null, confirmationRef?: string | null, confirmedAt?: string | null, contractId?: string | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null }> } };

export type GetPaymentTransactionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPaymentTransactionQuery = { __typename?: 'Query', paymentTransaction: { __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, phone?: string | null, description?: string | null, systemType?: string | null, createdBy: string, reason?: string | null, token?: string | null, tokenSequence?: number | null, tokenDays?: number | null, depositDeducted?: number | null, routingNote?: string | null, tokenForPreviousDevice: boolean, countsTowardBalance: boolean, bankConfirmed: boolean, confirmationSource?: PaymentConfirmationSource | null, bankName?: string | null, confirmationRef?: string | null, confirmedAt?: string | null, contractId?: string | null, reallocation?: { __typename?: 'PaymentReallocation', id: string, destinationContract: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null, rateName?: string | null, rateAmount?: number | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null, phone?: string | null, email?: string | null } | null, stockSale?: { __typename?: 'StockSale', stockItem?: { __typename?: 'StockItem', serialNumber?: string | null, accountNumber?: string | null } | null } | null } | null, callbacks: Array<{ __typename?: 'PaymentCallback', id: string, createdAt: string, accountNumber?: string | null, processedAt?: string | null, paymentTransactionId?: string | null, data: Record<string, unknown> }> } };

export type ExportPaymentTransactionsQueryVariables = Exact<{
  input?: InputMaybe<PaymentTransactionListInput>;
}>;


export type ExportPaymentTransactionsQuery = { __typename?: 'Query', exportPaymentTransactions: { __typename?: 'PaymentTransactionListResult', totalCount: number, items: Array<{ __typename?: 'PaymentTransaction', createdAt: string, referenceCode: string, accountNumber: string, amount: number, phone?: string | null, description?: string | null, systemType?: string | null, createdBy: string, reason?: string | null, token?: string | null, tokenSequence?: number | null, tokenDays?: number | null, depositDeducted?: number | null, routingNote?: string | null, bankConfirmed: boolean, confirmationSource?: PaymentConfirmationSource | null, bankName?: string | null, confirmationRef?: string | null, confirmedAt?: string | null, contract?: { __typename?: 'Contract', contractNumber?: string | null, distributorName?: string | null, nationalSalesManagerName?: string | null, customer?: { __typename?: 'Customer', fullName?: string | null } | null } | null }> } };

export type PayrollEmployeeFieldsFragment = { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null };

export type PayRunFieldsFragment = { __typename?: 'PayRun', id: string, periodMonth: string, status: PayRunStatus, payDate?: string | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, finalisedAt?: string | null, lineCount: number, totalGross?: number | null, linesWithoutGross: number, finalisedBy?: { __typename?: 'PayrollUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null };

export type PayslipFieldsFragment = { __typename?: 'Payslip', id: string, gross?: number | null, net?: number | null, basic?: number | null, overtimePay?: number | null, allowances?: number | null, deductions?: number | null, paye?: number | null, uifEmployee?: number | null, uifEmployer?: number | null, sdl?: number | null, employerPension?: number | null, employerMedical?: number | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } };

export type EmployeeBenefitFieldsFragment = { __typename?: 'EmployeeBenefit', id: string, type: EmployeeBenefitType, provider?: string | null, planName?: string | null, startDate?: string | null, endDate?: string | null, employerContribution?: number | null, employeeContribution?: number | null, notes?: string | null, source: HrDataSource, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } };

export type PayRunsQueryVariables = Exact<{
  filter?: InputMaybe<PayRunFilterInput>;
}>;


export type PayRunsQuery = { __typename?: 'Query', payRuns: Array<{ __typename?: 'PayRun', id: string, periodMonth: string, status: PayRunStatus, payDate?: string | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, finalisedAt?: string | null, lineCount: number, totalGross?: number | null, linesWithoutGross: number, finalisedBy?: { __typename?: 'PayrollUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> };

export type PayRunQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PayRunQuery = { __typename?: 'Query', payRun: { __typename?: 'PayRunDetail', run: { __typename?: 'PayRun', id: string, periodMonth: string, status: PayRunStatus, payDate?: string | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, finalisedAt?: string | null, lineCount: number, totalGross?: number | null, linesWithoutGross: number, finalisedBy?: { __typename?: 'PayrollUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }, payslips: Array<{ __typename?: 'Payslip', id: string, gross?: number | null, net?: number | null, basic?: number | null, overtimePay?: number | null, allowances?: number | null, deductions?: number | null, paye?: number | null, uifEmployee?: number | null, uifEmployer?: number | null, sdl?: number | null, employerPension?: number | null, employerMedical?: number | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } }> } };

export type PayRunExportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PayRunExportQuery = { __typename?: 'Query', payRunExport: Array<{ __typename?: 'Payslip', id: string, gross?: number | null, net?: number | null, basic?: number | null, overtimePay?: number | null, allowances?: number | null, deductions?: number | null, paye?: number | null, uifEmployee?: number | null, uifEmployer?: number | null, sdl?: number | null, employerPension?: number | null, employerMedical?: number | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } }> };

export type EmployeeBenefitsQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EmployeeBenefitsQuery = { __typename?: 'Query', employeeBenefits: Array<{ __typename?: 'EmployeeBenefit', id: string, type: EmployeeBenefitType, provider?: string | null, planName?: string | null, startDate?: string | null, endDate?: string | null, employerContribution?: number | null, employeeContribution?: number | null, notes?: string | null, source: HrDataSource, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } }> };

export type PayrollMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filter?: InputMaybe<PayrollMetricsFilterInput>;
}>;


export type PayrollMetricsQuery = { __typename?: 'Query', payrollMetrics: { __typename?: 'PayrollMetrics', from: string, to: string, totalPayrollCost: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, totalGross: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, employeesPaid: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, averageGross: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, medianGross: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, payrollCostPerEmployee: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, overtimeCostPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, benefitsCost: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, genderPayGapMeanPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, genderPayGapMedianPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, payrollGrowthPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } } };

export type CreatePayRunMutationVariables = Exact<{
  input: CreatePayRunInput;
}>;


export type CreatePayRunMutation = { __typename?: 'Mutation', createPayRun: { __typename?: 'PayRun', id: string, periodMonth: string, status: PayRunStatus, payDate?: string | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, finalisedAt?: string | null, lineCount: number, totalGross?: number | null, linesWithoutGross: number, finalisedBy?: { __typename?: 'PayrollUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type UpdatePayRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePayRunInput;
}>;


export type UpdatePayRunMutation = { __typename?: 'Mutation', updatePayRun: { __typename?: 'PayRun', id: string, periodMonth: string, status: PayRunStatus, payDate?: string | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, finalisedAt?: string | null, lineCount: number, totalGross?: number | null, linesWithoutGross: number, finalisedBy?: { __typename?: 'PayrollUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type DeletePayRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePayRunMutation = { __typename?: 'Mutation', deletePayRun: boolean };

export type FinalisePayRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinalisePayRunMutation = { __typename?: 'Mutation', finalisePayRun: { __typename?: 'PayRun', id: string, periodMonth: string, status: PayRunStatus, payDate?: string | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, finalisedAt?: string | null, lineCount: number, totalGross?: number | null, linesWithoutGross: number, finalisedBy?: { __typename?: 'PayrollUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type ReopenPayRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReopenPayRunMutation = { __typename?: 'Mutation', reopenPayRun: { __typename?: 'PayRun', id: string, periodMonth: string, status: PayRunStatus, payDate?: string | null, notes?: string | null, source: HrDataSource, importedAt?: string | null, finalisedAt?: string | null, lineCount: number, totalGross?: number | null, linesWithoutGross: number, finalisedBy?: { __typename?: 'PayrollUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type ImportPayslipsMutationVariables = Exact<{
  periodMonth: Scalars['DateTime']['input'];
  csv: Scalars['String']['input'];
}>;


export type ImportPayslipsMutation = { __typename?: 'Mutation', importPayslips: { __typename?: 'HrImportResult', imported: number, errors: Array<{ __typename?: 'HrImportError', line: number, message: string }>, unmatched: Array<{ __typename?: 'HrUnmatchedLine', line: number, employeeNumber?: string | null, name?: string | null, reason: string }> } };

export type CreatePayslipMutationVariables = Exact<{
  payRunId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  input: PayslipInput;
}>;


export type CreatePayslipMutation = { __typename?: 'Mutation', createPayslip: { __typename?: 'Payslip', id: string, gross?: number | null, net?: number | null, basic?: number | null, overtimePay?: number | null, allowances?: number | null, deductions?: number | null, paye?: number | null, uifEmployee?: number | null, uifEmployer?: number | null, sdl?: number | null, employerPension?: number | null, employerMedical?: number | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } } };

export type UpdatePayslipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PayslipInput;
}>;


export type UpdatePayslipMutation = { __typename?: 'Mutation', updatePayslip: { __typename?: 'Payslip', id: string, gross?: number | null, net?: number | null, basic?: number | null, overtimePay?: number | null, allowances?: number | null, deductions?: number | null, paye?: number | null, uifEmployee?: number | null, uifEmployer?: number | null, sdl?: number | null, employerPension?: number | null, employerMedical?: number | null, source: HrDataSource, importedAt?: string | null, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } } };

export type DeletePayslipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePayslipMutation = { __typename?: 'Mutation', deletePayslip: boolean };

export type CreateEmployeeBenefitMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  input: CreateEmployeeBenefitInput;
}>;


export type CreateEmployeeBenefitMutation = { __typename?: 'Mutation', createEmployeeBenefit: { __typename?: 'EmployeeBenefit', id: string, type: EmployeeBenefitType, provider?: string | null, planName?: string | null, startDate?: string | null, endDate?: string | null, employerContribution?: number | null, employeeContribution?: number | null, notes?: string | null, source: HrDataSource, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } } };

export type UpdateEmployeeBenefitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEmployeeBenefitInput;
}>;


export type UpdateEmployeeBenefitMutation = { __typename?: 'Mutation', updateEmployeeBenefit: { __typename?: 'EmployeeBenefit', id: string, type: EmployeeBenefitType, provider?: string | null, planName?: string | null, startDate?: string | null, endDate?: string | null, employerContribution?: number | null, employeeContribution?: number | null, notes?: string | null, source: HrDataSource, employee: { __typename?: 'PayrollEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'PayrollDepartment', id: string, name: string } | null } } };

export type DeleteEmployeeBenefitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEmployeeBenefitMutation = { __typename?: 'Mutation', deleteEmployeeBenefit: boolean };

export type ReviewCycleFieldsFragment = { __typename?: 'ReviewCycle', id: string, name: string, periodStart: string, periodEnd: string, dueDate: string, reviewCount: number, completedCount: number };

export type PerformanceReviewFieldsFragment = { __typename?: 'PerformanceReview', id: string, rating?: number | null, status: PerformanceReviewStatus, comments?: string | null, reviewDate?: string | null, updatedAt: string, cycle: { __typename?: 'ReviewCycleSummary', id: string, name: string, periodStart: string, periodEnd: string }, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string }, reviewer?: { __typename?: 'PerformanceReviewer', id: string, email: string, firstName?: string | null, lastName?: string | null } | null };

export type ImprovementPlanFieldsFragment = { __typename?: 'ImprovementPlan', id: string, startDate: string, endDate: string, status: ImprovementPlanStatus, objectives: string, notes?: string | null, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string } };

export type ProbationFieldsFragment = { __typename?: 'Probation', id: string, endDate: string, outcome?: ProbationOutcome | null, extendedTo?: string | null, effectiveEndDate: string, notes?: string | null };

export type PerformanceMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filter?: InputMaybe<PerformanceFilterInput>;
}>;


export type PerformanceMetricsQuery = { __typename?: 'Query', performanceMetrics: { __typename?: 'PerformanceMetrics', from: string, to: string, cycleCount: number, reviewsExpected: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, reviewsCompleted: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, reviewCompletionRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, byRating: Array<{ __typename?: 'RatingCount', rating?: number | null, count: number }>, averageRating: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, highPerformerPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, highPerformerLeavers: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, highPerformerLeaverPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, probationPassRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, probationsEndingSoon: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, openImprovementPlans: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, improvementPlanSuccessRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } } };

export type ReviewCyclesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewCyclesQuery = { __typename?: 'Query', reviewCycles: Array<{ __typename?: 'ReviewCycle', id: string, name: string, periodStart: string, periodEnd: string, dueDate: string, reviewCount: number, completedCount: number }> };

export type PerformanceReviewsQueryVariables = Exact<{
  cycleId: Scalars['ID']['input'];
}>;


export type PerformanceReviewsQuery = { __typename?: 'Query', performanceReviews: Array<{ __typename?: 'PerformanceReview', id: string, rating?: number | null, status: PerformanceReviewStatus, comments?: string | null, reviewDate?: string | null, updatedAt: string, cycle: { __typename?: 'ReviewCycleSummary', id: string, name: string, periodStart: string, periodEnd: string }, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string }, reviewer?: { __typename?: 'PerformanceReviewer', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> };

export type EmployeePerformanceQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type EmployeePerformanceQuery = { __typename?: 'Query', employeePerformance: { __typename?: 'EmployeePerformance', employeeId: string, probations: Array<{ __typename?: 'EmploymentProbation', employmentId: string, startDate?: string | null, endDate?: string | null, probation?: { __typename?: 'Probation', id: string, endDate: string, outcome?: ProbationOutcome | null, extendedTo?: string | null, effectiveEndDate: string, notes?: string | null } | null }>, reviews: Array<{ __typename?: 'PerformanceReview', id: string, rating?: number | null, status: PerformanceReviewStatus, comments?: string | null, reviewDate?: string | null, updatedAt: string, cycle: { __typename?: 'ReviewCycleSummary', id: string, name: string, periodStart: string, periodEnd: string }, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string }, reviewer?: { __typename?: 'PerformanceReviewer', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }>, improvementPlans: Array<{ __typename?: 'ImprovementPlan', id: string, startDate: string, endDate: string, status: ImprovementPlanStatus, objectives: string, notes?: string | null, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string } }> } };

export type CreateReviewCycleMutationVariables = Exact<{
  input: ReviewCycleInput;
}>;


export type CreateReviewCycleMutation = { __typename?: 'Mutation', createReviewCycle: { __typename?: 'ReviewCycle', id: string, name: string, periodStart: string, periodEnd: string, dueDate: string, reviewCount: number, completedCount: number } };

export type UpdateReviewCycleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateReviewCycleInput;
}>;


export type UpdateReviewCycleMutation = { __typename?: 'Mutation', updateReviewCycle: { __typename?: 'ReviewCycle', id: string, name: string, periodStart: string, periodEnd: string, dueDate: string, reviewCount: number, completedCount: number } };

export type DeleteReviewCycleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReviewCycleMutation = { __typename?: 'Mutation', deleteReviewCycle: boolean };

export type CreatePerformanceReviewMutationVariables = Exact<{
  input: CreatePerformanceReviewInput;
}>;


export type CreatePerformanceReviewMutation = { __typename?: 'Mutation', createPerformanceReview: { __typename?: 'PerformanceReview', id: string, rating?: number | null, status: PerformanceReviewStatus, comments?: string | null, reviewDate?: string | null, updatedAt: string, cycle: { __typename?: 'ReviewCycleSummary', id: string, name: string, periodStart: string, periodEnd: string }, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string }, reviewer?: { __typename?: 'PerformanceReviewer', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type UpdatePerformanceReviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePerformanceReviewInput;
}>;


export type UpdatePerformanceReviewMutation = { __typename?: 'Mutation', updatePerformanceReview: { __typename?: 'PerformanceReview', id: string, rating?: number | null, status: PerformanceReviewStatus, comments?: string | null, reviewDate?: string | null, updatedAt: string, cycle: { __typename?: 'ReviewCycleSummary', id: string, name: string, periodStart: string, periodEnd: string }, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string }, reviewer?: { __typename?: 'PerformanceReviewer', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type CreateImprovementPlanMutationVariables = Exact<{
  input: CreateImprovementPlanInput;
}>;


export type CreateImprovementPlanMutation = { __typename?: 'Mutation', createImprovementPlan: { __typename?: 'ImprovementPlan', id: string, startDate: string, endDate: string, status: ImprovementPlanStatus, objectives: string, notes?: string | null, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string } } };

export type UpdateImprovementPlanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateImprovementPlanInput;
}>;


export type UpdateImprovementPlanMutation = { __typename?: 'Mutation', updateImprovementPlan: { __typename?: 'ImprovementPlan', id: string, startDate: string, endDate: string, status: ImprovementPlanStatus, objectives: string, notes?: string | null, employee: { __typename?: 'PerformancePerson', id: string, firstName: string, lastName: string } } };

export type SetProbationMutationVariables = Exact<{
  employmentId: Scalars['ID']['input'];
  input: ProbationInput;
}>;


export type SetProbationMutation = { __typename?: 'Mutation', setProbation: { __typename?: 'Probation', id: string, endDate: string, outcome?: ProbationOutcome | null, extendedTo?: string | null, effectiveEndDate: string, notes?: string | null } };

export type PermissionChangeRequestFieldsFragment = { __typename?: 'PermissionChangeRequest', id?: string | null, createdAt?: string | null, kind?: PermissionRequestKind | null, status?: PermissionRequestStatus | null, summary?: string | null, sensitive?: Array<string> | null, affectedUserCount?: number | null, expiresAt?: string | null, reviewNotes?: string | null, reviewedAt?: string | null, requestedById?: string | null, requestedByName?: string | null, targetUserName?: string | null, reviewedByName?: string | null };

export type GetPermissionChangeRequestsQueryVariables = Exact<{
  status?: InputMaybe<PermissionRequestStatus>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPermissionChangeRequestsQuery = { __typename?: 'Query', permissionChangeRequests?: Array<{ __typename?: 'PermissionChangeRequest', id?: string | null, createdAt?: string | null, kind?: PermissionRequestKind | null, status?: PermissionRequestStatus | null, summary?: string | null, sensitive?: Array<string> | null, affectedUserCount?: number | null, expiresAt?: string | null, reviewNotes?: string | null, reviewedAt?: string | null, requestedById?: string | null, requestedByName?: string | null, targetUserName?: string | null, reviewedByName?: string | null }> | null };

export type GetPendingPermissionChangeRequestCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingPermissionChangeRequestCountQuery = { __typename?: 'Query', pendingPermissionChangeRequestCount?: number | null };

export type GetCanApproveAccessRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCanApproveAccessRequestsQuery = { __typename?: 'Query', canApproveAccessRequests?: boolean | null };

export type ReviewPermissionChangeRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  decision: PermissionRequestDecision;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReviewPermissionChangeRequestMutation = { __typename?: 'Mutation', reviewPermissionChangeRequest?: { __typename?: 'PermissionChangeRequest', id?: string | null, createdAt?: string | null, kind?: PermissionRequestKind | null, status?: PermissionRequestStatus | null, summary?: string | null, sensitive?: Array<string> | null, affectedUserCount?: number | null, expiresAt?: string | null, reviewNotes?: string | null, reviewedAt?: string | null, requestedById?: string | null, requestedByName?: string | null, targetUserName?: string | null, reviewedByName?: string | null } | null };

export type CancelPermissionChangeRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelPermissionChangeRequestMutation = { __typename?: 'Mutation', cancelPermissionChangeRequest?: { __typename?: 'PermissionChangeRequest', id?: string | null, createdAt?: string | null, kind?: PermissionRequestKind | null, status?: PermissionRequestStatus | null, summary?: string | null, sensitive?: Array<string> | null, affectedUserCount?: number | null, expiresAt?: string | null, reviewNotes?: string | null, reviewedAt?: string | null, requestedById?: string | null, requestedByName?: string | null, targetUserName?: string | null, reviewedByName?: string | null } | null };

export type GetEffectivePermissionsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEffectivePermissionsQuery = { __typename?: 'Query', effectivePermissions?: Array<{ __typename?: 'EffectivePermission', moduleCode?: string | null, moduleName?: string | null, action?: string | null, granted?: boolean | null, source?: string | null, sourceRoleId?: string | null, manualOverride?: boolean | null }> | null };

export type GetUserPermissionsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserPermissionsQuery = { __typename?: 'Query', userPermissions?: Array<{ __typename?: 'UserPermission', id?: string | null, action?: string | null, granted?: boolean | null, manualOverride?: boolean | null, sourceRoleId?: string | null, reason?: string | null, expiresAt?: string | null, grantedByName?: string | null, createdAt?: string | null, updatedAt?: string | null, module?: { __typename?: 'Module', id?: string | null, code?: string | null, name?: string | null } | null, sourceRole?: { __typename?: 'Role', id?: string | null, code?: string | null, name?: string | null } | null }> | null };

export type GetSensitivePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSensitivePermissionsQuery = { __typename?: 'Query', sensitivePermissions?: Array<{ __typename?: 'SensitivePermission', moduleCode?: string | null, action?: string | null, level?: string | null }> | null };

export type SetUserPermissionMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  moduleCode: Scalars['String']['input'];
  action: Scalars['String']['input'];
  granted: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SetUserPermissionMutation = { __typename?: 'Mutation', setUserPermission?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RemoveUserPermissionOverrideMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  moduleCode: Scalars['String']['input'];
  action: Scalars['String']['input'];
}>;


export type RemoveUserPermissionOverrideMutation = { __typename?: 'Mutation', removeUserPermissionOverride?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type MaterializeAllPermissionsMutationVariables = Exact<{ [key: string]: never; }>;


export type MaterializeAllPermissionsMutation = { __typename?: 'Mutation', materializeAllPermissions?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type SetUserPermissionOverrideMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  moduleCode: Scalars['String']['input'];
  action: Scalars['String']['input'];
  granted: Scalars['Boolean']['input'];
}>;


export type SetUserPermissionOverrideMutation = { __typename?: 'Mutation', setUserPermissionOverride?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type PhoneNumberUpdateRequestFieldsFragment = { __typename?: 'PhoneNumberUpdateRequest', id: string, status: string, newPhone: string, oldPhone?: string | null, maskedNewPhone: string, maskedOldPhone?: string | null, expiresAt: string, verifiedAt?: string | null, otpAttempts: number, resendCount: number, attemptsRemaining: number, resendsRemaining: number, createdAt: string };

export type ActivePhoneNumberUpdateRequestQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type ActivePhoneNumberUpdateRequestQuery = { __typename?: 'Query', activePhoneNumberUpdateRequest?: { __typename?: 'PhoneNumberUpdateRequest', id: string, status: string, newPhone: string, oldPhone?: string | null, maskedNewPhone: string, maskedOldPhone?: string | null, expiresAt: string, verifiedAt?: string | null, otpAttempts: number, resendCount: number, attemptsRemaining: number, resendsRemaining: number, createdAt: string } | null };

export type RequestPhoneNumberUpdateMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  newPhone: Scalars['String']['input'];
}>;


export type RequestPhoneNumberUpdateMutation = { __typename?: 'Mutation', requestPhoneNumberUpdate: { __typename?: 'PhoneNumberUpdateRequest', id: string, status: string, newPhone: string, oldPhone?: string | null, maskedNewPhone: string, maskedOldPhone?: string | null, expiresAt: string, verifiedAt?: string | null, otpAttempts: number, resendCount: number, attemptsRemaining: number, resendsRemaining: number, createdAt: string } };

export type ResendPhoneNumberUpdateOtpMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type ResendPhoneNumberUpdateOtpMutation = { __typename?: 'Mutation', resendPhoneNumberUpdateOtp: { __typename?: 'PhoneNumberUpdateRequest', id: string, status: string, newPhone: string, oldPhone?: string | null, maskedNewPhone: string, maskedOldPhone?: string | null, expiresAt: string, verifiedAt?: string | null, otpAttempts: number, resendCount: number, attemptsRemaining: number, resendsRemaining: number, createdAt: string } };

export type VerifyPhoneNumberUpdateOtpMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type VerifyPhoneNumberUpdateOtpMutation = { __typename?: 'Mutation', verifyPhoneNumberUpdateOtp: { __typename?: 'PhoneNumberUpdateRequest', id: string, status: string, newPhone: string, oldPhone?: string | null, maskedNewPhone: string, maskedOldPhone?: string | null, expiresAt: string, verifiedAt?: string | null, otpAttempts: number, resendCount: number, attemptsRemaining: number, resendsRemaining: number, createdAt: string, customer: { __typename?: 'Customer', id?: string | null, phone?: string | null } } };

export type GetProductBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductBrandsQuery = { __typename?: 'Query', productBrands?: Array<{ __typename?: 'ProductBrand', id?: string | null, name?: string | null, externalCode?: string | null, productCount?: number | null, createdAt?: string | null, updatedAt?: string | null }> | null };

export type CreateProductBrandMutationVariables = Exact<{
  input: CreateProductBrandInput;
}>;


export type CreateProductBrandMutation = { __typename?: 'Mutation', createProductBrand?: { __typename?: 'ProductBrand', id?: string | null, name?: string | null, externalCode?: string | null } | null };

export type UpdateProductBrandMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateProductBrandInput;
}>;


export type UpdateProductBrandMutation = { __typename?: 'Mutation', updateProductBrand?: { __typename?: 'ProductBrand', id?: string | null, name?: string | null, externalCode?: string | null } | null };

export type DeleteProductBrandMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProductBrandMutation = { __typename?: 'Mutation', deleteProductBrand?: { __typename?: 'ProductBrand', id?: string | null, name?: string | null } | null };

export type GetProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCategoriesQuery = { __typename?: 'Query', productCategories?: Array<{ __typename?: 'ProductCategory', id?: string | null, name?: string | null, externalCode?: string | null, rank?: number | null, productCount?: number | null, createdAt?: string | null, updatedAt?: string | null }> | null };

export type CreateProductCategoryMutationVariables = Exact<{
  input: CreateProductCategoryInput;
}>;


export type CreateProductCategoryMutation = { __typename?: 'Mutation', createProductCategory?: { __typename?: 'ProductCategory', id?: string | null, name?: string | null, externalCode?: string | null, rank?: number | null } | null };

export type UpdateProductCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateProductCategoryInput;
}>;


export type UpdateProductCategoryMutation = { __typename?: 'Mutation', updateProductCategory?: { __typename?: 'ProductCategory', id?: string | null, name?: string | null, externalCode?: string | null, rank?: number | null } | null };

export type DeleteProductCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProductCategoryMutation = { __typename?: 'Mutation', deleteProductCategory?: { __typename?: 'ProductCategory', id?: string | null, name?: string | null } | null };

export type GetProductsQueryVariables = Exact<{
  input?: InputMaybe<ProductListInput>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductListResult', totalCount: number, items: Array<{ __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null, description?: string | null, requiresSerialTracking?: boolean | null, canAcceptToken?: boolean | null, panelWatts?: number | null, batteryKwh?: number | null, panelEfficiency?: number | null, systemEfficiency?: number | null, isActive?: boolean | null, family?: string | null, kind: ProductKind, productCategoryId?: string | null, productBrandId?: string | null, businessLineId?: string | null, unitOfMeasureId?: string | null, itemCategoryId?: string | null, lastCostCents?: number | null, createdAt?: string | null, productCategory?: { __typename?: 'ProductCategory', id?: string | null, name?: string | null } | null, productBrand?: { __typename?: 'ProductBrand', id?: string | null, name?: string | null } | null, businessLine?: { __typename?: 'BusinessLine', id?: string | null, name?: string | null } | null, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id?: string | null, name?: string | null } | null }> } | null };

export type GetProductQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null, description?: string | null, requiresSerialTracking?: boolean | null, canAcceptToken?: boolean | null, panelWatts?: number | null, batteryKwh?: number | null, panelEfficiency?: number | null, systemEfficiency?: number | null, isActive?: boolean | null, family?: string | null, kind: ProductKind, productCategoryId?: string | null, productBrandId?: string | null, businessLineId?: string | null, unitOfMeasureId?: string | null, lastCostCents?: number | null, createdAt?: string | null, updatedAt?: string | null, productCategory?: { __typename?: 'ProductCategory', id?: string | null, name?: string | null } | null, productBrand?: { __typename?: 'ProductBrand', id?: string | null, name?: string | null } | null, businessLine?: { __typename?: 'BusinessLine', id?: string | null, name?: string | null } | null, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id?: string | null, name?: string | null } | null } | null };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct?: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null } | null };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null, isActive?: boolean | null } | null };

export type GetPurchaseOrdersQueryVariables = Exact<{
  input?: InputMaybe<PurchaseOrderListInput>;
}>;


export type GetPurchaseOrdersQuery = { __typename?: 'Query', purchaseOrders?: { __typename?: 'PurchaseOrderListResult', totalCount: number, items: Array<{ __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, poNumber?: string | null, waybillReference?: string | null, contentType?: PurchaseOrderContentType | null, stockType?: PurchaseOrderStockType | null, status?: PurchaseOrderStatus | null, closedAt?: string | null, cancelledAt?: string | null, createdAt?: string | null, shipment?: { __typename?: 'Shipment', id?: string | null, state?: ShipmentState | null, closedAt?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, shippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null } | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type GetPurchaseOrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPurchaseOrderQuery = { __typename?: 'Query', purchaseOrder?: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, poNumber?: string | null, waybillReference?: string | null, contentType?: PurchaseOrderContentType | null, stockType?: PurchaseOrderStockType | null, status?: PurchaseOrderStatus | null, closedAt?: string | null, cancelledAt?: string | null, cancelReason?: string | null, notes?: string | null, createdAt?: string | null, updatedAt?: string | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, shippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null, courier?: Courier | null } | null, shipment?: { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null } | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, items?: Array<{ __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null, stockType?: { __typename?: 'StockType', id?: string | null, name?: string | null } | null }> | null, lines: Array<{ __typename?: 'PurchaseOrderLine', id: string, quantity: number, unitCostCents?: number | null, receivedQuantity?: number | null, receivedAt?: string | null, product: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null, kind: ProductKind } }> } | null };

export type PurchaseOrderLineFieldsFragment = { __typename?: 'PurchaseOrderLine', id: string, quantity: number, unitCostCents?: number | null, receivedQuantity?: number | null, receivedAt?: string | null, product: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null, kind: ProductKind } };

export type CreatePurchaseOrderMutationVariables = Exact<{
  input: CreatePurchaseOrderInput;
}>;


export type CreatePurchaseOrderMutation = { __typename?: 'Mutation', createPurchaseOrder?: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null } | null };

export type AddPurchaseOrderItemsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: AddPurchaseOrderItemsInput;
}>;


export type AddPurchaseOrderItemsMutation = { __typename?: 'Mutation', addPurchaseOrderItems?: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, items?: Array<{ __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null }> | null } | null };

export type MarkPurchaseOrderInTransitMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkPurchaseOrderInTransitMutation = { __typename?: 'Mutation', markPurchaseOrderInTransit?: { __typename?: 'PurchaseOrder', id?: string | null, status?: PurchaseOrderStatus | null } | null };

export type ClosePurchaseOrderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  courierOverrideReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClosePurchaseOrderMutation = { __typename?: 'Mutation', closePurchaseOrder?: { __typename?: 'PurchaseOrder', id?: string | null, status?: PurchaseOrderStatus | null, closedAt?: string | null } | null };

export type CancelPurchaseOrderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type CancelPurchaseOrderMutation = { __typename?: 'Mutation', cancelPurchaseOrder?: { __typename?: 'PurchaseOrder', id?: string | null, status?: PurchaseOrderStatus | null, cancelledAt?: string | null, cancelReason?: string | null } | null };

export type UpdatePurchaseOrderShippingMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ShippingDetailsInput;
}>;


export type UpdatePurchaseOrderShippingMutation = { __typename?: 'Mutation', updatePurchaseOrderShipping?: { __typename?: 'PurchaseOrder', id?: string | null, waybillReference?: string | null, shippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null, courier?: Courier | null } | null, shipment?: { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null } | null } | null };

export type UpdatePurchaseOrderLinesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  lines: Array<PurchaseOrderLineInput> | PurchaseOrderLineInput;
}>;


export type UpdatePurchaseOrderLinesMutation = { __typename?: 'Mutation', updatePurchaseOrderPlan?: { __typename?: 'PurchaseOrder', id?: string | null, lines: Array<{ __typename?: 'PurchaseOrderLine', id: string, quantity: number, unitCostCents?: number | null, receivedQuantity?: number | null, receivedAt?: string | null, product: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null, kind: ProductKind } }> } | null };

export type ReceivePurchaseOrderLinesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  lines: Array<ReceivePurchaseOrderLineInput> | ReceivePurchaseOrderLineInput;
}>;


export type ReceivePurchaseOrderLinesMutation = { __typename?: 'Mutation', receivePurchaseOrderLines?: { __typename?: 'PurchaseOrder', id?: string | null, lines: Array<{ __typename?: 'PurchaseOrderLine', id: string, quantity: number, unitCostCents?: number | null, receivedQuantity?: number | null, receivedAt?: string | null, product: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null, kind: ProductKind } }> } | null };

export type ResolveRatePlanChangeQueryVariables = Exact<{
  input: ResolveRatePlanChangeInput;
}>;


export type ResolveRatePlanChangeQuery = { __typename?: 'Query', resolveRatePlanChange?: { __typename?: 'RatePlanChangePreview', planValid?: boolean | null, planError?: string | null, planRateName?: string | null, rows?: Array<{ __typename?: 'RatePlanChangeRowPreview', rowNumber?: number | null, identifier?: string | null, valid?: boolean | null, error?: string | null, alreadyApplied?: boolean | null, contractId?: string | null, contractNumber?: string | null, customerName?: string | null, currentRateName?: string | null, currentDeviceSerialNumber?: string | null, currentDeviceAccountNumber?: string | null, newDeviceSerialNumber?: string | null, newDeviceAccountNumber?: string | null, newDeviceProductName?: string | null, currentTotalPrice?: number | null, newTotalPrice?: number | null, currentBalance?: number | null, projectedBalance?: number | null, catchUpTokenDays?: number | null, catchUpTokenAmount?: number | null, wouldPayOff?: boolean | null, devices?: Array<{ __typename?: 'RatePlanChangeDevicePreview', productName?: string | null, replacing?: boolean | null, currentSerialNumber?: string | null, currentAccountNumber?: string | null, newSerialNumber?: string | null, newAccountNumber?: string | null }> | null, warnings?: Array<{ __typename?: 'DeviceReassignmentWarning', code?: DeviceReassignmentWarningCode | null, detail?: string | null }> | null }> | null } | null };

export type ChangeContractRatePlanMutationVariables = Exact<{
  input: ChangeContractRatePlanInput;
}>;


export type ChangeContractRatePlanMutation = { __typename?: 'Mutation', changeContractRatePlan?: { __typename?: 'ChangeRatePlanResult', contractNumber?: string | null, newRateName?: string | null, newTotalPrice?: number | null, newBalance?: number | null, catchUpTokenDays?: number | null, catchUpTokenAmount?: number | null, reassignment?: { __typename?: 'DeviceReassignment', id?: string | null, newSerialNumber?: string | null, newAccountNumber?: string | null, customerNotifiedAt?: string | null } | null } | null };

export type BulkChangeContractRatePlanMutationVariables = Exact<{
  input: BulkChangeContractRatePlanInput;
}>;


export type BulkChangeContractRatePlanMutation = { __typename?: 'Mutation', bulkChangeContractRatePlan?: { __typename?: 'BulkRatePlanChangeResult', total?: number | null, succeeded?: number | null, failed?: number | null, skipped?: number | null, rows?: Array<{ __typename?: 'BulkRatePlanChangeRowOutcome', rowNumber?: number | null, identifier?: string | null, status?: RatePlanChangeRowStatus | null, reason?: string | null, contractNumber?: string | null, previousSerialNumber?: string | null, newSerialNumber?: string | null, catchUpTokenDays?: number | null, catchUpTokenAmount?: number | null, newBalance?: number | null }> | null } | null };

export type GetRatePlansQueryVariables = Exact<{
  input?: InputMaybe<RatePlanListInput>;
}>;


export type GetRatePlansQuery = { __typename?: 'Query', ratePlans?: { __typename?: 'RatePlanListResult', totalCount: number, items: Array<{ __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null, manSystem?: string | null, depositAmount?: number | null, depositCollectedUpfront?: boolean | null, rateAmount?: number | null, downpayment?: number | null, downpaymentFormula?: string | null, termLength?: number | null, tokenCase?: string | null, type?: string | null, isActive?: boolean | null, createdAt?: string | null, contractCount?: number | null, commissionMonth1?: number | null, commissionMonth2?: number | null, commissionMonth3?: number | null, commissionMonth4?: number | null, commissionCloseout?: number | null, commissionRam?: number | null, aftercareAgent?: number | null, aftercareRam?: number | null, products?: Array<{ __typename?: 'RatePlanProduct', id?: string | null, allocationPercentage?: number | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null, sku?: string | null, canAcceptToken?: boolean | null } | null }> | null }> } | null };

export type GetRatePlanQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRatePlanQuery = { __typename?: 'Query', ratePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null, manSystem?: string | null, depositAmount?: number | null, depositCollectedUpfront?: boolean | null, rateAmount?: number | null, downpayment?: number | null, downpaymentFormula?: string | null, termLength?: number | null, tokenCase?: string | null, isActive?: boolean | null, createdAt?: string | null, updatedAt?: string | null, contractCount?: number | null, commissionMonth1?: number | null, commissionMonth2?: number | null, commissionMonth3?: number | null, commissionMonth4?: number | null, commissionCloseout?: number | null, products?: Array<{ __typename?: 'RatePlanProduct', id?: string | null, allocationPercentage?: number | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null, sku?: string | null, canAcceptToken?: boolean | null } | null }> | null } | null };

export type CreateRatePlanMutationVariables = Exact<{
  input: CreateRatePlanInput;
}>;


export type CreateRatePlanMutation = { __typename?: 'Mutation', createRatePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null, manSystem?: string | null, depositAmount?: number | null, depositCollectedUpfront?: boolean | null, rateAmount?: number | null, downpayment?: number | null, downpaymentFormula?: string | null, termLength?: number | null, tokenCase?: string | null, isActive?: boolean | null, commissionMonth1?: number | null, commissionMonth2?: number | null, commissionMonth3?: number | null, commissionMonth4?: number | null, commissionCloseout?: number | null, products?: Array<{ __typename?: 'RatePlanProduct', id?: string | null, allocationPercentage?: number | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null, sku?: string | null, canAcceptToken?: boolean | null } | null }> | null } | null };

export type UpdateRatePlanMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateRatePlanInput;
}>;


export type UpdateRatePlanMutation = { __typename?: 'Mutation', updateRatePlan?: { __typename?: 'RatePlan', id?: string | null, rateName?: string | null, product?: string | null, manSystem?: string | null, depositAmount?: number | null, depositCollectedUpfront?: boolean | null, rateAmount?: number | null, downpayment?: number | null, downpaymentFormula?: string | null, termLength?: number | null, tokenCase?: string | null, isActive?: boolean | null, commissionMonth1?: number | null, commissionMonth2?: number | null, commissionMonth3?: number | null, commissionMonth4?: number | null, commissionCloseout?: number | null, products?: Array<{ __typename?: 'RatePlanProduct', id?: string | null, allocationPercentage?: number | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null, sku?: string | null, canAcceptToken?: boolean | null } | null }> | null } | null };

export type DeleteRatePlanMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteRatePlanMutation = { __typename?: 'Mutation', deleteRatePlan?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type PayAtDumpRowFieldsFragment = { __typename?: 'PayAtDumpRow', id: string, rowIndex: number, store: string, tillDate: string, rawReference: string, accountNumber?: string | null, totalCents: number, feeCents: number, tenderType?: string | null, status: PayAtDumpRowStatus, matchedAt?: string | null, matchedBy?: string | null, claimedCents: number, varianceCents: number, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null, payments: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, bankConfirmed: boolean, confirmationRef?: string | null, createdBy: string }> };

export type GetPayAtReconciliationSummaryQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type GetPayAtReconciliationSummaryQuery = { __typename?: 'Query', payAtReconciliationSummary?: { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number, byStatus: Array<{ __typename?: 'PayAtReconciliationStatusCount', status: PayAtDumpRowStatus, lines: number, totalCents: number }> } | null };

export type GetPayAtDumpRowsQueryVariables = Exact<{
  filter?: InputMaybe<PayAtDumpRowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPayAtDumpRowsQuery = { __typename?: 'Query', payAtDumpRows?: { __typename?: 'PayAtDumpRowListResult', totalCount: number, items: Array<{ __typename?: 'PayAtDumpRow', id: string, rowIndex: number, store: string, tillDate: string, rawReference: string, accountNumber?: string | null, totalCents: number, feeCents: number, tenderType?: string | null, status: PayAtDumpRowStatus, matchedAt?: string | null, matchedBy?: string | null, claimedCents: number, varianceCents: number, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null, payments: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, bankConfirmed: boolean, confirmationRef?: string | null, createdBy: string }> }> } | null };

export type GetPayAtDumpRowQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPayAtDumpRowQuery = { __typename?: 'Query', payAtDumpRow?: { __typename?: 'PayAtDumpRow', id: string, rowIndex: number, store: string, tillDate: string, rawReference: string, accountNumber?: string | null, totalCents: number, feeCents: number, tenderType?: string | null, status: PayAtDumpRowStatus, matchedAt?: string | null, matchedBy?: string | null, claimedCents: number, varianceCents: number, dump: { __typename?: 'PayAtDump', id: string, fileName: string, businessDate: string }, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null, payments: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, bankConfirmed: boolean, confirmationRef?: string | null, createdBy: string }> } | null };

export type GetPayAtRowCandidatesQueryVariables = Exact<{
  rowId: Scalars['String']['input'];
}>;


export type GetPayAtRowCandidatesQuery = { __typename?: 'Query', payAtRowCandidates?: Array<{ __typename?: 'PayAtCandidateGroup', referenceCode: string, contractId: string, paymentIds: Array<string>, grossCents: number, paidAt: string, accountNumbers: Array<string>, daysApart: number, contractNumber?: string | null, customerName?: string | null }> | null };

export type GetPayAtDumpsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPayAtDumpsQuery = { __typename?: 'Query', payAtDumps?: { __typename?: 'PayAtDumpListResult', totalCount: number, items: Array<{ __typename?: 'PayAtDump', id: string, fileName: string, businessDate: string, status: PayAtDumpStatus, lineCount: number, badLineCount: number, error?: string | null, ingestedAt?: string | null, matchedAt?: string | null }> } | null };

export type GetUnclaimedTillPaymentsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUnclaimedTillPaymentsQuery = { __typename?: 'Query', unclaimedTillPayments?: { __typename?: 'UnclaimedTillPaymentListResult', totalCount: number, items: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, countsTowardBalance: boolean, depositDeducted?: number | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null }> } | null };

export type MatchPayAtRowMutationVariables = Exact<{
  rowId: Scalars['String']['input'];
  paymentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MatchPayAtRowMutation = { __typename?: 'Mutation', matchPayAtRow?: { __typename?: 'PayAtDumpRow', id: string, rowIndex: number, store: string, tillDate: string, rawReference: string, accountNumber?: string | null, totalCents: number, feeCents: number, tenderType?: string | null, status: PayAtDumpRowStatus, matchedAt?: string | null, matchedBy?: string | null, claimedCents: number, varianceCents: number, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null, payments: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, bankConfirmed: boolean, confirmationRef?: string | null, createdBy: string }> } | null };

export type UnmatchPayAtRowMutationVariables = Exact<{
  rowId: Scalars['String']['input'];
}>;


export type UnmatchPayAtRowMutation = { __typename?: 'Mutation', unmatchPayAtRow?: { __typename?: 'PayAtDumpRow', id: string, rowIndex: number, store: string, tillDate: string, rawReference: string, accountNumber?: string | null, totalCents: number, feeCents: number, tenderType?: string | null, status: PayAtDumpRowStatus, matchedAt?: string | null, matchedBy?: string | null, claimedCents: number, varianceCents: number, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null, payments: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, bankConfirmed: boolean, confirmationRef?: string | null, createdBy: string }> } | null };

export type IgnorePayAtRowsMutationVariables = Exact<{
  rowIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type IgnorePayAtRowsMutation = { __typename?: 'Mutation', ignorePayAtRows?: number | null };

export type UnignorePayAtRowMutationVariables = Exact<{
  rowId: Scalars['String']['input'];
}>;


export type UnignorePayAtRowMutation = { __typename?: 'Mutation', unignorePayAtRow?: { __typename?: 'PayAtDumpRow', id: string, rowIndex: number, store: string, tillDate: string, rawReference: string, accountNumber?: string | null, totalCents: number, feeCents: number, tenderType?: string | null, status: PayAtDumpRowStatus, matchedAt?: string | null, matchedBy?: string | null, claimedCents: number, varianceCents: number, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null, payments: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, bankConfirmed: boolean, confirmationRef?: string | null, createdBy: string }> } | null };

export type SetPayAtRowAccountMutationVariables = Exact<{
  rowId: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
}>;


export type SetPayAtRowAccountMutation = { __typename?: 'Mutation', setPayAtRowAccount?: { __typename?: 'PayAtDumpRow', id: string, rowIndex: number, store: string, tillDate: string, rawReference: string, accountNumber?: string | null, totalCents: number, feeCents: number, tenderType?: string | null, status: PayAtDumpRowStatus, matchedAt?: string | null, matchedBy?: string | null, claimedCents: number, varianceCents: number, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null, payments: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, bankConfirmed: boolean, confirmationRef?: string | null, createdBy: string }> } | null };

export type RecordPayAtRowPaymentMutationVariables = Exact<{
  rowId: Scalars['String']['input'];
}>;


export type RecordPayAtRowPaymentMutation = { __typename?: 'Mutation', recordPayAtRowPayment?: { __typename?: 'PayAtRecordPaymentResult', paymentId: string, rowId: string } | null };

export type RunPayAtReconciliationMutationVariables = Exact<{ [key: string]: never; }>;


export type RunPayAtReconciliationMutation = { __typename?: 'Mutation', runPayAtReconciliation?: { __typename?: 'PayAtReconciliationRunResult', failures: Array<string>, stats: Array<{ __typename?: 'PayAtReconciliationRunStat', label: string, value: string }> } | null };

export type RecheckPayAtRowMutationVariables = Exact<{
  rowId: Scalars['String']['input'];
}>;


export type RecheckPayAtRowMutation = { __typename?: 'Mutation', recheckPayAtRow?: { __typename?: 'PayAtDumpRow', id: string, rowIndex: number, store: string, tillDate: string, rawReference: string, accountNumber?: string | null, totalCents: number, feeCents: number, tenderType?: string | null, status: PayAtDumpRowStatus, matchedAt?: string | null, matchedBy?: string | null, claimedCents: number, varianceCents: number, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null, payments: Array<{ __typename?: 'PaymentTransaction', id: string, createdAt: string, referenceCode: string, accountNumber: string, amount: number, token?: string | null, bankConfirmed: boolean, confirmationRef?: string | null, createdBy: string }> } | null };

export type ExportSalesWorkbookQueryVariables = Exact<{
  to: Scalars['DateTime']['input'];
}>;


export type ExportSalesWorkbookQuery = { __typename?: 'Query', exportSalesWorkbook?: { __typename?: 'SalesWorkbook', fileName?: string | null, contentBase64?: string | null, payAtLinesWithoutFees?: number | null } | null };

export type PayAtWeekTotalFragment = { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number };

export type GetPayAtMoneySeriesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  bucket: SeriesBucket;
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPayAtMoneySeriesQuery = { __typename?: 'Query', payAtReconciliationSeries: Array<{ __typename?: 'PayAtMoneyInPoint', start: string, end: string, totalCents: number, lines: number }> };

export type GetPayAtMonthlyTotalsQueryVariables = Exact<{
  from0: Scalars['DateTime']['input'];
  to0: Scalars['DateTime']['input'];
  from1: Scalars['DateTime']['input'];
  to1: Scalars['DateTime']['input'];
  from2: Scalars['DateTime']['input'];
  to2: Scalars['DateTime']['input'];
  from3: Scalars['DateTime']['input'];
  to3: Scalars['DateTime']['input'];
  from4: Scalars['DateTime']['input'];
  to4: Scalars['DateTime']['input'];
  yearAgoFrom: Scalars['DateTime']['input'];
  yearAgoTo: Scalars['DateTime']['input'];
  lastMonthFrom: Scalars['DateTime']['input'];
  lastMonthTo: Scalars['DateTime']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPayAtMonthlyTotalsQuery = { __typename?: 'Query', month0?: { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number } | null, month1?: { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number } | null, month2?: { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number } | null, month3?: { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number } | null, month4?: { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number } | null, yearAgo?: { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number } | null, lastMonthSoFar?: { __typename?: 'PayAtReconciliationSummary', from: string, to: string, lines: number, totalCents: number } | null };

export type GetLiveMoneyInWeekQueryVariables = Exact<{
  thisWeekFrom: Scalars['DateTime']['input'];
  thisWeekTo: Scalars['DateTime']['input'];
  lastWeekFrom: Scalars['DateTime']['input'];
  lastWeekTo: Scalars['DateTime']['input'];
}>;


export type GetLiveMoneyInWeekQuery = { __typename?: 'Query', thisWeek?: { __typename?: 'LiveMoneyIn', totalCents: number, payments: number } | null, lastWeekSoFar?: { __typename?: 'LiveMoneyIn', totalCents: number, payments: number } | null, bankReconciled?: { __typename?: 'LiveMoneyIn', totalCents: number, payments: number } | null };

export type RecruitmentUserFieldsFragment = { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null };

export type RecruitmentCostFieldsFragment = { __typename?: 'RecruitmentCost', id: string, category: RecruitmentCostCategory, amount: number, incurredDate: string, description?: string | null };

export type VacancyFieldsFragment = { __typename?: 'Vacancy', id: string, title: string, departmentId?: string | null, departmentName?: string | null, jobPositionId?: string | null, jobPositionTitle?: string | null, headcount: number, reason?: VacancyReason | null, openedDate?: string | null, targetFillDate?: string | null, closedDate?: string | null, status: VacancyStatus, notes?: string | null, applicationCount: number, hiredCount: number, totalCost?: number | null, hiringManager?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null };

export type CandidateFieldsFragment = { __typename?: 'Candidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null, sourceDetail?: string | null, notes?: string | null, documents: Array<{ __typename?: 'CandidateCv', id: string, originalName: string, mimeType: string, size: number, createdAt: string }>, applications: Array<{ __typename?: 'CandidateApplication', id: string, stage: JobApplicationStage, appliedDate: string, vacancyId: string, vacancyTitle: string, vacancyStatus: VacancyStatus }> };

export type JobApplicationFieldsFragment = { __typename?: 'JobApplication', id: string, vacancyId: string, vacancyTitle: string, appliedDate: string, stage: JobApplicationStage, stageDate: string, candidate: { __typename?: 'JobApplicationCandidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null }, offer?: { __typename?: 'JobOffer', id: string, offeredDate: string, startDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, acceptedDate?: string | null, declinedDate?: string | null, notes?: string | null } | null, employee?: { __typename?: 'JobApplicationEmployee', id: string, firstName: string, lastName: string } | null, history: Array<{ __typename?: 'JobApplicationMove', id: string, fromStage?: JobApplicationStage | null, toStage: JobApplicationStage, date: string, notes?: string | null, movedBy?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> };

export type VacanciesQueryVariables = Exact<{
  filter?: InputMaybe<VacancyFilterInput>;
}>;


export type VacanciesQuery = { __typename?: 'Query', vacancies: { __typename?: 'VacancyList', totalCount: number, items: Array<{ __typename?: 'Vacancy', id: string, title: string, departmentId?: string | null, departmentName?: string | null, jobPositionId?: string | null, jobPositionTitle?: string | null, headcount: number, reason?: VacancyReason | null, openedDate?: string | null, targetFillDate?: string | null, closedDate?: string | null, status: VacancyStatus, notes?: string | null, applicationCount: number, hiredCount: number, totalCost?: number | null, hiringManager?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type VacanciesExportQueryVariables = Exact<{
  filter?: InputMaybe<VacancyFilterInput>;
}>;


export type VacanciesExportQuery = { __typename?: 'Query', vacanciesExport: Array<{ __typename?: 'Vacancy', id: string, title: string, departmentId?: string | null, departmentName?: string | null, jobPositionId?: string | null, jobPositionTitle?: string | null, headcount: number, reason?: VacancyReason | null, openedDate?: string | null, targetFillDate?: string | null, closedDate?: string | null, status: VacancyStatus, notes?: string | null, applicationCount: number, hiredCount: number, totalCost?: number | null, hiringManager?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> };

export type VacancyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VacancyQuery = { __typename?: 'Query', vacancy: { __typename?: 'Vacancy', id: string, title: string, departmentId?: string | null, departmentName?: string | null, jobPositionId?: string | null, jobPositionTitle?: string | null, headcount: number, reason?: VacancyReason | null, openedDate?: string | null, targetFillDate?: string | null, closedDate?: string | null, status: VacancyStatus, notes?: string | null, applicationCount: number, hiredCount: number, totalCost?: number | null, costs: Array<{ __typename?: 'RecruitmentCost', id: string, category: RecruitmentCostCategory, amount: number, incurredDate: string, description?: string | null }>, hiringManager?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }, jobApplications: Array<{ __typename?: 'JobApplication', id: string, vacancyId: string, vacancyTitle: string, appliedDate: string, stage: JobApplicationStage, stageDate: string, candidate: { __typename?: 'JobApplicationCandidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null }, offer?: { __typename?: 'JobOffer', id: string, offeredDate: string, startDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, acceptedDate?: string | null, declinedDate?: string | null, notes?: string | null } | null, employee?: { __typename?: 'JobApplicationEmployee', id: string, firstName: string, lastName: string } | null, history: Array<{ __typename?: 'JobApplicationMove', id: string, fromStage?: JobApplicationStage | null, toStage: JobApplicationStage, date: string, notes?: string | null, movedBy?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> }> };

export type CandidatesQueryVariables = Exact<{
  filter?: InputMaybe<CandidateFilterInput>;
}>;


export type CandidatesQuery = { __typename?: 'Query', candidates: { __typename?: 'CandidateList', totalCount: number, items: Array<{ __typename?: 'Candidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null, sourceDetail?: string | null, notes?: string | null, documents: Array<{ __typename?: 'CandidateCv', id: string, originalName: string, mimeType: string, size: number, createdAt: string }>, applications: Array<{ __typename?: 'CandidateApplication', id: string, stage: JobApplicationStage, appliedDate: string, vacancyId: string, vacancyTitle: string, vacancyStatus: VacancyStatus }> }> } };

export type CandidateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CandidateQuery = { __typename?: 'Query', candidate: { __typename?: 'Candidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null, sourceDetail?: string | null, notes?: string | null, documents: Array<{ __typename?: 'CandidateCv', id: string, originalName: string, mimeType: string, size: number, createdAt: string }>, applications: Array<{ __typename?: 'CandidateApplication', id: string, stage: JobApplicationStage, appliedDate: string, vacancyId: string, vacancyTitle: string, vacancyStatus: VacancyStatus }> } };

export type RecruitmentMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filter?: InputMaybe<RecruitmentMetricsFilterInput>;
}>;


export type RecruitmentMetricsQuery = { __typename?: 'Query', recruitmentMetrics: { __typename?: 'RecruitmentMetrics', from: string, to: string, openVacancies: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, openPositions: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, vacanciesFilled: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, averageDaysToFill: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, applications: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, applicationsPerVacancy: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, hires: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, averageDaysToHire: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, offerAcceptanceRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, totalCost: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, costPerHire: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, internalHirePercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, pipeline: Array<{ __typename?: 'RecruitmentStageCount', stage: JobApplicationStage, reached: number, current: number }>, sourceOfHire: Array<{ __typename?: 'RecruitmentSourceCount', source?: CandidateSource | null, count: number }> } };

export type CreateVacancyMutationVariables = Exact<{
  input: CreateVacancyInput;
}>;


export type CreateVacancyMutation = { __typename?: 'Mutation', createVacancy: { __typename?: 'Vacancy', id: string, title: string, departmentId?: string | null, departmentName?: string | null, jobPositionId?: string | null, jobPositionTitle?: string | null, headcount: number, reason?: VacancyReason | null, openedDate?: string | null, targetFillDate?: string | null, closedDate?: string | null, status: VacancyStatus, notes?: string | null, applicationCount: number, hiredCount: number, totalCost?: number | null, hiringManager?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type UpdateVacancyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateVacancyInput;
}>;


export type UpdateVacancyMutation = { __typename?: 'Mutation', updateVacancy: { __typename?: 'Vacancy', id: string, title: string, departmentId?: string | null, departmentName?: string | null, jobPositionId?: string | null, jobPositionTitle?: string | null, headcount: number, reason?: VacancyReason | null, openedDate?: string | null, targetFillDate?: string | null, closedDate?: string | null, status: VacancyStatus, notes?: string | null, applicationCount: number, hiredCount: number, totalCost?: number | null, hiringManager?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type DeleteVacancyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteVacancyMutation = { __typename?: 'Mutation', deleteVacancy: boolean };

export type AddRecruitmentCostMutationVariables = Exact<{
  vacancyId: Scalars['ID']['input'];
  input: RecruitmentCostInput;
}>;


export type AddRecruitmentCostMutation = { __typename?: 'Mutation', addRecruitmentCost: { __typename?: 'RecruitmentCost', id: string, category: RecruitmentCostCategory, amount: number, incurredDate: string, description?: string | null } };

export type UpdateRecruitmentCostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRecruitmentCostInput;
}>;


export type UpdateRecruitmentCostMutation = { __typename?: 'Mutation', updateRecruitmentCost: { __typename?: 'RecruitmentCost', id: string, category: RecruitmentCostCategory, amount: number, incurredDate: string, description?: string | null } };

export type DeleteRecruitmentCostMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRecruitmentCostMutation = { __typename?: 'Mutation', deleteRecruitmentCost: boolean };

export type CreateCandidateMutationVariables = Exact<{
  input: CreateCandidateInput;
}>;


export type CreateCandidateMutation = { __typename?: 'Mutation', createCandidate: { __typename?: 'Candidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null, sourceDetail?: string | null, notes?: string | null, documents: Array<{ __typename?: 'CandidateCv', id: string, originalName: string, mimeType: string, size: number, createdAt: string }>, applications: Array<{ __typename?: 'CandidateApplication', id: string, stage: JobApplicationStage, appliedDate: string, vacancyId: string, vacancyTitle: string, vacancyStatus: VacancyStatus }> } };

export type UpdateCandidateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCandidateInput;
}>;


export type UpdateCandidateMutation = { __typename?: 'Mutation', updateCandidate: { __typename?: 'Candidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null, sourceDetail?: string | null, notes?: string | null, documents: Array<{ __typename?: 'CandidateCv', id: string, originalName: string, mimeType: string, size: number, createdAt: string }>, applications: Array<{ __typename?: 'CandidateApplication', id: string, stage: JobApplicationStage, appliedDate: string, vacancyId: string, vacancyTitle: string, vacancyStatus: VacancyStatus }> } };

export type DeleteCandidateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCandidateMutation = { __typename?: 'Mutation', deleteCandidate: boolean };

export type RemoveCandidateCvMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type RemoveCandidateCvMutation = { __typename?: 'Mutation', removeCandidateCv: boolean };

export type CreateJobApplicationMutationVariables = Exact<{
  input: CreateJobApplicationInput;
}>;


export type CreateJobApplicationMutation = { __typename?: 'Mutation', createJobApplication: { __typename?: 'JobApplication', id: string, vacancyId: string, vacancyTitle: string, appliedDate: string, stage: JobApplicationStage, stageDate: string, candidate: { __typename?: 'JobApplicationCandidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null }, offer?: { __typename?: 'JobOffer', id: string, offeredDate: string, startDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, acceptedDate?: string | null, declinedDate?: string | null, notes?: string | null } | null, employee?: { __typename?: 'JobApplicationEmployee', id: string, firstName: string, lastName: string } | null, history: Array<{ __typename?: 'JobApplicationMove', id: string, fromStage?: JobApplicationStage | null, toStage: JobApplicationStage, date: string, notes?: string | null, movedBy?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type MoveJobApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: MoveJobApplicationInput;
}>;


export type MoveJobApplicationMutation = { __typename?: 'Mutation', moveJobApplication: { __typename?: 'JobApplication', id: string, vacancyId: string, vacancyTitle: string, appliedDate: string, stage: JobApplicationStage, stageDate: string, candidate: { __typename?: 'JobApplicationCandidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null }, offer?: { __typename?: 'JobOffer', id: string, offeredDate: string, startDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, acceptedDate?: string | null, declinedDate?: string | null, notes?: string | null } | null, employee?: { __typename?: 'JobApplicationEmployee', id: string, firstName: string, lastName: string } | null, history: Array<{ __typename?: 'JobApplicationMove', id: string, fromStage?: JobApplicationStage | null, toStage: JobApplicationStage, date: string, notes?: string | null, movedBy?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type SaveJobOfferMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  input: JobOfferInput;
}>;


export type SaveJobOfferMutation = { __typename?: 'Mutation', saveJobOffer: { __typename?: 'JobApplication', id: string, vacancyId: string, vacancyTitle: string, appliedDate: string, stage: JobApplicationStage, stageDate: string, candidate: { __typename?: 'JobApplicationCandidate', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, source?: CandidateSource | null }, offer?: { __typename?: 'JobOffer', id: string, offeredDate: string, startDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, acceptedDate?: string | null, declinedDate?: string | null, notes?: string | null } | null, employee?: { __typename?: 'JobApplicationEmployee', id: string, firstName: string, lastName: string } | null, history: Array<{ __typename?: 'JobApplicationMove', id: string, fromStage?: JobApplicationStage | null, toStage: JobApplicationStage, date: string, notes?: string | null, movedBy?: { __typename?: 'RecruitmentUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type DeleteJobApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobApplicationMutation = { __typename?: 'Mutation', deleteJobApplication: boolean };

export type CreateEmployeeFromHireMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  input?: InputMaybe<CreateEmployeeFromHireInput>;
}>;


export type CreateEmployeeFromHireMutation = { __typename?: 'Mutation', createEmployeeFromHire: { __typename?: 'Employee', id: string } };

export type GetStockSalesReportQueryVariables = Exact<{
  input?: InputMaybe<ReportDateRangeInput>;
}>;


export type GetStockSalesReportQuery = { __typename?: 'Query', stockSalesReport?: { __typename?: 'StockSalesReport', totalCount?: number | null, items?: Array<{ __typename?: 'StockSalesReportRow', saleReference?: string | null, saleDate?: string | null, status?: string | null, agentSalesId?: string | null, agentName?: string | null, product?: string | null, productSku?: string | null, productCategory?: string | null, productCategoryRank?: number | null, serialNumber?: string | null, accountNumber?: string | null, customerName?: string | null, customerPhone?: string | null, contractNumber?: string | null, contractStatus?: string | null, ratePlan?: string | null, deposit?: number | null, rateAmount?: number | null, termLengthMonths?: number | null, totalPrice?: number | null, flaggedBad?: boolean | null, isWarrantyReplacement?: boolean | null, notCountedReason?: string | null, notes?: string | null, previousSerialNumber?: string | null, previousAccountNumber?: string | null, distributorName?: string | null, nationalSalesManagerName?: string | null }> | null } | null };

export type GetUnitsSoldSeriesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  bucket: SeriesBucket;
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUnitsSoldSeriesQuery = { __typename?: 'Query', unitsSoldSeries: Array<{ __typename?: 'UnitsSoldPoint', start: string, end: string, units: number }> };

export type GetTopSellersQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTopSellersQuery = { __typename?: 'Query', topSellers: Array<{ __typename?: 'SellerRank', agentId: string, salesId: string, name: string, units: number }> };

export type GetProductSalesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductSalesQuery = { __typename?: 'Query', productSales: Array<{ __typename?: 'ProductSales', productId?: string | null, name: string, units: number }> };

export type GetComboSalesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetComboSalesQuery = { __typename?: 'Query', comboSales: { __typename?: 'ComboSales', countedFrom: string, sales: number, combos: number, mixes: Array<{ __typename?: 'ComboMix', devices: string, units: number }> } };

export type GetSalesContributionReportQueryVariables = Exact<{
  month?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSalesContributionReportQuery = { __typename?: 'Query', salesContributionReport: { __typename?: 'SalesContributionReport', month: string, monthStart: string, closingDate: string, partialMonth: boolean, yearStart: string, previousThreeMonthsStart: string, lastYearStart: string, lastYearClosingDate: string, generatedAt: string, products: Array<string>, regions: Array<{ __typename?: 'SalesContributionRegion', regionId: string, name: string, emblemUrl?: string | null }>, nsms: Array<{ __typename?: 'SalesContributionNsm', nsmId: string, nsmName: string, nsmEmail: string, nsmAvatarUrl?: string | null, regionId?: string | null }>, sellers: Array<{ __typename?: 'SalesContributionSeller', agentId?: string | null, agentSalesId?: string | null, agentName?: string | null, agentType?: AgentType | null, agentStatus?: AgentStatus | null, agentAvatarUrl?: string | null, distributorId?: string | null, distributorName?: string | null, nsmId?: string | null, products: Array<{ __typename?: 'SalesContributionProductLine', product: string, mtd: number, mtdDelinquent: number, ytd: number, ytdDelinquent: number, previousThreeMonths: number, sameDaysLastYear: number }> }> } };

export type GetSalesContributionSalesQueryVariables = Exact<{
  month?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  span: SalesContributionSpan;
}>;


export type GetSalesContributionSalesQuery = { __typename?: 'Query', salesContributionSales: Array<{ __typename?: 'SalesContributionSale', contractId: string, contractNumber: string, accountNumber?: string | null, customerName?: string | null, saleDate: string, agentId?: string | null, product: string, contractStatus: ContractStatus, delinquent: boolean }> };

export type GetCustomerBookReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerBookReportQuery = { __typename?: 'Query', customerBookReport: { __typename?: 'CustomerBookReport', totalCustomers: number, attributedCustomers: number, totalContracts: number, attributedContracts: number, items: Array<{ __typename?: 'CustomerBookNsm', nsmId?: string | null, nsmName?: string | null, nsmEmail?: string | null, nsmAvatarUrl?: string | null, distributors: number, salesAgents: number, customers: number, contracts: number, owners: Array<{ __typename?: 'CustomerBookOwner', agentId: string, agentSalesId: string, agentName: string, agentType: AgentType, agentStatus: AgentStatus, agentAvatarUrl?: string | null, distributorName?: string | null, customers: number, contracts: number }> }> } };

export type GetCustomerBookActivityQueryVariables = Exact<{
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomerBookActivityQuery = { __typename?: 'Query', customerBookActivity: { __typename?: 'CustomerBookActivity', month: string, openingDate: string, closingDate: string, partialMonth: boolean, generatedAt: string, total: { __typename?: 'CustomerBookActivityFigures', openingCustomers: number, openingContracts: number, closingCustomers: number, closingContracts: number, newContracts: number, paidAgain: number, returned: number, tokenRanOut: number, paidOff: number, repossessed: number, writtenOff: number, cancelled: number, openingTokenOut: number, closingTokenOut: number, openingNoPayment90: number, closingNoPayment90: number, closingPaidOffContracts: number, closingRepossessedContracts: number, closingWrittenOffContracts: number, closingTokenOutCustomers: number, closingPaidOffCustomers: number, closingRepossessedCustomers: number, closingWrittenOffCustomers: number }, agents: Array<{ __typename?: 'CustomerBookAgentActivity', agentId?: string | null, figures: { __typename?: 'CustomerBookActivityFigures', openingCustomers: number, openingContracts: number, closingCustomers: number, closingContracts: number, newContracts: number, paidAgain: number, returned: number, tokenRanOut: number, paidOff: number, repossessed: number, writtenOff: number, cancelled: number, openingTokenOut: number, closingTokenOut: number, openingNoPayment90: number, closingNoPayment90: number, closingPaidOffContracts: number, closingRepossessedContracts: number, closingWrittenOffContracts: number, closingTokenOutCustomers: number, closingPaidOffCustomers: number, closingRepossessedCustomers: number, closingWrittenOffCustomers: number } }> } };

export type GetCustomerBookTrendQueryVariables = Exact<{
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomerBookTrendQuery = { __typename?: 'Query', customerBookTrend: { __typename?: 'CustomerBookTrend', month: string, step: CustomerBookTrendStep, dates: Array<string>, partialMonth: boolean, generatedAt: string, total: { __typename?: 'CustomerBookTrendSeries', activeContracts: Array<number>, tokenOut: Array<number>, noPayment90: Array<number> }, agents: Array<{ __typename?: 'CustomerBookAgentTrend', agentId?: string | null, series: { __typename?: 'CustomerBookTrendSeries', activeContracts: Array<number>, tokenOut: Array<number>, noPayment90: Array<number> } }> } };

export type CustomerBookTrendSeriesFragment = { __typename?: 'CustomerBookTrendSeries', activeContracts: Array<number>, tokenOut: Array<number>, noPayment90: Array<number> };

export type CustomerBookActivityFiguresFragment = { __typename?: 'CustomerBookActivityFigures', openingCustomers: number, openingContracts: number, closingCustomers: number, closingContracts: number, newContracts: number, paidAgain: number, returned: number, tokenRanOut: number, paidOff: number, repossessed: number, writtenOff: number, cancelled: number, openingTokenOut: number, closingTokenOut: number, openingNoPayment90: number, closingNoPayment90: number, closingPaidOffContracts: number, closingRepossessedContracts: number, closingWrittenOffContracts: number, closingTokenOutCustomers: number, closingPaidOffCustomers: number, closingRepossessedCustomers: number, closingWrittenOffCustomers: number };

export type GetReceivablesReportQueryVariables = Exact<{
  month: Scalars['String']['input'];
  basis?: InputMaybe<ReceivablesBasis>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetReceivablesReportQuery = { __typename?: 'Query', receivablesReport: { __typename?: 'ReceivablesReport', cutoff: string, basis: ReceivablesBasis, generatedAt: string, partialMonth: boolean, buckets: Array<{ __typename?: 'ReceivablesBucketRow', bucket: ReceivablesBucket, contracts: number, customers: number, buyout: number }>, years: Array<{ __typename?: 'ReceivablesYearRow', registrationYear: number, contracts: number, customers: number, buyout: number, overdueBuyout: number, buckets: Array<{ __typename?: 'ReceivablesBucketRow', bucket: ReceivablesBucket, contracts: number, customers: number, buyout: number }> }>, totals: { __typename?: 'ReceivablesTotals', contracts: number, customers: number, buyout: number, overdueContracts: number, overdueBuyout: number }, statuses: Array<{ __typename?: 'ReceivablesStatusRow', status: ReceivablesStatus, contracts: number, owingContracts: number, customers: number, unlockPrice: number, paid: number, outstanding: number, credit: number }>, statusYears: Array<{ __typename?: 'ReceivablesStatusYearRow', status: ReceivablesStatus, registrationYear: number, contracts: number, owingContracts: number, customers: number, unlockPrice: number, paid: number, outstanding: number, credit: number }>, statusBrands: Array<{ __typename?: 'ReceivablesStatusBrandRow', status: ReceivablesStatus, brand?: string | null, contracts: number, owingContracts: number, customers: number, unlockPrice: number, paid: number, outstanding: number, credit: number }> } };

export type GetBadDebtorsReportQueryVariables = Exact<{
  month: Scalars['String']['input'];
  basis?: InputMaybe<ReceivablesBasis>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBadDebtorsReportQuery = { __typename?: 'Query', badDebtorsReport: { __typename?: 'BadDebtorsReport', cutoff: string, basis: ReceivablesBasis, generatedAt: string, partialMonth: boolean, groups: Array<{ __typename?: 'ReceivablesStatusRow', status: ReceivablesStatus, contracts: number, owingContracts: number, customers: number, unlockPrice: number, paid: number, outstanding: number, credit: number }>, totals: { __typename?: 'BadDebtorsTotals', contracts: number, customers: number, unlockPrice: number, paid: number, outstanding: number, averageUnlockPrice: number, averagePaid: number, recoveredShare: number } } };

export type GetReceivablesContractsQueryVariables = Exact<{
  month: Scalars['String']['input'];
  basis?: InputMaybe<ReceivablesBasis>;
  section?: InputMaybe<ReceivablesSectionInput>;
}>;


export type GetReceivablesContractsQuery = { __typename?: 'Query', receivablesContracts: Array<{ __typename?: 'ReceivablesContract', contractId: string, contractNumber: string, customerId: string, customerName: string, customerPhone?: string | null, accountNumber?: string | null, registrationDate?: string | null, registrationYear: number, ratePlan?: string | null, brand?: string | null, product?: string | null, status: ReceivablesStatus, unlockPrice: number, paid: number, outstanding: number, distributorName?: string | null, nationalSalesManagerName?: string | null }> };

export type GetWarrantyReportQueryVariables = Exact<{
  input?: InputMaybe<ReportDateRangeInput>;
}>;


export type GetWarrantyReportQuery = { __typename?: 'Query', warrantyReport: { __typename?: 'WarrantyReport', totalCount: number, warrantyPeriodDays: number, unidentifiedDevices: number, items: Array<{ __typename?: 'WarrantyReportRow', saleReference: string, product?: string | null, productSku?: string | null, brand?: string | null, accountNumber?: string | null, serialNumber?: string | null, salesDate?: string | null, returnDate: string, failureMode?: string | null, faultDescription?: string | null, sparePartUsed?: string | null, replacementSerialNumber?: string | null, replacementAccountNumber?: string | null, repairOrReplacementDate: string, ageDays?: number | null, inWarranty?: boolean | null, customerName?: string | null, contractNumber?: string | null, agentName?: string | null }> } };

export type StockOnHandFieldsFragment = { __typename?: 'StockOnHand', available: number, reserved: number, damaged: number, inTransit: number, inWorkshop: number, onHand: number, sold: number, issued: number };

export type GetStockByTierReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStockByTierReportQuery = { __typename?: 'Query', stockByTierReport: { __typename?: 'StockByTierFullReport', generatedAt: string, totals: { __typename?: 'StockByTierTotals', atWarehouse: number, withDistributors: number, withAgents: number, atWorkshop: number, incoming: number, skuCount: number, distributorCount: number, agentCount: number, totalUnits: number, stock: { __typename?: 'StockOnHand', available: number, reserved: number, damaged: number, inTransit: number, inWorkshop: number, onHand: number, sold: number, issued: number } }, skus: Array<{ __typename?: 'StockByTierSku', sku: string, description: string, isActive: boolean, atWarehouse: number, withDistributors: number, withAgents: number, atWorkshop: number, incoming: number, stock: { __typename?: 'StockOnHand', available: number, reserved: number, damaged: number, inTransit: number, inWorkshop: number, onHand: number, sold: number, issued: number } }>, points: Array<{ __typename?: 'StockByTierPoint', stockingPointId: string, name: string, tier: StockingPointType, province?: string | null, isActive: boolean, holderName?: string | null, distributorName?: string | null, distributorKey?: string | null, stock: { __typename?: 'StockOnHand', available: number, reserved: number, damaged: number, inTransit: number, inWorkshop: number, onHand: number, sold: number, issued: number }, bySku: Array<{ __typename?: 'StockByTierPointSku', sku: string, description: string, stock: { __typename?: 'StockOnHand', available: number, reserved: number, damaged: number, inTransit: number, inWorkshop: number, onHand: number, sold: number, issued: number } }> }>, accessories: { __typename?: 'StockByTierReport', totals: { __typename?: 'StockByTierTotals', atWarehouse: number, withDistributors: number, withAgents: number, atWorkshop: number, skuCount: number, totalUnits: number, stock: { __typename?: 'StockOnHand', available: number, reserved: number, damaged: number, inTransit: number, inWorkshop: number, onHand: number, sold: number, issued: number } }, skus: Array<{ __typename?: 'StockByTierSku', sku: string, description: string, isActive: boolean, atWarehouse: number, withDistributors: number, withAgents: number, atWorkshop: number, incoming: number, stock: { __typename?: 'StockOnHand', available: number, reserved: number, damaged: number, inTransit: number, inWorkshop: number, onHand: number, sold: number, issued: number } }>, points: Array<{ __typename?: 'StockByTierPoint', tier: StockingPointType, bySku: Array<{ __typename?: 'StockByTierPointSku', sku: string, stock: { __typename?: 'StockOnHand', available: number, reserved: number, damaged: number, inTransit: number, inWorkshop: number, onHand: number, sold: number, issued: number } }> }> } } };

export type GetStockByTierUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStockByTierUnitsQuery = { __typename?: 'Query', stockByTierUnits: Array<{ __typename?: 'StockByTierUnit', serialNumber?: string | null, accountNumber?: string | null, sku: string, description: string, stockType?: string | null, stockingPoint?: string | null, tier?: StockingPointType | null, province?: string | null, status: StockItemStatus }> };

export type GetUnitsSoldByMonthQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  lastMonthFrom: Scalars['DateTime']['input'];
  lastMonthTo: Scalars['DateTime']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUnitsSoldByMonthQuery = { __typename?: 'Query', months: Array<{ __typename?: 'UnitsSoldPoint', start: string, end: string, units: number }>, lastMonthSoFar: Array<{ __typename?: 'UnitsSoldPoint', units: number }> };

export type ExportAgentHierarchyWorkbookQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportAgentHierarchyWorkbookQuery = { __typename?: 'Query', exportAgentHierarchyWorkbook?: { __typename?: 'AgentHierarchyWorkbook', fileName?: string | null, contentBase64?: string | null } | null };

export type ExportFinanceWorkbookQueryVariables = Exact<{
  kind: FinanceWorkbookKind;
  month?: InputMaybe<Scalars['String']['input']>;
  basis?: InputMaybe<ReceivablesBasis>;
  months?: InputMaybe<Scalars['Int']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExportFinanceWorkbookQuery = { __typename?: 'Query', exportFinanceWorkbook: { __typename?: 'FinanceWorkbook', status: FinanceWorkbookStatus, fileName?: string | null, contentBase64?: string | null, builtAt?: string | null } };

export type GetEdfReportQueryVariables = Exact<{
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEdfReportQuery = { __typename?: 'Query', edfReportDefaultRate: { __typename?: 'EdfReportDefaultRate', cutoff: string, generatedAt: string, partialMonth: boolean, portfolioContracts: number, inDefault: number, defaultRate?: number | null, reactivated: number, noLongerInDefaultRate?: number | null, leftPortfolio: number }, edfReportCollectionRate: { __typename?: 'EdfReportCollectionRate', paidForPaygo: number, cashSales: number, deposit: number, expected: number, collectionRate?: number | null, expectedContracts: number, newPaygoContracts: number, cashSaleContracts: number }, edfReportRepaymentRate: { __typename?: 'EdfReportRepaymentRate', portfolioContracts: number, paid: number, due: number, repaymentRate?: number | null }, edfReportRecoveries: { __typename?: 'EdfReportRecoveries', totalContracts: number, inPortfolio: number, toRecover: number, par60Contracts: number, repossessed: number, writtenOff: number, reactivated: number, recovered: number, repossessionRate?: number | null, writeOffRate?: number | null, reactivatedRate?: number | null, repossessedYearToDate: number }, edfReportReceivablesAtRisk: { __typename?: 'EdfReportReceivablesAtRisk', contracts: number, receivables: number, bands: Array<{ __typename?: 'EdfReportRarBandRow', band: EdfReportRarBand, contracts: number, receivables: number, share?: number | null }> } };

export type GetEdfDebtorAgeingQueryVariables = Exact<{
  month: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEdfDebtorAgeingQuery = { __typename?: 'Query', edfReportDebtorAgeing: { __typename?: 'EdfReportDebtorAgeing', month: string, cutoff: string, generatedAt: string, partialMonth: boolean, months: Array<{ __typename?: 'EdfReportDebtorAgeingMonth', month: string, newContracts: number, openingDebtor: number, newContractRevenue: number, paymentsReceived: number, overpayment: number, writtenOff: number, closingDebtor: number, days0To30: number, days31To60: number, days61To90: number, days90Plus: number }> } };

export type GetCustomerDemographicsReportQueryVariables = Exact<{
  filter?: InputMaybe<CustomerDemographicsFilter>;
}>;


export type GetCustomerDemographicsReportQuery = { __typename?: 'Query', customerDemographicsReport: { __typename?: 'CustomerDemographicsReport', totalCustomers: number, medianAge?: number | null, averageAge?: number | null, coverage: { __typename?: 'DemographicsCoverage', age: number, gender: number, province: number, city: number, municipality: number, town: number }, gender: Array<{ __typename?: 'DemographicGenderCount', gender: DemographicGender, customers: number }>, ageBands: Array<{ __typename?: 'DemographicAgeBand', band: AgeBand, female: number, male: number, other: number, unknown: number, total: number }>, provinces: Array<{ __typename?: 'DemographicPlace', name: string, customers: number }>, cities: Array<{ __typename?: 'DemographicPlace', name: string, province?: string | null, customers: number }>, municipalities: Array<{ __typename?: 'DemographicPlace', name: string, province?: string | null, customers: number }>, towns: Array<{ __typename?: 'DemographicPlace', name: string, province?: string | null, customers: number }>, sources: Array<{ __typename?: 'DemographicSourceCoverage', source: CustomerSource, customers: number, withAge: number, withGender: number, withProvince: number }> } };

export type GetStockSalesActivationsQueryVariables = Exact<{
  input?: InputMaybe<ReportDateRangeInput>;
}>;


export type GetStockSalesActivationsQuery = { __typename?: 'Query', stockSalesActivations?: { __typename?: 'StockSalesActivations', totalCount?: number | null, items?: Array<{ __typename?: 'StockSalesActivationRow', contractNumber?: string | null, activatedAt?: string | null, registrationDate?: string | null, contractStatus?: string | null, customerName?: string | null, agentName?: string | null, product?: string | null, productCategory?: string | null, productCategoryRank?: number | null, ratePlan?: string | null, comboDevices?: string | null, deposit?: number | null, rateAmount?: number | null, totalPrice?: number | null, notCountedReason?: string | null }> | null } | null };

export type StockValuationProductFieldsFragment = { __typename?: 'StockValuationProduct', id: string, sku: string, name: string, kind: ProductKind, lastCostCents?: number | null, unitOfMeasureName?: string | null };

export type GetStockValuationReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStockValuationReportQuery = { __typename?: 'Query', stockValuationReport: { __typename?: 'StockValuationReport', asAt: string, quantity: number, valueCents: number, unpricedQuantity: number, unitsWithoutProduct: number, lines: Array<{ __typename?: 'StockValuationLine', quantity: number, valueCents: number, unpricedQuantity: number, businessLine?: { __typename?: 'StockValuationBusinessLine', id: string, name: string, externalCode?: string | null } | null, products: Array<{ __typename?: 'StockValuationProductRow', quantity: number, damagedQuantity: number, valueCents: number, unpricedQuantity: number, product: { __typename?: 'StockValuationProduct', id: string, sku: string, name: string, kind: ProductKind, lastCostCents?: number | null, unitOfMeasureName?: string | null } }> }> } };

export type ExportStockValuationQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportStockValuationQuery = { __typename?: 'Query', stockValuationReport: { __typename?: 'StockValuationReport', asAt: string, lines: Array<{ __typename?: 'StockValuationLine', businessLine?: { __typename?: 'StockValuationBusinessLine', name: string, externalCode?: string | null } | null, products: Array<{ __typename?: 'StockValuationProductRow', product: { __typename?: 'StockValuationProduct', id: string, sku: string, name: string, kind: ProductKind, lastCostCents?: number | null, unitOfMeasureName?: string | null }, places: Array<{ __typename?: 'StockValuationPlace', stockingPointName?: string | null, condition: StockCondition, quantity: number, valueCents?: number | null }> }> }> } };

export type DeviceHistoryEntryFieldsFragment = { __typename?: 'DeviceHistoryEntry', at?: string | null, kind?: DeviceHistoryKind | null, summary?: string | null, reference?: string | null };

export type ReturnToHeadOfficeDeviceFieldsFragment = { __typename?: 'ReturnToHeadOfficeDevice', stockItemId?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, condition?: StockItemCondition | null, declinedAt?: string | null, recentHistory?: Array<{ __typename?: 'DeviceHistoryEntry', at?: string | null, kind?: DeviceHistoryKind | null, summary?: string | null, reference?: string | null }> | null };

export type ReturnToHeadOfficeSummaryFieldsFragment = { __typename?: 'ReturnToHeadOffice', id?: string | null, returnNumber?: string | null, status?: ReturnToHeadOfficeStatus | null, transferStatus?: TransferStatus | null, approvalStatus?: ApprovalStatus | null, sourceStockingPointName?: string | null, destinationStockingPointName?: string | null, agentName?: string | null, submittedByName?: string | null, submittedAt?: string | null, reviewedByName?: string | null, reviewedAt?: string | null, deviceCount?: number | null, declinedCount?: number | null, shippingCompanyName?: string | null, waybillReference?: string | null };

export type GetReturnableDevicesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReturnableDevicesQuery = { __typename?: 'Query', returnableDevices?: { __typename?: 'ReturnableDeviceListResult', totalCount?: number | null, stockingPointName?: string | null, items?: Array<{ __typename?: 'ReturnableDevice', stockItemId?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, condition?: StockItemCondition | null, blockedReason?: string | null, releases?: string | null, recentHistory?: Array<{ __typename?: 'DeviceHistoryEntry', at?: string | null, kind?: DeviceHistoryKind | null, summary?: string | null, reference?: string | null }> | null }> | null } | null };

export type GetReturnsToHeadOfficeQueryVariables = Exact<{
  input?: InputMaybe<ReturnToHeadOfficeListInput>;
}>;


export type GetReturnsToHeadOfficeQuery = { __typename?: 'Query', returnsToHeadOffice?: { __typename?: 'ReturnToHeadOfficeListResult', totalCount?: number | null, items?: Array<{ __typename?: 'ReturnToHeadOffice', id?: string | null, returnNumber?: string | null, status?: ReturnToHeadOfficeStatus | null, transferStatus?: TransferStatus | null, approvalStatus?: ApprovalStatus | null, sourceStockingPointName?: string | null, destinationStockingPointName?: string | null, agentName?: string | null, submittedByName?: string | null, submittedAt?: string | null, reviewedByName?: string | null, reviewedAt?: string | null, deviceCount?: number | null, declinedCount?: number | null, shippingCompanyName?: string | null, waybillReference?: string | null }> | null } | null };

export type GetReturnToHeadOfficeCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReturnToHeadOfficeCountsQuery = { __typename?: 'Query', returnToHeadOfficeCounts?: Array<{ __typename?: 'ReturnToHeadOfficeStatusCount', status?: ReturnToHeadOfficeStatus | null, count?: number | null }> | null };

export type GetReturnToHeadOfficeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetReturnToHeadOfficeQuery = { __typename?: 'Query', returnToHeadOffice?: { __typename?: 'ReturnToHeadOffice', approvalRequestId?: string | null, sourceStockingPointId?: string | null, destinationStockingPointId?: string | null, submittedById?: string | null, notes?: string | null, reviewNotes?: string | null, dispatchedAt?: string | null, completedAt?: string | null, cancelledAt?: string | null, cancelReason?: string | null, manifestAvailable?: boolean | null, manifestUrl?: string | null, id?: string | null, returnNumber?: string | null, status?: ReturnToHeadOfficeStatus | null, transferStatus?: TransferStatus | null, approvalStatus?: ApprovalStatus | null, sourceStockingPointName?: string | null, destinationStockingPointName?: string | null, agentName?: string | null, submittedByName?: string | null, submittedAt?: string | null, reviewedByName?: string | null, reviewedAt?: string | null, deviceCount?: number | null, declinedCount?: number | null, shippingCompanyName?: string | null, waybillReference?: string | null, transfer?: { __typename?: 'StockTransfer', id?: string | null, status?: TransferStatus | null, dispatchedAt?: string | null, waybillReference?: string | null, shippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null, courier?: Courier | null } | null, shipment?: { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null } | null } | null, devices?: Array<{ __typename?: 'ReturnToHeadOfficeDevice', stockItemId?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, condition?: StockItemCondition | null, declinedAt?: string | null, recentHistory?: Array<{ __typename?: 'DeviceHistoryEntry', at?: string | null, kind?: DeviceHistoryKind | null, summary?: string | null, reference?: string | null }> | null }> | null, declinedDevices?: Array<{ __typename?: 'ReturnToHeadOfficeDevice', stockItemId?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, condition?: StockItemCondition | null, declinedAt?: string | null, recentHistory?: Array<{ __typename?: 'DeviceHistoryEntry', at?: string | null, kind?: DeviceHistoryKind | null, summary?: string | null, reference?: string | null }> | null }> | null } | null };

export type GetReturnToHeadOfficeLinkQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetReturnToHeadOfficeLinkQuery = { __typename?: 'Query', returnToHeadOffice?: { __typename?: 'ReturnToHeadOffice', id?: string | null, returnNumber?: string | null, status?: ReturnToHeadOfficeStatus | null } | null };

export type SubmitReturnToHeadOfficeMutationVariables = Exact<{
  input: SubmitReturnToHeadOfficeInput;
}>;


export type SubmitReturnToHeadOfficeMutation = { __typename?: 'Mutation', submitReturnToHeadOffice?: { __typename?: 'ReturnToHeadOffice', id?: string | null, returnNumber?: string | null, status?: ReturnToHeadOfficeStatus | null, transferStatus?: TransferStatus | null, approvalStatus?: ApprovalStatus | null, sourceStockingPointName?: string | null, destinationStockingPointName?: string | null, agentName?: string | null, submittedByName?: string | null, submittedAt?: string | null, reviewedByName?: string | null, reviewedAt?: string | null, deviceCount?: number | null, declinedCount?: number | null, shippingCompanyName?: string | null, waybillReference?: string | null } | null };

export type ReviewReturnToHeadOfficeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ReviewReturnToHeadOfficeInput;
}>;


export type ReviewReturnToHeadOfficeMutation = { __typename?: 'Mutation', reviewReturnToHeadOffice?: { __typename?: 'ReturnToHeadOffice', reviewNotes?: string | null, manifestAvailable?: boolean | null, id?: string | null, returnNumber?: string | null, status?: ReturnToHeadOfficeStatus | null, transferStatus?: TransferStatus | null, approvalStatus?: ApprovalStatus | null, sourceStockingPointName?: string | null, destinationStockingPointName?: string | null, agentName?: string | null, submittedByName?: string | null, submittedAt?: string | null, reviewedByName?: string | null, reviewedAt?: string | null, deviceCount?: number | null, declinedCount?: number | null, shippingCompanyName?: string | null, waybillReference?: string | null } | null };

export type WithdrawReturnToHeadOfficeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type WithdrawReturnToHeadOfficeMutation = { __typename?: 'Mutation', withdrawReturnToHeadOffice?: { __typename?: 'ReturnToHeadOffice', cancelReason?: string | null, id?: string | null, returnNumber?: string | null, status?: ReturnToHeadOfficeStatus | null, transferStatus?: TransferStatus | null, approvalStatus?: ApprovalStatus | null, sourceStockingPointName?: string | null, destinationStockingPointName?: string | null, agentName?: string | null, submittedByName?: string | null, submittedAt?: string | null, reviewedByName?: string | null, reviewedAt?: string | null, deviceCount?: number | null, declinedCount?: number | null, shippingCompanyName?: string | null, waybillReference?: string | null } | null };

export type CancelReturnToHeadOfficeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type CancelReturnToHeadOfficeMutation = { __typename?: 'Mutation', cancelReturnToHeadOffice?: { __typename?: 'ReturnToHeadOffice', cancelReason?: string | null, id?: string | null, returnNumber?: string | null, status?: ReturnToHeadOfficeStatus | null, transferStatus?: TransferStatus | null, approvalStatus?: ApprovalStatus | null, sourceStockingPointName?: string | null, destinationStockingPointName?: string | null, agentName?: string | null, submittedByName?: string | null, submittedAt?: string | null, reviewedByName?: string | null, reviewedAt?: string | null, deviceCount?: number | null, declinedCount?: number | null, shippingCompanyName?: string | null, waybillReference?: string | null } | null };

export type GetRolesQueryVariables = Exact<{
  assignableForAgents?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRolesQuery = { __typename?: 'Query', roles?: Array<{ __typename?: 'Role', id?: string | null, code?: string | null, name?: string | null, description?: string | null, accessLevel?: string | null, isSystem?: boolean | null, assignableForAgents?: boolean | null, canManageAgents?: boolean | null, requiresWorkshop?: boolean | null, homeModule?: HomeModule | null, createdAt?: string | null, permissions?: Array<{ __typename?: 'RolePermission', id?: string | null, action?: string | null, granted?: boolean | null, module?: { __typename?: 'Module', id?: string | null, code?: string | null, name?: string | null } | null }> | null, userRoles?: Array<{ __typename?: 'UserRole', id?: string | null }> | null, grantableRoles?: Array<{ __typename?: 'Role', id?: string | null, name?: string | null }> | null }> | null };

export type GetRoleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRoleQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id?: string | null, code?: string | null, name?: string | null, description?: string | null, accessLevel?: string | null, isSystem?: boolean | null, createdAt?: string | null, updatedAt?: string | null, permissions?: Array<{ __typename?: 'RolePermission', id?: string | null, action?: string | null, granted?: boolean | null, module?: { __typename?: 'Module', id?: string | null, code?: string | null, name?: string | null } | null }> | null } | null };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole?: { __typename?: 'Role', id?: string | null, code?: string | null, name?: string | null, description?: string | null, accessLevel?: string | null } | null };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'Role', id?: string | null, code?: string | null, name?: string | null, description?: string | null, accessLevel?: string | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type CloneRoleMutationVariables = Exact<{
  sourceRoleId: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type CloneRoleMutation = { __typename?: 'Mutation', cloneRole?: { __typename?: 'Role', id?: string | null, code?: string | null, name?: string | null } | null };

export type UpdateRolePermissionsMutationVariables = Exact<{
  roleId: Scalars['String']['input'];
  permissions: Array<RolePermissionInput> | RolePermissionInput;
}>;


export type UpdateRolePermissionsMutation = { __typename?: 'Mutation', updateRolePermissions?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type SetRoleGrantsMutationVariables = Exact<{
  roleId: Scalars['String']['input'];
  grantableRoleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SetRoleGrantsMutation = { __typename?: 'Mutation', setRoleGrants: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } };

export type SafetyUserFieldsFragment = { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null };

export type SafetyCorrectiveActionFieldsFragment = { __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null };

export type SafetyIncidentFieldsFragment = { __typename?: 'SafetyIncident', id: string, occurredAt: string, location?: string | null, type?: SafetyIncidentType | null, severity?: SafetyIncidentSeverity | null, description?: string | null, injuryDetails?: string | null, lostDays?: number | null, reportable?: boolean | null, coidaClaimNumber?: string | null, coidaClaimStatus?: CoidaClaimStatus | null, rootCause?: string | null, status: SafetyIncidentStatus, closedDate?: string | null, createdAt: string, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null, employee?: { __typename?: 'SafetyEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } | null, subcontractor?: { __typename?: 'SafetySubcontractor', id: string, name: string } | null, subcontractorWorker?: { __typename?: 'SafetyWorker', id: string, firstName: string, lastName: string } | null, reportedBy?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null, actions: Array<{ __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }>, evidence: Array<{ __typename?: 'SafetyIncidentEvidence', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> };

export type SafetyInspectionFieldsFragment = { __typename?: 'SafetyInspection', id: string, type: SafetyInspectionType, inspectionDate: string, area: string, inspectorName?: string | null, scorePercent?: number | null, findingsCount?: number | null, notes?: string | null, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null };

export type SafetyIncidentsQueryVariables = Exact<{
  filter?: InputMaybe<SafetyIncidentFilterInput>;
}>;


export type SafetyIncidentsQuery = { __typename?: 'Query', safetyIncidents: { __typename?: 'SafetyIncidentList', totalCount: number, items: Array<{ __typename?: 'SafetyIncident', id: string, occurredAt: string, location?: string | null, type?: SafetyIncidentType | null, severity?: SafetyIncidentSeverity | null, description?: string | null, injuryDetails?: string | null, lostDays?: number | null, reportable?: boolean | null, coidaClaimNumber?: string | null, coidaClaimStatus?: CoidaClaimStatus | null, rootCause?: string | null, status: SafetyIncidentStatus, closedDate?: string | null, createdAt: string, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null, employee?: { __typename?: 'SafetyEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } | null, subcontractor?: { __typename?: 'SafetySubcontractor', id: string, name: string } | null, subcontractorWorker?: { __typename?: 'SafetyWorker', id: string, firstName: string, lastName: string } | null, reportedBy?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null, actions: Array<{ __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }>, evidence: Array<{ __typename?: 'SafetyIncidentEvidence', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> }> } };

export type SafetyIncidentsExportQueryVariables = Exact<{
  filter?: InputMaybe<SafetyIncidentFilterInput>;
}>;


export type SafetyIncidentsExportQuery = { __typename?: 'Query', safetyIncidentsExport: Array<{ __typename?: 'SafetyIncident', id: string, occurredAt: string, location?: string | null, type?: SafetyIncidentType | null, severity?: SafetyIncidentSeverity | null, description?: string | null, injuryDetails?: string | null, lostDays?: number | null, reportable?: boolean | null, coidaClaimNumber?: string | null, coidaClaimStatus?: CoidaClaimStatus | null, rootCause?: string | null, status: SafetyIncidentStatus, closedDate?: string | null, createdAt: string, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null, employee?: { __typename?: 'SafetyEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } | null, subcontractor?: { __typename?: 'SafetySubcontractor', id: string, name: string } | null, subcontractorWorker?: { __typename?: 'SafetyWorker', id: string, firstName: string, lastName: string } | null, reportedBy?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null, actions: Array<{ __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }>, evidence: Array<{ __typename?: 'SafetyIncidentEvidence', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> }> };

export type SafetyIncidentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SafetyIncidentQuery = { __typename?: 'Query', safetyIncident: { __typename?: 'SafetyIncident', id: string, occurredAt: string, location?: string | null, type?: SafetyIncidentType | null, severity?: SafetyIncidentSeverity | null, description?: string | null, injuryDetails?: string | null, lostDays?: number | null, reportable?: boolean | null, coidaClaimNumber?: string | null, coidaClaimStatus?: CoidaClaimStatus | null, rootCause?: string | null, status: SafetyIncidentStatus, closedDate?: string | null, createdAt: string, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null, employee?: { __typename?: 'SafetyEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } | null, subcontractor?: { __typename?: 'SafetySubcontractor', id: string, name: string } | null, subcontractorWorker?: { __typename?: 'SafetyWorker', id: string, firstName: string, lastName: string } | null, reportedBy?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null, actions: Array<{ __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }>, evidence: Array<{ __typename?: 'SafetyIncidentEvidence', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type SafetyInspectionsQueryVariables = Exact<{
  filter?: InputMaybe<SafetyInspectionFilterInput>;
}>;


export type SafetyInspectionsQuery = { __typename?: 'Query', safetyInspections: { __typename?: 'SafetyInspectionList', totalCount: number, items: Array<{ __typename?: 'SafetyInspection', id: string, type: SafetyInspectionType, inspectionDate: string, area: string, inspectorName?: string | null, scorePercent?: number | null, findingsCount?: number | null, notes?: string | null, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null }> } };

export type SafetySubcontractorOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SafetySubcontractorOptionsQuery = { __typename?: 'Query', safetySubcontractorOptions: Array<{ __typename?: 'SafetySubcontractorOption', id: string, name: string, workers: Array<{ __typename?: 'SafetyWorker', id: string, firstName: string, lastName: string }> }> };

export type SafetyMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filter?: InputMaybe<SafetyMetricsFilterInput>;
}>;


export type SafetyMetricsQuery = { __typename?: 'Query', safetyMetrics: { __typename?: 'SafetyMetrics', from: string, to: string, incidents: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, lostTimeInjuries: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, fatalities: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, lostDays: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, daysSinceLastLostTimeInjury: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, nearMisses: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, reportableIncidents: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, openCorrectiveActions: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, overdueCorrectiveActions: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, inspections: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, averageInspectionScore: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, inspectionFindings: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, employeeHoursWorked: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, ltifr: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, subcontractorHoursWorked: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, subcontractorLtifr: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, incidentsByType: Array<{ __typename?: 'SafetyIncidentTypeCount', type?: SafetyIncidentType | null, count: number }>, incidentsBySeverity: Array<{ __typename?: 'SafetyIncidentSeverityCount', severity?: SafetyIncidentSeverity | null, count: number }> } };

export type CreateSafetyIncidentMutationVariables = Exact<{
  input: CreateSafetyIncidentInput;
}>;


export type CreateSafetyIncidentMutation = { __typename?: 'Mutation', createSafetyIncident: { __typename?: 'SafetyIncident', id: string, occurredAt: string, location?: string | null, type?: SafetyIncidentType | null, severity?: SafetyIncidentSeverity | null, description?: string | null, injuryDetails?: string | null, lostDays?: number | null, reportable?: boolean | null, coidaClaimNumber?: string | null, coidaClaimStatus?: CoidaClaimStatus | null, rootCause?: string | null, status: SafetyIncidentStatus, closedDate?: string | null, createdAt: string, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null, employee?: { __typename?: 'SafetyEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } | null, subcontractor?: { __typename?: 'SafetySubcontractor', id: string, name: string } | null, subcontractorWorker?: { __typename?: 'SafetyWorker', id: string, firstName: string, lastName: string } | null, reportedBy?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null, actions: Array<{ __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }>, evidence: Array<{ __typename?: 'SafetyIncidentEvidence', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type UpdateSafetyIncidentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSafetyIncidentInput;
}>;


export type UpdateSafetyIncidentMutation = { __typename?: 'Mutation', updateSafetyIncident: { __typename?: 'SafetyIncident', id: string, occurredAt: string, location?: string | null, type?: SafetyIncidentType | null, severity?: SafetyIncidentSeverity | null, description?: string | null, injuryDetails?: string | null, lostDays?: number | null, reportable?: boolean | null, coidaClaimNumber?: string | null, coidaClaimStatus?: CoidaClaimStatus | null, rootCause?: string | null, status: SafetyIncidentStatus, closedDate?: string | null, createdAt: string, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null, employee?: { __typename?: 'SafetyEmployee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } | null, subcontractor?: { __typename?: 'SafetySubcontractor', id: string, name: string } | null, subcontractorWorker?: { __typename?: 'SafetyWorker', id: string, firstName: string, lastName: string } | null, reportedBy?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null, actions: Array<{ __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null }>, evidence: Array<{ __typename?: 'SafetyIncidentEvidence', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type DeleteSafetyIncidentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSafetyIncidentMutation = { __typename?: 'Mutation', deleteSafetyIncident: boolean };

export type RemoveSafetyIncidentEvidenceMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type RemoveSafetyIncidentEvidenceMutation = { __typename?: 'Mutation', removeSafetyIncidentEvidence: boolean };

export type CreateSafetyCorrectiveActionMutationVariables = Exact<{
  incidentId: Scalars['ID']['input'];
  input: CreateSafetyCorrectiveActionInput;
}>;


export type CreateSafetyCorrectiveActionMutation = { __typename?: 'Mutation', createSafetyCorrectiveAction: { __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type UpdateSafetyCorrectiveActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSafetyCorrectiveActionInput;
}>;


export type UpdateSafetyCorrectiveActionMutation = { __typename?: 'Mutation', updateSafetyCorrectiveAction: { __typename?: 'SafetyCorrectiveAction', id: string, description: string, dueDate?: string | null, doneDate?: string | null, notes?: string | null, owner?: { __typename?: 'SafetyUser', id: string, email: string, firstName?: string | null, lastName?: string | null } | null } };

export type DeleteSafetyCorrectiveActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSafetyCorrectiveActionMutation = { __typename?: 'Mutation', deleteSafetyCorrectiveAction: boolean };

export type CreateSafetyInspectionMutationVariables = Exact<{
  input: CreateSafetyInspectionInput;
}>;


export type CreateSafetyInspectionMutation = { __typename?: 'Mutation', createSafetyInspection: { __typename?: 'SafetyInspection', id: string, type: SafetyInspectionType, inspectionDate: string, area: string, inspectorName?: string | null, scorePercent?: number | null, findingsCount?: number | null, notes?: string | null, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null } };

export type UpdateSafetyInspectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSafetyInspectionInput;
}>;


export type UpdateSafetyInspectionMutation = { __typename?: 'Mutation', updateSafetyInspection: { __typename?: 'SafetyInspection', id: string, type: SafetyInspectionType, inspectionDate: string, area: string, inspectorName?: string | null, scorePercent?: number | null, findingsCount?: number | null, notes?: string | null, department?: { __typename?: 'SafetyDepartment', id: string, name: string } | null } };

export type DeleteSafetyInspectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSafetyInspectionMutation = { __typename?: 'Mutation', deleteSafetyInspection: boolean };

export type SalesAppMessageFieldsFragment = { __typename?: 'SalesAppMessage', id: string, category: SalesAppMessageCategory, title: string, message: string, audience: SalesAppMessageAudience, agentIds: Array<string>, status: SalesAppMessageStatus, sentTo?: number | null, alreadySent?: number | null, unknownAgentIds: Array<string>, lastError?: string | null, attempts: number, sentAt?: string | null, resentFromId?: string | null, createdAt: string, sentByName?: string | null };

export type GetSalesAppMessagesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSalesAppMessagesQuery = { __typename?: 'Query', salesAppMessages: { __typename?: 'SalesAppMessageListResult', totalCount: number, items: Array<{ __typename?: 'SalesAppMessage', id: string, category: SalesAppMessageCategory, title: string, message: string, audience: SalesAppMessageAudience, agentIds: Array<string>, status: SalesAppMessageStatus, sentTo?: number | null, alreadySent?: number | null, unknownAgentIds: Array<string>, lastError?: string | null, attempts: number, sentAt?: string | null, resentFromId?: string | null, createdAt: string, sentByName?: string | null }> } };

export type GetSalesAppMessageDistributorTeamQueryVariables = Exact<{
  distributorId: Scalars['ID']['input'];
}>;


export type GetSalesAppMessageDistributorTeamQuery = { __typename?: 'Query', salesAppMessageDistributorTeam: Array<string> };

export type SearchSalesAppMessageAgentsQueryVariables = Exact<{
  input?: InputMaybe<AgentListInput>;
}>;


export type SearchSalesAppMessageAgentsQuery = { __typename?: 'Query', agents?: { __typename?: 'AgentListResult', totalCount: number, items: Array<{ __typename?: 'Agent', id?: string | null, salesId?: string | null, firstName?: string | null, lastName?: string | null, agentType?: AgentType | null }> } | null };

export type SendSalesAppMessageMutationVariables = Exact<{
  input: SendSalesAppMessageInput;
}>;


export type SendSalesAppMessageMutation = { __typename?: 'Mutation', sendSalesAppMessage: { __typename?: 'SalesAppMessage', id: string, category: SalesAppMessageCategory, title: string, message: string, audience: SalesAppMessageAudience, agentIds: Array<string>, status: SalesAppMessageStatus, sentTo?: number | null, alreadySent?: number | null, unknownAgentIds: Array<string>, lastError?: string | null, attempts: number, sentAt?: string | null, resentFromId?: string | null, createdAt: string, sentByName?: string | null } };

export type RetrySalesAppMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetrySalesAppMessageMutation = { __typename?: 'Mutation', retrySalesAppMessage: { __typename?: 'SalesAppMessage', id: string, category: SalesAppMessageCategory, title: string, message: string, audience: SalesAppMessageAudience, agentIds: Array<string>, status: SalesAppMessageStatus, sentTo?: number | null, alreadySent?: number | null, unknownAgentIds: Array<string>, lastError?: string | null, attempts: number, sentAt?: string | null, resentFromId?: string | null, createdAt: string, sentByName?: string | null } };

export type GetSalesRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesRegionsQuery = { __typename?: 'Query', salesRegions: Array<{ __typename?: 'SalesRegion', id: string, name: string, emblemUrl?: string | null, managers: Array<{ __typename?: 'SalesRegionManager', userId: string, name: string }> }>, salesRegionManagers: Array<{ __typename?: 'SalesRegionManager', userId: string, name: string, email: string, avatarUrl?: string | null, salesRegionId?: string | null, agents: number }> };

export type CreateSalesRegionMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateSalesRegionMutation = { __typename?: 'Mutation', createSalesRegion: { __typename?: 'SalesRegion', id: string, name: string } };

export type RenameSalesRegionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameSalesRegionMutation = { __typename?: 'Mutation', renameSalesRegion: { __typename?: 'SalesRegion', id: string, name: string } };

export type DeleteSalesRegionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSalesRegionMutation = { __typename?: 'Mutation', deleteSalesRegion: boolean };

export type AssignSalesRegionMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  salesRegionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssignSalesRegionMutation = { __typename?: 'Mutation', assignSalesRegion: { __typename?: 'SalesRegionManager', userId: string, salesRegionId?: string | null } };

export type SellerCorrectionAgentFieldsFragment = { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null };

export type SellerCorrectionSaleFieldsFragment = { __typename?: 'SellerCorrectionSale', stockSaleId?: string | null, saleReference?: string | null, accountNumber?: string | null, serialNumber?: string | null, contractNumber?: string | null, customerName?: string | null, productName?: string | null, saleDate?: string | null, status?: SaleStatus | null, distributorPinned?: boolean | null, sellerPaidAmountCents?: number | null, sellerPaidEntryCount?: number | null, sellerUnpaidAmountCents?: number | null, sellerUnpaidEntryCount?: number | null, seller?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null, distributor?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null };

export type SellerCorrectionFieldsFragment = { __typename?: 'SellerCorrection', id?: string | null, createdAt?: string | null, stockSaleId?: string | null, saleReference?: string | null, accountNumber?: string | null, serialNumber?: string | null, customerName?: string | null, fromAgentId?: string | null, fromAgentName?: string | null, toAgentId?: string | null, toAgentName?: string | null, fromDistributorName?: string | null, toDistributorName?: string | null, movedEntryCount?: number | null, paidEntryCount?: number | null, paidAmountCents?: number | null, cancelledEntryCount?: number | null, cancelledAmountCents?: number | null, reason?: string | null, source?: SellerCorrectionSource | null, correctedByName?: string | null };

export type AgentNameMatchFieldsFragment = { __typename?: 'AgentNameMatch', status?: AgentNameMatchStatus | null, agent?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null, candidates?: Array<{ __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null }> | null };

export type SellerCorrectionSalesQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type SellerCorrectionSalesQuery = { __typename?: 'Query', sellerCorrectionSales?: Array<{ __typename?: 'SellerCorrectionSale', stockSaleId?: string | null, saleReference?: string | null, accountNumber?: string | null, serialNumber?: string | null, contractNumber?: string | null, customerName?: string | null, productName?: string | null, saleDate?: string | null, status?: SaleStatus | null, distributorPinned?: boolean | null, sellerPaidAmountCents?: number | null, sellerPaidEntryCount?: number | null, sellerUnpaidAmountCents?: number | null, sellerUnpaidEntryCount?: number | null, seller?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null, distributor?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null }> | null };

export type SellerCorrectionAgentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SellerCorrectionAgentsQuery = { __typename?: 'Query', sellerCorrectionAgents?: Array<{ __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null }> | null };

export type PreviewSellerCorrectionUploadQueryVariables = Exact<{
  input: PreviewSellerCorrectionUploadInput;
}>;


export type PreviewSellerCorrectionUploadQuery = { __typename?: 'Query', previewSellerCorrectionUpload?: { __typename?: 'SellerCorrectionPreview', okCount?: number | null, problemCount?: number | null, rows?: Array<{ __typename?: 'SellerCorrectionPreviewRow', rowNumber?: number | null, accountNumber?: string | null, moveFrom?: string | null, moveTo?: string | null, verdict?: SellerCorrectionVerdict | null, message?: string | null, sale?: { __typename?: 'SellerCorrectionSale', stockSaleId?: string | null, saleReference?: string | null, accountNumber?: string | null, serialNumber?: string | null, contractNumber?: string | null, customerName?: string | null, productName?: string | null, saleDate?: string | null, status?: SaleStatus | null, distributorPinned?: boolean | null, sellerPaidAmountCents?: number | null, sellerPaidEntryCount?: number | null, sellerUnpaidAmountCents?: number | null, sellerUnpaidEntryCount?: number | null, seller?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null, distributor?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null } | null, from?: { __typename?: 'AgentNameMatch', status?: AgentNameMatchStatus | null, agent?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null, candidates?: Array<{ __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null }> | null } | null, to?: { __typename?: 'AgentNameMatch', status?: AgentNameMatchStatus | null, agent?: { __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null } | null, candidates?: Array<{ __typename?: 'SellerCorrectionAgent', id?: string | null, name?: string | null, salesId?: string | null, agentType?: AgentType | null, status?: AgentStatus | null }> | null } | null }> | null } | null };

export type SellerCorrectionsQueryVariables = Exact<{
  input?: InputMaybe<SellerCorrectionListInput>;
}>;


export type SellerCorrectionsQuery = { __typename?: 'Query', sellerCorrections?: { __typename?: 'SellerCorrectionListResult', totalCount: number, items: Array<{ __typename?: 'SellerCorrection', id?: string | null, createdAt?: string | null, stockSaleId?: string | null, saleReference?: string | null, accountNumber?: string | null, serialNumber?: string | null, customerName?: string | null, fromAgentId?: string | null, fromAgentName?: string | null, toAgentId?: string | null, toAgentName?: string | null, fromDistributorName?: string | null, toDistributorName?: string | null, movedEntryCount?: number | null, paidEntryCount?: number | null, paidAmountCents?: number | null, cancelledEntryCount?: number | null, cancelledAmountCents?: number | null, reason?: string | null, source?: SellerCorrectionSource | null, correctedByName?: string | null }> } | null };

export type PaidToPreviousSellerQueryVariables = Exact<{
  input?: InputMaybe<SellerCorrectionListInput>;
}>;


export type PaidToPreviousSellerQuery = { __typename?: 'Query', paidToPreviousSeller?: { __typename?: 'SellerCorrectionListResult', totalCount: number, items: Array<{ __typename?: 'SellerCorrection', id?: string | null, createdAt?: string | null, stockSaleId?: string | null, saleReference?: string | null, accountNumber?: string | null, serialNumber?: string | null, customerName?: string | null, fromAgentId?: string | null, fromAgentName?: string | null, toAgentId?: string | null, toAgentName?: string | null, fromDistributorName?: string | null, toDistributorName?: string | null, movedEntryCount?: number | null, paidEntryCount?: number | null, paidAmountCents?: number | null, cancelledEntryCount?: number | null, cancelledAmountCents?: number | null, reason?: string | null, source?: SellerCorrectionSource | null, correctedByName?: string | null }> } | null };

export type ApplySellerCorrectionsMutationVariables = Exact<{
  input: ApplySellerCorrectionsInput;
}>;


export type ApplySellerCorrectionsMutation = { __typename?: 'Mutation', applySellerCorrections?: { __typename?: 'ApplySellerCorrectionsResult', appliedCount?: number | null, skippedCount?: number | null, rows?: Array<{ __typename?: 'SellerCorrectionRowResult', stockSaleId?: string | null, saleReference?: string | null, outcome?: SellerCorrectionOutcome | null, skipReason?: SellerCorrectionSkipReason | null, message?: string | null, correctionId?: string | null, movedEntryCount?: number | null, paidEntryCount?: number | null, paidAmountCents?: number | null, cancelledEntryCount?: number | null, cancelledAmountCents?: number | null }> | null } | null };

export type GetOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id?: string | null, name?: string | null, logoUrl?: string | null, logoBackground?: string | null, currency?: string | null, requireConfirmPassword?: boolean | null, requireAgentInviteApproval: boolean, googleAnalyticsId?: string | null, legalName?: string | null, registrationNumber?: string | null, legalAddress?: string | null, contactPhone?: string | null, contactEmail?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'Organization', id?: string | null, name?: string | null, logoBackground?: string | null, currency?: string | null, requireConfirmPassword?: boolean | null, requireAgentInviteApproval: boolean, googleAnalyticsId?: string | null, legalName?: string | null, registrationNumber?: string | null, legalAddress?: string | null, contactPhone?: string | null, contactEmail?: string | null, updatedAt?: string | null } | null };

export type GetAuditLogsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', auditLogs?: { __typename?: 'AuditLogListResult', totalCount: number, items: Array<{ __typename?: 'AuditLog', id?: string | null, action?: string | null, category?: string | null, status?: string | null, description?: string | null, entityType?: string | null, entityId?: string | null, changes?: Record<string, unknown> | null, metadata?: Record<string, unknown> | null, errorMessage?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt?: string | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type ShipmentFieldsFragment = { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null };

export type RefreshShipmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RefreshShipmentMutation = { __typename?: 'Mutation', refreshShipment?: { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null, purchaseOrder?: { __typename?: 'PurchaseOrder', id?: string | null, status?: PurchaseOrderStatus | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, status?: TransferStatus | null, dispatchedAt?: string | null, dispatchedByCourier?: boolean | null } | null } | null };

export type GetCourierImportsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCourierImportsQuery = { __typename?: 'Query', courierImports?: Array<{ __typename?: 'CourierImport', id?: string | null, createdAt?: string | null, kind?: CourierImportKind | null, fileName?: string | null, rowsRead?: number | null, rowsImported?: number | null, invoiceNumber?: string | null, notFoundWaybills?: Array<string> | null, importedBy?: string | null }> | null };

export type GetShippingCompaniesQueryVariables = Exact<{
  input?: InputMaybe<ShippingCompanyListInput>;
}>;


export type GetShippingCompaniesQuery = { __typename?: 'Query', shippingCompanies?: { __typename?: 'ShippingCompanyListResult', totalCount: number, items: Array<{ __typename?: 'ShippingCompany', id?: string | null, name?: string | null, contactPerson?: string | null, email?: string | null, phone?: string | null, trackingUrlTemplate?: string | null, courier?: Courier | null, isActive?: boolean | null, createdAt?: string | null }> } | null };

export type GetShippingCompanyQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetShippingCompanyQuery = { __typename?: 'Query', shippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null, contactPerson?: string | null, email?: string | null, phone?: string | null, trackingUrlTemplate?: string | null, courier?: Courier | null, isActive?: boolean | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type CreateShippingCompanyMutationVariables = Exact<{
  input: CreateShippingCompanyInput;
}>;


export type CreateShippingCompanyMutation = { __typename?: 'Mutation', createShippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null } | null };

export type UpdateShippingCompanyMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateShippingCompanyInput;
}>;


export type UpdateShippingCompanyMutation = { __typename?: 'Mutation', updateShippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null, isActive?: boolean | null } | null };

export type SmsCampaignFieldsFragment = { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } };

export type GetSmsCampaignsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSmsCampaignsQuery = { __typename?: 'Query', smsCampaigns: { __typename?: 'SmsCampaignListResult', totalCount: number, items: Array<{ __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } }> } };

export type GetSmsCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSmsCampaignQuery = { __typename?: 'Query', smsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, batches: Array<{ __typename?: 'SmsCampaignBatch', number: number, recipients: number, creditBalance: number, sent: number, failed: number, skipped: number, pending: number, credits: number, approvedByName?: string | null, createdAt: string, completedAt?: string | null }>, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type GetSmsCampaignRecipientsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  status?: InputMaybe<SmsCampaignRecipientStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSmsCampaignRecipientsQuery = { __typename?: 'Query', smsCampaignRecipients: { __typename?: 'SmsCampaignRecipientListResult', totalCount: number, items: Array<{ __typename?: 'SmsCampaignRecipient', id: string, source: SmsCampaignRecipientSource, customerId?: string | null, contractNumber?: string | null, name?: string | null, phone?: string | null, message: string, parts: number, status: SmsCampaignRecipientStatus, skipReason?: string | null, attempts: number, error?: string | null, sentAt?: string | null, deliveryState?: string | null, deliveryStateAt?: string | null }> } };

export type GetSmsCampaignRecipientsCsvQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type GetSmsCampaignRecipientsCsvQuery = { __typename?: 'Query', smsCampaignRecipientsCsv: string };

export type GetSmsCampaignPreviewQueryVariables = Exact<{
  body: Scalars['String']['input'];
  audience: SmsCampaignAudienceInput;
}>;


export type GetSmsCampaignPreviewQuery = { __typename?: 'Query', smsCampaignPreview: { __typename?: 'SmsCampaignPreview', recipients: number, duplicates: number, creditsNeeded: number, maxParts: number, samples: Array<string>, creditBalance?: number | null, skipped: Array<{ __typename?: 'SmsCampaignSkipCount', reason: SmsCampaignSkipReason, count: number }> } };

export type GetSmsCampaignMessageSizeQueryVariables = Exact<{
  body: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSmsCampaignMessageSizeQuery = { __typename?: 'Query', smsCampaignMessageSize: { __typename?: 'SmsMessageSize', text: string, encoding: SmsEncoding, characters: number, parts: number } };

export type GetSmsOptOutsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSmsOptOutsQuery = { __typename?: 'Query', smsOptOuts: { __typename?: 'SmsOptOutListResult', totalCount: number, items: Array<{ __typename?: 'SmsOptOut', id: string, phone: string, source: string, customerId?: string | null, createdAt: string }> } };

export type SearchSmsCampaignContractsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchSmsCampaignContractsQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractListResult', items: Array<{ __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null, phone?: string | null } | null }> } | null };

export type CreateSmsCampaignMutationVariables = Exact<{
  input: SmsCampaignDraftInput;
}>;


export type CreateSmsCampaignMutation = { __typename?: 'Mutation', createSmsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type UpdateSmsCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SmsCampaignDraftInput;
}>;


export type UpdateSmsCampaignMutation = { __typename?: 'Mutation', updateSmsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type DeleteSmsCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSmsCampaignMutation = { __typename?: 'Mutation', deleteSmsCampaign: boolean };

export type CopySmsCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CopySmsCampaignMutation = { __typename?: 'Mutation', copySmsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type SendSmsCampaignTestMutationVariables = Exact<{
  body: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type SendSmsCampaignTestMutation = { __typename?: 'Mutation', sendSmsCampaignTest: boolean };

export type SendSmsCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SendSmsCampaignInput;
}>;


export type SendSmsCampaignMutation = { __typename?: 'Mutation', sendSmsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type StopSmsCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StopSmsCampaignMutation = { __typename?: 'Mutation', stopSmsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type ApproveNextSmsCampaignBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveNextSmsCampaignBatchMutation = { __typename?: 'Mutation', approveNextSmsCampaignBatch: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type ResumeSmsCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResumeSmsCampaignMutation = { __typename?: 'Mutation', resumeSmsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type CancelSmsCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelSmsCampaignMutation = { __typename?: 'Mutation', cancelSmsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type ResendFailedSmsCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendFailedSmsCampaignMutation = { __typename?: 'Mutation', resendFailedSmsCampaign: { __typename?: 'SmsCampaign', id: string, name: string, body: string, audience: Record<string, unknown>, status: SmsCampaignStatus, scheduledAt?: string | null, startedAt?: string | null, completedAt?: string | null, lastError?: string | null, createdAt: string, createdByName?: string | null, sentByName?: string | null, copiedFromId?: string | null, counts: { __typename?: 'SmsCampaignCounts', total: number, pending: number, sent: number, delivered: number, failed: number, skipped: number } } };

export type AddSmsOptOutMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type AddSmsOptOutMutation = { __typename?: 'Mutation', addSmsOptOut: { __typename?: 'SmsOptOut', id: string } };

export type RemoveSmsOptOutMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type RemoveSmsOptOutMutation = { __typename?: 'Mutation', removeSmsOptOut: { __typename?: 'SmsOptOut', id: string } };

export type GetSmsLogsQueryVariables = Exact<{
  input?: InputMaybe<SmsLogListInput>;
}>;


export type GetSmsLogsQuery = { __typename?: 'Query', smsLogs: { __typename?: 'SmsLogListResult', totalCount: number, platforms: Array<string>, items: Array<{ __typename?: 'SmsLog', id: string, customerNumber?: string | null, cellNumber?: string | null, message?: string | null, type?: SmsType | null, source?: string | null, platform: string, accepted: boolean, gatewayResult?: string | null, providerMessageId?: string | null, loadedAt?: string | null, sentAt?: string | null, deliveryState?: string | null, deliveryStateAt?: string | null, reply?: string | null, repliedAt?: string | null, customer: { __typename?: 'Customer', id?: string | null, fullName?: string | null, customerNumber?: string | null } }> } };

export type GetSmsCallbacksQueryVariables = Exact<{
  input?: InputMaybe<SmsCallbackListInput>;
}>;


export type GetSmsCallbacksQuery = { __typename?: 'Query', smsCallbacks: { __typename?: 'SmsCallbackListResult', totalCount: number, states: Array<string>, items: Array<{ __typename?: 'SmsCallback', id: string, createdAt: string, kind: SmsCallbackKind, providerMessageId?: string | null, phone?: string | null, state?: string | null, statusCode?: number | null, text?: string | null, sentMessageText?: string | null, messageAt?: string | null, statusAt?: string | null, platform: string, payload: Record<string, unknown>, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null, customerNumber?: string | null } | null, smsLog?: { __typename?: 'SmsLog', id: string } | null }> } };

export type StockBalanceRowFieldsFragment = { __typename?: 'StockBalanceRow', inTransit: number, damagedQuantity: number, total: number, valueCents?: number | null, unitCostCents?: number | null, belowMinimumCount: number, onOrder: number, lastIssuedAt?: string | null, product: { __typename?: 'StockBalanceProduct', id: string, sku: string, name: string, kind: ProductKind, isActive: boolean, requiresSerialTracking: boolean, unitOfMeasureName?: string | null, businessLineName?: string | null, itemCategoryName?: string | null }, places: Array<{ __typename?: 'StockBalancePlace', stockingPointId: string, quantity: number, minimum?: number | null, belowMinimum: boolean }> };

export type StockCardMovementFieldsFragment = { __typename?: 'StockCardMovement', id: string, at: string, reason: StockMovementReason, document?: string | null, storeName: string, productId: string, productName: string, productSku: string, quantityIn: number, quantityOut: number, balance?: number | null, note?: string | null, recordedByName?: string | null };

export type GetStockBalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStockBalancesQuery = { __typename?: 'Query', stockBalances: { __typename?: 'StockBalances', asAt: string, showsValue: boolean, valueCents: number, unpricedProductCount: number, stockingPoints: Array<{ __typename?: 'StockBalancePoint', id: string, name: string, type: StockingPointType }>, rows: Array<{ __typename?: 'StockBalanceRow', inTransit: number, damagedQuantity: number, total: number, valueCents?: number | null, unitCostCents?: number | null, belowMinimumCount: number, onOrder: number, lastIssuedAt?: string | null, product: { __typename?: 'StockBalanceProduct', id: string, sku: string, name: string, kind: ProductKind, isActive: boolean, requiresSerialTracking: boolean, unitOfMeasureName?: string | null, businessLineName?: string | null, itemCategoryName?: string | null }, places: Array<{ __typename?: 'StockBalancePlace', stockingPointId: string, quantity: number, minimum?: number | null, belowMinimum: boolean }> }> } };

export type GetStockCardQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetStockCardQuery = { __typename?: 'Query', stockCard: { __typename?: 'StockCard', tracksMovements: boolean, from: string, openingBalance: number, closingBalance: number, lastReceivedAt?: string | null, showsValue: boolean, stockingPoints: Array<{ __typename?: 'StockBalancePoint', id: string, name: string, type: StockingPointType }>, row?: { __typename?: 'StockBalanceRow', inTransit: number, damagedQuantity: number, total: number, valueCents?: number | null, unitCostCents?: number | null, belowMinimumCount: number, onOrder: number, lastIssuedAt?: string | null, product: { __typename?: 'StockBalanceProduct', id: string, sku: string, name: string, kind: ProductKind, isActive: boolean, requiresSerialTracking: boolean, unitOfMeasureName?: string | null, businessLineName?: string | null, itemCategoryName?: string | null }, places: Array<{ __typename?: 'StockBalancePlace', stockingPointId: string, quantity: number, minimum?: number | null, belowMinimum: boolean }> } | null, movements: Array<{ __typename?: 'StockCardMovement', id: string, at: string, reason: StockMovementReason, document?: string | null, storeName: string, productId: string, productName: string, productSku: string, quantityIn: number, quantityOut: number, balance?: number | null, note?: string | null, recordedByName?: string | null }>, openOrders: Array<{ __typename?: 'OpenOrderLine', purchaseOrderId: string, purchaseOrderNumber: string, purchaseOrderLineId: string, supplierName: string, destinationId: string, destinationName: string, remaining: number, expectedAt?: string | null }> } };

export type GetStockActivityQueryVariables = Exact<{
  months?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStockActivityQuery = { __typename?: 'Query', stockActivity: { __typename?: 'StockActivity', months: Array<{ __typename?: 'StockActivityMonth', month: string, received: number, issued: number }>, recent: Array<{ __typename?: 'StockCardMovement', id: string, at: string, reason: StockMovementReason, document?: string | null, storeName: string, productId: string, productName: string, productSku: string, quantityIn: number, quantityOut: number, balance?: number | null, note?: string | null, recordedByName?: string | null }> } };

export type GetStockImportBatchesQueryVariables = Exact<{
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStockImportBatchesQuery = { __typename?: 'Query', stockImportBatches?: Array<{ __typename?: 'StockImportBatch', id?: string | null, createdAt?: string | null, productName?: string | null, deviceTypeName?: string | null, stockTypeName?: string | null, importedCount?: number | null, importedByName?: string | null, reversedAt?: string | null, reversedByName?: string | null, reversible?: boolean | null, waybillReference?: string | null, awaitingReceipt?: boolean | null, receivedAt?: string | null, receivedByName?: string | null, shippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null } | null, shipment?: { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null } | null }> | null };

export type ReverseStockImportMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
}>;


export type ReverseStockImportMutation = { __typename?: 'Mutation', reverseStockImport?: { __typename?: 'StockImportReversalResult', reversed?: number | null, blocked?: Array<{ __typename?: 'ReversalBlockedItem', identifier?: string | null, reason?: string | null }> | null } | null };

export type ReceiveStockImportMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
  courierOverrideReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReceiveStockImportMutation = { __typename?: 'Mutation', receiveStockImport?: number | null };

export type GetStockItemsQueryVariables = Exact<{
  input?: InputMaybe<StockItemListInput>;
}>;


export type GetStockItemsQuery = { __typename?: 'Query', stockItems?: { __typename?: 'StockItemListResult', totalCount: number, items: Array<{ __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, productSku?: string | null, kind?: StockKind | null, condition?: StockItemCondition | null, status?: StockItemStatus | null, updatedAt?: string | null, stockType?: { __typename?: 'StockType', id?: string | null, name?: string | null } | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, type?: StockingPointType | null } | null }> } | null };

export type ArchiveStockItemsMutationVariables = Exact<{
  input: ArchiveStockItemsInput;
}>;


export type ArchiveStockItemsMutation = { __typename?: 'Mutation', archiveStockItems?: { __typename?: 'StockItemBulkActionResult', successCount?: number | null, failureCount?: number | null, results?: Array<{ __typename?: 'StockItemActionResult', stockItemId?: string | null, serialNumber?: string | null, accountNumber?: string | null, success?: boolean | null, error?: string | null }> | null } | null };

export type RestoreStockItemsMutationVariables = Exact<{
  input: RestoreStockItemsInput;
}>;


export type RestoreStockItemsMutation = { __typename?: 'Mutation', restoreStockItems?: { __typename?: 'StockItemBulkActionResult', successCount?: number | null, failureCount?: number | null, results?: Array<{ __typename?: 'StockItemActionResult', stockItemId?: string | null, serialNumber?: string | null, accountNumber?: string | null, success?: boolean | null, error?: string | null }> | null } | null };

export type GetCountedStockQueryVariables = Exact<{
  kind: ProductKind;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCountedStockQuery = { __typename?: 'Query', countedStock: Array<{ __typename?: 'StockLevel', id: string, quantity: number, reservedQuantity: number, condition: StockCondition, product: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null }, stockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } }> };

export type ValidateSerialForSaleQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
  override?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ValidateSerialForSaleQuery = { __typename?: 'Query', validateSerialForSale?: { __typename?: 'SerialValidationResult', valid?: boolean | null, stockItemId?: string | null, serialNumber?: string | null, productName?: string | null, accountNumber?: string | null, hasMeter: boolean, requiresOverride?: boolean | null, currentLocationName?: string | null, error?: string | null } | null };

export type GetStockSalesQueryVariables = Exact<{
  input?: InputMaybe<StockSaleListInput>;
}>;


export type GetStockSalesQuery = { __typename?: 'Query', stockSales?: { __typename?: 'StockSaleListResult', totalCount: number, items: Array<{ __typename?: 'StockSale', id?: string | null, saleReference?: string | null, status?: SaleStatus | null, saleDate?: string | null, notes?: string | null, createdAt?: string | null, flaggedBadAt?: string | null, stockItem?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, isMigrated?: boolean | null } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type GetStockSaleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStockSaleQuery = { __typename?: 'Query', stockSale?: { __typename?: 'StockSale', id?: string | null, saleReference?: string | null, status?: SaleStatus | null, saleDate?: string | null, notes?: string | null, createdAt?: string | null, updatedAt?: string | null, flaggedBadAt?: string | null, flaggedBadReason?: string | null, flaggedBadBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, stockItem?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null, isMigrated?: boolean | null } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, recordedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, onBehalfOfAgent?: { __typename?: 'Agent', id?: string | null } | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null, deviceReassignments?: Array<{ __typename?: 'DeviceReassignment', id?: string | null, createdAt?: string | null, previousSerialNumber?: string | null, previousAccountNumber?: string | null, newSerialNumber?: string | null, newAccountNumber?: string | null, cause?: DeviceReassignmentCause | null, notes?: string | null, tokenDaysShortfall?: number | null, creditRecoveryTotal?: number | null, creditRecoveryPerPayment?: number | null, creditRecoveryRemaining?: number | null, customerNotifiedAt?: string | null, swapGroupId?: string | null, performedBy?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email?: string | null } | null }> | null } | null };

export type GetAgentStockQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAgentStockQuery = { __typename?: 'Query', agentStock?: Array<{ __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null, createdAt?: string | null, stockType?: { __typename?: 'StockType', id?: string | null, name?: string | null, isReplacement?: boolean | null } | null }> | null };

export type GetReplacementStockOptionsQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  onBehalfOfAgentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetReplacementStockOptionsQuery = { __typename?: 'Query', replacementStockOptions?: Array<{ __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, product?: { __typename?: 'Product', id?: string | null, canAcceptToken?: boolean | null } | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null }> | null };

export type GetStockOnHandQueryVariables = Exact<{
  input?: InputMaybe<StockOnHandInput>;
}>;


export type GetStockOnHandQuery = { __typename?: 'Query', stockOnHand?: { __typename?: 'StockItemListResult', totalCount: number, items: Array<{ __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null, stockType?: { __typename?: 'StockType', id?: string | null, name?: string | null, isReplacement?: boolean | null } | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null }> } | null };

export type ExportStockOnHandQueryVariables = Exact<{
  input?: InputMaybe<StockOnHandInput>;
}>;


export type ExportStockOnHandQuery = { __typename?: 'Query', exportStockOnHand?: { __typename?: 'StockItemListResult', totalCount: number, items: Array<{ __typename?: 'StockItem', serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null, stockType?: { __typename?: 'StockType', name?: string | null } | null, stockingPoint?: { __typename?: 'StockingPoint', name?: string | null, province?: string | null } | null }> } | null };

export type GetStockReportQueryVariables = Exact<{
  input?: InputMaybe<StockReportInput>;
}>;


export type GetStockReportQuery = { __typename?: 'Query', stockReport?: { __typename?: 'StockReportResult', totalSales?: number | null, salesByAgent?: Array<{ __typename?: 'SalesByAgent', agentId?: string | null, agentName?: string | null, agentSalesId?: string | null, salesCount?: number | null }> | null } | null };

export type GetDistributorReconciliationQueryVariables = Exact<{
  distributorId: Scalars['String']['input'];
}>;


export type GetDistributorReconciliationQuery = { __typename?: 'Query', distributorReconciliation?: { __typename?: 'DistributorReconciliation', distributorId?: string | null, distributorName?: string | null, childAgentCount?: number | null, stockingPointCount?: number | null, totalHeld?: number | null, availableStock?: number | null, reservedStock?: number | null, soldStock?: number | null, damagedStock?: number | null, inTransitStock?: number | null, otherStock?: number | null, salesRecorded?: number | null, salesFromOwnStock?: number | null, salesFromOtherStock?: number | null, closedSales?: number | null, accessoriesHeld?: number | null, accessoriesIssued?: number | null } | null };

export type GetSerialNumberHistoryQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type GetSerialNumberHistoryQuery = { __typename?: 'Query', serialNumberHistory?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null, condition?: StockItemCondition | null, createdAt?: string | null, updatedAt?: string | null, meterHostedOn: MeterHost, hasMeter: boolean, meterHasSecretKey: boolean, meterTokenCount?: number | null, meterStartingCode?: string | null, meterTypeName?: string | null, product?: { __typename?: 'Product', id?: string | null, canAcceptToken?: boolean | null } | null, stockType?: { __typename?: 'StockType', id?: string | null, name?: string | null, isReplacement?: boolean | null } | null, deviceType?: { __typename?: 'DeviceType', id?: string | null, name?: string | null } | null, workshopJobs?: Array<{ __typename?: 'WorkshopJob', id: string, openedAt: string, stage: WorkshopJobStage, intakeReason: WorkshopJobIntakeReason, faultDescription?: string | null, completedAt?: string | null, closedAt?: string | null, scrapReason?: string | null, stockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, faultType?: { __typename?: 'FaultType', id: string, name: string } | null, openedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null, purchaseOrder?: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, closedAt?: string | null, createdAt?: string | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, shipment?: { __typename?: 'Shipment', id?: string | null, state?: ShipmentState | null, statusLabel?: string | null, closedAt?: string | null } | null } | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null, onTheWay?: { __typename?: 'DeviceOnTheWay', kind: DeviceOnTheWayKind, recordId: string, reference?: string | null, from?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, to: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, shipment?: { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null } | null } | null, archiveEvents?: Array<{ __typename?: 'StockItemArchiveEvent', id?: string | null, createdAt?: string | null, action?: StockItemArchiveAction | null, reason?: StockItemArchiveReason | null, note?: string | null, fromStatus?: StockItemStatus | null, toStatus?: StockItemStatus | null, performedByName?: string | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null }> | null, reassignedFrom?: Array<{ __typename?: 'DeviceReassignment', id?: string | null, createdAt?: string | null, cause?: DeviceReassignmentCause | null, notes?: string | null, newSerialNumber?: string | null, newAccountNumber?: string | null, swapGroupId?: string | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null }> | null, reassignedTo?: Array<{ __typename?: 'DeviceReassignment', id?: string | null, createdAt?: string | null, cause?: DeviceReassignmentCause | null, notes?: string | null, previousSerialNumber?: string | null, previousAccountNumber?: string | null, swapGroupId?: string | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null }> | null, releases?: Array<{ __typename?: 'DeviceRelease', id?: string | null, releasedAt?: string | null, reason?: ContractStatus | null, contractId?: string | null, contractNumber?: string | null, location?: string | null, relocated?: boolean | null, transferNumber?: string | null, backfilled?: boolean | null, ratePlanChange?: boolean | null, replacedBySerialNumber?: string | null, applicationId?: string | null, releasedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null, releaseEligibility?: { __typename?: 'DeviceReleaseEligibility', eligible?: boolean | null, blocker?: DeviceReleaseBlocker | null, hold?: DeviceReleaseHold | null, explanation?: string | null, contractId?: string | null, contractNumber?: string | null, contractStatus?: ContractStatus | null, resultingCondition?: StockItemCondition | null, closesLiveSale?: boolean | null, location?: string | null, applicationId?: string | null, applicationSiblings?: Array<string> | null, reasonRequired: boolean, requiredPermission?: string | null, viewerMayRelease?: boolean | null } | null, transferItems?: Array<{ __typename?: 'StockTransferItem', id?: string | null, transfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null, notes?: string | null, createdAt?: string | null, dispatchedAt?: string | null, completedAt?: string | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, dispatchedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, completedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, cancelledBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, destinationStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, shipment?: { __typename?: 'Shipment', id?: string | null, state?: ShipmentState | null, statusLabel?: string | null, closedAt?: string | null } | null } | null }> | null, sale?: { __typename?: 'StockSale', id?: string | null, saleReference?: string | null, status?: SaleStatus | null, saleDate?: string | null, notes?: string | null, defectiveCondition?: DeviceCondition | null, stockItem?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, recordedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, onBehalfOfAgent?: { __typename?: 'Agent', id?: string | null } | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null } | null, sales?: Array<{ __typename?: 'StockSale', id?: string | null, saleReference?: string | null, status?: SaleStatus | null, saleDate?: string | null, notes?: string | null, defectiveCondition?: DeviceCondition | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null } | null, recordedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, customer?: { __typename?: 'Customer', id?: string | null, firstName?: string | null, lastName?: string | null } | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null } | null }> | null } | null };

export type RecordStockSaleMutationVariables = Exact<{
  input: RecordStockSaleInput;
}>;


export type RecordStockSaleMutation = { __typename?: 'Mutation', recordStockSale?: { __typename?: 'StockSale', id?: string | null, saleReference?: string | null, status?: SaleStatus | null, saleDate?: string | null } | null };

export type AssignDeviceToContractMutationVariables = Exact<{
  input: AssignDeviceToContractInput;
}>;


export type AssignDeviceToContractMutation = { __typename?: 'Mutation', assignDeviceToContract?: { __typename?: 'StockSale', id?: string | null, saleReference?: string | null, status?: SaleStatus | null, saleDate?: string | null, stockItem?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null } | null } | null };

export type ProcessWarrantyReplacementMutationVariables = Exact<{
  input: WarrantyReplacementInput;
}>;


export type ProcessWarrantyReplacementMutation = { __typename?: 'Mutation', processWarrantyReplacement?: { __typename?: 'StockSale', id?: string | null, saleReference?: string | null, status?: SaleStatus | null, saleDate?: string | null, notes?: string | null } | null };

export type SetupDeviceMeterMutationVariables = Exact<{
  input: SetupDeviceMeterInput;
}>;


export type SetupDeviceMeterMutation = { __typename?: 'Mutation', setupDeviceMeter?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, hasMeter: boolean, meterTypeName?: string | null, meterTypeId?: number | null, meterStartingCode?: string | null, meterHasSecretKey: boolean } | null };

export type UpdateDeviceMutationVariables = Exact<{
  input: UpdateDeviceInput;
}>;


export type UpdateDeviceMutation = { __typename?: 'Mutation', updateDevice?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null } | null };

export type UpdateDeviceMeterMutationVariables = Exact<{
  input: UpdateDeviceMeterInput;
}>;


export type UpdateDeviceMeterMutation = { __typename?: 'Mutation', updateDeviceMeter?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, hasMeter: boolean, meterTypeName?: string | null, meterTypeId?: number | null, meterStartingCode?: string | null, meterHasSecretKey: boolean } | null };

export type FlagStockSaleAsBadMutationVariables = Exact<{
  input: FlagStockSaleAsBadInput;
}>;


export type FlagStockSaleAsBadMutation = { __typename?: 'Mutation', flagStockSaleAsBad?: { __typename?: 'StockSale', id?: string | null, flaggedBadAt?: string | null, flaggedBadReason?: string | null, flaggedBadBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null };

export type UnflagStockSaleMutationVariables = Exact<{
  input: UnflagStockSaleInput;
}>;


export type UnflagStockSaleMutation = { __typename?: 'Mutation', unflagStockSale?: { __typename?: 'StockSale', id?: string | null, flaggedBadAt?: string | null, flaggedBadReason?: string | null, flaggedBadBy?: { __typename?: 'User', id?: string | null } | null } | null };

export type ReleaseDeviceMutationVariables = Exact<{
  input: ReleaseDeviceInput;
}>;


export type ReleaseDeviceMutation = { __typename?: 'Mutation', releaseDevice?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, status?: StockItemStatus | null, condition?: StockItemCondition | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, releaseEligibility?: { __typename?: 'DeviceReleaseEligibility', eligible?: boolean | null, blocker?: DeviceReleaseBlocker | null, hold?: DeviceReleaseHold | null, explanation?: string | null, viewerMayRelease?: boolean | null } | null } | null };

export type GetStockSaleProductNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStockSaleProductNamesQuery = { __typename?: 'Query', stockSaleProductNames?: Array<string> | null };

export type ExportStockSalesQueryVariables = Exact<{
  input?: InputMaybe<StockSaleListInput>;
}>;


export type ExportStockSalesQuery = { __typename?: 'Query', exportStockSales?: { __typename?: 'StockSaleListResult', totalCount: number, items: Array<{ __typename?: 'StockSale', saleReference?: string | null, status?: SaleStatus | null, saleDate?: string | null, notes?: string | null, createdAt?: string | null, distributorName?: string | null, nationalSalesManagerName?: string | null, stockItem?: { __typename?: 'StockItem', serialNumber?: string | null, accountNumber?: string | null, productName?: string | null } | null, agent?: { __typename?: 'Agent', firstName?: string | null, lastName?: string | null, salesId?: string | null } | null, customer?: { __typename?: 'Customer', firstName?: string | null, lastName?: string | null } | null }> } | null };

export type StockTakeHeaderFragment = { __typename?: 'StockTake', id: string, takeNumber: string, status: StockTakeStatus, wholePoint: boolean, countsUnits: boolean, note?: string | null, statusReason?: string | null, createdAt: string, submittedAt?: string | null, approvedAt?: string | null, cancelledAt?: string | null, stockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, openedBy: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null }, submittedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, approvedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, cancelledBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, summary: { __typename?: 'StockTakeSummary', lineCount: number, countedLineCount: number, shortQuantity: number, overQuantity: number, varianceValueCents: number, unpricedLineCount: number, foundUnits: number, missingUnits: number, unexpectedUnits: number, missingValueCents: number } };

export type GetStockTakesQueryVariables = Exact<{
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StockTakeStatus>;
}>;


export type GetStockTakesQuery = { __typename?: 'Query', stockTakes: Array<{ __typename?: 'StockTake', id: string, takeNumber: string, status: StockTakeStatus, wholePoint: boolean, countsUnits: boolean, note?: string | null, statusReason?: string | null, createdAt: string, submittedAt?: string | null, approvedAt?: string | null, cancelledAt?: string | null, stockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, openedBy: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null }, submittedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, approvedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, cancelledBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, summary: { __typename?: 'StockTakeSummary', lineCount: number, countedLineCount: number, shortQuantity: number, overQuantity: number, varianceValueCents: number, unpricedLineCount: number, foundUnits: number, missingUnits: number, unexpectedUnits: number, missingValueCents: number } }> };

export type GetStockTakeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStockTakeQuery = { __typename?: 'Query', stockTake?: { __typename?: 'StockTake', id: string, takeNumber: string, status: StockTakeStatus, wholePoint: boolean, countsUnits: boolean, note?: string | null, statusReason?: string | null, createdAt: string, submittedAt?: string | null, approvedAt?: string | null, cancelledAt?: string | null, lines: Array<{ __typename?: 'StockTakeLine', id: string, condition: StockCondition, expectedQuantity?: number | null, countedQuantity?: number | null, variance?: number | null, unitCostCents?: number | null, countedAt?: string | null, countedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, product: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null, lastCostCents?: number | null, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id?: string | null, name?: string | null } | null } }>, units: Array<{ __typename?: 'StockTakeUnit', id: string, serial: string, outcome: StockTakeUnitOutcome, scannedAt?: string | null, scannedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, stockItem?: { __typename?: 'StockItem', id?: string | null, productName?: string | null, status?: StockItemStatus | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } | null }>, stockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, openedBy: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null }, submittedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, approvedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, cancelledBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, summary: { __typename?: 'StockTakeSummary', lineCount: number, countedLineCount: number, shortQuantity: number, overQuantity: number, varianceValueCents: number, unpricedLineCount: number, foundUnits: number, missingUnits: number, unexpectedUnits: number, missingValueCents: number } } | null };

export type OpenStockTakeMutationVariables = Exact<{
  input: OpenStockTakeInput;
}>;


export type OpenStockTakeMutation = { __typename?: 'Mutation', openStockTake?: { __typename?: 'StockTake', id: string, takeNumber: string } | null };

export type CountStockTakeLineMutationVariables = Exact<{
  lineId: Scalars['String']['input'];
  countedQuantity: Scalars['Int']['input'];
}>;


export type CountStockTakeLineMutation = { __typename?: 'Mutation', countStockTakeLine?: { __typename?: 'StockTakeLine', id: string, expectedQuantity?: number | null, countedQuantity?: number | null, variance?: number | null, countedAt?: string | null } | null };

export type AddStockTakeLineMutationVariables = Exact<{
  stockTakeId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  condition?: InputMaybe<StockCondition>;
}>;


export type AddStockTakeLineMutation = { __typename?: 'Mutation', addStockTakeLine?: { __typename?: 'StockTakeLine', id: string } | null };

export type ScanStockTakeUnitMutationVariables = Exact<{
  stockTakeId: Scalars['String']['input'];
  serial: Scalars['String']['input'];
}>;


export type ScanStockTakeUnitMutation = { __typename?: 'Mutation', scanStockTakeUnit?: { __typename?: 'StockTakeUnit', id: string, serial: string, outcome: StockTakeUnitOutcome } | null };

export type RemoveStockTakeScanMutationVariables = Exact<{
  stockTakeUnitId: Scalars['String']['input'];
}>;


export type RemoveStockTakeScanMutation = { __typename?: 'Mutation', removeStockTakeScan?: boolean | null };

export type SubmitStockTakeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SubmitStockTakeMutation = { __typename?: 'Mutation', submitStockTake?: { __typename?: 'StockTake', id: string, status: StockTakeStatus } | null };

export type SendBackStockTakeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type SendBackStockTakeMutation = { __typename?: 'Mutation', sendBackStockTake?: { __typename?: 'StockTake', id: string, status: StockTakeStatus } | null };

export type ApproveStockTakeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ApproveStockTakeMutation = { __typename?: 'Mutation', approveStockTake?: { __typename?: 'StockTake', id: string, status: StockTakeStatus } | null };

export type CancelStockTakeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type CancelStockTakeMutation = { __typename?: 'Mutation', cancelStockTake?: { __typename?: 'StockTake', id: string, status: StockTakeStatus } | null };

export type GetAgentTransferDestinationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentTransferDestinationsQuery = { __typename?: 'Query', agentTransferDestinations?: Array<{ __typename?: 'AgentTransferDestination', stockingPointId: string, stockingPointName: string, label: string }> | null };

export type GetTransferDestinationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransferDestinationsQuery = { __typename?: 'Query', transferDestinations?: Array<{ __typename?: 'TransferDestination', id: string, stockingPointId: string, name: string, type: StockingPointType }> | null };

export type GetTransferSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransferSourcesQuery = { __typename?: 'Query', transferSources?: Array<{ __typename?: 'TransferSource', id: string, stockingPointId: string, name: string, type: StockingPointType }> | null };

export type GetStockTransfersQueryVariables = Exact<{
  input?: InputMaybe<StockTransferListInput>;
}>;


export type GetStockTransfersQuery = { __typename?: 'Query', stockTransfers?: { __typename?: 'StockTransferListResult', totalCount: number, items: Array<{ __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null, waybillReference?: string | null, completedAt?: string | null, cancelledAt?: string | null, createdAt?: string | null, shipment?: { __typename?: 'Shipment', id?: string | null, state?: ShipmentState | null, closedAt?: string | null } | null, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null, destinationStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type GetStockTransferQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStockTransferQuery = { __typename?: 'Query', stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, isReturnToHeadOffice?: boolean | null, transferNumber?: string | null, status?: TransferStatus | null, dispatchedAt?: string | null, dispatchedByCourier?: boolean | null, waybillReference?: string | null, notes?: string | null, completedAt?: string | null, cancelledAt?: string | null, cancelReason?: string | null, createdAt?: string | null, updatedAt?: string | null, shippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null, courier?: Courier | null } | null, shipment?: { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null } | null, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null, type?: StockingPointType | null } | null, destinationStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null, type?: StockingPointType | null } | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, dispatchedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, completedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, cancelledBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, lines: Array<{ __typename?: 'StockTransferLine', id: string, quantity: number, condition: StockCondition, product: { __typename?: 'Product', id?: string | null, sku?: string | null, name?: string | null } }>, partRequests: Array<{ __typename?: 'PartRequest', id: string, quantity: number, status: PartRequestStatus, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null }>, items?: Array<{ __typename?: 'StockTransferItem', id?: string | null, stockItem?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null } | null }> | null } | null };

export type ValidateSerialForTransferQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
  sourceStockingPointId: Scalars['String']['input'];
}>;


export type ValidateSerialForTransferQuery = { __typename?: 'Query', validateSerialForTransfer?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, productSku?: string | null, productName?: string | null, status?: StockItemStatus | null, product?: { __typename?: 'Product', id?: string | null, name?: string | null, sku?: string | null } | null } | null };

export type ValidateTransferItemsQueryVariables = Exact<{
  sourceStockingPointId: Scalars['String']['input'];
  identifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ValidateTransferItemsQuery = { __typename?: 'Query', validateTransferItems?: Array<{ __typename?: 'TransferItemValidation', identifier: string, status: TransferItemStatus, stockItemId?: string | null, productName?: string | null, currentLocationName?: string | null, currentStatus?: string | null }> | null };

export type CreateStockTransferMutationVariables = Exact<{
  input: CreateStockTransferInput;
}>;


export type CreateStockTransferMutation = { __typename?: 'Mutation', createStockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null };

export type CreateStockTransferFromSerialsMutationVariables = Exact<{
  input: CreateStockTransferFromSerialsInput;
}>;


export type CreateStockTransferFromSerialsMutation = { __typename?: 'Mutation', createStockTransferFromSerials?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null };

export type CreateAgentTransferMutationVariables = Exact<{
  input: CreateAgentTransferInput;
}>;


export type CreateAgentTransferMutation = { __typename?: 'Mutation', createAgentTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null };

export type DispatchStockTransferMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DispatchStockTransferMutation = { __typename?: 'Mutation', dispatchStockTransfer?: { __typename?: 'StockTransfer', id?: string | null, status?: TransferStatus | null } | null };

export type CompleteStockTransferMutationVariables = Exact<{
  id: Scalars['String']['input'];
  courierOverrideReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompleteStockTransferMutation = { __typename?: 'Mutation', completeStockTransfer?: { __typename?: 'StockTransfer', id?: string | null, status?: TransferStatus | null, completedAt?: string | null } | null };

export type CancelStockTransferMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type CancelStockTransferMutation = { __typename?: 'Mutation', cancelStockTransfer?: { __typename?: 'StockTransfer', id?: string | null, status?: TransferStatus | null, cancelledAt?: string | null, cancelReason?: string | null } | null };

export type UpdateStockTransferShippingMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ShippingDetailsInput;
}>;


export type UpdateStockTransferShippingMutation = { __typename?: 'Mutation', updateStockTransferShipping?: { __typename?: 'StockTransfer', id?: string | null, waybillReference?: string | null, shippingCompany?: { __typename?: 'ShippingCompany', id?: string | null, name?: string | null, courier?: Courier | null } | null, shipment?: { __typename?: 'Shipment', id?: string | null, courier?: Courier | null, waybillNumber?: string | null, state?: ShipmentState | null, statusLabel?: string | null, events?: Record<string, unknown> | null, details?: Record<string, unknown> | null, courierDeliveredAt?: string | null, lastCheckedAt?: string | null, lastError?: string | null, closedAt?: string | null } | null } | null };

export type GetStockTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStockTypesQuery = { __typename?: 'Query', stockTypes?: Array<{ __typename?: 'StockType', id?: string | null, name?: string | null, isReplacement?: boolean | null, isSystem?: boolean | null, sortOrder?: number | null, createdAt?: string | null, updatedAt?: string | null }> | null };

export type CreateStockTypeMutationVariables = Exact<{
  input: CreateStockTypeInput;
}>;


export type CreateStockTypeMutation = { __typename?: 'Mutation', createStockType?: { __typename?: 'StockType', id?: string | null, name?: string | null, isReplacement?: boolean | null, isSystem?: boolean | null, sortOrder?: number | null } | null };

export type UpdateStockTypeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateStockTypeInput;
}>;


export type UpdateStockTypeMutation = { __typename?: 'Mutation', updateStockType?: { __typename?: 'StockType', id?: string | null, name?: string | null, isReplacement?: boolean | null, isSystem?: boolean | null, sortOrder?: number | null } | null };

export type DeleteStockTypeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteStockTypeMutation = { __typename?: 'Mutation', deleteStockType?: { __typename?: 'StockType', id?: string | null, name?: string | null } | null };

export type GetStockingPointsQueryVariables = Exact<{
  input?: InputMaybe<StockingPointListInput>;
}>;


export type GetStockingPointsQuery = { __typename?: 'Query', stockingPoints?: { __typename?: 'StockingPointListResult', totalCount: number, items: Array<{ __typename?: 'StockingPoint', id?: string | null, stockingPointId?: string | null, name?: string | null, type?: StockingPointType | null, province?: string | null, municipality?: string | null, stockQuantityLimit?: number | null, minimumStockLevel?: number | null, isActive?: boolean | null, displayOrder?: number | null, createdAt?: string | null, parentStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null }> } | null };

export type GetStockingPointQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStockingPointQuery = { __typename?: 'Query', stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, stockingPointId?: string | null, name?: string | null, type?: StockingPointType | null, addressLine1?: string | null, addressLine2?: string | null, province?: string | null, municipality?: string | null, postalCode?: string | null, country?: string | null, stockQuantityLimit?: number | null, minimumStockLevel?: number | null, isActive?: boolean | null, canToggleActive?: boolean | null, canRename?: boolean | null, deactivatedAt?: string | null, deactivationReason?: string | null, createdAt?: string | null, updatedAt?: string | null, stockOnTheWay?: { __typename?: 'StockOnTheWay', arriving?: { __typename?: 'StockArriving', devices?: number | null, transfers?: number | null, purchaseOrders?: number | null, uploads?: number | null } | null, leaving?: { __typename?: 'StockLeaving', devices?: number | null, transfers?: number | null } | null } | null, deactivatedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, parentStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null, childStockingPoints?: Array<{ __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null, type?: StockingPointType | null, isActive?: boolean | null }> | null, users?: Array<{ __typename?: 'StockingPointUser', id?: string | null, isPrimary?: boolean | null, agent?: { __typename?: 'Agent', id?: string | null, firstName?: string | null, lastName?: string | null, salesId?: string | null, agentType?: AgentType | null } | null }> | null, members?: Array<{ __typename?: 'StockingPointMember', id?: string | null, createdAt?: string | null, user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, userRoles?: Array<{ __typename?: 'UserRole', id?: string | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null } | null }> | null } | null }> | null } | null };

export type GetStockingPointInventoryQueryVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StockItemStatus>;
  search?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<StockKind>;
}>;


export type GetStockingPointInventoryQuery = { __typename?: 'Query', stockingPointInventory?: { __typename?: 'StockingPointInventoryResult', totalCount: number, items: Array<{ __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productSku?: string | null, productName?: string | null, isMigrated?: boolean | null, status?: StockItemStatus | null, createdAt?: string | null, stockType?: { __typename?: 'StockType', id?: string | null, name?: string | null } | null }>, statusCounts: Array<{ __typename?: 'StockItemStatusCount', status?: string | null, count?: number | null }> } | null };

export type GetReplenishmentAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReplenishmentAlertsQuery = { __typename?: 'Query', replenishmentAlerts?: Array<{ __typename?: 'ReplenishmentAlert', shortProductCount?: number | null, totalDeficit?: number | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, stockingPointId?: string | null, name?: string | null, type?: StockingPointType | null } | null, products?: Array<{ __typename?: 'ReplenishmentProduct', productId?: string | null, name?: string | null, sku?: string | null, availableCount?: number | null, arrivingCount?: number | null, minimumStockLevel?: number | null, deficit?: number | null }> | null }> | null };

export type GetStockingPointProductMinimumsQueryVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
}>;


export type GetStockingPointProductMinimumsQuery = { __typename?: 'Query', stockingPointProductMinimums?: Array<{ __typename?: 'StockingPointProductMinimum', productId?: string | null, name?: string | null, sku?: string | null, minimumStockLevel?: number | null, availableCount?: number | null }> | null };

export type SetStockingPointProductMinimumMutationVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  minimumStockLevel: Scalars['Int']['input'];
}>;


export type SetStockingPointProductMinimumMutation = { __typename?: 'Mutation', setStockingPointProductMinimum?: { __typename?: 'StockingPointProductMinimum', productId?: string | null, name?: string | null, sku?: string | null, minimumStockLevel?: number | null, availableCount?: number | null } | null };

export type CreateStockingPointMutationVariables = Exact<{
  input: CreateStockingPointInput;
}>;


export type CreateStockingPointMutation = { __typename?: 'Mutation', createStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, stockingPointId?: string | null, name?: string | null, type?: StockingPointType | null } | null };

export type UpdateStockingPointMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateStockingPointInput;
}>;


export type UpdateStockingPointMutation = { __typename?: 'Mutation', updateStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, stockingPointId?: string | null, name?: string | null, type?: StockingPointType | null, isActive?: boolean | null } | null };

export type RenameStockingPointMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameStockingPointMutation = { __typename?: 'Mutation', renameStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, stockingPointId?: string | null } | null };

export type SetStockingPointActiveMutationVariables = Exact<{
  id: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
}>;


export type SetStockingPointActiveMutation = { __typename?: 'Mutation', setStockingPointActive?: { __typename?: 'StockingPoint', id?: string | null, isActive?: boolean | null, canToggleActive?: boolean | null, deactivatedAt?: string | null, deactivationReason?: string | null, deactivatedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type AssignAgentToStockingPointMutationVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
}>;


export type AssignAgentToStockingPointMutation = { __typename?: 'Mutation', assignAgentToStockingPoint?: { __typename?: 'StockingPointUser', id?: string | null, isPrimary?: boolean | null } | null };

export type AssignWorkshopMemberMutationVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type AssignWorkshopMemberMutation = { __typename?: 'Mutation', assignWorkshopMember?: { __typename?: 'StockingPointMember', id?: string | null, createdAt?: string | null, user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } | null };

export type RemoveWorkshopMemberMutationVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type RemoveWorkshopMemberMutation = { __typename?: 'Mutation', removeWorkshopMember?: boolean | null };

export type RemoveAgentFromStockingPointMutationVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
}>;


export type RemoveAgentFromStockingPointMutation = { __typename?: 'Mutation', removeAgentFromStockingPoint?: boolean | null };

export type ReorderStockingPointsMutationVariables = Exact<{
  orderedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderStockingPointsMutation = { __typename?: 'Mutation', reorderStockingPoints?: Array<{ __typename?: 'StockingPoint', id?: string | null, displayOrder?: number | null }> | null };

export type UpdateMinimumStockLevelMutationVariables = Exact<{
  id: Scalars['String']['input'];
  minimumStockLevel: Scalars['Int']['input'];
}>;


export type UpdateMinimumStockLevelMutation = { __typename?: 'Mutation', updateMinimumStockLevel?: { __typename?: 'StockingPoint', id?: string | null, minimumStockLevel?: number | null } | null };

export type BatchAddDevicesToStockingPointMutationVariables = Exact<{
  input: BatchAddDevicesInput;
}>;


export type BatchAddDevicesToStockingPointMutation = { __typename?: 'Mutation', batchAddDevicesToStockingPoint?: { __typename?: 'BatchAddDevicesResult', imported?: number | null, skipped?: number | null, skippedRows?: Array<{ __typename?: 'BatchDeviceError', row?: number | null, reason?: string | null }> | null, errors?: Array<{ __typename?: 'BatchDeviceError', row?: number | null, reason?: string | null }> | null } | null };

export type AddStockItemToStockingPointMutationVariables = Exact<{
  input: AddStockItemInput;
}>;


export type AddStockItemToStockingPointMutation = { __typename?: 'Mutation', addStockItemToStockingPoint?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, stockType?: { __typename?: 'StockType', id?: string | null, name?: string | null } | null } | null };

export type SubcontractorFieldsFragment = { __typename?: 'Subcontractor', id: string, name: string, registrationNumber?: string | null, bbbeeLevel?: BbbeeLevel | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, services?: string | null, contractStart?: string | null, contractEnd?: string | null, contractValue?: number | null, status: SubcontractorStatus, notes?: string | null, activeWorkerCount: number };

export type SubcontractorWorkerFieldsFragment = { __typename?: 'SubcontractorWorker', id: string, firstName: string, lastName: string, idNumber?: string | null, role?: string | null, inductionDate?: string | null, active: boolean, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, agent?: { __typename?: 'SubcontractorWorkerAgent', id: string, firstName: string, lastName: string, salesId: string } | null };

export type SubcontractorHoursFieldsFragment = { __typename?: 'SubcontractorHours', id: string, periodStart: string, periodEnd: string, hours: number, notes?: string | null, worker: { __typename?: 'SubcontractorHoursWorker', id: string, firstName: string, lastName: string, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string } } };

export type SubcontractorInvoiceFieldsFragment = { __typename?: 'SubcontractorInvoice', id: string, invoiceNumber?: string | null, invoiceDate: string, amount: number, notes?: string | null };

export type SubcontractorComplianceFieldsFragment = { __typename?: 'SubcontractorComplianceDocument', id: string, type: SubcontractorDocumentType, reference?: string | null, issuedDate?: string | null, expiryDate?: string | null, notes?: string | null, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, files: Array<{ __typename?: 'SubcontractorComplianceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> };

export type SubcontractorsQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>;
}>;


export type SubcontractorsQuery = { __typename?: 'Query', subcontractors: { __typename?: 'SubcontractorList', totalCount: number, items: Array<{ __typename?: 'Subcontractor', id: string, name: string, registrationNumber?: string | null, bbbeeLevel?: BbbeeLevel | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, services?: string | null, contractStart?: string | null, contractEnd?: string | null, contractValue?: number | null, status: SubcontractorStatus, notes?: string | null, activeWorkerCount: number }> } };

export type SubcontractorsExportQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorFilterInput>;
}>;


export type SubcontractorsExportQuery = { __typename?: 'Query', subcontractorsExport: Array<{ __typename?: 'Subcontractor', id: string, name: string, registrationNumber?: string | null, bbbeeLevel?: BbbeeLevel | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, services?: string | null, contractStart?: string | null, contractEnd?: string | null, contractValue?: number | null, status: SubcontractorStatus, notes?: string | null, activeWorkerCount: number }> };

export type SubcontractorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubcontractorQuery = { __typename?: 'Query', subcontractor: { __typename?: 'SubcontractorDetail', subcontractor: { __typename?: 'Subcontractor', id: string, name: string, registrationNumber?: string | null, bbbeeLevel?: BbbeeLevel | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, services?: string | null, contractStart?: string | null, contractEnd?: string | null, contractValue?: number | null, status: SubcontractorStatus, notes?: string | null, activeWorkerCount: number }, workers: Array<{ __typename?: 'SubcontractorWorker', id: string, firstName: string, lastName: string, idNumber?: string | null, role?: string | null, inductionDate?: string | null, active: boolean, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, agent?: { __typename?: 'SubcontractorWorkerAgent', id: string, firstName: string, lastName: string, salesId: string } | null }>, invoices: Array<{ __typename?: 'SubcontractorInvoice', id: string, invoiceNumber?: string | null, invoiceDate: string, amount: number, notes?: string | null }>, complianceDocuments: Array<{ __typename?: 'SubcontractorComplianceDocument', id: string, type: SubcontractorDocumentType, reference?: string | null, issuedDate?: string | null, expiryDate?: string | null, notes?: string | null, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, files: Array<{ __typename?: 'SubcontractorComplianceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> }> } };

export type SubcontractorHoursQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorHoursFilterInput>;
}>;


export type SubcontractorHoursQuery = { __typename?: 'Query', subcontractorHours: { __typename?: 'SubcontractorHoursList', totalCount: number, totalHours: number, items: Array<{ __typename?: 'SubcontractorHours', id: string, periodStart: string, periodEnd: string, hours: number, notes?: string | null, worker: { __typename?: 'SubcontractorHoursWorker', id: string, firstName: string, lastName: string, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string } } }> } };

export type SubcontractorComplianceDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<SubcontractorComplianceFilterInput>;
}>;


export type SubcontractorComplianceDocumentsQuery = { __typename?: 'Query', subcontractorComplianceDocuments: Array<{ __typename?: 'SubcontractorComplianceDocument', id: string, type: SubcontractorDocumentType, reference?: string | null, issuedDate?: string | null, expiryDate?: string | null, notes?: string | null, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, files: Array<{ __typename?: 'SubcontractorComplianceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> }> };

export type SubcontractorAgentOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubcontractorAgentOptionsQuery = { __typename?: 'Query', subcontractorAgentOptions: Array<{ __typename?: 'SubcontractorWorkerAgent', id: string, firstName: string, lastName: string, salesId: string }> };

export type SubcontractorMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type SubcontractorMetricsQuery = { __typename?: 'Query', subcontractorMetrics: { __typename?: 'SubcontractorMetrics', from: string, to: string, activeSubcontractors: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, activeWorkers: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, hoursWorked: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, spend: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, complianceExpired: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, complianceExpiring: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, withoutValidCoida: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, inductedPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, incidents?: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } | null, lostTimeIncidents?: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } | null, spendBySubcontractor: Array<{ __typename?: 'SubcontractorSpend', subcontractorId: string, name: string, spend: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } }>, bbbeeLevels: Array<{ __typename?: 'BbbeeLevelCount', level?: BbbeeLevel | null, count: number }> } };

export type CreateSubcontractorMutationVariables = Exact<{
  input: CreateSubcontractorInput;
}>;


export type CreateSubcontractorMutation = { __typename?: 'Mutation', createSubcontractor: { __typename?: 'Subcontractor', id: string, name: string, registrationNumber?: string | null, bbbeeLevel?: BbbeeLevel | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, services?: string | null, contractStart?: string | null, contractEnd?: string | null, contractValue?: number | null, status: SubcontractorStatus, notes?: string | null, activeWorkerCount: number } };

export type UpdateSubcontractorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorInput;
}>;


export type UpdateSubcontractorMutation = { __typename?: 'Mutation', updateSubcontractor: { __typename?: 'Subcontractor', id: string, name: string, registrationNumber?: string | null, bbbeeLevel?: BbbeeLevel | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, services?: string | null, contractStart?: string | null, contractEnd?: string | null, contractValue?: number | null, status: SubcontractorStatus, notes?: string | null, activeWorkerCount: number } };

export type DeleteSubcontractorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSubcontractorMutation = { __typename?: 'Mutation', deleteSubcontractor: boolean };

export type CreateSubcontractorWorkerMutationVariables = Exact<{
  subcontractorId: Scalars['ID']['input'];
  input: CreateSubcontractorWorkerInput;
}>;


export type CreateSubcontractorWorkerMutation = { __typename?: 'Mutation', createSubcontractorWorker: { __typename?: 'SubcontractorWorker', id: string, firstName: string, lastName: string, idNumber?: string | null, role?: string | null, inductionDate?: string | null, active: boolean, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, agent?: { __typename?: 'SubcontractorWorkerAgent', id: string, firstName: string, lastName: string, salesId: string } | null } };

export type UpdateSubcontractorWorkerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorWorkerInput;
}>;


export type UpdateSubcontractorWorkerMutation = { __typename?: 'Mutation', updateSubcontractorWorker: { __typename?: 'SubcontractorWorker', id: string, firstName: string, lastName: string, idNumber?: string | null, role?: string | null, inductionDate?: string | null, active: boolean, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, agent?: { __typename?: 'SubcontractorWorkerAgent', id: string, firstName: string, lastName: string, salesId: string } | null } };

export type DeleteSubcontractorWorkerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSubcontractorWorkerMutation = { __typename?: 'Mutation', deleteSubcontractorWorker: boolean };

export type CreateSubcontractorHoursMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
  input: CreateSubcontractorHoursInput;
}>;


export type CreateSubcontractorHoursMutation = { __typename?: 'Mutation', createSubcontractorHours: { __typename?: 'SubcontractorHours', id: string, periodStart: string, periodEnd: string, hours: number, notes?: string | null, worker: { __typename?: 'SubcontractorHoursWorker', id: string, firstName: string, lastName: string, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string } } } };

export type UpdateSubcontractorHoursMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorHoursInput;
}>;


export type UpdateSubcontractorHoursMutation = { __typename?: 'Mutation', updateSubcontractorHours: { __typename?: 'SubcontractorHours', id: string, periodStart: string, periodEnd: string, hours: number, notes?: string | null, worker: { __typename?: 'SubcontractorHoursWorker', id: string, firstName: string, lastName: string, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string } } } };

export type DeleteSubcontractorHoursMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSubcontractorHoursMutation = { __typename?: 'Mutation', deleteSubcontractorHours: boolean };

export type ImportSubcontractorHoursMutationVariables = Exact<{
  subcontractorId: Scalars['ID']['input'];
  csv: Scalars['String']['input'];
}>;


export type ImportSubcontractorHoursMutation = { __typename?: 'Mutation', importSubcontractorHours: { __typename?: 'SubcontractorHoursImportResult', imported: number, errors: Array<{ __typename?: 'SubcontractorHoursImportError', line: number, message: string }> } };

export type CreateSubcontractorInvoiceMutationVariables = Exact<{
  subcontractorId: Scalars['ID']['input'];
  input: CreateSubcontractorInvoiceInput;
}>;


export type CreateSubcontractorInvoiceMutation = { __typename?: 'Mutation', createSubcontractorInvoice: { __typename?: 'SubcontractorInvoice', id: string, invoiceNumber?: string | null, invoiceDate: string, amount: number, notes?: string | null } };

export type UpdateSubcontractorInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorInvoiceInput;
}>;


export type UpdateSubcontractorInvoiceMutation = { __typename?: 'Mutation', updateSubcontractorInvoice: { __typename?: 'SubcontractorInvoice', id: string, invoiceNumber?: string | null, invoiceDate: string, amount: number, notes?: string | null } };

export type DeleteSubcontractorInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSubcontractorInvoiceMutation = { __typename?: 'Mutation', deleteSubcontractorInvoice: boolean };

export type CreateSubcontractorComplianceDocumentMutationVariables = Exact<{
  subcontractorId: Scalars['ID']['input'];
  input: CreateSubcontractorComplianceInput;
}>;


export type CreateSubcontractorComplianceDocumentMutation = { __typename?: 'Mutation', createSubcontractorComplianceDocument: { __typename?: 'SubcontractorComplianceDocument', id: string, type: SubcontractorDocumentType, reference?: string | null, issuedDate?: string | null, expiryDate?: string | null, notes?: string | null, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, files: Array<{ __typename?: 'SubcontractorComplianceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type UpdateSubcontractorComplianceDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSubcontractorComplianceInput;
}>;


export type UpdateSubcontractorComplianceDocumentMutation = { __typename?: 'Mutation', updateSubcontractorComplianceDocument: { __typename?: 'SubcontractorComplianceDocument', id: string, type: SubcontractorDocumentType, reference?: string | null, issuedDate?: string | null, expiryDate?: string | null, notes?: string | null, subcontractor: { __typename?: 'SubcontractorRef', id: string, name: string }, files: Array<{ __typename?: 'SubcontractorComplianceFile', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type DeleteSubcontractorComplianceDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSubcontractorComplianceDocumentMutation = { __typename?: 'Mutation', deleteSubcontractorComplianceDocument: boolean };

export type RemoveSubcontractorComplianceFileMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type RemoveSubcontractorComplianceFileMutation = { __typename?: 'Mutation', removeSubcontractorComplianceFile: boolean };

export type GetSuppliersQueryVariables = Exact<{
  input?: InputMaybe<SupplierListInput>;
}>;


export type GetSuppliersQuery = { __typename?: 'Query', suppliers?: { __typename?: 'SupplierListResult', totalCount: number, items: Array<{ __typename?: 'Supplier', id?: string | null, name?: string | null, contactPerson?: string | null, email?: string | null, phone?: string | null, beeLevel?: number | null, beeStatus?: string | null, isActive?: boolean | null, createdAt?: string | null }> } | null };

export type GetSupplierQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSupplierQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null, contactPerson?: string | null, email?: string | null, phone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, country?: string | null, beeLevel?: number | null, beeStatus?: string | null, isActive?: boolean | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type CreateSupplierMutationVariables = Exact<{
  input: CreateSupplierInput;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null };

export type UpdateSupplierMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateSupplierInput;
}>;


export type UpdateSupplierMutation = { __typename?: 'Mutation', updateSupplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null, isActive?: boolean | null } | null };

export type GetThirdPartyCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThirdPartyCredentialsQuery = { __typename?: 'Query', thirdPartyCredentials?: Array<{ __typename?: 'ThirdPartyCredential', id?: string | null, provider?: string | null, name?: string | null, prefix?: string | null, notes?: string | null, isActive?: boolean | null, lastUsedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> | null };

export type CreateThirdPartyCredentialMutationVariables = Exact<{
  input: CreateThirdPartyCredentialInput;
}>;


export type CreateThirdPartyCredentialMutation = { __typename?: 'Mutation', createThirdPartyCredential?: { __typename?: 'ThirdPartyCredential', id?: string | null, provider?: string | null, name?: string | null, prefix?: string | null, notes?: string | null, isActive?: boolean | null, createdAt?: string | null, createdBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type UpdateThirdPartyCredentialMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateThirdPartyCredentialInput;
}>;


export type UpdateThirdPartyCredentialMutation = { __typename?: 'Mutation', updateThirdPartyCredential?: { __typename?: 'ThirdPartyCredential', id?: string | null, provider?: string | null, name?: string | null, prefix?: string | null, notes?: string | null, isActive?: boolean | null, updatedAt?: string | null } | null };

export type RevokeThirdPartyCredentialMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevokeThirdPartyCredentialMutation = { __typename?: 'Mutation', revokeThirdPartyCredential?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type DeleteThirdPartyCredentialMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteThirdPartyCredentialMutation = { __typename?: 'Mutation', deleteThirdPartyCredential?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RevealThirdPartyCredentialQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevealThirdPartyCredentialQuery = { __typename?: 'Query', revealThirdPartyCredential?: { __typename?: 'RevealedThirdPartyCredential', id: string, value: string } | null };

export type TrainingPersonFieldsFragment = { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null };

export type TrainingCourseFieldsFragment = { __typename?: 'TrainingCourse', id: string, name: string, provider?: string | null, category: TrainingCategory, accredited: boolean, mandatory: boolean, validityMonths?: number | null, sessionCount: number, certificationCount: number };

export type TrainingSessionFieldsFragment = { __typename?: 'TrainingSession', id: string, startDate: string, endDate?: string | null, hours?: number | null, cost?: number | null, status: TrainingSessionStatus, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } };

export type TrainingCertificationFieldsFragment = { __typename?: 'TrainingCertification', id: string, name?: string | null, certificateNumber?: string | null, issuedDate: string, expiryDate?: string | null, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course?: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } | null, documents: Array<{ __typename?: 'TrainingCertificateDocument', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> };

export type LearningProgrammeFieldsFragment = { __typename?: 'LearningProgramme', id: string, employmentId: string, type: LearningProgrammeType, name: string, seta?: string | null, nqfLevel?: number | null, startDate: string, endDate?: string | null, outcome?: LearningProgrammeOutcome | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } };

export type TrainingCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type TrainingCoursesQuery = { __typename?: 'Query', trainingCourses: Array<{ __typename?: 'TrainingCourse', id: string, name: string, provider?: string | null, category: TrainingCategory, accredited: boolean, mandatory: boolean, validityMonths?: number | null, sessionCount: number, certificationCount: number }> };

export type TrainingSessionsQueryVariables = Exact<{
  filter?: InputMaybe<TrainingSessionFilterInput>;
}>;


export type TrainingSessionsQuery = { __typename?: 'Query', trainingSessions: { __typename?: 'TrainingSessionList', totalCount: number, items: Array<{ __typename?: 'TrainingSession', id: string, startDate: string, endDate?: string | null, hours?: number | null, cost?: number | null, status: TrainingSessionStatus, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } }> } };

export type TrainingSessionsExportQueryVariables = Exact<{
  filter?: InputMaybe<TrainingSessionFilterInput>;
}>;


export type TrainingSessionsExportQuery = { __typename?: 'Query', trainingSessionsExport: Array<{ __typename?: 'TrainingSession', id: string, startDate: string, endDate?: string | null, hours?: number | null, cost?: number | null, status: TrainingSessionStatus, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } }> };

export type TrainingCertificationsQueryVariables = Exact<{
  filter?: InputMaybe<TrainingCertificationFilterInput>;
}>;


export type TrainingCertificationsQuery = { __typename?: 'Query', trainingCertifications: Array<{ __typename?: 'TrainingCertification', id: string, name?: string | null, certificateNumber?: string | null, issuedDate: string, expiryDate?: string | null, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course?: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } | null, documents: Array<{ __typename?: 'TrainingCertificateDocument', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> }> };

export type LearningProgrammesQueryVariables = Exact<{
  filter?: InputMaybe<LearningProgrammeFilterInput>;
}>;


export type LearningProgrammesQuery = { __typename?: 'Query', learningProgrammes: Array<{ __typename?: 'LearningProgramme', id: string, employmentId: string, type: LearningProgrammeType, name: string, seta?: string | null, nqfLevel?: number | null, startDate: string, endDate?: string | null, outcome?: LearningProgrammeOutcome | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } }> };

export type EmployeeTrainingQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type EmployeeTrainingQuery = { __typename?: 'Query', employeeTraining: { __typename?: 'EmployeeTraining', employeeId: string, sessions: Array<{ __typename?: 'TrainingSession', id: string, startDate: string, endDate?: string | null, hours?: number | null, cost?: number | null, status: TrainingSessionStatus, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } }>, certifications: Array<{ __typename?: 'TrainingCertification', id: string, name?: string | null, certificateNumber?: string | null, issuedDate: string, expiryDate?: string | null, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course?: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } | null, documents: Array<{ __typename?: 'TrainingCertificateDocument', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> }>, programmes: Array<{ __typename?: 'LearningProgramme', id: string, employmentId: string, type: LearningProgrammeType, name: string, seta?: string | null, nqfLevel?: number | null, startDate: string, endDate?: string | null, outcome?: LearningProgrammeOutcome | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } }> } };

export type TrainingMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filter?: InputMaybe<TrainingMetricsFilterInput>;
}>;


export type TrainingMetricsQuery = { __typename?: 'Query', trainingMetrics: { __typename?: 'TrainingMetrics', from: string, to: string, trainingHours: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, hoursPerEmployee: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, spend: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, spendPerEmployee: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, completionRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, peopleTrained: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, trainedPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, mandatoryCompliance: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, mandatoryCourses: Array<{ __typename?: 'TrainingMandatoryCompliance', courseId: string, courseName: string, holders: number, compliance: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } }>, expiringIn30: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, expiringIn60: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, expiringIn90: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, expired: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, activeLearners: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, skillsSpendPercentOfPayroll: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number } } };

export type CreateTrainingCourseMutationVariables = Exact<{
  input: TrainingCourseInput;
}>;


export type CreateTrainingCourseMutation = { __typename?: 'Mutation', createTrainingCourse: { __typename?: 'TrainingCourse', id: string, name: string, provider?: string | null, category: TrainingCategory, accredited: boolean, mandatory: boolean, validityMonths?: number | null, sessionCount: number, certificationCount: number } };

export type UpdateTrainingCourseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTrainingCourseInput;
}>;


export type UpdateTrainingCourseMutation = { __typename?: 'Mutation', updateTrainingCourse: { __typename?: 'TrainingCourse', id: string, name: string, provider?: string | null, category: TrainingCategory, accredited: boolean, mandatory: boolean, validityMonths?: number | null, sessionCount: number, certificationCount: number } };

export type DeleteTrainingCourseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTrainingCourseMutation = { __typename?: 'Mutation', deleteTrainingCourse: boolean };

export type CreateTrainingSessionMutationVariables = Exact<{
  input: CreateTrainingSessionInput;
}>;


export type CreateTrainingSessionMutation = { __typename?: 'Mutation', createTrainingSession: { __typename?: 'TrainingSession', id: string, startDate: string, endDate?: string | null, hours?: number | null, cost?: number | null, status: TrainingSessionStatus, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } } };

export type UpdateTrainingSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTrainingSessionInput;
}>;


export type UpdateTrainingSessionMutation = { __typename?: 'Mutation', updateTrainingSession: { __typename?: 'TrainingSession', id: string, startDate: string, endDate?: string | null, hours?: number | null, cost?: number | null, status: TrainingSessionStatus, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } } };

export type DeleteTrainingSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTrainingSessionMutation = { __typename?: 'Mutation', deleteTrainingSession: boolean };

export type CreateTrainingCertificationMutationVariables = Exact<{
  input: CreateTrainingCertificationInput;
}>;


export type CreateTrainingCertificationMutation = { __typename?: 'Mutation', createTrainingCertification: { __typename?: 'TrainingCertification', id: string, name?: string | null, certificateNumber?: string | null, issuedDate: string, expiryDate?: string | null, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course?: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } | null, documents: Array<{ __typename?: 'TrainingCertificateDocument', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type UpdateTrainingCertificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTrainingCertificationInput;
}>;


export type UpdateTrainingCertificationMutation = { __typename?: 'Mutation', updateTrainingCertification: { __typename?: 'TrainingCertification', id: string, name?: string | null, certificateNumber?: string | null, issuedDate: string, expiryDate?: string | null, notes?: string | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null }, course?: { __typename?: 'TrainingCourseSummary', id: string, name: string, category: TrainingCategory, mandatory: boolean, validityMonths?: number | null } | null, documents: Array<{ __typename?: 'TrainingCertificateDocument', id: string, originalName: string, mimeType: string, size: number, createdAt: string }> } };

export type DeleteTrainingCertificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTrainingCertificationMutation = { __typename?: 'Mutation', deleteTrainingCertification: boolean };

export type RemoveTrainingCertificateDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type RemoveTrainingCertificateDocumentMutation = { __typename?: 'Mutation', removeTrainingCertificateDocument: boolean };

export type CreateLearningProgrammeMutationVariables = Exact<{
  input: CreateLearningProgrammeInput;
}>;


export type CreateLearningProgrammeMutation = { __typename?: 'Mutation', createLearningProgramme: { __typename?: 'LearningProgramme', id: string, employmentId: string, type: LearningProgrammeType, name: string, seta?: string | null, nqfLevel?: number | null, startDate: string, endDate?: string | null, outcome?: LearningProgrammeOutcome | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } } };

export type UpdateLearningProgrammeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLearningProgrammeInput;
}>;


export type UpdateLearningProgrammeMutation = { __typename?: 'Mutation', updateLearningProgramme: { __typename?: 'LearningProgramme', id: string, employmentId: string, type: LearningProgrammeType, name: string, seta?: string | null, nqfLevel?: number | null, startDate: string, endDate?: string | null, outcome?: LearningProgrammeOutcome | null, employee: { __typename?: 'TrainingPerson', id: string, firstName: string, lastName: string, employeeNumber?: string | null, departmentName?: string | null } } };

export type GetUnitsOfMeasureQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitsOfMeasureQuery = { __typename?: 'Query', unitsOfMeasure?: Array<{ __typename?: 'UnitOfMeasure', id?: string | null, name?: string | null, externalCode?: string | null, productCount?: number | null, createdAt?: string | null, updatedAt?: string | null }> | null };

export type CreateUnitOfMeasureMutationVariables = Exact<{
  input: CreateUnitOfMeasureInput;
}>;


export type CreateUnitOfMeasureMutation = { __typename?: 'Mutation', createUnitOfMeasure?: { __typename?: 'UnitOfMeasure', id?: string | null, name?: string | null, externalCode?: string | null } | null };

export type UpdateUnitOfMeasureMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateUnitOfMeasureInput;
}>;


export type UpdateUnitOfMeasureMutation = { __typename?: 'Mutation', updateUnitOfMeasure?: { __typename?: 'UnitOfMeasure', id?: string | null, name?: string | null, externalCode?: string | null } | null };

export type DeleteUnitOfMeasureMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUnitOfMeasureMutation = { __typename?: 'Mutation', deleteUnitOfMeasure?: { __typename?: 'UnitOfMeasure', id?: string | null, name?: string | null } | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, sessionTimeoutEnabled?: boolean | null, preferredLanguage?: string | null, createdAt?: string | null, userRoles?: Array<{ __typename?: 'UserRole', id?: string | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null, grantableRoles?: Array<{ __typename?: 'Role', id?: string | null, name?: string | null }> | null } | null }> | null, userDepartments?: Array<{ __typename?: 'UserDepartment', id?: string | null, department?: { __typename?: 'Department', id?: string | null, name?: string | null } | null }> | null, stockingPointMemberships?: Array<{ __typename?: 'StockingPointMember', id?: string | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null }> | null, agent?: { __typename?: 'Agent', id?: string | null, agentType?: AgentType | null, canSell?: boolean | null, canDoReplacements?: boolean | null, bankName?: string | null, bankAccountNumber?: string | null, bankBranchCode?: string | null, bankAccountType?: AgentBankAccountType | null, stockingPointUsers?: Array<{ __typename?: 'StockingPointUser', isPrimary?: boolean | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, addressLine1?: string | null, province?: string | null, municipality?: string | null, postalCode?: string | null } | null }> | null } | null } | null };

export type GetMembersQueryVariables = Exact<{
  input?: InputMaybe<MemberSearchInput>;
}>;


export type GetMembersQuery = { __typename?: 'Query', members?: { __typename?: 'MemberListResult', totalCount: number, items: Array<{ __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, archivedAt?: string | null, createdAt?: string | null, userRoles?: Array<{ __typename?: 'UserRole', id?: string | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null } | null }> | null, userDepartments?: Array<{ __typename?: 'UserDepartment', id?: string | null, isAdmin?: boolean | null, department?: { __typename?: 'Department', id?: string | null, name?: string | null } | null }> | null, stockingPointMemberships?: Array<{ __typename?: 'StockingPointMember', id?: string | null, stockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null }> | null, agent?: { __typename?: 'Agent', id?: string | null } | null }> } | null };

export type GetAgentManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentManagersQuery = { __typename?: 'Query', agentManagers?: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null }> | null };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, preferredLanguage?: string | null, createdAt?: string | null } | null };

export type AssignUserToRoleMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
}>;


export type AssignUserToRoleMutation = { __typename?: 'Mutation', assignUserToRole?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RemoveUserFromRoleMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
}>;


export type RemoveUserFromRoleMutation = { __typename?: 'Mutation', removeUserFromRole?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type UpdateMyBankingDetailsMutationVariables = Exact<{
  input: UpdateMyBankingInput;
}>;


export type UpdateMyBankingDetailsMutation = { __typename?: 'Mutation', updateMyBankingDetails?: { __typename?: 'Agent', id?: string | null, bankName?: string | null, bankAccountNumber?: string | null, bankBranchCode?: string | null, bankAccountType?: AgentBankAccountType | null } | null };

export type ArchiveMemberMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ArchiveMemberMutation = { __typename?: 'Mutation', archiveMember?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RestoreMemberMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RestoreMemberMutation = { __typename?: 'Mutation', restoreMember?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type GetWebhookEventsQueryVariables = Exact<{
  input?: InputMaybe<WebhookEventListInput>;
}>;


export type GetWebhookEventsQuery = { __typename?: 'Query', webhookEvents: { __typename?: 'WebhookEventListResult', totalCount: number, eventNames: Array<string>, events: Array<{ __typename?: 'WebhookEvent', id: string, createdAt: string, direction: WebhookDirection, source: string, event: string, version?: number | null, subjectType?: string | null, subjectId?: string | null, occurredAt?: string | null, correlationId?: string | null, payload: Record<string, unknown>, status: WebhookEventStatus, signatureStatus?: WebhookSignatureStatus | null, responseStatus?: number | null, error?: string | null, deliveries: Array<{ __typename?: 'WebhookDelivery', id: string, status: WebhookDeliveryStatus, attempts: number, lastAttemptAt?: string | null, nextRetryAt?: string | null, sentAt?: string | null, responseStatus?: number | null, lastError?: string | null, subscription: { __typename?: 'WebhookSubscription', id: string, name: string } }> }> } };

export type ResendWebhookDeliveryMutationVariables = Exact<{
  deliveryId: Scalars['String']['input'];
}>;


export type ResendWebhookDeliveryMutation = { __typename?: 'Mutation', resendWebhookDelivery?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type GetWebhookSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebhookSubscriptionsQuery = { __typename?: 'Query', webhookSubscriptions: Array<{ __typename?: 'WebhookSubscription', id: string, name: string, url: string, events: Array<string>, isActive: boolean, secretHint: string, hasApiKey: boolean, maxAttempts: number, lastSuccessAt?: string | null, lastFailureAt?: string | null, pendingDeliveryCount: number, failedDeliveryCount: number, failuresClearedAt?: string | null, createdAt: string }> };

export type GetWebhookEventCatalogueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebhookEventCatalogueQuery = { __typename?: 'Query', webhookEventCatalogue: Array<string> };

export type CreateWebhookSubscriptionMutationVariables = Exact<{
  input: CreateWebhookSubscriptionInput;
}>;


export type CreateWebhookSubscriptionMutation = { __typename?: 'Mutation', createWebhookSubscription?: { __typename?: 'CreateWebhookSubscriptionResult', secret: string, subscription: { __typename?: 'WebhookSubscription', id: string, name: string, url: string, events: Array<string>, isActive: boolean, secretHint: string } } | null };

export type UpdateWebhookSubscriptionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateWebhookSubscriptionInput;
}>;


export type UpdateWebhookSubscriptionMutation = { __typename?: 'Mutation', updateWebhookSubscription?: { __typename?: 'WebhookSubscription', id: string, name: string, url: string, events: Array<string>, isActive: boolean, maxAttempts: number } | null };

export type DeleteWebhookSubscriptionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteWebhookSubscriptionMutation = { __typename?: 'Mutation', deleteWebhookSubscription?: { __typename?: 'SuccessPayload', success?: boolean | null, message?: string | null } | null };

export type RotateWebhookSubscriptionSecretMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RotateWebhookSubscriptionSecretMutation = { __typename?: 'Mutation', rotateWebhookSubscriptionSecret?: { __typename?: 'RotateWebhookSecretResult', secret: string, subscription: { __typename?: 'WebhookSubscription', id: string, secretHint: string } } | null };

export type ClearWebhookSubscriptionFailuresMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ClearWebhookSubscriptionFailuresMutation = { __typename?: 'Mutation', clearWebhookSubscriptionFailures?: { __typename?: 'WebhookSubscription', id: string, failedDeliveryCount: number, failuresClearedAt?: string | null } | null };

export type HrMetricFieldsFragment = { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number };

export type EmploymentFieldsFragment = { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean };

export type EmployeeSummaryFieldsFragment = { __typename?: 'Employee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'EmployeeDepartment', id: string, name: string } | null, currentEmployment?: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } | null, employments: Array<{ __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean }> };

export type EmployeeDetailFieldsFragment = { __typename?: 'Employee', createdAt: string, id: string, firstName: string, lastName: string, employeeNumber?: string | null, user?: { __typename?: 'EmployeeUser', id: string, email: string, blocked: boolean, archived: boolean } | null, department?: { __typename?: 'EmployeeDepartment', id: string, name: string } | null, currentEmployment?: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } | null, employments: Array<{ __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean }> };

export type EmployeesQueryVariables = Exact<{
  filter?: InputMaybe<EmployeeFilterInput>;
}>;


export type EmployeesQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeList', totalCount: number, items: Array<{ __typename?: 'Employee', id: string, firstName: string, lastName: string, employeeNumber?: string | null, department?: { __typename?: 'EmployeeDepartment', id: string, name: string } | null, currentEmployment?: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } | null, employments: Array<{ __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean }> }> } };

export type EmployeeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmployeeQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', createdAt: string, id: string, firstName: string, lastName: string, employeeNumber?: string | null, user?: { __typename?: 'EmployeeUser', id: string, email: string, blocked: boolean, archived: boolean } | null, department?: { __typename?: 'EmployeeDepartment', id: string, name: string } | null, currentEmployment?: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } | null, employments: Array<{ __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean }> } };

export type HrDepartmentOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type HrDepartmentOptionsQuery = { __typename?: 'Query', departments?: Array<{ __typename?: 'Department', id?: string | null, name?: string | null }> | null };

export type HrUserOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type HrUserOptionsQuery = { __typename?: 'Query', members?: { __typename?: 'MemberListResult', totalCount: number, items: Array<{ __typename?: 'User', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, agent?: { __typename?: 'Agent', id?: string | null } | null }> } | null };

export type WorkforceMetricsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  filter?: InputMaybe<WorkforceFilterInput>;
}>;


export type WorkforceMetricsQuery = { __typename?: 'Query', workforceMetrics: { __typename?: 'WorkforceMetrics', from: string, to: string, headcount: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, permanent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, fixedTerm: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, contractors: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, fullTime: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, partTime: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, newHires: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, terminations: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, netGrowth: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, netGrowthPercent: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, turnoverRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, voluntaryLeavers: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, involuntaryLeavers: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, contractEnded: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, promotions: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, promotionRate: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, transfers: { __typename?: 'HrMetric', value?: number | null, state: HrMetricState, source?: string | null, lastSyncedAt?: string | null, notRecorded: number }, byDepartment: Array<{ __typename?: 'WorkforceDepartmentCount', departmentId?: string | null, departmentName?: string | null, count: number }>, trend: Array<{ __typename?: 'HeadcountPoint', monthEnd: string, headcount: number, notRecorded: number }>, grievances?: Array<{ __typename?: 'GrievanceStatusCount', status: string, count: number }> | null } };

export type EmployeesLeftWithLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeesLeftWithLoginQuery = { __typename?: 'Query', employeesLeftWithLogin: Array<{ __typename?: 'LeftWithLogin', employeeId: string, userId: string, name: string, email: string, endDate: string }> };

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', createdAt: string, id: string, firstName: string, lastName: string, employeeNumber?: string | null, user?: { __typename?: 'EmployeeUser', id: string, email: string, blocked: boolean, archived: boolean } | null, department?: { __typename?: 'EmployeeDepartment', id: string, name: string } | null, currentEmployment?: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } | null, employments: Array<{ __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean }> } };

export type UpdateEmployeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEmployeeInput;
  movement?: InputMaybe<MovementDetailsInput>;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', createdAt: string, id: string, firstName: string, lastName: string, employeeNumber?: string | null, user?: { __typename?: 'EmployeeUser', id: string, email: string, blocked: boolean, archived: boolean } | null, department?: { __typename?: 'EmployeeDepartment', id: string, name: string } | null, currentEmployment?: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } | null, employments: Array<{ __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean }> } };

export type StartEmploymentMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  input: EmploymentInput;
}>;


export type StartEmploymentMutation = { __typename?: 'Mutation', startEmployment: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } };

export type UpdateEmploymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: EmploymentInput;
  movement?: InputMaybe<MovementDetailsInput>;
}>;


export type UpdateEmploymentMutation = { __typename?: 'Mutation', updateEmployment: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } };

export type EndEmploymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: EndEmploymentInput;
}>;


export type EndEmploymentMutation = { __typename?: 'Mutation', endEmployment: { __typename?: 'Employment', id: string, startDate?: string | null, endDate?: string | null, employmentType?: EmploymentType | null, workingPattern?: WorkingPattern | null, exitType?: ExitType | null, exitReason?: string | null, isOpen: boolean } };

export type GetWorkshopJobsQueryVariables = Exact<{
  input?: InputMaybe<WorkshopJobListInput>;
}>;


export type GetWorkshopJobsQuery = { __typename?: 'Query', workshopJobs: { __typename?: 'WorkshopJobListResult', totalCount: number, items: Array<{ __typename?: 'WorkshopJob', id: string, stage: WorkshopJobStage, intakeReason: WorkshopJobIntakeReason, faultDescription?: string | null, openedAt: string, createdAt: string, closedAt?: string | null, scrapReason?: string | null, faultCategory?: { __typename?: 'FaultCategory', id: string, name: string } | null, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null }, stockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, assignedTo?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } };

export type GetWorkshopIntakeQueueQueryVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
}>;


export type GetWorkshopIntakeQueueQuery = { __typename?: 'Query', workshopIntakeQueue?: { __typename?: 'WorkshopIntakeQueue', source?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, items?: Array<{ __typename?: 'WorkshopIntakeCandidate', reportedFault?: string | null, reportedCondition?: DeviceCondition | null, arrivedAt?: string | null, stockItem?: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null } | null, reportedFaultCategory?: { __typename?: 'FaultCategory', id: string, name: string } | null, pendingTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null }> | null } | null };

export type GetWorkshopPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkshopPolicyQuery = { __typename?: 'Query', workshopPolicy?: { __typename?: 'WorkshopPolicy', maxTestTokenDays?: number | null, updatedAt?: string | null } | null };

export type GetWorkshopJobQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWorkshopJobQuery = { __typename?: 'Query', workshopJob: { __typename?: 'WorkshopJob', id: string, stage: WorkshopJobStage, intakeReason: WorkshopJobIntakeReason, faultDescription?: string | null, physicalState?: WorkshopJobPhysicalState | null, physicalStateNote?: string | null, comments?: string | null, completedAt?: string | null, closedAt?: string | null, scrapReason?: string | null, openedAt: string, createdAt: string, updatedAt: string, tokenTests: Array<{ __typename?: 'WorkshopTokenTest', id: string, createdAt: string, status: WorkshopTokenTestStatus, amount: number, vendor?: string | null, failureReason?: string | null, token?: string | null, tokenSequence?: number | null, deviceAccepted?: boolean | null, verdictAt?: string | null }>, partsUsed: Array<{ __typename?: 'StockMovement', id: string, createdAt: string, delta: number, reason: StockMovementReason, product: { __typename?: 'Product', id?: string | null, name?: string | null } }>, faultCategory?: { __typename?: 'FaultCategory', id: string, name: string } | null, faultType?: { __typename?: 'FaultType', id: string, name: string } | null, faultSubType?: { __typename?: 'FaultSubType', id: string, name: string } | null, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null, accountNumber?: string | null, productName?: string | null, status?: StockItemStatus | null, hasMeter: boolean, meterHasSecretKey: boolean, meterStartingCode?: string | null, meterTokenCount?: number | null, deviceType?: { __typename?: 'DeviceType', id?: string | null, name?: string | null } | null, purchaseOrder?: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null } | null, transferItems?: Array<{ __typename?: 'StockTransferItem', id?: string | null, transfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null, completedAt?: string | null, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, destinationStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } | null }> | null, sale?: { __typename?: 'StockSale', id?: string | null, contract?: { __typename?: 'Contract', id?: string | null, contractNumber?: string | null, status?: string | null } | null, customer?: { __typename?: 'Customer', id?: string | null, fullName?: string | null } | null } | null }, stockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null, type?: StockingPointType | null }, openedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } };

export type GetFaultCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFaultCategoriesQuery = { __typename?: 'Query', faultCategories: Array<{ __typename?: 'FaultCategory', id: string, name: string }> };

export type GetFaultTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFaultTypesQuery = { __typename?: 'Query', faultTypes: Array<{ __typename?: 'FaultType', id: string, name: string, subTypes: Array<{ __typename?: 'FaultSubType', id: string, name: string }> }> };

export type GetWorkshopBenchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkshopBenchesQuery = { __typename?: 'Query', stockingPoints?: { __typename?: 'StockingPointListResult', totalCount: number, items: Array<{ __typename?: 'StockingPoint', id?: string | null, name?: string | null }> } | null };

export type RegisterDeviceAtWorkshopMutationVariables = Exact<{
  input: RegisterDeviceAtWorkshopInput;
}>;


export type RegisterDeviceAtWorkshopMutation = { __typename?: 'Mutation', registerDeviceAtWorkshop: { __typename?: 'WorkshopJob', id: string, stage: WorkshopJobStage, intakeReason: WorkshopJobIntakeReason } };

export type CompleteRepairMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CompleteRepairInput;
}>;


export type CompleteRepairMutation = { __typename?: 'Mutation', completeRepair: { __typename?: 'WorkshopJob', id: string, stage: WorkshopJobStage, physicalState?: WorkshopJobPhysicalState | null, comments?: string | null, faultType?: { __typename?: 'FaultType', id: string, name: string } | null, faultSubType?: { __typename?: 'FaultSubType', id: string, name: string } | null } };

export type RecordTokenTestVerdictMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accepted: Scalars['Boolean']['input'];
}>;


export type RecordTokenTestVerdictMutation = { __typename?: 'Mutation', recordTokenTestVerdict: { __typename?: 'WorkshopTokenTest', id: string, deviceAccepted?: boolean | null, verdictAt?: string | null } };

export type ReleaseFromWorkshopMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReleaseFromWorkshopMutation = { __typename?: 'Mutation', releaseFromWorkshop: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } };

export type SetWorkshopJobIntakeReasonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  intakeReason: WorkshopJobIntakeReason;
}>;


export type SetWorkshopJobIntakeReasonMutation = { __typename?: 'Mutation', setWorkshopJobIntakeReason: { __typename?: 'WorkshopJob', id: string, intakeReason: WorkshopJobIntakeReason } };

export type GetFaultTaxonomyQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFaultTaxonomyQuery = { __typename?: 'Query', faultCategories: Array<{ __typename?: 'FaultCategory', id: string, name: string, isActive: boolean, sortOrder: number }>, faultTypes: Array<{ __typename?: 'FaultType', id: string, name: string, isActive: boolean, sortOrder: number, subTypes: Array<{ __typename?: 'FaultSubType', id: string, name: string, isActive: boolean, sortOrder: number }> }> };

export type CreateFaultCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateFaultCategoryMutation = { __typename?: 'Mutation', createFaultCategory: { __typename?: 'FaultCategory', id: string, name: string, isActive: boolean } };

export type UpdateFaultCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TaxonomyEntryUpdateInput;
}>;


export type UpdateFaultCategoryMutation = { __typename?: 'Mutation', updateFaultCategory: { __typename?: 'FaultCategory', id: string, name: string, isActive: boolean } };

export type DeleteFaultCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFaultCategoryMutation = { __typename?: 'Mutation', deleteFaultCategory: boolean };

export type CreateFaultTypeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateFaultTypeMutation = { __typename?: 'Mutation', createFaultType: { __typename?: 'FaultType', id: string, name: string, isActive: boolean } };

export type UpdateFaultTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TaxonomyEntryUpdateInput;
}>;


export type UpdateFaultTypeMutation = { __typename?: 'Mutation', updateFaultType: { __typename?: 'FaultType', id: string, name: string, isActive: boolean } };

export type DeleteFaultTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFaultTypeMutation = { __typename?: 'Mutation', deleteFaultType: boolean };

export type CreateFaultSubTypeMutationVariables = Exact<{
  faultTypeId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateFaultSubTypeMutation = { __typename?: 'Mutation', createFaultSubType: { __typename?: 'FaultSubType', id: string, name: string, isActive: boolean } };

export type UpdateFaultSubTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TaxonomyEntryUpdateInput;
}>;


export type UpdateFaultSubTypeMutation = { __typename?: 'Mutation', updateFaultSubType: { __typename?: 'FaultSubType', id: string, name: string, isActive: boolean } };

export type DeleteFaultSubTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFaultSubTypeMutation = { __typename?: 'Mutation', deleteFaultSubType: boolean };

export type ConfigureDeviceAtWorkshopMutationVariables = Exact<{
  input: ConfigureWorkshopDeviceInput;
}>;


export type ConfigureDeviceAtWorkshopMutation = { __typename?: 'Mutation', configureDeviceAtWorkshop: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, accountNumber?: string | null, status?: StockItemStatus | null } } };

export type ReceiveAtWorkshopMutationVariables = Exact<{
  input: ReceiveAtWorkshopInput;
}>;


export type ReceiveAtWorkshopMutation = { __typename?: 'Mutation', receiveAtWorkshop?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } | null };

export type UpdateWorkshopPolicyMutationVariables = Exact<{
  input: UpdateWorkshopPolicyInput;
}>;


export type UpdateWorkshopPolicyMutation = { __typename?: 'Mutation', updateWorkshopPolicy?: { __typename?: 'WorkshopPolicy', maxTestTokenDays?: number | null, updatedAt?: string | null } | null };

export type ReleaseFromWorkshopManyMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReleaseFromWorkshopManyMutation = { __typename?: 'Mutation', releaseFromWorkshopMany?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null };

export type ScrapDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type ScrapDeviceMutation = { __typename?: 'Mutation', scrapDevice?: { __typename?: 'WorkshopJob', id: string, stage: WorkshopJobStage, closedAt?: string | null, scrapReason?: string | null } | null };

export type GenerateTestTokenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  days: Scalars['Int']['input'];
}>;


export type GenerateTestTokenMutation = { __typename?: 'Mutation', generateTestToken: { __typename?: 'WorkshopTokenTest', id: string, status: WorkshopTokenTestStatus, token?: string | null, tokenSequence?: number | null, vendor?: string | null, amount: number, failureReason?: string | null, createdAt: string } };

export type GetPartStockQueryVariables = Exact<{
  stockingPointId: Scalars['String']['input'];
}>;


export type GetPartStockQuery = { __typename?: 'Query', partStock: Array<{ __typename?: 'StockLevel', id: string, quantity: number, reservedQuantity: number, condition: StockCondition, minimum?: number | null, isBelowMinimum: boolean, product: { __typename?: 'Product', id?: string | null, name?: string | null, itemCategoryId?: string | null, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } }> };

export type UsePartsMutationVariables = Exact<{
  input: PartMovementInput;
}>;


export type UsePartsMutation = { __typename?: 'Mutation', useParts: { __typename?: 'StockMovement', id: string, delta: number, product: { __typename?: 'Product', id?: string | null, name?: string | null } } };

export type ReturnPartsMutationVariables = Exact<{
  input: PartMovementInput;
}>;


export type ReturnPartsMutation = { __typename?: 'Mutation', returnParts: { __typename?: 'StockMovement', id: string, delta: number } };

export type GetPartsQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  stockingPointId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPartsQuery = { __typename?: 'Query', parts: Array<{ __typename?: 'Part', id: string, sku: string, name: string, itemCategoryId?: string | null, lastCostCents?: number | null, isActive: boolean, totalQuantity: number, reorderLevelAt?: number | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null, businessLine?: { __typename?: 'BusinessLine', id?: string | null, name?: string | null } | null, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id?: string | null, name?: string | null } | null }> };

export type GetPartsToRequestQueryVariables = Exact<{
  benchId: Scalars['String']['input'];
}>;


export type GetPartsToRequestQuery = { __typename?: 'Query', parts: Array<{ __typename?: 'Part', id: string, name: string, headOfficeQuantity: number, elsewhereQuantity: number }> };

export type CreatePartMutationVariables = Exact<{
  input: PartInput;
}>;


export type CreatePartMutation = { __typename?: 'Mutation', createPart: { __typename?: 'Part', id: string, name: string } };

export type UpdatePartMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PartInput;
}>;


export type UpdatePartMutation = { __typename?: 'Mutation', updatePart: { __typename?: 'Part', id: string, name: string, isActive: boolean } };

export type ReceivePartsMutationVariables = Exact<{
  input: PartMovementInput;
}>;


export type ReceivePartsMutation = { __typename?: 'Mutation', receiveParts: { __typename?: 'StockMovement', id: string, delta: number } };

export type AdjustPartStockMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  stockingPointId: Scalars['String']['input'];
  delta: Scalars['Int']['input'];
  note: Scalars['String']['input'];
}>;


export type AdjustPartStockMutation = { __typename?: 'Mutation', adjustPartStock?: { __typename?: 'StockMovement', id: string, delta: number } | null };

export type PartRequestFieldsFragment = { __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type GetPartRequestsQueryVariables = Exact<{
  input?: InputMaybe<PartRequestListInput>;
}>;


export type GetPartRequestsQuery = { __typename?: 'Query', partRequests: { __typename?: 'PartRequestListResult', totalCount: number, items: Array<{ __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null }> } };

export type RaisePartRequestMutationVariables = Exact<{
  input: RaisePartRequestInput;
}>;


export type RaisePartRequestMutation = { __typename?: 'Mutation', raisePartRequest: { __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } };

export type LinkPartRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
}>;


export type LinkPartRequestMutation = { __typename?: 'Mutation', linkPartRequest?: { __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type AddPartFromRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PartInput;
}>;


export type AddPartFromRequestMutation = { __typename?: 'Mutation', addPartFromRequest?: { __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type SendPartRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SourcePartRequestInput;
}>;


export type SendPartRequestMutation = { __typename?: 'Mutation', sendPartRequest: { __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } };

export type ReceivePartRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReceivePartRequestMutation = { __typename?: 'Mutation', receivePartRequest: { __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } };

export type RejectPartRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  resolutionNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectPartRequestMutation = { __typename?: 'Mutation', rejectPartRequest: { __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } };

export type CancelPartRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  resolutionNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelPartRequestMutation = { __typename?: 'Mutation', cancelPartRequest: { __typename?: 'PartRequest', id: string, createdAt: string, quantity: number, status: PartRequestStatus, route?: PartRequestRoute | null, reference?: string | null, note?: string | null, resolutionNote?: string | null, description?: string | null, sentAt?: string | null, receivedAt?: string | null, part?: { __typename?: 'Part', id: string, name: string, itemCategoryId?: string | null, headOfficeQuantity: number, itemCategory?: { __typename?: 'ItemCategory', id: string, path: string } | null } | null, destinationStockingPoint: { __typename?: 'StockingPoint', id?: string | null, name?: string | null }, sourceStockingPoint?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id?: string | null, name?: string | null } | null, stockTransfer?: { __typename?: 'StockTransfer', id?: string | null, transferNumber?: string | null, status?: TransferStatus | null } | null, purchaseOrderLine?: { __typename?: 'PurchaseOrderLine', id: string, purchaseOrder: { __typename?: 'PurchaseOrder', id?: string | null, purchaseOrderNumber?: string | null, status?: PurchaseOrderStatus | null, destination?: { __typename?: 'StockingPoint', id?: string | null, name?: string | null } | null } } | null, workshopJob?: { __typename?: 'WorkshopJob', id: string, stockItem: { __typename?: 'StockItem', id?: string | null, serialNumber?: string | null } } | null, requestedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null } | null } };

export type WorkshopDeviceSecretQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type WorkshopDeviceSecretQuery = { __typename?: 'Query', workshopDeviceSecret: { __typename?: 'RevealedDeviceSecret', jobId: string, identifier: string, secretKey?: string | null, tokenCount?: number | null } };

export type GetWorkshopStatsQueryVariables = Exact<{
  input: WorkshopStatsInput;
}>;


export type GetWorkshopStatsQuery = { __typename?: 'Query', workshopStats: { __typename?: 'WorkshopStats', from: string, to: string, totals: { __typename?: 'WorkshopStatsCounts', received: number, processed: number, repaired: number, pendingParts: number, scrapped: number }, byDeviceType: Array<{ __typename?: 'WorkshopStatsRow', id?: string | null, name?: string | null, faultTypeName?: string | null, received: number, processed: number, repaired: number, pendingParts: number, scrapped: number }>, byProduct: Array<{ __typename?: 'WorkshopStatsRow', id?: string | null, name?: string | null, faultTypeName?: string | null, received: number, processed: number, repaired: number, pendingParts: number, scrapped: number }>, byFaultType: Array<{ __typename?: 'WorkshopStatsRow', id?: string | null, name?: string | null, faultTypeName?: string | null, received: number, processed: number, repaired: number, pendingParts: number, scrapped: number }>, byFaultSubType: Array<{ __typename?: 'WorkshopStatsRow', id?: string | null, name?: string | null, faultTypeName?: string | null, received: number, processed: number, repaired: number, pendingParts: number, scrapped: number }> } };

export type WorkshopStatsCountsFieldsFragment = { __typename?: 'WorkshopStatsCounts', received: number, processed: number, repaired: number, pendingParts: number, scrapped: number };

export type WorkshopStatsRowFieldsFragment = { __typename?: 'WorkshopStatsRow', id?: string | null, name?: string | null, faultTypeName?: string | null, received: number, processed: number, repaired: number, pendingParts: number, scrapped: number };

export const AgentAgreementDetailFragmentDoc = gql`
    fragment AgentAgreementDetail on AgentAgreement {
  id
  status
  partyType
  templateVersion
  decisionReason
  issuedAt
  signedAt
  signingDate
  consentAcceptedAt
  documentHash
  signatureMethod
  slaDueAt
  slaBreached
  reviewedAt
  countersignedAt
  countersignedByName
  reminderCount
  createdAt
  partyNameSnapshot
  partyIdNumberSnapshot
  partyRegistrationNumberSnapshot
  partyAddressSnapshot
  signatoryNameSnapshot
  signatoryCapacitySnapshot
  template {
    id
    title
    version
    partyType
    consentStatement
  }
  agent {
    id
    firstName
    lastName
    salesId
    agentType
    agreementStatus
  }
  signedBy {
    id
    firstName
    lastName
    email
  }
  reviewedBy {
    id
    firstName
    lastName
    email
  }
  documents {
    id
    documentType
    originalName
    mimeType
    size
    createdAt
  }
  events {
    id
    createdAt
    fromStatus
    toStatus
    reason
    actor {
      id
      firstName
      lastName
    }
  }
}
    `;
export const AgentDisputeFieldsFragmentDoc = gql`
    fragment AgentDisputeFields on Agent {
  id
  firstName
  lastName
  externalAgentId
  needsParentReconciliation
  pendingParentExternalId
  parentDisputed
  parentDisputeReason
  profileDisputed
  disputedFirstName
  disputedLastName
  dccFirstNameSnapshot
  dccLastNameSnapshot
  dccRamIdSnapshot
  dccRamNameSnapshot
  expectedParentExternalId
  parentMismatch
  agentCategory {
    id
    name
  }
  parentAgent {
    id
    firstName
    lastName
    externalAgentId
  }
}
    `;
export const AgentInviteApprovalFieldsFragmentDoc = gql`
    fragment AgentInviteApprovalFields on AgentInviteApproval {
  id
  status
  email
  firstName
  lastName
  agentType
  agentCategoryName
  claimsDormantAgent
  createdAt
  reviewedAt
  reviewNotes
  parentAgent {
    id
    firstName
    lastName
    salesId
  }
  requestedBy {
    id
    firstName
    lastName
    email
  }
  reviewedBy {
    id
    firstName
    lastName
    email
  }
}
    `;
export const ApiConsumerFieldsFragmentDoc = gql`
    fragment ApiConsumerFields on ApiConsumer {
  id
  name
  clientId
  scopes
  isActive
  expiresAt
  lastUsedAt
  contactEmail
  createdAt
  updatedAt
}
    `;
export const ApplicationFieldsFragmentDoc = gql`
    fragment ApplicationFields on Application {
  id
  referenceNumber
  employer
  income
  employmentStatus
  status
  metadata
  createdAt
  updatedAt
  customer {
    id
    firstName
    lastName
    fullName
  }
  createdBy {
    id
    firstName
    lastName
  }
}
    `;
export const DocumentFieldsFragmentDoc = gql`
    fragment DocumentFields on Document {
  id
  fileName
  originalName
  mimeType
  size
  documentType
  createdAt
  uploadedBy {
    id
    firstName
    lastName
  }
}
    `;
export const ChangeHistoryFieldsFragmentDoc = gql`
    fragment ChangeHistoryFields on ApplicationChangeHistory {
  id
  fieldName
  oldValue
  newValue
  changeType
  createdAt
  changedBy {
    id
    firstName
    lastName
  }
}
    `;
export const AttendanceEmployeeFieldsFragmentDoc = gql`
    fragment AttendanceEmployeeFields on AttendanceEmployee {
  id
  firstName
  lastName
  employeeNumber
  department {
    id
    name
  }
}
    `;
export const AttendanceRecordFieldsFragmentDoc = gql`
    fragment AttendanceRecordFields on AttendanceRecord {
  id
  employee {
    ...AttendanceEmployeeFields
  }
  date
  status
  hoursWorked
  overtimeHours
  notes
  source
  importedAt
}
    ${AttendanceEmployeeFieldsFragmentDoc}`;
export const LeaveTypeFieldsFragmentDoc = gql`
    fragment LeaveTypeFields on LeaveType {
  id
  category
  name
  entitlementDays
  cycleMonths
  paid
  active
}
    `;
export const LeaveRequestFieldsFragmentDoc = gql`
    fragment LeaveRequestFields on LeaveRequest {
  id
  employee {
    ...AttendanceEmployeeFields
  }
  leaveType {
    id
    category
    name
  }
  startDate
  endDate
  days
  reason
  status
  approver {
    id
    email
    firstName
    lastName
  }
  decidedAt
  decisionNote
  source
  createdAt
}
    ${AttendanceEmployeeFieldsFragmentDoc}`;
export const LeaveBalanceFieldsFragmentDoc = gql`
    fragment LeaveBalanceFields on LeaveBalance {
  id
  employee {
    ...AttendanceEmployeeFields
  }
  leaveType {
    id
    category
    name
  }
  cycleStart
  cycleEnd
  entitlementDays
  takenDays
  takenFromRequests
  remainingDays
  source
}
    ${AttendanceEmployeeFieldsFragmentDoc}`;
export const HrImportResultFieldsFragmentDoc = gql`
    fragment HrImportResultFields on HrImportResult {
  imported
  errors {
    line
    message
  }
  unmatched {
    line
    employeeNumber
    name
    reason
  }
}
    `;
export const BankVerificationDetailFragmentDoc = gql`
    fragment BankVerificationDetail on BankVerification {
  id
  status
  decisionReason
  submittedAt
  slaDueAt
  slaBreached
  hasStaleProof
  reviewedAt
  reminderCount
  bankNameSnapshot
  bankAccountNumberSnapshot
  bankBranchCodeSnapshot
  bankAccountHolderSnapshot
  createdAt
  agent {
    id
    firstName
    lastName
    salesId
    bankVerificationStatus
  }
  reviewedBy {
    id
    firstName
    lastName
    email
  }
  documents {
    id
    originalName
    mimeType
    size
    createdAt
  }
  events {
    id
    createdAt
    fromStatus
    toStatus
    reason
    actor {
      id
      firstName
      lastName
    }
  }
}
    `;
export const CallCardFieldsFragmentDoc = gql`
    fragment CallCardFields on Call {
  id
  occurredAt
  source
  callType
  durationSeconds
  dispositionOne
  dispositionTwo
  dispositionThree
  notes
  statedIssue
  solutionToIssue
  callerNumber
  contract {
    id
    contractNumber
  }
  loggedBy {
    id
    firstName
    lastName
  }
}
    `;
export const CommissionApproachSettingsFieldsFragmentDoc = gql`
    fragment CommissionApproachSettingsFields on CommissionApproachSettings {
  currentPeriod
  currentApproach
  collectedFrom
  earliestFromPeriod
  changes {
    id
    fromPeriod
    approach
    createdAt
    changedByName
    removable
  }
}
    `;
export const RunningCommissionFigureFieldsFragmentDoc = gql`
    fragment RunningCommissionFigureFields on RunningCommissionFigure {
  agentId
  agentName
  periodDate
  computedAt
  saleCommissionCents
  monthlyAmountCents
  feeCents
  totalCents
  saleMonths
  paidUnits
}
    `;
export const DeviceReassignmentFieldsFragmentDoc = gql`
    fragment DeviceReassignmentFields on DeviceReassignment {
  id
  createdAt
  previousSerialNumber
  previousAccountNumber
  newSerialNumber
  newAccountNumber
  cause
  notes
  contractPaidThroughAt
  deviceLoadedThroughAt
  tokenDaysShortfall
  swapGroupId
  customerNotifiedAt
  creditRecoveryTotal
  creditRecoveryPerPayment
  creditRecoveryRemaining
  performedBy {
    id
    firstName
    lastName
    email
  }
}
    `;
export const DigitalChannelFieldsFragmentDoc = gql`
    fragment DigitalChannelFields on DigitalChannel {
  id
  name
  kind
  gaPropertyId
  sortOrder
  isActive
}
    `;
export const DigitalChannelTotalsFieldsFragmentDoc = gql`
    fragment DigitalChannelTotalsFields on DigitalChannelTotals {
  activeUsers
  newUsers
  sessions
  averageEngagementSeconds
}
    `;
export const EmployeeDemographicsFieldsFragmentDoc = gql`
    fragment EmployeeDemographicsFields on EmployeeDemographics {
  employeeId
  gender
  race
  hasDisability
  dateOfBirth
  jobLevel
  isManagement
  team {
    id
    name
    departmentId
  }
  jobPosition {
    id
    title
    level
  }
  updatedAt
}
    `;
export const TeamFieldsFragmentDoc = gql`
    fragment TeamFields on Team {
  id
  name
  memberCount
  department {
    id
    name
  }
}
    `;
export const JobPositionFieldsFragmentDoc = gql`
    fragment JobPositionFields on JobPosition {
  id
  title
  level
  holderCount
}
    `;
export const EsgProgrammeFieldsFragmentDoc = gql`
    fragment EsgProgrammeFields on EsgProgramme {
  id
  name
  category
  bbbeeElement
  description
  startDate
  endDate
  budget
  status
  owner {
    id
    email
    firstName
    lastName
  }
  location
  municipality
  spentToDate
  budgetUsedPercent
  beneficiaryCount
}
    `;
export const EsgSpendFieldsFragmentDoc = gql`
    fragment EsgSpendFields on EsgSpend {
  id
  spendDate
  amount
  description
  files {
    id
    originalName
    mimeType
    size
    createdAt
  }
}
    `;
export const EsgBeneficiaryFieldsFragmentDoc = gql`
    fragment EsgBeneficiaryFields on EsgBeneficiary {
  id
  name
  type
  reachedDate
  peopleCount
  gender
  isYouth
  hasDisability
  location
  employee {
    id
    firstName
    lastName
    employeeNumber
  }
  notes
}
    `;
export const EsgOutcomeFieldsFragmentDoc = gql`
    fragment EsgOutcomeFields on EsgOutcome {
  id
  metricName
  value
  unit
  measuredDate
  notes
}
    `;
export const EsgVolunteeringFieldsFragmentDoc = gql`
    fragment EsgVolunteeringFields on EsgVolunteering {
  id
  employee {
    id
    firstName
    lastName
    employeeNumber
  }
  activityDate
  hours
  notes
}
    `;
export const GrievanceOfficerFieldsFragmentDoc = gql`
    fragment GrievanceOfficerFields on GrievanceOfficer {
  id
  name
  email
}
    `;
export const GrievanceSummaryFieldsFragmentDoc = gql`
    fragment GrievanceSummaryFields on Grievance {
  id
  reference
  source
  status
  subject
  openedAt
  acknowledgedAt
  resolvedAt
  retaliationConcern
  category {
    id
    code
    label
  }
  owner {
    ...GrievanceOfficerFields
  }
}
    ${GrievanceOfficerFieldsFragmentDoc}`;
export const GrievanceDetailFieldsFragmentDoc = gql`
    fragment GrievanceDetailFields on Grievance {
  ...GrievanceSummaryFields
  description
  closedAt
  withdrawnAt
  resolutionNotes
  incidentDate
  incidentLocation
  involvement
  managementAware
  desiredOutcome
  outcome {
    id
    code
    label
  }
  events {
    id
    type
    fromStatus
    toStatus
    note
    createdAt
    actor {
      ...GrievanceOfficerFields
    }
  }
  messages {
    id
    from
    body
    createdAt
    author {
      ...GrievanceOfficerFields
    }
  }
}
    ${GrievanceSummaryFieldsFragmentDoc}
${GrievanceOfficerFieldsFragmentDoc}`;
export const GrievanceSettingsFieldsFragmentDoc = gql`
    fragment GrievanceSettingsFields on GrievanceSettings {
  messagesEnabled
  extraQuestionsEnabled
  contactPhone
  contactEmail
  contactHours
  replyPromiseWorkingDays
}
    `;
export const GrievanceDurationsFieldsFragmentDoc = gql`
    fragment GrievanceDurationsFields on GrievanceDurations {
  count
  medianHours
  p90Hours
}
    `;
export const HrCaseFieldsFragmentDoc = gql`
    fragment HrCaseFields on HrCase {
  id
  employee {
    id
    firstName
    lastName
    employeeNumber
    departmentName
  }
  type
  status
  openedDate
  closedDate
  description
  cost
  offenceCategory
  sanction
  warningExpiryDate
  caseNumber
  referralDate
  stage
  outcome
  openedBy {
    id
    email
    firstName
    lastName
  }
  updatedAt
}
    `;
export const ItemCategoryFieldsFragmentDoc = gql`
    fragment ItemCategoryFields on ItemCategory {
  id
  name
  position
  parentId
  path
  productCount
}
    `;
export const EmployeeMovementFieldsFragmentDoc = gql`
    fragment EmployeeMovementFields on EmployeeMovement {
  id
  effectiveDate
  movementType
  reason
  recordedAt
  recordedByName
  diversityHidden
  changes {
    field
    from
    to
    fromLabel
    toLabel
  }
}
    `;
export const NoteCardFieldsFragmentDoc = gql`
    fragment NoteCardFields on Note {
  id
  body
  format
  visibility
  revisionCount
  isEdited
  isRedacted
  canEdit
  canModerate
  lastEditedAt
  pinnedAt
  createdAt
  archivedAt
  archivedReason
  redactedAt
  redactedReason
  category {
    id
    name
    color
  }
  contract {
    id
    contractNumber
  }
  createdBy {
    id
    firstName
    lastName
  }
  pinnedBy {
    id
    firstName
    lastName
  }
  redactedBy {
    id
    firstName
    lastName
  }
}
    `;
export const PaymentRatingThresholdsFragmentDoc = gql`
    fragment PaymentRatingThresholds on PaymentRatingPolicy {
  excellentMaxPercent
  goodMaxPercent
  fairMaxPercent
  poorMaxPercent
}
    `;
export const PaymentReallocationFieldsFragmentDoc = gql`
    fragment PaymentReallocationFields on PaymentReallocation {
  id
  createdAt
  appliedAt
  reason
  notes
  creditRecoveryTotal
  creditRecoveryPerPayment
  creditRecoveryRemaining
  sourcePayment {
    id
    referenceCode
    amount
  }
  sourceContract {
    id
    contractNumber
  }
  destinationContract {
    id
    contractNumber
  }
  destinationPayment {
    id
    referenceCode
  }
  performedBy {
    id
    firstName
    lastName
  }
}
    `;
export const PayRunFieldsFragmentDoc = gql`
    fragment PayRunFields on PayRun {
  id
  periodMonth
  status
  payDate
  notes
  source
  importedAt
  finalisedAt
  finalisedBy {
    id
    email
    firstName
    lastName
  }
  lineCount
  totalGross
  linesWithoutGross
}
    `;
export const PayrollEmployeeFieldsFragmentDoc = gql`
    fragment PayrollEmployeeFields on PayrollEmployee {
  id
  firstName
  lastName
  employeeNumber
  department {
    id
    name
  }
}
    `;
export const PayslipFieldsFragmentDoc = gql`
    fragment PayslipFields on Payslip {
  id
  employee {
    ...PayrollEmployeeFields
  }
  gross
  net
  basic
  overtimePay
  allowances
  deductions
  paye
  uifEmployee
  uifEmployer
  sdl
  employerPension
  employerMedical
  source
  importedAt
}
    ${PayrollEmployeeFieldsFragmentDoc}`;
export const EmployeeBenefitFieldsFragmentDoc = gql`
    fragment EmployeeBenefitFields on EmployeeBenefit {
  id
  employee {
    ...PayrollEmployeeFields
  }
  type
  provider
  planName
  startDate
  endDate
  employerContribution
  employeeContribution
  notes
  source
}
    ${PayrollEmployeeFieldsFragmentDoc}`;
export const ReviewCycleFieldsFragmentDoc = gql`
    fragment ReviewCycleFields on ReviewCycle {
  id
  name
  periodStart
  periodEnd
  dueDate
  reviewCount
  completedCount
}
    `;
export const PerformanceReviewFieldsFragmentDoc = gql`
    fragment PerformanceReviewFields on PerformanceReview {
  id
  cycle {
    id
    name
    periodStart
    periodEnd
  }
  employee {
    id
    firstName
    lastName
  }
  reviewer {
    id
    email
    firstName
    lastName
  }
  rating
  status
  comments
  reviewDate
  updatedAt
}
    `;
export const ImprovementPlanFieldsFragmentDoc = gql`
    fragment ImprovementPlanFields on ImprovementPlan {
  id
  employee {
    id
    firstName
    lastName
  }
  startDate
  endDate
  status
  objectives
  notes
}
    `;
export const ProbationFieldsFragmentDoc = gql`
    fragment ProbationFields on Probation {
  id
  endDate
  outcome
  extendedTo
  effectiveEndDate
  notes
}
    `;
export const PermissionChangeRequestFieldsFragmentDoc = gql`
    fragment PermissionChangeRequestFields on PermissionChangeRequest {
  id
  createdAt
  kind
  status
  summary
  sensitive
  affectedUserCount
  expiresAt
  reviewNotes
  reviewedAt
  requestedById
  requestedByName
  targetUserName
  reviewedByName
}
    `;
export const PhoneNumberUpdateRequestFieldsFragmentDoc = gql`
    fragment PhoneNumberUpdateRequestFields on PhoneNumberUpdateRequest {
  id
  status
  newPhone
  oldPhone
  maskedNewPhone
  maskedOldPhone
  expiresAt
  verifiedAt
  otpAttempts
  resendCount
  attemptsRemaining
  resendsRemaining
  createdAt
}
    `;
export const PurchaseOrderLineFieldsFragmentDoc = gql`
    fragment PurchaseOrderLineFields on PurchaseOrderLine {
  id
  quantity
  unitCostCents
  receivedQuantity
  receivedAt
  product {
    id
    sku
    name
    kind
  }
}
    `;
export const PayAtDumpRowFieldsFragmentDoc = gql`
    fragment PayAtDumpRowFields on PayAtDumpRow {
  id
  rowIndex
  store
  tillDate
  rawReference
  accountNumber
  totalCents
  feeCents
  tenderType
  status
  matchedAt
  matchedBy
  claimedCents
  varianceCents
  contract {
    id
    contractNumber
    customer {
      id
      fullName
    }
  }
  payments {
    id
    createdAt
    referenceCode
    accountNumber
    amount
    token
    bankConfirmed
    confirmationRef
    createdBy
  }
}
    `;
export const PayAtWeekTotalFragmentDoc = gql`
    fragment PayAtWeekTotal on PayAtReconciliationSummary {
  from
  to
  lines
  totalCents
}
    `;
export const RecruitmentCostFieldsFragmentDoc = gql`
    fragment RecruitmentCostFields on RecruitmentCost {
  id
  category
  amount
  incurredDate
  description
}
    `;
export const RecruitmentUserFieldsFragmentDoc = gql`
    fragment RecruitmentUserFields on RecruitmentUser {
  id
  email
  firstName
  lastName
}
    `;
export const VacancyFieldsFragmentDoc = gql`
    fragment VacancyFields on Vacancy {
  id
  title
  departmentId
  departmentName
  jobPositionId
  jobPositionTitle
  headcount
  reason
  openedDate
  targetFillDate
  closedDate
  status
  hiringManager {
    ...RecruitmentUserFields
  }
  notes
  applicationCount
  hiredCount
  totalCost
}
    ${RecruitmentUserFieldsFragmentDoc}`;
export const CandidateFieldsFragmentDoc = gql`
    fragment CandidateFields on Candidate {
  id
  firstName
  lastName
  email
  phone
  source
  sourceDetail
  notes
  documents {
    id
    originalName
    mimeType
    size
    createdAt
  }
  applications {
    id
    stage
    appliedDate
    vacancyId
    vacancyTitle
    vacancyStatus
  }
}
    `;
export const JobApplicationFieldsFragmentDoc = gql`
    fragment JobApplicationFields on JobApplication {
  id
  vacancyId
  vacancyTitle
  candidate {
    id
    firstName
    lastName
    email
    phone
    source
  }
  appliedDate
  stage
  stageDate
  offer {
    id
    offeredDate
    startDate
    employmentType
    workingPattern
    acceptedDate
    declinedDate
    notes
  }
  employee {
    id
    firstName
    lastName
  }
  history {
    id
    fromStage
    toStage
    date
    notes
    movedBy {
      ...RecruitmentUserFields
    }
  }
}
    ${RecruitmentUserFieldsFragmentDoc}`;
export const CustomerBookTrendSeriesFragmentDoc = gql`
    fragment CustomerBookTrendSeries on CustomerBookTrendSeries {
  activeContracts
  tokenOut
  noPayment90
}
    `;
export const CustomerBookActivityFiguresFragmentDoc = gql`
    fragment CustomerBookActivityFigures on CustomerBookActivityFigures {
  openingCustomers
  openingContracts
  closingCustomers
  closingContracts
  newContracts
  paidAgain
  returned
  tokenRanOut
  paidOff
  repossessed
  writtenOff
  cancelled
  openingTokenOut
  closingTokenOut
  openingNoPayment90
  closingNoPayment90
  closingPaidOffContracts
  closingRepossessedContracts
  closingWrittenOffContracts
  closingTokenOutCustomers
  closingPaidOffCustomers
  closingRepossessedCustomers
  closingWrittenOffCustomers
}
    `;
export const StockOnHandFieldsFragmentDoc = gql`
    fragment StockOnHandFields on StockOnHand {
  available
  reserved
  damaged
  inTransit
  inWorkshop
  onHand
  sold
  issued
}
    `;
export const StockValuationProductFieldsFragmentDoc = gql`
    fragment StockValuationProductFields on StockValuationProduct {
  id
  sku
  name
  kind
  lastCostCents
  unitOfMeasureName
}
    `;
export const DeviceHistoryEntryFieldsFragmentDoc = gql`
    fragment DeviceHistoryEntryFields on DeviceHistoryEntry {
  at
  kind
  summary
  reference
}
    `;
export const ReturnToHeadOfficeDeviceFieldsFragmentDoc = gql`
    fragment ReturnToHeadOfficeDeviceFields on ReturnToHeadOfficeDevice {
  stockItemId
  serialNumber
  accountNumber
  productName
  status
  condition
  declinedAt
  recentHistory {
    ...DeviceHistoryEntryFields
  }
}
    ${DeviceHistoryEntryFieldsFragmentDoc}`;
export const ReturnToHeadOfficeSummaryFieldsFragmentDoc = gql`
    fragment ReturnToHeadOfficeSummaryFields on ReturnToHeadOffice {
  id
  returnNumber
  status
  transferStatus
  approvalStatus
  sourceStockingPointName
  destinationStockingPointName
  agentName
  submittedByName
  submittedAt
  reviewedByName
  reviewedAt
  deviceCount
  declinedCount
  shippingCompanyName
  waybillReference
}
    `;
export const SafetyUserFieldsFragmentDoc = gql`
    fragment SafetyUserFields on SafetyUser {
  id
  email
  firstName
  lastName
}
    `;
export const SafetyCorrectiveActionFieldsFragmentDoc = gql`
    fragment SafetyCorrectiveActionFields on SafetyCorrectiveAction {
  id
  description
  owner {
    ...SafetyUserFields
  }
  dueDate
  doneDate
  notes
}
    ${SafetyUserFieldsFragmentDoc}`;
export const SafetyIncidentFieldsFragmentDoc = gql`
    fragment SafetyIncidentFields on SafetyIncident {
  id
  occurredAt
  location
  type
  severity
  department {
    id
    name
  }
  employee {
    id
    firstName
    lastName
    employeeNumber
    departmentName
  }
  subcontractor {
    id
    name
  }
  subcontractorWorker {
    id
    firstName
    lastName
  }
  description
  injuryDetails
  lostDays
  reportable
  coidaClaimNumber
  coidaClaimStatus
  rootCause
  status
  closedDate
  reportedBy {
    ...SafetyUserFields
  }
  actions {
    ...SafetyCorrectiveActionFields
  }
  evidence {
    id
    originalName
    mimeType
    size
    createdAt
  }
  createdAt
}
    ${SafetyUserFieldsFragmentDoc}
${SafetyCorrectiveActionFieldsFragmentDoc}`;
export const SafetyInspectionFieldsFragmentDoc = gql`
    fragment SafetyInspectionFields on SafetyInspection {
  id
  type
  inspectionDate
  area
  department {
    id
    name
  }
  inspectorName
  scorePercent
  findingsCount
  notes
}
    `;
export const SalesAppMessageFieldsFragmentDoc = gql`
    fragment SalesAppMessageFields on SalesAppMessage {
  id
  category
  title
  message
  audience
  agentIds
  status
  sentTo
  alreadySent
  unknownAgentIds
  lastError
  attempts
  sentAt
  resentFromId
  createdAt
  sentByName
}
    `;
export const SellerCorrectionAgentFieldsFragmentDoc = gql`
    fragment SellerCorrectionAgentFields on SellerCorrectionAgent {
  id
  name
  salesId
  agentType
  status
}
    `;
export const SellerCorrectionSaleFieldsFragmentDoc = gql`
    fragment SellerCorrectionSaleFields on SellerCorrectionSale {
  stockSaleId
  saleReference
  accountNumber
  serialNumber
  contractNumber
  customerName
  productName
  saleDate
  status
  distributorPinned
  seller {
    ...SellerCorrectionAgentFields
  }
  distributor {
    ...SellerCorrectionAgentFields
  }
  sellerPaidAmountCents
  sellerPaidEntryCount
  sellerUnpaidAmountCents
  sellerUnpaidEntryCount
}
    ${SellerCorrectionAgentFieldsFragmentDoc}`;
export const SellerCorrectionFieldsFragmentDoc = gql`
    fragment SellerCorrectionFields on SellerCorrection {
  id
  createdAt
  stockSaleId
  saleReference
  accountNumber
  serialNumber
  customerName
  fromAgentId
  fromAgentName
  toAgentId
  toAgentName
  fromDistributorName
  toDistributorName
  movedEntryCount
  paidEntryCount
  paidAmountCents
  cancelledEntryCount
  cancelledAmountCents
  reason
  source
  correctedByName
}
    `;
export const AgentNameMatchFieldsFragmentDoc = gql`
    fragment AgentNameMatchFields on AgentNameMatch {
  status
  agent {
    ...SellerCorrectionAgentFields
  }
  candidates {
    ...SellerCorrectionAgentFields
  }
}
    ${SellerCorrectionAgentFieldsFragmentDoc}`;
export const ShipmentFieldsFragmentDoc = gql`
    fragment ShipmentFields on Shipment {
  id
  courier
  waybillNumber
  state
  statusLabel
  events
  details
  courierDeliveredAt
  lastCheckedAt
  lastError
  closedAt
}
    `;
export const SmsCampaignFieldsFragmentDoc = gql`
    fragment SmsCampaignFields on SmsCampaign {
  id
  name
  body
  audience
  status
  scheduledAt
  startedAt
  completedAt
  lastError
  createdAt
  createdByName
  sentByName
  copiedFromId
  counts {
    total
    pending
    sent
    delivered
    failed
    skipped
  }
}
    `;
export const StockBalanceRowFieldsFragmentDoc = gql`
    fragment StockBalanceRowFields on StockBalanceRow {
  product {
    id
    sku
    name
    kind
    isActive
    requiresSerialTracking
    unitOfMeasureName
    businessLineName
    itemCategoryName
  }
  places {
    stockingPointId
    quantity
    minimum
    belowMinimum
  }
  inTransit
  damagedQuantity
  total
  valueCents
  unitCostCents
  belowMinimumCount
  onOrder
  lastIssuedAt
}
    `;
export const StockCardMovementFieldsFragmentDoc = gql`
    fragment StockCardMovementFields on StockCardMovement {
  id
  at
  reason
  document
  storeName
  productId
  productName
  productSku
  quantityIn
  quantityOut
  balance
  note
  recordedByName
}
    `;
export const StockTakeHeaderFragmentDoc = gql`
    fragment StockTakeHeader on StockTake {
  id
  takeNumber
  status
  wholePoint
  countsUnits
  note
  statusReason
  createdAt
  submittedAt
  approvedAt
  cancelledAt
  stockingPoint {
    id
    name
  }
  openedBy {
    id
    firstName
    lastName
  }
  submittedBy {
    id
    firstName
    lastName
  }
  approvedBy {
    id
    firstName
    lastName
  }
  cancelledBy {
    id
    firstName
    lastName
  }
  summary {
    lineCount
    countedLineCount
    shortQuantity
    overQuantity
    varianceValueCents
    unpricedLineCount
    foundUnits
    missingUnits
    unexpectedUnits
    missingValueCents
  }
}
    `;
export const SubcontractorFieldsFragmentDoc = gql`
    fragment SubcontractorFields on Subcontractor {
  id
  name
  registrationNumber
  bbbeeLevel
  contactName
  contactEmail
  contactPhone
  services
  contractStart
  contractEnd
  contractValue
  status
  notes
  activeWorkerCount
}
    `;
export const SubcontractorWorkerFieldsFragmentDoc = gql`
    fragment SubcontractorWorkerFields on SubcontractorWorker {
  id
  subcontractor {
    id
    name
  }
  firstName
  lastName
  idNumber
  role
  agent {
    id
    firstName
    lastName
    salesId
  }
  inductionDate
  active
}
    `;
export const SubcontractorHoursFieldsFragmentDoc = gql`
    fragment SubcontractorHoursFields on SubcontractorHours {
  id
  worker {
    id
    firstName
    lastName
    subcontractor {
      id
      name
    }
  }
  periodStart
  periodEnd
  hours
  notes
}
    `;
export const SubcontractorInvoiceFieldsFragmentDoc = gql`
    fragment SubcontractorInvoiceFields on SubcontractorInvoice {
  id
  invoiceNumber
  invoiceDate
  amount
  notes
}
    `;
export const SubcontractorComplianceFieldsFragmentDoc = gql`
    fragment SubcontractorComplianceFields on SubcontractorComplianceDocument {
  id
  subcontractor {
    id
    name
  }
  type
  reference
  issuedDate
  expiryDate
  notes
  files {
    id
    originalName
    mimeType
    size
    createdAt
  }
}
    `;
export const TrainingCourseFieldsFragmentDoc = gql`
    fragment TrainingCourseFields on TrainingCourse {
  id
  name
  provider
  category
  accredited
  mandatory
  validityMonths
  sessionCount
  certificationCount
}
    `;
export const TrainingPersonFieldsFragmentDoc = gql`
    fragment TrainingPersonFields on TrainingPerson {
  id
  firstName
  lastName
  employeeNumber
  departmentName
}
    `;
export const TrainingSessionFieldsFragmentDoc = gql`
    fragment TrainingSessionFields on TrainingSession {
  id
  employee {
    ...TrainingPersonFields
  }
  course {
    id
    name
    category
    mandatory
    validityMonths
  }
  startDate
  endDate
  hours
  cost
  status
  notes
}
    ${TrainingPersonFieldsFragmentDoc}`;
export const TrainingCertificationFieldsFragmentDoc = gql`
    fragment TrainingCertificationFields on TrainingCertification {
  id
  employee {
    ...TrainingPersonFields
  }
  course {
    id
    name
    category
    mandatory
    validityMonths
  }
  name
  certificateNumber
  issuedDate
  expiryDate
  notes
  documents {
    id
    originalName
    mimeType
    size
    createdAt
  }
}
    ${TrainingPersonFieldsFragmentDoc}`;
export const LearningProgrammeFieldsFragmentDoc = gql`
    fragment LearningProgrammeFields on LearningProgramme {
  id
  employee {
    ...TrainingPersonFields
  }
  employmentId
  type
  name
  seta
  nqfLevel
  startDate
  endDate
  outcome
}
    ${TrainingPersonFieldsFragmentDoc}`;
export const HrMetricFieldsFragmentDoc = gql`
    fragment HrMetricFields on HrMetric {
  value
  state
  source
  lastSyncedAt
  notRecorded
}
    `;
export const EmploymentFieldsFragmentDoc = gql`
    fragment EmploymentFields on Employment {
  id
  startDate
  endDate
  employmentType
  workingPattern
  exitType
  exitReason
  isOpen
}
    `;
export const EmployeeSummaryFieldsFragmentDoc = gql`
    fragment EmployeeSummaryFields on Employee {
  id
  firstName
  lastName
  employeeNumber
  department {
    id
    name
  }
  currentEmployment {
    ...EmploymentFields
  }
  employments {
    ...EmploymentFields
  }
}
    ${EmploymentFieldsFragmentDoc}`;
export const EmployeeDetailFieldsFragmentDoc = gql`
    fragment EmployeeDetailFields on Employee {
  ...EmployeeSummaryFields
  createdAt
  user {
    id
    email
    blocked
    archived
  }
}
    ${EmployeeSummaryFieldsFragmentDoc}`;
export const PartRequestFieldsFragmentDoc = gql`
    fragment PartRequestFields on PartRequest {
  id
  createdAt
  quantity
  status
  route
  reference
  note
  resolutionNote
  description
  sentAt
  receivedAt
  part {
    id
    name
    itemCategoryId
    itemCategory {
      id
      path
    }
    headOfficeQuantity
  }
  destinationStockingPoint {
    id
    name
  }
  sourceStockingPoint {
    id
    name
  }
  supplier {
    id
    name
  }
  stockTransfer {
    id
    transferNumber
    status
  }
  purchaseOrderLine {
    id
    purchaseOrder {
      id
      purchaseOrderNumber
      status
      destination {
        id
        name
      }
    }
  }
  workshopJob {
    id
    stockItem {
      id
      serialNumber
    }
  }
  requestedBy {
    id
    firstName
    lastName
  }
}
    `;
export const WorkshopStatsCountsFieldsFragmentDoc = gql`
    fragment WorkshopStatsCountsFields on WorkshopStatsCounts {
  received
  processed
  repaired
  pendingParts
  scrapped
}
    `;
export const WorkshopStatsRowFieldsFragmentDoc = gql`
    fragment WorkshopStatsRowFields on WorkshopStatsRow {
  id
  name
  faultTypeName
  received
  processed
  repaired
  pendingParts
  scrapped
}
    `;
export const MyAgentAgreementDocument = gql`
    query MyAgentAgreement {
  myAgentAgreement {
    ...AgentAgreementDetail
  }
}
    ${AgentAgreementDetailFragmentDoc}`;

/**
 * __useMyAgentAgreementQuery__
 *
 * To run a query within a React component, call `useMyAgentAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAgentAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAgentAgreementQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAgentAgreementQuery(baseOptions?: Apollo.QueryHookOptions<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>(MyAgentAgreementDocument, options);
      }
export function useMyAgentAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>(MyAgentAgreementDocument, options);
        }
// @ts-ignore
export function useMyAgentAgreementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>): Apollo.UseSuspenseQueryResult<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>;
export function useMyAgentAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>): Apollo.UseSuspenseQueryResult<MyAgentAgreementQuery | undefined, MyAgentAgreementQueryVariables>;
export function useMyAgentAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>(MyAgentAgreementDocument, options);
        }
export type MyAgentAgreementQueryHookResult = ReturnType<typeof useMyAgentAgreementQuery>;
export type MyAgentAgreementLazyQueryHookResult = ReturnType<typeof useMyAgentAgreementLazyQuery>;
export type MyAgentAgreementSuspenseQueryHookResult = ReturnType<typeof useMyAgentAgreementSuspenseQuery>;
export type MyAgentAgreementQueryResult = Apollo.QueryResult<MyAgentAgreementQuery, MyAgentAgreementQueryVariables>;
export const MyAgreementPartyPrefillDocument = gql`
    query MyAgreementPartyPrefill {
  myAgreementPartyPrefill {
    partyName
    idNumber
    idType
    registrationNumber
    address
    signatoryName
    signatoryCapacity
  }
}
    `;

/**
 * __useMyAgreementPartyPrefillQuery__
 *
 * To run a query within a React component, call `useMyAgreementPartyPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAgreementPartyPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAgreementPartyPrefillQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAgreementPartyPrefillQuery(baseOptions?: Apollo.QueryHookOptions<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>(MyAgreementPartyPrefillDocument, options);
      }
export function useMyAgreementPartyPrefillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>(MyAgreementPartyPrefillDocument, options);
        }
// @ts-ignore
export function useMyAgreementPartyPrefillSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>): Apollo.UseSuspenseQueryResult<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>;
export function useMyAgreementPartyPrefillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>): Apollo.UseSuspenseQueryResult<MyAgreementPartyPrefillQuery | undefined, MyAgreementPartyPrefillQueryVariables>;
export function useMyAgreementPartyPrefillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>(MyAgreementPartyPrefillDocument, options);
        }
export type MyAgreementPartyPrefillQueryHookResult = ReturnType<typeof useMyAgreementPartyPrefillQuery>;
export type MyAgreementPartyPrefillLazyQueryHookResult = ReturnType<typeof useMyAgreementPartyPrefillLazyQuery>;
export type MyAgreementPartyPrefillSuspenseQueryHookResult = ReturnType<typeof useMyAgreementPartyPrefillSuspenseQuery>;
export type MyAgreementPartyPrefillQueryResult = Apollo.QueryResult<MyAgreementPartyPrefillQuery, MyAgreementPartyPrefillQueryVariables>;
export const AgentAgreementsDocument = gql`
    query AgentAgreements($filter: AgentAgreementFilterInput) {
  agentAgreements(filter: $filter) {
    totalCount
    items {
      id
      status
      partyType
      templateVersion
      signedAt
      signingDate
      slaDueAt
      slaBreached
      agent {
        id
        firstName
        lastName
        salesId
        agentType
      }
      template {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useAgentAgreementsQuery__
 *
 * To run a query within a React component, call `useAgentAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentAgreementsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAgentAgreementsQuery(baseOptions?: Apollo.QueryHookOptions<AgentAgreementsQuery, AgentAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentAgreementsQuery, AgentAgreementsQueryVariables>(AgentAgreementsDocument, options);
      }
export function useAgentAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentAgreementsQuery, AgentAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentAgreementsQuery, AgentAgreementsQueryVariables>(AgentAgreementsDocument, options);
        }
// @ts-ignore
export function useAgentAgreementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentAgreementsQuery, AgentAgreementsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentAgreementsQuery, AgentAgreementsQueryVariables>;
export function useAgentAgreementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentAgreementsQuery, AgentAgreementsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentAgreementsQuery | undefined, AgentAgreementsQueryVariables>;
export function useAgentAgreementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentAgreementsQuery, AgentAgreementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentAgreementsQuery, AgentAgreementsQueryVariables>(AgentAgreementsDocument, options);
        }
export type AgentAgreementsQueryHookResult = ReturnType<typeof useAgentAgreementsQuery>;
export type AgentAgreementsLazyQueryHookResult = ReturnType<typeof useAgentAgreementsLazyQuery>;
export type AgentAgreementsSuspenseQueryHookResult = ReturnType<typeof useAgentAgreementsSuspenseQuery>;
export type AgentAgreementsQueryResult = Apollo.QueryResult<AgentAgreementsQuery, AgentAgreementsQueryVariables>;
export const AgentAgreementDocument = gql`
    query AgentAgreement($id: String!) {
  agentAgreement(id: $id) {
    ...AgentAgreementDetail
  }
}
    ${AgentAgreementDetailFragmentDoc}`;

/**
 * __useAgentAgreementQuery__
 *
 * To run a query within a React component, call `useAgentAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentAgreementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgentAgreementQuery(baseOptions: Apollo.QueryHookOptions<AgentAgreementQuery, AgentAgreementQueryVariables> & ({ variables: AgentAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentAgreementQuery, AgentAgreementQueryVariables>(AgentAgreementDocument, options);
      }
export function useAgentAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentAgreementQuery, AgentAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentAgreementQuery, AgentAgreementQueryVariables>(AgentAgreementDocument, options);
        }
// @ts-ignore
export function useAgentAgreementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentAgreementQuery, AgentAgreementQueryVariables>): Apollo.UseSuspenseQueryResult<AgentAgreementQuery, AgentAgreementQueryVariables>;
export function useAgentAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentAgreementQuery, AgentAgreementQueryVariables>): Apollo.UseSuspenseQueryResult<AgentAgreementQuery | undefined, AgentAgreementQueryVariables>;
export function useAgentAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentAgreementQuery, AgentAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentAgreementQuery, AgentAgreementQueryVariables>(AgentAgreementDocument, options);
        }
export type AgentAgreementQueryHookResult = ReturnType<typeof useAgentAgreementQuery>;
export type AgentAgreementLazyQueryHookResult = ReturnType<typeof useAgentAgreementLazyQuery>;
export type AgentAgreementSuspenseQueryHookResult = ReturnType<typeof useAgentAgreementSuspenseQuery>;
export type AgentAgreementQueryResult = Apollo.QueryResult<AgentAgreementQuery, AgentAgreementQueryVariables>;
export const SignMyAgentAgreementDocument = gql`
    mutation SignMyAgentAgreement($input: SignAgreementInput!) {
  signMyAgentAgreement(input: $input) {
    id
    status
    signedAt
    documentHash
  }
}
    `;
export type SignMyAgentAgreementMutationFn = Apollo.MutationFunction<SignMyAgentAgreementMutation, SignMyAgentAgreementMutationVariables>;

/**
 * __useSignMyAgentAgreementMutation__
 *
 * To run a mutation, you first call `useSignMyAgentAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignMyAgentAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signMyAgentAgreementMutation, { data, loading, error }] = useSignMyAgentAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignMyAgentAgreementMutation(baseOptions?: Apollo.MutationHookOptions<SignMyAgentAgreementMutation, SignMyAgentAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignMyAgentAgreementMutation, SignMyAgentAgreementMutationVariables>(SignMyAgentAgreementDocument, options);
      }
export type SignMyAgentAgreementMutationHookResult = ReturnType<typeof useSignMyAgentAgreementMutation>;
export type SignMyAgentAgreementMutationResult = Apollo.MutationResult<SignMyAgentAgreementMutation>;
export type SignMyAgentAgreementMutationOptions = Apollo.BaseMutationOptions<SignMyAgentAgreementMutation, SignMyAgentAgreementMutationVariables>;
export const StartAgentAgreementReviewDocument = gql`
    mutation StartAgentAgreementReview($id: String!) {
  startAgentAgreementReview(id: $id) {
    id
    status
  }
}
    `;
export type StartAgentAgreementReviewMutationFn = Apollo.MutationFunction<StartAgentAgreementReviewMutation, StartAgentAgreementReviewMutationVariables>;

/**
 * __useStartAgentAgreementReviewMutation__
 *
 * To run a mutation, you first call `useStartAgentAgreementReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAgentAgreementReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAgentAgreementReviewMutation, { data, loading, error }] = useStartAgentAgreementReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartAgentAgreementReviewMutation(baseOptions?: Apollo.MutationHookOptions<StartAgentAgreementReviewMutation, StartAgentAgreementReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAgentAgreementReviewMutation, StartAgentAgreementReviewMutationVariables>(StartAgentAgreementReviewDocument, options);
      }
export type StartAgentAgreementReviewMutationHookResult = ReturnType<typeof useStartAgentAgreementReviewMutation>;
export type StartAgentAgreementReviewMutationResult = Apollo.MutationResult<StartAgentAgreementReviewMutation>;
export type StartAgentAgreementReviewMutationOptions = Apollo.BaseMutationOptions<StartAgentAgreementReviewMutation, StartAgentAgreementReviewMutationVariables>;
export const CountersignAgentAgreementDocument = gql`
    mutation CountersignAgentAgreement($id: String!, $signingDate: DateTime) {
  countersignAgentAgreement(id: $id, signingDate: $signingDate) {
    id
    status
    countersignedByName
    countersignedAt
    signingDate
  }
}
    `;
export type CountersignAgentAgreementMutationFn = Apollo.MutationFunction<CountersignAgentAgreementMutation, CountersignAgentAgreementMutationVariables>;

/**
 * __useCountersignAgentAgreementMutation__
 *
 * To run a mutation, you first call `useCountersignAgentAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountersignAgentAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countersignAgentAgreementMutation, { data, loading, error }] = useCountersignAgentAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      signingDate: // value for 'signingDate'
 *   },
 * });
 */
export function useCountersignAgentAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CountersignAgentAgreementMutation, CountersignAgentAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CountersignAgentAgreementMutation, CountersignAgentAgreementMutationVariables>(CountersignAgentAgreementDocument, options);
      }
export type CountersignAgentAgreementMutationHookResult = ReturnType<typeof useCountersignAgentAgreementMutation>;
export type CountersignAgentAgreementMutationResult = Apollo.MutationResult<CountersignAgentAgreementMutation>;
export type CountersignAgentAgreementMutationOptions = Apollo.BaseMutationOptions<CountersignAgentAgreementMutation, CountersignAgentAgreementMutationVariables>;
export const RejectAgentAgreementDocument = gql`
    mutation RejectAgentAgreement($id: String!, $reason: String!) {
  rejectAgentAgreement(id: $id, reason: $reason) {
    id
    status
    decisionReason
  }
}
    `;
export type RejectAgentAgreementMutationFn = Apollo.MutationFunction<RejectAgentAgreementMutation, RejectAgentAgreementMutationVariables>;

/**
 * __useRejectAgentAgreementMutation__
 *
 * To run a mutation, you first call `useRejectAgentAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectAgentAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectAgentAgreementMutation, { data, loading, error }] = useRejectAgentAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectAgentAgreementMutation(baseOptions?: Apollo.MutationHookOptions<RejectAgentAgreementMutation, RejectAgentAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectAgentAgreementMutation, RejectAgentAgreementMutationVariables>(RejectAgentAgreementDocument, options);
      }
export type RejectAgentAgreementMutationHookResult = ReturnType<typeof useRejectAgentAgreementMutation>;
export type RejectAgentAgreementMutationResult = Apollo.MutationResult<RejectAgentAgreementMutation>;
export type RejectAgentAgreementMutationOptions = Apollo.BaseMutationOptions<RejectAgentAgreementMutation, RejectAgentAgreementMutationVariables>;
export const RequestAgentAgreementInfoDocument = gql`
    mutation RequestAgentAgreementInfo($id: String!, $reason: String!) {
  requestAgentAgreementInfo(id: $id, reason: $reason) {
    id
    status
    decisionReason
  }
}
    `;
export type RequestAgentAgreementInfoMutationFn = Apollo.MutationFunction<RequestAgentAgreementInfoMutation, RequestAgentAgreementInfoMutationVariables>;

/**
 * __useRequestAgentAgreementInfoMutation__
 *
 * To run a mutation, you first call `useRequestAgentAgreementInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAgentAgreementInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAgentAgreementInfoMutation, { data, loading, error }] = useRequestAgentAgreementInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestAgentAgreementInfoMutation(baseOptions?: Apollo.MutationHookOptions<RequestAgentAgreementInfoMutation, RequestAgentAgreementInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAgentAgreementInfoMutation, RequestAgentAgreementInfoMutationVariables>(RequestAgentAgreementInfoDocument, options);
      }
export type RequestAgentAgreementInfoMutationHookResult = ReturnType<typeof useRequestAgentAgreementInfoMutation>;
export type RequestAgentAgreementInfoMutationResult = Apollo.MutationResult<RequestAgentAgreementInfoMutation>;
export type RequestAgentAgreementInfoMutationOptions = Apollo.BaseMutationOptions<RequestAgentAgreementInfoMutation, RequestAgentAgreementInfoMutationVariables>;
export const DeclineAgentAgreementDocument = gql`
    mutation DeclineAgentAgreement($id: String!, $reason: String!) {
  declineAgentAgreement(id: $id, reason: $reason) {
    id
    status
    decisionReason
  }
}
    `;
export type DeclineAgentAgreementMutationFn = Apollo.MutationFunction<DeclineAgentAgreementMutation, DeclineAgentAgreementMutationVariables>;

/**
 * __useDeclineAgentAgreementMutation__
 *
 * To run a mutation, you first call `useDeclineAgentAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAgentAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAgentAgreementMutation, { data, loading, error }] = useDeclineAgentAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeclineAgentAgreementMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAgentAgreementMutation, DeclineAgentAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAgentAgreementMutation, DeclineAgentAgreementMutationVariables>(DeclineAgentAgreementDocument, options);
      }
export type DeclineAgentAgreementMutationHookResult = ReturnType<typeof useDeclineAgentAgreementMutation>;
export type DeclineAgentAgreementMutationResult = Apollo.MutationResult<DeclineAgentAgreementMutation>;
export type DeclineAgentAgreementMutationOptions = Apollo.BaseMutationOptions<DeclineAgentAgreementMutation, DeclineAgentAgreementMutationVariables>;
export const IssueAgentAgreementDocument = gql`
    mutation IssueAgentAgreement($agentId: String!, $reason: String) {
  issueAgentAgreement(agentId: $agentId, reason: $reason) {
    id
    status
    agent {
      id
      firstName
      lastName
      salesId
    }
  }
}
    `;
export type IssueAgentAgreementMutationFn = Apollo.MutationFunction<IssueAgentAgreementMutation, IssueAgentAgreementMutationVariables>;

/**
 * __useIssueAgentAgreementMutation__
 *
 * To run a mutation, you first call `useIssueAgentAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueAgentAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueAgentAgreementMutation, { data, loading, error }] = useIssueAgentAgreementMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useIssueAgentAgreementMutation(baseOptions?: Apollo.MutationHookOptions<IssueAgentAgreementMutation, IssueAgentAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueAgentAgreementMutation, IssueAgentAgreementMutationVariables>(IssueAgentAgreementDocument, options);
      }
export type IssueAgentAgreementMutationHookResult = ReturnType<typeof useIssueAgentAgreementMutation>;
export type IssueAgentAgreementMutationResult = Apollo.MutationResult<IssueAgentAgreementMutation>;
export type IssueAgentAgreementMutationOptions = Apollo.BaseMutationOptions<IssueAgentAgreementMutation, IssueAgentAgreementMutationVariables>;
export const GetAgentCategoriesDocument = gql`
    query GetAgentCategories {
  agentCategories {
    id
    name
    rank
    canBeParent
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAgentCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAgentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>(GetAgentCategoriesDocument, options);
      }
export function useGetAgentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>(GetAgentCategoriesDocument, options);
        }
// @ts-ignore
export function useGetAgentCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>;
export function useGetAgentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCategoriesQuery | undefined, GetAgentCategoriesQueryVariables>;
export function useGetAgentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>(GetAgentCategoriesDocument, options);
        }
export type GetAgentCategoriesQueryHookResult = ReturnType<typeof useGetAgentCategoriesQuery>;
export type GetAgentCategoriesLazyQueryHookResult = ReturnType<typeof useGetAgentCategoriesLazyQuery>;
export type GetAgentCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetAgentCategoriesSuspenseQuery>;
export type GetAgentCategoriesQueryResult = Apollo.QueryResult<GetAgentCategoriesQuery, GetAgentCategoriesQueryVariables>;
export const GetAgentCategoryDocument = gql`
    query GetAgentCategory($id: String!) {
  agentCategory(id: $id) {
    id
    name
    rank
    canBeParent
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAgentCategoryQuery__
 *
 * To run a query within a React component, call `useGetAgentCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetAgentCategoryQuery, GetAgentCategoryQueryVariables> & ({ variables: GetAgentCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>(GetAgentCategoryDocument, options);
      }
export function useGetAgentCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>(GetAgentCategoryDocument, options);
        }
// @ts-ignore
export function useGetAgentCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>;
export function useGetAgentCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCategoryQuery | undefined, GetAgentCategoryQueryVariables>;
export function useGetAgentCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>(GetAgentCategoryDocument, options);
        }
export type GetAgentCategoryQueryHookResult = ReturnType<typeof useGetAgentCategoryQuery>;
export type GetAgentCategoryLazyQueryHookResult = ReturnType<typeof useGetAgentCategoryLazyQuery>;
export type GetAgentCategorySuspenseQueryHookResult = ReturnType<typeof useGetAgentCategorySuspenseQuery>;
export type GetAgentCategoryQueryResult = Apollo.QueryResult<GetAgentCategoryQuery, GetAgentCategoryQueryVariables>;
export const CreateAgentCategoryDocument = gql`
    mutation CreateAgentCategory($input: CreateAgentCategoryInput!) {
  createAgentCategory(input: $input) {
    id
    name
    rank
    canBeParent
  }
}
    `;
export type CreateAgentCategoryMutationFn = Apollo.MutationFunction<CreateAgentCategoryMutation, CreateAgentCategoryMutationVariables>;

/**
 * __useCreateAgentCategoryMutation__
 *
 * To run a mutation, you first call `useCreateAgentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentCategoryMutation, { data, loading, error }] = useCreateAgentCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentCategoryMutation, CreateAgentCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentCategoryMutation, CreateAgentCategoryMutationVariables>(CreateAgentCategoryDocument, options);
      }
export type CreateAgentCategoryMutationHookResult = ReturnType<typeof useCreateAgentCategoryMutation>;
export type CreateAgentCategoryMutationResult = Apollo.MutationResult<CreateAgentCategoryMutation>;
export type CreateAgentCategoryMutationOptions = Apollo.BaseMutationOptions<CreateAgentCategoryMutation, CreateAgentCategoryMutationVariables>;
export const UpdateAgentCategoryDocument = gql`
    mutation UpdateAgentCategory($id: String!, $input: UpdateAgentCategoryInput!) {
  updateAgentCategory(id: $id, input: $input) {
    id
    name
    rank
    canBeParent
  }
}
    `;
export type UpdateAgentCategoryMutationFn = Apollo.MutationFunction<UpdateAgentCategoryMutation, UpdateAgentCategoryMutationVariables>;

/**
 * __useUpdateAgentCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateAgentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentCategoryMutation, { data, loading, error }] = useUpdateAgentCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgentCategoryMutation, UpdateAgentCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgentCategoryMutation, UpdateAgentCategoryMutationVariables>(UpdateAgentCategoryDocument, options);
      }
export type UpdateAgentCategoryMutationHookResult = ReturnType<typeof useUpdateAgentCategoryMutation>;
export type UpdateAgentCategoryMutationResult = Apollo.MutationResult<UpdateAgentCategoryMutation>;
export type UpdateAgentCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateAgentCategoryMutation, UpdateAgentCategoryMutationVariables>;
export const DeleteAgentCategoryDocument = gql`
    mutation DeleteAgentCategory($id: String!) {
  deleteAgentCategory(id: $id) {
    id
    name
  }
}
    `;
export type DeleteAgentCategoryMutationFn = Apollo.MutationFunction<DeleteAgentCategoryMutation, DeleteAgentCategoryMutationVariables>;

/**
 * __useDeleteAgentCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteAgentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentCategoryMutation, { data, loading, error }] = useDeleteAgentCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgentCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgentCategoryMutation, DeleteAgentCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgentCategoryMutation, DeleteAgentCategoryMutationVariables>(DeleteAgentCategoryDocument, options);
      }
export type DeleteAgentCategoryMutationHookResult = ReturnType<typeof useDeleteAgentCategoryMutation>;
export type DeleteAgentCategoryMutationResult = Apollo.MutationResult<DeleteAgentCategoryMutation>;
export type DeleteAgentCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteAgentCategoryMutation, DeleteAgentCategoryMutationVariables>;
export const GetAgentDisputesDocument = gql`
    query GetAgentDisputes($input: ListDisputesInput) {
  agentDisputes(input: $input) {
    ...AgentDisputeFields
  }
}
    ${AgentDisputeFieldsFragmentDoc}`;

/**
 * __useGetAgentDisputesQuery__
 *
 * To run a query within a React component, call `useGetAgentDisputesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentDisputesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentDisputesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAgentDisputesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>(GetAgentDisputesDocument, options);
      }
export function useGetAgentDisputesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>(GetAgentDisputesDocument, options);
        }
// @ts-ignore
export function useGetAgentDisputesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>;
export function useGetAgentDisputesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentDisputesQuery | undefined, GetAgentDisputesQueryVariables>;
export function useGetAgentDisputesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>(GetAgentDisputesDocument, options);
        }
export type GetAgentDisputesQueryHookResult = ReturnType<typeof useGetAgentDisputesQuery>;
export type GetAgentDisputesLazyQueryHookResult = ReturnType<typeof useGetAgentDisputesLazyQuery>;
export type GetAgentDisputesSuspenseQueryHookResult = ReturnType<typeof useGetAgentDisputesSuspenseQuery>;
export type GetAgentDisputesQueryResult = Apollo.QueryResult<GetAgentDisputesQuery, GetAgentDisputesQueryVariables>;
export const GetAgentDisputeCountDocument = gql`
    query GetAgentDisputeCount($input: ListDisputesInput) {
  agentDisputeCount(input: $input)
}
    `;

/**
 * __useGetAgentDisputeCountQuery__
 *
 * To run a query within a React component, call `useGetAgentDisputeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentDisputeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentDisputeCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAgentDisputeCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>(GetAgentDisputeCountDocument, options);
      }
export function useGetAgentDisputeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>(GetAgentDisputeCountDocument, options);
        }
// @ts-ignore
export function useGetAgentDisputeCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>;
export function useGetAgentDisputeCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentDisputeCountQuery | undefined, GetAgentDisputeCountQueryVariables>;
export function useGetAgentDisputeCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>(GetAgentDisputeCountDocument, options);
        }
export type GetAgentDisputeCountQueryHookResult = ReturnType<typeof useGetAgentDisputeCountQuery>;
export type GetAgentDisputeCountLazyQueryHookResult = ReturnType<typeof useGetAgentDisputeCountLazyQuery>;
export type GetAgentDisputeCountSuspenseQueryHookResult = ReturnType<typeof useGetAgentDisputeCountSuspenseQuery>;
export type GetAgentDisputeCountQueryResult = Apollo.QueryResult<GetAgentDisputeCountQuery, GetAgentDisputeCountQueryVariables>;
export const GetAgentDisputeResolutionsDocument = gql`
    query GetAgentDisputeResolutions($agentId: String!) {
  agentDisputeResolutions(agentId: $agentId) {
    id
    createdAt
    disputeType
    outcome
    notes
    beforeValue
    afterValue
    resolvedBy {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetAgentDisputeResolutionsQuery__
 *
 * To run a query within a React component, call `useGetAgentDisputeResolutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentDisputeResolutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentDisputeResolutionsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetAgentDisputeResolutionsQuery(baseOptions: Apollo.QueryHookOptions<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables> & ({ variables: GetAgentDisputeResolutionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>(GetAgentDisputeResolutionsDocument, options);
      }
export function useGetAgentDisputeResolutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>(GetAgentDisputeResolutionsDocument, options);
        }
// @ts-ignore
export function useGetAgentDisputeResolutionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>;
export function useGetAgentDisputeResolutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentDisputeResolutionsQuery | undefined, GetAgentDisputeResolutionsQueryVariables>;
export function useGetAgentDisputeResolutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>(GetAgentDisputeResolutionsDocument, options);
        }
export type GetAgentDisputeResolutionsQueryHookResult = ReturnType<typeof useGetAgentDisputeResolutionsQuery>;
export type GetAgentDisputeResolutionsLazyQueryHookResult = ReturnType<typeof useGetAgentDisputeResolutionsLazyQuery>;
export type GetAgentDisputeResolutionsSuspenseQueryHookResult = ReturnType<typeof useGetAgentDisputeResolutionsSuspenseQuery>;
export type GetAgentDisputeResolutionsQueryResult = Apollo.QueryResult<GetAgentDisputeResolutionsQuery, GetAgentDisputeResolutionsQueryVariables>;
export const ResolveDisputeDocument = gql`
    mutation ResolveDispute($input: ResolveDisputeInput!) {
  resolveDispute(input: $input) {
    agentId
    resolutionId
  }
}
    `;
export type ResolveDisputeMutationFn = Apollo.MutationFunction<ResolveDisputeMutation, ResolveDisputeMutationVariables>;

/**
 * __useResolveDisputeMutation__
 *
 * To run a mutation, you first call `useResolveDisputeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveDisputeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveDisputeMutation, { data, loading, error }] = useResolveDisputeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveDisputeMutation(baseOptions?: Apollo.MutationHookOptions<ResolveDisputeMutation, ResolveDisputeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveDisputeMutation, ResolveDisputeMutationVariables>(ResolveDisputeDocument, options);
      }
export type ResolveDisputeMutationHookResult = ReturnType<typeof useResolveDisputeMutation>;
export type ResolveDisputeMutationResult = Apollo.MutationResult<ResolveDisputeMutation>;
export type ResolveDisputeMutationOptions = Apollo.BaseMutationOptions<ResolveDisputeMutation, ResolveDisputeMutationVariables>;
export const GetAgentInviteApprovalsDocument = gql`
    query GetAgentInviteApprovals($input: AgentInviteApprovalListInput) {
  agentInviteApprovals(input: $input) {
    totalCount
    items {
      ...AgentInviteApprovalFields
    }
  }
}
    ${AgentInviteApprovalFieldsFragmentDoc}`;

/**
 * __useGetAgentInviteApprovalsQuery__
 *
 * To run a query within a React component, call `useGetAgentInviteApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentInviteApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentInviteApprovalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAgentInviteApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>(GetAgentInviteApprovalsDocument, options);
      }
export function useGetAgentInviteApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>(GetAgentInviteApprovalsDocument, options);
        }
// @ts-ignore
export function useGetAgentInviteApprovalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>;
export function useGetAgentInviteApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentInviteApprovalsQuery | undefined, GetAgentInviteApprovalsQueryVariables>;
export function useGetAgentInviteApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>(GetAgentInviteApprovalsDocument, options);
        }
export type GetAgentInviteApprovalsQueryHookResult = ReturnType<typeof useGetAgentInviteApprovalsQuery>;
export type GetAgentInviteApprovalsLazyQueryHookResult = ReturnType<typeof useGetAgentInviteApprovalsLazyQuery>;
export type GetAgentInviteApprovalsSuspenseQueryHookResult = ReturnType<typeof useGetAgentInviteApprovalsSuspenseQuery>;
export type GetAgentInviteApprovalsQueryResult = Apollo.QueryResult<GetAgentInviteApprovalsQuery, GetAgentInviteApprovalsQueryVariables>;
export const GetAgentInviteApprovalCountsDocument = gql`
    query GetAgentInviteApprovalCounts {
  agentInviteApprovalCounts {
    status
    count
  }
}
    `;

/**
 * __useGetAgentInviteApprovalCountsQuery__
 *
 * To run a query within a React component, call `useGetAgentInviteApprovalCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentInviteApprovalCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentInviteApprovalCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentInviteApprovalCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>(GetAgentInviteApprovalCountsDocument, options);
      }
export function useGetAgentInviteApprovalCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>(GetAgentInviteApprovalCountsDocument, options);
        }
// @ts-ignore
export function useGetAgentInviteApprovalCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>;
export function useGetAgentInviteApprovalCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentInviteApprovalCountsQuery | undefined, GetAgentInviteApprovalCountsQueryVariables>;
export function useGetAgentInviteApprovalCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>(GetAgentInviteApprovalCountsDocument, options);
        }
export type GetAgentInviteApprovalCountsQueryHookResult = ReturnType<typeof useGetAgentInviteApprovalCountsQuery>;
export type GetAgentInviteApprovalCountsLazyQueryHookResult = ReturnType<typeof useGetAgentInviteApprovalCountsLazyQuery>;
export type GetAgentInviteApprovalCountsSuspenseQueryHookResult = ReturnType<typeof useGetAgentInviteApprovalCountsSuspenseQuery>;
export type GetAgentInviteApprovalCountsQueryResult = Apollo.QueryResult<GetAgentInviteApprovalCountsQuery, GetAgentInviteApprovalCountsQueryVariables>;
export const ReviewAgentInviteApprovalDocument = gql`
    mutation ReviewAgentInviteApproval($id: String!, $input: ReviewAgentInviteInput!) {
  reviewAgentInviteApproval(id: $id, input: $input) {
    ...AgentInviteApprovalFields
  }
}
    ${AgentInviteApprovalFieldsFragmentDoc}`;
export type ReviewAgentInviteApprovalMutationFn = Apollo.MutationFunction<ReviewAgentInviteApprovalMutation, ReviewAgentInviteApprovalMutationVariables>;

/**
 * __useReviewAgentInviteApprovalMutation__
 *
 * To run a mutation, you first call `useReviewAgentInviteApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewAgentInviteApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewAgentInviteApprovalMutation, { data, loading, error }] = useReviewAgentInviteApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewAgentInviteApprovalMutation(baseOptions?: Apollo.MutationHookOptions<ReviewAgentInviteApprovalMutation, ReviewAgentInviteApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewAgentInviteApprovalMutation, ReviewAgentInviteApprovalMutationVariables>(ReviewAgentInviteApprovalDocument, options);
      }
export type ReviewAgentInviteApprovalMutationHookResult = ReturnType<typeof useReviewAgentInviteApprovalMutation>;
export type ReviewAgentInviteApprovalMutationResult = Apollo.MutationResult<ReviewAgentInviteApprovalMutation>;
export type ReviewAgentInviteApprovalMutationOptions = Apollo.BaseMutationOptions<ReviewAgentInviteApprovalMutation, ReviewAgentInviteApprovalMutationVariables>;
export const CancelAgentInviteApprovalDocument = gql`
    mutation CancelAgentInviteApproval($id: String!) {
  cancelAgentInviteApproval(id: $id) {
    ...AgentInviteApprovalFields
  }
}
    ${AgentInviteApprovalFieldsFragmentDoc}`;
export type CancelAgentInviteApprovalMutationFn = Apollo.MutationFunction<CancelAgentInviteApprovalMutation, CancelAgentInviteApprovalMutationVariables>;

/**
 * __useCancelAgentInviteApprovalMutation__
 *
 * To run a mutation, you first call `useCancelAgentInviteApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAgentInviteApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAgentInviteApprovalMutation, { data, loading, error }] = useCancelAgentInviteApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelAgentInviteApprovalMutation(baseOptions?: Apollo.MutationHookOptions<CancelAgentInviteApprovalMutation, CancelAgentInviteApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAgentInviteApprovalMutation, CancelAgentInviteApprovalMutationVariables>(CancelAgentInviteApprovalDocument, options);
      }
export type CancelAgentInviteApprovalMutationHookResult = ReturnType<typeof useCancelAgentInviteApprovalMutation>;
export type CancelAgentInviteApprovalMutationResult = Apollo.MutationResult<CancelAgentInviteApprovalMutation>;
export type CancelAgentInviteApprovalMutationOptions = Apollo.BaseMutationOptions<CancelAgentInviteApprovalMutation, CancelAgentInviteApprovalMutationVariables>;
export const GetAgentsDocument = gql`
    query GetAgents($input: AgentListInput) {
  agents(input: $input) {
    items {
      id
      salesId
      firstName
      lastName
      phone
      paymentPhone
      taxId
      agentType
      agreementStatus
      agentCategory {
        id
        name
      }
      status
      province
      municipality
      canSell
      canHoldStock
      canDoReplacements
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetAgentsQuery__
 *
 * To run a query within a React component, call `useGetAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
      }
export function useGetAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
        }
// @ts-ignore
export function useGetAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsQuery, GetAgentsQueryVariables>;
export function useGetAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsQuery | undefined, GetAgentsQueryVariables>;
export function useGetAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
        }
export type GetAgentsQueryHookResult = ReturnType<typeof useGetAgentsQuery>;
export type GetAgentsLazyQueryHookResult = ReturnType<typeof useGetAgentsLazyQuery>;
export type GetAgentsSuspenseQueryHookResult = ReturnType<typeof useGetAgentsSuspenseQuery>;
export type GetAgentsQueryResult = Apollo.QueryResult<GetAgentsQuery, GetAgentsQueryVariables>;
export const GetAgentDocument = gql`
    query GetAgent($id: String!) {
  agent(id: $id) {
    id
    salesId
    firstName
    lastName
    phone
    paymentPhone
    taxId
    province
    municipality
    bankName
    bankAccountNumber
    bankBranchCode
    bankAccountType
    agentType
    agentCategory {
      id
      name
      rank
      canBeParent
    }
    status
    sourceSystem
    sourceAgentKey
    sourcePhone
    canSell
    canHoldStock
    canDoReplacements
    earnsMonthlyFee
    createdAt
    updatedAt
    parentAgent {
      id
      firstName
      lastName
      salesId
    }
    childAgents {
      id
      firstName
      lastName
      salesId
      status
    }
    user {
      id
      firstName
      lastName
      email
    }
    stockingPointUsers {
      id
      isPrimary
      stockingPoint {
        id
        name
        stockingPointId
        type
        stockOnTheWay {
          arriving {
            devices
          }
        }
      }
    }
    changeHistory {
      id
      createdAt
      effectiveFrom
      fieldName
      oldValue
      newValue
      changeType
      changedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetAgentQuery__
 *
 * To run a query within a React component, call `useGetAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentQuery(baseOptions: Apollo.QueryHookOptions<GetAgentQuery, GetAgentQueryVariables> & ({ variables: GetAgentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentQuery, GetAgentQueryVariables>(GetAgentDocument, options);
      }
export function useGetAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentQuery, GetAgentQueryVariables>(GetAgentDocument, options);
        }
// @ts-ignore
export function useGetAgentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentQuery, GetAgentQueryVariables>;
export function useGetAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentQuery | undefined, GetAgentQueryVariables>;
export function useGetAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentQuery, GetAgentQueryVariables>(GetAgentDocument, options);
        }
export type GetAgentQueryHookResult = ReturnType<typeof useGetAgentQuery>;
export type GetAgentLazyQueryHookResult = ReturnType<typeof useGetAgentLazyQuery>;
export type GetAgentSuspenseQueryHookResult = ReturnType<typeof useGetAgentSuspenseQuery>;
export type GetAgentQueryResult = Apollo.QueryResult<GetAgentQuery, GetAgentQueryVariables>;
export const GetAgentStockingPointsDocument = gql`
    query GetAgentStockingPoints($id: String!) {
  agent(id: $id) {
    id
    stockingPointUsers {
      id
      isPrimary
      stockingPoint {
        id
        name
        isActive
      }
    }
  }
}
    `;

/**
 * __useGetAgentStockingPointsQuery__
 *
 * To run a query within a React component, call `useGetAgentStockingPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentStockingPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentStockingPointsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentStockingPointsQuery(baseOptions: Apollo.QueryHookOptions<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables> & ({ variables: GetAgentStockingPointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>(GetAgentStockingPointsDocument, options);
      }
export function useGetAgentStockingPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>(GetAgentStockingPointsDocument, options);
        }
// @ts-ignore
export function useGetAgentStockingPointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>;
export function useGetAgentStockingPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentStockingPointsQuery | undefined, GetAgentStockingPointsQueryVariables>;
export function useGetAgentStockingPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>(GetAgentStockingPointsDocument, options);
        }
export type GetAgentStockingPointsQueryHookResult = ReturnType<typeof useGetAgentStockingPointsQuery>;
export type GetAgentStockingPointsLazyQueryHookResult = ReturnType<typeof useGetAgentStockingPointsLazyQuery>;
export type GetAgentStockingPointsSuspenseQueryHookResult = ReturnType<typeof useGetAgentStockingPointsSuspenseQuery>;
export type GetAgentStockingPointsQueryResult = Apollo.QueryResult<GetAgentStockingPointsQuery, GetAgentStockingPointsQueryVariables>;
export const GetAgentStatusCountsDocument = gql`
    query GetAgentStatusCounts {
  agentStatusCounts {
    status
    count
  }
}
    `;

/**
 * __useGetAgentStatusCountsQuery__
 *
 * To run a query within a React component, call `useGetAgentStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentStatusCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>(GetAgentStatusCountsDocument, options);
      }
export function useGetAgentStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>(GetAgentStatusCountsDocument, options);
        }
// @ts-ignore
export function useGetAgentStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>;
export function useGetAgentStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentStatusCountsQuery | undefined, GetAgentStatusCountsQueryVariables>;
export function useGetAgentStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>(GetAgentStatusCountsDocument, options);
        }
export type GetAgentStatusCountsQueryHookResult = ReturnType<typeof useGetAgentStatusCountsQuery>;
export type GetAgentStatusCountsLazyQueryHookResult = ReturnType<typeof useGetAgentStatusCountsLazyQuery>;
export type GetAgentStatusCountsSuspenseQueryHookResult = ReturnType<typeof useGetAgentStatusCountsSuspenseQuery>;
export type GetAgentStatusCountsQueryResult = Apollo.QueryResult<GetAgentStatusCountsQuery, GetAgentStatusCountsQueryVariables>;
export const GetAgentsOnboardedThisMonthDocument = gql`
    query GetAgentsOnboardedThisMonth {
  agentsOnboardedThisMonth {
    month
    total
    byDistributor {
      distributorId
      distributorName
      distributorSalesId
      count
    }
  }
}
    `;

/**
 * __useGetAgentsOnboardedThisMonthQuery__
 *
 * To run a query within a React component, call `useGetAgentsOnboardedThisMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsOnboardedThisMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsOnboardedThisMonthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentsOnboardedThisMonthQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>(GetAgentsOnboardedThisMonthDocument, options);
      }
export function useGetAgentsOnboardedThisMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>(GetAgentsOnboardedThisMonthDocument, options);
        }
// @ts-ignore
export function useGetAgentsOnboardedThisMonthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>;
export function useGetAgentsOnboardedThisMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentsOnboardedThisMonthQuery | undefined, GetAgentsOnboardedThisMonthQueryVariables>;
export function useGetAgentsOnboardedThisMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>(GetAgentsOnboardedThisMonthDocument, options);
        }
export type GetAgentsOnboardedThisMonthQueryHookResult = ReturnType<typeof useGetAgentsOnboardedThisMonthQuery>;
export type GetAgentsOnboardedThisMonthLazyQueryHookResult = ReturnType<typeof useGetAgentsOnboardedThisMonthLazyQuery>;
export type GetAgentsOnboardedThisMonthSuspenseQueryHookResult = ReturnType<typeof useGetAgentsOnboardedThisMonthSuspenseQuery>;
export type GetAgentsOnboardedThisMonthQueryResult = Apollo.QueryResult<GetAgentsOnboardedThisMonthQuery, GetAgentsOnboardedThisMonthQueryVariables>;
export const CreateAgentDocument = gql`
    mutation CreateAgent($input: CreateAgentInput!) {
  createAgent(input: $input) {
    id
    salesId
    firstName
    lastName
    status
  }
}
    `;
export type CreateAgentMutationFn = Apollo.MutationFunction<CreateAgentMutation, CreateAgentMutationVariables>;

/**
 * __useCreateAgentMutation__
 *
 * To run a mutation, you first call `useCreateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentMutation, { data, loading, error }] = useCreateAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentMutation, CreateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentMutation, CreateAgentMutationVariables>(CreateAgentDocument, options);
      }
export type CreateAgentMutationHookResult = ReturnType<typeof useCreateAgentMutation>;
export type CreateAgentMutationResult = Apollo.MutationResult<CreateAgentMutation>;
export type CreateAgentMutationOptions = Apollo.BaseMutationOptions<CreateAgentMutation, CreateAgentMutationVariables>;
export const UpdateAgentDocument = gql`
    mutation UpdateAgent($id: String!, $input: UpdateAgentInput!) {
  updateAgent(id: $id, input: $input) {
    id
    salesId
    firstName
    lastName
    status
  }
}
    `;
export type UpdateAgentMutationFn = Apollo.MutationFunction<UpdateAgentMutation, UpdateAgentMutationVariables>;

/**
 * __useUpdateAgentMutation__
 *
 * To run a mutation, you first call `useUpdateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentMutation, { data, loading, error }] = useUpdateAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgentMutation, UpdateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgentMutation, UpdateAgentMutationVariables>(UpdateAgentDocument, options);
      }
export type UpdateAgentMutationHookResult = ReturnType<typeof useUpdateAgentMutation>;
export type UpdateAgentMutationResult = Apollo.MutationResult<UpdateAgentMutation>;
export type UpdateAgentMutationOptions = Apollo.BaseMutationOptions<UpdateAgentMutation, UpdateAgentMutationVariables>;
export const DeactivateAgentDocument = gql`
    mutation DeactivateAgent($id: String!) {
  deactivateAgent(id: $id)
}
    `;
export type DeactivateAgentMutationFn = Apollo.MutationFunction<DeactivateAgentMutation, DeactivateAgentMutationVariables>;

/**
 * __useDeactivateAgentMutation__
 *
 * To run a mutation, you first call `useDeactivateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAgentMutation, { data, loading, error }] = useDeactivateAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateAgentMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAgentMutation, DeactivateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAgentMutation, DeactivateAgentMutationVariables>(DeactivateAgentDocument, options);
      }
export type DeactivateAgentMutationHookResult = ReturnType<typeof useDeactivateAgentMutation>;
export type DeactivateAgentMutationResult = Apollo.MutationResult<DeactivateAgentMutation>;
export type DeactivateAgentMutationOptions = Apollo.BaseMutationOptions<DeactivateAgentMutation, DeactivateAgentMutationVariables>;
export const ReactivateAgentDocument = gql`
    mutation ReactivateAgent($id: String!) {
  reactivateAgent(id: $id)
}
    `;
export type ReactivateAgentMutationFn = Apollo.MutationFunction<ReactivateAgentMutation, ReactivateAgentMutationVariables>;

/**
 * __useReactivateAgentMutation__
 *
 * To run a mutation, you first call `useReactivateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateAgentMutation, { data, loading, error }] = useReactivateAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateAgentMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateAgentMutation, ReactivateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateAgentMutation, ReactivateAgentMutationVariables>(ReactivateAgentDocument, options);
      }
export type ReactivateAgentMutationHookResult = ReturnType<typeof useReactivateAgentMutation>;
export type ReactivateAgentMutationResult = Apollo.MutationResult<ReactivateAgentMutation>;
export type ReactivateAgentMutationOptions = Apollo.BaseMutationOptions<ReactivateAgentMutation, ReactivateAgentMutationVariables>;
export const ReplaceAgentDocument = gql`
    mutation ReplaceAgent($id: String!, $replacementAgentId: String!) {
  replaceAgent(id: $id, replacementAgentId: $replacementAgentId)
}
    `;
export type ReplaceAgentMutationFn = Apollo.MutationFunction<ReplaceAgentMutation, ReplaceAgentMutationVariables>;

/**
 * __useReplaceAgentMutation__
 *
 * To run a mutation, you first call `useReplaceAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceAgentMutation, { data, loading, error }] = useReplaceAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      replacementAgentId: // value for 'replacementAgentId'
 *   },
 * });
 */
export function useReplaceAgentMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceAgentMutation, ReplaceAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceAgentMutation, ReplaceAgentMutationVariables>(ReplaceAgentDocument, options);
      }
export type ReplaceAgentMutationHookResult = ReturnType<typeof useReplaceAgentMutation>;
export type ReplaceAgentMutationResult = Apollo.MutationResult<ReplaceAgentMutation>;
export type ReplaceAgentMutationOptions = Apollo.BaseMutationOptions<ReplaceAgentMutation, ReplaceAgentMutationVariables>;
export const GetApiConsumersDocument = gql`
    query GetApiConsumers {
  apiConsumers {
    ...ApiConsumerFields
  }
}
    ${ApiConsumerFieldsFragmentDoc}`;

/**
 * __useGetApiConsumersQuery__
 *
 * To run a query within a React component, call `useGetApiConsumersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiConsumersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiConsumersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiConsumersQuery(baseOptions?: Apollo.QueryHookOptions<GetApiConsumersQuery, GetApiConsumersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiConsumersQuery, GetApiConsumersQueryVariables>(GetApiConsumersDocument, options);
      }
export function useGetApiConsumersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiConsumersQuery, GetApiConsumersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiConsumersQuery, GetApiConsumersQueryVariables>(GetApiConsumersDocument, options);
        }
// @ts-ignore
export function useGetApiConsumersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiConsumersQuery, GetApiConsumersQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiConsumersQuery, GetApiConsumersQueryVariables>;
export function useGetApiConsumersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiConsumersQuery, GetApiConsumersQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiConsumersQuery | undefined, GetApiConsumersQueryVariables>;
export function useGetApiConsumersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiConsumersQuery, GetApiConsumersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiConsumersQuery, GetApiConsumersQueryVariables>(GetApiConsumersDocument, options);
        }
export type GetApiConsumersQueryHookResult = ReturnType<typeof useGetApiConsumersQuery>;
export type GetApiConsumersLazyQueryHookResult = ReturnType<typeof useGetApiConsumersLazyQuery>;
export type GetApiConsumersSuspenseQueryHookResult = ReturnType<typeof useGetApiConsumersSuspenseQuery>;
export type GetApiConsumersQueryResult = Apollo.QueryResult<GetApiConsumersQuery, GetApiConsumersQueryVariables>;
export const CreateApiConsumerDocument = gql`
    mutation CreateApiConsumer($input: CreateApiConsumerInput!) {
  createApiConsumer(input: $input) {
    clientId
    clientSecret
    consumer {
      ...ApiConsumerFields
    }
  }
}
    ${ApiConsumerFieldsFragmentDoc}`;
export type CreateApiConsumerMutationFn = Apollo.MutationFunction<CreateApiConsumerMutation, CreateApiConsumerMutationVariables>;

/**
 * __useCreateApiConsumerMutation__
 *
 * To run a mutation, you first call `useCreateApiConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiConsumerMutation, { data, loading, error }] = useCreateApiConsumerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiConsumerMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiConsumerMutation, CreateApiConsumerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiConsumerMutation, CreateApiConsumerMutationVariables>(CreateApiConsumerDocument, options);
      }
export type CreateApiConsumerMutationHookResult = ReturnType<typeof useCreateApiConsumerMutation>;
export type CreateApiConsumerMutationResult = Apollo.MutationResult<CreateApiConsumerMutation>;
export type CreateApiConsumerMutationOptions = Apollo.BaseMutationOptions<CreateApiConsumerMutation, CreateApiConsumerMutationVariables>;
export const RevokeApiConsumerDocument = gql`
    mutation RevokeApiConsumer($id: String!) {
  revokeApiConsumer(id: $id) {
    ...ApiConsumerFields
  }
}
    ${ApiConsumerFieldsFragmentDoc}`;
export type RevokeApiConsumerMutationFn = Apollo.MutationFunction<RevokeApiConsumerMutation, RevokeApiConsumerMutationVariables>;

/**
 * __useRevokeApiConsumerMutation__
 *
 * To run a mutation, you first call `useRevokeApiConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiConsumerMutation, { data, loading, error }] = useRevokeApiConsumerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeApiConsumerMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiConsumerMutation, RevokeApiConsumerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiConsumerMutation, RevokeApiConsumerMutationVariables>(RevokeApiConsumerDocument, options);
      }
export type RevokeApiConsumerMutationHookResult = ReturnType<typeof useRevokeApiConsumerMutation>;
export type RevokeApiConsumerMutationResult = Apollo.MutationResult<RevokeApiConsumerMutation>;
export type RevokeApiConsumerMutationOptions = Apollo.BaseMutationOptions<RevokeApiConsumerMutation, RevokeApiConsumerMutationVariables>;
export const RotateApiConsumerSecretDocument = gql`
    mutation RotateApiConsumerSecret($id: String!) {
  rotateApiConsumerSecret(id: $id) {
    clientSecret
    consumer {
      ...ApiConsumerFields
    }
  }
}
    ${ApiConsumerFieldsFragmentDoc}`;
export type RotateApiConsumerSecretMutationFn = Apollo.MutationFunction<RotateApiConsumerSecretMutation, RotateApiConsumerSecretMutationVariables>;

/**
 * __useRotateApiConsumerSecretMutation__
 *
 * To run a mutation, you first call `useRotateApiConsumerSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateApiConsumerSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateApiConsumerSecretMutation, { data, loading, error }] = useRotateApiConsumerSecretMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRotateApiConsumerSecretMutation(baseOptions?: Apollo.MutationHookOptions<RotateApiConsumerSecretMutation, RotateApiConsumerSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RotateApiConsumerSecretMutation, RotateApiConsumerSecretMutationVariables>(RotateApiConsumerSecretDocument, options);
      }
export type RotateApiConsumerSecretMutationHookResult = ReturnType<typeof useRotateApiConsumerSecretMutation>;
export type RotateApiConsumerSecretMutationResult = Apollo.MutationResult<RotateApiConsumerSecretMutation>;
export type RotateApiConsumerSecretMutationOptions = Apollo.BaseMutationOptions<RotateApiConsumerSecretMutation, RotateApiConsumerSecretMutationVariables>;
export const GetApiConsumerUsageDocument = gql`
    query GetApiConsumerUsage($apiConsumerId: ID!, $days: Int) {
  apiConsumerUsage(apiConsumerId: $apiConsumerId, days: $days) {
    days
    calls
    failed
    refused
    estimatedTokens
    averageDurationMs
    lastCallAt
    byDay {
      day
      calls
      failed
      estimatedTokens
    }
    byTool {
      tool
      calls
      failed
      estimatedTokens
    }
    recent {
      id
      createdAt
      tool
      arguments
      ipAddress
      succeeded
      error
      durationMs
      estimatedTokens
    }
  }
}
    `;

/**
 * __useGetApiConsumerUsageQuery__
 *
 * To run a query within a React component, call `useGetApiConsumerUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiConsumerUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiConsumerUsageQuery({
 *   variables: {
 *      apiConsumerId: // value for 'apiConsumerId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetApiConsumerUsageQuery(baseOptions: Apollo.QueryHookOptions<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables> & ({ variables: GetApiConsumerUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>(GetApiConsumerUsageDocument, options);
      }
export function useGetApiConsumerUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>(GetApiConsumerUsageDocument, options);
        }
// @ts-ignore
export function useGetApiConsumerUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>;
export function useGetApiConsumerUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiConsumerUsageQuery | undefined, GetApiConsumerUsageQueryVariables>;
export function useGetApiConsumerUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>(GetApiConsumerUsageDocument, options);
        }
export type GetApiConsumerUsageQueryHookResult = ReturnType<typeof useGetApiConsumerUsageQuery>;
export type GetApiConsumerUsageLazyQueryHookResult = ReturnType<typeof useGetApiConsumerUsageLazyQuery>;
export type GetApiConsumerUsageSuspenseQueryHookResult = ReturnType<typeof useGetApiConsumerUsageSuspenseQuery>;
export type GetApiConsumerUsageQueryResult = Apollo.QueryResult<GetApiConsumerUsageQuery, GetApiConsumerUsageQueryVariables>;
export const GetApiKeysDocument = gql`
    query GetApiKeys {
  apiKeys {
    id
    name
    prefix
    isActive
    lastUsedAt
    createdAt
    inboundSignatureMode
    hasInboundSecret
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
// @ts-ignore
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiKeysQuery | undefined, GetApiKeysQueryVariables>;
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysSuspenseQueryHookResult = ReturnType<typeof useGetApiKeysSuspenseQuery>;
export type GetApiKeysQueryResult = Apollo.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($input: CreateApiKeyInput!) {
  createApiKey(input: $input) {
    apiKey {
      id
      name
      prefix
      isActive
      createdAt
    }
    rawKey
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const RevokeApiKeyDocument = gql`
    mutation RevokeApiKey($id: String!) {
  revokeApiKey(id: $id) {
    success
    message
  }
}
    `;
export type RevokeApiKeyMutationFn = Apollo.MutationFunction<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;

/**
 * __useRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiKeyMutation, { data, loading, error }] = useRevokeApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>(RevokeApiKeyDocument, options);
      }
export type RevokeApiKeyMutationHookResult = ReturnType<typeof useRevokeApiKeyMutation>;
export type RevokeApiKeyMutationResult = Apollo.MutationResult<RevokeApiKeyMutation>;
export type RevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation DeleteApiKey($id: String!) {
  deleteApiKey(id: $id) {
    success
    message
  }
}
    `;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = Apollo.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const SetApiKeyInboundSignatureDocument = gql`
    mutation SetApiKeyInboundSignature($id: String!, $input: SetInboundSignatureInput!) {
  setApiKeyInboundSignature(id: $id, input: $input) {
    id
    inboundSignatureMode
    hasInboundSecret
  }
}
    `;
export type SetApiKeyInboundSignatureMutationFn = Apollo.MutationFunction<SetApiKeyInboundSignatureMutation, SetApiKeyInboundSignatureMutationVariables>;

/**
 * __useSetApiKeyInboundSignatureMutation__
 *
 * To run a mutation, you first call `useSetApiKeyInboundSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetApiKeyInboundSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setApiKeyInboundSignatureMutation, { data, loading, error }] = useSetApiKeyInboundSignatureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetApiKeyInboundSignatureMutation(baseOptions?: Apollo.MutationHookOptions<SetApiKeyInboundSignatureMutation, SetApiKeyInboundSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetApiKeyInboundSignatureMutation, SetApiKeyInboundSignatureMutationVariables>(SetApiKeyInboundSignatureDocument, options);
      }
export type SetApiKeyInboundSignatureMutationHookResult = ReturnType<typeof useSetApiKeyInboundSignatureMutation>;
export type SetApiKeyInboundSignatureMutationResult = Apollo.MutationResult<SetApiKeyInboundSignatureMutation>;
export type SetApiKeyInboundSignatureMutationOptions = Apollo.BaseMutationOptions<SetApiKeyInboundSignatureMutation, SetApiKeyInboundSignatureMutationVariables>;
export const GetApplicationsDocument = gql`
    query GetApplications($input: ApplicationListInput) {
  applications(input: $input) {
    items {
      id
      referenceNumber
      status
      createdAt
      customer {
        id
        firstName
        lastName
        fullName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetApplicationsQuery__
 *
 * To run a query within a React component, call `useGetApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
      }
export function useGetApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
        }
// @ts-ignore
export function useGetApplicationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationsQuery, GetApplicationsQueryVariables>;
export function useGetApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationsQuery | undefined, GetApplicationsQueryVariables>;
export function useGetApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
        }
export type GetApplicationsQueryHookResult = ReturnType<typeof useGetApplicationsQuery>;
export type GetApplicationsLazyQueryHookResult = ReturnType<typeof useGetApplicationsLazyQuery>;
export type GetApplicationsSuspenseQueryHookResult = ReturnType<typeof useGetApplicationsSuspenseQuery>;
export type GetApplicationsQueryResult = Apollo.QueryResult<GetApplicationsQuery, GetApplicationsQueryVariables>;
export const GetApplicationDocument = gql`
    query GetApplication($id: String!) {
  application(id: $id) {
    ...ApplicationFields
    documents {
      ...DocumentFields
    }
    changeHistory {
      ...ChangeHistoryFields
    }
  }
}
    ${ApplicationFieldsFragmentDoc}
${DocumentFieldsFragmentDoc}
${ChangeHistoryFieldsFragmentDoc}`;

/**
 * __useGetApplicationQuery__
 *
 * To run a query within a React component, call `useGetApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables> & ({ variables: GetApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationQuery, GetApplicationQueryVariables>(GetApplicationDocument, options);
      }
export function useGetApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationQuery, GetApplicationQueryVariables>(GetApplicationDocument, options);
        }
// @ts-ignore
export function useGetApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationQuery, GetApplicationQueryVariables>;
export function useGetApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationQuery | undefined, GetApplicationQueryVariables>;
export function useGetApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationQuery, GetApplicationQueryVariables>(GetApplicationDocument, options);
        }
export type GetApplicationQueryHookResult = ReturnType<typeof useGetApplicationQuery>;
export type GetApplicationLazyQueryHookResult = ReturnType<typeof useGetApplicationLazyQuery>;
export type GetApplicationSuspenseQueryHookResult = ReturnType<typeof useGetApplicationSuspenseQuery>;
export type GetApplicationQueryResult = Apollo.QueryResult<GetApplicationQuery, GetApplicationQueryVariables>;
export const CreateApplicationDocument = gql`
    mutation CreateApplication($input: CreateApplicationInput!) {
  createApplication(input: $input) {
    id
    referenceNumber
    status
  }
}
    `;
export type CreateApplicationMutationFn = Apollo.MutationFunction<CreateApplicationMutation, CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = Apollo.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicationMutation, CreateApplicationMutationVariables>;
export const UpdateApplicationDocument = gql`
    mutation UpdateApplication($id: String!, $input: UpdateApplicationInput!) {
  updateApplication(id: $id, input: $input) {
    ...ApplicationFields
    documents {
      ...DocumentFields
    }
    changeHistory {
      ...ChangeHistoryFields
    }
  }
}
    ${ApplicationFieldsFragmentDoc}
${DocumentFieldsFragmentDoc}
${ChangeHistoryFieldsFragmentDoc}`;
export type UpdateApplicationMutationFn = Apollo.MutationFunction<UpdateApplicationMutation, UpdateApplicationMutationVariables>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument, options);
      }
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>;
export type UpdateApplicationMutationResult = Apollo.MutationResult<UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>;
export const GetApprovalRequestsDocument = gql`
    query GetApprovalRequests($input: ApprovalListInput) {
  approvalRequests(input: $input) {
    items {
      id
      kind
      createdAt
      status
      requestReason
      reviewNotes
      reviewedAt
      customer {
        id
        firstName
        lastName
        status
        contracts {
          id
          contractNumber
          status
          rateName
          totalPrice
          depositAmount
          rateAmount
          termLength
        }
      }
      ratePlan {
        id
        rateName
        product
        depositAmount
        rateAmount
        termLength
      }
      requestedBy {
        id
        firstName
        lastName
      }
      reviewedBy {
        id
        firstName
        lastName
      }
      contract {
        id
        contractNumber
      }
      stockTransfer {
        id
        transferNumber
        sourceStockingPoint {
          id
          name
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetApprovalRequestsQuery__
 *
 * To run a query within a React component, call `useGetApprovalRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalRequestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApprovalRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>(GetApprovalRequestsDocument, options);
      }
export function useGetApprovalRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>(GetApprovalRequestsDocument, options);
        }
// @ts-ignore
export function useGetApprovalRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>;
export function useGetApprovalRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalRequestsQuery | undefined, GetApprovalRequestsQueryVariables>;
export function useGetApprovalRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>(GetApprovalRequestsDocument, options);
        }
export type GetApprovalRequestsQueryHookResult = ReturnType<typeof useGetApprovalRequestsQuery>;
export type GetApprovalRequestsLazyQueryHookResult = ReturnType<typeof useGetApprovalRequestsLazyQuery>;
export type GetApprovalRequestsSuspenseQueryHookResult = ReturnType<typeof useGetApprovalRequestsSuspenseQuery>;
export type GetApprovalRequestsQueryResult = Apollo.QueryResult<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>;
export const GetApprovalRequestDocument = gql`
    query GetApprovalRequest($id: String!) {
  approvalRequest(id: $id) {
    id
    kind
    createdAt
    status
    requestReason
    reviewNotes
    reviewedAt
    customer {
      id
      firstName
      lastName
      status
      contracts {
        id
        contractNumber
        status
        rateName
        totalPrice
        depositAmount
        rateAmount
        termLength
        applicationType
      }
    }
    ratePlan {
      id
      rateName
      product
      depositAmount
      rateAmount
      termLength
      products {
        id
        product {
          id
          name
        }
      }
    }
    requestedBy {
      id
      firstName
      lastName
    }
    reviewedBy {
      id
      firstName
      lastName
    }
    contract {
      id
      contractNumber
      status
      stockSale {
        id
      }
    }
    stockTransfer {
      id
    }
  }
}
    `;

/**
 * __useGetApprovalRequestQuery__
 *
 * To run a query within a React component, call `useGetApprovalRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApprovalRequestQuery(baseOptions: Apollo.QueryHookOptions<GetApprovalRequestQuery, GetApprovalRequestQueryVariables> & ({ variables: GetApprovalRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>(GetApprovalRequestDocument, options);
      }
export function useGetApprovalRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>(GetApprovalRequestDocument, options);
        }
// @ts-ignore
export function useGetApprovalRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>;
export function useGetApprovalRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalRequestQuery | undefined, GetApprovalRequestQueryVariables>;
export function useGetApprovalRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>(GetApprovalRequestDocument, options);
        }
export type GetApprovalRequestQueryHookResult = ReturnType<typeof useGetApprovalRequestQuery>;
export type GetApprovalRequestLazyQueryHookResult = ReturnType<typeof useGetApprovalRequestLazyQuery>;
export type GetApprovalRequestSuspenseQueryHookResult = ReturnType<typeof useGetApprovalRequestSuspenseQuery>;
export type GetApprovalRequestQueryResult = Apollo.QueryResult<GetApprovalRequestQuery, GetApprovalRequestQueryVariables>;
export const GetApprovalStatusCountsDocument = gql`
    query GetApprovalStatusCounts($kinds: [ApprovalRequestKind!]) {
  approvalStatusCounts(kinds: $kinds) {
    status
    count
  }
}
    `;

/**
 * __useGetApprovalStatusCountsQuery__
 *
 * To run a query within a React component, call `useGetApprovalStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalStatusCountsQuery({
 *   variables: {
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useGetApprovalStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>(GetApprovalStatusCountsDocument, options);
      }
export function useGetApprovalStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>(GetApprovalStatusCountsDocument, options);
        }
// @ts-ignore
export function useGetApprovalStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>;
export function useGetApprovalStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalStatusCountsQuery | undefined, GetApprovalStatusCountsQueryVariables>;
export function useGetApprovalStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>(GetApprovalStatusCountsDocument, options);
        }
export type GetApprovalStatusCountsQueryHookResult = ReturnType<typeof useGetApprovalStatusCountsQuery>;
export type GetApprovalStatusCountsLazyQueryHookResult = ReturnType<typeof useGetApprovalStatusCountsLazyQuery>;
export type GetApprovalStatusCountsSuspenseQueryHookResult = ReturnType<typeof useGetApprovalStatusCountsSuspenseQuery>;
export type GetApprovalStatusCountsQueryResult = Apollo.QueryResult<GetApprovalStatusCountsQuery, GetApprovalStatusCountsQueryVariables>;
export const CreateApprovalRequestDocument = gql`
    mutation CreateApprovalRequest($input: CreateApprovalRequestInput!) {
  createApprovalRequest(input: $input) {
    id
    status
    requestReason
    customer {
      id
      firstName
      lastName
    }
    ratePlan {
      id
      rateName
    }
  }
}
    `;
export type CreateApprovalRequestMutationFn = Apollo.MutationFunction<CreateApprovalRequestMutation, CreateApprovalRequestMutationVariables>;

/**
 * __useCreateApprovalRequestMutation__
 *
 * To run a mutation, you first call `useCreateApprovalRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApprovalRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApprovalRequestMutation, { data, loading, error }] = useCreateApprovalRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApprovalRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateApprovalRequestMutation, CreateApprovalRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApprovalRequestMutation, CreateApprovalRequestMutationVariables>(CreateApprovalRequestDocument, options);
      }
export type CreateApprovalRequestMutationHookResult = ReturnType<typeof useCreateApprovalRequestMutation>;
export type CreateApprovalRequestMutationResult = Apollo.MutationResult<CreateApprovalRequestMutation>;
export type CreateApprovalRequestMutationOptions = Apollo.BaseMutationOptions<CreateApprovalRequestMutation, CreateApprovalRequestMutationVariables>;
export const ReviewApprovalRequestDocument = gql`
    mutation ReviewApprovalRequest($id: String!, $input: ReviewApprovalInput!) {
  reviewApprovalRequest(id: $id, input: $input) {
    id
    status
    reviewNotes
    reviewedAt
    contract {
      id
      contractNumber
    }
  }
}
    `;
export type ReviewApprovalRequestMutationFn = Apollo.MutationFunction<ReviewApprovalRequestMutation, ReviewApprovalRequestMutationVariables>;

/**
 * __useReviewApprovalRequestMutation__
 *
 * To run a mutation, you first call `useReviewApprovalRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewApprovalRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewApprovalRequestMutation, { data, loading, error }] = useReviewApprovalRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewApprovalRequestMutation(baseOptions?: Apollo.MutationHookOptions<ReviewApprovalRequestMutation, ReviewApprovalRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewApprovalRequestMutation, ReviewApprovalRequestMutationVariables>(ReviewApprovalRequestDocument, options);
      }
export type ReviewApprovalRequestMutationHookResult = ReturnType<typeof useReviewApprovalRequestMutation>;
export type ReviewApprovalRequestMutationResult = Apollo.MutationResult<ReviewApprovalRequestMutation>;
export type ReviewApprovalRequestMutationOptions = Apollo.BaseMutationOptions<ReviewApprovalRequestMutation, ReviewApprovalRequestMutationVariables>;
export const CancelApprovalRequestDocument = gql`
    mutation CancelApprovalRequest($id: String!) {
  cancelApprovalRequest(id: $id) {
    id
    status
  }
}
    `;
export type CancelApprovalRequestMutationFn = Apollo.MutationFunction<CancelApprovalRequestMutation, CancelApprovalRequestMutationVariables>;

/**
 * __useCancelApprovalRequestMutation__
 *
 * To run a mutation, you first call `useCancelApprovalRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelApprovalRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelApprovalRequestMutation, { data, loading, error }] = useCancelApprovalRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelApprovalRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelApprovalRequestMutation, CancelApprovalRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelApprovalRequestMutation, CancelApprovalRequestMutationVariables>(CancelApprovalRequestDocument, options);
      }
export type CancelApprovalRequestMutationHookResult = ReturnType<typeof useCancelApprovalRequestMutation>;
export type CancelApprovalRequestMutationResult = Apollo.MutationResult<CancelApprovalRequestMutation>;
export type CancelApprovalRequestMutationOptions = Apollo.BaseMutationOptions<CancelApprovalRequestMutation, CancelApprovalRequestMutationVariables>;
export const GetAtlasRekeyDevicesDocument = gql`
    query GetAtlasRekeyDevices($customerId: String, $contractId: String) {
  atlasRekeyDevices(customerId: $customerId, contractId: $contractId) {
    stockSaleId
    contractId
    contractNumber
    accountNumber
    serialNumber
    productName
    vendor
  }
}
    `;

/**
 * __useGetAtlasRekeyDevicesQuery__
 *
 * To run a query within a React component, call `useGetAtlasRekeyDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtlasRekeyDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtlasRekeyDevicesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetAtlasRekeyDevicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>(GetAtlasRekeyDevicesDocument, options);
      }
export function useGetAtlasRekeyDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>(GetAtlasRekeyDevicesDocument, options);
        }
// @ts-ignore
export function useGetAtlasRekeyDevicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>;
export function useGetAtlasRekeyDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtlasRekeyDevicesQuery | undefined, GetAtlasRekeyDevicesQueryVariables>;
export function useGetAtlasRekeyDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>(GetAtlasRekeyDevicesDocument, options);
        }
export type GetAtlasRekeyDevicesQueryHookResult = ReturnType<typeof useGetAtlasRekeyDevicesQuery>;
export type GetAtlasRekeyDevicesLazyQueryHookResult = ReturnType<typeof useGetAtlasRekeyDevicesLazyQuery>;
export type GetAtlasRekeyDevicesSuspenseQueryHookResult = ReturnType<typeof useGetAtlasRekeyDevicesSuspenseQuery>;
export type GetAtlasRekeyDevicesQueryResult = Apollo.QueryResult<GetAtlasRekeyDevicesQuery, GetAtlasRekeyDevicesQueryVariables>;
export const GetAtlasTokenHistoryDocument = gql`
    query GetAtlasTokenHistory($accountNumber: String!, $page: Int, $size: Int) {
  atlasTokenHistory(accountNumber: $accountNumber, page: $page, size: $size) {
    accountNumber
    page
    size
    totalTokens
    hasMore
    fetchedAt
    items {
      id
      token
      index
      tokenType
      issuedAt
    }
  }
}
    `;

/**
 * __useGetAtlasTokenHistoryQuery__
 *
 * To run a query within a React component, call `useGetAtlasTokenHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtlasTokenHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtlasTokenHistoryQuery({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetAtlasTokenHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables> & ({ variables: GetAtlasTokenHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>(GetAtlasTokenHistoryDocument, options);
      }
export function useGetAtlasTokenHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>(GetAtlasTokenHistoryDocument, options);
        }
// @ts-ignore
export function useGetAtlasTokenHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>;
export function useGetAtlasTokenHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtlasTokenHistoryQuery | undefined, GetAtlasTokenHistoryQueryVariables>;
export function useGetAtlasTokenHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>(GetAtlasTokenHistoryDocument, options);
        }
export type GetAtlasTokenHistoryQueryHookResult = ReturnType<typeof useGetAtlasTokenHistoryQuery>;
export type GetAtlasTokenHistoryLazyQueryHookResult = ReturnType<typeof useGetAtlasTokenHistoryLazyQuery>;
export type GetAtlasTokenHistorySuspenseQueryHookResult = ReturnType<typeof useGetAtlasTokenHistorySuspenseQuery>;
export type GetAtlasTokenHistoryQueryResult = Apollo.QueryResult<GetAtlasTokenHistoryQuery, GetAtlasTokenHistoryQueryVariables>;
export const AttendanceRecordsDocument = gql`
    query AttendanceRecords($filter: AttendanceFilterInput) {
  attendanceRecords(filter: $filter) {
    items {
      ...AttendanceRecordFields
    }
    totalCount
  }
}
    ${AttendanceRecordFieldsFragmentDoc}`;

/**
 * __useAttendanceRecordsQuery__
 *
 * To run a query within a React component, call `useAttendanceRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceRecordsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAttendanceRecordsQuery(baseOptions?: Apollo.QueryHookOptions<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>(AttendanceRecordsDocument, options);
      }
export function useAttendanceRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>(AttendanceRecordsDocument, options);
        }
// @ts-ignore
export function useAttendanceRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>;
export function useAttendanceRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<AttendanceRecordsQuery | undefined, AttendanceRecordsQueryVariables>;
export function useAttendanceRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>(AttendanceRecordsDocument, options);
        }
export type AttendanceRecordsQueryHookResult = ReturnType<typeof useAttendanceRecordsQuery>;
export type AttendanceRecordsLazyQueryHookResult = ReturnType<typeof useAttendanceRecordsLazyQuery>;
export type AttendanceRecordsSuspenseQueryHookResult = ReturnType<typeof useAttendanceRecordsSuspenseQuery>;
export type AttendanceRecordsQueryResult = Apollo.QueryResult<AttendanceRecordsQuery, AttendanceRecordsQueryVariables>;
export const AttendanceRecordsExportDocument = gql`
    query AttendanceRecordsExport($filter: AttendanceFilterInput) {
  attendanceRecordsExport(filter: $filter) {
    ...AttendanceRecordFields
  }
}
    ${AttendanceRecordFieldsFragmentDoc}`;

/**
 * __useAttendanceRecordsExportQuery__
 *
 * To run a query within a React component, call `useAttendanceRecordsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceRecordsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceRecordsExportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAttendanceRecordsExportQuery(baseOptions?: Apollo.QueryHookOptions<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>(AttendanceRecordsExportDocument, options);
      }
export function useAttendanceRecordsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>(AttendanceRecordsExportDocument, options);
        }
// @ts-ignore
export function useAttendanceRecordsExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>): Apollo.UseSuspenseQueryResult<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>;
export function useAttendanceRecordsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>): Apollo.UseSuspenseQueryResult<AttendanceRecordsExportQuery | undefined, AttendanceRecordsExportQueryVariables>;
export function useAttendanceRecordsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>(AttendanceRecordsExportDocument, options);
        }
export type AttendanceRecordsExportQueryHookResult = ReturnType<typeof useAttendanceRecordsExportQuery>;
export type AttendanceRecordsExportLazyQueryHookResult = ReturnType<typeof useAttendanceRecordsExportLazyQuery>;
export type AttendanceRecordsExportSuspenseQueryHookResult = ReturnType<typeof useAttendanceRecordsExportSuspenseQuery>;
export type AttendanceRecordsExportQueryResult = Apollo.QueryResult<AttendanceRecordsExportQuery, AttendanceRecordsExportQueryVariables>;
export const LeaveTypesDocument = gql`
    query LeaveTypes {
  leaveTypes {
    ...LeaveTypeFields
  }
}
    ${LeaveTypeFieldsFragmentDoc}`;

/**
 * __useLeaveTypesQuery__
 *
 * To run a query within a React component, call `useLeaveTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaveTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaveTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeaveTypesQuery(baseOptions?: Apollo.QueryHookOptions<LeaveTypesQuery, LeaveTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaveTypesQuery, LeaveTypesQueryVariables>(LeaveTypesDocument, options);
      }
export function useLeaveTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaveTypesQuery, LeaveTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaveTypesQuery, LeaveTypesQueryVariables>(LeaveTypesDocument, options);
        }
// @ts-ignore
export function useLeaveTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LeaveTypesQuery, LeaveTypesQueryVariables>): Apollo.UseSuspenseQueryResult<LeaveTypesQuery, LeaveTypesQueryVariables>;
export function useLeaveTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaveTypesQuery, LeaveTypesQueryVariables>): Apollo.UseSuspenseQueryResult<LeaveTypesQuery | undefined, LeaveTypesQueryVariables>;
export function useLeaveTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaveTypesQuery, LeaveTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeaveTypesQuery, LeaveTypesQueryVariables>(LeaveTypesDocument, options);
        }
export type LeaveTypesQueryHookResult = ReturnType<typeof useLeaveTypesQuery>;
export type LeaveTypesLazyQueryHookResult = ReturnType<typeof useLeaveTypesLazyQuery>;
export type LeaveTypesSuspenseQueryHookResult = ReturnType<typeof useLeaveTypesSuspenseQuery>;
export type LeaveTypesQueryResult = Apollo.QueryResult<LeaveTypesQuery, LeaveTypesQueryVariables>;
export const LeaveRequestsDocument = gql`
    query LeaveRequests($filter: LeaveRequestFilterInput) {
  leaveRequests(filter: $filter) {
    items {
      ...LeaveRequestFields
    }
    totalCount
  }
}
    ${LeaveRequestFieldsFragmentDoc}`;

/**
 * __useLeaveRequestsQuery__
 *
 * To run a query within a React component, call `useLeaveRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaveRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaveRequestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLeaveRequestsQuery(baseOptions?: Apollo.QueryHookOptions<LeaveRequestsQuery, LeaveRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaveRequestsQuery, LeaveRequestsQueryVariables>(LeaveRequestsDocument, options);
      }
export function useLeaveRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaveRequestsQuery, LeaveRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaveRequestsQuery, LeaveRequestsQueryVariables>(LeaveRequestsDocument, options);
        }
// @ts-ignore
export function useLeaveRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LeaveRequestsQuery, LeaveRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<LeaveRequestsQuery, LeaveRequestsQueryVariables>;
export function useLeaveRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaveRequestsQuery, LeaveRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<LeaveRequestsQuery | undefined, LeaveRequestsQueryVariables>;
export function useLeaveRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaveRequestsQuery, LeaveRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeaveRequestsQuery, LeaveRequestsQueryVariables>(LeaveRequestsDocument, options);
        }
export type LeaveRequestsQueryHookResult = ReturnType<typeof useLeaveRequestsQuery>;
export type LeaveRequestsLazyQueryHookResult = ReturnType<typeof useLeaveRequestsLazyQuery>;
export type LeaveRequestsSuspenseQueryHookResult = ReturnType<typeof useLeaveRequestsSuspenseQuery>;
export type LeaveRequestsQueryResult = Apollo.QueryResult<LeaveRequestsQuery, LeaveRequestsQueryVariables>;
export const LeaveBalancesDocument = gql`
    query LeaveBalances($filter: LeaveBalanceFilterInput) {
  leaveBalances(filter: $filter) {
    ...LeaveBalanceFields
  }
}
    ${LeaveBalanceFieldsFragmentDoc}`;

/**
 * __useLeaveBalancesQuery__
 *
 * To run a query within a React component, call `useLeaveBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaveBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaveBalancesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLeaveBalancesQuery(baseOptions?: Apollo.QueryHookOptions<LeaveBalancesQuery, LeaveBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaveBalancesQuery, LeaveBalancesQueryVariables>(LeaveBalancesDocument, options);
      }
export function useLeaveBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaveBalancesQuery, LeaveBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaveBalancesQuery, LeaveBalancesQueryVariables>(LeaveBalancesDocument, options);
        }
// @ts-ignore
export function useLeaveBalancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LeaveBalancesQuery, LeaveBalancesQueryVariables>): Apollo.UseSuspenseQueryResult<LeaveBalancesQuery, LeaveBalancesQueryVariables>;
export function useLeaveBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaveBalancesQuery, LeaveBalancesQueryVariables>): Apollo.UseSuspenseQueryResult<LeaveBalancesQuery | undefined, LeaveBalancesQueryVariables>;
export function useLeaveBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaveBalancesQuery, LeaveBalancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeaveBalancesQuery, LeaveBalancesQueryVariables>(LeaveBalancesDocument, options);
        }
export type LeaveBalancesQueryHookResult = ReturnType<typeof useLeaveBalancesQuery>;
export type LeaveBalancesLazyQueryHookResult = ReturnType<typeof useLeaveBalancesLazyQuery>;
export type LeaveBalancesSuspenseQueryHookResult = ReturnType<typeof useLeaveBalancesSuspenseQuery>;
export type LeaveBalancesQueryResult = Apollo.QueryResult<LeaveBalancesQuery, LeaveBalancesQueryVariables>;
export const AttendanceMetricsDocument = gql`
    query AttendanceMetrics($from: DateTime!, $to: DateTime!, $filter: AttendanceMetricsFilterInput) {
  attendanceMetrics(from: $from, to: $to, filter: $filter) {
    from
    to
    absenteeismRate {
      ...HrMetricFields
    }
    absentDays {
      ...HrMetricFields
    }
    scheduledDays {
      ...HrMetricFields
    }
    lateArrivals {
      ...HrMetricFields
    }
    hoursWorked {
      ...HrMetricFields
    }
    overtimeHours {
      ...HrMetricFields
    }
    sickDays {
      ...HrMetricFields
    }
    sickDaysPerEmployee {
      ...HrMetricFields
    }
    leaveDaysTaken {
      ...HrMetricFields
    }
    pendingLeaveRequests {
      ...HrMetricFields
    }
    leaveLiabilityDays {
      ...HrMetricFields
    }
    leaveTakenByType {
      category
      days
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useAttendanceMetricsQuery__
 *
 * To run a query within a React component, call `useAttendanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAttendanceMetricsQuery(baseOptions: Apollo.QueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables> & ({ variables: AttendanceMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(AttendanceMetricsDocument, options);
      }
export function useAttendanceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(AttendanceMetricsDocument, options);
        }
// @ts-ignore
export function useAttendanceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>;
export function useAttendanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AttendanceMetricsQuery | undefined, AttendanceMetricsQueryVariables>;
export function useAttendanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(AttendanceMetricsDocument, options);
        }
export type AttendanceMetricsQueryHookResult = ReturnType<typeof useAttendanceMetricsQuery>;
export type AttendanceMetricsLazyQueryHookResult = ReturnType<typeof useAttendanceMetricsLazyQuery>;
export type AttendanceMetricsSuspenseQueryHookResult = ReturnType<typeof useAttendanceMetricsSuspenseQuery>;
export type AttendanceMetricsQueryResult = Apollo.QueryResult<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>;
export const CreateAttendanceRecordDocument = gql`
    mutation CreateAttendanceRecord($employeeId: ID!, $input: CreateAttendanceRecordInput!) {
  createAttendanceRecord(employeeId: $employeeId, input: $input) {
    ...AttendanceRecordFields
  }
}
    ${AttendanceRecordFieldsFragmentDoc}`;
export type CreateAttendanceRecordMutationFn = Apollo.MutationFunction<CreateAttendanceRecordMutation, CreateAttendanceRecordMutationVariables>;

/**
 * __useCreateAttendanceRecordMutation__
 *
 * To run a mutation, you first call `useCreateAttendanceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttendanceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttendanceRecordMutation, { data, loading, error }] = useCreateAttendanceRecordMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttendanceRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttendanceRecordMutation, CreateAttendanceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttendanceRecordMutation, CreateAttendanceRecordMutationVariables>(CreateAttendanceRecordDocument, options);
      }
export type CreateAttendanceRecordMutationHookResult = ReturnType<typeof useCreateAttendanceRecordMutation>;
export type CreateAttendanceRecordMutationResult = Apollo.MutationResult<CreateAttendanceRecordMutation>;
export type CreateAttendanceRecordMutationOptions = Apollo.BaseMutationOptions<CreateAttendanceRecordMutation, CreateAttendanceRecordMutationVariables>;
export const UpdateAttendanceRecordDocument = gql`
    mutation UpdateAttendanceRecord($id: ID!, $input: UpdateAttendanceRecordInput!) {
  updateAttendanceRecord(id: $id, input: $input) {
    ...AttendanceRecordFields
  }
}
    ${AttendanceRecordFieldsFragmentDoc}`;
export type UpdateAttendanceRecordMutationFn = Apollo.MutationFunction<UpdateAttendanceRecordMutation, UpdateAttendanceRecordMutationVariables>;

/**
 * __useUpdateAttendanceRecordMutation__
 *
 * To run a mutation, you first call `useUpdateAttendanceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttendanceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttendanceRecordMutation, { data, loading, error }] = useUpdateAttendanceRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttendanceRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttendanceRecordMutation, UpdateAttendanceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttendanceRecordMutation, UpdateAttendanceRecordMutationVariables>(UpdateAttendanceRecordDocument, options);
      }
export type UpdateAttendanceRecordMutationHookResult = ReturnType<typeof useUpdateAttendanceRecordMutation>;
export type UpdateAttendanceRecordMutationResult = Apollo.MutationResult<UpdateAttendanceRecordMutation>;
export type UpdateAttendanceRecordMutationOptions = Apollo.BaseMutationOptions<UpdateAttendanceRecordMutation, UpdateAttendanceRecordMutationVariables>;
export const DeleteAttendanceRecordDocument = gql`
    mutation DeleteAttendanceRecord($id: ID!) {
  deleteAttendanceRecord(id: $id)
}
    `;
export type DeleteAttendanceRecordMutationFn = Apollo.MutationFunction<DeleteAttendanceRecordMutation, DeleteAttendanceRecordMutationVariables>;

/**
 * __useDeleteAttendanceRecordMutation__
 *
 * To run a mutation, you first call `useDeleteAttendanceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendanceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendanceRecordMutation, { data, loading, error }] = useDeleteAttendanceRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttendanceRecordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttendanceRecordMutation, DeleteAttendanceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttendanceRecordMutation, DeleteAttendanceRecordMutationVariables>(DeleteAttendanceRecordDocument, options);
      }
export type DeleteAttendanceRecordMutationHookResult = ReturnType<typeof useDeleteAttendanceRecordMutation>;
export type DeleteAttendanceRecordMutationResult = Apollo.MutationResult<DeleteAttendanceRecordMutation>;
export type DeleteAttendanceRecordMutationOptions = Apollo.BaseMutationOptions<DeleteAttendanceRecordMutation, DeleteAttendanceRecordMutationVariables>;
export const ImportAttendanceDocument = gql`
    mutation ImportAttendance($csv: String!) {
  importAttendance(csv: $csv) {
    ...HrImportResultFields
  }
}
    ${HrImportResultFieldsFragmentDoc}`;
export type ImportAttendanceMutationFn = Apollo.MutationFunction<ImportAttendanceMutation, ImportAttendanceMutationVariables>;

/**
 * __useImportAttendanceMutation__
 *
 * To run a mutation, you first call `useImportAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAttendanceMutation, { data, loading, error }] = useImportAttendanceMutation({
 *   variables: {
 *      csv: // value for 'csv'
 *   },
 * });
 */
export function useImportAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<ImportAttendanceMutation, ImportAttendanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportAttendanceMutation, ImportAttendanceMutationVariables>(ImportAttendanceDocument, options);
      }
export type ImportAttendanceMutationHookResult = ReturnType<typeof useImportAttendanceMutation>;
export type ImportAttendanceMutationResult = Apollo.MutationResult<ImportAttendanceMutation>;
export type ImportAttendanceMutationOptions = Apollo.BaseMutationOptions<ImportAttendanceMutation, ImportAttendanceMutationVariables>;
export const SeedLeaveTypesDocument = gql`
    mutation SeedLeaveTypes {
  seedLeaveTypes {
    ...LeaveTypeFields
  }
}
    ${LeaveTypeFieldsFragmentDoc}`;
export type SeedLeaveTypesMutationFn = Apollo.MutationFunction<SeedLeaveTypesMutation, SeedLeaveTypesMutationVariables>;

/**
 * __useSeedLeaveTypesMutation__
 *
 * To run a mutation, you first call `useSeedLeaveTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedLeaveTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedLeaveTypesMutation, { data, loading, error }] = useSeedLeaveTypesMutation({
 *   variables: {
 *   },
 * });
 */
export function useSeedLeaveTypesMutation(baseOptions?: Apollo.MutationHookOptions<SeedLeaveTypesMutation, SeedLeaveTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeedLeaveTypesMutation, SeedLeaveTypesMutationVariables>(SeedLeaveTypesDocument, options);
      }
export type SeedLeaveTypesMutationHookResult = ReturnType<typeof useSeedLeaveTypesMutation>;
export type SeedLeaveTypesMutationResult = Apollo.MutationResult<SeedLeaveTypesMutation>;
export type SeedLeaveTypesMutationOptions = Apollo.BaseMutationOptions<SeedLeaveTypesMutation, SeedLeaveTypesMutationVariables>;
export const UpdateLeaveTypeDocument = gql`
    mutation UpdateLeaveType($id: ID!, $input: UpdateLeaveTypeInput!) {
  updateLeaveType(id: $id, input: $input) {
    ...LeaveTypeFields
  }
}
    ${LeaveTypeFieldsFragmentDoc}`;
export type UpdateLeaveTypeMutationFn = Apollo.MutationFunction<UpdateLeaveTypeMutation, UpdateLeaveTypeMutationVariables>;

/**
 * __useUpdateLeaveTypeMutation__
 *
 * To run a mutation, you first call `useUpdateLeaveTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaveTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaveTypeMutation, { data, loading, error }] = useUpdateLeaveTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeaveTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaveTypeMutation, UpdateLeaveTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaveTypeMutation, UpdateLeaveTypeMutationVariables>(UpdateLeaveTypeDocument, options);
      }
export type UpdateLeaveTypeMutationHookResult = ReturnType<typeof useUpdateLeaveTypeMutation>;
export type UpdateLeaveTypeMutationResult = Apollo.MutationResult<UpdateLeaveTypeMutation>;
export type UpdateLeaveTypeMutationOptions = Apollo.BaseMutationOptions<UpdateLeaveTypeMutation, UpdateLeaveTypeMutationVariables>;
export const CreateLeaveRequestDocument = gql`
    mutation CreateLeaveRequest($input: CreateLeaveRequestInput!) {
  createLeaveRequest(input: $input) {
    ...LeaveRequestFields
  }
}
    ${LeaveRequestFieldsFragmentDoc}`;
export type CreateLeaveRequestMutationFn = Apollo.MutationFunction<CreateLeaveRequestMutation, CreateLeaveRequestMutationVariables>;

/**
 * __useCreateLeaveRequestMutation__
 *
 * To run a mutation, you first call `useCreateLeaveRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaveRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaveRequestMutation, { data, loading, error }] = useCreateLeaveRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeaveRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaveRequestMutation, CreateLeaveRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaveRequestMutation, CreateLeaveRequestMutationVariables>(CreateLeaveRequestDocument, options);
      }
export type CreateLeaveRequestMutationHookResult = ReturnType<typeof useCreateLeaveRequestMutation>;
export type CreateLeaveRequestMutationResult = Apollo.MutationResult<CreateLeaveRequestMutation>;
export type CreateLeaveRequestMutationOptions = Apollo.BaseMutationOptions<CreateLeaveRequestMutation, CreateLeaveRequestMutationVariables>;
export const DecideLeaveRequestDocument = gql`
    mutation DecideLeaveRequest($id: ID!, $approve: Boolean!, $note: String) {
  decideLeaveRequest(id: $id, approve: $approve, note: $note) {
    ...LeaveRequestFields
  }
}
    ${LeaveRequestFieldsFragmentDoc}`;
export type DecideLeaveRequestMutationFn = Apollo.MutationFunction<DecideLeaveRequestMutation, DecideLeaveRequestMutationVariables>;

/**
 * __useDecideLeaveRequestMutation__
 *
 * To run a mutation, you first call `useDecideLeaveRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecideLeaveRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decideLeaveRequestMutation, { data, loading, error }] = useDecideLeaveRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approve: // value for 'approve'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useDecideLeaveRequestMutation(baseOptions?: Apollo.MutationHookOptions<DecideLeaveRequestMutation, DecideLeaveRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DecideLeaveRequestMutation, DecideLeaveRequestMutationVariables>(DecideLeaveRequestDocument, options);
      }
export type DecideLeaveRequestMutationHookResult = ReturnType<typeof useDecideLeaveRequestMutation>;
export type DecideLeaveRequestMutationResult = Apollo.MutationResult<DecideLeaveRequestMutation>;
export type DecideLeaveRequestMutationOptions = Apollo.BaseMutationOptions<DecideLeaveRequestMutation, DecideLeaveRequestMutationVariables>;
export const CancelLeaveRequestDocument = gql`
    mutation CancelLeaveRequest($id: ID!) {
  cancelLeaveRequest(id: $id) {
    ...LeaveRequestFields
  }
}
    ${LeaveRequestFieldsFragmentDoc}`;
export type CancelLeaveRequestMutationFn = Apollo.MutationFunction<CancelLeaveRequestMutation, CancelLeaveRequestMutationVariables>;

/**
 * __useCancelLeaveRequestMutation__
 *
 * To run a mutation, you first call `useCancelLeaveRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLeaveRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLeaveRequestMutation, { data, loading, error }] = useCancelLeaveRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelLeaveRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelLeaveRequestMutation, CancelLeaveRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelLeaveRequestMutation, CancelLeaveRequestMutationVariables>(CancelLeaveRequestDocument, options);
      }
export type CancelLeaveRequestMutationHookResult = ReturnType<typeof useCancelLeaveRequestMutation>;
export type CancelLeaveRequestMutationResult = Apollo.MutationResult<CancelLeaveRequestMutation>;
export type CancelLeaveRequestMutationOptions = Apollo.BaseMutationOptions<CancelLeaveRequestMutation, CancelLeaveRequestMutationVariables>;
export const CreateLeaveBalanceDocument = gql`
    mutation CreateLeaveBalance($employeeId: ID!, $leaveTypeId: ID!, $input: CreateLeaveBalanceInput!) {
  createLeaveBalance(
    employeeId: $employeeId
    leaveTypeId: $leaveTypeId
    input: $input
  ) {
    ...LeaveBalanceFields
  }
}
    ${LeaveBalanceFieldsFragmentDoc}`;
export type CreateLeaveBalanceMutationFn = Apollo.MutationFunction<CreateLeaveBalanceMutation, CreateLeaveBalanceMutationVariables>;

/**
 * __useCreateLeaveBalanceMutation__
 *
 * To run a mutation, you first call `useCreateLeaveBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaveBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaveBalanceMutation, { data, loading, error }] = useCreateLeaveBalanceMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      leaveTypeId: // value for 'leaveTypeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeaveBalanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaveBalanceMutation, CreateLeaveBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaveBalanceMutation, CreateLeaveBalanceMutationVariables>(CreateLeaveBalanceDocument, options);
      }
export type CreateLeaveBalanceMutationHookResult = ReturnType<typeof useCreateLeaveBalanceMutation>;
export type CreateLeaveBalanceMutationResult = Apollo.MutationResult<CreateLeaveBalanceMutation>;
export type CreateLeaveBalanceMutationOptions = Apollo.BaseMutationOptions<CreateLeaveBalanceMutation, CreateLeaveBalanceMutationVariables>;
export const UpdateLeaveBalanceDocument = gql`
    mutation UpdateLeaveBalance($id: ID!, $input: UpdateLeaveBalanceInput!) {
  updateLeaveBalance(id: $id, input: $input) {
    ...LeaveBalanceFields
  }
}
    ${LeaveBalanceFieldsFragmentDoc}`;
export type UpdateLeaveBalanceMutationFn = Apollo.MutationFunction<UpdateLeaveBalanceMutation, UpdateLeaveBalanceMutationVariables>;

/**
 * __useUpdateLeaveBalanceMutation__
 *
 * To run a mutation, you first call `useUpdateLeaveBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaveBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaveBalanceMutation, { data, loading, error }] = useUpdateLeaveBalanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeaveBalanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaveBalanceMutation, UpdateLeaveBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaveBalanceMutation, UpdateLeaveBalanceMutationVariables>(UpdateLeaveBalanceDocument, options);
      }
export type UpdateLeaveBalanceMutationHookResult = ReturnType<typeof useUpdateLeaveBalanceMutation>;
export type UpdateLeaveBalanceMutationResult = Apollo.MutationResult<UpdateLeaveBalanceMutation>;
export type UpdateLeaveBalanceMutationOptions = Apollo.BaseMutationOptions<UpdateLeaveBalanceMutation, UpdateLeaveBalanceMutationVariables>;
export const DeleteLeaveBalanceDocument = gql`
    mutation DeleteLeaveBalance($id: ID!) {
  deleteLeaveBalance(id: $id)
}
    `;
export type DeleteLeaveBalanceMutationFn = Apollo.MutationFunction<DeleteLeaveBalanceMutation, DeleteLeaveBalanceMutationVariables>;

/**
 * __useDeleteLeaveBalanceMutation__
 *
 * To run a mutation, you first call `useDeleteLeaveBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeaveBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeaveBalanceMutation, { data, loading, error }] = useDeleteLeaveBalanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLeaveBalanceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeaveBalanceMutation, DeleteLeaveBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeaveBalanceMutation, DeleteLeaveBalanceMutationVariables>(DeleteLeaveBalanceDocument, options);
      }
export type DeleteLeaveBalanceMutationHookResult = ReturnType<typeof useDeleteLeaveBalanceMutation>;
export type DeleteLeaveBalanceMutationResult = Apollo.MutationResult<DeleteLeaveBalanceMutation>;
export type DeleteLeaveBalanceMutationOptions = Apollo.BaseMutationOptions<DeleteLeaveBalanceMutation, DeleteLeaveBalanceMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    accessToken
    refreshToken
    expiresIn
    requiresEmailVerification
    user {
      id
      email
      firstName
      lastName
      confirmed
      isSuperAdmin
      homeModule
      organization {
        id
        name
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($input: AcceptInviteInput!) {
  acceptInvite(input: $input) {
    accessToken
    refreshToken
    expiresIn
    user {
      id
      email
      firstName
      lastName
      confirmed
      isSuperAdmin
      homeModule
      organization {
        id
        name
      }
    }
  }
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const ValidateInviteDocument = gql`
    mutation ValidateInvite($token: String!) {
  validateInvite(token: $token) {
    valid
    email
    organizationName
    requireConfirmPassword
    isAgent
    agentType
    agentCategoryId
    getsStockingPoint
    firstName
    lastName
    externalAgentId
    dccProfile {
      externalAgentId
      name
      surname
      ramId
      ramName
      role
    }
  }
}
    `;
export type ValidateInviteMutationFn = Apollo.MutationFunction<ValidateInviteMutation, ValidateInviteMutationVariables>;

/**
 * __useValidateInviteMutation__
 *
 * To run a mutation, you first call `useValidateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateInviteMutation, { data, loading, error }] = useValidateInviteMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateInviteMutation(baseOptions?: Apollo.MutationHookOptions<ValidateInviteMutation, ValidateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateInviteMutation, ValidateInviteMutationVariables>(ValidateInviteDocument, options);
      }
export type ValidateInviteMutationHookResult = ReturnType<typeof useValidateInviteMutation>;
export type ValidateInviteMutationResult = Apollo.MutationResult<ValidateInviteMutation>;
export type ValidateInviteMutationOptions = Apollo.BaseMutationOptions<ValidateInviteMutation, ValidateInviteMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: RefreshTokenInput!) {
  refreshToken(input: $input) {
    accessToken
    expiresIn
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($input: VerifyEmailInput!) {
  verifyEmail(input: $input) {
    success
    message
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation ResendVerificationEmail {
  resendVerificationEmail {
    success
    message
  }
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input) {
    success
    message
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    success
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    success
    message
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const GetBankStatementBatchesDocument = gql`
    query GetBankStatementBatches($limit: Int, $offset: Int, $search: String) {
  bankStatementBatches(limit: $limit, offset: $offset, search: $search) {
    totalCount
    items {
      id
      createdAt
      processedAt
      uploadedByName
      bank
      format
      originalFileName
      status
      totalRows
      matchedRows
      processedRows
    }
  }
}
    `;

/**
 * __useGetBankStatementBatchesQuery__
 *
 * To run a query within a React component, call `useGetBankStatementBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankStatementBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankStatementBatchesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetBankStatementBatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>(GetBankStatementBatchesDocument, options);
      }
export function useGetBankStatementBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>(GetBankStatementBatchesDocument, options);
        }
// @ts-ignore
export function useGetBankStatementBatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>;
export function useGetBankStatementBatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBankStatementBatchesQuery | undefined, GetBankStatementBatchesQueryVariables>;
export function useGetBankStatementBatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>(GetBankStatementBatchesDocument, options);
        }
export type GetBankStatementBatchesQueryHookResult = ReturnType<typeof useGetBankStatementBatchesQuery>;
export type GetBankStatementBatchesLazyQueryHookResult = ReturnType<typeof useGetBankStatementBatchesLazyQuery>;
export type GetBankStatementBatchesSuspenseQueryHookResult = ReturnType<typeof useGetBankStatementBatchesSuspenseQuery>;
export type GetBankStatementBatchesQueryResult = Apollo.QueryResult<GetBankStatementBatchesQuery, GetBankStatementBatchesQueryVariables>;
export const GetBankStatementBatchDocument = gql`
    query GetBankStatementBatch($id: String!) {
  bankStatementBatch(id: $id) {
    id
    createdAt
    processedAt
    uploadedByName
    bank
    format
    originalFileName
    status
    totalRows
    matchedRows
    processedRows
    eligibleProcessableRows
    periods {
      weekStart
      weekEnd
      eligible
      totalRows
      processableRows
    }
    rows {
      id
      rowIndex
      bankUniqueId
      bankDate
      amount
      rawDescription
      scrubbedDescription
      derivedAccountNumber
      matchedContractId
      matchedCustomerId
      customerName
      disposition
      noLoadReason
      lastTransactionAt
      lastTransactionAmount
      paymentTransactionId
      error
    }
  }
}
    `;

/**
 * __useGetBankStatementBatchQuery__
 *
 * To run a query within a React component, call `useGetBankStatementBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankStatementBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankStatementBatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBankStatementBatchQuery(baseOptions: Apollo.QueryHookOptions<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables> & ({ variables: GetBankStatementBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>(GetBankStatementBatchDocument, options);
      }
export function useGetBankStatementBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>(GetBankStatementBatchDocument, options);
        }
// @ts-ignore
export function useGetBankStatementBatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>;
export function useGetBankStatementBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GetBankStatementBatchQuery | undefined, GetBankStatementBatchQueryVariables>;
export function useGetBankStatementBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>(GetBankStatementBatchDocument, options);
        }
export type GetBankStatementBatchQueryHookResult = ReturnType<typeof useGetBankStatementBatchQuery>;
export type GetBankStatementBatchLazyQueryHookResult = ReturnType<typeof useGetBankStatementBatchLazyQuery>;
export type GetBankStatementBatchSuspenseQueryHookResult = ReturnType<typeof useGetBankStatementBatchSuspenseQuery>;
export type GetBankStatementBatchQueryResult = Apollo.QueryResult<GetBankStatementBatchQuery, GetBankStatementBatchQueryVariables>;
export const AutoMatchBankStatementDocument = gql`
    mutation AutoMatchBankStatement($batchId: String!) {
  autoMatchBankStatement(batchId: $batchId) {
    id
    status
    totalRows
    matchedRows
    processedRows
  }
}
    `;
export type AutoMatchBankStatementMutationFn = Apollo.MutationFunction<AutoMatchBankStatementMutation, AutoMatchBankStatementMutationVariables>;

/**
 * __useAutoMatchBankStatementMutation__
 *
 * To run a mutation, you first call `useAutoMatchBankStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoMatchBankStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoMatchBankStatementMutation, { data, loading, error }] = useAutoMatchBankStatementMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useAutoMatchBankStatementMutation(baseOptions?: Apollo.MutationHookOptions<AutoMatchBankStatementMutation, AutoMatchBankStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoMatchBankStatementMutation, AutoMatchBankStatementMutationVariables>(AutoMatchBankStatementDocument, options);
      }
export type AutoMatchBankStatementMutationHookResult = ReturnType<typeof useAutoMatchBankStatementMutation>;
export type AutoMatchBankStatementMutationResult = Apollo.MutationResult<AutoMatchBankStatementMutation>;
export type AutoMatchBankStatementMutationOptions = Apollo.BaseMutationOptions<AutoMatchBankStatementMutation, AutoMatchBankStatementMutationVariables>;
export const UpdateBankStatementRowDocument = gql`
    mutation UpdateBankStatementRow($input: UpdateBankStatementRowInput!) {
  updateBankStatementRow(input: $input) {
    id
    disposition
    noLoadReason
    derivedAccountNumber
    matchedContractId
    matchedCustomerId
    customerName
    amount
    error
    lastTransactionAt
    lastTransactionAmount
  }
}
    `;
export type UpdateBankStatementRowMutationFn = Apollo.MutationFunction<UpdateBankStatementRowMutation, UpdateBankStatementRowMutationVariables>;

/**
 * __useUpdateBankStatementRowMutation__
 *
 * To run a mutation, you first call `useUpdateBankStatementRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankStatementRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankStatementRowMutation, { data, loading, error }] = useUpdateBankStatementRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBankStatementRowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankStatementRowMutation, UpdateBankStatementRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBankStatementRowMutation, UpdateBankStatementRowMutationVariables>(UpdateBankStatementRowDocument, options);
      }
export type UpdateBankStatementRowMutationHookResult = ReturnType<typeof useUpdateBankStatementRowMutation>;
export type UpdateBankStatementRowMutationResult = Apollo.MutationResult<UpdateBankStatementRowMutation>;
export type UpdateBankStatementRowMutationOptions = Apollo.BaseMutationOptions<UpdateBankStatementRowMutation, UpdateBankStatementRowMutationVariables>;
export const ProcessBankStatementDocument = gql`
    mutation ProcessBankStatement($batchId: String!, $weekStarts: [String!]) {
  processBankStatement(batchId: $batchId, weekStarts: $weekStarts) {
    batchId
    processed
    skipped
    failed {
      rowId
      error
    }
  }
}
    `;
export type ProcessBankStatementMutationFn = Apollo.MutationFunction<ProcessBankStatementMutation, ProcessBankStatementMutationVariables>;

/**
 * __useProcessBankStatementMutation__
 *
 * To run a mutation, you first call `useProcessBankStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessBankStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processBankStatementMutation, { data, loading, error }] = useProcessBankStatementMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      weekStarts: // value for 'weekStarts'
 *   },
 * });
 */
export function useProcessBankStatementMutation(baseOptions?: Apollo.MutationHookOptions<ProcessBankStatementMutation, ProcessBankStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessBankStatementMutation, ProcessBankStatementMutationVariables>(ProcessBankStatementDocument, options);
      }
export type ProcessBankStatementMutationHookResult = ReturnType<typeof useProcessBankStatementMutation>;
export type ProcessBankStatementMutationResult = Apollo.MutationResult<ProcessBankStatementMutation>;
export type ProcessBankStatementMutationOptions = Apollo.BaseMutationOptions<ProcessBankStatementMutation, ProcessBankStatementMutationVariables>;
export const ProcessBankStatementsDocument = gql`
    mutation ProcessBankStatements($batchIds: [String!]!, $weekStarts: [String!]!) {
  processBankStatements(batchIds: $batchIds, weekStarts: $weekStarts) {
    batchId
    processed
    skipped
    failed {
      rowId
      error
    }
  }
}
    `;
export type ProcessBankStatementsMutationFn = Apollo.MutationFunction<ProcessBankStatementsMutation, ProcessBankStatementsMutationVariables>;

/**
 * __useProcessBankStatementsMutation__
 *
 * To run a mutation, you first call `useProcessBankStatementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessBankStatementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processBankStatementsMutation, { data, loading, error }] = useProcessBankStatementsMutation({
 *   variables: {
 *      batchIds: // value for 'batchIds'
 *      weekStarts: // value for 'weekStarts'
 *   },
 * });
 */
export function useProcessBankStatementsMutation(baseOptions?: Apollo.MutationHookOptions<ProcessBankStatementsMutation, ProcessBankStatementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessBankStatementsMutation, ProcessBankStatementsMutationVariables>(ProcessBankStatementsDocument, options);
      }
export type ProcessBankStatementsMutationHookResult = ReturnType<typeof useProcessBankStatementsMutation>;
export type ProcessBankStatementsMutationResult = Apollo.MutationResult<ProcessBankStatementsMutation>;
export type ProcessBankStatementsMutationOptions = Apollo.BaseMutationOptions<ProcessBankStatementsMutation, ProcessBankStatementsMutationVariables>;
export const GetBankStatementTokenWeeksDocument = gql`
    query GetBankStatementTokenWeeks {
  bankStatementTokenWeeks {
    weekStart
    weekEnd
    processableRows
    statements {
      processableRows
      batch {
        id
        createdAt
        bank
        originalFileName
      }
    }
  }
}
    `;

/**
 * __useGetBankStatementTokenWeeksQuery__
 *
 * To run a query within a React component, call `useGetBankStatementTokenWeeksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankStatementTokenWeeksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankStatementTokenWeeksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankStatementTokenWeeksQuery(baseOptions?: Apollo.QueryHookOptions<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>(GetBankStatementTokenWeeksDocument, options);
      }
export function useGetBankStatementTokenWeeksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>(GetBankStatementTokenWeeksDocument, options);
        }
// @ts-ignore
export function useGetBankStatementTokenWeeksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>): Apollo.UseSuspenseQueryResult<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>;
export function useGetBankStatementTokenWeeksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>): Apollo.UseSuspenseQueryResult<GetBankStatementTokenWeeksQuery | undefined, GetBankStatementTokenWeeksQueryVariables>;
export function useGetBankStatementTokenWeeksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>(GetBankStatementTokenWeeksDocument, options);
        }
export type GetBankStatementTokenWeeksQueryHookResult = ReturnType<typeof useGetBankStatementTokenWeeksQuery>;
export type GetBankStatementTokenWeeksLazyQueryHookResult = ReturnType<typeof useGetBankStatementTokenWeeksLazyQuery>;
export type GetBankStatementTokenWeeksSuspenseQueryHookResult = ReturnType<typeof useGetBankStatementTokenWeeksSuspenseQuery>;
export type GetBankStatementTokenWeeksQueryResult = Apollo.QueryResult<GetBankStatementTokenWeeksQuery, GetBankStatementTokenWeeksQueryVariables>;
export const SearchBankStatementContractsDocument = gql`
    query SearchBankStatementContracts($search: String!) {
  bankStatementContractSearch(search: $search) {
    contractId
    contractNumber
    status
    customerName
    accountNumber
  }
}
    `;

/**
 * __useSearchBankStatementContractsQuery__
 *
 * To run a query within a React component, call `useSearchBankStatementContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBankStatementContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBankStatementContractsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchBankStatementContractsQuery(baseOptions: Apollo.QueryHookOptions<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables> & ({ variables: SearchBankStatementContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>(SearchBankStatementContractsDocument, options);
      }
export function useSearchBankStatementContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>(SearchBankStatementContractsDocument, options);
        }
// @ts-ignore
export function useSearchBankStatementContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>;
export function useSearchBankStatementContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchBankStatementContractsQuery | undefined, SearchBankStatementContractsQueryVariables>;
export function useSearchBankStatementContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>(SearchBankStatementContractsDocument, options);
        }
export type SearchBankStatementContractsQueryHookResult = ReturnType<typeof useSearchBankStatementContractsQuery>;
export type SearchBankStatementContractsLazyQueryHookResult = ReturnType<typeof useSearchBankStatementContractsLazyQuery>;
export type SearchBankStatementContractsSuspenseQueryHookResult = ReturnType<typeof useSearchBankStatementContractsSuspenseQuery>;
export type SearchBankStatementContractsQueryResult = Apollo.QueryResult<SearchBankStatementContractsQuery, SearchBankStatementContractsQueryVariables>;
export const GetBankStatementRowCandidatesDocument = gql`
    query GetBankStatementRowCandidates($rowId: String!) {
  bankStatementRowCandidates(rowId: $rowId) {
    id
    createdAt
    referenceCode
    amount
    reason
    createdBy
    tokenDays
    bankConfirmed
  }
}
    `;

/**
 * __useGetBankStatementRowCandidatesQuery__
 *
 * To run a query within a React component, call `useGetBankStatementRowCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankStatementRowCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankStatementRowCandidatesQuery({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useGetBankStatementRowCandidatesQuery(baseOptions: Apollo.QueryHookOptions<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables> & ({ variables: GetBankStatementRowCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>(GetBankStatementRowCandidatesDocument, options);
      }
export function useGetBankStatementRowCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>(GetBankStatementRowCandidatesDocument, options);
        }
// @ts-ignore
export function useGetBankStatementRowCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>;
export function useGetBankStatementRowCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBankStatementRowCandidatesQuery | undefined, GetBankStatementRowCandidatesQueryVariables>;
export function useGetBankStatementRowCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>(GetBankStatementRowCandidatesDocument, options);
        }
export type GetBankStatementRowCandidatesQueryHookResult = ReturnType<typeof useGetBankStatementRowCandidatesQuery>;
export type GetBankStatementRowCandidatesLazyQueryHookResult = ReturnType<typeof useGetBankStatementRowCandidatesLazyQuery>;
export type GetBankStatementRowCandidatesSuspenseQueryHookResult = ReturnType<typeof useGetBankStatementRowCandidatesSuspenseQuery>;
export type GetBankStatementRowCandidatesQueryResult = Apollo.QueryResult<GetBankStatementRowCandidatesQuery, GetBankStatementRowCandidatesQueryVariables>;
export const ReconcileBankStatementRowDocument = gql`
    mutation ReconcileBankStatementRow($input: ReconcileBankStatementRowInput!) {
  reconcileBankStatementRow(input: $input) {
    id
    disposition
    noLoadReason
    paymentTransactionId
    error
  }
}
    `;
export type ReconcileBankStatementRowMutationFn = Apollo.MutationFunction<ReconcileBankStatementRowMutation, ReconcileBankStatementRowMutationVariables>;

/**
 * __useReconcileBankStatementRowMutation__
 *
 * To run a mutation, you first call `useReconcileBankStatementRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileBankStatementRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileBankStatementRowMutation, { data, loading, error }] = useReconcileBankStatementRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReconcileBankStatementRowMutation(baseOptions?: Apollo.MutationHookOptions<ReconcileBankStatementRowMutation, ReconcileBankStatementRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconcileBankStatementRowMutation, ReconcileBankStatementRowMutationVariables>(ReconcileBankStatementRowDocument, options);
      }
export type ReconcileBankStatementRowMutationHookResult = ReturnType<typeof useReconcileBankStatementRowMutation>;
export type ReconcileBankStatementRowMutationResult = Apollo.MutationResult<ReconcileBankStatementRowMutation>;
export type ReconcileBankStatementRowMutationOptions = Apollo.BaseMutationOptions<ReconcileBankStatementRowMutation, ReconcileBankStatementRowMutationVariables>;
export const UnreconcileBankStatementRowDocument = gql`
    mutation UnreconcileBankStatementRow($rowId: String!) {
  unreconcileBankStatementRow(rowId: $rowId) {
    id
    disposition
    noLoadReason
    paymentTransactionId
    lastTransactionAt
    lastTransactionAmount
    error
  }
}
    `;
export type UnreconcileBankStatementRowMutationFn = Apollo.MutationFunction<UnreconcileBankStatementRowMutation, UnreconcileBankStatementRowMutationVariables>;

/**
 * __useUnreconcileBankStatementRowMutation__
 *
 * To run a mutation, you first call `useUnreconcileBankStatementRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnreconcileBankStatementRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unreconcileBankStatementRowMutation, { data, loading, error }] = useUnreconcileBankStatementRowMutation({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useUnreconcileBankStatementRowMutation(baseOptions?: Apollo.MutationHookOptions<UnreconcileBankStatementRowMutation, UnreconcileBankStatementRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnreconcileBankStatementRowMutation, UnreconcileBankStatementRowMutationVariables>(UnreconcileBankStatementRowDocument, options);
      }
export type UnreconcileBankStatementRowMutationHookResult = ReturnType<typeof useUnreconcileBankStatementRowMutation>;
export type UnreconcileBankStatementRowMutationResult = Apollo.MutationResult<UnreconcileBankStatementRowMutation>;
export type UnreconcileBankStatementRowMutationOptions = Apollo.BaseMutationOptions<UnreconcileBankStatementRowMutation, UnreconcileBankStatementRowMutationVariables>;
export const MyBankVerificationDocument = gql`
    query MyBankVerification {
  myBankVerification {
    ...BankVerificationDetail
  }
}
    ${BankVerificationDetailFragmentDoc}`;

/**
 * __useMyBankVerificationQuery__
 *
 * To run a query within a React component, call `useMyBankVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBankVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBankVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyBankVerificationQuery(baseOptions?: Apollo.QueryHookOptions<MyBankVerificationQuery, MyBankVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyBankVerificationQuery, MyBankVerificationQueryVariables>(MyBankVerificationDocument, options);
      }
export function useMyBankVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBankVerificationQuery, MyBankVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyBankVerificationQuery, MyBankVerificationQueryVariables>(MyBankVerificationDocument, options);
        }
// @ts-ignore
export function useMyBankVerificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyBankVerificationQuery, MyBankVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<MyBankVerificationQuery, MyBankVerificationQueryVariables>;
export function useMyBankVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyBankVerificationQuery, MyBankVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<MyBankVerificationQuery | undefined, MyBankVerificationQueryVariables>;
export function useMyBankVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyBankVerificationQuery, MyBankVerificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyBankVerificationQuery, MyBankVerificationQueryVariables>(MyBankVerificationDocument, options);
        }
export type MyBankVerificationQueryHookResult = ReturnType<typeof useMyBankVerificationQuery>;
export type MyBankVerificationLazyQueryHookResult = ReturnType<typeof useMyBankVerificationLazyQuery>;
export type MyBankVerificationSuspenseQueryHookResult = ReturnType<typeof useMyBankVerificationSuspenseQuery>;
export type MyBankVerificationQueryResult = Apollo.QueryResult<MyBankVerificationQuery, MyBankVerificationQueryVariables>;
export const BankVerificationsDocument = gql`
    query BankVerifications($filter: BankVerificationFilterInput) {
  bankVerifications(filter: $filter) {
    totalCount
    items {
      id
      status
      submittedAt
      slaDueAt
      slaBreached
      hasStaleProof
      agent {
        id
        firstName
        lastName
        salesId
      }
    }
  }
}
    `;

/**
 * __useBankVerificationsQuery__
 *
 * To run a query within a React component, call `useBankVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankVerificationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBankVerificationsQuery(baseOptions?: Apollo.QueryHookOptions<BankVerificationsQuery, BankVerificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankVerificationsQuery, BankVerificationsQueryVariables>(BankVerificationsDocument, options);
      }
export function useBankVerificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankVerificationsQuery, BankVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankVerificationsQuery, BankVerificationsQueryVariables>(BankVerificationsDocument, options);
        }
// @ts-ignore
export function useBankVerificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankVerificationsQuery, BankVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<BankVerificationsQuery, BankVerificationsQueryVariables>;
export function useBankVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankVerificationsQuery, BankVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<BankVerificationsQuery | undefined, BankVerificationsQueryVariables>;
export function useBankVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankVerificationsQuery, BankVerificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankVerificationsQuery, BankVerificationsQueryVariables>(BankVerificationsDocument, options);
        }
export type BankVerificationsQueryHookResult = ReturnType<typeof useBankVerificationsQuery>;
export type BankVerificationsLazyQueryHookResult = ReturnType<typeof useBankVerificationsLazyQuery>;
export type BankVerificationsSuspenseQueryHookResult = ReturnType<typeof useBankVerificationsSuspenseQuery>;
export type BankVerificationsQueryResult = Apollo.QueryResult<BankVerificationsQuery, BankVerificationsQueryVariables>;
export const BankVerificationDocument = gql`
    query BankVerification($id: String!) {
  bankVerification(id: $id) {
    ...BankVerificationDetail
  }
}
    ${BankVerificationDetailFragmentDoc}`;

/**
 * __useBankVerificationQuery__
 *
 * To run a query within a React component, call `useBankVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankVerificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBankVerificationQuery(baseOptions: Apollo.QueryHookOptions<BankVerificationQuery, BankVerificationQueryVariables> & ({ variables: BankVerificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankVerificationQuery, BankVerificationQueryVariables>(BankVerificationDocument, options);
      }
export function useBankVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankVerificationQuery, BankVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankVerificationQuery, BankVerificationQueryVariables>(BankVerificationDocument, options);
        }
// @ts-ignore
export function useBankVerificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankVerificationQuery, BankVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<BankVerificationQuery, BankVerificationQueryVariables>;
export function useBankVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankVerificationQuery, BankVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<BankVerificationQuery | undefined, BankVerificationQueryVariables>;
export function useBankVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankVerificationQuery, BankVerificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankVerificationQuery, BankVerificationQueryVariables>(BankVerificationDocument, options);
        }
export type BankVerificationQueryHookResult = ReturnType<typeof useBankVerificationQuery>;
export type BankVerificationLazyQueryHookResult = ReturnType<typeof useBankVerificationLazyQuery>;
export type BankVerificationSuspenseQueryHookResult = ReturnType<typeof useBankVerificationSuspenseQuery>;
export type BankVerificationQueryResult = Apollo.QueryResult<BankVerificationQuery, BankVerificationQueryVariables>;
export const StartBankVerificationReviewDocument = gql`
    mutation StartBankVerificationReview($id: String!) {
  startBankVerificationReview(id: $id) {
    id
    status
  }
}
    `;
export type StartBankVerificationReviewMutationFn = Apollo.MutationFunction<StartBankVerificationReviewMutation, StartBankVerificationReviewMutationVariables>;

/**
 * __useStartBankVerificationReviewMutation__
 *
 * To run a mutation, you first call `useStartBankVerificationReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBankVerificationReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBankVerificationReviewMutation, { data, loading, error }] = useStartBankVerificationReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartBankVerificationReviewMutation(baseOptions?: Apollo.MutationHookOptions<StartBankVerificationReviewMutation, StartBankVerificationReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBankVerificationReviewMutation, StartBankVerificationReviewMutationVariables>(StartBankVerificationReviewDocument, options);
      }
export type StartBankVerificationReviewMutationHookResult = ReturnType<typeof useStartBankVerificationReviewMutation>;
export type StartBankVerificationReviewMutationResult = Apollo.MutationResult<StartBankVerificationReviewMutation>;
export type StartBankVerificationReviewMutationOptions = Apollo.BaseMutationOptions<StartBankVerificationReviewMutation, StartBankVerificationReviewMutationVariables>;
export const ApproveBankVerificationDocument = gql`
    mutation ApproveBankVerification($id: String!) {
  approveBankVerification(id: $id) {
    id
    status
  }
}
    `;
export type ApproveBankVerificationMutationFn = Apollo.MutationFunction<ApproveBankVerificationMutation, ApproveBankVerificationMutationVariables>;

/**
 * __useApproveBankVerificationMutation__
 *
 * To run a mutation, you first call `useApproveBankVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBankVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBankVerificationMutation, { data, loading, error }] = useApproveBankVerificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveBankVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBankVerificationMutation, ApproveBankVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBankVerificationMutation, ApproveBankVerificationMutationVariables>(ApproveBankVerificationDocument, options);
      }
export type ApproveBankVerificationMutationHookResult = ReturnType<typeof useApproveBankVerificationMutation>;
export type ApproveBankVerificationMutationResult = Apollo.MutationResult<ApproveBankVerificationMutation>;
export type ApproveBankVerificationMutationOptions = Apollo.BaseMutationOptions<ApproveBankVerificationMutation, ApproveBankVerificationMutationVariables>;
export const RejectBankVerificationDocument = gql`
    mutation RejectBankVerification($id: String!, $reason: String!) {
  rejectBankVerification(id: $id, reason: $reason) {
    id
    status
    decisionReason
  }
}
    `;
export type RejectBankVerificationMutationFn = Apollo.MutationFunction<RejectBankVerificationMutation, RejectBankVerificationMutationVariables>;

/**
 * __useRejectBankVerificationMutation__
 *
 * To run a mutation, you first call `useRejectBankVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectBankVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectBankVerificationMutation, { data, loading, error }] = useRejectBankVerificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectBankVerificationMutation(baseOptions?: Apollo.MutationHookOptions<RejectBankVerificationMutation, RejectBankVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectBankVerificationMutation, RejectBankVerificationMutationVariables>(RejectBankVerificationDocument, options);
      }
export type RejectBankVerificationMutationHookResult = ReturnType<typeof useRejectBankVerificationMutation>;
export type RejectBankVerificationMutationResult = Apollo.MutationResult<RejectBankVerificationMutation>;
export type RejectBankVerificationMutationOptions = Apollo.BaseMutationOptions<RejectBankVerificationMutation, RejectBankVerificationMutationVariables>;
export const RequestBankVerificationInfoDocument = gql`
    mutation RequestBankVerificationInfo($id: String!, $reason: String!) {
  requestBankVerificationInfo(id: $id, reason: $reason) {
    id
    status
    decisionReason
  }
}
    `;
export type RequestBankVerificationInfoMutationFn = Apollo.MutationFunction<RequestBankVerificationInfoMutation, RequestBankVerificationInfoMutationVariables>;

/**
 * __useRequestBankVerificationInfoMutation__
 *
 * To run a mutation, you first call `useRequestBankVerificationInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBankVerificationInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBankVerificationInfoMutation, { data, loading, error }] = useRequestBankVerificationInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestBankVerificationInfoMutation(baseOptions?: Apollo.MutationHookOptions<RequestBankVerificationInfoMutation, RequestBankVerificationInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBankVerificationInfoMutation, RequestBankVerificationInfoMutationVariables>(RequestBankVerificationInfoDocument, options);
      }
export type RequestBankVerificationInfoMutationHookResult = ReturnType<typeof useRequestBankVerificationInfoMutation>;
export type RequestBankVerificationInfoMutationResult = Apollo.MutationResult<RequestBankVerificationInfoMutation>;
export type RequestBankVerificationInfoMutationOptions = Apollo.BaseMutationOptions<RequestBankVerificationInfoMutation, RequestBankVerificationInfoMutationVariables>;
export const GetBusinessLinesDocument = gql`
    query GetBusinessLines {
  businessLines {
    id
    name
    externalCode
    productCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetBusinessLinesQuery__
 *
 * To run a query within a React component, call `useGetBusinessLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessLinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessLinesQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>(GetBusinessLinesDocument, options);
      }
export function useGetBusinessLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>(GetBusinessLinesDocument, options);
        }
// @ts-ignore
export function useGetBusinessLinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>;
export function useGetBusinessLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessLinesQuery | undefined, GetBusinessLinesQueryVariables>;
export function useGetBusinessLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>(GetBusinessLinesDocument, options);
        }
export type GetBusinessLinesQueryHookResult = ReturnType<typeof useGetBusinessLinesQuery>;
export type GetBusinessLinesLazyQueryHookResult = ReturnType<typeof useGetBusinessLinesLazyQuery>;
export type GetBusinessLinesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessLinesSuspenseQuery>;
export type GetBusinessLinesQueryResult = Apollo.QueryResult<GetBusinessLinesQuery, GetBusinessLinesQueryVariables>;
export const CreateBusinessLineDocument = gql`
    mutation CreateBusinessLine($input: CreateBusinessLineInput!) {
  createBusinessLine(input: $input) {
    id
    name
    externalCode
  }
}
    `;
export type CreateBusinessLineMutationFn = Apollo.MutationFunction<CreateBusinessLineMutation, CreateBusinessLineMutationVariables>;

/**
 * __useCreateBusinessLineMutation__
 *
 * To run a mutation, you first call `useCreateBusinessLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessLineMutation, { data, loading, error }] = useCreateBusinessLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBusinessLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessLineMutation, CreateBusinessLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessLineMutation, CreateBusinessLineMutationVariables>(CreateBusinessLineDocument, options);
      }
export type CreateBusinessLineMutationHookResult = ReturnType<typeof useCreateBusinessLineMutation>;
export type CreateBusinessLineMutationResult = Apollo.MutationResult<CreateBusinessLineMutation>;
export type CreateBusinessLineMutationOptions = Apollo.BaseMutationOptions<CreateBusinessLineMutation, CreateBusinessLineMutationVariables>;
export const UpdateBusinessLineDocument = gql`
    mutation UpdateBusinessLine($id: String!, $input: UpdateBusinessLineInput!) {
  updateBusinessLine(id: $id, input: $input) {
    id
    name
    externalCode
  }
}
    `;
export type UpdateBusinessLineMutationFn = Apollo.MutationFunction<UpdateBusinessLineMutation, UpdateBusinessLineMutationVariables>;

/**
 * __useUpdateBusinessLineMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessLineMutation, { data, loading, error }] = useUpdateBusinessLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessLineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessLineMutation, UpdateBusinessLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessLineMutation, UpdateBusinessLineMutationVariables>(UpdateBusinessLineDocument, options);
      }
export type UpdateBusinessLineMutationHookResult = ReturnType<typeof useUpdateBusinessLineMutation>;
export type UpdateBusinessLineMutationResult = Apollo.MutationResult<UpdateBusinessLineMutation>;
export type UpdateBusinessLineMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessLineMutation, UpdateBusinessLineMutationVariables>;
export const DeleteBusinessLineDocument = gql`
    mutation DeleteBusinessLine($id: String!) {
  deleteBusinessLine(id: $id) {
    id
    name
  }
}
    `;
export type DeleteBusinessLineMutationFn = Apollo.MutationFunction<DeleteBusinessLineMutation, DeleteBusinessLineMutationVariables>;

/**
 * __useDeleteBusinessLineMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessLineMutation, { data, loading, error }] = useDeleteBusinessLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBusinessLineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessLineMutation, DeleteBusinessLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessLineMutation, DeleteBusinessLineMutationVariables>(DeleteBusinessLineDocument, options);
      }
export type DeleteBusinessLineMutationHookResult = ReturnType<typeof useDeleteBusinessLineMutation>;
export type DeleteBusinessLineMutationResult = Apollo.MutationResult<DeleteBusinessLineMutation>;
export type DeleteBusinessLineMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessLineMutation, DeleteBusinessLineMutationVariables>;
export const GetCallsDocument = gql`
    query GetCalls($input: CallListInput!) {
  calls(input: $input) {
    items {
      ...CallCardFields
    }
    totalCount
  }
}
    ${CallCardFieldsFragmentDoc}`;

/**
 * __useGetCallsQuery__
 *
 * To run a query within a React component, call `useGetCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCallsQuery(baseOptions: Apollo.QueryHookOptions<GetCallsQuery, GetCallsQueryVariables> & ({ variables: GetCallsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
      }
export function useGetCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
        }
// @ts-ignore
export function useGetCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallsQuery, GetCallsQueryVariables>;
export function useGetCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallsQuery | undefined, GetCallsQueryVariables>;
export function useGetCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
        }
export type GetCallsQueryHookResult = ReturnType<typeof useGetCallsQuery>;
export type GetCallsLazyQueryHookResult = ReturnType<typeof useGetCallsLazyQuery>;
export type GetCallsSuspenseQueryHookResult = ReturnType<typeof useGetCallsSuspenseQuery>;
export type GetCallsQueryResult = Apollo.QueryResult<GetCallsQuery, GetCallsQueryVariables>;
export const ExportCallsDocument = gql`
    query ExportCalls($input: CallListInput!) {
  exportCalls(input: $input) {
    items {
      ...CallCardFields
    }
    totalCount
  }
}
    ${CallCardFieldsFragmentDoc}`;

/**
 * __useExportCallsQuery__
 *
 * To run a query within a React component, call `useExportCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCallsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportCallsQuery(baseOptions: Apollo.QueryHookOptions<ExportCallsQuery, ExportCallsQueryVariables> & ({ variables: ExportCallsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCallsQuery, ExportCallsQueryVariables>(ExportCallsDocument, options);
      }
export function useExportCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCallsQuery, ExportCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCallsQuery, ExportCallsQueryVariables>(ExportCallsDocument, options);
        }
// @ts-ignore
export function useExportCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportCallsQuery, ExportCallsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCallsQuery, ExportCallsQueryVariables>;
export function useExportCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCallsQuery, ExportCallsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCallsQuery | undefined, ExportCallsQueryVariables>;
export function useExportCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCallsQuery, ExportCallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportCallsQuery, ExportCallsQueryVariables>(ExportCallsDocument, options);
        }
export type ExportCallsQueryHookResult = ReturnType<typeof useExportCallsQuery>;
export type ExportCallsLazyQueryHookResult = ReturnType<typeof useExportCallsLazyQuery>;
export type ExportCallsSuspenseQueryHookResult = ReturnType<typeof useExportCallsSuspenseQuery>;
export type ExportCallsQueryResult = Apollo.QueryResult<ExportCallsQuery, ExportCallsQueryVariables>;
export const GetCallTypesDocument = gql`
    query GetCallTypes($input: CallListInput!) {
  callTypes(input: $input)
}
    `;

/**
 * __useGetCallTypesQuery__
 *
 * To run a query within a React component, call `useGetCallTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCallTypesQuery(baseOptions: Apollo.QueryHookOptions<GetCallTypesQuery, GetCallTypesQueryVariables> & ({ variables: GetCallTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallTypesQuery, GetCallTypesQueryVariables>(GetCallTypesDocument, options);
      }
export function useGetCallTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallTypesQuery, GetCallTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallTypesQuery, GetCallTypesQueryVariables>(GetCallTypesDocument, options);
        }
// @ts-ignore
export function useGetCallTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallTypesQuery, GetCallTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallTypesQuery, GetCallTypesQueryVariables>;
export function useGetCallTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallTypesQuery, GetCallTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallTypesQuery | undefined, GetCallTypesQueryVariables>;
export function useGetCallTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallTypesQuery, GetCallTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallTypesQuery, GetCallTypesQueryVariables>(GetCallTypesDocument, options);
        }
export type GetCallTypesQueryHookResult = ReturnType<typeof useGetCallTypesQuery>;
export type GetCallTypesLazyQueryHookResult = ReturnType<typeof useGetCallTypesLazyQuery>;
export type GetCallTypesSuspenseQueryHookResult = ReturnType<typeof useGetCallTypesSuspenseQuery>;
export type GetCallTypesQueryResult = Apollo.QueryResult<GetCallTypesQuery, GetCallTypesQueryVariables>;
export const GetCommissionApproachDocument = gql`
    query GetCommissionApproach {
  commissionApproach {
    ...CommissionApproachSettingsFields
  }
}
    ${CommissionApproachSettingsFieldsFragmentDoc}`;

/**
 * __useGetCommissionApproachQuery__
 *
 * To run a query within a React component, call `useGetCommissionApproachQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionApproachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionApproachQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionApproachQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>(GetCommissionApproachDocument, options);
      }
export function useGetCommissionApproachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>(GetCommissionApproachDocument, options);
        }
// @ts-ignore
export function useGetCommissionApproachSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>;
export function useGetCommissionApproachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionApproachQuery | undefined, GetCommissionApproachQueryVariables>;
export function useGetCommissionApproachSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>(GetCommissionApproachDocument, options);
        }
export type GetCommissionApproachQueryHookResult = ReturnType<typeof useGetCommissionApproachQuery>;
export type GetCommissionApproachLazyQueryHookResult = ReturnType<typeof useGetCommissionApproachLazyQuery>;
export type GetCommissionApproachSuspenseQueryHookResult = ReturnType<typeof useGetCommissionApproachSuspenseQuery>;
export type GetCommissionApproachQueryResult = Apollo.QueryResult<GetCommissionApproachQuery, GetCommissionApproachQueryVariables>;
export const GetMyRunningCommissionDocument = gql`
    query GetMyRunningCommission {
  myRunningCommission {
    periodDate
    collected
    current {
      ...RunningCommissionFigureFields
    }
    previous {
      ...RunningCommissionFigureFields
    }
    team {
      ...RunningCommissionFigureFields
    }
  }
}
    ${RunningCommissionFigureFieldsFragmentDoc}`;

/**
 * __useGetMyRunningCommissionQuery__
 *
 * To run a query within a React component, call `useGetMyRunningCommissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRunningCommissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRunningCommissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyRunningCommissionQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>(GetMyRunningCommissionDocument, options);
      }
export function useGetMyRunningCommissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>(GetMyRunningCommissionDocument, options);
        }
// @ts-ignore
export function useGetMyRunningCommissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>;
export function useGetMyRunningCommissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyRunningCommissionQuery | undefined, GetMyRunningCommissionQueryVariables>;
export function useGetMyRunningCommissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>(GetMyRunningCommissionDocument, options);
        }
export type GetMyRunningCommissionQueryHookResult = ReturnType<typeof useGetMyRunningCommissionQuery>;
export type GetMyRunningCommissionLazyQueryHookResult = ReturnType<typeof useGetMyRunningCommissionLazyQuery>;
export type GetMyRunningCommissionSuspenseQueryHookResult = ReturnType<typeof useGetMyRunningCommissionSuspenseQuery>;
export type GetMyRunningCommissionQueryResult = Apollo.QueryResult<GetMyRunningCommissionQuery, GetMyRunningCommissionQueryVariables>;
export const ScheduleCommissionApproachDocument = gql`
    mutation ScheduleCommissionApproach($input: ScheduleCommissionApproachInput!) {
  scheduleCommissionApproach(input: $input) {
    ...CommissionApproachSettingsFields
  }
}
    ${CommissionApproachSettingsFieldsFragmentDoc}`;
export type ScheduleCommissionApproachMutationFn = Apollo.MutationFunction<ScheduleCommissionApproachMutation, ScheduleCommissionApproachMutationVariables>;

/**
 * __useScheduleCommissionApproachMutation__
 *
 * To run a mutation, you first call `useScheduleCommissionApproachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleCommissionApproachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleCommissionApproachMutation, { data, loading, error }] = useScheduleCommissionApproachMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleCommissionApproachMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleCommissionApproachMutation, ScheduleCommissionApproachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleCommissionApproachMutation, ScheduleCommissionApproachMutationVariables>(ScheduleCommissionApproachDocument, options);
      }
export type ScheduleCommissionApproachMutationHookResult = ReturnType<typeof useScheduleCommissionApproachMutation>;
export type ScheduleCommissionApproachMutationResult = Apollo.MutationResult<ScheduleCommissionApproachMutation>;
export type ScheduleCommissionApproachMutationOptions = Apollo.BaseMutationOptions<ScheduleCommissionApproachMutation, ScheduleCommissionApproachMutationVariables>;
export const RemoveCommissionApproachChangeDocument = gql`
    mutation RemoveCommissionApproachChange($id: String!) {
  removeCommissionApproachChange(id: $id) {
    ...CommissionApproachSettingsFields
  }
}
    ${CommissionApproachSettingsFieldsFragmentDoc}`;
export type RemoveCommissionApproachChangeMutationFn = Apollo.MutationFunction<RemoveCommissionApproachChangeMutation, RemoveCommissionApproachChangeMutationVariables>;

/**
 * __useRemoveCommissionApproachChangeMutation__
 *
 * To run a mutation, you first call `useRemoveCommissionApproachChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommissionApproachChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommissionApproachChangeMutation, { data, loading, error }] = useRemoveCommissionApproachChangeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCommissionApproachChangeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommissionApproachChangeMutation, RemoveCommissionApproachChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommissionApproachChangeMutation, RemoveCommissionApproachChangeMutationVariables>(RemoveCommissionApproachChangeDocument, options);
      }
export type RemoveCommissionApproachChangeMutationHookResult = ReturnType<typeof useRemoveCommissionApproachChangeMutation>;
export type RemoveCommissionApproachChangeMutationResult = Apollo.MutationResult<RemoveCommissionApproachChangeMutation>;
export type RemoveCommissionApproachChangeMutationOptions = Apollo.BaseMutationOptions<RemoveCommissionApproachChangeMutation, RemoveCommissionApproachChangeMutationVariables>;
export const RefreshRunningCommissionDocument = gql`
    mutation RefreshRunningCommission {
  refreshRunningCommission
}
    `;
export type RefreshRunningCommissionMutationFn = Apollo.MutationFunction<RefreshRunningCommissionMutation, RefreshRunningCommissionMutationVariables>;

/**
 * __useRefreshRunningCommissionMutation__
 *
 * To run a mutation, you first call `useRefreshRunningCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshRunningCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshRunningCommissionMutation, { data, loading, error }] = useRefreshRunningCommissionMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshRunningCommissionMutation(baseOptions?: Apollo.MutationHookOptions<RefreshRunningCommissionMutation, RefreshRunningCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshRunningCommissionMutation, RefreshRunningCommissionMutationVariables>(RefreshRunningCommissionDocument, options);
      }
export type RefreshRunningCommissionMutationHookResult = ReturnType<typeof useRefreshRunningCommissionMutation>;
export type RefreshRunningCommissionMutationResult = Apollo.MutationResult<RefreshRunningCommissionMutation>;
export type RefreshRunningCommissionMutationOptions = Apollo.BaseMutationOptions<RefreshRunningCommissionMutation, RefreshRunningCommissionMutationVariables>;
export const GetCommissionPolicyDocument = gql`
    query GetCommissionPolicy {
  commissionPolicy {
    trancheMonthBasis
    monthOneStartsAt
    runDayOfNextMonth
    requireUpToDate
    missedTranche
    visitMode
    monthlyUnitEligibility
    distributorPaid
    paidOffBonusTiming
    minimumPayoutCents
    updatedAt
  }
}
    `;

/**
 * __useGetCommissionPolicyQuery__
 *
 * To run a query within a React component, call `useGetCommissionPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionPolicyQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>(GetCommissionPolicyDocument, options);
      }
export function useGetCommissionPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>(GetCommissionPolicyDocument, options);
        }
// @ts-ignore
export function useGetCommissionPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>;
export function useGetCommissionPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionPolicyQuery | undefined, GetCommissionPolicyQueryVariables>;
export function useGetCommissionPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>(GetCommissionPolicyDocument, options);
        }
export type GetCommissionPolicyQueryHookResult = ReturnType<typeof useGetCommissionPolicyQuery>;
export type GetCommissionPolicyLazyQueryHookResult = ReturnType<typeof useGetCommissionPolicyLazyQuery>;
export type GetCommissionPolicySuspenseQueryHookResult = ReturnType<typeof useGetCommissionPolicySuspenseQuery>;
export type GetCommissionPolicyQueryResult = Apollo.QueryResult<GetCommissionPolicyQuery, GetCommissionPolicyQueryVariables>;
export const UpdateCommissionPolicyDocument = gql`
    mutation UpdateCommissionPolicy($input: UpdateCommissionPolicyInput!) {
  updateCommissionPolicy(input: $input) {
    trancheMonthBasis
    monthOneStartsAt
    runDayOfNextMonth
    requireUpToDate
    missedTranche
    visitMode
    monthlyUnitEligibility
    distributorPaid
    paidOffBonusTiming
    minimumPayoutCents
    updatedAt
  }
}
    `;
export type UpdateCommissionPolicyMutationFn = Apollo.MutationFunction<UpdateCommissionPolicyMutation, UpdateCommissionPolicyMutationVariables>;

/**
 * __useUpdateCommissionPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateCommissionPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommissionPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommissionPolicyMutation, { data, loading, error }] = useUpdateCommissionPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommissionPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommissionPolicyMutation, UpdateCommissionPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommissionPolicyMutation, UpdateCommissionPolicyMutationVariables>(UpdateCommissionPolicyDocument, options);
      }
export type UpdateCommissionPolicyMutationHookResult = ReturnType<typeof useUpdateCommissionPolicyMutation>;
export type UpdateCommissionPolicyMutationResult = Apollo.MutationResult<UpdateCommissionPolicyMutation>;
export type UpdateCommissionPolicyMutationOptions = Apollo.BaseMutationOptions<UpdateCommissionPolicyMutation, UpdateCommissionPolicyMutationVariables>;
export const GetCommissionRulesDocument = gql`
    query GetCommissionRules {
  commissionRules {
    id
    commissionTypeId
    calculationMethod
    startMonth
    endMonth
    isNegative
    active
    ratePlanId
    createdAt
    updatedAt
    commissionType {
      id
      name
      code
      triggerEvent
    }
    ratePlan {
      id
      rateName
      product
    }
    rates {
      id
      agentCategoryId
      amountCents
      percentage
      agentCategory {
        id
        name
        rank
      }
    }
  }
}
    `;

/**
 * __useGetCommissionRulesQuery__
 *
 * To run a query within a React component, call `useGetCommissionRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>(GetCommissionRulesDocument, options);
      }
export function useGetCommissionRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>(GetCommissionRulesDocument, options);
        }
// @ts-ignore
export function useGetCommissionRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>;
export function useGetCommissionRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionRulesQuery | undefined, GetCommissionRulesQueryVariables>;
export function useGetCommissionRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>(GetCommissionRulesDocument, options);
        }
export type GetCommissionRulesQueryHookResult = ReturnType<typeof useGetCommissionRulesQuery>;
export type GetCommissionRulesLazyQueryHookResult = ReturnType<typeof useGetCommissionRulesLazyQuery>;
export type GetCommissionRulesSuspenseQueryHookResult = ReturnType<typeof useGetCommissionRulesSuspenseQuery>;
export type GetCommissionRulesQueryResult = Apollo.QueryResult<GetCommissionRulesQuery, GetCommissionRulesQueryVariables>;
export const GetCommissionRulesPageDocument = gql`
    query GetCommissionRulesPage($input: CommissionRuleListInput) {
  commissionRulesPage(input: $input) {
    totalCount
    items {
      id
      commissionTypeId
      calculationMethod
      startMonth
      endMonth
      isNegative
      active
      ratePlanId
      commissionType {
        id
        name
        code
      }
      ratePlan {
        id
        rateName
        product
      }
      rates {
        id
        agentCategoryId
        amountCents
        percentage
        agentCategory {
          id
          name
          rank
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommissionRulesPageQuery__
 *
 * To run a query within a React component, call `useGetCommissionRulesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionRulesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionRulesPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommissionRulesPageQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>(GetCommissionRulesPageDocument, options);
      }
export function useGetCommissionRulesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>(GetCommissionRulesPageDocument, options);
        }
// @ts-ignore
export function useGetCommissionRulesPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>;
export function useGetCommissionRulesPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionRulesPageQuery | undefined, GetCommissionRulesPageQueryVariables>;
export function useGetCommissionRulesPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>(GetCommissionRulesPageDocument, options);
        }
export type GetCommissionRulesPageQueryHookResult = ReturnType<typeof useGetCommissionRulesPageQuery>;
export type GetCommissionRulesPageLazyQueryHookResult = ReturnType<typeof useGetCommissionRulesPageLazyQuery>;
export type GetCommissionRulesPageSuspenseQueryHookResult = ReturnType<typeof useGetCommissionRulesPageSuspenseQuery>;
export type GetCommissionRulesPageQueryResult = Apollo.QueryResult<GetCommissionRulesPageQuery, GetCommissionRulesPageQueryVariables>;
export const GetCommissionRuleDocument = gql`
    query GetCommissionRule($id: String!) {
  commissionRule(id: $id) {
    id
    commissionTypeId
    calculationMethod
    startMonth
    endMonth
    isNegative
    active
    ratePlanId
    createdAt
    updatedAt
    commissionType {
      id
      name
      code
      triggerEvent
    }
    ratePlan {
      id
      rateName
      product
    }
    rates {
      id
      agentCategoryId
      amountCents
      percentage
      agentCategory {
        id
        name
        rank
      }
    }
  }
}
    `;

/**
 * __useGetCommissionRuleQuery__
 *
 * To run a query within a React component, call `useGetCommissionRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommissionRuleQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionRuleQuery, GetCommissionRuleQueryVariables> & ({ variables: GetCommissionRuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>(GetCommissionRuleDocument, options);
      }
export function useGetCommissionRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>(GetCommissionRuleDocument, options);
        }
// @ts-ignore
export function useGetCommissionRuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>;
export function useGetCommissionRuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionRuleQuery | undefined, GetCommissionRuleQueryVariables>;
export function useGetCommissionRuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>(GetCommissionRuleDocument, options);
        }
export type GetCommissionRuleQueryHookResult = ReturnType<typeof useGetCommissionRuleQuery>;
export type GetCommissionRuleLazyQueryHookResult = ReturnType<typeof useGetCommissionRuleLazyQuery>;
export type GetCommissionRuleSuspenseQueryHookResult = ReturnType<typeof useGetCommissionRuleSuspenseQuery>;
export type GetCommissionRuleQueryResult = Apollo.QueryResult<GetCommissionRuleQuery, GetCommissionRuleQueryVariables>;
export const CreateCommissionRuleDocument = gql`
    mutation CreateCommissionRule($input: CreateCommissionRuleInput!, $rates: [CommissionRuleRateInput!]!) {
  createCommissionRule(input: $input, rates: $rates) {
    id
    calculationMethod
    startMonth
    endMonth
    isNegative
    active
    ratePlanId
    commissionType {
      id
      name
      code
    }
    ratePlan {
      id
      rateName
      product
    }
    rates {
      id
      agentCategoryId
      amountCents
      percentage
      agentCategory {
        id
        name
      }
    }
  }
}
    `;
export type CreateCommissionRuleMutationFn = Apollo.MutationFunction<CreateCommissionRuleMutation, CreateCommissionRuleMutationVariables>;

/**
 * __useCreateCommissionRuleMutation__
 *
 * To run a mutation, you first call `useCreateCommissionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommissionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommissionRuleMutation, { data, loading, error }] = useCreateCommissionRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useCreateCommissionRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommissionRuleMutation, CreateCommissionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommissionRuleMutation, CreateCommissionRuleMutationVariables>(CreateCommissionRuleDocument, options);
      }
export type CreateCommissionRuleMutationHookResult = ReturnType<typeof useCreateCommissionRuleMutation>;
export type CreateCommissionRuleMutationResult = Apollo.MutationResult<CreateCommissionRuleMutation>;
export type CreateCommissionRuleMutationOptions = Apollo.BaseMutationOptions<CreateCommissionRuleMutation, CreateCommissionRuleMutationVariables>;
export const UpdateCommissionRuleDocument = gql`
    mutation UpdateCommissionRule($input: UpdateCommissionRuleInput!, $rates: [CommissionRuleRateInput!]) {
  updateCommissionRule(input: $input, rates: $rates) {
    id
    calculationMethod
    startMonth
    endMonth
    isNegative
    active
    ratePlanId
    commissionType {
      id
      name
      code
    }
    ratePlan {
      id
      rateName
      product
    }
    rates {
      id
      agentCategoryId
      amountCents
      percentage
      agentCategory {
        id
        name
      }
    }
  }
}
    `;
export type UpdateCommissionRuleMutationFn = Apollo.MutationFunction<UpdateCommissionRuleMutation, UpdateCommissionRuleMutationVariables>;

/**
 * __useUpdateCommissionRuleMutation__
 *
 * To run a mutation, you first call `useUpdateCommissionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommissionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommissionRuleMutation, { data, loading, error }] = useUpdateCommissionRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useUpdateCommissionRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommissionRuleMutation, UpdateCommissionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommissionRuleMutation, UpdateCommissionRuleMutationVariables>(UpdateCommissionRuleDocument, options);
      }
export type UpdateCommissionRuleMutationHookResult = ReturnType<typeof useUpdateCommissionRuleMutation>;
export type UpdateCommissionRuleMutationResult = Apollo.MutationResult<UpdateCommissionRuleMutation>;
export type UpdateCommissionRuleMutationOptions = Apollo.BaseMutationOptions<UpdateCommissionRuleMutation, UpdateCommissionRuleMutationVariables>;
export const DeleteCommissionRuleDocument = gql`
    mutation DeleteCommissionRule($id: String!) {
  deleteCommissionRule(id: $id)
}
    `;
export type DeleteCommissionRuleMutationFn = Apollo.MutationFunction<DeleteCommissionRuleMutation, DeleteCommissionRuleMutationVariables>;

/**
 * __useDeleteCommissionRuleMutation__
 *
 * To run a mutation, you first call `useDeleteCommissionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommissionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommissionRuleMutation, { data, loading, error }] = useDeleteCommissionRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommissionRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommissionRuleMutation, DeleteCommissionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommissionRuleMutation, DeleteCommissionRuleMutationVariables>(DeleteCommissionRuleDocument, options);
      }
export type DeleteCommissionRuleMutationHookResult = ReturnType<typeof useDeleteCommissionRuleMutation>;
export type DeleteCommissionRuleMutationResult = Apollo.MutationResult<DeleteCommissionRuleMutation>;
export type DeleteCommissionRuleMutationOptions = Apollo.BaseMutationOptions<DeleteCommissionRuleMutation, DeleteCommissionRuleMutationVariables>;
export const ToggleCommissionRuleActiveDocument = gql`
    mutation ToggleCommissionRuleActive($id: String!) {
  toggleCommissionRuleActive(id: $id) {
    id
    active
  }
}
    `;
export type ToggleCommissionRuleActiveMutationFn = Apollo.MutationFunction<ToggleCommissionRuleActiveMutation, ToggleCommissionRuleActiveMutationVariables>;

/**
 * __useToggleCommissionRuleActiveMutation__
 *
 * To run a mutation, you first call `useToggleCommissionRuleActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCommissionRuleActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCommissionRuleActiveMutation, { data, loading, error }] = useToggleCommissionRuleActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCommissionRuleActiveMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCommissionRuleActiveMutation, ToggleCommissionRuleActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCommissionRuleActiveMutation, ToggleCommissionRuleActiveMutationVariables>(ToggleCommissionRuleActiveDocument, options);
      }
export type ToggleCommissionRuleActiveMutationHookResult = ReturnType<typeof useToggleCommissionRuleActiveMutation>;
export type ToggleCommissionRuleActiveMutationResult = Apollo.MutationResult<ToggleCommissionRuleActiveMutation>;
export type ToggleCommissionRuleActiveMutationOptions = Apollo.BaseMutationOptions<ToggleCommissionRuleActiveMutation, ToggleCommissionRuleActiveMutationVariables>;
export const GetCommissionTypeConfigsDocument = gql`
    query GetCommissionTypeConfigs {
  commissionTypeConfigs {
    id
    name
    code
    triggerEvent
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCommissionTypeConfigsQuery__
 *
 * To run a query within a React component, call `useGetCommissionTypeConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionTypeConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionTypeConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionTypeConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>(GetCommissionTypeConfigsDocument, options);
      }
export function useGetCommissionTypeConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>(GetCommissionTypeConfigsDocument, options);
        }
// @ts-ignore
export function useGetCommissionTypeConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>;
export function useGetCommissionTypeConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionTypeConfigsQuery | undefined, GetCommissionTypeConfigsQueryVariables>;
export function useGetCommissionTypeConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>(GetCommissionTypeConfigsDocument, options);
        }
export type GetCommissionTypeConfigsQueryHookResult = ReturnType<typeof useGetCommissionTypeConfigsQuery>;
export type GetCommissionTypeConfigsLazyQueryHookResult = ReturnType<typeof useGetCommissionTypeConfigsLazyQuery>;
export type GetCommissionTypeConfigsSuspenseQueryHookResult = ReturnType<typeof useGetCommissionTypeConfigsSuspenseQuery>;
export type GetCommissionTypeConfigsQueryResult = Apollo.QueryResult<GetCommissionTypeConfigsQuery, GetCommissionTypeConfigsQueryVariables>;
export const GetCommissionTypeConfigDocument = gql`
    query GetCommissionTypeConfig($id: String!) {
  commissionTypeConfig(id: $id) {
    id
    name
    code
    triggerEvent
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCommissionTypeConfigQuery__
 *
 * To run a query within a React component, call `useGetCommissionTypeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionTypeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionTypeConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommissionTypeConfigQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables> & ({ variables: GetCommissionTypeConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>(GetCommissionTypeConfigDocument, options);
      }
export function useGetCommissionTypeConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>(GetCommissionTypeConfigDocument, options);
        }
// @ts-ignore
export function useGetCommissionTypeConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>;
export function useGetCommissionTypeConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionTypeConfigQuery | undefined, GetCommissionTypeConfigQueryVariables>;
export function useGetCommissionTypeConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>(GetCommissionTypeConfigDocument, options);
        }
export type GetCommissionTypeConfigQueryHookResult = ReturnType<typeof useGetCommissionTypeConfigQuery>;
export type GetCommissionTypeConfigLazyQueryHookResult = ReturnType<typeof useGetCommissionTypeConfigLazyQuery>;
export type GetCommissionTypeConfigSuspenseQueryHookResult = ReturnType<typeof useGetCommissionTypeConfigSuspenseQuery>;
export type GetCommissionTypeConfigQueryResult = Apollo.QueryResult<GetCommissionTypeConfigQuery, GetCommissionTypeConfigQueryVariables>;
export const CreateCommissionTypeConfigDocument = gql`
    mutation CreateCommissionTypeConfig($input: CreateCommissionTypeInput!) {
  createCommissionTypeConfig(input: $input) {
    id
    name
    code
    triggerEvent
  }
}
    `;
export type CreateCommissionTypeConfigMutationFn = Apollo.MutationFunction<CreateCommissionTypeConfigMutation, CreateCommissionTypeConfigMutationVariables>;

/**
 * __useCreateCommissionTypeConfigMutation__
 *
 * To run a mutation, you first call `useCreateCommissionTypeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommissionTypeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommissionTypeConfigMutation, { data, loading, error }] = useCreateCommissionTypeConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommissionTypeConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommissionTypeConfigMutation, CreateCommissionTypeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommissionTypeConfigMutation, CreateCommissionTypeConfigMutationVariables>(CreateCommissionTypeConfigDocument, options);
      }
export type CreateCommissionTypeConfigMutationHookResult = ReturnType<typeof useCreateCommissionTypeConfigMutation>;
export type CreateCommissionTypeConfigMutationResult = Apollo.MutationResult<CreateCommissionTypeConfigMutation>;
export type CreateCommissionTypeConfigMutationOptions = Apollo.BaseMutationOptions<CreateCommissionTypeConfigMutation, CreateCommissionTypeConfigMutationVariables>;
export const UpdateCommissionTypeConfigDocument = gql`
    mutation UpdateCommissionTypeConfig($input: UpdateCommissionTypeInput!) {
  updateCommissionTypeConfig(input: $input) {
    id
    name
    code
    triggerEvent
  }
}
    `;
export type UpdateCommissionTypeConfigMutationFn = Apollo.MutationFunction<UpdateCommissionTypeConfigMutation, UpdateCommissionTypeConfigMutationVariables>;

/**
 * __useUpdateCommissionTypeConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCommissionTypeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommissionTypeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommissionTypeConfigMutation, { data, loading, error }] = useUpdateCommissionTypeConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommissionTypeConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommissionTypeConfigMutation, UpdateCommissionTypeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommissionTypeConfigMutation, UpdateCommissionTypeConfigMutationVariables>(UpdateCommissionTypeConfigDocument, options);
      }
export type UpdateCommissionTypeConfigMutationHookResult = ReturnType<typeof useUpdateCommissionTypeConfigMutation>;
export type UpdateCommissionTypeConfigMutationResult = Apollo.MutationResult<UpdateCommissionTypeConfigMutation>;
export type UpdateCommissionTypeConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCommissionTypeConfigMutation, UpdateCommissionTypeConfigMutationVariables>;
export const DeleteCommissionTypeConfigDocument = gql`
    mutation DeleteCommissionTypeConfig($id: String!) {
  deleteCommissionTypeConfig(id: $id)
}
    `;
export type DeleteCommissionTypeConfigMutationFn = Apollo.MutationFunction<DeleteCommissionTypeConfigMutation, DeleteCommissionTypeConfigMutationVariables>;

/**
 * __useDeleteCommissionTypeConfigMutation__
 *
 * To run a mutation, you first call `useDeleteCommissionTypeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommissionTypeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommissionTypeConfigMutation, { data, loading, error }] = useDeleteCommissionTypeConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommissionTypeConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommissionTypeConfigMutation, DeleteCommissionTypeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommissionTypeConfigMutation, DeleteCommissionTypeConfigMutationVariables>(DeleteCommissionTypeConfigDocument, options);
      }
export type DeleteCommissionTypeConfigMutationHookResult = ReturnType<typeof useDeleteCommissionTypeConfigMutation>;
export type DeleteCommissionTypeConfigMutationResult = Apollo.MutationResult<DeleteCommissionTypeConfigMutation>;
export type DeleteCommissionTypeConfigMutationOptions = Apollo.BaseMutationOptions<DeleteCommissionTypeConfigMutation, DeleteCommissionTypeConfigMutationVariables>;
export const GetCommissionEntriesDocument = gql`
    query GetCommissionEntries($input: CommissionEntryListInput) {
  commissionEntries(input: $input) {
    items {
      id
      commissionType
      commissionTypeRef {
        id
        name
        code
      }
      source
      note
      periodMonth
      periodDate
      amountCents
      amountRands
      status
      approvedAt
      paidAt
      cancelledAt
      cancelReason
      createdAt
      agent {
        id
        firstName
        lastName
        salesId
      }
      stockSale {
        id
        saleReference
        saleDate
      }
      ratePlan {
        id
        rateName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetCommissionEntriesQuery__
 *
 * To run a query within a React component, call `useGetCommissionEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommissionEntriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>(GetCommissionEntriesDocument, options);
      }
export function useGetCommissionEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>(GetCommissionEntriesDocument, options);
        }
// @ts-ignore
export function useGetCommissionEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>;
export function useGetCommissionEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionEntriesQuery | undefined, GetCommissionEntriesQueryVariables>;
export function useGetCommissionEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>(GetCommissionEntriesDocument, options);
        }
export type GetCommissionEntriesQueryHookResult = ReturnType<typeof useGetCommissionEntriesQuery>;
export type GetCommissionEntriesLazyQueryHookResult = ReturnType<typeof useGetCommissionEntriesLazyQuery>;
export type GetCommissionEntriesSuspenseQueryHookResult = ReturnType<typeof useGetCommissionEntriesSuspenseQuery>;
export type GetCommissionEntriesQueryResult = Apollo.QueryResult<GetCommissionEntriesQuery, GetCommissionEntriesQueryVariables>;
export const GetAgentCommissionSummaryDocument = gql`
    query GetAgentCommissionSummary($agentId: String!) {
  agentCommissionSummary(agentId: $agentId) {
    pendingAmountCents
    pendingAmountRands
    pendingCount
    approvedAmountCents
    approvedAmountRands
    approvedCount
    paidAmountCents
    paidAmountRands
    paidCount
    cancelledAmountCents
    cancelledCount
  }
}
    `;

/**
 * __useGetAgentCommissionSummaryQuery__
 *
 * To run a query within a React component, call `useGetAgentCommissionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentCommissionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentCommissionSummaryQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetAgentCommissionSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables> & ({ variables: GetAgentCommissionSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>(GetAgentCommissionSummaryDocument, options);
      }
export function useGetAgentCommissionSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>(GetAgentCommissionSummaryDocument, options);
        }
// @ts-ignore
export function useGetAgentCommissionSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>;
export function useGetAgentCommissionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentCommissionSummaryQuery | undefined, GetAgentCommissionSummaryQueryVariables>;
export function useGetAgentCommissionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>(GetAgentCommissionSummaryDocument, options);
        }
export type GetAgentCommissionSummaryQueryHookResult = ReturnType<typeof useGetAgentCommissionSummaryQuery>;
export type GetAgentCommissionSummaryLazyQueryHookResult = ReturnType<typeof useGetAgentCommissionSummaryLazyQuery>;
export type GetAgentCommissionSummarySuspenseQueryHookResult = ReturnType<typeof useGetAgentCommissionSummarySuspenseQuery>;
export type GetAgentCommissionSummaryQueryResult = Apollo.QueryResult<GetAgentCommissionSummaryQuery, GetAgentCommissionSummaryQueryVariables>;
export const GetCommissionSummaryDocument = gql`
    query GetCommissionSummary {
  commissionSummary {
    pendingAmountRands
    pendingCount
    approvedAmountRands
    approvedCount
    paidAmountRands
    paidCount
    onHoldAmountRands
    onHoldCount
  }
}
    `;

/**
 * __useGetCommissionSummaryQuery__
 *
 * To run a query within a React component, call `useGetCommissionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommissionSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>(GetCommissionSummaryDocument, options);
      }
export function useGetCommissionSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>(GetCommissionSummaryDocument, options);
        }
// @ts-ignore
export function useGetCommissionSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>;
export function useGetCommissionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionSummaryQuery | undefined, GetCommissionSummaryQueryVariables>;
export function useGetCommissionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>(GetCommissionSummaryDocument, options);
        }
export type GetCommissionSummaryQueryHookResult = ReturnType<typeof useGetCommissionSummaryQuery>;
export type GetCommissionSummaryLazyQueryHookResult = ReturnType<typeof useGetCommissionSummaryLazyQuery>;
export type GetCommissionSummarySuspenseQueryHookResult = ReturnType<typeof useGetCommissionSummarySuspenseQuery>;
export type GetCommissionSummaryQueryResult = Apollo.QueryResult<GetCommissionSummaryQuery, GetCommissionSummaryQueryVariables>;
export const GetMyCommissionSummaryDocument = gql`
    query GetMyCommissionSummary {
  myCommissionSummary {
    pendingAmountCents
    pendingCount
    approvedAmountCents
    approvedCount
    paidAmountCents
    paidCount
  }
}
    `;

/**
 * __useGetMyCommissionSummaryQuery__
 *
 * To run a query within a React component, call `useGetMyCommissionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCommissionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCommissionSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCommissionSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>(GetMyCommissionSummaryDocument, options);
      }
export function useGetMyCommissionSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>(GetMyCommissionSummaryDocument, options);
        }
// @ts-ignore
export function useGetMyCommissionSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>;
export function useGetMyCommissionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCommissionSummaryQuery | undefined, GetMyCommissionSummaryQueryVariables>;
export function useGetMyCommissionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>(GetMyCommissionSummaryDocument, options);
        }
export type GetMyCommissionSummaryQueryHookResult = ReturnType<typeof useGetMyCommissionSummaryQuery>;
export type GetMyCommissionSummaryLazyQueryHookResult = ReturnType<typeof useGetMyCommissionSummaryLazyQuery>;
export type GetMyCommissionSummarySuspenseQueryHookResult = ReturnType<typeof useGetMyCommissionSummarySuspenseQuery>;
export type GetMyCommissionSummaryQueryResult = Apollo.QueryResult<GetMyCommissionSummaryQuery, GetMyCommissionSummaryQueryVariables>;
export const GetCommissionRunsDocument = gql`
    query GetCommissionRuns($input: CommissionRunListInput) {
  commissionRuns(input: $input) {
    items {
      id
      periodDate
      approach
      status
      totalEntries
      totalAmountCents
      totalAmountRands
      paidAmountRands
      unpaidEntryCount
      errorMessage
      startedAt
      completedAt
      createdAt
      triggeredBy {
        id
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetCommissionRunsQuery__
 *
 * To run a query within a React component, call `useGetCommissionRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionRunsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommissionRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>(GetCommissionRunsDocument, options);
      }
export function useGetCommissionRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>(GetCommissionRunsDocument, options);
        }
// @ts-ignore
export function useGetCommissionRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>;
export function useGetCommissionRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionRunsQuery | undefined, GetCommissionRunsQueryVariables>;
export function useGetCommissionRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>(GetCommissionRunsDocument, options);
        }
export type GetCommissionRunsQueryHookResult = ReturnType<typeof useGetCommissionRunsQuery>;
export type GetCommissionRunsLazyQueryHookResult = ReturnType<typeof useGetCommissionRunsLazyQuery>;
export type GetCommissionRunsSuspenseQueryHookResult = ReturnType<typeof useGetCommissionRunsSuspenseQuery>;
export type GetCommissionRunsQueryResult = Apollo.QueryResult<GetCommissionRunsQuery, GetCommissionRunsQueryVariables>;
export const GetNewDistributorFeeReviewDocument = gql`
    query GetNewDistributorFeeReview($periodDate: DateTime!) {
  newDistributorFeeReview(periodDate: $periodDate) {
    agentId
    agentName
    entryId
    onboardedAt
    firstStockAt
    firstSaleAt
    daysCounted
    daysInMonth
    amountCents
    amountRands
    status
    reason
  }
}
    `;

/**
 * __useGetNewDistributorFeeReviewQuery__
 *
 * To run a query within a React component, call `useGetNewDistributorFeeReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewDistributorFeeReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewDistributorFeeReviewQuery({
 *   variables: {
 *      periodDate: // value for 'periodDate'
 *   },
 * });
 */
export function useGetNewDistributorFeeReviewQuery(baseOptions: Apollo.QueryHookOptions<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables> & ({ variables: GetNewDistributorFeeReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>(GetNewDistributorFeeReviewDocument, options);
      }
export function useGetNewDistributorFeeReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>(GetNewDistributorFeeReviewDocument, options);
        }
// @ts-ignore
export function useGetNewDistributorFeeReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>;
export function useGetNewDistributorFeeReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewDistributorFeeReviewQuery | undefined, GetNewDistributorFeeReviewQueryVariables>;
export function useGetNewDistributorFeeReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>(GetNewDistributorFeeReviewDocument, options);
        }
export type GetNewDistributorFeeReviewQueryHookResult = ReturnType<typeof useGetNewDistributorFeeReviewQuery>;
export type GetNewDistributorFeeReviewLazyQueryHookResult = ReturnType<typeof useGetNewDistributorFeeReviewLazyQuery>;
export type GetNewDistributorFeeReviewSuspenseQueryHookResult = ReturnType<typeof useGetNewDistributorFeeReviewSuspenseQuery>;
export type GetNewDistributorFeeReviewQueryResult = Apollo.QueryResult<GetNewDistributorFeeReviewQuery, GetNewDistributorFeeReviewQueryVariables>;
export const RunCommissionsDocument = gql`
    mutation RunCommissions($input: RunCommissionInput!) {
  runCommissions(input: $input) {
    id
    periodDate
    status
    totalEntries
    totalAmountCents
    totalAmountRands
    completedAt
  }
}
    `;
export type RunCommissionsMutationFn = Apollo.MutationFunction<RunCommissionsMutation, RunCommissionsMutationVariables>;

/**
 * __useRunCommissionsMutation__
 *
 * To run a mutation, you first call `useRunCommissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunCommissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runCommissionsMutation, { data, loading, error }] = useRunCommissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunCommissionsMutation(baseOptions?: Apollo.MutationHookOptions<RunCommissionsMutation, RunCommissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunCommissionsMutation, RunCommissionsMutationVariables>(RunCommissionsDocument, options);
      }
export type RunCommissionsMutationHookResult = ReturnType<typeof useRunCommissionsMutation>;
export type RunCommissionsMutationResult = Apollo.MutationResult<RunCommissionsMutation>;
export type RunCommissionsMutationOptions = Apollo.BaseMutationOptions<RunCommissionsMutation, RunCommissionsMutationVariables>;
export const ApproveCommissionsDocument = gql`
    mutation ApproveCommissions($input: ApproveCommissionsInput!) {
  approveCommissions(input: $input) {
    count
  }
}
    `;
export type ApproveCommissionsMutationFn = Apollo.MutationFunction<ApproveCommissionsMutation, ApproveCommissionsMutationVariables>;

/**
 * __useApproveCommissionsMutation__
 *
 * To run a mutation, you first call `useApproveCommissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCommissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCommissionsMutation, { data, loading, error }] = useApproveCommissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveCommissionsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCommissionsMutation, ApproveCommissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveCommissionsMutation, ApproveCommissionsMutationVariables>(ApproveCommissionsDocument, options);
      }
export type ApproveCommissionsMutationHookResult = ReturnType<typeof useApproveCommissionsMutation>;
export type ApproveCommissionsMutationResult = Apollo.MutationResult<ApproveCommissionsMutation>;
export type ApproveCommissionsMutationOptions = Apollo.BaseMutationOptions<ApproveCommissionsMutation, ApproveCommissionsMutationVariables>;
export const ApproveHeldCommissionsDocument = gql`
    mutation ApproveHeldCommissions($input: ApproveCommissionsInput!) {
  approveHeldCommissions(input: $input) {
    count
  }
}
    `;
export type ApproveHeldCommissionsMutationFn = Apollo.MutationFunction<ApproveHeldCommissionsMutation, ApproveHeldCommissionsMutationVariables>;

/**
 * __useApproveHeldCommissionsMutation__
 *
 * To run a mutation, you first call `useApproveHeldCommissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveHeldCommissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveHeldCommissionsMutation, { data, loading, error }] = useApproveHeldCommissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveHeldCommissionsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveHeldCommissionsMutation, ApproveHeldCommissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveHeldCommissionsMutation, ApproveHeldCommissionsMutationVariables>(ApproveHeldCommissionsDocument, options);
      }
export type ApproveHeldCommissionsMutationHookResult = ReturnType<typeof useApproveHeldCommissionsMutation>;
export type ApproveHeldCommissionsMutationResult = Apollo.MutationResult<ApproveHeldCommissionsMutation>;
export type ApproveHeldCommissionsMutationOptions = Apollo.BaseMutationOptions<ApproveHeldCommissionsMutation, ApproveHeldCommissionsMutationVariables>;
export const MarkCommissionsPaidDocument = gql`
    mutation MarkCommissionsPaid($input: MarkCommissionsPaidInput!) {
  markCommissionsPaid(input: $input) {
    paidCount
    skippedCount
    skipped {
      agentId
      agentName
      reason
    }
  }
}
    `;
export type MarkCommissionsPaidMutationFn = Apollo.MutationFunction<MarkCommissionsPaidMutation, MarkCommissionsPaidMutationVariables>;

/**
 * __useMarkCommissionsPaidMutation__
 *
 * To run a mutation, you first call `useMarkCommissionsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommissionsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCommissionsPaidMutation, { data, loading, error }] = useMarkCommissionsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkCommissionsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkCommissionsPaidMutation, MarkCommissionsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCommissionsPaidMutation, MarkCommissionsPaidMutationVariables>(MarkCommissionsPaidDocument, options);
      }
export type MarkCommissionsPaidMutationHookResult = ReturnType<typeof useMarkCommissionsPaidMutation>;
export type MarkCommissionsPaidMutationResult = Apollo.MutationResult<MarkCommissionsPaidMutation>;
export type MarkCommissionsPaidMutationOptions = Apollo.BaseMutationOptions<MarkCommissionsPaidMutation, MarkCommissionsPaidMutationVariables>;
export const MarkCommissionRunPaidDocument = gql`
    mutation MarkCommissionRunPaid($input: MarkCommissionRunPaidInput!) {
  markCommissionRunPaid(input: $input) {
    paidCount
    skippedCount
    skipped {
      agentId
      agentName
      reason
    }
  }
}
    `;
export type MarkCommissionRunPaidMutationFn = Apollo.MutationFunction<MarkCommissionRunPaidMutation, MarkCommissionRunPaidMutationVariables>;

/**
 * __useMarkCommissionRunPaidMutation__
 *
 * To run a mutation, you first call `useMarkCommissionRunPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommissionRunPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCommissionRunPaidMutation, { data, loading, error }] = useMarkCommissionRunPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkCommissionRunPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkCommissionRunPaidMutation, MarkCommissionRunPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCommissionRunPaidMutation, MarkCommissionRunPaidMutationVariables>(MarkCommissionRunPaidDocument, options);
      }
export type MarkCommissionRunPaidMutationHookResult = ReturnType<typeof useMarkCommissionRunPaidMutation>;
export type MarkCommissionRunPaidMutationResult = Apollo.MutationResult<MarkCommissionRunPaidMutation>;
export type MarkCommissionRunPaidMutationOptions = Apollo.BaseMutationOptions<MarkCommissionRunPaidMutation, MarkCommissionRunPaidMutationVariables>;
export const CancelCommissionDocument = gql`
    mutation CancelCommission($input: CancelCommissionInput!) {
  cancelCommission(input: $input)
}
    `;
export type CancelCommissionMutationFn = Apollo.MutationFunction<CancelCommissionMutation, CancelCommissionMutationVariables>;

/**
 * __useCancelCommissionMutation__
 *
 * To run a mutation, you first call `useCancelCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCommissionMutation, { data, loading, error }] = useCancelCommissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelCommissionMutation(baseOptions?: Apollo.MutationHookOptions<CancelCommissionMutation, CancelCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCommissionMutation, CancelCommissionMutationVariables>(CancelCommissionDocument, options);
      }
export type CancelCommissionMutationHookResult = ReturnType<typeof useCancelCommissionMutation>;
export type CancelCommissionMutationResult = Apollo.MutationResult<CancelCommissionMutation>;
export type CancelCommissionMutationOptions = Apollo.BaseMutationOptions<CancelCommissionMutation, CancelCommissionMutationVariables>;
export const CreateManualCommissionDocument = gql`
    mutation CreateManualCommission($input: CreateManualCommissionInput!) {
  createManualCommission(input: $input) {
    id
    amountCents
    amountRands
    status
    source
    note
    periodDate
    agent {
      id
      firstName
      lastName
      salesId
    }
    commissionTypeRef {
      id
      name
      code
    }
  }
}
    `;
export type CreateManualCommissionMutationFn = Apollo.MutationFunction<CreateManualCommissionMutation, CreateManualCommissionMutationVariables>;

/**
 * __useCreateManualCommissionMutation__
 *
 * To run a mutation, you first call `useCreateManualCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualCommissionMutation, { data, loading, error }] = useCreateManualCommissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualCommissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualCommissionMutation, CreateManualCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualCommissionMutation, CreateManualCommissionMutationVariables>(CreateManualCommissionDocument, options);
      }
export type CreateManualCommissionMutationHookResult = ReturnType<typeof useCreateManualCommissionMutation>;
export type CreateManualCommissionMutationResult = Apollo.MutationResult<CreateManualCommissionMutation>;
export type CreateManualCommissionMutationOptions = Apollo.BaseMutationOptions<CreateManualCommissionMutation, CreateManualCommissionMutationVariables>;
export const ExportCommissionEntriesDocument = gql`
    query ExportCommissionEntries($input: CommissionEntryListInput) {
  exportCommissionEntries(input: $input) {
    totalCount
    items {
      commissionType
      source
      note
      periodMonth
      periodDate
      amountRands
      status
      approvedAt
      paidAt
      createdAt
      commissionTypeRef {
        name
        code
      }
      agent {
        firstName
        lastName
        salesId
      }
      stockSale {
        saleReference
        saleDate
      }
      ratePlan {
        rateName
      }
    }
  }
}
    `;

/**
 * __useExportCommissionEntriesQuery__
 *
 * To run a query within a React component, call `useExportCommissionEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCommissionEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCommissionEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportCommissionEntriesQuery(baseOptions?: Apollo.QueryHookOptions<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>(ExportCommissionEntriesDocument, options);
      }
export function useExportCommissionEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>(ExportCommissionEntriesDocument, options);
        }
// @ts-ignore
export function useExportCommissionEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>;
export function useExportCommissionEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCommissionEntriesQuery | undefined, ExportCommissionEntriesQueryVariables>;
export function useExportCommissionEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>(ExportCommissionEntriesDocument, options);
        }
export type ExportCommissionEntriesQueryHookResult = ReturnType<typeof useExportCommissionEntriesQuery>;
export type ExportCommissionEntriesLazyQueryHookResult = ReturnType<typeof useExportCommissionEntriesLazyQuery>;
export type ExportCommissionEntriesSuspenseQueryHookResult = ReturnType<typeof useExportCommissionEntriesSuspenseQuery>;
export type ExportCommissionEntriesQueryResult = Apollo.QueryResult<ExportCommissionEntriesQuery, ExportCommissionEntriesQueryVariables>;
export const ExportCommissionRunDocument = gql`
    query ExportCommissionRun($runId: String!) {
  exportCommissionRun(runId: $runId) {
    fileName
    contentBase64
  }
}
    `;

/**
 * __useExportCommissionRunQuery__
 *
 * To run a query within a React component, call `useExportCommissionRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCommissionRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCommissionRunQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useExportCommissionRunQuery(baseOptions: Apollo.QueryHookOptions<ExportCommissionRunQuery, ExportCommissionRunQueryVariables> & ({ variables: ExportCommissionRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>(ExportCommissionRunDocument, options);
      }
export function useExportCommissionRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>(ExportCommissionRunDocument, options);
        }
// @ts-ignore
export function useExportCommissionRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>;
export function useExportCommissionRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCommissionRunQuery | undefined, ExportCommissionRunQueryVariables>;
export function useExportCommissionRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>(ExportCommissionRunDocument, options);
        }
export type ExportCommissionRunQueryHookResult = ReturnType<typeof useExportCommissionRunQuery>;
export type ExportCommissionRunLazyQueryHookResult = ReturnType<typeof useExportCommissionRunLazyQuery>;
export type ExportCommissionRunSuspenseQueryHookResult = ReturnType<typeof useExportCommissionRunSuspenseQuery>;
export type ExportCommissionRunQueryResult = Apollo.QueryResult<ExportCommissionRunQuery, ExportCommissionRunQueryVariables>;
export const IssueContractAccessoriesDocument = gql`
    mutation IssueContractAccessories($input: IssueContractAccessoriesInput!) {
  issueContractAccessories(input: $input) {
    id
    quantity
  }
}
    `;
export type IssueContractAccessoriesMutationFn = Apollo.MutationFunction<IssueContractAccessoriesMutation, IssueContractAccessoriesMutationVariables>;

/**
 * __useIssueContractAccessoriesMutation__
 *
 * To run a mutation, you first call `useIssueContractAccessoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueContractAccessoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueContractAccessoriesMutation, { data, loading, error }] = useIssueContractAccessoriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueContractAccessoriesMutation(baseOptions?: Apollo.MutationHookOptions<IssueContractAccessoriesMutation, IssueContractAccessoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueContractAccessoriesMutation, IssueContractAccessoriesMutationVariables>(IssueContractAccessoriesDocument, options);
      }
export type IssueContractAccessoriesMutationHookResult = ReturnType<typeof useIssueContractAccessoriesMutation>;
export type IssueContractAccessoriesMutationResult = Apollo.MutationResult<IssueContractAccessoriesMutation>;
export type IssueContractAccessoriesMutationOptions = Apollo.BaseMutationOptions<IssueContractAccessoriesMutation, IssueContractAccessoriesMutationVariables>;
export const ReturnContractAccessoryDocument = gql`
    mutation ReturnContractAccessory($input: ReturnContractAccessoryInput!) {
  returnContractAccessory(input: $input) {
    id
    returnedAt
    returnReason
  }
}
    `;
export type ReturnContractAccessoryMutationFn = Apollo.MutationFunction<ReturnContractAccessoryMutation, ReturnContractAccessoryMutationVariables>;

/**
 * __useReturnContractAccessoryMutation__
 *
 * To run a mutation, you first call `useReturnContractAccessoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnContractAccessoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnContractAccessoryMutation, { data, loading, error }] = useReturnContractAccessoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReturnContractAccessoryMutation(baseOptions?: Apollo.MutationHookOptions<ReturnContractAccessoryMutation, ReturnContractAccessoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReturnContractAccessoryMutation, ReturnContractAccessoryMutationVariables>(ReturnContractAccessoryDocument, options);
      }
export type ReturnContractAccessoryMutationHookResult = ReturnType<typeof useReturnContractAccessoryMutation>;
export type ReturnContractAccessoryMutationResult = Apollo.MutationResult<ReturnContractAccessoryMutation>;
export type ReturnContractAccessoryMutationOptions = Apollo.BaseMutationOptions<ReturnContractAccessoryMutation, ReturnContractAccessoryMutationVariables>;
export const AddAccessoryStockDocument = gql`
    mutation AddAccessoryStock($input: AddAccessoryStockInput!) {
  addAccessoryStock(input: $input)
}
    `;
export type AddAccessoryStockMutationFn = Apollo.MutationFunction<AddAccessoryStockMutation, AddAccessoryStockMutationVariables>;

/**
 * __useAddAccessoryStockMutation__
 *
 * To run a mutation, you first call `useAddAccessoryStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccessoryStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccessoryStockMutation, { data, loading, error }] = useAddAccessoryStockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccessoryStockMutation(baseOptions?: Apollo.MutationHookOptions<AddAccessoryStockMutation, AddAccessoryStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccessoryStockMutation, AddAccessoryStockMutationVariables>(AddAccessoryStockDocument, options);
      }
export type AddAccessoryStockMutationHookResult = ReturnType<typeof useAddAccessoryStockMutation>;
export type AddAccessoryStockMutationResult = Apollo.MutationResult<AddAccessoryStockMutation>;
export type AddAccessoryStockMutationOptions = Apollo.BaseMutationOptions<AddAccessoryStockMutation, AddAccessoryStockMutationVariables>;
export const GetUpgradeOnboardingDocument = gql`
    query GetUpgradeOnboarding($contractId: ID!) {
  upgradeOnboarding(contractId: $contractId) {
    contractId
    contractNumber
    contractTotalPrice
    depositOutstanding
    customerId
    customerName
    approvalRequestId
    approvalStatus
    blockedReason
    contractUpgradeId
    closableBalanceTotal
    candidates {
      id
      contractNumber
      paymentNumber
      status
      statusGroup
      balance
      totalPaid
      tokenExpiresAt
      liveDevices
      selectable
      notSelectableReason
    }
  }
}
    `;

/**
 * __useGetUpgradeOnboardingQuery__
 *
 * To run a query within a React component, call `useGetUpgradeOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpgradeOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpgradeOnboardingQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetUpgradeOnboardingQuery(baseOptions: Apollo.QueryHookOptions<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables> & ({ variables: GetUpgradeOnboardingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>(GetUpgradeOnboardingDocument, options);
      }
export function useGetUpgradeOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>(GetUpgradeOnboardingDocument, options);
        }
// @ts-ignore
export function useGetUpgradeOnboardingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>): Apollo.UseSuspenseQueryResult<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>;
export function useGetUpgradeOnboardingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>): Apollo.UseSuspenseQueryResult<GetUpgradeOnboardingQuery | undefined, GetUpgradeOnboardingQueryVariables>;
export function useGetUpgradeOnboardingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>(GetUpgradeOnboardingDocument, options);
        }
export type GetUpgradeOnboardingQueryHookResult = ReturnType<typeof useGetUpgradeOnboardingQuery>;
export type GetUpgradeOnboardingLazyQueryHookResult = ReturnType<typeof useGetUpgradeOnboardingLazyQuery>;
export type GetUpgradeOnboardingSuspenseQueryHookResult = ReturnType<typeof useGetUpgradeOnboardingSuspenseQuery>;
export type GetUpgradeOnboardingQueryResult = Apollo.QueryResult<GetUpgradeOnboardingQuery, GetUpgradeOnboardingQueryVariables>;
export const GetContractUpgradeDocument = gql`
    query GetContractUpgrade($id: String!) {
  contract(id: $id) {
    id
    upgrade {
      id
      createdAt
      movedTotal
      writtenOffTotal
      creditAmount
      creditReason
      openingBalance
      note
      onboardedBy {
        id
        firstName
        lastName
      }
      sources {
        id
        statusBefore
        balanceAtClosure
        balanceTreatment
        deviceOutcome
        amountMoved
        amountWrittenOff
        sourceContract {
          id
          contractNumber
        }
      }
    }
  }
}
    `;

/**
 * __useGetContractUpgradeQuery__
 *
 * To run a query within a React component, call `useGetContractUpgradeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractUpgradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractUpgradeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractUpgradeQuery(baseOptions: Apollo.QueryHookOptions<GetContractUpgradeQuery, GetContractUpgradeQueryVariables> & ({ variables: GetContractUpgradeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>(GetContractUpgradeDocument, options);
      }
export function useGetContractUpgradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>(GetContractUpgradeDocument, options);
        }
// @ts-ignore
export function useGetContractUpgradeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>;
export function useGetContractUpgradeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractUpgradeQuery | undefined, GetContractUpgradeQueryVariables>;
export function useGetContractUpgradeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>(GetContractUpgradeDocument, options);
        }
export type GetContractUpgradeQueryHookResult = ReturnType<typeof useGetContractUpgradeQuery>;
export type GetContractUpgradeLazyQueryHookResult = ReturnType<typeof useGetContractUpgradeLazyQuery>;
export type GetContractUpgradeSuspenseQueryHookResult = ReturnType<typeof useGetContractUpgradeSuspenseQuery>;
export type GetContractUpgradeQueryResult = Apollo.QueryResult<GetContractUpgradeQuery, GetContractUpgradeQueryVariables>;
export const RequestUpgradeOnboardingDocument = gql`
    mutation RequestUpgradeOnboarding($input: RequestUpgradeOnboardingInput!) {
  requestUpgradeOnboarding(input: $input) {
    id
    status
  }
}
    `;
export type RequestUpgradeOnboardingMutationFn = Apollo.MutationFunction<RequestUpgradeOnboardingMutation, RequestUpgradeOnboardingMutationVariables>;

/**
 * __useRequestUpgradeOnboardingMutation__
 *
 * To run a mutation, you first call `useRequestUpgradeOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUpgradeOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUpgradeOnboardingMutation, { data, loading, error }] = useRequestUpgradeOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestUpgradeOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<RequestUpgradeOnboardingMutation, RequestUpgradeOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUpgradeOnboardingMutation, RequestUpgradeOnboardingMutationVariables>(RequestUpgradeOnboardingDocument, options);
      }
export type RequestUpgradeOnboardingMutationHookResult = ReturnType<typeof useRequestUpgradeOnboardingMutation>;
export type RequestUpgradeOnboardingMutationResult = Apollo.MutationResult<RequestUpgradeOnboardingMutation>;
export type RequestUpgradeOnboardingMutationOptions = Apollo.BaseMutationOptions<RequestUpgradeOnboardingMutation, RequestUpgradeOnboardingMutationVariables>;
export const OnboardUpgradeDocument = gql`
    mutation OnboardUpgrade($input: OnboardUpgradeInput!) {
  onboardUpgrade(input: $input) {
    id
    movedTotal
    writtenOffTotal
    creditAmount
    openingBalance
    sources {
      id
    }
  }
}
    `;
export type OnboardUpgradeMutationFn = Apollo.MutationFunction<OnboardUpgradeMutation, OnboardUpgradeMutationVariables>;

/**
 * __useOnboardUpgradeMutation__
 *
 * To run a mutation, you first call `useOnboardUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardUpgradeMutation, { data, loading, error }] = useOnboardUpgradeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardUpgradeMutation(baseOptions?: Apollo.MutationHookOptions<OnboardUpgradeMutation, OnboardUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardUpgradeMutation, OnboardUpgradeMutationVariables>(OnboardUpgradeDocument, options);
      }
export type OnboardUpgradeMutationHookResult = ReturnType<typeof useOnboardUpgradeMutation>;
export type OnboardUpgradeMutationResult = Apollo.MutationResult<OnboardUpgradeMutation>;
export type OnboardUpgradeMutationOptions = Apollo.BaseMutationOptions<OnboardUpgradeMutation, OnboardUpgradeMutationVariables>;
export const GetContractsDocument = gql`
    query GetContracts($input: ContractListInput) {
  contracts(input: $input) {
    items {
      id
      contractNumber
      contractReference
      status
      statusGroup
      subStatus
      daysPastDue
      writeOffReason
      writeOffEligible
      totalPrice
      priceAdjustment
      carriedBalance
      balance
      depositAmount
      depositOutstanding
      rateAmount
      nonTokenAmount
      rateName
      termLength
      registrationDate
      contractEndDate
      manSystem
      isMigrated
      applicationType
      xeroInvoiceId
      xeroRepeatingInvoiceId
      createdAt
      distributorName
      nationalSalesManagerName
      customer {
        id
        fullName
      }
      ratePlan {
        id
        rateName
        product
        depositAmount
        rateAmount
        downpayment
        termLength
      }
      stockSale {
        id
        stockItem {
          id
          accountNumber
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetContractsQuery__
 *
 * To run a query within a React component, call `useGetContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
      }
export function useGetContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
        }
// @ts-ignore
export function useGetContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractsQuery, GetContractsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractsQuery, GetContractsQueryVariables>;
export function useGetContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractsQuery, GetContractsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractsQuery | undefined, GetContractsQueryVariables>;
export function useGetContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractsQuery, GetContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, options);
        }
export type GetContractsQueryHookResult = ReturnType<typeof useGetContractsQuery>;
export type GetContractsLazyQueryHookResult = ReturnType<typeof useGetContractsLazyQuery>;
export type GetContractsSuspenseQueryHookResult = ReturnType<typeof useGetContractsSuspenseQuery>;
export type GetContractsQueryResult = Apollo.QueryResult<GetContractsQuery, GetContractsQueryVariables>;
export const GetContractHeldBalanceDocument = gql`
    query GetContractHeldBalance($id: String!) {
  contract(id: $id) {
    id
    heldBalance
  }
}
    `;

/**
 * __useGetContractHeldBalanceQuery__
 *
 * To run a query within a React component, call `useGetContractHeldBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractHeldBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractHeldBalanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractHeldBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables> & ({ variables: GetContractHeldBalanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>(GetContractHeldBalanceDocument, options);
      }
export function useGetContractHeldBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>(GetContractHeldBalanceDocument, options);
        }
// @ts-ignore
export function useGetContractHeldBalanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>;
export function useGetContractHeldBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractHeldBalanceQuery | undefined, GetContractHeldBalanceQueryVariables>;
export function useGetContractHeldBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>(GetContractHeldBalanceDocument, options);
        }
export type GetContractHeldBalanceQueryHookResult = ReturnType<typeof useGetContractHeldBalanceQuery>;
export type GetContractHeldBalanceLazyQueryHookResult = ReturnType<typeof useGetContractHeldBalanceLazyQuery>;
export type GetContractHeldBalanceSuspenseQueryHookResult = ReturnType<typeof useGetContractHeldBalanceSuspenseQuery>;
export type GetContractHeldBalanceQueryResult = Apollo.QueryResult<GetContractHeldBalanceQuery, GetContractHeldBalanceQueryVariables>;
export const GetContractStatusCountsDocument = gql`
    query GetContractStatusCounts($mine: Boolean) {
  contractStatusCounts(mine: $mine) {
    status
    count
  }
}
    `;

/**
 * __useGetContractStatusCountsQuery__
 *
 * To run a query within a React component, call `useGetContractStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractStatusCountsQuery({
 *   variables: {
 *      mine: // value for 'mine'
 *   },
 * });
 */
export function useGetContractStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>(GetContractStatusCountsDocument, options);
      }
export function useGetContractStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>(GetContractStatusCountsDocument, options);
        }
// @ts-ignore
export function useGetContractStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>;
export function useGetContractStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractStatusCountsQuery | undefined, GetContractStatusCountsQueryVariables>;
export function useGetContractStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>(GetContractStatusCountsDocument, options);
        }
export type GetContractStatusCountsQueryHookResult = ReturnType<typeof useGetContractStatusCountsQuery>;
export type GetContractStatusCountsLazyQueryHookResult = ReturnType<typeof useGetContractStatusCountsLazyQuery>;
export type GetContractStatusCountsSuspenseQueryHookResult = ReturnType<typeof useGetContractStatusCountsSuspenseQuery>;
export type GetContractStatusCountsQueryResult = Apollo.QueryResult<GetContractStatusCountsQuery, GetContractStatusCountsQueryVariables>;
export const GetContractLifecycleSummaryDocument = gql`
    query GetContractLifecycleSummary {
  contractLifecycleSummary {
    total
    draft
    pendingInstallation
    active
    paidOff
    cancelled
    upgraded
    writtenOff
    repossessed
    activeInCredit
    activeDelinquent
    activeWriteOffDue
    activeRepossessionDue
    writtenOffRepossessed
    writtenOffTheft
    writtenOffNotRepossessed
  }
}
    `;

/**
 * __useGetContractLifecycleSummaryQuery__
 *
 * To run a query within a React component, call `useGetContractLifecycleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractLifecycleSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractLifecycleSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractLifecycleSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>(GetContractLifecycleSummaryDocument, options);
      }
export function useGetContractLifecycleSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>(GetContractLifecycleSummaryDocument, options);
        }
// @ts-ignore
export function useGetContractLifecycleSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>;
export function useGetContractLifecycleSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractLifecycleSummaryQuery | undefined, GetContractLifecycleSummaryQueryVariables>;
export function useGetContractLifecycleSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>(GetContractLifecycleSummaryDocument, options);
        }
export type GetContractLifecycleSummaryQueryHookResult = ReturnType<typeof useGetContractLifecycleSummaryQuery>;
export type GetContractLifecycleSummaryLazyQueryHookResult = ReturnType<typeof useGetContractLifecycleSummaryLazyQuery>;
export type GetContractLifecycleSummarySuspenseQueryHookResult = ReturnType<typeof useGetContractLifecycleSummarySuspenseQuery>;
export type GetContractLifecycleSummaryQueryResult = Apollo.QueryResult<GetContractLifecycleSummaryQuery, GetContractLifecycleSummaryQueryVariables>;
export const GetContractDocument = gql`
    query GetContract($id: String!) {
  contract(id: $id) {
    id
    contractNumber
    paymentNumber
    paymentNumberNotifiedAt
    paymentNumberNotifiedTo
    contractReference
    status
    statusGroup
    subStatus
    daysPastDue
    writeOffReason
    writeOffEligible
    totalPrice
    balance
    carriedBalance
    depositAmount
    depositOutstanding
    heldBalance
    rateAmount
    nonTokenAmount
    commissionMonth1
    commissionMonth2
    commissionMonth3
    commissionMonth4
    commissionCloseout
    commissionRam
    aftercareAgent
    aftercareRam
    rateName
    termLength
    registrationDate
    contractEndDate
    flaggedForRepossessionAt
    flaggedForRepossessionReason
    isFlaggedForRepossession
    flaggedForRepossessionBy {
      id
      firstName
      lastName
    }
    reopenPreview {
      targetStatus
      devicesPutBack
      reasons
      blocker
      deviceStep
      devicesToConfirm {
        productName
      }
      replaceBecause
    }
    repossessedAt
    repossessedBy {
      id
      firstName
      lastName
    }
    manSystem
    externalId
    isMigrated
    applicationType
    upgrade {
      id
      creditAmount
    }
    upgradedInto {
      id
      balanceTreatment
      deviceOutcome
      amountMoved
      amountWrittenOff
      contractUpgrade {
        id
        createdAt
        upgradeContract {
          id
          contractNumber
        }
      }
    }
    xeroInvoiceId
    xeroRepeatingInvoiceId
    createdAt
    updatedAt
    customer {
      id
      fullName
      phone
      address {
        country
      }
    }
    ratePlan {
      id
      rateName
      manSystem
      depositAmount
      rateAmount
      downpayment
      termLength
      products {
        id
        allocationPercentage
        product {
          id
          name
          canAcceptToken
        }
      }
    }
    deviceCapacity
    deviceControlActions {
      id
      createdAt
      action
      status
      accountNumber
      vendor
      token
      tokenSequence
      failureReason
      customerNotifiedAt
      customerNotifiedTo
      confirmedAt
      confirmedBy {
        id
        firstName
        lastName
      }
      requestedBy {
        id
        firstName
        lastName
      }
      stockSale {
        id
      }
    }
    accessories {
      id
      issuedAt
      returnedAt
      returnReason
      issuedBy {
        id
        firstName
        lastName
      }
      returnedBy {
        id
        firstName
        lastName
      }
      quantity
      product {
        id
        sku
        name
      }
      stockItem {
        id
        serialNumber
        accountNumber
        productName
        status
        stockingPoint {
          id
          name
        }
      }
    }
    stockSales {
      id
      status
      saleReference
      saleDate
      deviceControl {
        eligible
        explanation
        vendor
        alreadyUnlockedAt
      }
      deviceLockControl {
        eligible
        explanation
        vendor
        requiresIndex
        runtimeAtRisk
        belief
        pendingSince
      }
      stockItem {
        id
        serialNumber
        accountNumber
        productName
        status
        hasMeter
        meterHostedOn
        meterTypeName
        meterTypeId
        meterStartingCode
        meterHasSecretKey
      }
      agent {
        id
        firstName
        lastName
        salesId
        parentAgent {
          id
          firstName
          lastName
          salesId
        }
      }
    }
    createdBy {
      id
      firstName
      lastName
    }
    changeHistory {
      id
      fieldName
      oldValue
      newValue
      changeType
      createdAt
      changedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetContractQuery__
 *
 * To run a query within a React component, call `useGetContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractQuery(baseOptions: Apollo.QueryHookOptions<GetContractQuery, GetContractQueryVariables> & ({ variables: GetContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
      }
export function useGetContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
        }
// @ts-ignore
export function useGetContractSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractQuery, GetContractQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractQuery, GetContractQueryVariables>;
export function useGetContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractQuery, GetContractQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractQuery | undefined, GetContractQueryVariables>;
export function useGetContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
        }
export type GetContractQueryHookResult = ReturnType<typeof useGetContractQuery>;
export type GetContractLazyQueryHookResult = ReturnType<typeof useGetContractLazyQuery>;
export type GetContractSuspenseQueryHookResult = ReturnType<typeof useGetContractSuspenseQuery>;
export type GetContractQueryResult = Apollo.QueryResult<GetContractQuery, GetContractQueryVariables>;
export const CreateContractDocument = gql`
    mutation CreateContract($input: CreateContractInput!) {
  createContract(input: $input) {
    id
    contractNumber
    status
    depositAmount
    rateAmount
    rateName
    termLength
    manSystem
  }
}
    `;
export type CreateContractMutationFn = Apollo.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const UpdateContractDocument = gql`
    mutation UpdateContract($id: String!, $input: UpdateContractInput!) {
  updateContract(id: $id, input: $input) {
    id
    contractNumber
    status
    subStatus
    daysPastDue
    writeOffReason
    writeOffEligible
    depositAmount
    rateAmount
    nonTokenAmount
    rateName
    termLength
  }
}
    `;
export type UpdateContractMutationFn = Apollo.MutationFunction<UpdateContractMutation, UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractMutation, UpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, options);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>;
export const ExportContractsDocument = gql`
    query ExportContracts($input: ContractListInput) {
  exportContracts(input: $input) {
    totalCount
    items {
      contractNumber
      contractReference
      status
      subStatus
      daysPastDue
      totalPrice
      balance
      depositAmount
      depositOutstanding
      rateAmount
      rateName
      termLength
      registrationDate
      contractEndDate
      lastPaymentDate
      createdAt
      distributorName
      nationalSalesManagerName
      customer {
        fullName
        phone
        idNumber
        identificationType
        address {
          streetAddress
          addressLevel1
          addressLevel2
          postalCode
          country
          countryName
        }
      }
      ratePlan {
        rateName
        product
      }
      stockSales {
        stockItem {
          serialNumber
          accountNumber
        }
        agent {
          id
          firstName
          lastName
          salesId
        }
      }
    }
  }
}
    `;

/**
 * __useExportContractsQuery__
 *
 * To run a query within a React component, call `useExportContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportContractsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportContractsQuery(baseOptions?: Apollo.QueryHookOptions<ExportContractsQuery, ExportContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportContractsQuery, ExportContractsQueryVariables>(ExportContractsDocument, options);
      }
export function useExportContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportContractsQuery, ExportContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportContractsQuery, ExportContractsQueryVariables>(ExportContractsDocument, options);
        }
// @ts-ignore
export function useExportContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportContractsQuery, ExportContractsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportContractsQuery, ExportContractsQueryVariables>;
export function useExportContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportContractsQuery, ExportContractsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportContractsQuery | undefined, ExportContractsQueryVariables>;
export function useExportContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportContractsQuery, ExportContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportContractsQuery, ExportContractsQueryVariables>(ExportContractsDocument, options);
        }
export type ExportContractsQueryHookResult = ReturnType<typeof useExportContractsQuery>;
export type ExportContractsLazyQueryHookResult = ReturnType<typeof useExportContractsLazyQuery>;
export type ExportContractsSuspenseQueryHookResult = ReturnType<typeof useExportContractsSuspenseQuery>;
export type ExportContractsQueryResult = Apollo.QueryResult<ExportContractsQuery, ExportContractsQueryVariables>;
export const FlagContractForRepossessionDocument = gql`
    mutation FlagContractForRepossession($input: FlagForRepossessionInput!) {
  flagContractForRepossession(input: $input) {
    id
    status
    flaggedForRepossessionAt
    flaggedForRepossessionReason
    isFlaggedForRepossession
    flaggedForRepossessionBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type FlagContractForRepossessionMutationFn = Apollo.MutationFunction<FlagContractForRepossessionMutation, FlagContractForRepossessionMutationVariables>;

/**
 * __useFlagContractForRepossessionMutation__
 *
 * To run a mutation, you first call `useFlagContractForRepossessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagContractForRepossessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagContractForRepossessionMutation, { data, loading, error }] = useFlagContractForRepossessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFlagContractForRepossessionMutation(baseOptions?: Apollo.MutationHookOptions<FlagContractForRepossessionMutation, FlagContractForRepossessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagContractForRepossessionMutation, FlagContractForRepossessionMutationVariables>(FlagContractForRepossessionDocument, options);
      }
export type FlagContractForRepossessionMutationHookResult = ReturnType<typeof useFlagContractForRepossessionMutation>;
export type FlagContractForRepossessionMutationResult = Apollo.MutationResult<FlagContractForRepossessionMutation>;
export type FlagContractForRepossessionMutationOptions = Apollo.BaseMutationOptions<FlagContractForRepossessionMutation, FlagContractForRepossessionMutationVariables>;
export const ClearContractRepossessionFlagDocument = gql`
    mutation ClearContractRepossessionFlag($input: ClearRepossessionFlagInput!) {
  clearContractRepossessionFlag(input: $input) {
    id
    status
    flaggedForRepossessionAt
    flaggedForRepossessionReason
    isFlaggedForRepossession
  }
}
    `;
export type ClearContractRepossessionFlagMutationFn = Apollo.MutationFunction<ClearContractRepossessionFlagMutation, ClearContractRepossessionFlagMutationVariables>;

/**
 * __useClearContractRepossessionFlagMutation__
 *
 * To run a mutation, you first call `useClearContractRepossessionFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearContractRepossessionFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearContractRepossessionFlagMutation, { data, loading, error }] = useClearContractRepossessionFlagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearContractRepossessionFlagMutation(baseOptions?: Apollo.MutationHookOptions<ClearContractRepossessionFlagMutation, ClearContractRepossessionFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearContractRepossessionFlagMutation, ClearContractRepossessionFlagMutationVariables>(ClearContractRepossessionFlagDocument, options);
      }
export type ClearContractRepossessionFlagMutationHookResult = ReturnType<typeof useClearContractRepossessionFlagMutation>;
export type ClearContractRepossessionFlagMutationResult = Apollo.MutationResult<ClearContractRepossessionFlagMutation>;
export type ClearContractRepossessionFlagMutationOptions = Apollo.BaseMutationOptions<ClearContractRepossessionFlagMutation, ClearContractRepossessionFlagMutationVariables>;
export const RecordContractRepossessionDocument = gql`
    mutation RecordContractRepossession($input: RecordRepossessionInput!) {
  recordContractRepossession(input: $input) {
    id
    status
    repossessedAt
    repossessedBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type RecordContractRepossessionMutationFn = Apollo.MutationFunction<RecordContractRepossessionMutation, RecordContractRepossessionMutationVariables>;

/**
 * __useRecordContractRepossessionMutation__
 *
 * To run a mutation, you first call `useRecordContractRepossessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordContractRepossessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordContractRepossessionMutation, { data, loading, error }] = useRecordContractRepossessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordContractRepossessionMutation(baseOptions?: Apollo.MutationHookOptions<RecordContractRepossessionMutation, RecordContractRepossessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordContractRepossessionMutation, RecordContractRepossessionMutationVariables>(RecordContractRepossessionDocument, options);
      }
export type RecordContractRepossessionMutationHookResult = ReturnType<typeof useRecordContractRepossessionMutation>;
export type RecordContractRepossessionMutationResult = Apollo.MutationResult<RecordContractRepossessionMutation>;
export type RecordContractRepossessionMutationOptions = Apollo.BaseMutationOptions<RecordContractRepossessionMutation, RecordContractRepossessionMutationVariables>;
export const ReopenContractDocument = gql`
    mutation ReopenContract($input: ReopenContractInput!) {
  reopenContract(input: $input) {
    id
    status
    statusGroup
    subStatus
    daysPastDue
    writeOffReason
    writeOffEligible
    balance
  }
}
    `;
export type ReopenContractMutationFn = Apollo.MutationFunction<ReopenContractMutation, ReopenContractMutationVariables>;

/**
 * __useReopenContractMutation__
 *
 * To run a mutation, you first call `useReopenContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenContractMutation, { data, loading, error }] = useReopenContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenContractMutation(baseOptions?: Apollo.MutationHookOptions<ReopenContractMutation, ReopenContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenContractMutation, ReopenContractMutationVariables>(ReopenContractDocument, options);
      }
export type ReopenContractMutationHookResult = ReturnType<typeof useReopenContractMutation>;
export type ReopenContractMutationResult = Apollo.MutationResult<ReopenContractMutation>;
export type ReopenContractMutationOptions = Apollo.BaseMutationOptions<ReopenContractMutation, ReopenContractMutationVariables>;
export const WriteOffContractDocument = gql`
    mutation WriteOffContract($input: WriteOffContractInput!) {
  writeOffContract(input: $input) {
    id
    status
    writeOffReason
    writeOffEligible
    repossessedAt
    repossessedBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type WriteOffContractMutationFn = Apollo.MutationFunction<WriteOffContractMutation, WriteOffContractMutationVariables>;

/**
 * __useWriteOffContractMutation__
 *
 * To run a mutation, you first call `useWriteOffContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteOffContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeOffContractMutation, { data, loading, error }] = useWriteOffContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWriteOffContractMutation(baseOptions?: Apollo.MutationHookOptions<WriteOffContractMutation, WriteOffContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteOffContractMutation, WriteOffContractMutationVariables>(WriteOffContractDocument, options);
      }
export type WriteOffContractMutationHookResult = ReturnType<typeof useWriteOffContractMutation>;
export type WriteOffContractMutationResult = Apollo.MutationResult<WriteOffContractMutation>;
export type WriteOffContractMutationOptions = Apollo.BaseMutationOptions<WriteOffContractMutation, WriteOffContractMutationVariables>;
export const UnlockContractDevicesDocument = gql`
    mutation UnlockContractDevices($contractId: ID!, $stockSaleId: ID) {
  unlockContractDevices(contractId: $contractId, stockSaleId: $stockSaleId) {
    id
    createdAt
    status
    accountNumber
    vendor
    token
    tokenSequence
    failureReason
    customerNotifiedAt
    customerNotifiedTo
    stockSale {
      id
    }
  }
}
    `;
export type UnlockContractDevicesMutationFn = Apollo.MutationFunction<UnlockContractDevicesMutation, UnlockContractDevicesMutationVariables>;

/**
 * __useUnlockContractDevicesMutation__
 *
 * To run a mutation, you first call `useUnlockContractDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockContractDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockContractDevicesMutation, { data, loading, error }] = useUnlockContractDevicesMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      stockSaleId: // value for 'stockSaleId'
 *   },
 * });
 */
export function useUnlockContractDevicesMutation(baseOptions?: Apollo.MutationHookOptions<UnlockContractDevicesMutation, UnlockContractDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockContractDevicesMutation, UnlockContractDevicesMutationVariables>(UnlockContractDevicesDocument, options);
      }
export type UnlockContractDevicesMutationHookResult = ReturnType<typeof useUnlockContractDevicesMutation>;
export type UnlockContractDevicesMutationResult = Apollo.MutationResult<UnlockContractDevicesMutation>;
export type UnlockContractDevicesMutationOptions = Apollo.BaseMutationOptions<UnlockContractDevicesMutation, UnlockContractDevicesMutationVariables>;
export const ResendContractPaymentNumberSmsDocument = gql`
    mutation ResendContractPaymentNumberSms($contractId: ID!, $phoneOverride: String) {
  resendContractPaymentNumberSms(
    contractId: $contractId
    phoneOverride: $phoneOverride
  ) {
    id
    paymentNumberNotifiedAt
    paymentNumberNotifiedTo
  }
}
    `;
export type ResendContractPaymentNumberSmsMutationFn = Apollo.MutationFunction<ResendContractPaymentNumberSmsMutation, ResendContractPaymentNumberSmsMutationVariables>;

/**
 * __useResendContractPaymentNumberSmsMutation__
 *
 * To run a mutation, you first call `useResendContractPaymentNumberSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendContractPaymentNumberSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendContractPaymentNumberSmsMutation, { data, loading, error }] = useResendContractPaymentNumberSmsMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      phoneOverride: // value for 'phoneOverride'
 *   },
 * });
 */
export function useResendContractPaymentNumberSmsMutation(baseOptions?: Apollo.MutationHookOptions<ResendContractPaymentNumberSmsMutation, ResendContractPaymentNumberSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendContractPaymentNumberSmsMutation, ResendContractPaymentNumberSmsMutationVariables>(ResendContractPaymentNumberSmsDocument, options);
      }
export type ResendContractPaymentNumberSmsMutationHookResult = ReturnType<typeof useResendContractPaymentNumberSmsMutation>;
export type ResendContractPaymentNumberSmsMutationResult = Apollo.MutationResult<ResendContractPaymentNumberSmsMutation>;
export type ResendContractPaymentNumberSmsMutationOptions = Apollo.BaseMutationOptions<ResendContractPaymentNumberSmsMutation, ResendContractPaymentNumberSmsMutationVariables>;
export const ResendDeviceUnlockSmsDocument = gql`
    mutation ResendDeviceUnlockSms($deviceControlActionId: ID!, $phoneOverride: String) {
  resendDeviceUnlockSms(
    deviceControlActionId: $deviceControlActionId
    phoneOverride: $phoneOverride
  ) {
    id
    customerNotifiedAt
    customerNotifiedTo
  }
}
    `;
export type ResendDeviceUnlockSmsMutationFn = Apollo.MutationFunction<ResendDeviceUnlockSmsMutation, ResendDeviceUnlockSmsMutationVariables>;

/**
 * __useResendDeviceUnlockSmsMutation__
 *
 * To run a mutation, you first call `useResendDeviceUnlockSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendDeviceUnlockSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendDeviceUnlockSmsMutation, { data, loading, error }] = useResendDeviceUnlockSmsMutation({
 *   variables: {
 *      deviceControlActionId: // value for 'deviceControlActionId'
 *      phoneOverride: // value for 'phoneOverride'
 *   },
 * });
 */
export function useResendDeviceUnlockSmsMutation(baseOptions?: Apollo.MutationHookOptions<ResendDeviceUnlockSmsMutation, ResendDeviceUnlockSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendDeviceUnlockSmsMutation, ResendDeviceUnlockSmsMutationVariables>(ResendDeviceUnlockSmsDocument, options);
      }
export type ResendDeviceUnlockSmsMutationHookResult = ReturnType<typeof useResendDeviceUnlockSmsMutation>;
export type ResendDeviceUnlockSmsMutationResult = Apollo.MutationResult<ResendDeviceUnlockSmsMutation>;
export type ResendDeviceUnlockSmsMutationOptions = Apollo.BaseMutationOptions<ResendDeviceUnlockSmsMutation, ResendDeviceUnlockSmsMutationVariables>;
export const GetCustomerDeviceUnlocksDocument = gql`
    query GetCustomerDeviceUnlocks($customerId: String!) {
  contracts(input: {customerId: $customerId}) {
    items {
      id
      deviceControlActions {
        id
        createdAt
        status
        accountNumber
        vendor
        token
        failureReason
        customerNotifiedAt
        customerNotifiedTo
        requestedBy {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomerDeviceUnlocksQuery__
 *
 * To run a query within a React component, call `useGetCustomerDeviceUnlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDeviceUnlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDeviceUnlocksQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerDeviceUnlocksQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables> & ({ variables: GetCustomerDeviceUnlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>(GetCustomerDeviceUnlocksDocument, options);
      }
export function useGetCustomerDeviceUnlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>(GetCustomerDeviceUnlocksDocument, options);
        }
// @ts-ignore
export function useGetCustomerDeviceUnlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>;
export function useGetCustomerDeviceUnlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerDeviceUnlocksQuery | undefined, GetCustomerDeviceUnlocksQueryVariables>;
export function useGetCustomerDeviceUnlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>(GetCustomerDeviceUnlocksDocument, options);
        }
export type GetCustomerDeviceUnlocksQueryHookResult = ReturnType<typeof useGetCustomerDeviceUnlocksQuery>;
export type GetCustomerDeviceUnlocksLazyQueryHookResult = ReturnType<typeof useGetCustomerDeviceUnlocksLazyQuery>;
export type GetCustomerDeviceUnlocksSuspenseQueryHookResult = ReturnType<typeof useGetCustomerDeviceUnlocksSuspenseQuery>;
export type GetCustomerDeviceUnlocksQueryResult = Apollo.QueryResult<GetCustomerDeviceUnlocksQuery, GetCustomerDeviceUnlocksQueryVariables>;
export const LockContractDevicesDocument = gql`
    mutation LockContractDevices($contractId: ID!, $stockSaleId: ID, $index: Int) {
  lockContractDevices(
    contractId: $contractId
    stockSaleId: $stockSaleId
    index: $index
  ) {
    id
    createdAt
    action
    status
    accountNumber
    vendor
    token
    tokenSequence
    failureReason
    confirmedAt
    stockSale {
      id
    }
  }
}
    `;
export type LockContractDevicesMutationFn = Apollo.MutationFunction<LockContractDevicesMutation, LockContractDevicesMutationVariables>;

/**
 * __useLockContractDevicesMutation__
 *
 * To run a mutation, you first call `useLockContractDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockContractDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockContractDevicesMutation, { data, loading, error }] = useLockContractDevicesMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      stockSaleId: // value for 'stockSaleId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useLockContractDevicesMutation(baseOptions?: Apollo.MutationHookOptions<LockContractDevicesMutation, LockContractDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockContractDevicesMutation, LockContractDevicesMutationVariables>(LockContractDevicesDocument, options);
      }
export type LockContractDevicesMutationHookResult = ReturnType<typeof useLockContractDevicesMutation>;
export type LockContractDevicesMutationResult = Apollo.MutationResult<LockContractDevicesMutation>;
export type LockContractDevicesMutationOptions = Apollo.BaseMutationOptions<LockContractDevicesMutation, LockContractDevicesMutationVariables>;
export const ConfirmDeviceLockDocument = gql`
    mutation ConfirmDeviceLock($deviceControlActionId: ID!) {
  confirmDeviceLock(deviceControlActionId: $deviceControlActionId) {
    id
    confirmedAt
    confirmedBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type ConfirmDeviceLockMutationFn = Apollo.MutationFunction<ConfirmDeviceLockMutation, ConfirmDeviceLockMutationVariables>;

/**
 * __useConfirmDeviceLockMutation__
 *
 * To run a mutation, you first call `useConfirmDeviceLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDeviceLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDeviceLockMutation, { data, loading, error }] = useConfirmDeviceLockMutation({
 *   variables: {
 *      deviceControlActionId: // value for 'deviceControlActionId'
 *   },
 * });
 */
export function useConfirmDeviceLockMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmDeviceLockMutation, ConfirmDeviceLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmDeviceLockMutation, ConfirmDeviceLockMutationVariables>(ConfirmDeviceLockDocument, options);
      }
export type ConfirmDeviceLockMutationHookResult = ReturnType<typeof useConfirmDeviceLockMutation>;
export type ConfirmDeviceLockMutationResult = Apollo.MutationResult<ConfirmDeviceLockMutation>;
export type ConfirmDeviceLockMutationOptions = Apollo.BaseMutationOptions<ConfirmDeviceLockMutation, ConfirmDeviceLockMutationVariables>;
export const GetContractIdsForBulkFlagDocument = gql`
    query GetContractIdsForBulkFlag($input: ContractListInput) {
  contracts(input: $input) {
    items {
      id
    }
    totalCount
  }
}
    `;

/**
 * __useGetContractIdsForBulkFlagQuery__
 *
 * To run a query within a React component, call `useGetContractIdsForBulkFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractIdsForBulkFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractIdsForBulkFlagQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContractIdsForBulkFlagQuery(baseOptions?: Apollo.QueryHookOptions<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>(GetContractIdsForBulkFlagDocument, options);
      }
export function useGetContractIdsForBulkFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>(GetContractIdsForBulkFlagDocument, options);
        }
// @ts-ignore
export function useGetContractIdsForBulkFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>;
export function useGetContractIdsForBulkFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>): Apollo.UseSuspenseQueryResult<GetContractIdsForBulkFlagQuery | undefined, GetContractIdsForBulkFlagQueryVariables>;
export function useGetContractIdsForBulkFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>(GetContractIdsForBulkFlagDocument, options);
        }
export type GetContractIdsForBulkFlagQueryHookResult = ReturnType<typeof useGetContractIdsForBulkFlagQuery>;
export type GetContractIdsForBulkFlagLazyQueryHookResult = ReturnType<typeof useGetContractIdsForBulkFlagLazyQuery>;
export type GetContractIdsForBulkFlagSuspenseQueryHookResult = ReturnType<typeof useGetContractIdsForBulkFlagSuspenseQuery>;
export type GetContractIdsForBulkFlagQueryResult = Apollo.QueryResult<GetContractIdsForBulkFlagQuery, GetContractIdsForBulkFlagQueryVariables>;
export const BulkFlagContractsForRepossessionDocument = gql`
    mutation BulkFlagContractsForRepossession($input: BulkFlagContractsForRepossessionInput!) {
  bulkFlagContractsForRepossession(input: $input) {
    total
    flagged
    skipped
    failed
    rows {
      contractNumber
      status
      reason
    }
  }
}
    `;
export type BulkFlagContractsForRepossessionMutationFn = Apollo.MutationFunction<BulkFlagContractsForRepossessionMutation, BulkFlagContractsForRepossessionMutationVariables>;

/**
 * __useBulkFlagContractsForRepossessionMutation__
 *
 * To run a mutation, you first call `useBulkFlagContractsForRepossessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkFlagContractsForRepossessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkFlagContractsForRepossessionMutation, { data, loading, error }] = useBulkFlagContractsForRepossessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkFlagContractsForRepossessionMutation(baseOptions?: Apollo.MutationHookOptions<BulkFlagContractsForRepossessionMutation, BulkFlagContractsForRepossessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkFlagContractsForRepossessionMutation, BulkFlagContractsForRepossessionMutationVariables>(BulkFlagContractsForRepossessionDocument, options);
      }
export type BulkFlagContractsForRepossessionMutationHookResult = ReturnType<typeof useBulkFlagContractsForRepossessionMutation>;
export type BulkFlagContractsForRepossessionMutationResult = Apollo.MutationResult<BulkFlagContractsForRepossessionMutation>;
export type BulkFlagContractsForRepossessionMutationOptions = Apollo.BaseMutationOptions<BulkFlagContractsForRepossessionMutation, BulkFlagContractsForRepossessionMutationVariables>;
export const GetCustomersDocument = gql`
    query GetCustomers($input: CustomerSearchInput) {
  customers(input: $input) {
    items {
      id
      customerNumber
      firstName
      lastName
      fullName
      idNumber
      phone
      email
      status
      createdAt
      isMigrated
      primarySource
      distributorName
      nationalSalesManagerName
    }
    totalCount
  }
}
    `;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
// @ts-ignore
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersQuery | undefined, GetCustomersQueryVariables>;
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const ExportCustomersDocument = gql`
    query ExportCustomers($input: CustomerSearchInput) {
  exportCustomers(input: $input) {
    items {
      firstName
      lastName
      idNumber
      dateOfBirth
      gender
      phone
      email
      employer
      income
      employmentStatus
      identificationType
      secondaryPhone
      occupation
      currentSourceOfLight
      secondaryContactFirstName
      secondaryContactLastName
      secondaryContactPhone
      address {
        streetAddress
        addressLine1
        addressLine2
        addressLevel1
        addressLevel2
        addressLevel3
        addressLevel4
        postalCode
        country
        countryName
      }
      status
      createdAt
      distributorName
      nationalSalesManagerName
    }
    totalCount
  }
}
    `;

/**
 * __useExportCustomersQuery__
 *
 * To run a query within a React component, call `useExportCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCustomersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportCustomersQuery(baseOptions?: Apollo.QueryHookOptions<ExportCustomersQuery, ExportCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCustomersQuery, ExportCustomersQueryVariables>(ExportCustomersDocument, options);
      }
export function useExportCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCustomersQuery, ExportCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCustomersQuery, ExportCustomersQueryVariables>(ExportCustomersDocument, options);
        }
// @ts-ignore
export function useExportCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportCustomersQuery, ExportCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCustomersQuery, ExportCustomersQueryVariables>;
export function useExportCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCustomersQuery, ExportCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCustomersQuery | undefined, ExportCustomersQueryVariables>;
export function useExportCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCustomersQuery, ExportCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportCustomersQuery, ExportCustomersQueryVariables>(ExportCustomersDocument, options);
        }
export type ExportCustomersQueryHookResult = ReturnType<typeof useExportCustomersQuery>;
export type ExportCustomersLazyQueryHookResult = ReturnType<typeof useExportCustomersLazyQuery>;
export type ExportCustomersSuspenseQueryHookResult = ReturnType<typeof useExportCustomersSuspenseQuery>;
export type ExportCustomersQueryResult = Apollo.QueryResult<ExportCustomersQuery, ExportCustomersQueryVariables>;
export const GetCustomerStatusCountsDocument = gql`
    query GetCustomerStatusCounts($mine: Boolean) {
  customerStatusCounts(mine: $mine) {
    status
    count
  }
}
    `;

/**
 * __useGetCustomerStatusCountsQuery__
 *
 * To run a query within a React component, call `useGetCustomerStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerStatusCountsQuery({
 *   variables: {
 *      mine: // value for 'mine'
 *   },
 * });
 */
export function useGetCustomerStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>(GetCustomerStatusCountsDocument, options);
      }
export function useGetCustomerStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>(GetCustomerStatusCountsDocument, options);
        }
// @ts-ignore
export function useGetCustomerStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>;
export function useGetCustomerStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerStatusCountsQuery | undefined, GetCustomerStatusCountsQueryVariables>;
export function useGetCustomerStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>(GetCustomerStatusCountsDocument, options);
        }
export type GetCustomerStatusCountsQueryHookResult = ReturnType<typeof useGetCustomerStatusCountsQuery>;
export type GetCustomerStatusCountsLazyQueryHookResult = ReturnType<typeof useGetCustomerStatusCountsLazyQuery>;
export type GetCustomerStatusCountsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerStatusCountsSuspenseQuery>;
export type GetCustomerStatusCountsQueryResult = Apollo.QueryResult<GetCustomerStatusCountsQuery, GetCustomerStatusCountsQueryVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($id: String!) {
  customer(id: $id) {
    id
    customerNumber
    firstName
    lastName
    fullName
    idNumber
    dateOfBirth
    gender
    phone
    email
    employer
    income
    employmentStatus
    identificationType
    secondaryPhone
    occupation
    currentSourceOfLight
    secondaryContactFirstName
    secondaryContactLastName
    secondaryContactPhone
    xeroContactId
    address {
      id
      streetAddress
      addressLine1
      addressLine2
      addressLevel1
      addressLevel2
      addressLevel3
      addressLevel4
      postalCode
      country
      countryName
    }
    primarySource
    sourceSystemIds
    externalId
    isMigrated
    registrationDate
    gpsLatitude
    gpsLongitude
    status
    deactivatedAt
    archivedAt
    archivedReason
    createdAt
    updatedAt
    createdBy {
      id
      firstName
      lastName
    }
    deactivatedBy {
      id
      firstName
      lastName
    }
    changeHistory {
      id
      fieldName
      oldValue
      newValue
      changeType
      createdAt
      changedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
// @ts-ignore
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerQuery | undefined, GetCustomerQueryVariables>;
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const CheckDuplicateCustomerDocument = gql`
    query CheckDuplicateCustomer($input: CheckDuplicateCustomerInput!) {
  checkDuplicateCustomer(input: $input) {
    hasDuplicates
    hardConflicts {
      id
      firstName
      lastName
      idNumber
      phone
      email
      status
      matchedOn
    }
    softConflicts {
      id
      firstName
      lastName
      idNumber
      phone
      email
      status
      matchedOn
    }
  }
}
    `;

/**
 * __useCheckDuplicateCustomerQuery__
 *
 * To run a query within a React component, call `useCheckDuplicateCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDuplicateCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDuplicateCustomerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckDuplicateCustomerQuery(baseOptions: Apollo.QueryHookOptions<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables> & ({ variables: CheckDuplicateCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>(CheckDuplicateCustomerDocument, options);
      }
export function useCheckDuplicateCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>(CheckDuplicateCustomerDocument, options);
        }
// @ts-ignore
export function useCheckDuplicateCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>;
export function useCheckDuplicateCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>): Apollo.UseSuspenseQueryResult<CheckDuplicateCustomerQuery | undefined, CheckDuplicateCustomerQueryVariables>;
export function useCheckDuplicateCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>(CheckDuplicateCustomerDocument, options);
        }
export type CheckDuplicateCustomerQueryHookResult = ReturnType<typeof useCheckDuplicateCustomerQuery>;
export type CheckDuplicateCustomerLazyQueryHookResult = ReturnType<typeof useCheckDuplicateCustomerLazyQuery>;
export type CheckDuplicateCustomerSuspenseQueryHookResult = ReturnType<typeof useCheckDuplicateCustomerSuspenseQuery>;
export type CheckDuplicateCustomerQueryResult = Apollo.QueryResult<CheckDuplicateCustomerQuery, CheckDuplicateCustomerQueryVariables>;
export const CustomerStatementsDocument = gql`
    query CustomerStatements($customerId: String!) {
  customerStatements(customerId: $customerId) {
    id
    number
    issuedAt
    periodFrom
    periodTo
    totalBalance
    contractCount
    issuedByName
  }
}
    `;

/**
 * __useCustomerStatementsQuery__
 *
 * To run a query within a React component, call `useCustomerStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerStatementsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerStatementsQuery(baseOptions: Apollo.QueryHookOptions<CustomerStatementsQuery, CustomerStatementsQueryVariables> & ({ variables: CustomerStatementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerStatementsQuery, CustomerStatementsQueryVariables>(CustomerStatementsDocument, options);
      }
export function useCustomerStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerStatementsQuery, CustomerStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerStatementsQuery, CustomerStatementsQueryVariables>(CustomerStatementsDocument, options);
        }
// @ts-ignore
export function useCustomerStatementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerStatementsQuery, CustomerStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerStatementsQuery, CustomerStatementsQueryVariables>;
export function useCustomerStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerStatementsQuery, CustomerStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerStatementsQuery | undefined, CustomerStatementsQueryVariables>;
export function useCustomerStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerStatementsQuery, CustomerStatementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerStatementsQuery, CustomerStatementsQueryVariables>(CustomerStatementsDocument, options);
        }
export type CustomerStatementsQueryHookResult = ReturnType<typeof useCustomerStatementsQuery>;
export type CustomerStatementsLazyQueryHookResult = ReturnType<typeof useCustomerStatementsLazyQuery>;
export type CustomerStatementsSuspenseQueryHookResult = ReturnType<typeof useCustomerStatementsSuspenseQuery>;
export type CustomerStatementsQueryResult = Apollo.QueryResult<CustomerStatementsQuery, CustomerStatementsQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    id
    firstName
    lastName
    fullName
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($id: String!, $input: UpdateCustomerInput!) {
  updateCustomer(id: $id, input: $input) {
    id
    firstName
    lastName
    fullName
    idNumber
    dateOfBirth
    gender
    phone
    email
    employer
    income
    employmentStatus
    identificationType
    secondaryPhone
    occupation
    currentSourceOfLight
    secondaryContactFirstName
    secondaryContactLastName
    secondaryContactPhone
    address {
      id
      streetAddress
      addressLine1
      addressLine2
      addressLevel1
      addressLevel2
      addressLevel3
      addressLevel4
      postalCode
      country
      countryName
    }
    primarySource
    sourceSystemIds
    externalId
    isMigrated
    registrationDate
    gpsLatitude
    gpsLongitude
    status
    deactivatedAt
    archivedAt
    archivedReason
    createdAt
    updatedAt
    createdBy {
      id
      firstName
      lastName
    }
    deactivatedBy {
      id
      firstName
      lastName
    }
    changeHistory {
      id
      fieldName
      oldValue
      newValue
      changeType
      createdAt
      changedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DeactivateCustomerDocument = gql`
    mutation DeactivateCustomer($id: String!) {
  deactivateCustomer(id: $id) {
    success
    message
  }
}
    `;
export type DeactivateCustomerMutationFn = Apollo.MutationFunction<DeactivateCustomerMutation, DeactivateCustomerMutationVariables>;

/**
 * __useDeactivateCustomerMutation__
 *
 * To run a mutation, you first call `useDeactivateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCustomerMutation, { data, loading, error }] = useDeactivateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateCustomerMutation, DeactivateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateCustomerMutation, DeactivateCustomerMutationVariables>(DeactivateCustomerDocument, options);
      }
export type DeactivateCustomerMutationHookResult = ReturnType<typeof useDeactivateCustomerMutation>;
export type DeactivateCustomerMutationResult = Apollo.MutationResult<DeactivateCustomerMutation>;
export type DeactivateCustomerMutationOptions = Apollo.BaseMutationOptions<DeactivateCustomerMutation, DeactivateCustomerMutationVariables>;
export const ReactivateCustomerDocument = gql`
    mutation ReactivateCustomer($id: String!) {
  reactivateCustomer(id: $id) {
    success
    message
  }
}
    `;
export type ReactivateCustomerMutationFn = Apollo.MutationFunction<ReactivateCustomerMutation, ReactivateCustomerMutationVariables>;

/**
 * __useReactivateCustomerMutation__
 *
 * To run a mutation, you first call `useReactivateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateCustomerMutation, { data, loading, error }] = useReactivateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateCustomerMutation, ReactivateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateCustomerMutation, ReactivateCustomerMutationVariables>(ReactivateCustomerDocument, options);
      }
export type ReactivateCustomerMutationHookResult = ReturnType<typeof useReactivateCustomerMutation>;
export type ReactivateCustomerMutationResult = Apollo.MutationResult<ReactivateCustomerMutation>;
export type ReactivateCustomerMutationOptions = Apollo.BaseMutationOptions<ReactivateCustomerMutation, ReactivateCustomerMutationVariables>;
export const ArchiveCustomerDocument = gql`
    mutation ArchiveCustomer($id: String!, $reason: String!) {
  archiveCustomer(id: $id, reason: $reason) {
    success
    message
  }
}
    `;
export type ArchiveCustomerMutationFn = Apollo.MutationFunction<ArchiveCustomerMutation, ArchiveCustomerMutationVariables>;

/**
 * __useArchiveCustomerMutation__
 *
 * To run a mutation, you first call `useArchiveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomerMutation, { data, loading, error }] = useArchiveCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCustomerMutation, ArchiveCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCustomerMutation, ArchiveCustomerMutationVariables>(ArchiveCustomerDocument, options);
      }
export type ArchiveCustomerMutationHookResult = ReturnType<typeof useArchiveCustomerMutation>;
export type ArchiveCustomerMutationResult = Apollo.MutationResult<ArchiveCustomerMutation>;
export type ArchiveCustomerMutationOptions = Apollo.BaseMutationOptions<ArchiveCustomerMutation, ArchiveCustomerMutationVariables>;
export const RestoreCustomerDocument = gql`
    mutation RestoreCustomer($id: String!) {
  restoreCustomer(id: $id) {
    success
    message
  }
}
    `;
export type RestoreCustomerMutationFn = Apollo.MutationFunction<RestoreCustomerMutation, RestoreCustomerMutationVariables>;

/**
 * __useRestoreCustomerMutation__
 *
 * To run a mutation, you first call `useRestoreCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCustomerMutation, { data, loading, error }] = useRestoreCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCustomerMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCustomerMutation, RestoreCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCustomerMutation, RestoreCustomerMutationVariables>(RestoreCustomerDocument, options);
      }
export type RestoreCustomerMutationHookResult = ReturnType<typeof useRestoreCustomerMutation>;
export type RestoreCustomerMutationResult = Apollo.MutationResult<RestoreCustomerMutation>;
export type RestoreCustomerMutationOptions = Apollo.BaseMutationOptions<RestoreCustomerMutation, RestoreCustomerMutationVariables>;
export const ActivateCustomerDocument = gql`
    mutation ActivateCustomer($id: String!) {
  activateCustomer(id: $id) {
    success
    message
  }
}
    `;
export type ActivateCustomerMutationFn = Apollo.MutationFunction<ActivateCustomerMutation, ActivateCustomerMutationVariables>;

/**
 * __useActivateCustomerMutation__
 *
 * To run a mutation, you first call `useActivateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCustomerMutation, { data, loading, error }] = useActivateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ActivateCustomerMutation, ActivateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateCustomerMutation, ActivateCustomerMutationVariables>(ActivateCustomerDocument, options);
      }
export type ActivateCustomerMutationHookResult = ReturnType<typeof useActivateCustomerMutation>;
export type ActivateCustomerMutationResult = Apollo.MutationResult<ActivateCustomerMutation>;
export type ActivateCustomerMutationOptions = Apollo.BaseMutationOptions<ActivateCustomerMutation, ActivateCustomerMutationVariables>;
export const SuspendCustomerDocument = gql`
    mutation SuspendCustomer($id: String!) {
  suspendCustomer(id: $id) {
    success
    message
  }
}
    `;
export type SuspendCustomerMutationFn = Apollo.MutationFunction<SuspendCustomerMutation, SuspendCustomerMutationVariables>;

/**
 * __useSuspendCustomerMutation__
 *
 * To run a mutation, you first call `useSuspendCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendCustomerMutation, { data, loading, error }] = useSuspendCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuspendCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SuspendCustomerMutation, SuspendCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendCustomerMutation, SuspendCustomerMutationVariables>(SuspendCustomerDocument, options);
      }
export type SuspendCustomerMutationHookResult = ReturnType<typeof useSuspendCustomerMutation>;
export type SuspendCustomerMutationResult = Apollo.MutationResult<SuspendCustomerMutation>;
export type SuspendCustomerMutationOptions = Apollo.BaseMutationOptions<SuspendCustomerMutation, SuspendCustomerMutationVariables>;
export const MarkCustomerDelinquentDocument = gql`
    mutation MarkCustomerDelinquent($id: String!) {
  markCustomerDelinquent(id: $id) {
    success
    message
  }
}
    `;
export type MarkCustomerDelinquentMutationFn = Apollo.MutationFunction<MarkCustomerDelinquentMutation, MarkCustomerDelinquentMutationVariables>;

/**
 * __useMarkCustomerDelinquentMutation__
 *
 * To run a mutation, you first call `useMarkCustomerDelinquentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCustomerDelinquentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCustomerDelinquentMutation, { data, loading, error }] = useMarkCustomerDelinquentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkCustomerDelinquentMutation(baseOptions?: Apollo.MutationHookOptions<MarkCustomerDelinquentMutation, MarkCustomerDelinquentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCustomerDelinquentMutation, MarkCustomerDelinquentMutationVariables>(MarkCustomerDelinquentDocument, options);
      }
export type MarkCustomerDelinquentMutationHookResult = ReturnType<typeof useMarkCustomerDelinquentMutation>;
export type MarkCustomerDelinquentMutationResult = Apollo.MutationResult<MarkCustomerDelinquentMutation>;
export type MarkCustomerDelinquentMutationOptions = Apollo.BaseMutationOptions<MarkCustomerDelinquentMutation, MarkCustomerDelinquentMutationVariables>;
export const LogRedactedFieldAccessDocument = gql`
    mutation LogRedactedFieldAccess($customerId: String!, $fieldName: String!) {
  logRedactedFieldAccess(customerId: $customerId, fieldName: $fieldName) {
    success
    message
  }
}
    `;
export type LogRedactedFieldAccessMutationFn = Apollo.MutationFunction<LogRedactedFieldAccessMutation, LogRedactedFieldAccessMutationVariables>;

/**
 * __useLogRedactedFieldAccessMutation__
 *
 * To run a mutation, you first call `useLogRedactedFieldAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogRedactedFieldAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logRedactedFieldAccessMutation, { data, loading, error }] = useLogRedactedFieldAccessMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      fieldName: // value for 'fieldName'
 *   },
 * });
 */
export function useLogRedactedFieldAccessMutation(baseOptions?: Apollo.MutationHookOptions<LogRedactedFieldAccessMutation, LogRedactedFieldAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogRedactedFieldAccessMutation, LogRedactedFieldAccessMutationVariables>(LogRedactedFieldAccessDocument, options);
      }
export type LogRedactedFieldAccessMutationHookResult = ReturnType<typeof useLogRedactedFieldAccessMutation>;
export type LogRedactedFieldAccessMutationResult = Apollo.MutationResult<LogRedactedFieldAccessMutation>;
export type LogRedactedFieldAccessMutationOptions = Apollo.BaseMutationOptions<LogRedactedFieldAccessMutation, LogRedactedFieldAccessMutationVariables>;
export const GetDelinquencyPolicyDocument = gql`
    query GetDelinquencyPolicy {
  delinquencyPolicy {
    tier1Days
    tier2Days
    tier3Days
    writeOffThresholdDays
    repossessionThresholdDays
    updatedAt
  }
}
    `;

/**
 * __useGetDelinquencyPolicyQuery__
 *
 * To run a query within a React component, call `useGetDelinquencyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDelinquencyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDelinquencyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDelinquencyPolicyQuery(baseOptions?: Apollo.QueryHookOptions<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>(GetDelinquencyPolicyDocument, options);
      }
export function useGetDelinquencyPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>(GetDelinquencyPolicyDocument, options);
        }
// @ts-ignore
export function useGetDelinquencyPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>;
export function useGetDelinquencyPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetDelinquencyPolicyQuery | undefined, GetDelinquencyPolicyQueryVariables>;
export function useGetDelinquencyPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>(GetDelinquencyPolicyDocument, options);
        }
export type GetDelinquencyPolicyQueryHookResult = ReturnType<typeof useGetDelinquencyPolicyQuery>;
export type GetDelinquencyPolicyLazyQueryHookResult = ReturnType<typeof useGetDelinquencyPolicyLazyQuery>;
export type GetDelinquencyPolicySuspenseQueryHookResult = ReturnType<typeof useGetDelinquencyPolicySuspenseQuery>;
export type GetDelinquencyPolicyQueryResult = Apollo.QueryResult<GetDelinquencyPolicyQuery, GetDelinquencyPolicyQueryVariables>;
export const UpdateDelinquencyPolicyDocument = gql`
    mutation UpdateDelinquencyPolicy($input: UpdateDelinquencyPolicyInput!) {
  updateDelinquencyPolicy(input: $input) {
    tier1Days
    tier2Days
    tier3Days
    writeOffThresholdDays
    repossessionThresholdDays
    updatedAt
  }
}
    `;
export type UpdateDelinquencyPolicyMutationFn = Apollo.MutationFunction<UpdateDelinquencyPolicyMutation, UpdateDelinquencyPolicyMutationVariables>;

/**
 * __useUpdateDelinquencyPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateDelinquencyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDelinquencyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDelinquencyPolicyMutation, { data, loading, error }] = useUpdateDelinquencyPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDelinquencyPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDelinquencyPolicyMutation, UpdateDelinquencyPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDelinquencyPolicyMutation, UpdateDelinquencyPolicyMutationVariables>(UpdateDelinquencyPolicyDocument, options);
      }
export type UpdateDelinquencyPolicyMutationHookResult = ReturnType<typeof useUpdateDelinquencyPolicyMutation>;
export type UpdateDelinquencyPolicyMutationResult = Apollo.MutationResult<UpdateDelinquencyPolicyMutation>;
export type UpdateDelinquencyPolicyMutationOptions = Apollo.BaseMutationOptions<UpdateDelinquencyPolicyMutation, UpdateDelinquencyPolicyMutationVariables>;
export const GetDepartmentsDocument = gql`
    query GetDepartments {
  departments {
    id
    name
    createdAt
    userDepartments {
      id
      user {
        id
        email
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
      }
export function useGetDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
        }
// @ts-ignore
export function useGetDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export function useGetDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDepartmentsQuery | undefined, GetDepartmentsQueryVariables>;
export function useGetDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
        }
export type GetDepartmentsQueryHookResult = ReturnType<typeof useGetDepartmentsQuery>;
export type GetDepartmentsLazyQueryHookResult = ReturnType<typeof useGetDepartmentsLazyQuery>;
export type GetDepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetDepartmentsSuspenseQuery>;
export type GetDepartmentsQueryResult = Apollo.QueryResult<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export const GetDepartmentDocument = gql`
    query GetDepartment($id: String!) {
  department(id: $id) {
    id
    name
    createdAt
    updatedAt
    userDepartments {
      id
      user {
        id
        email
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetDepartmentQuery__
 *
 * To run a query within a React component, call `useGetDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDepartmentQuery(baseOptions: Apollo.QueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables> & ({ variables: GetDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
      }
export function useGetDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
        }
// @ts-ignore
export function useGetDepartmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDepartmentQuery, GetDepartmentQueryVariables>;
export function useGetDepartmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDepartmentQuery | undefined, GetDepartmentQueryVariables>;
export function useGetDepartmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepartmentQuery, GetDepartmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDepartmentQuery, GetDepartmentQueryVariables>(GetDepartmentDocument, options);
        }
export type GetDepartmentQueryHookResult = ReturnType<typeof useGetDepartmentQuery>;
export type GetDepartmentLazyQueryHookResult = ReturnType<typeof useGetDepartmentLazyQuery>;
export type GetDepartmentSuspenseQueryHookResult = ReturnType<typeof useGetDepartmentSuspenseQuery>;
export type GetDepartmentQueryResult = Apollo.QueryResult<GetDepartmentQuery, GetDepartmentQueryVariables>;
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($input: CreateDepartmentInput!) {
  createDepartment(input: $input) {
    id
    name
  }
}
    `;
export type CreateDepartmentMutationFn = Apollo.MutationFunction<CreateDepartmentMutation, CreateDepartmentMutationVariables>;

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentMutation, { data, loading, error }] = useCreateDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, options);
      }
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>;
export type CreateDepartmentMutationResult = Apollo.MutationResult<CreateDepartmentMutation>;
export type CreateDepartmentMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($id: String!, $input: UpdateDepartmentInput!) {
  updateDepartment(id: $id, input: $input) {
    id
    name
  }
}
    `;
export type UpdateDepartmentMutationFn = Apollo.MutationFunction<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, options);
      }
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = Apollo.MutationResult<UpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($id: String!) {
  deleteDepartment(id: $id) {
    success
    message
  }
}
    `;
export type DeleteDepartmentMutationFn = Apollo.MutationFunction<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;

/**
 * __useDeleteDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepartmentMutation, { data, loading, error }] = useDeleteDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, options);
      }
export type DeleteDepartmentMutationHookResult = ReturnType<typeof useDeleteDepartmentMutation>;
export type DeleteDepartmentMutationResult = Apollo.MutationResult<DeleteDepartmentMutation>;
export type DeleteDepartmentMutationOptions = Apollo.BaseMutationOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;
export const AssignUserToDepartmentDocument = gql`
    mutation AssignUserToDepartment($userId: String!, $departmentId: String!) {
  assignUserToDepartment(userId: $userId, departmentId: $departmentId) {
    success
    message
  }
}
    `;
export type AssignUserToDepartmentMutationFn = Apollo.MutationFunction<AssignUserToDepartmentMutation, AssignUserToDepartmentMutationVariables>;

/**
 * __useAssignUserToDepartmentMutation__
 *
 * To run a mutation, you first call `useAssignUserToDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserToDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUserToDepartmentMutation, { data, loading, error }] = useAssignUserToDepartmentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useAssignUserToDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<AssignUserToDepartmentMutation, AssignUserToDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUserToDepartmentMutation, AssignUserToDepartmentMutationVariables>(AssignUserToDepartmentDocument, options);
      }
export type AssignUserToDepartmentMutationHookResult = ReturnType<typeof useAssignUserToDepartmentMutation>;
export type AssignUserToDepartmentMutationResult = Apollo.MutationResult<AssignUserToDepartmentMutation>;
export type AssignUserToDepartmentMutationOptions = Apollo.BaseMutationOptions<AssignUserToDepartmentMutation, AssignUserToDepartmentMutationVariables>;
export const RemoveUserFromDepartmentDocument = gql`
    mutation RemoveUserFromDepartment($userId: String!, $departmentId: String!) {
  removeUserFromDepartment(userId: $userId, departmentId: $departmentId) {
    success
    message
  }
}
    `;
export type RemoveUserFromDepartmentMutationFn = Apollo.MutationFunction<RemoveUserFromDepartmentMutation, RemoveUserFromDepartmentMutationVariables>;

/**
 * __useRemoveUserFromDepartmentMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromDepartmentMutation, { data, loading, error }] = useRemoveUserFromDepartmentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useRemoveUserFromDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromDepartmentMutation, RemoveUserFromDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromDepartmentMutation, RemoveUserFromDepartmentMutationVariables>(RemoveUserFromDepartmentDocument, options);
      }
export type RemoveUserFromDepartmentMutationHookResult = ReturnType<typeof useRemoveUserFromDepartmentMutation>;
export type RemoveUserFromDepartmentMutationResult = Apollo.MutationResult<RemoveUserFromDepartmentMutation>;
export type RemoveUserFromDepartmentMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromDepartmentMutation, RemoveUserFromDepartmentMutationVariables>;
export const SetDepartmentAdminDocument = gql`
    mutation SetDepartmentAdmin($userId: String!, $departmentId: String!, $isAdmin: Boolean!) {
  setDepartmentAdmin(
    userId: $userId
    departmentId: $departmentId
    isAdmin: $isAdmin
  ) {
    success
    message
  }
}
    `;
export type SetDepartmentAdminMutationFn = Apollo.MutationFunction<SetDepartmentAdminMutation, SetDepartmentAdminMutationVariables>;

/**
 * __useSetDepartmentAdminMutation__
 *
 * To run a mutation, you first call `useSetDepartmentAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDepartmentAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDepartmentAdminMutation, { data, loading, error }] = useSetDepartmentAdminMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      departmentId: // value for 'departmentId'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useSetDepartmentAdminMutation(baseOptions?: Apollo.MutationHookOptions<SetDepartmentAdminMutation, SetDepartmentAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDepartmentAdminMutation, SetDepartmentAdminMutationVariables>(SetDepartmentAdminDocument, options);
      }
export type SetDepartmentAdminMutationHookResult = ReturnType<typeof useSetDepartmentAdminMutation>;
export type SetDepartmentAdminMutationResult = Apollo.MutationResult<SetDepartmentAdminMutation>;
export type SetDepartmentAdminMutationOptions = Apollo.BaseMutationOptions<SetDepartmentAdminMutation, SetDepartmentAdminMutationVariables>;
export const ResolveCorrectDeviceDocument = gql`
    query ResolveCorrectDevice($contractId: String!, $identifier: String!, $stockSaleId: String) {
  resolveCorrectDevice(
    contractId: $contractId
    identifier: $identifier
    stockSaleId: $stockSaleId
  ) {
    valid
    kind
    error
    stockItemId
    serialNumber
    accountNumber
    productName
    otherContractId
    otherContractNumber
    otherCustomerName
    otherStockSaleId
    tokenDaysShortfall
    otherTokenDaysShortfall
    warnings {
      code
      detail
    }
  }
}
    `;

/**
 * __useResolveCorrectDeviceQuery__
 *
 * To run a query within a React component, call `useResolveCorrectDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveCorrectDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveCorrectDeviceQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      identifier: // value for 'identifier'
 *      stockSaleId: // value for 'stockSaleId'
 *   },
 * });
 */
export function useResolveCorrectDeviceQuery(baseOptions: Apollo.QueryHookOptions<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables> & ({ variables: ResolveCorrectDeviceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>(ResolveCorrectDeviceDocument, options);
      }
export function useResolveCorrectDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>(ResolveCorrectDeviceDocument, options);
        }
// @ts-ignore
export function useResolveCorrectDeviceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>;
export function useResolveCorrectDeviceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveCorrectDeviceQuery | undefined, ResolveCorrectDeviceQueryVariables>;
export function useResolveCorrectDeviceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>(ResolveCorrectDeviceDocument, options);
        }
export type ResolveCorrectDeviceQueryHookResult = ReturnType<typeof useResolveCorrectDeviceQuery>;
export type ResolveCorrectDeviceLazyQueryHookResult = ReturnType<typeof useResolveCorrectDeviceLazyQuery>;
export type ResolveCorrectDeviceSuspenseQueryHookResult = ReturnType<typeof useResolveCorrectDeviceSuspenseQuery>;
export type ResolveCorrectDeviceQueryResult = Apollo.QueryResult<ResolveCorrectDeviceQuery, ResolveCorrectDeviceQueryVariables>;
export const ContractDeviceHistoryDocument = gql`
    query ContractDeviceHistory($contractId: String!) {
  contractDeviceHistory(contractId: $contractId) {
    ...DeviceReassignmentFields
  }
}
    ${DeviceReassignmentFieldsFragmentDoc}`;

/**
 * __useContractDeviceHistoryQuery__
 *
 * To run a query within a React component, call `useContractDeviceHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDeviceHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDeviceHistoryQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractDeviceHistoryQuery(baseOptions: Apollo.QueryHookOptions<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables> & ({ variables: ContractDeviceHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>(ContractDeviceHistoryDocument, options);
      }
export function useContractDeviceHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>(ContractDeviceHistoryDocument, options);
        }
// @ts-ignore
export function useContractDeviceHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>;
export function useContractDeviceHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<ContractDeviceHistoryQuery | undefined, ContractDeviceHistoryQueryVariables>;
export function useContractDeviceHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>(ContractDeviceHistoryDocument, options);
        }
export type ContractDeviceHistoryQueryHookResult = ReturnType<typeof useContractDeviceHistoryQuery>;
export type ContractDeviceHistoryLazyQueryHookResult = ReturnType<typeof useContractDeviceHistoryLazyQuery>;
export type ContractDeviceHistorySuspenseQueryHookResult = ReturnType<typeof useContractDeviceHistorySuspenseQuery>;
export type ContractDeviceHistoryQueryResult = Apollo.QueryResult<ContractDeviceHistoryQuery, ContractDeviceHistoryQueryVariables>;
export const ReassignContractDeviceDocument = gql`
    mutation ReassignContractDevice($input: ReassignContractDeviceInput!) {
  reassignContractDevice(input: $input) {
    ...DeviceReassignmentFields
  }
}
    ${DeviceReassignmentFieldsFragmentDoc}`;
export type ReassignContractDeviceMutationFn = Apollo.MutationFunction<ReassignContractDeviceMutation, ReassignContractDeviceMutationVariables>;

/**
 * __useReassignContractDeviceMutation__
 *
 * To run a mutation, you first call `useReassignContractDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignContractDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignContractDeviceMutation, { data, loading, error }] = useReassignContractDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignContractDeviceMutation(baseOptions?: Apollo.MutationHookOptions<ReassignContractDeviceMutation, ReassignContractDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignContractDeviceMutation, ReassignContractDeviceMutationVariables>(ReassignContractDeviceDocument, options);
      }
export type ReassignContractDeviceMutationHookResult = ReturnType<typeof useReassignContractDeviceMutation>;
export type ReassignContractDeviceMutationResult = Apollo.MutationResult<ReassignContractDeviceMutation>;
export type ReassignContractDeviceMutationOptions = Apollo.BaseMutationOptions<ReassignContractDeviceMutation, ReassignContractDeviceMutationVariables>;
export const SwapContractDevicesDocument = gql`
    mutation SwapContractDevices($input: SwapContractDevicesInput!) {
  swapContractDevices(input: $input) {
    ...DeviceReassignmentFields
  }
}
    ${DeviceReassignmentFieldsFragmentDoc}`;
export type SwapContractDevicesMutationFn = Apollo.MutationFunction<SwapContractDevicesMutation, SwapContractDevicesMutationVariables>;

/**
 * __useSwapContractDevicesMutation__
 *
 * To run a mutation, you first call `useSwapContractDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapContractDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapContractDevicesMutation, { data, loading, error }] = useSwapContractDevicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwapContractDevicesMutation(baseOptions?: Apollo.MutationHookOptions<SwapContractDevicesMutation, SwapContractDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwapContractDevicesMutation, SwapContractDevicesMutationVariables>(SwapContractDevicesDocument, options);
      }
export type SwapContractDevicesMutationHookResult = ReturnType<typeof useSwapContractDevicesMutation>;
export type SwapContractDevicesMutationResult = Apollo.MutationResult<SwapContractDevicesMutation>;
export type SwapContractDevicesMutationOptions = Apollo.BaseMutationOptions<SwapContractDevicesMutation, SwapContractDevicesMutationVariables>;
export const GetDeviceTypesDocument = gql`
    query GetDeviceTypes {
  deviceTypes {
    id
    name
    isSystem
    sortOrder
    defaultMeterTypeId
    defaultMeterType {
      id
      name
    }
    fields {
      id
      field
      requirement
    }
  }
}
    `;

/**
 * __useGetDeviceTypesQuery__
 *
 * To run a query within a React component, call `useGetDeviceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeviceTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>(GetDeviceTypesDocument, options);
      }
export function useGetDeviceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>(GetDeviceTypesDocument, options);
        }
// @ts-ignore
export function useGetDeviceTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>;
export function useGetDeviceTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeviceTypesQuery | undefined, GetDeviceTypesQueryVariables>;
export function useGetDeviceTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>(GetDeviceTypesDocument, options);
        }
export type GetDeviceTypesQueryHookResult = ReturnType<typeof useGetDeviceTypesQuery>;
export type GetDeviceTypesLazyQueryHookResult = ReturnType<typeof useGetDeviceTypesLazyQuery>;
export type GetDeviceTypesSuspenseQueryHookResult = ReturnType<typeof useGetDeviceTypesSuspenseQuery>;
export type GetDeviceTypesQueryResult = Apollo.QueryResult<GetDeviceTypesQuery, GetDeviceTypesQueryVariables>;
export const CreateDeviceTypeDocument = gql`
    mutation CreateDeviceType($input: CreateDeviceTypeInput!) {
  createDeviceType(input: $input) {
    id
    name
    isSystem
    sortOrder
    defaultMeterTypeId
    defaultMeterType {
      id
      name
    }
    fields {
      id
      field
      requirement
    }
  }
}
    `;
export type CreateDeviceTypeMutationFn = Apollo.MutationFunction<CreateDeviceTypeMutation, CreateDeviceTypeMutationVariables>;

/**
 * __useCreateDeviceTypeMutation__
 *
 * To run a mutation, you first call `useCreateDeviceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceTypeMutation, { data, loading, error }] = useCreateDeviceTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviceTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceTypeMutation, CreateDeviceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceTypeMutation, CreateDeviceTypeMutationVariables>(CreateDeviceTypeDocument, options);
      }
export type CreateDeviceTypeMutationHookResult = ReturnType<typeof useCreateDeviceTypeMutation>;
export type CreateDeviceTypeMutationResult = Apollo.MutationResult<CreateDeviceTypeMutation>;
export type CreateDeviceTypeMutationOptions = Apollo.BaseMutationOptions<CreateDeviceTypeMutation, CreateDeviceTypeMutationVariables>;
export const UpdateDeviceTypeDocument = gql`
    mutation UpdateDeviceType($id: String!, $input: UpdateDeviceTypeInput!) {
  updateDeviceType(id: $id, input: $input) {
    id
    name
    isSystem
    sortOrder
    defaultMeterTypeId
    defaultMeterType {
      id
      name
    }
    fields {
      id
      field
      requirement
    }
  }
}
    `;
export type UpdateDeviceTypeMutationFn = Apollo.MutationFunction<UpdateDeviceTypeMutation, UpdateDeviceTypeMutationVariables>;

/**
 * __useUpdateDeviceTypeMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceTypeMutation, { data, loading, error }] = useUpdateDeviceTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeviceTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceTypeMutation, UpdateDeviceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceTypeMutation, UpdateDeviceTypeMutationVariables>(UpdateDeviceTypeDocument, options);
      }
export type UpdateDeviceTypeMutationHookResult = ReturnType<typeof useUpdateDeviceTypeMutation>;
export type UpdateDeviceTypeMutationResult = Apollo.MutationResult<UpdateDeviceTypeMutation>;
export type UpdateDeviceTypeMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceTypeMutation, UpdateDeviceTypeMutationVariables>;
export const DeleteDeviceTypeDocument = gql`
    mutation DeleteDeviceType($id: String!) {
  deleteDeviceType(id: $id) {
    id
    name
  }
}
    `;
export type DeleteDeviceTypeMutationFn = Apollo.MutationFunction<DeleteDeviceTypeMutation, DeleteDeviceTypeMutationVariables>;

/**
 * __useDeleteDeviceTypeMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceTypeMutation, { data, loading, error }] = useDeleteDeviceTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceTypeMutation, DeleteDeviceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceTypeMutation, DeleteDeviceTypeMutationVariables>(DeleteDeviceTypeDocument, options);
      }
export type DeleteDeviceTypeMutationHookResult = ReturnType<typeof useDeleteDeviceTypeMutation>;
export type DeleteDeviceTypeMutationResult = Apollo.MutationResult<DeleteDeviceTypeMutation>;
export type DeleteDeviceTypeMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceTypeMutation, DeleteDeviceTypeMutationVariables>;
export const GetDigitalChannelsDocument = gql`
    query GetDigitalChannels($includeInactive: Boolean) {
  digitalChannels(includeInactive: $includeInactive) {
    ...DigitalChannelFields
  }
}
    ${DigitalChannelFieldsFragmentDoc}`;

/**
 * __useGetDigitalChannelsQuery__
 *
 * To run a query within a React component, call `useGetDigitalChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalChannelsQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetDigitalChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>(GetDigitalChannelsDocument, options);
      }
export function useGetDigitalChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>(GetDigitalChannelsDocument, options);
        }
// @ts-ignore
export function useGetDigitalChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>;
export function useGetDigitalChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalChannelsQuery | undefined, GetDigitalChannelsQueryVariables>;
export function useGetDigitalChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>(GetDigitalChannelsDocument, options);
        }
export type GetDigitalChannelsQueryHookResult = ReturnType<typeof useGetDigitalChannelsQuery>;
export type GetDigitalChannelsLazyQueryHookResult = ReturnType<typeof useGetDigitalChannelsLazyQuery>;
export type GetDigitalChannelsSuspenseQueryHookResult = ReturnType<typeof useGetDigitalChannelsSuspenseQuery>;
export type GetDigitalChannelsQueryResult = Apollo.QueryResult<GetDigitalChannelsQuery, GetDigitalChannelsQueryVariables>;
export const GetDigitalChannelOverviewDocument = gql`
    query GetDigitalChannelOverview($input: DigitalChannelPeriodInput!) {
  digitalChannelOverview(input: $input) {
    dateFrom
    dateTo
    previousFrom
    previousTo
    channels {
      channel {
        ...DigitalChannelFields
      }
      status
      unavailableReason
      current {
        ...DigitalChannelTotalsFields
      }
      previous {
        ...DigitalChannelTotalsFields
      }
      series {
        date
        activeUsers
        sessions
      }
    }
  }
}
    ${DigitalChannelFieldsFragmentDoc}
${DigitalChannelTotalsFieldsFragmentDoc}`;

/**
 * __useGetDigitalChannelOverviewQuery__
 *
 * To run a query within a React component, call `useGetDigitalChannelOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalChannelOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalChannelOverviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDigitalChannelOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables> & ({ variables: GetDigitalChannelOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>(GetDigitalChannelOverviewDocument, options);
      }
export function useGetDigitalChannelOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>(GetDigitalChannelOverviewDocument, options);
        }
// @ts-ignore
export function useGetDigitalChannelOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>;
export function useGetDigitalChannelOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalChannelOverviewQuery | undefined, GetDigitalChannelOverviewQueryVariables>;
export function useGetDigitalChannelOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>(GetDigitalChannelOverviewDocument, options);
        }
export type GetDigitalChannelOverviewQueryHookResult = ReturnType<typeof useGetDigitalChannelOverviewQuery>;
export type GetDigitalChannelOverviewLazyQueryHookResult = ReturnType<typeof useGetDigitalChannelOverviewLazyQuery>;
export type GetDigitalChannelOverviewSuspenseQueryHookResult = ReturnType<typeof useGetDigitalChannelOverviewSuspenseQuery>;
export type GetDigitalChannelOverviewQueryResult = Apollo.QueryResult<GetDigitalChannelOverviewQuery, GetDigitalChannelOverviewQueryVariables>;
export const GetDigitalChannelDetailDocument = gql`
    query GetDigitalChannelDetail($channelId: String!, $input: DigitalChannelPeriodInput!) {
  digitalChannelDetail(channelId: $channelId, input: $input) {
    channel {
      ...DigitalChannelFields
    }
    dateFrom
    dateTo
    status
    unavailableReason
    topContent {
      label
      views
      activeUsers
    }
    trafficSources {
      label
      sessions
      activeUsers
    }
    platforms {
      label
      activeUsers
    }
    appVersions {
      label
      activeUsers
    }
  }
}
    ${DigitalChannelFieldsFragmentDoc}`;

/**
 * __useGetDigitalChannelDetailQuery__
 *
 * To run a query within a React component, call `useGetDigitalChannelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDigitalChannelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDigitalChannelDetailQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDigitalChannelDetailQuery(baseOptions: Apollo.QueryHookOptions<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables> & ({ variables: GetDigitalChannelDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>(GetDigitalChannelDetailDocument, options);
      }
export function useGetDigitalChannelDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>(GetDigitalChannelDetailDocument, options);
        }
// @ts-ignore
export function useGetDigitalChannelDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>;
export function useGetDigitalChannelDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetDigitalChannelDetailQuery | undefined, GetDigitalChannelDetailQueryVariables>;
export function useGetDigitalChannelDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>(GetDigitalChannelDetailDocument, options);
        }
export type GetDigitalChannelDetailQueryHookResult = ReturnType<typeof useGetDigitalChannelDetailQuery>;
export type GetDigitalChannelDetailLazyQueryHookResult = ReturnType<typeof useGetDigitalChannelDetailLazyQuery>;
export type GetDigitalChannelDetailSuspenseQueryHookResult = ReturnType<typeof useGetDigitalChannelDetailSuspenseQuery>;
export type GetDigitalChannelDetailQueryResult = Apollo.QueryResult<GetDigitalChannelDetailQuery, GetDigitalChannelDetailQueryVariables>;
export const CreateDigitalChannelDocument = gql`
    mutation CreateDigitalChannel($input: CreateDigitalChannelInput!) {
  createDigitalChannel(input: $input) {
    ...DigitalChannelFields
  }
}
    ${DigitalChannelFieldsFragmentDoc}`;
export type CreateDigitalChannelMutationFn = Apollo.MutationFunction<CreateDigitalChannelMutation, CreateDigitalChannelMutationVariables>;

/**
 * __useCreateDigitalChannelMutation__
 *
 * To run a mutation, you first call `useCreateDigitalChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDigitalChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDigitalChannelMutation, { data, loading, error }] = useCreateDigitalChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDigitalChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateDigitalChannelMutation, CreateDigitalChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDigitalChannelMutation, CreateDigitalChannelMutationVariables>(CreateDigitalChannelDocument, options);
      }
export type CreateDigitalChannelMutationHookResult = ReturnType<typeof useCreateDigitalChannelMutation>;
export type CreateDigitalChannelMutationResult = Apollo.MutationResult<CreateDigitalChannelMutation>;
export type CreateDigitalChannelMutationOptions = Apollo.BaseMutationOptions<CreateDigitalChannelMutation, CreateDigitalChannelMutationVariables>;
export const UpdateDigitalChannelDocument = gql`
    mutation UpdateDigitalChannel($id: String!, $input: UpdateDigitalChannelInput!) {
  updateDigitalChannel(id: $id, input: $input) {
    ...DigitalChannelFields
  }
}
    ${DigitalChannelFieldsFragmentDoc}`;
export type UpdateDigitalChannelMutationFn = Apollo.MutationFunction<UpdateDigitalChannelMutation, UpdateDigitalChannelMutationVariables>;

/**
 * __useUpdateDigitalChannelMutation__
 *
 * To run a mutation, you first call `useUpdateDigitalChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigitalChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDigitalChannelMutation, { data, loading, error }] = useUpdateDigitalChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDigitalChannelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDigitalChannelMutation, UpdateDigitalChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDigitalChannelMutation, UpdateDigitalChannelMutationVariables>(UpdateDigitalChannelDocument, options);
      }
export type UpdateDigitalChannelMutationHookResult = ReturnType<typeof useUpdateDigitalChannelMutation>;
export type UpdateDigitalChannelMutationResult = Apollo.MutationResult<UpdateDigitalChannelMutation>;
export type UpdateDigitalChannelMutationOptions = Apollo.BaseMutationOptions<UpdateDigitalChannelMutation, UpdateDigitalChannelMutationVariables>;
export const DeleteDigitalChannelDocument = gql`
    mutation DeleteDigitalChannel($id: String!) {
  deleteDigitalChannel(id: $id)
}
    `;
export type DeleteDigitalChannelMutationFn = Apollo.MutationFunction<DeleteDigitalChannelMutation, DeleteDigitalChannelMutationVariables>;

/**
 * __useDeleteDigitalChannelMutation__
 *
 * To run a mutation, you first call `useDeleteDigitalChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDigitalChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDigitalChannelMutation, { data, loading, error }] = useDeleteDigitalChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDigitalChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDigitalChannelMutation, DeleteDigitalChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDigitalChannelMutation, DeleteDigitalChannelMutationVariables>(DeleteDigitalChannelDocument, options);
      }
export type DeleteDigitalChannelMutationHookResult = ReturnType<typeof useDeleteDigitalChannelMutation>;
export type DeleteDigitalChannelMutationResult = Apollo.MutationResult<DeleteDigitalChannelMutation>;
export type DeleteDigitalChannelMutationOptions = Apollo.BaseMutationOptions<DeleteDigitalChannelMutation, DeleteDigitalChannelMutationVariables>;
export const DiversityMetricsDocument = gql`
    query DiversityMetrics($asOf: DateTime!, $filter: DiversityFilterInput) {
  diversityMetrics(asOf: $asOf, filter: $filter) {
    asOf
    headcount {
      ...HrMetricFields
    }
    byGender {
      gender
      count
    }
    byRace {
      race
      count
    }
    byGenderRace {
      gender
      race
      count
    }
    byJobLevel {
      level
      count
    }
    disabilityPercent {
      ...HrMetricFields
    }
    youthPercent {
      ...HrMetricFields
    }
    womenInManagementPercent {
      ...HrMetricFields
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useDiversityMetricsQuery__
 *
 * To run a query within a React component, call `useDiversityMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiversityMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiversityMetricsQuery({
 *   variables: {
 *      asOf: // value for 'asOf'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDiversityMetricsQuery(baseOptions: Apollo.QueryHookOptions<DiversityMetricsQuery, DiversityMetricsQueryVariables> & ({ variables: DiversityMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiversityMetricsQuery, DiversityMetricsQueryVariables>(DiversityMetricsDocument, options);
      }
export function useDiversityMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiversityMetricsQuery, DiversityMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiversityMetricsQuery, DiversityMetricsQueryVariables>(DiversityMetricsDocument, options);
        }
// @ts-ignore
export function useDiversityMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiversityMetricsQuery, DiversityMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<DiversityMetricsQuery, DiversityMetricsQueryVariables>;
export function useDiversityMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiversityMetricsQuery, DiversityMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<DiversityMetricsQuery | undefined, DiversityMetricsQueryVariables>;
export function useDiversityMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiversityMetricsQuery, DiversityMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiversityMetricsQuery, DiversityMetricsQueryVariables>(DiversityMetricsDocument, options);
        }
export type DiversityMetricsQueryHookResult = ReturnType<typeof useDiversityMetricsQuery>;
export type DiversityMetricsLazyQueryHookResult = ReturnType<typeof useDiversityMetricsLazyQuery>;
export type DiversityMetricsSuspenseQueryHookResult = ReturnType<typeof useDiversityMetricsSuspenseQuery>;
export type DiversityMetricsQueryResult = Apollo.QueryResult<DiversityMetricsQuery, DiversityMetricsQueryVariables>;
export const EmployeeDemographicsDocument = gql`
    query EmployeeDemographics($employeeId: ID!) {
  employeeDemographics(employeeId: $employeeId) {
    ...EmployeeDemographicsFields
  }
}
    ${EmployeeDemographicsFieldsFragmentDoc}`;

/**
 * __useEmployeeDemographicsQuery__
 *
 * To run a query within a React component, call `useEmployeeDemographicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDemographicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDemographicsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeeDemographicsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables> & ({ variables: EmployeeDemographicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>(EmployeeDemographicsDocument, options);
      }
export function useEmployeeDemographicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>(EmployeeDemographicsDocument, options);
        }
// @ts-ignore
export function useEmployeeDemographicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>;
export function useEmployeeDemographicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeDemographicsQuery | undefined, EmployeeDemographicsQueryVariables>;
export function useEmployeeDemographicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>(EmployeeDemographicsDocument, options);
        }
export type EmployeeDemographicsQueryHookResult = ReturnType<typeof useEmployeeDemographicsQuery>;
export type EmployeeDemographicsLazyQueryHookResult = ReturnType<typeof useEmployeeDemographicsLazyQuery>;
export type EmployeeDemographicsSuspenseQueryHookResult = ReturnType<typeof useEmployeeDemographicsSuspenseQuery>;
export type EmployeeDemographicsQueryResult = Apollo.QueryResult<EmployeeDemographicsQuery, EmployeeDemographicsQueryVariables>;
export const UpdateEmployeeDemographicsDocument = gql`
    mutation UpdateEmployeeDemographics($employeeId: ID!, $input: EmployeeDemographicsInput!, $movement: MovementDetailsInput) {
  updateEmployeeDemographics(
    employeeId: $employeeId
    input: $input
    movement: $movement
  ) {
    ...EmployeeDemographicsFields
  }
}
    ${EmployeeDemographicsFieldsFragmentDoc}`;
export type UpdateEmployeeDemographicsMutationFn = Apollo.MutationFunction<UpdateEmployeeDemographicsMutation, UpdateEmployeeDemographicsMutationVariables>;

/**
 * __useUpdateEmployeeDemographicsMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeDemographicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeDemographicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeDemographicsMutation, { data, loading, error }] = useUpdateEmployeeDemographicsMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *      movement: // value for 'movement'
 *   },
 * });
 */
export function useUpdateEmployeeDemographicsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeDemographicsMutation, UpdateEmployeeDemographicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeDemographicsMutation, UpdateEmployeeDemographicsMutationVariables>(UpdateEmployeeDemographicsDocument, options);
      }
export type UpdateEmployeeDemographicsMutationHookResult = ReturnType<typeof useUpdateEmployeeDemographicsMutation>;
export type UpdateEmployeeDemographicsMutationResult = Apollo.MutationResult<UpdateEmployeeDemographicsMutation>;
export type UpdateEmployeeDemographicsMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeDemographicsMutation, UpdateEmployeeDemographicsMutationVariables>;
export const HrTeamsDocument = gql`
    query HrTeams($departmentId: ID) {
  teams(departmentId: $departmentId) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;

/**
 * __useHrTeamsQuery__
 *
 * To run a query within a React component, call `useHrTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrTeamsQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useHrTeamsQuery(baseOptions?: Apollo.QueryHookOptions<HrTeamsQuery, HrTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrTeamsQuery, HrTeamsQueryVariables>(HrTeamsDocument, options);
      }
export function useHrTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrTeamsQuery, HrTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrTeamsQuery, HrTeamsQueryVariables>(HrTeamsDocument, options);
        }
// @ts-ignore
export function useHrTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HrTeamsQuery, HrTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<HrTeamsQuery, HrTeamsQueryVariables>;
export function useHrTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrTeamsQuery, HrTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<HrTeamsQuery | undefined, HrTeamsQueryVariables>;
export function useHrTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrTeamsQuery, HrTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrTeamsQuery, HrTeamsQueryVariables>(HrTeamsDocument, options);
        }
export type HrTeamsQueryHookResult = ReturnType<typeof useHrTeamsQuery>;
export type HrTeamsLazyQueryHookResult = ReturnType<typeof useHrTeamsLazyQuery>;
export type HrTeamsSuspenseQueryHookResult = ReturnType<typeof useHrTeamsSuspenseQuery>;
export type HrTeamsQueryResult = Apollo.QueryResult<HrTeamsQuery, HrTeamsQueryVariables>;
export const JobPositionsDocument = gql`
    query JobPositions {
  jobPositions {
    ...JobPositionFields
  }
}
    ${JobPositionFieldsFragmentDoc}`;

/**
 * __useJobPositionsQuery__
 *
 * To run a query within a React component, call `useJobPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPositionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobPositionsQuery(baseOptions?: Apollo.QueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPositionsQuery, JobPositionsQueryVariables>(JobPositionsDocument, options);
      }
export function useJobPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPositionsQuery, JobPositionsQueryVariables>(JobPositionsDocument, options);
        }
// @ts-ignore
export function useJobPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionsQuery, JobPositionsQueryVariables>;
export function useJobPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionsQuery | undefined, JobPositionsQueryVariables>;
export function useJobPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPositionsQuery, JobPositionsQueryVariables>(JobPositionsDocument, options);
        }
export type JobPositionsQueryHookResult = ReturnType<typeof useJobPositionsQuery>;
export type JobPositionsLazyQueryHookResult = ReturnType<typeof useJobPositionsLazyQuery>;
export type JobPositionsSuspenseQueryHookResult = ReturnType<typeof useJobPositionsSuspenseQuery>;
export type JobPositionsQueryResult = Apollo.QueryResult<JobPositionsQuery, JobPositionsQueryVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: TeamInput!) {
  createTeam(input: $input) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($id: ID!, $input: UpdateTeamInput!) {
  updateTeam(id: $id, input: $input) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($id: ID!) {
  deleteTeam(id: $id)
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const CreateJobPositionDocument = gql`
    mutation CreateJobPosition($input: JobPositionInput!) {
  createJobPosition(input: $input) {
    ...JobPositionFields
  }
}
    ${JobPositionFieldsFragmentDoc}`;
export type CreateJobPositionMutationFn = Apollo.MutationFunction<CreateJobPositionMutation, CreateJobPositionMutationVariables>;

/**
 * __useCreateJobPositionMutation__
 *
 * To run a mutation, you first call `useCreateJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobPositionMutation, { data, loading, error }] = useCreateJobPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobPositionMutation, CreateJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobPositionMutation, CreateJobPositionMutationVariables>(CreateJobPositionDocument, options);
      }
export type CreateJobPositionMutationHookResult = ReturnType<typeof useCreateJobPositionMutation>;
export type CreateJobPositionMutationResult = Apollo.MutationResult<CreateJobPositionMutation>;
export type CreateJobPositionMutationOptions = Apollo.BaseMutationOptions<CreateJobPositionMutation, CreateJobPositionMutationVariables>;
export const UpdateJobPositionDocument = gql`
    mutation UpdateJobPosition($id: ID!, $input: UpdateJobPositionInput!) {
  updateJobPosition(id: $id, input: $input) {
    ...JobPositionFields
  }
}
    ${JobPositionFieldsFragmentDoc}`;
export type UpdateJobPositionMutationFn = Apollo.MutationFunction<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>;

/**
 * __useUpdateJobPositionMutation__
 *
 * To run a mutation, you first call `useUpdateJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPositionMutation, { data, loading, error }] = useUpdateJobPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>(UpdateJobPositionDocument, options);
      }
export type UpdateJobPositionMutationHookResult = ReturnType<typeof useUpdateJobPositionMutation>;
export type UpdateJobPositionMutationResult = Apollo.MutationResult<UpdateJobPositionMutation>;
export type UpdateJobPositionMutationOptions = Apollo.BaseMutationOptions<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>;
export const DeleteJobPositionDocument = gql`
    mutation DeleteJobPosition($id: ID!) {
  deleteJobPosition(id: $id)
}
    `;
export type DeleteJobPositionMutationFn = Apollo.MutationFunction<DeleteJobPositionMutation, DeleteJobPositionMutationVariables>;

/**
 * __useDeleteJobPositionMutation__
 *
 * To run a mutation, you first call `useDeleteJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobPositionMutation, { data, loading, error }] = useDeleteJobPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobPositionMutation, DeleteJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobPositionMutation, DeleteJobPositionMutationVariables>(DeleteJobPositionDocument, options);
      }
export type DeleteJobPositionMutationHookResult = ReturnType<typeof useDeleteJobPositionMutation>;
export type DeleteJobPositionMutationResult = Apollo.MutationResult<DeleteJobPositionMutation>;
export type DeleteJobPositionMutationOptions = Apollo.BaseMutationOptions<DeleteJobPositionMutation, DeleteJobPositionMutationVariables>;
export const GetCustomerDocumentsDocument = gql`
    query GetCustomerDocuments($customerId: String!) {
  customerDocuments(customerId: $customerId) {
    ...DocumentFields
    application {
      id
      referenceNumber
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useGetCustomerDocumentsQuery__
 *
 * To run a query within a React component, call `useGetCustomerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDocumentsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables> & ({ variables: GetCustomerDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>(GetCustomerDocumentsDocument, options);
      }
export function useGetCustomerDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>(GetCustomerDocumentsDocument, options);
        }
// @ts-ignore
export function useGetCustomerDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>;
export function useGetCustomerDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerDocumentsQuery | undefined, GetCustomerDocumentsQueryVariables>;
export function useGetCustomerDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>(GetCustomerDocumentsDocument, options);
        }
export type GetCustomerDocumentsQueryHookResult = ReturnType<typeof useGetCustomerDocumentsQuery>;
export type GetCustomerDocumentsLazyQueryHookResult = ReturnType<typeof useGetCustomerDocumentsLazyQuery>;
export type GetCustomerDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerDocumentsSuspenseQuery>;
export type GetCustomerDocumentsQueryResult = Apollo.QueryResult<GetCustomerDocumentsQuery, GetCustomerDocumentsQueryVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($id: String!) {
  deleteDocument(id: $id) {
    success
    message
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const EsgProgrammesDocument = gql`
    query EsgProgrammes($filter: EsgProgrammeFilterInput) {
  esgProgrammes(filter: $filter) {
    items {
      ...EsgProgrammeFields
    }
    totalCount
  }
}
    ${EsgProgrammeFieldsFragmentDoc}`;

/**
 * __useEsgProgrammesQuery__
 *
 * To run a query within a React component, call `useEsgProgrammesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsgProgrammesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsgProgrammesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEsgProgrammesQuery(baseOptions?: Apollo.QueryHookOptions<EsgProgrammesQuery, EsgProgrammesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsgProgrammesQuery, EsgProgrammesQueryVariables>(EsgProgrammesDocument, options);
      }
export function useEsgProgrammesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsgProgrammesQuery, EsgProgrammesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsgProgrammesQuery, EsgProgrammesQueryVariables>(EsgProgrammesDocument, options);
        }
// @ts-ignore
export function useEsgProgrammesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EsgProgrammesQuery, EsgProgrammesQueryVariables>): Apollo.UseSuspenseQueryResult<EsgProgrammesQuery, EsgProgrammesQueryVariables>;
export function useEsgProgrammesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsgProgrammesQuery, EsgProgrammesQueryVariables>): Apollo.UseSuspenseQueryResult<EsgProgrammesQuery | undefined, EsgProgrammesQueryVariables>;
export function useEsgProgrammesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsgProgrammesQuery, EsgProgrammesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsgProgrammesQuery, EsgProgrammesQueryVariables>(EsgProgrammesDocument, options);
        }
export type EsgProgrammesQueryHookResult = ReturnType<typeof useEsgProgrammesQuery>;
export type EsgProgrammesLazyQueryHookResult = ReturnType<typeof useEsgProgrammesLazyQuery>;
export type EsgProgrammesSuspenseQueryHookResult = ReturnType<typeof useEsgProgrammesSuspenseQuery>;
export type EsgProgrammesQueryResult = Apollo.QueryResult<EsgProgrammesQuery, EsgProgrammesQueryVariables>;
export const EsgProgrammesExportDocument = gql`
    query EsgProgrammesExport($filter: EsgProgrammeFilterInput) {
  esgProgrammesExport(filter: $filter) {
    ...EsgProgrammeFields
  }
}
    ${EsgProgrammeFieldsFragmentDoc}`;

/**
 * __useEsgProgrammesExportQuery__
 *
 * To run a query within a React component, call `useEsgProgrammesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsgProgrammesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsgProgrammesExportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEsgProgrammesExportQuery(baseOptions?: Apollo.QueryHookOptions<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>(EsgProgrammesExportDocument, options);
      }
export function useEsgProgrammesExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>(EsgProgrammesExportDocument, options);
        }
// @ts-ignore
export function useEsgProgrammesExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>): Apollo.UseSuspenseQueryResult<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>;
export function useEsgProgrammesExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>): Apollo.UseSuspenseQueryResult<EsgProgrammesExportQuery | undefined, EsgProgrammesExportQueryVariables>;
export function useEsgProgrammesExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>(EsgProgrammesExportDocument, options);
        }
export type EsgProgrammesExportQueryHookResult = ReturnType<typeof useEsgProgrammesExportQuery>;
export type EsgProgrammesExportLazyQueryHookResult = ReturnType<typeof useEsgProgrammesExportLazyQuery>;
export type EsgProgrammesExportSuspenseQueryHookResult = ReturnType<typeof useEsgProgrammesExportSuspenseQuery>;
export type EsgProgrammesExportQueryResult = Apollo.QueryResult<EsgProgrammesExportQuery, EsgProgrammesExportQueryVariables>;
export const EsgProgrammeDocument = gql`
    query EsgProgramme($id: ID!) {
  esgProgramme(id: $id) {
    programme {
      ...EsgProgrammeFields
    }
    spend {
      ...EsgSpendFields
    }
    beneficiaries {
      ...EsgBeneficiaryFields
    }
    outcomes {
      ...EsgOutcomeFields
    }
    volunteering {
      ...EsgVolunteeringFields
    }
  }
}
    ${EsgProgrammeFieldsFragmentDoc}
${EsgSpendFieldsFragmentDoc}
${EsgBeneficiaryFieldsFragmentDoc}
${EsgOutcomeFieldsFragmentDoc}
${EsgVolunteeringFieldsFragmentDoc}`;

/**
 * __useEsgProgrammeQuery__
 *
 * To run a query within a React component, call `useEsgProgrammeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsgProgrammeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsgProgrammeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEsgProgrammeQuery(baseOptions: Apollo.QueryHookOptions<EsgProgrammeQuery, EsgProgrammeQueryVariables> & ({ variables: EsgProgrammeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsgProgrammeQuery, EsgProgrammeQueryVariables>(EsgProgrammeDocument, options);
      }
export function useEsgProgrammeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsgProgrammeQuery, EsgProgrammeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsgProgrammeQuery, EsgProgrammeQueryVariables>(EsgProgrammeDocument, options);
        }
// @ts-ignore
export function useEsgProgrammeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EsgProgrammeQuery, EsgProgrammeQueryVariables>): Apollo.UseSuspenseQueryResult<EsgProgrammeQuery, EsgProgrammeQueryVariables>;
export function useEsgProgrammeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsgProgrammeQuery, EsgProgrammeQueryVariables>): Apollo.UseSuspenseQueryResult<EsgProgrammeQuery | undefined, EsgProgrammeQueryVariables>;
export function useEsgProgrammeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsgProgrammeQuery, EsgProgrammeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsgProgrammeQuery, EsgProgrammeQueryVariables>(EsgProgrammeDocument, options);
        }
export type EsgProgrammeQueryHookResult = ReturnType<typeof useEsgProgrammeQuery>;
export type EsgProgrammeLazyQueryHookResult = ReturnType<typeof useEsgProgrammeLazyQuery>;
export type EsgProgrammeSuspenseQueryHookResult = ReturnType<typeof useEsgProgrammeSuspenseQuery>;
export type EsgProgrammeQueryResult = Apollo.QueryResult<EsgProgrammeQuery, EsgProgrammeQueryVariables>;
export const EsgMetricsDocument = gql`
    query EsgMetrics($from: DateTime!, $to: DateTime!) {
  esgMetrics(from: $from, to: $to) {
    from
    to
    totalSpend {
      ...HrMetricFields
    }
    spendByCategory {
      category
      amount
    }
    spendByBbbeeElement {
      element
      amount
    }
    budgetUsedPercent {
      ...HrMetricFields
    }
    activeProgrammes {
      ...HrMetricFields
    }
    individualsReached {
      ...HrMetricFields
    }
    organisationsReached {
      ...HrMetricFields
    }
    communitiesReached {
      ...HrMetricFields
    }
    communityPeopleReached {
      ...HrMetricFields
    }
    beneficiariesByGender {
      gender
      count
    }
    beneficiariesByYouth {
      value
      count
    }
    beneficiariesByDisability {
      value
      count
    }
    volunteeringHours {
      ...HrMetricFields
    }
    volunteers {
      ...HrMetricFields
    }
    spendPercentOfNetProfit {
      ...HrMetricFields
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useEsgMetricsQuery__
 *
 * To run a query within a React component, call `useEsgMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsgMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsgMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useEsgMetricsQuery(baseOptions: Apollo.QueryHookOptions<EsgMetricsQuery, EsgMetricsQueryVariables> & ({ variables: EsgMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsgMetricsQuery, EsgMetricsQueryVariables>(EsgMetricsDocument, options);
      }
export function useEsgMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsgMetricsQuery, EsgMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsgMetricsQuery, EsgMetricsQueryVariables>(EsgMetricsDocument, options);
        }
// @ts-ignore
export function useEsgMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EsgMetricsQuery, EsgMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EsgMetricsQuery, EsgMetricsQueryVariables>;
export function useEsgMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsgMetricsQuery, EsgMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EsgMetricsQuery | undefined, EsgMetricsQueryVariables>;
export function useEsgMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsgMetricsQuery, EsgMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsgMetricsQuery, EsgMetricsQueryVariables>(EsgMetricsDocument, options);
        }
export type EsgMetricsQueryHookResult = ReturnType<typeof useEsgMetricsQuery>;
export type EsgMetricsLazyQueryHookResult = ReturnType<typeof useEsgMetricsLazyQuery>;
export type EsgMetricsSuspenseQueryHookResult = ReturnType<typeof useEsgMetricsSuspenseQuery>;
export type EsgMetricsQueryResult = Apollo.QueryResult<EsgMetricsQuery, EsgMetricsQueryVariables>;
export const CreateEsgProgrammeDocument = gql`
    mutation CreateEsgProgramme($input: CreateEsgProgrammeInput!) {
  createEsgProgramme(input: $input) {
    ...EsgProgrammeFields
  }
}
    ${EsgProgrammeFieldsFragmentDoc}`;
export type CreateEsgProgrammeMutationFn = Apollo.MutationFunction<CreateEsgProgrammeMutation, CreateEsgProgrammeMutationVariables>;

/**
 * __useCreateEsgProgrammeMutation__
 *
 * To run a mutation, you first call `useCreateEsgProgrammeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEsgProgrammeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEsgProgrammeMutation, { data, loading, error }] = useCreateEsgProgrammeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEsgProgrammeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEsgProgrammeMutation, CreateEsgProgrammeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEsgProgrammeMutation, CreateEsgProgrammeMutationVariables>(CreateEsgProgrammeDocument, options);
      }
export type CreateEsgProgrammeMutationHookResult = ReturnType<typeof useCreateEsgProgrammeMutation>;
export type CreateEsgProgrammeMutationResult = Apollo.MutationResult<CreateEsgProgrammeMutation>;
export type CreateEsgProgrammeMutationOptions = Apollo.BaseMutationOptions<CreateEsgProgrammeMutation, CreateEsgProgrammeMutationVariables>;
export const UpdateEsgProgrammeDocument = gql`
    mutation UpdateEsgProgramme($id: ID!, $input: UpdateEsgProgrammeInput!) {
  updateEsgProgramme(id: $id, input: $input) {
    ...EsgProgrammeFields
  }
}
    ${EsgProgrammeFieldsFragmentDoc}`;
export type UpdateEsgProgrammeMutationFn = Apollo.MutationFunction<UpdateEsgProgrammeMutation, UpdateEsgProgrammeMutationVariables>;

/**
 * __useUpdateEsgProgrammeMutation__
 *
 * To run a mutation, you first call `useUpdateEsgProgrammeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsgProgrammeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsgProgrammeMutation, { data, loading, error }] = useUpdateEsgProgrammeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEsgProgrammeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsgProgrammeMutation, UpdateEsgProgrammeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsgProgrammeMutation, UpdateEsgProgrammeMutationVariables>(UpdateEsgProgrammeDocument, options);
      }
export type UpdateEsgProgrammeMutationHookResult = ReturnType<typeof useUpdateEsgProgrammeMutation>;
export type UpdateEsgProgrammeMutationResult = Apollo.MutationResult<UpdateEsgProgrammeMutation>;
export type UpdateEsgProgrammeMutationOptions = Apollo.BaseMutationOptions<UpdateEsgProgrammeMutation, UpdateEsgProgrammeMutationVariables>;
export const DeleteEsgProgrammeDocument = gql`
    mutation DeleteEsgProgramme($id: ID!) {
  deleteEsgProgramme(id: $id)
}
    `;
export type DeleteEsgProgrammeMutationFn = Apollo.MutationFunction<DeleteEsgProgrammeMutation, DeleteEsgProgrammeMutationVariables>;

/**
 * __useDeleteEsgProgrammeMutation__
 *
 * To run a mutation, you first call `useDeleteEsgProgrammeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEsgProgrammeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEsgProgrammeMutation, { data, loading, error }] = useDeleteEsgProgrammeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEsgProgrammeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEsgProgrammeMutation, DeleteEsgProgrammeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEsgProgrammeMutation, DeleteEsgProgrammeMutationVariables>(DeleteEsgProgrammeDocument, options);
      }
export type DeleteEsgProgrammeMutationHookResult = ReturnType<typeof useDeleteEsgProgrammeMutation>;
export type DeleteEsgProgrammeMutationResult = Apollo.MutationResult<DeleteEsgProgrammeMutation>;
export type DeleteEsgProgrammeMutationOptions = Apollo.BaseMutationOptions<DeleteEsgProgrammeMutation, DeleteEsgProgrammeMutationVariables>;
export const CreateEsgSpendDocument = gql`
    mutation CreateEsgSpend($programmeId: ID!, $input: CreateEsgSpendInput!) {
  createEsgSpend(programmeId: $programmeId, input: $input) {
    ...EsgSpendFields
  }
}
    ${EsgSpendFieldsFragmentDoc}`;
export type CreateEsgSpendMutationFn = Apollo.MutationFunction<CreateEsgSpendMutation, CreateEsgSpendMutationVariables>;

/**
 * __useCreateEsgSpendMutation__
 *
 * To run a mutation, you first call `useCreateEsgSpendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEsgSpendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEsgSpendMutation, { data, loading, error }] = useCreateEsgSpendMutation({
 *   variables: {
 *      programmeId: // value for 'programmeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEsgSpendMutation(baseOptions?: Apollo.MutationHookOptions<CreateEsgSpendMutation, CreateEsgSpendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEsgSpendMutation, CreateEsgSpendMutationVariables>(CreateEsgSpendDocument, options);
      }
export type CreateEsgSpendMutationHookResult = ReturnType<typeof useCreateEsgSpendMutation>;
export type CreateEsgSpendMutationResult = Apollo.MutationResult<CreateEsgSpendMutation>;
export type CreateEsgSpendMutationOptions = Apollo.BaseMutationOptions<CreateEsgSpendMutation, CreateEsgSpendMutationVariables>;
export const UpdateEsgSpendDocument = gql`
    mutation UpdateEsgSpend($id: ID!, $input: UpdateEsgSpendInput!) {
  updateEsgSpend(id: $id, input: $input) {
    ...EsgSpendFields
  }
}
    ${EsgSpendFieldsFragmentDoc}`;
export type UpdateEsgSpendMutationFn = Apollo.MutationFunction<UpdateEsgSpendMutation, UpdateEsgSpendMutationVariables>;

/**
 * __useUpdateEsgSpendMutation__
 *
 * To run a mutation, you first call `useUpdateEsgSpendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsgSpendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsgSpendMutation, { data, loading, error }] = useUpdateEsgSpendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEsgSpendMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsgSpendMutation, UpdateEsgSpendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsgSpendMutation, UpdateEsgSpendMutationVariables>(UpdateEsgSpendDocument, options);
      }
export type UpdateEsgSpendMutationHookResult = ReturnType<typeof useUpdateEsgSpendMutation>;
export type UpdateEsgSpendMutationResult = Apollo.MutationResult<UpdateEsgSpendMutation>;
export type UpdateEsgSpendMutationOptions = Apollo.BaseMutationOptions<UpdateEsgSpendMutation, UpdateEsgSpendMutationVariables>;
export const DeleteEsgSpendDocument = gql`
    mutation DeleteEsgSpend($id: ID!) {
  deleteEsgSpend(id: $id)
}
    `;
export type DeleteEsgSpendMutationFn = Apollo.MutationFunction<DeleteEsgSpendMutation, DeleteEsgSpendMutationVariables>;

/**
 * __useDeleteEsgSpendMutation__
 *
 * To run a mutation, you first call `useDeleteEsgSpendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEsgSpendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEsgSpendMutation, { data, loading, error }] = useDeleteEsgSpendMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEsgSpendMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEsgSpendMutation, DeleteEsgSpendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEsgSpendMutation, DeleteEsgSpendMutationVariables>(DeleteEsgSpendDocument, options);
      }
export type DeleteEsgSpendMutationHookResult = ReturnType<typeof useDeleteEsgSpendMutation>;
export type DeleteEsgSpendMutationResult = Apollo.MutationResult<DeleteEsgSpendMutation>;
export type DeleteEsgSpendMutationOptions = Apollo.BaseMutationOptions<DeleteEsgSpendMutation, DeleteEsgSpendMutationVariables>;
export const RemoveEsgSpendEvidenceDocument = gql`
    mutation RemoveEsgSpendEvidence($documentId: ID!) {
  removeEsgSpendEvidence(documentId: $documentId)
}
    `;
export type RemoveEsgSpendEvidenceMutationFn = Apollo.MutationFunction<RemoveEsgSpendEvidenceMutation, RemoveEsgSpendEvidenceMutationVariables>;

/**
 * __useRemoveEsgSpendEvidenceMutation__
 *
 * To run a mutation, you first call `useRemoveEsgSpendEvidenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEsgSpendEvidenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEsgSpendEvidenceMutation, { data, loading, error }] = useRemoveEsgSpendEvidenceMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveEsgSpendEvidenceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEsgSpendEvidenceMutation, RemoveEsgSpendEvidenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEsgSpendEvidenceMutation, RemoveEsgSpendEvidenceMutationVariables>(RemoveEsgSpendEvidenceDocument, options);
      }
export type RemoveEsgSpendEvidenceMutationHookResult = ReturnType<typeof useRemoveEsgSpendEvidenceMutation>;
export type RemoveEsgSpendEvidenceMutationResult = Apollo.MutationResult<RemoveEsgSpendEvidenceMutation>;
export type RemoveEsgSpendEvidenceMutationOptions = Apollo.BaseMutationOptions<RemoveEsgSpendEvidenceMutation, RemoveEsgSpendEvidenceMutationVariables>;
export const CreateEsgBeneficiaryDocument = gql`
    mutation CreateEsgBeneficiary($programmeId: ID!, $input: CreateEsgBeneficiaryInput!) {
  createEsgBeneficiary(programmeId: $programmeId, input: $input) {
    ...EsgBeneficiaryFields
  }
}
    ${EsgBeneficiaryFieldsFragmentDoc}`;
export type CreateEsgBeneficiaryMutationFn = Apollo.MutationFunction<CreateEsgBeneficiaryMutation, CreateEsgBeneficiaryMutationVariables>;

/**
 * __useCreateEsgBeneficiaryMutation__
 *
 * To run a mutation, you first call `useCreateEsgBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEsgBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEsgBeneficiaryMutation, { data, loading, error }] = useCreateEsgBeneficiaryMutation({
 *   variables: {
 *      programmeId: // value for 'programmeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEsgBeneficiaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEsgBeneficiaryMutation, CreateEsgBeneficiaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEsgBeneficiaryMutation, CreateEsgBeneficiaryMutationVariables>(CreateEsgBeneficiaryDocument, options);
      }
export type CreateEsgBeneficiaryMutationHookResult = ReturnType<typeof useCreateEsgBeneficiaryMutation>;
export type CreateEsgBeneficiaryMutationResult = Apollo.MutationResult<CreateEsgBeneficiaryMutation>;
export type CreateEsgBeneficiaryMutationOptions = Apollo.BaseMutationOptions<CreateEsgBeneficiaryMutation, CreateEsgBeneficiaryMutationVariables>;
export const UpdateEsgBeneficiaryDocument = gql`
    mutation UpdateEsgBeneficiary($id: ID!, $input: UpdateEsgBeneficiaryInput!) {
  updateEsgBeneficiary(id: $id, input: $input) {
    ...EsgBeneficiaryFields
  }
}
    ${EsgBeneficiaryFieldsFragmentDoc}`;
export type UpdateEsgBeneficiaryMutationFn = Apollo.MutationFunction<UpdateEsgBeneficiaryMutation, UpdateEsgBeneficiaryMutationVariables>;

/**
 * __useUpdateEsgBeneficiaryMutation__
 *
 * To run a mutation, you first call `useUpdateEsgBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsgBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsgBeneficiaryMutation, { data, loading, error }] = useUpdateEsgBeneficiaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEsgBeneficiaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsgBeneficiaryMutation, UpdateEsgBeneficiaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsgBeneficiaryMutation, UpdateEsgBeneficiaryMutationVariables>(UpdateEsgBeneficiaryDocument, options);
      }
export type UpdateEsgBeneficiaryMutationHookResult = ReturnType<typeof useUpdateEsgBeneficiaryMutation>;
export type UpdateEsgBeneficiaryMutationResult = Apollo.MutationResult<UpdateEsgBeneficiaryMutation>;
export type UpdateEsgBeneficiaryMutationOptions = Apollo.BaseMutationOptions<UpdateEsgBeneficiaryMutation, UpdateEsgBeneficiaryMutationVariables>;
export const DeleteEsgBeneficiaryDocument = gql`
    mutation DeleteEsgBeneficiary($id: ID!) {
  deleteEsgBeneficiary(id: $id)
}
    `;
export type DeleteEsgBeneficiaryMutationFn = Apollo.MutationFunction<DeleteEsgBeneficiaryMutation, DeleteEsgBeneficiaryMutationVariables>;

/**
 * __useDeleteEsgBeneficiaryMutation__
 *
 * To run a mutation, you first call `useDeleteEsgBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEsgBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEsgBeneficiaryMutation, { data, loading, error }] = useDeleteEsgBeneficiaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEsgBeneficiaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEsgBeneficiaryMutation, DeleteEsgBeneficiaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEsgBeneficiaryMutation, DeleteEsgBeneficiaryMutationVariables>(DeleteEsgBeneficiaryDocument, options);
      }
export type DeleteEsgBeneficiaryMutationHookResult = ReturnType<typeof useDeleteEsgBeneficiaryMutation>;
export type DeleteEsgBeneficiaryMutationResult = Apollo.MutationResult<DeleteEsgBeneficiaryMutation>;
export type DeleteEsgBeneficiaryMutationOptions = Apollo.BaseMutationOptions<DeleteEsgBeneficiaryMutation, DeleteEsgBeneficiaryMutationVariables>;
export const CreateEsgOutcomeDocument = gql`
    mutation CreateEsgOutcome($programmeId: ID!, $input: CreateEsgOutcomeInput!) {
  createEsgOutcome(programmeId: $programmeId, input: $input) {
    ...EsgOutcomeFields
  }
}
    ${EsgOutcomeFieldsFragmentDoc}`;
export type CreateEsgOutcomeMutationFn = Apollo.MutationFunction<CreateEsgOutcomeMutation, CreateEsgOutcomeMutationVariables>;

/**
 * __useCreateEsgOutcomeMutation__
 *
 * To run a mutation, you first call `useCreateEsgOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEsgOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEsgOutcomeMutation, { data, loading, error }] = useCreateEsgOutcomeMutation({
 *   variables: {
 *      programmeId: // value for 'programmeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEsgOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEsgOutcomeMutation, CreateEsgOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEsgOutcomeMutation, CreateEsgOutcomeMutationVariables>(CreateEsgOutcomeDocument, options);
      }
export type CreateEsgOutcomeMutationHookResult = ReturnType<typeof useCreateEsgOutcomeMutation>;
export type CreateEsgOutcomeMutationResult = Apollo.MutationResult<CreateEsgOutcomeMutation>;
export type CreateEsgOutcomeMutationOptions = Apollo.BaseMutationOptions<CreateEsgOutcomeMutation, CreateEsgOutcomeMutationVariables>;
export const UpdateEsgOutcomeDocument = gql`
    mutation UpdateEsgOutcome($id: ID!, $input: UpdateEsgOutcomeInput!) {
  updateEsgOutcome(id: $id, input: $input) {
    ...EsgOutcomeFields
  }
}
    ${EsgOutcomeFieldsFragmentDoc}`;
export type UpdateEsgOutcomeMutationFn = Apollo.MutationFunction<UpdateEsgOutcomeMutation, UpdateEsgOutcomeMutationVariables>;

/**
 * __useUpdateEsgOutcomeMutation__
 *
 * To run a mutation, you first call `useUpdateEsgOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsgOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsgOutcomeMutation, { data, loading, error }] = useUpdateEsgOutcomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEsgOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsgOutcomeMutation, UpdateEsgOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsgOutcomeMutation, UpdateEsgOutcomeMutationVariables>(UpdateEsgOutcomeDocument, options);
      }
export type UpdateEsgOutcomeMutationHookResult = ReturnType<typeof useUpdateEsgOutcomeMutation>;
export type UpdateEsgOutcomeMutationResult = Apollo.MutationResult<UpdateEsgOutcomeMutation>;
export type UpdateEsgOutcomeMutationOptions = Apollo.BaseMutationOptions<UpdateEsgOutcomeMutation, UpdateEsgOutcomeMutationVariables>;
export const DeleteEsgOutcomeDocument = gql`
    mutation DeleteEsgOutcome($id: ID!) {
  deleteEsgOutcome(id: $id)
}
    `;
export type DeleteEsgOutcomeMutationFn = Apollo.MutationFunction<DeleteEsgOutcomeMutation, DeleteEsgOutcomeMutationVariables>;

/**
 * __useDeleteEsgOutcomeMutation__
 *
 * To run a mutation, you first call `useDeleteEsgOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEsgOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEsgOutcomeMutation, { data, loading, error }] = useDeleteEsgOutcomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEsgOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEsgOutcomeMutation, DeleteEsgOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEsgOutcomeMutation, DeleteEsgOutcomeMutationVariables>(DeleteEsgOutcomeDocument, options);
      }
export type DeleteEsgOutcomeMutationHookResult = ReturnType<typeof useDeleteEsgOutcomeMutation>;
export type DeleteEsgOutcomeMutationResult = Apollo.MutationResult<DeleteEsgOutcomeMutation>;
export type DeleteEsgOutcomeMutationOptions = Apollo.BaseMutationOptions<DeleteEsgOutcomeMutation, DeleteEsgOutcomeMutationVariables>;
export const CreateEsgVolunteeringDocument = gql`
    mutation CreateEsgVolunteering($programmeId: ID!, $input: CreateEsgVolunteeringInput!) {
  createEsgVolunteering(programmeId: $programmeId, input: $input) {
    ...EsgVolunteeringFields
  }
}
    ${EsgVolunteeringFieldsFragmentDoc}`;
export type CreateEsgVolunteeringMutationFn = Apollo.MutationFunction<CreateEsgVolunteeringMutation, CreateEsgVolunteeringMutationVariables>;

/**
 * __useCreateEsgVolunteeringMutation__
 *
 * To run a mutation, you first call `useCreateEsgVolunteeringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEsgVolunteeringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEsgVolunteeringMutation, { data, loading, error }] = useCreateEsgVolunteeringMutation({
 *   variables: {
 *      programmeId: // value for 'programmeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEsgVolunteeringMutation(baseOptions?: Apollo.MutationHookOptions<CreateEsgVolunteeringMutation, CreateEsgVolunteeringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEsgVolunteeringMutation, CreateEsgVolunteeringMutationVariables>(CreateEsgVolunteeringDocument, options);
      }
export type CreateEsgVolunteeringMutationHookResult = ReturnType<typeof useCreateEsgVolunteeringMutation>;
export type CreateEsgVolunteeringMutationResult = Apollo.MutationResult<CreateEsgVolunteeringMutation>;
export type CreateEsgVolunteeringMutationOptions = Apollo.BaseMutationOptions<CreateEsgVolunteeringMutation, CreateEsgVolunteeringMutationVariables>;
export const UpdateEsgVolunteeringDocument = gql`
    mutation UpdateEsgVolunteering($id: ID!, $input: UpdateEsgVolunteeringInput!) {
  updateEsgVolunteering(id: $id, input: $input) {
    ...EsgVolunteeringFields
  }
}
    ${EsgVolunteeringFieldsFragmentDoc}`;
export type UpdateEsgVolunteeringMutationFn = Apollo.MutationFunction<UpdateEsgVolunteeringMutation, UpdateEsgVolunteeringMutationVariables>;

/**
 * __useUpdateEsgVolunteeringMutation__
 *
 * To run a mutation, you first call `useUpdateEsgVolunteeringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsgVolunteeringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsgVolunteeringMutation, { data, loading, error }] = useUpdateEsgVolunteeringMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEsgVolunteeringMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsgVolunteeringMutation, UpdateEsgVolunteeringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsgVolunteeringMutation, UpdateEsgVolunteeringMutationVariables>(UpdateEsgVolunteeringDocument, options);
      }
export type UpdateEsgVolunteeringMutationHookResult = ReturnType<typeof useUpdateEsgVolunteeringMutation>;
export type UpdateEsgVolunteeringMutationResult = Apollo.MutationResult<UpdateEsgVolunteeringMutation>;
export type UpdateEsgVolunteeringMutationOptions = Apollo.BaseMutationOptions<UpdateEsgVolunteeringMutation, UpdateEsgVolunteeringMutationVariables>;
export const DeleteEsgVolunteeringDocument = gql`
    mutation DeleteEsgVolunteering($id: ID!) {
  deleteEsgVolunteering(id: $id)
}
    `;
export type DeleteEsgVolunteeringMutationFn = Apollo.MutationFunction<DeleteEsgVolunteeringMutation, DeleteEsgVolunteeringMutationVariables>;

/**
 * __useDeleteEsgVolunteeringMutation__
 *
 * To run a mutation, you first call `useDeleteEsgVolunteeringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEsgVolunteeringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEsgVolunteeringMutation, { data, loading, error }] = useDeleteEsgVolunteeringMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEsgVolunteeringMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEsgVolunteeringMutation, DeleteEsgVolunteeringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEsgVolunteeringMutation, DeleteEsgVolunteeringMutationVariables>(DeleteEsgVolunteeringDocument, options);
      }
export type DeleteEsgVolunteeringMutationHookResult = ReturnType<typeof useDeleteEsgVolunteeringMutation>;
export type DeleteEsgVolunteeringMutationResult = Apollo.MutationResult<DeleteEsgVolunteeringMutation>;
export type DeleteEsgVolunteeringMutationOptions = Apollo.BaseMutationOptions<DeleteEsgVolunteeringMutation, DeleteEsgVolunteeringMutationVariables>;
export const GrievancesDocument = gql`
    query Grievances($filter: GrievanceFilterInput) {
  grievances(filter: $filter) {
    totalCount
    items {
      ...GrievanceSummaryFields
    }
  }
}
    ${GrievanceSummaryFieldsFragmentDoc}`;

/**
 * __useGrievancesQuery__
 *
 * To run a query within a React component, call `useGrievancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrievancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrievancesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGrievancesQuery(baseOptions?: Apollo.QueryHookOptions<GrievancesQuery, GrievancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrievancesQuery, GrievancesQueryVariables>(GrievancesDocument, options);
      }
export function useGrievancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrievancesQuery, GrievancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrievancesQuery, GrievancesQueryVariables>(GrievancesDocument, options);
        }
// @ts-ignore
export function useGrievancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrievancesQuery, GrievancesQueryVariables>): Apollo.UseSuspenseQueryResult<GrievancesQuery, GrievancesQueryVariables>;
export function useGrievancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrievancesQuery, GrievancesQueryVariables>): Apollo.UseSuspenseQueryResult<GrievancesQuery | undefined, GrievancesQueryVariables>;
export function useGrievancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrievancesQuery, GrievancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrievancesQuery, GrievancesQueryVariables>(GrievancesDocument, options);
        }
export type GrievancesQueryHookResult = ReturnType<typeof useGrievancesQuery>;
export type GrievancesLazyQueryHookResult = ReturnType<typeof useGrievancesLazyQuery>;
export type GrievancesSuspenseQueryHookResult = ReturnType<typeof useGrievancesSuspenseQuery>;
export type GrievancesQueryResult = Apollo.QueryResult<GrievancesQuery, GrievancesQueryVariables>;
export const GrievanceDocument = gql`
    query Grievance($id: ID!) {
  grievance(id: $id) {
    ...GrievanceDetailFields
  }
}
    ${GrievanceDetailFieldsFragmentDoc}`;

/**
 * __useGrievanceQuery__
 *
 * To run a query within a React component, call `useGrievanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrievanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrievanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGrievanceQuery(baseOptions: Apollo.QueryHookOptions<GrievanceQuery, GrievanceQueryVariables> & ({ variables: GrievanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrievanceQuery, GrievanceQueryVariables>(GrievanceDocument, options);
      }
export function useGrievanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrievanceQuery, GrievanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrievanceQuery, GrievanceQueryVariables>(GrievanceDocument, options);
        }
// @ts-ignore
export function useGrievanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrievanceQuery, GrievanceQueryVariables>): Apollo.UseSuspenseQueryResult<GrievanceQuery, GrievanceQueryVariables>;
export function useGrievanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrievanceQuery, GrievanceQueryVariables>): Apollo.UseSuspenseQueryResult<GrievanceQuery | undefined, GrievanceQueryVariables>;
export function useGrievanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrievanceQuery, GrievanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrievanceQuery, GrievanceQueryVariables>(GrievanceDocument, options);
        }
export type GrievanceQueryHookResult = ReturnType<typeof useGrievanceQuery>;
export type GrievanceLazyQueryHookResult = ReturnType<typeof useGrievanceLazyQuery>;
export type GrievanceSuspenseQueryHookResult = ReturnType<typeof useGrievanceSuspenseQuery>;
export type GrievanceQueryResult = Apollo.QueryResult<GrievanceQuery, GrievanceQueryVariables>;
export const GrievanceLookupsDocument = gql`
    query GrievanceLookups {
  grievanceOfficers {
    ...GrievanceOfficerFields
  }
  grievanceCategories {
    id
    code
    label
    active
    sortOrder
  }
  grievanceOutcomes {
    id
    code
    label
    active
    sortOrder
  }
  grievanceSettings {
    ...GrievanceSettingsFields
  }
}
    ${GrievanceOfficerFieldsFragmentDoc}
${GrievanceSettingsFieldsFragmentDoc}`;

/**
 * __useGrievanceLookupsQuery__
 *
 * To run a query within a React component, call `useGrievanceLookupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrievanceLookupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrievanceLookupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGrievanceLookupsQuery(baseOptions?: Apollo.QueryHookOptions<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>(GrievanceLookupsDocument, options);
      }
export function useGrievanceLookupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>(GrievanceLookupsDocument, options);
        }
// @ts-ignore
export function useGrievanceLookupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>): Apollo.UseSuspenseQueryResult<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>;
export function useGrievanceLookupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>): Apollo.UseSuspenseQueryResult<GrievanceLookupsQuery | undefined, GrievanceLookupsQueryVariables>;
export function useGrievanceLookupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>(GrievanceLookupsDocument, options);
        }
export type GrievanceLookupsQueryHookResult = ReturnType<typeof useGrievanceLookupsQuery>;
export type GrievanceLookupsLazyQueryHookResult = ReturnType<typeof useGrievanceLookupsLazyQuery>;
export type GrievanceLookupsSuspenseQueryHookResult = ReturnType<typeof useGrievanceLookupsSuspenseQuery>;
export type GrievanceLookupsQueryResult = Apollo.QueryResult<GrievanceLookupsQuery, GrievanceLookupsQueryVariables>;
export const GrievanceReportDocument = gql`
    query GrievanceReport($from: DateTime!, $to: DateTime!) {
  grievanceReport(from: $from, to: $to) {
    from
    to
    total
    bySource {
      key
      count
    }
    byStatus {
      key
      count
    }
    byOutcome {
      key
      count
    }
    acknowledgement {
      ...GrievanceDurationsFields
    }
    resolution {
      ...GrievanceDurationsFields
    }
    openAgeing {
      ...GrievanceDurationsFields
    }
    byCategory {
      categoryCode
      count
      acknowledgement {
        ...GrievanceDurationsFields
      }
      resolution {
        ...GrievanceDurationsFields
      }
      openAgeing {
        ...GrievanceDurationsFields
      }
    }
  }
}
    ${GrievanceDurationsFieldsFragmentDoc}`;

/**
 * __useGrievanceReportQuery__
 *
 * To run a query within a React component, call `useGrievanceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrievanceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrievanceReportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGrievanceReportQuery(baseOptions: Apollo.QueryHookOptions<GrievanceReportQuery, GrievanceReportQueryVariables> & ({ variables: GrievanceReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrievanceReportQuery, GrievanceReportQueryVariables>(GrievanceReportDocument, options);
      }
export function useGrievanceReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrievanceReportQuery, GrievanceReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrievanceReportQuery, GrievanceReportQueryVariables>(GrievanceReportDocument, options);
        }
// @ts-ignore
export function useGrievanceReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrievanceReportQuery, GrievanceReportQueryVariables>): Apollo.UseSuspenseQueryResult<GrievanceReportQuery, GrievanceReportQueryVariables>;
export function useGrievanceReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrievanceReportQuery, GrievanceReportQueryVariables>): Apollo.UseSuspenseQueryResult<GrievanceReportQuery | undefined, GrievanceReportQueryVariables>;
export function useGrievanceReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GrievanceReportQuery, GrievanceReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrievanceReportQuery, GrievanceReportQueryVariables>(GrievanceReportDocument, options);
        }
export type GrievanceReportQueryHookResult = ReturnType<typeof useGrievanceReportQuery>;
export type GrievanceReportLazyQueryHookResult = ReturnType<typeof useGrievanceReportLazyQuery>;
export type GrievanceReportSuspenseQueryHookResult = ReturnType<typeof useGrievanceReportSuspenseQuery>;
export type GrievanceReportQueryResult = Apollo.QueryResult<GrievanceReportQuery, GrievanceReportQueryVariables>;
export const CreateGrievanceDocument = gql`
    mutation CreateGrievance($input: CreateGrievanceInput!) {
  createGrievance(input: $input) {
    accessCode
    grievance {
      ...GrievanceDetailFields
    }
  }
}
    ${GrievanceDetailFieldsFragmentDoc}`;
export type CreateGrievanceMutationFn = Apollo.MutationFunction<CreateGrievanceMutation, CreateGrievanceMutationVariables>;

/**
 * __useCreateGrievanceMutation__
 *
 * To run a mutation, you first call `useCreateGrievanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGrievanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGrievanceMutation, { data, loading, error }] = useCreateGrievanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGrievanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateGrievanceMutation, CreateGrievanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGrievanceMutation, CreateGrievanceMutationVariables>(CreateGrievanceDocument, options);
      }
export type CreateGrievanceMutationHookResult = ReturnType<typeof useCreateGrievanceMutation>;
export type CreateGrievanceMutationResult = Apollo.MutationResult<CreateGrievanceMutation>;
export type CreateGrievanceMutationOptions = Apollo.BaseMutationOptions<CreateGrievanceMutation, CreateGrievanceMutationVariables>;
export const AcknowledgeGrievanceDocument = gql`
    mutation AcknowledgeGrievance($id: ID!) {
  acknowledgeGrievance(id: $id) {
    ...GrievanceDetailFields
  }
}
    ${GrievanceDetailFieldsFragmentDoc}`;
export type AcknowledgeGrievanceMutationFn = Apollo.MutationFunction<AcknowledgeGrievanceMutation, AcknowledgeGrievanceMutationVariables>;

/**
 * __useAcknowledgeGrievanceMutation__
 *
 * To run a mutation, you first call `useAcknowledgeGrievanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeGrievanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeGrievanceMutation, { data, loading, error }] = useAcknowledgeGrievanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcknowledgeGrievanceMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeGrievanceMutation, AcknowledgeGrievanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeGrievanceMutation, AcknowledgeGrievanceMutationVariables>(AcknowledgeGrievanceDocument, options);
      }
export type AcknowledgeGrievanceMutationHookResult = ReturnType<typeof useAcknowledgeGrievanceMutation>;
export type AcknowledgeGrievanceMutationResult = Apollo.MutationResult<AcknowledgeGrievanceMutation>;
export type AcknowledgeGrievanceMutationOptions = Apollo.BaseMutationOptions<AcknowledgeGrievanceMutation, AcknowledgeGrievanceMutationVariables>;
export const AssignGrievanceDocument = gql`
    mutation AssignGrievance($id: ID!, $ownerUserId: ID!) {
  assignGrievance(id: $id, ownerUserId: $ownerUserId) {
    ...GrievanceDetailFields
  }
}
    ${GrievanceDetailFieldsFragmentDoc}`;
export type AssignGrievanceMutationFn = Apollo.MutationFunction<AssignGrievanceMutation, AssignGrievanceMutationVariables>;

/**
 * __useAssignGrievanceMutation__
 *
 * To run a mutation, you first call `useAssignGrievanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignGrievanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignGrievanceMutation, { data, loading, error }] = useAssignGrievanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ownerUserId: // value for 'ownerUserId'
 *   },
 * });
 */
export function useAssignGrievanceMutation(baseOptions?: Apollo.MutationHookOptions<AssignGrievanceMutation, AssignGrievanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignGrievanceMutation, AssignGrievanceMutationVariables>(AssignGrievanceDocument, options);
      }
export type AssignGrievanceMutationHookResult = ReturnType<typeof useAssignGrievanceMutation>;
export type AssignGrievanceMutationResult = Apollo.MutationResult<AssignGrievanceMutation>;
export type AssignGrievanceMutationOptions = Apollo.BaseMutationOptions<AssignGrievanceMutation, AssignGrievanceMutationVariables>;
export const UpdateGrievanceStatusDocument = gql`
    mutation UpdateGrievanceStatus($id: ID!, $toStatus: GrievanceStatusChange!, $note: String) {
  updateGrievanceStatus(id: $id, toStatus: $toStatus, note: $note) {
    ...GrievanceDetailFields
  }
}
    ${GrievanceDetailFieldsFragmentDoc}`;
export type UpdateGrievanceStatusMutationFn = Apollo.MutationFunction<UpdateGrievanceStatusMutation, UpdateGrievanceStatusMutationVariables>;

/**
 * __useUpdateGrievanceStatusMutation__
 *
 * To run a mutation, you first call `useUpdateGrievanceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGrievanceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGrievanceStatusMutation, { data, loading, error }] = useUpdateGrievanceStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      toStatus: // value for 'toStatus'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateGrievanceStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGrievanceStatusMutation, UpdateGrievanceStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGrievanceStatusMutation, UpdateGrievanceStatusMutationVariables>(UpdateGrievanceStatusDocument, options);
      }
export type UpdateGrievanceStatusMutationHookResult = ReturnType<typeof useUpdateGrievanceStatusMutation>;
export type UpdateGrievanceStatusMutationResult = Apollo.MutationResult<UpdateGrievanceStatusMutation>;
export type UpdateGrievanceStatusMutationOptions = Apollo.BaseMutationOptions<UpdateGrievanceStatusMutation, UpdateGrievanceStatusMutationVariables>;
export const AddGrievanceNoteDocument = gql`
    mutation AddGrievanceNote($id: ID!, $note: String!) {
  addGrievanceNote(id: $id, note: $note) {
    id
  }
}
    `;
export type AddGrievanceNoteMutationFn = Apollo.MutationFunction<AddGrievanceNoteMutation, AddGrievanceNoteMutationVariables>;

/**
 * __useAddGrievanceNoteMutation__
 *
 * To run a mutation, you first call `useAddGrievanceNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGrievanceNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGrievanceNoteMutation, { data, loading, error }] = useAddGrievanceNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAddGrievanceNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddGrievanceNoteMutation, AddGrievanceNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGrievanceNoteMutation, AddGrievanceNoteMutationVariables>(AddGrievanceNoteDocument, options);
      }
export type AddGrievanceNoteMutationHookResult = ReturnType<typeof useAddGrievanceNoteMutation>;
export type AddGrievanceNoteMutationResult = Apollo.MutationResult<AddGrievanceNoteMutation>;
export type AddGrievanceNoteMutationOptions = Apollo.BaseMutationOptions<AddGrievanceNoteMutation, AddGrievanceNoteMutationVariables>;
export const ResolveGrievanceDocument = gql`
    mutation ResolveGrievance($id: ID!, $outcome: String!, $resolutionNotes: String!) {
  resolveGrievance(id: $id, outcome: $outcome, resolutionNotes: $resolutionNotes) {
    ...GrievanceDetailFields
  }
}
    ${GrievanceDetailFieldsFragmentDoc}`;
export type ResolveGrievanceMutationFn = Apollo.MutationFunction<ResolveGrievanceMutation, ResolveGrievanceMutationVariables>;

/**
 * __useResolveGrievanceMutation__
 *
 * To run a mutation, you first call `useResolveGrievanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveGrievanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveGrievanceMutation, { data, loading, error }] = useResolveGrievanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      outcome: // value for 'outcome'
 *      resolutionNotes: // value for 'resolutionNotes'
 *   },
 * });
 */
export function useResolveGrievanceMutation(baseOptions?: Apollo.MutationHookOptions<ResolveGrievanceMutation, ResolveGrievanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveGrievanceMutation, ResolveGrievanceMutationVariables>(ResolveGrievanceDocument, options);
      }
export type ResolveGrievanceMutationHookResult = ReturnType<typeof useResolveGrievanceMutation>;
export type ResolveGrievanceMutationResult = Apollo.MutationResult<ResolveGrievanceMutation>;
export type ResolveGrievanceMutationOptions = Apollo.BaseMutationOptions<ResolveGrievanceMutation, ResolveGrievanceMutationVariables>;
export const ReopenGrievanceDocument = gql`
    mutation ReopenGrievance($id: ID!, $note: String!) {
  reopenGrievance(id: $id, note: $note) {
    ...GrievanceDetailFields
  }
}
    ${GrievanceDetailFieldsFragmentDoc}`;
export type ReopenGrievanceMutationFn = Apollo.MutationFunction<ReopenGrievanceMutation, ReopenGrievanceMutationVariables>;

/**
 * __useReopenGrievanceMutation__
 *
 * To run a mutation, you first call `useReopenGrievanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenGrievanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenGrievanceMutation, { data, loading, error }] = useReopenGrievanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useReopenGrievanceMutation(baseOptions?: Apollo.MutationHookOptions<ReopenGrievanceMutation, ReopenGrievanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenGrievanceMutation, ReopenGrievanceMutationVariables>(ReopenGrievanceDocument, options);
      }
export type ReopenGrievanceMutationHookResult = ReturnType<typeof useReopenGrievanceMutation>;
export type ReopenGrievanceMutationResult = Apollo.MutationResult<ReopenGrievanceMutation>;
export type ReopenGrievanceMutationOptions = Apollo.BaseMutationOptions<ReopenGrievanceMutation, ReopenGrievanceMutationVariables>;
export const SendGrievanceMessageDocument = gql`
    mutation SendGrievanceMessage($id: ID!, $body: String!) {
  sendGrievanceMessage(id: $id, body: $body) {
    id
  }
}
    `;
export type SendGrievanceMessageMutationFn = Apollo.MutationFunction<SendGrievanceMessageMutation, SendGrievanceMessageMutationVariables>;

/**
 * __useSendGrievanceMessageMutation__
 *
 * To run a mutation, you first call `useSendGrievanceMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGrievanceMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGrievanceMessageMutation, { data, loading, error }] = useSendGrievanceMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSendGrievanceMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendGrievanceMessageMutation, SendGrievanceMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGrievanceMessageMutation, SendGrievanceMessageMutationVariables>(SendGrievanceMessageDocument, options);
      }
export type SendGrievanceMessageMutationHookResult = ReturnType<typeof useSendGrievanceMessageMutation>;
export type SendGrievanceMessageMutationResult = Apollo.MutationResult<SendGrievanceMessageMutation>;
export type SendGrievanceMessageMutationOptions = Apollo.BaseMutationOptions<SendGrievanceMessageMutation, SendGrievanceMessageMutationVariables>;
export const UpdateGrievanceSettingsDocument = gql`
    mutation UpdateGrievanceSettings($input: UpdateGrievanceSettingsInput!) {
  updateGrievanceSettings(input: $input) {
    ...GrievanceSettingsFields
  }
}
    ${GrievanceSettingsFieldsFragmentDoc}`;
export type UpdateGrievanceSettingsMutationFn = Apollo.MutationFunction<UpdateGrievanceSettingsMutation, UpdateGrievanceSettingsMutationVariables>;

/**
 * __useUpdateGrievanceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateGrievanceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGrievanceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGrievanceSettingsMutation, { data, loading, error }] = useUpdateGrievanceSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGrievanceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGrievanceSettingsMutation, UpdateGrievanceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGrievanceSettingsMutation, UpdateGrievanceSettingsMutationVariables>(UpdateGrievanceSettingsDocument, options);
      }
export type UpdateGrievanceSettingsMutationHookResult = ReturnType<typeof useUpdateGrievanceSettingsMutation>;
export type UpdateGrievanceSettingsMutationResult = Apollo.MutationResult<UpdateGrievanceSettingsMutation>;
export type UpdateGrievanceSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateGrievanceSettingsMutation, UpdateGrievanceSettingsMutationVariables>;
export const HrCasesDocument = gql`
    query HrCases($filter: HrCaseFilterInput) {
  hrCases(filter: $filter) {
    items {
      ...HrCaseFields
    }
    totalCount
  }
}
    ${HrCaseFieldsFragmentDoc}`;

/**
 * __useHrCasesQuery__
 *
 * To run a query within a React component, call `useHrCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrCasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHrCasesQuery(baseOptions?: Apollo.QueryHookOptions<HrCasesQuery, HrCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrCasesQuery, HrCasesQueryVariables>(HrCasesDocument, options);
      }
export function useHrCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrCasesQuery, HrCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrCasesQuery, HrCasesQueryVariables>(HrCasesDocument, options);
        }
// @ts-ignore
export function useHrCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HrCasesQuery, HrCasesQueryVariables>): Apollo.UseSuspenseQueryResult<HrCasesQuery, HrCasesQueryVariables>;
export function useHrCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrCasesQuery, HrCasesQueryVariables>): Apollo.UseSuspenseQueryResult<HrCasesQuery | undefined, HrCasesQueryVariables>;
export function useHrCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrCasesQuery, HrCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrCasesQuery, HrCasesQueryVariables>(HrCasesDocument, options);
        }
export type HrCasesQueryHookResult = ReturnType<typeof useHrCasesQuery>;
export type HrCasesLazyQueryHookResult = ReturnType<typeof useHrCasesLazyQuery>;
export type HrCasesSuspenseQueryHookResult = ReturnType<typeof useHrCasesSuspenseQuery>;
export type HrCasesQueryResult = Apollo.QueryResult<HrCasesQuery, HrCasesQueryVariables>;
export const HrCaseDocument = gql`
    query HrCase($id: ID!) {
  hrCase(id: $id) {
    ...HrCaseFields
    events {
      id
      kind
      eventDate
      note
      actor {
        id
        email
        firstName
        lastName
      }
      createdAt
    }
    documents {
      id
      originalName
      mimeType
      size
      createdAt
      uploadedBy {
        id
        email
        firstName
        lastName
      }
    }
  }
}
    ${HrCaseFieldsFragmentDoc}`;

/**
 * __useHrCaseQuery__
 *
 * To run a query within a React component, call `useHrCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHrCaseQuery(baseOptions: Apollo.QueryHookOptions<HrCaseQuery, HrCaseQueryVariables> & ({ variables: HrCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrCaseQuery, HrCaseQueryVariables>(HrCaseDocument, options);
      }
export function useHrCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrCaseQuery, HrCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrCaseQuery, HrCaseQueryVariables>(HrCaseDocument, options);
        }
// @ts-ignore
export function useHrCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HrCaseQuery, HrCaseQueryVariables>): Apollo.UseSuspenseQueryResult<HrCaseQuery, HrCaseQueryVariables>;
export function useHrCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrCaseQuery, HrCaseQueryVariables>): Apollo.UseSuspenseQueryResult<HrCaseQuery | undefined, HrCaseQueryVariables>;
export function useHrCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrCaseQuery, HrCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrCaseQuery, HrCaseQueryVariables>(HrCaseDocument, options);
        }
export type HrCaseQueryHookResult = ReturnType<typeof useHrCaseQuery>;
export type HrCaseLazyQueryHookResult = ReturnType<typeof useHrCaseLazyQuery>;
export type HrCaseSuspenseQueryHookResult = ReturnType<typeof useHrCaseSuspenseQuery>;
export type HrCaseQueryResult = Apollo.QueryResult<HrCaseQuery, HrCaseQueryVariables>;
export const HrCasesExportDocument = gql`
    query HrCasesExport($filter: HrCaseFilterInput) {
  hrCasesExport(filter: $filter) {
    ...HrCaseFields
  }
}
    ${HrCaseFieldsFragmentDoc}`;

/**
 * __useHrCasesExportQuery__
 *
 * To run a query within a React component, call `useHrCasesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrCasesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrCasesExportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHrCasesExportQuery(baseOptions?: Apollo.QueryHookOptions<HrCasesExportQuery, HrCasesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrCasesExportQuery, HrCasesExportQueryVariables>(HrCasesExportDocument, options);
      }
export function useHrCasesExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrCasesExportQuery, HrCasesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrCasesExportQuery, HrCasesExportQueryVariables>(HrCasesExportDocument, options);
        }
// @ts-ignore
export function useHrCasesExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HrCasesExportQuery, HrCasesExportQueryVariables>): Apollo.UseSuspenseQueryResult<HrCasesExportQuery, HrCasesExportQueryVariables>;
export function useHrCasesExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrCasesExportQuery, HrCasesExportQueryVariables>): Apollo.UseSuspenseQueryResult<HrCasesExportQuery | undefined, HrCasesExportQueryVariables>;
export function useHrCasesExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrCasesExportQuery, HrCasesExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrCasesExportQuery, HrCasesExportQueryVariables>(HrCasesExportDocument, options);
        }
export type HrCasesExportQueryHookResult = ReturnType<typeof useHrCasesExportQuery>;
export type HrCasesExportLazyQueryHookResult = ReturnType<typeof useHrCasesExportLazyQuery>;
export type HrCasesExportSuspenseQueryHookResult = ReturnType<typeof useHrCasesExportSuspenseQuery>;
export type HrCasesExportQueryResult = Apollo.QueryResult<HrCasesExportQuery, HrCasesExportQueryVariables>;
export const HrCaseMetricsDocument = gql`
    query HrCaseMetrics($from: DateTime!, $to: DateTime!, $filter: HrCaseMetricsFilterInput) {
  hrCaseMetrics(from: $from, to: $to, filter: $filter) {
    from
    to
    openCases {
      ...HrMetricFields
    }
    openByType {
      type
      count
    }
    newCases {
      ...HrMetricFields
    }
    disciplinaryCases {
      ...HrMetricFields
    }
    disciplinaryPer100 {
      ...HrMetricFields
    }
    bySanction {
      sanction
      count
    }
    activeWarnings {
      ...HrMetricFields
    }
    ccmaReferrals {
      ...HrMetricFields
    }
    disputeWinRate {
      ...HrMetricFields
    }
    disputesByOutcome {
      outcome
      count
    }
    averageDaysToClose {
      ...HrMetricFields
    }
    totalCost {
      ...HrMetricFields
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useHrCaseMetricsQuery__
 *
 * To run a query within a React component, call `useHrCaseMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrCaseMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrCaseMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useHrCaseMetricsQuery(baseOptions: Apollo.QueryHookOptions<HrCaseMetricsQuery, HrCaseMetricsQueryVariables> & ({ variables: HrCaseMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>(HrCaseMetricsDocument, options);
      }
export function useHrCaseMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>(HrCaseMetricsDocument, options);
        }
// @ts-ignore
export function useHrCaseMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>;
export function useHrCaseMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<HrCaseMetricsQuery | undefined, HrCaseMetricsQueryVariables>;
export function useHrCaseMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>(HrCaseMetricsDocument, options);
        }
export type HrCaseMetricsQueryHookResult = ReturnType<typeof useHrCaseMetricsQuery>;
export type HrCaseMetricsLazyQueryHookResult = ReturnType<typeof useHrCaseMetricsLazyQuery>;
export type HrCaseMetricsSuspenseQueryHookResult = ReturnType<typeof useHrCaseMetricsSuspenseQuery>;
export type HrCaseMetricsQueryResult = Apollo.QueryResult<HrCaseMetricsQuery, HrCaseMetricsQueryVariables>;
export const CreateHrCaseDocument = gql`
    mutation CreateHrCase($input: CreateHrCaseInput!) {
  createHrCase(input: $input) {
    ...HrCaseFields
  }
}
    ${HrCaseFieldsFragmentDoc}`;
export type CreateHrCaseMutationFn = Apollo.MutationFunction<CreateHrCaseMutation, CreateHrCaseMutationVariables>;

/**
 * __useCreateHrCaseMutation__
 *
 * To run a mutation, you first call `useCreateHrCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHrCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHrCaseMutation, { data, loading, error }] = useCreateHrCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHrCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateHrCaseMutation, CreateHrCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHrCaseMutation, CreateHrCaseMutationVariables>(CreateHrCaseDocument, options);
      }
export type CreateHrCaseMutationHookResult = ReturnType<typeof useCreateHrCaseMutation>;
export type CreateHrCaseMutationResult = Apollo.MutationResult<CreateHrCaseMutation>;
export type CreateHrCaseMutationOptions = Apollo.BaseMutationOptions<CreateHrCaseMutation, CreateHrCaseMutationVariables>;
export const UpdateHrCaseDocument = gql`
    mutation UpdateHrCase($id: ID!, $input: UpdateHrCaseInput!) {
  updateHrCase(id: $id, input: $input) {
    ...HrCaseFields
  }
}
    ${HrCaseFieldsFragmentDoc}`;
export type UpdateHrCaseMutationFn = Apollo.MutationFunction<UpdateHrCaseMutation, UpdateHrCaseMutationVariables>;

/**
 * __useUpdateHrCaseMutation__
 *
 * To run a mutation, you first call `useUpdateHrCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHrCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHrCaseMutation, { data, loading, error }] = useUpdateHrCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHrCaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHrCaseMutation, UpdateHrCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHrCaseMutation, UpdateHrCaseMutationVariables>(UpdateHrCaseDocument, options);
      }
export type UpdateHrCaseMutationHookResult = ReturnType<typeof useUpdateHrCaseMutation>;
export type UpdateHrCaseMutationResult = Apollo.MutationResult<UpdateHrCaseMutation>;
export type UpdateHrCaseMutationOptions = Apollo.BaseMutationOptions<UpdateHrCaseMutation, UpdateHrCaseMutationVariables>;
export const AddHrCaseNoteDocument = gql`
    mutation AddHrCaseNote($caseId: ID!, $input: HrCaseNoteInput!) {
  addHrCaseNote(caseId: $caseId, input: $input) {
    id
  }
}
    `;
export type AddHrCaseNoteMutationFn = Apollo.MutationFunction<AddHrCaseNoteMutation, AddHrCaseNoteMutationVariables>;

/**
 * __useAddHrCaseNoteMutation__
 *
 * To run a mutation, you first call `useAddHrCaseNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHrCaseNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHrCaseNoteMutation, { data, loading, error }] = useAddHrCaseNoteMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddHrCaseNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddHrCaseNoteMutation, AddHrCaseNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddHrCaseNoteMutation, AddHrCaseNoteMutationVariables>(AddHrCaseNoteDocument, options);
      }
export type AddHrCaseNoteMutationHookResult = ReturnType<typeof useAddHrCaseNoteMutation>;
export type AddHrCaseNoteMutationResult = Apollo.MutationResult<AddHrCaseNoteMutation>;
export type AddHrCaseNoteMutationOptions = Apollo.BaseMutationOptions<AddHrCaseNoteMutation, AddHrCaseNoteMutationVariables>;
export const RemoveHrCaseDocumentDocument = gql`
    mutation RemoveHrCaseDocument($id: ID!) {
  removeHrCaseDocument(id: $id)
}
    `;
export type RemoveHrCaseDocumentMutationFn = Apollo.MutationFunction<RemoveHrCaseDocumentMutation, RemoveHrCaseDocumentMutationVariables>;

/**
 * __useRemoveHrCaseDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveHrCaseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHrCaseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHrCaseDocumentMutation, { data, loading, error }] = useRemoveHrCaseDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveHrCaseDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveHrCaseDocumentMutation, RemoveHrCaseDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveHrCaseDocumentMutation, RemoveHrCaseDocumentMutationVariables>(RemoveHrCaseDocumentDocument, options);
      }
export type RemoveHrCaseDocumentMutationHookResult = ReturnType<typeof useRemoveHrCaseDocumentMutation>;
export type RemoveHrCaseDocumentMutationResult = Apollo.MutationResult<RemoveHrCaseDocumentMutation>;
export type RemoveHrCaseDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveHrCaseDocumentMutation, RemoveHrCaseDocumentMutationVariables>;
export const SendInviteDocument = gql`
    mutation SendInvite($input: SendInviteInput!) {
  sendInvite(input: $input) {
    success
    message
  }
}
    `;
export type SendInviteMutationFn = Apollo.MutationFunction<SendInviteMutation, SendInviteMutationVariables>;

/**
 * __useSendInviteMutation__
 *
 * To run a mutation, you first call `useSendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteMutation, { data, loading, error }] = useSendInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendInviteMutation, SendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInviteMutation, SendInviteMutationVariables>(SendInviteDocument, options);
      }
export type SendInviteMutationHookResult = ReturnType<typeof useSendInviteMutation>;
export type SendInviteMutationResult = Apollo.MutationResult<SendInviteMutation>;
export type SendInviteMutationOptions = Apollo.BaseMutationOptions<SendInviteMutation, SendInviteMutationVariables>;
export const RevokeInviteDocument = gql`
    mutation RevokeInvite($id: String!) {
  revokeInvite(id: $id) {
    success
    message
  }
}
    `;
export type RevokeInviteMutationFn = Apollo.MutationFunction<RevokeInviteMutation, RevokeInviteMutationVariables>;

/**
 * __useRevokeInviteMutation__
 *
 * To run a mutation, you first call `useRevokeInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInviteMutation, { data, loading, error }] = useRevokeInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeInviteMutation(baseOptions?: Apollo.MutationHookOptions<RevokeInviteMutation, RevokeInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeInviteMutation, RevokeInviteMutationVariables>(RevokeInviteDocument, options);
      }
export type RevokeInviteMutationHookResult = ReturnType<typeof useRevokeInviteMutation>;
export type RevokeInviteMutationResult = Apollo.MutationResult<RevokeInviteMutation>;
export type RevokeInviteMutationOptions = Apollo.BaseMutationOptions<RevokeInviteMutation, RevokeInviteMutationVariables>;
export const ResendInviteDocument = gql`
    mutation ResendInvite($id: String!) {
  resendInvite(id: $id) {
    success
    message
  }
}
    `;
export type ResendInviteMutationFn = Apollo.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const BulkInviteDocument = gql`
    mutation BulkInvite($input: BulkInviteInput!) {
  bulkInvite(input: $input) {
    sent
    pendingApproval
    failed {
      email
      reason
    }
  }
}
    `;
export type BulkInviteMutationFn = Apollo.MutationFunction<BulkInviteMutation, BulkInviteMutationVariables>;

/**
 * __useBulkInviteMutation__
 *
 * To run a mutation, you first call `useBulkInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkInviteMutation, { data, loading, error }] = useBulkInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkInviteMutation(baseOptions?: Apollo.MutationHookOptions<BulkInviteMutation, BulkInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkInviteMutation, BulkInviteMutationVariables>(BulkInviteDocument, options);
      }
export type BulkInviteMutationHookResult = ReturnType<typeof useBulkInviteMutation>;
export type BulkInviteMutationResult = Apollo.MutationResult<BulkInviteMutation>;
export type BulkInviteMutationOptions = Apollo.BaseMutationOptions<BulkInviteMutation, BulkInviteMutationVariables>;
export const BulkSendInvitesDocument = gql`
    mutation BulkSendInvites($input: BulkSendInvitesInput!) {
  bulkSendInvites(input: $input) {
    total
    succeeded
    failed
    skipped
    pendingApproval
    rows {
      rowNumber
      identifier
      status
      reason
    }
  }
}
    `;
export type BulkSendInvitesMutationFn = Apollo.MutationFunction<BulkSendInvitesMutation, BulkSendInvitesMutationVariables>;

/**
 * __useBulkSendInvitesMutation__
 *
 * To run a mutation, you first call `useBulkSendInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSendInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSendInvitesMutation, { data, loading, error }] = useBulkSendInvitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkSendInvitesMutation(baseOptions?: Apollo.MutationHookOptions<BulkSendInvitesMutation, BulkSendInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSendInvitesMutation, BulkSendInvitesMutationVariables>(BulkSendInvitesDocument, options);
      }
export type BulkSendInvitesMutationHookResult = ReturnType<typeof useBulkSendInvitesMutation>;
export type BulkSendInvitesMutationResult = Apollo.MutationResult<BulkSendInvitesMutation>;
export type BulkSendInvitesMutationOptions = Apollo.BaseMutationOptions<BulkSendInvitesMutation, BulkSendInvitesMutationVariables>;
export const GetPendingInvitesDocument = gql`
    query GetPendingInvites {
  pendingInvites {
    id
    email
    roleId
    invitedBy
    isAgent
    agentType
    firstName
    lastName
    createdAt
    expiresAt
  }
}
    `;

/**
 * __useGetPendingInvitesQuery__
 *
 * To run a query within a React component, call `useGetPendingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>(GetPendingInvitesDocument, options);
      }
export function useGetPendingInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>(GetPendingInvitesDocument, options);
        }
// @ts-ignore
export function useGetPendingInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>;
export function useGetPendingInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingInvitesQuery | undefined, GetPendingInvitesQueryVariables>;
export function useGetPendingInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>(GetPendingInvitesDocument, options);
        }
export type GetPendingInvitesQueryHookResult = ReturnType<typeof useGetPendingInvitesQuery>;
export type GetPendingInvitesLazyQueryHookResult = ReturnType<typeof useGetPendingInvitesLazyQuery>;
export type GetPendingInvitesSuspenseQueryHookResult = ReturnType<typeof useGetPendingInvitesSuspenseQuery>;
export type GetPendingInvitesQueryResult = Apollo.QueryResult<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>;
export const GetItemCategoriesDocument = gql`
    query GetItemCategories {
  itemCategories {
    ...ItemCategoryFields
    children {
      ...ItemCategoryFields
    }
  }
}
    ${ItemCategoryFieldsFragmentDoc}`;

/**
 * __useGetItemCategoriesQuery__
 *
 * To run a query within a React component, call `useGetItemCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetItemCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>(GetItemCategoriesDocument, options);
      }
export function useGetItemCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>(GetItemCategoriesDocument, options);
        }
// @ts-ignore
export function useGetItemCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>;
export function useGetItemCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetItemCategoriesQuery | undefined, GetItemCategoriesQueryVariables>;
export function useGetItemCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>(GetItemCategoriesDocument, options);
        }
export type GetItemCategoriesQueryHookResult = ReturnType<typeof useGetItemCategoriesQuery>;
export type GetItemCategoriesLazyQueryHookResult = ReturnType<typeof useGetItemCategoriesLazyQuery>;
export type GetItemCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetItemCategoriesSuspenseQuery>;
export type GetItemCategoriesQueryResult = Apollo.QueryResult<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>;
export const CreateItemCategoryDocument = gql`
    mutation CreateItemCategory($input: CreateItemCategoryInput!) {
  createItemCategory(input: $input) {
    id
  }
}
    `;
export type CreateItemCategoryMutationFn = Apollo.MutationFunction<CreateItemCategoryMutation, CreateItemCategoryMutationVariables>;

/**
 * __useCreateItemCategoryMutation__
 *
 * To run a mutation, you first call `useCreateItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemCategoryMutation, { data, loading, error }] = useCreateItemCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemCategoryMutation, CreateItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemCategoryMutation, CreateItemCategoryMutationVariables>(CreateItemCategoryDocument, options);
      }
export type CreateItemCategoryMutationHookResult = ReturnType<typeof useCreateItemCategoryMutation>;
export type CreateItemCategoryMutationResult = Apollo.MutationResult<CreateItemCategoryMutation>;
export type CreateItemCategoryMutationOptions = Apollo.BaseMutationOptions<CreateItemCategoryMutation, CreateItemCategoryMutationVariables>;
export const UpdateItemCategoryDocument = gql`
    mutation UpdateItemCategory($id: String!, $input: UpdateItemCategoryInput!) {
  updateItemCategory(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateItemCategoryMutationFn = Apollo.MutationFunction<UpdateItemCategoryMutation, UpdateItemCategoryMutationVariables>;

/**
 * __useUpdateItemCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemCategoryMutation, { data, loading, error }] = useUpdateItemCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemCategoryMutation, UpdateItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemCategoryMutation, UpdateItemCategoryMutationVariables>(UpdateItemCategoryDocument, options);
      }
export type UpdateItemCategoryMutationHookResult = ReturnType<typeof useUpdateItemCategoryMutation>;
export type UpdateItemCategoryMutationResult = Apollo.MutationResult<UpdateItemCategoryMutation>;
export type UpdateItemCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateItemCategoryMutation, UpdateItemCategoryMutationVariables>;
export const DeleteItemCategoryDocument = gql`
    mutation DeleteItemCategory($id: String!) {
  deleteItemCategory(id: $id) {
    id
  }
}
    `;
export type DeleteItemCategoryMutationFn = Apollo.MutationFunction<DeleteItemCategoryMutation, DeleteItemCategoryMutationVariables>;

/**
 * __useDeleteItemCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteItemCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemCategoryMutation, { data, loading, error }] = useDeleteItemCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteItemCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemCategoryMutation, DeleteItemCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemCategoryMutation, DeleteItemCategoryMutationVariables>(DeleteItemCategoryDocument, options);
      }
export type DeleteItemCategoryMutationHookResult = ReturnType<typeof useDeleteItemCategoryMutation>;
export type DeleteItemCategoryMutationResult = Apollo.MutationResult<DeleteItemCategoryMutation>;
export type DeleteItemCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteItemCategoryMutation, DeleteItemCategoryMutationVariables>;
export const ReorderItemCategoriesDocument = gql`
    mutation ReorderItemCategories($parentId: String, $orderedIds: [String!]!) {
  reorderItemCategories(parentId: $parentId, orderedIds: $orderedIds) {
    id
    position
  }
}
    `;
export type ReorderItemCategoriesMutationFn = Apollo.MutationFunction<ReorderItemCategoriesMutation, ReorderItemCategoriesMutationVariables>;

/**
 * __useReorderItemCategoriesMutation__
 *
 * To run a mutation, you first call `useReorderItemCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderItemCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderItemCategoriesMutation, { data, loading, error }] = useReorderItemCategoriesMutation({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      orderedIds: // value for 'orderedIds'
 *   },
 * });
 */
export function useReorderItemCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderItemCategoriesMutation, ReorderItemCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderItemCategoriesMutation, ReorderItemCategoriesMutationVariables>(ReorderItemCategoriesDocument, options);
      }
export type ReorderItemCategoriesMutationHookResult = ReturnType<typeof useReorderItemCategoriesMutation>;
export type ReorderItemCategoriesMutationResult = Apollo.MutationResult<ReorderItemCategoriesMutation>;
export type ReorderItemCategoriesMutationOptions = Apollo.BaseMutationOptions<ReorderItemCategoriesMutation, ReorderItemCategoriesMutationVariables>;
export const ResetItemCategoryOrderDocument = gql`
    mutation ResetItemCategoryOrder($parentId: String) {
  resetItemCategoryOrder(parentId: $parentId) {
    id
    position
  }
}
    `;
export type ResetItemCategoryOrderMutationFn = Apollo.MutationFunction<ResetItemCategoryOrderMutation, ResetItemCategoryOrderMutationVariables>;

/**
 * __useResetItemCategoryOrderMutation__
 *
 * To run a mutation, you first call `useResetItemCategoryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetItemCategoryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetItemCategoryOrderMutation, { data, loading, error }] = useResetItemCategoryOrderMutation({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useResetItemCategoryOrderMutation(baseOptions?: Apollo.MutationHookOptions<ResetItemCategoryOrderMutation, ResetItemCategoryOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetItemCategoryOrderMutation, ResetItemCategoryOrderMutationVariables>(ResetItemCategoryOrderDocument, options);
      }
export type ResetItemCategoryOrderMutationHookResult = ReturnType<typeof useResetItemCategoryOrderMutation>;
export type ResetItemCategoryOrderMutationResult = Apollo.MutationResult<ResetItemCategoryOrderMutation>;
export type ResetItemCategoryOrderMutationOptions = Apollo.BaseMutationOptions<ResetItemCategoryOrderMutation, ResetItemCategoryOrderMutationVariables>;
export const GetLeadsDocument = gql`
    query GetLeads($input: LeadSearchInput) {
  leads(input: $input) {
    items {
      id
      leadNumber
      firstName
      lastName
      fullName
      phone
      email
      idNumber
      createdAt
      estimatedValue
      status {
        id
        name
        color
        category
      }
      source {
        id
        name
      }
      assignedTo {
        id
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetLeadsQuery__
 *
 * To run a query within a React component, call `useGetLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLeadsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadsQuery, GetLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadsQuery, GetLeadsQueryVariables>(GetLeadsDocument, options);
      }
export function useGetLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadsQuery, GetLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadsQuery, GetLeadsQueryVariables>(GetLeadsDocument, options);
        }
// @ts-ignore
export function useGetLeadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadsQuery, GetLeadsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadsQuery, GetLeadsQueryVariables>;
export function useGetLeadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadsQuery, GetLeadsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadsQuery | undefined, GetLeadsQueryVariables>;
export function useGetLeadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadsQuery, GetLeadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadsQuery, GetLeadsQueryVariables>(GetLeadsDocument, options);
        }
export type GetLeadsQueryHookResult = ReturnType<typeof useGetLeadsQuery>;
export type GetLeadsLazyQueryHookResult = ReturnType<typeof useGetLeadsLazyQuery>;
export type GetLeadsSuspenseQueryHookResult = ReturnType<typeof useGetLeadsSuspenseQuery>;
export type GetLeadsQueryResult = Apollo.QueryResult<GetLeadsQuery, GetLeadsQueryVariables>;
export const GetLeadDocument = gql`
    query GetLead($id: String!) {
  lead(id: $id) {
    id
    leadNumber
    firstName
    lastName
    fullName
    country
    phone
    email
    identificationType
    idNumber
    notes
    preferredChannel
    estimatedValue
    createdAt
    convertedAt
    products {
      id
      quantity
      unitValue
      lineValue
      product {
        id
        name
        sku
      }
      ratePlan {
        id
        rateName
      }
    }
    status {
      id
      name
      color
      category
    }
    source {
      id
      name
    }
    assignedTo {
      id
      firstName
      lastName
      email
    }
    createdBy {
      id
      firstName
      lastName
    }
    convertedCustomer {
      id
      fullName
    }
  }
}
    `;

/**
 * __useGetLeadQuery__
 *
 * To run a query within a React component, call `useGetLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeadQuery(baseOptions: Apollo.QueryHookOptions<GetLeadQuery, GetLeadQueryVariables> & ({ variables: GetLeadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadQuery, GetLeadQueryVariables>(GetLeadDocument, options);
      }
export function useGetLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadQuery, GetLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadQuery, GetLeadQueryVariables>(GetLeadDocument, options);
        }
// @ts-ignore
export function useGetLeadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadQuery, GetLeadQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadQuery, GetLeadQueryVariables>;
export function useGetLeadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadQuery, GetLeadQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadQuery | undefined, GetLeadQueryVariables>;
export function useGetLeadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadQuery, GetLeadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadQuery, GetLeadQueryVariables>(GetLeadDocument, options);
        }
export type GetLeadQueryHookResult = ReturnType<typeof useGetLeadQuery>;
export type GetLeadLazyQueryHookResult = ReturnType<typeof useGetLeadLazyQuery>;
export type GetLeadSuspenseQueryHookResult = ReturnType<typeof useGetLeadSuspenseQuery>;
export type GetLeadQueryResult = Apollo.QueryResult<GetLeadQuery, GetLeadQueryVariables>;
export const GetLeadCategoryCountsDocument = gql`
    query GetLeadCategoryCounts {
  leadCategoryCounts {
    open
    converted
    lost
  }
}
    `;

/**
 * __useGetLeadCategoryCountsQuery__
 *
 * To run a query within a React component, call `useGetLeadCategoryCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadCategoryCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadCategoryCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeadCategoryCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>(GetLeadCategoryCountsDocument, options);
      }
export function useGetLeadCategoryCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>(GetLeadCategoryCountsDocument, options);
        }
// @ts-ignore
export function useGetLeadCategoryCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>;
export function useGetLeadCategoryCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadCategoryCountsQuery | undefined, GetLeadCategoryCountsQueryVariables>;
export function useGetLeadCategoryCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>(GetLeadCategoryCountsDocument, options);
        }
export type GetLeadCategoryCountsQueryHookResult = ReturnType<typeof useGetLeadCategoryCountsQuery>;
export type GetLeadCategoryCountsLazyQueryHookResult = ReturnType<typeof useGetLeadCategoryCountsLazyQuery>;
export type GetLeadCategoryCountsSuspenseQueryHookResult = ReturnType<typeof useGetLeadCategoryCountsSuspenseQuery>;
export type GetLeadCategoryCountsQueryResult = Apollo.QueryResult<GetLeadCategoryCountsQuery, GetLeadCategoryCountsQueryVariables>;
export const GetLeadAssignableUsersDocument = gql`
    query GetLeadAssignableUsers {
  leadAssignableUsers {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useGetLeadAssignableUsersQuery__
 *
 * To run a query within a React component, call `useGetLeadAssignableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadAssignableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadAssignableUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeadAssignableUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>(GetLeadAssignableUsersDocument, options);
      }
export function useGetLeadAssignableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>(GetLeadAssignableUsersDocument, options);
        }
// @ts-ignore
export function useGetLeadAssignableUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>;
export function useGetLeadAssignableUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadAssignableUsersQuery | undefined, GetLeadAssignableUsersQueryVariables>;
export function useGetLeadAssignableUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>(GetLeadAssignableUsersDocument, options);
        }
export type GetLeadAssignableUsersQueryHookResult = ReturnType<typeof useGetLeadAssignableUsersQuery>;
export type GetLeadAssignableUsersLazyQueryHookResult = ReturnType<typeof useGetLeadAssignableUsersLazyQuery>;
export type GetLeadAssignableUsersSuspenseQueryHookResult = ReturnType<typeof useGetLeadAssignableUsersSuspenseQuery>;
export type GetLeadAssignableUsersQueryResult = Apollo.QueryResult<GetLeadAssignableUsersQuery, GetLeadAssignableUsersQueryVariables>;
export const CheckDuplicateLeadDocument = gql`
    query CheckDuplicateLead($input: CheckDuplicateLeadInput!) {
  checkDuplicateLead(input: $input) {
    hasConflict
    hasHardConflict
    customerMatches {
      id
      firstName
      lastName
      idNumber
      phone
      email
      status
      matchedOn
      isHard
    }
    leadMatches {
      id
      firstName
      lastName
      idNumber
      phone
      email
      statusName
      matchedOn
      isHard
    }
  }
}
    `;

/**
 * __useCheckDuplicateLeadQuery__
 *
 * To run a query within a React component, call `useCheckDuplicateLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDuplicateLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDuplicateLeadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckDuplicateLeadQuery(baseOptions: Apollo.QueryHookOptions<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables> & ({ variables: CheckDuplicateLeadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>(CheckDuplicateLeadDocument, options);
      }
export function useCheckDuplicateLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>(CheckDuplicateLeadDocument, options);
        }
// @ts-ignore
export function useCheckDuplicateLeadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>): Apollo.UseSuspenseQueryResult<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>;
export function useCheckDuplicateLeadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>): Apollo.UseSuspenseQueryResult<CheckDuplicateLeadQuery | undefined, CheckDuplicateLeadQueryVariables>;
export function useCheckDuplicateLeadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>(CheckDuplicateLeadDocument, options);
        }
export type CheckDuplicateLeadQueryHookResult = ReturnType<typeof useCheckDuplicateLeadQuery>;
export type CheckDuplicateLeadLazyQueryHookResult = ReturnType<typeof useCheckDuplicateLeadLazyQuery>;
export type CheckDuplicateLeadSuspenseQueryHookResult = ReturnType<typeof useCheckDuplicateLeadSuspenseQuery>;
export type CheckDuplicateLeadQueryResult = Apollo.QueryResult<CheckDuplicateLeadQuery, CheckDuplicateLeadQueryVariables>;
export const GetLeadStatusesDocument = gql`
    query GetLeadStatuses {
  leadStatuses {
    id
    name
    color
    sortOrder
    category
    isSystem
    isDefault
  }
}
    `;

/**
 * __useGetLeadStatusesQuery__
 *
 * To run a query within a React component, call `useGetLeadStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeadStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>(GetLeadStatusesDocument, options);
      }
export function useGetLeadStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>(GetLeadStatusesDocument, options);
        }
// @ts-ignore
export function useGetLeadStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>;
export function useGetLeadStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadStatusesQuery | undefined, GetLeadStatusesQueryVariables>;
export function useGetLeadStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>(GetLeadStatusesDocument, options);
        }
export type GetLeadStatusesQueryHookResult = ReturnType<typeof useGetLeadStatusesQuery>;
export type GetLeadStatusesLazyQueryHookResult = ReturnType<typeof useGetLeadStatusesLazyQuery>;
export type GetLeadStatusesSuspenseQueryHookResult = ReturnType<typeof useGetLeadStatusesSuspenseQuery>;
export type GetLeadStatusesQueryResult = Apollo.QueryResult<GetLeadStatusesQuery, GetLeadStatusesQueryVariables>;
export const GetLeadSourcesDocument = gql`
    query GetLeadSources {
  leadSources {
    id
    name
    sortOrder
    isDefault
  }
}
    `;

/**
 * __useGetLeadSourcesQuery__
 *
 * To run a query within a React component, call `useGetLeadSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeadSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>(GetLeadSourcesDocument, options);
      }
export function useGetLeadSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>(GetLeadSourcesDocument, options);
        }
// @ts-ignore
export function useGetLeadSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>;
export function useGetLeadSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeadSourcesQuery | undefined, GetLeadSourcesQueryVariables>;
export function useGetLeadSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>(GetLeadSourcesDocument, options);
        }
export type GetLeadSourcesQueryHookResult = ReturnType<typeof useGetLeadSourcesQuery>;
export type GetLeadSourcesLazyQueryHookResult = ReturnType<typeof useGetLeadSourcesLazyQuery>;
export type GetLeadSourcesSuspenseQueryHookResult = ReturnType<typeof useGetLeadSourcesSuspenseQuery>;
export type GetLeadSourcesQueryResult = Apollo.QueryResult<GetLeadSourcesQuery, GetLeadSourcesQueryVariables>;
export const CreateLeadDocument = gql`
    mutation CreateLead($input: CreateLeadInput!) {
  createLead(input: $input) {
    id
    firstName
    lastName
    fullName
  }
}
    `;
export type CreateLeadMutationFn = Apollo.MutationFunction<CreateLeadMutation, CreateLeadMutationVariables>;

/**
 * __useCreateLeadMutation__
 *
 * To run a mutation, you first call `useCreateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadMutation, { data, loading, error }] = useCreateLeadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadMutation, CreateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadMutation, CreateLeadMutationVariables>(CreateLeadDocument, options);
      }
export type CreateLeadMutationHookResult = ReturnType<typeof useCreateLeadMutation>;
export type CreateLeadMutationResult = Apollo.MutationResult<CreateLeadMutation>;
export type CreateLeadMutationOptions = Apollo.BaseMutationOptions<CreateLeadMutation, CreateLeadMutationVariables>;
export const UpdateLeadDocument = gql`
    mutation UpdateLead($id: String!, $input: UpdateLeadInput!) {
  updateLead(id: $id, input: $input) {
    id
    firstName
    lastName
    phone
    email
    idNumber
    notes
    preferredChannel
    estimatedValue
    products {
      id
      quantity
      unitValue
      lineValue
      product {
        id
        name
        sku
      }
      ratePlan {
        id
        rateName
      }
    }
    source {
      id
      name
    }
  }
}
    `;
export type UpdateLeadMutationFn = Apollo.MutationFunction<UpdateLeadMutation, UpdateLeadMutationVariables>;

/**
 * __useUpdateLeadMutation__
 *
 * To run a mutation, you first call `useUpdateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadMutation, { data, loading, error }] = useUpdateLeadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadMutation, UpdateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadMutation, UpdateLeadMutationVariables>(UpdateLeadDocument, options);
      }
export type UpdateLeadMutationHookResult = ReturnType<typeof useUpdateLeadMutation>;
export type UpdateLeadMutationResult = Apollo.MutationResult<UpdateLeadMutation>;
export type UpdateLeadMutationOptions = Apollo.BaseMutationOptions<UpdateLeadMutation, UpdateLeadMutationVariables>;
export const ChangeLeadStatusDocument = gql`
    mutation ChangeLeadStatus($id: String!, $statusId: String!) {
  changeLeadStatus(id: $id, statusId: $statusId) {
    id
    status {
      id
      name
      category
    }
  }
}
    `;
export type ChangeLeadStatusMutationFn = Apollo.MutationFunction<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;

/**
 * __useChangeLeadStatusMutation__
 *
 * To run a mutation, you first call `useChangeLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLeadStatusMutation, { data, loading, error }] = useChangeLeadStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useChangeLeadStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>(ChangeLeadStatusDocument, options);
      }
export type ChangeLeadStatusMutationHookResult = ReturnType<typeof useChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationResult = Apollo.MutationResult<ChangeLeadStatusMutation>;
export type ChangeLeadStatusMutationOptions = Apollo.BaseMutationOptions<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables>;
export const ReassignLeadDocument = gql`
    mutation ReassignLead($id: String!, $assignedToId: String!) {
  reassignLead(id: $id, assignedToId: $assignedToId) {
    id
    assignedTo {
      id
      firstName
      lastName
    }
  }
}
    `;
export type ReassignLeadMutationFn = Apollo.MutationFunction<ReassignLeadMutation, ReassignLeadMutationVariables>;

/**
 * __useReassignLeadMutation__
 *
 * To run a mutation, you first call `useReassignLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignLeadMutation, { data, loading, error }] = useReassignLeadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assignedToId: // value for 'assignedToId'
 *   },
 * });
 */
export function useReassignLeadMutation(baseOptions?: Apollo.MutationHookOptions<ReassignLeadMutation, ReassignLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignLeadMutation, ReassignLeadMutationVariables>(ReassignLeadDocument, options);
      }
export type ReassignLeadMutationHookResult = ReturnType<typeof useReassignLeadMutation>;
export type ReassignLeadMutationResult = Apollo.MutationResult<ReassignLeadMutation>;
export type ReassignLeadMutationOptions = Apollo.BaseMutationOptions<ReassignLeadMutation, ReassignLeadMutationVariables>;
export const ConvertLeadDocument = gql`
    mutation ConvertLead($id: String!) {
  convertLead(id: $id) {
    customerId
    linked
  }
}
    `;
export type ConvertLeadMutationFn = Apollo.MutationFunction<ConvertLeadMutation, ConvertLeadMutationVariables>;

/**
 * __useConvertLeadMutation__
 *
 * To run a mutation, you first call `useConvertLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertLeadMutation, { data, loading, error }] = useConvertLeadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConvertLeadMutation(baseOptions?: Apollo.MutationHookOptions<ConvertLeadMutation, ConvertLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertLeadMutation, ConvertLeadMutationVariables>(ConvertLeadDocument, options);
      }
export type ConvertLeadMutationHookResult = ReturnType<typeof useConvertLeadMutation>;
export type ConvertLeadMutationResult = Apollo.MutationResult<ConvertLeadMutation>;
export type ConvertLeadMutationOptions = Apollo.BaseMutationOptions<ConvertLeadMutation, ConvertLeadMutationVariables>;
export const CreateLeadStatusDocument = gql`
    mutation CreateLeadStatus($input: CreateLeadStatusInput!) {
  createLeadStatus(input: $input) {
    id
    name
    category
  }
}
    `;
export type CreateLeadStatusMutationFn = Apollo.MutationFunction<CreateLeadStatusMutation, CreateLeadStatusMutationVariables>;

/**
 * __useCreateLeadStatusMutation__
 *
 * To run a mutation, you first call `useCreateLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadStatusMutation, { data, loading, error }] = useCreateLeadStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeadStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadStatusMutation, CreateLeadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadStatusMutation, CreateLeadStatusMutationVariables>(CreateLeadStatusDocument, options);
      }
export type CreateLeadStatusMutationHookResult = ReturnType<typeof useCreateLeadStatusMutation>;
export type CreateLeadStatusMutationResult = Apollo.MutationResult<CreateLeadStatusMutation>;
export type CreateLeadStatusMutationOptions = Apollo.BaseMutationOptions<CreateLeadStatusMutation, CreateLeadStatusMutationVariables>;
export const UpdateLeadStatusDocument = gql`
    mutation UpdateLeadStatus($id: String!, $input: UpdateLeadStatusInput!) {
  updateLeadStatus(id: $id, input: $input) {
    id
    name
    color
    sortOrder
    category
    isDefault
  }
}
    `;
export type UpdateLeadStatusMutationFn = Apollo.MutationFunction<UpdateLeadStatusMutation, UpdateLeadStatusMutationVariables>;

/**
 * __useUpdateLeadStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadStatusMutation, { data, loading, error }] = useUpdateLeadStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeadStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadStatusMutation, UpdateLeadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadStatusMutation, UpdateLeadStatusMutationVariables>(UpdateLeadStatusDocument, options);
      }
export type UpdateLeadStatusMutationHookResult = ReturnType<typeof useUpdateLeadStatusMutation>;
export type UpdateLeadStatusMutationResult = Apollo.MutationResult<UpdateLeadStatusMutation>;
export type UpdateLeadStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLeadStatusMutation, UpdateLeadStatusMutationVariables>;
export const DeleteLeadStatusDocument = gql`
    mutation DeleteLeadStatus($id: String!) {
  deleteLeadStatus(id: $id) {
    id
  }
}
    `;
export type DeleteLeadStatusMutationFn = Apollo.MutationFunction<DeleteLeadStatusMutation, DeleteLeadStatusMutationVariables>;

/**
 * __useDeleteLeadStatusMutation__
 *
 * To run a mutation, you first call `useDeleteLeadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeadStatusMutation, { data, loading, error }] = useDeleteLeadStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLeadStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeadStatusMutation, DeleteLeadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeadStatusMutation, DeleteLeadStatusMutationVariables>(DeleteLeadStatusDocument, options);
      }
export type DeleteLeadStatusMutationHookResult = ReturnType<typeof useDeleteLeadStatusMutation>;
export type DeleteLeadStatusMutationResult = Apollo.MutationResult<DeleteLeadStatusMutation>;
export type DeleteLeadStatusMutationOptions = Apollo.BaseMutationOptions<DeleteLeadStatusMutation, DeleteLeadStatusMutationVariables>;
export const CreateLeadSourceDocument = gql`
    mutation CreateLeadSource($input: CreateLeadSourceInput!) {
  createLeadSource(input: $input) {
    id
    name
  }
}
    `;
export type CreateLeadSourceMutationFn = Apollo.MutationFunction<CreateLeadSourceMutation, CreateLeadSourceMutationVariables>;

/**
 * __useCreateLeadSourceMutation__
 *
 * To run a mutation, you first call `useCreateLeadSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadSourceMutation, { data, loading, error }] = useCreateLeadSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeadSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadSourceMutation, CreateLeadSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadSourceMutation, CreateLeadSourceMutationVariables>(CreateLeadSourceDocument, options);
      }
export type CreateLeadSourceMutationHookResult = ReturnType<typeof useCreateLeadSourceMutation>;
export type CreateLeadSourceMutationResult = Apollo.MutationResult<CreateLeadSourceMutation>;
export type CreateLeadSourceMutationOptions = Apollo.BaseMutationOptions<CreateLeadSourceMutation, CreateLeadSourceMutationVariables>;
export const UpdateLeadSourceDocument = gql`
    mutation UpdateLeadSource($id: String!, $input: UpdateLeadSourceInput!) {
  updateLeadSource(id: $id, input: $input) {
    id
    name
    sortOrder
    isDefault
  }
}
    `;
export type UpdateLeadSourceMutationFn = Apollo.MutationFunction<UpdateLeadSourceMutation, UpdateLeadSourceMutationVariables>;

/**
 * __useUpdateLeadSourceMutation__
 *
 * To run a mutation, you first call `useUpdateLeadSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadSourceMutation, { data, loading, error }] = useUpdateLeadSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeadSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadSourceMutation, UpdateLeadSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadSourceMutation, UpdateLeadSourceMutationVariables>(UpdateLeadSourceDocument, options);
      }
export type UpdateLeadSourceMutationHookResult = ReturnType<typeof useUpdateLeadSourceMutation>;
export type UpdateLeadSourceMutationResult = Apollo.MutationResult<UpdateLeadSourceMutation>;
export type UpdateLeadSourceMutationOptions = Apollo.BaseMutationOptions<UpdateLeadSourceMutation, UpdateLeadSourceMutationVariables>;
export const DeleteLeadSourceDocument = gql`
    mutation DeleteLeadSource($id: String!) {
  deleteLeadSource(id: $id) {
    id
  }
}
    `;
export type DeleteLeadSourceMutationFn = Apollo.MutationFunction<DeleteLeadSourceMutation, DeleteLeadSourceMutationVariables>;

/**
 * __useDeleteLeadSourceMutation__
 *
 * To run a mutation, you first call `useDeleteLeadSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeadSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeadSourceMutation, { data, loading, error }] = useDeleteLeadSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLeadSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeadSourceMutation, DeleteLeadSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeadSourceMutation, DeleteLeadSourceMutationVariables>(DeleteLeadSourceDocument, options);
      }
export type DeleteLeadSourceMutationHookResult = ReturnType<typeof useDeleteLeadSourceMutation>;
export type DeleteLeadSourceMutationResult = Apollo.MutationResult<DeleteLeadSourceMutation>;
export type DeleteLeadSourceMutationOptions = Apollo.BaseMutationOptions<DeleteLeadSourceMutation, DeleteLeadSourceMutationVariables>;
export const ExportLeadsDocument = gql`
    query ExportLeads($input: LeadSearchInput) {
  exportLeads(input: $input) {
    totalCount
    items {
      leadNumber
      firstName
      lastName
      phone
      email
      idNumber
      estimatedValue
      createdAt
      status {
        name
        category
      }
      source {
        name
      }
      assignedTo {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useExportLeadsQuery__
 *
 * To run a query within a React component, call `useExportLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportLeadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportLeadsQuery(baseOptions?: Apollo.QueryHookOptions<ExportLeadsQuery, ExportLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportLeadsQuery, ExportLeadsQueryVariables>(ExportLeadsDocument, options);
      }
export function useExportLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportLeadsQuery, ExportLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportLeadsQuery, ExportLeadsQueryVariables>(ExportLeadsDocument, options);
        }
// @ts-ignore
export function useExportLeadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportLeadsQuery, ExportLeadsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportLeadsQuery, ExportLeadsQueryVariables>;
export function useExportLeadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportLeadsQuery, ExportLeadsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportLeadsQuery | undefined, ExportLeadsQueryVariables>;
export function useExportLeadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportLeadsQuery, ExportLeadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportLeadsQuery, ExportLeadsQueryVariables>(ExportLeadsDocument, options);
        }
export type ExportLeadsQueryHookResult = ReturnType<typeof useExportLeadsQuery>;
export type ExportLeadsLazyQueryHookResult = ReturnType<typeof useExportLeadsLazyQuery>;
export type ExportLeadsSuspenseQueryHookResult = ReturnType<typeof useExportLeadsSuspenseQuery>;
export type ExportLeadsQueryResult = Apollo.QueryResult<ExportLeadsQuery, ExportLeadsQueryVariables>;
export const LegacySourceRecordsDocument = gql`
    query LegacySourceRecords($entityType: LegacyEntityType!, $entityId: String!) {
  legacySourceRecords(entityType: $entityType, entityId: $entityId) {
    entityType
    entityId
    externalId
    system
    available
    message
    records {
      system
      recordType
      sourceTable
      sourceId
      syncedAt
      data
    }
  }
}
    `;

/**
 * __useLegacySourceRecordsQuery__
 *
 * To run a query within a React component, call `useLegacySourceRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacySourceRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacySourceRecordsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useLegacySourceRecordsQuery(baseOptions: Apollo.QueryHookOptions<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables> & ({ variables: LegacySourceRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>(LegacySourceRecordsDocument, options);
      }
export function useLegacySourceRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>(LegacySourceRecordsDocument, options);
        }
// @ts-ignore
export function useLegacySourceRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>;
export function useLegacySourceRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<LegacySourceRecordsQuery | undefined, LegacySourceRecordsQueryVariables>;
export function useLegacySourceRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>(LegacySourceRecordsDocument, options);
        }
export type LegacySourceRecordsQueryHookResult = ReturnType<typeof useLegacySourceRecordsQuery>;
export type LegacySourceRecordsLazyQueryHookResult = ReturnType<typeof useLegacySourceRecordsLazyQuery>;
export type LegacySourceRecordsSuspenseQueryHookResult = ReturnType<typeof useLegacySourceRecordsSuspenseQuery>;
export type LegacySourceRecordsQueryResult = Apollo.QueryResult<LegacySourceRecordsQuery, LegacySourceRecordsQueryVariables>;
export const GetMailingListDocument = gql`
    query GetMailingList($list: MailingListName!) {
  mailingList(list: $list) {
    id
    list
    email
    createdAt
  }
}
    `;

/**
 * __useGetMailingListQuery__
 *
 * To run a query within a React component, call `useGetMailingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailingListQuery({
 *   variables: {
 *      list: // value for 'list'
 *   },
 * });
 */
export function useGetMailingListQuery(baseOptions: Apollo.QueryHookOptions<GetMailingListQuery, GetMailingListQueryVariables> & ({ variables: GetMailingListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailingListQuery, GetMailingListQueryVariables>(GetMailingListDocument, options);
      }
export function useGetMailingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailingListQuery, GetMailingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailingListQuery, GetMailingListQueryVariables>(GetMailingListDocument, options);
        }
// @ts-ignore
export function useGetMailingListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMailingListQuery, GetMailingListQueryVariables>): Apollo.UseSuspenseQueryResult<GetMailingListQuery, GetMailingListQueryVariables>;
export function useGetMailingListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailingListQuery, GetMailingListQueryVariables>): Apollo.UseSuspenseQueryResult<GetMailingListQuery | undefined, GetMailingListQueryVariables>;
export function useGetMailingListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailingListQuery, GetMailingListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailingListQuery, GetMailingListQueryVariables>(GetMailingListDocument, options);
        }
export type GetMailingListQueryHookResult = ReturnType<typeof useGetMailingListQuery>;
export type GetMailingListLazyQueryHookResult = ReturnType<typeof useGetMailingListLazyQuery>;
export type GetMailingListSuspenseQueryHookResult = ReturnType<typeof useGetMailingListSuspenseQuery>;
export type GetMailingListQueryResult = Apollo.QueryResult<GetMailingListQuery, GetMailingListQueryVariables>;
export const GetMailingListFallbackRecipientDocument = gql`
    query GetMailingListFallbackRecipient {
  mailingListFallbackRecipient
}
    `;

/**
 * __useGetMailingListFallbackRecipientQuery__
 *
 * To run a query within a React component, call `useGetMailingListFallbackRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailingListFallbackRecipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailingListFallbackRecipientQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMailingListFallbackRecipientQuery(baseOptions?: Apollo.QueryHookOptions<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>(GetMailingListFallbackRecipientDocument, options);
      }
export function useGetMailingListFallbackRecipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>(GetMailingListFallbackRecipientDocument, options);
        }
// @ts-ignore
export function useGetMailingListFallbackRecipientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>): Apollo.UseSuspenseQueryResult<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>;
export function useGetMailingListFallbackRecipientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>): Apollo.UseSuspenseQueryResult<GetMailingListFallbackRecipientQuery | undefined, GetMailingListFallbackRecipientQueryVariables>;
export function useGetMailingListFallbackRecipientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>(GetMailingListFallbackRecipientDocument, options);
        }
export type GetMailingListFallbackRecipientQueryHookResult = ReturnType<typeof useGetMailingListFallbackRecipientQuery>;
export type GetMailingListFallbackRecipientLazyQueryHookResult = ReturnType<typeof useGetMailingListFallbackRecipientLazyQuery>;
export type GetMailingListFallbackRecipientSuspenseQueryHookResult = ReturnType<typeof useGetMailingListFallbackRecipientSuspenseQuery>;
export type GetMailingListFallbackRecipientQueryResult = Apollo.QueryResult<GetMailingListFallbackRecipientQuery, GetMailingListFallbackRecipientQueryVariables>;
export const AddToMailingListDocument = gql`
    mutation AddToMailingList($list: MailingListName!, $email: String!) {
  addToMailingList(list: $list, email: $email) {
    id
    list
    email
    createdAt
  }
}
    `;
export type AddToMailingListMutationFn = Apollo.MutationFunction<AddToMailingListMutation, AddToMailingListMutationVariables>;

/**
 * __useAddToMailingListMutation__
 *
 * To run a mutation, you first call `useAddToMailingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToMailingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToMailingListMutation, { data, loading, error }] = useAddToMailingListMutation({
 *   variables: {
 *      list: // value for 'list'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddToMailingListMutation(baseOptions?: Apollo.MutationHookOptions<AddToMailingListMutation, AddToMailingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToMailingListMutation, AddToMailingListMutationVariables>(AddToMailingListDocument, options);
      }
export type AddToMailingListMutationHookResult = ReturnType<typeof useAddToMailingListMutation>;
export type AddToMailingListMutationResult = Apollo.MutationResult<AddToMailingListMutation>;
export type AddToMailingListMutationOptions = Apollo.BaseMutationOptions<AddToMailingListMutation, AddToMailingListMutationVariables>;
export const RemoveFromMailingListDocument = gql`
    mutation RemoveFromMailingList($id: String!) {
  removeFromMailingList(id: $id) {
    success
    message
  }
}
    `;
export type RemoveFromMailingListMutationFn = Apollo.MutationFunction<RemoveFromMailingListMutation, RemoveFromMailingListMutationVariables>;

/**
 * __useRemoveFromMailingListMutation__
 *
 * To run a mutation, you first call `useRemoveFromMailingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromMailingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromMailingListMutation, { data, loading, error }] = useRemoveFromMailingListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveFromMailingListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromMailingListMutation, RemoveFromMailingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromMailingListMutation, RemoveFromMailingListMutationVariables>(RemoveFromMailingListDocument, options);
      }
export type RemoveFromMailingListMutationHookResult = ReturnType<typeof useRemoveFromMailingListMutation>;
export type RemoveFromMailingListMutationResult = Apollo.MutationResult<RemoveFromMailingListMutation>;
export type RemoveFromMailingListMutationOptions = Apollo.BaseMutationOptions<RemoveFromMailingListMutation, RemoveFromMailingListMutationVariables>;
export const GetMailingListScheduleDocument = gql`
    query GetMailingListSchedule($list: MailingListName!) {
  mailingListSchedule(list: $list) {
    list
    frequency
    startsOn
    sendAt
    nextSendAt
    updatedAt
  }
}
    `;

/**
 * __useGetMailingListScheduleQuery__
 *
 * To run a query within a React component, call `useGetMailingListScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailingListScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailingListScheduleQuery({
 *   variables: {
 *      list: // value for 'list'
 *   },
 * });
 */
export function useGetMailingListScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables> & ({ variables: GetMailingListScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>(GetMailingListScheduleDocument, options);
      }
export function useGetMailingListScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>(GetMailingListScheduleDocument, options);
        }
// @ts-ignore
export function useGetMailingListScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>;
export function useGetMailingListScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetMailingListScheduleQuery | undefined, GetMailingListScheduleQueryVariables>;
export function useGetMailingListScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>(GetMailingListScheduleDocument, options);
        }
export type GetMailingListScheduleQueryHookResult = ReturnType<typeof useGetMailingListScheduleQuery>;
export type GetMailingListScheduleLazyQueryHookResult = ReturnType<typeof useGetMailingListScheduleLazyQuery>;
export type GetMailingListScheduleSuspenseQueryHookResult = ReturnType<typeof useGetMailingListScheduleSuspenseQuery>;
export type GetMailingListScheduleQueryResult = Apollo.QueryResult<GetMailingListScheduleQuery, GetMailingListScheduleQueryVariables>;
export const ExportWriteOffWorkbookDocument = gql`
    query ExportWriteOffWorkbook($from: String!, $to: String!) {
  exportWriteOffWorkbook(from: $from, to: $to) {
    fileName
    contentBase64
    contracts
  }
}
    `;

/**
 * __useExportWriteOffWorkbookQuery__
 *
 * To run a query within a React component, call `useExportWriteOffWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportWriteOffWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportWriteOffWorkbookQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExportWriteOffWorkbookQuery(baseOptions: Apollo.QueryHookOptions<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables> & ({ variables: ExportWriteOffWorkbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>(ExportWriteOffWorkbookDocument, options);
      }
export function useExportWriteOffWorkbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>(ExportWriteOffWorkbookDocument, options);
        }
// @ts-ignore
export function useExportWriteOffWorkbookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>): Apollo.UseSuspenseQueryResult<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>;
export function useExportWriteOffWorkbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>): Apollo.UseSuspenseQueryResult<ExportWriteOffWorkbookQuery | undefined, ExportWriteOffWorkbookQueryVariables>;
export function useExportWriteOffWorkbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>(ExportWriteOffWorkbookDocument, options);
        }
export type ExportWriteOffWorkbookQueryHookResult = ReturnType<typeof useExportWriteOffWorkbookQuery>;
export type ExportWriteOffWorkbookLazyQueryHookResult = ReturnType<typeof useExportWriteOffWorkbookLazyQuery>;
export type ExportWriteOffWorkbookSuspenseQueryHookResult = ReturnType<typeof useExportWriteOffWorkbookSuspenseQuery>;
export type ExportWriteOffWorkbookQueryResult = Apollo.QueryResult<ExportWriteOffWorkbookQuery, ExportWriteOffWorkbookQueryVariables>;
export const SetMailingListScheduleDocument = gql`
    mutation SetMailingListSchedule($input: SetMailingListScheduleInput!) {
  setMailingListSchedule(input: $input) {
    list
    frequency
    startsOn
    sendAt
    nextSendAt
    updatedAt
  }
}
    `;
export type SetMailingListScheduleMutationFn = Apollo.MutationFunction<SetMailingListScheduleMutation, SetMailingListScheduleMutationVariables>;

/**
 * __useSetMailingListScheduleMutation__
 *
 * To run a mutation, you first call `useSetMailingListScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMailingListScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMailingListScheduleMutation, { data, loading, error }] = useSetMailingListScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMailingListScheduleMutation(baseOptions?: Apollo.MutationHookOptions<SetMailingListScheduleMutation, SetMailingListScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMailingListScheduleMutation, SetMailingListScheduleMutationVariables>(SetMailingListScheduleDocument, options);
      }
export type SetMailingListScheduleMutationHookResult = ReturnType<typeof useSetMailingListScheduleMutation>;
export type SetMailingListScheduleMutationResult = Apollo.MutationResult<SetMailingListScheduleMutation>;
export type SetMailingListScheduleMutationOptions = Apollo.BaseMutationOptions<SetMailingListScheduleMutation, SetMailingListScheduleMutationVariables>;
export const GetMeterTypesDocument = gql`
    query GetMeterTypes {
  meterTypes {
    id
    name
  }
}
    `;

/**
 * __useGetMeterTypesQuery__
 *
 * To run a query within a React component, call `useGetMeterTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeterTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeterTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeterTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetMeterTypesQuery, GetMeterTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeterTypesQuery, GetMeterTypesQueryVariables>(GetMeterTypesDocument, options);
      }
export function useGetMeterTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeterTypesQuery, GetMeterTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeterTypesQuery, GetMeterTypesQueryVariables>(GetMeterTypesDocument, options);
        }
// @ts-ignore
export function useGetMeterTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeterTypesQuery, GetMeterTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeterTypesQuery, GetMeterTypesQueryVariables>;
export function useGetMeterTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeterTypesQuery, GetMeterTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeterTypesQuery | undefined, GetMeterTypesQueryVariables>;
export function useGetMeterTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeterTypesQuery, GetMeterTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeterTypesQuery, GetMeterTypesQueryVariables>(GetMeterTypesDocument, options);
        }
export type GetMeterTypesQueryHookResult = ReturnType<typeof useGetMeterTypesQuery>;
export type GetMeterTypesLazyQueryHookResult = ReturnType<typeof useGetMeterTypesLazyQuery>;
export type GetMeterTypesSuspenseQueryHookResult = ReturnType<typeof useGetMeterTypesSuspenseQuery>;
export type GetMeterTypesQueryResult = Apollo.QueryResult<GetMeterTypesQuery, GetMeterTypesQueryVariables>;
export const GetModulesDocument = gql`
    query GetModules {
  modules {
    id
    code
    name
    description
    enabled
    createdAt
    actions
    parentCode
  }
}
    `;

/**
 * __useGetModulesQuery__
 *
 * To run a query within a React component, call `useGetModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
      }
export function useGetModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
        }
// @ts-ignore
export function useGetModulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetModulesQuery, GetModulesQueryVariables>;
export function useGetModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetModulesQuery | undefined, GetModulesQueryVariables>;
export function useGetModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
        }
export type GetModulesQueryHookResult = ReturnType<typeof useGetModulesQuery>;
export type GetModulesLazyQueryHookResult = ReturnType<typeof useGetModulesLazyQuery>;
export type GetModulesSuspenseQueryHookResult = ReturnType<typeof useGetModulesSuspenseQuery>;
export type GetModulesQueryResult = Apollo.QueryResult<GetModulesQuery, GetModulesQueryVariables>;
export const CreateModuleDocument = gql`
    mutation CreateModule($input: CreateModuleInput!) {
  createModule(input: $input) {
    id
    code
    name
    description
    enabled
  }
}
    `;
export type CreateModuleMutationFn = Apollo.MutationFunction<CreateModuleMutation, CreateModuleMutationVariables>;

/**
 * __useCreateModuleMutation__
 *
 * To run a mutation, you first call `useCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModuleMutation, { data, loading, error }] = useCreateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateModuleMutation, CreateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModuleMutation, CreateModuleMutationVariables>(CreateModuleDocument, options);
      }
export type CreateModuleMutationHookResult = ReturnType<typeof useCreateModuleMutation>;
export type CreateModuleMutationResult = Apollo.MutationResult<CreateModuleMutation>;
export type CreateModuleMutationOptions = Apollo.BaseMutationOptions<CreateModuleMutation, CreateModuleMutationVariables>;
export const UpdateModuleDocument = gql`
    mutation UpdateModule($id: String!, $input: UpdateModuleInput!) {
  updateModule(id: $id, input: $input) {
    id
    code
    name
    description
    enabled
  }
}
    `;
export type UpdateModuleMutationFn = Apollo.MutationFunction<UpdateModuleMutation, UpdateModuleMutationVariables>;

/**
 * __useUpdateModuleMutation__
 *
 * To run a mutation, you first call `useUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleMutation, { data, loading, error }] = useUpdateModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateModuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModuleMutation, UpdateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModuleMutation, UpdateModuleMutationVariables>(UpdateModuleDocument, options);
      }
export type UpdateModuleMutationHookResult = ReturnType<typeof useUpdateModuleMutation>;
export type UpdateModuleMutationResult = Apollo.MutationResult<UpdateModuleMutation>;
export type UpdateModuleMutationOptions = Apollo.BaseMutationOptions<UpdateModuleMutation, UpdateModuleMutationVariables>;
export const ToggleModuleDocument = gql`
    mutation ToggleModule($id: String!, $enabled: Boolean!) {
  toggleModule(id: $id, enabled: $enabled) {
    id
    code
    name
    enabled
  }
}
    `;
export type ToggleModuleMutationFn = Apollo.MutationFunction<ToggleModuleMutation, ToggleModuleMutationVariables>;

/**
 * __useToggleModuleMutation__
 *
 * To run a mutation, you first call `useToggleModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleModuleMutation, { data, loading, error }] = useToggleModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleModuleMutation(baseOptions?: Apollo.MutationHookOptions<ToggleModuleMutation, ToggleModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleModuleMutation, ToggleModuleMutationVariables>(ToggleModuleDocument, options);
      }
export type ToggleModuleMutationHookResult = ReturnType<typeof useToggleModuleMutation>;
export type ToggleModuleMutationResult = Apollo.MutationResult<ToggleModuleMutation>;
export type ToggleModuleMutationOptions = Apollo.BaseMutationOptions<ToggleModuleMutation, ToggleModuleMutationVariables>;
export const DeleteModuleDocument = gql`
    mutation DeleteModule($id: String!) {
  deleteModule(id: $id) {
    success
    message
  }
}
    `;
export type DeleteModuleMutationFn = Apollo.MutationFunction<DeleteModuleMutation, DeleteModuleMutationVariables>;

/**
 * __useDeleteModuleMutation__
 *
 * To run a mutation, you first call `useDeleteModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleMutation, { data, loading, error }] = useDeleteModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteModuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModuleMutation, DeleteModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModuleMutation, DeleteModuleMutationVariables>(DeleteModuleDocument, options);
      }
export type DeleteModuleMutationHookResult = ReturnType<typeof useDeleteModuleMutation>;
export type DeleteModuleMutationResult = Apollo.MutationResult<DeleteModuleMutation>;
export type DeleteModuleMutationOptions = Apollo.BaseMutationOptions<DeleteModuleMutation, DeleteModuleMutationVariables>;
export const GetMoMoPosPaymentsDocument = gql`
    query GetMoMoPosPayments($filter: MoMoPosPaymentFilterInput) {
  momoPosPayments(filter: $filter) {
    totalCount
    items {
      id
      paidAt
      amount
      accountNumber
      typedAccount
      status
      terminalSerial
      cardScheme
      maskedCard
      authCode
      mtnTransactionNo
      contract {
        id
        contractNumber
        customerName
      }
    }
  }
}
    `;

/**
 * __useGetMoMoPosPaymentsQuery__
 *
 * To run a query within a React component, call `useGetMoMoPosPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoMoPosPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoMoPosPaymentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMoMoPosPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>(GetMoMoPosPaymentsDocument, options);
      }
export function useGetMoMoPosPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>(GetMoMoPosPaymentsDocument, options);
        }
// @ts-ignore
export function useGetMoMoPosPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>;
export function useGetMoMoPosPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoMoPosPaymentsQuery | undefined, GetMoMoPosPaymentsQueryVariables>;
export function useGetMoMoPosPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>(GetMoMoPosPaymentsDocument, options);
        }
export type GetMoMoPosPaymentsQueryHookResult = ReturnType<typeof useGetMoMoPosPaymentsQuery>;
export type GetMoMoPosPaymentsLazyQueryHookResult = ReturnType<typeof useGetMoMoPosPaymentsLazyQuery>;
export type GetMoMoPosPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetMoMoPosPaymentsSuspenseQuery>;
export type GetMoMoPosPaymentsQueryResult = Apollo.QueryResult<GetMoMoPosPaymentsQuery, GetMoMoPosPaymentsQueryVariables>;
export const EmployeeMovementsDocument = gql`
    query EmployeeMovements($employeeId: ID!) {
  employeeMovements(employeeId: $employeeId) {
    ...EmployeeMovementFields
  }
}
    ${EmployeeMovementFieldsFragmentDoc}`;

/**
 * __useEmployeeMovementsQuery__
 *
 * To run a query within a React component, call `useEmployeeMovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeMovementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeMovementsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeeMovementsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeMovementsQuery, EmployeeMovementsQueryVariables> & ({ variables: EmployeeMovementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>(EmployeeMovementsDocument, options);
      }
export function useEmployeeMovementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>(EmployeeMovementsDocument, options);
        }
// @ts-ignore
export function useEmployeeMovementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>;
export function useEmployeeMovementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeMovementsQuery | undefined, EmployeeMovementsQueryVariables>;
export function useEmployeeMovementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>(EmployeeMovementsDocument, options);
        }
export type EmployeeMovementsQueryHookResult = ReturnType<typeof useEmployeeMovementsQuery>;
export type EmployeeMovementsLazyQueryHookResult = ReturnType<typeof useEmployeeMovementsLazyQuery>;
export type EmployeeMovementsSuspenseQueryHookResult = ReturnType<typeof useEmployeeMovementsSuspenseQuery>;
export type EmployeeMovementsQueryResult = Apollo.QueryResult<EmployeeMovementsQuery, EmployeeMovementsQueryVariables>;
export const RecordEmployeeMovementDocument = gql`
    mutation RecordEmployeeMovement($input: RecordEmployeeMovementInput!) {
  recordEmployeeMovement(input: $input) {
    ...EmployeeMovementFields
  }
}
    ${EmployeeMovementFieldsFragmentDoc}`;
export type RecordEmployeeMovementMutationFn = Apollo.MutationFunction<RecordEmployeeMovementMutation, RecordEmployeeMovementMutationVariables>;

/**
 * __useRecordEmployeeMovementMutation__
 *
 * To run a mutation, you first call `useRecordEmployeeMovementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordEmployeeMovementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordEmployeeMovementMutation, { data, loading, error }] = useRecordEmployeeMovementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordEmployeeMovementMutation(baseOptions?: Apollo.MutationHookOptions<RecordEmployeeMovementMutation, RecordEmployeeMovementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordEmployeeMovementMutation, RecordEmployeeMovementMutationVariables>(RecordEmployeeMovementDocument, options);
      }
export type RecordEmployeeMovementMutationHookResult = ReturnType<typeof useRecordEmployeeMovementMutation>;
export type RecordEmployeeMovementMutationResult = Apollo.MutationResult<RecordEmployeeMovementMutation>;
export type RecordEmployeeMovementMutationOptions = Apollo.BaseMutationOptions<RecordEmployeeMovementMutation, RecordEmployeeMovementMutationVariables>;
export const GetSaLocationsDocument = gql`
    query GetSaLocations {
  provinces {
    id
    name
    districtMunicipalities {
      id
      name
      localMunicipalities {
        id
        municipality
      }
    }
  }
}
    `;

/**
 * __useGetSaLocationsQuery__
 *
 * To run a query within a React component, call `useGetSaLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSaLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetSaLocationsQuery, GetSaLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaLocationsQuery, GetSaLocationsQueryVariables>(GetSaLocationsDocument, options);
      }
export function useGetSaLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaLocationsQuery, GetSaLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaLocationsQuery, GetSaLocationsQueryVariables>(GetSaLocationsDocument, options);
        }
// @ts-ignore
export function useGetSaLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSaLocationsQuery, GetSaLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSaLocationsQuery, GetSaLocationsQueryVariables>;
export function useGetSaLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSaLocationsQuery, GetSaLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSaLocationsQuery | undefined, GetSaLocationsQueryVariables>;
export function useGetSaLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSaLocationsQuery, GetSaLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSaLocationsQuery, GetSaLocationsQueryVariables>(GetSaLocationsDocument, options);
        }
export type GetSaLocationsQueryHookResult = ReturnType<typeof useGetSaLocationsQuery>;
export type GetSaLocationsLazyQueryHookResult = ReturnType<typeof useGetSaLocationsLazyQuery>;
export type GetSaLocationsSuspenseQueryHookResult = ReturnType<typeof useGetSaLocationsSuspenseQuery>;
export type GetSaLocationsQueryResult = Apollo.QueryResult<GetSaLocationsQuery, GetSaLocationsQueryVariables>;
export const GetNotesDocument = gql`
    query GetNotes($input: NoteListInput!) {
  notes(input: $input) {
    items {
      ...NoteCardFields
    }
    totalCount
    restrictedHiddenCount
  }
}
    ${NoteCardFieldsFragmentDoc}`;

/**
 * __useGetNotesQuery__
 *
 * To run a query within a React component, call `useGetNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNotesQuery(baseOptions: Apollo.QueryHookOptions<GetNotesQuery, GetNotesQueryVariables> & ({ variables: GetNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
      }
export function useGetNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
// @ts-ignore
export function useGetNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotesQuery, GetNotesQueryVariables>;
export function useGetNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotesQuery | undefined, GetNotesQueryVariables>;
export function useGetNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
export type GetNotesQueryHookResult = ReturnType<typeof useGetNotesQuery>;
export type GetNotesLazyQueryHookResult = ReturnType<typeof useGetNotesLazyQuery>;
export type GetNotesSuspenseQueryHookResult = ReturnType<typeof useGetNotesSuspenseQuery>;
export type GetNotesQueryResult = Apollo.QueryResult<GetNotesQuery, GetNotesQueryVariables>;
export const GetNoteDocument = gql`
    query GetNote($id: String!) {
  note(id: $id) {
    ...NoteCardFields
    revisions {
      id
      revision
      body
      visibility
      changeReason
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
    }
  }
}
    ${NoteCardFieldsFragmentDoc}`;

/**
 * __useGetNoteQuery__
 *
 * To run a query within a React component, call `useGetNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNoteQuery(baseOptions: Apollo.QueryHookOptions<GetNoteQuery, GetNoteQueryVariables> & ({ variables: GetNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
      }
export function useGetNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
        }
// @ts-ignore
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>): Apollo.UseSuspenseQueryResult<GetNoteQuery, GetNoteQueryVariables>;
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>): Apollo.UseSuspenseQueryResult<GetNoteQuery | undefined, GetNoteQueryVariables>;
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
        }
export type GetNoteQueryHookResult = ReturnType<typeof useGetNoteQuery>;
export type GetNoteLazyQueryHookResult = ReturnType<typeof useGetNoteLazyQuery>;
export type GetNoteSuspenseQueryHookResult = ReturnType<typeof useGetNoteSuspenseQuery>;
export type GetNoteQueryResult = Apollo.QueryResult<GetNoteQuery, GetNoteQueryVariables>;
export const GetNoteCategoriesDocument = gql`
    query GetNoteCategories {
  noteCategories {
    id
    name
    color
    sortOrder
    isDefault
    isSystem
  }
}
    `;

/**
 * __useGetNoteCategoriesQuery__
 *
 * To run a query within a React component, call `useGetNoteCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNoteCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>(GetNoteCategoriesDocument, options);
      }
export function useGetNoteCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>(GetNoteCategoriesDocument, options);
        }
// @ts-ignore
export function useGetNoteCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>;
export function useGetNoteCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNoteCategoriesQuery | undefined, GetNoteCategoriesQueryVariables>;
export function useGetNoteCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>(GetNoteCategoriesDocument, options);
        }
export type GetNoteCategoriesQueryHookResult = ReturnType<typeof useGetNoteCategoriesQuery>;
export type GetNoteCategoriesLazyQueryHookResult = ReturnType<typeof useGetNoteCategoriesLazyQuery>;
export type GetNoteCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetNoteCategoriesSuspenseQuery>;
export type GetNoteCategoriesQueryResult = Apollo.QueryResult<GetNoteCategoriesQuery, GetNoteCategoriesQueryVariables>;
export const ExportNotesDocument = gql`
    query ExportNotes($input: NoteListInput!) {
  exportNotes(input: $input) {
    items {
      ...NoteCardFields
    }
    totalCount
  }
}
    ${NoteCardFieldsFragmentDoc}`;

/**
 * __useExportNotesQuery__
 *
 * To run a query within a React component, call `useExportNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportNotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportNotesQuery(baseOptions: Apollo.QueryHookOptions<ExportNotesQuery, ExportNotesQueryVariables> & ({ variables: ExportNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportNotesQuery, ExportNotesQueryVariables>(ExportNotesDocument, options);
      }
export function useExportNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportNotesQuery, ExportNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportNotesQuery, ExportNotesQueryVariables>(ExportNotesDocument, options);
        }
// @ts-ignore
export function useExportNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportNotesQuery, ExportNotesQueryVariables>): Apollo.UseSuspenseQueryResult<ExportNotesQuery, ExportNotesQueryVariables>;
export function useExportNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportNotesQuery, ExportNotesQueryVariables>): Apollo.UseSuspenseQueryResult<ExportNotesQuery | undefined, ExportNotesQueryVariables>;
export function useExportNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportNotesQuery, ExportNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportNotesQuery, ExportNotesQueryVariables>(ExportNotesDocument, options);
        }
export type ExportNotesQueryHookResult = ReturnType<typeof useExportNotesQuery>;
export type ExportNotesLazyQueryHookResult = ReturnType<typeof useExportNotesLazyQuery>;
export type ExportNotesSuspenseQueryHookResult = ReturnType<typeof useExportNotesSuspenseQuery>;
export type ExportNotesQueryResult = Apollo.QueryResult<ExportNotesQuery, ExportNotesQueryVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    id
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($id: String!, $input: UpdateNoteInput!) {
  updateNote(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const SetNoteVisibilityDocument = gql`
    mutation SetNoteVisibility($id: String!, $visibility: NoteVisibility!) {
  setNoteVisibility(id: $id, visibility: $visibility) {
    id
    visibility
  }
}
    `;
export type SetNoteVisibilityMutationFn = Apollo.MutationFunction<SetNoteVisibilityMutation, SetNoteVisibilityMutationVariables>;

/**
 * __useSetNoteVisibilityMutation__
 *
 * To run a mutation, you first call `useSetNoteVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNoteVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNoteVisibilityMutation, { data, loading, error }] = useSetNoteVisibilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useSetNoteVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<SetNoteVisibilityMutation, SetNoteVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNoteVisibilityMutation, SetNoteVisibilityMutationVariables>(SetNoteVisibilityDocument, options);
      }
export type SetNoteVisibilityMutationHookResult = ReturnType<typeof useSetNoteVisibilityMutation>;
export type SetNoteVisibilityMutationResult = Apollo.MutationResult<SetNoteVisibilityMutation>;
export type SetNoteVisibilityMutationOptions = Apollo.BaseMutationOptions<SetNoteVisibilityMutation, SetNoteVisibilityMutationVariables>;
export const SetNotePinnedDocument = gql`
    mutation SetNotePinned($id: String!, $pinned: Boolean!) {
  setNotePinned(id: $id, pinned: $pinned) {
    id
    pinnedAt
  }
}
    `;
export type SetNotePinnedMutationFn = Apollo.MutationFunction<SetNotePinnedMutation, SetNotePinnedMutationVariables>;

/**
 * __useSetNotePinnedMutation__
 *
 * To run a mutation, you first call `useSetNotePinnedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotePinnedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotePinnedMutation, { data, loading, error }] = useSetNotePinnedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function useSetNotePinnedMutation(baseOptions?: Apollo.MutationHookOptions<SetNotePinnedMutation, SetNotePinnedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotePinnedMutation, SetNotePinnedMutationVariables>(SetNotePinnedDocument, options);
      }
export type SetNotePinnedMutationHookResult = ReturnType<typeof useSetNotePinnedMutation>;
export type SetNotePinnedMutationResult = Apollo.MutationResult<SetNotePinnedMutation>;
export type SetNotePinnedMutationOptions = Apollo.BaseMutationOptions<SetNotePinnedMutation, SetNotePinnedMutationVariables>;
export const ArchiveNoteDocument = gql`
    mutation ArchiveNote($id: String!, $reason: String!) {
  archiveNote(id: $id, reason: $reason) {
    success
    message
  }
}
    `;
export type ArchiveNoteMutationFn = Apollo.MutationFunction<ArchiveNoteMutation, ArchiveNoteMutationVariables>;

/**
 * __useArchiveNoteMutation__
 *
 * To run a mutation, you first call `useArchiveNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNoteMutation, { data, loading, error }] = useArchiveNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveNoteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNoteMutation, ArchiveNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNoteMutation, ArchiveNoteMutationVariables>(ArchiveNoteDocument, options);
      }
export type ArchiveNoteMutationHookResult = ReturnType<typeof useArchiveNoteMutation>;
export type ArchiveNoteMutationResult = Apollo.MutationResult<ArchiveNoteMutation>;
export type ArchiveNoteMutationOptions = Apollo.BaseMutationOptions<ArchiveNoteMutation, ArchiveNoteMutationVariables>;
export const RestoreNoteDocument = gql`
    mutation RestoreNote($id: String!) {
  restoreNote(id: $id) {
    id
  }
}
    `;
export type RestoreNoteMutationFn = Apollo.MutationFunction<RestoreNoteMutation, RestoreNoteMutationVariables>;

/**
 * __useRestoreNoteMutation__
 *
 * To run a mutation, you first call `useRestoreNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreNoteMutation, { data, loading, error }] = useRestoreNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreNoteMutation(baseOptions?: Apollo.MutationHookOptions<RestoreNoteMutation, RestoreNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreNoteMutation, RestoreNoteMutationVariables>(RestoreNoteDocument, options);
      }
export type RestoreNoteMutationHookResult = ReturnType<typeof useRestoreNoteMutation>;
export type RestoreNoteMutationResult = Apollo.MutationResult<RestoreNoteMutation>;
export type RestoreNoteMutationOptions = Apollo.BaseMutationOptions<RestoreNoteMutation, RestoreNoteMutationVariables>;
export const RedactNoteDocument = gql`
    mutation RedactNote($id: String!, $reason: String!) {
  redactNote(id: $id, reason: $reason) {
    success
    message
  }
}
    `;
export type RedactNoteMutationFn = Apollo.MutationFunction<RedactNoteMutation, RedactNoteMutationVariables>;

/**
 * __useRedactNoteMutation__
 *
 * To run a mutation, you first call `useRedactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redactNoteMutation, { data, loading, error }] = useRedactNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRedactNoteMutation(baseOptions?: Apollo.MutationHookOptions<RedactNoteMutation, RedactNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedactNoteMutation, RedactNoteMutationVariables>(RedactNoteDocument, options);
      }
export type RedactNoteMutationHookResult = ReturnType<typeof useRedactNoteMutation>;
export type RedactNoteMutationResult = Apollo.MutationResult<RedactNoteMutation>;
export type RedactNoteMutationOptions = Apollo.BaseMutationOptions<RedactNoteMutation, RedactNoteMutationVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications($limit: Int, $offset: Int, $unreadOnly: Boolean) {
  notifications(limit: $limit, offset: $offset, unreadOnly: $unreadOnly) {
    id
    title
    message
    channel
    status
    entityType
    entityId
    readAt
    createdAt
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      unreadOnly: // value for 'unreadOnly'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
// @ts-ignore
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetUnreadNotificationCountDocument = gql`
    query GetUnreadNotificationCount {
  unreadNotificationCount {
    count
  }
}
    `;

/**
 * __useGetUnreadNotificationCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadNotificationCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>(GetUnreadNotificationCountDocument, options);
      }
export function useGetUnreadNotificationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>(GetUnreadNotificationCountDocument, options);
        }
// @ts-ignore
export function useGetUnreadNotificationCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>;
export function useGetUnreadNotificationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnreadNotificationCountQuery | undefined, GetUnreadNotificationCountQueryVariables>;
export function useGetUnreadNotificationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>(GetUnreadNotificationCountDocument, options);
        }
export type GetUnreadNotificationCountQueryHookResult = ReturnType<typeof useGetUnreadNotificationCountQuery>;
export type GetUnreadNotificationCountLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationCountLazyQuery>;
export type GetUnreadNotificationCountSuspenseQueryHookResult = ReturnType<typeof useGetUnreadNotificationCountSuspenseQuery>;
export type GetUnreadNotificationCountQueryResult = Apollo.QueryResult<GetUnreadNotificationCountQuery, GetUnreadNotificationCountQueryVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($id: String!) {
  markNotificationAsRead(id: $id) {
    id
    readAt
    status
  }
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation MarkAllNotificationsAsRead {
  markAllNotificationsAsRead {
    success
    count
  }
}
    `;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const OnNotificationReceivedDocument = gql`
    subscription OnNotificationReceived {
  notificationReceived {
    id
    title
    message
    channel
    status
    entityType
    entityId
    createdAt
  }
}
    `;

/**
 * __useOnNotificationReceivedSubscription__
 *
 * To run a query within a React component, call `useOnNotificationReceivedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationReceivedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationReceivedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNotificationReceivedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnNotificationReceivedSubscription, OnNotificationReceivedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNotificationReceivedSubscription, OnNotificationReceivedSubscriptionVariables>(OnNotificationReceivedDocument, options);
      }
export type OnNotificationReceivedSubscriptionHookResult = ReturnType<typeof useOnNotificationReceivedSubscription>;
export type OnNotificationReceivedSubscriptionResult = Apollo.SubscriptionResult<OnNotificationReceivedSubscription>;
export const GetCustomerFinancialAnalysisDocument = gql`
    query GetCustomerFinancialAnalysis($customerId: ID!, $from: DateTime) {
  customerFinancialAnalysis(customerId: $customerId, from: $from) {
    fromDate
    toDate
    totalDaysAnalysed
    daysWithoutCredit
    percentWithoutCredit
    rating
    currentGapDays
    priorDefault {
      contractNumber
      status
      at
    }
    longestGap {
      days
      fromDate
      toDate
    }
    days {
      date
      creditDays
      inCredit
      paymentAmount
    }
    contracts {
      contractId
      contractNumber
      status
      fromDate
      toDate
      totalDaysAnalysed
      daysWithoutCredit
      percentWithoutCredit
      longestGapDays
    }
    insights {
      code
      rating
      percent
      days
      fromDate
      toDate
      contractNumber
      contractStatus
    }
    thresholds {
      ...PaymentRatingThresholds
    }
  }
}
    ${PaymentRatingThresholdsFragmentDoc}`;

/**
 * __useGetCustomerFinancialAnalysisQuery__
 *
 * To run a query within a React component, call `useGetCustomerFinancialAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerFinancialAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerFinancialAnalysisQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useGetCustomerFinancialAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables> & ({ variables: GetCustomerFinancialAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>(GetCustomerFinancialAnalysisDocument, options);
      }
export function useGetCustomerFinancialAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>(GetCustomerFinancialAnalysisDocument, options);
        }
// @ts-ignore
export function useGetCustomerFinancialAnalysisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>;
export function useGetCustomerFinancialAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerFinancialAnalysisQuery | undefined, GetCustomerFinancialAnalysisQueryVariables>;
export function useGetCustomerFinancialAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>(GetCustomerFinancialAnalysisDocument, options);
        }
export type GetCustomerFinancialAnalysisQueryHookResult = ReturnType<typeof useGetCustomerFinancialAnalysisQuery>;
export type GetCustomerFinancialAnalysisLazyQueryHookResult = ReturnType<typeof useGetCustomerFinancialAnalysisLazyQuery>;
export type GetCustomerFinancialAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetCustomerFinancialAnalysisSuspenseQuery>;
export type GetCustomerFinancialAnalysisQueryResult = Apollo.QueryResult<GetCustomerFinancialAnalysisQuery, GetCustomerFinancialAnalysisQueryVariables>;
export const GetCustomerPaymentVerdictDocument = gql`
    query GetCustomerPaymentVerdict($customerId: ID!) {
  customerFinancialAnalysis(customerId: $customerId) {
    totalDaysAnalysed
    daysWithoutCredit
    percentWithoutCredit
    rating
    currentGapDays
    priorDefault {
      contractNumber
      status
      at
    }
    longestGap {
      days
      fromDate
      toDate
    }
  }
}
    `;

/**
 * __useGetCustomerPaymentVerdictQuery__
 *
 * To run a query within a React component, call `useGetCustomerPaymentVerdictQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerPaymentVerdictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerPaymentVerdictQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerPaymentVerdictQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables> & ({ variables: GetCustomerPaymentVerdictQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>(GetCustomerPaymentVerdictDocument, options);
      }
export function useGetCustomerPaymentVerdictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>(GetCustomerPaymentVerdictDocument, options);
        }
// @ts-ignore
export function useGetCustomerPaymentVerdictSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>;
export function useGetCustomerPaymentVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerPaymentVerdictQuery | undefined, GetCustomerPaymentVerdictQueryVariables>;
export function useGetCustomerPaymentVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>(GetCustomerPaymentVerdictDocument, options);
        }
export type GetCustomerPaymentVerdictQueryHookResult = ReturnType<typeof useGetCustomerPaymentVerdictQuery>;
export type GetCustomerPaymentVerdictLazyQueryHookResult = ReturnType<typeof useGetCustomerPaymentVerdictLazyQuery>;
export type GetCustomerPaymentVerdictSuspenseQueryHookResult = ReturnType<typeof useGetCustomerPaymentVerdictSuspenseQuery>;
export type GetCustomerPaymentVerdictQueryResult = Apollo.QueryResult<GetCustomerPaymentVerdictQuery, GetCustomerPaymentVerdictQueryVariables>;
export const GetPaymentRatingPolicyDocument = gql`
    query GetPaymentRatingPolicy {
  paymentRatingPolicy {
    ...PaymentRatingThresholds
    updatedAt
  }
}
    ${PaymentRatingThresholdsFragmentDoc}`;

/**
 * __useGetPaymentRatingPolicyQuery__
 *
 * To run a query within a React component, call `useGetPaymentRatingPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentRatingPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentRatingPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentRatingPolicyQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>(GetPaymentRatingPolicyDocument, options);
      }
export function useGetPaymentRatingPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>(GetPaymentRatingPolicyDocument, options);
        }
// @ts-ignore
export function useGetPaymentRatingPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>;
export function useGetPaymentRatingPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentRatingPolicyQuery | undefined, GetPaymentRatingPolicyQueryVariables>;
export function useGetPaymentRatingPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>(GetPaymentRatingPolicyDocument, options);
        }
export type GetPaymentRatingPolicyQueryHookResult = ReturnType<typeof useGetPaymentRatingPolicyQuery>;
export type GetPaymentRatingPolicyLazyQueryHookResult = ReturnType<typeof useGetPaymentRatingPolicyLazyQuery>;
export type GetPaymentRatingPolicySuspenseQueryHookResult = ReturnType<typeof useGetPaymentRatingPolicySuspenseQuery>;
export type GetPaymentRatingPolicyQueryResult = Apollo.QueryResult<GetPaymentRatingPolicyQuery, GetPaymentRatingPolicyQueryVariables>;
export const UpdatePaymentRatingPolicyDocument = gql`
    mutation UpdatePaymentRatingPolicy($input: UpdatePaymentRatingPolicyInput!) {
  updatePaymentRatingPolicy(input: $input) {
    ...PaymentRatingThresholds
    updatedAt
  }
}
    ${PaymentRatingThresholdsFragmentDoc}`;
export type UpdatePaymentRatingPolicyMutationFn = Apollo.MutationFunction<UpdatePaymentRatingPolicyMutation, UpdatePaymentRatingPolicyMutationVariables>;

/**
 * __useUpdatePaymentRatingPolicyMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentRatingPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentRatingPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentRatingPolicyMutation, { data, loading, error }] = useUpdatePaymentRatingPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentRatingPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentRatingPolicyMutation, UpdatePaymentRatingPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentRatingPolicyMutation, UpdatePaymentRatingPolicyMutationVariables>(UpdatePaymentRatingPolicyDocument, options);
      }
export type UpdatePaymentRatingPolicyMutationHookResult = ReturnType<typeof useUpdatePaymentRatingPolicyMutation>;
export type UpdatePaymentRatingPolicyMutationResult = Apollo.MutationResult<UpdatePaymentRatingPolicyMutation>;
export type UpdatePaymentRatingPolicyMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentRatingPolicyMutation, UpdatePaymentRatingPolicyMutationVariables>;
export const PreviewReallocationDocument = gql`
    query PreviewReallocation($input: PreviewReallocationInput!) {
  previewReallocation(input: $input) {
    paymentTransactionId
    amount
    sourceContractId
    sourceContractNumber
    sourceCustomerName
    destinationContractId
    destinationContractNumber
    destinationCustomerName
    deliveredTokenDays
    unrecoverable
    costRecoveryAmount
    amountReachingDestination
    recovery {
      total
      perPayment
      instalments
      extendedByFloor
    }
    warnings {
      code
      detail
    }
  }
}
    `;

/**
 * __usePreviewReallocationQuery__
 *
 * To run a query within a React component, call `usePreviewReallocationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewReallocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewReallocationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewReallocationQuery(baseOptions: Apollo.QueryHookOptions<PreviewReallocationQuery, PreviewReallocationQueryVariables> & ({ variables: PreviewReallocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewReallocationQuery, PreviewReallocationQueryVariables>(PreviewReallocationDocument, options);
      }
export function usePreviewReallocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewReallocationQuery, PreviewReallocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewReallocationQuery, PreviewReallocationQueryVariables>(PreviewReallocationDocument, options);
        }
// @ts-ignore
export function usePreviewReallocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewReallocationQuery, PreviewReallocationQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewReallocationQuery, PreviewReallocationQueryVariables>;
export function usePreviewReallocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewReallocationQuery, PreviewReallocationQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewReallocationQuery | undefined, PreviewReallocationQueryVariables>;
export function usePreviewReallocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewReallocationQuery, PreviewReallocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewReallocationQuery, PreviewReallocationQueryVariables>(PreviewReallocationDocument, options);
        }
export type PreviewReallocationQueryHookResult = ReturnType<typeof usePreviewReallocationQuery>;
export type PreviewReallocationLazyQueryHookResult = ReturnType<typeof usePreviewReallocationLazyQuery>;
export type PreviewReallocationSuspenseQueryHookResult = ReturnType<typeof usePreviewReallocationSuspenseQuery>;
export type PreviewReallocationQueryResult = Apollo.QueryResult<PreviewReallocationQuery, PreviewReallocationQueryVariables>;
export const UnappliedPaymentReallocationsDocument = gql`
    query UnappliedPaymentReallocations {
  unappliedPaymentReallocations {
    ...PaymentReallocationFields
  }
}
    ${PaymentReallocationFieldsFragmentDoc}`;

/**
 * __useUnappliedPaymentReallocationsQuery__
 *
 * To run a query within a React component, call `useUnappliedPaymentReallocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnappliedPaymentReallocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnappliedPaymentReallocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnappliedPaymentReallocationsQuery(baseOptions?: Apollo.QueryHookOptions<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>(UnappliedPaymentReallocationsDocument, options);
      }
export function useUnappliedPaymentReallocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>(UnappliedPaymentReallocationsDocument, options);
        }
// @ts-ignore
export function useUnappliedPaymentReallocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>): Apollo.UseSuspenseQueryResult<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>;
export function useUnappliedPaymentReallocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>): Apollo.UseSuspenseQueryResult<UnappliedPaymentReallocationsQuery | undefined, UnappliedPaymentReallocationsQueryVariables>;
export function useUnappliedPaymentReallocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>(UnappliedPaymentReallocationsDocument, options);
        }
export type UnappliedPaymentReallocationsQueryHookResult = ReturnType<typeof useUnappliedPaymentReallocationsQuery>;
export type UnappliedPaymentReallocationsLazyQueryHookResult = ReturnType<typeof useUnappliedPaymentReallocationsLazyQuery>;
export type UnappliedPaymentReallocationsSuspenseQueryHookResult = ReturnType<typeof useUnappliedPaymentReallocationsSuspenseQuery>;
export type UnappliedPaymentReallocationsQueryResult = Apollo.QueryResult<UnappliedPaymentReallocationsQuery, UnappliedPaymentReallocationsQueryVariables>;
export const ReallocatePaymentDocument = gql`
    mutation ReallocatePayment($input: ReallocatePaymentInput!) {
  reallocatePayment(input: $input) {
    reallocationId
    applied
    applyError
    writtenOffAmount
    writtenOffReason
  }
}
    `;
export type ReallocatePaymentMutationFn = Apollo.MutationFunction<ReallocatePaymentMutation, ReallocatePaymentMutationVariables>;

/**
 * __useReallocatePaymentMutation__
 *
 * To run a mutation, you first call `useReallocatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReallocatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reallocatePaymentMutation, { data, loading, error }] = useReallocatePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReallocatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReallocatePaymentMutation, ReallocatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReallocatePaymentMutation, ReallocatePaymentMutationVariables>(ReallocatePaymentDocument, options);
      }
export type ReallocatePaymentMutationHookResult = ReturnType<typeof useReallocatePaymentMutation>;
export type ReallocatePaymentMutationResult = Apollo.MutationResult<ReallocatePaymentMutation>;
export type ReallocatePaymentMutationOptions = Apollo.BaseMutationOptions<ReallocatePaymentMutation, ReallocatePaymentMutationVariables>;
export const ApplyPaymentReallocationDocument = gql`
    mutation ApplyPaymentReallocation($reallocationId: String!) {
  applyPaymentReallocation(reallocationId: $reallocationId) {
    reallocationId
    applied
    applyError
  }
}
    `;
export type ApplyPaymentReallocationMutationFn = Apollo.MutationFunction<ApplyPaymentReallocationMutation, ApplyPaymentReallocationMutationVariables>;

/**
 * __useApplyPaymentReallocationMutation__
 *
 * To run a mutation, you first call `useApplyPaymentReallocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyPaymentReallocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyPaymentReallocationMutation, { data, loading, error }] = useApplyPaymentReallocationMutation({
 *   variables: {
 *      reallocationId: // value for 'reallocationId'
 *   },
 * });
 */
export function useApplyPaymentReallocationMutation(baseOptions?: Apollo.MutationHookOptions<ApplyPaymentReallocationMutation, ApplyPaymentReallocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyPaymentReallocationMutation, ApplyPaymentReallocationMutationVariables>(ApplyPaymentReallocationDocument, options);
      }
export type ApplyPaymentReallocationMutationHookResult = ReturnType<typeof useApplyPaymentReallocationMutation>;
export type ApplyPaymentReallocationMutationResult = Apollo.MutationResult<ApplyPaymentReallocationMutation>;
export type ApplyPaymentReallocationMutationOptions = Apollo.BaseMutationOptions<ApplyPaymentReallocationMutation, ApplyPaymentReallocationMutationVariables>;
export const SearchContractsForReallocationDocument = gql`
    query SearchContractsForReallocation($search: String!) {
  contracts(input: {search: $search, limit: 8}) {
    items {
      id
      contractNumber
      customer {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useSearchContractsForReallocationQuery__
 *
 * To run a query within a React component, call `useSearchContractsForReallocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContractsForReallocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContractsForReallocationQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchContractsForReallocationQuery(baseOptions: Apollo.QueryHookOptions<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables> & ({ variables: SearchContractsForReallocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>(SearchContractsForReallocationDocument, options);
      }
export function useSearchContractsForReallocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>(SearchContractsForReallocationDocument, options);
        }
// @ts-ignore
export function useSearchContractsForReallocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>): Apollo.UseSuspenseQueryResult<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>;
export function useSearchContractsForReallocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>): Apollo.UseSuspenseQueryResult<SearchContractsForReallocationQuery | undefined, SearchContractsForReallocationQueryVariables>;
export function useSearchContractsForReallocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>(SearchContractsForReallocationDocument, options);
        }
export type SearchContractsForReallocationQueryHookResult = ReturnType<typeof useSearchContractsForReallocationQuery>;
export type SearchContractsForReallocationLazyQueryHookResult = ReturnType<typeof useSearchContractsForReallocationLazyQuery>;
export type SearchContractsForReallocationSuspenseQueryHookResult = ReturnType<typeof useSearchContractsForReallocationSuspenseQuery>;
export type SearchContractsForReallocationQueryResult = Apollo.QueryResult<SearchContractsForReallocationQuery, SearchContractsForReallocationQueryVariables>;
export const GetReallocationPolicyDocument = gql`
    query GetReallocationPolicy {
  reallocationPolicy {
    costRecoveryAmount
    minimumTokenDaysPerPayment
    updatedAt
  }
}
    `;

/**
 * __useGetReallocationPolicyQuery__
 *
 * To run a query within a React component, call `useGetReallocationPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReallocationPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReallocationPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReallocationPolicyQuery(baseOptions?: Apollo.QueryHookOptions<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>(GetReallocationPolicyDocument, options);
      }
export function useGetReallocationPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>(GetReallocationPolicyDocument, options);
        }
// @ts-ignore
export function useGetReallocationPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>;
export function useGetReallocationPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetReallocationPolicyQuery | undefined, GetReallocationPolicyQueryVariables>;
export function useGetReallocationPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>(GetReallocationPolicyDocument, options);
        }
export type GetReallocationPolicyQueryHookResult = ReturnType<typeof useGetReallocationPolicyQuery>;
export type GetReallocationPolicyLazyQueryHookResult = ReturnType<typeof useGetReallocationPolicyLazyQuery>;
export type GetReallocationPolicySuspenseQueryHookResult = ReturnType<typeof useGetReallocationPolicySuspenseQuery>;
export type GetReallocationPolicyQueryResult = Apollo.QueryResult<GetReallocationPolicyQuery, GetReallocationPolicyQueryVariables>;
export const UpdateReallocationPolicyDocument = gql`
    mutation UpdateReallocationPolicy($input: UpdateReallocationPolicyInput!) {
  updateReallocationPolicy(input: $input) {
    costRecoveryAmount
    minimumTokenDaysPerPayment
    updatedAt
  }
}
    `;
export type UpdateReallocationPolicyMutationFn = Apollo.MutationFunction<UpdateReallocationPolicyMutation, UpdateReallocationPolicyMutationVariables>;

/**
 * __useUpdateReallocationPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateReallocationPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReallocationPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReallocationPolicyMutation, { data, loading, error }] = useUpdateReallocationPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReallocationPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReallocationPolicyMutation, UpdateReallocationPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReallocationPolicyMutation, UpdateReallocationPolicyMutationVariables>(UpdateReallocationPolicyDocument, options);
      }
export type UpdateReallocationPolicyMutationHookResult = ReturnType<typeof useUpdateReallocationPolicyMutation>;
export type UpdateReallocationPolicyMutationResult = Apollo.MutationResult<UpdateReallocationPolicyMutation>;
export type UpdateReallocationPolicyMutationOptions = Apollo.BaseMutationOptions<UpdateReallocationPolicyMutation, UpdateReallocationPolicyMutationVariables>;
export const GenerateTokenDocument = gql`
    mutation GenerateToken($input: GenerateTokenInput!) {
  generateToken(input: $input) {
    transactionId
    accountNumber
    contractId
    amount
    message
    initiatedAt
    token
    tokenSequence
    devices {
      transactionId
      accountNumber
      productName
      amount
      message
      token
      tokenSequence
      accepted
    }
  }
}
    `;
export type GenerateTokenMutationFn = Apollo.MutationFunction<GenerateTokenMutation, GenerateTokenMutationVariables>;

/**
 * __useGenerateTokenMutation__
 *
 * To run a mutation, you first call `useGenerateTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTokenMutation, { data, loading, error }] = useGenerateTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTokenMutation, GenerateTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTokenMutation, GenerateTokenMutationVariables>(GenerateTokenDocument, options);
      }
export type GenerateTokenMutationHookResult = ReturnType<typeof useGenerateTokenMutation>;
export type GenerateTokenMutationResult = Apollo.MutationResult<GenerateTokenMutation>;
export type GenerateTokenMutationOptions = Apollo.BaseMutationOptions<GenerateTokenMutation, GenerateTokenMutationVariables>;
export const ResendTokenSmsDocument = gql`
    mutation ResendTokenSms($paymentTransactionId: String!, $phoneOverride: String) {
  resendTokenSms(
    paymentTransactionId: $paymentTransactionId
    phoneOverride: $phoneOverride
  ) {
    success
    message
    to
    accountNumber
  }
}
    `;
export type ResendTokenSmsMutationFn = Apollo.MutationFunction<ResendTokenSmsMutation, ResendTokenSmsMutationVariables>;

/**
 * __useResendTokenSmsMutation__
 *
 * To run a mutation, you first call `useResendTokenSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTokenSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTokenSmsMutation, { data, loading, error }] = useResendTokenSmsMutation({
 *   variables: {
 *      paymentTransactionId: // value for 'paymentTransactionId'
 *      phoneOverride: // value for 'phoneOverride'
 *   },
 * });
 */
export function useResendTokenSmsMutation(baseOptions?: Apollo.MutationHookOptions<ResendTokenSmsMutation, ResendTokenSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendTokenSmsMutation, ResendTokenSmsMutationVariables>(ResendTokenSmsDocument, options);
      }
export type ResendTokenSmsMutationHookResult = ReturnType<typeof useResendTokenSmsMutation>;
export type ResendTokenSmsMutationResult = Apollo.MutationResult<ResendTokenSmsMutation>;
export type ResendTokenSmsMutationOptions = Apollo.BaseMutationOptions<ResendTokenSmsMutation, ResendTokenSmsMutationVariables>;
export const GetPaymentTransactionsDocument = gql`
    query GetPaymentTransactions($input: PaymentTransactionListInput) {
  paymentTransactions(input: $input) {
    totalCount
    items {
      id
      createdAt
      referenceCode
      accountNumber
      amount
      phone
      description
      systemType
      createdBy
      reason
      token
      tokenSequence
      tokenDays
      depositDeducted
      countsTowardBalance
      routingNote
      tokenForPreviousDevice
      bankConfirmed
      confirmationSource
      bankName
      confirmationRef
      confirmedAt
      contractId
      contract {
        id
        contractNumber
        status
        customer {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaymentTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPaymentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTransactionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaymentTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>(GetPaymentTransactionsDocument, options);
      }
export function useGetPaymentTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>(GetPaymentTransactionsDocument, options);
        }
// @ts-ignore
export function useGetPaymentTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>;
export function useGetPaymentTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentTransactionsQuery | undefined, GetPaymentTransactionsQueryVariables>;
export function useGetPaymentTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>(GetPaymentTransactionsDocument, options);
        }
export type GetPaymentTransactionsQueryHookResult = ReturnType<typeof useGetPaymentTransactionsQuery>;
export type GetPaymentTransactionsLazyQueryHookResult = ReturnType<typeof useGetPaymentTransactionsLazyQuery>;
export type GetPaymentTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentTransactionsSuspenseQuery>;
export type GetPaymentTransactionsQueryResult = Apollo.QueryResult<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>;
export const GetPaymentTransactionDocument = gql`
    query GetPaymentTransaction($id: String!) {
  paymentTransaction(id: $id) {
    id
    createdAt
    referenceCode
    accountNumber
    amount
    phone
    description
    systemType
    createdBy
    reason
    token
    tokenSequence
    tokenDays
    depositDeducted
    routingNote
    tokenForPreviousDevice
    countsTowardBalance
    reallocation {
      id
      destinationContract {
        id
        contractNumber
      }
    }
    bankConfirmed
    confirmationSource
    bankName
    confirmationRef
    confirmedAt
    contractId
    contract {
      id
      contractNumber
      status
      rateName
      rateAmount
      customer {
        id
        fullName
        phone
        email
      }
      stockSale {
        stockItem {
          serialNumber
          accountNumber
        }
      }
    }
    callbacks {
      id
      createdAt
      accountNumber
      processedAt
      paymentTransactionId
      data
    }
  }
}
    `;

/**
 * __useGetPaymentTransactionQuery__
 *
 * To run a query within a React component, call `useGetPaymentTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables> & ({ variables: GetPaymentTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>(GetPaymentTransactionDocument, options);
      }
export function useGetPaymentTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>(GetPaymentTransactionDocument, options);
        }
// @ts-ignore
export function useGetPaymentTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>;
export function useGetPaymentTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentTransactionQuery | undefined, GetPaymentTransactionQueryVariables>;
export function useGetPaymentTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>(GetPaymentTransactionDocument, options);
        }
export type GetPaymentTransactionQueryHookResult = ReturnType<typeof useGetPaymentTransactionQuery>;
export type GetPaymentTransactionLazyQueryHookResult = ReturnType<typeof useGetPaymentTransactionLazyQuery>;
export type GetPaymentTransactionSuspenseQueryHookResult = ReturnType<typeof useGetPaymentTransactionSuspenseQuery>;
export type GetPaymentTransactionQueryResult = Apollo.QueryResult<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>;
export const ExportPaymentTransactionsDocument = gql`
    query ExportPaymentTransactions($input: PaymentTransactionListInput) {
  exportPaymentTransactions(input: $input) {
    totalCount
    items {
      createdAt
      referenceCode
      accountNumber
      amount
      phone
      description
      systemType
      createdBy
      reason
      token
      tokenSequence
      tokenDays
      depositDeducted
      routingNote
      bankConfirmed
      confirmationSource
      bankName
      confirmationRef
      confirmedAt
      contract {
        contractNumber
        distributorName
        nationalSalesManagerName
        customer {
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useExportPaymentTransactionsQuery__
 *
 * To run a query within a React component, call `useExportPaymentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPaymentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPaymentTransactionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportPaymentTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>(ExportPaymentTransactionsDocument, options);
      }
export function useExportPaymentTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>(ExportPaymentTransactionsDocument, options);
        }
// @ts-ignore
export function useExportPaymentTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>;
export function useExportPaymentTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportPaymentTransactionsQuery | undefined, ExportPaymentTransactionsQueryVariables>;
export function useExportPaymentTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>(ExportPaymentTransactionsDocument, options);
        }
export type ExportPaymentTransactionsQueryHookResult = ReturnType<typeof useExportPaymentTransactionsQuery>;
export type ExportPaymentTransactionsLazyQueryHookResult = ReturnType<typeof useExportPaymentTransactionsLazyQuery>;
export type ExportPaymentTransactionsSuspenseQueryHookResult = ReturnType<typeof useExportPaymentTransactionsSuspenseQuery>;
export type ExportPaymentTransactionsQueryResult = Apollo.QueryResult<ExportPaymentTransactionsQuery, ExportPaymentTransactionsQueryVariables>;
export const PayRunsDocument = gql`
    query PayRuns($filter: PayRunFilterInput) {
  payRuns(filter: $filter) {
    ...PayRunFields
  }
}
    ${PayRunFieldsFragmentDoc}`;

/**
 * __usePayRunsQuery__
 *
 * To run a query within a React component, call `usePayRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayRunsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePayRunsQuery(baseOptions?: Apollo.QueryHookOptions<PayRunsQuery, PayRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayRunsQuery, PayRunsQueryVariables>(PayRunsDocument, options);
      }
export function usePayRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayRunsQuery, PayRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayRunsQuery, PayRunsQueryVariables>(PayRunsDocument, options);
        }
// @ts-ignore
export function usePayRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayRunsQuery, PayRunsQueryVariables>): Apollo.UseSuspenseQueryResult<PayRunsQuery, PayRunsQueryVariables>;
export function usePayRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayRunsQuery, PayRunsQueryVariables>): Apollo.UseSuspenseQueryResult<PayRunsQuery | undefined, PayRunsQueryVariables>;
export function usePayRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayRunsQuery, PayRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayRunsQuery, PayRunsQueryVariables>(PayRunsDocument, options);
        }
export type PayRunsQueryHookResult = ReturnType<typeof usePayRunsQuery>;
export type PayRunsLazyQueryHookResult = ReturnType<typeof usePayRunsLazyQuery>;
export type PayRunsSuspenseQueryHookResult = ReturnType<typeof usePayRunsSuspenseQuery>;
export type PayRunsQueryResult = Apollo.QueryResult<PayRunsQuery, PayRunsQueryVariables>;
export const PayRunDocument = gql`
    query PayRun($id: ID!) {
  payRun(id: $id) {
    run {
      ...PayRunFields
    }
    payslips {
      ...PayslipFields
    }
  }
}
    ${PayRunFieldsFragmentDoc}
${PayslipFieldsFragmentDoc}`;

/**
 * __usePayRunQuery__
 *
 * To run a query within a React component, call `usePayRunQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePayRunQuery(baseOptions: Apollo.QueryHookOptions<PayRunQuery, PayRunQueryVariables> & ({ variables: PayRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayRunQuery, PayRunQueryVariables>(PayRunDocument, options);
      }
export function usePayRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayRunQuery, PayRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayRunQuery, PayRunQueryVariables>(PayRunDocument, options);
        }
// @ts-ignore
export function usePayRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayRunQuery, PayRunQueryVariables>): Apollo.UseSuspenseQueryResult<PayRunQuery, PayRunQueryVariables>;
export function usePayRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayRunQuery, PayRunQueryVariables>): Apollo.UseSuspenseQueryResult<PayRunQuery | undefined, PayRunQueryVariables>;
export function usePayRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayRunQuery, PayRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayRunQuery, PayRunQueryVariables>(PayRunDocument, options);
        }
export type PayRunQueryHookResult = ReturnType<typeof usePayRunQuery>;
export type PayRunLazyQueryHookResult = ReturnType<typeof usePayRunLazyQuery>;
export type PayRunSuspenseQueryHookResult = ReturnType<typeof usePayRunSuspenseQuery>;
export type PayRunQueryResult = Apollo.QueryResult<PayRunQuery, PayRunQueryVariables>;
export const PayRunExportDocument = gql`
    query PayRunExport($id: ID!) {
  payRunExport(id: $id) {
    ...PayslipFields
  }
}
    ${PayslipFieldsFragmentDoc}`;

/**
 * __usePayRunExportQuery__
 *
 * To run a query within a React component, call `usePayRunExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayRunExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayRunExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePayRunExportQuery(baseOptions: Apollo.QueryHookOptions<PayRunExportQuery, PayRunExportQueryVariables> & ({ variables: PayRunExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayRunExportQuery, PayRunExportQueryVariables>(PayRunExportDocument, options);
      }
export function usePayRunExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayRunExportQuery, PayRunExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayRunExportQuery, PayRunExportQueryVariables>(PayRunExportDocument, options);
        }
// @ts-ignore
export function usePayRunExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayRunExportQuery, PayRunExportQueryVariables>): Apollo.UseSuspenseQueryResult<PayRunExportQuery, PayRunExportQueryVariables>;
export function usePayRunExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayRunExportQuery, PayRunExportQueryVariables>): Apollo.UseSuspenseQueryResult<PayRunExportQuery | undefined, PayRunExportQueryVariables>;
export function usePayRunExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayRunExportQuery, PayRunExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayRunExportQuery, PayRunExportQueryVariables>(PayRunExportDocument, options);
        }
export type PayRunExportQueryHookResult = ReturnType<typeof usePayRunExportQuery>;
export type PayRunExportLazyQueryHookResult = ReturnType<typeof usePayRunExportLazyQuery>;
export type PayRunExportSuspenseQueryHookResult = ReturnType<typeof usePayRunExportSuspenseQuery>;
export type PayRunExportQueryResult = Apollo.QueryResult<PayRunExportQuery, PayRunExportQueryVariables>;
export const EmployeeBenefitsDocument = gql`
    query EmployeeBenefits($employeeId: ID) {
  employeeBenefits(employeeId: $employeeId) {
    ...EmployeeBenefitFields
  }
}
    ${EmployeeBenefitFieldsFragmentDoc}`;

/**
 * __useEmployeeBenefitsQuery__
 *
 * To run a query within a React component, call `useEmployeeBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeBenefitsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeeBenefitsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>(EmployeeBenefitsDocument, options);
      }
export function useEmployeeBenefitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>(EmployeeBenefitsDocument, options);
        }
// @ts-ignore
export function useEmployeeBenefitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>;
export function useEmployeeBenefitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeBenefitsQuery | undefined, EmployeeBenefitsQueryVariables>;
export function useEmployeeBenefitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>(EmployeeBenefitsDocument, options);
        }
export type EmployeeBenefitsQueryHookResult = ReturnType<typeof useEmployeeBenefitsQuery>;
export type EmployeeBenefitsLazyQueryHookResult = ReturnType<typeof useEmployeeBenefitsLazyQuery>;
export type EmployeeBenefitsSuspenseQueryHookResult = ReturnType<typeof useEmployeeBenefitsSuspenseQuery>;
export type EmployeeBenefitsQueryResult = Apollo.QueryResult<EmployeeBenefitsQuery, EmployeeBenefitsQueryVariables>;
export const PayrollMetricsDocument = gql`
    query PayrollMetrics($from: DateTime!, $to: DateTime!, $filter: PayrollMetricsFilterInput) {
  payrollMetrics(from: $from, to: $to, filter: $filter) {
    from
    to
    totalPayrollCost {
      ...HrMetricFields
    }
    totalGross {
      ...HrMetricFields
    }
    employeesPaid {
      ...HrMetricFields
    }
    averageGross {
      ...HrMetricFields
    }
    medianGross {
      ...HrMetricFields
    }
    payrollCostPerEmployee {
      ...HrMetricFields
    }
    overtimeCostPercent {
      ...HrMetricFields
    }
    benefitsCost {
      ...HrMetricFields
    }
    genderPayGapMeanPercent {
      ...HrMetricFields
    }
    genderPayGapMedianPercent {
      ...HrMetricFields
    }
    payrollGrowthPercent {
      ...HrMetricFields
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __usePayrollMetricsQuery__
 *
 * To run a query within a React component, call `usePayrollMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePayrollMetricsQuery(baseOptions: Apollo.QueryHookOptions<PayrollMetricsQuery, PayrollMetricsQueryVariables> & ({ variables: PayrollMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollMetricsQuery, PayrollMetricsQueryVariables>(PayrollMetricsDocument, options);
      }
export function usePayrollMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollMetricsQuery, PayrollMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollMetricsQuery, PayrollMetricsQueryVariables>(PayrollMetricsDocument, options);
        }
// @ts-ignore
export function usePayrollMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayrollMetricsQuery, PayrollMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PayrollMetricsQuery, PayrollMetricsQueryVariables>;
export function usePayrollMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollMetricsQuery, PayrollMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PayrollMetricsQuery | undefined, PayrollMetricsQueryVariables>;
export function usePayrollMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollMetricsQuery, PayrollMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollMetricsQuery, PayrollMetricsQueryVariables>(PayrollMetricsDocument, options);
        }
export type PayrollMetricsQueryHookResult = ReturnType<typeof usePayrollMetricsQuery>;
export type PayrollMetricsLazyQueryHookResult = ReturnType<typeof usePayrollMetricsLazyQuery>;
export type PayrollMetricsSuspenseQueryHookResult = ReturnType<typeof usePayrollMetricsSuspenseQuery>;
export type PayrollMetricsQueryResult = Apollo.QueryResult<PayrollMetricsQuery, PayrollMetricsQueryVariables>;
export const CreatePayRunDocument = gql`
    mutation CreatePayRun($input: CreatePayRunInput!) {
  createPayRun(input: $input) {
    ...PayRunFields
  }
}
    ${PayRunFieldsFragmentDoc}`;
export type CreatePayRunMutationFn = Apollo.MutationFunction<CreatePayRunMutation, CreatePayRunMutationVariables>;

/**
 * __useCreatePayRunMutation__
 *
 * To run a mutation, you first call `useCreatePayRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayRunMutation, { data, loading, error }] = useCreatePayRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayRunMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayRunMutation, CreatePayRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayRunMutation, CreatePayRunMutationVariables>(CreatePayRunDocument, options);
      }
export type CreatePayRunMutationHookResult = ReturnType<typeof useCreatePayRunMutation>;
export type CreatePayRunMutationResult = Apollo.MutationResult<CreatePayRunMutation>;
export type CreatePayRunMutationOptions = Apollo.BaseMutationOptions<CreatePayRunMutation, CreatePayRunMutationVariables>;
export const UpdatePayRunDocument = gql`
    mutation UpdatePayRun($id: ID!, $input: UpdatePayRunInput!) {
  updatePayRun(id: $id, input: $input) {
    ...PayRunFields
  }
}
    ${PayRunFieldsFragmentDoc}`;
export type UpdatePayRunMutationFn = Apollo.MutationFunction<UpdatePayRunMutation, UpdatePayRunMutationVariables>;

/**
 * __useUpdatePayRunMutation__
 *
 * To run a mutation, you first call `useUpdatePayRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayRunMutation, { data, loading, error }] = useUpdatePayRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePayRunMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePayRunMutation, UpdatePayRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePayRunMutation, UpdatePayRunMutationVariables>(UpdatePayRunDocument, options);
      }
export type UpdatePayRunMutationHookResult = ReturnType<typeof useUpdatePayRunMutation>;
export type UpdatePayRunMutationResult = Apollo.MutationResult<UpdatePayRunMutation>;
export type UpdatePayRunMutationOptions = Apollo.BaseMutationOptions<UpdatePayRunMutation, UpdatePayRunMutationVariables>;
export const DeletePayRunDocument = gql`
    mutation DeletePayRun($id: ID!) {
  deletePayRun(id: $id)
}
    `;
export type DeletePayRunMutationFn = Apollo.MutationFunction<DeletePayRunMutation, DeletePayRunMutationVariables>;

/**
 * __useDeletePayRunMutation__
 *
 * To run a mutation, you first call `useDeletePayRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayRunMutation, { data, loading, error }] = useDeletePayRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePayRunMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayRunMutation, DeletePayRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayRunMutation, DeletePayRunMutationVariables>(DeletePayRunDocument, options);
      }
export type DeletePayRunMutationHookResult = ReturnType<typeof useDeletePayRunMutation>;
export type DeletePayRunMutationResult = Apollo.MutationResult<DeletePayRunMutation>;
export type DeletePayRunMutationOptions = Apollo.BaseMutationOptions<DeletePayRunMutation, DeletePayRunMutationVariables>;
export const FinalisePayRunDocument = gql`
    mutation FinalisePayRun($id: ID!) {
  finalisePayRun(id: $id) {
    ...PayRunFields
  }
}
    ${PayRunFieldsFragmentDoc}`;
export type FinalisePayRunMutationFn = Apollo.MutationFunction<FinalisePayRunMutation, FinalisePayRunMutationVariables>;

/**
 * __useFinalisePayRunMutation__
 *
 * To run a mutation, you first call `useFinalisePayRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalisePayRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalisePayRunMutation, { data, loading, error }] = useFinalisePayRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinalisePayRunMutation(baseOptions?: Apollo.MutationHookOptions<FinalisePayRunMutation, FinalisePayRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalisePayRunMutation, FinalisePayRunMutationVariables>(FinalisePayRunDocument, options);
      }
export type FinalisePayRunMutationHookResult = ReturnType<typeof useFinalisePayRunMutation>;
export type FinalisePayRunMutationResult = Apollo.MutationResult<FinalisePayRunMutation>;
export type FinalisePayRunMutationOptions = Apollo.BaseMutationOptions<FinalisePayRunMutation, FinalisePayRunMutationVariables>;
export const ReopenPayRunDocument = gql`
    mutation ReopenPayRun($id: ID!) {
  reopenPayRun(id: $id) {
    ...PayRunFields
  }
}
    ${PayRunFieldsFragmentDoc}`;
export type ReopenPayRunMutationFn = Apollo.MutationFunction<ReopenPayRunMutation, ReopenPayRunMutationVariables>;

/**
 * __useReopenPayRunMutation__
 *
 * To run a mutation, you first call `useReopenPayRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenPayRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenPayRunMutation, { data, loading, error }] = useReopenPayRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReopenPayRunMutation(baseOptions?: Apollo.MutationHookOptions<ReopenPayRunMutation, ReopenPayRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenPayRunMutation, ReopenPayRunMutationVariables>(ReopenPayRunDocument, options);
      }
export type ReopenPayRunMutationHookResult = ReturnType<typeof useReopenPayRunMutation>;
export type ReopenPayRunMutationResult = Apollo.MutationResult<ReopenPayRunMutation>;
export type ReopenPayRunMutationOptions = Apollo.BaseMutationOptions<ReopenPayRunMutation, ReopenPayRunMutationVariables>;
export const ImportPayslipsDocument = gql`
    mutation ImportPayslips($periodMonth: DateTime!, $csv: String!) {
  importPayslips(periodMonth: $periodMonth, csv: $csv) {
    ...HrImportResultFields
  }
}
    ${HrImportResultFieldsFragmentDoc}`;
export type ImportPayslipsMutationFn = Apollo.MutationFunction<ImportPayslipsMutation, ImportPayslipsMutationVariables>;

/**
 * __useImportPayslipsMutation__
 *
 * To run a mutation, you first call `useImportPayslipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPayslipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPayslipsMutation, { data, loading, error }] = useImportPayslipsMutation({
 *   variables: {
 *      periodMonth: // value for 'periodMonth'
 *      csv: // value for 'csv'
 *   },
 * });
 */
export function useImportPayslipsMutation(baseOptions?: Apollo.MutationHookOptions<ImportPayslipsMutation, ImportPayslipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPayslipsMutation, ImportPayslipsMutationVariables>(ImportPayslipsDocument, options);
      }
export type ImportPayslipsMutationHookResult = ReturnType<typeof useImportPayslipsMutation>;
export type ImportPayslipsMutationResult = Apollo.MutationResult<ImportPayslipsMutation>;
export type ImportPayslipsMutationOptions = Apollo.BaseMutationOptions<ImportPayslipsMutation, ImportPayslipsMutationVariables>;
export const CreatePayslipDocument = gql`
    mutation CreatePayslip($payRunId: ID!, $employeeId: ID!, $input: PayslipInput!) {
  createPayslip(payRunId: $payRunId, employeeId: $employeeId, input: $input) {
    ...PayslipFields
  }
}
    ${PayslipFieldsFragmentDoc}`;
export type CreatePayslipMutationFn = Apollo.MutationFunction<CreatePayslipMutation, CreatePayslipMutationVariables>;

/**
 * __useCreatePayslipMutation__
 *
 * To run a mutation, you first call `useCreatePayslipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayslipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayslipMutation, { data, loading, error }] = useCreatePayslipMutation({
 *   variables: {
 *      payRunId: // value for 'payRunId'
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayslipMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayslipMutation, CreatePayslipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayslipMutation, CreatePayslipMutationVariables>(CreatePayslipDocument, options);
      }
export type CreatePayslipMutationHookResult = ReturnType<typeof useCreatePayslipMutation>;
export type CreatePayslipMutationResult = Apollo.MutationResult<CreatePayslipMutation>;
export type CreatePayslipMutationOptions = Apollo.BaseMutationOptions<CreatePayslipMutation, CreatePayslipMutationVariables>;
export const UpdatePayslipDocument = gql`
    mutation UpdatePayslip($id: ID!, $input: PayslipInput!) {
  updatePayslip(id: $id, input: $input) {
    ...PayslipFields
  }
}
    ${PayslipFieldsFragmentDoc}`;
export type UpdatePayslipMutationFn = Apollo.MutationFunction<UpdatePayslipMutation, UpdatePayslipMutationVariables>;

/**
 * __useUpdatePayslipMutation__
 *
 * To run a mutation, you first call `useUpdatePayslipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayslipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayslipMutation, { data, loading, error }] = useUpdatePayslipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePayslipMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePayslipMutation, UpdatePayslipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePayslipMutation, UpdatePayslipMutationVariables>(UpdatePayslipDocument, options);
      }
export type UpdatePayslipMutationHookResult = ReturnType<typeof useUpdatePayslipMutation>;
export type UpdatePayslipMutationResult = Apollo.MutationResult<UpdatePayslipMutation>;
export type UpdatePayslipMutationOptions = Apollo.BaseMutationOptions<UpdatePayslipMutation, UpdatePayslipMutationVariables>;
export const DeletePayslipDocument = gql`
    mutation DeletePayslip($id: ID!) {
  deletePayslip(id: $id)
}
    `;
export type DeletePayslipMutationFn = Apollo.MutationFunction<DeletePayslipMutation, DeletePayslipMutationVariables>;

/**
 * __useDeletePayslipMutation__
 *
 * To run a mutation, you first call `useDeletePayslipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayslipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayslipMutation, { data, loading, error }] = useDeletePayslipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePayslipMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayslipMutation, DeletePayslipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayslipMutation, DeletePayslipMutationVariables>(DeletePayslipDocument, options);
      }
export type DeletePayslipMutationHookResult = ReturnType<typeof useDeletePayslipMutation>;
export type DeletePayslipMutationResult = Apollo.MutationResult<DeletePayslipMutation>;
export type DeletePayslipMutationOptions = Apollo.BaseMutationOptions<DeletePayslipMutation, DeletePayslipMutationVariables>;
export const CreateEmployeeBenefitDocument = gql`
    mutation CreateEmployeeBenefit($employeeId: ID!, $input: CreateEmployeeBenefitInput!) {
  createEmployeeBenefit(employeeId: $employeeId, input: $input) {
    ...EmployeeBenefitFields
  }
}
    ${EmployeeBenefitFieldsFragmentDoc}`;
export type CreateEmployeeBenefitMutationFn = Apollo.MutationFunction<CreateEmployeeBenefitMutation, CreateEmployeeBenefitMutationVariables>;

/**
 * __useCreateEmployeeBenefitMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeBenefitMutation, { data, loading, error }] = useCreateEmployeeBenefitMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeBenefitMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeBenefitMutation, CreateEmployeeBenefitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeBenefitMutation, CreateEmployeeBenefitMutationVariables>(CreateEmployeeBenefitDocument, options);
      }
export type CreateEmployeeBenefitMutationHookResult = ReturnType<typeof useCreateEmployeeBenefitMutation>;
export type CreateEmployeeBenefitMutationResult = Apollo.MutationResult<CreateEmployeeBenefitMutation>;
export type CreateEmployeeBenefitMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeBenefitMutation, CreateEmployeeBenefitMutationVariables>;
export const UpdateEmployeeBenefitDocument = gql`
    mutation UpdateEmployeeBenefit($id: ID!, $input: UpdateEmployeeBenefitInput!) {
  updateEmployeeBenefit(id: $id, input: $input) {
    ...EmployeeBenefitFields
  }
}
    ${EmployeeBenefitFieldsFragmentDoc}`;
export type UpdateEmployeeBenefitMutationFn = Apollo.MutationFunction<UpdateEmployeeBenefitMutation, UpdateEmployeeBenefitMutationVariables>;

/**
 * __useUpdateEmployeeBenefitMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeBenefitMutation, { data, loading, error }] = useUpdateEmployeeBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeBenefitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeBenefitMutation, UpdateEmployeeBenefitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeBenefitMutation, UpdateEmployeeBenefitMutationVariables>(UpdateEmployeeBenefitDocument, options);
      }
export type UpdateEmployeeBenefitMutationHookResult = ReturnType<typeof useUpdateEmployeeBenefitMutation>;
export type UpdateEmployeeBenefitMutationResult = Apollo.MutationResult<UpdateEmployeeBenefitMutation>;
export type UpdateEmployeeBenefitMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeBenefitMutation, UpdateEmployeeBenefitMutationVariables>;
export const DeleteEmployeeBenefitDocument = gql`
    mutation DeleteEmployeeBenefit($id: ID!) {
  deleteEmployeeBenefit(id: $id)
}
    `;
export type DeleteEmployeeBenefitMutationFn = Apollo.MutationFunction<DeleteEmployeeBenefitMutation, DeleteEmployeeBenefitMutationVariables>;

/**
 * __useDeleteEmployeeBenefitMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeBenefitMutation, { data, loading, error }] = useDeleteEmployeeBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeBenefitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeBenefitMutation, DeleteEmployeeBenefitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeBenefitMutation, DeleteEmployeeBenefitMutationVariables>(DeleteEmployeeBenefitDocument, options);
      }
export type DeleteEmployeeBenefitMutationHookResult = ReturnType<typeof useDeleteEmployeeBenefitMutation>;
export type DeleteEmployeeBenefitMutationResult = Apollo.MutationResult<DeleteEmployeeBenefitMutation>;
export type DeleteEmployeeBenefitMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeBenefitMutation, DeleteEmployeeBenefitMutationVariables>;
export const PerformanceMetricsDocument = gql`
    query PerformanceMetrics($from: DateTime!, $to: DateTime!, $filter: PerformanceFilterInput) {
  performanceMetrics(from: $from, to: $to, filter: $filter) {
    from
    to
    cycleCount
    reviewsExpected {
      ...HrMetricFields
    }
    reviewsCompleted {
      ...HrMetricFields
    }
    reviewCompletionRate {
      ...HrMetricFields
    }
    byRating {
      rating
      count
    }
    averageRating {
      ...HrMetricFields
    }
    highPerformerPercent {
      ...HrMetricFields
    }
    highPerformerLeavers {
      ...HrMetricFields
    }
    highPerformerLeaverPercent {
      ...HrMetricFields
    }
    probationPassRate {
      ...HrMetricFields
    }
    probationsEndingSoon {
      ...HrMetricFields
    }
    openImprovementPlans {
      ...HrMetricFields
    }
    improvementPlanSuccessRate {
      ...HrMetricFields
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __usePerformanceMetricsQuery__
 *
 * To run a query within a React component, call `usePerformanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePerformanceMetricsQuery(baseOptions: Apollo.QueryHookOptions<PerformanceMetricsQuery, PerformanceMetricsQueryVariables> & ({ variables: PerformanceMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>(PerformanceMetricsDocument, options);
      }
export function usePerformanceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>(PerformanceMetricsDocument, options);
        }
// @ts-ignore
export function usePerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>;
export function usePerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceMetricsQuery | undefined, PerformanceMetricsQueryVariables>;
export function usePerformanceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>(PerformanceMetricsDocument, options);
        }
export type PerformanceMetricsQueryHookResult = ReturnType<typeof usePerformanceMetricsQuery>;
export type PerformanceMetricsLazyQueryHookResult = ReturnType<typeof usePerformanceMetricsLazyQuery>;
export type PerformanceMetricsSuspenseQueryHookResult = ReturnType<typeof usePerformanceMetricsSuspenseQuery>;
export type PerformanceMetricsQueryResult = Apollo.QueryResult<PerformanceMetricsQuery, PerformanceMetricsQueryVariables>;
export const ReviewCyclesDocument = gql`
    query ReviewCycles {
  reviewCycles {
    ...ReviewCycleFields
  }
}
    ${ReviewCycleFieldsFragmentDoc}`;

/**
 * __useReviewCyclesQuery__
 *
 * To run a query within a React component, call `useReviewCyclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewCyclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewCyclesQuery({
 *   variables: {
 *   },
 * });
 */
export function useReviewCyclesQuery(baseOptions?: Apollo.QueryHookOptions<ReviewCyclesQuery, ReviewCyclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewCyclesQuery, ReviewCyclesQueryVariables>(ReviewCyclesDocument, options);
      }
export function useReviewCyclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewCyclesQuery, ReviewCyclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewCyclesQuery, ReviewCyclesQueryVariables>(ReviewCyclesDocument, options);
        }
// @ts-ignore
export function useReviewCyclesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewCyclesQuery, ReviewCyclesQueryVariables>): Apollo.UseSuspenseQueryResult<ReviewCyclesQuery, ReviewCyclesQueryVariables>;
export function useReviewCyclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewCyclesQuery, ReviewCyclesQueryVariables>): Apollo.UseSuspenseQueryResult<ReviewCyclesQuery | undefined, ReviewCyclesQueryVariables>;
export function useReviewCyclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewCyclesQuery, ReviewCyclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewCyclesQuery, ReviewCyclesQueryVariables>(ReviewCyclesDocument, options);
        }
export type ReviewCyclesQueryHookResult = ReturnType<typeof useReviewCyclesQuery>;
export type ReviewCyclesLazyQueryHookResult = ReturnType<typeof useReviewCyclesLazyQuery>;
export type ReviewCyclesSuspenseQueryHookResult = ReturnType<typeof useReviewCyclesSuspenseQuery>;
export type ReviewCyclesQueryResult = Apollo.QueryResult<ReviewCyclesQuery, ReviewCyclesQueryVariables>;
export const PerformanceReviewsDocument = gql`
    query PerformanceReviews($cycleId: ID!) {
  performanceReviews(cycleId: $cycleId) {
    ...PerformanceReviewFields
  }
}
    ${PerformanceReviewFieldsFragmentDoc}`;

/**
 * __usePerformanceReviewsQuery__
 *
 * To run a query within a React component, call `usePerformanceReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceReviewsQuery({
 *   variables: {
 *      cycleId: // value for 'cycleId'
 *   },
 * });
 */
export function usePerformanceReviewsQuery(baseOptions: Apollo.QueryHookOptions<PerformanceReviewsQuery, PerformanceReviewsQueryVariables> & ({ variables: PerformanceReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>(PerformanceReviewsDocument, options);
      }
export function usePerformanceReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>(PerformanceReviewsDocument, options);
        }
// @ts-ignore
export function usePerformanceReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>;
export function usePerformanceReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceReviewsQuery | undefined, PerformanceReviewsQueryVariables>;
export function usePerformanceReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>(PerformanceReviewsDocument, options);
        }
export type PerformanceReviewsQueryHookResult = ReturnType<typeof usePerformanceReviewsQuery>;
export type PerformanceReviewsLazyQueryHookResult = ReturnType<typeof usePerformanceReviewsLazyQuery>;
export type PerformanceReviewsSuspenseQueryHookResult = ReturnType<typeof usePerformanceReviewsSuspenseQuery>;
export type PerformanceReviewsQueryResult = Apollo.QueryResult<PerformanceReviewsQuery, PerformanceReviewsQueryVariables>;
export const EmployeePerformanceDocument = gql`
    query EmployeePerformance($employeeId: ID!) {
  employeePerformance(employeeId: $employeeId) {
    employeeId
    probations {
      employmentId
      startDate
      endDate
      probation {
        ...ProbationFields
      }
    }
    reviews {
      ...PerformanceReviewFields
    }
    improvementPlans {
      ...ImprovementPlanFields
    }
  }
}
    ${ProbationFieldsFragmentDoc}
${PerformanceReviewFieldsFragmentDoc}
${ImprovementPlanFieldsFragmentDoc}`;

/**
 * __useEmployeePerformanceQuery__
 *
 * To run a query within a React component, call `useEmployeePerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePerformanceQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeePerformanceQuery(baseOptions: Apollo.QueryHookOptions<EmployeePerformanceQuery, EmployeePerformanceQueryVariables> & ({ variables: EmployeePerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>(EmployeePerformanceDocument, options);
      }
export function useEmployeePerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>(EmployeePerformanceDocument, options);
        }
// @ts-ignore
export function useEmployeePerformanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>;
export function useEmployeePerformanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeePerformanceQuery | undefined, EmployeePerformanceQueryVariables>;
export function useEmployeePerformanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>(EmployeePerformanceDocument, options);
        }
export type EmployeePerformanceQueryHookResult = ReturnType<typeof useEmployeePerformanceQuery>;
export type EmployeePerformanceLazyQueryHookResult = ReturnType<typeof useEmployeePerformanceLazyQuery>;
export type EmployeePerformanceSuspenseQueryHookResult = ReturnType<typeof useEmployeePerformanceSuspenseQuery>;
export type EmployeePerformanceQueryResult = Apollo.QueryResult<EmployeePerformanceQuery, EmployeePerformanceQueryVariables>;
export const CreateReviewCycleDocument = gql`
    mutation CreateReviewCycle($input: ReviewCycleInput!) {
  createReviewCycle(input: $input) {
    ...ReviewCycleFields
  }
}
    ${ReviewCycleFieldsFragmentDoc}`;
export type CreateReviewCycleMutationFn = Apollo.MutationFunction<CreateReviewCycleMutation, CreateReviewCycleMutationVariables>;

/**
 * __useCreateReviewCycleMutation__
 *
 * To run a mutation, you first call `useCreateReviewCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewCycleMutation, { data, loading, error }] = useCreateReviewCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReviewCycleMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewCycleMutation, CreateReviewCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewCycleMutation, CreateReviewCycleMutationVariables>(CreateReviewCycleDocument, options);
      }
export type CreateReviewCycleMutationHookResult = ReturnType<typeof useCreateReviewCycleMutation>;
export type CreateReviewCycleMutationResult = Apollo.MutationResult<CreateReviewCycleMutation>;
export type CreateReviewCycleMutationOptions = Apollo.BaseMutationOptions<CreateReviewCycleMutation, CreateReviewCycleMutationVariables>;
export const UpdateReviewCycleDocument = gql`
    mutation UpdateReviewCycle($id: ID!, $input: UpdateReviewCycleInput!) {
  updateReviewCycle(id: $id, input: $input) {
    ...ReviewCycleFields
  }
}
    ${ReviewCycleFieldsFragmentDoc}`;
export type UpdateReviewCycleMutationFn = Apollo.MutationFunction<UpdateReviewCycleMutation, UpdateReviewCycleMutationVariables>;

/**
 * __useUpdateReviewCycleMutation__
 *
 * To run a mutation, you first call `useUpdateReviewCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReviewCycleMutation, { data, loading, error }] = useUpdateReviewCycleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReviewCycleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReviewCycleMutation, UpdateReviewCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReviewCycleMutation, UpdateReviewCycleMutationVariables>(UpdateReviewCycleDocument, options);
      }
export type UpdateReviewCycleMutationHookResult = ReturnType<typeof useUpdateReviewCycleMutation>;
export type UpdateReviewCycleMutationResult = Apollo.MutationResult<UpdateReviewCycleMutation>;
export type UpdateReviewCycleMutationOptions = Apollo.BaseMutationOptions<UpdateReviewCycleMutation, UpdateReviewCycleMutationVariables>;
export const DeleteReviewCycleDocument = gql`
    mutation DeleteReviewCycle($id: ID!) {
  deleteReviewCycle(id: $id)
}
    `;
export type DeleteReviewCycleMutationFn = Apollo.MutationFunction<DeleteReviewCycleMutation, DeleteReviewCycleMutationVariables>;

/**
 * __useDeleteReviewCycleMutation__
 *
 * To run a mutation, you first call `useDeleteReviewCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewCycleMutation, { data, loading, error }] = useDeleteReviewCycleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReviewCycleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReviewCycleMutation, DeleteReviewCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReviewCycleMutation, DeleteReviewCycleMutationVariables>(DeleteReviewCycleDocument, options);
      }
export type DeleteReviewCycleMutationHookResult = ReturnType<typeof useDeleteReviewCycleMutation>;
export type DeleteReviewCycleMutationResult = Apollo.MutationResult<DeleteReviewCycleMutation>;
export type DeleteReviewCycleMutationOptions = Apollo.BaseMutationOptions<DeleteReviewCycleMutation, DeleteReviewCycleMutationVariables>;
export const CreatePerformanceReviewDocument = gql`
    mutation CreatePerformanceReview($input: CreatePerformanceReviewInput!) {
  createPerformanceReview(input: $input) {
    ...PerformanceReviewFields
  }
}
    ${PerformanceReviewFieldsFragmentDoc}`;
export type CreatePerformanceReviewMutationFn = Apollo.MutationFunction<CreatePerformanceReviewMutation, CreatePerformanceReviewMutationVariables>;

/**
 * __useCreatePerformanceReviewMutation__
 *
 * To run a mutation, you first call `useCreatePerformanceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePerformanceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPerformanceReviewMutation, { data, loading, error }] = useCreatePerformanceReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePerformanceReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreatePerformanceReviewMutation, CreatePerformanceReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePerformanceReviewMutation, CreatePerformanceReviewMutationVariables>(CreatePerformanceReviewDocument, options);
      }
export type CreatePerformanceReviewMutationHookResult = ReturnType<typeof useCreatePerformanceReviewMutation>;
export type CreatePerformanceReviewMutationResult = Apollo.MutationResult<CreatePerformanceReviewMutation>;
export type CreatePerformanceReviewMutationOptions = Apollo.BaseMutationOptions<CreatePerformanceReviewMutation, CreatePerformanceReviewMutationVariables>;
export const UpdatePerformanceReviewDocument = gql`
    mutation UpdatePerformanceReview($id: ID!, $input: UpdatePerformanceReviewInput!) {
  updatePerformanceReview(id: $id, input: $input) {
    ...PerformanceReviewFields
  }
}
    ${PerformanceReviewFieldsFragmentDoc}`;
export type UpdatePerformanceReviewMutationFn = Apollo.MutationFunction<UpdatePerformanceReviewMutation, UpdatePerformanceReviewMutationVariables>;

/**
 * __useUpdatePerformanceReviewMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceReviewMutation, { data, loading, error }] = useUpdatePerformanceReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePerformanceReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceReviewMutation, UpdatePerformanceReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceReviewMutation, UpdatePerformanceReviewMutationVariables>(UpdatePerformanceReviewDocument, options);
      }
export type UpdatePerformanceReviewMutationHookResult = ReturnType<typeof useUpdatePerformanceReviewMutation>;
export type UpdatePerformanceReviewMutationResult = Apollo.MutationResult<UpdatePerformanceReviewMutation>;
export type UpdatePerformanceReviewMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceReviewMutation, UpdatePerformanceReviewMutationVariables>;
export const CreateImprovementPlanDocument = gql`
    mutation CreateImprovementPlan($input: CreateImprovementPlanInput!) {
  createImprovementPlan(input: $input) {
    ...ImprovementPlanFields
  }
}
    ${ImprovementPlanFieldsFragmentDoc}`;
export type CreateImprovementPlanMutationFn = Apollo.MutationFunction<CreateImprovementPlanMutation, CreateImprovementPlanMutationVariables>;

/**
 * __useCreateImprovementPlanMutation__
 *
 * To run a mutation, you first call `useCreateImprovementPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImprovementPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImprovementPlanMutation, { data, loading, error }] = useCreateImprovementPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImprovementPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateImprovementPlanMutation, CreateImprovementPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImprovementPlanMutation, CreateImprovementPlanMutationVariables>(CreateImprovementPlanDocument, options);
      }
export type CreateImprovementPlanMutationHookResult = ReturnType<typeof useCreateImprovementPlanMutation>;
export type CreateImprovementPlanMutationResult = Apollo.MutationResult<CreateImprovementPlanMutation>;
export type CreateImprovementPlanMutationOptions = Apollo.BaseMutationOptions<CreateImprovementPlanMutation, CreateImprovementPlanMutationVariables>;
export const UpdateImprovementPlanDocument = gql`
    mutation UpdateImprovementPlan($id: ID!, $input: UpdateImprovementPlanInput!) {
  updateImprovementPlan(id: $id, input: $input) {
    ...ImprovementPlanFields
  }
}
    ${ImprovementPlanFieldsFragmentDoc}`;
export type UpdateImprovementPlanMutationFn = Apollo.MutationFunction<UpdateImprovementPlanMutation, UpdateImprovementPlanMutationVariables>;

/**
 * __useUpdateImprovementPlanMutation__
 *
 * To run a mutation, you first call `useUpdateImprovementPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImprovementPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImprovementPlanMutation, { data, loading, error }] = useUpdateImprovementPlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImprovementPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImprovementPlanMutation, UpdateImprovementPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImprovementPlanMutation, UpdateImprovementPlanMutationVariables>(UpdateImprovementPlanDocument, options);
      }
export type UpdateImprovementPlanMutationHookResult = ReturnType<typeof useUpdateImprovementPlanMutation>;
export type UpdateImprovementPlanMutationResult = Apollo.MutationResult<UpdateImprovementPlanMutation>;
export type UpdateImprovementPlanMutationOptions = Apollo.BaseMutationOptions<UpdateImprovementPlanMutation, UpdateImprovementPlanMutationVariables>;
export const SetProbationDocument = gql`
    mutation SetProbation($employmentId: ID!, $input: ProbationInput!) {
  setProbation(employmentId: $employmentId, input: $input) {
    ...ProbationFields
  }
}
    ${ProbationFieldsFragmentDoc}`;
export type SetProbationMutationFn = Apollo.MutationFunction<SetProbationMutation, SetProbationMutationVariables>;

/**
 * __useSetProbationMutation__
 *
 * To run a mutation, you first call `useSetProbationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProbationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProbationMutation, { data, loading, error }] = useSetProbationMutation({
 *   variables: {
 *      employmentId: // value for 'employmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProbationMutation(baseOptions?: Apollo.MutationHookOptions<SetProbationMutation, SetProbationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProbationMutation, SetProbationMutationVariables>(SetProbationDocument, options);
      }
export type SetProbationMutationHookResult = ReturnType<typeof useSetProbationMutation>;
export type SetProbationMutationResult = Apollo.MutationResult<SetProbationMutation>;
export type SetProbationMutationOptions = Apollo.BaseMutationOptions<SetProbationMutation, SetProbationMutationVariables>;
export const GetPermissionChangeRequestsDocument = gql`
    query GetPermissionChangeRequests($status: PermissionRequestStatus, $mine: Boolean) {
  permissionChangeRequests(status: $status, mine: $mine) {
    ...PermissionChangeRequestFields
  }
}
    ${PermissionChangeRequestFieldsFragmentDoc}`;

/**
 * __useGetPermissionChangeRequestsQuery__
 *
 * To run a query within a React component, call `useGetPermissionChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionChangeRequestsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      mine: // value for 'mine'
 *   },
 * });
 */
export function useGetPermissionChangeRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>(GetPermissionChangeRequestsDocument, options);
      }
export function useGetPermissionChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>(GetPermissionChangeRequestsDocument, options);
        }
// @ts-ignore
export function useGetPermissionChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>;
export function useGetPermissionChangeRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionChangeRequestsQuery | undefined, GetPermissionChangeRequestsQueryVariables>;
export function useGetPermissionChangeRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>(GetPermissionChangeRequestsDocument, options);
        }
export type GetPermissionChangeRequestsQueryHookResult = ReturnType<typeof useGetPermissionChangeRequestsQuery>;
export type GetPermissionChangeRequestsLazyQueryHookResult = ReturnType<typeof useGetPermissionChangeRequestsLazyQuery>;
export type GetPermissionChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionChangeRequestsSuspenseQuery>;
export type GetPermissionChangeRequestsQueryResult = Apollo.QueryResult<GetPermissionChangeRequestsQuery, GetPermissionChangeRequestsQueryVariables>;
export const GetPendingPermissionChangeRequestCountDocument = gql`
    query GetPendingPermissionChangeRequestCount {
  pendingPermissionChangeRequestCount
}
    `;

/**
 * __useGetPendingPermissionChangeRequestCountQuery__
 *
 * To run a query within a React component, call `useGetPendingPermissionChangeRequestCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingPermissionChangeRequestCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingPermissionChangeRequestCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingPermissionChangeRequestCountQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>(GetPendingPermissionChangeRequestCountDocument, options);
      }
export function useGetPendingPermissionChangeRequestCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>(GetPendingPermissionChangeRequestCountDocument, options);
        }
// @ts-ignore
export function useGetPendingPermissionChangeRequestCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>;
export function useGetPendingPermissionChangeRequestCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingPermissionChangeRequestCountQuery | undefined, GetPendingPermissionChangeRequestCountQueryVariables>;
export function useGetPendingPermissionChangeRequestCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>(GetPendingPermissionChangeRequestCountDocument, options);
        }
export type GetPendingPermissionChangeRequestCountQueryHookResult = ReturnType<typeof useGetPendingPermissionChangeRequestCountQuery>;
export type GetPendingPermissionChangeRequestCountLazyQueryHookResult = ReturnType<typeof useGetPendingPermissionChangeRequestCountLazyQuery>;
export type GetPendingPermissionChangeRequestCountSuspenseQueryHookResult = ReturnType<typeof useGetPendingPermissionChangeRequestCountSuspenseQuery>;
export type GetPendingPermissionChangeRequestCountQueryResult = Apollo.QueryResult<GetPendingPermissionChangeRequestCountQuery, GetPendingPermissionChangeRequestCountQueryVariables>;
export const GetCanApproveAccessRequestsDocument = gql`
    query GetCanApproveAccessRequests {
  canApproveAccessRequests
}
    `;

/**
 * __useGetCanApproveAccessRequestsQuery__
 *
 * To run a query within a React component, call `useGetCanApproveAccessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanApproveAccessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanApproveAccessRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCanApproveAccessRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>(GetCanApproveAccessRequestsDocument, options);
      }
export function useGetCanApproveAccessRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>(GetCanApproveAccessRequestsDocument, options);
        }
// @ts-ignore
export function useGetCanApproveAccessRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>;
export function useGetCanApproveAccessRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCanApproveAccessRequestsQuery | undefined, GetCanApproveAccessRequestsQueryVariables>;
export function useGetCanApproveAccessRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>(GetCanApproveAccessRequestsDocument, options);
        }
export type GetCanApproveAccessRequestsQueryHookResult = ReturnType<typeof useGetCanApproveAccessRequestsQuery>;
export type GetCanApproveAccessRequestsLazyQueryHookResult = ReturnType<typeof useGetCanApproveAccessRequestsLazyQuery>;
export type GetCanApproveAccessRequestsSuspenseQueryHookResult = ReturnType<typeof useGetCanApproveAccessRequestsSuspenseQuery>;
export type GetCanApproveAccessRequestsQueryResult = Apollo.QueryResult<GetCanApproveAccessRequestsQuery, GetCanApproveAccessRequestsQueryVariables>;
export const ReviewPermissionChangeRequestDocument = gql`
    mutation ReviewPermissionChangeRequest($id: String!, $decision: PermissionRequestDecision!, $notes: String) {
  reviewPermissionChangeRequest(id: $id, decision: $decision, notes: $notes) {
    ...PermissionChangeRequestFields
  }
}
    ${PermissionChangeRequestFieldsFragmentDoc}`;
export type ReviewPermissionChangeRequestMutationFn = Apollo.MutationFunction<ReviewPermissionChangeRequestMutation, ReviewPermissionChangeRequestMutationVariables>;

/**
 * __useReviewPermissionChangeRequestMutation__
 *
 * To run a mutation, you first call `useReviewPermissionChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewPermissionChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewPermissionChangeRequestMutation, { data, loading, error }] = useReviewPermissionChangeRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      decision: // value for 'decision'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useReviewPermissionChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<ReviewPermissionChangeRequestMutation, ReviewPermissionChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewPermissionChangeRequestMutation, ReviewPermissionChangeRequestMutationVariables>(ReviewPermissionChangeRequestDocument, options);
      }
export type ReviewPermissionChangeRequestMutationHookResult = ReturnType<typeof useReviewPermissionChangeRequestMutation>;
export type ReviewPermissionChangeRequestMutationResult = Apollo.MutationResult<ReviewPermissionChangeRequestMutation>;
export type ReviewPermissionChangeRequestMutationOptions = Apollo.BaseMutationOptions<ReviewPermissionChangeRequestMutation, ReviewPermissionChangeRequestMutationVariables>;
export const CancelPermissionChangeRequestDocument = gql`
    mutation CancelPermissionChangeRequest($id: String!) {
  cancelPermissionChangeRequest(id: $id) {
    ...PermissionChangeRequestFields
  }
}
    ${PermissionChangeRequestFieldsFragmentDoc}`;
export type CancelPermissionChangeRequestMutationFn = Apollo.MutationFunction<CancelPermissionChangeRequestMutation, CancelPermissionChangeRequestMutationVariables>;

/**
 * __useCancelPermissionChangeRequestMutation__
 *
 * To run a mutation, you first call `useCancelPermissionChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPermissionChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPermissionChangeRequestMutation, { data, loading, error }] = useCancelPermissionChangeRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPermissionChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelPermissionChangeRequestMutation, CancelPermissionChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPermissionChangeRequestMutation, CancelPermissionChangeRequestMutationVariables>(CancelPermissionChangeRequestDocument, options);
      }
export type CancelPermissionChangeRequestMutationHookResult = ReturnType<typeof useCancelPermissionChangeRequestMutation>;
export type CancelPermissionChangeRequestMutationResult = Apollo.MutationResult<CancelPermissionChangeRequestMutation>;
export type CancelPermissionChangeRequestMutationOptions = Apollo.BaseMutationOptions<CancelPermissionChangeRequestMutation, CancelPermissionChangeRequestMutationVariables>;
export const GetEffectivePermissionsDocument = gql`
    query GetEffectivePermissions($userId: String) {
  effectivePermissions(userId: $userId) {
    moduleCode
    moduleName
    action
    granted
    source
    sourceRoleId
    manualOverride
  }
}
    `;

/**
 * __useGetEffectivePermissionsQuery__
 *
 * To run a query within a React component, call `useGetEffectivePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEffectivePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEffectivePermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetEffectivePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>(GetEffectivePermissionsDocument, options);
      }
export function useGetEffectivePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>(GetEffectivePermissionsDocument, options);
        }
// @ts-ignore
export function useGetEffectivePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>;
export function useGetEffectivePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEffectivePermissionsQuery | undefined, GetEffectivePermissionsQueryVariables>;
export function useGetEffectivePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>(GetEffectivePermissionsDocument, options);
        }
export type GetEffectivePermissionsQueryHookResult = ReturnType<typeof useGetEffectivePermissionsQuery>;
export type GetEffectivePermissionsLazyQueryHookResult = ReturnType<typeof useGetEffectivePermissionsLazyQuery>;
export type GetEffectivePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetEffectivePermissionsSuspenseQuery>;
export type GetEffectivePermissionsQueryResult = Apollo.QueryResult<GetEffectivePermissionsQuery, GetEffectivePermissionsQueryVariables>;
export const GetUserPermissionsDocument = gql`
    query GetUserPermissions($userId: String!) {
  userPermissions(userId: $userId) {
    id
    action
    granted
    manualOverride
    sourceRoleId
    reason
    expiresAt
    grantedByName
    createdAt
    updatedAt
    module {
      id
      code
      name
    }
    sourceRole {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useGetUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables> & ({ variables: GetUserPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
      }
export function useGetUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
// @ts-ignore
export function useGetUserPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>;
export function useGetUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPermissionsQuery | undefined, GetUserPermissionsQueryVariables>;
export function useGetUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
export type GetUserPermissionsQueryHookResult = ReturnType<typeof useGetUserPermissionsQuery>;
export type GetUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsLazyQuery>;
export type GetUserPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionsSuspenseQuery>;
export type GetUserPermissionsQueryResult = Apollo.QueryResult<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>;
export const GetSensitivePermissionsDocument = gql`
    query GetSensitivePermissions {
  sensitivePermissions {
    moduleCode
    action
    level
  }
}
    `;

/**
 * __useGetSensitivePermissionsQuery__
 *
 * To run a query within a React component, call `useGetSensitivePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSensitivePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSensitivePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSensitivePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>(GetSensitivePermissionsDocument, options);
      }
export function useGetSensitivePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>(GetSensitivePermissionsDocument, options);
        }
// @ts-ignore
export function useGetSensitivePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>;
export function useGetSensitivePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSensitivePermissionsQuery | undefined, GetSensitivePermissionsQueryVariables>;
export function useGetSensitivePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>(GetSensitivePermissionsDocument, options);
        }
export type GetSensitivePermissionsQueryHookResult = ReturnType<typeof useGetSensitivePermissionsQuery>;
export type GetSensitivePermissionsLazyQueryHookResult = ReturnType<typeof useGetSensitivePermissionsLazyQuery>;
export type GetSensitivePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetSensitivePermissionsSuspenseQuery>;
export type GetSensitivePermissionsQueryResult = Apollo.QueryResult<GetSensitivePermissionsQuery, GetSensitivePermissionsQueryVariables>;
export const SetUserPermissionDocument = gql`
    mutation SetUserPermission($userId: String!, $moduleCode: String!, $action: String!, $granted: Boolean!, $reason: String, $expiresAt: DateTime) {
  setUserPermission(
    userId: $userId
    moduleCode: $moduleCode
    action: $action
    granted: $granted
    reason: $reason
    expiresAt: $expiresAt
  ) {
    success
    message
  }
}
    `;
export type SetUserPermissionMutationFn = Apollo.MutationFunction<SetUserPermissionMutation, SetUserPermissionMutationVariables>;

/**
 * __useSetUserPermissionMutation__
 *
 * To run a mutation, you first call `useSetUserPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPermissionMutation, { data, loading, error }] = useSetUserPermissionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      moduleCode: // value for 'moduleCode'
 *      action: // value for 'action'
 *      granted: // value for 'granted'
 *      reason: // value for 'reason'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useSetUserPermissionMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPermissionMutation, SetUserPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserPermissionMutation, SetUserPermissionMutationVariables>(SetUserPermissionDocument, options);
      }
export type SetUserPermissionMutationHookResult = ReturnType<typeof useSetUserPermissionMutation>;
export type SetUserPermissionMutationResult = Apollo.MutationResult<SetUserPermissionMutation>;
export type SetUserPermissionMutationOptions = Apollo.BaseMutationOptions<SetUserPermissionMutation, SetUserPermissionMutationVariables>;
export const RemoveUserPermissionOverrideDocument = gql`
    mutation RemoveUserPermissionOverride($userId: String!, $moduleCode: String!, $action: String!) {
  removeUserPermissionOverride(
    userId: $userId
    moduleCode: $moduleCode
    action: $action
  ) {
    success
    message
  }
}
    `;
export type RemoveUserPermissionOverrideMutationFn = Apollo.MutationFunction<RemoveUserPermissionOverrideMutation, RemoveUserPermissionOverrideMutationVariables>;

/**
 * __useRemoveUserPermissionOverrideMutation__
 *
 * To run a mutation, you first call `useRemoveUserPermissionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserPermissionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserPermissionOverrideMutation, { data, loading, error }] = useRemoveUserPermissionOverrideMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      moduleCode: // value for 'moduleCode'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useRemoveUserPermissionOverrideMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserPermissionOverrideMutation, RemoveUserPermissionOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserPermissionOverrideMutation, RemoveUserPermissionOverrideMutationVariables>(RemoveUserPermissionOverrideDocument, options);
      }
export type RemoveUserPermissionOverrideMutationHookResult = ReturnType<typeof useRemoveUserPermissionOverrideMutation>;
export type RemoveUserPermissionOverrideMutationResult = Apollo.MutationResult<RemoveUserPermissionOverrideMutation>;
export type RemoveUserPermissionOverrideMutationOptions = Apollo.BaseMutationOptions<RemoveUserPermissionOverrideMutation, RemoveUserPermissionOverrideMutationVariables>;
export const MaterializeAllPermissionsDocument = gql`
    mutation MaterializeAllPermissions {
  materializeAllPermissions {
    success
    message
  }
}
    `;
export type MaterializeAllPermissionsMutationFn = Apollo.MutationFunction<MaterializeAllPermissionsMutation, MaterializeAllPermissionsMutationVariables>;

/**
 * __useMaterializeAllPermissionsMutation__
 *
 * To run a mutation, you first call `useMaterializeAllPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaterializeAllPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [materializeAllPermissionsMutation, { data, loading, error }] = useMaterializeAllPermissionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useMaterializeAllPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<MaterializeAllPermissionsMutation, MaterializeAllPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MaterializeAllPermissionsMutation, MaterializeAllPermissionsMutationVariables>(MaterializeAllPermissionsDocument, options);
      }
export type MaterializeAllPermissionsMutationHookResult = ReturnType<typeof useMaterializeAllPermissionsMutation>;
export type MaterializeAllPermissionsMutationResult = Apollo.MutationResult<MaterializeAllPermissionsMutation>;
export type MaterializeAllPermissionsMutationOptions = Apollo.BaseMutationOptions<MaterializeAllPermissionsMutation, MaterializeAllPermissionsMutationVariables>;
export const SetUserPermissionOverrideDocument = gql`
    mutation SetUserPermissionOverride($userId: String!, $moduleCode: String!, $action: String!, $granted: Boolean!) {
  setUserPermissionOverride(
    userId: $userId
    moduleCode: $moduleCode
    action: $action
    granted: $granted
  ) {
    success
    message
  }
}
    `;
export type SetUserPermissionOverrideMutationFn = Apollo.MutationFunction<SetUserPermissionOverrideMutation, SetUserPermissionOverrideMutationVariables>;

/**
 * __useSetUserPermissionOverrideMutation__
 *
 * To run a mutation, you first call `useSetUserPermissionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPermissionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPermissionOverrideMutation, { data, loading, error }] = useSetUserPermissionOverrideMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      moduleCode: // value for 'moduleCode'
 *      action: // value for 'action'
 *      granted: // value for 'granted'
 *   },
 * });
 */
export function useSetUserPermissionOverrideMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPermissionOverrideMutation, SetUserPermissionOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserPermissionOverrideMutation, SetUserPermissionOverrideMutationVariables>(SetUserPermissionOverrideDocument, options);
      }
export type SetUserPermissionOverrideMutationHookResult = ReturnType<typeof useSetUserPermissionOverrideMutation>;
export type SetUserPermissionOverrideMutationResult = Apollo.MutationResult<SetUserPermissionOverrideMutation>;
export type SetUserPermissionOverrideMutationOptions = Apollo.BaseMutationOptions<SetUserPermissionOverrideMutation, SetUserPermissionOverrideMutationVariables>;
export const ActivePhoneNumberUpdateRequestDocument = gql`
    query ActivePhoneNumberUpdateRequest($customerId: String!) {
  activePhoneNumberUpdateRequest(customerId: $customerId) {
    ...PhoneNumberUpdateRequestFields
  }
}
    ${PhoneNumberUpdateRequestFieldsFragmentDoc}`;

/**
 * __useActivePhoneNumberUpdateRequestQuery__
 *
 * To run a query within a React component, call `useActivePhoneNumberUpdateRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivePhoneNumberUpdateRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivePhoneNumberUpdateRequestQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useActivePhoneNumberUpdateRequestQuery(baseOptions: Apollo.QueryHookOptions<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables> & ({ variables: ActivePhoneNumberUpdateRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>(ActivePhoneNumberUpdateRequestDocument, options);
      }
export function useActivePhoneNumberUpdateRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>(ActivePhoneNumberUpdateRequestDocument, options);
        }
// @ts-ignore
export function useActivePhoneNumberUpdateRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>): Apollo.UseSuspenseQueryResult<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>;
export function useActivePhoneNumberUpdateRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>): Apollo.UseSuspenseQueryResult<ActivePhoneNumberUpdateRequestQuery | undefined, ActivePhoneNumberUpdateRequestQueryVariables>;
export function useActivePhoneNumberUpdateRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>(ActivePhoneNumberUpdateRequestDocument, options);
        }
export type ActivePhoneNumberUpdateRequestQueryHookResult = ReturnType<typeof useActivePhoneNumberUpdateRequestQuery>;
export type ActivePhoneNumberUpdateRequestLazyQueryHookResult = ReturnType<typeof useActivePhoneNumberUpdateRequestLazyQuery>;
export type ActivePhoneNumberUpdateRequestSuspenseQueryHookResult = ReturnType<typeof useActivePhoneNumberUpdateRequestSuspenseQuery>;
export type ActivePhoneNumberUpdateRequestQueryResult = Apollo.QueryResult<ActivePhoneNumberUpdateRequestQuery, ActivePhoneNumberUpdateRequestQueryVariables>;
export const RequestPhoneNumberUpdateDocument = gql`
    mutation RequestPhoneNumberUpdate($customerId: String!, $newPhone: String!) {
  requestPhoneNumberUpdate(customerId: $customerId, newPhone: $newPhone) {
    ...PhoneNumberUpdateRequestFields
  }
}
    ${PhoneNumberUpdateRequestFieldsFragmentDoc}`;
export type RequestPhoneNumberUpdateMutationFn = Apollo.MutationFunction<RequestPhoneNumberUpdateMutation, RequestPhoneNumberUpdateMutationVariables>;

/**
 * __useRequestPhoneNumberUpdateMutation__
 *
 * To run a mutation, you first call `useRequestPhoneNumberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPhoneNumberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPhoneNumberUpdateMutation, { data, loading, error }] = useRequestPhoneNumberUpdateMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      newPhone: // value for 'newPhone'
 *   },
 * });
 */
export function useRequestPhoneNumberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestPhoneNumberUpdateMutation, RequestPhoneNumberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPhoneNumberUpdateMutation, RequestPhoneNumberUpdateMutationVariables>(RequestPhoneNumberUpdateDocument, options);
      }
export type RequestPhoneNumberUpdateMutationHookResult = ReturnType<typeof useRequestPhoneNumberUpdateMutation>;
export type RequestPhoneNumberUpdateMutationResult = Apollo.MutationResult<RequestPhoneNumberUpdateMutation>;
export type RequestPhoneNumberUpdateMutationOptions = Apollo.BaseMutationOptions<RequestPhoneNumberUpdateMutation, RequestPhoneNumberUpdateMutationVariables>;
export const ResendPhoneNumberUpdateOtpDocument = gql`
    mutation ResendPhoneNumberUpdateOtp($requestId: String!) {
  resendPhoneNumberUpdateOtp(requestId: $requestId) {
    ...PhoneNumberUpdateRequestFields
  }
}
    ${PhoneNumberUpdateRequestFieldsFragmentDoc}`;
export type ResendPhoneNumberUpdateOtpMutationFn = Apollo.MutationFunction<ResendPhoneNumberUpdateOtpMutation, ResendPhoneNumberUpdateOtpMutationVariables>;

/**
 * __useResendPhoneNumberUpdateOtpMutation__
 *
 * To run a mutation, you first call `useResendPhoneNumberUpdateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPhoneNumberUpdateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPhoneNumberUpdateOtpMutation, { data, loading, error }] = useResendPhoneNumberUpdateOtpMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useResendPhoneNumberUpdateOtpMutation(baseOptions?: Apollo.MutationHookOptions<ResendPhoneNumberUpdateOtpMutation, ResendPhoneNumberUpdateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPhoneNumberUpdateOtpMutation, ResendPhoneNumberUpdateOtpMutationVariables>(ResendPhoneNumberUpdateOtpDocument, options);
      }
export type ResendPhoneNumberUpdateOtpMutationHookResult = ReturnType<typeof useResendPhoneNumberUpdateOtpMutation>;
export type ResendPhoneNumberUpdateOtpMutationResult = Apollo.MutationResult<ResendPhoneNumberUpdateOtpMutation>;
export type ResendPhoneNumberUpdateOtpMutationOptions = Apollo.BaseMutationOptions<ResendPhoneNumberUpdateOtpMutation, ResendPhoneNumberUpdateOtpMutationVariables>;
export const VerifyPhoneNumberUpdateOtpDocument = gql`
    mutation VerifyPhoneNumberUpdateOtp($requestId: String!, $otp: String!) {
  verifyPhoneNumberUpdateOtp(requestId: $requestId, otp: $otp) {
    ...PhoneNumberUpdateRequestFields
    customer {
      id
      phone
    }
  }
}
    ${PhoneNumberUpdateRequestFieldsFragmentDoc}`;
export type VerifyPhoneNumberUpdateOtpMutationFn = Apollo.MutationFunction<VerifyPhoneNumberUpdateOtpMutation, VerifyPhoneNumberUpdateOtpMutationVariables>;

/**
 * __useVerifyPhoneNumberUpdateOtpMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneNumberUpdateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneNumberUpdateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneNumberUpdateOtpMutation, { data, loading, error }] = useVerifyPhoneNumberUpdateOtpMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useVerifyPhoneNumberUpdateOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPhoneNumberUpdateOtpMutation, VerifyPhoneNumberUpdateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPhoneNumberUpdateOtpMutation, VerifyPhoneNumberUpdateOtpMutationVariables>(VerifyPhoneNumberUpdateOtpDocument, options);
      }
export type VerifyPhoneNumberUpdateOtpMutationHookResult = ReturnType<typeof useVerifyPhoneNumberUpdateOtpMutation>;
export type VerifyPhoneNumberUpdateOtpMutationResult = Apollo.MutationResult<VerifyPhoneNumberUpdateOtpMutation>;
export type VerifyPhoneNumberUpdateOtpMutationOptions = Apollo.BaseMutationOptions<VerifyPhoneNumberUpdateOtpMutation, VerifyPhoneNumberUpdateOtpMutationVariables>;
export const GetProductBrandsDocument = gql`
    query GetProductBrands {
  productBrands {
    id
    name
    externalCode
    productCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetProductBrandsQuery__
 *
 * To run a query within a React component, call `useGetProductBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductBrandsQuery, GetProductBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductBrandsQuery, GetProductBrandsQueryVariables>(GetProductBrandsDocument, options);
      }
export function useGetProductBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductBrandsQuery, GetProductBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductBrandsQuery, GetProductBrandsQueryVariables>(GetProductBrandsDocument, options);
        }
// @ts-ignore
export function useGetProductBrandsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductBrandsQuery, GetProductBrandsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductBrandsQuery, GetProductBrandsQueryVariables>;
export function useGetProductBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductBrandsQuery, GetProductBrandsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductBrandsQuery | undefined, GetProductBrandsQueryVariables>;
export function useGetProductBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductBrandsQuery, GetProductBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductBrandsQuery, GetProductBrandsQueryVariables>(GetProductBrandsDocument, options);
        }
export type GetProductBrandsQueryHookResult = ReturnType<typeof useGetProductBrandsQuery>;
export type GetProductBrandsLazyQueryHookResult = ReturnType<typeof useGetProductBrandsLazyQuery>;
export type GetProductBrandsSuspenseQueryHookResult = ReturnType<typeof useGetProductBrandsSuspenseQuery>;
export type GetProductBrandsQueryResult = Apollo.QueryResult<GetProductBrandsQuery, GetProductBrandsQueryVariables>;
export const CreateProductBrandDocument = gql`
    mutation CreateProductBrand($input: CreateProductBrandInput!) {
  createProductBrand(input: $input) {
    id
    name
    externalCode
  }
}
    `;
export type CreateProductBrandMutationFn = Apollo.MutationFunction<CreateProductBrandMutation, CreateProductBrandMutationVariables>;

/**
 * __useCreateProductBrandMutation__
 *
 * To run a mutation, you first call `useCreateProductBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductBrandMutation, { data, loading, error }] = useCreateProductBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductBrandMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductBrandMutation, CreateProductBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductBrandMutation, CreateProductBrandMutationVariables>(CreateProductBrandDocument, options);
      }
export type CreateProductBrandMutationHookResult = ReturnType<typeof useCreateProductBrandMutation>;
export type CreateProductBrandMutationResult = Apollo.MutationResult<CreateProductBrandMutation>;
export type CreateProductBrandMutationOptions = Apollo.BaseMutationOptions<CreateProductBrandMutation, CreateProductBrandMutationVariables>;
export const UpdateProductBrandDocument = gql`
    mutation UpdateProductBrand($id: String!, $input: UpdateProductBrandInput!) {
  updateProductBrand(id: $id, input: $input) {
    id
    name
    externalCode
  }
}
    `;
export type UpdateProductBrandMutationFn = Apollo.MutationFunction<UpdateProductBrandMutation, UpdateProductBrandMutationVariables>;

/**
 * __useUpdateProductBrandMutation__
 *
 * To run a mutation, you first call `useUpdateProductBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBrandMutation, { data, loading, error }] = useUpdateProductBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductBrandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductBrandMutation, UpdateProductBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductBrandMutation, UpdateProductBrandMutationVariables>(UpdateProductBrandDocument, options);
      }
export type UpdateProductBrandMutationHookResult = ReturnType<typeof useUpdateProductBrandMutation>;
export type UpdateProductBrandMutationResult = Apollo.MutationResult<UpdateProductBrandMutation>;
export type UpdateProductBrandMutationOptions = Apollo.BaseMutationOptions<UpdateProductBrandMutation, UpdateProductBrandMutationVariables>;
export const DeleteProductBrandDocument = gql`
    mutation DeleteProductBrand($id: String!) {
  deleteProductBrand(id: $id) {
    id
    name
  }
}
    `;
export type DeleteProductBrandMutationFn = Apollo.MutationFunction<DeleteProductBrandMutation, DeleteProductBrandMutationVariables>;

/**
 * __useDeleteProductBrandMutation__
 *
 * To run a mutation, you first call `useDeleteProductBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductBrandMutation, { data, loading, error }] = useDeleteProductBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductBrandMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductBrandMutation, DeleteProductBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductBrandMutation, DeleteProductBrandMutationVariables>(DeleteProductBrandDocument, options);
      }
export type DeleteProductBrandMutationHookResult = ReturnType<typeof useDeleteProductBrandMutation>;
export type DeleteProductBrandMutationResult = Apollo.MutationResult<DeleteProductBrandMutation>;
export type DeleteProductBrandMutationOptions = Apollo.BaseMutationOptions<DeleteProductBrandMutation, DeleteProductBrandMutationVariables>;
export const GetProductCategoriesDocument = gql`
    query GetProductCategories {
  productCategories {
    id
    name
    externalCode
    rank
    productCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetProductCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
      }
export function useGetProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
// @ts-ignore
export function useGetProductCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export function useGetProductCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductCategoriesQuery | undefined, GetProductCategoriesQueryVariables>;
export function useGetProductCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
export type GetProductCategoriesQueryHookResult = ReturnType<typeof useGetProductCategoriesQuery>;
export type GetProductCategoriesLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesLazyQuery>;
export type GetProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetProductCategoriesSuspenseQuery>;
export type GetProductCategoriesQueryResult = Apollo.QueryResult<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export const CreateProductCategoryDocument = gql`
    mutation CreateProductCategory($input: CreateProductCategoryInput!) {
  createProductCategory(input: $input) {
    id
    name
    externalCode
    rank
  }
}
    `;
export type CreateProductCategoryMutationFn = Apollo.MutationFunction<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>;

/**
 * __useCreateProductCategoryMutation__
 *
 * To run a mutation, you first call `useCreateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductCategoryMutation, { data, loading, error }] = useCreateProductCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>(CreateProductCategoryDocument, options);
      }
export type CreateProductCategoryMutationHookResult = ReturnType<typeof useCreateProductCategoryMutation>;
export type CreateProductCategoryMutationResult = Apollo.MutationResult<CreateProductCategoryMutation>;
export type CreateProductCategoryMutationOptions = Apollo.BaseMutationOptions<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>;
export const UpdateProductCategoryDocument = gql`
    mutation UpdateProductCategory($id: String!, $input: UpdateProductCategoryInput!) {
  updateProductCategory(id: $id, input: $input) {
    id
    name
    externalCode
    rank
  }
}
    `;
export type UpdateProductCategoryMutationFn = Apollo.MutationFunction<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>;

/**
 * __useUpdateProductCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductCategoryMutation, { data, loading, error }] = useUpdateProductCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>(UpdateProductCategoryDocument, options);
      }
export type UpdateProductCategoryMutationHookResult = ReturnType<typeof useUpdateProductCategoryMutation>;
export type UpdateProductCategoryMutationResult = Apollo.MutationResult<UpdateProductCategoryMutation>;
export type UpdateProductCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>;
export const DeleteProductCategoryDocument = gql`
    mutation DeleteProductCategory($id: String!) {
  deleteProductCategory(id: $id) {
    id
    name
  }
}
    `;
export type DeleteProductCategoryMutationFn = Apollo.MutationFunction<DeleteProductCategoryMutation, DeleteProductCategoryMutationVariables>;

/**
 * __useDeleteProductCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductCategoryMutation, { data, loading, error }] = useDeleteProductCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductCategoryMutation, DeleteProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductCategoryMutation, DeleteProductCategoryMutationVariables>(DeleteProductCategoryDocument, options);
      }
export type DeleteProductCategoryMutationHookResult = ReturnType<typeof useDeleteProductCategoryMutation>;
export type DeleteProductCategoryMutationResult = Apollo.MutationResult<DeleteProductCategoryMutation>;
export type DeleteProductCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteProductCategoryMutation, DeleteProductCategoryMutationVariables>;
export const GetProductsDocument = gql`
    query GetProducts($input: ProductListInput) {
  products(input: $input) {
    items {
      id
      sku
      name
      description
      requiresSerialTracking
      canAcceptToken
      panelWatts
      batteryKwh
      panelEfficiency
      systemEfficiency
      isActive
      family
      kind
      productCategoryId
      productCategory {
        id
        name
      }
      productBrandId
      productBrand {
        id
        name
      }
      businessLineId
      businessLine {
        id
        name
      }
      unitOfMeasureId
      itemCategoryId
      itemCategory {
        id
        path
      }
      itemCategoryId
      itemCategory {
        id
        path
      }
      unitOfMeasure {
        id
        name
      }
      lastCostCents
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
// @ts-ignore
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsQuery, GetProductsQueryVariables>;
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductsQuery | undefined, GetProductsQueryVariables>;
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($id: String!) {
  product(id: $id) {
    id
    sku
    name
    description
    requiresSerialTracking
    canAcceptToken
    panelWatts
    batteryKwh
    panelEfficiency
    systemEfficiency
    isActive
    family
    kind
    productCategoryId
    productCategory {
      id
      name
    }
    productBrandId
    productBrand {
      id
      name
    }
    businessLineId
    businessLine {
      id
      name
    }
    unitOfMeasureId
    unitOfMeasure {
      id
      name
    }
    lastCostCents
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables> & ({ variables: GetProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
// @ts-ignore
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductQuery, GetProductQueryVariables>;
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductQuery | undefined, GetProductQueryVariables>;
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    id
    sku
    name
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: String!, $input: UpdateProductInput!) {
  updateProduct(id: $id, input: $input) {
    id
    sku
    name
    isActive
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const GetPurchaseOrdersDocument = gql`
    query GetPurchaseOrders($input: PurchaseOrderListInput) {
  purchaseOrders(input: $input) {
    items {
      shipment {
        id
        state
        closedAt
      }
      id
      purchaseOrderNumber
      poNumber
      supplier {
        id
        name
      }
      shippingCompany {
        id
        name
      }
      waybillReference
      contentType
      stockType
      status
      closedAt
      cancelledAt
      createdAt
      destination {
        id
        name
        stockingPointId
      }
      createdBy {
        id
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetPurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useGetPurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPurchaseOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>(GetPurchaseOrdersDocument, options);
      }
export function useGetPurchaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>(GetPurchaseOrdersDocument, options);
        }
// @ts-ignore
export function useGetPurchaseOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>;
export function useGetPurchaseOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrdersQuery | undefined, GetPurchaseOrdersQueryVariables>;
export function useGetPurchaseOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>(GetPurchaseOrdersDocument, options);
        }
export type GetPurchaseOrdersQueryHookResult = ReturnType<typeof useGetPurchaseOrdersQuery>;
export type GetPurchaseOrdersLazyQueryHookResult = ReturnType<typeof useGetPurchaseOrdersLazyQuery>;
export type GetPurchaseOrdersSuspenseQueryHookResult = ReturnType<typeof useGetPurchaseOrdersSuspenseQuery>;
export type GetPurchaseOrdersQueryResult = Apollo.QueryResult<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>;
export const GetPurchaseOrderDocument = gql`
    query GetPurchaseOrder($id: String!) {
  purchaseOrder(id: $id) {
    id
    purchaseOrderNumber
    poNumber
    supplier {
      id
      name
    }
    shippingCompany {
      id
      name
      courier
    }
    waybillReference
    shipment {
      ...ShipmentFields
    }
    contentType
    stockType
    status
    closedAt
    cancelledAt
    cancelReason
    notes
    createdAt
    updatedAt
    destination {
      id
      name
      stockingPointId
    }
    createdBy {
      id
      firstName
      lastName
    }
    items {
      id
      serialNumber
      accountNumber
      productSku
      productName
      stockType {
        id
        name
      }
      status
    }
    lines {
      ...PurchaseOrderLineFields
    }
  }
}
    ${ShipmentFieldsFragmentDoc}
${PurchaseOrderLineFieldsFragmentDoc}`;

/**
 * __useGetPurchaseOrderQuery__
 *
 * To run a query within a React component, call `useGetPurchaseOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPurchaseOrderQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables> & ({ variables: GetPurchaseOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>(GetPurchaseOrderDocument, options);
      }
export function useGetPurchaseOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>(GetPurchaseOrderDocument, options);
        }
// @ts-ignore
export function useGetPurchaseOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>;
export function useGetPurchaseOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>): Apollo.UseSuspenseQueryResult<GetPurchaseOrderQuery | undefined, GetPurchaseOrderQueryVariables>;
export function useGetPurchaseOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>(GetPurchaseOrderDocument, options);
        }
export type GetPurchaseOrderQueryHookResult = ReturnType<typeof useGetPurchaseOrderQuery>;
export type GetPurchaseOrderLazyQueryHookResult = ReturnType<typeof useGetPurchaseOrderLazyQuery>;
export type GetPurchaseOrderSuspenseQueryHookResult = ReturnType<typeof useGetPurchaseOrderSuspenseQuery>;
export type GetPurchaseOrderQueryResult = Apollo.QueryResult<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>;
export const CreatePurchaseOrderDocument = gql`
    mutation CreatePurchaseOrder($input: CreatePurchaseOrderInput!) {
  createPurchaseOrder(input: $input) {
    id
    purchaseOrderNumber
    status
  }
}
    `;
export type CreatePurchaseOrderMutationFn = Apollo.MutationFunction<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;

/**
 * __useCreatePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseOrderMutation, { data, loading, error }] = useCreatePurchaseOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>(CreatePurchaseOrderDocument, options);
      }
export type CreatePurchaseOrderMutationHookResult = ReturnType<typeof useCreatePurchaseOrderMutation>;
export type CreatePurchaseOrderMutationResult = Apollo.MutationResult<CreatePurchaseOrderMutation>;
export type CreatePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;
export const AddPurchaseOrderItemsDocument = gql`
    mutation AddPurchaseOrderItems($id: String!, $input: AddPurchaseOrderItemsInput!) {
  addPurchaseOrderItems(id: $id, input: $input) {
    id
    purchaseOrderNumber
    items {
      id
      serialNumber
      accountNumber
      productSku
      productName
      status
    }
  }
}
    `;
export type AddPurchaseOrderItemsMutationFn = Apollo.MutationFunction<AddPurchaseOrderItemsMutation, AddPurchaseOrderItemsMutationVariables>;

/**
 * __useAddPurchaseOrderItemsMutation__
 *
 * To run a mutation, you first call `useAddPurchaseOrderItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPurchaseOrderItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPurchaseOrderItemsMutation, { data, loading, error }] = useAddPurchaseOrderItemsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPurchaseOrderItemsMutation(baseOptions?: Apollo.MutationHookOptions<AddPurchaseOrderItemsMutation, AddPurchaseOrderItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPurchaseOrderItemsMutation, AddPurchaseOrderItemsMutationVariables>(AddPurchaseOrderItemsDocument, options);
      }
export type AddPurchaseOrderItemsMutationHookResult = ReturnType<typeof useAddPurchaseOrderItemsMutation>;
export type AddPurchaseOrderItemsMutationResult = Apollo.MutationResult<AddPurchaseOrderItemsMutation>;
export type AddPurchaseOrderItemsMutationOptions = Apollo.BaseMutationOptions<AddPurchaseOrderItemsMutation, AddPurchaseOrderItemsMutationVariables>;
export const MarkPurchaseOrderInTransitDocument = gql`
    mutation MarkPurchaseOrderInTransit($id: String!) {
  markPurchaseOrderInTransit(id: $id) {
    id
    status
  }
}
    `;
export type MarkPurchaseOrderInTransitMutationFn = Apollo.MutationFunction<MarkPurchaseOrderInTransitMutation, MarkPurchaseOrderInTransitMutationVariables>;

/**
 * __useMarkPurchaseOrderInTransitMutation__
 *
 * To run a mutation, you first call `useMarkPurchaseOrderInTransitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPurchaseOrderInTransitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPurchaseOrderInTransitMutation, { data, loading, error }] = useMarkPurchaseOrderInTransitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkPurchaseOrderInTransitMutation(baseOptions?: Apollo.MutationHookOptions<MarkPurchaseOrderInTransitMutation, MarkPurchaseOrderInTransitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPurchaseOrderInTransitMutation, MarkPurchaseOrderInTransitMutationVariables>(MarkPurchaseOrderInTransitDocument, options);
      }
export type MarkPurchaseOrderInTransitMutationHookResult = ReturnType<typeof useMarkPurchaseOrderInTransitMutation>;
export type MarkPurchaseOrderInTransitMutationResult = Apollo.MutationResult<MarkPurchaseOrderInTransitMutation>;
export type MarkPurchaseOrderInTransitMutationOptions = Apollo.BaseMutationOptions<MarkPurchaseOrderInTransitMutation, MarkPurchaseOrderInTransitMutationVariables>;
export const ClosePurchaseOrderDocument = gql`
    mutation ClosePurchaseOrder($id: String!, $courierOverrideReason: String) {
  closePurchaseOrder(id: $id, courierOverrideReason: $courierOverrideReason) {
    id
    status
    closedAt
  }
}
    `;
export type ClosePurchaseOrderMutationFn = Apollo.MutationFunction<ClosePurchaseOrderMutation, ClosePurchaseOrderMutationVariables>;

/**
 * __useClosePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useClosePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closePurchaseOrderMutation, { data, loading, error }] = useClosePurchaseOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierOverrideReason: // value for 'courierOverrideReason'
 *   },
 * });
 */
export function useClosePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<ClosePurchaseOrderMutation, ClosePurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosePurchaseOrderMutation, ClosePurchaseOrderMutationVariables>(ClosePurchaseOrderDocument, options);
      }
export type ClosePurchaseOrderMutationHookResult = ReturnType<typeof useClosePurchaseOrderMutation>;
export type ClosePurchaseOrderMutationResult = Apollo.MutationResult<ClosePurchaseOrderMutation>;
export type ClosePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<ClosePurchaseOrderMutation, ClosePurchaseOrderMutationVariables>;
export const CancelPurchaseOrderDocument = gql`
    mutation CancelPurchaseOrder($id: String!, $reason: String!) {
  cancelPurchaseOrder(id: $id, reason: $reason) {
    id
    status
    cancelledAt
    cancelReason
  }
}
    `;
export type CancelPurchaseOrderMutationFn = Apollo.MutationFunction<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>;

/**
 * __useCancelPurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCancelPurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPurchaseOrderMutation, { data, loading, error }] = useCancelPurchaseOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelPurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>(CancelPurchaseOrderDocument, options);
      }
export type CancelPurchaseOrderMutationHookResult = ReturnType<typeof useCancelPurchaseOrderMutation>;
export type CancelPurchaseOrderMutationResult = Apollo.MutationResult<CancelPurchaseOrderMutation>;
export type CancelPurchaseOrderMutationOptions = Apollo.BaseMutationOptions<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>;
export const UpdatePurchaseOrderShippingDocument = gql`
    mutation UpdatePurchaseOrderShipping($id: String!, $input: ShippingDetailsInput!) {
  updatePurchaseOrderShipping(id: $id, input: $input) {
    id
    shippingCompany {
      id
      name
      courier
    }
    waybillReference
    shipment {
      ...ShipmentFields
    }
  }
}
    ${ShipmentFieldsFragmentDoc}`;
export type UpdatePurchaseOrderShippingMutationFn = Apollo.MutationFunction<UpdatePurchaseOrderShippingMutation, UpdatePurchaseOrderShippingMutationVariables>;

/**
 * __useUpdatePurchaseOrderShippingMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseOrderShippingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseOrderShippingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseOrderShippingMutation, { data, loading, error }] = useUpdatePurchaseOrderShippingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePurchaseOrderShippingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseOrderShippingMutation, UpdatePurchaseOrderShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseOrderShippingMutation, UpdatePurchaseOrderShippingMutationVariables>(UpdatePurchaseOrderShippingDocument, options);
      }
export type UpdatePurchaseOrderShippingMutationHookResult = ReturnType<typeof useUpdatePurchaseOrderShippingMutation>;
export type UpdatePurchaseOrderShippingMutationResult = Apollo.MutationResult<UpdatePurchaseOrderShippingMutation>;
export type UpdatePurchaseOrderShippingMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseOrderShippingMutation, UpdatePurchaseOrderShippingMutationVariables>;
export const UpdatePurchaseOrderLinesDocument = gql`
    mutation UpdatePurchaseOrderLines($id: String!, $lines: [PurchaseOrderLineInput!]!) {
  updatePurchaseOrderPlan(id: $id, input: {lines: $lines}) {
    id
    lines {
      ...PurchaseOrderLineFields
    }
  }
}
    ${PurchaseOrderLineFieldsFragmentDoc}`;
export type UpdatePurchaseOrderLinesMutationFn = Apollo.MutationFunction<UpdatePurchaseOrderLinesMutation, UpdatePurchaseOrderLinesMutationVariables>;

/**
 * __useUpdatePurchaseOrderLinesMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseOrderLinesMutation, { data, loading, error }] = useUpdatePurchaseOrderLinesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lines: // value for 'lines'
 *   },
 * });
 */
export function useUpdatePurchaseOrderLinesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseOrderLinesMutation, UpdatePurchaseOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseOrderLinesMutation, UpdatePurchaseOrderLinesMutationVariables>(UpdatePurchaseOrderLinesDocument, options);
      }
export type UpdatePurchaseOrderLinesMutationHookResult = ReturnType<typeof useUpdatePurchaseOrderLinesMutation>;
export type UpdatePurchaseOrderLinesMutationResult = Apollo.MutationResult<UpdatePurchaseOrderLinesMutation>;
export type UpdatePurchaseOrderLinesMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseOrderLinesMutation, UpdatePurchaseOrderLinesMutationVariables>;
export const ReceivePurchaseOrderLinesDocument = gql`
    mutation ReceivePurchaseOrderLines($id: String!, $lines: [ReceivePurchaseOrderLineInput!]!) {
  receivePurchaseOrderLines(id: $id, lines: $lines) {
    id
    lines {
      ...PurchaseOrderLineFields
    }
  }
}
    ${PurchaseOrderLineFieldsFragmentDoc}`;
export type ReceivePurchaseOrderLinesMutationFn = Apollo.MutationFunction<ReceivePurchaseOrderLinesMutation, ReceivePurchaseOrderLinesMutationVariables>;

/**
 * __useReceivePurchaseOrderLinesMutation__
 *
 * To run a mutation, you first call `useReceivePurchaseOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceivePurchaseOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receivePurchaseOrderLinesMutation, { data, loading, error }] = useReceivePurchaseOrderLinesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lines: // value for 'lines'
 *   },
 * });
 */
export function useReceivePurchaseOrderLinesMutation(baseOptions?: Apollo.MutationHookOptions<ReceivePurchaseOrderLinesMutation, ReceivePurchaseOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceivePurchaseOrderLinesMutation, ReceivePurchaseOrderLinesMutationVariables>(ReceivePurchaseOrderLinesDocument, options);
      }
export type ReceivePurchaseOrderLinesMutationHookResult = ReturnType<typeof useReceivePurchaseOrderLinesMutation>;
export type ReceivePurchaseOrderLinesMutationResult = Apollo.MutationResult<ReceivePurchaseOrderLinesMutation>;
export type ReceivePurchaseOrderLinesMutationOptions = Apollo.BaseMutationOptions<ReceivePurchaseOrderLinesMutation, ReceivePurchaseOrderLinesMutationVariables>;
export const ResolveRatePlanChangeDocument = gql`
    query ResolveRatePlanChange($input: ResolveRatePlanChangeInput!) {
  resolveRatePlanChange(input: $input) {
    planValid
    planError
    planRateName
    rows {
      rowNumber
      identifier
      valid
      error
      alreadyApplied
      contractId
      contractNumber
      customerName
      currentRateName
      currentDeviceSerialNumber
      currentDeviceAccountNumber
      newDeviceSerialNumber
      newDeviceAccountNumber
      newDeviceProductName
      devices {
        productName
        replacing
        currentSerialNumber
        currentAccountNumber
        newSerialNumber
        newAccountNumber
      }
      currentTotalPrice
      newTotalPrice
      currentBalance
      projectedBalance
      catchUpTokenDays
      catchUpTokenAmount
      wouldPayOff
      warnings {
        code
        detail
      }
    }
  }
}
    `;

/**
 * __useResolveRatePlanChangeQuery__
 *
 * To run a query within a React component, call `useResolveRatePlanChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveRatePlanChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveRatePlanChangeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveRatePlanChangeQuery(baseOptions: Apollo.QueryHookOptions<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables> & ({ variables: ResolveRatePlanChangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>(ResolveRatePlanChangeDocument, options);
      }
export function useResolveRatePlanChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>(ResolveRatePlanChangeDocument, options);
        }
// @ts-ignore
export function useResolveRatePlanChangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>;
export function useResolveRatePlanChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveRatePlanChangeQuery | undefined, ResolveRatePlanChangeQueryVariables>;
export function useResolveRatePlanChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>(ResolveRatePlanChangeDocument, options);
        }
export type ResolveRatePlanChangeQueryHookResult = ReturnType<typeof useResolveRatePlanChangeQuery>;
export type ResolveRatePlanChangeLazyQueryHookResult = ReturnType<typeof useResolveRatePlanChangeLazyQuery>;
export type ResolveRatePlanChangeSuspenseQueryHookResult = ReturnType<typeof useResolveRatePlanChangeSuspenseQuery>;
export type ResolveRatePlanChangeQueryResult = Apollo.QueryResult<ResolveRatePlanChangeQuery, ResolveRatePlanChangeQueryVariables>;
export const ChangeContractRatePlanDocument = gql`
    mutation ChangeContractRatePlan($input: ChangeContractRatePlanInput!) {
  changeContractRatePlan(input: $input) {
    contractNumber
    newRateName
    newTotalPrice
    newBalance
    catchUpTokenDays
    catchUpTokenAmount
    reassignment {
      id
      newSerialNumber
      newAccountNumber
      customerNotifiedAt
    }
  }
}
    `;
export type ChangeContractRatePlanMutationFn = Apollo.MutationFunction<ChangeContractRatePlanMutation, ChangeContractRatePlanMutationVariables>;

/**
 * __useChangeContractRatePlanMutation__
 *
 * To run a mutation, you first call `useChangeContractRatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeContractRatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeContractRatePlanMutation, { data, loading, error }] = useChangeContractRatePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeContractRatePlanMutation(baseOptions?: Apollo.MutationHookOptions<ChangeContractRatePlanMutation, ChangeContractRatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeContractRatePlanMutation, ChangeContractRatePlanMutationVariables>(ChangeContractRatePlanDocument, options);
      }
export type ChangeContractRatePlanMutationHookResult = ReturnType<typeof useChangeContractRatePlanMutation>;
export type ChangeContractRatePlanMutationResult = Apollo.MutationResult<ChangeContractRatePlanMutation>;
export type ChangeContractRatePlanMutationOptions = Apollo.BaseMutationOptions<ChangeContractRatePlanMutation, ChangeContractRatePlanMutationVariables>;
export const BulkChangeContractRatePlanDocument = gql`
    mutation BulkChangeContractRatePlan($input: BulkChangeContractRatePlanInput!) {
  bulkChangeContractRatePlan(input: $input) {
    total
    succeeded
    failed
    skipped
    rows {
      rowNumber
      identifier
      status
      reason
      contractNumber
      previousSerialNumber
      newSerialNumber
      catchUpTokenDays
      catchUpTokenAmount
      newBalance
    }
  }
}
    `;
export type BulkChangeContractRatePlanMutationFn = Apollo.MutationFunction<BulkChangeContractRatePlanMutation, BulkChangeContractRatePlanMutationVariables>;

/**
 * __useBulkChangeContractRatePlanMutation__
 *
 * To run a mutation, you first call `useBulkChangeContractRatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkChangeContractRatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkChangeContractRatePlanMutation, { data, loading, error }] = useBulkChangeContractRatePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkChangeContractRatePlanMutation(baseOptions?: Apollo.MutationHookOptions<BulkChangeContractRatePlanMutation, BulkChangeContractRatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkChangeContractRatePlanMutation, BulkChangeContractRatePlanMutationVariables>(BulkChangeContractRatePlanDocument, options);
      }
export type BulkChangeContractRatePlanMutationHookResult = ReturnType<typeof useBulkChangeContractRatePlanMutation>;
export type BulkChangeContractRatePlanMutationResult = Apollo.MutationResult<BulkChangeContractRatePlanMutation>;
export type BulkChangeContractRatePlanMutationOptions = Apollo.BaseMutationOptions<BulkChangeContractRatePlanMutation, BulkChangeContractRatePlanMutationVariables>;
export const GetRatePlansDocument = gql`
    query GetRatePlans($input: RatePlanListInput) {
  ratePlans(input: $input) {
    items {
      id
      rateName
      product
      manSystem
      depositAmount
      depositCollectedUpfront
      rateAmount
      downpayment
      downpaymentFormula
      termLength
      tokenCase
      type
      isActive
      createdAt
      contractCount
      commissionMonth1
      commissionMonth2
      commissionMonth3
      commissionMonth4
      commissionCloseout
      commissionRam
      aftercareAgent
      aftercareRam
      products {
        id
        allocationPercentage
        product {
          id
          name
          sku
          canAcceptToken
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetRatePlansQuery__
 *
 * To run a query within a React component, call `useGetRatePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatePlansQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRatePlansQuery(baseOptions?: Apollo.QueryHookOptions<GetRatePlansQuery, GetRatePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRatePlansQuery, GetRatePlansQueryVariables>(GetRatePlansDocument, options);
      }
export function useGetRatePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRatePlansQuery, GetRatePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRatePlansQuery, GetRatePlansQueryVariables>(GetRatePlansDocument, options);
        }
// @ts-ignore
export function useGetRatePlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRatePlansQuery, GetRatePlansQueryVariables>): Apollo.UseSuspenseQueryResult<GetRatePlansQuery, GetRatePlansQueryVariables>;
export function useGetRatePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRatePlansQuery, GetRatePlansQueryVariables>): Apollo.UseSuspenseQueryResult<GetRatePlansQuery | undefined, GetRatePlansQueryVariables>;
export function useGetRatePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRatePlansQuery, GetRatePlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRatePlansQuery, GetRatePlansQueryVariables>(GetRatePlansDocument, options);
        }
export type GetRatePlansQueryHookResult = ReturnType<typeof useGetRatePlansQuery>;
export type GetRatePlansLazyQueryHookResult = ReturnType<typeof useGetRatePlansLazyQuery>;
export type GetRatePlansSuspenseQueryHookResult = ReturnType<typeof useGetRatePlansSuspenseQuery>;
export type GetRatePlansQueryResult = Apollo.QueryResult<GetRatePlansQuery, GetRatePlansQueryVariables>;
export const GetRatePlanDocument = gql`
    query GetRatePlan($id: String!) {
  ratePlan(id: $id) {
    id
    rateName
    product
    manSystem
    depositAmount
    depositCollectedUpfront
    rateAmount
    downpayment
    downpaymentFormula
    termLength
    tokenCase
    isActive
    createdAt
    updatedAt
    contractCount
    commissionMonth1
    commissionMonth2
    commissionMonth3
    commissionMonth4
    commissionCloseout
    products {
      id
      allocationPercentage
      product {
        id
        name
        sku
        canAcceptToken
      }
    }
  }
}
    `;

/**
 * __useGetRatePlanQuery__
 *
 * To run a query within a React component, call `useGetRatePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatePlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRatePlanQuery(baseOptions: Apollo.QueryHookOptions<GetRatePlanQuery, GetRatePlanQueryVariables> & ({ variables: GetRatePlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRatePlanQuery, GetRatePlanQueryVariables>(GetRatePlanDocument, options);
      }
export function useGetRatePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRatePlanQuery, GetRatePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRatePlanQuery, GetRatePlanQueryVariables>(GetRatePlanDocument, options);
        }
// @ts-ignore
export function useGetRatePlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRatePlanQuery, GetRatePlanQueryVariables>): Apollo.UseSuspenseQueryResult<GetRatePlanQuery, GetRatePlanQueryVariables>;
export function useGetRatePlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRatePlanQuery, GetRatePlanQueryVariables>): Apollo.UseSuspenseQueryResult<GetRatePlanQuery | undefined, GetRatePlanQueryVariables>;
export function useGetRatePlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRatePlanQuery, GetRatePlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRatePlanQuery, GetRatePlanQueryVariables>(GetRatePlanDocument, options);
        }
export type GetRatePlanQueryHookResult = ReturnType<typeof useGetRatePlanQuery>;
export type GetRatePlanLazyQueryHookResult = ReturnType<typeof useGetRatePlanLazyQuery>;
export type GetRatePlanSuspenseQueryHookResult = ReturnType<typeof useGetRatePlanSuspenseQuery>;
export type GetRatePlanQueryResult = Apollo.QueryResult<GetRatePlanQuery, GetRatePlanQueryVariables>;
export const CreateRatePlanDocument = gql`
    mutation CreateRatePlan($input: CreateRatePlanInput!) {
  createRatePlan(input: $input) {
    id
    rateName
    product
    manSystem
    depositAmount
    depositCollectedUpfront
    rateAmount
    downpayment
    downpaymentFormula
    termLength
    tokenCase
    isActive
    commissionMonth1
    commissionMonth2
    commissionMonth3
    commissionMonth4
    commissionCloseout
    products {
      id
      allocationPercentage
      product {
        id
        name
        sku
        canAcceptToken
      }
    }
  }
}
    `;
export type CreateRatePlanMutationFn = Apollo.MutationFunction<CreateRatePlanMutation, CreateRatePlanMutationVariables>;

/**
 * __useCreateRatePlanMutation__
 *
 * To run a mutation, you first call `useCreateRatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRatePlanMutation, { data, loading, error }] = useCreateRatePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRatePlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateRatePlanMutation, CreateRatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRatePlanMutation, CreateRatePlanMutationVariables>(CreateRatePlanDocument, options);
      }
export type CreateRatePlanMutationHookResult = ReturnType<typeof useCreateRatePlanMutation>;
export type CreateRatePlanMutationResult = Apollo.MutationResult<CreateRatePlanMutation>;
export type CreateRatePlanMutationOptions = Apollo.BaseMutationOptions<CreateRatePlanMutation, CreateRatePlanMutationVariables>;
export const UpdateRatePlanDocument = gql`
    mutation UpdateRatePlan($id: String!, $input: UpdateRatePlanInput!) {
  updateRatePlan(id: $id, input: $input) {
    id
    rateName
    product
    manSystem
    depositAmount
    depositCollectedUpfront
    rateAmount
    downpayment
    downpaymentFormula
    termLength
    tokenCase
    isActive
    commissionMonth1
    commissionMonth2
    commissionMonth3
    commissionMonth4
    commissionCloseout
    products {
      id
      allocationPercentage
      product {
        id
        name
        sku
        canAcceptToken
      }
    }
  }
}
    `;
export type UpdateRatePlanMutationFn = Apollo.MutationFunction<UpdateRatePlanMutation, UpdateRatePlanMutationVariables>;

/**
 * __useUpdateRatePlanMutation__
 *
 * To run a mutation, you first call `useUpdateRatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRatePlanMutation, { data, loading, error }] = useUpdateRatePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRatePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRatePlanMutation, UpdateRatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRatePlanMutation, UpdateRatePlanMutationVariables>(UpdateRatePlanDocument, options);
      }
export type UpdateRatePlanMutationHookResult = ReturnType<typeof useUpdateRatePlanMutation>;
export type UpdateRatePlanMutationResult = Apollo.MutationResult<UpdateRatePlanMutation>;
export type UpdateRatePlanMutationOptions = Apollo.BaseMutationOptions<UpdateRatePlanMutation, UpdateRatePlanMutationVariables>;
export const DeleteRatePlanDocument = gql`
    mutation DeleteRatePlan($id: String!) {
  deleteRatePlan(id: $id) {
    success
    message
  }
}
    `;
export type DeleteRatePlanMutationFn = Apollo.MutationFunction<DeleteRatePlanMutation, DeleteRatePlanMutationVariables>;

/**
 * __useDeleteRatePlanMutation__
 *
 * To run a mutation, you first call `useDeleteRatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRatePlanMutation, { data, loading, error }] = useDeleteRatePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRatePlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRatePlanMutation, DeleteRatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRatePlanMutation, DeleteRatePlanMutationVariables>(DeleteRatePlanDocument, options);
      }
export type DeleteRatePlanMutationHookResult = ReturnType<typeof useDeleteRatePlanMutation>;
export type DeleteRatePlanMutationResult = Apollo.MutationResult<DeleteRatePlanMutation>;
export type DeleteRatePlanMutationOptions = Apollo.BaseMutationOptions<DeleteRatePlanMutation, DeleteRatePlanMutationVariables>;
export const GetPayAtReconciliationSummaryDocument = gql`
    query GetPayAtReconciliationSummary($from: DateTime!, $to: DateTime!) {
  payAtReconciliationSummary(from: $from, to: $to) {
    from
    to
    lines
    totalCents
    byStatus {
      status
      lines
      totalCents
    }
  }
}
    `;

/**
 * __useGetPayAtReconciliationSummaryQuery__
 *
 * To run a query within a React component, call `useGetPayAtReconciliationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayAtReconciliationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayAtReconciliationSummaryQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetPayAtReconciliationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables> & ({ variables: GetPayAtReconciliationSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>(GetPayAtReconciliationSummaryDocument, options);
      }
export function useGetPayAtReconciliationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>(GetPayAtReconciliationSummaryDocument, options);
        }
// @ts-ignore
export function useGetPayAtReconciliationSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>;
export function useGetPayAtReconciliationSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtReconciliationSummaryQuery | undefined, GetPayAtReconciliationSummaryQueryVariables>;
export function useGetPayAtReconciliationSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>(GetPayAtReconciliationSummaryDocument, options);
        }
export type GetPayAtReconciliationSummaryQueryHookResult = ReturnType<typeof useGetPayAtReconciliationSummaryQuery>;
export type GetPayAtReconciliationSummaryLazyQueryHookResult = ReturnType<typeof useGetPayAtReconciliationSummaryLazyQuery>;
export type GetPayAtReconciliationSummarySuspenseQueryHookResult = ReturnType<typeof useGetPayAtReconciliationSummarySuspenseQuery>;
export type GetPayAtReconciliationSummaryQueryResult = Apollo.QueryResult<GetPayAtReconciliationSummaryQuery, GetPayAtReconciliationSummaryQueryVariables>;
export const GetPayAtDumpRowsDocument = gql`
    query GetPayAtDumpRows($filter: PayAtDumpRowFilterInput, $limit: Int, $offset: Int) {
  payAtDumpRows(filter: $filter, limit: $limit, offset: $offset) {
    totalCount
    items {
      ...PayAtDumpRowFields
    }
  }
}
    ${PayAtDumpRowFieldsFragmentDoc}`;

/**
 * __useGetPayAtDumpRowsQuery__
 *
 * To run a query within a React component, call `useGetPayAtDumpRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayAtDumpRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayAtDumpRowsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPayAtDumpRowsQuery(baseOptions?: Apollo.QueryHookOptions<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>(GetPayAtDumpRowsDocument, options);
      }
export function useGetPayAtDumpRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>(GetPayAtDumpRowsDocument, options);
        }
// @ts-ignore
export function useGetPayAtDumpRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>;
export function useGetPayAtDumpRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtDumpRowsQuery | undefined, GetPayAtDumpRowsQueryVariables>;
export function useGetPayAtDumpRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>(GetPayAtDumpRowsDocument, options);
        }
export type GetPayAtDumpRowsQueryHookResult = ReturnType<typeof useGetPayAtDumpRowsQuery>;
export type GetPayAtDumpRowsLazyQueryHookResult = ReturnType<typeof useGetPayAtDumpRowsLazyQuery>;
export type GetPayAtDumpRowsSuspenseQueryHookResult = ReturnType<typeof useGetPayAtDumpRowsSuspenseQuery>;
export type GetPayAtDumpRowsQueryResult = Apollo.QueryResult<GetPayAtDumpRowsQuery, GetPayAtDumpRowsQueryVariables>;
export const GetPayAtDumpRowDocument = gql`
    query GetPayAtDumpRow($id: String!) {
  payAtDumpRow(id: $id) {
    ...PayAtDumpRowFields
    dump {
      id
      fileName
      businessDate
    }
  }
}
    ${PayAtDumpRowFieldsFragmentDoc}`;

/**
 * __useGetPayAtDumpRowQuery__
 *
 * To run a query within a React component, call `useGetPayAtDumpRowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayAtDumpRowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayAtDumpRowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPayAtDumpRowQuery(baseOptions: Apollo.QueryHookOptions<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables> & ({ variables: GetPayAtDumpRowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>(GetPayAtDumpRowDocument, options);
      }
export function useGetPayAtDumpRowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>(GetPayAtDumpRowDocument, options);
        }
// @ts-ignore
export function useGetPayAtDumpRowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>;
export function useGetPayAtDumpRowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtDumpRowQuery | undefined, GetPayAtDumpRowQueryVariables>;
export function useGetPayAtDumpRowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>(GetPayAtDumpRowDocument, options);
        }
export type GetPayAtDumpRowQueryHookResult = ReturnType<typeof useGetPayAtDumpRowQuery>;
export type GetPayAtDumpRowLazyQueryHookResult = ReturnType<typeof useGetPayAtDumpRowLazyQuery>;
export type GetPayAtDumpRowSuspenseQueryHookResult = ReturnType<typeof useGetPayAtDumpRowSuspenseQuery>;
export type GetPayAtDumpRowQueryResult = Apollo.QueryResult<GetPayAtDumpRowQuery, GetPayAtDumpRowQueryVariables>;
export const GetPayAtRowCandidatesDocument = gql`
    query GetPayAtRowCandidates($rowId: String!) {
  payAtRowCandidates(rowId: $rowId) {
    referenceCode
    contractId
    paymentIds
    grossCents
    paidAt
    accountNumbers
    daysApart
    contractNumber
    customerName
  }
}
    `;

/**
 * __useGetPayAtRowCandidatesQuery__
 *
 * To run a query within a React component, call `useGetPayAtRowCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayAtRowCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayAtRowCandidatesQuery({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useGetPayAtRowCandidatesQuery(baseOptions: Apollo.QueryHookOptions<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables> & ({ variables: GetPayAtRowCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>(GetPayAtRowCandidatesDocument, options);
      }
export function useGetPayAtRowCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>(GetPayAtRowCandidatesDocument, options);
        }
// @ts-ignore
export function useGetPayAtRowCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>;
export function useGetPayAtRowCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtRowCandidatesQuery | undefined, GetPayAtRowCandidatesQueryVariables>;
export function useGetPayAtRowCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>(GetPayAtRowCandidatesDocument, options);
        }
export type GetPayAtRowCandidatesQueryHookResult = ReturnType<typeof useGetPayAtRowCandidatesQuery>;
export type GetPayAtRowCandidatesLazyQueryHookResult = ReturnType<typeof useGetPayAtRowCandidatesLazyQuery>;
export type GetPayAtRowCandidatesSuspenseQueryHookResult = ReturnType<typeof useGetPayAtRowCandidatesSuspenseQuery>;
export type GetPayAtRowCandidatesQueryResult = Apollo.QueryResult<GetPayAtRowCandidatesQuery, GetPayAtRowCandidatesQueryVariables>;
export const GetPayAtDumpsDocument = gql`
    query GetPayAtDumps($limit: Int, $offset: Int) {
  payAtDumps(limit: $limit, offset: $offset) {
    totalCount
    items {
      id
      fileName
      businessDate
      status
      lineCount
      badLineCount
      error
      ingestedAt
      matchedAt
    }
  }
}
    `;

/**
 * __useGetPayAtDumpsQuery__
 *
 * To run a query within a React component, call `useGetPayAtDumpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayAtDumpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayAtDumpsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPayAtDumpsQuery(baseOptions?: Apollo.QueryHookOptions<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>(GetPayAtDumpsDocument, options);
      }
export function useGetPayAtDumpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>(GetPayAtDumpsDocument, options);
        }
// @ts-ignore
export function useGetPayAtDumpsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>;
export function useGetPayAtDumpsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtDumpsQuery | undefined, GetPayAtDumpsQueryVariables>;
export function useGetPayAtDumpsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>(GetPayAtDumpsDocument, options);
        }
export type GetPayAtDumpsQueryHookResult = ReturnType<typeof useGetPayAtDumpsQuery>;
export type GetPayAtDumpsLazyQueryHookResult = ReturnType<typeof useGetPayAtDumpsLazyQuery>;
export type GetPayAtDumpsSuspenseQueryHookResult = ReturnType<typeof useGetPayAtDumpsSuspenseQuery>;
export type GetPayAtDumpsQueryResult = Apollo.QueryResult<GetPayAtDumpsQuery, GetPayAtDumpsQueryVariables>;
export const GetUnclaimedTillPaymentsDocument = gql`
    query GetUnclaimedTillPayments($from: DateTime!, $to: DateTime!, $limit: Int, $offset: Int) {
  unclaimedTillPayments(from: $from, to: $to, limit: $limit, offset: $offset) {
    totalCount
    items {
      id
      createdAt
      referenceCode
      accountNumber
      amount
      token
      countsTowardBalance
      depositDeducted
      contract {
        id
        contractNumber
        customer {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnclaimedTillPaymentsQuery__
 *
 * To run a query within a React component, call `useGetUnclaimedTillPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnclaimedTillPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnclaimedTillPaymentsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUnclaimedTillPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables> & ({ variables: GetUnclaimedTillPaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>(GetUnclaimedTillPaymentsDocument, options);
      }
export function useGetUnclaimedTillPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>(GetUnclaimedTillPaymentsDocument, options);
        }
// @ts-ignore
export function useGetUnclaimedTillPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>;
export function useGetUnclaimedTillPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnclaimedTillPaymentsQuery | undefined, GetUnclaimedTillPaymentsQueryVariables>;
export function useGetUnclaimedTillPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>(GetUnclaimedTillPaymentsDocument, options);
        }
export type GetUnclaimedTillPaymentsQueryHookResult = ReturnType<typeof useGetUnclaimedTillPaymentsQuery>;
export type GetUnclaimedTillPaymentsLazyQueryHookResult = ReturnType<typeof useGetUnclaimedTillPaymentsLazyQuery>;
export type GetUnclaimedTillPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetUnclaimedTillPaymentsSuspenseQuery>;
export type GetUnclaimedTillPaymentsQueryResult = Apollo.QueryResult<GetUnclaimedTillPaymentsQuery, GetUnclaimedTillPaymentsQueryVariables>;
export const MatchPayAtRowDocument = gql`
    mutation MatchPayAtRow($rowId: String!, $paymentIds: [String!]!) {
  matchPayAtRow(rowId: $rowId, paymentIds: $paymentIds) {
    ...PayAtDumpRowFields
  }
}
    ${PayAtDumpRowFieldsFragmentDoc}`;
export type MatchPayAtRowMutationFn = Apollo.MutationFunction<MatchPayAtRowMutation, MatchPayAtRowMutationVariables>;

/**
 * __useMatchPayAtRowMutation__
 *
 * To run a mutation, you first call `useMatchPayAtRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchPayAtRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchPayAtRowMutation, { data, loading, error }] = useMatchPayAtRowMutation({
 *   variables: {
 *      rowId: // value for 'rowId'
 *      paymentIds: // value for 'paymentIds'
 *   },
 * });
 */
export function useMatchPayAtRowMutation(baseOptions?: Apollo.MutationHookOptions<MatchPayAtRowMutation, MatchPayAtRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchPayAtRowMutation, MatchPayAtRowMutationVariables>(MatchPayAtRowDocument, options);
      }
export type MatchPayAtRowMutationHookResult = ReturnType<typeof useMatchPayAtRowMutation>;
export type MatchPayAtRowMutationResult = Apollo.MutationResult<MatchPayAtRowMutation>;
export type MatchPayAtRowMutationOptions = Apollo.BaseMutationOptions<MatchPayAtRowMutation, MatchPayAtRowMutationVariables>;
export const UnmatchPayAtRowDocument = gql`
    mutation UnmatchPayAtRow($rowId: String!) {
  unmatchPayAtRow(rowId: $rowId) {
    ...PayAtDumpRowFields
  }
}
    ${PayAtDumpRowFieldsFragmentDoc}`;
export type UnmatchPayAtRowMutationFn = Apollo.MutationFunction<UnmatchPayAtRowMutation, UnmatchPayAtRowMutationVariables>;

/**
 * __useUnmatchPayAtRowMutation__
 *
 * To run a mutation, you first call `useUnmatchPayAtRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmatchPayAtRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmatchPayAtRowMutation, { data, loading, error }] = useUnmatchPayAtRowMutation({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useUnmatchPayAtRowMutation(baseOptions?: Apollo.MutationHookOptions<UnmatchPayAtRowMutation, UnmatchPayAtRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmatchPayAtRowMutation, UnmatchPayAtRowMutationVariables>(UnmatchPayAtRowDocument, options);
      }
export type UnmatchPayAtRowMutationHookResult = ReturnType<typeof useUnmatchPayAtRowMutation>;
export type UnmatchPayAtRowMutationResult = Apollo.MutationResult<UnmatchPayAtRowMutation>;
export type UnmatchPayAtRowMutationOptions = Apollo.BaseMutationOptions<UnmatchPayAtRowMutation, UnmatchPayAtRowMutationVariables>;
export const IgnorePayAtRowsDocument = gql`
    mutation IgnorePayAtRows($rowIds: [String!]!) {
  ignorePayAtRows(rowIds: $rowIds)
}
    `;
export type IgnorePayAtRowsMutationFn = Apollo.MutationFunction<IgnorePayAtRowsMutation, IgnorePayAtRowsMutationVariables>;

/**
 * __useIgnorePayAtRowsMutation__
 *
 * To run a mutation, you first call `useIgnorePayAtRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnorePayAtRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignorePayAtRowsMutation, { data, loading, error }] = useIgnorePayAtRowsMutation({
 *   variables: {
 *      rowIds: // value for 'rowIds'
 *   },
 * });
 */
export function useIgnorePayAtRowsMutation(baseOptions?: Apollo.MutationHookOptions<IgnorePayAtRowsMutation, IgnorePayAtRowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnorePayAtRowsMutation, IgnorePayAtRowsMutationVariables>(IgnorePayAtRowsDocument, options);
      }
export type IgnorePayAtRowsMutationHookResult = ReturnType<typeof useIgnorePayAtRowsMutation>;
export type IgnorePayAtRowsMutationResult = Apollo.MutationResult<IgnorePayAtRowsMutation>;
export type IgnorePayAtRowsMutationOptions = Apollo.BaseMutationOptions<IgnorePayAtRowsMutation, IgnorePayAtRowsMutationVariables>;
export const UnignorePayAtRowDocument = gql`
    mutation UnignorePayAtRow($rowId: String!) {
  unignorePayAtRow(rowId: $rowId) {
    ...PayAtDumpRowFields
  }
}
    ${PayAtDumpRowFieldsFragmentDoc}`;
export type UnignorePayAtRowMutationFn = Apollo.MutationFunction<UnignorePayAtRowMutation, UnignorePayAtRowMutationVariables>;

/**
 * __useUnignorePayAtRowMutation__
 *
 * To run a mutation, you first call `useUnignorePayAtRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnignorePayAtRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unignorePayAtRowMutation, { data, loading, error }] = useUnignorePayAtRowMutation({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useUnignorePayAtRowMutation(baseOptions?: Apollo.MutationHookOptions<UnignorePayAtRowMutation, UnignorePayAtRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnignorePayAtRowMutation, UnignorePayAtRowMutationVariables>(UnignorePayAtRowDocument, options);
      }
export type UnignorePayAtRowMutationHookResult = ReturnType<typeof useUnignorePayAtRowMutation>;
export type UnignorePayAtRowMutationResult = Apollo.MutationResult<UnignorePayAtRowMutation>;
export type UnignorePayAtRowMutationOptions = Apollo.BaseMutationOptions<UnignorePayAtRowMutation, UnignorePayAtRowMutationVariables>;
export const SetPayAtRowAccountDocument = gql`
    mutation SetPayAtRowAccount($rowId: String!, $accountNumber: String!) {
  setPayAtRowAccount(rowId: $rowId, accountNumber: $accountNumber) {
    ...PayAtDumpRowFields
  }
}
    ${PayAtDumpRowFieldsFragmentDoc}`;
export type SetPayAtRowAccountMutationFn = Apollo.MutationFunction<SetPayAtRowAccountMutation, SetPayAtRowAccountMutationVariables>;

/**
 * __useSetPayAtRowAccountMutation__
 *
 * To run a mutation, you first call `useSetPayAtRowAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPayAtRowAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPayAtRowAccountMutation, { data, loading, error }] = useSetPayAtRowAccountMutation({
 *   variables: {
 *      rowId: // value for 'rowId'
 *      accountNumber: // value for 'accountNumber'
 *   },
 * });
 */
export function useSetPayAtRowAccountMutation(baseOptions?: Apollo.MutationHookOptions<SetPayAtRowAccountMutation, SetPayAtRowAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPayAtRowAccountMutation, SetPayAtRowAccountMutationVariables>(SetPayAtRowAccountDocument, options);
      }
export type SetPayAtRowAccountMutationHookResult = ReturnType<typeof useSetPayAtRowAccountMutation>;
export type SetPayAtRowAccountMutationResult = Apollo.MutationResult<SetPayAtRowAccountMutation>;
export type SetPayAtRowAccountMutationOptions = Apollo.BaseMutationOptions<SetPayAtRowAccountMutation, SetPayAtRowAccountMutationVariables>;
export const RecordPayAtRowPaymentDocument = gql`
    mutation RecordPayAtRowPayment($rowId: String!) {
  recordPayAtRowPayment(rowId: $rowId) {
    paymentId
    rowId
  }
}
    `;
export type RecordPayAtRowPaymentMutationFn = Apollo.MutationFunction<RecordPayAtRowPaymentMutation, RecordPayAtRowPaymentMutationVariables>;

/**
 * __useRecordPayAtRowPaymentMutation__
 *
 * To run a mutation, you first call `useRecordPayAtRowPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPayAtRowPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPayAtRowPaymentMutation, { data, loading, error }] = useRecordPayAtRowPaymentMutation({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useRecordPayAtRowPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordPayAtRowPaymentMutation, RecordPayAtRowPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPayAtRowPaymentMutation, RecordPayAtRowPaymentMutationVariables>(RecordPayAtRowPaymentDocument, options);
      }
export type RecordPayAtRowPaymentMutationHookResult = ReturnType<typeof useRecordPayAtRowPaymentMutation>;
export type RecordPayAtRowPaymentMutationResult = Apollo.MutationResult<RecordPayAtRowPaymentMutation>;
export type RecordPayAtRowPaymentMutationOptions = Apollo.BaseMutationOptions<RecordPayAtRowPaymentMutation, RecordPayAtRowPaymentMutationVariables>;
export const RunPayAtReconciliationDocument = gql`
    mutation RunPayAtReconciliation {
  runPayAtReconciliation {
    stats {
      label
      value
    }
    failures
  }
}
    `;
export type RunPayAtReconciliationMutationFn = Apollo.MutationFunction<RunPayAtReconciliationMutation, RunPayAtReconciliationMutationVariables>;

/**
 * __useRunPayAtReconciliationMutation__
 *
 * To run a mutation, you first call `useRunPayAtReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunPayAtReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runPayAtReconciliationMutation, { data, loading, error }] = useRunPayAtReconciliationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunPayAtReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<RunPayAtReconciliationMutation, RunPayAtReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunPayAtReconciliationMutation, RunPayAtReconciliationMutationVariables>(RunPayAtReconciliationDocument, options);
      }
export type RunPayAtReconciliationMutationHookResult = ReturnType<typeof useRunPayAtReconciliationMutation>;
export type RunPayAtReconciliationMutationResult = Apollo.MutationResult<RunPayAtReconciliationMutation>;
export type RunPayAtReconciliationMutationOptions = Apollo.BaseMutationOptions<RunPayAtReconciliationMutation, RunPayAtReconciliationMutationVariables>;
export const RecheckPayAtRowDocument = gql`
    mutation RecheckPayAtRow($rowId: String!) {
  recheckPayAtRow(rowId: $rowId) {
    ...PayAtDumpRowFields
  }
}
    ${PayAtDumpRowFieldsFragmentDoc}`;
export type RecheckPayAtRowMutationFn = Apollo.MutationFunction<RecheckPayAtRowMutation, RecheckPayAtRowMutationVariables>;

/**
 * __useRecheckPayAtRowMutation__
 *
 * To run a mutation, you first call `useRecheckPayAtRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecheckPayAtRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recheckPayAtRowMutation, { data, loading, error }] = useRecheckPayAtRowMutation({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useRecheckPayAtRowMutation(baseOptions?: Apollo.MutationHookOptions<RecheckPayAtRowMutation, RecheckPayAtRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecheckPayAtRowMutation, RecheckPayAtRowMutationVariables>(RecheckPayAtRowDocument, options);
      }
export type RecheckPayAtRowMutationHookResult = ReturnType<typeof useRecheckPayAtRowMutation>;
export type RecheckPayAtRowMutationResult = Apollo.MutationResult<RecheckPayAtRowMutation>;
export type RecheckPayAtRowMutationOptions = Apollo.BaseMutationOptions<RecheckPayAtRowMutation, RecheckPayAtRowMutationVariables>;
export const ExportSalesWorkbookDocument = gql`
    query ExportSalesWorkbook($to: DateTime!) {
  exportSalesWorkbook(to: $to) {
    fileName
    contentBase64
    payAtLinesWithoutFees
  }
}
    `;

/**
 * __useExportSalesWorkbookQuery__
 *
 * To run a query within a React component, call `useExportSalesWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSalesWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSalesWorkbookQuery({
 *   variables: {
 *      to: // value for 'to'
 *   },
 * });
 */
export function useExportSalesWorkbookQuery(baseOptions: Apollo.QueryHookOptions<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables> & ({ variables: ExportSalesWorkbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>(ExportSalesWorkbookDocument, options);
      }
export function useExportSalesWorkbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>(ExportSalesWorkbookDocument, options);
        }
// @ts-ignore
export function useExportSalesWorkbookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>): Apollo.UseSuspenseQueryResult<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>;
export function useExportSalesWorkbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>): Apollo.UseSuspenseQueryResult<ExportSalesWorkbookQuery | undefined, ExportSalesWorkbookQueryVariables>;
export function useExportSalesWorkbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>(ExportSalesWorkbookDocument, options);
        }
export type ExportSalesWorkbookQueryHookResult = ReturnType<typeof useExportSalesWorkbookQuery>;
export type ExportSalesWorkbookLazyQueryHookResult = ReturnType<typeof useExportSalesWorkbookLazyQuery>;
export type ExportSalesWorkbookSuspenseQueryHookResult = ReturnType<typeof useExportSalesWorkbookSuspenseQuery>;
export type ExportSalesWorkbookQueryResult = Apollo.QueryResult<ExportSalesWorkbookQuery, ExportSalesWorkbookQueryVariables>;
export const GetPayAtMoneySeriesDocument = gql`
    query GetPayAtMoneySeries($from: DateTime!, $to: DateTime!, $bucket: SeriesBucket!, $timeZone: String) {
  payAtReconciliationSeries(
    from: $from
    to: $to
    bucket: $bucket
    timeZone: $timeZone
  ) {
    start
    end
    totalCents
    lines
  }
}
    `;

/**
 * __useGetPayAtMoneySeriesQuery__
 *
 * To run a query within a React component, call `useGetPayAtMoneySeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayAtMoneySeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayAtMoneySeriesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      bucket: // value for 'bucket'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useGetPayAtMoneySeriesQuery(baseOptions: Apollo.QueryHookOptions<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables> & ({ variables: GetPayAtMoneySeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>(GetPayAtMoneySeriesDocument, options);
      }
export function useGetPayAtMoneySeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>(GetPayAtMoneySeriesDocument, options);
        }
// @ts-ignore
export function useGetPayAtMoneySeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>;
export function useGetPayAtMoneySeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtMoneySeriesQuery | undefined, GetPayAtMoneySeriesQueryVariables>;
export function useGetPayAtMoneySeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>(GetPayAtMoneySeriesDocument, options);
        }
export type GetPayAtMoneySeriesQueryHookResult = ReturnType<typeof useGetPayAtMoneySeriesQuery>;
export type GetPayAtMoneySeriesLazyQueryHookResult = ReturnType<typeof useGetPayAtMoneySeriesLazyQuery>;
export type GetPayAtMoneySeriesSuspenseQueryHookResult = ReturnType<typeof useGetPayAtMoneySeriesSuspenseQuery>;
export type GetPayAtMoneySeriesQueryResult = Apollo.QueryResult<GetPayAtMoneySeriesQuery, GetPayAtMoneySeriesQueryVariables>;
export const GetPayAtMonthlyTotalsDocument = gql`
    query GetPayAtMonthlyTotals($from0: DateTime!, $to0: DateTime!, $from1: DateTime!, $to1: DateTime!, $from2: DateTime!, $to2: DateTime!, $from3: DateTime!, $to3: DateTime!, $from4: DateTime!, $to4: DateTime!, $yearAgoFrom: DateTime!, $yearAgoTo: DateTime!, $lastMonthFrom: DateTime!, $lastMonthTo: DateTime!, $timeZone: String) {
  month0: payAtReconciliationSummary(from: $from0, to: $to0, timeZone: $timeZone) {
    ...PayAtWeekTotal
  }
  month1: payAtReconciliationSummary(from: $from1, to: $to1, timeZone: $timeZone) {
    ...PayAtWeekTotal
  }
  month2: payAtReconciliationSummary(from: $from2, to: $to2, timeZone: $timeZone) {
    ...PayAtWeekTotal
  }
  month3: payAtReconciliationSummary(from: $from3, to: $to3, timeZone: $timeZone) {
    ...PayAtWeekTotal
  }
  month4: payAtReconciliationSummary(from: $from4, to: $to4, timeZone: $timeZone) {
    ...PayAtWeekTotal
  }
  yearAgo: payAtReconciliationSummary(
    from: $yearAgoFrom
    to: $yearAgoTo
    timeZone: $timeZone
  ) {
    ...PayAtWeekTotal
  }
  lastMonthSoFar: payAtReconciliationSummary(
    from: $lastMonthFrom
    to: $lastMonthTo
    timeZone: $timeZone
  ) {
    ...PayAtWeekTotal
  }
}
    ${PayAtWeekTotalFragmentDoc}`;

/**
 * __useGetPayAtMonthlyTotalsQuery__
 *
 * To run a query within a React component, call `useGetPayAtMonthlyTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayAtMonthlyTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayAtMonthlyTotalsQuery({
 *   variables: {
 *      from0: // value for 'from0'
 *      to0: // value for 'to0'
 *      from1: // value for 'from1'
 *      to1: // value for 'to1'
 *      from2: // value for 'from2'
 *      to2: // value for 'to2'
 *      from3: // value for 'from3'
 *      to3: // value for 'to3'
 *      from4: // value for 'from4'
 *      to4: // value for 'to4'
 *      yearAgoFrom: // value for 'yearAgoFrom'
 *      yearAgoTo: // value for 'yearAgoTo'
 *      lastMonthFrom: // value for 'lastMonthFrom'
 *      lastMonthTo: // value for 'lastMonthTo'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useGetPayAtMonthlyTotalsQuery(baseOptions: Apollo.QueryHookOptions<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables> & ({ variables: GetPayAtMonthlyTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>(GetPayAtMonthlyTotalsDocument, options);
      }
export function useGetPayAtMonthlyTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>(GetPayAtMonthlyTotalsDocument, options);
        }
// @ts-ignore
export function useGetPayAtMonthlyTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>;
export function useGetPayAtMonthlyTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPayAtMonthlyTotalsQuery | undefined, GetPayAtMonthlyTotalsQueryVariables>;
export function useGetPayAtMonthlyTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>(GetPayAtMonthlyTotalsDocument, options);
        }
export type GetPayAtMonthlyTotalsQueryHookResult = ReturnType<typeof useGetPayAtMonthlyTotalsQuery>;
export type GetPayAtMonthlyTotalsLazyQueryHookResult = ReturnType<typeof useGetPayAtMonthlyTotalsLazyQuery>;
export type GetPayAtMonthlyTotalsSuspenseQueryHookResult = ReturnType<typeof useGetPayAtMonthlyTotalsSuspenseQuery>;
export type GetPayAtMonthlyTotalsQueryResult = Apollo.QueryResult<GetPayAtMonthlyTotalsQuery, GetPayAtMonthlyTotalsQueryVariables>;
export const GetLiveMoneyInWeekDocument = gql`
    query GetLiveMoneyInWeek($thisWeekFrom: DateTime!, $thisWeekTo: DateTime!, $lastWeekFrom: DateTime!, $lastWeekTo: DateTime!) {
  thisWeek: liveMoneyIn(from: $thisWeekFrom, to: $thisWeekTo) {
    totalCents
    payments
  }
  lastWeekSoFar: liveMoneyIn(from: $lastWeekFrom, to: $lastWeekTo) {
    totalCents
    payments
  }
  bankReconciled: bankReconciledMoneyIn(from: $thisWeekFrom, to: $thisWeekTo) {
    totalCents
    payments
  }
}
    `;

/**
 * __useGetLiveMoneyInWeekQuery__
 *
 * To run a query within a React component, call `useGetLiveMoneyInWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveMoneyInWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveMoneyInWeekQuery({
 *   variables: {
 *      thisWeekFrom: // value for 'thisWeekFrom'
 *      thisWeekTo: // value for 'thisWeekTo'
 *      lastWeekFrom: // value for 'lastWeekFrom'
 *      lastWeekTo: // value for 'lastWeekTo'
 *   },
 * });
 */
export function useGetLiveMoneyInWeekQuery(baseOptions: Apollo.QueryHookOptions<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables> & ({ variables: GetLiveMoneyInWeekQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>(GetLiveMoneyInWeekDocument, options);
      }
export function useGetLiveMoneyInWeekLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>(GetLiveMoneyInWeekDocument, options);
        }
// @ts-ignore
export function useGetLiveMoneyInWeekSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>): Apollo.UseSuspenseQueryResult<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>;
export function useGetLiveMoneyInWeekSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>): Apollo.UseSuspenseQueryResult<GetLiveMoneyInWeekQuery | undefined, GetLiveMoneyInWeekQueryVariables>;
export function useGetLiveMoneyInWeekSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>(GetLiveMoneyInWeekDocument, options);
        }
export type GetLiveMoneyInWeekQueryHookResult = ReturnType<typeof useGetLiveMoneyInWeekQuery>;
export type GetLiveMoneyInWeekLazyQueryHookResult = ReturnType<typeof useGetLiveMoneyInWeekLazyQuery>;
export type GetLiveMoneyInWeekSuspenseQueryHookResult = ReturnType<typeof useGetLiveMoneyInWeekSuspenseQuery>;
export type GetLiveMoneyInWeekQueryResult = Apollo.QueryResult<GetLiveMoneyInWeekQuery, GetLiveMoneyInWeekQueryVariables>;
export const VacanciesDocument = gql`
    query Vacancies($filter: VacancyFilterInput) {
  vacancies(filter: $filter) {
    items {
      ...VacancyFields
    }
    totalCount
  }
}
    ${VacancyFieldsFragmentDoc}`;

/**
 * __useVacanciesQuery__
 *
 * To run a query within a React component, call `useVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacanciesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVacanciesQuery(baseOptions?: Apollo.QueryHookOptions<VacanciesQuery, VacanciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacanciesQuery, VacanciesQueryVariables>(VacanciesDocument, options);
      }
export function useVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacanciesQuery, VacanciesQueryVariables>(VacanciesDocument, options);
        }
// @ts-ignore
export function useVacanciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>): Apollo.UseSuspenseQueryResult<VacanciesQuery, VacanciesQueryVariables>;
export function useVacanciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>): Apollo.UseSuspenseQueryResult<VacanciesQuery | undefined, VacanciesQueryVariables>;
export function useVacanciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacanciesQuery, VacanciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacanciesQuery, VacanciesQueryVariables>(VacanciesDocument, options);
        }
export type VacanciesQueryHookResult = ReturnType<typeof useVacanciesQuery>;
export type VacanciesLazyQueryHookResult = ReturnType<typeof useVacanciesLazyQuery>;
export type VacanciesSuspenseQueryHookResult = ReturnType<typeof useVacanciesSuspenseQuery>;
export type VacanciesQueryResult = Apollo.QueryResult<VacanciesQuery, VacanciesQueryVariables>;
export const VacanciesExportDocument = gql`
    query VacanciesExport($filter: VacancyFilterInput) {
  vacanciesExport(filter: $filter) {
    ...VacancyFields
  }
}
    ${VacancyFieldsFragmentDoc}`;

/**
 * __useVacanciesExportQuery__
 *
 * To run a query within a React component, call `useVacanciesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacanciesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacanciesExportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVacanciesExportQuery(baseOptions?: Apollo.QueryHookOptions<VacanciesExportQuery, VacanciesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacanciesExportQuery, VacanciesExportQueryVariables>(VacanciesExportDocument, options);
      }
export function useVacanciesExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacanciesExportQuery, VacanciesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacanciesExportQuery, VacanciesExportQueryVariables>(VacanciesExportDocument, options);
        }
// @ts-ignore
export function useVacanciesExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VacanciesExportQuery, VacanciesExportQueryVariables>): Apollo.UseSuspenseQueryResult<VacanciesExportQuery, VacanciesExportQueryVariables>;
export function useVacanciesExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacanciesExportQuery, VacanciesExportQueryVariables>): Apollo.UseSuspenseQueryResult<VacanciesExportQuery | undefined, VacanciesExportQueryVariables>;
export function useVacanciesExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacanciesExportQuery, VacanciesExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacanciesExportQuery, VacanciesExportQueryVariables>(VacanciesExportDocument, options);
        }
export type VacanciesExportQueryHookResult = ReturnType<typeof useVacanciesExportQuery>;
export type VacanciesExportLazyQueryHookResult = ReturnType<typeof useVacanciesExportLazyQuery>;
export type VacanciesExportSuspenseQueryHookResult = ReturnType<typeof useVacanciesExportSuspenseQuery>;
export type VacanciesExportQueryResult = Apollo.QueryResult<VacanciesExportQuery, VacanciesExportQueryVariables>;
export const VacancyDocument = gql`
    query Vacancy($id: ID!) {
  vacancy(id: $id) {
    ...VacancyFields
    costs {
      ...RecruitmentCostFields
    }
  }
  jobApplications(vacancyId: $id) {
    ...JobApplicationFields
  }
}
    ${VacancyFieldsFragmentDoc}
${RecruitmentCostFieldsFragmentDoc}
${JobApplicationFieldsFragmentDoc}`;

/**
 * __useVacancyQuery__
 *
 * To run a query within a React component, call `useVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacancyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVacancyQuery(baseOptions: Apollo.QueryHookOptions<VacancyQuery, VacancyQueryVariables> & ({ variables: VacancyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
      }
export function useVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacancyQuery, VacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
        }
// @ts-ignore
export function useVacancySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VacancyQuery, VacancyQueryVariables>): Apollo.UseSuspenseQueryResult<VacancyQuery, VacancyQueryVariables>;
export function useVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacancyQuery, VacancyQueryVariables>): Apollo.UseSuspenseQueryResult<VacancyQuery | undefined, VacancyQueryVariables>;
export function useVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacancyQuery, VacancyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
        }
export type VacancyQueryHookResult = ReturnType<typeof useVacancyQuery>;
export type VacancyLazyQueryHookResult = ReturnType<typeof useVacancyLazyQuery>;
export type VacancySuspenseQueryHookResult = ReturnType<typeof useVacancySuspenseQuery>;
export type VacancyQueryResult = Apollo.QueryResult<VacancyQuery, VacancyQueryVariables>;
export const CandidatesDocument = gql`
    query Candidates($filter: CandidateFilterInput) {
  candidates(filter: $filter) {
    items {
      ...CandidateFields
    }
    totalCount
  }
}
    ${CandidateFieldsFragmentDoc}`;

/**
 * __useCandidatesQuery__
 *
 * To run a query within a React component, call `useCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<CandidatesQuery, CandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidatesQuery, CandidatesQueryVariables>(CandidatesDocument, options);
      }
export function useCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidatesQuery, CandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidatesQuery, CandidatesQueryVariables>(CandidatesDocument, options);
        }
// @ts-ignore
export function useCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidatesQuery, CandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<CandidatesQuery, CandidatesQueryVariables>;
export function useCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidatesQuery, CandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<CandidatesQuery | undefined, CandidatesQueryVariables>;
export function useCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidatesQuery, CandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidatesQuery, CandidatesQueryVariables>(CandidatesDocument, options);
        }
export type CandidatesQueryHookResult = ReturnType<typeof useCandidatesQuery>;
export type CandidatesLazyQueryHookResult = ReturnType<typeof useCandidatesLazyQuery>;
export type CandidatesSuspenseQueryHookResult = ReturnType<typeof useCandidatesSuspenseQuery>;
export type CandidatesQueryResult = Apollo.QueryResult<CandidatesQuery, CandidatesQueryVariables>;
export const CandidateDocument = gql`
    query Candidate($id: ID!) {
  candidate(id: $id) {
    ...CandidateFields
  }
}
    ${CandidateFieldsFragmentDoc}`;

/**
 * __useCandidateQuery__
 *
 * To run a query within a React component, call `useCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidateQuery(baseOptions: Apollo.QueryHookOptions<CandidateQuery, CandidateQueryVariables> & ({ variables: CandidateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateQuery, CandidateQueryVariables>(CandidateDocument, options);
      }
export function useCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateQuery, CandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateQuery, CandidateQueryVariables>(CandidateDocument, options);
        }
// @ts-ignore
export function useCandidateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateQuery, CandidateQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateQuery, CandidateQueryVariables>;
export function useCandidateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateQuery, CandidateQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateQuery | undefined, CandidateQueryVariables>;
export function useCandidateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateQuery, CandidateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateQuery, CandidateQueryVariables>(CandidateDocument, options);
        }
export type CandidateQueryHookResult = ReturnType<typeof useCandidateQuery>;
export type CandidateLazyQueryHookResult = ReturnType<typeof useCandidateLazyQuery>;
export type CandidateSuspenseQueryHookResult = ReturnType<typeof useCandidateSuspenseQuery>;
export type CandidateQueryResult = Apollo.QueryResult<CandidateQuery, CandidateQueryVariables>;
export const RecruitmentMetricsDocument = gql`
    query RecruitmentMetrics($from: DateTime!, $to: DateTime!, $filter: RecruitmentMetricsFilterInput) {
  recruitmentMetrics(from: $from, to: $to, filter: $filter) {
    from
    to
    openVacancies {
      ...HrMetricFields
    }
    openPositions {
      ...HrMetricFields
    }
    vacanciesFilled {
      ...HrMetricFields
    }
    averageDaysToFill {
      ...HrMetricFields
    }
    applications {
      ...HrMetricFields
    }
    applicationsPerVacancy {
      ...HrMetricFields
    }
    hires {
      ...HrMetricFields
    }
    averageDaysToHire {
      ...HrMetricFields
    }
    offerAcceptanceRate {
      ...HrMetricFields
    }
    totalCost {
      ...HrMetricFields
    }
    costPerHire {
      ...HrMetricFields
    }
    internalHirePercent {
      ...HrMetricFields
    }
    pipeline {
      stage
      reached
      current
    }
    sourceOfHire {
      source
      count
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useRecruitmentMetricsQuery__
 *
 * To run a query within a React component, call `useRecruitmentMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecruitmentMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecruitmentMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRecruitmentMetricsQuery(baseOptions: Apollo.QueryHookOptions<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables> & ({ variables: RecruitmentMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>(RecruitmentMetricsDocument, options);
      }
export function useRecruitmentMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>(RecruitmentMetricsDocument, options);
        }
// @ts-ignore
export function useRecruitmentMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>;
export function useRecruitmentMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<RecruitmentMetricsQuery | undefined, RecruitmentMetricsQueryVariables>;
export function useRecruitmentMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>(RecruitmentMetricsDocument, options);
        }
export type RecruitmentMetricsQueryHookResult = ReturnType<typeof useRecruitmentMetricsQuery>;
export type RecruitmentMetricsLazyQueryHookResult = ReturnType<typeof useRecruitmentMetricsLazyQuery>;
export type RecruitmentMetricsSuspenseQueryHookResult = ReturnType<typeof useRecruitmentMetricsSuspenseQuery>;
export type RecruitmentMetricsQueryResult = Apollo.QueryResult<RecruitmentMetricsQuery, RecruitmentMetricsQueryVariables>;
export const CreateVacancyDocument = gql`
    mutation CreateVacancy($input: CreateVacancyInput!) {
  createVacancy(input: $input) {
    ...VacancyFields
  }
}
    ${VacancyFieldsFragmentDoc}`;
export type CreateVacancyMutationFn = Apollo.MutationFunction<CreateVacancyMutation, CreateVacancyMutationVariables>;

/**
 * __useCreateVacancyMutation__
 *
 * To run a mutation, you first call `useCreateVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVacancyMutation, { data, loading, error }] = useCreateVacancyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVacancyMutation(baseOptions?: Apollo.MutationHookOptions<CreateVacancyMutation, CreateVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVacancyMutation, CreateVacancyMutationVariables>(CreateVacancyDocument, options);
      }
export type CreateVacancyMutationHookResult = ReturnType<typeof useCreateVacancyMutation>;
export type CreateVacancyMutationResult = Apollo.MutationResult<CreateVacancyMutation>;
export type CreateVacancyMutationOptions = Apollo.BaseMutationOptions<CreateVacancyMutation, CreateVacancyMutationVariables>;
export const UpdateVacancyDocument = gql`
    mutation UpdateVacancy($id: ID!, $input: UpdateVacancyInput!) {
  updateVacancy(id: $id, input: $input) {
    ...VacancyFields
  }
}
    ${VacancyFieldsFragmentDoc}`;
export type UpdateVacancyMutationFn = Apollo.MutationFunction<UpdateVacancyMutation, UpdateVacancyMutationVariables>;

/**
 * __useUpdateVacancyMutation__
 *
 * To run a mutation, you first call `useUpdateVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVacancyMutation, { data, loading, error }] = useUpdateVacancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVacancyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVacancyMutation, UpdateVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVacancyMutation, UpdateVacancyMutationVariables>(UpdateVacancyDocument, options);
      }
export type UpdateVacancyMutationHookResult = ReturnType<typeof useUpdateVacancyMutation>;
export type UpdateVacancyMutationResult = Apollo.MutationResult<UpdateVacancyMutation>;
export type UpdateVacancyMutationOptions = Apollo.BaseMutationOptions<UpdateVacancyMutation, UpdateVacancyMutationVariables>;
export const DeleteVacancyDocument = gql`
    mutation DeleteVacancy($id: ID!) {
  deleteVacancy(id: $id)
}
    `;
export type DeleteVacancyMutationFn = Apollo.MutationFunction<DeleteVacancyMutation, DeleteVacancyMutationVariables>;

/**
 * __useDeleteVacancyMutation__
 *
 * To run a mutation, you first call `useDeleteVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVacancyMutation, { data, loading, error }] = useDeleteVacancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVacancyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVacancyMutation, DeleteVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVacancyMutation, DeleteVacancyMutationVariables>(DeleteVacancyDocument, options);
      }
export type DeleteVacancyMutationHookResult = ReturnType<typeof useDeleteVacancyMutation>;
export type DeleteVacancyMutationResult = Apollo.MutationResult<DeleteVacancyMutation>;
export type DeleteVacancyMutationOptions = Apollo.BaseMutationOptions<DeleteVacancyMutation, DeleteVacancyMutationVariables>;
export const AddRecruitmentCostDocument = gql`
    mutation AddRecruitmentCost($vacancyId: ID!, $input: RecruitmentCostInput!) {
  addRecruitmentCost(vacancyId: $vacancyId, input: $input) {
    ...RecruitmentCostFields
  }
}
    ${RecruitmentCostFieldsFragmentDoc}`;
export type AddRecruitmentCostMutationFn = Apollo.MutationFunction<AddRecruitmentCostMutation, AddRecruitmentCostMutationVariables>;

/**
 * __useAddRecruitmentCostMutation__
 *
 * To run a mutation, you first call `useAddRecruitmentCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecruitmentCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecruitmentCostMutation, { data, loading, error }] = useAddRecruitmentCostMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRecruitmentCostMutation(baseOptions?: Apollo.MutationHookOptions<AddRecruitmentCostMutation, AddRecruitmentCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRecruitmentCostMutation, AddRecruitmentCostMutationVariables>(AddRecruitmentCostDocument, options);
      }
export type AddRecruitmentCostMutationHookResult = ReturnType<typeof useAddRecruitmentCostMutation>;
export type AddRecruitmentCostMutationResult = Apollo.MutationResult<AddRecruitmentCostMutation>;
export type AddRecruitmentCostMutationOptions = Apollo.BaseMutationOptions<AddRecruitmentCostMutation, AddRecruitmentCostMutationVariables>;
export const UpdateRecruitmentCostDocument = gql`
    mutation UpdateRecruitmentCost($id: ID!, $input: UpdateRecruitmentCostInput!) {
  updateRecruitmentCost(id: $id, input: $input) {
    ...RecruitmentCostFields
  }
}
    ${RecruitmentCostFieldsFragmentDoc}`;
export type UpdateRecruitmentCostMutationFn = Apollo.MutationFunction<UpdateRecruitmentCostMutation, UpdateRecruitmentCostMutationVariables>;

/**
 * __useUpdateRecruitmentCostMutation__
 *
 * To run a mutation, you first call `useUpdateRecruitmentCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecruitmentCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecruitmentCostMutation, { data, loading, error }] = useUpdateRecruitmentCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRecruitmentCostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecruitmentCostMutation, UpdateRecruitmentCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecruitmentCostMutation, UpdateRecruitmentCostMutationVariables>(UpdateRecruitmentCostDocument, options);
      }
export type UpdateRecruitmentCostMutationHookResult = ReturnType<typeof useUpdateRecruitmentCostMutation>;
export type UpdateRecruitmentCostMutationResult = Apollo.MutationResult<UpdateRecruitmentCostMutation>;
export type UpdateRecruitmentCostMutationOptions = Apollo.BaseMutationOptions<UpdateRecruitmentCostMutation, UpdateRecruitmentCostMutationVariables>;
export const DeleteRecruitmentCostDocument = gql`
    mutation DeleteRecruitmentCost($id: ID!) {
  deleteRecruitmentCost(id: $id)
}
    `;
export type DeleteRecruitmentCostMutationFn = Apollo.MutationFunction<DeleteRecruitmentCostMutation, DeleteRecruitmentCostMutationVariables>;

/**
 * __useDeleteRecruitmentCostMutation__
 *
 * To run a mutation, you first call `useDeleteRecruitmentCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecruitmentCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecruitmentCostMutation, { data, loading, error }] = useDeleteRecruitmentCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRecruitmentCostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecruitmentCostMutation, DeleteRecruitmentCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecruitmentCostMutation, DeleteRecruitmentCostMutationVariables>(DeleteRecruitmentCostDocument, options);
      }
export type DeleteRecruitmentCostMutationHookResult = ReturnType<typeof useDeleteRecruitmentCostMutation>;
export type DeleteRecruitmentCostMutationResult = Apollo.MutationResult<DeleteRecruitmentCostMutation>;
export type DeleteRecruitmentCostMutationOptions = Apollo.BaseMutationOptions<DeleteRecruitmentCostMutation, DeleteRecruitmentCostMutationVariables>;
export const CreateCandidateDocument = gql`
    mutation CreateCandidate($input: CreateCandidateInput!) {
  createCandidate(input: $input) {
    ...CandidateFields
  }
}
    ${CandidateFieldsFragmentDoc}`;
export type CreateCandidateMutationFn = Apollo.MutationFunction<CreateCandidateMutation, CreateCandidateMutationVariables>;

/**
 * __useCreateCandidateMutation__
 *
 * To run a mutation, you first call `useCreateCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateMutation, { data, loading, error }] = useCreateCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateMutation, CreateCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateMutation, CreateCandidateMutationVariables>(CreateCandidateDocument, options);
      }
export type CreateCandidateMutationHookResult = ReturnType<typeof useCreateCandidateMutation>;
export type CreateCandidateMutationResult = Apollo.MutationResult<CreateCandidateMutation>;
export type CreateCandidateMutationOptions = Apollo.BaseMutationOptions<CreateCandidateMutation, CreateCandidateMutationVariables>;
export const UpdateCandidateDocument = gql`
    mutation UpdateCandidate($id: ID!, $input: UpdateCandidateInput!) {
  updateCandidate(id: $id, input: $input) {
    ...CandidateFields
  }
}
    ${CandidateFieldsFragmentDoc}`;
export type UpdateCandidateMutationFn = Apollo.MutationFunction<UpdateCandidateMutation, UpdateCandidateMutationVariables>;

/**
 * __useUpdateCandidateMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateMutation, { data, loading, error }] = useUpdateCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateMutation, UpdateCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateMutation, UpdateCandidateMutationVariables>(UpdateCandidateDocument, options);
      }
export type UpdateCandidateMutationHookResult = ReturnType<typeof useUpdateCandidateMutation>;
export type UpdateCandidateMutationResult = Apollo.MutationResult<UpdateCandidateMutation>;
export type UpdateCandidateMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateMutation, UpdateCandidateMutationVariables>;
export const DeleteCandidateDocument = gql`
    mutation DeleteCandidate($id: ID!) {
  deleteCandidate(id: $id)
}
    `;
export type DeleteCandidateMutationFn = Apollo.MutationFunction<DeleteCandidateMutation, DeleteCandidateMutationVariables>;

/**
 * __useDeleteCandidateMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateMutation, { data, loading, error }] = useDeleteCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCandidateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidateMutation, DeleteCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidateMutation, DeleteCandidateMutationVariables>(DeleteCandidateDocument, options);
      }
export type DeleteCandidateMutationHookResult = ReturnType<typeof useDeleteCandidateMutation>;
export type DeleteCandidateMutationResult = Apollo.MutationResult<DeleteCandidateMutation>;
export type DeleteCandidateMutationOptions = Apollo.BaseMutationOptions<DeleteCandidateMutation, DeleteCandidateMutationVariables>;
export const RemoveCandidateCvDocument = gql`
    mutation RemoveCandidateCv($documentId: ID!) {
  removeCandidateCv(documentId: $documentId)
}
    `;
export type RemoveCandidateCvMutationFn = Apollo.MutationFunction<RemoveCandidateCvMutation, RemoveCandidateCvMutationVariables>;

/**
 * __useRemoveCandidateCvMutation__
 *
 * To run a mutation, you first call `useRemoveCandidateCvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCandidateCvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCandidateCvMutation, { data, loading, error }] = useRemoveCandidateCvMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveCandidateCvMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCandidateCvMutation, RemoveCandidateCvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCandidateCvMutation, RemoveCandidateCvMutationVariables>(RemoveCandidateCvDocument, options);
      }
export type RemoveCandidateCvMutationHookResult = ReturnType<typeof useRemoveCandidateCvMutation>;
export type RemoveCandidateCvMutationResult = Apollo.MutationResult<RemoveCandidateCvMutation>;
export type RemoveCandidateCvMutationOptions = Apollo.BaseMutationOptions<RemoveCandidateCvMutation, RemoveCandidateCvMutationVariables>;
export const CreateJobApplicationDocument = gql`
    mutation CreateJobApplication($input: CreateJobApplicationInput!) {
  createJobApplication(input: $input) {
    ...JobApplicationFields
  }
}
    ${JobApplicationFieldsFragmentDoc}`;
export type CreateJobApplicationMutationFn = Apollo.MutationFunction<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>;

/**
 * __useCreateJobApplicationMutation__
 *
 * To run a mutation, you first call `useCreateJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobApplicationMutation, { data, loading, error }] = useCreateJobApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>(CreateJobApplicationDocument, options);
      }
export type CreateJobApplicationMutationHookResult = ReturnType<typeof useCreateJobApplicationMutation>;
export type CreateJobApplicationMutationResult = Apollo.MutationResult<CreateJobApplicationMutation>;
export type CreateJobApplicationMutationOptions = Apollo.BaseMutationOptions<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>;
export const MoveJobApplicationDocument = gql`
    mutation MoveJobApplication($id: ID!, $input: MoveJobApplicationInput!) {
  moveJobApplication(id: $id, input: $input) {
    ...JobApplicationFields
  }
}
    ${JobApplicationFieldsFragmentDoc}`;
export type MoveJobApplicationMutationFn = Apollo.MutationFunction<MoveJobApplicationMutation, MoveJobApplicationMutationVariables>;

/**
 * __useMoveJobApplicationMutation__
 *
 * To run a mutation, you first call `useMoveJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveJobApplicationMutation, { data, loading, error }] = useMoveJobApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<MoveJobApplicationMutation, MoveJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveJobApplicationMutation, MoveJobApplicationMutationVariables>(MoveJobApplicationDocument, options);
      }
export type MoveJobApplicationMutationHookResult = ReturnType<typeof useMoveJobApplicationMutation>;
export type MoveJobApplicationMutationResult = Apollo.MutationResult<MoveJobApplicationMutation>;
export type MoveJobApplicationMutationOptions = Apollo.BaseMutationOptions<MoveJobApplicationMutation, MoveJobApplicationMutationVariables>;
export const SaveJobOfferDocument = gql`
    mutation SaveJobOffer($applicationId: ID!, $input: JobOfferInput!) {
  saveJobOffer(applicationId: $applicationId, input: $input) {
    ...JobApplicationFields
  }
}
    ${JobApplicationFieldsFragmentDoc}`;
export type SaveJobOfferMutationFn = Apollo.MutationFunction<SaveJobOfferMutation, SaveJobOfferMutationVariables>;

/**
 * __useSaveJobOfferMutation__
 *
 * To run a mutation, you first call `useSaveJobOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveJobOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveJobOfferMutation, { data, loading, error }] = useSaveJobOfferMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveJobOfferMutation(baseOptions?: Apollo.MutationHookOptions<SaveJobOfferMutation, SaveJobOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveJobOfferMutation, SaveJobOfferMutationVariables>(SaveJobOfferDocument, options);
      }
export type SaveJobOfferMutationHookResult = ReturnType<typeof useSaveJobOfferMutation>;
export type SaveJobOfferMutationResult = Apollo.MutationResult<SaveJobOfferMutation>;
export type SaveJobOfferMutationOptions = Apollo.BaseMutationOptions<SaveJobOfferMutation, SaveJobOfferMutationVariables>;
export const DeleteJobApplicationDocument = gql`
    mutation DeleteJobApplication($id: ID!) {
  deleteJobApplication(id: $id)
}
    `;
export type DeleteJobApplicationMutationFn = Apollo.MutationFunction<DeleteJobApplicationMutation, DeleteJobApplicationMutationVariables>;

/**
 * __useDeleteJobApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobApplicationMutation, { data, loading, error }] = useDeleteJobApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobApplicationMutation, DeleteJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobApplicationMutation, DeleteJobApplicationMutationVariables>(DeleteJobApplicationDocument, options);
      }
export type DeleteJobApplicationMutationHookResult = ReturnType<typeof useDeleteJobApplicationMutation>;
export type DeleteJobApplicationMutationResult = Apollo.MutationResult<DeleteJobApplicationMutation>;
export type DeleteJobApplicationMutationOptions = Apollo.BaseMutationOptions<DeleteJobApplicationMutation, DeleteJobApplicationMutationVariables>;
export const CreateEmployeeFromHireDocument = gql`
    mutation CreateEmployeeFromHire($applicationId: ID!, $input: CreateEmployeeFromHireInput) {
  createEmployeeFromHire(applicationId: $applicationId, input: $input) {
    id
  }
}
    `;
export type CreateEmployeeFromHireMutationFn = Apollo.MutationFunction<CreateEmployeeFromHireMutation, CreateEmployeeFromHireMutationVariables>;

/**
 * __useCreateEmployeeFromHireMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeFromHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeFromHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeFromHireMutation, { data, loading, error }] = useCreateEmployeeFromHireMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeFromHireMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeFromHireMutation, CreateEmployeeFromHireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeFromHireMutation, CreateEmployeeFromHireMutationVariables>(CreateEmployeeFromHireDocument, options);
      }
export type CreateEmployeeFromHireMutationHookResult = ReturnType<typeof useCreateEmployeeFromHireMutation>;
export type CreateEmployeeFromHireMutationResult = Apollo.MutationResult<CreateEmployeeFromHireMutation>;
export type CreateEmployeeFromHireMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeFromHireMutation, CreateEmployeeFromHireMutationVariables>;
export const GetStockSalesReportDocument = gql`
    query GetStockSalesReport($input: ReportDateRangeInput) {
  stockSalesReport(input: $input) {
    totalCount
    items {
      saleReference
      saleDate
      status
      agentSalesId
      agentName
      product
      productSku
      productCategory
      productCategoryRank
      serialNumber
      accountNumber
      customerName
      customerPhone
      contractNumber
      contractStatus
      ratePlan
      deposit
      rateAmount
      termLengthMonths
      totalPrice
      flaggedBad
      isWarrantyReplacement
      notCountedReason
      notes
      previousSerialNumber
      previousAccountNumber
      distributorName
      nationalSalesManagerName
    }
  }
}
    `;

/**
 * __useGetStockSalesReportQuery__
 *
 * To run a query within a React component, call `useGetStockSalesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockSalesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockSalesReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockSalesReportQuery(baseOptions?: Apollo.QueryHookOptions<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>(GetStockSalesReportDocument, options);
      }
export function useGetStockSalesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>(GetStockSalesReportDocument, options);
        }
// @ts-ignore
export function useGetStockSalesReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>;
export function useGetStockSalesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSalesReportQuery | undefined, GetStockSalesReportQueryVariables>;
export function useGetStockSalesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>(GetStockSalesReportDocument, options);
        }
export type GetStockSalesReportQueryHookResult = ReturnType<typeof useGetStockSalesReportQuery>;
export type GetStockSalesReportLazyQueryHookResult = ReturnType<typeof useGetStockSalesReportLazyQuery>;
export type GetStockSalesReportSuspenseQueryHookResult = ReturnType<typeof useGetStockSalesReportSuspenseQuery>;
export type GetStockSalesReportQueryResult = Apollo.QueryResult<GetStockSalesReportQuery, GetStockSalesReportQueryVariables>;
export const GetUnitsSoldSeriesDocument = gql`
    query GetUnitsSoldSeries($from: DateTime!, $to: DateTime!, $bucket: SeriesBucket!, $timeZone: String) {
  unitsSoldSeries(from: $from, to: $to, bucket: $bucket, timeZone: $timeZone) {
    start
    end
    units
  }
}
    `;

/**
 * __useGetUnitsSoldSeriesQuery__
 *
 * To run a query within a React component, call `useGetUnitsSoldSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsSoldSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsSoldSeriesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      bucket: // value for 'bucket'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useGetUnitsSoldSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables> & ({ variables: GetUnitsSoldSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>(GetUnitsSoldSeriesDocument, options);
      }
export function useGetUnitsSoldSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>(GetUnitsSoldSeriesDocument, options);
        }
// @ts-ignore
export function useGetUnitsSoldSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>;
export function useGetUnitsSoldSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnitsSoldSeriesQuery | undefined, GetUnitsSoldSeriesQueryVariables>;
export function useGetUnitsSoldSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>(GetUnitsSoldSeriesDocument, options);
        }
export type GetUnitsSoldSeriesQueryHookResult = ReturnType<typeof useGetUnitsSoldSeriesQuery>;
export type GetUnitsSoldSeriesLazyQueryHookResult = ReturnType<typeof useGetUnitsSoldSeriesLazyQuery>;
export type GetUnitsSoldSeriesSuspenseQueryHookResult = ReturnType<typeof useGetUnitsSoldSeriesSuspenseQuery>;
export type GetUnitsSoldSeriesQueryResult = Apollo.QueryResult<GetUnitsSoldSeriesQuery, GetUnitsSoldSeriesQueryVariables>;
export const GetTopSellersDocument = gql`
    query GetTopSellers($from: DateTime!, $to: DateTime!, $limit: Int) {
  topSellers(from: $from, to: $to, limit: $limit) {
    agentId
    salesId
    name
    units
  }
}
    `;

/**
 * __useGetTopSellersQuery__
 *
 * To run a query within a React component, call `useGetTopSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopSellersQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTopSellersQuery(baseOptions: Apollo.QueryHookOptions<GetTopSellersQuery, GetTopSellersQueryVariables> & ({ variables: GetTopSellersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopSellersQuery, GetTopSellersQueryVariables>(GetTopSellersDocument, options);
      }
export function useGetTopSellersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopSellersQuery, GetTopSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopSellersQuery, GetTopSellersQueryVariables>(GetTopSellersDocument, options);
        }
// @ts-ignore
export function useGetTopSellersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopSellersQuery, GetTopSellersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopSellersQuery, GetTopSellersQueryVariables>;
export function useGetTopSellersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopSellersQuery, GetTopSellersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopSellersQuery | undefined, GetTopSellersQueryVariables>;
export function useGetTopSellersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopSellersQuery, GetTopSellersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopSellersQuery, GetTopSellersQueryVariables>(GetTopSellersDocument, options);
        }
export type GetTopSellersQueryHookResult = ReturnType<typeof useGetTopSellersQuery>;
export type GetTopSellersLazyQueryHookResult = ReturnType<typeof useGetTopSellersLazyQuery>;
export type GetTopSellersSuspenseQueryHookResult = ReturnType<typeof useGetTopSellersSuspenseQuery>;
export type GetTopSellersQueryResult = Apollo.QueryResult<GetTopSellersQuery, GetTopSellersQueryVariables>;
export const GetProductSalesDocument = gql`
    query GetProductSales($from: DateTime!, $to: DateTime!, $limit: Int) {
  productSales(from: $from, to: $to, limit: $limit) {
    productId
    name
    units
  }
}
    `;

/**
 * __useGetProductSalesQuery__
 *
 * To run a query within a React component, call `useGetProductSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSalesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProductSalesQuery(baseOptions: Apollo.QueryHookOptions<GetProductSalesQuery, GetProductSalesQueryVariables> & ({ variables: GetProductSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSalesQuery, GetProductSalesQueryVariables>(GetProductSalesDocument, options);
      }
export function useGetProductSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSalesQuery, GetProductSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSalesQuery, GetProductSalesQueryVariables>(GetProductSalesDocument, options);
        }
// @ts-ignore
export function useGetProductSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductSalesQuery, GetProductSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductSalesQuery, GetProductSalesQueryVariables>;
export function useGetProductSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductSalesQuery, GetProductSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductSalesQuery | undefined, GetProductSalesQueryVariables>;
export function useGetProductSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductSalesQuery, GetProductSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductSalesQuery, GetProductSalesQueryVariables>(GetProductSalesDocument, options);
        }
export type GetProductSalesQueryHookResult = ReturnType<typeof useGetProductSalesQuery>;
export type GetProductSalesLazyQueryHookResult = ReturnType<typeof useGetProductSalesLazyQuery>;
export type GetProductSalesSuspenseQueryHookResult = ReturnType<typeof useGetProductSalesSuspenseQuery>;
export type GetProductSalesQueryResult = Apollo.QueryResult<GetProductSalesQuery, GetProductSalesQueryVariables>;
export const GetComboSalesDocument = gql`
    query GetComboSales($from: DateTime!, $to: DateTime!, $limit: Int) {
  comboSales(from: $from, to: $to, limit: $limit) {
    countedFrom
    sales
    combos
    mixes {
      devices
      units
    }
  }
}
    `;

/**
 * __useGetComboSalesQuery__
 *
 * To run a query within a React component, call `useGetComboSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComboSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComboSalesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetComboSalesQuery(baseOptions: Apollo.QueryHookOptions<GetComboSalesQuery, GetComboSalesQueryVariables> & ({ variables: GetComboSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComboSalesQuery, GetComboSalesQueryVariables>(GetComboSalesDocument, options);
      }
export function useGetComboSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComboSalesQuery, GetComboSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComboSalesQuery, GetComboSalesQueryVariables>(GetComboSalesDocument, options);
        }
// @ts-ignore
export function useGetComboSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetComboSalesQuery, GetComboSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetComboSalesQuery, GetComboSalesQueryVariables>;
export function useGetComboSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetComboSalesQuery, GetComboSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetComboSalesQuery | undefined, GetComboSalesQueryVariables>;
export function useGetComboSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetComboSalesQuery, GetComboSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetComboSalesQuery, GetComboSalesQueryVariables>(GetComboSalesDocument, options);
        }
export type GetComboSalesQueryHookResult = ReturnType<typeof useGetComboSalesQuery>;
export type GetComboSalesLazyQueryHookResult = ReturnType<typeof useGetComboSalesLazyQuery>;
export type GetComboSalesSuspenseQueryHookResult = ReturnType<typeof useGetComboSalesSuspenseQuery>;
export type GetComboSalesQueryResult = Apollo.QueryResult<GetComboSalesQuery, GetComboSalesQueryVariables>;
export const GetSalesContributionReportDocument = gql`
    query GetSalesContributionReport($month: String, $date: String) {
  salesContributionReport(month: $month, date: $date) {
    month
    monthStart
    closingDate
    partialMonth
    yearStart
    previousThreeMonthsStart
    lastYearStart
    lastYearClosingDate
    generatedAt
    products
    regions {
      regionId
      name
      emblemUrl
    }
    nsms {
      nsmId
      nsmName
      nsmEmail
      nsmAvatarUrl
      regionId
    }
    sellers {
      agentId
      agentSalesId
      agentName
      agentType
      agentStatus
      agentAvatarUrl
      distributorId
      distributorName
      nsmId
      products {
        product
        mtd
        mtdDelinquent
        ytd
        ytdDelinquent
        previousThreeMonths
        sameDaysLastYear
      }
    }
  }
}
    `;

/**
 * __useGetSalesContributionReportQuery__
 *
 * To run a query within a React component, call `useGetSalesContributionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesContributionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesContributionReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetSalesContributionReportQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>(GetSalesContributionReportDocument, options);
      }
export function useGetSalesContributionReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>(GetSalesContributionReportDocument, options);
        }
// @ts-ignore
export function useGetSalesContributionReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>;
export function useGetSalesContributionReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesContributionReportQuery | undefined, GetSalesContributionReportQueryVariables>;
export function useGetSalesContributionReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>(GetSalesContributionReportDocument, options);
        }
export type GetSalesContributionReportQueryHookResult = ReturnType<typeof useGetSalesContributionReportQuery>;
export type GetSalesContributionReportLazyQueryHookResult = ReturnType<typeof useGetSalesContributionReportLazyQuery>;
export type GetSalesContributionReportSuspenseQueryHookResult = ReturnType<typeof useGetSalesContributionReportSuspenseQuery>;
export type GetSalesContributionReportQueryResult = Apollo.QueryResult<GetSalesContributionReportQuery, GetSalesContributionReportQueryVariables>;
export const GetSalesContributionSalesDocument = gql`
    query GetSalesContributionSales($month: String, $date: String, $span: SalesContributionSpan!) {
  salesContributionSales(month: $month, date: $date, span: $span) {
    contractId
    contractNumber
    accountNumber
    customerName
    saleDate
    agentId
    product
    contractStatus
    delinquent
  }
}
    `;

/**
 * __useGetSalesContributionSalesQuery__
 *
 * To run a query within a React component, call `useGetSalesContributionSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesContributionSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesContributionSalesQuery({
 *   variables: {
 *      month: // value for 'month'
 *      date: // value for 'date'
 *      span: // value for 'span'
 *   },
 * });
 */
export function useGetSalesContributionSalesQuery(baseOptions: Apollo.QueryHookOptions<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables> & ({ variables: GetSalesContributionSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>(GetSalesContributionSalesDocument, options);
      }
export function useGetSalesContributionSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>(GetSalesContributionSalesDocument, options);
        }
// @ts-ignore
export function useGetSalesContributionSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>;
export function useGetSalesContributionSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesContributionSalesQuery | undefined, GetSalesContributionSalesQueryVariables>;
export function useGetSalesContributionSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>(GetSalesContributionSalesDocument, options);
        }
export type GetSalesContributionSalesQueryHookResult = ReturnType<typeof useGetSalesContributionSalesQuery>;
export type GetSalesContributionSalesLazyQueryHookResult = ReturnType<typeof useGetSalesContributionSalesLazyQuery>;
export type GetSalesContributionSalesSuspenseQueryHookResult = ReturnType<typeof useGetSalesContributionSalesSuspenseQuery>;
export type GetSalesContributionSalesQueryResult = Apollo.QueryResult<GetSalesContributionSalesQuery, GetSalesContributionSalesQueryVariables>;
export const GetCustomerBookReportDocument = gql`
    query GetCustomerBookReport {
  customerBookReport {
    totalCustomers
    attributedCustomers
    totalContracts
    attributedContracts
    items {
      nsmId
      nsmName
      nsmEmail
      nsmAvatarUrl
      distributors
      salesAgents
      customers
      contracts
      owners {
        agentId
        agentSalesId
        agentName
        agentType
        agentStatus
        agentAvatarUrl
        distributorName
        customers
        contracts
      }
    }
  }
}
    `;

/**
 * __useGetCustomerBookReportQuery__
 *
 * To run a query within a React component, call `useGetCustomerBookReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerBookReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerBookReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerBookReportQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>(GetCustomerBookReportDocument, options);
      }
export function useGetCustomerBookReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>(GetCustomerBookReportDocument, options);
        }
// @ts-ignore
export function useGetCustomerBookReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>;
export function useGetCustomerBookReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerBookReportQuery | undefined, GetCustomerBookReportQueryVariables>;
export function useGetCustomerBookReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>(GetCustomerBookReportDocument, options);
        }
export type GetCustomerBookReportQueryHookResult = ReturnType<typeof useGetCustomerBookReportQuery>;
export type GetCustomerBookReportLazyQueryHookResult = ReturnType<typeof useGetCustomerBookReportLazyQuery>;
export type GetCustomerBookReportSuspenseQueryHookResult = ReturnType<typeof useGetCustomerBookReportSuspenseQuery>;
export type GetCustomerBookReportQueryResult = Apollo.QueryResult<GetCustomerBookReportQuery, GetCustomerBookReportQueryVariables>;
export const GetCustomerBookActivityDocument = gql`
    query GetCustomerBookActivity($month: String!, $refresh: Boolean) {
  customerBookActivity(month: $month, refresh: $refresh) {
    month
    openingDate
    closingDate
    partialMonth
    generatedAt
    total {
      ...CustomerBookActivityFigures
    }
    agents {
      agentId
      figures {
        ...CustomerBookActivityFigures
      }
    }
  }
}
    ${CustomerBookActivityFiguresFragmentDoc}`;

/**
 * __useGetCustomerBookActivityQuery__
 *
 * To run a query within a React component, call `useGetCustomerBookActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerBookActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerBookActivityQuery({
 *   variables: {
 *      month: // value for 'month'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useGetCustomerBookActivityQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables> & ({ variables: GetCustomerBookActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>(GetCustomerBookActivityDocument, options);
      }
export function useGetCustomerBookActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>(GetCustomerBookActivityDocument, options);
        }
// @ts-ignore
export function useGetCustomerBookActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>;
export function useGetCustomerBookActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerBookActivityQuery | undefined, GetCustomerBookActivityQueryVariables>;
export function useGetCustomerBookActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>(GetCustomerBookActivityDocument, options);
        }
export type GetCustomerBookActivityQueryHookResult = ReturnType<typeof useGetCustomerBookActivityQuery>;
export type GetCustomerBookActivityLazyQueryHookResult = ReturnType<typeof useGetCustomerBookActivityLazyQuery>;
export type GetCustomerBookActivitySuspenseQueryHookResult = ReturnType<typeof useGetCustomerBookActivitySuspenseQuery>;
export type GetCustomerBookActivityQueryResult = Apollo.QueryResult<GetCustomerBookActivityQuery, GetCustomerBookActivityQueryVariables>;
export const GetCustomerBookTrendDocument = gql`
    query GetCustomerBookTrend($month: String!, $refresh: Boolean) {
  customerBookTrend(month: $month, refresh: $refresh) {
    month
    step
    dates
    partialMonth
    generatedAt
    total {
      ...CustomerBookTrendSeries
    }
    agents {
      agentId
      series {
        ...CustomerBookTrendSeries
      }
    }
  }
}
    ${CustomerBookTrendSeriesFragmentDoc}`;

/**
 * __useGetCustomerBookTrendQuery__
 *
 * To run a query within a React component, call `useGetCustomerBookTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerBookTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerBookTrendQuery({
 *   variables: {
 *      month: // value for 'month'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useGetCustomerBookTrendQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables> & ({ variables: GetCustomerBookTrendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>(GetCustomerBookTrendDocument, options);
      }
export function useGetCustomerBookTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>(GetCustomerBookTrendDocument, options);
        }
// @ts-ignore
export function useGetCustomerBookTrendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>;
export function useGetCustomerBookTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerBookTrendQuery | undefined, GetCustomerBookTrendQueryVariables>;
export function useGetCustomerBookTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>(GetCustomerBookTrendDocument, options);
        }
export type GetCustomerBookTrendQueryHookResult = ReturnType<typeof useGetCustomerBookTrendQuery>;
export type GetCustomerBookTrendLazyQueryHookResult = ReturnType<typeof useGetCustomerBookTrendLazyQuery>;
export type GetCustomerBookTrendSuspenseQueryHookResult = ReturnType<typeof useGetCustomerBookTrendSuspenseQuery>;
export type GetCustomerBookTrendQueryResult = Apollo.QueryResult<GetCustomerBookTrendQuery, GetCustomerBookTrendQueryVariables>;
export const GetReceivablesReportDocument = gql`
    query GetReceivablesReport($month: String!, $basis: ReceivablesBasis, $refresh: Boolean) {
  receivablesReport(month: $month, basis: $basis, refresh: $refresh) {
    cutoff
    basis
    generatedAt
    partialMonth
    buckets {
      bucket
      contracts
      customers
      buyout
    }
    years {
      registrationYear
      contracts
      customers
      buyout
      overdueBuyout
      buckets {
        bucket
        contracts
        customers
        buyout
      }
    }
    totals {
      contracts
      customers
      buyout
      overdueContracts
      overdueBuyout
    }
    statuses {
      status
      contracts
      owingContracts
      customers
      unlockPrice
      paid
      outstanding
      credit
    }
    statusYears {
      status
      registrationYear
      contracts
      owingContracts
      customers
      unlockPrice
      paid
      outstanding
      credit
    }
    statusBrands {
      status
      brand
      contracts
      owingContracts
      customers
      unlockPrice
      paid
      outstanding
      credit
    }
  }
}
    `;

/**
 * __useGetReceivablesReportQuery__
 *
 * To run a query within a React component, call `useGetReceivablesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceivablesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceivablesReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      basis: // value for 'basis'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useGetReceivablesReportQuery(baseOptions: Apollo.QueryHookOptions<GetReceivablesReportQuery, GetReceivablesReportQueryVariables> & ({ variables: GetReceivablesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>(GetReceivablesReportDocument, options);
      }
export function useGetReceivablesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>(GetReceivablesReportDocument, options);
        }
// @ts-ignore
export function useGetReceivablesReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>;
export function useGetReceivablesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetReceivablesReportQuery | undefined, GetReceivablesReportQueryVariables>;
export function useGetReceivablesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>(GetReceivablesReportDocument, options);
        }
export type GetReceivablesReportQueryHookResult = ReturnType<typeof useGetReceivablesReportQuery>;
export type GetReceivablesReportLazyQueryHookResult = ReturnType<typeof useGetReceivablesReportLazyQuery>;
export type GetReceivablesReportSuspenseQueryHookResult = ReturnType<typeof useGetReceivablesReportSuspenseQuery>;
export type GetReceivablesReportQueryResult = Apollo.QueryResult<GetReceivablesReportQuery, GetReceivablesReportQueryVariables>;
export const GetBadDebtorsReportDocument = gql`
    query GetBadDebtorsReport($month: String!, $basis: ReceivablesBasis, $refresh: Boolean) {
  badDebtorsReport(month: $month, basis: $basis, refresh: $refresh) {
    cutoff
    basis
    generatedAt
    partialMonth
    groups {
      status
      contracts
      owingContracts
      customers
      unlockPrice
      paid
      outstanding
      credit
    }
    totals {
      contracts
      customers
      unlockPrice
      paid
      outstanding
      averageUnlockPrice
      averagePaid
      recoveredShare
    }
  }
}
    `;

/**
 * __useGetBadDebtorsReportQuery__
 *
 * To run a query within a React component, call `useGetBadDebtorsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadDebtorsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadDebtorsReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      basis: // value for 'basis'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useGetBadDebtorsReportQuery(baseOptions: Apollo.QueryHookOptions<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables> & ({ variables: GetBadDebtorsReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>(GetBadDebtorsReportDocument, options);
      }
export function useGetBadDebtorsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>(GetBadDebtorsReportDocument, options);
        }
// @ts-ignore
export function useGetBadDebtorsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>;
export function useGetBadDebtorsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetBadDebtorsReportQuery | undefined, GetBadDebtorsReportQueryVariables>;
export function useGetBadDebtorsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>(GetBadDebtorsReportDocument, options);
        }
export type GetBadDebtorsReportQueryHookResult = ReturnType<typeof useGetBadDebtorsReportQuery>;
export type GetBadDebtorsReportLazyQueryHookResult = ReturnType<typeof useGetBadDebtorsReportLazyQuery>;
export type GetBadDebtorsReportSuspenseQueryHookResult = ReturnType<typeof useGetBadDebtorsReportSuspenseQuery>;
export type GetBadDebtorsReportQueryResult = Apollo.QueryResult<GetBadDebtorsReportQuery, GetBadDebtorsReportQueryVariables>;
export const GetReceivablesContractsDocument = gql`
    query GetReceivablesContracts($month: String!, $basis: ReceivablesBasis, $section: ReceivablesSectionInput) {
  receivablesContracts(month: $month, basis: $basis, section: $section) {
    contractId
    contractNumber
    customerId
    customerName
    customerPhone
    accountNumber
    registrationDate
    registrationYear
    ratePlan
    brand
    product
    status
    unlockPrice
    paid
    outstanding
    distributorName
    nationalSalesManagerName
  }
}
    `;

/**
 * __useGetReceivablesContractsQuery__
 *
 * To run a query within a React component, call `useGetReceivablesContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceivablesContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceivablesContractsQuery({
 *   variables: {
 *      month: // value for 'month'
 *      basis: // value for 'basis'
 *      section: // value for 'section'
 *   },
 * });
 */
export function useGetReceivablesContractsQuery(baseOptions: Apollo.QueryHookOptions<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables> & ({ variables: GetReceivablesContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>(GetReceivablesContractsDocument, options);
      }
export function useGetReceivablesContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>(GetReceivablesContractsDocument, options);
        }
// @ts-ignore
export function useGetReceivablesContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>;
export function useGetReceivablesContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReceivablesContractsQuery | undefined, GetReceivablesContractsQueryVariables>;
export function useGetReceivablesContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>(GetReceivablesContractsDocument, options);
        }
export type GetReceivablesContractsQueryHookResult = ReturnType<typeof useGetReceivablesContractsQuery>;
export type GetReceivablesContractsLazyQueryHookResult = ReturnType<typeof useGetReceivablesContractsLazyQuery>;
export type GetReceivablesContractsSuspenseQueryHookResult = ReturnType<typeof useGetReceivablesContractsSuspenseQuery>;
export type GetReceivablesContractsQueryResult = Apollo.QueryResult<GetReceivablesContractsQuery, GetReceivablesContractsQueryVariables>;
export const GetWarrantyReportDocument = gql`
    query GetWarrantyReport($input: ReportDateRangeInput) {
  warrantyReport(input: $input) {
    totalCount
    warrantyPeriodDays
    unidentifiedDevices
    items {
      saleReference
      product
      productSku
      brand
      accountNumber
      serialNumber
      salesDate
      returnDate
      failureMode
      faultDescription
      sparePartUsed
      replacementSerialNumber
      replacementAccountNumber
      repairOrReplacementDate
      ageDays
      inWarranty
      customerName
      contractNumber
      agentName
    }
  }
}
    `;

/**
 * __useGetWarrantyReportQuery__
 *
 * To run a query within a React component, call `useGetWarrantyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWarrantyReportQuery(baseOptions?: Apollo.QueryHookOptions<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>(GetWarrantyReportDocument, options);
      }
export function useGetWarrantyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>(GetWarrantyReportDocument, options);
        }
// @ts-ignore
export function useGetWarrantyReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>;
export function useGetWarrantyReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarrantyReportQuery | undefined, GetWarrantyReportQueryVariables>;
export function useGetWarrantyReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>(GetWarrantyReportDocument, options);
        }
export type GetWarrantyReportQueryHookResult = ReturnType<typeof useGetWarrantyReportQuery>;
export type GetWarrantyReportLazyQueryHookResult = ReturnType<typeof useGetWarrantyReportLazyQuery>;
export type GetWarrantyReportSuspenseQueryHookResult = ReturnType<typeof useGetWarrantyReportSuspenseQuery>;
export type GetWarrantyReportQueryResult = Apollo.QueryResult<GetWarrantyReportQuery, GetWarrantyReportQueryVariables>;
export const GetStockByTierReportDocument = gql`
    query GetStockByTierReport {
  stockByTierReport {
    generatedAt
    totals {
      atWarehouse
      withDistributors
      withAgents
      atWorkshop
      incoming
      skuCount
      distributorCount
      agentCount
      totalUnits
      stock {
        ...StockOnHandFields
      }
    }
    skus {
      sku
      description
      isActive
      atWarehouse
      withDistributors
      withAgents
      atWorkshop
      incoming
      stock {
        ...StockOnHandFields
      }
    }
    points {
      stockingPointId
      name
      tier
      province
      isActive
      holderName
      distributorName
      distributorKey
      stock {
        ...StockOnHandFields
      }
      bySku {
        sku
        description
        stock {
          ...StockOnHandFields
        }
      }
    }
    accessories {
      totals {
        atWarehouse
        withDistributors
        withAgents
        atWorkshop
        skuCount
        totalUnits
        stock {
          ...StockOnHandFields
        }
      }
      skus {
        sku
        description
        isActive
        atWarehouse
        withDistributors
        withAgents
        atWorkshop
        incoming
        stock {
          ...StockOnHandFields
        }
      }
      points {
        tier
        bySku {
          sku
          stock {
            ...StockOnHandFields
          }
        }
      }
    }
  }
}
    ${StockOnHandFieldsFragmentDoc}`;

/**
 * __useGetStockByTierReportQuery__
 *
 * To run a query within a React component, call `useGetStockByTierReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockByTierReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockByTierReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStockByTierReportQuery(baseOptions?: Apollo.QueryHookOptions<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>(GetStockByTierReportDocument, options);
      }
export function useGetStockByTierReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>(GetStockByTierReportDocument, options);
        }
// @ts-ignore
export function useGetStockByTierReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>;
export function useGetStockByTierReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockByTierReportQuery | undefined, GetStockByTierReportQueryVariables>;
export function useGetStockByTierReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>(GetStockByTierReportDocument, options);
        }
export type GetStockByTierReportQueryHookResult = ReturnType<typeof useGetStockByTierReportQuery>;
export type GetStockByTierReportLazyQueryHookResult = ReturnType<typeof useGetStockByTierReportLazyQuery>;
export type GetStockByTierReportSuspenseQueryHookResult = ReturnType<typeof useGetStockByTierReportSuspenseQuery>;
export type GetStockByTierReportQueryResult = Apollo.QueryResult<GetStockByTierReportQuery, GetStockByTierReportQueryVariables>;
export const GetStockByTierUnitsDocument = gql`
    query GetStockByTierUnits {
  stockByTierUnits {
    serialNumber
    accountNumber
    sku
    description
    stockType
    stockingPoint
    tier
    province
    status
  }
}
    `;

/**
 * __useGetStockByTierUnitsQuery__
 *
 * To run a query within a React component, call `useGetStockByTierUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockByTierUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockByTierUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStockByTierUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>(GetStockByTierUnitsDocument, options);
      }
export function useGetStockByTierUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>(GetStockByTierUnitsDocument, options);
        }
// @ts-ignore
export function useGetStockByTierUnitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>;
export function useGetStockByTierUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockByTierUnitsQuery | undefined, GetStockByTierUnitsQueryVariables>;
export function useGetStockByTierUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>(GetStockByTierUnitsDocument, options);
        }
export type GetStockByTierUnitsQueryHookResult = ReturnType<typeof useGetStockByTierUnitsQuery>;
export type GetStockByTierUnitsLazyQueryHookResult = ReturnType<typeof useGetStockByTierUnitsLazyQuery>;
export type GetStockByTierUnitsSuspenseQueryHookResult = ReturnType<typeof useGetStockByTierUnitsSuspenseQuery>;
export type GetStockByTierUnitsQueryResult = Apollo.QueryResult<GetStockByTierUnitsQuery, GetStockByTierUnitsQueryVariables>;
export const GetUnitsSoldByMonthDocument = gql`
    query GetUnitsSoldByMonth($from: DateTime!, $to: DateTime!, $lastMonthFrom: DateTime!, $lastMonthTo: DateTime!, $timeZone: String) {
  months: unitsSoldSeries(
    from: $from
    to: $to
    bucket: MONTH
    timeZone: $timeZone
  ) {
    start
    end
    units
  }
  lastMonthSoFar: unitsSoldSeries(
    from: $lastMonthFrom
    to: $lastMonthTo
    bucket: MONTH
    timeZone: $timeZone
  ) {
    units
  }
}
    `;

/**
 * __useGetUnitsSoldByMonthQuery__
 *
 * To run a query within a React component, call `useGetUnitsSoldByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsSoldByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsSoldByMonthQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      lastMonthFrom: // value for 'lastMonthFrom'
 *      lastMonthTo: // value for 'lastMonthTo'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useGetUnitsSoldByMonthQuery(baseOptions: Apollo.QueryHookOptions<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables> & ({ variables: GetUnitsSoldByMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>(GetUnitsSoldByMonthDocument, options);
      }
export function useGetUnitsSoldByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>(GetUnitsSoldByMonthDocument, options);
        }
// @ts-ignore
export function useGetUnitsSoldByMonthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>;
export function useGetUnitsSoldByMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnitsSoldByMonthQuery | undefined, GetUnitsSoldByMonthQueryVariables>;
export function useGetUnitsSoldByMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>(GetUnitsSoldByMonthDocument, options);
        }
export type GetUnitsSoldByMonthQueryHookResult = ReturnType<typeof useGetUnitsSoldByMonthQuery>;
export type GetUnitsSoldByMonthLazyQueryHookResult = ReturnType<typeof useGetUnitsSoldByMonthLazyQuery>;
export type GetUnitsSoldByMonthSuspenseQueryHookResult = ReturnType<typeof useGetUnitsSoldByMonthSuspenseQuery>;
export type GetUnitsSoldByMonthQueryResult = Apollo.QueryResult<GetUnitsSoldByMonthQuery, GetUnitsSoldByMonthQueryVariables>;
export const ExportAgentHierarchyWorkbookDocument = gql`
    query ExportAgentHierarchyWorkbook {
  exportAgentHierarchyWorkbook {
    fileName
    contentBase64
  }
}
    `;

/**
 * __useExportAgentHierarchyWorkbookQuery__
 *
 * To run a query within a React component, call `useExportAgentHierarchyWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAgentHierarchyWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportAgentHierarchyWorkbookQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportAgentHierarchyWorkbookQuery(baseOptions?: Apollo.QueryHookOptions<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>(ExportAgentHierarchyWorkbookDocument, options);
      }
export function useExportAgentHierarchyWorkbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>(ExportAgentHierarchyWorkbookDocument, options);
        }
// @ts-ignore
export function useExportAgentHierarchyWorkbookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>): Apollo.UseSuspenseQueryResult<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>;
export function useExportAgentHierarchyWorkbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>): Apollo.UseSuspenseQueryResult<ExportAgentHierarchyWorkbookQuery | undefined, ExportAgentHierarchyWorkbookQueryVariables>;
export function useExportAgentHierarchyWorkbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>(ExportAgentHierarchyWorkbookDocument, options);
        }
export type ExportAgentHierarchyWorkbookQueryHookResult = ReturnType<typeof useExportAgentHierarchyWorkbookQuery>;
export type ExportAgentHierarchyWorkbookLazyQueryHookResult = ReturnType<typeof useExportAgentHierarchyWorkbookLazyQuery>;
export type ExportAgentHierarchyWorkbookSuspenseQueryHookResult = ReturnType<typeof useExportAgentHierarchyWorkbookSuspenseQuery>;
export type ExportAgentHierarchyWorkbookQueryResult = Apollo.QueryResult<ExportAgentHierarchyWorkbookQuery, ExportAgentHierarchyWorkbookQueryVariables>;
export const ExportFinanceWorkbookDocument = gql`
    query ExportFinanceWorkbook($kind: FinanceWorkbookKind!, $month: String, $basis: ReceivablesBasis, $months: Int, $refresh: Boolean) {
  exportFinanceWorkbook(
    kind: $kind
    month: $month
    basis: $basis
    months: $months
    refresh: $refresh
  ) {
    status
    fileName
    contentBase64
    builtAt
  }
}
    `;

/**
 * __useExportFinanceWorkbookQuery__
 *
 * To run a query within a React component, call `useExportFinanceWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportFinanceWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportFinanceWorkbookQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      month: // value for 'month'
 *      basis: // value for 'basis'
 *      months: // value for 'months'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useExportFinanceWorkbookQuery(baseOptions: Apollo.QueryHookOptions<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables> & ({ variables: ExportFinanceWorkbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>(ExportFinanceWorkbookDocument, options);
      }
export function useExportFinanceWorkbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>(ExportFinanceWorkbookDocument, options);
        }
// @ts-ignore
export function useExportFinanceWorkbookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>): Apollo.UseSuspenseQueryResult<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>;
export function useExportFinanceWorkbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>): Apollo.UseSuspenseQueryResult<ExportFinanceWorkbookQuery | undefined, ExportFinanceWorkbookQueryVariables>;
export function useExportFinanceWorkbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>(ExportFinanceWorkbookDocument, options);
        }
export type ExportFinanceWorkbookQueryHookResult = ReturnType<typeof useExportFinanceWorkbookQuery>;
export type ExportFinanceWorkbookLazyQueryHookResult = ReturnType<typeof useExportFinanceWorkbookLazyQuery>;
export type ExportFinanceWorkbookSuspenseQueryHookResult = ReturnType<typeof useExportFinanceWorkbookSuspenseQuery>;
export type ExportFinanceWorkbookQueryResult = Apollo.QueryResult<ExportFinanceWorkbookQuery, ExportFinanceWorkbookQueryVariables>;
export const GetEdfReportDocument = gql`
    query GetEdfReport($month: String!, $refresh: Boolean) {
  edfReportDefaultRate(month: $month, refresh: $refresh) {
    cutoff
    generatedAt
    partialMonth
    portfolioContracts
    inDefault
    defaultRate
    reactivated
    noLongerInDefaultRate
    leftPortfolio
  }
  edfReportCollectionRate(month: $month, refresh: $refresh) {
    paidForPaygo
    cashSales
    deposit
    expected
    collectionRate
    expectedContracts
    newPaygoContracts
    cashSaleContracts
  }
  edfReportRepaymentRate(month: $month, refresh: $refresh) {
    portfolioContracts
    paid
    due
    repaymentRate
  }
  edfReportRecoveries(month: $month, refresh: $refresh) {
    totalContracts
    inPortfolio
    toRecover
    par60Contracts
    repossessed
    writtenOff
    reactivated
    recovered
    repossessionRate
    writeOffRate
    reactivatedRate
    repossessedYearToDate
  }
  edfReportReceivablesAtRisk(month: $month, refresh: $refresh) {
    contracts
    receivables
    bands {
      band
      contracts
      receivables
      share
    }
  }
}
    `;

/**
 * __useGetEdfReportQuery__
 *
 * To run a query within a React component, call `useGetEdfReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEdfReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdfReportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useGetEdfReportQuery(baseOptions: Apollo.QueryHookOptions<GetEdfReportQuery, GetEdfReportQueryVariables> & ({ variables: GetEdfReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEdfReportQuery, GetEdfReportQueryVariables>(GetEdfReportDocument, options);
      }
export function useGetEdfReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEdfReportQuery, GetEdfReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEdfReportQuery, GetEdfReportQueryVariables>(GetEdfReportDocument, options);
        }
// @ts-ignore
export function useGetEdfReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEdfReportQuery, GetEdfReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetEdfReportQuery, GetEdfReportQueryVariables>;
export function useGetEdfReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEdfReportQuery, GetEdfReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetEdfReportQuery | undefined, GetEdfReportQueryVariables>;
export function useGetEdfReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEdfReportQuery, GetEdfReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEdfReportQuery, GetEdfReportQueryVariables>(GetEdfReportDocument, options);
        }
export type GetEdfReportQueryHookResult = ReturnType<typeof useGetEdfReportQuery>;
export type GetEdfReportLazyQueryHookResult = ReturnType<typeof useGetEdfReportLazyQuery>;
export type GetEdfReportSuspenseQueryHookResult = ReturnType<typeof useGetEdfReportSuspenseQuery>;
export type GetEdfReportQueryResult = Apollo.QueryResult<GetEdfReportQuery, GetEdfReportQueryVariables>;
export const GetEdfDebtorAgeingDocument = gql`
    query GetEdfDebtorAgeing($month: String!, $refresh: Boolean) {
  edfReportDebtorAgeing(month: $month, refresh: $refresh) {
    month
    cutoff
    generatedAt
    partialMonth
    months {
      month
      newContracts
      openingDebtor
      newContractRevenue
      paymentsReceived
      overpayment
      writtenOff
      closingDebtor
      days0To30
      days31To60
      days61To90
      days90Plus
    }
  }
}
    `;

/**
 * __useGetEdfDebtorAgeingQuery__
 *
 * To run a query within a React component, call `useGetEdfDebtorAgeingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEdfDebtorAgeingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdfDebtorAgeingQuery({
 *   variables: {
 *      month: // value for 'month'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useGetEdfDebtorAgeingQuery(baseOptions: Apollo.QueryHookOptions<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables> & ({ variables: GetEdfDebtorAgeingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>(GetEdfDebtorAgeingDocument, options);
      }
export function useGetEdfDebtorAgeingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>(GetEdfDebtorAgeingDocument, options);
        }
// @ts-ignore
export function useGetEdfDebtorAgeingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>): Apollo.UseSuspenseQueryResult<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>;
export function useGetEdfDebtorAgeingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>): Apollo.UseSuspenseQueryResult<GetEdfDebtorAgeingQuery | undefined, GetEdfDebtorAgeingQueryVariables>;
export function useGetEdfDebtorAgeingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>(GetEdfDebtorAgeingDocument, options);
        }
export type GetEdfDebtorAgeingQueryHookResult = ReturnType<typeof useGetEdfDebtorAgeingQuery>;
export type GetEdfDebtorAgeingLazyQueryHookResult = ReturnType<typeof useGetEdfDebtorAgeingLazyQuery>;
export type GetEdfDebtorAgeingSuspenseQueryHookResult = ReturnType<typeof useGetEdfDebtorAgeingSuspenseQuery>;
export type GetEdfDebtorAgeingQueryResult = Apollo.QueryResult<GetEdfDebtorAgeingQuery, GetEdfDebtorAgeingQueryVariables>;
export const GetCustomerDemographicsReportDocument = gql`
    query GetCustomerDemographicsReport($filter: CustomerDemographicsFilter) {
  customerDemographicsReport(filter: $filter) {
    totalCustomers
    medianAge
    averageAge
    coverage {
      age
      gender
      province
      city
      municipality
      town
    }
    gender {
      gender
      customers
    }
    ageBands {
      band
      female
      male
      other
      unknown
      total
    }
    provinces {
      name
      customers
    }
    cities {
      name
      province
      customers
    }
    municipalities {
      name
      province
      customers
    }
    towns {
      name
      province
      customers
    }
    sources {
      source
      customers
      withAge
      withGender
      withProvince
    }
  }
}
    `;

/**
 * __useGetCustomerDemographicsReportQuery__
 *
 * To run a query within a React component, call `useGetCustomerDemographicsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDemographicsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDemographicsReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomerDemographicsReportQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>(GetCustomerDemographicsReportDocument, options);
      }
export function useGetCustomerDemographicsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>(GetCustomerDemographicsReportDocument, options);
        }
// @ts-ignore
export function useGetCustomerDemographicsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>;
export function useGetCustomerDemographicsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerDemographicsReportQuery | undefined, GetCustomerDemographicsReportQueryVariables>;
export function useGetCustomerDemographicsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>(GetCustomerDemographicsReportDocument, options);
        }
export type GetCustomerDemographicsReportQueryHookResult = ReturnType<typeof useGetCustomerDemographicsReportQuery>;
export type GetCustomerDemographicsReportLazyQueryHookResult = ReturnType<typeof useGetCustomerDemographicsReportLazyQuery>;
export type GetCustomerDemographicsReportSuspenseQueryHookResult = ReturnType<typeof useGetCustomerDemographicsReportSuspenseQuery>;
export type GetCustomerDemographicsReportQueryResult = Apollo.QueryResult<GetCustomerDemographicsReportQuery, GetCustomerDemographicsReportQueryVariables>;
export const GetStockSalesActivationsDocument = gql`
    query GetStockSalesActivations($input: ReportDateRangeInput) {
  stockSalesActivations(input: $input) {
    totalCount
    items {
      contractNumber
      activatedAt
      registrationDate
      contractStatus
      customerName
      agentName
      product
      productCategory
      productCategoryRank
      ratePlan
      comboDevices
      deposit
      rateAmount
      totalPrice
      notCountedReason
    }
  }
}
    `;

/**
 * __useGetStockSalesActivationsQuery__
 *
 * To run a query within a React component, call `useGetStockSalesActivationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockSalesActivationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockSalesActivationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockSalesActivationsQuery(baseOptions?: Apollo.QueryHookOptions<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>(GetStockSalesActivationsDocument, options);
      }
export function useGetStockSalesActivationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>(GetStockSalesActivationsDocument, options);
        }
// @ts-ignore
export function useGetStockSalesActivationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>;
export function useGetStockSalesActivationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSalesActivationsQuery | undefined, GetStockSalesActivationsQueryVariables>;
export function useGetStockSalesActivationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>(GetStockSalesActivationsDocument, options);
        }
export type GetStockSalesActivationsQueryHookResult = ReturnType<typeof useGetStockSalesActivationsQuery>;
export type GetStockSalesActivationsLazyQueryHookResult = ReturnType<typeof useGetStockSalesActivationsLazyQuery>;
export type GetStockSalesActivationsSuspenseQueryHookResult = ReturnType<typeof useGetStockSalesActivationsSuspenseQuery>;
export type GetStockSalesActivationsQueryResult = Apollo.QueryResult<GetStockSalesActivationsQuery, GetStockSalesActivationsQueryVariables>;
export const GetStockValuationReportDocument = gql`
    query GetStockValuationReport {
  stockValuationReport {
    asAt
    quantity
    valueCents
    unpricedQuantity
    unitsWithoutProduct
    lines {
      businessLine {
        id
        name
        externalCode
      }
      quantity
      valueCents
      unpricedQuantity
      products {
        product {
          ...StockValuationProductFields
        }
        quantity
        damagedQuantity
        valueCents
        unpricedQuantity
      }
    }
  }
}
    ${StockValuationProductFieldsFragmentDoc}`;

/**
 * __useGetStockValuationReportQuery__
 *
 * To run a query within a React component, call `useGetStockValuationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockValuationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockValuationReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStockValuationReportQuery(baseOptions?: Apollo.QueryHookOptions<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>(GetStockValuationReportDocument, options);
      }
export function useGetStockValuationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>(GetStockValuationReportDocument, options);
        }
// @ts-ignore
export function useGetStockValuationReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>;
export function useGetStockValuationReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockValuationReportQuery | undefined, GetStockValuationReportQueryVariables>;
export function useGetStockValuationReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>(GetStockValuationReportDocument, options);
        }
export type GetStockValuationReportQueryHookResult = ReturnType<typeof useGetStockValuationReportQuery>;
export type GetStockValuationReportLazyQueryHookResult = ReturnType<typeof useGetStockValuationReportLazyQuery>;
export type GetStockValuationReportSuspenseQueryHookResult = ReturnType<typeof useGetStockValuationReportSuspenseQuery>;
export type GetStockValuationReportQueryResult = Apollo.QueryResult<GetStockValuationReportQuery, GetStockValuationReportQueryVariables>;
export const ExportStockValuationDocument = gql`
    query ExportStockValuation {
  stockValuationReport {
    asAt
    lines {
      businessLine {
        name
        externalCode
      }
      products {
        product {
          ...StockValuationProductFields
        }
        places {
          stockingPointName
          condition
          quantity
          valueCents
        }
      }
    }
  }
}
    ${StockValuationProductFieldsFragmentDoc}`;

/**
 * __useExportStockValuationQuery__
 *
 * To run a query within a React component, call `useExportStockValuationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportStockValuationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportStockValuationQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportStockValuationQuery(baseOptions?: Apollo.QueryHookOptions<ExportStockValuationQuery, ExportStockValuationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportStockValuationQuery, ExportStockValuationQueryVariables>(ExportStockValuationDocument, options);
      }
export function useExportStockValuationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportStockValuationQuery, ExportStockValuationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportStockValuationQuery, ExportStockValuationQueryVariables>(ExportStockValuationDocument, options);
        }
// @ts-ignore
export function useExportStockValuationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportStockValuationQuery, ExportStockValuationQueryVariables>): Apollo.UseSuspenseQueryResult<ExportStockValuationQuery, ExportStockValuationQueryVariables>;
export function useExportStockValuationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportStockValuationQuery, ExportStockValuationQueryVariables>): Apollo.UseSuspenseQueryResult<ExportStockValuationQuery | undefined, ExportStockValuationQueryVariables>;
export function useExportStockValuationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportStockValuationQuery, ExportStockValuationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportStockValuationQuery, ExportStockValuationQueryVariables>(ExportStockValuationDocument, options);
        }
export type ExportStockValuationQueryHookResult = ReturnType<typeof useExportStockValuationQuery>;
export type ExportStockValuationLazyQueryHookResult = ReturnType<typeof useExportStockValuationLazyQuery>;
export type ExportStockValuationSuspenseQueryHookResult = ReturnType<typeof useExportStockValuationSuspenseQuery>;
export type ExportStockValuationQueryResult = Apollo.QueryResult<ExportStockValuationQuery, ExportStockValuationQueryVariables>;
export const GetReturnableDevicesDocument = gql`
    query GetReturnableDevices($search: String, $limit: Int, $offset: Int) {
  returnableDevices(search: $search, limit: $limit, offset: $offset) {
    totalCount
    stockingPointName
    items {
      stockItemId
      serialNumber
      accountNumber
      productName
      status
      condition
      blockedReason
      releases
      recentHistory {
        ...DeviceHistoryEntryFields
      }
    }
  }
}
    ${DeviceHistoryEntryFieldsFragmentDoc}`;

/**
 * __useGetReturnableDevicesQuery__
 *
 * To run a query within a React component, call `useGetReturnableDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnableDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnableDevicesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetReturnableDevicesQuery(baseOptions?: Apollo.QueryHookOptions<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>(GetReturnableDevicesDocument, options);
      }
export function useGetReturnableDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>(GetReturnableDevicesDocument, options);
        }
// @ts-ignore
export function useGetReturnableDevicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>;
export function useGetReturnableDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnableDevicesQuery | undefined, GetReturnableDevicesQueryVariables>;
export function useGetReturnableDevicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>(GetReturnableDevicesDocument, options);
        }
export type GetReturnableDevicesQueryHookResult = ReturnType<typeof useGetReturnableDevicesQuery>;
export type GetReturnableDevicesLazyQueryHookResult = ReturnType<typeof useGetReturnableDevicesLazyQuery>;
export type GetReturnableDevicesSuspenseQueryHookResult = ReturnType<typeof useGetReturnableDevicesSuspenseQuery>;
export type GetReturnableDevicesQueryResult = Apollo.QueryResult<GetReturnableDevicesQuery, GetReturnableDevicesQueryVariables>;
export const GetReturnsToHeadOfficeDocument = gql`
    query GetReturnsToHeadOffice($input: ReturnToHeadOfficeListInput) {
  returnsToHeadOffice(input: $input) {
    totalCount
    items {
      ...ReturnToHeadOfficeSummaryFields
    }
  }
}
    ${ReturnToHeadOfficeSummaryFieldsFragmentDoc}`;

/**
 * __useGetReturnsToHeadOfficeQuery__
 *
 * To run a query within a React component, call `useGetReturnsToHeadOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnsToHeadOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnsToHeadOfficeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReturnsToHeadOfficeQuery(baseOptions?: Apollo.QueryHookOptions<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>(GetReturnsToHeadOfficeDocument, options);
      }
export function useGetReturnsToHeadOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>(GetReturnsToHeadOfficeDocument, options);
        }
// @ts-ignore
export function useGetReturnsToHeadOfficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>;
export function useGetReturnsToHeadOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnsToHeadOfficeQuery | undefined, GetReturnsToHeadOfficeQueryVariables>;
export function useGetReturnsToHeadOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>(GetReturnsToHeadOfficeDocument, options);
        }
export type GetReturnsToHeadOfficeQueryHookResult = ReturnType<typeof useGetReturnsToHeadOfficeQuery>;
export type GetReturnsToHeadOfficeLazyQueryHookResult = ReturnType<typeof useGetReturnsToHeadOfficeLazyQuery>;
export type GetReturnsToHeadOfficeSuspenseQueryHookResult = ReturnType<typeof useGetReturnsToHeadOfficeSuspenseQuery>;
export type GetReturnsToHeadOfficeQueryResult = Apollo.QueryResult<GetReturnsToHeadOfficeQuery, GetReturnsToHeadOfficeQueryVariables>;
export const GetReturnToHeadOfficeCountsDocument = gql`
    query GetReturnToHeadOfficeCounts {
  returnToHeadOfficeCounts {
    status
    count
  }
}
    `;

/**
 * __useGetReturnToHeadOfficeCountsQuery__
 *
 * To run a query within a React component, call `useGetReturnToHeadOfficeCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnToHeadOfficeCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnToHeadOfficeCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReturnToHeadOfficeCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>(GetReturnToHeadOfficeCountsDocument, options);
      }
export function useGetReturnToHeadOfficeCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>(GetReturnToHeadOfficeCountsDocument, options);
        }
// @ts-ignore
export function useGetReturnToHeadOfficeCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>;
export function useGetReturnToHeadOfficeCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnToHeadOfficeCountsQuery | undefined, GetReturnToHeadOfficeCountsQueryVariables>;
export function useGetReturnToHeadOfficeCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>(GetReturnToHeadOfficeCountsDocument, options);
        }
export type GetReturnToHeadOfficeCountsQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeCountsQuery>;
export type GetReturnToHeadOfficeCountsLazyQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeCountsLazyQuery>;
export type GetReturnToHeadOfficeCountsSuspenseQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeCountsSuspenseQuery>;
export type GetReturnToHeadOfficeCountsQueryResult = Apollo.QueryResult<GetReturnToHeadOfficeCountsQuery, GetReturnToHeadOfficeCountsQueryVariables>;
export const GetReturnToHeadOfficeDocument = gql`
    query GetReturnToHeadOffice($id: String!) {
  returnToHeadOffice(id: $id) {
    ...ReturnToHeadOfficeSummaryFields
    approvalRequestId
    sourceStockingPointId
    destinationStockingPointId
    submittedById
    notes
    reviewNotes
    dispatchedAt
    completedAt
    cancelledAt
    cancelReason
    manifestAvailable
    manifestUrl
    transfer {
      id
      status
      dispatchedAt
      waybillReference
      shippingCompany {
        id
        name
        courier
      }
      shipment {
        ...ShipmentFields
      }
    }
    devices {
      ...ReturnToHeadOfficeDeviceFields
    }
    declinedDevices {
      ...ReturnToHeadOfficeDeviceFields
    }
  }
}
    ${ReturnToHeadOfficeSummaryFieldsFragmentDoc}
${ShipmentFieldsFragmentDoc}
${ReturnToHeadOfficeDeviceFieldsFragmentDoc}`;

/**
 * __useGetReturnToHeadOfficeQuery__
 *
 * To run a query within a React component, call `useGetReturnToHeadOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnToHeadOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnToHeadOfficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReturnToHeadOfficeQuery(baseOptions: Apollo.QueryHookOptions<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables> & ({ variables: GetReturnToHeadOfficeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>(GetReturnToHeadOfficeDocument, options);
      }
export function useGetReturnToHeadOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>(GetReturnToHeadOfficeDocument, options);
        }
// @ts-ignore
export function useGetReturnToHeadOfficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>;
export function useGetReturnToHeadOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnToHeadOfficeQuery | undefined, GetReturnToHeadOfficeQueryVariables>;
export function useGetReturnToHeadOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>(GetReturnToHeadOfficeDocument, options);
        }
export type GetReturnToHeadOfficeQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeQuery>;
export type GetReturnToHeadOfficeLazyQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeLazyQuery>;
export type GetReturnToHeadOfficeSuspenseQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeSuspenseQuery>;
export type GetReturnToHeadOfficeQueryResult = Apollo.QueryResult<GetReturnToHeadOfficeQuery, GetReturnToHeadOfficeQueryVariables>;
export const GetReturnToHeadOfficeLinkDocument = gql`
    query GetReturnToHeadOfficeLink($id: String!) {
  returnToHeadOffice(id: $id) {
    id
    returnNumber
    status
  }
}
    `;

/**
 * __useGetReturnToHeadOfficeLinkQuery__
 *
 * To run a query within a React component, call `useGetReturnToHeadOfficeLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnToHeadOfficeLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnToHeadOfficeLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReturnToHeadOfficeLinkQuery(baseOptions: Apollo.QueryHookOptions<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables> & ({ variables: GetReturnToHeadOfficeLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>(GetReturnToHeadOfficeLinkDocument, options);
      }
export function useGetReturnToHeadOfficeLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>(GetReturnToHeadOfficeLinkDocument, options);
        }
// @ts-ignore
export function useGetReturnToHeadOfficeLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>;
export function useGetReturnToHeadOfficeLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetReturnToHeadOfficeLinkQuery | undefined, GetReturnToHeadOfficeLinkQueryVariables>;
export function useGetReturnToHeadOfficeLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>(GetReturnToHeadOfficeLinkDocument, options);
        }
export type GetReturnToHeadOfficeLinkQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeLinkQuery>;
export type GetReturnToHeadOfficeLinkLazyQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeLinkLazyQuery>;
export type GetReturnToHeadOfficeLinkSuspenseQueryHookResult = ReturnType<typeof useGetReturnToHeadOfficeLinkSuspenseQuery>;
export type GetReturnToHeadOfficeLinkQueryResult = Apollo.QueryResult<GetReturnToHeadOfficeLinkQuery, GetReturnToHeadOfficeLinkQueryVariables>;
export const SubmitReturnToHeadOfficeDocument = gql`
    mutation SubmitReturnToHeadOffice($input: SubmitReturnToHeadOfficeInput!) {
  submitReturnToHeadOffice(input: $input) {
    ...ReturnToHeadOfficeSummaryFields
  }
}
    ${ReturnToHeadOfficeSummaryFieldsFragmentDoc}`;
export type SubmitReturnToHeadOfficeMutationFn = Apollo.MutationFunction<SubmitReturnToHeadOfficeMutation, SubmitReturnToHeadOfficeMutationVariables>;

/**
 * __useSubmitReturnToHeadOfficeMutation__
 *
 * To run a mutation, you first call `useSubmitReturnToHeadOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReturnToHeadOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReturnToHeadOfficeMutation, { data, loading, error }] = useSubmitReturnToHeadOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitReturnToHeadOfficeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitReturnToHeadOfficeMutation, SubmitReturnToHeadOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitReturnToHeadOfficeMutation, SubmitReturnToHeadOfficeMutationVariables>(SubmitReturnToHeadOfficeDocument, options);
      }
export type SubmitReturnToHeadOfficeMutationHookResult = ReturnType<typeof useSubmitReturnToHeadOfficeMutation>;
export type SubmitReturnToHeadOfficeMutationResult = Apollo.MutationResult<SubmitReturnToHeadOfficeMutation>;
export type SubmitReturnToHeadOfficeMutationOptions = Apollo.BaseMutationOptions<SubmitReturnToHeadOfficeMutation, SubmitReturnToHeadOfficeMutationVariables>;
export const ReviewReturnToHeadOfficeDocument = gql`
    mutation ReviewReturnToHeadOffice($id: String!, $input: ReviewReturnToHeadOfficeInput!) {
  reviewReturnToHeadOffice(id: $id, input: $input) {
    ...ReturnToHeadOfficeSummaryFields
    reviewNotes
    manifestAvailable
  }
}
    ${ReturnToHeadOfficeSummaryFieldsFragmentDoc}`;
export type ReviewReturnToHeadOfficeMutationFn = Apollo.MutationFunction<ReviewReturnToHeadOfficeMutation, ReviewReturnToHeadOfficeMutationVariables>;

/**
 * __useReviewReturnToHeadOfficeMutation__
 *
 * To run a mutation, you first call `useReviewReturnToHeadOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewReturnToHeadOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewReturnToHeadOfficeMutation, { data, loading, error }] = useReviewReturnToHeadOfficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewReturnToHeadOfficeMutation(baseOptions?: Apollo.MutationHookOptions<ReviewReturnToHeadOfficeMutation, ReviewReturnToHeadOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewReturnToHeadOfficeMutation, ReviewReturnToHeadOfficeMutationVariables>(ReviewReturnToHeadOfficeDocument, options);
      }
export type ReviewReturnToHeadOfficeMutationHookResult = ReturnType<typeof useReviewReturnToHeadOfficeMutation>;
export type ReviewReturnToHeadOfficeMutationResult = Apollo.MutationResult<ReviewReturnToHeadOfficeMutation>;
export type ReviewReturnToHeadOfficeMutationOptions = Apollo.BaseMutationOptions<ReviewReturnToHeadOfficeMutation, ReviewReturnToHeadOfficeMutationVariables>;
export const WithdrawReturnToHeadOfficeDocument = gql`
    mutation WithdrawReturnToHeadOffice($id: String!, $reason: String) {
  withdrawReturnToHeadOffice(id: $id, reason: $reason) {
    ...ReturnToHeadOfficeSummaryFields
    cancelReason
  }
}
    ${ReturnToHeadOfficeSummaryFieldsFragmentDoc}`;
export type WithdrawReturnToHeadOfficeMutationFn = Apollo.MutationFunction<WithdrawReturnToHeadOfficeMutation, WithdrawReturnToHeadOfficeMutationVariables>;

/**
 * __useWithdrawReturnToHeadOfficeMutation__
 *
 * To run a mutation, you first call `useWithdrawReturnToHeadOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawReturnToHeadOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawReturnToHeadOfficeMutation, { data, loading, error }] = useWithdrawReturnToHeadOfficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useWithdrawReturnToHeadOfficeMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawReturnToHeadOfficeMutation, WithdrawReturnToHeadOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawReturnToHeadOfficeMutation, WithdrawReturnToHeadOfficeMutationVariables>(WithdrawReturnToHeadOfficeDocument, options);
      }
export type WithdrawReturnToHeadOfficeMutationHookResult = ReturnType<typeof useWithdrawReturnToHeadOfficeMutation>;
export type WithdrawReturnToHeadOfficeMutationResult = Apollo.MutationResult<WithdrawReturnToHeadOfficeMutation>;
export type WithdrawReturnToHeadOfficeMutationOptions = Apollo.BaseMutationOptions<WithdrawReturnToHeadOfficeMutation, WithdrawReturnToHeadOfficeMutationVariables>;
export const CancelReturnToHeadOfficeDocument = gql`
    mutation CancelReturnToHeadOffice($id: String!, $reason: String!) {
  cancelReturnToHeadOffice(id: $id, reason: $reason) {
    ...ReturnToHeadOfficeSummaryFields
    cancelReason
  }
}
    ${ReturnToHeadOfficeSummaryFieldsFragmentDoc}`;
export type CancelReturnToHeadOfficeMutationFn = Apollo.MutationFunction<CancelReturnToHeadOfficeMutation, CancelReturnToHeadOfficeMutationVariables>;

/**
 * __useCancelReturnToHeadOfficeMutation__
 *
 * To run a mutation, you first call `useCancelReturnToHeadOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReturnToHeadOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReturnToHeadOfficeMutation, { data, loading, error }] = useCancelReturnToHeadOfficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelReturnToHeadOfficeMutation(baseOptions?: Apollo.MutationHookOptions<CancelReturnToHeadOfficeMutation, CancelReturnToHeadOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReturnToHeadOfficeMutation, CancelReturnToHeadOfficeMutationVariables>(CancelReturnToHeadOfficeDocument, options);
      }
export type CancelReturnToHeadOfficeMutationHookResult = ReturnType<typeof useCancelReturnToHeadOfficeMutation>;
export type CancelReturnToHeadOfficeMutationResult = Apollo.MutationResult<CancelReturnToHeadOfficeMutation>;
export type CancelReturnToHeadOfficeMutationOptions = Apollo.BaseMutationOptions<CancelReturnToHeadOfficeMutation, CancelReturnToHeadOfficeMutationVariables>;
export const GetRolesDocument = gql`
    query GetRoles($assignableForAgents: Boolean) {
  roles(assignableForAgents: $assignableForAgents) {
    id
    code
    name
    description
    accessLevel
    isSystem
    assignableForAgents
    canManageAgents
    requiresWorkshop
    homeModule
    createdAt
    permissions {
      id
      action
      granted
      module {
        id
        code
        name
      }
    }
    userRoles {
      id
    }
    grantableRoles {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      assignableForAgents: // value for 'assignableForAgents'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
// @ts-ignore
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesQuery, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesQuery | undefined, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetRoleDocument = gql`
    query GetRole($id: String!) {
  role(id: $id) {
    id
    code
    name
    description
    accessLevel
    isSystem
    createdAt
    updatedAt
    permissions {
      id
      action
      granted
      module {
        id
        code
        name
      }
    }
  }
}
    `;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> & ({ variables: GetRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
// @ts-ignore
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleQuery, GetRoleQueryVariables>;
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleQuery | undefined, GetRoleQueryVariables>;
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<typeof useGetRoleSuspenseQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($input: CreateRoleInput!) {
  createRole(input: $input) {
    id
    code
    name
    description
    accessLevel
  }
}
    `;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($id: String!, $input: UpdateRoleInput!) {
  updateRole(id: $id, input: $input) {
    id
    code
    name
    description
    accessLevel
  }
}
    `;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($id: String!) {
  deleteRole(id: $id) {
    success
    message
  }
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const CloneRoleDocument = gql`
    mutation CloneRole($sourceRoleId: String!, $newName: String!) {
  cloneRole(sourceRoleId: $sourceRoleId, newName: $newName) {
    id
    code
    name
  }
}
    `;
export type CloneRoleMutationFn = Apollo.MutationFunction<CloneRoleMutation, CloneRoleMutationVariables>;

/**
 * __useCloneRoleMutation__
 *
 * To run a mutation, you first call `useCloneRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneRoleMutation, { data, loading, error }] = useCloneRoleMutation({
 *   variables: {
 *      sourceRoleId: // value for 'sourceRoleId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useCloneRoleMutation(baseOptions?: Apollo.MutationHookOptions<CloneRoleMutation, CloneRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneRoleMutation, CloneRoleMutationVariables>(CloneRoleDocument, options);
      }
export type CloneRoleMutationHookResult = ReturnType<typeof useCloneRoleMutation>;
export type CloneRoleMutationResult = Apollo.MutationResult<CloneRoleMutation>;
export type CloneRoleMutationOptions = Apollo.BaseMutationOptions<CloneRoleMutation, CloneRoleMutationVariables>;
export const UpdateRolePermissionsDocument = gql`
    mutation UpdateRolePermissions($roleId: String!, $permissions: [RolePermissionInput!]!) {
  updateRolePermissions(roleId: $roleId, permissions: $permissions) {
    success
    message
  }
}
    `;
export type UpdateRolePermissionsMutationFn = Apollo.MutationFunction<UpdateRolePermissionsMutation, UpdateRolePermissionsMutationVariables>;

/**
 * __useUpdateRolePermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRolePermissionsMutation, { data, loading, error }] = useUpdateRolePermissionsMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useUpdateRolePermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRolePermissionsMutation, UpdateRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRolePermissionsMutation, UpdateRolePermissionsMutationVariables>(UpdateRolePermissionsDocument, options);
      }
export type UpdateRolePermissionsMutationHookResult = ReturnType<typeof useUpdateRolePermissionsMutation>;
export type UpdateRolePermissionsMutationResult = Apollo.MutationResult<UpdateRolePermissionsMutation>;
export type UpdateRolePermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateRolePermissionsMutation, UpdateRolePermissionsMutationVariables>;
export const SetRoleGrantsDocument = gql`
    mutation SetRoleGrants($roleId: String!, $grantableRoleIds: [String!]!) {
  setRoleGrants(roleId: $roleId, grantableRoleIds: $grantableRoleIds) {
    success
    message
  }
}
    `;
export type SetRoleGrantsMutationFn = Apollo.MutationFunction<SetRoleGrantsMutation, SetRoleGrantsMutationVariables>;

/**
 * __useSetRoleGrantsMutation__
 *
 * To run a mutation, you first call `useSetRoleGrantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRoleGrantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRoleGrantsMutation, { data, loading, error }] = useSetRoleGrantsMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      grantableRoleIds: // value for 'grantableRoleIds'
 *   },
 * });
 */
export function useSetRoleGrantsMutation(baseOptions?: Apollo.MutationHookOptions<SetRoleGrantsMutation, SetRoleGrantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRoleGrantsMutation, SetRoleGrantsMutationVariables>(SetRoleGrantsDocument, options);
      }
export type SetRoleGrantsMutationHookResult = ReturnType<typeof useSetRoleGrantsMutation>;
export type SetRoleGrantsMutationResult = Apollo.MutationResult<SetRoleGrantsMutation>;
export type SetRoleGrantsMutationOptions = Apollo.BaseMutationOptions<SetRoleGrantsMutation, SetRoleGrantsMutationVariables>;
export const SafetyIncidentsDocument = gql`
    query SafetyIncidents($filter: SafetyIncidentFilterInput) {
  safetyIncidents(filter: $filter) {
    totalCount
    items {
      ...SafetyIncidentFields
    }
  }
}
    ${SafetyIncidentFieldsFragmentDoc}`;

/**
 * __useSafetyIncidentsQuery__
 *
 * To run a query within a React component, call `useSafetyIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyIncidentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSafetyIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>(SafetyIncidentsDocument, options);
      }
export function useSafetyIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>(SafetyIncidentsDocument, options);
        }
// @ts-ignore
export function useSafetyIncidentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>;
export function useSafetyIncidentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyIncidentsQuery | undefined, SafetyIncidentsQueryVariables>;
export function useSafetyIncidentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>(SafetyIncidentsDocument, options);
        }
export type SafetyIncidentsQueryHookResult = ReturnType<typeof useSafetyIncidentsQuery>;
export type SafetyIncidentsLazyQueryHookResult = ReturnType<typeof useSafetyIncidentsLazyQuery>;
export type SafetyIncidentsSuspenseQueryHookResult = ReturnType<typeof useSafetyIncidentsSuspenseQuery>;
export type SafetyIncidentsQueryResult = Apollo.QueryResult<SafetyIncidentsQuery, SafetyIncidentsQueryVariables>;
export const SafetyIncidentsExportDocument = gql`
    query SafetyIncidentsExport($filter: SafetyIncidentFilterInput) {
  safetyIncidentsExport(filter: $filter) {
    ...SafetyIncidentFields
  }
}
    ${SafetyIncidentFieldsFragmentDoc}`;

/**
 * __useSafetyIncidentsExportQuery__
 *
 * To run a query within a React component, call `useSafetyIncidentsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyIncidentsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyIncidentsExportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSafetyIncidentsExportQuery(baseOptions?: Apollo.QueryHookOptions<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>(SafetyIncidentsExportDocument, options);
      }
export function useSafetyIncidentsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>(SafetyIncidentsExportDocument, options);
        }
// @ts-ignore
export function useSafetyIncidentsExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>;
export function useSafetyIncidentsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyIncidentsExportQuery | undefined, SafetyIncidentsExportQueryVariables>;
export function useSafetyIncidentsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>(SafetyIncidentsExportDocument, options);
        }
export type SafetyIncidentsExportQueryHookResult = ReturnType<typeof useSafetyIncidentsExportQuery>;
export type SafetyIncidentsExportLazyQueryHookResult = ReturnType<typeof useSafetyIncidentsExportLazyQuery>;
export type SafetyIncidentsExportSuspenseQueryHookResult = ReturnType<typeof useSafetyIncidentsExportSuspenseQuery>;
export type SafetyIncidentsExportQueryResult = Apollo.QueryResult<SafetyIncidentsExportQuery, SafetyIncidentsExportQueryVariables>;
export const SafetyIncidentDocument = gql`
    query SafetyIncident($id: ID!) {
  safetyIncident(id: $id) {
    ...SafetyIncidentFields
  }
}
    ${SafetyIncidentFieldsFragmentDoc}`;

/**
 * __useSafetyIncidentQuery__
 *
 * To run a query within a React component, call `useSafetyIncidentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyIncidentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyIncidentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSafetyIncidentQuery(baseOptions: Apollo.QueryHookOptions<SafetyIncidentQuery, SafetyIncidentQueryVariables> & ({ variables: SafetyIncidentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyIncidentQuery, SafetyIncidentQueryVariables>(SafetyIncidentDocument, options);
      }
export function useSafetyIncidentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyIncidentQuery, SafetyIncidentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyIncidentQuery, SafetyIncidentQueryVariables>(SafetyIncidentDocument, options);
        }
// @ts-ignore
export function useSafetyIncidentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SafetyIncidentQuery, SafetyIncidentQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyIncidentQuery, SafetyIncidentQueryVariables>;
export function useSafetyIncidentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyIncidentQuery, SafetyIncidentQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyIncidentQuery | undefined, SafetyIncidentQueryVariables>;
export function useSafetyIncidentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyIncidentQuery, SafetyIncidentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SafetyIncidentQuery, SafetyIncidentQueryVariables>(SafetyIncidentDocument, options);
        }
export type SafetyIncidentQueryHookResult = ReturnType<typeof useSafetyIncidentQuery>;
export type SafetyIncidentLazyQueryHookResult = ReturnType<typeof useSafetyIncidentLazyQuery>;
export type SafetyIncidentSuspenseQueryHookResult = ReturnType<typeof useSafetyIncidentSuspenseQuery>;
export type SafetyIncidentQueryResult = Apollo.QueryResult<SafetyIncidentQuery, SafetyIncidentQueryVariables>;
export const SafetyInspectionsDocument = gql`
    query SafetyInspections($filter: SafetyInspectionFilterInput) {
  safetyInspections(filter: $filter) {
    totalCount
    items {
      ...SafetyInspectionFields
    }
  }
}
    ${SafetyInspectionFieldsFragmentDoc}`;

/**
 * __useSafetyInspectionsQuery__
 *
 * To run a query within a React component, call `useSafetyInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyInspectionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSafetyInspectionsQuery(baseOptions?: Apollo.QueryHookOptions<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>(SafetyInspectionsDocument, options);
      }
export function useSafetyInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>(SafetyInspectionsDocument, options);
        }
// @ts-ignore
export function useSafetyInspectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>;
export function useSafetyInspectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyInspectionsQuery | undefined, SafetyInspectionsQueryVariables>;
export function useSafetyInspectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>(SafetyInspectionsDocument, options);
        }
export type SafetyInspectionsQueryHookResult = ReturnType<typeof useSafetyInspectionsQuery>;
export type SafetyInspectionsLazyQueryHookResult = ReturnType<typeof useSafetyInspectionsLazyQuery>;
export type SafetyInspectionsSuspenseQueryHookResult = ReturnType<typeof useSafetyInspectionsSuspenseQuery>;
export type SafetyInspectionsQueryResult = Apollo.QueryResult<SafetyInspectionsQuery, SafetyInspectionsQueryVariables>;
export const SafetySubcontractorOptionsDocument = gql`
    query SafetySubcontractorOptions($search: String) {
  safetySubcontractorOptions(search: $search) {
    id
    name
    workers {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useSafetySubcontractorOptionsQuery__
 *
 * To run a query within a React component, call `useSafetySubcontractorOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetySubcontractorOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetySubcontractorOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSafetySubcontractorOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>(SafetySubcontractorOptionsDocument, options);
      }
export function useSafetySubcontractorOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>(SafetySubcontractorOptionsDocument, options);
        }
// @ts-ignore
export function useSafetySubcontractorOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>;
export function useSafetySubcontractorOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SafetySubcontractorOptionsQuery | undefined, SafetySubcontractorOptionsQueryVariables>;
export function useSafetySubcontractorOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>(SafetySubcontractorOptionsDocument, options);
        }
export type SafetySubcontractorOptionsQueryHookResult = ReturnType<typeof useSafetySubcontractorOptionsQuery>;
export type SafetySubcontractorOptionsLazyQueryHookResult = ReturnType<typeof useSafetySubcontractorOptionsLazyQuery>;
export type SafetySubcontractorOptionsSuspenseQueryHookResult = ReturnType<typeof useSafetySubcontractorOptionsSuspenseQuery>;
export type SafetySubcontractorOptionsQueryResult = Apollo.QueryResult<SafetySubcontractorOptionsQuery, SafetySubcontractorOptionsQueryVariables>;
export const SafetyMetricsDocument = gql`
    query SafetyMetrics($from: DateTime!, $to: DateTime!, $filter: SafetyMetricsFilterInput) {
  safetyMetrics(from: $from, to: $to, filter: $filter) {
    from
    to
    incidents {
      ...HrMetricFields
    }
    lostTimeInjuries {
      ...HrMetricFields
    }
    fatalities {
      ...HrMetricFields
    }
    lostDays {
      ...HrMetricFields
    }
    daysSinceLastLostTimeInjury {
      ...HrMetricFields
    }
    nearMisses {
      ...HrMetricFields
    }
    reportableIncidents {
      ...HrMetricFields
    }
    openCorrectiveActions {
      ...HrMetricFields
    }
    overdueCorrectiveActions {
      ...HrMetricFields
    }
    inspections {
      ...HrMetricFields
    }
    averageInspectionScore {
      ...HrMetricFields
    }
    inspectionFindings {
      ...HrMetricFields
    }
    employeeHoursWorked {
      ...HrMetricFields
    }
    ltifr {
      ...HrMetricFields
    }
    subcontractorHoursWorked {
      ...HrMetricFields
    }
    subcontractorLtifr {
      ...HrMetricFields
    }
    incidentsByType {
      type
      count
    }
    incidentsBySeverity {
      severity
      count
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useSafetyMetricsQuery__
 *
 * To run a query within a React component, call `useSafetyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSafetyMetricsQuery(baseOptions: Apollo.QueryHookOptions<SafetyMetricsQuery, SafetyMetricsQueryVariables> & ({ variables: SafetyMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyMetricsQuery, SafetyMetricsQueryVariables>(SafetyMetricsDocument, options);
      }
export function useSafetyMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyMetricsQuery, SafetyMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyMetricsQuery, SafetyMetricsQueryVariables>(SafetyMetricsDocument, options);
        }
// @ts-ignore
export function useSafetyMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SafetyMetricsQuery, SafetyMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyMetricsQuery, SafetyMetricsQueryVariables>;
export function useSafetyMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyMetricsQuery, SafetyMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<SafetyMetricsQuery | undefined, SafetyMetricsQueryVariables>;
export function useSafetyMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SafetyMetricsQuery, SafetyMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SafetyMetricsQuery, SafetyMetricsQueryVariables>(SafetyMetricsDocument, options);
        }
export type SafetyMetricsQueryHookResult = ReturnType<typeof useSafetyMetricsQuery>;
export type SafetyMetricsLazyQueryHookResult = ReturnType<typeof useSafetyMetricsLazyQuery>;
export type SafetyMetricsSuspenseQueryHookResult = ReturnType<typeof useSafetyMetricsSuspenseQuery>;
export type SafetyMetricsQueryResult = Apollo.QueryResult<SafetyMetricsQuery, SafetyMetricsQueryVariables>;
export const CreateSafetyIncidentDocument = gql`
    mutation CreateSafetyIncident($input: CreateSafetyIncidentInput!) {
  createSafetyIncident(input: $input) {
    ...SafetyIncidentFields
  }
}
    ${SafetyIncidentFieldsFragmentDoc}`;
export type CreateSafetyIncidentMutationFn = Apollo.MutationFunction<CreateSafetyIncidentMutation, CreateSafetyIncidentMutationVariables>;

/**
 * __useCreateSafetyIncidentMutation__
 *
 * To run a mutation, you first call `useCreateSafetyIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSafetyIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSafetyIncidentMutation, { data, loading, error }] = useCreateSafetyIncidentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSafetyIncidentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSafetyIncidentMutation, CreateSafetyIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSafetyIncidentMutation, CreateSafetyIncidentMutationVariables>(CreateSafetyIncidentDocument, options);
      }
export type CreateSafetyIncidentMutationHookResult = ReturnType<typeof useCreateSafetyIncidentMutation>;
export type CreateSafetyIncidentMutationResult = Apollo.MutationResult<CreateSafetyIncidentMutation>;
export type CreateSafetyIncidentMutationOptions = Apollo.BaseMutationOptions<CreateSafetyIncidentMutation, CreateSafetyIncidentMutationVariables>;
export const UpdateSafetyIncidentDocument = gql`
    mutation UpdateSafetyIncident($id: ID!, $input: UpdateSafetyIncidentInput!) {
  updateSafetyIncident(id: $id, input: $input) {
    ...SafetyIncidentFields
  }
}
    ${SafetyIncidentFieldsFragmentDoc}`;
export type UpdateSafetyIncidentMutationFn = Apollo.MutationFunction<UpdateSafetyIncidentMutation, UpdateSafetyIncidentMutationVariables>;

/**
 * __useUpdateSafetyIncidentMutation__
 *
 * To run a mutation, you first call `useUpdateSafetyIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafetyIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafetyIncidentMutation, { data, loading, error }] = useUpdateSafetyIncidentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafetyIncidentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSafetyIncidentMutation, UpdateSafetyIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSafetyIncidentMutation, UpdateSafetyIncidentMutationVariables>(UpdateSafetyIncidentDocument, options);
      }
export type UpdateSafetyIncidentMutationHookResult = ReturnType<typeof useUpdateSafetyIncidentMutation>;
export type UpdateSafetyIncidentMutationResult = Apollo.MutationResult<UpdateSafetyIncidentMutation>;
export type UpdateSafetyIncidentMutationOptions = Apollo.BaseMutationOptions<UpdateSafetyIncidentMutation, UpdateSafetyIncidentMutationVariables>;
export const DeleteSafetyIncidentDocument = gql`
    mutation DeleteSafetyIncident($id: ID!) {
  deleteSafetyIncident(id: $id)
}
    `;
export type DeleteSafetyIncidentMutationFn = Apollo.MutationFunction<DeleteSafetyIncidentMutation, DeleteSafetyIncidentMutationVariables>;

/**
 * __useDeleteSafetyIncidentMutation__
 *
 * To run a mutation, you first call `useDeleteSafetyIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSafetyIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSafetyIncidentMutation, { data, loading, error }] = useDeleteSafetyIncidentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSafetyIncidentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSafetyIncidentMutation, DeleteSafetyIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSafetyIncidentMutation, DeleteSafetyIncidentMutationVariables>(DeleteSafetyIncidentDocument, options);
      }
export type DeleteSafetyIncidentMutationHookResult = ReturnType<typeof useDeleteSafetyIncidentMutation>;
export type DeleteSafetyIncidentMutationResult = Apollo.MutationResult<DeleteSafetyIncidentMutation>;
export type DeleteSafetyIncidentMutationOptions = Apollo.BaseMutationOptions<DeleteSafetyIncidentMutation, DeleteSafetyIncidentMutationVariables>;
export const RemoveSafetyIncidentEvidenceDocument = gql`
    mutation RemoveSafetyIncidentEvidence($documentId: ID!) {
  removeSafetyIncidentEvidence(documentId: $documentId)
}
    `;
export type RemoveSafetyIncidentEvidenceMutationFn = Apollo.MutationFunction<RemoveSafetyIncidentEvidenceMutation, RemoveSafetyIncidentEvidenceMutationVariables>;

/**
 * __useRemoveSafetyIncidentEvidenceMutation__
 *
 * To run a mutation, you first call `useRemoveSafetyIncidentEvidenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSafetyIncidentEvidenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSafetyIncidentEvidenceMutation, { data, loading, error }] = useRemoveSafetyIncidentEvidenceMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveSafetyIncidentEvidenceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSafetyIncidentEvidenceMutation, RemoveSafetyIncidentEvidenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSafetyIncidentEvidenceMutation, RemoveSafetyIncidentEvidenceMutationVariables>(RemoveSafetyIncidentEvidenceDocument, options);
      }
export type RemoveSafetyIncidentEvidenceMutationHookResult = ReturnType<typeof useRemoveSafetyIncidentEvidenceMutation>;
export type RemoveSafetyIncidentEvidenceMutationResult = Apollo.MutationResult<RemoveSafetyIncidentEvidenceMutation>;
export type RemoveSafetyIncidentEvidenceMutationOptions = Apollo.BaseMutationOptions<RemoveSafetyIncidentEvidenceMutation, RemoveSafetyIncidentEvidenceMutationVariables>;
export const CreateSafetyCorrectiveActionDocument = gql`
    mutation CreateSafetyCorrectiveAction($incidentId: ID!, $input: CreateSafetyCorrectiveActionInput!) {
  createSafetyCorrectiveAction(incidentId: $incidentId, input: $input) {
    ...SafetyCorrectiveActionFields
  }
}
    ${SafetyCorrectiveActionFieldsFragmentDoc}`;
export type CreateSafetyCorrectiveActionMutationFn = Apollo.MutationFunction<CreateSafetyCorrectiveActionMutation, CreateSafetyCorrectiveActionMutationVariables>;

/**
 * __useCreateSafetyCorrectiveActionMutation__
 *
 * To run a mutation, you first call `useCreateSafetyCorrectiveActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSafetyCorrectiveActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSafetyCorrectiveActionMutation, { data, loading, error }] = useCreateSafetyCorrectiveActionMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSafetyCorrectiveActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSafetyCorrectiveActionMutation, CreateSafetyCorrectiveActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSafetyCorrectiveActionMutation, CreateSafetyCorrectiveActionMutationVariables>(CreateSafetyCorrectiveActionDocument, options);
      }
export type CreateSafetyCorrectiveActionMutationHookResult = ReturnType<typeof useCreateSafetyCorrectiveActionMutation>;
export type CreateSafetyCorrectiveActionMutationResult = Apollo.MutationResult<CreateSafetyCorrectiveActionMutation>;
export type CreateSafetyCorrectiveActionMutationOptions = Apollo.BaseMutationOptions<CreateSafetyCorrectiveActionMutation, CreateSafetyCorrectiveActionMutationVariables>;
export const UpdateSafetyCorrectiveActionDocument = gql`
    mutation UpdateSafetyCorrectiveAction($id: ID!, $input: UpdateSafetyCorrectiveActionInput!) {
  updateSafetyCorrectiveAction(id: $id, input: $input) {
    ...SafetyCorrectiveActionFields
  }
}
    ${SafetyCorrectiveActionFieldsFragmentDoc}`;
export type UpdateSafetyCorrectiveActionMutationFn = Apollo.MutationFunction<UpdateSafetyCorrectiveActionMutation, UpdateSafetyCorrectiveActionMutationVariables>;

/**
 * __useUpdateSafetyCorrectiveActionMutation__
 *
 * To run a mutation, you first call `useUpdateSafetyCorrectiveActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafetyCorrectiveActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafetyCorrectiveActionMutation, { data, loading, error }] = useUpdateSafetyCorrectiveActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafetyCorrectiveActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSafetyCorrectiveActionMutation, UpdateSafetyCorrectiveActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSafetyCorrectiveActionMutation, UpdateSafetyCorrectiveActionMutationVariables>(UpdateSafetyCorrectiveActionDocument, options);
      }
export type UpdateSafetyCorrectiveActionMutationHookResult = ReturnType<typeof useUpdateSafetyCorrectiveActionMutation>;
export type UpdateSafetyCorrectiveActionMutationResult = Apollo.MutationResult<UpdateSafetyCorrectiveActionMutation>;
export type UpdateSafetyCorrectiveActionMutationOptions = Apollo.BaseMutationOptions<UpdateSafetyCorrectiveActionMutation, UpdateSafetyCorrectiveActionMutationVariables>;
export const DeleteSafetyCorrectiveActionDocument = gql`
    mutation DeleteSafetyCorrectiveAction($id: ID!) {
  deleteSafetyCorrectiveAction(id: $id)
}
    `;
export type DeleteSafetyCorrectiveActionMutationFn = Apollo.MutationFunction<DeleteSafetyCorrectiveActionMutation, DeleteSafetyCorrectiveActionMutationVariables>;

/**
 * __useDeleteSafetyCorrectiveActionMutation__
 *
 * To run a mutation, you first call `useDeleteSafetyCorrectiveActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSafetyCorrectiveActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSafetyCorrectiveActionMutation, { data, loading, error }] = useDeleteSafetyCorrectiveActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSafetyCorrectiveActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSafetyCorrectiveActionMutation, DeleteSafetyCorrectiveActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSafetyCorrectiveActionMutation, DeleteSafetyCorrectiveActionMutationVariables>(DeleteSafetyCorrectiveActionDocument, options);
      }
export type DeleteSafetyCorrectiveActionMutationHookResult = ReturnType<typeof useDeleteSafetyCorrectiveActionMutation>;
export type DeleteSafetyCorrectiveActionMutationResult = Apollo.MutationResult<DeleteSafetyCorrectiveActionMutation>;
export type DeleteSafetyCorrectiveActionMutationOptions = Apollo.BaseMutationOptions<DeleteSafetyCorrectiveActionMutation, DeleteSafetyCorrectiveActionMutationVariables>;
export const CreateSafetyInspectionDocument = gql`
    mutation CreateSafetyInspection($input: CreateSafetyInspectionInput!) {
  createSafetyInspection(input: $input) {
    ...SafetyInspectionFields
  }
}
    ${SafetyInspectionFieldsFragmentDoc}`;
export type CreateSafetyInspectionMutationFn = Apollo.MutationFunction<CreateSafetyInspectionMutation, CreateSafetyInspectionMutationVariables>;

/**
 * __useCreateSafetyInspectionMutation__
 *
 * To run a mutation, you first call `useCreateSafetyInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSafetyInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSafetyInspectionMutation, { data, loading, error }] = useCreateSafetyInspectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSafetyInspectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSafetyInspectionMutation, CreateSafetyInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSafetyInspectionMutation, CreateSafetyInspectionMutationVariables>(CreateSafetyInspectionDocument, options);
      }
export type CreateSafetyInspectionMutationHookResult = ReturnType<typeof useCreateSafetyInspectionMutation>;
export type CreateSafetyInspectionMutationResult = Apollo.MutationResult<CreateSafetyInspectionMutation>;
export type CreateSafetyInspectionMutationOptions = Apollo.BaseMutationOptions<CreateSafetyInspectionMutation, CreateSafetyInspectionMutationVariables>;
export const UpdateSafetyInspectionDocument = gql`
    mutation UpdateSafetyInspection($id: ID!, $input: UpdateSafetyInspectionInput!) {
  updateSafetyInspection(id: $id, input: $input) {
    ...SafetyInspectionFields
  }
}
    ${SafetyInspectionFieldsFragmentDoc}`;
export type UpdateSafetyInspectionMutationFn = Apollo.MutationFunction<UpdateSafetyInspectionMutation, UpdateSafetyInspectionMutationVariables>;

/**
 * __useUpdateSafetyInspectionMutation__
 *
 * To run a mutation, you first call `useUpdateSafetyInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafetyInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafetyInspectionMutation, { data, loading, error }] = useUpdateSafetyInspectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafetyInspectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSafetyInspectionMutation, UpdateSafetyInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSafetyInspectionMutation, UpdateSafetyInspectionMutationVariables>(UpdateSafetyInspectionDocument, options);
      }
export type UpdateSafetyInspectionMutationHookResult = ReturnType<typeof useUpdateSafetyInspectionMutation>;
export type UpdateSafetyInspectionMutationResult = Apollo.MutationResult<UpdateSafetyInspectionMutation>;
export type UpdateSafetyInspectionMutationOptions = Apollo.BaseMutationOptions<UpdateSafetyInspectionMutation, UpdateSafetyInspectionMutationVariables>;
export const DeleteSafetyInspectionDocument = gql`
    mutation DeleteSafetyInspection($id: ID!) {
  deleteSafetyInspection(id: $id)
}
    `;
export type DeleteSafetyInspectionMutationFn = Apollo.MutationFunction<DeleteSafetyInspectionMutation, DeleteSafetyInspectionMutationVariables>;

/**
 * __useDeleteSafetyInspectionMutation__
 *
 * To run a mutation, you first call `useDeleteSafetyInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSafetyInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSafetyInspectionMutation, { data, loading, error }] = useDeleteSafetyInspectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSafetyInspectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSafetyInspectionMutation, DeleteSafetyInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSafetyInspectionMutation, DeleteSafetyInspectionMutationVariables>(DeleteSafetyInspectionDocument, options);
      }
export type DeleteSafetyInspectionMutationHookResult = ReturnType<typeof useDeleteSafetyInspectionMutation>;
export type DeleteSafetyInspectionMutationResult = Apollo.MutationResult<DeleteSafetyInspectionMutation>;
export type DeleteSafetyInspectionMutationOptions = Apollo.BaseMutationOptions<DeleteSafetyInspectionMutation, DeleteSafetyInspectionMutationVariables>;
export const GetSalesAppMessagesDocument = gql`
    query GetSalesAppMessages($limit: Int, $offset: Int) {
  salesAppMessages(limit: $limit, offset: $offset) {
    items {
      ...SalesAppMessageFields
    }
    totalCount
  }
}
    ${SalesAppMessageFieldsFragmentDoc}`;

/**
 * __useGetSalesAppMessagesQuery__
 *
 * To run a query within a React component, call `useGetSalesAppMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAppMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAppMessagesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSalesAppMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>(GetSalesAppMessagesDocument, options);
      }
export function useGetSalesAppMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>(GetSalesAppMessagesDocument, options);
        }
// @ts-ignore
export function useGetSalesAppMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>;
export function useGetSalesAppMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesAppMessagesQuery | undefined, GetSalesAppMessagesQueryVariables>;
export function useGetSalesAppMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>(GetSalesAppMessagesDocument, options);
        }
export type GetSalesAppMessagesQueryHookResult = ReturnType<typeof useGetSalesAppMessagesQuery>;
export type GetSalesAppMessagesLazyQueryHookResult = ReturnType<typeof useGetSalesAppMessagesLazyQuery>;
export type GetSalesAppMessagesSuspenseQueryHookResult = ReturnType<typeof useGetSalesAppMessagesSuspenseQuery>;
export type GetSalesAppMessagesQueryResult = Apollo.QueryResult<GetSalesAppMessagesQuery, GetSalesAppMessagesQueryVariables>;
export const GetSalesAppMessageDistributorTeamDocument = gql`
    query GetSalesAppMessageDistributorTeam($distributorId: ID!) {
  salesAppMessageDistributorTeam(distributorId: $distributorId)
}
    `;

/**
 * __useGetSalesAppMessageDistributorTeamQuery__
 *
 * To run a query within a React component, call `useGetSalesAppMessageDistributorTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAppMessageDistributorTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAppMessageDistributorTeamQuery({
 *   variables: {
 *      distributorId: // value for 'distributorId'
 *   },
 * });
 */
export function useGetSalesAppMessageDistributorTeamQuery(baseOptions: Apollo.QueryHookOptions<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables> & ({ variables: GetSalesAppMessageDistributorTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>(GetSalesAppMessageDistributorTeamDocument, options);
      }
export function useGetSalesAppMessageDistributorTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>(GetSalesAppMessageDistributorTeamDocument, options);
        }
// @ts-ignore
export function useGetSalesAppMessageDistributorTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>;
export function useGetSalesAppMessageDistributorTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesAppMessageDistributorTeamQuery | undefined, GetSalesAppMessageDistributorTeamQueryVariables>;
export function useGetSalesAppMessageDistributorTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>(GetSalesAppMessageDistributorTeamDocument, options);
        }
export type GetSalesAppMessageDistributorTeamQueryHookResult = ReturnType<typeof useGetSalesAppMessageDistributorTeamQuery>;
export type GetSalesAppMessageDistributorTeamLazyQueryHookResult = ReturnType<typeof useGetSalesAppMessageDistributorTeamLazyQuery>;
export type GetSalesAppMessageDistributorTeamSuspenseQueryHookResult = ReturnType<typeof useGetSalesAppMessageDistributorTeamSuspenseQuery>;
export type GetSalesAppMessageDistributorTeamQueryResult = Apollo.QueryResult<GetSalesAppMessageDistributorTeamQuery, GetSalesAppMessageDistributorTeamQueryVariables>;
export const SearchSalesAppMessageAgentsDocument = gql`
    query SearchSalesAppMessageAgents($input: AgentListInput) {
  agents(input: $input) {
    items {
      id
      salesId
      firstName
      lastName
      agentType
    }
    totalCount
  }
}
    `;

/**
 * __useSearchSalesAppMessageAgentsQuery__
 *
 * To run a query within a React component, call `useSearchSalesAppMessageAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSalesAppMessageAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSalesAppMessageAgentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchSalesAppMessageAgentsQuery(baseOptions?: Apollo.QueryHookOptions<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>(SearchSalesAppMessageAgentsDocument, options);
      }
export function useSearchSalesAppMessageAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>(SearchSalesAppMessageAgentsDocument, options);
        }
// @ts-ignore
export function useSearchSalesAppMessageAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>;
export function useSearchSalesAppMessageAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchSalesAppMessageAgentsQuery | undefined, SearchSalesAppMessageAgentsQueryVariables>;
export function useSearchSalesAppMessageAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>(SearchSalesAppMessageAgentsDocument, options);
        }
export type SearchSalesAppMessageAgentsQueryHookResult = ReturnType<typeof useSearchSalesAppMessageAgentsQuery>;
export type SearchSalesAppMessageAgentsLazyQueryHookResult = ReturnType<typeof useSearchSalesAppMessageAgentsLazyQuery>;
export type SearchSalesAppMessageAgentsSuspenseQueryHookResult = ReturnType<typeof useSearchSalesAppMessageAgentsSuspenseQuery>;
export type SearchSalesAppMessageAgentsQueryResult = Apollo.QueryResult<SearchSalesAppMessageAgentsQuery, SearchSalesAppMessageAgentsQueryVariables>;
export const SendSalesAppMessageDocument = gql`
    mutation SendSalesAppMessage($input: SendSalesAppMessageInput!) {
  sendSalesAppMessage(input: $input) {
    ...SalesAppMessageFields
  }
}
    ${SalesAppMessageFieldsFragmentDoc}`;
export type SendSalesAppMessageMutationFn = Apollo.MutationFunction<SendSalesAppMessageMutation, SendSalesAppMessageMutationVariables>;

/**
 * __useSendSalesAppMessageMutation__
 *
 * To run a mutation, you first call `useSendSalesAppMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSalesAppMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSalesAppMessageMutation, { data, loading, error }] = useSendSalesAppMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSalesAppMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendSalesAppMessageMutation, SendSalesAppMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSalesAppMessageMutation, SendSalesAppMessageMutationVariables>(SendSalesAppMessageDocument, options);
      }
export type SendSalesAppMessageMutationHookResult = ReturnType<typeof useSendSalesAppMessageMutation>;
export type SendSalesAppMessageMutationResult = Apollo.MutationResult<SendSalesAppMessageMutation>;
export type SendSalesAppMessageMutationOptions = Apollo.BaseMutationOptions<SendSalesAppMessageMutation, SendSalesAppMessageMutationVariables>;
export const RetrySalesAppMessageDocument = gql`
    mutation RetrySalesAppMessage($id: ID!) {
  retrySalesAppMessage(id: $id) {
    ...SalesAppMessageFields
  }
}
    ${SalesAppMessageFieldsFragmentDoc}`;
export type RetrySalesAppMessageMutationFn = Apollo.MutationFunction<RetrySalesAppMessageMutation, RetrySalesAppMessageMutationVariables>;

/**
 * __useRetrySalesAppMessageMutation__
 *
 * To run a mutation, you first call `useRetrySalesAppMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySalesAppMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySalesAppMessageMutation, { data, loading, error }] = useRetrySalesAppMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetrySalesAppMessageMutation(baseOptions?: Apollo.MutationHookOptions<RetrySalesAppMessageMutation, RetrySalesAppMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySalesAppMessageMutation, RetrySalesAppMessageMutationVariables>(RetrySalesAppMessageDocument, options);
      }
export type RetrySalesAppMessageMutationHookResult = ReturnType<typeof useRetrySalesAppMessageMutation>;
export type RetrySalesAppMessageMutationResult = Apollo.MutationResult<RetrySalesAppMessageMutation>;
export type RetrySalesAppMessageMutationOptions = Apollo.BaseMutationOptions<RetrySalesAppMessageMutation, RetrySalesAppMessageMutationVariables>;
export const GetSalesRegionsDocument = gql`
    query GetSalesRegions {
  salesRegions {
    id
    name
    emblemUrl
    managers {
      userId
      name
    }
  }
  salesRegionManagers {
    userId
    name
    email
    avatarUrl
    salesRegionId
    agents
  }
}
    `;

/**
 * __useGetSalesRegionsQuery__
 *
 * To run a query within a React component, call `useGetSalesRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>(GetSalesRegionsDocument, options);
      }
export function useGetSalesRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>(GetSalesRegionsDocument, options);
        }
// @ts-ignore
export function useGetSalesRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>;
export function useGetSalesRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSalesRegionsQuery | undefined, GetSalesRegionsQueryVariables>;
export function useGetSalesRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>(GetSalesRegionsDocument, options);
        }
export type GetSalesRegionsQueryHookResult = ReturnType<typeof useGetSalesRegionsQuery>;
export type GetSalesRegionsLazyQueryHookResult = ReturnType<typeof useGetSalesRegionsLazyQuery>;
export type GetSalesRegionsSuspenseQueryHookResult = ReturnType<typeof useGetSalesRegionsSuspenseQuery>;
export type GetSalesRegionsQueryResult = Apollo.QueryResult<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>;
export const CreateSalesRegionDocument = gql`
    mutation CreateSalesRegion($name: String!) {
  createSalesRegion(name: $name) {
    id
    name
  }
}
    `;
export type CreateSalesRegionMutationFn = Apollo.MutationFunction<CreateSalesRegionMutation, CreateSalesRegionMutationVariables>;

/**
 * __useCreateSalesRegionMutation__
 *
 * To run a mutation, you first call `useCreateSalesRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesRegionMutation, { data, loading, error }] = useCreateSalesRegionMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateSalesRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalesRegionMutation, CreateSalesRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalesRegionMutation, CreateSalesRegionMutationVariables>(CreateSalesRegionDocument, options);
      }
export type CreateSalesRegionMutationHookResult = ReturnType<typeof useCreateSalesRegionMutation>;
export type CreateSalesRegionMutationResult = Apollo.MutationResult<CreateSalesRegionMutation>;
export type CreateSalesRegionMutationOptions = Apollo.BaseMutationOptions<CreateSalesRegionMutation, CreateSalesRegionMutationVariables>;
export const RenameSalesRegionDocument = gql`
    mutation RenameSalesRegion($id: String!, $name: String!) {
  renameSalesRegion(id: $id, name: $name) {
    id
    name
  }
}
    `;
export type RenameSalesRegionMutationFn = Apollo.MutationFunction<RenameSalesRegionMutation, RenameSalesRegionMutationVariables>;

/**
 * __useRenameSalesRegionMutation__
 *
 * To run a mutation, you first call `useRenameSalesRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameSalesRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameSalesRegionMutation, { data, loading, error }] = useRenameSalesRegionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameSalesRegionMutation(baseOptions?: Apollo.MutationHookOptions<RenameSalesRegionMutation, RenameSalesRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameSalesRegionMutation, RenameSalesRegionMutationVariables>(RenameSalesRegionDocument, options);
      }
export type RenameSalesRegionMutationHookResult = ReturnType<typeof useRenameSalesRegionMutation>;
export type RenameSalesRegionMutationResult = Apollo.MutationResult<RenameSalesRegionMutation>;
export type RenameSalesRegionMutationOptions = Apollo.BaseMutationOptions<RenameSalesRegionMutation, RenameSalesRegionMutationVariables>;
export const DeleteSalesRegionDocument = gql`
    mutation DeleteSalesRegion($id: String!) {
  deleteSalesRegion(id: $id)
}
    `;
export type DeleteSalesRegionMutationFn = Apollo.MutationFunction<DeleteSalesRegionMutation, DeleteSalesRegionMutationVariables>;

/**
 * __useDeleteSalesRegionMutation__
 *
 * To run a mutation, you first call `useDeleteSalesRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesRegionMutation, { data, loading, error }] = useDeleteSalesRegionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSalesRegionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesRegionMutation, DeleteSalesRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesRegionMutation, DeleteSalesRegionMutationVariables>(DeleteSalesRegionDocument, options);
      }
export type DeleteSalesRegionMutationHookResult = ReturnType<typeof useDeleteSalesRegionMutation>;
export type DeleteSalesRegionMutationResult = Apollo.MutationResult<DeleteSalesRegionMutation>;
export type DeleteSalesRegionMutationOptions = Apollo.BaseMutationOptions<DeleteSalesRegionMutation, DeleteSalesRegionMutationVariables>;
export const AssignSalesRegionDocument = gql`
    mutation AssignSalesRegion($userId: String!, $salesRegionId: String) {
  assignSalesRegion(userId: $userId, salesRegionId: $salesRegionId) {
    userId
    salesRegionId
  }
}
    `;
export type AssignSalesRegionMutationFn = Apollo.MutationFunction<AssignSalesRegionMutation, AssignSalesRegionMutationVariables>;

/**
 * __useAssignSalesRegionMutation__
 *
 * To run a mutation, you first call `useAssignSalesRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignSalesRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignSalesRegionMutation, { data, loading, error }] = useAssignSalesRegionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      salesRegionId: // value for 'salesRegionId'
 *   },
 * });
 */
export function useAssignSalesRegionMutation(baseOptions?: Apollo.MutationHookOptions<AssignSalesRegionMutation, AssignSalesRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignSalesRegionMutation, AssignSalesRegionMutationVariables>(AssignSalesRegionDocument, options);
      }
export type AssignSalesRegionMutationHookResult = ReturnType<typeof useAssignSalesRegionMutation>;
export type AssignSalesRegionMutationResult = Apollo.MutationResult<AssignSalesRegionMutation>;
export type AssignSalesRegionMutationOptions = Apollo.BaseMutationOptions<AssignSalesRegionMutation, AssignSalesRegionMutationVariables>;
export const SellerCorrectionSalesDocument = gql`
    query SellerCorrectionSales($identifier: String!) {
  sellerCorrectionSales(identifier: $identifier) {
    ...SellerCorrectionSaleFields
  }
}
    ${SellerCorrectionSaleFieldsFragmentDoc}`;

/**
 * __useSellerCorrectionSalesQuery__
 *
 * To run a query within a React component, call `useSellerCorrectionSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerCorrectionSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerCorrectionSalesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useSellerCorrectionSalesQuery(baseOptions: Apollo.QueryHookOptions<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables> & ({ variables: SellerCorrectionSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>(SellerCorrectionSalesDocument, options);
      }
export function useSellerCorrectionSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>(SellerCorrectionSalesDocument, options);
        }
// @ts-ignore
export function useSellerCorrectionSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>): Apollo.UseSuspenseQueryResult<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>;
export function useSellerCorrectionSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>): Apollo.UseSuspenseQueryResult<SellerCorrectionSalesQuery | undefined, SellerCorrectionSalesQueryVariables>;
export function useSellerCorrectionSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>(SellerCorrectionSalesDocument, options);
        }
export type SellerCorrectionSalesQueryHookResult = ReturnType<typeof useSellerCorrectionSalesQuery>;
export type SellerCorrectionSalesLazyQueryHookResult = ReturnType<typeof useSellerCorrectionSalesLazyQuery>;
export type SellerCorrectionSalesSuspenseQueryHookResult = ReturnType<typeof useSellerCorrectionSalesSuspenseQuery>;
export type SellerCorrectionSalesQueryResult = Apollo.QueryResult<SellerCorrectionSalesQuery, SellerCorrectionSalesQueryVariables>;
export const SellerCorrectionAgentsDocument = gql`
    query SellerCorrectionAgents($search: String, $limit: Int) {
  sellerCorrectionAgents(search: $search, limit: $limit) {
    ...SellerCorrectionAgentFields
  }
}
    ${SellerCorrectionAgentFieldsFragmentDoc}`;

/**
 * __useSellerCorrectionAgentsQuery__
 *
 * To run a query within a React component, call `useSellerCorrectionAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerCorrectionAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerCorrectionAgentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSellerCorrectionAgentsQuery(baseOptions?: Apollo.QueryHookOptions<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>(SellerCorrectionAgentsDocument, options);
      }
export function useSellerCorrectionAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>(SellerCorrectionAgentsDocument, options);
        }
// @ts-ignore
export function useSellerCorrectionAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>;
export function useSellerCorrectionAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<SellerCorrectionAgentsQuery | undefined, SellerCorrectionAgentsQueryVariables>;
export function useSellerCorrectionAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>(SellerCorrectionAgentsDocument, options);
        }
export type SellerCorrectionAgentsQueryHookResult = ReturnType<typeof useSellerCorrectionAgentsQuery>;
export type SellerCorrectionAgentsLazyQueryHookResult = ReturnType<typeof useSellerCorrectionAgentsLazyQuery>;
export type SellerCorrectionAgentsSuspenseQueryHookResult = ReturnType<typeof useSellerCorrectionAgentsSuspenseQuery>;
export type SellerCorrectionAgentsQueryResult = Apollo.QueryResult<SellerCorrectionAgentsQuery, SellerCorrectionAgentsQueryVariables>;
export const PreviewSellerCorrectionUploadDocument = gql`
    query PreviewSellerCorrectionUpload($input: PreviewSellerCorrectionUploadInput!) {
  previewSellerCorrectionUpload(input: $input) {
    okCount
    problemCount
    rows {
      rowNumber
      accountNumber
      moveFrom
      moveTo
      verdict
      message
      sale {
        ...SellerCorrectionSaleFields
      }
      from {
        ...AgentNameMatchFields
      }
      to {
        ...AgentNameMatchFields
      }
    }
  }
}
    ${SellerCorrectionSaleFieldsFragmentDoc}
${AgentNameMatchFieldsFragmentDoc}`;

/**
 * __usePreviewSellerCorrectionUploadQuery__
 *
 * To run a query within a React component, call `usePreviewSellerCorrectionUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewSellerCorrectionUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewSellerCorrectionUploadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewSellerCorrectionUploadQuery(baseOptions: Apollo.QueryHookOptions<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables> & ({ variables: PreviewSellerCorrectionUploadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>(PreviewSellerCorrectionUploadDocument, options);
      }
export function usePreviewSellerCorrectionUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>(PreviewSellerCorrectionUploadDocument, options);
        }
// @ts-ignore
export function usePreviewSellerCorrectionUploadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>;
export function usePreviewSellerCorrectionUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewSellerCorrectionUploadQuery | undefined, PreviewSellerCorrectionUploadQueryVariables>;
export function usePreviewSellerCorrectionUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>(PreviewSellerCorrectionUploadDocument, options);
        }
export type PreviewSellerCorrectionUploadQueryHookResult = ReturnType<typeof usePreviewSellerCorrectionUploadQuery>;
export type PreviewSellerCorrectionUploadLazyQueryHookResult = ReturnType<typeof usePreviewSellerCorrectionUploadLazyQuery>;
export type PreviewSellerCorrectionUploadSuspenseQueryHookResult = ReturnType<typeof usePreviewSellerCorrectionUploadSuspenseQuery>;
export type PreviewSellerCorrectionUploadQueryResult = Apollo.QueryResult<PreviewSellerCorrectionUploadQuery, PreviewSellerCorrectionUploadQueryVariables>;
export const SellerCorrectionsDocument = gql`
    query SellerCorrections($input: SellerCorrectionListInput) {
  sellerCorrections(input: $input) {
    totalCount
    items {
      ...SellerCorrectionFields
    }
  }
}
    ${SellerCorrectionFieldsFragmentDoc}`;

/**
 * __useSellerCorrectionsQuery__
 *
 * To run a query within a React component, call `useSellerCorrectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellerCorrectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellerCorrectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSellerCorrectionsQuery(baseOptions?: Apollo.QueryHookOptions<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>(SellerCorrectionsDocument, options);
      }
export function useSellerCorrectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>(SellerCorrectionsDocument, options);
        }
// @ts-ignore
export function useSellerCorrectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>): Apollo.UseSuspenseQueryResult<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>;
export function useSellerCorrectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>): Apollo.UseSuspenseQueryResult<SellerCorrectionsQuery | undefined, SellerCorrectionsQueryVariables>;
export function useSellerCorrectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>(SellerCorrectionsDocument, options);
        }
export type SellerCorrectionsQueryHookResult = ReturnType<typeof useSellerCorrectionsQuery>;
export type SellerCorrectionsLazyQueryHookResult = ReturnType<typeof useSellerCorrectionsLazyQuery>;
export type SellerCorrectionsSuspenseQueryHookResult = ReturnType<typeof useSellerCorrectionsSuspenseQuery>;
export type SellerCorrectionsQueryResult = Apollo.QueryResult<SellerCorrectionsQuery, SellerCorrectionsQueryVariables>;
export const PaidToPreviousSellerDocument = gql`
    query PaidToPreviousSeller($input: SellerCorrectionListInput) {
  paidToPreviousSeller(input: $input) {
    totalCount
    items {
      ...SellerCorrectionFields
    }
  }
}
    ${SellerCorrectionFieldsFragmentDoc}`;

/**
 * __usePaidToPreviousSellerQuery__
 *
 * To run a query within a React component, call `usePaidToPreviousSellerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaidToPreviousSellerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaidToPreviousSellerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaidToPreviousSellerQuery(baseOptions?: Apollo.QueryHookOptions<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>(PaidToPreviousSellerDocument, options);
      }
export function usePaidToPreviousSellerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>(PaidToPreviousSellerDocument, options);
        }
// @ts-ignore
export function usePaidToPreviousSellerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>): Apollo.UseSuspenseQueryResult<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>;
export function usePaidToPreviousSellerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>): Apollo.UseSuspenseQueryResult<PaidToPreviousSellerQuery | undefined, PaidToPreviousSellerQueryVariables>;
export function usePaidToPreviousSellerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>(PaidToPreviousSellerDocument, options);
        }
export type PaidToPreviousSellerQueryHookResult = ReturnType<typeof usePaidToPreviousSellerQuery>;
export type PaidToPreviousSellerLazyQueryHookResult = ReturnType<typeof usePaidToPreviousSellerLazyQuery>;
export type PaidToPreviousSellerSuspenseQueryHookResult = ReturnType<typeof usePaidToPreviousSellerSuspenseQuery>;
export type PaidToPreviousSellerQueryResult = Apollo.QueryResult<PaidToPreviousSellerQuery, PaidToPreviousSellerQueryVariables>;
export const ApplySellerCorrectionsDocument = gql`
    mutation ApplySellerCorrections($input: ApplySellerCorrectionsInput!) {
  applySellerCorrections(input: $input) {
    appliedCount
    skippedCount
    rows {
      stockSaleId
      saleReference
      outcome
      skipReason
      message
      correctionId
      movedEntryCount
      paidEntryCount
      paidAmountCents
      cancelledEntryCount
      cancelledAmountCents
    }
  }
}
    `;
export type ApplySellerCorrectionsMutationFn = Apollo.MutationFunction<ApplySellerCorrectionsMutation, ApplySellerCorrectionsMutationVariables>;

/**
 * __useApplySellerCorrectionsMutation__
 *
 * To run a mutation, you first call `useApplySellerCorrectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplySellerCorrectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applySellerCorrectionsMutation, { data, loading, error }] = useApplySellerCorrectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplySellerCorrectionsMutation(baseOptions?: Apollo.MutationHookOptions<ApplySellerCorrectionsMutation, ApplySellerCorrectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplySellerCorrectionsMutation, ApplySellerCorrectionsMutationVariables>(ApplySellerCorrectionsDocument, options);
      }
export type ApplySellerCorrectionsMutationHookResult = ReturnType<typeof useApplySellerCorrectionsMutation>;
export type ApplySellerCorrectionsMutationResult = Apollo.MutationResult<ApplySellerCorrectionsMutation>;
export type ApplySellerCorrectionsMutationOptions = Apollo.BaseMutationOptions<ApplySellerCorrectionsMutation, ApplySellerCorrectionsMutationVariables>;
export const GetOrganizationDocument = gql`
    query GetOrganization {
  organization {
    id
    name
    logoUrl
    logoBackground
    currency
    requireConfirmPassword
    requireAgentInviteApproval
    googleAnalyticsId
    legalName
    registrationNumber
    legalAddress
    contactPhone
    contactEmail
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
// @ts-ignore
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationQuery | undefined, GetOrganizationQueryVariables>;
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    id
    name
    logoBackground
    currency
    requireConfirmPassword
    requireAgentInviteApproval
    googleAnalyticsId
    legalName
    registrationNumber
    legalAddress
    contactPhone
    contactEmail
    updatedAt
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const GetAuditLogsDocument = gql`
    query GetAuditLogs($limit: Int, $offset: Int, $category: String, $searchTerm: String) {
  auditLogs(
    limit: $limit
    offset: $offset
    category: $category
    searchTerm: $searchTerm
  ) {
    items {
      id
      action
      category
      status
      description
      entityType
      entityId
      changes
      metadata
      errorMessage
      ipAddress
      userAgent
      createdAt
      user {
        id
        email
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      category: // value for 'category'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetAuditLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
      }
export function useGetAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
        }
// @ts-ignore
export function useGetAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export function useGetAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuditLogsQuery | undefined, GetAuditLogsQueryVariables>;
export function useGetAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
        }
export type GetAuditLogsQueryHookResult = ReturnType<typeof useGetAuditLogsQuery>;
export type GetAuditLogsLazyQueryHookResult = ReturnType<typeof useGetAuditLogsLazyQuery>;
export type GetAuditLogsSuspenseQueryHookResult = ReturnType<typeof useGetAuditLogsSuspenseQuery>;
export type GetAuditLogsQueryResult = Apollo.QueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const RefreshShipmentDocument = gql`
    mutation RefreshShipment($id: String!) {
  refreshShipment(id: $id) {
    ...ShipmentFields
    purchaseOrder {
      id
      status
    }
    stockTransfer {
      id
      status
      dispatchedAt
      dispatchedByCourier
    }
  }
}
    ${ShipmentFieldsFragmentDoc}`;
export type RefreshShipmentMutationFn = Apollo.MutationFunction<RefreshShipmentMutation, RefreshShipmentMutationVariables>;

/**
 * __useRefreshShipmentMutation__
 *
 * To run a mutation, you first call `useRefreshShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshShipmentMutation, { data, loading, error }] = useRefreshShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshShipmentMutation(baseOptions?: Apollo.MutationHookOptions<RefreshShipmentMutation, RefreshShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshShipmentMutation, RefreshShipmentMutationVariables>(RefreshShipmentDocument, options);
      }
export type RefreshShipmentMutationHookResult = ReturnType<typeof useRefreshShipmentMutation>;
export type RefreshShipmentMutationResult = Apollo.MutationResult<RefreshShipmentMutation>;
export type RefreshShipmentMutationOptions = Apollo.BaseMutationOptions<RefreshShipmentMutation, RefreshShipmentMutationVariables>;
export const GetCourierImportsDocument = gql`
    query GetCourierImports($limit: Int) {
  courierImports(limit: $limit) {
    id
    createdAt
    kind
    fileName
    rowsRead
    rowsImported
    invoiceNumber
    notFoundWaybills
    importedBy
  }
}
    `;

/**
 * __useGetCourierImportsQuery__
 *
 * To run a query within a React component, call `useGetCourierImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierImportsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCourierImportsQuery(baseOptions?: Apollo.QueryHookOptions<GetCourierImportsQuery, GetCourierImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierImportsQuery, GetCourierImportsQueryVariables>(GetCourierImportsDocument, options);
      }
export function useGetCourierImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierImportsQuery, GetCourierImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierImportsQuery, GetCourierImportsQueryVariables>(GetCourierImportsDocument, options);
        }
// @ts-ignore
export function useGetCourierImportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourierImportsQuery, GetCourierImportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourierImportsQuery, GetCourierImportsQueryVariables>;
export function useGetCourierImportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourierImportsQuery, GetCourierImportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourierImportsQuery | undefined, GetCourierImportsQueryVariables>;
export function useGetCourierImportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourierImportsQuery, GetCourierImportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourierImportsQuery, GetCourierImportsQueryVariables>(GetCourierImportsDocument, options);
        }
export type GetCourierImportsQueryHookResult = ReturnType<typeof useGetCourierImportsQuery>;
export type GetCourierImportsLazyQueryHookResult = ReturnType<typeof useGetCourierImportsLazyQuery>;
export type GetCourierImportsSuspenseQueryHookResult = ReturnType<typeof useGetCourierImportsSuspenseQuery>;
export type GetCourierImportsQueryResult = Apollo.QueryResult<GetCourierImportsQuery, GetCourierImportsQueryVariables>;
export const GetShippingCompaniesDocument = gql`
    query GetShippingCompanies($input: ShippingCompanyListInput) {
  shippingCompanies(input: $input) {
    items {
      id
      name
      contactPerson
      email
      phone
      trackingUrlTemplate
      courier
      isActive
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetShippingCompaniesQuery__
 *
 * To run a query within a React component, call `useGetShippingCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingCompaniesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetShippingCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>(GetShippingCompaniesDocument, options);
      }
export function useGetShippingCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>(GetShippingCompaniesDocument, options);
        }
// @ts-ignore
export function useGetShippingCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>;
export function useGetShippingCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetShippingCompaniesQuery | undefined, GetShippingCompaniesQueryVariables>;
export function useGetShippingCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>(GetShippingCompaniesDocument, options);
        }
export type GetShippingCompaniesQueryHookResult = ReturnType<typeof useGetShippingCompaniesQuery>;
export type GetShippingCompaniesLazyQueryHookResult = ReturnType<typeof useGetShippingCompaniesLazyQuery>;
export type GetShippingCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetShippingCompaniesSuspenseQuery>;
export type GetShippingCompaniesQueryResult = Apollo.QueryResult<GetShippingCompaniesQuery, GetShippingCompaniesQueryVariables>;
export const GetShippingCompanyDocument = gql`
    query GetShippingCompany($id: String!) {
  shippingCompany(id: $id) {
    id
    name
    contactPerson
    email
    phone
    trackingUrlTemplate
    courier
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetShippingCompanyQuery__
 *
 * To run a query within a React component, call `useGetShippingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShippingCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetShippingCompanyQuery, GetShippingCompanyQueryVariables> & ({ variables: GetShippingCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>(GetShippingCompanyDocument, options);
      }
export function useGetShippingCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>(GetShippingCompanyDocument, options);
        }
// @ts-ignore
export function useGetShippingCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>;
export function useGetShippingCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetShippingCompanyQuery | undefined, GetShippingCompanyQueryVariables>;
export function useGetShippingCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>(GetShippingCompanyDocument, options);
        }
export type GetShippingCompanyQueryHookResult = ReturnType<typeof useGetShippingCompanyQuery>;
export type GetShippingCompanyLazyQueryHookResult = ReturnType<typeof useGetShippingCompanyLazyQuery>;
export type GetShippingCompanySuspenseQueryHookResult = ReturnType<typeof useGetShippingCompanySuspenseQuery>;
export type GetShippingCompanyQueryResult = Apollo.QueryResult<GetShippingCompanyQuery, GetShippingCompanyQueryVariables>;
export const CreateShippingCompanyDocument = gql`
    mutation CreateShippingCompany($input: CreateShippingCompanyInput!) {
  createShippingCompany(input: $input) {
    id
    name
  }
}
    `;
export type CreateShippingCompanyMutationFn = Apollo.MutationFunction<CreateShippingCompanyMutation, CreateShippingCompanyMutationVariables>;

/**
 * __useCreateShippingCompanyMutation__
 *
 * To run a mutation, you first call `useCreateShippingCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShippingCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShippingCompanyMutation, { data, loading, error }] = useCreateShippingCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShippingCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateShippingCompanyMutation, CreateShippingCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShippingCompanyMutation, CreateShippingCompanyMutationVariables>(CreateShippingCompanyDocument, options);
      }
export type CreateShippingCompanyMutationHookResult = ReturnType<typeof useCreateShippingCompanyMutation>;
export type CreateShippingCompanyMutationResult = Apollo.MutationResult<CreateShippingCompanyMutation>;
export type CreateShippingCompanyMutationOptions = Apollo.BaseMutationOptions<CreateShippingCompanyMutation, CreateShippingCompanyMutationVariables>;
export const UpdateShippingCompanyDocument = gql`
    mutation UpdateShippingCompany($id: String!, $input: UpdateShippingCompanyInput!) {
  updateShippingCompany(id: $id, input: $input) {
    id
    name
    isActive
  }
}
    `;
export type UpdateShippingCompanyMutationFn = Apollo.MutationFunction<UpdateShippingCompanyMutation, UpdateShippingCompanyMutationVariables>;

/**
 * __useUpdateShippingCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateShippingCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingCompanyMutation, { data, loading, error }] = useUpdateShippingCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShippingCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingCompanyMutation, UpdateShippingCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingCompanyMutation, UpdateShippingCompanyMutationVariables>(UpdateShippingCompanyDocument, options);
      }
export type UpdateShippingCompanyMutationHookResult = ReturnType<typeof useUpdateShippingCompanyMutation>;
export type UpdateShippingCompanyMutationResult = Apollo.MutationResult<UpdateShippingCompanyMutation>;
export type UpdateShippingCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateShippingCompanyMutation, UpdateShippingCompanyMutationVariables>;
export const GetSmsCampaignsDocument = gql`
    query GetSmsCampaigns($limit: Int, $offset: Int) {
  smsCampaigns(limit: $limit, offset: $offset) {
    totalCount
    items {
      ...SmsCampaignFields
    }
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;

/**
 * __useGetSmsCampaignsQuery__
 *
 * To run a query within a React component, call `useGetSmsCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsCampaignsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSmsCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>(GetSmsCampaignsDocument, options);
      }
export function useGetSmsCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>(GetSmsCampaignsDocument, options);
        }
// @ts-ignore
export function useGetSmsCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>;
export function useGetSmsCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignsQuery | undefined, GetSmsCampaignsQueryVariables>;
export function useGetSmsCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>(GetSmsCampaignsDocument, options);
        }
export type GetSmsCampaignsQueryHookResult = ReturnType<typeof useGetSmsCampaignsQuery>;
export type GetSmsCampaignsLazyQueryHookResult = ReturnType<typeof useGetSmsCampaignsLazyQuery>;
export type GetSmsCampaignsSuspenseQueryHookResult = ReturnType<typeof useGetSmsCampaignsSuspenseQuery>;
export type GetSmsCampaignsQueryResult = Apollo.QueryResult<GetSmsCampaignsQuery, GetSmsCampaignsQueryVariables>;
export const GetSmsCampaignDocument = gql`
    query GetSmsCampaign($id: ID!) {
  smsCampaign(id: $id) {
    ...SmsCampaignFields
    batches {
      number
      recipients
      creditBalance
      sent
      failed
      skipped
      pending
      credits
      approvedByName
      createdAt
      completedAt
    }
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;

/**
 * __useGetSmsCampaignQuery__
 *
 * To run a query within a React component, call `useGetSmsCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSmsCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetSmsCampaignQuery, GetSmsCampaignQueryVariables> & ({ variables: GetSmsCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>(GetSmsCampaignDocument, options);
      }
export function useGetSmsCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>(GetSmsCampaignDocument, options);
        }
// @ts-ignore
export function useGetSmsCampaignSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>;
export function useGetSmsCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignQuery | undefined, GetSmsCampaignQueryVariables>;
export function useGetSmsCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>(GetSmsCampaignDocument, options);
        }
export type GetSmsCampaignQueryHookResult = ReturnType<typeof useGetSmsCampaignQuery>;
export type GetSmsCampaignLazyQueryHookResult = ReturnType<typeof useGetSmsCampaignLazyQuery>;
export type GetSmsCampaignSuspenseQueryHookResult = ReturnType<typeof useGetSmsCampaignSuspenseQuery>;
export type GetSmsCampaignQueryResult = Apollo.QueryResult<GetSmsCampaignQuery, GetSmsCampaignQueryVariables>;
export const GetSmsCampaignRecipientsDocument = gql`
    query GetSmsCampaignRecipients($campaignId: ID!, $status: SmsCampaignRecipientStatus, $limit: Int, $offset: Int) {
  smsCampaignRecipients(
    campaignId: $campaignId
    status: $status
    limit: $limit
    offset: $offset
  ) {
    totalCount
    items {
      id
      source
      customerId
      contractNumber
      name
      phone
      message
      parts
      status
      skipReason
      attempts
      error
      sentAt
      deliveryState
      deliveryStateAt
    }
  }
}
    `;

/**
 * __useGetSmsCampaignRecipientsQuery__
 *
 * To run a query within a React component, call `useGetSmsCampaignRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsCampaignRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsCampaignRecipientsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSmsCampaignRecipientsQuery(baseOptions: Apollo.QueryHookOptions<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables> & ({ variables: GetSmsCampaignRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>(GetSmsCampaignRecipientsDocument, options);
      }
export function useGetSmsCampaignRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>(GetSmsCampaignRecipientsDocument, options);
        }
// @ts-ignore
export function useGetSmsCampaignRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>;
export function useGetSmsCampaignRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignRecipientsQuery | undefined, GetSmsCampaignRecipientsQueryVariables>;
export function useGetSmsCampaignRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>(GetSmsCampaignRecipientsDocument, options);
        }
export type GetSmsCampaignRecipientsQueryHookResult = ReturnType<typeof useGetSmsCampaignRecipientsQuery>;
export type GetSmsCampaignRecipientsLazyQueryHookResult = ReturnType<typeof useGetSmsCampaignRecipientsLazyQuery>;
export type GetSmsCampaignRecipientsSuspenseQueryHookResult = ReturnType<typeof useGetSmsCampaignRecipientsSuspenseQuery>;
export type GetSmsCampaignRecipientsQueryResult = Apollo.QueryResult<GetSmsCampaignRecipientsQuery, GetSmsCampaignRecipientsQueryVariables>;
export const GetSmsCampaignRecipientsCsvDocument = gql`
    query GetSmsCampaignRecipientsCsv($campaignId: ID!) {
  smsCampaignRecipientsCsv(campaignId: $campaignId)
}
    `;

/**
 * __useGetSmsCampaignRecipientsCsvQuery__
 *
 * To run a query within a React component, call `useGetSmsCampaignRecipientsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsCampaignRecipientsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsCampaignRecipientsCsvQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetSmsCampaignRecipientsCsvQuery(baseOptions: Apollo.QueryHookOptions<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables> & ({ variables: GetSmsCampaignRecipientsCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>(GetSmsCampaignRecipientsCsvDocument, options);
      }
export function useGetSmsCampaignRecipientsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>(GetSmsCampaignRecipientsCsvDocument, options);
        }
// @ts-ignore
export function useGetSmsCampaignRecipientsCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>;
export function useGetSmsCampaignRecipientsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignRecipientsCsvQuery | undefined, GetSmsCampaignRecipientsCsvQueryVariables>;
export function useGetSmsCampaignRecipientsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>(GetSmsCampaignRecipientsCsvDocument, options);
        }
export type GetSmsCampaignRecipientsCsvQueryHookResult = ReturnType<typeof useGetSmsCampaignRecipientsCsvQuery>;
export type GetSmsCampaignRecipientsCsvLazyQueryHookResult = ReturnType<typeof useGetSmsCampaignRecipientsCsvLazyQuery>;
export type GetSmsCampaignRecipientsCsvSuspenseQueryHookResult = ReturnType<typeof useGetSmsCampaignRecipientsCsvSuspenseQuery>;
export type GetSmsCampaignRecipientsCsvQueryResult = Apollo.QueryResult<GetSmsCampaignRecipientsCsvQuery, GetSmsCampaignRecipientsCsvQueryVariables>;
export const GetSmsCampaignPreviewDocument = gql`
    query GetSmsCampaignPreview($body: String!, $audience: SmsCampaignAudienceInput!) {
  smsCampaignPreview(body: $body, audience: $audience) {
    recipients
    skipped {
      reason
      count
    }
    duplicates
    creditsNeeded
    maxParts
    samples
    creditBalance
  }
}
    `;

/**
 * __useGetSmsCampaignPreviewQuery__
 *
 * To run a query within a React component, call `useGetSmsCampaignPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsCampaignPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsCampaignPreviewQuery({
 *   variables: {
 *      body: // value for 'body'
 *      audience: // value for 'audience'
 *   },
 * });
 */
export function useGetSmsCampaignPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables> & ({ variables: GetSmsCampaignPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>(GetSmsCampaignPreviewDocument, options);
      }
export function useGetSmsCampaignPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>(GetSmsCampaignPreviewDocument, options);
        }
// @ts-ignore
export function useGetSmsCampaignPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>;
export function useGetSmsCampaignPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignPreviewQuery | undefined, GetSmsCampaignPreviewQueryVariables>;
export function useGetSmsCampaignPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>(GetSmsCampaignPreviewDocument, options);
        }
export type GetSmsCampaignPreviewQueryHookResult = ReturnType<typeof useGetSmsCampaignPreviewQuery>;
export type GetSmsCampaignPreviewLazyQueryHookResult = ReturnType<typeof useGetSmsCampaignPreviewLazyQuery>;
export type GetSmsCampaignPreviewSuspenseQueryHookResult = ReturnType<typeof useGetSmsCampaignPreviewSuspenseQuery>;
export type GetSmsCampaignPreviewQueryResult = Apollo.QueryResult<GetSmsCampaignPreviewQuery, GetSmsCampaignPreviewQueryVariables>;
export const GetSmsCampaignMessageSizeDocument = gql`
    query GetSmsCampaignMessageSize($body: String!, $firstName: String) {
  smsCampaignMessageSize(body: $body, firstName: $firstName) {
    text
    encoding
    characters
    parts
  }
}
    `;

/**
 * __useGetSmsCampaignMessageSizeQuery__
 *
 * To run a query within a React component, call `useGetSmsCampaignMessageSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsCampaignMessageSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsCampaignMessageSizeQuery({
 *   variables: {
 *      body: // value for 'body'
 *      firstName: // value for 'firstName'
 *   },
 * });
 */
export function useGetSmsCampaignMessageSizeQuery(baseOptions: Apollo.QueryHookOptions<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables> & ({ variables: GetSmsCampaignMessageSizeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>(GetSmsCampaignMessageSizeDocument, options);
      }
export function useGetSmsCampaignMessageSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>(GetSmsCampaignMessageSizeDocument, options);
        }
// @ts-ignore
export function useGetSmsCampaignMessageSizeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>;
export function useGetSmsCampaignMessageSizeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCampaignMessageSizeQuery | undefined, GetSmsCampaignMessageSizeQueryVariables>;
export function useGetSmsCampaignMessageSizeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>(GetSmsCampaignMessageSizeDocument, options);
        }
export type GetSmsCampaignMessageSizeQueryHookResult = ReturnType<typeof useGetSmsCampaignMessageSizeQuery>;
export type GetSmsCampaignMessageSizeLazyQueryHookResult = ReturnType<typeof useGetSmsCampaignMessageSizeLazyQuery>;
export type GetSmsCampaignMessageSizeSuspenseQueryHookResult = ReturnType<typeof useGetSmsCampaignMessageSizeSuspenseQuery>;
export type GetSmsCampaignMessageSizeQueryResult = Apollo.QueryResult<GetSmsCampaignMessageSizeQuery, GetSmsCampaignMessageSizeQueryVariables>;
export const GetSmsOptOutsDocument = gql`
    query GetSmsOptOuts($search: String, $limit: Int, $offset: Int) {
  smsOptOuts(search: $search, limit: $limit, offset: $offset) {
    totalCount
    items {
      id
      phone
      source
      customerId
      createdAt
    }
  }
}
    `;

/**
 * __useGetSmsOptOutsQuery__
 *
 * To run a query within a React component, call `useGetSmsOptOutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsOptOutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsOptOutsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSmsOptOutsQuery(baseOptions?: Apollo.QueryHookOptions<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>(GetSmsOptOutsDocument, options);
      }
export function useGetSmsOptOutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>(GetSmsOptOutsDocument, options);
        }
// @ts-ignore
export function useGetSmsOptOutsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>;
export function useGetSmsOptOutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsOptOutsQuery | undefined, GetSmsOptOutsQueryVariables>;
export function useGetSmsOptOutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>(GetSmsOptOutsDocument, options);
        }
export type GetSmsOptOutsQueryHookResult = ReturnType<typeof useGetSmsOptOutsQuery>;
export type GetSmsOptOutsLazyQueryHookResult = ReturnType<typeof useGetSmsOptOutsLazyQuery>;
export type GetSmsOptOutsSuspenseQueryHookResult = ReturnType<typeof useGetSmsOptOutsSuspenseQuery>;
export type GetSmsOptOutsQueryResult = Apollo.QueryResult<GetSmsOptOutsQuery, GetSmsOptOutsQueryVariables>;
export const SearchSmsCampaignContractsDocument = gql`
    query SearchSmsCampaignContracts($search: String!) {
  contracts(input: {search: $search, limit: 10}) {
    items {
      id
      contractNumber
      status
      customer {
        id
        fullName
        phone
      }
    }
  }
}
    `;

/**
 * __useSearchSmsCampaignContractsQuery__
 *
 * To run a query within a React component, call `useSearchSmsCampaignContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSmsCampaignContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSmsCampaignContractsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchSmsCampaignContractsQuery(baseOptions: Apollo.QueryHookOptions<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables> & ({ variables: SearchSmsCampaignContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>(SearchSmsCampaignContractsDocument, options);
      }
export function useSearchSmsCampaignContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>(SearchSmsCampaignContractsDocument, options);
        }
// @ts-ignore
export function useSearchSmsCampaignContractsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>;
export function useSearchSmsCampaignContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchSmsCampaignContractsQuery | undefined, SearchSmsCampaignContractsQueryVariables>;
export function useSearchSmsCampaignContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>(SearchSmsCampaignContractsDocument, options);
        }
export type SearchSmsCampaignContractsQueryHookResult = ReturnType<typeof useSearchSmsCampaignContractsQuery>;
export type SearchSmsCampaignContractsLazyQueryHookResult = ReturnType<typeof useSearchSmsCampaignContractsLazyQuery>;
export type SearchSmsCampaignContractsSuspenseQueryHookResult = ReturnType<typeof useSearchSmsCampaignContractsSuspenseQuery>;
export type SearchSmsCampaignContractsQueryResult = Apollo.QueryResult<SearchSmsCampaignContractsQuery, SearchSmsCampaignContractsQueryVariables>;
export const CreateSmsCampaignDocument = gql`
    mutation CreateSmsCampaign($input: SmsCampaignDraftInput!) {
  createSmsCampaign(input: $input) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type CreateSmsCampaignMutationFn = Apollo.MutationFunction<CreateSmsCampaignMutation, CreateSmsCampaignMutationVariables>;

/**
 * __useCreateSmsCampaignMutation__
 *
 * To run a mutation, you first call `useCreateSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSmsCampaignMutation, { data, loading, error }] = useCreateSmsCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateSmsCampaignMutation, CreateSmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSmsCampaignMutation, CreateSmsCampaignMutationVariables>(CreateSmsCampaignDocument, options);
      }
export type CreateSmsCampaignMutationHookResult = ReturnType<typeof useCreateSmsCampaignMutation>;
export type CreateSmsCampaignMutationResult = Apollo.MutationResult<CreateSmsCampaignMutation>;
export type CreateSmsCampaignMutationOptions = Apollo.BaseMutationOptions<CreateSmsCampaignMutation, CreateSmsCampaignMutationVariables>;
export const UpdateSmsCampaignDocument = gql`
    mutation UpdateSmsCampaign($id: ID!, $input: SmsCampaignDraftInput!) {
  updateSmsCampaign(id: $id, input: $input) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type UpdateSmsCampaignMutationFn = Apollo.MutationFunction<UpdateSmsCampaignMutation, UpdateSmsCampaignMutationVariables>;

/**
 * __useUpdateSmsCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSmsCampaignMutation, { data, loading, error }] = useUpdateSmsCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSmsCampaignMutation, UpdateSmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSmsCampaignMutation, UpdateSmsCampaignMutationVariables>(UpdateSmsCampaignDocument, options);
      }
export type UpdateSmsCampaignMutationHookResult = ReturnType<typeof useUpdateSmsCampaignMutation>;
export type UpdateSmsCampaignMutationResult = Apollo.MutationResult<UpdateSmsCampaignMutation>;
export type UpdateSmsCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateSmsCampaignMutation, UpdateSmsCampaignMutationVariables>;
export const DeleteSmsCampaignDocument = gql`
    mutation DeleteSmsCampaign($id: ID!) {
  deleteSmsCampaign(id: $id)
}
    `;
export type DeleteSmsCampaignMutationFn = Apollo.MutationFunction<DeleteSmsCampaignMutation, DeleteSmsCampaignMutationVariables>;

/**
 * __useDeleteSmsCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSmsCampaignMutation, { data, loading, error }] = useDeleteSmsCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSmsCampaignMutation, DeleteSmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSmsCampaignMutation, DeleteSmsCampaignMutationVariables>(DeleteSmsCampaignDocument, options);
      }
export type DeleteSmsCampaignMutationHookResult = ReturnType<typeof useDeleteSmsCampaignMutation>;
export type DeleteSmsCampaignMutationResult = Apollo.MutationResult<DeleteSmsCampaignMutation>;
export type DeleteSmsCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteSmsCampaignMutation, DeleteSmsCampaignMutationVariables>;
export const CopySmsCampaignDocument = gql`
    mutation CopySmsCampaign($id: ID!) {
  copySmsCampaign(id: $id) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type CopySmsCampaignMutationFn = Apollo.MutationFunction<CopySmsCampaignMutation, CopySmsCampaignMutationVariables>;

/**
 * __useCopySmsCampaignMutation__
 *
 * To run a mutation, you first call `useCopySmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopySmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copySmsCampaignMutation, { data, loading, error }] = useCopySmsCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCopySmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CopySmsCampaignMutation, CopySmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopySmsCampaignMutation, CopySmsCampaignMutationVariables>(CopySmsCampaignDocument, options);
      }
export type CopySmsCampaignMutationHookResult = ReturnType<typeof useCopySmsCampaignMutation>;
export type CopySmsCampaignMutationResult = Apollo.MutationResult<CopySmsCampaignMutation>;
export type CopySmsCampaignMutationOptions = Apollo.BaseMutationOptions<CopySmsCampaignMutation, CopySmsCampaignMutationVariables>;
export const SendSmsCampaignTestDocument = gql`
    mutation SendSmsCampaignTest($body: String!, $phone: String!) {
  sendSmsCampaignTest(body: $body, phone: $phone)
}
    `;
export type SendSmsCampaignTestMutationFn = Apollo.MutationFunction<SendSmsCampaignTestMutation, SendSmsCampaignTestMutationVariables>;

/**
 * __useSendSmsCampaignTestMutation__
 *
 * To run a mutation, you first call `useSendSmsCampaignTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsCampaignTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsCampaignTestMutation, { data, loading, error }] = useSendSmsCampaignTestMutation({
 *   variables: {
 *      body: // value for 'body'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useSendSmsCampaignTestMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsCampaignTestMutation, SendSmsCampaignTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsCampaignTestMutation, SendSmsCampaignTestMutationVariables>(SendSmsCampaignTestDocument, options);
      }
export type SendSmsCampaignTestMutationHookResult = ReturnType<typeof useSendSmsCampaignTestMutation>;
export type SendSmsCampaignTestMutationResult = Apollo.MutationResult<SendSmsCampaignTestMutation>;
export type SendSmsCampaignTestMutationOptions = Apollo.BaseMutationOptions<SendSmsCampaignTestMutation, SendSmsCampaignTestMutationVariables>;
export const SendSmsCampaignDocument = gql`
    mutation SendSmsCampaign($id: ID!, $input: SendSmsCampaignInput!) {
  sendSmsCampaign(id: $id, input: $input) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type SendSmsCampaignMutationFn = Apollo.MutationFunction<SendSmsCampaignMutation, SendSmsCampaignMutationVariables>;

/**
 * __useSendSmsCampaignMutation__
 *
 * To run a mutation, you first call `useSendSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsCampaignMutation, { data, loading, error }] = useSendSmsCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsCampaignMutation, SendSmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsCampaignMutation, SendSmsCampaignMutationVariables>(SendSmsCampaignDocument, options);
      }
export type SendSmsCampaignMutationHookResult = ReturnType<typeof useSendSmsCampaignMutation>;
export type SendSmsCampaignMutationResult = Apollo.MutationResult<SendSmsCampaignMutation>;
export type SendSmsCampaignMutationOptions = Apollo.BaseMutationOptions<SendSmsCampaignMutation, SendSmsCampaignMutationVariables>;
export const StopSmsCampaignDocument = gql`
    mutation StopSmsCampaign($id: ID!) {
  stopSmsCampaign(id: $id) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type StopSmsCampaignMutationFn = Apollo.MutationFunction<StopSmsCampaignMutation, StopSmsCampaignMutationVariables>;

/**
 * __useStopSmsCampaignMutation__
 *
 * To run a mutation, you first call `useStopSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSmsCampaignMutation, { data, loading, error }] = useStopSmsCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<StopSmsCampaignMutation, StopSmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopSmsCampaignMutation, StopSmsCampaignMutationVariables>(StopSmsCampaignDocument, options);
      }
export type StopSmsCampaignMutationHookResult = ReturnType<typeof useStopSmsCampaignMutation>;
export type StopSmsCampaignMutationResult = Apollo.MutationResult<StopSmsCampaignMutation>;
export type StopSmsCampaignMutationOptions = Apollo.BaseMutationOptions<StopSmsCampaignMutation, StopSmsCampaignMutationVariables>;
export const ApproveNextSmsCampaignBatchDocument = gql`
    mutation ApproveNextSmsCampaignBatch($id: ID!) {
  approveNextSmsCampaignBatch(id: $id) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type ApproveNextSmsCampaignBatchMutationFn = Apollo.MutationFunction<ApproveNextSmsCampaignBatchMutation, ApproveNextSmsCampaignBatchMutationVariables>;

/**
 * __useApproveNextSmsCampaignBatchMutation__
 *
 * To run a mutation, you first call `useApproveNextSmsCampaignBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveNextSmsCampaignBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveNextSmsCampaignBatchMutation, { data, loading, error }] = useApproveNextSmsCampaignBatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveNextSmsCampaignBatchMutation(baseOptions?: Apollo.MutationHookOptions<ApproveNextSmsCampaignBatchMutation, ApproveNextSmsCampaignBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveNextSmsCampaignBatchMutation, ApproveNextSmsCampaignBatchMutationVariables>(ApproveNextSmsCampaignBatchDocument, options);
      }
export type ApproveNextSmsCampaignBatchMutationHookResult = ReturnType<typeof useApproveNextSmsCampaignBatchMutation>;
export type ApproveNextSmsCampaignBatchMutationResult = Apollo.MutationResult<ApproveNextSmsCampaignBatchMutation>;
export type ApproveNextSmsCampaignBatchMutationOptions = Apollo.BaseMutationOptions<ApproveNextSmsCampaignBatchMutation, ApproveNextSmsCampaignBatchMutationVariables>;
export const ResumeSmsCampaignDocument = gql`
    mutation ResumeSmsCampaign($id: ID!) {
  resumeSmsCampaign(id: $id) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type ResumeSmsCampaignMutationFn = Apollo.MutationFunction<ResumeSmsCampaignMutation, ResumeSmsCampaignMutationVariables>;

/**
 * __useResumeSmsCampaignMutation__
 *
 * To run a mutation, you first call `useResumeSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSmsCampaignMutation, { data, loading, error }] = useResumeSmsCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResumeSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSmsCampaignMutation, ResumeSmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeSmsCampaignMutation, ResumeSmsCampaignMutationVariables>(ResumeSmsCampaignDocument, options);
      }
export type ResumeSmsCampaignMutationHookResult = ReturnType<typeof useResumeSmsCampaignMutation>;
export type ResumeSmsCampaignMutationResult = Apollo.MutationResult<ResumeSmsCampaignMutation>;
export type ResumeSmsCampaignMutationOptions = Apollo.BaseMutationOptions<ResumeSmsCampaignMutation, ResumeSmsCampaignMutationVariables>;
export const CancelSmsCampaignDocument = gql`
    mutation CancelSmsCampaign($id: ID!) {
  cancelSmsCampaign(id: $id) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type CancelSmsCampaignMutationFn = Apollo.MutationFunction<CancelSmsCampaignMutation, CancelSmsCampaignMutationVariables>;

/**
 * __useCancelSmsCampaignMutation__
 *
 * To run a mutation, you first call `useCancelSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSmsCampaignMutation, { data, loading, error }] = useCancelSmsCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CancelSmsCampaignMutation, CancelSmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSmsCampaignMutation, CancelSmsCampaignMutationVariables>(CancelSmsCampaignDocument, options);
      }
export type CancelSmsCampaignMutationHookResult = ReturnType<typeof useCancelSmsCampaignMutation>;
export type CancelSmsCampaignMutationResult = Apollo.MutationResult<CancelSmsCampaignMutation>;
export type CancelSmsCampaignMutationOptions = Apollo.BaseMutationOptions<CancelSmsCampaignMutation, CancelSmsCampaignMutationVariables>;
export const ResendFailedSmsCampaignDocument = gql`
    mutation ResendFailedSmsCampaign($id: ID!) {
  resendFailedSmsCampaign(id: $id) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export type ResendFailedSmsCampaignMutationFn = Apollo.MutationFunction<ResendFailedSmsCampaignMutation, ResendFailedSmsCampaignMutationVariables>;

/**
 * __useResendFailedSmsCampaignMutation__
 *
 * To run a mutation, you first call `useResendFailedSmsCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendFailedSmsCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendFailedSmsCampaignMutation, { data, loading, error }] = useResendFailedSmsCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendFailedSmsCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ResendFailedSmsCampaignMutation, ResendFailedSmsCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendFailedSmsCampaignMutation, ResendFailedSmsCampaignMutationVariables>(ResendFailedSmsCampaignDocument, options);
      }
export type ResendFailedSmsCampaignMutationHookResult = ReturnType<typeof useResendFailedSmsCampaignMutation>;
export type ResendFailedSmsCampaignMutationResult = Apollo.MutationResult<ResendFailedSmsCampaignMutation>;
export type ResendFailedSmsCampaignMutationOptions = Apollo.BaseMutationOptions<ResendFailedSmsCampaignMutation, ResendFailedSmsCampaignMutationVariables>;
export const AddSmsOptOutDocument = gql`
    mutation AddSmsOptOut($phone: String!) {
  addSmsOptOut(phone: $phone) {
    id
  }
}
    `;
export type AddSmsOptOutMutationFn = Apollo.MutationFunction<AddSmsOptOutMutation, AddSmsOptOutMutationVariables>;

/**
 * __useAddSmsOptOutMutation__
 *
 * To run a mutation, you first call `useAddSmsOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSmsOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSmsOptOutMutation, { data, loading, error }] = useAddSmsOptOutMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useAddSmsOptOutMutation(baseOptions?: Apollo.MutationHookOptions<AddSmsOptOutMutation, AddSmsOptOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSmsOptOutMutation, AddSmsOptOutMutationVariables>(AddSmsOptOutDocument, options);
      }
export type AddSmsOptOutMutationHookResult = ReturnType<typeof useAddSmsOptOutMutation>;
export type AddSmsOptOutMutationResult = Apollo.MutationResult<AddSmsOptOutMutation>;
export type AddSmsOptOutMutationOptions = Apollo.BaseMutationOptions<AddSmsOptOutMutation, AddSmsOptOutMutationVariables>;
export const RemoveSmsOptOutDocument = gql`
    mutation RemoveSmsOptOut($id: ID!, $reason: String!) {
  removeSmsOptOut(id: $id, reason: $reason) {
    id
  }
}
    `;
export type RemoveSmsOptOutMutationFn = Apollo.MutationFunction<RemoveSmsOptOutMutation, RemoveSmsOptOutMutationVariables>;

/**
 * __useRemoveSmsOptOutMutation__
 *
 * To run a mutation, you first call `useRemoveSmsOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSmsOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSmsOptOutMutation, { data, loading, error }] = useRemoveSmsOptOutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRemoveSmsOptOutMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSmsOptOutMutation, RemoveSmsOptOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSmsOptOutMutation, RemoveSmsOptOutMutationVariables>(RemoveSmsOptOutDocument, options);
      }
export type RemoveSmsOptOutMutationHookResult = ReturnType<typeof useRemoveSmsOptOutMutation>;
export type RemoveSmsOptOutMutationResult = Apollo.MutationResult<RemoveSmsOptOutMutation>;
export type RemoveSmsOptOutMutationOptions = Apollo.BaseMutationOptions<RemoveSmsOptOutMutation, RemoveSmsOptOutMutationVariables>;
export const GetSmsLogsDocument = gql`
    query GetSmsLogs($input: SmsLogListInput) {
  smsLogs(input: $input) {
    totalCount
    platforms
    items {
      id
      customer {
        id
        fullName
        customerNumber
      }
      customerNumber
      cellNumber
      message
      type
      source
      platform
      accepted
      gatewayResult
      providerMessageId
      loadedAt
      sentAt
      deliveryState
      deliveryStateAt
      reply
      repliedAt
    }
  }
}
    `;

/**
 * __useGetSmsLogsQuery__
 *
 * To run a query within a React component, call `useGetSmsLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSmsLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetSmsLogsQuery, GetSmsLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsLogsQuery, GetSmsLogsQueryVariables>(GetSmsLogsDocument, options);
      }
export function useGetSmsLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsLogsQuery, GetSmsLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsLogsQuery, GetSmsLogsQueryVariables>(GetSmsLogsDocument, options);
        }
// @ts-ignore
export function useGetSmsLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsLogsQuery, GetSmsLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsLogsQuery, GetSmsLogsQueryVariables>;
export function useGetSmsLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsLogsQuery, GetSmsLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsLogsQuery | undefined, GetSmsLogsQueryVariables>;
export function useGetSmsLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsLogsQuery, GetSmsLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsLogsQuery, GetSmsLogsQueryVariables>(GetSmsLogsDocument, options);
        }
export type GetSmsLogsQueryHookResult = ReturnType<typeof useGetSmsLogsQuery>;
export type GetSmsLogsLazyQueryHookResult = ReturnType<typeof useGetSmsLogsLazyQuery>;
export type GetSmsLogsSuspenseQueryHookResult = ReturnType<typeof useGetSmsLogsSuspenseQuery>;
export type GetSmsLogsQueryResult = Apollo.QueryResult<GetSmsLogsQuery, GetSmsLogsQueryVariables>;
export const GetSmsCallbacksDocument = gql`
    query GetSmsCallbacks($input: SmsCallbackListInput) {
  smsCallbacks(input: $input) {
    totalCount
    states
    items {
      id
      createdAt
      kind
      providerMessageId
      phone
      state
      statusCode
      text
      sentMessageText
      messageAt
      statusAt
      platform
      payload
      customer {
        id
        fullName
        customerNumber
      }
      smsLog {
        id
      }
    }
  }
}
    `;

/**
 * __useGetSmsCallbacksQuery__
 *
 * To run a query within a React component, call `useGetSmsCallbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsCallbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsCallbacksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSmsCallbacksQuery(baseOptions?: Apollo.QueryHookOptions<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>(GetSmsCallbacksDocument, options);
      }
export function useGetSmsCallbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>(GetSmsCallbacksDocument, options);
        }
// @ts-ignore
export function useGetSmsCallbacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>;
export function useGetSmsCallbacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsCallbacksQuery | undefined, GetSmsCallbacksQueryVariables>;
export function useGetSmsCallbacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>(GetSmsCallbacksDocument, options);
        }
export type GetSmsCallbacksQueryHookResult = ReturnType<typeof useGetSmsCallbacksQuery>;
export type GetSmsCallbacksLazyQueryHookResult = ReturnType<typeof useGetSmsCallbacksLazyQuery>;
export type GetSmsCallbacksSuspenseQueryHookResult = ReturnType<typeof useGetSmsCallbacksSuspenseQuery>;
export type GetSmsCallbacksQueryResult = Apollo.QueryResult<GetSmsCallbacksQuery, GetSmsCallbacksQueryVariables>;
export const GetStockBalancesDocument = gql`
    query GetStockBalances {
  stockBalances {
    asAt
    showsValue
    valueCents
    unpricedProductCount
    stockingPoints {
      id
      name
      type
    }
    rows {
      ...StockBalanceRowFields
    }
  }
}
    ${StockBalanceRowFieldsFragmentDoc}`;

/**
 * __useGetStockBalancesQuery__
 *
 * To run a query within a React component, call `useGetStockBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockBalancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStockBalancesQuery(baseOptions?: Apollo.QueryHookOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockBalancesQuery, GetStockBalancesQueryVariables>(GetStockBalancesDocument, options);
      }
export function useGetStockBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockBalancesQuery, GetStockBalancesQueryVariables>(GetStockBalancesDocument, options);
        }
// @ts-ignore
export function useGetStockBalancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockBalancesQuery, GetStockBalancesQueryVariables>;
export function useGetStockBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockBalancesQuery | undefined, GetStockBalancesQueryVariables>;
export function useGetStockBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockBalancesQuery, GetStockBalancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockBalancesQuery, GetStockBalancesQueryVariables>(GetStockBalancesDocument, options);
        }
export type GetStockBalancesQueryHookResult = ReturnType<typeof useGetStockBalancesQuery>;
export type GetStockBalancesLazyQueryHookResult = ReturnType<typeof useGetStockBalancesLazyQuery>;
export type GetStockBalancesSuspenseQueryHookResult = ReturnType<typeof useGetStockBalancesSuspenseQuery>;
export type GetStockBalancesQueryResult = Apollo.QueryResult<GetStockBalancesQuery, GetStockBalancesQueryVariables>;
export const GetStockCardDocument = gql`
    query GetStockCard($productId: String!, $from: DateTime) {
  stockCard(productId: $productId, from: $from) {
    tracksMovements
    from
    openingBalance
    closingBalance
    lastReceivedAt
    showsValue
    stockingPoints {
      id
      name
      type
    }
    row {
      ...StockBalanceRowFields
    }
    movements {
      ...StockCardMovementFields
    }
    openOrders {
      purchaseOrderId
      purchaseOrderNumber
      purchaseOrderLineId
      supplierName
      destinationId
      destinationName
      remaining
      expectedAt
    }
  }
}
    ${StockBalanceRowFieldsFragmentDoc}
${StockCardMovementFieldsFragmentDoc}`;

/**
 * __useGetStockCardQuery__
 *
 * To run a query within a React component, call `useGetStockCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockCardQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useGetStockCardQuery(baseOptions: Apollo.QueryHookOptions<GetStockCardQuery, GetStockCardQueryVariables> & ({ variables: GetStockCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockCardQuery, GetStockCardQueryVariables>(GetStockCardDocument, options);
      }
export function useGetStockCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockCardQuery, GetStockCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockCardQuery, GetStockCardQueryVariables>(GetStockCardDocument, options);
        }
// @ts-ignore
export function useGetStockCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockCardQuery, GetStockCardQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockCardQuery, GetStockCardQueryVariables>;
export function useGetStockCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockCardQuery, GetStockCardQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockCardQuery | undefined, GetStockCardQueryVariables>;
export function useGetStockCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockCardQuery, GetStockCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockCardQuery, GetStockCardQueryVariables>(GetStockCardDocument, options);
        }
export type GetStockCardQueryHookResult = ReturnType<typeof useGetStockCardQuery>;
export type GetStockCardLazyQueryHookResult = ReturnType<typeof useGetStockCardLazyQuery>;
export type GetStockCardSuspenseQueryHookResult = ReturnType<typeof useGetStockCardSuspenseQuery>;
export type GetStockCardQueryResult = Apollo.QueryResult<GetStockCardQuery, GetStockCardQueryVariables>;
export const GetStockActivityDocument = gql`
    query GetStockActivity($months: Int) {
  stockActivity(months: $months) {
    months {
      month
      received
      issued
    }
    recent {
      ...StockCardMovementFields
    }
  }
}
    ${StockCardMovementFieldsFragmentDoc}`;

/**
 * __useGetStockActivityQuery__
 *
 * To run a query within a React component, call `useGetStockActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockActivityQuery({
 *   variables: {
 *      months: // value for 'months'
 *   },
 * });
 */
export function useGetStockActivityQuery(baseOptions?: Apollo.QueryHookOptions<GetStockActivityQuery, GetStockActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockActivityQuery, GetStockActivityQueryVariables>(GetStockActivityDocument, options);
      }
export function useGetStockActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockActivityQuery, GetStockActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockActivityQuery, GetStockActivityQueryVariables>(GetStockActivityDocument, options);
        }
// @ts-ignore
export function useGetStockActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockActivityQuery, GetStockActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockActivityQuery, GetStockActivityQueryVariables>;
export function useGetStockActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockActivityQuery, GetStockActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockActivityQuery | undefined, GetStockActivityQueryVariables>;
export function useGetStockActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockActivityQuery, GetStockActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockActivityQuery, GetStockActivityQueryVariables>(GetStockActivityDocument, options);
        }
export type GetStockActivityQueryHookResult = ReturnType<typeof useGetStockActivityQuery>;
export type GetStockActivityLazyQueryHookResult = ReturnType<typeof useGetStockActivityLazyQuery>;
export type GetStockActivitySuspenseQueryHookResult = ReturnType<typeof useGetStockActivitySuspenseQuery>;
export type GetStockActivityQueryResult = Apollo.QueryResult<GetStockActivityQuery, GetStockActivityQueryVariables>;
export const GetStockImportBatchesDocument = gql`
    query GetStockImportBatches($stockingPointId: String) {
  stockImportBatches(stockingPointId: $stockingPointId) {
    id
    createdAt
    productName
    deviceTypeName
    stockTypeName
    importedCount
    importedByName
    reversedAt
    reversedByName
    reversible
    shippingCompany {
      id
      name
    }
    waybillReference
    awaitingReceipt
    receivedAt
    receivedByName
    shipment {
      ...ShipmentFields
    }
  }
}
    ${ShipmentFieldsFragmentDoc}`;

/**
 * __useGetStockImportBatchesQuery__
 *
 * To run a query within a React component, call `useGetStockImportBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockImportBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockImportBatchesQuery({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *   },
 * });
 */
export function useGetStockImportBatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>(GetStockImportBatchesDocument, options);
      }
export function useGetStockImportBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>(GetStockImportBatchesDocument, options);
        }
// @ts-ignore
export function useGetStockImportBatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>;
export function useGetStockImportBatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockImportBatchesQuery | undefined, GetStockImportBatchesQueryVariables>;
export function useGetStockImportBatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>(GetStockImportBatchesDocument, options);
        }
export type GetStockImportBatchesQueryHookResult = ReturnType<typeof useGetStockImportBatchesQuery>;
export type GetStockImportBatchesLazyQueryHookResult = ReturnType<typeof useGetStockImportBatchesLazyQuery>;
export type GetStockImportBatchesSuspenseQueryHookResult = ReturnType<typeof useGetStockImportBatchesSuspenseQuery>;
export type GetStockImportBatchesQueryResult = Apollo.QueryResult<GetStockImportBatchesQuery, GetStockImportBatchesQueryVariables>;
export const ReverseStockImportDocument = gql`
    mutation ReverseStockImport($batchId: String!) {
  reverseStockImport(batchId: $batchId) {
    reversed
    blocked {
      identifier
      reason
    }
  }
}
    `;
export type ReverseStockImportMutationFn = Apollo.MutationFunction<ReverseStockImportMutation, ReverseStockImportMutationVariables>;

/**
 * __useReverseStockImportMutation__
 *
 * To run a mutation, you first call `useReverseStockImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseStockImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseStockImportMutation, { data, loading, error }] = useReverseStockImportMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useReverseStockImportMutation(baseOptions?: Apollo.MutationHookOptions<ReverseStockImportMutation, ReverseStockImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseStockImportMutation, ReverseStockImportMutationVariables>(ReverseStockImportDocument, options);
      }
export type ReverseStockImportMutationHookResult = ReturnType<typeof useReverseStockImportMutation>;
export type ReverseStockImportMutationResult = Apollo.MutationResult<ReverseStockImportMutation>;
export type ReverseStockImportMutationOptions = Apollo.BaseMutationOptions<ReverseStockImportMutation, ReverseStockImportMutationVariables>;
export const ReceiveStockImportDocument = gql`
    mutation ReceiveStockImport($batchId: String!, $courierOverrideReason: String) {
  receiveStockImport(
    batchId: $batchId
    courierOverrideReason: $courierOverrideReason
  )
}
    `;
export type ReceiveStockImportMutationFn = Apollo.MutationFunction<ReceiveStockImportMutation, ReceiveStockImportMutationVariables>;

/**
 * __useReceiveStockImportMutation__
 *
 * To run a mutation, you first call `useReceiveStockImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveStockImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveStockImportMutation, { data, loading, error }] = useReceiveStockImportMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      courierOverrideReason: // value for 'courierOverrideReason'
 *   },
 * });
 */
export function useReceiveStockImportMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveStockImportMutation, ReceiveStockImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveStockImportMutation, ReceiveStockImportMutationVariables>(ReceiveStockImportDocument, options);
      }
export type ReceiveStockImportMutationHookResult = ReturnType<typeof useReceiveStockImportMutation>;
export type ReceiveStockImportMutationResult = Apollo.MutationResult<ReceiveStockImportMutation>;
export type ReceiveStockImportMutationOptions = Apollo.BaseMutationOptions<ReceiveStockImportMutation, ReceiveStockImportMutationVariables>;
export const GetStockItemsDocument = gql`
    query GetStockItems($input: StockItemListInput) {
  stockItems(input: $input) {
    items {
      id
      serialNumber
      accountNumber
      productName
      productSku
      kind
      condition
      status
      updatedAt
      stockType {
        id
        name
      }
      stockingPoint {
        id
        name
        type
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetStockItemsQuery__
 *
 * To run a query within a React component, call `useGetStockItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetStockItemsQuery, GetStockItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockItemsQuery, GetStockItemsQueryVariables>(GetStockItemsDocument, options);
      }
export function useGetStockItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockItemsQuery, GetStockItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockItemsQuery, GetStockItemsQueryVariables>(GetStockItemsDocument, options);
        }
// @ts-ignore
export function useGetStockItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockItemsQuery, GetStockItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockItemsQuery, GetStockItemsQueryVariables>;
export function useGetStockItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockItemsQuery, GetStockItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockItemsQuery | undefined, GetStockItemsQueryVariables>;
export function useGetStockItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockItemsQuery, GetStockItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockItemsQuery, GetStockItemsQueryVariables>(GetStockItemsDocument, options);
        }
export type GetStockItemsQueryHookResult = ReturnType<typeof useGetStockItemsQuery>;
export type GetStockItemsLazyQueryHookResult = ReturnType<typeof useGetStockItemsLazyQuery>;
export type GetStockItemsSuspenseQueryHookResult = ReturnType<typeof useGetStockItemsSuspenseQuery>;
export type GetStockItemsQueryResult = Apollo.QueryResult<GetStockItemsQuery, GetStockItemsQueryVariables>;
export const ArchiveStockItemsDocument = gql`
    mutation ArchiveStockItems($input: ArchiveStockItemsInput!) {
  archiveStockItems(input: $input) {
    successCount
    failureCount
    results {
      stockItemId
      serialNumber
      accountNumber
      success
      error
    }
  }
}
    `;
export type ArchiveStockItemsMutationFn = Apollo.MutationFunction<ArchiveStockItemsMutation, ArchiveStockItemsMutationVariables>;

/**
 * __useArchiveStockItemsMutation__
 *
 * To run a mutation, you first call `useArchiveStockItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveStockItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveStockItemsMutation, { data, loading, error }] = useArchiveStockItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveStockItemsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveStockItemsMutation, ArchiveStockItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveStockItemsMutation, ArchiveStockItemsMutationVariables>(ArchiveStockItemsDocument, options);
      }
export type ArchiveStockItemsMutationHookResult = ReturnType<typeof useArchiveStockItemsMutation>;
export type ArchiveStockItemsMutationResult = Apollo.MutationResult<ArchiveStockItemsMutation>;
export type ArchiveStockItemsMutationOptions = Apollo.BaseMutationOptions<ArchiveStockItemsMutation, ArchiveStockItemsMutationVariables>;
export const RestoreStockItemsDocument = gql`
    mutation RestoreStockItems($input: RestoreStockItemsInput!) {
  restoreStockItems(input: $input) {
    successCount
    failureCount
    results {
      stockItemId
      serialNumber
      accountNumber
      success
      error
    }
  }
}
    `;
export type RestoreStockItemsMutationFn = Apollo.MutationFunction<RestoreStockItemsMutation, RestoreStockItemsMutationVariables>;

/**
 * __useRestoreStockItemsMutation__
 *
 * To run a mutation, you first call `useRestoreStockItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreStockItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreStockItemsMutation, { data, loading, error }] = useRestoreStockItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreStockItemsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreStockItemsMutation, RestoreStockItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreStockItemsMutation, RestoreStockItemsMutationVariables>(RestoreStockItemsDocument, options);
      }
export type RestoreStockItemsMutationHookResult = ReturnType<typeof useRestoreStockItemsMutation>;
export type RestoreStockItemsMutationResult = Apollo.MutationResult<RestoreStockItemsMutation>;
export type RestoreStockItemsMutationOptions = Apollo.BaseMutationOptions<RestoreStockItemsMutation, RestoreStockItemsMutationVariables>;
export const GetCountedStockDocument = gql`
    query GetCountedStock($kind: ProductKind!, $stockingPointId: String) {
  countedStock(kind: $kind, stockingPointId: $stockingPointId) {
    id
    quantity
    reservedQuantity
    condition
    product {
      id
      sku
      name
    }
    stockingPoint {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCountedStockQuery__
 *
 * To run a query within a React component, call `useGetCountedStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountedStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountedStockQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      stockingPointId: // value for 'stockingPointId'
 *   },
 * });
 */
export function useGetCountedStockQuery(baseOptions: Apollo.QueryHookOptions<GetCountedStockQuery, GetCountedStockQueryVariables> & ({ variables: GetCountedStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountedStockQuery, GetCountedStockQueryVariables>(GetCountedStockDocument, options);
      }
export function useGetCountedStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountedStockQuery, GetCountedStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountedStockQuery, GetCountedStockQueryVariables>(GetCountedStockDocument, options);
        }
// @ts-ignore
export function useGetCountedStockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountedStockQuery, GetCountedStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountedStockQuery, GetCountedStockQueryVariables>;
export function useGetCountedStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountedStockQuery, GetCountedStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountedStockQuery | undefined, GetCountedStockQueryVariables>;
export function useGetCountedStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountedStockQuery, GetCountedStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountedStockQuery, GetCountedStockQueryVariables>(GetCountedStockDocument, options);
        }
export type GetCountedStockQueryHookResult = ReturnType<typeof useGetCountedStockQuery>;
export type GetCountedStockLazyQueryHookResult = ReturnType<typeof useGetCountedStockLazyQuery>;
export type GetCountedStockSuspenseQueryHookResult = ReturnType<typeof useGetCountedStockSuspenseQuery>;
export type GetCountedStockQueryResult = Apollo.QueryResult<GetCountedStockQuery, GetCountedStockQueryVariables>;
export const ValidateSerialForSaleDocument = gql`
    query ValidateSerialForSale($identifier: String!, $agentId: String!, $override: Boolean) {
  validateSerialForSale(
    identifier: $identifier
    agentId: $agentId
    override: $override
  ) {
    valid
    stockItemId
    serialNumber
    productName
    accountNumber
    hasMeter
    requiresOverride
    currentLocationName
    error
  }
}
    `;

/**
 * __useValidateSerialForSaleQuery__
 *
 * To run a query within a React component, call `useValidateSerialForSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSerialForSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSerialForSaleQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      agentId: // value for 'agentId'
 *      override: // value for 'override'
 *   },
 * });
 */
export function useValidateSerialForSaleQuery(baseOptions: Apollo.QueryHookOptions<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables> & ({ variables: ValidateSerialForSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>(ValidateSerialForSaleDocument, options);
      }
export function useValidateSerialForSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>(ValidateSerialForSaleDocument, options);
        }
// @ts-ignore
export function useValidateSerialForSaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>;
export function useValidateSerialForSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSerialForSaleQuery | undefined, ValidateSerialForSaleQueryVariables>;
export function useValidateSerialForSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>(ValidateSerialForSaleDocument, options);
        }
export type ValidateSerialForSaleQueryHookResult = ReturnType<typeof useValidateSerialForSaleQuery>;
export type ValidateSerialForSaleLazyQueryHookResult = ReturnType<typeof useValidateSerialForSaleLazyQuery>;
export type ValidateSerialForSaleSuspenseQueryHookResult = ReturnType<typeof useValidateSerialForSaleSuspenseQuery>;
export type ValidateSerialForSaleQueryResult = Apollo.QueryResult<ValidateSerialForSaleQuery, ValidateSerialForSaleQueryVariables>;
export const GetStockSalesDocument = gql`
    query GetStockSales($input: StockSaleListInput) {
  stockSales(input: $input) {
    items {
      id
      saleReference
      status
      saleDate
      notes
      createdAt
      flaggedBadAt
      stockItem {
        id
        serialNumber
        accountNumber
        productName
        isMigrated
      }
      agent {
        id
        firstName
        lastName
        salesId
      }
      customer {
        id
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetStockSalesQuery__
 *
 * To run a query within a React component, call `useGetStockSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockSalesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockSalesQuery(baseOptions?: Apollo.QueryHookOptions<GetStockSalesQuery, GetStockSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockSalesQuery, GetStockSalesQueryVariables>(GetStockSalesDocument, options);
      }
export function useGetStockSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockSalesQuery, GetStockSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockSalesQuery, GetStockSalesQueryVariables>(GetStockSalesDocument, options);
        }
// @ts-ignore
export function useGetStockSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockSalesQuery, GetStockSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSalesQuery, GetStockSalesQueryVariables>;
export function useGetStockSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSalesQuery, GetStockSalesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSalesQuery | undefined, GetStockSalesQueryVariables>;
export function useGetStockSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSalesQuery, GetStockSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockSalesQuery, GetStockSalesQueryVariables>(GetStockSalesDocument, options);
        }
export type GetStockSalesQueryHookResult = ReturnType<typeof useGetStockSalesQuery>;
export type GetStockSalesLazyQueryHookResult = ReturnType<typeof useGetStockSalesLazyQuery>;
export type GetStockSalesSuspenseQueryHookResult = ReturnType<typeof useGetStockSalesSuspenseQuery>;
export type GetStockSalesQueryResult = Apollo.QueryResult<GetStockSalesQuery, GetStockSalesQueryVariables>;
export const GetStockSaleDocument = gql`
    query GetStockSale($id: String!) {
  stockSale(id: $id) {
    id
    saleReference
    status
    saleDate
    notes
    createdAt
    updatedAt
    flaggedBadAt
    flaggedBadReason
    flaggedBadBy {
      id
      firstName
      lastName
      email
    }
    stockItem {
      id
      serialNumber
      accountNumber
      productSku
      productName
      status
      isMigrated
    }
    agent {
      id
      firstName
      lastName
      salesId
    }
    recordedBy {
      id
      firstName
      lastName
    }
    onBehalfOfAgent {
      id
    }
    customer {
      id
      firstName
      lastName
    }
    contract {
      id
      contractNumber
    }
    deviceReassignments {
      id
      createdAt
      previousSerialNumber
      previousAccountNumber
      newSerialNumber
      newAccountNumber
      cause
      notes
      tokenDaysShortfall
      creditRecoveryTotal
      creditRecoveryPerPayment
      creditRecoveryRemaining
      customerNotifiedAt
      swapGroupId
      performedBy {
        firstName
        lastName
        email
      }
    }
  }
}
    `;

/**
 * __useGetStockSaleQuery__
 *
 * To run a query within a React component, call `useGetStockSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockSaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStockSaleQuery(baseOptions: Apollo.QueryHookOptions<GetStockSaleQuery, GetStockSaleQueryVariables> & ({ variables: GetStockSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockSaleQuery, GetStockSaleQueryVariables>(GetStockSaleDocument, options);
      }
export function useGetStockSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockSaleQuery, GetStockSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockSaleQuery, GetStockSaleQueryVariables>(GetStockSaleDocument, options);
        }
// @ts-ignore
export function useGetStockSaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockSaleQuery, GetStockSaleQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSaleQuery, GetStockSaleQueryVariables>;
export function useGetStockSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSaleQuery, GetStockSaleQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSaleQuery | undefined, GetStockSaleQueryVariables>;
export function useGetStockSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSaleQuery, GetStockSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockSaleQuery, GetStockSaleQueryVariables>(GetStockSaleDocument, options);
        }
export type GetStockSaleQueryHookResult = ReturnType<typeof useGetStockSaleQuery>;
export type GetStockSaleLazyQueryHookResult = ReturnType<typeof useGetStockSaleLazyQuery>;
export type GetStockSaleSuspenseQueryHookResult = ReturnType<typeof useGetStockSaleSuspenseQuery>;
export type GetStockSaleQueryResult = Apollo.QueryResult<GetStockSaleQuery, GetStockSaleQueryVariables>;
export const GetAgentStockDocument = gql`
    query GetAgentStock($agentId: String!, $productName: String) {
  agentStock(agentId: $agentId, productName: $productName) {
    id
    serialNumber
    accountNumber
    productSku
    productName
    stockType {
      id
      name
      isReplacement
    }
    status
    createdAt
  }
}
    `;

/**
 * __useGetAgentStockQuery__
 *
 * To run a query within a React component, call `useGetAgentStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentStockQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useGetAgentStockQuery(baseOptions: Apollo.QueryHookOptions<GetAgentStockQuery, GetAgentStockQueryVariables> & ({ variables: GetAgentStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentStockQuery, GetAgentStockQueryVariables>(GetAgentStockDocument, options);
      }
export function useGetAgentStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentStockQuery, GetAgentStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentStockQuery, GetAgentStockQueryVariables>(GetAgentStockDocument, options);
        }
// @ts-ignore
export function useGetAgentStockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentStockQuery, GetAgentStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentStockQuery, GetAgentStockQueryVariables>;
export function useGetAgentStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentStockQuery, GetAgentStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentStockQuery | undefined, GetAgentStockQueryVariables>;
export function useGetAgentStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentStockQuery, GetAgentStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentStockQuery, GetAgentStockQueryVariables>(GetAgentStockDocument, options);
        }
export type GetAgentStockQueryHookResult = ReturnType<typeof useGetAgentStockQuery>;
export type GetAgentStockLazyQueryHookResult = ReturnType<typeof useGetAgentStockLazyQuery>;
export type GetAgentStockSuspenseQueryHookResult = ReturnType<typeof useGetAgentStockSuspenseQuery>;
export type GetAgentStockQueryResult = Apollo.QueryResult<GetAgentStockQuery, GetAgentStockQueryVariables>;
export const GetReplacementStockOptionsDocument = gql`
    query GetReplacementStockOptions($agentId: String!, $productName: String, $onBehalfOfAgentId: String) {
  replacementStockOptions(
    agentId: $agentId
    productName: $productName
    onBehalfOfAgentId: $onBehalfOfAgentId
  ) {
    id
    serialNumber
    accountNumber
    productName
    product {
      id
      canAcceptToken
    }
    status
    stockingPoint {
      id
      name
    }
  }
}
    `;

/**
 * __useGetReplacementStockOptionsQuery__
 *
 * To run a query within a React component, call `useGetReplacementStockOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReplacementStockOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReplacementStockOptionsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      productName: // value for 'productName'
 *      onBehalfOfAgentId: // value for 'onBehalfOfAgentId'
 *   },
 * });
 */
export function useGetReplacementStockOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables> & ({ variables: GetReplacementStockOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>(GetReplacementStockOptionsDocument, options);
      }
export function useGetReplacementStockOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>(GetReplacementStockOptionsDocument, options);
        }
// @ts-ignore
export function useGetReplacementStockOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>;
export function useGetReplacementStockOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReplacementStockOptionsQuery | undefined, GetReplacementStockOptionsQueryVariables>;
export function useGetReplacementStockOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>(GetReplacementStockOptionsDocument, options);
        }
export type GetReplacementStockOptionsQueryHookResult = ReturnType<typeof useGetReplacementStockOptionsQuery>;
export type GetReplacementStockOptionsLazyQueryHookResult = ReturnType<typeof useGetReplacementStockOptionsLazyQuery>;
export type GetReplacementStockOptionsSuspenseQueryHookResult = ReturnType<typeof useGetReplacementStockOptionsSuspenseQuery>;
export type GetReplacementStockOptionsQueryResult = Apollo.QueryResult<GetReplacementStockOptionsQuery, GetReplacementStockOptionsQueryVariables>;
export const GetStockOnHandDocument = gql`
    query GetStockOnHand($input: StockOnHandInput) {
  stockOnHand(input: $input) {
    items {
      id
      serialNumber
      accountNumber
      productSku
      productName
      stockType {
        id
        name
        isReplacement
      }
      status
      stockingPoint {
        id
        name
        stockingPointId
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetStockOnHandQuery__
 *
 * To run a query within a React component, call `useGetStockOnHandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockOnHandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockOnHandQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockOnHandQuery(baseOptions?: Apollo.QueryHookOptions<GetStockOnHandQuery, GetStockOnHandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockOnHandQuery, GetStockOnHandQueryVariables>(GetStockOnHandDocument, options);
      }
export function useGetStockOnHandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockOnHandQuery, GetStockOnHandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockOnHandQuery, GetStockOnHandQueryVariables>(GetStockOnHandDocument, options);
        }
// @ts-ignore
export function useGetStockOnHandSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockOnHandQuery, GetStockOnHandQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockOnHandQuery, GetStockOnHandQueryVariables>;
export function useGetStockOnHandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockOnHandQuery, GetStockOnHandQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockOnHandQuery | undefined, GetStockOnHandQueryVariables>;
export function useGetStockOnHandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockOnHandQuery, GetStockOnHandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockOnHandQuery, GetStockOnHandQueryVariables>(GetStockOnHandDocument, options);
        }
export type GetStockOnHandQueryHookResult = ReturnType<typeof useGetStockOnHandQuery>;
export type GetStockOnHandLazyQueryHookResult = ReturnType<typeof useGetStockOnHandLazyQuery>;
export type GetStockOnHandSuspenseQueryHookResult = ReturnType<typeof useGetStockOnHandSuspenseQuery>;
export type GetStockOnHandQueryResult = Apollo.QueryResult<GetStockOnHandQuery, GetStockOnHandQueryVariables>;
export const ExportStockOnHandDocument = gql`
    query ExportStockOnHand($input: StockOnHandInput) {
  exportStockOnHand(input: $input) {
    items {
      serialNumber
      accountNumber
      productSku
      productName
      stockType {
        name
      }
      status
      stockingPoint {
        name
        province
      }
    }
    totalCount
  }
}
    `;

/**
 * __useExportStockOnHandQuery__
 *
 * To run a query within a React component, call `useExportStockOnHandQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportStockOnHandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportStockOnHandQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportStockOnHandQuery(baseOptions?: Apollo.QueryHookOptions<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>(ExportStockOnHandDocument, options);
      }
export function useExportStockOnHandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>(ExportStockOnHandDocument, options);
        }
// @ts-ignore
export function useExportStockOnHandSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>): Apollo.UseSuspenseQueryResult<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>;
export function useExportStockOnHandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>): Apollo.UseSuspenseQueryResult<ExportStockOnHandQuery | undefined, ExportStockOnHandQueryVariables>;
export function useExportStockOnHandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>(ExportStockOnHandDocument, options);
        }
export type ExportStockOnHandQueryHookResult = ReturnType<typeof useExportStockOnHandQuery>;
export type ExportStockOnHandLazyQueryHookResult = ReturnType<typeof useExportStockOnHandLazyQuery>;
export type ExportStockOnHandSuspenseQueryHookResult = ReturnType<typeof useExportStockOnHandSuspenseQuery>;
export type ExportStockOnHandQueryResult = Apollo.QueryResult<ExportStockOnHandQuery, ExportStockOnHandQueryVariables>;
export const GetStockReportDocument = gql`
    query GetStockReport($input: StockReportInput) {
  stockReport(input: $input) {
    totalSales
    salesByAgent {
      agentId
      agentName
      agentSalesId
      salesCount
    }
  }
}
    `;

/**
 * __useGetStockReportQuery__
 *
 * To run a query within a React component, call `useGetStockReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockReportQuery(baseOptions?: Apollo.QueryHookOptions<GetStockReportQuery, GetStockReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockReportQuery, GetStockReportQueryVariables>(GetStockReportDocument, options);
      }
export function useGetStockReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockReportQuery, GetStockReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockReportQuery, GetStockReportQueryVariables>(GetStockReportDocument, options);
        }
// @ts-ignore
export function useGetStockReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockReportQuery, GetStockReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockReportQuery, GetStockReportQueryVariables>;
export function useGetStockReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockReportQuery, GetStockReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockReportQuery | undefined, GetStockReportQueryVariables>;
export function useGetStockReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockReportQuery, GetStockReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockReportQuery, GetStockReportQueryVariables>(GetStockReportDocument, options);
        }
export type GetStockReportQueryHookResult = ReturnType<typeof useGetStockReportQuery>;
export type GetStockReportLazyQueryHookResult = ReturnType<typeof useGetStockReportLazyQuery>;
export type GetStockReportSuspenseQueryHookResult = ReturnType<typeof useGetStockReportSuspenseQuery>;
export type GetStockReportQueryResult = Apollo.QueryResult<GetStockReportQuery, GetStockReportQueryVariables>;
export const GetDistributorReconciliationDocument = gql`
    query GetDistributorReconciliation($distributorId: String!) {
  distributorReconciliation(distributorId: $distributorId) {
    distributorId
    distributorName
    childAgentCount
    stockingPointCount
    totalHeld
    availableStock
    reservedStock
    soldStock
    damagedStock
    inTransitStock
    otherStock
    salesRecorded
    salesFromOwnStock
    salesFromOtherStock
    closedSales
    accessoriesHeld
    accessoriesIssued
  }
}
    `;

/**
 * __useGetDistributorReconciliationQuery__
 *
 * To run a query within a React component, call `useGetDistributorReconciliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributorReconciliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributorReconciliationQuery({
 *   variables: {
 *      distributorId: // value for 'distributorId'
 *   },
 * });
 */
export function useGetDistributorReconciliationQuery(baseOptions: Apollo.QueryHookOptions<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables> & ({ variables: GetDistributorReconciliationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>(GetDistributorReconciliationDocument, options);
      }
export function useGetDistributorReconciliationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>(GetDistributorReconciliationDocument, options);
        }
// @ts-ignore
export function useGetDistributorReconciliationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>): Apollo.UseSuspenseQueryResult<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>;
export function useGetDistributorReconciliationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>): Apollo.UseSuspenseQueryResult<GetDistributorReconciliationQuery | undefined, GetDistributorReconciliationQueryVariables>;
export function useGetDistributorReconciliationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>(GetDistributorReconciliationDocument, options);
        }
export type GetDistributorReconciliationQueryHookResult = ReturnType<typeof useGetDistributorReconciliationQuery>;
export type GetDistributorReconciliationLazyQueryHookResult = ReturnType<typeof useGetDistributorReconciliationLazyQuery>;
export type GetDistributorReconciliationSuspenseQueryHookResult = ReturnType<typeof useGetDistributorReconciliationSuspenseQuery>;
export type GetDistributorReconciliationQueryResult = Apollo.QueryResult<GetDistributorReconciliationQuery, GetDistributorReconciliationQueryVariables>;
export const GetSerialNumberHistoryDocument = gql`
    query GetSerialNumberHistory($identifier: String!) {
  serialNumberHistory(identifier: $identifier) {
    id
    serialNumber
    accountNumber
    productSku
    productName
    product {
      id
      canAcceptToken
    }
    stockType {
      id
      name
      isReplacement
    }
    status
    condition
    createdAt
    updatedAt
    meterHostedOn
    deviceType {
      id
      name
    }
    hasMeter
    meterHasSecretKey
    meterTokenCount
    meterStartingCode
    meterTypeName
    workshopJobs {
      id
      openedAt
      stage
      intakeReason
      faultDescription
      completedAt
      closedAt
      scrapReason
      stockingPoint {
        id
        name
      }
      faultType {
        id
        name
      }
      openedBy {
        id
        firstName
        lastName
      }
    }
    purchaseOrder {
      id
      purchaseOrderNumber
      supplier {
        id
        name
      }
      status
      closedAt
      createdAt
      shipment {
        id
        state
        statusLabel
        closedAt
      }
    }
    stockingPoint {
      id
      name
      stockingPointId
    }
    onTheWay {
      kind
      recordId
      reference
      from {
        id
        name
      }
      to {
        id
        name
      }
      shipment {
        ...ShipmentFields
      }
    }
    archiveEvents {
      id
      createdAt
      action
      reason
      note
      fromStatus
      toStatus
      performedByName
      stockingPoint {
        id
        name
      }
    }
    reassignedFrom {
      id
      createdAt
      cause
      notes
      newSerialNumber
      newAccountNumber
      swapGroupId
      contract {
        id
        contractNumber
      }
    }
    reassignedTo {
      id
      createdAt
      cause
      notes
      previousSerialNumber
      previousAccountNumber
      swapGroupId
      contract {
        id
        contractNumber
      }
    }
    releases {
      id
      releasedAt
      reason
      contractId
      contractNumber
      location
      relocated
      transferNumber
      backfilled
      ratePlanChange
      replacedBySerialNumber
      applicationId
      releasedBy {
        id
        firstName
        lastName
      }
    }
    releaseEligibility {
      eligible
      blocker
      hold
      explanation
      contractId
      contractNumber
      contractStatus
      resultingCondition
      closesLiveSale
      location
      applicationId
      applicationSiblings
      reasonRequired
      requiredPermission
      viewerMayRelease
    }
    transferItems {
      id
      transfer {
        id
        transferNumber
        status
        notes
        createdAt
        dispatchedAt
        completedAt
        createdBy {
          id
          firstName
          lastName
        }
        dispatchedBy {
          id
          firstName
          lastName
        }
        completedBy {
          id
          firstName
          lastName
        }
        cancelledBy {
          id
          firstName
          lastName
        }
        sourceStockingPoint {
          id
          name
        }
        destinationStockingPoint {
          id
          name
        }
        shipment {
          id
          state
          statusLabel
          closedAt
        }
      }
    }
    sale {
      id
      saleReference
      status
      saleDate
      notes
      defectiveCondition
      stockItem {
        id
        serialNumber
      }
      agent {
        id
        firstName
        lastName
        salesId
      }
      recordedBy {
        id
        firstName
        lastName
      }
      onBehalfOfAgent {
        id
      }
      customer {
        id
        firstName
        lastName
      }
      contract {
        id
        contractNumber
      }
    }
    sales {
      id
      saleReference
      status
      saleDate
      notes
      defectiveCondition
      agent {
        id
        firstName
        lastName
      }
      recordedBy {
        id
        firstName
        lastName
      }
      customer {
        id
        firstName
        lastName
      }
      contract {
        id
        contractNumber
      }
    }
  }
}
    ${ShipmentFieldsFragmentDoc}`;

/**
 * __useGetSerialNumberHistoryQuery__
 *
 * To run a query within a React component, call `useGetSerialNumberHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSerialNumberHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSerialNumberHistoryQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetSerialNumberHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables> & ({ variables: GetSerialNumberHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>(GetSerialNumberHistoryDocument, options);
      }
export function useGetSerialNumberHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>(GetSerialNumberHistoryDocument, options);
        }
// @ts-ignore
export function useGetSerialNumberHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>;
export function useGetSerialNumberHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetSerialNumberHistoryQuery | undefined, GetSerialNumberHistoryQueryVariables>;
export function useGetSerialNumberHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>(GetSerialNumberHistoryDocument, options);
        }
export type GetSerialNumberHistoryQueryHookResult = ReturnType<typeof useGetSerialNumberHistoryQuery>;
export type GetSerialNumberHistoryLazyQueryHookResult = ReturnType<typeof useGetSerialNumberHistoryLazyQuery>;
export type GetSerialNumberHistorySuspenseQueryHookResult = ReturnType<typeof useGetSerialNumberHistorySuspenseQuery>;
export type GetSerialNumberHistoryQueryResult = Apollo.QueryResult<GetSerialNumberHistoryQuery, GetSerialNumberHistoryQueryVariables>;
export const RecordStockSaleDocument = gql`
    mutation RecordStockSale($input: RecordStockSaleInput!) {
  recordStockSale(input: $input) {
    id
    saleReference
    status
    saleDate
  }
}
    `;
export type RecordStockSaleMutationFn = Apollo.MutationFunction<RecordStockSaleMutation, RecordStockSaleMutationVariables>;

/**
 * __useRecordStockSaleMutation__
 *
 * To run a mutation, you first call `useRecordStockSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordStockSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordStockSaleMutation, { data, loading, error }] = useRecordStockSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordStockSaleMutation(baseOptions?: Apollo.MutationHookOptions<RecordStockSaleMutation, RecordStockSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordStockSaleMutation, RecordStockSaleMutationVariables>(RecordStockSaleDocument, options);
      }
export type RecordStockSaleMutationHookResult = ReturnType<typeof useRecordStockSaleMutation>;
export type RecordStockSaleMutationResult = Apollo.MutationResult<RecordStockSaleMutation>;
export type RecordStockSaleMutationOptions = Apollo.BaseMutationOptions<RecordStockSaleMutation, RecordStockSaleMutationVariables>;
export const AssignDeviceToContractDocument = gql`
    mutation AssignDeviceToContract($input: AssignDeviceToContractInput!) {
  assignDeviceToContract(input: $input) {
    id
    saleReference
    status
    saleDate
    stockItem {
      id
      serialNumber
      accountNumber
      productName
    }
  }
}
    `;
export type AssignDeviceToContractMutationFn = Apollo.MutationFunction<AssignDeviceToContractMutation, AssignDeviceToContractMutationVariables>;

/**
 * __useAssignDeviceToContractMutation__
 *
 * To run a mutation, you first call `useAssignDeviceToContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDeviceToContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDeviceToContractMutation, { data, loading, error }] = useAssignDeviceToContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignDeviceToContractMutation(baseOptions?: Apollo.MutationHookOptions<AssignDeviceToContractMutation, AssignDeviceToContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignDeviceToContractMutation, AssignDeviceToContractMutationVariables>(AssignDeviceToContractDocument, options);
      }
export type AssignDeviceToContractMutationHookResult = ReturnType<typeof useAssignDeviceToContractMutation>;
export type AssignDeviceToContractMutationResult = Apollo.MutationResult<AssignDeviceToContractMutation>;
export type AssignDeviceToContractMutationOptions = Apollo.BaseMutationOptions<AssignDeviceToContractMutation, AssignDeviceToContractMutationVariables>;
export const ProcessWarrantyReplacementDocument = gql`
    mutation ProcessWarrantyReplacement($input: WarrantyReplacementInput!) {
  processWarrantyReplacement(input: $input) {
    id
    saleReference
    status
    saleDate
    notes
  }
}
    `;
export type ProcessWarrantyReplacementMutationFn = Apollo.MutationFunction<ProcessWarrantyReplacementMutation, ProcessWarrantyReplacementMutationVariables>;

/**
 * __useProcessWarrantyReplacementMutation__
 *
 * To run a mutation, you first call `useProcessWarrantyReplacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessWarrantyReplacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processWarrantyReplacementMutation, { data, loading, error }] = useProcessWarrantyReplacementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessWarrantyReplacementMutation(baseOptions?: Apollo.MutationHookOptions<ProcessWarrantyReplacementMutation, ProcessWarrantyReplacementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessWarrantyReplacementMutation, ProcessWarrantyReplacementMutationVariables>(ProcessWarrantyReplacementDocument, options);
      }
export type ProcessWarrantyReplacementMutationHookResult = ReturnType<typeof useProcessWarrantyReplacementMutation>;
export type ProcessWarrantyReplacementMutationResult = Apollo.MutationResult<ProcessWarrantyReplacementMutation>;
export type ProcessWarrantyReplacementMutationOptions = Apollo.BaseMutationOptions<ProcessWarrantyReplacementMutation, ProcessWarrantyReplacementMutationVariables>;
export const SetupDeviceMeterDocument = gql`
    mutation SetupDeviceMeter($input: SetupDeviceMeterInput!) {
  setupDeviceMeter(input: $input) {
    id
    serialNumber
    accountNumber
    hasMeter
    meterTypeName
    meterTypeId
    meterStartingCode
    meterHasSecretKey
  }
}
    `;
export type SetupDeviceMeterMutationFn = Apollo.MutationFunction<SetupDeviceMeterMutation, SetupDeviceMeterMutationVariables>;

/**
 * __useSetupDeviceMeterMutation__
 *
 * To run a mutation, you first call `useSetupDeviceMeterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupDeviceMeterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupDeviceMeterMutation, { data, loading, error }] = useSetupDeviceMeterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupDeviceMeterMutation(baseOptions?: Apollo.MutationHookOptions<SetupDeviceMeterMutation, SetupDeviceMeterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupDeviceMeterMutation, SetupDeviceMeterMutationVariables>(SetupDeviceMeterDocument, options);
      }
export type SetupDeviceMeterMutationHookResult = ReturnType<typeof useSetupDeviceMeterMutation>;
export type SetupDeviceMeterMutationResult = Apollo.MutationResult<SetupDeviceMeterMutation>;
export type SetupDeviceMeterMutationOptions = Apollo.BaseMutationOptions<SetupDeviceMeterMutation, SetupDeviceMeterMutationVariables>;
export const UpdateDeviceDocument = gql`
    mutation UpdateDevice($input: UpdateDeviceInput!) {
  updateDevice(input: $input) {
    id
    serialNumber
    accountNumber
  }
}
    `;
export type UpdateDeviceMutationFn = Apollo.MutationFunction<UpdateDeviceMutation, UpdateDeviceMutationVariables>;

/**
 * __useUpdateDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceMutation, { data, loading, error }] = useUpdateDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceMutation, UpdateDeviceMutationVariables>(UpdateDeviceDocument, options);
      }
export type UpdateDeviceMutationHookResult = ReturnType<typeof useUpdateDeviceMutation>;
export type UpdateDeviceMutationResult = Apollo.MutationResult<UpdateDeviceMutation>;
export type UpdateDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>;
export const UpdateDeviceMeterDocument = gql`
    mutation UpdateDeviceMeter($input: UpdateDeviceMeterInput!) {
  updateDeviceMeter(input: $input) {
    id
    serialNumber
    accountNumber
    hasMeter
    meterTypeName
    meterTypeId
    meterStartingCode
    meterHasSecretKey
  }
}
    `;
export type UpdateDeviceMeterMutationFn = Apollo.MutationFunction<UpdateDeviceMeterMutation, UpdateDeviceMeterMutationVariables>;

/**
 * __useUpdateDeviceMeterMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMeterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMeterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceMeterMutation, { data, loading, error }] = useUpdateDeviceMeterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeviceMeterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceMeterMutation, UpdateDeviceMeterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceMeterMutation, UpdateDeviceMeterMutationVariables>(UpdateDeviceMeterDocument, options);
      }
export type UpdateDeviceMeterMutationHookResult = ReturnType<typeof useUpdateDeviceMeterMutation>;
export type UpdateDeviceMeterMutationResult = Apollo.MutationResult<UpdateDeviceMeterMutation>;
export type UpdateDeviceMeterMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceMeterMutation, UpdateDeviceMeterMutationVariables>;
export const FlagStockSaleAsBadDocument = gql`
    mutation FlagStockSaleAsBad($input: FlagStockSaleAsBadInput!) {
  flagStockSaleAsBad(input: $input) {
    id
    flaggedBadAt
    flaggedBadReason
    flaggedBadBy {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type FlagStockSaleAsBadMutationFn = Apollo.MutationFunction<FlagStockSaleAsBadMutation, FlagStockSaleAsBadMutationVariables>;

/**
 * __useFlagStockSaleAsBadMutation__
 *
 * To run a mutation, you first call `useFlagStockSaleAsBadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagStockSaleAsBadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagStockSaleAsBadMutation, { data, loading, error }] = useFlagStockSaleAsBadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFlagStockSaleAsBadMutation(baseOptions?: Apollo.MutationHookOptions<FlagStockSaleAsBadMutation, FlagStockSaleAsBadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagStockSaleAsBadMutation, FlagStockSaleAsBadMutationVariables>(FlagStockSaleAsBadDocument, options);
      }
export type FlagStockSaleAsBadMutationHookResult = ReturnType<typeof useFlagStockSaleAsBadMutation>;
export type FlagStockSaleAsBadMutationResult = Apollo.MutationResult<FlagStockSaleAsBadMutation>;
export type FlagStockSaleAsBadMutationOptions = Apollo.BaseMutationOptions<FlagStockSaleAsBadMutation, FlagStockSaleAsBadMutationVariables>;
export const UnflagStockSaleDocument = gql`
    mutation UnflagStockSale($input: UnflagStockSaleInput!) {
  unflagStockSale(input: $input) {
    id
    flaggedBadAt
    flaggedBadReason
    flaggedBadBy {
      id
    }
  }
}
    `;
export type UnflagStockSaleMutationFn = Apollo.MutationFunction<UnflagStockSaleMutation, UnflagStockSaleMutationVariables>;

/**
 * __useUnflagStockSaleMutation__
 *
 * To run a mutation, you first call `useUnflagStockSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnflagStockSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unflagStockSaleMutation, { data, loading, error }] = useUnflagStockSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnflagStockSaleMutation(baseOptions?: Apollo.MutationHookOptions<UnflagStockSaleMutation, UnflagStockSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnflagStockSaleMutation, UnflagStockSaleMutationVariables>(UnflagStockSaleDocument, options);
      }
export type UnflagStockSaleMutationHookResult = ReturnType<typeof useUnflagStockSaleMutation>;
export type UnflagStockSaleMutationResult = Apollo.MutationResult<UnflagStockSaleMutation>;
export type UnflagStockSaleMutationOptions = Apollo.BaseMutationOptions<UnflagStockSaleMutation, UnflagStockSaleMutationVariables>;
export const ReleaseDeviceDocument = gql`
    mutation ReleaseDevice($input: ReleaseDeviceInput!) {
  releaseDevice(input: $input) {
    id
    serialNumber
    accountNumber
    status
    condition
    stockingPoint {
      id
      name
    }
    releaseEligibility {
      eligible
      blocker
      hold
      explanation
      viewerMayRelease
    }
  }
}
    `;
export type ReleaseDeviceMutationFn = Apollo.MutationFunction<ReleaseDeviceMutation, ReleaseDeviceMutationVariables>;

/**
 * __useReleaseDeviceMutation__
 *
 * To run a mutation, you first call `useReleaseDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseDeviceMutation, { data, loading, error }] = useReleaseDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleaseDeviceMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseDeviceMutation, ReleaseDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseDeviceMutation, ReleaseDeviceMutationVariables>(ReleaseDeviceDocument, options);
      }
export type ReleaseDeviceMutationHookResult = ReturnType<typeof useReleaseDeviceMutation>;
export type ReleaseDeviceMutationResult = Apollo.MutationResult<ReleaseDeviceMutation>;
export type ReleaseDeviceMutationOptions = Apollo.BaseMutationOptions<ReleaseDeviceMutation, ReleaseDeviceMutationVariables>;
export const GetStockSaleProductNamesDocument = gql`
    query GetStockSaleProductNames {
  stockSaleProductNames
}
    `;

/**
 * __useGetStockSaleProductNamesQuery__
 *
 * To run a query within a React component, call `useGetStockSaleProductNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockSaleProductNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockSaleProductNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStockSaleProductNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>(GetStockSaleProductNamesDocument, options);
      }
export function useGetStockSaleProductNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>(GetStockSaleProductNamesDocument, options);
        }
// @ts-ignore
export function useGetStockSaleProductNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>;
export function useGetStockSaleProductNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockSaleProductNamesQuery | undefined, GetStockSaleProductNamesQueryVariables>;
export function useGetStockSaleProductNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>(GetStockSaleProductNamesDocument, options);
        }
export type GetStockSaleProductNamesQueryHookResult = ReturnType<typeof useGetStockSaleProductNamesQuery>;
export type GetStockSaleProductNamesLazyQueryHookResult = ReturnType<typeof useGetStockSaleProductNamesLazyQuery>;
export type GetStockSaleProductNamesSuspenseQueryHookResult = ReturnType<typeof useGetStockSaleProductNamesSuspenseQuery>;
export type GetStockSaleProductNamesQueryResult = Apollo.QueryResult<GetStockSaleProductNamesQuery, GetStockSaleProductNamesQueryVariables>;
export const ExportStockSalesDocument = gql`
    query ExportStockSales($input: StockSaleListInput) {
  exportStockSales(input: $input) {
    totalCount
    items {
      saleReference
      status
      saleDate
      notes
      createdAt
      distributorName
      nationalSalesManagerName
      stockItem {
        serialNumber
        accountNumber
        productName
      }
      agent {
        firstName
        lastName
        salesId
      }
      customer {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useExportStockSalesQuery__
 *
 * To run a query within a React component, call `useExportStockSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportStockSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportStockSalesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportStockSalesQuery(baseOptions?: Apollo.QueryHookOptions<ExportStockSalesQuery, ExportStockSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportStockSalesQuery, ExportStockSalesQueryVariables>(ExportStockSalesDocument, options);
      }
export function useExportStockSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportStockSalesQuery, ExportStockSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportStockSalesQuery, ExportStockSalesQueryVariables>(ExportStockSalesDocument, options);
        }
// @ts-ignore
export function useExportStockSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportStockSalesQuery, ExportStockSalesQueryVariables>): Apollo.UseSuspenseQueryResult<ExportStockSalesQuery, ExportStockSalesQueryVariables>;
export function useExportStockSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportStockSalesQuery, ExportStockSalesQueryVariables>): Apollo.UseSuspenseQueryResult<ExportStockSalesQuery | undefined, ExportStockSalesQueryVariables>;
export function useExportStockSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportStockSalesQuery, ExportStockSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportStockSalesQuery, ExportStockSalesQueryVariables>(ExportStockSalesDocument, options);
        }
export type ExportStockSalesQueryHookResult = ReturnType<typeof useExportStockSalesQuery>;
export type ExportStockSalesLazyQueryHookResult = ReturnType<typeof useExportStockSalesLazyQuery>;
export type ExportStockSalesSuspenseQueryHookResult = ReturnType<typeof useExportStockSalesSuspenseQuery>;
export type ExportStockSalesQueryResult = Apollo.QueryResult<ExportStockSalesQuery, ExportStockSalesQueryVariables>;
export const GetStockTakesDocument = gql`
    query GetStockTakes($stockingPointId: String, $status: StockTakeStatus) {
  stockTakes(stockingPointId: $stockingPointId, status: $status) {
    ...StockTakeHeader
  }
}
    ${StockTakeHeaderFragmentDoc}`;

/**
 * __useGetStockTakesQuery__
 *
 * To run a query within a React component, call `useGetStockTakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTakesQuery({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetStockTakesQuery(baseOptions?: Apollo.QueryHookOptions<GetStockTakesQuery, GetStockTakesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockTakesQuery, GetStockTakesQueryVariables>(GetStockTakesDocument, options);
      }
export function useGetStockTakesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockTakesQuery, GetStockTakesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockTakesQuery, GetStockTakesQueryVariables>(GetStockTakesDocument, options);
        }
// @ts-ignore
export function useGetStockTakesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockTakesQuery, GetStockTakesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTakesQuery, GetStockTakesQueryVariables>;
export function useGetStockTakesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTakesQuery, GetStockTakesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTakesQuery | undefined, GetStockTakesQueryVariables>;
export function useGetStockTakesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTakesQuery, GetStockTakesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockTakesQuery, GetStockTakesQueryVariables>(GetStockTakesDocument, options);
        }
export type GetStockTakesQueryHookResult = ReturnType<typeof useGetStockTakesQuery>;
export type GetStockTakesLazyQueryHookResult = ReturnType<typeof useGetStockTakesLazyQuery>;
export type GetStockTakesSuspenseQueryHookResult = ReturnType<typeof useGetStockTakesSuspenseQuery>;
export type GetStockTakesQueryResult = Apollo.QueryResult<GetStockTakesQuery, GetStockTakesQueryVariables>;
export const GetStockTakeDocument = gql`
    query GetStockTake($id: String!) {
  stockTake(id: $id) {
    ...StockTakeHeader
    lines {
      id
      condition
      expectedQuantity
      countedQuantity
      variance
      unitCostCents
      countedAt
      countedBy {
        id
        firstName
        lastName
      }
      product {
        id
        sku
        name
        lastCostCents
        unitOfMeasure {
          id
          name
        }
      }
    }
    units {
      id
      serial
      outcome
      scannedAt
      scannedBy {
        id
        firstName
        lastName
      }
      stockItem {
        id
        productName
        status
        stockingPoint {
          id
          name
        }
      }
    }
  }
}
    ${StockTakeHeaderFragmentDoc}`;

/**
 * __useGetStockTakeQuery__
 *
 * To run a query within a React component, call `useGetStockTakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTakeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStockTakeQuery(baseOptions: Apollo.QueryHookOptions<GetStockTakeQuery, GetStockTakeQueryVariables> & ({ variables: GetStockTakeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockTakeQuery, GetStockTakeQueryVariables>(GetStockTakeDocument, options);
      }
export function useGetStockTakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockTakeQuery, GetStockTakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockTakeQuery, GetStockTakeQueryVariables>(GetStockTakeDocument, options);
        }
// @ts-ignore
export function useGetStockTakeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockTakeQuery, GetStockTakeQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTakeQuery, GetStockTakeQueryVariables>;
export function useGetStockTakeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTakeQuery, GetStockTakeQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTakeQuery | undefined, GetStockTakeQueryVariables>;
export function useGetStockTakeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTakeQuery, GetStockTakeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockTakeQuery, GetStockTakeQueryVariables>(GetStockTakeDocument, options);
        }
export type GetStockTakeQueryHookResult = ReturnType<typeof useGetStockTakeQuery>;
export type GetStockTakeLazyQueryHookResult = ReturnType<typeof useGetStockTakeLazyQuery>;
export type GetStockTakeSuspenseQueryHookResult = ReturnType<typeof useGetStockTakeSuspenseQuery>;
export type GetStockTakeQueryResult = Apollo.QueryResult<GetStockTakeQuery, GetStockTakeQueryVariables>;
export const OpenStockTakeDocument = gql`
    mutation OpenStockTake($input: OpenStockTakeInput!) {
  openStockTake(input: $input) {
    id
    takeNumber
  }
}
    `;
export type OpenStockTakeMutationFn = Apollo.MutationFunction<OpenStockTakeMutation, OpenStockTakeMutationVariables>;

/**
 * __useOpenStockTakeMutation__
 *
 * To run a mutation, you first call `useOpenStockTakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenStockTakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openStockTakeMutation, { data, loading, error }] = useOpenStockTakeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenStockTakeMutation(baseOptions?: Apollo.MutationHookOptions<OpenStockTakeMutation, OpenStockTakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenStockTakeMutation, OpenStockTakeMutationVariables>(OpenStockTakeDocument, options);
      }
export type OpenStockTakeMutationHookResult = ReturnType<typeof useOpenStockTakeMutation>;
export type OpenStockTakeMutationResult = Apollo.MutationResult<OpenStockTakeMutation>;
export type OpenStockTakeMutationOptions = Apollo.BaseMutationOptions<OpenStockTakeMutation, OpenStockTakeMutationVariables>;
export const CountStockTakeLineDocument = gql`
    mutation CountStockTakeLine($lineId: String!, $countedQuantity: Int!) {
  countStockTakeLine(lineId: $lineId, countedQuantity: $countedQuantity) {
    id
    expectedQuantity
    countedQuantity
    variance
    countedAt
  }
}
    `;
export type CountStockTakeLineMutationFn = Apollo.MutationFunction<CountStockTakeLineMutation, CountStockTakeLineMutationVariables>;

/**
 * __useCountStockTakeLineMutation__
 *
 * To run a mutation, you first call `useCountStockTakeLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountStockTakeLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countStockTakeLineMutation, { data, loading, error }] = useCountStockTakeLineMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *      countedQuantity: // value for 'countedQuantity'
 *   },
 * });
 */
export function useCountStockTakeLineMutation(baseOptions?: Apollo.MutationHookOptions<CountStockTakeLineMutation, CountStockTakeLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CountStockTakeLineMutation, CountStockTakeLineMutationVariables>(CountStockTakeLineDocument, options);
      }
export type CountStockTakeLineMutationHookResult = ReturnType<typeof useCountStockTakeLineMutation>;
export type CountStockTakeLineMutationResult = Apollo.MutationResult<CountStockTakeLineMutation>;
export type CountStockTakeLineMutationOptions = Apollo.BaseMutationOptions<CountStockTakeLineMutation, CountStockTakeLineMutationVariables>;
export const AddStockTakeLineDocument = gql`
    mutation AddStockTakeLine($stockTakeId: String!, $productId: String!, $condition: StockCondition) {
  addStockTakeLine(
    stockTakeId: $stockTakeId
    productId: $productId
    condition: $condition
  ) {
    id
  }
}
    `;
export type AddStockTakeLineMutationFn = Apollo.MutationFunction<AddStockTakeLineMutation, AddStockTakeLineMutationVariables>;

/**
 * __useAddStockTakeLineMutation__
 *
 * To run a mutation, you first call `useAddStockTakeLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStockTakeLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStockTakeLineMutation, { data, loading, error }] = useAddStockTakeLineMutation({
 *   variables: {
 *      stockTakeId: // value for 'stockTakeId'
 *      productId: // value for 'productId'
 *      condition: // value for 'condition'
 *   },
 * });
 */
export function useAddStockTakeLineMutation(baseOptions?: Apollo.MutationHookOptions<AddStockTakeLineMutation, AddStockTakeLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStockTakeLineMutation, AddStockTakeLineMutationVariables>(AddStockTakeLineDocument, options);
      }
export type AddStockTakeLineMutationHookResult = ReturnType<typeof useAddStockTakeLineMutation>;
export type AddStockTakeLineMutationResult = Apollo.MutationResult<AddStockTakeLineMutation>;
export type AddStockTakeLineMutationOptions = Apollo.BaseMutationOptions<AddStockTakeLineMutation, AddStockTakeLineMutationVariables>;
export const ScanStockTakeUnitDocument = gql`
    mutation ScanStockTakeUnit($stockTakeId: String!, $serial: String!) {
  scanStockTakeUnit(stockTakeId: $stockTakeId, serial: $serial) {
    id
    serial
    outcome
  }
}
    `;
export type ScanStockTakeUnitMutationFn = Apollo.MutationFunction<ScanStockTakeUnitMutation, ScanStockTakeUnitMutationVariables>;

/**
 * __useScanStockTakeUnitMutation__
 *
 * To run a mutation, you first call `useScanStockTakeUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScanStockTakeUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scanStockTakeUnitMutation, { data, loading, error }] = useScanStockTakeUnitMutation({
 *   variables: {
 *      stockTakeId: // value for 'stockTakeId'
 *      serial: // value for 'serial'
 *   },
 * });
 */
export function useScanStockTakeUnitMutation(baseOptions?: Apollo.MutationHookOptions<ScanStockTakeUnitMutation, ScanStockTakeUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScanStockTakeUnitMutation, ScanStockTakeUnitMutationVariables>(ScanStockTakeUnitDocument, options);
      }
export type ScanStockTakeUnitMutationHookResult = ReturnType<typeof useScanStockTakeUnitMutation>;
export type ScanStockTakeUnitMutationResult = Apollo.MutationResult<ScanStockTakeUnitMutation>;
export type ScanStockTakeUnitMutationOptions = Apollo.BaseMutationOptions<ScanStockTakeUnitMutation, ScanStockTakeUnitMutationVariables>;
export const RemoveStockTakeScanDocument = gql`
    mutation RemoveStockTakeScan($stockTakeUnitId: String!) {
  removeStockTakeScan(stockTakeUnitId: $stockTakeUnitId)
}
    `;
export type RemoveStockTakeScanMutationFn = Apollo.MutationFunction<RemoveStockTakeScanMutation, RemoveStockTakeScanMutationVariables>;

/**
 * __useRemoveStockTakeScanMutation__
 *
 * To run a mutation, you first call `useRemoveStockTakeScanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStockTakeScanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStockTakeScanMutation, { data, loading, error }] = useRemoveStockTakeScanMutation({
 *   variables: {
 *      stockTakeUnitId: // value for 'stockTakeUnitId'
 *   },
 * });
 */
export function useRemoveStockTakeScanMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStockTakeScanMutation, RemoveStockTakeScanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStockTakeScanMutation, RemoveStockTakeScanMutationVariables>(RemoveStockTakeScanDocument, options);
      }
export type RemoveStockTakeScanMutationHookResult = ReturnType<typeof useRemoveStockTakeScanMutation>;
export type RemoveStockTakeScanMutationResult = Apollo.MutationResult<RemoveStockTakeScanMutation>;
export type RemoveStockTakeScanMutationOptions = Apollo.BaseMutationOptions<RemoveStockTakeScanMutation, RemoveStockTakeScanMutationVariables>;
export const SubmitStockTakeDocument = gql`
    mutation SubmitStockTake($id: String!) {
  submitStockTake(id: $id) {
    id
    status
  }
}
    `;
export type SubmitStockTakeMutationFn = Apollo.MutationFunction<SubmitStockTakeMutation, SubmitStockTakeMutationVariables>;

/**
 * __useSubmitStockTakeMutation__
 *
 * To run a mutation, you first call `useSubmitStockTakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitStockTakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitStockTakeMutation, { data, loading, error }] = useSubmitStockTakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitStockTakeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitStockTakeMutation, SubmitStockTakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitStockTakeMutation, SubmitStockTakeMutationVariables>(SubmitStockTakeDocument, options);
      }
export type SubmitStockTakeMutationHookResult = ReturnType<typeof useSubmitStockTakeMutation>;
export type SubmitStockTakeMutationResult = Apollo.MutationResult<SubmitStockTakeMutation>;
export type SubmitStockTakeMutationOptions = Apollo.BaseMutationOptions<SubmitStockTakeMutation, SubmitStockTakeMutationVariables>;
export const SendBackStockTakeDocument = gql`
    mutation SendBackStockTake($id: String!, $reason: String!) {
  sendBackStockTake(id: $id, reason: $reason) {
    id
    status
  }
}
    `;
export type SendBackStockTakeMutationFn = Apollo.MutationFunction<SendBackStockTakeMutation, SendBackStockTakeMutationVariables>;

/**
 * __useSendBackStockTakeMutation__
 *
 * To run a mutation, you first call `useSendBackStockTakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBackStockTakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBackStockTakeMutation, { data, loading, error }] = useSendBackStockTakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useSendBackStockTakeMutation(baseOptions?: Apollo.MutationHookOptions<SendBackStockTakeMutation, SendBackStockTakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBackStockTakeMutation, SendBackStockTakeMutationVariables>(SendBackStockTakeDocument, options);
      }
export type SendBackStockTakeMutationHookResult = ReturnType<typeof useSendBackStockTakeMutation>;
export type SendBackStockTakeMutationResult = Apollo.MutationResult<SendBackStockTakeMutation>;
export type SendBackStockTakeMutationOptions = Apollo.BaseMutationOptions<SendBackStockTakeMutation, SendBackStockTakeMutationVariables>;
export const ApproveStockTakeDocument = gql`
    mutation ApproveStockTake($id: String!) {
  approveStockTake(id: $id) {
    id
    status
  }
}
    `;
export type ApproveStockTakeMutationFn = Apollo.MutationFunction<ApproveStockTakeMutation, ApproveStockTakeMutationVariables>;

/**
 * __useApproveStockTakeMutation__
 *
 * To run a mutation, you first call `useApproveStockTakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveStockTakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveStockTakeMutation, { data, loading, error }] = useApproveStockTakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveStockTakeMutation(baseOptions?: Apollo.MutationHookOptions<ApproveStockTakeMutation, ApproveStockTakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveStockTakeMutation, ApproveStockTakeMutationVariables>(ApproveStockTakeDocument, options);
      }
export type ApproveStockTakeMutationHookResult = ReturnType<typeof useApproveStockTakeMutation>;
export type ApproveStockTakeMutationResult = Apollo.MutationResult<ApproveStockTakeMutation>;
export type ApproveStockTakeMutationOptions = Apollo.BaseMutationOptions<ApproveStockTakeMutation, ApproveStockTakeMutationVariables>;
export const CancelStockTakeDocument = gql`
    mutation CancelStockTake($id: String!, $reason: String!) {
  cancelStockTake(id: $id, reason: $reason) {
    id
    status
  }
}
    `;
export type CancelStockTakeMutationFn = Apollo.MutationFunction<CancelStockTakeMutation, CancelStockTakeMutationVariables>;

/**
 * __useCancelStockTakeMutation__
 *
 * To run a mutation, you first call `useCancelStockTakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStockTakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStockTakeMutation, { data, loading, error }] = useCancelStockTakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelStockTakeMutation(baseOptions?: Apollo.MutationHookOptions<CancelStockTakeMutation, CancelStockTakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelStockTakeMutation, CancelStockTakeMutationVariables>(CancelStockTakeDocument, options);
      }
export type CancelStockTakeMutationHookResult = ReturnType<typeof useCancelStockTakeMutation>;
export type CancelStockTakeMutationResult = Apollo.MutationResult<CancelStockTakeMutation>;
export type CancelStockTakeMutationOptions = Apollo.BaseMutationOptions<CancelStockTakeMutation, CancelStockTakeMutationVariables>;
export const GetAgentTransferDestinationsDocument = gql`
    query GetAgentTransferDestinations {
  agentTransferDestinations {
    stockingPointId
    stockingPointName
    label
  }
}
    `;

/**
 * __useGetAgentTransferDestinationsQuery__
 *
 * To run a query within a React component, call `useGetAgentTransferDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentTransferDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentTransferDestinationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentTransferDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>(GetAgentTransferDestinationsDocument, options);
      }
export function useGetAgentTransferDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>(GetAgentTransferDestinationsDocument, options);
        }
// @ts-ignore
export function useGetAgentTransferDestinationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>;
export function useGetAgentTransferDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentTransferDestinationsQuery | undefined, GetAgentTransferDestinationsQueryVariables>;
export function useGetAgentTransferDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>(GetAgentTransferDestinationsDocument, options);
        }
export type GetAgentTransferDestinationsQueryHookResult = ReturnType<typeof useGetAgentTransferDestinationsQuery>;
export type GetAgentTransferDestinationsLazyQueryHookResult = ReturnType<typeof useGetAgentTransferDestinationsLazyQuery>;
export type GetAgentTransferDestinationsSuspenseQueryHookResult = ReturnType<typeof useGetAgentTransferDestinationsSuspenseQuery>;
export type GetAgentTransferDestinationsQueryResult = Apollo.QueryResult<GetAgentTransferDestinationsQuery, GetAgentTransferDestinationsQueryVariables>;
export const GetTransferDestinationsDocument = gql`
    query GetTransferDestinations {
  transferDestinations {
    id
    stockingPointId
    name
    type
  }
}
    `;

/**
 * __useGetTransferDestinationsQuery__
 *
 * To run a query within a React component, call `useGetTransferDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferDestinationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransferDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>(GetTransferDestinationsDocument, options);
      }
export function useGetTransferDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>(GetTransferDestinationsDocument, options);
        }
// @ts-ignore
export function useGetTransferDestinationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>;
export function useGetTransferDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferDestinationsQuery | undefined, GetTransferDestinationsQueryVariables>;
export function useGetTransferDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>(GetTransferDestinationsDocument, options);
        }
export type GetTransferDestinationsQueryHookResult = ReturnType<typeof useGetTransferDestinationsQuery>;
export type GetTransferDestinationsLazyQueryHookResult = ReturnType<typeof useGetTransferDestinationsLazyQuery>;
export type GetTransferDestinationsSuspenseQueryHookResult = ReturnType<typeof useGetTransferDestinationsSuspenseQuery>;
export type GetTransferDestinationsQueryResult = Apollo.QueryResult<GetTransferDestinationsQuery, GetTransferDestinationsQueryVariables>;
export const GetTransferSourcesDocument = gql`
    query GetTransferSources {
  transferSources {
    id
    stockingPointId
    name
    type
  }
}
    `;

/**
 * __useGetTransferSourcesQuery__
 *
 * To run a query within a React component, call `useGetTransferSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransferSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>(GetTransferSourcesDocument, options);
      }
export function useGetTransferSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>(GetTransferSourcesDocument, options);
        }
// @ts-ignore
export function useGetTransferSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>;
export function useGetTransferSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferSourcesQuery | undefined, GetTransferSourcesQueryVariables>;
export function useGetTransferSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>(GetTransferSourcesDocument, options);
        }
export type GetTransferSourcesQueryHookResult = ReturnType<typeof useGetTransferSourcesQuery>;
export type GetTransferSourcesLazyQueryHookResult = ReturnType<typeof useGetTransferSourcesLazyQuery>;
export type GetTransferSourcesSuspenseQueryHookResult = ReturnType<typeof useGetTransferSourcesSuspenseQuery>;
export type GetTransferSourcesQueryResult = Apollo.QueryResult<GetTransferSourcesQuery, GetTransferSourcesQueryVariables>;
export const GetStockTransfersDocument = gql`
    query GetStockTransfers($input: StockTransferListInput) {
  stockTransfers(input: $input) {
    items {
      shipment {
        id
        state
        closedAt
      }
      id
      transferNumber
      status
      waybillReference
      completedAt
      cancelledAt
      createdAt
      sourceStockingPoint {
        id
        name
        stockingPointId
      }
      destinationStockingPoint {
        id
        name
        stockingPointId
      }
      createdBy {
        id
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetStockTransfersQuery__
 *
 * To run a query within a React component, call `useGetStockTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTransfersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockTransfersQuery(baseOptions?: Apollo.QueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockTransfersQuery, GetStockTransfersQueryVariables>(GetStockTransfersDocument, options);
      }
export function useGetStockTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockTransfersQuery, GetStockTransfersQueryVariables>(GetStockTransfersDocument, options);
        }
// @ts-ignore
export function useGetStockTransfersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTransfersQuery, GetStockTransfersQueryVariables>;
export function useGetStockTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTransfersQuery | undefined, GetStockTransfersQueryVariables>;
export function useGetStockTransfersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTransfersQuery, GetStockTransfersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockTransfersQuery, GetStockTransfersQueryVariables>(GetStockTransfersDocument, options);
        }
export type GetStockTransfersQueryHookResult = ReturnType<typeof useGetStockTransfersQuery>;
export type GetStockTransfersLazyQueryHookResult = ReturnType<typeof useGetStockTransfersLazyQuery>;
export type GetStockTransfersSuspenseQueryHookResult = ReturnType<typeof useGetStockTransfersSuspenseQuery>;
export type GetStockTransfersQueryResult = Apollo.QueryResult<GetStockTransfersQuery, GetStockTransfersQueryVariables>;
export const GetStockTransferDocument = gql`
    query GetStockTransfer($id: String!) {
  stockTransfer(id: $id) {
    id
    isReturnToHeadOffice
    transferNumber
    status
    dispatchedAt
    dispatchedByCourier
    shippingCompany {
      id
      name
      courier
    }
    waybillReference
    shipment {
      ...ShipmentFields
    }
    notes
    completedAt
    cancelledAt
    cancelReason
    createdAt
    updatedAt
    sourceStockingPoint {
      id
      name
      stockingPointId
      type
    }
    destinationStockingPoint {
      id
      name
      stockingPointId
      type
    }
    createdBy {
      id
      firstName
      lastName
    }
    dispatchedBy {
      id
      firstName
      lastName
    }
    completedBy {
      id
      firstName
      lastName
    }
    cancelledBy {
      id
      firstName
      lastName
    }
    lines {
      id
      quantity
      condition
      product {
        id
        sku
        name
      }
    }
    partRequests {
      id
      quantity
      status
      destinationStockingPoint {
        id
        name
      }
      workshopJob {
        id
        stockItem {
          id
          serialNumber
        }
      }
    }
    items {
      id
      stockItem {
        id
        serialNumber
        accountNumber
        productSku
        productName
        status
      }
    }
  }
}
    ${ShipmentFieldsFragmentDoc}`;

/**
 * __useGetStockTransferQuery__
 *
 * To run a query within a React component, call `useGetStockTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTransferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStockTransferQuery(baseOptions: Apollo.QueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables> & ({ variables: GetStockTransferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockTransferQuery, GetStockTransferQueryVariables>(GetStockTransferDocument, options);
      }
export function useGetStockTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockTransferQuery, GetStockTransferQueryVariables>(GetStockTransferDocument, options);
        }
// @ts-ignore
export function useGetStockTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTransferQuery, GetStockTransferQueryVariables>;
export function useGetStockTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTransferQuery | undefined, GetStockTransferQueryVariables>;
export function useGetStockTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTransferQuery, GetStockTransferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockTransferQuery, GetStockTransferQueryVariables>(GetStockTransferDocument, options);
        }
export type GetStockTransferQueryHookResult = ReturnType<typeof useGetStockTransferQuery>;
export type GetStockTransferLazyQueryHookResult = ReturnType<typeof useGetStockTransferLazyQuery>;
export type GetStockTransferSuspenseQueryHookResult = ReturnType<typeof useGetStockTransferSuspenseQuery>;
export type GetStockTransferQueryResult = Apollo.QueryResult<GetStockTransferQuery, GetStockTransferQueryVariables>;
export const ValidateSerialForTransferDocument = gql`
    query ValidateSerialForTransfer($serialNumber: String!, $sourceStockingPointId: String!) {
  validateSerialForTransfer(
    serialNumber: $serialNumber
    sourceStockingPointId: $sourceStockingPointId
  ) {
    id
    serialNumber
    productSku
    productName
    status
    product {
      id
      name
      sku
    }
  }
}
    `;

/**
 * __useValidateSerialForTransferQuery__
 *
 * To run a query within a React component, call `useValidateSerialForTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSerialForTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSerialForTransferQuery({
 *   variables: {
 *      serialNumber: // value for 'serialNumber'
 *      sourceStockingPointId: // value for 'sourceStockingPointId'
 *   },
 * });
 */
export function useValidateSerialForTransferQuery(baseOptions: Apollo.QueryHookOptions<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables> & ({ variables: ValidateSerialForTransferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>(ValidateSerialForTransferDocument, options);
      }
export function useValidateSerialForTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>(ValidateSerialForTransferDocument, options);
        }
// @ts-ignore
export function useValidateSerialForTransferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>;
export function useValidateSerialForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSerialForTransferQuery | undefined, ValidateSerialForTransferQueryVariables>;
export function useValidateSerialForTransferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>(ValidateSerialForTransferDocument, options);
        }
export type ValidateSerialForTransferQueryHookResult = ReturnType<typeof useValidateSerialForTransferQuery>;
export type ValidateSerialForTransferLazyQueryHookResult = ReturnType<typeof useValidateSerialForTransferLazyQuery>;
export type ValidateSerialForTransferSuspenseQueryHookResult = ReturnType<typeof useValidateSerialForTransferSuspenseQuery>;
export type ValidateSerialForTransferQueryResult = Apollo.QueryResult<ValidateSerialForTransferQuery, ValidateSerialForTransferQueryVariables>;
export const ValidateTransferItemsDocument = gql`
    query ValidateTransferItems($sourceStockingPointId: String!, $identifiers: [String!]!) {
  validateTransferItems(
    sourceStockingPointId: $sourceStockingPointId
    identifiers: $identifiers
  ) {
    identifier
    status
    stockItemId
    productName
    currentLocationName
    currentStatus
  }
}
    `;

/**
 * __useValidateTransferItemsQuery__
 *
 * To run a query within a React component, call `useValidateTransferItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTransferItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateTransferItemsQuery({
 *   variables: {
 *      sourceStockingPointId: // value for 'sourceStockingPointId'
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useValidateTransferItemsQuery(baseOptions: Apollo.QueryHookOptions<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables> & ({ variables: ValidateTransferItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>(ValidateTransferItemsDocument, options);
      }
export function useValidateTransferItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>(ValidateTransferItemsDocument, options);
        }
// @ts-ignore
export function useValidateTransferItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>;
export function useValidateTransferItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateTransferItemsQuery | undefined, ValidateTransferItemsQueryVariables>;
export function useValidateTransferItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>(ValidateTransferItemsDocument, options);
        }
export type ValidateTransferItemsQueryHookResult = ReturnType<typeof useValidateTransferItemsQuery>;
export type ValidateTransferItemsLazyQueryHookResult = ReturnType<typeof useValidateTransferItemsLazyQuery>;
export type ValidateTransferItemsSuspenseQueryHookResult = ReturnType<typeof useValidateTransferItemsSuspenseQuery>;
export type ValidateTransferItemsQueryResult = Apollo.QueryResult<ValidateTransferItemsQuery, ValidateTransferItemsQueryVariables>;
export const CreateStockTransferDocument = gql`
    mutation CreateStockTransfer($input: CreateStockTransferInput!) {
  createStockTransfer(input: $input) {
    id
    transferNumber
    status
  }
}
    `;
export type CreateStockTransferMutationFn = Apollo.MutationFunction<CreateStockTransferMutation, CreateStockTransferMutationVariables>;

/**
 * __useCreateStockTransferMutation__
 *
 * To run a mutation, you first call `useCreateStockTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockTransferMutation, { data, loading, error }] = useCreateStockTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockTransferMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockTransferMutation, CreateStockTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStockTransferMutation, CreateStockTransferMutationVariables>(CreateStockTransferDocument, options);
      }
export type CreateStockTransferMutationHookResult = ReturnType<typeof useCreateStockTransferMutation>;
export type CreateStockTransferMutationResult = Apollo.MutationResult<CreateStockTransferMutation>;
export type CreateStockTransferMutationOptions = Apollo.BaseMutationOptions<CreateStockTransferMutation, CreateStockTransferMutationVariables>;
export const CreateStockTransferFromSerialsDocument = gql`
    mutation CreateStockTransferFromSerials($input: CreateStockTransferFromSerialsInput!) {
  createStockTransferFromSerials(input: $input) {
    id
    transferNumber
    status
  }
}
    `;
export type CreateStockTransferFromSerialsMutationFn = Apollo.MutationFunction<CreateStockTransferFromSerialsMutation, CreateStockTransferFromSerialsMutationVariables>;

/**
 * __useCreateStockTransferFromSerialsMutation__
 *
 * To run a mutation, you first call `useCreateStockTransferFromSerialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockTransferFromSerialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockTransferFromSerialsMutation, { data, loading, error }] = useCreateStockTransferFromSerialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockTransferFromSerialsMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockTransferFromSerialsMutation, CreateStockTransferFromSerialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStockTransferFromSerialsMutation, CreateStockTransferFromSerialsMutationVariables>(CreateStockTransferFromSerialsDocument, options);
      }
export type CreateStockTransferFromSerialsMutationHookResult = ReturnType<typeof useCreateStockTransferFromSerialsMutation>;
export type CreateStockTransferFromSerialsMutationResult = Apollo.MutationResult<CreateStockTransferFromSerialsMutation>;
export type CreateStockTransferFromSerialsMutationOptions = Apollo.BaseMutationOptions<CreateStockTransferFromSerialsMutation, CreateStockTransferFromSerialsMutationVariables>;
export const CreateAgentTransferDocument = gql`
    mutation CreateAgentTransfer($input: CreateAgentTransferInput!) {
  createAgentTransfer(input: $input) {
    id
    transferNumber
    status
  }
}
    `;
export type CreateAgentTransferMutationFn = Apollo.MutationFunction<CreateAgentTransferMutation, CreateAgentTransferMutationVariables>;

/**
 * __useCreateAgentTransferMutation__
 *
 * To run a mutation, you first call `useCreateAgentTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentTransferMutation, { data, loading, error }] = useCreateAgentTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentTransferMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentTransferMutation, CreateAgentTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentTransferMutation, CreateAgentTransferMutationVariables>(CreateAgentTransferDocument, options);
      }
export type CreateAgentTransferMutationHookResult = ReturnType<typeof useCreateAgentTransferMutation>;
export type CreateAgentTransferMutationResult = Apollo.MutationResult<CreateAgentTransferMutation>;
export type CreateAgentTransferMutationOptions = Apollo.BaseMutationOptions<CreateAgentTransferMutation, CreateAgentTransferMutationVariables>;
export const DispatchStockTransferDocument = gql`
    mutation DispatchStockTransfer($id: String!) {
  dispatchStockTransfer(id: $id) {
    id
    status
  }
}
    `;
export type DispatchStockTransferMutationFn = Apollo.MutationFunction<DispatchStockTransferMutation, DispatchStockTransferMutationVariables>;

/**
 * __useDispatchStockTransferMutation__
 *
 * To run a mutation, you first call `useDispatchStockTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchStockTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchStockTransferMutation, { data, loading, error }] = useDispatchStockTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDispatchStockTransferMutation(baseOptions?: Apollo.MutationHookOptions<DispatchStockTransferMutation, DispatchStockTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispatchStockTransferMutation, DispatchStockTransferMutationVariables>(DispatchStockTransferDocument, options);
      }
export type DispatchStockTransferMutationHookResult = ReturnType<typeof useDispatchStockTransferMutation>;
export type DispatchStockTransferMutationResult = Apollo.MutationResult<DispatchStockTransferMutation>;
export type DispatchStockTransferMutationOptions = Apollo.BaseMutationOptions<DispatchStockTransferMutation, DispatchStockTransferMutationVariables>;
export const CompleteStockTransferDocument = gql`
    mutation CompleteStockTransfer($id: String!, $courierOverrideReason: String) {
  completeStockTransfer(id: $id, courierOverrideReason: $courierOverrideReason) {
    id
    status
    completedAt
  }
}
    `;
export type CompleteStockTransferMutationFn = Apollo.MutationFunction<CompleteStockTransferMutation, CompleteStockTransferMutationVariables>;

/**
 * __useCompleteStockTransferMutation__
 *
 * To run a mutation, you first call `useCompleteStockTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStockTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeStockTransferMutation, { data, loading, error }] = useCompleteStockTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierOverrideReason: // value for 'courierOverrideReason'
 *   },
 * });
 */
export function useCompleteStockTransferMutation(baseOptions?: Apollo.MutationHookOptions<CompleteStockTransferMutation, CompleteStockTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteStockTransferMutation, CompleteStockTransferMutationVariables>(CompleteStockTransferDocument, options);
      }
export type CompleteStockTransferMutationHookResult = ReturnType<typeof useCompleteStockTransferMutation>;
export type CompleteStockTransferMutationResult = Apollo.MutationResult<CompleteStockTransferMutation>;
export type CompleteStockTransferMutationOptions = Apollo.BaseMutationOptions<CompleteStockTransferMutation, CompleteStockTransferMutationVariables>;
export const CancelStockTransferDocument = gql`
    mutation CancelStockTransfer($id: String!, $reason: String!) {
  cancelStockTransfer(id: $id, reason: $reason) {
    id
    status
    cancelledAt
    cancelReason
  }
}
    `;
export type CancelStockTransferMutationFn = Apollo.MutationFunction<CancelStockTransferMutation, CancelStockTransferMutationVariables>;

/**
 * __useCancelStockTransferMutation__
 *
 * To run a mutation, you first call `useCancelStockTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStockTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStockTransferMutation, { data, loading, error }] = useCancelStockTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelStockTransferMutation(baseOptions?: Apollo.MutationHookOptions<CancelStockTransferMutation, CancelStockTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelStockTransferMutation, CancelStockTransferMutationVariables>(CancelStockTransferDocument, options);
      }
export type CancelStockTransferMutationHookResult = ReturnType<typeof useCancelStockTransferMutation>;
export type CancelStockTransferMutationResult = Apollo.MutationResult<CancelStockTransferMutation>;
export type CancelStockTransferMutationOptions = Apollo.BaseMutationOptions<CancelStockTransferMutation, CancelStockTransferMutationVariables>;
export const UpdateStockTransferShippingDocument = gql`
    mutation UpdateStockTransferShipping($id: String!, $input: ShippingDetailsInput!) {
  updateStockTransferShipping(id: $id, input: $input) {
    id
    shippingCompany {
      id
      name
      courier
    }
    waybillReference
    shipment {
      ...ShipmentFields
    }
  }
}
    ${ShipmentFieldsFragmentDoc}`;
export type UpdateStockTransferShippingMutationFn = Apollo.MutationFunction<UpdateStockTransferShippingMutation, UpdateStockTransferShippingMutationVariables>;

/**
 * __useUpdateStockTransferShippingMutation__
 *
 * To run a mutation, you first call `useUpdateStockTransferShippingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockTransferShippingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockTransferShippingMutation, { data, loading, error }] = useUpdateStockTransferShippingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStockTransferShippingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockTransferShippingMutation, UpdateStockTransferShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStockTransferShippingMutation, UpdateStockTransferShippingMutationVariables>(UpdateStockTransferShippingDocument, options);
      }
export type UpdateStockTransferShippingMutationHookResult = ReturnType<typeof useUpdateStockTransferShippingMutation>;
export type UpdateStockTransferShippingMutationResult = Apollo.MutationResult<UpdateStockTransferShippingMutation>;
export type UpdateStockTransferShippingMutationOptions = Apollo.BaseMutationOptions<UpdateStockTransferShippingMutation, UpdateStockTransferShippingMutationVariables>;
export const GetStockTypesDocument = gql`
    query GetStockTypes {
  stockTypes {
    id
    name
    isReplacement
    isSystem
    sortOrder
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetStockTypesQuery__
 *
 * To run a query within a React component, call `useGetStockTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStockTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetStockTypesQuery, GetStockTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockTypesQuery, GetStockTypesQueryVariables>(GetStockTypesDocument, options);
      }
export function useGetStockTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockTypesQuery, GetStockTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockTypesQuery, GetStockTypesQueryVariables>(GetStockTypesDocument, options);
        }
// @ts-ignore
export function useGetStockTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockTypesQuery, GetStockTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTypesQuery, GetStockTypesQueryVariables>;
export function useGetStockTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTypesQuery, GetStockTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockTypesQuery | undefined, GetStockTypesQueryVariables>;
export function useGetStockTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockTypesQuery, GetStockTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockTypesQuery, GetStockTypesQueryVariables>(GetStockTypesDocument, options);
        }
export type GetStockTypesQueryHookResult = ReturnType<typeof useGetStockTypesQuery>;
export type GetStockTypesLazyQueryHookResult = ReturnType<typeof useGetStockTypesLazyQuery>;
export type GetStockTypesSuspenseQueryHookResult = ReturnType<typeof useGetStockTypesSuspenseQuery>;
export type GetStockTypesQueryResult = Apollo.QueryResult<GetStockTypesQuery, GetStockTypesQueryVariables>;
export const CreateStockTypeDocument = gql`
    mutation CreateStockType($input: CreateStockTypeInput!) {
  createStockType(input: $input) {
    id
    name
    isReplacement
    isSystem
    sortOrder
  }
}
    `;
export type CreateStockTypeMutationFn = Apollo.MutationFunction<CreateStockTypeMutation, CreateStockTypeMutationVariables>;

/**
 * __useCreateStockTypeMutation__
 *
 * To run a mutation, you first call `useCreateStockTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockTypeMutation, { data, loading, error }] = useCreateStockTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockTypeMutation, CreateStockTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStockTypeMutation, CreateStockTypeMutationVariables>(CreateStockTypeDocument, options);
      }
export type CreateStockTypeMutationHookResult = ReturnType<typeof useCreateStockTypeMutation>;
export type CreateStockTypeMutationResult = Apollo.MutationResult<CreateStockTypeMutation>;
export type CreateStockTypeMutationOptions = Apollo.BaseMutationOptions<CreateStockTypeMutation, CreateStockTypeMutationVariables>;
export const UpdateStockTypeDocument = gql`
    mutation UpdateStockType($id: String!, $input: UpdateStockTypeInput!) {
  updateStockType(id: $id, input: $input) {
    id
    name
    isReplacement
    isSystem
    sortOrder
  }
}
    `;
export type UpdateStockTypeMutationFn = Apollo.MutationFunction<UpdateStockTypeMutation, UpdateStockTypeMutationVariables>;

/**
 * __useUpdateStockTypeMutation__
 *
 * To run a mutation, you first call `useUpdateStockTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockTypeMutation, { data, loading, error }] = useUpdateStockTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStockTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockTypeMutation, UpdateStockTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStockTypeMutation, UpdateStockTypeMutationVariables>(UpdateStockTypeDocument, options);
      }
export type UpdateStockTypeMutationHookResult = ReturnType<typeof useUpdateStockTypeMutation>;
export type UpdateStockTypeMutationResult = Apollo.MutationResult<UpdateStockTypeMutation>;
export type UpdateStockTypeMutationOptions = Apollo.BaseMutationOptions<UpdateStockTypeMutation, UpdateStockTypeMutationVariables>;
export const DeleteStockTypeDocument = gql`
    mutation DeleteStockType($id: String!) {
  deleteStockType(id: $id) {
    id
    name
  }
}
    `;
export type DeleteStockTypeMutationFn = Apollo.MutationFunction<DeleteStockTypeMutation, DeleteStockTypeMutationVariables>;

/**
 * __useDeleteStockTypeMutation__
 *
 * To run a mutation, you first call `useDeleteStockTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStockTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStockTypeMutation, { data, loading, error }] = useDeleteStockTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStockTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStockTypeMutation, DeleteStockTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStockTypeMutation, DeleteStockTypeMutationVariables>(DeleteStockTypeDocument, options);
      }
export type DeleteStockTypeMutationHookResult = ReturnType<typeof useDeleteStockTypeMutation>;
export type DeleteStockTypeMutationResult = Apollo.MutationResult<DeleteStockTypeMutation>;
export type DeleteStockTypeMutationOptions = Apollo.BaseMutationOptions<DeleteStockTypeMutation, DeleteStockTypeMutationVariables>;
export const GetStockingPointsDocument = gql`
    query GetStockingPoints($input: StockingPointListInput) {
  stockingPoints(input: $input) {
    items {
      id
      stockingPointId
      name
      type
      province
      municipality
      stockQuantityLimit
      minimumStockLevel
      isActive
      displayOrder
      createdAt
      parentStockingPoint {
        id
        name
        stockingPointId
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetStockingPointsQuery__
 *
 * To run a query within a React component, call `useGetStockingPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockingPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockingPointsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockingPointsQuery(baseOptions?: Apollo.QueryHookOptions<GetStockingPointsQuery, GetStockingPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockingPointsQuery, GetStockingPointsQueryVariables>(GetStockingPointsDocument, options);
      }
export function useGetStockingPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockingPointsQuery, GetStockingPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockingPointsQuery, GetStockingPointsQueryVariables>(GetStockingPointsDocument, options);
        }
// @ts-ignore
export function useGetStockingPointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockingPointsQuery, GetStockingPointsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockingPointsQuery, GetStockingPointsQueryVariables>;
export function useGetStockingPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockingPointsQuery, GetStockingPointsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockingPointsQuery | undefined, GetStockingPointsQueryVariables>;
export function useGetStockingPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockingPointsQuery, GetStockingPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockingPointsQuery, GetStockingPointsQueryVariables>(GetStockingPointsDocument, options);
        }
export type GetStockingPointsQueryHookResult = ReturnType<typeof useGetStockingPointsQuery>;
export type GetStockingPointsLazyQueryHookResult = ReturnType<typeof useGetStockingPointsLazyQuery>;
export type GetStockingPointsSuspenseQueryHookResult = ReturnType<typeof useGetStockingPointsSuspenseQuery>;
export type GetStockingPointsQueryResult = Apollo.QueryResult<GetStockingPointsQuery, GetStockingPointsQueryVariables>;
export const GetStockingPointDocument = gql`
    query GetStockingPoint($id: String!) {
  stockingPoint(id: $id) {
    id
    stockingPointId
    name
    type
    addressLine1
    addressLine2
    province
    municipality
    postalCode
    country
    stockQuantityLimit
    stockOnTheWay {
      arriving {
        devices
        transfers
        purchaseOrders
        uploads
      }
      leaving {
        devices
        transfers
      }
    }
    minimumStockLevel
    isActive
    canToggleActive
    canRename
    deactivatedAt
    deactivationReason
    deactivatedBy {
      id
      firstName
      lastName
    }
    createdAt
    updatedAt
    parentStockingPoint {
      id
      name
      stockingPointId
    }
    childStockingPoints {
      id
      name
      stockingPointId
      type
      isActive
    }
    users {
      id
      isPrimary
      agent {
        id
        firstName
        lastName
        salesId
        agentType
      }
    }
    members {
      id
      createdAt
      user {
        id
        firstName
        lastName
        email
        userRoles {
          id
          role {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetStockingPointQuery__
 *
 * To run a query within a React component, call `useGetStockingPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockingPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockingPointQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStockingPointQuery(baseOptions: Apollo.QueryHookOptions<GetStockingPointQuery, GetStockingPointQueryVariables> & ({ variables: GetStockingPointQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockingPointQuery, GetStockingPointQueryVariables>(GetStockingPointDocument, options);
      }
export function useGetStockingPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockingPointQuery, GetStockingPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockingPointQuery, GetStockingPointQueryVariables>(GetStockingPointDocument, options);
        }
// @ts-ignore
export function useGetStockingPointSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockingPointQuery, GetStockingPointQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockingPointQuery, GetStockingPointQueryVariables>;
export function useGetStockingPointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockingPointQuery, GetStockingPointQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockingPointQuery | undefined, GetStockingPointQueryVariables>;
export function useGetStockingPointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockingPointQuery, GetStockingPointQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockingPointQuery, GetStockingPointQueryVariables>(GetStockingPointDocument, options);
        }
export type GetStockingPointQueryHookResult = ReturnType<typeof useGetStockingPointQuery>;
export type GetStockingPointLazyQueryHookResult = ReturnType<typeof useGetStockingPointLazyQuery>;
export type GetStockingPointSuspenseQueryHookResult = ReturnType<typeof useGetStockingPointSuspenseQuery>;
export type GetStockingPointQueryResult = Apollo.QueryResult<GetStockingPointQuery, GetStockingPointQueryVariables>;
export const GetStockingPointInventoryDocument = gql`
    query GetStockingPointInventory($stockingPointId: String!, $limit: Int, $offset: Int, $status: StockItemStatus, $search: String, $kind: StockKind) {
  stockingPointInventory(
    stockingPointId: $stockingPointId
    limit: $limit
    offset: $offset
    status: $status
    search: $search
    kind: $kind
  ) {
    items {
      id
      serialNumber
      accountNumber
      productSku
      productName
      isMigrated
      stockType {
        id
        name
      }
      status
      createdAt
    }
    totalCount
    statusCounts {
      status
      count
    }
  }
}
    `;

/**
 * __useGetStockingPointInventoryQuery__
 *
 * To run a query within a React component, call `useGetStockingPointInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockingPointInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockingPointInventoryQuery({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useGetStockingPointInventoryQuery(baseOptions: Apollo.QueryHookOptions<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables> & ({ variables: GetStockingPointInventoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>(GetStockingPointInventoryDocument, options);
      }
export function useGetStockingPointInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>(GetStockingPointInventoryDocument, options);
        }
// @ts-ignore
export function useGetStockingPointInventorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>;
export function useGetStockingPointInventorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockingPointInventoryQuery | undefined, GetStockingPointInventoryQueryVariables>;
export function useGetStockingPointInventorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>(GetStockingPointInventoryDocument, options);
        }
export type GetStockingPointInventoryQueryHookResult = ReturnType<typeof useGetStockingPointInventoryQuery>;
export type GetStockingPointInventoryLazyQueryHookResult = ReturnType<typeof useGetStockingPointInventoryLazyQuery>;
export type GetStockingPointInventorySuspenseQueryHookResult = ReturnType<typeof useGetStockingPointInventorySuspenseQuery>;
export type GetStockingPointInventoryQueryResult = Apollo.QueryResult<GetStockingPointInventoryQuery, GetStockingPointInventoryQueryVariables>;
export const GetReplenishmentAlertsDocument = gql`
    query GetReplenishmentAlerts {
  replenishmentAlerts {
    stockingPoint {
      id
      stockingPointId
      name
      type
    }
    shortProductCount
    totalDeficit
    products {
      productId
      name
      sku
      availableCount
      arrivingCount
      minimumStockLevel
      deficit
    }
  }
}
    `;

/**
 * __useGetReplenishmentAlertsQuery__
 *
 * To run a query within a React component, call `useGetReplenishmentAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReplenishmentAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReplenishmentAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReplenishmentAlertsQuery(baseOptions?: Apollo.QueryHookOptions<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>(GetReplenishmentAlertsDocument, options);
      }
export function useGetReplenishmentAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>(GetReplenishmentAlertsDocument, options);
        }
// @ts-ignore
export function useGetReplenishmentAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>;
export function useGetReplenishmentAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReplenishmentAlertsQuery | undefined, GetReplenishmentAlertsQueryVariables>;
export function useGetReplenishmentAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>(GetReplenishmentAlertsDocument, options);
        }
export type GetReplenishmentAlertsQueryHookResult = ReturnType<typeof useGetReplenishmentAlertsQuery>;
export type GetReplenishmentAlertsLazyQueryHookResult = ReturnType<typeof useGetReplenishmentAlertsLazyQuery>;
export type GetReplenishmentAlertsSuspenseQueryHookResult = ReturnType<typeof useGetReplenishmentAlertsSuspenseQuery>;
export type GetReplenishmentAlertsQueryResult = Apollo.QueryResult<GetReplenishmentAlertsQuery, GetReplenishmentAlertsQueryVariables>;
export const GetStockingPointProductMinimumsDocument = gql`
    query GetStockingPointProductMinimums($stockingPointId: String!) {
  stockingPointProductMinimums(stockingPointId: $stockingPointId) {
    productId
    name
    sku
    minimumStockLevel
    availableCount
  }
}
    `;

/**
 * __useGetStockingPointProductMinimumsQuery__
 *
 * To run a query within a React component, call `useGetStockingPointProductMinimumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockingPointProductMinimumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockingPointProductMinimumsQuery({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *   },
 * });
 */
export function useGetStockingPointProductMinimumsQuery(baseOptions: Apollo.QueryHookOptions<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables> & ({ variables: GetStockingPointProductMinimumsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>(GetStockingPointProductMinimumsDocument, options);
      }
export function useGetStockingPointProductMinimumsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>(GetStockingPointProductMinimumsDocument, options);
        }
// @ts-ignore
export function useGetStockingPointProductMinimumsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>;
export function useGetStockingPointProductMinimumsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStockingPointProductMinimumsQuery | undefined, GetStockingPointProductMinimumsQueryVariables>;
export function useGetStockingPointProductMinimumsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>(GetStockingPointProductMinimumsDocument, options);
        }
export type GetStockingPointProductMinimumsQueryHookResult = ReturnType<typeof useGetStockingPointProductMinimumsQuery>;
export type GetStockingPointProductMinimumsLazyQueryHookResult = ReturnType<typeof useGetStockingPointProductMinimumsLazyQuery>;
export type GetStockingPointProductMinimumsSuspenseQueryHookResult = ReturnType<typeof useGetStockingPointProductMinimumsSuspenseQuery>;
export type GetStockingPointProductMinimumsQueryResult = Apollo.QueryResult<GetStockingPointProductMinimumsQuery, GetStockingPointProductMinimumsQueryVariables>;
export const SetStockingPointProductMinimumDocument = gql`
    mutation SetStockingPointProductMinimum($stockingPointId: String!, $productId: String!, $minimumStockLevel: Int!) {
  setStockingPointProductMinimum(
    stockingPointId: $stockingPointId
    productId: $productId
    minimumStockLevel: $minimumStockLevel
  ) {
    productId
    name
    sku
    minimumStockLevel
    availableCount
  }
}
    `;
export type SetStockingPointProductMinimumMutationFn = Apollo.MutationFunction<SetStockingPointProductMinimumMutation, SetStockingPointProductMinimumMutationVariables>;

/**
 * __useSetStockingPointProductMinimumMutation__
 *
 * To run a mutation, you first call `useSetStockingPointProductMinimumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStockingPointProductMinimumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStockingPointProductMinimumMutation, { data, loading, error }] = useSetStockingPointProductMinimumMutation({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *      productId: // value for 'productId'
 *      minimumStockLevel: // value for 'minimumStockLevel'
 *   },
 * });
 */
export function useSetStockingPointProductMinimumMutation(baseOptions?: Apollo.MutationHookOptions<SetStockingPointProductMinimumMutation, SetStockingPointProductMinimumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStockingPointProductMinimumMutation, SetStockingPointProductMinimumMutationVariables>(SetStockingPointProductMinimumDocument, options);
      }
export type SetStockingPointProductMinimumMutationHookResult = ReturnType<typeof useSetStockingPointProductMinimumMutation>;
export type SetStockingPointProductMinimumMutationResult = Apollo.MutationResult<SetStockingPointProductMinimumMutation>;
export type SetStockingPointProductMinimumMutationOptions = Apollo.BaseMutationOptions<SetStockingPointProductMinimumMutation, SetStockingPointProductMinimumMutationVariables>;
export const CreateStockingPointDocument = gql`
    mutation CreateStockingPoint($input: CreateStockingPointInput!) {
  createStockingPoint(input: $input) {
    id
    stockingPointId
    name
    type
  }
}
    `;
export type CreateStockingPointMutationFn = Apollo.MutationFunction<CreateStockingPointMutation, CreateStockingPointMutationVariables>;

/**
 * __useCreateStockingPointMutation__
 *
 * To run a mutation, you first call `useCreateStockingPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockingPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockingPointMutation, { data, loading, error }] = useCreateStockingPointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockingPointMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockingPointMutation, CreateStockingPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStockingPointMutation, CreateStockingPointMutationVariables>(CreateStockingPointDocument, options);
      }
export type CreateStockingPointMutationHookResult = ReturnType<typeof useCreateStockingPointMutation>;
export type CreateStockingPointMutationResult = Apollo.MutationResult<CreateStockingPointMutation>;
export type CreateStockingPointMutationOptions = Apollo.BaseMutationOptions<CreateStockingPointMutation, CreateStockingPointMutationVariables>;
export const UpdateStockingPointDocument = gql`
    mutation UpdateStockingPoint($id: String!, $input: UpdateStockingPointInput!) {
  updateStockingPoint(id: $id, input: $input) {
    id
    stockingPointId
    name
    type
    isActive
  }
}
    `;
export type UpdateStockingPointMutationFn = Apollo.MutationFunction<UpdateStockingPointMutation, UpdateStockingPointMutationVariables>;

/**
 * __useUpdateStockingPointMutation__
 *
 * To run a mutation, you first call `useUpdateStockingPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockingPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockingPointMutation, { data, loading, error }] = useUpdateStockingPointMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStockingPointMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockingPointMutation, UpdateStockingPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStockingPointMutation, UpdateStockingPointMutationVariables>(UpdateStockingPointDocument, options);
      }
export type UpdateStockingPointMutationHookResult = ReturnType<typeof useUpdateStockingPointMutation>;
export type UpdateStockingPointMutationResult = Apollo.MutationResult<UpdateStockingPointMutation>;
export type UpdateStockingPointMutationOptions = Apollo.BaseMutationOptions<UpdateStockingPointMutation, UpdateStockingPointMutationVariables>;
export const RenameStockingPointDocument = gql`
    mutation RenameStockingPoint($id: String!, $name: String!) {
  renameStockingPoint(id: $id, name: $name) {
    id
    name
    stockingPointId
  }
}
    `;
export type RenameStockingPointMutationFn = Apollo.MutationFunction<RenameStockingPointMutation, RenameStockingPointMutationVariables>;

/**
 * __useRenameStockingPointMutation__
 *
 * To run a mutation, you first call `useRenameStockingPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameStockingPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameStockingPointMutation, { data, loading, error }] = useRenameStockingPointMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameStockingPointMutation(baseOptions?: Apollo.MutationHookOptions<RenameStockingPointMutation, RenameStockingPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameStockingPointMutation, RenameStockingPointMutationVariables>(RenameStockingPointDocument, options);
      }
export type RenameStockingPointMutationHookResult = ReturnType<typeof useRenameStockingPointMutation>;
export type RenameStockingPointMutationResult = Apollo.MutationResult<RenameStockingPointMutation>;
export type RenameStockingPointMutationOptions = Apollo.BaseMutationOptions<RenameStockingPointMutation, RenameStockingPointMutationVariables>;
export const SetStockingPointActiveDocument = gql`
    mutation SetStockingPointActive($id: String!, $isActive: Boolean!, $reason: String!) {
  setStockingPointActive(id: $id, isActive: $isActive, reason: $reason) {
    id
    isActive
    canToggleActive
    deactivatedAt
    deactivationReason
    deactivatedBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type SetStockingPointActiveMutationFn = Apollo.MutationFunction<SetStockingPointActiveMutation, SetStockingPointActiveMutationVariables>;

/**
 * __useSetStockingPointActiveMutation__
 *
 * To run a mutation, you first call `useSetStockingPointActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStockingPointActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStockingPointActiveMutation, { data, loading, error }] = useSetStockingPointActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useSetStockingPointActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetStockingPointActiveMutation, SetStockingPointActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStockingPointActiveMutation, SetStockingPointActiveMutationVariables>(SetStockingPointActiveDocument, options);
      }
export type SetStockingPointActiveMutationHookResult = ReturnType<typeof useSetStockingPointActiveMutation>;
export type SetStockingPointActiveMutationResult = Apollo.MutationResult<SetStockingPointActiveMutation>;
export type SetStockingPointActiveMutationOptions = Apollo.BaseMutationOptions<SetStockingPointActiveMutation, SetStockingPointActiveMutationVariables>;
export const AssignAgentToStockingPointDocument = gql`
    mutation AssignAgentToStockingPoint($stockingPointId: String!, $agentId: String!) {
  assignAgentToStockingPoint(stockingPointId: $stockingPointId, agentId: $agentId) {
    id
    isPrimary
  }
}
    `;
export type AssignAgentToStockingPointMutationFn = Apollo.MutationFunction<AssignAgentToStockingPointMutation, AssignAgentToStockingPointMutationVariables>;

/**
 * __useAssignAgentToStockingPointMutation__
 *
 * To run a mutation, you first call `useAssignAgentToStockingPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAgentToStockingPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAgentToStockingPointMutation, { data, loading, error }] = useAssignAgentToStockingPointMutation({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useAssignAgentToStockingPointMutation(baseOptions?: Apollo.MutationHookOptions<AssignAgentToStockingPointMutation, AssignAgentToStockingPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAgentToStockingPointMutation, AssignAgentToStockingPointMutationVariables>(AssignAgentToStockingPointDocument, options);
      }
export type AssignAgentToStockingPointMutationHookResult = ReturnType<typeof useAssignAgentToStockingPointMutation>;
export type AssignAgentToStockingPointMutationResult = Apollo.MutationResult<AssignAgentToStockingPointMutation>;
export type AssignAgentToStockingPointMutationOptions = Apollo.BaseMutationOptions<AssignAgentToStockingPointMutation, AssignAgentToStockingPointMutationVariables>;
export const AssignWorkshopMemberDocument = gql`
    mutation AssignWorkshopMember($stockingPointId: String!, $userId: String!) {
  assignWorkshopMember(stockingPointId: $stockingPointId, userId: $userId) {
    id
    createdAt
    user {
      id
      firstName
      lastName
      email
    }
    stockingPoint {
      id
      name
    }
  }
}
    `;
export type AssignWorkshopMemberMutationFn = Apollo.MutationFunction<AssignWorkshopMemberMutation, AssignWorkshopMemberMutationVariables>;

/**
 * __useAssignWorkshopMemberMutation__
 *
 * To run a mutation, you first call `useAssignWorkshopMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignWorkshopMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignWorkshopMemberMutation, { data, loading, error }] = useAssignWorkshopMemberMutation({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignWorkshopMemberMutation(baseOptions?: Apollo.MutationHookOptions<AssignWorkshopMemberMutation, AssignWorkshopMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignWorkshopMemberMutation, AssignWorkshopMemberMutationVariables>(AssignWorkshopMemberDocument, options);
      }
export type AssignWorkshopMemberMutationHookResult = ReturnType<typeof useAssignWorkshopMemberMutation>;
export type AssignWorkshopMemberMutationResult = Apollo.MutationResult<AssignWorkshopMemberMutation>;
export type AssignWorkshopMemberMutationOptions = Apollo.BaseMutationOptions<AssignWorkshopMemberMutation, AssignWorkshopMemberMutationVariables>;
export const RemoveWorkshopMemberDocument = gql`
    mutation RemoveWorkshopMember($stockingPointId: String!, $userId: String!) {
  removeWorkshopMember(stockingPointId: $stockingPointId, userId: $userId)
}
    `;
export type RemoveWorkshopMemberMutationFn = Apollo.MutationFunction<RemoveWorkshopMemberMutation, RemoveWorkshopMemberMutationVariables>;

/**
 * __useRemoveWorkshopMemberMutation__
 *
 * To run a mutation, you first call `useRemoveWorkshopMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkshopMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkshopMemberMutation, { data, loading, error }] = useRemoveWorkshopMemberMutation({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveWorkshopMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkshopMemberMutation, RemoveWorkshopMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkshopMemberMutation, RemoveWorkshopMemberMutationVariables>(RemoveWorkshopMemberDocument, options);
      }
export type RemoveWorkshopMemberMutationHookResult = ReturnType<typeof useRemoveWorkshopMemberMutation>;
export type RemoveWorkshopMemberMutationResult = Apollo.MutationResult<RemoveWorkshopMemberMutation>;
export type RemoveWorkshopMemberMutationOptions = Apollo.BaseMutationOptions<RemoveWorkshopMemberMutation, RemoveWorkshopMemberMutationVariables>;
export const RemoveAgentFromStockingPointDocument = gql`
    mutation RemoveAgentFromStockingPoint($stockingPointId: String!, $agentId: String!) {
  removeAgentFromStockingPoint(
    stockingPointId: $stockingPointId
    agentId: $agentId
  )
}
    `;
export type RemoveAgentFromStockingPointMutationFn = Apollo.MutationFunction<RemoveAgentFromStockingPointMutation, RemoveAgentFromStockingPointMutationVariables>;

/**
 * __useRemoveAgentFromStockingPointMutation__
 *
 * To run a mutation, you first call `useRemoveAgentFromStockingPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAgentFromStockingPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAgentFromStockingPointMutation, { data, loading, error }] = useRemoveAgentFromStockingPointMutation({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useRemoveAgentFromStockingPointMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAgentFromStockingPointMutation, RemoveAgentFromStockingPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAgentFromStockingPointMutation, RemoveAgentFromStockingPointMutationVariables>(RemoveAgentFromStockingPointDocument, options);
      }
export type RemoveAgentFromStockingPointMutationHookResult = ReturnType<typeof useRemoveAgentFromStockingPointMutation>;
export type RemoveAgentFromStockingPointMutationResult = Apollo.MutationResult<RemoveAgentFromStockingPointMutation>;
export type RemoveAgentFromStockingPointMutationOptions = Apollo.BaseMutationOptions<RemoveAgentFromStockingPointMutation, RemoveAgentFromStockingPointMutationVariables>;
export const ReorderStockingPointsDocument = gql`
    mutation ReorderStockingPoints($orderedIds: [ID!]!) {
  reorderStockingPoints(orderedIds: $orderedIds) {
    id
    displayOrder
  }
}
    `;
export type ReorderStockingPointsMutationFn = Apollo.MutationFunction<ReorderStockingPointsMutation, ReorderStockingPointsMutationVariables>;

/**
 * __useReorderStockingPointsMutation__
 *
 * To run a mutation, you first call `useReorderStockingPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderStockingPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderStockingPointsMutation, { data, loading, error }] = useReorderStockingPointsMutation({
 *   variables: {
 *      orderedIds: // value for 'orderedIds'
 *   },
 * });
 */
export function useReorderStockingPointsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderStockingPointsMutation, ReorderStockingPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderStockingPointsMutation, ReorderStockingPointsMutationVariables>(ReorderStockingPointsDocument, options);
      }
export type ReorderStockingPointsMutationHookResult = ReturnType<typeof useReorderStockingPointsMutation>;
export type ReorderStockingPointsMutationResult = Apollo.MutationResult<ReorderStockingPointsMutation>;
export type ReorderStockingPointsMutationOptions = Apollo.BaseMutationOptions<ReorderStockingPointsMutation, ReorderStockingPointsMutationVariables>;
export const UpdateMinimumStockLevelDocument = gql`
    mutation UpdateMinimumStockLevel($id: String!, $minimumStockLevel: Int!) {
  updateMinimumStockLevel(id: $id, minimumStockLevel: $minimumStockLevel) {
    id
    minimumStockLevel
  }
}
    `;
export type UpdateMinimumStockLevelMutationFn = Apollo.MutationFunction<UpdateMinimumStockLevelMutation, UpdateMinimumStockLevelMutationVariables>;

/**
 * __useUpdateMinimumStockLevelMutation__
 *
 * To run a mutation, you first call `useUpdateMinimumStockLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMinimumStockLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMinimumStockLevelMutation, { data, loading, error }] = useUpdateMinimumStockLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      minimumStockLevel: // value for 'minimumStockLevel'
 *   },
 * });
 */
export function useUpdateMinimumStockLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMinimumStockLevelMutation, UpdateMinimumStockLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMinimumStockLevelMutation, UpdateMinimumStockLevelMutationVariables>(UpdateMinimumStockLevelDocument, options);
      }
export type UpdateMinimumStockLevelMutationHookResult = ReturnType<typeof useUpdateMinimumStockLevelMutation>;
export type UpdateMinimumStockLevelMutationResult = Apollo.MutationResult<UpdateMinimumStockLevelMutation>;
export type UpdateMinimumStockLevelMutationOptions = Apollo.BaseMutationOptions<UpdateMinimumStockLevelMutation, UpdateMinimumStockLevelMutationVariables>;
export const BatchAddDevicesToStockingPointDocument = gql`
    mutation BatchAddDevicesToStockingPoint($input: BatchAddDevicesInput!) {
  batchAddDevicesToStockingPoint(input: $input) {
    imported
    skipped
    skippedRows {
      row
      reason
    }
    errors {
      row
      reason
    }
  }
}
    `;
export type BatchAddDevicesToStockingPointMutationFn = Apollo.MutationFunction<BatchAddDevicesToStockingPointMutation, BatchAddDevicesToStockingPointMutationVariables>;

/**
 * __useBatchAddDevicesToStockingPointMutation__
 *
 * To run a mutation, you first call `useBatchAddDevicesToStockingPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchAddDevicesToStockingPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchAddDevicesToStockingPointMutation, { data, loading, error }] = useBatchAddDevicesToStockingPointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchAddDevicesToStockingPointMutation(baseOptions?: Apollo.MutationHookOptions<BatchAddDevicesToStockingPointMutation, BatchAddDevicesToStockingPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchAddDevicesToStockingPointMutation, BatchAddDevicesToStockingPointMutationVariables>(BatchAddDevicesToStockingPointDocument, options);
      }
export type BatchAddDevicesToStockingPointMutationHookResult = ReturnType<typeof useBatchAddDevicesToStockingPointMutation>;
export type BatchAddDevicesToStockingPointMutationResult = Apollo.MutationResult<BatchAddDevicesToStockingPointMutation>;
export type BatchAddDevicesToStockingPointMutationOptions = Apollo.BaseMutationOptions<BatchAddDevicesToStockingPointMutation, BatchAddDevicesToStockingPointMutationVariables>;
export const AddStockItemToStockingPointDocument = gql`
    mutation AddStockItemToStockingPoint($input: AddStockItemInput!) {
  addStockItemToStockingPoint(input: $input) {
    id
    serialNumber
    accountNumber
    productName
    stockType {
      id
      name
    }
    status
  }
}
    `;
export type AddStockItemToStockingPointMutationFn = Apollo.MutationFunction<AddStockItemToStockingPointMutation, AddStockItemToStockingPointMutationVariables>;

/**
 * __useAddStockItemToStockingPointMutation__
 *
 * To run a mutation, you first call `useAddStockItemToStockingPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStockItemToStockingPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStockItemToStockingPointMutation, { data, loading, error }] = useAddStockItemToStockingPointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStockItemToStockingPointMutation(baseOptions?: Apollo.MutationHookOptions<AddStockItemToStockingPointMutation, AddStockItemToStockingPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStockItemToStockingPointMutation, AddStockItemToStockingPointMutationVariables>(AddStockItemToStockingPointDocument, options);
      }
export type AddStockItemToStockingPointMutationHookResult = ReturnType<typeof useAddStockItemToStockingPointMutation>;
export type AddStockItemToStockingPointMutationResult = Apollo.MutationResult<AddStockItemToStockingPointMutation>;
export type AddStockItemToStockingPointMutationOptions = Apollo.BaseMutationOptions<AddStockItemToStockingPointMutation, AddStockItemToStockingPointMutationVariables>;
export const SubcontractorsDocument = gql`
    query Subcontractors($filter: SubcontractorFilterInput) {
  subcontractors(filter: $filter) {
    totalCount
    items {
      ...SubcontractorFields
    }
  }
}
    ${SubcontractorFieldsFragmentDoc}`;

/**
 * __useSubcontractorsQuery__
 *
 * To run a query within a React component, call `useSubcontractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractorsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSubcontractorsQuery(baseOptions?: Apollo.QueryHookOptions<SubcontractorsQuery, SubcontractorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcontractorsQuery, SubcontractorsQueryVariables>(SubcontractorsDocument, options);
      }
export function useSubcontractorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcontractorsQuery, SubcontractorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcontractorsQuery, SubcontractorsQueryVariables>(SubcontractorsDocument, options);
        }
// @ts-ignore
export function useSubcontractorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubcontractorsQuery, SubcontractorsQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorsQuery, SubcontractorsQueryVariables>;
export function useSubcontractorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorsQuery, SubcontractorsQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorsQuery | undefined, SubcontractorsQueryVariables>;
export function useSubcontractorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorsQuery, SubcontractorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubcontractorsQuery, SubcontractorsQueryVariables>(SubcontractorsDocument, options);
        }
export type SubcontractorsQueryHookResult = ReturnType<typeof useSubcontractorsQuery>;
export type SubcontractorsLazyQueryHookResult = ReturnType<typeof useSubcontractorsLazyQuery>;
export type SubcontractorsSuspenseQueryHookResult = ReturnType<typeof useSubcontractorsSuspenseQuery>;
export type SubcontractorsQueryResult = Apollo.QueryResult<SubcontractorsQuery, SubcontractorsQueryVariables>;
export const SubcontractorsExportDocument = gql`
    query SubcontractorsExport($filter: SubcontractorFilterInput) {
  subcontractorsExport(filter: $filter) {
    ...SubcontractorFields
  }
}
    ${SubcontractorFieldsFragmentDoc}`;

/**
 * __useSubcontractorsExportQuery__
 *
 * To run a query within a React component, call `useSubcontractorsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractorsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractorsExportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSubcontractorsExportQuery(baseOptions?: Apollo.QueryHookOptions<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>(SubcontractorsExportDocument, options);
      }
export function useSubcontractorsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>(SubcontractorsExportDocument, options);
        }
// @ts-ignore
export function useSubcontractorsExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>;
export function useSubcontractorsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorsExportQuery | undefined, SubcontractorsExportQueryVariables>;
export function useSubcontractorsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>(SubcontractorsExportDocument, options);
        }
export type SubcontractorsExportQueryHookResult = ReturnType<typeof useSubcontractorsExportQuery>;
export type SubcontractorsExportLazyQueryHookResult = ReturnType<typeof useSubcontractorsExportLazyQuery>;
export type SubcontractorsExportSuspenseQueryHookResult = ReturnType<typeof useSubcontractorsExportSuspenseQuery>;
export type SubcontractorsExportQueryResult = Apollo.QueryResult<SubcontractorsExportQuery, SubcontractorsExportQueryVariables>;
export const SubcontractorDocument = gql`
    query Subcontractor($id: ID!) {
  subcontractor(id: $id) {
    subcontractor {
      ...SubcontractorFields
    }
    workers {
      ...SubcontractorWorkerFields
    }
    invoices {
      ...SubcontractorInvoiceFields
    }
    complianceDocuments {
      ...SubcontractorComplianceFields
    }
  }
}
    ${SubcontractorFieldsFragmentDoc}
${SubcontractorWorkerFieldsFragmentDoc}
${SubcontractorInvoiceFieldsFragmentDoc}
${SubcontractorComplianceFieldsFragmentDoc}`;

/**
 * __useSubcontractorQuery__
 *
 * To run a query within a React component, call `useSubcontractorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubcontractorQuery(baseOptions: Apollo.QueryHookOptions<SubcontractorQuery, SubcontractorQueryVariables> & ({ variables: SubcontractorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcontractorQuery, SubcontractorQueryVariables>(SubcontractorDocument, options);
      }
export function useSubcontractorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcontractorQuery, SubcontractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcontractorQuery, SubcontractorQueryVariables>(SubcontractorDocument, options);
        }
// @ts-ignore
export function useSubcontractorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubcontractorQuery, SubcontractorQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorQuery, SubcontractorQueryVariables>;
export function useSubcontractorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorQuery, SubcontractorQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorQuery | undefined, SubcontractorQueryVariables>;
export function useSubcontractorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorQuery, SubcontractorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubcontractorQuery, SubcontractorQueryVariables>(SubcontractorDocument, options);
        }
export type SubcontractorQueryHookResult = ReturnType<typeof useSubcontractorQuery>;
export type SubcontractorLazyQueryHookResult = ReturnType<typeof useSubcontractorLazyQuery>;
export type SubcontractorSuspenseQueryHookResult = ReturnType<typeof useSubcontractorSuspenseQuery>;
export type SubcontractorQueryResult = Apollo.QueryResult<SubcontractorQuery, SubcontractorQueryVariables>;
export const SubcontractorHoursDocument = gql`
    query SubcontractorHours($filter: SubcontractorHoursFilterInput) {
  subcontractorHours(filter: $filter) {
    totalCount
    totalHours
    items {
      ...SubcontractorHoursFields
    }
  }
}
    ${SubcontractorHoursFieldsFragmentDoc}`;

/**
 * __useSubcontractorHoursQuery__
 *
 * To run a query within a React component, call `useSubcontractorHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractorHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractorHoursQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSubcontractorHoursQuery(baseOptions?: Apollo.QueryHookOptions<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>(SubcontractorHoursDocument, options);
      }
export function useSubcontractorHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>(SubcontractorHoursDocument, options);
        }
// @ts-ignore
export function useSubcontractorHoursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>;
export function useSubcontractorHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorHoursQuery | undefined, SubcontractorHoursQueryVariables>;
export function useSubcontractorHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>(SubcontractorHoursDocument, options);
        }
export type SubcontractorHoursQueryHookResult = ReturnType<typeof useSubcontractorHoursQuery>;
export type SubcontractorHoursLazyQueryHookResult = ReturnType<typeof useSubcontractorHoursLazyQuery>;
export type SubcontractorHoursSuspenseQueryHookResult = ReturnType<typeof useSubcontractorHoursSuspenseQuery>;
export type SubcontractorHoursQueryResult = Apollo.QueryResult<SubcontractorHoursQuery, SubcontractorHoursQueryVariables>;
export const SubcontractorComplianceDocumentsDocument = gql`
    query SubcontractorComplianceDocuments($filter: SubcontractorComplianceFilterInput) {
  subcontractorComplianceDocuments(filter: $filter) {
    ...SubcontractorComplianceFields
  }
}
    ${SubcontractorComplianceFieldsFragmentDoc}`;

/**
 * __useSubcontractorComplianceDocumentsQuery__
 *
 * To run a query within a React component, call `useSubcontractorComplianceDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractorComplianceDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractorComplianceDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSubcontractorComplianceDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>(SubcontractorComplianceDocumentsDocument, options);
      }
export function useSubcontractorComplianceDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>(SubcontractorComplianceDocumentsDocument, options);
        }
// @ts-ignore
export function useSubcontractorComplianceDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>;
export function useSubcontractorComplianceDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorComplianceDocumentsQuery | undefined, SubcontractorComplianceDocumentsQueryVariables>;
export function useSubcontractorComplianceDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>(SubcontractorComplianceDocumentsDocument, options);
        }
export type SubcontractorComplianceDocumentsQueryHookResult = ReturnType<typeof useSubcontractorComplianceDocumentsQuery>;
export type SubcontractorComplianceDocumentsLazyQueryHookResult = ReturnType<typeof useSubcontractorComplianceDocumentsLazyQuery>;
export type SubcontractorComplianceDocumentsSuspenseQueryHookResult = ReturnType<typeof useSubcontractorComplianceDocumentsSuspenseQuery>;
export type SubcontractorComplianceDocumentsQueryResult = Apollo.QueryResult<SubcontractorComplianceDocumentsQuery, SubcontractorComplianceDocumentsQueryVariables>;
export const SubcontractorAgentOptionsDocument = gql`
    query SubcontractorAgentOptions($search: String) {
  subcontractorAgentOptions(search: $search) {
    id
    firstName
    lastName
    salesId
  }
}
    `;

/**
 * __useSubcontractorAgentOptionsQuery__
 *
 * To run a query within a React component, call `useSubcontractorAgentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractorAgentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractorAgentOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSubcontractorAgentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>(SubcontractorAgentOptionsDocument, options);
      }
export function useSubcontractorAgentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>(SubcontractorAgentOptionsDocument, options);
        }
// @ts-ignore
export function useSubcontractorAgentOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>;
export function useSubcontractorAgentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorAgentOptionsQuery | undefined, SubcontractorAgentOptionsQueryVariables>;
export function useSubcontractorAgentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>(SubcontractorAgentOptionsDocument, options);
        }
export type SubcontractorAgentOptionsQueryHookResult = ReturnType<typeof useSubcontractorAgentOptionsQuery>;
export type SubcontractorAgentOptionsLazyQueryHookResult = ReturnType<typeof useSubcontractorAgentOptionsLazyQuery>;
export type SubcontractorAgentOptionsSuspenseQueryHookResult = ReturnType<typeof useSubcontractorAgentOptionsSuspenseQuery>;
export type SubcontractorAgentOptionsQueryResult = Apollo.QueryResult<SubcontractorAgentOptionsQuery, SubcontractorAgentOptionsQueryVariables>;
export const SubcontractorMetricsDocument = gql`
    query SubcontractorMetrics($from: DateTime!, $to: DateTime!) {
  subcontractorMetrics(from: $from, to: $to) {
    from
    to
    activeSubcontractors {
      ...HrMetricFields
    }
    activeWorkers {
      ...HrMetricFields
    }
    hoursWorked {
      ...HrMetricFields
    }
    spend {
      ...HrMetricFields
    }
    complianceExpired {
      ...HrMetricFields
    }
    complianceExpiring {
      ...HrMetricFields
    }
    withoutValidCoida {
      ...HrMetricFields
    }
    inductedPercent {
      ...HrMetricFields
    }
    incidents {
      ...HrMetricFields
    }
    lostTimeIncidents {
      ...HrMetricFields
    }
    spendBySubcontractor {
      subcontractorId
      name
      spend {
        ...HrMetricFields
      }
    }
    bbbeeLevels {
      level
      count
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useSubcontractorMetricsQuery__
 *
 * To run a query within a React component, call `useSubcontractorMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractorMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractorMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSubcontractorMetricsQuery(baseOptions: Apollo.QueryHookOptions<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables> & ({ variables: SubcontractorMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>(SubcontractorMetricsDocument, options);
      }
export function useSubcontractorMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>(SubcontractorMetricsDocument, options);
        }
// @ts-ignore
export function useSubcontractorMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>;
export function useSubcontractorMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<SubcontractorMetricsQuery | undefined, SubcontractorMetricsQueryVariables>;
export function useSubcontractorMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>(SubcontractorMetricsDocument, options);
        }
export type SubcontractorMetricsQueryHookResult = ReturnType<typeof useSubcontractorMetricsQuery>;
export type SubcontractorMetricsLazyQueryHookResult = ReturnType<typeof useSubcontractorMetricsLazyQuery>;
export type SubcontractorMetricsSuspenseQueryHookResult = ReturnType<typeof useSubcontractorMetricsSuspenseQuery>;
export type SubcontractorMetricsQueryResult = Apollo.QueryResult<SubcontractorMetricsQuery, SubcontractorMetricsQueryVariables>;
export const CreateSubcontractorDocument = gql`
    mutation CreateSubcontractor($input: CreateSubcontractorInput!) {
  createSubcontractor(input: $input) {
    ...SubcontractorFields
  }
}
    ${SubcontractorFieldsFragmentDoc}`;
export type CreateSubcontractorMutationFn = Apollo.MutationFunction<CreateSubcontractorMutation, CreateSubcontractorMutationVariables>;

/**
 * __useCreateSubcontractorMutation__
 *
 * To run a mutation, you first call `useCreateSubcontractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubcontractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubcontractorMutation, { data, loading, error }] = useCreateSubcontractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubcontractorMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubcontractorMutation, CreateSubcontractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubcontractorMutation, CreateSubcontractorMutationVariables>(CreateSubcontractorDocument, options);
      }
export type CreateSubcontractorMutationHookResult = ReturnType<typeof useCreateSubcontractorMutation>;
export type CreateSubcontractorMutationResult = Apollo.MutationResult<CreateSubcontractorMutation>;
export type CreateSubcontractorMutationOptions = Apollo.BaseMutationOptions<CreateSubcontractorMutation, CreateSubcontractorMutationVariables>;
export const UpdateSubcontractorDocument = gql`
    mutation UpdateSubcontractor($id: ID!, $input: UpdateSubcontractorInput!) {
  updateSubcontractor(id: $id, input: $input) {
    ...SubcontractorFields
  }
}
    ${SubcontractorFieldsFragmentDoc}`;
export type UpdateSubcontractorMutationFn = Apollo.MutationFunction<UpdateSubcontractorMutation, UpdateSubcontractorMutationVariables>;

/**
 * __useUpdateSubcontractorMutation__
 *
 * To run a mutation, you first call `useUpdateSubcontractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubcontractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubcontractorMutation, { data, loading, error }] = useUpdateSubcontractorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubcontractorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubcontractorMutation, UpdateSubcontractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubcontractorMutation, UpdateSubcontractorMutationVariables>(UpdateSubcontractorDocument, options);
      }
export type UpdateSubcontractorMutationHookResult = ReturnType<typeof useUpdateSubcontractorMutation>;
export type UpdateSubcontractorMutationResult = Apollo.MutationResult<UpdateSubcontractorMutation>;
export type UpdateSubcontractorMutationOptions = Apollo.BaseMutationOptions<UpdateSubcontractorMutation, UpdateSubcontractorMutationVariables>;
export const DeleteSubcontractorDocument = gql`
    mutation DeleteSubcontractor($id: ID!) {
  deleteSubcontractor(id: $id)
}
    `;
export type DeleteSubcontractorMutationFn = Apollo.MutationFunction<DeleteSubcontractorMutation, DeleteSubcontractorMutationVariables>;

/**
 * __useDeleteSubcontractorMutation__
 *
 * To run a mutation, you first call `useDeleteSubcontractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubcontractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubcontractorMutation, { data, loading, error }] = useDeleteSubcontractorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubcontractorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubcontractorMutation, DeleteSubcontractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubcontractorMutation, DeleteSubcontractorMutationVariables>(DeleteSubcontractorDocument, options);
      }
export type DeleteSubcontractorMutationHookResult = ReturnType<typeof useDeleteSubcontractorMutation>;
export type DeleteSubcontractorMutationResult = Apollo.MutationResult<DeleteSubcontractorMutation>;
export type DeleteSubcontractorMutationOptions = Apollo.BaseMutationOptions<DeleteSubcontractorMutation, DeleteSubcontractorMutationVariables>;
export const CreateSubcontractorWorkerDocument = gql`
    mutation CreateSubcontractorWorker($subcontractorId: ID!, $input: CreateSubcontractorWorkerInput!) {
  createSubcontractorWorker(subcontractorId: $subcontractorId, input: $input) {
    ...SubcontractorWorkerFields
  }
}
    ${SubcontractorWorkerFieldsFragmentDoc}`;
export type CreateSubcontractorWorkerMutationFn = Apollo.MutationFunction<CreateSubcontractorWorkerMutation, CreateSubcontractorWorkerMutationVariables>;

/**
 * __useCreateSubcontractorWorkerMutation__
 *
 * To run a mutation, you first call `useCreateSubcontractorWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubcontractorWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubcontractorWorkerMutation, { data, loading, error }] = useCreateSubcontractorWorkerMutation({
 *   variables: {
 *      subcontractorId: // value for 'subcontractorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubcontractorWorkerMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubcontractorWorkerMutation, CreateSubcontractorWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubcontractorWorkerMutation, CreateSubcontractorWorkerMutationVariables>(CreateSubcontractorWorkerDocument, options);
      }
export type CreateSubcontractorWorkerMutationHookResult = ReturnType<typeof useCreateSubcontractorWorkerMutation>;
export type CreateSubcontractorWorkerMutationResult = Apollo.MutationResult<CreateSubcontractorWorkerMutation>;
export type CreateSubcontractorWorkerMutationOptions = Apollo.BaseMutationOptions<CreateSubcontractorWorkerMutation, CreateSubcontractorWorkerMutationVariables>;
export const UpdateSubcontractorWorkerDocument = gql`
    mutation UpdateSubcontractorWorker($id: ID!, $input: UpdateSubcontractorWorkerInput!) {
  updateSubcontractorWorker(id: $id, input: $input) {
    ...SubcontractorWorkerFields
  }
}
    ${SubcontractorWorkerFieldsFragmentDoc}`;
export type UpdateSubcontractorWorkerMutationFn = Apollo.MutationFunction<UpdateSubcontractorWorkerMutation, UpdateSubcontractorWorkerMutationVariables>;

/**
 * __useUpdateSubcontractorWorkerMutation__
 *
 * To run a mutation, you first call `useUpdateSubcontractorWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubcontractorWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubcontractorWorkerMutation, { data, loading, error }] = useUpdateSubcontractorWorkerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubcontractorWorkerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubcontractorWorkerMutation, UpdateSubcontractorWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubcontractorWorkerMutation, UpdateSubcontractorWorkerMutationVariables>(UpdateSubcontractorWorkerDocument, options);
      }
export type UpdateSubcontractorWorkerMutationHookResult = ReturnType<typeof useUpdateSubcontractorWorkerMutation>;
export type UpdateSubcontractorWorkerMutationResult = Apollo.MutationResult<UpdateSubcontractorWorkerMutation>;
export type UpdateSubcontractorWorkerMutationOptions = Apollo.BaseMutationOptions<UpdateSubcontractorWorkerMutation, UpdateSubcontractorWorkerMutationVariables>;
export const DeleteSubcontractorWorkerDocument = gql`
    mutation DeleteSubcontractorWorker($id: ID!) {
  deleteSubcontractorWorker(id: $id)
}
    `;
export type DeleteSubcontractorWorkerMutationFn = Apollo.MutationFunction<DeleteSubcontractorWorkerMutation, DeleteSubcontractorWorkerMutationVariables>;

/**
 * __useDeleteSubcontractorWorkerMutation__
 *
 * To run a mutation, you first call `useDeleteSubcontractorWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubcontractorWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubcontractorWorkerMutation, { data, loading, error }] = useDeleteSubcontractorWorkerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubcontractorWorkerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubcontractorWorkerMutation, DeleteSubcontractorWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubcontractorWorkerMutation, DeleteSubcontractorWorkerMutationVariables>(DeleteSubcontractorWorkerDocument, options);
      }
export type DeleteSubcontractorWorkerMutationHookResult = ReturnType<typeof useDeleteSubcontractorWorkerMutation>;
export type DeleteSubcontractorWorkerMutationResult = Apollo.MutationResult<DeleteSubcontractorWorkerMutation>;
export type DeleteSubcontractorWorkerMutationOptions = Apollo.BaseMutationOptions<DeleteSubcontractorWorkerMutation, DeleteSubcontractorWorkerMutationVariables>;
export const CreateSubcontractorHoursDocument = gql`
    mutation CreateSubcontractorHours($workerId: ID!, $input: CreateSubcontractorHoursInput!) {
  createSubcontractorHours(workerId: $workerId, input: $input) {
    ...SubcontractorHoursFields
  }
}
    ${SubcontractorHoursFieldsFragmentDoc}`;
export type CreateSubcontractorHoursMutationFn = Apollo.MutationFunction<CreateSubcontractorHoursMutation, CreateSubcontractorHoursMutationVariables>;

/**
 * __useCreateSubcontractorHoursMutation__
 *
 * To run a mutation, you first call `useCreateSubcontractorHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubcontractorHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubcontractorHoursMutation, { data, loading, error }] = useCreateSubcontractorHoursMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubcontractorHoursMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubcontractorHoursMutation, CreateSubcontractorHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubcontractorHoursMutation, CreateSubcontractorHoursMutationVariables>(CreateSubcontractorHoursDocument, options);
      }
export type CreateSubcontractorHoursMutationHookResult = ReturnType<typeof useCreateSubcontractorHoursMutation>;
export type CreateSubcontractorHoursMutationResult = Apollo.MutationResult<CreateSubcontractorHoursMutation>;
export type CreateSubcontractorHoursMutationOptions = Apollo.BaseMutationOptions<CreateSubcontractorHoursMutation, CreateSubcontractorHoursMutationVariables>;
export const UpdateSubcontractorHoursDocument = gql`
    mutation UpdateSubcontractorHours($id: ID!, $input: UpdateSubcontractorHoursInput!) {
  updateSubcontractorHours(id: $id, input: $input) {
    ...SubcontractorHoursFields
  }
}
    ${SubcontractorHoursFieldsFragmentDoc}`;
export type UpdateSubcontractorHoursMutationFn = Apollo.MutationFunction<UpdateSubcontractorHoursMutation, UpdateSubcontractorHoursMutationVariables>;

/**
 * __useUpdateSubcontractorHoursMutation__
 *
 * To run a mutation, you first call `useUpdateSubcontractorHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubcontractorHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubcontractorHoursMutation, { data, loading, error }] = useUpdateSubcontractorHoursMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubcontractorHoursMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubcontractorHoursMutation, UpdateSubcontractorHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubcontractorHoursMutation, UpdateSubcontractorHoursMutationVariables>(UpdateSubcontractorHoursDocument, options);
      }
export type UpdateSubcontractorHoursMutationHookResult = ReturnType<typeof useUpdateSubcontractorHoursMutation>;
export type UpdateSubcontractorHoursMutationResult = Apollo.MutationResult<UpdateSubcontractorHoursMutation>;
export type UpdateSubcontractorHoursMutationOptions = Apollo.BaseMutationOptions<UpdateSubcontractorHoursMutation, UpdateSubcontractorHoursMutationVariables>;
export const DeleteSubcontractorHoursDocument = gql`
    mutation DeleteSubcontractorHours($id: ID!) {
  deleteSubcontractorHours(id: $id)
}
    `;
export type DeleteSubcontractorHoursMutationFn = Apollo.MutationFunction<DeleteSubcontractorHoursMutation, DeleteSubcontractorHoursMutationVariables>;

/**
 * __useDeleteSubcontractorHoursMutation__
 *
 * To run a mutation, you first call `useDeleteSubcontractorHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubcontractorHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubcontractorHoursMutation, { data, loading, error }] = useDeleteSubcontractorHoursMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubcontractorHoursMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubcontractorHoursMutation, DeleteSubcontractorHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubcontractorHoursMutation, DeleteSubcontractorHoursMutationVariables>(DeleteSubcontractorHoursDocument, options);
      }
export type DeleteSubcontractorHoursMutationHookResult = ReturnType<typeof useDeleteSubcontractorHoursMutation>;
export type DeleteSubcontractorHoursMutationResult = Apollo.MutationResult<DeleteSubcontractorHoursMutation>;
export type DeleteSubcontractorHoursMutationOptions = Apollo.BaseMutationOptions<DeleteSubcontractorHoursMutation, DeleteSubcontractorHoursMutationVariables>;
export const ImportSubcontractorHoursDocument = gql`
    mutation ImportSubcontractorHours($subcontractorId: ID!, $csv: String!) {
  importSubcontractorHours(subcontractorId: $subcontractorId, csv: $csv) {
    imported
    errors {
      line
      message
    }
  }
}
    `;
export type ImportSubcontractorHoursMutationFn = Apollo.MutationFunction<ImportSubcontractorHoursMutation, ImportSubcontractorHoursMutationVariables>;

/**
 * __useImportSubcontractorHoursMutation__
 *
 * To run a mutation, you first call `useImportSubcontractorHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportSubcontractorHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importSubcontractorHoursMutation, { data, loading, error }] = useImportSubcontractorHoursMutation({
 *   variables: {
 *      subcontractorId: // value for 'subcontractorId'
 *      csv: // value for 'csv'
 *   },
 * });
 */
export function useImportSubcontractorHoursMutation(baseOptions?: Apollo.MutationHookOptions<ImportSubcontractorHoursMutation, ImportSubcontractorHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportSubcontractorHoursMutation, ImportSubcontractorHoursMutationVariables>(ImportSubcontractorHoursDocument, options);
      }
export type ImportSubcontractorHoursMutationHookResult = ReturnType<typeof useImportSubcontractorHoursMutation>;
export type ImportSubcontractorHoursMutationResult = Apollo.MutationResult<ImportSubcontractorHoursMutation>;
export type ImportSubcontractorHoursMutationOptions = Apollo.BaseMutationOptions<ImportSubcontractorHoursMutation, ImportSubcontractorHoursMutationVariables>;
export const CreateSubcontractorInvoiceDocument = gql`
    mutation CreateSubcontractorInvoice($subcontractorId: ID!, $input: CreateSubcontractorInvoiceInput!) {
  createSubcontractorInvoice(subcontractorId: $subcontractorId, input: $input) {
    ...SubcontractorInvoiceFields
  }
}
    ${SubcontractorInvoiceFieldsFragmentDoc}`;
export type CreateSubcontractorInvoiceMutationFn = Apollo.MutationFunction<CreateSubcontractorInvoiceMutation, CreateSubcontractorInvoiceMutationVariables>;

/**
 * __useCreateSubcontractorInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateSubcontractorInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubcontractorInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubcontractorInvoiceMutation, { data, loading, error }] = useCreateSubcontractorInvoiceMutation({
 *   variables: {
 *      subcontractorId: // value for 'subcontractorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubcontractorInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubcontractorInvoiceMutation, CreateSubcontractorInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubcontractorInvoiceMutation, CreateSubcontractorInvoiceMutationVariables>(CreateSubcontractorInvoiceDocument, options);
      }
export type CreateSubcontractorInvoiceMutationHookResult = ReturnType<typeof useCreateSubcontractorInvoiceMutation>;
export type CreateSubcontractorInvoiceMutationResult = Apollo.MutationResult<CreateSubcontractorInvoiceMutation>;
export type CreateSubcontractorInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateSubcontractorInvoiceMutation, CreateSubcontractorInvoiceMutationVariables>;
export const UpdateSubcontractorInvoiceDocument = gql`
    mutation UpdateSubcontractorInvoice($id: ID!, $input: UpdateSubcontractorInvoiceInput!) {
  updateSubcontractorInvoice(id: $id, input: $input) {
    ...SubcontractorInvoiceFields
  }
}
    ${SubcontractorInvoiceFieldsFragmentDoc}`;
export type UpdateSubcontractorInvoiceMutationFn = Apollo.MutationFunction<UpdateSubcontractorInvoiceMutation, UpdateSubcontractorInvoiceMutationVariables>;

/**
 * __useUpdateSubcontractorInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateSubcontractorInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubcontractorInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubcontractorInvoiceMutation, { data, loading, error }] = useUpdateSubcontractorInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubcontractorInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubcontractorInvoiceMutation, UpdateSubcontractorInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubcontractorInvoiceMutation, UpdateSubcontractorInvoiceMutationVariables>(UpdateSubcontractorInvoiceDocument, options);
      }
export type UpdateSubcontractorInvoiceMutationHookResult = ReturnType<typeof useUpdateSubcontractorInvoiceMutation>;
export type UpdateSubcontractorInvoiceMutationResult = Apollo.MutationResult<UpdateSubcontractorInvoiceMutation>;
export type UpdateSubcontractorInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateSubcontractorInvoiceMutation, UpdateSubcontractorInvoiceMutationVariables>;
export const DeleteSubcontractorInvoiceDocument = gql`
    mutation DeleteSubcontractorInvoice($id: ID!) {
  deleteSubcontractorInvoice(id: $id)
}
    `;
export type DeleteSubcontractorInvoiceMutationFn = Apollo.MutationFunction<DeleteSubcontractorInvoiceMutation, DeleteSubcontractorInvoiceMutationVariables>;

/**
 * __useDeleteSubcontractorInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteSubcontractorInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubcontractorInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubcontractorInvoiceMutation, { data, loading, error }] = useDeleteSubcontractorInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubcontractorInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubcontractorInvoiceMutation, DeleteSubcontractorInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubcontractorInvoiceMutation, DeleteSubcontractorInvoiceMutationVariables>(DeleteSubcontractorInvoiceDocument, options);
      }
export type DeleteSubcontractorInvoiceMutationHookResult = ReturnType<typeof useDeleteSubcontractorInvoiceMutation>;
export type DeleteSubcontractorInvoiceMutationResult = Apollo.MutationResult<DeleteSubcontractorInvoiceMutation>;
export type DeleteSubcontractorInvoiceMutationOptions = Apollo.BaseMutationOptions<DeleteSubcontractorInvoiceMutation, DeleteSubcontractorInvoiceMutationVariables>;
export const CreateSubcontractorComplianceDocumentDocument = gql`
    mutation CreateSubcontractorComplianceDocument($subcontractorId: ID!, $input: CreateSubcontractorComplianceInput!) {
  createSubcontractorComplianceDocument(
    subcontractorId: $subcontractorId
    input: $input
  ) {
    ...SubcontractorComplianceFields
  }
}
    ${SubcontractorComplianceFieldsFragmentDoc}`;
export type CreateSubcontractorComplianceDocumentMutationFn = Apollo.MutationFunction<CreateSubcontractorComplianceDocumentMutation, CreateSubcontractorComplianceDocumentMutationVariables>;

/**
 * __useCreateSubcontractorComplianceDocumentMutation__
 *
 * To run a mutation, you first call `useCreateSubcontractorComplianceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubcontractorComplianceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubcontractorComplianceDocumentMutation, { data, loading, error }] = useCreateSubcontractorComplianceDocumentMutation({
 *   variables: {
 *      subcontractorId: // value for 'subcontractorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubcontractorComplianceDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubcontractorComplianceDocumentMutation, CreateSubcontractorComplianceDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubcontractorComplianceDocumentMutation, CreateSubcontractorComplianceDocumentMutationVariables>(CreateSubcontractorComplianceDocumentDocument, options);
      }
export type CreateSubcontractorComplianceDocumentMutationHookResult = ReturnType<typeof useCreateSubcontractorComplianceDocumentMutation>;
export type CreateSubcontractorComplianceDocumentMutationResult = Apollo.MutationResult<CreateSubcontractorComplianceDocumentMutation>;
export type CreateSubcontractorComplianceDocumentMutationOptions = Apollo.BaseMutationOptions<CreateSubcontractorComplianceDocumentMutation, CreateSubcontractorComplianceDocumentMutationVariables>;
export const UpdateSubcontractorComplianceDocumentDocument = gql`
    mutation UpdateSubcontractorComplianceDocument($id: ID!, $input: UpdateSubcontractorComplianceInput!) {
  updateSubcontractorComplianceDocument(id: $id, input: $input) {
    ...SubcontractorComplianceFields
  }
}
    ${SubcontractorComplianceFieldsFragmentDoc}`;
export type UpdateSubcontractorComplianceDocumentMutationFn = Apollo.MutationFunction<UpdateSubcontractorComplianceDocumentMutation, UpdateSubcontractorComplianceDocumentMutationVariables>;

/**
 * __useUpdateSubcontractorComplianceDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateSubcontractorComplianceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubcontractorComplianceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubcontractorComplianceDocumentMutation, { data, loading, error }] = useUpdateSubcontractorComplianceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubcontractorComplianceDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubcontractorComplianceDocumentMutation, UpdateSubcontractorComplianceDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubcontractorComplianceDocumentMutation, UpdateSubcontractorComplianceDocumentMutationVariables>(UpdateSubcontractorComplianceDocumentDocument, options);
      }
export type UpdateSubcontractorComplianceDocumentMutationHookResult = ReturnType<typeof useUpdateSubcontractorComplianceDocumentMutation>;
export type UpdateSubcontractorComplianceDocumentMutationResult = Apollo.MutationResult<UpdateSubcontractorComplianceDocumentMutation>;
export type UpdateSubcontractorComplianceDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateSubcontractorComplianceDocumentMutation, UpdateSubcontractorComplianceDocumentMutationVariables>;
export const DeleteSubcontractorComplianceDocumentDocument = gql`
    mutation DeleteSubcontractorComplianceDocument($id: ID!) {
  deleteSubcontractorComplianceDocument(id: $id)
}
    `;
export type DeleteSubcontractorComplianceDocumentMutationFn = Apollo.MutationFunction<DeleteSubcontractorComplianceDocumentMutation, DeleteSubcontractorComplianceDocumentMutationVariables>;

/**
 * __useDeleteSubcontractorComplianceDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteSubcontractorComplianceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubcontractorComplianceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubcontractorComplianceDocumentMutation, { data, loading, error }] = useDeleteSubcontractorComplianceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubcontractorComplianceDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubcontractorComplianceDocumentMutation, DeleteSubcontractorComplianceDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubcontractorComplianceDocumentMutation, DeleteSubcontractorComplianceDocumentMutationVariables>(DeleteSubcontractorComplianceDocumentDocument, options);
      }
export type DeleteSubcontractorComplianceDocumentMutationHookResult = ReturnType<typeof useDeleteSubcontractorComplianceDocumentMutation>;
export type DeleteSubcontractorComplianceDocumentMutationResult = Apollo.MutationResult<DeleteSubcontractorComplianceDocumentMutation>;
export type DeleteSubcontractorComplianceDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteSubcontractorComplianceDocumentMutation, DeleteSubcontractorComplianceDocumentMutationVariables>;
export const RemoveSubcontractorComplianceFileDocument = gql`
    mutation RemoveSubcontractorComplianceFile($documentId: ID!) {
  removeSubcontractorComplianceFile(documentId: $documentId)
}
    `;
export type RemoveSubcontractorComplianceFileMutationFn = Apollo.MutationFunction<RemoveSubcontractorComplianceFileMutation, RemoveSubcontractorComplianceFileMutationVariables>;

/**
 * __useRemoveSubcontractorComplianceFileMutation__
 *
 * To run a mutation, you first call `useRemoveSubcontractorComplianceFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSubcontractorComplianceFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSubcontractorComplianceFileMutation, { data, loading, error }] = useRemoveSubcontractorComplianceFileMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveSubcontractorComplianceFileMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSubcontractorComplianceFileMutation, RemoveSubcontractorComplianceFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSubcontractorComplianceFileMutation, RemoveSubcontractorComplianceFileMutationVariables>(RemoveSubcontractorComplianceFileDocument, options);
      }
export type RemoveSubcontractorComplianceFileMutationHookResult = ReturnType<typeof useRemoveSubcontractorComplianceFileMutation>;
export type RemoveSubcontractorComplianceFileMutationResult = Apollo.MutationResult<RemoveSubcontractorComplianceFileMutation>;
export type RemoveSubcontractorComplianceFileMutationOptions = Apollo.BaseMutationOptions<RemoveSubcontractorComplianceFileMutation, RemoveSubcontractorComplianceFileMutationVariables>;
export const GetSuppliersDocument = gql`
    query GetSuppliers($input: SupplierListInput) {
  suppliers(input: $input) {
    items {
      id
      name
      contactPerson
      email
      phone
      beeLevel
      beeStatus
      isActive
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetSuppliersQuery__
 *
 * To run a query within a React component, call `useGetSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
      }
export function useGetSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
// @ts-ignore
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuppliersQuery, GetSuppliersQueryVariables>;
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSuppliersQuery | undefined, GetSuppliersQueryVariables>;
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
export type GetSuppliersQueryHookResult = ReturnType<typeof useGetSuppliersQuery>;
export type GetSuppliersLazyQueryHookResult = ReturnType<typeof useGetSuppliersLazyQuery>;
export type GetSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetSuppliersSuspenseQuery>;
export type GetSuppliersQueryResult = Apollo.QueryResult<GetSuppliersQuery, GetSuppliersQueryVariables>;
export const GetSupplierDocument = gql`
    query GetSupplier($id: String!) {
  supplier(id: $id) {
    id
    name
    contactPerson
    email
    phone
    addressLine1
    addressLine2
    city
    province
    postalCode
    country
    beeLevel
    beeStatus
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetSupplierQuery__
 *
 * To run a query within a React component, call `useGetSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupplierQuery(baseOptions: Apollo.QueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables> & ({ variables: GetSupplierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplierQuery, GetSupplierQueryVariables>(GetSupplierDocument, options);
      }
export function useGetSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplierQuery, GetSupplierQueryVariables>(GetSupplierDocument, options);
        }
// @ts-ignore
export function useGetSupplierSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplierQuery, GetSupplierQueryVariables>;
export function useGetSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>): Apollo.UseSuspenseQueryResult<GetSupplierQuery | undefined, GetSupplierQueryVariables>;
export function useGetSupplierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplierQuery, GetSupplierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupplierQuery, GetSupplierQueryVariables>(GetSupplierDocument, options);
        }
export type GetSupplierQueryHookResult = ReturnType<typeof useGetSupplierQuery>;
export type GetSupplierLazyQueryHookResult = ReturnType<typeof useGetSupplierLazyQuery>;
export type GetSupplierSuspenseQueryHookResult = ReturnType<typeof useGetSupplierSuspenseQuery>;
export type GetSupplierQueryResult = Apollo.QueryResult<GetSupplierQuery, GetSupplierQueryVariables>;
export const CreateSupplierDocument = gql`
    mutation CreateSupplier($input: CreateSupplierInput!) {
  createSupplier(input: $input) {
    id
    name
  }
}
    `;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;

/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, options);
      }
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const UpdateSupplierDocument = gql`
    mutation UpdateSupplier($id: String!, $input: UpdateSupplierInput!) {
  updateSupplier(id: $id, input: $input) {
    id
    name
    isActive
  }
}
    `;
export type UpdateSupplierMutationFn = Apollo.MutationFunction<UpdateSupplierMutation, UpdateSupplierMutationVariables>;

/**
 * __useUpdateSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierMutation, { data, loading, error }] = useUpdateSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierMutation, UpdateSupplierMutationVariables>(UpdateSupplierDocument, options);
      }
export type UpdateSupplierMutationHookResult = ReturnType<typeof useUpdateSupplierMutation>;
export type UpdateSupplierMutationResult = Apollo.MutationResult<UpdateSupplierMutation>;
export type UpdateSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>;
export const GetThirdPartyCredentialsDocument = gql`
    query GetThirdPartyCredentials {
  thirdPartyCredentials {
    id
    provider
    name
    prefix
    notes
    isActive
    lastUsedAt
    createdAt
    updatedAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetThirdPartyCredentialsQuery__
 *
 * To run a query within a React component, call `useGetThirdPartyCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThirdPartyCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThirdPartyCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThirdPartyCredentialsQuery(baseOptions?: Apollo.QueryHookOptions<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>(GetThirdPartyCredentialsDocument, options);
      }
export function useGetThirdPartyCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>(GetThirdPartyCredentialsDocument, options);
        }
// @ts-ignore
export function useGetThirdPartyCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>;
export function useGetThirdPartyCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetThirdPartyCredentialsQuery | undefined, GetThirdPartyCredentialsQueryVariables>;
export function useGetThirdPartyCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>(GetThirdPartyCredentialsDocument, options);
        }
export type GetThirdPartyCredentialsQueryHookResult = ReturnType<typeof useGetThirdPartyCredentialsQuery>;
export type GetThirdPartyCredentialsLazyQueryHookResult = ReturnType<typeof useGetThirdPartyCredentialsLazyQuery>;
export type GetThirdPartyCredentialsSuspenseQueryHookResult = ReturnType<typeof useGetThirdPartyCredentialsSuspenseQuery>;
export type GetThirdPartyCredentialsQueryResult = Apollo.QueryResult<GetThirdPartyCredentialsQuery, GetThirdPartyCredentialsQueryVariables>;
export const CreateThirdPartyCredentialDocument = gql`
    mutation CreateThirdPartyCredential($input: CreateThirdPartyCredentialInput!) {
  createThirdPartyCredential(input: $input) {
    id
    provider
    name
    prefix
    notes
    isActive
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export type CreateThirdPartyCredentialMutationFn = Apollo.MutationFunction<CreateThirdPartyCredentialMutation, CreateThirdPartyCredentialMutationVariables>;

/**
 * __useCreateThirdPartyCredentialMutation__
 *
 * To run a mutation, you first call `useCreateThirdPartyCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThirdPartyCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThirdPartyCredentialMutation, { data, loading, error }] = useCreateThirdPartyCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateThirdPartyCredentialMutation(baseOptions?: Apollo.MutationHookOptions<CreateThirdPartyCredentialMutation, CreateThirdPartyCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThirdPartyCredentialMutation, CreateThirdPartyCredentialMutationVariables>(CreateThirdPartyCredentialDocument, options);
      }
export type CreateThirdPartyCredentialMutationHookResult = ReturnType<typeof useCreateThirdPartyCredentialMutation>;
export type CreateThirdPartyCredentialMutationResult = Apollo.MutationResult<CreateThirdPartyCredentialMutation>;
export type CreateThirdPartyCredentialMutationOptions = Apollo.BaseMutationOptions<CreateThirdPartyCredentialMutation, CreateThirdPartyCredentialMutationVariables>;
export const UpdateThirdPartyCredentialDocument = gql`
    mutation UpdateThirdPartyCredential($id: String!, $input: UpdateThirdPartyCredentialInput!) {
  updateThirdPartyCredential(id: $id, input: $input) {
    id
    provider
    name
    prefix
    notes
    isActive
    updatedAt
  }
}
    `;
export type UpdateThirdPartyCredentialMutationFn = Apollo.MutationFunction<UpdateThirdPartyCredentialMutation, UpdateThirdPartyCredentialMutationVariables>;

/**
 * __useUpdateThirdPartyCredentialMutation__
 *
 * To run a mutation, you first call `useUpdateThirdPartyCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThirdPartyCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThirdPartyCredentialMutation, { data, loading, error }] = useUpdateThirdPartyCredentialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateThirdPartyCredentialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThirdPartyCredentialMutation, UpdateThirdPartyCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThirdPartyCredentialMutation, UpdateThirdPartyCredentialMutationVariables>(UpdateThirdPartyCredentialDocument, options);
      }
export type UpdateThirdPartyCredentialMutationHookResult = ReturnType<typeof useUpdateThirdPartyCredentialMutation>;
export type UpdateThirdPartyCredentialMutationResult = Apollo.MutationResult<UpdateThirdPartyCredentialMutation>;
export type UpdateThirdPartyCredentialMutationOptions = Apollo.BaseMutationOptions<UpdateThirdPartyCredentialMutation, UpdateThirdPartyCredentialMutationVariables>;
export const RevokeThirdPartyCredentialDocument = gql`
    mutation RevokeThirdPartyCredential($id: String!) {
  revokeThirdPartyCredential(id: $id) {
    success
    message
  }
}
    `;
export type RevokeThirdPartyCredentialMutationFn = Apollo.MutationFunction<RevokeThirdPartyCredentialMutation, RevokeThirdPartyCredentialMutationVariables>;

/**
 * __useRevokeThirdPartyCredentialMutation__
 *
 * To run a mutation, you first call `useRevokeThirdPartyCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeThirdPartyCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeThirdPartyCredentialMutation, { data, loading, error }] = useRevokeThirdPartyCredentialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeThirdPartyCredentialMutation(baseOptions?: Apollo.MutationHookOptions<RevokeThirdPartyCredentialMutation, RevokeThirdPartyCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeThirdPartyCredentialMutation, RevokeThirdPartyCredentialMutationVariables>(RevokeThirdPartyCredentialDocument, options);
      }
export type RevokeThirdPartyCredentialMutationHookResult = ReturnType<typeof useRevokeThirdPartyCredentialMutation>;
export type RevokeThirdPartyCredentialMutationResult = Apollo.MutationResult<RevokeThirdPartyCredentialMutation>;
export type RevokeThirdPartyCredentialMutationOptions = Apollo.BaseMutationOptions<RevokeThirdPartyCredentialMutation, RevokeThirdPartyCredentialMutationVariables>;
export const DeleteThirdPartyCredentialDocument = gql`
    mutation DeleteThirdPartyCredential($id: String!) {
  deleteThirdPartyCredential(id: $id) {
    success
    message
  }
}
    `;
export type DeleteThirdPartyCredentialMutationFn = Apollo.MutationFunction<DeleteThirdPartyCredentialMutation, DeleteThirdPartyCredentialMutationVariables>;

/**
 * __useDeleteThirdPartyCredentialMutation__
 *
 * To run a mutation, you first call `useDeleteThirdPartyCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThirdPartyCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThirdPartyCredentialMutation, { data, loading, error }] = useDeleteThirdPartyCredentialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteThirdPartyCredentialMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThirdPartyCredentialMutation, DeleteThirdPartyCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThirdPartyCredentialMutation, DeleteThirdPartyCredentialMutationVariables>(DeleteThirdPartyCredentialDocument, options);
      }
export type DeleteThirdPartyCredentialMutationHookResult = ReturnType<typeof useDeleteThirdPartyCredentialMutation>;
export type DeleteThirdPartyCredentialMutationResult = Apollo.MutationResult<DeleteThirdPartyCredentialMutation>;
export type DeleteThirdPartyCredentialMutationOptions = Apollo.BaseMutationOptions<DeleteThirdPartyCredentialMutation, DeleteThirdPartyCredentialMutationVariables>;
export const RevealThirdPartyCredentialDocument = gql`
    query RevealThirdPartyCredential($id: String!) {
  revealThirdPartyCredential(id: $id) {
    id
    value
  }
}
    `;

/**
 * __useRevealThirdPartyCredentialQuery__
 *
 * To run a query within a React component, call `useRevealThirdPartyCredentialQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevealThirdPartyCredentialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevealThirdPartyCredentialQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevealThirdPartyCredentialQuery(baseOptions: Apollo.QueryHookOptions<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables> & ({ variables: RevealThirdPartyCredentialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>(RevealThirdPartyCredentialDocument, options);
      }
export function useRevealThirdPartyCredentialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>(RevealThirdPartyCredentialDocument, options);
        }
// @ts-ignore
export function useRevealThirdPartyCredentialSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>): Apollo.UseSuspenseQueryResult<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>;
export function useRevealThirdPartyCredentialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>): Apollo.UseSuspenseQueryResult<RevealThirdPartyCredentialQuery | undefined, RevealThirdPartyCredentialQueryVariables>;
export function useRevealThirdPartyCredentialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>(RevealThirdPartyCredentialDocument, options);
        }
export type RevealThirdPartyCredentialQueryHookResult = ReturnType<typeof useRevealThirdPartyCredentialQuery>;
export type RevealThirdPartyCredentialLazyQueryHookResult = ReturnType<typeof useRevealThirdPartyCredentialLazyQuery>;
export type RevealThirdPartyCredentialSuspenseQueryHookResult = ReturnType<typeof useRevealThirdPartyCredentialSuspenseQuery>;
export type RevealThirdPartyCredentialQueryResult = Apollo.QueryResult<RevealThirdPartyCredentialQuery, RevealThirdPartyCredentialQueryVariables>;
export const TrainingCoursesDocument = gql`
    query TrainingCourses {
  trainingCourses {
    ...TrainingCourseFields
  }
}
    ${TrainingCourseFieldsFragmentDoc}`;

/**
 * __useTrainingCoursesQuery__
 *
 * To run a query within a React component, call `useTrainingCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrainingCoursesQuery(baseOptions?: Apollo.QueryHookOptions<TrainingCoursesQuery, TrainingCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingCoursesQuery, TrainingCoursesQueryVariables>(TrainingCoursesDocument, options);
      }
export function useTrainingCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingCoursesQuery, TrainingCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingCoursesQuery, TrainingCoursesQueryVariables>(TrainingCoursesDocument, options);
        }
// @ts-ignore
export function useTrainingCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainingCoursesQuery, TrainingCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingCoursesQuery, TrainingCoursesQueryVariables>;
export function useTrainingCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingCoursesQuery, TrainingCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingCoursesQuery | undefined, TrainingCoursesQueryVariables>;
export function useTrainingCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingCoursesQuery, TrainingCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainingCoursesQuery, TrainingCoursesQueryVariables>(TrainingCoursesDocument, options);
        }
export type TrainingCoursesQueryHookResult = ReturnType<typeof useTrainingCoursesQuery>;
export type TrainingCoursesLazyQueryHookResult = ReturnType<typeof useTrainingCoursesLazyQuery>;
export type TrainingCoursesSuspenseQueryHookResult = ReturnType<typeof useTrainingCoursesSuspenseQuery>;
export type TrainingCoursesQueryResult = Apollo.QueryResult<TrainingCoursesQuery, TrainingCoursesQueryVariables>;
export const TrainingSessionsDocument = gql`
    query TrainingSessions($filter: TrainingSessionFilterInput) {
  trainingSessions(filter: $filter) {
    items {
      ...TrainingSessionFields
    }
    totalCount
  }
}
    ${TrainingSessionFieldsFragmentDoc}`;

/**
 * __useTrainingSessionsQuery__
 *
 * To run a query within a React component, call `useTrainingSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingSessionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTrainingSessionsQuery(baseOptions?: Apollo.QueryHookOptions<TrainingSessionsQuery, TrainingSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingSessionsQuery, TrainingSessionsQueryVariables>(TrainingSessionsDocument, options);
      }
export function useTrainingSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingSessionsQuery, TrainingSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingSessionsQuery, TrainingSessionsQueryVariables>(TrainingSessionsDocument, options);
        }
// @ts-ignore
export function useTrainingSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainingSessionsQuery, TrainingSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingSessionsQuery, TrainingSessionsQueryVariables>;
export function useTrainingSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingSessionsQuery, TrainingSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingSessionsQuery | undefined, TrainingSessionsQueryVariables>;
export function useTrainingSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingSessionsQuery, TrainingSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainingSessionsQuery, TrainingSessionsQueryVariables>(TrainingSessionsDocument, options);
        }
export type TrainingSessionsQueryHookResult = ReturnType<typeof useTrainingSessionsQuery>;
export type TrainingSessionsLazyQueryHookResult = ReturnType<typeof useTrainingSessionsLazyQuery>;
export type TrainingSessionsSuspenseQueryHookResult = ReturnType<typeof useTrainingSessionsSuspenseQuery>;
export type TrainingSessionsQueryResult = Apollo.QueryResult<TrainingSessionsQuery, TrainingSessionsQueryVariables>;
export const TrainingSessionsExportDocument = gql`
    query TrainingSessionsExport($filter: TrainingSessionFilterInput) {
  trainingSessionsExport(filter: $filter) {
    ...TrainingSessionFields
  }
}
    ${TrainingSessionFieldsFragmentDoc}`;

/**
 * __useTrainingSessionsExportQuery__
 *
 * To run a query within a React component, call `useTrainingSessionsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingSessionsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingSessionsExportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTrainingSessionsExportQuery(baseOptions?: Apollo.QueryHookOptions<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>(TrainingSessionsExportDocument, options);
      }
export function useTrainingSessionsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>(TrainingSessionsExportDocument, options);
        }
// @ts-ignore
export function useTrainingSessionsExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>;
export function useTrainingSessionsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingSessionsExportQuery | undefined, TrainingSessionsExportQueryVariables>;
export function useTrainingSessionsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>(TrainingSessionsExportDocument, options);
        }
export type TrainingSessionsExportQueryHookResult = ReturnType<typeof useTrainingSessionsExportQuery>;
export type TrainingSessionsExportLazyQueryHookResult = ReturnType<typeof useTrainingSessionsExportLazyQuery>;
export type TrainingSessionsExportSuspenseQueryHookResult = ReturnType<typeof useTrainingSessionsExportSuspenseQuery>;
export type TrainingSessionsExportQueryResult = Apollo.QueryResult<TrainingSessionsExportQuery, TrainingSessionsExportQueryVariables>;
export const TrainingCertificationsDocument = gql`
    query TrainingCertifications($filter: TrainingCertificationFilterInput) {
  trainingCertifications(filter: $filter) {
    ...TrainingCertificationFields
  }
}
    ${TrainingCertificationFieldsFragmentDoc}`;

/**
 * __useTrainingCertificationsQuery__
 *
 * To run a query within a React component, call `useTrainingCertificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingCertificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingCertificationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTrainingCertificationsQuery(baseOptions?: Apollo.QueryHookOptions<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>(TrainingCertificationsDocument, options);
      }
export function useTrainingCertificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>(TrainingCertificationsDocument, options);
        }
// @ts-ignore
export function useTrainingCertificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>;
export function useTrainingCertificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingCertificationsQuery | undefined, TrainingCertificationsQueryVariables>;
export function useTrainingCertificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>(TrainingCertificationsDocument, options);
        }
export type TrainingCertificationsQueryHookResult = ReturnType<typeof useTrainingCertificationsQuery>;
export type TrainingCertificationsLazyQueryHookResult = ReturnType<typeof useTrainingCertificationsLazyQuery>;
export type TrainingCertificationsSuspenseQueryHookResult = ReturnType<typeof useTrainingCertificationsSuspenseQuery>;
export type TrainingCertificationsQueryResult = Apollo.QueryResult<TrainingCertificationsQuery, TrainingCertificationsQueryVariables>;
export const LearningProgrammesDocument = gql`
    query LearningProgrammes($filter: LearningProgrammeFilterInput) {
  learningProgrammes(filter: $filter) {
    ...LearningProgrammeFields
  }
}
    ${LearningProgrammeFieldsFragmentDoc}`;

/**
 * __useLearningProgrammesQuery__
 *
 * To run a query within a React component, call `useLearningProgrammesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningProgrammesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningProgrammesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLearningProgrammesQuery(baseOptions?: Apollo.QueryHookOptions<LearningProgrammesQuery, LearningProgrammesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningProgrammesQuery, LearningProgrammesQueryVariables>(LearningProgrammesDocument, options);
      }
export function useLearningProgrammesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningProgrammesQuery, LearningProgrammesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningProgrammesQuery, LearningProgrammesQueryVariables>(LearningProgrammesDocument, options);
        }
// @ts-ignore
export function useLearningProgrammesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningProgrammesQuery, LearningProgrammesQueryVariables>): Apollo.UseSuspenseQueryResult<LearningProgrammesQuery, LearningProgrammesQueryVariables>;
export function useLearningProgrammesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningProgrammesQuery, LearningProgrammesQueryVariables>): Apollo.UseSuspenseQueryResult<LearningProgrammesQuery | undefined, LearningProgrammesQueryVariables>;
export function useLearningProgrammesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningProgrammesQuery, LearningProgrammesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningProgrammesQuery, LearningProgrammesQueryVariables>(LearningProgrammesDocument, options);
        }
export type LearningProgrammesQueryHookResult = ReturnType<typeof useLearningProgrammesQuery>;
export type LearningProgrammesLazyQueryHookResult = ReturnType<typeof useLearningProgrammesLazyQuery>;
export type LearningProgrammesSuspenseQueryHookResult = ReturnType<typeof useLearningProgrammesSuspenseQuery>;
export type LearningProgrammesQueryResult = Apollo.QueryResult<LearningProgrammesQuery, LearningProgrammesQueryVariables>;
export const EmployeeTrainingDocument = gql`
    query EmployeeTraining($employeeId: ID!) {
  employeeTraining(employeeId: $employeeId) {
    employeeId
    sessions {
      ...TrainingSessionFields
    }
    certifications {
      ...TrainingCertificationFields
    }
    programmes {
      ...LearningProgrammeFields
    }
  }
}
    ${TrainingSessionFieldsFragmentDoc}
${TrainingCertificationFieldsFragmentDoc}
${LearningProgrammeFieldsFragmentDoc}`;

/**
 * __useEmployeeTrainingQuery__
 *
 * To run a query within a React component, call `useEmployeeTrainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeTrainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeTrainingQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeeTrainingQuery(baseOptions: Apollo.QueryHookOptions<EmployeeTrainingQuery, EmployeeTrainingQueryVariables> & ({ variables: EmployeeTrainingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>(EmployeeTrainingDocument, options);
      }
export function useEmployeeTrainingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>(EmployeeTrainingDocument, options);
        }
// @ts-ignore
export function useEmployeeTrainingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>;
export function useEmployeeTrainingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeTrainingQuery | undefined, EmployeeTrainingQueryVariables>;
export function useEmployeeTrainingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>(EmployeeTrainingDocument, options);
        }
export type EmployeeTrainingQueryHookResult = ReturnType<typeof useEmployeeTrainingQuery>;
export type EmployeeTrainingLazyQueryHookResult = ReturnType<typeof useEmployeeTrainingLazyQuery>;
export type EmployeeTrainingSuspenseQueryHookResult = ReturnType<typeof useEmployeeTrainingSuspenseQuery>;
export type EmployeeTrainingQueryResult = Apollo.QueryResult<EmployeeTrainingQuery, EmployeeTrainingQueryVariables>;
export const TrainingMetricsDocument = gql`
    query TrainingMetrics($from: DateTime!, $to: DateTime!, $filter: TrainingMetricsFilterInput) {
  trainingMetrics(from: $from, to: $to, filter: $filter) {
    from
    to
    trainingHours {
      ...HrMetricFields
    }
    hoursPerEmployee {
      ...HrMetricFields
    }
    spend {
      ...HrMetricFields
    }
    spendPerEmployee {
      ...HrMetricFields
    }
    completionRate {
      ...HrMetricFields
    }
    peopleTrained {
      ...HrMetricFields
    }
    trainedPercent {
      ...HrMetricFields
    }
    mandatoryCompliance {
      ...HrMetricFields
    }
    mandatoryCourses {
      courseId
      courseName
      holders
      compliance {
        ...HrMetricFields
      }
    }
    expiringIn30 {
      ...HrMetricFields
    }
    expiringIn60 {
      ...HrMetricFields
    }
    expiringIn90 {
      ...HrMetricFields
    }
    expired {
      ...HrMetricFields
    }
    activeLearners {
      ...HrMetricFields
    }
    skillsSpendPercentOfPayroll {
      ...HrMetricFields
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useTrainingMetricsQuery__
 *
 * To run a query within a React component, call `useTrainingMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTrainingMetricsQuery(baseOptions: Apollo.QueryHookOptions<TrainingMetricsQuery, TrainingMetricsQueryVariables> & ({ variables: TrainingMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingMetricsQuery, TrainingMetricsQueryVariables>(TrainingMetricsDocument, options);
      }
export function useTrainingMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingMetricsQuery, TrainingMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingMetricsQuery, TrainingMetricsQueryVariables>(TrainingMetricsDocument, options);
        }
// @ts-ignore
export function useTrainingMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrainingMetricsQuery, TrainingMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingMetricsQuery, TrainingMetricsQueryVariables>;
export function useTrainingMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingMetricsQuery, TrainingMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<TrainingMetricsQuery | undefined, TrainingMetricsQueryVariables>;
export function useTrainingMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrainingMetricsQuery, TrainingMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrainingMetricsQuery, TrainingMetricsQueryVariables>(TrainingMetricsDocument, options);
        }
export type TrainingMetricsQueryHookResult = ReturnType<typeof useTrainingMetricsQuery>;
export type TrainingMetricsLazyQueryHookResult = ReturnType<typeof useTrainingMetricsLazyQuery>;
export type TrainingMetricsSuspenseQueryHookResult = ReturnType<typeof useTrainingMetricsSuspenseQuery>;
export type TrainingMetricsQueryResult = Apollo.QueryResult<TrainingMetricsQuery, TrainingMetricsQueryVariables>;
export const CreateTrainingCourseDocument = gql`
    mutation CreateTrainingCourse($input: TrainingCourseInput!) {
  createTrainingCourse(input: $input) {
    ...TrainingCourseFields
  }
}
    ${TrainingCourseFieldsFragmentDoc}`;
export type CreateTrainingCourseMutationFn = Apollo.MutationFunction<CreateTrainingCourseMutation, CreateTrainingCourseMutationVariables>;

/**
 * __useCreateTrainingCourseMutation__
 *
 * To run a mutation, you first call `useCreateTrainingCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainingCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainingCourseMutation, { data, loading, error }] = useCreateTrainingCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrainingCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainingCourseMutation, CreateTrainingCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainingCourseMutation, CreateTrainingCourseMutationVariables>(CreateTrainingCourseDocument, options);
      }
export type CreateTrainingCourseMutationHookResult = ReturnType<typeof useCreateTrainingCourseMutation>;
export type CreateTrainingCourseMutationResult = Apollo.MutationResult<CreateTrainingCourseMutation>;
export type CreateTrainingCourseMutationOptions = Apollo.BaseMutationOptions<CreateTrainingCourseMutation, CreateTrainingCourseMutationVariables>;
export const UpdateTrainingCourseDocument = gql`
    mutation UpdateTrainingCourse($id: ID!, $input: UpdateTrainingCourseInput!) {
  updateTrainingCourse(id: $id, input: $input) {
    ...TrainingCourseFields
  }
}
    ${TrainingCourseFieldsFragmentDoc}`;
export type UpdateTrainingCourseMutationFn = Apollo.MutationFunction<UpdateTrainingCourseMutation, UpdateTrainingCourseMutationVariables>;

/**
 * __useUpdateTrainingCourseMutation__
 *
 * To run a mutation, you first call `useUpdateTrainingCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainingCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainingCourseMutation, { data, loading, error }] = useUpdateTrainingCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainingCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainingCourseMutation, UpdateTrainingCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainingCourseMutation, UpdateTrainingCourseMutationVariables>(UpdateTrainingCourseDocument, options);
      }
export type UpdateTrainingCourseMutationHookResult = ReturnType<typeof useUpdateTrainingCourseMutation>;
export type UpdateTrainingCourseMutationResult = Apollo.MutationResult<UpdateTrainingCourseMutation>;
export type UpdateTrainingCourseMutationOptions = Apollo.BaseMutationOptions<UpdateTrainingCourseMutation, UpdateTrainingCourseMutationVariables>;
export const DeleteTrainingCourseDocument = gql`
    mutation DeleteTrainingCourse($id: ID!) {
  deleteTrainingCourse(id: $id)
}
    `;
export type DeleteTrainingCourseMutationFn = Apollo.MutationFunction<DeleteTrainingCourseMutation, DeleteTrainingCourseMutationVariables>;

/**
 * __useDeleteTrainingCourseMutation__
 *
 * To run a mutation, you first call `useDeleteTrainingCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrainingCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrainingCourseMutation, { data, loading, error }] = useDeleteTrainingCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrainingCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrainingCourseMutation, DeleteTrainingCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrainingCourseMutation, DeleteTrainingCourseMutationVariables>(DeleteTrainingCourseDocument, options);
      }
export type DeleteTrainingCourseMutationHookResult = ReturnType<typeof useDeleteTrainingCourseMutation>;
export type DeleteTrainingCourseMutationResult = Apollo.MutationResult<DeleteTrainingCourseMutation>;
export type DeleteTrainingCourseMutationOptions = Apollo.BaseMutationOptions<DeleteTrainingCourseMutation, DeleteTrainingCourseMutationVariables>;
export const CreateTrainingSessionDocument = gql`
    mutation CreateTrainingSession($input: CreateTrainingSessionInput!) {
  createTrainingSession(input: $input) {
    ...TrainingSessionFields
  }
}
    ${TrainingSessionFieldsFragmentDoc}`;
export type CreateTrainingSessionMutationFn = Apollo.MutationFunction<CreateTrainingSessionMutation, CreateTrainingSessionMutationVariables>;

/**
 * __useCreateTrainingSessionMutation__
 *
 * To run a mutation, you first call `useCreateTrainingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainingSessionMutation, { data, loading, error }] = useCreateTrainingSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrainingSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainingSessionMutation, CreateTrainingSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainingSessionMutation, CreateTrainingSessionMutationVariables>(CreateTrainingSessionDocument, options);
      }
export type CreateTrainingSessionMutationHookResult = ReturnType<typeof useCreateTrainingSessionMutation>;
export type CreateTrainingSessionMutationResult = Apollo.MutationResult<CreateTrainingSessionMutation>;
export type CreateTrainingSessionMutationOptions = Apollo.BaseMutationOptions<CreateTrainingSessionMutation, CreateTrainingSessionMutationVariables>;
export const UpdateTrainingSessionDocument = gql`
    mutation UpdateTrainingSession($id: ID!, $input: UpdateTrainingSessionInput!) {
  updateTrainingSession(id: $id, input: $input) {
    ...TrainingSessionFields
  }
}
    ${TrainingSessionFieldsFragmentDoc}`;
export type UpdateTrainingSessionMutationFn = Apollo.MutationFunction<UpdateTrainingSessionMutation, UpdateTrainingSessionMutationVariables>;

/**
 * __useUpdateTrainingSessionMutation__
 *
 * To run a mutation, you first call `useUpdateTrainingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainingSessionMutation, { data, loading, error }] = useUpdateTrainingSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainingSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainingSessionMutation, UpdateTrainingSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainingSessionMutation, UpdateTrainingSessionMutationVariables>(UpdateTrainingSessionDocument, options);
      }
export type UpdateTrainingSessionMutationHookResult = ReturnType<typeof useUpdateTrainingSessionMutation>;
export type UpdateTrainingSessionMutationResult = Apollo.MutationResult<UpdateTrainingSessionMutation>;
export type UpdateTrainingSessionMutationOptions = Apollo.BaseMutationOptions<UpdateTrainingSessionMutation, UpdateTrainingSessionMutationVariables>;
export const DeleteTrainingSessionDocument = gql`
    mutation DeleteTrainingSession($id: ID!) {
  deleteTrainingSession(id: $id)
}
    `;
export type DeleteTrainingSessionMutationFn = Apollo.MutationFunction<DeleteTrainingSessionMutation, DeleteTrainingSessionMutationVariables>;

/**
 * __useDeleteTrainingSessionMutation__
 *
 * To run a mutation, you first call `useDeleteTrainingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrainingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrainingSessionMutation, { data, loading, error }] = useDeleteTrainingSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrainingSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrainingSessionMutation, DeleteTrainingSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrainingSessionMutation, DeleteTrainingSessionMutationVariables>(DeleteTrainingSessionDocument, options);
      }
export type DeleteTrainingSessionMutationHookResult = ReturnType<typeof useDeleteTrainingSessionMutation>;
export type DeleteTrainingSessionMutationResult = Apollo.MutationResult<DeleteTrainingSessionMutation>;
export type DeleteTrainingSessionMutationOptions = Apollo.BaseMutationOptions<DeleteTrainingSessionMutation, DeleteTrainingSessionMutationVariables>;
export const CreateTrainingCertificationDocument = gql`
    mutation CreateTrainingCertification($input: CreateTrainingCertificationInput!) {
  createTrainingCertification(input: $input) {
    ...TrainingCertificationFields
  }
}
    ${TrainingCertificationFieldsFragmentDoc}`;
export type CreateTrainingCertificationMutationFn = Apollo.MutationFunction<CreateTrainingCertificationMutation, CreateTrainingCertificationMutationVariables>;

/**
 * __useCreateTrainingCertificationMutation__
 *
 * To run a mutation, you first call `useCreateTrainingCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainingCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainingCertificationMutation, { data, loading, error }] = useCreateTrainingCertificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrainingCertificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainingCertificationMutation, CreateTrainingCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainingCertificationMutation, CreateTrainingCertificationMutationVariables>(CreateTrainingCertificationDocument, options);
      }
export type CreateTrainingCertificationMutationHookResult = ReturnType<typeof useCreateTrainingCertificationMutation>;
export type CreateTrainingCertificationMutationResult = Apollo.MutationResult<CreateTrainingCertificationMutation>;
export type CreateTrainingCertificationMutationOptions = Apollo.BaseMutationOptions<CreateTrainingCertificationMutation, CreateTrainingCertificationMutationVariables>;
export const UpdateTrainingCertificationDocument = gql`
    mutation UpdateTrainingCertification($id: ID!, $input: UpdateTrainingCertificationInput!) {
  updateTrainingCertification(id: $id, input: $input) {
    ...TrainingCertificationFields
  }
}
    ${TrainingCertificationFieldsFragmentDoc}`;
export type UpdateTrainingCertificationMutationFn = Apollo.MutationFunction<UpdateTrainingCertificationMutation, UpdateTrainingCertificationMutationVariables>;

/**
 * __useUpdateTrainingCertificationMutation__
 *
 * To run a mutation, you first call `useUpdateTrainingCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainingCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainingCertificationMutation, { data, loading, error }] = useUpdateTrainingCertificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainingCertificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainingCertificationMutation, UpdateTrainingCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainingCertificationMutation, UpdateTrainingCertificationMutationVariables>(UpdateTrainingCertificationDocument, options);
      }
export type UpdateTrainingCertificationMutationHookResult = ReturnType<typeof useUpdateTrainingCertificationMutation>;
export type UpdateTrainingCertificationMutationResult = Apollo.MutationResult<UpdateTrainingCertificationMutation>;
export type UpdateTrainingCertificationMutationOptions = Apollo.BaseMutationOptions<UpdateTrainingCertificationMutation, UpdateTrainingCertificationMutationVariables>;
export const DeleteTrainingCertificationDocument = gql`
    mutation DeleteTrainingCertification($id: ID!) {
  deleteTrainingCertification(id: $id)
}
    `;
export type DeleteTrainingCertificationMutationFn = Apollo.MutationFunction<DeleteTrainingCertificationMutation, DeleteTrainingCertificationMutationVariables>;

/**
 * __useDeleteTrainingCertificationMutation__
 *
 * To run a mutation, you first call `useDeleteTrainingCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrainingCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrainingCertificationMutation, { data, loading, error }] = useDeleteTrainingCertificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrainingCertificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrainingCertificationMutation, DeleteTrainingCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrainingCertificationMutation, DeleteTrainingCertificationMutationVariables>(DeleteTrainingCertificationDocument, options);
      }
export type DeleteTrainingCertificationMutationHookResult = ReturnType<typeof useDeleteTrainingCertificationMutation>;
export type DeleteTrainingCertificationMutationResult = Apollo.MutationResult<DeleteTrainingCertificationMutation>;
export type DeleteTrainingCertificationMutationOptions = Apollo.BaseMutationOptions<DeleteTrainingCertificationMutation, DeleteTrainingCertificationMutationVariables>;
export const RemoveTrainingCertificateDocumentDocument = gql`
    mutation RemoveTrainingCertificateDocument($documentId: ID!) {
  removeTrainingCertificateDocument(documentId: $documentId)
}
    `;
export type RemoveTrainingCertificateDocumentMutationFn = Apollo.MutationFunction<RemoveTrainingCertificateDocumentMutation, RemoveTrainingCertificateDocumentMutationVariables>;

/**
 * __useRemoveTrainingCertificateDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveTrainingCertificateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTrainingCertificateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTrainingCertificateDocumentMutation, { data, loading, error }] = useRemoveTrainingCertificateDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveTrainingCertificateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTrainingCertificateDocumentMutation, RemoveTrainingCertificateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTrainingCertificateDocumentMutation, RemoveTrainingCertificateDocumentMutationVariables>(RemoveTrainingCertificateDocumentDocument, options);
      }
export type RemoveTrainingCertificateDocumentMutationHookResult = ReturnType<typeof useRemoveTrainingCertificateDocumentMutation>;
export type RemoveTrainingCertificateDocumentMutationResult = Apollo.MutationResult<RemoveTrainingCertificateDocumentMutation>;
export type RemoveTrainingCertificateDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveTrainingCertificateDocumentMutation, RemoveTrainingCertificateDocumentMutationVariables>;
export const CreateLearningProgrammeDocument = gql`
    mutation CreateLearningProgramme($input: CreateLearningProgrammeInput!) {
  createLearningProgramme(input: $input) {
    ...LearningProgrammeFields
  }
}
    ${LearningProgrammeFieldsFragmentDoc}`;
export type CreateLearningProgrammeMutationFn = Apollo.MutationFunction<CreateLearningProgrammeMutation, CreateLearningProgrammeMutationVariables>;

/**
 * __useCreateLearningProgrammeMutation__
 *
 * To run a mutation, you first call `useCreateLearningProgrammeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningProgrammeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningProgrammeMutation, { data, loading, error }] = useCreateLearningProgrammeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningProgrammeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearningProgrammeMutation, CreateLearningProgrammeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearningProgrammeMutation, CreateLearningProgrammeMutationVariables>(CreateLearningProgrammeDocument, options);
      }
export type CreateLearningProgrammeMutationHookResult = ReturnType<typeof useCreateLearningProgrammeMutation>;
export type CreateLearningProgrammeMutationResult = Apollo.MutationResult<CreateLearningProgrammeMutation>;
export type CreateLearningProgrammeMutationOptions = Apollo.BaseMutationOptions<CreateLearningProgrammeMutation, CreateLearningProgrammeMutationVariables>;
export const UpdateLearningProgrammeDocument = gql`
    mutation UpdateLearningProgramme($id: ID!, $input: UpdateLearningProgrammeInput!) {
  updateLearningProgramme(id: $id, input: $input) {
    ...LearningProgrammeFields
  }
}
    ${LearningProgrammeFieldsFragmentDoc}`;
export type UpdateLearningProgrammeMutationFn = Apollo.MutationFunction<UpdateLearningProgrammeMutation, UpdateLearningProgrammeMutationVariables>;

/**
 * __useUpdateLearningProgrammeMutation__
 *
 * To run a mutation, you first call `useUpdateLearningProgrammeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningProgrammeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningProgrammeMutation, { data, loading, error }] = useUpdateLearningProgrammeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLearningProgrammeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearningProgrammeMutation, UpdateLearningProgrammeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearningProgrammeMutation, UpdateLearningProgrammeMutationVariables>(UpdateLearningProgrammeDocument, options);
      }
export type UpdateLearningProgrammeMutationHookResult = ReturnType<typeof useUpdateLearningProgrammeMutation>;
export type UpdateLearningProgrammeMutationResult = Apollo.MutationResult<UpdateLearningProgrammeMutation>;
export type UpdateLearningProgrammeMutationOptions = Apollo.BaseMutationOptions<UpdateLearningProgrammeMutation, UpdateLearningProgrammeMutationVariables>;
export const GetUnitsOfMeasureDocument = gql`
    query GetUnitsOfMeasure {
  unitsOfMeasure {
    id
    name
    externalCode
    productCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetUnitsOfMeasureQuery__
 *
 * To run a query within a React component, call `useGetUnitsOfMeasureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsOfMeasureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsOfMeasureQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnitsOfMeasureQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>(GetUnitsOfMeasureDocument, options);
      }
export function useGetUnitsOfMeasureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>(GetUnitsOfMeasureDocument, options);
        }
// @ts-ignore
export function useGetUnitsOfMeasureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>;
export function useGetUnitsOfMeasureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnitsOfMeasureQuery | undefined, GetUnitsOfMeasureQueryVariables>;
export function useGetUnitsOfMeasureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>(GetUnitsOfMeasureDocument, options);
        }
export type GetUnitsOfMeasureQueryHookResult = ReturnType<typeof useGetUnitsOfMeasureQuery>;
export type GetUnitsOfMeasureLazyQueryHookResult = ReturnType<typeof useGetUnitsOfMeasureLazyQuery>;
export type GetUnitsOfMeasureSuspenseQueryHookResult = ReturnType<typeof useGetUnitsOfMeasureSuspenseQuery>;
export type GetUnitsOfMeasureQueryResult = Apollo.QueryResult<GetUnitsOfMeasureQuery, GetUnitsOfMeasureQueryVariables>;
export const CreateUnitOfMeasureDocument = gql`
    mutation CreateUnitOfMeasure($input: CreateUnitOfMeasureInput!) {
  createUnitOfMeasure(input: $input) {
    id
    name
    externalCode
  }
}
    `;
export type CreateUnitOfMeasureMutationFn = Apollo.MutationFunction<CreateUnitOfMeasureMutation, CreateUnitOfMeasureMutationVariables>;

/**
 * __useCreateUnitOfMeasureMutation__
 *
 * To run a mutation, you first call `useCreateUnitOfMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnitOfMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnitOfMeasureMutation, { data, loading, error }] = useCreateUnitOfMeasureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUnitOfMeasureMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnitOfMeasureMutation, CreateUnitOfMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnitOfMeasureMutation, CreateUnitOfMeasureMutationVariables>(CreateUnitOfMeasureDocument, options);
      }
export type CreateUnitOfMeasureMutationHookResult = ReturnType<typeof useCreateUnitOfMeasureMutation>;
export type CreateUnitOfMeasureMutationResult = Apollo.MutationResult<CreateUnitOfMeasureMutation>;
export type CreateUnitOfMeasureMutationOptions = Apollo.BaseMutationOptions<CreateUnitOfMeasureMutation, CreateUnitOfMeasureMutationVariables>;
export const UpdateUnitOfMeasureDocument = gql`
    mutation UpdateUnitOfMeasure($id: String!, $input: UpdateUnitOfMeasureInput!) {
  updateUnitOfMeasure(id: $id, input: $input) {
    id
    name
    externalCode
  }
}
    `;
export type UpdateUnitOfMeasureMutationFn = Apollo.MutationFunction<UpdateUnitOfMeasureMutation, UpdateUnitOfMeasureMutationVariables>;

/**
 * __useUpdateUnitOfMeasureMutation__
 *
 * To run a mutation, you first call `useUpdateUnitOfMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnitOfMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnitOfMeasureMutation, { data, loading, error }] = useUpdateUnitOfMeasureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUnitOfMeasureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUnitOfMeasureMutation, UpdateUnitOfMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUnitOfMeasureMutation, UpdateUnitOfMeasureMutationVariables>(UpdateUnitOfMeasureDocument, options);
      }
export type UpdateUnitOfMeasureMutationHookResult = ReturnType<typeof useUpdateUnitOfMeasureMutation>;
export type UpdateUnitOfMeasureMutationResult = Apollo.MutationResult<UpdateUnitOfMeasureMutation>;
export type UpdateUnitOfMeasureMutationOptions = Apollo.BaseMutationOptions<UpdateUnitOfMeasureMutation, UpdateUnitOfMeasureMutationVariables>;
export const DeleteUnitOfMeasureDocument = gql`
    mutation DeleteUnitOfMeasure($id: String!) {
  deleteUnitOfMeasure(id: $id) {
    id
    name
  }
}
    `;
export type DeleteUnitOfMeasureMutationFn = Apollo.MutationFunction<DeleteUnitOfMeasureMutation, DeleteUnitOfMeasureMutationVariables>;

/**
 * __useDeleteUnitOfMeasureMutation__
 *
 * To run a mutation, you first call `useDeleteUnitOfMeasureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnitOfMeasureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnitOfMeasureMutation, { data, loading, error }] = useDeleteUnitOfMeasureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUnitOfMeasureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnitOfMeasureMutation, DeleteUnitOfMeasureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnitOfMeasureMutation, DeleteUnitOfMeasureMutationVariables>(DeleteUnitOfMeasureDocument, options);
      }
export type DeleteUnitOfMeasureMutationHookResult = ReturnType<typeof useDeleteUnitOfMeasureMutation>;
export type DeleteUnitOfMeasureMutationResult = Apollo.MutationResult<DeleteUnitOfMeasureMutation>;
export type DeleteUnitOfMeasureMutationOptions = Apollo.BaseMutationOptions<DeleteUnitOfMeasureMutation, DeleteUnitOfMeasureMutationVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  me {
    id
    email
    firstName
    lastName
    avatarUrl
    sessionTimeoutEnabled
    preferredLanguage
    createdAt
    userRoles {
      id
      role {
        id
        name
        grantableRoles {
          id
          name
        }
      }
    }
    userDepartments {
      id
      department {
        id
        name
      }
    }
    stockingPointMemberships {
      id
      stockingPoint {
        id
        name
      }
    }
    agent {
      id
      agentType
      canSell
      canDoReplacements
      bankName
      bankAccountNumber
      bankBranchCode
      bankAccountType
      stockingPointUsers {
        isPrimary
        stockingPoint {
          id
          name
          addressLine1
          province
          municipality
          postalCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserQuery | undefined, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetMembersDocument = gql`
    query GetMembers($input: MemberSearchInput) {
  members(input: $input) {
    items {
      id
      email
      firstName
      lastName
      archivedAt
      createdAt
      userRoles {
        id
        role {
          id
          name
        }
      }
      userDepartments {
        id
        isAdmin
        department {
          id
          name
        }
      }
      stockingPointMemberships {
        id
        stockingPoint {
          id
          name
        }
      }
      agent {
        id
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
// @ts-ignore
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMembersQuery, GetMembersQueryVariables>;
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMembersQuery | undefined, GetMembersQueryVariables>;
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersSuspenseQueryHookResult = ReturnType<typeof useGetMembersSuspenseQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const GetAgentManagersDocument = gql`
    query GetAgentManagers {
  agentManagers {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useGetAgentManagersQuery__
 *
 * To run a query within a React component, call `useGetAgentManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentManagersQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentManagersQuery, GetAgentManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentManagersQuery, GetAgentManagersQueryVariables>(GetAgentManagersDocument, options);
      }
export function useGetAgentManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentManagersQuery, GetAgentManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentManagersQuery, GetAgentManagersQueryVariables>(GetAgentManagersDocument, options);
        }
// @ts-ignore
export function useGetAgentManagersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentManagersQuery, GetAgentManagersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentManagersQuery, GetAgentManagersQueryVariables>;
export function useGetAgentManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentManagersQuery, GetAgentManagersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentManagersQuery | undefined, GetAgentManagersQueryVariables>;
export function useGetAgentManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentManagersQuery, GetAgentManagersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentManagersQuery, GetAgentManagersQueryVariables>(GetAgentManagersDocument, options);
        }
export type GetAgentManagersQueryHookResult = ReturnType<typeof useGetAgentManagersQuery>;
export type GetAgentManagersLazyQueryHookResult = ReturnType<typeof useGetAgentManagersLazyQuery>;
export type GetAgentManagersSuspenseQueryHookResult = ReturnType<typeof useGetAgentManagersSuspenseQuery>;
export type GetAgentManagersQueryResult = Apollo.QueryResult<GetAgentManagersQuery, GetAgentManagersQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    id
    email
    firstName
    lastName
    preferredLanguage
    createdAt
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const AssignUserToRoleDocument = gql`
    mutation AssignUserToRole($userId: String!, $roleId: String!) {
  assignUserToRole(userId: $userId, roleId: $roleId) {
    success
    message
  }
}
    `;
export type AssignUserToRoleMutationFn = Apollo.MutationFunction<AssignUserToRoleMutation, AssignUserToRoleMutationVariables>;

/**
 * __useAssignUserToRoleMutation__
 *
 * To run a mutation, you first call `useAssignUserToRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserToRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUserToRoleMutation, { data, loading, error }] = useAssignUserToRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAssignUserToRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignUserToRoleMutation, AssignUserToRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUserToRoleMutation, AssignUserToRoleMutationVariables>(AssignUserToRoleDocument, options);
      }
export type AssignUserToRoleMutationHookResult = ReturnType<typeof useAssignUserToRoleMutation>;
export type AssignUserToRoleMutationResult = Apollo.MutationResult<AssignUserToRoleMutation>;
export type AssignUserToRoleMutationOptions = Apollo.BaseMutationOptions<AssignUserToRoleMutation, AssignUserToRoleMutationVariables>;
export const RemoveUserFromRoleDocument = gql`
    mutation RemoveUserFromRole($userId: String!, $roleId: String!) {
  removeUserFromRole(userId: $userId, roleId: $roleId) {
    success
    message
  }
}
    `;
export type RemoveUserFromRoleMutationFn = Apollo.MutationFunction<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>;

/**
 * __useRemoveUserFromRoleMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromRoleMutation, { data, loading, error }] = useRemoveUserFromRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRemoveUserFromRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>(RemoveUserFromRoleDocument, options);
      }
export type RemoveUserFromRoleMutationHookResult = ReturnType<typeof useRemoveUserFromRoleMutation>;
export type RemoveUserFromRoleMutationResult = Apollo.MutationResult<RemoveUserFromRoleMutation>;
export type RemoveUserFromRoleMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>;
export const UpdateMyBankingDetailsDocument = gql`
    mutation UpdateMyBankingDetails($input: UpdateMyBankingInput!) {
  updateMyBankingDetails(input: $input) {
    id
    bankName
    bankAccountNumber
    bankBranchCode
    bankAccountType
  }
}
    `;
export type UpdateMyBankingDetailsMutationFn = Apollo.MutationFunction<UpdateMyBankingDetailsMutation, UpdateMyBankingDetailsMutationVariables>;

/**
 * __useUpdateMyBankingDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateMyBankingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyBankingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyBankingDetailsMutation, { data, loading, error }] = useUpdateMyBankingDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyBankingDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyBankingDetailsMutation, UpdateMyBankingDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyBankingDetailsMutation, UpdateMyBankingDetailsMutationVariables>(UpdateMyBankingDetailsDocument, options);
      }
export type UpdateMyBankingDetailsMutationHookResult = ReturnType<typeof useUpdateMyBankingDetailsMutation>;
export type UpdateMyBankingDetailsMutationResult = Apollo.MutationResult<UpdateMyBankingDetailsMutation>;
export type UpdateMyBankingDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateMyBankingDetailsMutation, UpdateMyBankingDetailsMutationVariables>;
export const ArchiveMemberDocument = gql`
    mutation ArchiveMember($userId: String!) {
  archiveMember(userId: $userId) {
    success
    message
  }
}
    `;
export type ArchiveMemberMutationFn = Apollo.MutationFunction<ArchiveMemberMutation, ArchiveMemberMutationVariables>;

/**
 * __useArchiveMemberMutation__
 *
 * To run a mutation, you first call `useArchiveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMemberMutation, { data, loading, error }] = useArchiveMemberMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useArchiveMemberMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveMemberMutation, ArchiveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveMemberMutation, ArchiveMemberMutationVariables>(ArchiveMemberDocument, options);
      }
export type ArchiveMemberMutationHookResult = ReturnType<typeof useArchiveMemberMutation>;
export type ArchiveMemberMutationResult = Apollo.MutationResult<ArchiveMemberMutation>;
export type ArchiveMemberMutationOptions = Apollo.BaseMutationOptions<ArchiveMemberMutation, ArchiveMemberMutationVariables>;
export const RestoreMemberDocument = gql`
    mutation RestoreMember($userId: String!) {
  restoreMember(userId: $userId) {
    success
    message
  }
}
    `;
export type RestoreMemberMutationFn = Apollo.MutationFunction<RestoreMemberMutation, RestoreMemberMutationVariables>;

/**
 * __useRestoreMemberMutation__
 *
 * To run a mutation, you first call `useRestoreMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMemberMutation, { data, loading, error }] = useRestoreMemberMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRestoreMemberMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMemberMutation, RestoreMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMemberMutation, RestoreMemberMutationVariables>(RestoreMemberDocument, options);
      }
export type RestoreMemberMutationHookResult = ReturnType<typeof useRestoreMemberMutation>;
export type RestoreMemberMutationResult = Apollo.MutationResult<RestoreMemberMutation>;
export type RestoreMemberMutationOptions = Apollo.BaseMutationOptions<RestoreMemberMutation, RestoreMemberMutationVariables>;
export const GetWebhookEventsDocument = gql`
    query GetWebhookEvents($input: WebhookEventListInput) {
  webhookEvents(input: $input) {
    totalCount
    eventNames
    events {
      id
      createdAt
      direction
      source
      event
      version
      subjectType
      subjectId
      occurredAt
      correlationId
      payload
      status
      signatureStatus
      responseStatus
      error
      deliveries {
        id
        status
        attempts
        lastAttemptAt
        nextRetryAt
        sentAt
        responseStatus
        lastError
        subscription {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetWebhookEventsQuery__
 *
 * To run a query within a React component, call `useGetWebhookEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWebhookEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>(GetWebhookEventsDocument, options);
      }
export function useGetWebhookEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>(GetWebhookEventsDocument, options);
        }
// @ts-ignore
export function useGetWebhookEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>;
export function useGetWebhookEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookEventsQuery | undefined, GetWebhookEventsQueryVariables>;
export function useGetWebhookEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>(GetWebhookEventsDocument, options);
        }
export type GetWebhookEventsQueryHookResult = ReturnType<typeof useGetWebhookEventsQuery>;
export type GetWebhookEventsLazyQueryHookResult = ReturnType<typeof useGetWebhookEventsLazyQuery>;
export type GetWebhookEventsSuspenseQueryHookResult = ReturnType<typeof useGetWebhookEventsSuspenseQuery>;
export type GetWebhookEventsQueryResult = Apollo.QueryResult<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>;
export const ResendWebhookDeliveryDocument = gql`
    mutation ResendWebhookDelivery($deliveryId: String!) {
  resendWebhookDelivery(deliveryId: $deliveryId) {
    success
    message
  }
}
    `;
export type ResendWebhookDeliveryMutationFn = Apollo.MutationFunction<ResendWebhookDeliveryMutation, ResendWebhookDeliveryMutationVariables>;

/**
 * __useResendWebhookDeliveryMutation__
 *
 * To run a mutation, you first call `useResendWebhookDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendWebhookDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendWebhookDeliveryMutation, { data, loading, error }] = useResendWebhookDeliveryMutation({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useResendWebhookDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<ResendWebhookDeliveryMutation, ResendWebhookDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendWebhookDeliveryMutation, ResendWebhookDeliveryMutationVariables>(ResendWebhookDeliveryDocument, options);
      }
export type ResendWebhookDeliveryMutationHookResult = ReturnType<typeof useResendWebhookDeliveryMutation>;
export type ResendWebhookDeliveryMutationResult = Apollo.MutationResult<ResendWebhookDeliveryMutation>;
export type ResendWebhookDeliveryMutationOptions = Apollo.BaseMutationOptions<ResendWebhookDeliveryMutation, ResendWebhookDeliveryMutationVariables>;
export const GetWebhookSubscriptionsDocument = gql`
    query GetWebhookSubscriptions {
  webhookSubscriptions {
    id
    name
    url
    events
    isActive
    secretHint
    hasApiKey
    maxAttempts
    lastSuccessAt
    lastFailureAt
    pendingDeliveryCount
    failedDeliveryCount
    failuresClearedAt
    createdAt
  }
}
    `;

/**
 * __useGetWebhookSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetWebhookSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebhookSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>(GetWebhookSubscriptionsDocument, options);
      }
export function useGetWebhookSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>(GetWebhookSubscriptionsDocument, options);
        }
// @ts-ignore
export function useGetWebhookSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>;
export function useGetWebhookSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookSubscriptionsQuery | undefined, GetWebhookSubscriptionsQueryVariables>;
export function useGetWebhookSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>(GetWebhookSubscriptionsDocument, options);
        }
export type GetWebhookSubscriptionsQueryHookResult = ReturnType<typeof useGetWebhookSubscriptionsQuery>;
export type GetWebhookSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetWebhookSubscriptionsLazyQuery>;
export type GetWebhookSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useGetWebhookSubscriptionsSuspenseQuery>;
export type GetWebhookSubscriptionsQueryResult = Apollo.QueryResult<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>;
export const GetWebhookEventCatalogueDocument = gql`
    query GetWebhookEventCatalogue {
  webhookEventCatalogue
}
    `;

/**
 * __useGetWebhookEventCatalogueQuery__
 *
 * To run a query within a React component, call `useGetWebhookEventCatalogueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookEventCatalogueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookEventCatalogueQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebhookEventCatalogueQuery(baseOptions?: Apollo.QueryHookOptions<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>(GetWebhookEventCatalogueDocument, options);
      }
export function useGetWebhookEventCatalogueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>(GetWebhookEventCatalogueDocument, options);
        }
// @ts-ignore
export function useGetWebhookEventCatalogueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>;
export function useGetWebhookEventCatalogueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookEventCatalogueQuery | undefined, GetWebhookEventCatalogueQueryVariables>;
export function useGetWebhookEventCatalogueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>(GetWebhookEventCatalogueDocument, options);
        }
export type GetWebhookEventCatalogueQueryHookResult = ReturnType<typeof useGetWebhookEventCatalogueQuery>;
export type GetWebhookEventCatalogueLazyQueryHookResult = ReturnType<typeof useGetWebhookEventCatalogueLazyQuery>;
export type GetWebhookEventCatalogueSuspenseQueryHookResult = ReturnType<typeof useGetWebhookEventCatalogueSuspenseQuery>;
export type GetWebhookEventCatalogueQueryResult = Apollo.QueryResult<GetWebhookEventCatalogueQuery, GetWebhookEventCatalogueQueryVariables>;
export const CreateWebhookSubscriptionDocument = gql`
    mutation CreateWebhookSubscription($input: CreateWebhookSubscriptionInput!) {
  createWebhookSubscription(input: $input) {
    secret
    subscription {
      id
      name
      url
      events
      isActive
      secretHint
    }
  }
}
    `;
export type CreateWebhookSubscriptionMutationFn = Apollo.MutationFunction<CreateWebhookSubscriptionMutation, CreateWebhookSubscriptionMutationVariables>;

/**
 * __useCreateWebhookSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateWebhookSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookSubscriptionMutation, { data, loading, error }] = useCreateWebhookSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebhookSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookSubscriptionMutation, CreateWebhookSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookSubscriptionMutation, CreateWebhookSubscriptionMutationVariables>(CreateWebhookSubscriptionDocument, options);
      }
export type CreateWebhookSubscriptionMutationHookResult = ReturnType<typeof useCreateWebhookSubscriptionMutation>;
export type CreateWebhookSubscriptionMutationResult = Apollo.MutationResult<CreateWebhookSubscriptionMutation>;
export type CreateWebhookSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateWebhookSubscriptionMutation, CreateWebhookSubscriptionMutationVariables>;
export const UpdateWebhookSubscriptionDocument = gql`
    mutation UpdateWebhookSubscription($id: String!, $input: UpdateWebhookSubscriptionInput!) {
  updateWebhookSubscription(id: $id, input: $input) {
    id
    name
    url
    events
    isActive
    maxAttempts
  }
}
    `;
export type UpdateWebhookSubscriptionMutationFn = Apollo.MutationFunction<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>;

/**
 * __useUpdateWebhookSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookSubscriptionMutation, { data, loading, error }] = useUpdateWebhookSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebhookSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>(UpdateWebhookSubscriptionDocument, options);
      }
export type UpdateWebhookSubscriptionMutationHookResult = ReturnType<typeof useUpdateWebhookSubscriptionMutation>;
export type UpdateWebhookSubscriptionMutationResult = Apollo.MutationResult<UpdateWebhookSubscriptionMutation>;
export type UpdateWebhookSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>;
export const DeleteWebhookSubscriptionDocument = gql`
    mutation DeleteWebhookSubscription($id: String!) {
  deleteWebhookSubscription(id: $id) {
    success
    message
  }
}
    `;
export type DeleteWebhookSubscriptionMutationFn = Apollo.MutationFunction<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>;

/**
 * __useDeleteWebhookSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookSubscriptionMutation, { data, loading, error }] = useDeleteWebhookSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWebhookSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>(DeleteWebhookSubscriptionDocument, options);
      }
export type DeleteWebhookSubscriptionMutationHookResult = ReturnType<typeof useDeleteWebhookSubscriptionMutation>;
export type DeleteWebhookSubscriptionMutationResult = Apollo.MutationResult<DeleteWebhookSubscriptionMutation>;
export type DeleteWebhookSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>;
export const RotateWebhookSubscriptionSecretDocument = gql`
    mutation RotateWebhookSubscriptionSecret($id: String!) {
  rotateWebhookSubscriptionSecret(id: $id) {
    secret
    subscription {
      id
      secretHint
    }
  }
}
    `;
export type RotateWebhookSubscriptionSecretMutationFn = Apollo.MutationFunction<RotateWebhookSubscriptionSecretMutation, RotateWebhookSubscriptionSecretMutationVariables>;

/**
 * __useRotateWebhookSubscriptionSecretMutation__
 *
 * To run a mutation, you first call `useRotateWebhookSubscriptionSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateWebhookSubscriptionSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateWebhookSubscriptionSecretMutation, { data, loading, error }] = useRotateWebhookSubscriptionSecretMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRotateWebhookSubscriptionSecretMutation(baseOptions?: Apollo.MutationHookOptions<RotateWebhookSubscriptionSecretMutation, RotateWebhookSubscriptionSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RotateWebhookSubscriptionSecretMutation, RotateWebhookSubscriptionSecretMutationVariables>(RotateWebhookSubscriptionSecretDocument, options);
      }
export type RotateWebhookSubscriptionSecretMutationHookResult = ReturnType<typeof useRotateWebhookSubscriptionSecretMutation>;
export type RotateWebhookSubscriptionSecretMutationResult = Apollo.MutationResult<RotateWebhookSubscriptionSecretMutation>;
export type RotateWebhookSubscriptionSecretMutationOptions = Apollo.BaseMutationOptions<RotateWebhookSubscriptionSecretMutation, RotateWebhookSubscriptionSecretMutationVariables>;
export const ClearWebhookSubscriptionFailuresDocument = gql`
    mutation ClearWebhookSubscriptionFailures($id: String!) {
  clearWebhookSubscriptionFailures(id: $id) {
    id
    failedDeliveryCount
    failuresClearedAt
  }
}
    `;
export type ClearWebhookSubscriptionFailuresMutationFn = Apollo.MutationFunction<ClearWebhookSubscriptionFailuresMutation, ClearWebhookSubscriptionFailuresMutationVariables>;

/**
 * __useClearWebhookSubscriptionFailuresMutation__
 *
 * To run a mutation, you first call `useClearWebhookSubscriptionFailuresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearWebhookSubscriptionFailuresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearWebhookSubscriptionFailuresMutation, { data, loading, error }] = useClearWebhookSubscriptionFailuresMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClearWebhookSubscriptionFailuresMutation(baseOptions?: Apollo.MutationHookOptions<ClearWebhookSubscriptionFailuresMutation, ClearWebhookSubscriptionFailuresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearWebhookSubscriptionFailuresMutation, ClearWebhookSubscriptionFailuresMutationVariables>(ClearWebhookSubscriptionFailuresDocument, options);
      }
export type ClearWebhookSubscriptionFailuresMutationHookResult = ReturnType<typeof useClearWebhookSubscriptionFailuresMutation>;
export type ClearWebhookSubscriptionFailuresMutationResult = Apollo.MutationResult<ClearWebhookSubscriptionFailuresMutation>;
export type ClearWebhookSubscriptionFailuresMutationOptions = Apollo.BaseMutationOptions<ClearWebhookSubscriptionFailuresMutation, ClearWebhookSubscriptionFailuresMutationVariables>;
export const EmployeesDocument = gql`
    query Employees($filter: EmployeeFilterInput) {
  employees(filter: $filter) {
    totalCount
    items {
      ...EmployeeSummaryFields
    }
  }
}
    ${EmployeeSummaryFieldsFragmentDoc}`;

/**
 * __useEmployeesQuery__
 *
 * To run a query within a React component, call `useEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
      }
export function useEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
// @ts-ignore
export function useEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesQuery, EmployeesQueryVariables>;
export function useEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesQuery | undefined, EmployeesQueryVariables>;
export function useEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
export type EmployeesQueryHookResult = ReturnType<typeof useEmployeesQuery>;
export type EmployeesLazyQueryHookResult = ReturnType<typeof useEmployeesLazyQuery>;
export type EmployeesSuspenseQueryHookResult = ReturnType<typeof useEmployeesSuspenseQuery>;
export type EmployeesQueryResult = Apollo.QueryResult<EmployeesQuery, EmployeesQueryVariables>;
export const EmployeeDocument = gql`
    query Employee($id: ID!) {
  employee(id: $id) {
    ...EmployeeDetailFields
  }
}
    ${EmployeeDetailFieldsFragmentDoc}`;

/**
 * __useEmployeeQuery__
 *
 * To run a query within a React component, call `useEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeQuery(baseOptions: Apollo.QueryHookOptions<EmployeeQuery, EmployeeQueryVariables> & ({ variables: EmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, options);
      }
export function useEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeQuery, EmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, options);
        }
// @ts-ignore
export function useEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeQuery, EmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeQuery, EmployeeQueryVariables>;
export function useEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeQuery, EmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeQuery | undefined, EmployeeQueryVariables>;
export function useEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeQuery, EmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, options);
        }
export type EmployeeQueryHookResult = ReturnType<typeof useEmployeeQuery>;
export type EmployeeLazyQueryHookResult = ReturnType<typeof useEmployeeLazyQuery>;
export type EmployeeSuspenseQueryHookResult = ReturnType<typeof useEmployeeSuspenseQuery>;
export type EmployeeQueryResult = Apollo.QueryResult<EmployeeQuery, EmployeeQueryVariables>;
export const HrDepartmentOptionsDocument = gql`
    query HrDepartmentOptions {
  departments {
    id
    name
  }
}
    `;

/**
 * __useHrDepartmentOptionsQuery__
 *
 * To run a query within a React component, call `useHrDepartmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrDepartmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrDepartmentOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHrDepartmentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>(HrDepartmentOptionsDocument, options);
      }
export function useHrDepartmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>(HrDepartmentOptionsDocument, options);
        }
// @ts-ignore
export function useHrDepartmentOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>;
export function useHrDepartmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<HrDepartmentOptionsQuery | undefined, HrDepartmentOptionsQueryVariables>;
export function useHrDepartmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>(HrDepartmentOptionsDocument, options);
        }
export type HrDepartmentOptionsQueryHookResult = ReturnType<typeof useHrDepartmentOptionsQuery>;
export type HrDepartmentOptionsLazyQueryHookResult = ReturnType<typeof useHrDepartmentOptionsLazyQuery>;
export type HrDepartmentOptionsSuspenseQueryHookResult = ReturnType<typeof useHrDepartmentOptionsSuspenseQuery>;
export type HrDepartmentOptionsQueryResult = Apollo.QueryResult<HrDepartmentOptionsQuery, HrDepartmentOptionsQueryVariables>;
export const HrUserOptionsDocument = gql`
    query HrUserOptions($search: String) {
  members(input: {archived: false, limit: 100, search: $search}) {
    totalCount
    items {
      id
      email
      firstName
      lastName
      agent {
        id
      }
    }
  }
}
    `;

/**
 * __useHrUserOptionsQuery__
 *
 * To run a query within a React component, call `useHrUserOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrUserOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrUserOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useHrUserOptionsQuery(baseOptions?: Apollo.QueryHookOptions<HrUserOptionsQuery, HrUserOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrUserOptionsQuery, HrUserOptionsQueryVariables>(HrUserOptionsDocument, options);
      }
export function useHrUserOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrUserOptionsQuery, HrUserOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrUserOptionsQuery, HrUserOptionsQueryVariables>(HrUserOptionsDocument, options);
        }
// @ts-ignore
export function useHrUserOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HrUserOptionsQuery, HrUserOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<HrUserOptionsQuery, HrUserOptionsQueryVariables>;
export function useHrUserOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrUserOptionsQuery, HrUserOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<HrUserOptionsQuery | undefined, HrUserOptionsQueryVariables>;
export function useHrUserOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HrUserOptionsQuery, HrUserOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HrUserOptionsQuery, HrUserOptionsQueryVariables>(HrUserOptionsDocument, options);
        }
export type HrUserOptionsQueryHookResult = ReturnType<typeof useHrUserOptionsQuery>;
export type HrUserOptionsLazyQueryHookResult = ReturnType<typeof useHrUserOptionsLazyQuery>;
export type HrUserOptionsSuspenseQueryHookResult = ReturnType<typeof useHrUserOptionsSuspenseQuery>;
export type HrUserOptionsQueryResult = Apollo.QueryResult<HrUserOptionsQuery, HrUserOptionsQueryVariables>;
export const WorkforceMetricsDocument = gql`
    query WorkforceMetrics($from: DateTime!, $to: DateTime!, $filter: WorkforceFilterInput) {
  workforceMetrics(from: $from, to: $to, filter: $filter) {
    from
    to
    headcount {
      ...HrMetricFields
    }
    permanent {
      ...HrMetricFields
    }
    fixedTerm {
      ...HrMetricFields
    }
    contractors {
      ...HrMetricFields
    }
    fullTime {
      ...HrMetricFields
    }
    partTime {
      ...HrMetricFields
    }
    newHires {
      ...HrMetricFields
    }
    terminations {
      ...HrMetricFields
    }
    netGrowth {
      ...HrMetricFields
    }
    netGrowthPercent {
      ...HrMetricFields
    }
    turnoverRate {
      ...HrMetricFields
    }
    voluntaryLeavers {
      ...HrMetricFields
    }
    involuntaryLeavers {
      ...HrMetricFields
    }
    contractEnded {
      ...HrMetricFields
    }
    promotions {
      ...HrMetricFields
    }
    promotionRate {
      ...HrMetricFields
    }
    transfers {
      ...HrMetricFields
    }
    byDepartment {
      departmentId
      departmentName
      count
    }
    trend {
      monthEnd
      headcount
      notRecorded
    }
    grievances {
      status
      count
    }
  }
}
    ${HrMetricFieldsFragmentDoc}`;

/**
 * __useWorkforceMetricsQuery__
 *
 * To run a query within a React component, call `useWorkforceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkforceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkforceMetricsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useWorkforceMetricsQuery(baseOptions: Apollo.QueryHookOptions<WorkforceMetricsQuery, WorkforceMetricsQueryVariables> & ({ variables: WorkforceMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>(WorkforceMetricsDocument, options);
      }
export function useWorkforceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>(WorkforceMetricsDocument, options);
        }
// @ts-ignore
export function useWorkforceMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>;
export function useWorkforceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkforceMetricsQuery | undefined, WorkforceMetricsQueryVariables>;
export function useWorkforceMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>(WorkforceMetricsDocument, options);
        }
export type WorkforceMetricsQueryHookResult = ReturnType<typeof useWorkforceMetricsQuery>;
export type WorkforceMetricsLazyQueryHookResult = ReturnType<typeof useWorkforceMetricsLazyQuery>;
export type WorkforceMetricsSuspenseQueryHookResult = ReturnType<typeof useWorkforceMetricsSuspenseQuery>;
export type WorkforceMetricsQueryResult = Apollo.QueryResult<WorkforceMetricsQuery, WorkforceMetricsQueryVariables>;
export const EmployeesLeftWithLoginDocument = gql`
    query EmployeesLeftWithLogin {
  employeesLeftWithLogin {
    employeeId
    userId
    name
    email
    endDate
  }
}
    `;

/**
 * __useEmployeesLeftWithLoginQuery__
 *
 * To run a query within a React component, call `useEmployeesLeftWithLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesLeftWithLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesLeftWithLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeesLeftWithLoginQuery(baseOptions?: Apollo.QueryHookOptions<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>(EmployeesLeftWithLoginDocument, options);
      }
export function useEmployeesLeftWithLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>(EmployeesLeftWithLoginDocument, options);
        }
// @ts-ignore
export function useEmployeesLeftWithLoginSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>;
export function useEmployeesLeftWithLoginSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesLeftWithLoginQuery | undefined, EmployeesLeftWithLoginQueryVariables>;
export function useEmployeesLeftWithLoginSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>(EmployeesLeftWithLoginDocument, options);
        }
export type EmployeesLeftWithLoginQueryHookResult = ReturnType<typeof useEmployeesLeftWithLoginQuery>;
export type EmployeesLeftWithLoginLazyQueryHookResult = ReturnType<typeof useEmployeesLeftWithLoginLazyQuery>;
export type EmployeesLeftWithLoginSuspenseQueryHookResult = ReturnType<typeof useEmployeesLeftWithLoginSuspenseQuery>;
export type EmployeesLeftWithLoginQueryResult = Apollo.QueryResult<EmployeesLeftWithLoginQuery, EmployeesLeftWithLoginQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($input: CreateEmployeeInput!) {
  createEmployee(input: $input) {
    ...EmployeeDetailFields
  }
}
    ${EmployeeDetailFieldsFragmentDoc}`;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($id: ID!, $input: UpdateEmployeeInput!, $movement: MovementDetailsInput) {
  updateEmployee(id: $id, input: $input, movement: $movement) {
    ...EmployeeDetailFields
  }
}
    ${EmployeeDetailFieldsFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      movement: // value for 'movement'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const StartEmploymentDocument = gql`
    mutation StartEmployment($employeeId: ID!, $input: EmploymentInput!) {
  startEmployment(employeeId: $employeeId, input: $input) {
    ...EmploymentFields
  }
}
    ${EmploymentFieldsFragmentDoc}`;
export type StartEmploymentMutationFn = Apollo.MutationFunction<StartEmploymentMutation, StartEmploymentMutationVariables>;

/**
 * __useStartEmploymentMutation__
 *
 * To run a mutation, you first call `useStartEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEmploymentMutation, { data, loading, error }] = useStartEmploymentMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartEmploymentMutation(baseOptions?: Apollo.MutationHookOptions<StartEmploymentMutation, StartEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEmploymentMutation, StartEmploymentMutationVariables>(StartEmploymentDocument, options);
      }
export type StartEmploymentMutationHookResult = ReturnType<typeof useStartEmploymentMutation>;
export type StartEmploymentMutationResult = Apollo.MutationResult<StartEmploymentMutation>;
export type StartEmploymentMutationOptions = Apollo.BaseMutationOptions<StartEmploymentMutation, StartEmploymentMutationVariables>;
export const UpdateEmploymentDocument = gql`
    mutation UpdateEmployment($id: ID!, $input: EmploymentInput!, $movement: MovementDetailsInput) {
  updateEmployment(id: $id, input: $input, movement: $movement) {
    ...EmploymentFields
  }
}
    ${EmploymentFieldsFragmentDoc}`;
export type UpdateEmploymentMutationFn = Apollo.MutationFunction<UpdateEmploymentMutation, UpdateEmploymentMutationVariables>;

/**
 * __useUpdateEmploymentMutation__
 *
 * To run a mutation, you first call `useUpdateEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmploymentMutation, { data, loading, error }] = useUpdateEmploymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      movement: // value for 'movement'
 *   },
 * });
 */
export function useUpdateEmploymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmploymentMutation, UpdateEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmploymentMutation, UpdateEmploymentMutationVariables>(UpdateEmploymentDocument, options);
      }
export type UpdateEmploymentMutationHookResult = ReturnType<typeof useUpdateEmploymentMutation>;
export type UpdateEmploymentMutationResult = Apollo.MutationResult<UpdateEmploymentMutation>;
export type UpdateEmploymentMutationOptions = Apollo.BaseMutationOptions<UpdateEmploymentMutation, UpdateEmploymentMutationVariables>;
export const EndEmploymentDocument = gql`
    mutation EndEmployment($id: ID!, $input: EndEmploymentInput!) {
  endEmployment(id: $id, input: $input) {
    ...EmploymentFields
  }
}
    ${EmploymentFieldsFragmentDoc}`;
export type EndEmploymentMutationFn = Apollo.MutationFunction<EndEmploymentMutation, EndEmploymentMutationVariables>;

/**
 * __useEndEmploymentMutation__
 *
 * To run a mutation, you first call `useEndEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endEmploymentMutation, { data, loading, error }] = useEndEmploymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndEmploymentMutation(baseOptions?: Apollo.MutationHookOptions<EndEmploymentMutation, EndEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndEmploymentMutation, EndEmploymentMutationVariables>(EndEmploymentDocument, options);
      }
export type EndEmploymentMutationHookResult = ReturnType<typeof useEndEmploymentMutation>;
export type EndEmploymentMutationResult = Apollo.MutationResult<EndEmploymentMutation>;
export type EndEmploymentMutationOptions = Apollo.BaseMutationOptions<EndEmploymentMutation, EndEmploymentMutationVariables>;
export const GetWorkshopJobsDocument = gql`
    query GetWorkshopJobs($input: WorkshopJobListInput) {
  workshopJobs(input: $input) {
    items {
      id
      stage
      intakeReason
      faultDescription
      openedAt
      createdAt
      closedAt
      scrapReason
      faultCategory {
        id
        name
      }
      stockItem {
        id
        serialNumber
        accountNumber
        productName
      }
      stockingPoint {
        id
        name
      }
      assignedTo {
        id
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetWorkshopJobsQuery__
 *
 * To run a query within a React component, call `useGetWorkshopJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkshopJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkshopJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkshopJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>(GetWorkshopJobsDocument, options);
      }
export function useGetWorkshopJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>(GetWorkshopJobsDocument, options);
        }
// @ts-ignore
export function useGetWorkshopJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>;
export function useGetWorkshopJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopJobsQuery | undefined, GetWorkshopJobsQueryVariables>;
export function useGetWorkshopJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>(GetWorkshopJobsDocument, options);
        }
export type GetWorkshopJobsQueryHookResult = ReturnType<typeof useGetWorkshopJobsQuery>;
export type GetWorkshopJobsLazyQueryHookResult = ReturnType<typeof useGetWorkshopJobsLazyQuery>;
export type GetWorkshopJobsSuspenseQueryHookResult = ReturnType<typeof useGetWorkshopJobsSuspenseQuery>;
export type GetWorkshopJobsQueryResult = Apollo.QueryResult<GetWorkshopJobsQuery, GetWorkshopJobsQueryVariables>;
export const GetWorkshopIntakeQueueDocument = gql`
    query GetWorkshopIntakeQueue($stockingPointId: String!) {
  workshopIntakeQueue(stockingPointId: $stockingPointId) {
    source {
      id
      name
    }
    items {
      stockItem {
        id
        serialNumber
        accountNumber
        productName
        status
      }
      reportedFaultCategory {
        id
        name
      }
      reportedFault
      reportedCondition
      arrivedAt
      pendingTransfer {
        id
        transferNumber
        status
      }
    }
  }
}
    `;

/**
 * __useGetWorkshopIntakeQueueQuery__
 *
 * To run a query within a React component, call `useGetWorkshopIntakeQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkshopIntakeQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkshopIntakeQueueQuery({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *   },
 * });
 */
export function useGetWorkshopIntakeQueueQuery(baseOptions: Apollo.QueryHookOptions<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables> & ({ variables: GetWorkshopIntakeQueueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>(GetWorkshopIntakeQueueDocument, options);
      }
export function useGetWorkshopIntakeQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>(GetWorkshopIntakeQueueDocument, options);
        }
// @ts-ignore
export function useGetWorkshopIntakeQueueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>;
export function useGetWorkshopIntakeQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopIntakeQueueQuery | undefined, GetWorkshopIntakeQueueQueryVariables>;
export function useGetWorkshopIntakeQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>(GetWorkshopIntakeQueueDocument, options);
        }
export type GetWorkshopIntakeQueueQueryHookResult = ReturnType<typeof useGetWorkshopIntakeQueueQuery>;
export type GetWorkshopIntakeQueueLazyQueryHookResult = ReturnType<typeof useGetWorkshopIntakeQueueLazyQuery>;
export type GetWorkshopIntakeQueueSuspenseQueryHookResult = ReturnType<typeof useGetWorkshopIntakeQueueSuspenseQuery>;
export type GetWorkshopIntakeQueueQueryResult = Apollo.QueryResult<GetWorkshopIntakeQueueQuery, GetWorkshopIntakeQueueQueryVariables>;
export const GetWorkshopPolicyDocument = gql`
    query GetWorkshopPolicy {
  workshopPolicy {
    maxTestTokenDays
    updatedAt
  }
}
    `;

/**
 * __useGetWorkshopPolicyQuery__
 *
 * To run a query within a React component, call `useGetWorkshopPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkshopPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkshopPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkshopPolicyQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>(GetWorkshopPolicyDocument, options);
      }
export function useGetWorkshopPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>(GetWorkshopPolicyDocument, options);
        }
// @ts-ignore
export function useGetWorkshopPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>;
export function useGetWorkshopPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopPolicyQuery | undefined, GetWorkshopPolicyQueryVariables>;
export function useGetWorkshopPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>(GetWorkshopPolicyDocument, options);
        }
export type GetWorkshopPolicyQueryHookResult = ReturnType<typeof useGetWorkshopPolicyQuery>;
export type GetWorkshopPolicyLazyQueryHookResult = ReturnType<typeof useGetWorkshopPolicyLazyQuery>;
export type GetWorkshopPolicySuspenseQueryHookResult = ReturnType<typeof useGetWorkshopPolicySuspenseQuery>;
export type GetWorkshopPolicyQueryResult = Apollo.QueryResult<GetWorkshopPolicyQuery, GetWorkshopPolicyQueryVariables>;
export const GetWorkshopJobDocument = gql`
    query GetWorkshopJob($id: String!) {
  workshopJob(id: $id) {
    id
    stage
    intakeReason
    faultDescription
    physicalState
    physicalStateNote
    comments
    completedAt
    closedAt
    scrapReason
    openedAt
    createdAt
    tokenTests {
      id
      createdAt
      status
      amount
      vendor
      failureReason
      token
      tokenSequence
      deviceAccepted
      verdictAt
    }
    partsUsed {
      id
      createdAt
      delta
      reason
      product {
        id
        name
      }
    }
    updatedAt
    faultCategory {
      id
      name
    }
    faultType {
      id
      name
    }
    faultSubType {
      id
      name
    }
    stockItem {
      id
      serialNumber
      accountNumber
      productName
      status
      deviceType {
        id
        name
      }
      hasMeter
      meterHasSecretKey
      meterStartingCode
      meterTokenCount
      purchaseOrder {
        id
        purchaseOrderNumber
        supplier {
          id
          name
        }
      }
      transferItems {
        id
        transfer {
          id
          transferNumber
          status
          completedAt
          sourceStockingPoint {
            id
            name
          }
          destinationStockingPoint {
            id
            name
          }
        }
      }
      sale {
        id
        contract {
          id
          contractNumber
          status
        }
        customer {
          id
          fullName
        }
      }
    }
    stockingPoint {
      id
      name
      type
    }
    openedBy {
      id
      firstName
      lastName
    }
    assignedTo {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetWorkshopJobQuery__
 *
 * To run a query within a React component, call `useGetWorkshopJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkshopJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkshopJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkshopJobQuery(baseOptions: Apollo.QueryHookOptions<GetWorkshopJobQuery, GetWorkshopJobQueryVariables> & ({ variables: GetWorkshopJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>(GetWorkshopJobDocument, options);
      }
export function useGetWorkshopJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>(GetWorkshopJobDocument, options);
        }
// @ts-ignore
export function useGetWorkshopJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>;
export function useGetWorkshopJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopJobQuery | undefined, GetWorkshopJobQueryVariables>;
export function useGetWorkshopJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>(GetWorkshopJobDocument, options);
        }
export type GetWorkshopJobQueryHookResult = ReturnType<typeof useGetWorkshopJobQuery>;
export type GetWorkshopJobLazyQueryHookResult = ReturnType<typeof useGetWorkshopJobLazyQuery>;
export type GetWorkshopJobSuspenseQueryHookResult = ReturnType<typeof useGetWorkshopJobSuspenseQuery>;
export type GetWorkshopJobQueryResult = Apollo.QueryResult<GetWorkshopJobQuery, GetWorkshopJobQueryVariables>;
export const GetFaultCategoriesDocument = gql`
    query GetFaultCategories {
  faultCategories {
    id
    name
  }
}
    `;

/**
 * __useGetFaultCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFaultCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaultCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaultCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFaultCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>(GetFaultCategoriesDocument, options);
      }
export function useGetFaultCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>(GetFaultCategoriesDocument, options);
        }
// @ts-ignore
export function useGetFaultCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>;
export function useGetFaultCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFaultCategoriesQuery | undefined, GetFaultCategoriesQueryVariables>;
export function useGetFaultCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>(GetFaultCategoriesDocument, options);
        }
export type GetFaultCategoriesQueryHookResult = ReturnType<typeof useGetFaultCategoriesQuery>;
export type GetFaultCategoriesLazyQueryHookResult = ReturnType<typeof useGetFaultCategoriesLazyQuery>;
export type GetFaultCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetFaultCategoriesSuspenseQuery>;
export type GetFaultCategoriesQueryResult = Apollo.QueryResult<GetFaultCategoriesQuery, GetFaultCategoriesQueryVariables>;
export const GetFaultTypesDocument = gql`
    query GetFaultTypes {
  faultTypes {
    id
    name
    subTypes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetFaultTypesQuery__
 *
 * To run a query within a React component, call `useGetFaultTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaultTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaultTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFaultTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetFaultTypesQuery, GetFaultTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFaultTypesQuery, GetFaultTypesQueryVariables>(GetFaultTypesDocument, options);
      }
export function useGetFaultTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFaultTypesQuery, GetFaultTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFaultTypesQuery, GetFaultTypesQueryVariables>(GetFaultTypesDocument, options);
        }
// @ts-ignore
export function useGetFaultTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFaultTypesQuery, GetFaultTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFaultTypesQuery, GetFaultTypesQueryVariables>;
export function useGetFaultTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFaultTypesQuery, GetFaultTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFaultTypesQuery | undefined, GetFaultTypesQueryVariables>;
export function useGetFaultTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFaultTypesQuery, GetFaultTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFaultTypesQuery, GetFaultTypesQueryVariables>(GetFaultTypesDocument, options);
        }
export type GetFaultTypesQueryHookResult = ReturnType<typeof useGetFaultTypesQuery>;
export type GetFaultTypesLazyQueryHookResult = ReturnType<typeof useGetFaultTypesLazyQuery>;
export type GetFaultTypesSuspenseQueryHookResult = ReturnType<typeof useGetFaultTypesSuspenseQuery>;
export type GetFaultTypesQueryResult = Apollo.QueryResult<GetFaultTypesQuery, GetFaultTypesQueryVariables>;
export const GetWorkshopBenchesDocument = gql`
    query GetWorkshopBenches {
  stockingPoints(input: {types: [WORKSHOP], isActive: true, limit: 100}) {
    items {
      id
      name
    }
    totalCount
  }
}
    `;

/**
 * __useGetWorkshopBenchesQuery__
 *
 * To run a query within a React component, call `useGetWorkshopBenchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkshopBenchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkshopBenchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkshopBenchesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>(GetWorkshopBenchesDocument, options);
      }
export function useGetWorkshopBenchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>(GetWorkshopBenchesDocument, options);
        }
// @ts-ignore
export function useGetWorkshopBenchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>;
export function useGetWorkshopBenchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopBenchesQuery | undefined, GetWorkshopBenchesQueryVariables>;
export function useGetWorkshopBenchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>(GetWorkshopBenchesDocument, options);
        }
export type GetWorkshopBenchesQueryHookResult = ReturnType<typeof useGetWorkshopBenchesQuery>;
export type GetWorkshopBenchesLazyQueryHookResult = ReturnType<typeof useGetWorkshopBenchesLazyQuery>;
export type GetWorkshopBenchesSuspenseQueryHookResult = ReturnType<typeof useGetWorkshopBenchesSuspenseQuery>;
export type GetWorkshopBenchesQueryResult = Apollo.QueryResult<GetWorkshopBenchesQuery, GetWorkshopBenchesQueryVariables>;
export const RegisterDeviceAtWorkshopDocument = gql`
    mutation RegisterDeviceAtWorkshop($input: RegisterDeviceAtWorkshopInput!) {
  registerDeviceAtWorkshop(input: $input) {
    id
    stage
    intakeReason
  }
}
    `;
export type RegisterDeviceAtWorkshopMutationFn = Apollo.MutationFunction<RegisterDeviceAtWorkshopMutation, RegisterDeviceAtWorkshopMutationVariables>;

/**
 * __useRegisterDeviceAtWorkshopMutation__
 *
 * To run a mutation, you first call `useRegisterDeviceAtWorkshopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDeviceAtWorkshopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDeviceAtWorkshopMutation, { data, loading, error }] = useRegisterDeviceAtWorkshopMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterDeviceAtWorkshopMutation(baseOptions?: Apollo.MutationHookOptions<RegisterDeviceAtWorkshopMutation, RegisterDeviceAtWorkshopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterDeviceAtWorkshopMutation, RegisterDeviceAtWorkshopMutationVariables>(RegisterDeviceAtWorkshopDocument, options);
      }
export type RegisterDeviceAtWorkshopMutationHookResult = ReturnType<typeof useRegisterDeviceAtWorkshopMutation>;
export type RegisterDeviceAtWorkshopMutationResult = Apollo.MutationResult<RegisterDeviceAtWorkshopMutation>;
export type RegisterDeviceAtWorkshopMutationOptions = Apollo.BaseMutationOptions<RegisterDeviceAtWorkshopMutation, RegisterDeviceAtWorkshopMutationVariables>;
export const CompleteRepairDocument = gql`
    mutation CompleteRepair($id: ID!, $input: CompleteRepairInput!) {
  completeRepair(id: $id, input: $input) {
    id
    stage
    physicalState
    comments
    faultType {
      id
      name
    }
    faultSubType {
      id
      name
    }
  }
}
    `;
export type CompleteRepairMutationFn = Apollo.MutationFunction<CompleteRepairMutation, CompleteRepairMutationVariables>;

/**
 * __useCompleteRepairMutation__
 *
 * To run a mutation, you first call `useCompleteRepairMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRepairMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRepairMutation, { data, loading, error }] = useCompleteRepairMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteRepairMutation(baseOptions?: Apollo.MutationHookOptions<CompleteRepairMutation, CompleteRepairMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteRepairMutation, CompleteRepairMutationVariables>(CompleteRepairDocument, options);
      }
export type CompleteRepairMutationHookResult = ReturnType<typeof useCompleteRepairMutation>;
export type CompleteRepairMutationResult = Apollo.MutationResult<CompleteRepairMutation>;
export type CompleteRepairMutationOptions = Apollo.BaseMutationOptions<CompleteRepairMutation, CompleteRepairMutationVariables>;
export const RecordTokenTestVerdictDocument = gql`
    mutation RecordTokenTestVerdict($id: ID!, $accepted: Boolean!) {
  recordTokenTestVerdict(id: $id, accepted: $accepted) {
    id
    deviceAccepted
    verdictAt
  }
}
    `;
export type RecordTokenTestVerdictMutationFn = Apollo.MutationFunction<RecordTokenTestVerdictMutation, RecordTokenTestVerdictMutationVariables>;

/**
 * __useRecordTokenTestVerdictMutation__
 *
 * To run a mutation, you first call `useRecordTokenTestVerdictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordTokenTestVerdictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordTokenTestVerdictMutation, { data, loading, error }] = useRecordTokenTestVerdictMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accepted: // value for 'accepted'
 *   },
 * });
 */
export function useRecordTokenTestVerdictMutation(baseOptions?: Apollo.MutationHookOptions<RecordTokenTestVerdictMutation, RecordTokenTestVerdictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordTokenTestVerdictMutation, RecordTokenTestVerdictMutationVariables>(RecordTokenTestVerdictDocument, options);
      }
export type RecordTokenTestVerdictMutationHookResult = ReturnType<typeof useRecordTokenTestVerdictMutation>;
export type RecordTokenTestVerdictMutationResult = Apollo.MutationResult<RecordTokenTestVerdictMutation>;
export type RecordTokenTestVerdictMutationOptions = Apollo.BaseMutationOptions<RecordTokenTestVerdictMutation, RecordTokenTestVerdictMutationVariables>;
export const ReleaseFromWorkshopDocument = gql`
    mutation ReleaseFromWorkshop($id: ID!) {
  releaseFromWorkshop(id: $id) {
    id
    transferNumber
    status
  }
}
    `;
export type ReleaseFromWorkshopMutationFn = Apollo.MutationFunction<ReleaseFromWorkshopMutation, ReleaseFromWorkshopMutationVariables>;

/**
 * __useReleaseFromWorkshopMutation__
 *
 * To run a mutation, you first call `useReleaseFromWorkshopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseFromWorkshopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseFromWorkshopMutation, { data, loading, error }] = useReleaseFromWorkshopMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReleaseFromWorkshopMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseFromWorkshopMutation, ReleaseFromWorkshopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseFromWorkshopMutation, ReleaseFromWorkshopMutationVariables>(ReleaseFromWorkshopDocument, options);
      }
export type ReleaseFromWorkshopMutationHookResult = ReturnType<typeof useReleaseFromWorkshopMutation>;
export type ReleaseFromWorkshopMutationResult = Apollo.MutationResult<ReleaseFromWorkshopMutation>;
export type ReleaseFromWorkshopMutationOptions = Apollo.BaseMutationOptions<ReleaseFromWorkshopMutation, ReleaseFromWorkshopMutationVariables>;
export const SetWorkshopJobIntakeReasonDocument = gql`
    mutation SetWorkshopJobIntakeReason($id: ID!, $intakeReason: WorkshopJobIntakeReason!) {
  setWorkshopJobIntakeReason(id: $id, intakeReason: $intakeReason) {
    id
    intakeReason
  }
}
    `;
export type SetWorkshopJobIntakeReasonMutationFn = Apollo.MutationFunction<SetWorkshopJobIntakeReasonMutation, SetWorkshopJobIntakeReasonMutationVariables>;

/**
 * __useSetWorkshopJobIntakeReasonMutation__
 *
 * To run a mutation, you first call `useSetWorkshopJobIntakeReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkshopJobIntakeReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkshopJobIntakeReasonMutation, { data, loading, error }] = useSetWorkshopJobIntakeReasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      intakeReason: // value for 'intakeReason'
 *   },
 * });
 */
export function useSetWorkshopJobIntakeReasonMutation(baseOptions?: Apollo.MutationHookOptions<SetWorkshopJobIntakeReasonMutation, SetWorkshopJobIntakeReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWorkshopJobIntakeReasonMutation, SetWorkshopJobIntakeReasonMutationVariables>(SetWorkshopJobIntakeReasonDocument, options);
      }
export type SetWorkshopJobIntakeReasonMutationHookResult = ReturnType<typeof useSetWorkshopJobIntakeReasonMutation>;
export type SetWorkshopJobIntakeReasonMutationResult = Apollo.MutationResult<SetWorkshopJobIntakeReasonMutation>;
export type SetWorkshopJobIntakeReasonMutationOptions = Apollo.BaseMutationOptions<SetWorkshopJobIntakeReasonMutation, SetWorkshopJobIntakeReasonMutationVariables>;
export const GetFaultTaxonomyDocument = gql`
    query GetFaultTaxonomy($includeInactive: Boolean) {
  faultCategories(includeInactive: $includeInactive) {
    id
    name
    isActive
    sortOrder
  }
  faultTypes(includeInactive: $includeInactive) {
    id
    name
    isActive
    sortOrder
    subTypes {
      id
      name
      isActive
      sortOrder
    }
  }
}
    `;

/**
 * __useGetFaultTaxonomyQuery__
 *
 * To run a query within a React component, call `useGetFaultTaxonomyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaultTaxonomyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaultTaxonomyQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetFaultTaxonomyQuery(baseOptions?: Apollo.QueryHookOptions<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>(GetFaultTaxonomyDocument, options);
      }
export function useGetFaultTaxonomyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>(GetFaultTaxonomyDocument, options);
        }
// @ts-ignore
export function useGetFaultTaxonomySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>): Apollo.UseSuspenseQueryResult<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>;
export function useGetFaultTaxonomySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>): Apollo.UseSuspenseQueryResult<GetFaultTaxonomyQuery | undefined, GetFaultTaxonomyQueryVariables>;
export function useGetFaultTaxonomySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>(GetFaultTaxonomyDocument, options);
        }
export type GetFaultTaxonomyQueryHookResult = ReturnType<typeof useGetFaultTaxonomyQuery>;
export type GetFaultTaxonomyLazyQueryHookResult = ReturnType<typeof useGetFaultTaxonomyLazyQuery>;
export type GetFaultTaxonomySuspenseQueryHookResult = ReturnType<typeof useGetFaultTaxonomySuspenseQuery>;
export type GetFaultTaxonomyQueryResult = Apollo.QueryResult<GetFaultTaxonomyQuery, GetFaultTaxonomyQueryVariables>;
export const CreateFaultCategoryDocument = gql`
    mutation CreateFaultCategory($name: String!) {
  createFaultCategory(name: $name) {
    id
    name
    isActive
  }
}
    `;
export type CreateFaultCategoryMutationFn = Apollo.MutationFunction<CreateFaultCategoryMutation, CreateFaultCategoryMutationVariables>;

/**
 * __useCreateFaultCategoryMutation__
 *
 * To run a mutation, you first call `useCreateFaultCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaultCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaultCategoryMutation, { data, loading, error }] = useCreateFaultCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateFaultCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaultCategoryMutation, CreateFaultCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaultCategoryMutation, CreateFaultCategoryMutationVariables>(CreateFaultCategoryDocument, options);
      }
export type CreateFaultCategoryMutationHookResult = ReturnType<typeof useCreateFaultCategoryMutation>;
export type CreateFaultCategoryMutationResult = Apollo.MutationResult<CreateFaultCategoryMutation>;
export type CreateFaultCategoryMutationOptions = Apollo.BaseMutationOptions<CreateFaultCategoryMutation, CreateFaultCategoryMutationVariables>;
export const UpdateFaultCategoryDocument = gql`
    mutation UpdateFaultCategory($id: ID!, $input: TaxonomyEntryUpdateInput!) {
  updateFaultCategory(id: $id, input: $input) {
    id
    name
    isActive
  }
}
    `;
export type UpdateFaultCategoryMutationFn = Apollo.MutationFunction<UpdateFaultCategoryMutation, UpdateFaultCategoryMutationVariables>;

/**
 * __useUpdateFaultCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateFaultCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaultCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaultCategoryMutation, { data, loading, error }] = useUpdateFaultCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFaultCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaultCategoryMutation, UpdateFaultCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaultCategoryMutation, UpdateFaultCategoryMutationVariables>(UpdateFaultCategoryDocument, options);
      }
export type UpdateFaultCategoryMutationHookResult = ReturnType<typeof useUpdateFaultCategoryMutation>;
export type UpdateFaultCategoryMutationResult = Apollo.MutationResult<UpdateFaultCategoryMutation>;
export type UpdateFaultCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateFaultCategoryMutation, UpdateFaultCategoryMutationVariables>;
export const DeleteFaultCategoryDocument = gql`
    mutation DeleteFaultCategory($id: ID!) {
  deleteFaultCategory(id: $id)
}
    `;
export type DeleteFaultCategoryMutationFn = Apollo.MutationFunction<DeleteFaultCategoryMutation, DeleteFaultCategoryMutationVariables>;

/**
 * __useDeleteFaultCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteFaultCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaultCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaultCategoryMutation, { data, loading, error }] = useDeleteFaultCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFaultCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaultCategoryMutation, DeleteFaultCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaultCategoryMutation, DeleteFaultCategoryMutationVariables>(DeleteFaultCategoryDocument, options);
      }
export type DeleteFaultCategoryMutationHookResult = ReturnType<typeof useDeleteFaultCategoryMutation>;
export type DeleteFaultCategoryMutationResult = Apollo.MutationResult<DeleteFaultCategoryMutation>;
export type DeleteFaultCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteFaultCategoryMutation, DeleteFaultCategoryMutationVariables>;
export const CreateFaultTypeDocument = gql`
    mutation CreateFaultType($name: String!) {
  createFaultType(name: $name) {
    id
    name
    isActive
  }
}
    `;
export type CreateFaultTypeMutationFn = Apollo.MutationFunction<CreateFaultTypeMutation, CreateFaultTypeMutationVariables>;

/**
 * __useCreateFaultTypeMutation__
 *
 * To run a mutation, you first call `useCreateFaultTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaultTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaultTypeMutation, { data, loading, error }] = useCreateFaultTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateFaultTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaultTypeMutation, CreateFaultTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaultTypeMutation, CreateFaultTypeMutationVariables>(CreateFaultTypeDocument, options);
      }
export type CreateFaultTypeMutationHookResult = ReturnType<typeof useCreateFaultTypeMutation>;
export type CreateFaultTypeMutationResult = Apollo.MutationResult<CreateFaultTypeMutation>;
export type CreateFaultTypeMutationOptions = Apollo.BaseMutationOptions<CreateFaultTypeMutation, CreateFaultTypeMutationVariables>;
export const UpdateFaultTypeDocument = gql`
    mutation UpdateFaultType($id: ID!, $input: TaxonomyEntryUpdateInput!) {
  updateFaultType(id: $id, input: $input) {
    id
    name
    isActive
  }
}
    `;
export type UpdateFaultTypeMutationFn = Apollo.MutationFunction<UpdateFaultTypeMutation, UpdateFaultTypeMutationVariables>;

/**
 * __useUpdateFaultTypeMutation__
 *
 * To run a mutation, you first call `useUpdateFaultTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaultTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaultTypeMutation, { data, loading, error }] = useUpdateFaultTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFaultTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaultTypeMutation, UpdateFaultTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaultTypeMutation, UpdateFaultTypeMutationVariables>(UpdateFaultTypeDocument, options);
      }
export type UpdateFaultTypeMutationHookResult = ReturnType<typeof useUpdateFaultTypeMutation>;
export type UpdateFaultTypeMutationResult = Apollo.MutationResult<UpdateFaultTypeMutation>;
export type UpdateFaultTypeMutationOptions = Apollo.BaseMutationOptions<UpdateFaultTypeMutation, UpdateFaultTypeMutationVariables>;
export const DeleteFaultTypeDocument = gql`
    mutation DeleteFaultType($id: ID!) {
  deleteFaultType(id: $id)
}
    `;
export type DeleteFaultTypeMutationFn = Apollo.MutationFunction<DeleteFaultTypeMutation, DeleteFaultTypeMutationVariables>;

/**
 * __useDeleteFaultTypeMutation__
 *
 * To run a mutation, you first call `useDeleteFaultTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaultTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaultTypeMutation, { data, loading, error }] = useDeleteFaultTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFaultTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaultTypeMutation, DeleteFaultTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaultTypeMutation, DeleteFaultTypeMutationVariables>(DeleteFaultTypeDocument, options);
      }
export type DeleteFaultTypeMutationHookResult = ReturnType<typeof useDeleteFaultTypeMutation>;
export type DeleteFaultTypeMutationResult = Apollo.MutationResult<DeleteFaultTypeMutation>;
export type DeleteFaultTypeMutationOptions = Apollo.BaseMutationOptions<DeleteFaultTypeMutation, DeleteFaultTypeMutationVariables>;
export const CreateFaultSubTypeDocument = gql`
    mutation CreateFaultSubType($faultTypeId: ID!, $name: String!) {
  createFaultSubType(faultTypeId: $faultTypeId, name: $name) {
    id
    name
    isActive
  }
}
    `;
export type CreateFaultSubTypeMutationFn = Apollo.MutationFunction<CreateFaultSubTypeMutation, CreateFaultSubTypeMutationVariables>;

/**
 * __useCreateFaultSubTypeMutation__
 *
 * To run a mutation, you first call `useCreateFaultSubTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaultSubTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaultSubTypeMutation, { data, loading, error }] = useCreateFaultSubTypeMutation({
 *   variables: {
 *      faultTypeId: // value for 'faultTypeId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateFaultSubTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaultSubTypeMutation, CreateFaultSubTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaultSubTypeMutation, CreateFaultSubTypeMutationVariables>(CreateFaultSubTypeDocument, options);
      }
export type CreateFaultSubTypeMutationHookResult = ReturnType<typeof useCreateFaultSubTypeMutation>;
export type CreateFaultSubTypeMutationResult = Apollo.MutationResult<CreateFaultSubTypeMutation>;
export type CreateFaultSubTypeMutationOptions = Apollo.BaseMutationOptions<CreateFaultSubTypeMutation, CreateFaultSubTypeMutationVariables>;
export const UpdateFaultSubTypeDocument = gql`
    mutation UpdateFaultSubType($id: ID!, $input: TaxonomyEntryUpdateInput!) {
  updateFaultSubType(id: $id, input: $input) {
    id
    name
    isActive
  }
}
    `;
export type UpdateFaultSubTypeMutationFn = Apollo.MutationFunction<UpdateFaultSubTypeMutation, UpdateFaultSubTypeMutationVariables>;

/**
 * __useUpdateFaultSubTypeMutation__
 *
 * To run a mutation, you first call `useUpdateFaultSubTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaultSubTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaultSubTypeMutation, { data, loading, error }] = useUpdateFaultSubTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFaultSubTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaultSubTypeMutation, UpdateFaultSubTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaultSubTypeMutation, UpdateFaultSubTypeMutationVariables>(UpdateFaultSubTypeDocument, options);
      }
export type UpdateFaultSubTypeMutationHookResult = ReturnType<typeof useUpdateFaultSubTypeMutation>;
export type UpdateFaultSubTypeMutationResult = Apollo.MutationResult<UpdateFaultSubTypeMutation>;
export type UpdateFaultSubTypeMutationOptions = Apollo.BaseMutationOptions<UpdateFaultSubTypeMutation, UpdateFaultSubTypeMutationVariables>;
export const DeleteFaultSubTypeDocument = gql`
    mutation DeleteFaultSubType($id: ID!) {
  deleteFaultSubType(id: $id)
}
    `;
export type DeleteFaultSubTypeMutationFn = Apollo.MutationFunction<DeleteFaultSubTypeMutation, DeleteFaultSubTypeMutationVariables>;

/**
 * __useDeleteFaultSubTypeMutation__
 *
 * To run a mutation, you first call `useDeleteFaultSubTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaultSubTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaultSubTypeMutation, { data, loading, error }] = useDeleteFaultSubTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFaultSubTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaultSubTypeMutation, DeleteFaultSubTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaultSubTypeMutation, DeleteFaultSubTypeMutationVariables>(DeleteFaultSubTypeDocument, options);
      }
export type DeleteFaultSubTypeMutationHookResult = ReturnType<typeof useDeleteFaultSubTypeMutation>;
export type DeleteFaultSubTypeMutationResult = Apollo.MutationResult<DeleteFaultSubTypeMutation>;
export type DeleteFaultSubTypeMutationOptions = Apollo.BaseMutationOptions<DeleteFaultSubTypeMutation, DeleteFaultSubTypeMutationVariables>;
export const ConfigureDeviceAtWorkshopDocument = gql`
    mutation ConfigureDeviceAtWorkshop($input: ConfigureWorkshopDeviceInput!) {
  configureDeviceAtWorkshop(input: $input) {
    id
    stockItem {
      id
      accountNumber
      status
    }
  }
}
    `;
export type ConfigureDeviceAtWorkshopMutationFn = Apollo.MutationFunction<ConfigureDeviceAtWorkshopMutation, ConfigureDeviceAtWorkshopMutationVariables>;

/**
 * __useConfigureDeviceAtWorkshopMutation__
 *
 * To run a mutation, you first call `useConfigureDeviceAtWorkshopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureDeviceAtWorkshopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureDeviceAtWorkshopMutation, { data, loading, error }] = useConfigureDeviceAtWorkshopMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureDeviceAtWorkshopMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureDeviceAtWorkshopMutation, ConfigureDeviceAtWorkshopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureDeviceAtWorkshopMutation, ConfigureDeviceAtWorkshopMutationVariables>(ConfigureDeviceAtWorkshopDocument, options);
      }
export type ConfigureDeviceAtWorkshopMutationHookResult = ReturnType<typeof useConfigureDeviceAtWorkshopMutation>;
export type ConfigureDeviceAtWorkshopMutationResult = Apollo.MutationResult<ConfigureDeviceAtWorkshopMutation>;
export type ConfigureDeviceAtWorkshopMutationOptions = Apollo.BaseMutationOptions<ConfigureDeviceAtWorkshopMutation, ConfigureDeviceAtWorkshopMutationVariables>;
export const ReceiveAtWorkshopDocument = gql`
    mutation ReceiveAtWorkshop($input: ReceiveAtWorkshopInput!) {
  receiveAtWorkshop(input: $input) {
    id
    transferNumber
    status
    sourceStockingPoint {
      id
      name
    }
  }
}
    `;
export type ReceiveAtWorkshopMutationFn = Apollo.MutationFunction<ReceiveAtWorkshopMutation, ReceiveAtWorkshopMutationVariables>;

/**
 * __useReceiveAtWorkshopMutation__
 *
 * To run a mutation, you first call `useReceiveAtWorkshopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveAtWorkshopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveAtWorkshopMutation, { data, loading, error }] = useReceiveAtWorkshopMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReceiveAtWorkshopMutation(baseOptions?: Apollo.MutationHookOptions<ReceiveAtWorkshopMutation, ReceiveAtWorkshopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceiveAtWorkshopMutation, ReceiveAtWorkshopMutationVariables>(ReceiveAtWorkshopDocument, options);
      }
export type ReceiveAtWorkshopMutationHookResult = ReturnType<typeof useReceiveAtWorkshopMutation>;
export type ReceiveAtWorkshopMutationResult = Apollo.MutationResult<ReceiveAtWorkshopMutation>;
export type ReceiveAtWorkshopMutationOptions = Apollo.BaseMutationOptions<ReceiveAtWorkshopMutation, ReceiveAtWorkshopMutationVariables>;
export const UpdateWorkshopPolicyDocument = gql`
    mutation UpdateWorkshopPolicy($input: UpdateWorkshopPolicyInput!) {
  updateWorkshopPolicy(input: $input) {
    maxTestTokenDays
    updatedAt
  }
}
    `;
export type UpdateWorkshopPolicyMutationFn = Apollo.MutationFunction<UpdateWorkshopPolicyMutation, UpdateWorkshopPolicyMutationVariables>;

/**
 * __useUpdateWorkshopPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateWorkshopPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkshopPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkshopPolicyMutation, { data, loading, error }] = useUpdateWorkshopPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkshopPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkshopPolicyMutation, UpdateWorkshopPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkshopPolicyMutation, UpdateWorkshopPolicyMutationVariables>(UpdateWorkshopPolicyDocument, options);
      }
export type UpdateWorkshopPolicyMutationHookResult = ReturnType<typeof useUpdateWorkshopPolicyMutation>;
export type UpdateWorkshopPolicyMutationResult = Apollo.MutationResult<UpdateWorkshopPolicyMutation>;
export type UpdateWorkshopPolicyMutationOptions = Apollo.BaseMutationOptions<UpdateWorkshopPolicyMutation, UpdateWorkshopPolicyMutationVariables>;
export const ReleaseFromWorkshopManyDocument = gql`
    mutation ReleaseFromWorkshopMany($ids: [ID!]!) {
  releaseFromWorkshopMany(ids: $ids) {
    id
    transferNumber
    status
  }
}
    `;
export type ReleaseFromWorkshopManyMutationFn = Apollo.MutationFunction<ReleaseFromWorkshopManyMutation, ReleaseFromWorkshopManyMutationVariables>;

/**
 * __useReleaseFromWorkshopManyMutation__
 *
 * To run a mutation, you first call `useReleaseFromWorkshopManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseFromWorkshopManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseFromWorkshopManyMutation, { data, loading, error }] = useReleaseFromWorkshopManyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useReleaseFromWorkshopManyMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseFromWorkshopManyMutation, ReleaseFromWorkshopManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseFromWorkshopManyMutation, ReleaseFromWorkshopManyMutationVariables>(ReleaseFromWorkshopManyDocument, options);
      }
export type ReleaseFromWorkshopManyMutationHookResult = ReturnType<typeof useReleaseFromWorkshopManyMutation>;
export type ReleaseFromWorkshopManyMutationResult = Apollo.MutationResult<ReleaseFromWorkshopManyMutation>;
export type ReleaseFromWorkshopManyMutationOptions = Apollo.BaseMutationOptions<ReleaseFromWorkshopManyMutation, ReleaseFromWorkshopManyMutationVariables>;
export const ScrapDeviceDocument = gql`
    mutation ScrapDevice($id: ID!, $reason: String!) {
  scrapDevice(id: $id, reason: $reason) {
    id
    stage
    closedAt
    scrapReason
  }
}
    `;
export type ScrapDeviceMutationFn = Apollo.MutationFunction<ScrapDeviceMutation, ScrapDeviceMutationVariables>;

/**
 * __useScrapDeviceMutation__
 *
 * To run a mutation, you first call `useScrapDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScrapDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scrapDeviceMutation, { data, loading, error }] = useScrapDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useScrapDeviceMutation(baseOptions?: Apollo.MutationHookOptions<ScrapDeviceMutation, ScrapDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScrapDeviceMutation, ScrapDeviceMutationVariables>(ScrapDeviceDocument, options);
      }
export type ScrapDeviceMutationHookResult = ReturnType<typeof useScrapDeviceMutation>;
export type ScrapDeviceMutationResult = Apollo.MutationResult<ScrapDeviceMutation>;
export type ScrapDeviceMutationOptions = Apollo.BaseMutationOptions<ScrapDeviceMutation, ScrapDeviceMutationVariables>;
export const GenerateTestTokenDocument = gql`
    mutation GenerateTestToken($id: ID!, $days: Int!) {
  generateTestToken(id: $id, days: $days) {
    id
    status
    token
    tokenSequence
    vendor
    amount
    failureReason
    createdAt
  }
}
    `;
export type GenerateTestTokenMutationFn = Apollo.MutationFunction<GenerateTestTokenMutation, GenerateTestTokenMutationVariables>;

/**
 * __useGenerateTestTokenMutation__
 *
 * To run a mutation, you first call `useGenerateTestTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTestTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTestTokenMutation, { data, loading, error }] = useGenerateTestTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGenerateTestTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTestTokenMutation, GenerateTestTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTestTokenMutation, GenerateTestTokenMutationVariables>(GenerateTestTokenDocument, options);
      }
export type GenerateTestTokenMutationHookResult = ReturnType<typeof useGenerateTestTokenMutation>;
export type GenerateTestTokenMutationResult = Apollo.MutationResult<GenerateTestTokenMutation>;
export type GenerateTestTokenMutationOptions = Apollo.BaseMutationOptions<GenerateTestTokenMutation, GenerateTestTokenMutationVariables>;
export const GetPartStockDocument = gql`
    query GetPartStock($stockingPointId: String!) {
  partStock(stockingPointId: $stockingPointId) {
    id
    quantity
    reservedQuantity
    condition
    minimum
    isBelowMinimum
    product {
      id
      name
      itemCategoryId
      itemCategory {
        id
        path
      }
    }
  }
}
    `;

/**
 * __useGetPartStockQuery__
 *
 * To run a query within a React component, call `useGetPartStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartStockQuery({
 *   variables: {
 *      stockingPointId: // value for 'stockingPointId'
 *   },
 * });
 */
export function useGetPartStockQuery(baseOptions: Apollo.QueryHookOptions<GetPartStockQuery, GetPartStockQueryVariables> & ({ variables: GetPartStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartStockQuery, GetPartStockQueryVariables>(GetPartStockDocument, options);
      }
export function useGetPartStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartStockQuery, GetPartStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartStockQuery, GetPartStockQueryVariables>(GetPartStockDocument, options);
        }
// @ts-ignore
export function useGetPartStockSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartStockQuery, GetPartStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartStockQuery, GetPartStockQueryVariables>;
export function useGetPartStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartStockQuery, GetPartStockQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartStockQuery | undefined, GetPartStockQueryVariables>;
export function useGetPartStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartStockQuery, GetPartStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartStockQuery, GetPartStockQueryVariables>(GetPartStockDocument, options);
        }
export type GetPartStockQueryHookResult = ReturnType<typeof useGetPartStockQuery>;
export type GetPartStockLazyQueryHookResult = ReturnType<typeof useGetPartStockLazyQuery>;
export type GetPartStockSuspenseQueryHookResult = ReturnType<typeof useGetPartStockSuspenseQuery>;
export type GetPartStockQueryResult = Apollo.QueryResult<GetPartStockQuery, GetPartStockQueryVariables>;
export const UsePartsDocument = gql`
    mutation UseParts($input: PartMovementInput!) {
  useParts(input: $input) {
    id
    delta
    product {
      id
      name
    }
  }
}
    `;
export type UsePartsMutationFn = Apollo.MutationFunction<UsePartsMutation, UsePartsMutationVariables>;

/**
 * __useUsePartsMutation__
 *
 * To run a mutation, you first call `useUsePartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsePartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usePartsMutation, { data, loading, error }] = useUsePartsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsePartsMutation(baseOptions?: Apollo.MutationHookOptions<UsePartsMutation, UsePartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UsePartsMutation, UsePartsMutationVariables>(UsePartsDocument, options);
      }
export type UsePartsMutationHookResult = ReturnType<typeof useUsePartsMutation>;
export type UsePartsMutationResult = Apollo.MutationResult<UsePartsMutation>;
export type UsePartsMutationOptions = Apollo.BaseMutationOptions<UsePartsMutation, UsePartsMutationVariables>;
export const ReturnPartsDocument = gql`
    mutation ReturnParts($input: PartMovementInput!) {
  returnParts(input: $input) {
    id
    delta
  }
}
    `;
export type ReturnPartsMutationFn = Apollo.MutationFunction<ReturnPartsMutation, ReturnPartsMutationVariables>;

/**
 * __useReturnPartsMutation__
 *
 * To run a mutation, you first call `useReturnPartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnPartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnPartsMutation, { data, loading, error }] = useReturnPartsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReturnPartsMutation(baseOptions?: Apollo.MutationHookOptions<ReturnPartsMutation, ReturnPartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReturnPartsMutation, ReturnPartsMutationVariables>(ReturnPartsDocument, options);
      }
export type ReturnPartsMutationHookResult = ReturnType<typeof useReturnPartsMutation>;
export type ReturnPartsMutationResult = Apollo.MutationResult<ReturnPartsMutation>;
export type ReturnPartsMutationOptions = Apollo.BaseMutationOptions<ReturnPartsMutation, ReturnPartsMutationVariables>;
export const GetPartsDocument = gql`
    query GetParts($includeInactive: Boolean, $stockingPointId: String) {
  parts(includeInactive: $includeInactive) {
    id
    sku
    name
    itemCategoryId
    itemCategory {
      id
      path
    }
    lastCostCents
    businessLine {
      id
      name
    }
    unitOfMeasure {
      id
      name
    }
    isActive
    totalQuantity
    reorderLevelAt(stockingPointId: $stockingPointId)
    headOfficeQuantity
  }
}
    `;

/**
 * __useGetPartsQuery__
 *
 * To run a query within a React component, call `useGetPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsQuery({
 *   variables: {
 *      includeInactive: // value for 'includeInactive'
 *      stockingPointId: // value for 'stockingPointId'
 *   },
 * });
 */
export function useGetPartsQuery(baseOptions?: Apollo.QueryHookOptions<GetPartsQuery, GetPartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsQuery, GetPartsQueryVariables>(GetPartsDocument, options);
      }
export function useGetPartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsQuery, GetPartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsQuery, GetPartsQueryVariables>(GetPartsDocument, options);
        }
// @ts-ignore
export function useGetPartsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsQuery, GetPartsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsQuery, GetPartsQueryVariables>;
export function useGetPartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsQuery, GetPartsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsQuery | undefined, GetPartsQueryVariables>;
export function useGetPartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsQuery, GetPartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsQuery, GetPartsQueryVariables>(GetPartsDocument, options);
        }
export type GetPartsQueryHookResult = ReturnType<typeof useGetPartsQuery>;
export type GetPartsLazyQueryHookResult = ReturnType<typeof useGetPartsLazyQuery>;
export type GetPartsSuspenseQueryHookResult = ReturnType<typeof useGetPartsSuspenseQuery>;
export type GetPartsQueryResult = Apollo.QueryResult<GetPartsQuery, GetPartsQueryVariables>;
export const GetPartsToRequestDocument = gql`
    query GetPartsToRequest($benchId: String!) {
  parts {
    id
    name
    headOfficeQuantity
    elsewhereQuantity(excludingStockingPointId: $benchId)
  }
}
    `;

/**
 * __useGetPartsToRequestQuery__
 *
 * To run a query within a React component, call `useGetPartsToRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsToRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsToRequestQuery({
 *   variables: {
 *      benchId: // value for 'benchId'
 *   },
 * });
 */
export function useGetPartsToRequestQuery(baseOptions: Apollo.QueryHookOptions<GetPartsToRequestQuery, GetPartsToRequestQueryVariables> & ({ variables: GetPartsToRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>(GetPartsToRequestDocument, options);
      }
export function useGetPartsToRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>(GetPartsToRequestDocument, options);
        }
// @ts-ignore
export function useGetPartsToRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>;
export function useGetPartsToRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsToRequestQuery | undefined, GetPartsToRequestQueryVariables>;
export function useGetPartsToRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>(GetPartsToRequestDocument, options);
        }
export type GetPartsToRequestQueryHookResult = ReturnType<typeof useGetPartsToRequestQuery>;
export type GetPartsToRequestLazyQueryHookResult = ReturnType<typeof useGetPartsToRequestLazyQuery>;
export type GetPartsToRequestSuspenseQueryHookResult = ReturnType<typeof useGetPartsToRequestSuspenseQuery>;
export type GetPartsToRequestQueryResult = Apollo.QueryResult<GetPartsToRequestQuery, GetPartsToRequestQueryVariables>;
export const CreatePartDocument = gql`
    mutation CreatePart($input: PartInput!) {
  createPart(input: $input) {
    id
    name
  }
}
    `;
export type CreatePartMutationFn = Apollo.MutationFunction<CreatePartMutation, CreatePartMutationVariables>;

/**
 * __useCreatePartMutation__
 *
 * To run a mutation, you first call `useCreatePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartMutation, { data, loading, error }] = useCreatePartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartMutation, CreatePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartMutation, CreatePartMutationVariables>(CreatePartDocument, options);
      }
export type CreatePartMutationHookResult = ReturnType<typeof useCreatePartMutation>;
export type CreatePartMutationResult = Apollo.MutationResult<CreatePartMutation>;
export type CreatePartMutationOptions = Apollo.BaseMutationOptions<CreatePartMutation, CreatePartMutationVariables>;
export const UpdatePartDocument = gql`
    mutation UpdatePart($id: ID!, $input: PartInput!) {
  updatePart(id: $id, input: $input) {
    id
    name
    isActive
  }
}
    `;
export type UpdatePartMutationFn = Apollo.MutationFunction<UpdatePartMutation, UpdatePartMutationVariables>;

/**
 * __useUpdatePartMutation__
 *
 * To run a mutation, you first call `useUpdatePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartMutation, { data, loading, error }] = useUpdatePartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartMutation, UpdatePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartMutation, UpdatePartMutationVariables>(UpdatePartDocument, options);
      }
export type UpdatePartMutationHookResult = ReturnType<typeof useUpdatePartMutation>;
export type UpdatePartMutationResult = Apollo.MutationResult<UpdatePartMutation>;
export type UpdatePartMutationOptions = Apollo.BaseMutationOptions<UpdatePartMutation, UpdatePartMutationVariables>;
export const ReceivePartsDocument = gql`
    mutation ReceiveParts($input: PartMovementInput!) {
  receiveParts(input: $input) {
    id
    delta
  }
}
    `;
export type ReceivePartsMutationFn = Apollo.MutationFunction<ReceivePartsMutation, ReceivePartsMutationVariables>;

/**
 * __useReceivePartsMutation__
 *
 * To run a mutation, you first call `useReceivePartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceivePartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receivePartsMutation, { data, loading, error }] = useReceivePartsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReceivePartsMutation(baseOptions?: Apollo.MutationHookOptions<ReceivePartsMutation, ReceivePartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceivePartsMutation, ReceivePartsMutationVariables>(ReceivePartsDocument, options);
      }
export type ReceivePartsMutationHookResult = ReturnType<typeof useReceivePartsMutation>;
export type ReceivePartsMutationResult = Apollo.MutationResult<ReceivePartsMutation>;
export type ReceivePartsMutationOptions = Apollo.BaseMutationOptions<ReceivePartsMutation, ReceivePartsMutationVariables>;
export const AdjustPartStockDocument = gql`
    mutation AdjustPartStock($productId: String!, $stockingPointId: String!, $delta: Int!, $note: String!) {
  adjustPartStock(
    productId: $productId
    stockingPointId: $stockingPointId
    delta: $delta
    note: $note
  ) {
    id
    delta
  }
}
    `;
export type AdjustPartStockMutationFn = Apollo.MutationFunction<AdjustPartStockMutation, AdjustPartStockMutationVariables>;

/**
 * __useAdjustPartStockMutation__
 *
 * To run a mutation, you first call `useAdjustPartStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustPartStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustPartStockMutation, { data, loading, error }] = useAdjustPartStockMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      stockingPointId: // value for 'stockingPointId'
 *      delta: // value for 'delta'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAdjustPartStockMutation(baseOptions?: Apollo.MutationHookOptions<AdjustPartStockMutation, AdjustPartStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustPartStockMutation, AdjustPartStockMutationVariables>(AdjustPartStockDocument, options);
      }
export type AdjustPartStockMutationHookResult = ReturnType<typeof useAdjustPartStockMutation>;
export type AdjustPartStockMutationResult = Apollo.MutationResult<AdjustPartStockMutation>;
export type AdjustPartStockMutationOptions = Apollo.BaseMutationOptions<AdjustPartStockMutation, AdjustPartStockMutationVariables>;
export const GetPartRequestsDocument = gql`
    query GetPartRequests($input: PartRequestListInput) {
  partRequests(input: $input) {
    items {
      ...PartRequestFields
    }
    totalCount
  }
}
    ${PartRequestFieldsFragmentDoc}`;

/**
 * __useGetPartRequestsQuery__
 *
 * To run a query within a React component, call `useGetPartRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartRequestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPartRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetPartRequestsQuery, GetPartRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartRequestsQuery, GetPartRequestsQueryVariables>(GetPartRequestsDocument, options);
      }
export function useGetPartRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartRequestsQuery, GetPartRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartRequestsQuery, GetPartRequestsQueryVariables>(GetPartRequestsDocument, options);
        }
// @ts-ignore
export function useGetPartRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartRequestsQuery, GetPartRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartRequestsQuery, GetPartRequestsQueryVariables>;
export function useGetPartRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartRequestsQuery, GetPartRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartRequestsQuery | undefined, GetPartRequestsQueryVariables>;
export function useGetPartRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartRequestsQuery, GetPartRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartRequestsQuery, GetPartRequestsQueryVariables>(GetPartRequestsDocument, options);
        }
export type GetPartRequestsQueryHookResult = ReturnType<typeof useGetPartRequestsQuery>;
export type GetPartRequestsLazyQueryHookResult = ReturnType<typeof useGetPartRequestsLazyQuery>;
export type GetPartRequestsSuspenseQueryHookResult = ReturnType<typeof useGetPartRequestsSuspenseQuery>;
export type GetPartRequestsQueryResult = Apollo.QueryResult<GetPartRequestsQuery, GetPartRequestsQueryVariables>;
export const RaisePartRequestDocument = gql`
    mutation RaisePartRequest($input: RaisePartRequestInput!) {
  raisePartRequest(input: $input) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export type RaisePartRequestMutationFn = Apollo.MutationFunction<RaisePartRequestMutation, RaisePartRequestMutationVariables>;

/**
 * __useRaisePartRequestMutation__
 *
 * To run a mutation, you first call `useRaisePartRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRaisePartRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [raisePartRequestMutation, { data, loading, error }] = useRaisePartRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRaisePartRequestMutation(baseOptions?: Apollo.MutationHookOptions<RaisePartRequestMutation, RaisePartRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RaisePartRequestMutation, RaisePartRequestMutationVariables>(RaisePartRequestDocument, options);
      }
export type RaisePartRequestMutationHookResult = ReturnType<typeof useRaisePartRequestMutation>;
export type RaisePartRequestMutationResult = Apollo.MutationResult<RaisePartRequestMutation>;
export type RaisePartRequestMutationOptions = Apollo.BaseMutationOptions<RaisePartRequestMutation, RaisePartRequestMutationVariables>;
export const LinkPartRequestDocument = gql`
    mutation LinkPartRequest($id: ID!, $productId: String!) {
  linkPartRequest(id: $id, productId: $productId) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export type LinkPartRequestMutationFn = Apollo.MutationFunction<LinkPartRequestMutation, LinkPartRequestMutationVariables>;

/**
 * __useLinkPartRequestMutation__
 *
 * To run a mutation, you first call `useLinkPartRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkPartRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkPartRequestMutation, { data, loading, error }] = useLinkPartRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useLinkPartRequestMutation(baseOptions?: Apollo.MutationHookOptions<LinkPartRequestMutation, LinkPartRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkPartRequestMutation, LinkPartRequestMutationVariables>(LinkPartRequestDocument, options);
      }
export type LinkPartRequestMutationHookResult = ReturnType<typeof useLinkPartRequestMutation>;
export type LinkPartRequestMutationResult = Apollo.MutationResult<LinkPartRequestMutation>;
export type LinkPartRequestMutationOptions = Apollo.BaseMutationOptions<LinkPartRequestMutation, LinkPartRequestMutationVariables>;
export const AddPartFromRequestDocument = gql`
    mutation AddPartFromRequest($id: ID!, $input: PartInput!) {
  addPartFromRequest(id: $id, input: $input) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export type AddPartFromRequestMutationFn = Apollo.MutationFunction<AddPartFromRequestMutation, AddPartFromRequestMutationVariables>;

/**
 * __useAddPartFromRequestMutation__
 *
 * To run a mutation, you first call `useAddPartFromRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartFromRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartFromRequestMutation, { data, loading, error }] = useAddPartFromRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPartFromRequestMutation(baseOptions?: Apollo.MutationHookOptions<AddPartFromRequestMutation, AddPartFromRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPartFromRequestMutation, AddPartFromRequestMutationVariables>(AddPartFromRequestDocument, options);
      }
export type AddPartFromRequestMutationHookResult = ReturnType<typeof useAddPartFromRequestMutation>;
export type AddPartFromRequestMutationResult = Apollo.MutationResult<AddPartFromRequestMutation>;
export type AddPartFromRequestMutationOptions = Apollo.BaseMutationOptions<AddPartFromRequestMutation, AddPartFromRequestMutationVariables>;
export const SendPartRequestDocument = gql`
    mutation SendPartRequest($id: ID!, $input: SourcePartRequestInput!) {
  sendPartRequest(id: $id, input: $input) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export type SendPartRequestMutationFn = Apollo.MutationFunction<SendPartRequestMutation, SendPartRequestMutationVariables>;

/**
 * __useSendPartRequestMutation__
 *
 * To run a mutation, you first call `useSendPartRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPartRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPartRequestMutation, { data, loading, error }] = useSendPartRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPartRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendPartRequestMutation, SendPartRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPartRequestMutation, SendPartRequestMutationVariables>(SendPartRequestDocument, options);
      }
export type SendPartRequestMutationHookResult = ReturnType<typeof useSendPartRequestMutation>;
export type SendPartRequestMutationResult = Apollo.MutationResult<SendPartRequestMutation>;
export type SendPartRequestMutationOptions = Apollo.BaseMutationOptions<SendPartRequestMutation, SendPartRequestMutationVariables>;
export const ReceivePartRequestDocument = gql`
    mutation ReceivePartRequest($id: ID!, $reference: String) {
  receivePartRequest(id: $id, reference: $reference) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export type ReceivePartRequestMutationFn = Apollo.MutationFunction<ReceivePartRequestMutation, ReceivePartRequestMutationVariables>;

/**
 * __useReceivePartRequestMutation__
 *
 * To run a mutation, you first call `useReceivePartRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceivePartRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receivePartRequestMutation, { data, loading, error }] = useReceivePartRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useReceivePartRequestMutation(baseOptions?: Apollo.MutationHookOptions<ReceivePartRequestMutation, ReceivePartRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReceivePartRequestMutation, ReceivePartRequestMutationVariables>(ReceivePartRequestDocument, options);
      }
export type ReceivePartRequestMutationHookResult = ReturnType<typeof useReceivePartRequestMutation>;
export type ReceivePartRequestMutationResult = Apollo.MutationResult<ReceivePartRequestMutation>;
export type ReceivePartRequestMutationOptions = Apollo.BaseMutationOptions<ReceivePartRequestMutation, ReceivePartRequestMutationVariables>;
export const RejectPartRequestDocument = gql`
    mutation RejectPartRequest($id: ID!, $resolutionNote: String) {
  rejectPartRequest(id: $id, resolutionNote: $resolutionNote) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export type RejectPartRequestMutationFn = Apollo.MutationFunction<RejectPartRequestMutation, RejectPartRequestMutationVariables>;

/**
 * __useRejectPartRequestMutation__
 *
 * To run a mutation, you first call `useRejectPartRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPartRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPartRequestMutation, { data, loading, error }] = useRejectPartRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resolutionNote: // value for 'resolutionNote'
 *   },
 * });
 */
export function useRejectPartRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectPartRequestMutation, RejectPartRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectPartRequestMutation, RejectPartRequestMutationVariables>(RejectPartRequestDocument, options);
      }
export type RejectPartRequestMutationHookResult = ReturnType<typeof useRejectPartRequestMutation>;
export type RejectPartRequestMutationResult = Apollo.MutationResult<RejectPartRequestMutation>;
export type RejectPartRequestMutationOptions = Apollo.BaseMutationOptions<RejectPartRequestMutation, RejectPartRequestMutationVariables>;
export const CancelPartRequestDocument = gql`
    mutation CancelPartRequest($id: ID!, $resolutionNote: String) {
  cancelPartRequest(id: $id, resolutionNote: $resolutionNote) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export type CancelPartRequestMutationFn = Apollo.MutationFunction<CancelPartRequestMutation, CancelPartRequestMutationVariables>;

/**
 * __useCancelPartRequestMutation__
 *
 * To run a mutation, you first call `useCancelPartRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPartRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPartRequestMutation, { data, loading, error }] = useCancelPartRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resolutionNote: // value for 'resolutionNote'
 *   },
 * });
 */
export function useCancelPartRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelPartRequestMutation, CancelPartRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPartRequestMutation, CancelPartRequestMutationVariables>(CancelPartRequestDocument, options);
      }
export type CancelPartRequestMutationHookResult = ReturnType<typeof useCancelPartRequestMutation>;
export type CancelPartRequestMutationResult = Apollo.MutationResult<CancelPartRequestMutation>;
export type CancelPartRequestMutationOptions = Apollo.BaseMutationOptions<CancelPartRequestMutation, CancelPartRequestMutationVariables>;
export const WorkshopDeviceSecretDocument = gql`
    query WorkshopDeviceSecret($jobId: String!) {
  workshopDeviceSecret(jobId: $jobId) {
    jobId
    identifier
    secretKey
    tokenCount
  }
}
    `;

/**
 * __useWorkshopDeviceSecretQuery__
 *
 * To run a query within a React component, call `useWorkshopDeviceSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkshopDeviceSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkshopDeviceSecretQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useWorkshopDeviceSecretQuery(baseOptions: Apollo.QueryHookOptions<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables> & ({ variables: WorkshopDeviceSecretQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>(WorkshopDeviceSecretDocument, options);
      }
export function useWorkshopDeviceSecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>(WorkshopDeviceSecretDocument, options);
        }
// @ts-ignore
export function useWorkshopDeviceSecretSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>): Apollo.UseSuspenseQueryResult<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>;
export function useWorkshopDeviceSecretSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>): Apollo.UseSuspenseQueryResult<WorkshopDeviceSecretQuery | undefined, WorkshopDeviceSecretQueryVariables>;
export function useWorkshopDeviceSecretSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>(WorkshopDeviceSecretDocument, options);
        }
export type WorkshopDeviceSecretQueryHookResult = ReturnType<typeof useWorkshopDeviceSecretQuery>;
export type WorkshopDeviceSecretLazyQueryHookResult = ReturnType<typeof useWorkshopDeviceSecretLazyQuery>;
export type WorkshopDeviceSecretSuspenseQueryHookResult = ReturnType<typeof useWorkshopDeviceSecretSuspenseQuery>;
export type WorkshopDeviceSecretQueryResult = Apollo.QueryResult<WorkshopDeviceSecretQuery, WorkshopDeviceSecretQueryVariables>;
export const GetWorkshopStatsDocument = gql`
    query GetWorkshopStats($input: WorkshopStatsInput!) {
  workshopStats(input: $input) {
    from
    to
    totals {
      ...WorkshopStatsCountsFields
    }
    byDeviceType {
      ...WorkshopStatsRowFields
    }
    byProduct {
      ...WorkshopStatsRowFields
    }
    byFaultType {
      ...WorkshopStatsRowFields
    }
    byFaultSubType {
      ...WorkshopStatsRowFields
    }
  }
}
    ${WorkshopStatsCountsFieldsFragmentDoc}
${WorkshopStatsRowFieldsFragmentDoc}`;

/**
 * __useGetWorkshopStatsQuery__
 *
 * To run a query within a React component, call `useGetWorkshopStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkshopStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkshopStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkshopStatsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables> & ({ variables: GetWorkshopStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>(GetWorkshopStatsDocument, options);
      }
export function useGetWorkshopStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>(GetWorkshopStatsDocument, options);
        }
// @ts-ignore
export function useGetWorkshopStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>;
export function useGetWorkshopStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkshopStatsQuery | undefined, GetWorkshopStatsQueryVariables>;
export function useGetWorkshopStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>(GetWorkshopStatsDocument, options);
        }
export type GetWorkshopStatsQueryHookResult = ReturnType<typeof useGetWorkshopStatsQuery>;
export type GetWorkshopStatsLazyQueryHookResult = ReturnType<typeof useGetWorkshopStatsLazyQuery>;
export type GetWorkshopStatsSuspenseQueryHookResult = ReturnType<typeof useGetWorkshopStatsSuspenseQuery>;
export type GetWorkshopStatsQueryResult = Apollo.QueryResult<GetWorkshopStatsQuery, GetWorkshopStatsQueryVariables>;